/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 312);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(319);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utility_service__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__utility_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__system_service__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__system_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_service__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__customer_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meetingNotes_service__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__meetingNotes_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_service__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__style_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sample_service__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__sample_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__costing_service__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__costing_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__permission_service__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__permission_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__development_service__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__development_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__communication_service__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__communication_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__country_service__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__country_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__report_service__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__report_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fileupload_service__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__fileupload_service__["a"]; });


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosize__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_time_picker__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_util__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Field=function(_Component){_inherits(Field,_Component);function Field(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Field);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Field.__proto__||Object.getPrototypeOf(Field)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Field,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_autosize___default()(document.querySelectorAll("textarea"));var textArea=document.querySelector("textarea");if(textArea){textArea.style.overflow='hidden';textArea.style.height='0px';textArea.style.height=textArea.scrollHeight+'px';}}},{key:"render",value:function render(){var _props=this.props,inputName=_props.inputName,placeholder=_props.placeholder,label=_props.label,inputType=_props.inputType,options=_props.options,_onChange=_props.onChange,onInput=_props.onInput,value=_props.value,disabled=_props.disabled,isFormGroup=_props.isFormGroup,index=_props.index,i=_props.i,max=_props.max,className=_props.className,checked=_props.checked,size=_props.size,style=_props.style;var inputField=undefined;switch(inputType){case"text":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{style:this.props.style,type:inputType,name:inputName,title:value,className:"form-control "+className,value:value,disabled:disabled,placeholder:placeholder,maxLength:max,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);}});break;case"password":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputName,className:"form-control "+className,value:value,disabled:disabled,placeholder:placeholder,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);}});break;case"number":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{style:this.props.style,type:inputType,name:inputName,className:"form-control "+className,value:value,disabled:disabled,min:0,maxLength:max,placeholder:placeholder,size:size,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);}});break;case"select":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{title:this.props.title,style:this.props.style,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);},onSelect:function onSelect(e){return onInput(inputName,e.target.value,index,i);},disabled:disabled,name:inputName,value:value,className:"form-control "+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:"",value:"",selected:true},"--select--"),options!==undefined&&Array.isArray(options)&&options.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:i,value:data.value,disabled:Object(__WEBPACK_IMPORTED_MODULE_8_util__["isBoolean"])(data.disabled)?!data.disabled:false},data.label);}));break;case"checkbox":var uniqueName=inputName;inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":className?"manage_permissions emb-chck "+className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox","class":"filled-in",id:uniqueName,name:uniqueName,value:value,checked:value,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.checked,index,i);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":uniqueName,"class":"font-apply-li"},label));break;case"checkboxToggle":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"switch switch-mod  "+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox","class":"",name:inputName,value:value,checked:value,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.checked,index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"lever"})),value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pr-2 font-apply-li"},"YES"),!value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pl-2 font-apply-li"},"NO"));break;case"textarea":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{type:"text",className:"form-control",rows:"2",cols:"50",style:style,name:inputName,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.value,index);},value:value});break;case"radio":uniqueName=inputName;inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio","class":"filled-in",id:value,name:uniqueName,value:value,checked:checked,disabled:disabled,onChange:function onChange(e){return _onChange(value,e.target.checked,index,i);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":value,"class":"font-apply-li"},label));break;case"date":if(this.props.durationETA){var _30DaysForward=new __WEBPACK_IMPORTED_MODULE_2_moment___default.a().add(this.props.durationETA,"day");var valueDate=inputName=="processDate"?null:value?new Date(value):new Date();inputField=!disabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default.a,{date:_30DaysForward,format:"DD MMM YYYY",onChange:function onChange(date){return _onChange(inputName,date,index,i);},placeholder:"dd mmm yyyy"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:inputName,value:valueDate!=""?__WEBPACK_IMPORTED_MODULE_2_moment___default()(valueDate).format("DD MMM YYYY"):"",disabled:true});break;}else{var _valueDate=inputName=="processDate"?null:value?new Date(value):new Date();inputField=!disabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default.a,{date:_valueDate,format:"DD MMM YYYY",onChange:function onChange(date){return _onChange(inputName,date,index,i);},placeholder:"dd mmm yyyy"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:inputName,value:_valueDate!=""?__WEBPACK_IMPORTED_MODULE_2_moment___default()(_valueDate).format("DD MMM YYYY"):"",disabled:true});break;}case"time":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_time_picker__["a" /* default */],{style:this.props.style,value:value!=""&&value!==null?__WEBPACK_IMPORTED_MODULE_2_moment___default()(value):__WEBPACK_IMPORTED_MODULE_2_moment___default()(""+(new Date().getFullYear(),new Date().getMonth(),new Date().getDay())),placeholder:"HH:MM",showSecond:false,disabled:disabled,format:"HH:mm",onChange:function onChange(value){return _onChange(inputName,value,index);}});break;default:inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputName,className:"form-control"});}return isFormGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group "+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},label&&label.endsWith("*")?label.split("*")[0]:label,label&&label.endsWith("*")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger madatory-asterisk"},label&&label.match(/\*/g)):""),inputField):inputField;}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(327)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_Component){_inherits(Button,_Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:'render',value:function render(){var _props=this.props,buttonName=_props.buttonName,_onClick=_props.onClick,buttonType=_props.buttonType,_props$disabled=_props.disabled,disabled=_props$disabled===undefined?false:_props$disabled,history=_props.history,title=_props.title;var button=undefined;switch(buttonType){case'save':button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',disabled:disabled,onClick:function onClick(e){return _onClick(e);},className:'primary  m-1'},buttonName,' ');break;case'cancel':button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return history.goBack();},className:'primary m-1'},"back",' ');break;case'add':button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{display:"block"},className:'btn-floating btn-small waves-effect waves-light green pull-right my-1 mr-1',onClick:function onClick(e){return _onClick(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'add'));break;case'remove':button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{display:"block"},'class':'btn-floating btn-small waves-effect waves-light red pull-right my-1 mr-1',id:'del-sample-size-btn pull-rog pull-right',onClick:_onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'clear'));break;default:button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',disabled:disabled,onClick:function onClick(e){return _onClick(e);},className:'primary  m-1',title:title},buttonName,' ');}return button;}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(366);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
} : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockTree = __webpack_require__(745);

var ContentState = __webpack_require__(157);

var EditorBidiService = __webpack_require__(747);

var SelectionState = __webpack_require__(115);

var Immutable = __webpack_require__(8);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack,
    OrderedMap = Immutable.OrderedMap,
    List = Immutable.List; // When configuring an editor, the user can chose to provide or not provide
// basically all keys. `currentContent` varies, so this type doesn't include it.
// (See the types defined below.)

var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};
var EditorStateRecord = Record(defaultRecord);

var EditorState = /*#__PURE__*/function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return this.createWithText('', decorator);
  };

  EditorState.createWithText = function createWithText(text, decorator) {
    return EditorState.createWithContent(ContentState.createFromText(text), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    if (contentState.getBlockMap().count() === 0) {
      return EditorState.createEmpty(decorator);
    }

    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _objectSpread({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });

    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.fromJS = function fromJS(config) {
    return new EditorState(new EditorStateRecord(_objectSpread({}, config, {
      directionMap: config.directionMap != null ? OrderedMap(config.directionMap) : config.directionMap,
      inlineStyleOverride: config.inlineStyleOverride != null ? OrderedSet(config.inlineStyleOverride) : config.inlineStyleOverride,
      nativelyRenderedContent: config.nativelyRenderedContent != null ? ContentState.fromJS(config.nativelyRenderedContent) : config.nativelyRenderedContent,
      redoStack: config.redoStack != null ? Stack(config.redoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.redoStack,
      selection: config.selection != null ? new SelectionState(config.selection) : config.selection,
      treeMap: config.treeMap != null ? OrderedMap(config.treeMap).map(function (v) {
        return List(v).map(function (v) {
          return BlockTree.fromJS(v);
        });
      }) : config.treeMap,
      undoStack: config.undoStack != null ? Stack(config.undoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.undoStack,
      currentContent: ContentState.fromJS(config.currentContent)
    })));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;

      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;

        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();

      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });
    return new EditorState(map);
  };

  var _proto = EditorState.prototype;

  _proto.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  _proto.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  _proto.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  _proto.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  _proto.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  _proto.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  _proto.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  _proto.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  _proto.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  _proto.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  }
  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */
  ;

  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, {
      inlineStyleOverride: inlineStyleOverride
    });
  }
  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */
  ;

  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();

    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  _proto.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  _proto.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  }
  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */
  ;

  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  }
  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */
  ;

  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }

    return updateSelection(editorState, selection, true);
  }
  /**
   * Move selection to the end of the editor without forcing focus.
   */
  ;

  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  }
  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */
  ;

  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  }
  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */
  ;

  EditorState.push = function push(editorState, contentState, changeType) {
    var forceSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };
    return EditorState.set(editorState, editorStateChanges);
  }
  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */
  ;

  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  }
  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */
  ;

  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  }
  /**
   * Not for public consumption.
   */
  ;

  function EditorState(immutable) {
    _defineProperty(this, "_immutable", void 0);

    this._immutable = immutable;
  }
  /**
   * Not for public consumption.
   */


  _proto.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();
/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */


function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}
/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */


function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}
/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */


function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}
/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */


function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.

  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.


  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  } // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.


  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) {
    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  }

  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(Loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loadingCss"},"Loading\u2026");});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(320);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_dashboard_css__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function PageHeader(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 px-0 py-2 position-top-stick'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 nopadding text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'p-2 cursor-hover',onClick:function onClick(){var route=props.history.location.state&&props.history.location.state.route;route!==undefined?props.history.push('/'+route,_defineProperty({},''+route.toLowerCase(),Object.assign({},props.history.location.state[''+route.toLowerCase()]))):props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:"20px",src:__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 nopadding text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,props.header==="cad"?"3D":props.header)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'}));}/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleHeader=function(_Component){_inherits(ModuleHeader,_Component);function ModuleHeader(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ModuleHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModuleHeader.__proto__||Object.getPrototypeOf(ModuleHeader)).call.apply(_ref,[this].concat(args))),_this),_this.state={assignedToList:[]// statusOption: [
//   { label: "CANCEL", value: "CANCEL" },
//   { label: "COMPLETED", value: "COMPLETED" },
//   { label: "IN PROCESS", value: "INPROCESS" },
//   { label: "PENDING", value: "PENDING" }
// ]
},_this.searchEmpList=function(value){__WEBPACK_IMPORTED_MODULE_5__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(res.status==200)){_context.next=7;break;}_context.t0=_this;_context.next=4;return res.text.data;case 4:_context.t1=_context.sent;_context.t2={assignedToList:_context.t1};_context.t0.setState.call(_context.t0,_context.t2);case 7:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModuleHeader,[{key:"componentWillMount",value:function componentWillMount(){this.searchEmpList("");var _props=this.props,process=_props.process,disabled=_props.disabled;this.setState({process:process,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// this.searchEmpList("")
var process=nextProps.process,disabled=nextProps.disabled;this.setState({process:process,disabled:disabled});}// componentDidMount() {
//   this.searchEmpList("")
// }
},{key:"render",value:function render(){var _this3=this;var _state$process=this.state.process,assignedTo=_state$process.assignedTo,status=_state$process.status,ETA=_state$process.ETA,processDate=_state$process.processDate;var _props2=this.props,placeOfSewing=_props2.placeOfSewing,statusList=_props2.statusList,measurementModal=_props2.measurementModal;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-head"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-grow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"dev-title",style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,this.props.header))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1 d-flex justify-content-center align-items-center mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},measurementModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{padding:"3px 6px",backgroundColor:"#009688",color:"white",border:"none",borderRadius:"4px",cursor:"pointer",fontSize:"12px"},onClick:function onClick(){return _this3.props.history.push({pathname:"/measurementChat",state:{header:_this3.props.header,_id:_this3.props._id,customer:_this3.props.customer,customerDepartmentId:_this3.props.customerDepartmentId,type:_this3.props.type,magnumStyleId:_this3.props.magnumStyleId,action:_this3.props.location.state.action}});}},"Measurement Chart"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1",style:{width:"150px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Assigned To"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"assignedTo",value:assignedTo,onChange:function onChange(value){return _this3.props.updateModulesMain("assignedTo",value,_this3.props.moduleName);},placeholder:"Find AssignedTo",options:this.state.assignedToList,disabled:this.state.disabled})))),placeOfSewing!==undefined&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"placeOfSewing",value:placeOfSewing!==null||this.props.PLACEOFSEWING&&this.props.PLACEOFSEWING[0].value,label:"Place of sewing",options:this.props.PLACEOFSEWING||[],onChange:this.props.updateSewing,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"status",value:status,label:"Status",options:statusList,onChange:function onChange(name,value){return _this3.props.updateModulesMain(name,value,_this3.props.moduleName);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{durationETA:this.props.durationETA,isFormGroup:true,inputType:"date",inputName:"ETA",value:ETA,label:"ETA Date",onChange:function onChange(name,value){return _this3.props.updateModulesMain(name,value,_this3.props.moduleName);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Completed Date"),status=="COMPLETED"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,processDate!==null?__WEBPACK_IMPORTED_MODULE_6_moment___default()(processDate).format("DD MMM YYYY"):""):"")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-1 m-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_audit__["a" /* default */],{_id:this.props._id,moduleName:this.props.moduleName==="qc"?this.props.moduleName:this.props.header})));}}]);return ModuleHeader;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* withRouter */])(ModuleHeader));

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alertContainer = __webpack_require__(381);

var _alertContainer2 = _interopRequireDefault(_alertContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _alertContainer2.default;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_common_fileType__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Common_Video__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Common_Alert__ = __webpack_require__(130);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//options 
//components
//images
var FileUpload=function(_Component){_inherits(FileUpload,_Component);function FileUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileUpload.__proto__||Object.getPrototypeOf(FileUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:'',moduleName:'',refImages:[],openModal:false,imageEdit:false,imageForModal:"",imageIndex:"",imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",index:_this.props.index,imageTypeOption:[],loading:false,disabled:false},_this.imageInfo=function(index){_this.setState({action:'edit',imageIndex:index,imageInfo:_this.state.refImages[index]});},_this.uploadNewImage=function(e){var imageInfo=Object.assign({},_this.state.imageInfo);imageInfo.fileName=e.target.files[0].name;__WEBPACK_IMPORTED_MODULE_4__services_common_fileType__["a" /* default */].map(function(data,index){if(data.fileType==e.target.files[0].type){imageInfo.fileType=data.name;}});_this.setState({uploadNewImage:e.target.files[0],imageInfo:imageInfo});},_this.updateImage=function(){var imageInfo=Object.assign({},_this.state.imageInfo);var uploadNewImage=_this.state.uploadNewImage;_this.setState({loading:true});var refImages=[].concat(_toConsumableArray(_this.state.refImages));if(uploadNewImage!==""){__WEBPACK_IMPORTED_MODULE_3__services__["f" /* FileUploadService */].uploadFile(uploadNewImage,_this.state.moduleName).then(function(response){if(response.status===200){imageInfo.path=response.text.data.url;imageInfo.url=response.text.data.fullUrl;imageInfo.fileName=uploadNewImage.name;if(_this.state.action=='add'){refImages.push(Object.assign({},imageInfo));}if(_this.state.action=='edit'){refImages[_this.state.imageIndex]=Object.assign({},imageInfo);}_this.setState({refImages:refImages,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",imageEdit:false},function(){return _this.props.getRefImages(refImages,_this.state.index);},_this.setState({loading:false}));}else if(response.status==401){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].unauthorisedFunc();}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this.msg,response.text.message);}}).catch(function(error){_this.setState({loading:false});});}else{refImages[_this.state.imageIndex]=Object.assign({},imageInfo);_this.setState({refImages:refImages,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",imageEdit:false},function(){return _this.props.getRefImages(refImages,_this.state.index);},_this.setState({loading:false}));}},_this._onChange=function(name,value){var imageInfo=Object.assign({},_this.state.imageInfo);imageInfo[name]=value;_this.setState({imageInfo:imageInfo});},_this.removeImage=function(indexVal){var refImages=[].concat(_toConsumableArray(_this.state.refImages));refImages=refImages.filter(function(image,index){return index!==indexVal;});_this.setState({refImages:refImages},function(){return _this.props.getRefImages(refImages,_this.state.index);});},_this.openForm=function(e,action){e.preventDefault();_this.setState({imageEdit:true,action:action,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''}});},_this.downloadFile=function(image){var anchor=document.createElement('a');anchor.href=image.url;anchor.target='_blank';anchor.download=image.imageDescription;anchor.click();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileUpload,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.uploadedDocs!==null){this.setState({refImages:this.props.uploadedDocs});}this.setState({// imageTypeOption : this.props.imageTypeOption,
moduleName:this.props.moduleName,disabled:this.props.disabled});}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].getImageType().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status==200){_this2.setState({imageTypeOption:response.text.data});}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg,response.text.message);}case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){return __WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.uploadedDocs!==null){this.setState({refImages:nextProps.uploadedDocs});}// if(nextProps.imageTypeOption != this.props.imageTypeOption){
//   this.setState({
//     imageTypeOption : nextProps.imageTypeOption
//   })
// }
this.setState({moduleName:nextProps.moduleName,disabled:nextProps.disabled});}},{key:"render",value:function render(){var _this3=this;var Heading=this.props.Heading;var filePreviewIframe=null;filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("iframe",{src:this.state.imageInfo.path,width:"100%",frameborder:"0"})," ");if(this.state.imageInfo.fileType=='video')filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Common_Video__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+this.state.imageInfo.path,width:"100%",height:"500"});if(this.state.imageInfo.fileType=='image')filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+this.state.imageInfo.path});if(this.state.imageInfo.fileType=='doc'||this.state.imageInfo.fileType=='sheet'||this.state.imageInfo.fileType=='pdf'||this.state.imageInfo.fileType=='zip'){filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("iframe",{className:'height-for-modal',width:"100%",src:"https://docs.google.com/viewer?url="+this.state.imageInfo.url+"&embedded=true",frameborder:"0"}));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_alert___default.a,Object.assign({ref:function ref(a){return _this3.msg=a;}},__WEBPACK_IMPORTED_MODULE_15__Common_Alert__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,Heading),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary pull-right",onClick:function onClick(e){return _this3.openForm(e,'add');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons vertical-align-middle"},"add"),"add file")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},this.state.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common_Loading__["a" /* default */],null),this.state.imageEdit===true?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"table-site"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{"class":"text-center site-title"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,this.state.action," FILE"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 col-md-offset-3 product-form"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"imageName",value:this.state.imageInfo.imageName,label:"File Name",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"imageType",value:this.state.imageInfo.imageType,options:this.state.imageTypeOption,label:"File Type",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"file-field input-field form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{style:{fontSize:"10px",color:"white"}},"File"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",id:"fileItem",onChange:function onChange(e){return _this3.uploadNewImage(e);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"file-path-wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{"class":"file-path validate form-control",type:"text",style:{marginTop:"6px"},value:this.state.imageInfo.fileName,disabled:true})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one mb-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"imageDescription",value:this.state.imageInfo.imageDescription,label:"Comments",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",name:"button",onClick:function onClick(){return _this3.updateImage();}},this.state.action=='add'?'Add':'Update'," File")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this3.setState({imageEdit:false});},style:{color:"#fff",cursor:"pointer"},"class":"primary site-add-go-back"},"Back")))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ref-images",style:{paddingLeft:0,paddingRight:"0"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"list-inline pt-3"},this.state.refImages.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:index,className:"img-responsive-fill-list p-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"data-lightbox":"image-1",onClick:function onClick(){_this3.setState({loading:true});setTimeout(function(){return _this3.setState({openModal:true,imageInfo:Object.assign({},image),loading:false});},2000);}},image.fileType=='image'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+image.path}):image.fileType=='pdf'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png___default.a}):image.fileType=='doc'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png___default.a}):image.fileType=='sheet'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png___default.a}):image.fileType=='zip'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png___default.a}):image.fileType=='video'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png___default.a}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{"class":"img-label"},image.imageName===""?"Sketch"+(index+1):image.imageName!==""&&image.imageName!==undefined&&image.imageName.length>7?image.imageName.substring(0,7):image.imageName)),!_this3.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black main-edit",title:"Edit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons",onClick:function onClick(){return _this3.setState({imageEdit:true},_this3.imageInfo(index));}},"edit"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black edit edit-img",title:"img-edit",onClick:function onClick(){return _this3.downloadFile(image);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"file_download"))),!_this3.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light red delete",title:"Delete",onClick:function onClick(){return _this3.removeImage(index);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"close"))));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this3.setState({openModal:false});},s:true,center:true},filePreviewIframe));}}]);return FileUpload;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FileUpload);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(37);

var ContentStateInlineStyle = __webpack_require__(735);

var applyEntityToContentState = __webpack_require__(736);

var getCharacterRemovalRange = __webpack_require__(738);

var getContentStateFragment = __webpack_require__(113);

var Immutable = __webpack_require__(8);

var insertFragmentIntoContentState = __webpack_require__(741);

var insertTextIntoContentState = __webpack_require__(742);

var invariant = __webpack_require__(9);

var modifyBlockForContentState = __webpack_require__(255);

var removeEntitiesAtEdges = __webpack_require__(253);

var removeRangeFromContentState = __webpack_require__(743);

var splitBlockInContentState = __webpack_require__(744);

var OrderedSet = Immutable.OrderedSet;
/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });
    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);
    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey, endKey, startBlock, endBlock;

    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }

    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.

    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, adjustedRemovalRange);
      }
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
    return removeRangeFromContentState(withoutEntities, rangeToRemove);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};
module.exports = DraftModifier;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var UserAgentData = __webpack_require__(754);

var VersionRange = __webpack_require__(757);

var mapObject = __webpack_require__(758);

var memoizeStringOnly = __webpack_require__(759);
/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */


function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  } // check for non-matching names


  if (!query.startsWith(name)) {
    return false;
  } // full comparison with version


  var range = query.slice(name.length);

  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}
/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */


function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}
/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */


var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },

  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },

  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },

  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },

  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },

  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};
module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropdown_tree_select__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropdown_tree_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dropdown_tree_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var assignObjectPaths=function assignObjectPaths(obj,stack){Object.keys(obj).forEach(function(k){var node=obj[k];if((typeof node==="undefined"?"undefined":_typeof(node))==="object"){node.path=stack?stack+"."+k:k;assignObjectPaths(node,node.path);}});};var onChange=function onChange(currentNode,selectedNodes){// (selectedNodes)=> this.props.selectedCustomers(selectedNodes)
// this.props.selectedCustomers(selectedNodes)
};var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.componentWillReceiveProps=function(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(nextProps.customerInfo,_this.state.data)){_this.setState({data:nextProps.customerInfo});}};_this.shouldComponentUpdate=function(nextProps){return!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(nextProps.customerInfo,_this.state.data);};_this.getCustomer=function(selectedNodes){_this.props.selectedCustomers(selectedNodes);};_this.state={data:_this.props.customerInfo};return _this;}_createClass(App,[{key:"render",value:function render(){if(this.state.data!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropdown_tree_select___default.a,{data:this.state.data,onChange:this.props.selectedCustomers,className:"bootstrap-demo"});}else return'';}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (App);// import React from "react";
// import { render } from "react-dom";
// import DropdownTreeSelect from "react-dropdown-tree-select";
// const onChange = (currentNode, selectedNodes) => {
//   
// };
// const assignObjectPaths = (obj, stack) => {
//   Object.keys(obj).forEach(k => {
//     const node = obj[k];
//     if (typeof node === "object") {
//       node.path = stack ? `${stack}.${k}` : k;
//       assignObjectPaths(node, node.path);
//     }
//   });
// };
// export default function App(props) {
//   if(props.customerInfo !== undefined){
//       assignObjectPaths(props.customerInfo);
//       return (
//         <DropdownTreeSelect
//           data={props.customerInfo}
//           onChange={props.selectedCustomers}
//           className="bootstrap-demo"
//           value={props.customerChoosen}
//         />
//       );
//   }
//   else return '';
// };

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(169);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(125);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    if (this.props.onClick) this.props.onClick(event);

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      location = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;
      var isActive = !!(isActiveProp ? isActiveProp(match, location) : match);
      var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
      var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
        "aria-current": isActive && ariaCurrent || null,
        className: className,
        style: style,
        to: to
      }, rest));
    }
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: Route.propTypes.exact,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: Route.propTypes.strict,
    style: PropTypes.object
  });
}




/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

exports.confirmAlert = confirmAlert;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactConfirmAlert = (_temp2 = _class = function (_Component) {
  _inherits(ReactConfirmAlert, _Component);

  function ReactConfirmAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactConfirmAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactConfirmAlert.__proto__ || Object.getPrototypeOf(ReactConfirmAlert)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickButton = function (button) {
      if (button.onClick) button.onClick();
      _this.close();
    }, _this.handleClickOverlay = function (e) {
      var _this$props = _this.props,
          closeOnClickOutside = _this$props.closeOnClickOutside,
          onClickOutside = _this$props.onClickOutside;

      var isClickOutside = e.target === _this.overlay;

      if (closeOnClickOutside && isClickOutside) {
        onClickOutside();
        _this.close();
      }
    }, _this.close = function () {
      var afterClose = _this.props.afterClose;

      removeBodyClass();
      removeElementReconfirm();
      removeSVGBlurReconfirm(afterClose);
    }, _this.keyboardClose = function (event) {
      var _this$props2 = _this.props,
          closeOnEscape = _this$props2.closeOnEscape,
          onKeypressEscape = _this$props2.onKeypressEscape,
          keyCodeForClose = _this$props2.keyCodeForClose;

      var keyCode = event.keyCode;
      var isKeyCodeEscape = keyCode === 27;

      if (keyCodeForClose.includes(keyCode)) {
        _this.close();
      }

      if (closeOnEscape && isKeyCodeEscape) {
        onKeypressEscape(event);
        _this.close();
      }
    }, _this.componentDidMount = function () {
      document.addEventListener('keydown', _this.keyboardClose, false);
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('keydown', _this.keyboardClose, false);
      _this.props.willUnmount();
    }, _this.renderCustomUI = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          message = _this$props3.message,
          buttons = _this$props3.buttons,
          customUI = _this$props3.customUI;

      var dataCustomUI = {
        title: title,
        message: message,
        buttons: buttons,
        onClose: _this.close
      };

      return customUI(dataCustomUI);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactConfirmAlert, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          message = _props.message,
          buttons = _props.buttons,
          childrenElement = _props.childrenElement,
          customUI = _props.customUI,
          overlayClassName = _props.overlayClassName;


      return _react2.default.createElement(
        'div',
        {
          className: 'react-confirm-alert-overlay ' + overlayClassName,
          ref: function ref(dom) {
            return _this2.overlay = dom;
          },
          onClick: this.handleClickOverlay
        },
        _react2.default.createElement(
          'div',
          { className: 'react-confirm-alert' },
          customUI ? this.renderCustomUI() : _react2.default.createElement(
            'div',
            { className: 'react-confirm-alert-body' },
            title && _react2.default.createElement(
              'h1',
              null,
              title
            ),
            message,
            childrenElement(),
            _react2.default.createElement(
              'div',
              { className: 'react-confirm-alert-button-group' },
              buttons.map(function (button, i) {
                return _react2.default.createElement(
                  'button',
                  { key: i, onClick: function onClick() {
                      return _this2.handleClickButton(button);
                    }, className: button.className },
                  button.label
                );
              })
            )
          )
        )
      );
    }
  }]);

  return ReactConfirmAlert;
}(_react.Component), _class.propTypes = {
  title: _propTypes2.default.string,
  message: _propTypes2.default.string,
  buttons: _propTypes2.default.array.isRequired,
  childrenElement: _propTypes2.default.func,
  customUI: _propTypes2.default.func,
  closeOnClickOutside: _propTypes2.default.bool,
  closeOnEscape: _propTypes2.default.bool,
  keyCodeForClose: _propTypes2.default.arrayOf(_propTypes2.default.number),
  willUnmount: _propTypes2.default.func,
  afterClose: _propTypes2.default.func,
  onClickOutside: _propTypes2.default.func,
  onKeypressEscape: _propTypes2.default.func,
  overlayClassName: _propTypes2.default.string
}, _class.defaultProps = {
  buttons: [{
    label: 'Cancel',
    onClick: function onClick() {
      return null;
    },
    className: null
  }, {
    label: 'Confirm',
    onClick: function onClick() {
      return null;
    },
    className: null
  }],
  childrenElement: function childrenElement() {
    return null;
  },
  closeOnClickOutside: true,
  closeOnEscape: true,
  keyCodeForClose: [],
  willUnmount: function willUnmount() {
    return null;
  },
  afterClose: function afterClose() {
    return null;
  },
  onClickOutside: function onClickOutside() {
    return null;
  },
  onKeypressEscape: function onKeypressEscape() {
    return null;
  }
}, _temp2);
exports.default = ReactConfirmAlert;


function createSVGBlurReconfirm() {
  // If has svg ignore to create the svg
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  if (svg) return;
  var svgNS = 'http://www.w3.org/2000/svg';
  var feGaussianBlur = document.createElementNS(svgNS, 'feGaussianBlur');
  feGaussianBlur.setAttribute('stdDeviation', '0.3');

  var filter = document.createElementNS(svgNS, 'filter');
  filter.setAttribute('id', 'gaussian-blur');
  filter.appendChild(feGaussianBlur);

  var svgElem = document.createElementNS(svgNS, 'svg');
  svgElem.setAttribute('id', 'react-confirm-alert-firm-svg');
  svgElem.setAttribute('class', 'react-confirm-alert-svg');
  svgElem.appendChild(filter);

  document.body.appendChild(svgElem);
}

function removeSVGBlurReconfirm(afterClose) {
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  if (svg) {
    svg.parentNode.removeChild(svg);
  }
  document.body.children[0].classList.remove('react-confirm-alert-blur');
  afterClose();
}

function createElementReconfirm(properties) {
  var divTarget = document.getElementById('react-confirm-alert');
  if (divTarget) {
    // Rerender - the mounted ReactConfirmAlert
    (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
  } else {
    // Mount the ReactConfirmAlert component
    document.body.children[0].classList.add('react-confirm-alert-blur');
    divTarget = document.createElement('div');
    divTarget.id = 'react-confirm-alert';
    document.body.appendChild(divTarget);
    (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
  }
}

function removeElementReconfirm() {
  var target = document.getElementById('react-confirm-alert');
  if (target) {
    (0, _reactDom.unmountComponentAtNode)(target);
    target.parentNode.removeChild(target);
  }
}

function addBodyClass() {
  document.body.classList.add('react-confirm-alert-body-element');
}

function removeBodyClass() {
  document.body.classList.remove('react-confirm-alert-body-element');
}

function confirmAlert(properties) {
  addBodyClass();
  createSVGBlurReconfirm();
  createElementReconfirm(properties);
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_ENV":"production"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(79), __webpack_require__(178)(module)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ButtonIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ButtonIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{display:"block"},"class":"btn-floating float-btn btn-small waves-effect waves-light add_item ml-auto mb-1"+(props.buttonType=="add"?" green ":" red "),onClick:props.addRemoveFunc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},props.buttonType=="add"?"add":"clear"));}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}var React=__webpack_require__(0),React__default=_interopDefault(React);__webpack_require__(3);var debounce=function(r,n){var l=null;return function(){clearTimeout(l);var e=arguments,t=this;l=setTimeout(function(){r.apply(t,e)},n)}};function includes(e,t,r){return r?-1<String(e).indexOf(String(t)):-1<String(e).toLowerCase().indexOf(String(t).toLowerCase())}function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var isDataObject=function(e,t,r){return"object"===_typeof(e)&&e.hasOwnProperty(t)&&e.hasOwnProperty(r)},hasItem=function(e,t,r,n,l){if(!e||!t)return!1;if(Array.isArray(e)){if(isDataObject(t,r,n)){var o=e.findIndex(function(e){return e[r]===t[r]});return l?o:-1<o}var i=e.indexOf(t);return l?i:-1<i}return isDataObject(t,r,n)?e[r]===t[r]:e===t},hasItemIndex=function(e,t,r,n){return hasItem(e,t,r,n,!0)},keyExtractor=function(e,t,r){return isDataObject(e,t,r)?e[t]:e},sortCollection=function(e,r){return r?e.sort(function(e,t){return e[r]<t[r]?-1:1}):e.sort(function(e,t){return e<t?-1:1})};function arraysEqual(e,t){if(e.length!==t.length)return!1;for(var r=e.length;r;){if(e[r]!==t[r])return!1;r--}return!0}function split(e){var t=1,r="",n=e.split("%"),l=n.length;0<l&&(r+=n[0]);for(var o=1;o<l;o++){if("s"===n[o][0]||"d"===n[o][0]){var i=arguments[t++];r+="d"===n[o][0]?Math.floor(i):i}else n[o][0]?r+="%"+n[o][0]:r+="%"+n[++o][0];r+=n[o].substring(1)}return r}var regex=/%[sdj]/;function format(e){return regex.test(e)?split.apply(null,arguments):Array.from(arguments).join(" ")}var hasOwnProperty=Object.prototype.hasOwnProperty;function is(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!=e&&t!=t}function shallowEqual(e,t){if(is(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var r=Object.keys(e),n=Object.keys(t);if(r.length!==n.length)return!1;for(var l=0;l<r.length;l++)if(!hasOwnProperty.call(t,r[l])||!is(e[r[l]],t[r[l]]))return!1;return!0}var shallowEqual_1=shallowEqual;function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t}function unwrapExports(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var lib=createCommonjsModule(function(e,t){Object.defineProperty(t,"__esModule",{value:!0});t.createChangeEmitter=function(){var r=[],n=r;function l(){n===r&&(n=r.slice())}return{listen:function(t){if("function"!=typeof t)throw new Error("Expected listener to be a function.");var r=!0;return l(),n.push(t),function(){if(r){r=!1,l();var e=n.indexOf(t);n.splice(e,1)}}},emit:function(){for(var e=r=n,t=0;t<e.length;t++)e[t].apply(e,arguments)}}}});unwrapExports(lib);var root,lib_1=lib.createChangeEmitter;function symbolObservablePonyfill(e){var t,r=e.Symbol;return"function"==typeof r?r.observable?t=r.observable:(t=r("observable"),r.observable=t):t="@@observable",t}var result=symbolObservablePonyfill(root="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global: true?module:Function("return this")()),setStatic=function(t,r){return function(e){return e[t]=r,e}},setDisplayName=function(e){return setStatic("displayName",e)},getDisplayName=function(e){return"string"==typeof e?e:e?e.displayName||e.name||"Component":void 0},wrapDisplayName=function(e,t){return t+"("+getDisplayName(e)+")"},pick=function(e,t){for(var r={},n=0;n<t.length;n++){var l=t[n];e.hasOwnProperty(l)&&(r[l]=e[l])}return r},shouldUpdate=function(l){return function(e){var n=React.createFactory(e),t=function(e){function t(){return e.apply(this,arguments)||this}_inheritsLoose(t,e);var r=t.prototype;return r.shouldComponentUpdate=function(e){return l(this.props,e)},r.render=function(){return n(this.props)},t}(React.Component);return false?setDisplayName(wrapDisplayName(e,"shouldUpdate"))(t):t}},onlyUpdateForKeys=function(r){var t=shouldUpdate(function(e,t){return!shallowEqual_1(pick(t,r),pick(e,r))});return false?function(e){return setDisplayName(wrapDisplayName(e,"onlyUpdateForKeys"))(t(e))}:t},isEmptyValue=function(e){return null==e||Array.isArray(e)&&!e.length},Placeholder=function(e){var t=e.placeholder,r=e.value,n=e.numberDisplayed,l=e.multiple,o=e.valueKey,i=e.labelKey,a=e.manySelectedPlaceholder,s=e.allSelectedPlaceholder,u=e.allSelected,c="";if(isEmptyValue(r))c=t;else if(Array.isArray(r)&&l)r.length<=n?c=r.map(function(e){return isDataObject(e,o,i)?e[i]:e}).join(", "):a&&!u?c=includes(a,"%s")?format(a,r.length):a:u&&s&&(c=includes(s,"%s")?format(s,r.length):s);else{var p=Array.isArray(r)?r[0]:r;c=isDataObject(p,o,i)?p[i]:p}return React__default.createElement("span",{className:isEmptyValue(r)?"picky__placeholder":void 0},c)};Placeholder.defaultProps={placeholder:"None selected",allSelectedPlaceholder:"%s selected",manySelectedPlaceholder:"%s selected",allSelected:!1};var Placeholder$1=onlyUpdateForKeys(["multiple","value","numberDisplayed","allSelected","allSelectedPlaceholder"])(Placeholder);function _typeof$1(e){return(_typeof$1="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){return t&&_defineProperties(e.prototype,t),r&&_defineProperties(e,r),e}function _possibleConstructorReturn(e,t){return!t||"object"!==_typeof$1(t)&&"function"!=typeof t?_assertThisInitialized(e):t}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var Filter=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.Component),_createClass(t,[{key:"shouldComponentUpdate",value:function(e){return this.props.placeholder!==e.placeholder||this.props.tabIndex!==e.tabIndex}},{key:"render",value:function(){var t=this;return React__default.createElement("div",{className:"picky__filter"},React__default.createElement("input",{type:"text",ref:function(e){return t.filterInput=e},className:"picky__filter__input",placeholder:this.props.placeholder,tabIndex:this.props.tabIndex,"aria-label":"filter options",onChange:function(e){return t.props.onFilterChange(e.target.value)}}))}}]),t}();Filter.defaultProps={placeholder:"Filter..."};var Option=function(e){var t=e.id,r=e.item,n=e.isSelected,l=e.labelKey,o=e.valueKey,i=e.selectValue,a=e.style,s=e.multiple,u=e.tabIndex,c=e.disabled,p=n?"option selected":"option",d=isDataObject(r,l,o)?r[l]:r,f=s?"checkbox":"radio";return React__default.createElement("div",{tabIndex:u,id:t,role:"option",style:a,"data-selected":n?"selected":"","aria-selected":n,className:p,onClick:function(){return!c&&i(r)},onKeyPress:function(e){e.preventDefault(),c||i(r)}},React__default.createElement("input",{type:f,readOnly:!0,tabIndex:-1,disabled:c,checked:n,"aria-label":d}),d)},Option$1=onlyUpdateForKeys(["multiple","isSelected","id","item","tabIndex"])(Option);function SelectAll(e){var t=e.tabIndex,r=e.disabled,n=e.allSelected,l=e.id,o=e.selectAllText,i=e.toggleSelectAll;return e.visible?React__default.createElement("div",{tabIndex:t,role:"option",id:l+"-option-selectall","data-selectall":"true","aria-selected":n,className:n?"option selected":"option",onClick:i,disabled:r,onKeyPress:i},React__default.createElement("input",{type:"checkbox",readOnly:!0,tabIndex:-1,checked:n,"aria-label":"select all",disabled:r}),React__default.createElement("span",null,o)):null}var SelectAll$1=onlyUpdateForKeys(["tabIndex","disabled","allSelected","selectAllText","visible"])(SelectAll);function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function _objectWithoutProperties(e,t){if(null==e)return{};var r,n,l=_objectWithoutPropertiesLoose(e,t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);for(n=0;n<o.length;n++)r=o[n],0<=t.indexOf(r)||Object.prototype.propertyIsEnumerable.call(e,r)&&(l[r]=e[r])}return l}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,n,l={},o=Object.keys(e);for(n=0;n<o.length;n++)r=o[n],0<=t.indexOf(r)||(l[r]=e[r]);return l}function Button(e){var t=e.id,r=e.disabled,n=e.onClick,l=e.children,o=e.className,i=_objectWithoutProperties(e,["id","disabled","onClick","children","className"]),a="".concat(t,"__button"),s=["picky__input",r?"picky__input--disabled":"",o].join(" ");return React__default.createElement("button",_extends({id:a,type:"button",className:s,onClick:n,disabled:r},i),l)}Button.displayName="Button";var Button$1=onlyUpdateForKeys(["disabled","children"])(Button);function _typeof$2(e){return(_typeof$2="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _extends$1(){return(_extends$1=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function _objectSpread(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},n=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),n.forEach(function(e){_defineProperty(t,e,r[e])})}return t}function _defineProperty(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_nonIterableSpread()}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function _iterableToArray(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}function _arrayWithoutHoles(e){if(Array.isArray(e)){for(var t=0,r=new Array(e.length);t<e.length;t++)r[t]=e[t];return r}}function _classCallCheck$1(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties$1(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function _createClass$1(e,t,r){return t&&_defineProperties$1(e.prototype,t),r&&_defineProperties$1(e,r),e}function _possibleConstructorReturn$1(e,t){return!t||"object"!==_typeof$2(t)&&"function"!=typeof t?_assertThisInitialized$1(e):t}function _getPrototypeOf$1(e){return(_getPrototypeOf$1=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _assertThisInitialized$1(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _inherits$1(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf$1(e,t)}function _setPrototypeOf$1(e,t){return(_setPrototypeOf$1=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var Picky=function(e){function r(e){var t;return _classCallCheck$1(this,r),(t=_possibleConstructorReturn$1(this,_getPrototypeOf$1(r).call(this,e))).state={selectedValue:e.value||(e.multiple?[]:null),open:e.open,filtered:!1,filteredOptions:[],allSelected:!1},t.toggleDropDown=t.toggleDropDown.bind(_assertThisInitialized$1(t)),t.toggleSelectAll=t.toggleSelectAll.bind(_assertThisInitialized$1(t)),t.onFilterChange=t.onFilterChange.bind(_assertThisInitialized$1(t)),t.selectValue=t.selectValue.bind(_assertThisInitialized$1(t)),t.allSelected=t.allSelected.bind(_assertThisInitialized$1(t)),t.handleOutsideClick=t.handleOutsideClick.bind(_assertThisInitialized$1(t)),t.isItemSelected=t.isItemSelected.bind(_assertThisInitialized$1(t)),t.focusFilterInput=t.focusFilterInput.bind(_assertThisInitialized$1(t)),t.getValue=t.getValue.bind(_assertThisInitialized$1(t)),t}return _inherits$1(r,React__default.PureComponent),_createClass$1(r,[{key:"UNSAFE_componentWillMount",value:function(){this.setState({allSelected:this.allSelected()})}},{key:"componentDidMount",value:function(){this.focusFilterInput(this.state.open)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("click",this.handleOutsideClick,!1)}},{key:"UNSAFE_componentWillReceiveProps",value:function(e){if(this.props.options!==e.options||this.props.value!==e.value){var t=Array.isArray(e.value)?arraysEqual(e.value,this.props.value):e.value===this.props.value,r=arraysEqual(e.options,this.props.options);this.setState({allSelected:t&&r?this.allSelected():this.allSelected(e.value,e.options)})}}},{key:"selectValue",value:function(e){var t=this,r=this.props.value;if(this.props.multiple&&Array.isArray(r)){var n=hasItemIndex(r,e,this.props.valueKey,this.props.labelKey),l=[];l=-1<n?[].concat(_toConsumableArray(r.slice(0,n)),_toConsumableArray(r.slice(n+1))):[].concat(_toConsumableArray(this.props.value),[e]),this.setState({allSelected:this.allSelected(l)},function(){t.props.onChange(l)})}else this.props.onChange(e)}},{key:"getValue",value:function(e){return void 0!==this.props.valueKey?e[this.props.valueKey]:e}},{key:"allSelected",value:function(e,t){var r=this.props,n=r.value,l=r.options,o=e||n,i=t||l;if(i&&0===i.length)return!1;var a=i.map(this.getValue),s=Array.isArray(o)?o.map(this.getValue):[];return arraysEqual(sortCollection(s),sortCollection(a))}},{key:"toggleSelectAll",value:function(){var t=this;this.props.disabled||this.setState(function(e){return _objectSpread({},e,{allSelected:!t.state.allSelected})},function(){t.state.allSelected?t.props.onChange(t.props.options):t.props.onChange([])})}},{key:"isItemSelected",value:function(e){return hasItem(this.props.value,e,this.props.valueKey,this.props.labelKey)}},{key:"renderOptions",value:function(){var l=this,e=this.state.filtered?this.state.filteredOptions:this.props.options,t=this.props,o=t.labelKey,i=t.valueKey,a=t.multiple,s=t.render,u=t.tabIndex,r=t.renderList,c=t.disabled;return r?r({items:e,selected:this.props.value,multiple:a,tabIndex:u,getIsSelected:this.isItemSelected,selectValue:this.selectValue,disabled:c}):e.map(function(e,t){var r=keyExtractor(e,i,o),n=l.isItemSelected(e);return"function"==typeof s?s({index:t,item:e,isSelected:n,selectValue:l.selectValue,labelKey:o,valueKey:i,multiple:a,disabled:c}):React__default.createElement(Option$1,{key:r,item:e,isSelected:n,selectValue:l.selectValue,labelKey:o,valueKey:i,multiple:a,tabIndex:u,disabled:c,id:l.props.id+"-option-"+t})})}},{key:"onFilterChange",value:function(t){var r=this;if(this.props.getFilterValue&&this.props.getFilterValue(t),!t.trim())return this.setState({filtered:!1,filteredOptions:[]});var n=isDataObject(this.props.options&&this.props.options[0],this.props.valueKey,this.props.labelKey),e=this.props.options.filter(function(e){return includes(n?e[r.props.labelKey]:e,t,r.props.caseSensitiveFilter)});this.setState({filtered:!0,filteredOptions:e},function(){r.props.onFiltered&&r.props.onFiltered(e)})}},{key:"handleOutsideClick",value:function(e){var t=this.props.keepOpen||this.props.multiple;this.node&&this.node.contains(e.target)&&t||this.filter&&this.filter.filterInput&&this.filter.filterInput.contains(e.target)||this.toggleDropDown()}},{key:"focusFilterInput",value:function(e){this.filter&&this.filter.filterInput&&(e&&this.props.defaultFocusFilter&&this.filter.filterInput.focus(),e||!0!==this.props.clearFilterOnClose||(this.filter.filterInput.value=""))}},{key:"toggleDropDown",value:function(){var t=this;this.state.open?document.removeEventListener("click",this.handleOutsideClick,!1):document.addEventListener("click",this.handleOutsideClick,!1),this.setState(function(e){return _objectSpread({},e,{open:!e.open,filtered:!t.props.clearFilterOnClose&&e.filtered,filteredOptions:t.props.clearFilterOnClose?[]:e.filteredOptions})},function(){var e=t.state.open;t.focusFilterInput(e),e&&t.props.onOpen?t.props.onOpen():!e&&t.props.onClose&&t.props.onClose()})}},{key:"render",value:function(){var t=this,e=this.props,r=e.className,n=e.placeholder,l=e.value,o=e.multiple,i=e.numberDisplayed,a=e.includeFilter,s=e.valueKey,u=e.labelKey,c=e.tabIndex,p=e.dropdownHeight,d=e.renderSelectAll,f=e.filterPlaceholder,y=e.disabled,h=e.buttonProps,b=this.state.open,_="";b&&(_+=this.props.id+"-list");var v="".concat(this.props.id,"__button"),m={maxHeight:p,overflowY:"scroll"};return React__default.createElement("div",{ref:function(e){t.node=e},className:["picky",r].join(" "),id:this.props.id,role:"combobox","aria-controls":v,"aria-expanded":b,"aria-haspopup":b,"aria-owns":_,tabIndex:c},React__default.createElement(Button$1,_extends$1({id:"".concat(this.props.id,"__button"),disabled:y,onClick:this.toggleDropDown},h),React__default.createElement(Placeholder$1,{allSelected:this.state.allSelected,placeholder:n,manySelectedPlaceholder:this.props.manySelectedPlaceholder,allSelectedPlaceholder:this.props.allSelectedPlaceholder,value:l,multiple:o,numberDisplayed:i,valueKey:s,labelKey:u})),React__default.createElement("div",{className:"picky__dropdown",id:this.props.id+"-list","aria-hidden":!b,hidden:!b,style:b?m:{visibility:"hidden"}},a&&React__default.createElement(Filter,{ref:function(e){return t.filter=e},placeholder:f,onFilterChange:this.filterDebounce}),d?d({filtered:this.state.filtered,allSelected:this.state.allSelected,toggleSelectAll:this.toggleSelectAll,tabIndex:c,multiple:o,disabled:y}):React__default.createElement(SelectAll$1,{visible:this.showSelectAll,tabIndex:c,disabled:y,allSelected:this.state.allSelected,id:this.props.id,selectAllText:this.props.selectAllText,toggleSelectAll:this.toggleSelectAll}),b&&React__default.createElement("div",null,this.renderOptions())))}},{key:"filterDebounce",get:function(){var e=this.props.filterDebounce;return 0<e?debounce(this.onFilterChange,e):this.onFilterChange}},{key:"showSelectAll",get:function(){var e=this.props,t=e.renderSelectAll,r=e.multiple,n=e.includeSelectAll;return!t&&n&&r&&("default"===this.props.selectAllMode&&!this.state.filtered||"filtered"===this.props.selectAllMode)}}]),r}();Picky.defaultProps={id:"picky",numberDisplayed:3,options:[],filterDebounce:150,dropdownHeight:300,onChange:function(){},tabIndex:0,keepOpen:!0,selectAllText:"Select all",selectAllMode:"default"},Array.prototype.findIndex||Object.defineProperty(Array.prototype,"findIndex",{value:function(e){if(null==this)throw new TypeError('"this" is null or not defined');var t=Object(this),r=t.length>>>0;if("function"!=typeof e)throw new TypeError("predicate must be a function");for(var n=arguments[1],l=0;l<r;){var o=t[l];if(e.call(n,o,l,t))return l;l++}return-1}}),module.exports=Picky;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(76)(module)))

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAnFBMVEUAAAAAl4kAlogAlogAqqoAlogAl4gAlogAlogAl4sAlIYAlogAl4gAlogAl4cAlocAi4sAl4cAlogAlYgAmYAAlogAmIoAlogAlYgAlYgAmIYAlogAlogAl4UAlogAl4gAlYkAlogAlYkAlYcAlogAlocAlocAlogAlogAlYkAlIgAlocAl4kAlogAnYkAl4gAlokAl4gAlogAAAAMy7zRAAAAMnRSTlMAf93DA22wu7kWN/CO23NmC0LtPAq9Jb7oXiq46SyteEHcKZHzM6CFo8ZPRG71DZDTwY6r08sAAAABYktHRACIBR1IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4wYEECkhSC+NvgAAAH1JREFUGNNjYMANGJmAgJmBhZWNHQQ4OLm4jYCAgYeXjx8MBBgEwQJCwjAtIqJgASMxGF/cSEKSGyEA4ksxcEnDBIDqZWTBLIgAgg8VkAOpl5dHCCgoKjEwKCsjBMAAIqCiChdQUweRGppa2hCgo8sFEtDTN2CCAEMtrH4GAN28DZKTD+hKAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA2LTA0VDE0OjQxOjMzKzAyOjAwijwcMgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNi0wNFQxNDo0MTozMyswMjowMPthpI4AAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/testIcon.7a057e7b.svg";

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return roleFilter; });
var options={currency:[{label:"$",value:"dollar"},{label:"₹",value:"rupee"}],typeOfRequest:[{label:"Initial",value:"initial"},{label:"Production",value:"production"},{label:"Product",value:"product"}],processTypeoptions:[{label:"Sample",value:"sample"},{label:"Garment Tech",value:"garmentTechnologist"},{label:"3D",value:"cad"},{label:"Fabric",value:"fabric"},{label:"Trim",value:"trim"},{label:"Pattern",value:"pattern"},{label:"Cutting",value:"cutting"},{label:"Sewing",value:"sewing"},{label:"Embellishment",value:"embellishment"},{label:"Embroidery",value:"embroidery"},{label:"Wash",value:"wash"},{label:"Dispatch",value:"dispatch"},{label:"Grading",value:"qc"},{label:"Marker",value:"marker"},{label:"Costing",value:"costing"},{label:"SignOff",value:"signOff"}]};var tableHeader={//meetingNOtes
meetingNoteTable:[{tableName:"MN ID",tableKeyName:"MNId"},{tableName:"Customer-Dept",tableKeyName:"customerAndDepartmentName"},{tableName:"Date of Meeting",tableKeyName:"dateOfMeeting"},{tableName:"Place of Meeting",tableKeyName:"placeOfMeeting"}],//customer
customerTable:[{tableName:"Customer Code",tableKeyName:"customerCode"},{tableName:"Customer Name",tableKeyName:"customerName"},{tableName:"Status",tableKeyName:"customerStatus"}],//fabric
fabricTable:[{tableName:"Fabric No",tableKeyName:"fabricNumber"},{tableName:"Dev ref no",tableKeyName:"devRefNumber"},{tableName:"Count & Construction",tableKeyName:"count & construction"},{tableName:"Quality",tableKeyName:"quality"},{tableName:"Classification",tableKeyName:"classificationOfFabric"},{tableName:"Supplier Name",tableKeyName:"supplierName"},{tableName:"Price ",tableKeyName:"price"}],//cad
cadTable:[{tableName:"Customer - Dept",tableKeyName:"customerAndDepartmentName"},{tableName:"Style No.",tableKeyName:"magnumStyleId"},{tableName:"3D Type",tableKeyName:"cadType"},{tableName:"3D name",tableKeyName:"cadName"},{tableName:"Category",tableKeyName:"category"},{tableName:"Print Type",tableKeyName:"printType"},{tableName:"Story Name",tableKeyName:"storyName"}],//style
styleTable:[{tableName:"Style No / Ref",tableKeyName:"styleNo"},{tableName:"Style name",tableKeyName:"styleName"},{tableName:"Cust ref no",tableKeyName:"custRefNo"},{tableName:"Item no",tableKeyName:"itemNo"},{tableName:"Cust-Dept",tableKeyName:"cust_Dept"},{tableName:"Garment type",tableKeyName:"garmentType"},{tableName:"Fabric type",tableKeyName:"fabricType"}],smvTable:[{tableName:"SMV No.",tableKeyName:"smvNumber"},{tableName:"Style No/Ref",tableKeyName:"styleNo"},{tableName:"Style name",tableKeyName:"styleName"},{tableName:"Cust-Dept",tableKeyName:"customer"},{tableName:"Total SAM",tableKeyName:"totalSam"},{tableName:"Total Thread",tableKeyName:"totalVal"}],tiTable:[{tableName:"Issue.No",tableKeyName:"issueNumber"},{tableName:"Date",tableKeyName:"date"},{tableName:"Style No/Ref",tableKeyName:"styleNo"},{tableName:"Style name",tableKeyName:"styleName"},{tableName:"Cust-Dept",tableKeyName:"customer"}],//trim
trimTable:[{tableName:"Trim No",tableKeyName:"trimNumber"},{tableName:"Category",tableKeyName:"trimCategory"},{tableName:"Description",tableKeyName:"description"},{tableName:"Supplier ref no",tableKeyName:"supplierRef"},{tableName:"Supplier",tableKeyName:"supplierName"},{tableName:"Price",tableKeyName:"price"},{tableName:"Size",tableKeyName:"sizeNumber"}],//sourcing
sourcingTable:[{tableName:"Sourcing No",tableKeyName:"sourcingNumber"},{tableName:"Meeting No",tableKeyName:"MNID"},{tableName:"Origination Of Request",tableKeyName:"originationOfRequest"},{tableName:"Supplier ref no",tableKeyName:"supplierRefId"},{tableName:"season",tableKeyName:"season"},{tableName:"Measurement",tableKeyName:"measurement"}],//sampleRequest
samplerequestTable:[{tableName:"SR No.",tableKeyName:"requestNumber"},{tableName:"Date of Req.",tableKeyName:"createdAt"},{tableName:"Style No.",tableKeyName:"styleNumber"},{tableName:"Style Name",tableKeyName:"styleName"},{tableName:"Cust-Dept",tableKeyName:"customerName"},{tableName:"Cust Ref no",tableKeyName:"customerId"},{tableName:"Source of Req.",tableKeyName:"typeOfRequest"},{tableName:"Sample Type",tableKeyName:"sampleType"}],//systemSupplier
systemSupplierTable:[{tableName:"Supplier Code",tableKeyName:"supplierCode"},{tableName:"Supplier Name",tableKeyName:"supplierName"},{tableName:"Status",tableKeyName:"supplierStatus"}],// print fabric list
fabricPrintTable:[{tableName:"FABRIC NO",tableKeyName:"fabricNumber"},{tableName:"SUPPLIER",tableKeyName:"supplierName"},{tableName:"SUPP REF NO",tableKeyName:"supplierRefNo"},{tableName:"COUNT",tableKeyName:"count"},{tableName:"CONSTRUCTION",tableKeyName:"construction"},{tableName:"QUALITY",tableKeyName:"quality"},{tableName:"COMPOSITION",tableKeyName:"composition"},{tableName:"GSM / WIDTH",tableKeyName:"gsm"},{tableName:"QTY RCVD",tableKeyName:"quantityReceived"}],stylePrintTable:[{tableName:"DATE",tableKeyName:"date"},{tableName:"MAGNUM STYLE NO",tableKeyName:"styleNo"},{tableName:"STYLE NAME",tableKeyName:"styleName"},// { tableName: "TYPE", tableKeyName: "type" },
{tableName:"SAMPLE TYPE",tableKeyName:"sampleType"},{tableName:"FABRIC",tableKeyName:"fabric"},// {tableName:"FABRIC NAME",tableKeyName:"fabricName"},
// {tableName:"BASE NO",tableKeyName:"bNumber"},
// { tableName: "FABRIC ORIGIN", tableKeyName: "fabricOrigination" },
{tableName:"SIZE",tableKeyName:"size"},{tableName:"WASH TYPE",tableKeyName:"washType"},{tableName:"CUSTOMER",tableKeyName:"customer"},// { tableName: "CUST REF NO / ITEM NO", tableKeyName: "cusRefItemNum" }
{tableName:"CUST REF NO ",tableKeyName:"cusRef"},{tableName:"CUST ITEM NO",tableKeyName:"ItemNum"}],bnoTable:[{tableName:"B NO",tableKeyName:"baseRefNumber"},{tableName:"F NO",tableKeyName:"fabricNumber"},{tableName:"COUNT & CONSTRUCTION ",tableKeyName:"countConstruction"},{tableName:"QUALITY",tableKeyName:"qualityName"},{tableName:"CLASSIFICATION",tableKeyName:"classificationOfFabric"},{tableName:"GREIGE MILL",tableKeyName:"greigeMill"},{tableName:"PROCESS MILL",tableKeyName:"processMill"}],costingTable:[{tableName:"Costing Id",tableKeyName:"costingNumber"},{tableName:"Created On",tableKeyName:"orderDate"},{tableName:"SR No.",tableKeyName:"sampleReqNo"},{tableName:"Style No/Ref",tableKeyName:"styleRefNumber"},{tableName:"Style name ",tableKeyName:"magnumStyleName"},{tableName:"Cust-Dept",tableKeyName:"custDept"},{tableName:"Costing Type",tableKeyName:"costingType"},{tableName:"Total Cost (₹​)",tableKeyName:"totalCost"},{tableName:"Price",tableKeyName:"otherCost"}],IBTable:[{tableName:"Heading",tableKeyName:"value"},{tableName:"Heading",tableKeyName:"value"},{tableName:"Heading",tableKeyName:"value"}],employeeTable:[{tableName:"User ID",tableKeyName:"userId"},{tableName:"Name",tableKeyName:"employeeName"},{tableName:"Role ",tableKeyName:"roleName"},{tableName:"Rights ",tableKeyName:"RIGHTS"}],roleTable:[{tableName:"Role Name",tableKeyName:"roleName"},{tableName:"Rights",tableKeyName:"RIGHTS"}]};var roleFilter=[{moduleName:"MEETINGROOM",rightsName:"meetingNotes"},{moduleName:"CAD",rightsName:"cad"},{moduleName:"FABRIC",rightsName:"fabric.fabric"},{moduleName:"BNUMBER",rightsName:"bNumber"},{moduleName:"TRIM",rightsName:"trim.trim"},{moduleName:"SOURCING",rightsName:"sourcing"},{moduleName:"STYLE",rightsName:"style"},{moduleName:"SAMPLEREQUEST",rightsName:"sampleRequest.sampleRequest"},{moduleName:"COSTING",rightsName:"costing"},{moduleName:"SYSTEMSUPPLIER",rightsName:"system"},{moduleName:"CUSTOMER",rightsName:"customer.customer"},{moduleName:"EMPLOYEE",rightsName:"permissions.employeeDetails"},{moduleName:"ROLE",rightsName:"permissions.roleManagement"},{moduleName:"SMVTHREAD",rightsName:"smvCalcThread"},{moduleName:"TECHNICALISSUES",rightsName:"technicalIssues"}];/* harmony default export */ __webpack_exports__["a"] = (options);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjBBsTMid4hknhAAAAgElEQVRIx+2UMRaCQAxEP/Z6gu1seOgh6MGL6A2h8QQWtmzJGUCajR3bUCUU7nMn9Z/MpAhkbetEZcEdA4Faj3uEiYt+u/ChyXhKeIHjyZnAnV7Bj/BGDPM66FqvCrHCg05XIR6x1Qf5JYtlD4tb+hYeYeZqS2F4qgBHSgv+b/oC4zZgxgwrOqkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDQtMjdUMTc6NTA6MzkrMDI6MDA0irmIAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTA0LTI3VDE3OjUwOjM5KzAyOjAwRdcBNAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Audit=function(_Component){_inherits(Audit,_Component);function Audit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Audit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Audit.__proto__||Object.getPrototypeOf(Audit)).call.apply(_ref,[this].concat(args))),_this),_this.state={openModal:false,data:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Audit,[{key:'getData',value:function getData(){var _this2=this;if(this.props.moduleName!==undefined){__WEBPACK_IMPORTED_MODULE_3__services__["j" /* SampleServices */].auditForSample(this.props._id,this.props.moduleName.replace(/ /g,'').toLowerCase()).then(function(response){if(response.status==200)_this2.setState({data:response.text.data,openModal:true});}).catch(function(error){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].getAuditInfo(this.props._id).then(function(response){if(response.status==200)_this2.setState({data:response.text.data,openModal:true});}).catch(function(error){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}}},{key:'render',value:function render(){var _this3=this;var data=this.state.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.moduleName==="Costing"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{cursor:"pointer"},className:"primary pull-right px-2 py-1 mr-3",onClick:function onClick(e){return _this3.getData();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',style:this.props.fontSize?{fontSize:"14px"}:{fontSize:"20px"}},'card_travel')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:"pointer"},className:this.props.locationInfo!==undefined&&this.props.locationInfo.pathname==="/developmentFabric"?"btn-green-icon mr-3":"btn-green-icon mr-3 pull-right py-1",onClick:function onClick(e){return _this3.getData();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',style:this.props.fontSize?{fontSize:"14px"}:{fontSize:"20px"}},'card_travel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this3.setState({openModal:false});},center:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:data!==null&&data.modified!==null&&data.modified!==undefined&&data.modified.length>0?'d-contents':'d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'col'},'S.No'),this.props._id==="bulkImport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'col'},'Range'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'col'},this.props._id==="bulkImport"?"Generated By":"Modified By"),this.props._id==="bulkImport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'col'},'Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'col'},'Date'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data!==null&&data.modified!==null&&data.modified!==undefined&&data.modified.length>0&&Array.isArray(data.modified)&&data.modified.map(function(info,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},i+1),_this3.props._id==="bulkImport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,info.data.from+" - "+info.data.to),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,info.userId.firstName+" "+info.userId.lastName),_this3.props._id==="bulkImport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,info.data.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(info.date).format('LLLL')));}))),this.props._id!=="bulkImport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font-weight-bold'},'Created By'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data!==null&&data.createdBy!==undefined?data.createdBy.firstName+" "+data.createdBy.lastName:"-")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font-weight-bold'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data!==null?__WEBPACK_IMPORTED_MODULE_2_moment___default()(data.createdBy!==undefined&&data.createdAt).format('LLLL'):"-")))));}}]);return Audit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Audit);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_no_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__);









function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CloseIcon = function CloseIcon(_ref) {
  var classes = _ref.classes,
      classNames = _ref.classNames,
      styles = _ref.styles,
      closeIconSize = _ref.closeIconSize,
      closeIconSvgPath = _ref.closeIconSvgPath,
      onClickCloseIcon = _ref.onClickCloseIcon,
      id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeButton, classNames.closeButton),
    style: styles.closeButton,
    onClick: onClickCloseIcon,
    id: id
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeIcon, classNames.closeIcon),
    style: styles.closeIcon,
    xmlns: "http://www.w3.org/2000/svg",
    width: closeIconSize,
    height: closeIconSize,
    viewBox: "0 0 36 36"
  }, closeIconSvgPath));
};

CloseIcon.propTypes = {
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onClickCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CloseIcon.defaultProps = {
  id: null
};

var _modals = [];
/**
 * Handle the order of the modals.
 * Inspired by the material-ui implementation.
 */

var modalManager = {
  /**
   * Return the modals array
   */
  modals: function modals() {
    return _modals;
  },

  /**
   * Register a new modal
   */
  add: function add(modal) {
    if (_modals.indexOf(modal) === -1) {
      _modals.push(modal);
    }
  },

  /**
   * Remove a modal
   */
  remove: function remove(modal) {
    var index = _modals.indexOf(modal);

    if (index !== -1) {
      _modals.splice(index, 1);
    }
  },

  /**
   * Check if the modal is the first one on the screen
   */
  isTopModal: function isTopModal(modal) {
    return !!_modals.length && _modals[_modals.length - 1] === modal;
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_overlayCenter__YHoO7 {\n  align-items: center;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n  margin: auto;\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
var cssClasses = {"overlay":"styles_overlay__CLSq-","overlayCenter":"styles_overlayCenter__YHoO7","modal":"styles_modal__gNwvD","closeButton":"styles_closeButton__20ID4","closeIcon":"styles_closeIcon__1QwbI","transitionEnter":"styles_transitionEnter__3j_-a","transitionEnterActive":"styles_transitionEnterActive___eQs7","transitionExit":"styles_transitionExit__1KmEf","transitionExitActive":"styles_transitionExitActive__1nQXw"};
styleInject(css,{"insertAt":"top"});

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldClose", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showPortal: _this.props.open
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOpen", function () {
      modalManager.add(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        Modal.blockScroll();
      }

      document.addEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
      modalManager.remove(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }

      document.removeEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOverlay", function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (!_this.shouldClose) {
        _this.shouldClose = null;
        return;
      }

      if (_this.props.onOverlayClick) {
        _this.props.onOverlayClick(event);
      }

      if (_this.props.closeOnOverlayClick) {
        _this.props.onClose(event);
      }

      _this.shouldClose = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickCloseIcon", function (event) {
      _this.props.onClose(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeydown", function (event) {
      // Only the last modal need to be escaped when pressing the esc key
      if (event.keyCode !== 27 || !modalManager.isTopModal(_assertThisInitialized(_assertThisInitialized(_this)))) {
        return;
      }

      if (_this.props.onEscKeyDown) {
        _this.props.onEscKeyDown(event);
      }

      if (_this.props.closeOnEsc) {
        _this.props.onClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleModalEvent", function () {
      _this.shouldClose = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntered", function () {
      if (_this.props.onEntered) {
        _this.props.onEntered();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleExited", function () {
      if (_this.props.onExited) {
        _this.props.onExited();
      }

      _this.setState({
        showPortal: false
      });

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unblockScroll", function () {
      // Restore the scroll only if there is no modal on the screen
      if (modalManager.modals().length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.off();
      }
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showPortal && !this.state.showPortal) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.open) {
        this.handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          center = _this$props.center,
          classes = _this$props.classes,
          classNames = _this$props.classNames,
          styles = _this$props.styles,
          showCloseIcon = _this$props.showCloseIcon,
          closeIconSize = _this$props.closeIconSize,
          closeIconSvgPath = _this$props.closeIconSvgPath,
          animationDuration = _this$props.animationDuration,
          container = _this$props.container,
          focusTrapped = _this$props.focusTrapped,
          focusTrapOptions = _this$props.focusTrapOptions,
          overlayId = _this$props.overlayId,
          modalId = _this$props.modalId,
          closeIconId = _this$props.closeIconId;
      var showPortal = this.state.showPortal;

      if (!showPortal) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default.a, {
        container: container
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default.a, {
        in: open,
        appear: true,
        classNames: {
          appear: classNames.transitionEnter || classes.transitionEnter,
          appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          enter: classNames.transitionEnter || classes.transitionEnter,
          enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          exit: classNames.transitionExit || classes.transitionExit,
          exitActive: classNames.transitionExitActive || classes.transitionExitActive
        },
        timeout: animationDuration,
        onEntered: this.handleEntered,
        onExited: this.handleExited
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.overlay, center ? classes.overlayCenter : null, classNames.overlay),
        onClick: this.handleClickOverlay,
        style: styles.overlay,
        id: overlayId
      }, focusTrapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default.a, {
        focusTrapOptions: _objectSpread({}, {
          clickOutsideDeactivates: true
        }, focusTrapOptions)
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      })))));
    }
  }], [{
    key: "blockScroll",
    value: function blockScroll() {
      __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.on();
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.showPortal && nextProps.open) {
        return {
          showPortal: true
        };
      }

      return null;
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  /**
   * Is the modal closable when user press esc key.
   */
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Is the modal closable when user click on overlay.
   */
  closeOnOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Callback fired when the Modal is open and the animation is finished.
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal has exited and the animation is finished.
   */
  onExited: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
   */
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Callback fired when the escape key is pressed.
   */
  onEscKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the overlay is clicked.
   */
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Control if the modal is open or not.
   */
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
   */
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
   */
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The content of the modal.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * @internal
   */
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Should the dialog be centered.
   */
  center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Show the close icon.
   */
  showCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Close icon size.
   */
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * A valid svg path to show as icon.
   */
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Animation duration in milliseconds.
   */
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * You can specify a container prop which should be of type `Element`. The portal will be rendered inside that element. The default behavior will create a div node and render it at the at the end of document.body.
   */
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  // eslint-disable-line

  /**
   * Whether to block scrolling when dialog is open
   */
  blockScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * When the modal is open, trap focus within it
   */
  focusTrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Options to be passed to the focus trap, details available at https://github.com/davidtheclark/focus-trap#focustrap--createfocustrapelement-createoptions
   */
  focusTrapOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * id attribute for overlay
   */
  overlayId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for modal
   */
  modalId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for close icon
   */
  closeIconId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Modal.defaultProps = {
  classes: cssClasses,
  closeOnEsc: true,
  closeOnOverlayClick: true,
  onEntered: null,
  onExited: null,
  onEscKeyDown: null,
  onOverlayClick: null,
  showCloseIcon: true,
  closeIconSize: 28,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
  }),
  classNames: {},
  styles: {},
  children: null,
  center: false,
  animationDuration: 500,
  blockScroll: true,
  focusTrapped: false,
  focusTrapOptions: {},
  overlayId: null,
  modalId: null,
  closeIconId: null
};
Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__["polyfill"])(Modal);

/* harmony default export */ __webpack_exports__["a"] = (Modal);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require = __webpack_require__(8),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record; // Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();
var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};
var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = /*#__PURE__*/function (_CharacterMetadataRec) {
  _inheritsLoose(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    return _CharacterMetadataRec.apply(this, arguments) || this;
  }

  var _proto = CharacterMetadata.prototype;

  _proto.getStyle = function getStyle() {
    return this.get('style');
  };

  _proto.getEntity = function getEntity() {
    return this.get('entity');
  };

  _proto.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  }
  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */
  ;

  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    }; // Fill in unspecified properties, if necessary.

    var configMap = Map(defaultConfig).merge(config);
    var existing = pool.get(configMap);

    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  CharacterMetadata.fromJS = function fromJS(_ref) {
    var style = _ref.style,
        entity = _ref.entity;
    return new CharacterMetadata({
      style: Array.isArray(style) ? OrderedSet(style) : style,
      entity: Array.isArray(entity) ? OrderedSet(entity) : entity
    });
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);
CharacterMetadata.EMPTY = EMPTY;
module.exports = CharacterMetadata;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(37);

var findRangesImmutable = __webpack_require__(90);

var Immutable = __webpack_require__(8);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = /*#__PURE__*/function (_ref) {
  _inheritsLoose(ContentBlockNode, _ref);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    /* eslint-disable-next-line constructor-super */
    return _ref.call(this, decorateCharacterList(props)) || this;
  }

  var _proto = ContentBlockNode.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  _proto.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  _proto.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  _proto.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["updateBasicDetails"] = updateBasicDetails;
/* harmony export (immutable) */ __webpack_exports__["fetchUserDetails"] = fetchUserDetails;
/* harmony export (immutable) */ __webpack_exports__["updateRights"] = updateRights;
/* harmony export (immutable) */ __webpack_exports__["signOut"] = signOut;
function updateBasicDetails(data){return{type:"UPDATE_BASIC_DETAILS",payload:data};}function fetchUserDetails(){return{type:"FETCH_USER_DETAILS"};}function updateRights(data){return{type:"UPDATE_RIGHTS",payload:data};}function signOut(){return{type:"SIGN_OUT"};}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key;

  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }

  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(238);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KEY_DELIMITER = '-';
var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    // Extracts the last two parts of offsetKey and captures the rest in blockKeyParts
    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(),
        leafKey = _offsetKey$split$reve[0],
        decoratorKey = _offsetKey$split$reve[1],
        blockKeyParts = _offsetKey$split$reve.slice(2);

    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
module.exports = DraftOffsetKey;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(81)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no-product-image.dbb4efbc.png";

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAQAAABKIxwrAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiDA4OHCES9+oSAAAA3klEQVQ4y7WUvQ3CMBSEz8SKqCkACUTNBClSZYSIDagyBEEUiCFSsQFsQYEYgDYSiJ+CAdIcRSI7Rg44BefmvadP1un8I6DEHgLYdBQvy5QR7Yo000Er/Rmnx5Q5ybgZYkwyZ0pPYomV08YTrOFJJGpQ4GEFC1UlUHH9MkOSFGQ1O+DayI8QloXG/xJkO1yqysl7y2Qk7hhWwxA7Kz1T1U0iU6fqY4Atngbaxxy+6jLoO8OIZMCusQKSkb4zdYcOz0N++NzgYvRjLOxBljrhbPTTptxL7b8fk6h5d/gJ3oPvpJCGeUtcAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTEyLTE0VDEzOjI4OjMzKzAxOjAw7dvNKgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0xMi0xNFQxMzoyODozMyswMTowMJyGdZYAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


module.exports = function (name) {
  if (typeof window !== 'undefined' && window.__DRAFT_GKX) {
    return !!window.__DRAFT_GKX[name];
  }

  return false;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(76)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(80);
var IE8_DOM_DEFINE = __webpack_require__(201);
var toPrimitive = __webpack_require__(135);
var dP = Object.defineProperty;

exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(143);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(521);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(525);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(143);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(649),
    getValue = __webpack_require__(652);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(37);

var findRangesImmutable = __webpack_require__(90);

var Immutable = __webpack_require__(8);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};
var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = /*#__PURE__*/function (_ContentBlockRecord) {
  _inheritsLoose(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    return _ContentBlockRecord.call(this, decorateCharacterList(config)) || this;
  }

  var _proto = ContentBlock.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  }
  /**
   * Execute a callback for every contiguous range of styles within the block.
   */
  ;

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  }
  /**
   * Execute a callback for every contiguous range of entities within the block.
   */
  ;

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }

  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return node.nodeType === Node.ELEMENT_NODE;
}

module.exports = isElement;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */


var invariant = __webpack_require__(9); // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.


var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */

function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */


function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;

  if (index + 1 === str.length) {
    return false;
  }

  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */


function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */


function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */


function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }

  return len;
}
/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */


function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  } // Obvious cases


  var size = str.length;

  if (size <= 0 || start > size || length <= 0) {
    return '';
  } // Find the actual starting position


  var posA = 0;

  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }

    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }

    if (posA < 0) {
      posA = 0;
    }
  } // Find the actual ending position


  var posB = size;

  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}
/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */


function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}
/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */


function getCodePoints(str) {
  var codePoints = [];

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }

  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};
module.exports = UnicodeUtils;

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(335);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(46);
var ctx = __webpack_require__(200);
var hide = __webpack_require__(66);
var has = __webpack_require__(53);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(52);
var createDesc = __webpack_require__(98);
module.exports = __webpack_require__(47) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(204);
var defined = __webpack_require__(136);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(139)('wks');
var uid = __webpack_require__(101);
var Symbol = __webpack_require__(45).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(231);

var warning = __webpack_require__(150);
var canDefineProperty = __webpack_require__(230);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(232);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Parser = __webpack_require__(291);
var DomHandler = __webpack_require__(293);

function defineProp(name, value) {
    delete module.exports[name];
    module.exports[name] = value;
    return value;
}

module.exports = {
    Parser: Parser,
    Tokenizer: __webpack_require__(292),
    ElementType: __webpack_require__(93),
    DomHandler: DomHandler,
    get FeedHandler() {
        return defineProp("FeedHandler", __webpack_require__(856));
    },
    get Stream() {
        return defineProp("Stream", __webpack_require__(870));
    },
    get WritableStream() {
        return defineProp("WritableStream", __webpack_require__(300));
    },
    get ProxyHandler() {
        return defineProp("ProxyHandler", __webpack_require__(877));
    },
    get DomUtils() {
        return defineProp("DomUtils", __webpack_require__(295));
    },
    get CollectingHandler() {
        return defineProp(
            "CollectingHandler",
            __webpack_require__(878)
        );
    },
    // For legacy support
    DefaultHandler: DomHandler,
    get RssHandler() {
        return defineProp("RssHandler", this.FeedHandler);
    },
    //helper methods
    parseDOM: function(data, options) {
        var handler = new DomHandler(options);
        new Parser(handler, options).end(data);
        return handler.dom;
    },
    parseFeed: function(feed, options) {
        var handler = new module.exports.FeedHandler(options);
        new Parser(handler, options).end(feed);
        return handler.dom;
    },
    createDomStream: function(cb, options, elementCb) {
        var handler = new DomHandler(cb, options, elementCb);
        return new Parser(handler, options);
    },
    // List of all events that the parser emits
    EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
    }
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFixedTwo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_action_main__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UtilityService=function(){function UtilityService(){_classCallCheck(this,UtilityService);this.unauthorisedFunc=function(){localStorage.removeItem("authToken");localStorage.clear();Object(__WEBPACK_IMPORTED_MODULE_4__redux_action_main__["signOut"])();__WEBPACK_IMPORTED_MODULE_3__containers_history__["a" /* default */]!==undefined&&__WEBPACK_IMPORTED_MODULE_3__containers_history__["a" /* default */].push("/");};}_createClass(UtilityService,[{key:'baseUrl',value:function baseUrl(){//  return 'http://180.151.69.138:2034/' //staging
//  return 'http://192.168.10.167:2024/' //janen
// return 'http://192.168.10.121:2024/' //raunik
// return 'http://192.168.10.173:2009/'
return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].base_url;}},{key:'fileUrl',value:function fileUrl(){return"https://magnum-clothing.s3.ap-south-1.amazonaws.com/";}},{key:'authToken',value:function authToken(){return'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TG9nZ2VkSW4iOiIyMDE4LTA1LTA4VDA3OjMwOjExLjE0OFoiLCJfaWQiOiI1YWUxYjQ3ZDZlZDIzYTIyOGU4ZGM0ZjQiLCJpYXQiOjE1MjU3NjQ2MTF9.pf3voSSp2j773cHLop_0a1bqpcIjOTimGs2jKMi15cU';//return 'http://192.168.10.173:2009/'
}},{key:'successMsg',value:function successMsg(msg,msgText,time){msgText=msgText?msgText:"Successfully Added";msg.show(msgText,{time:time?time:2000,type:'success'});}},{key:'warningMsg',value:function warningMsg(msg,msgText,time){msgText=msgText?msgText:"Entry already exists";msg.show(msgText,{time:time?time:2000,type:'info'});}},{key:'errorMsg',value:function errorMsg(msg,msgText,time){msgText=msgText?msgText:"Error Occurred!!!";if(msg!==undefined){msg.show(msgText,{time:time?time:2000,type:'error'});}}},{key:'manualErrorMsg',value:function manualErrorMsg(msg,msgString,time){if(msg!==undefined){msg.show(msgString,{time:time?time:2000,type:'error'});}}},{key:'editMsg',value:function editMsg(msg){msg.show("Successfully Edited",{time:2000,type:'success'});}},{key:'deleteMsg',value:function deleteMsg(msg,msgText,time){msgText=msgText?msgText:"Successfully Deleted";msg.show(msgText,{time:time?time:2000,type:'info'});}},{key:'completeMsg',value:function completeMsg(msg,time){msg.show("Successfully Completed",{time:time?time:2000,type:'info'});}},{key:'infoMsg',value:function infoMsg(msg,msgString,time){msg.show(msgString,{time:time?time:2000,type:'info'});}},{key:'fetchHandler',value:function fetchHandler(response){if(response.ok){return response.json().then(function(json){// the status was ok and there is a json body
return Promise.resolve({json:json,response:response});}).catch(function(err){// the status was ok but there is no json body
return Promise.resolve({response:response});});}else{return response.json().catch(function(err){// the status was not ok and there is no json body
throw new Error(response.statusText);}).then(function(json){// the status was not ok but there is a json body
throw new Error(json.error.message);// example error message returned by a REST API
});}}},{key:'parseIntegerToTime',value:function parseIntegerToTime(time){var videoTime=parseInt(time,10);videoTime=[parseInt(videoTime/60%60,10),parseInt(videoTime%60,10)].join(':').replace(/\b(\d)\b/g,'0$1');return videoTime;}},{key:'secondsToHours',value:function secondsToHours(seconds){return[parseInt(seconds/60/60,10),parseInt(seconds/60%60,10),parseInt(seconds%60,10)].join(':').replace(/\b(\d)\b/g,'0$1');}},{key:'displayDate',value:function displayDate(timestamp){var unixtime=timestamp;var newDate=new Date();newDate.setTime(unixtime*1000);var dateString=newDate.getDate()+'/'+(newDate.getMonth()+1)+'/'+newDate.getFullYear()+' '+this.formatAMPM(newDate);return dateString;}},{key:'getDateAndTime',value:function getDateAndTime(date){var newDate=new Date(date);return newDate=newDate.toString().substring(4,24);}},{key:'convertTimeToSec',value:function convertTimeToSec(value){var a=value.split(":");var totalSeconds=parseInt(a[0]*3600,10)+parseInt(a[1]*60,10)+parseInt(a[2],10);return parseInt(totalSeconds,10);}},{key:'round',value:function round(value){return Number(Math.round(value+'e2')+'e-2');}},{key:'getCurrentTimeDuration',value:function getCurrentTimeDuration(dateAndtime){var offset=__WEBPACK_IMPORTED_MODULE_1_moment___default()().utcOffset();var getCurrentLocalTime=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(dateAndtime).utcOffset(offset).format();return __WEBPACK_IMPORTED_MODULE_1_moment___default()(getCurrentLocalTime,"YYYY-MM-DD hh:mm:ss +ZZ").fromNow();}},{key:'imageUpload',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(value){var formData,i,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:formData=new FormData();// formData.append("refImage",value)
for(i=0;i<value.length;i++){formData.append("referenceImages",value[i]);}_context.next=4;return fetch(this.baseUrl()+'api/development/uploadReferenceImages',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 4:result=_context.sent;return _context.abrupt('return',result.json());case 6:case'end':return _context.stop();}}},_callee,this);}));function imageUpload(_x){return _ref.apply(this,arguments);}return imageUpload;}()},{key:'getUserInfo',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(this.baseUrl()+'api/employee/profile',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function getUserInfo(){return _ref2.apply(this,arguments);}return getUserInfo;}()},{key:'updateProfile',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(this.baseUrl()+'api/employee/profile',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function updateProfile(_x2){return _ref3.apply(this,arguments);}return updateProfile;}()},{key:'getAuditInfo',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id){var url,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:url=id!=="bulkImport"?'api/modulesLogs/getModuleLogs/'+id:'api/modulesLogs/getModuleLogFabBulk';_context4.next=3;return fetch(this.baseUrl()+url,{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 3:result=_context4.sent;_context4.t0=result.status;_context4.next=7;return result.json();case 7:_context4.t1=_context4.sent;return _context4.abrupt('return',{status:_context4.t0,text:_context4.t1});case 9:case'end':return _context4.stop();}}},_callee4,this);}));function getAuditInfo(_x3){return _ref4.apply(this,arguments);}return getAuditInfo;}()},{key:'getImageType',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var url,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:url='api/system/getSystemGenImages';_context5.next=3;return fetch(this.baseUrl()+url,{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 3:result=_context5.sent;_context5.t0=result.status;_context5.next=7;return result.json();case 7:_context5.t1=_context5.sent;return _context5.abrupt('return',{status:_context5.t0,text:_context5.t1});case 9:case'end':return _context5.stop();}}},_callee5,this);}));function getImageType(){return _ref5.apply(this,arguments);}return getImageType;}()},{key:'geturlparam',get:function get(){return window.location.pathname.split('/');}}]);return UtilityService;}();/* harmony default export */ __webpack_exports__["a"] = (new UtilityService());var getFixedTwo=function getFixedTwo(num){return Number(num).toFixed(2);};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var glamor = __webpack_require__(395);

var PropTypes = void 0;

/* istanbul ignore next */
if (parseFloat(React__default.version.slice(0, 4)) >= 15.5) {
  /* istanbul ignore next */
  try {
    PropTypes = __webpack_require__(3);
    /* istanbul ignore next */
  } catch (error) {
    // ignore
  }
}
/* istanbul ignore next */
PropTypes = PropTypes || React__default.PropTypes;



/*
eslint
  import/no-mutable-exports:0,
  import/prefer-default-export:0,
  react/no-deprecated:0
 */

var CHANNEL = '__glamorous__';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function generateWarningMessage(Comp) {
  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
  // eslint-disable-next-line max-len
  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
}

function withTheme(ComponentToTheme) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$noWarn = _ref.noWarn,
      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
      _ref$createElement = _ref.createElement,
      createElement = _ref$createElement === undefined ? true : _ref$createElement;

  var ThemedComponent = function (_Component) {
    inherits(ThemedComponent, _Component);

    function ThemedComponent() {
      var _ref2;

      var _temp, _this, _ret;

      classCallCheck(this, ThemedComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = ThemedComponent.__proto__ || Object.getPrototypeOf(ThemedComponent)).call.apply(_ref2, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
        return _this.setState({ theme: theme });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(ThemedComponent, [{
      key: 'componentWillMount',


      // eslint-disable-next-line complexity
      value: function componentWillMount() {
        if (!this.context[CHANNEL]) {
          if (false) {
            this.warned = true;
            // eslint-disable-next-line no-console
            console.warn(generateWarningMessage(ComponentToTheme));
          }
        }
        var theme = this.props.theme;

        if (this.context[CHANNEL]) {
          // if a theme is provided via props,
          // it takes precedence over context
          this.setTheme(theme ? theme : this.context[CHANNEL].getState());
        } else {
          this.setTheme(theme || {});
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) {
          this.setTheme(nextProps.theme);
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.context[CHANNEL] && !this.props.theme) {
          // subscribe to future theme changes
          this.unsubscribe = this.context[CHANNEL].subscribe(this.setTheme);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        // cleanup subscription
        this.unsubscribe && this.unsubscribe();
      }
    }, {
      key: 'render',
      value: function render() {
        if (createElement) {
          return React__default.createElement(ComponentToTheme, _extends({}, this.props, this.state));
        } else {
          // this allows us to effectively use the GlamorousComponent
          // as our `render` method without going through lifecycle hooks.
          // Also allows us to forward the context in the scenario where
          // a user wants to add more context.
          // eslint-disable-next-line babel/new-cap
          return ComponentToTheme(_extends({}, this.props, this.state), this.context);
        }
      }
    }]);
    return ThemedComponent;
  }(React.Component);

  ThemedComponent.propTypes = {
    theme: PropTypes.object
  };


  var defaultContextTypes = defineProperty({}, CHANNEL, PropTypes.object);

  var userDefinedContextTypes = null;

  // configure the contextTypes to be settable by the user,
  // however also retaining the glamorous channel.
  Object.defineProperty(ThemedComponent, 'contextTypes', {
    enumerable: true,
    configurable: true,
    set: function set$$1(value) {
      userDefinedContextTypes = value;
    },
    get: function get$$1() {
      // if the user has provided a contextTypes definition,
      // merge the default context types with the provided ones.
      if (userDefinedContextTypes) {
        return _extends({}, defaultContextTypes, userDefinedContextTypes);
      }
      return defaultContextTypes;
    }
  });

  return ThemedComponent;
}

/**
 * This function takes a className string and gets all the
 * associated glamor styles. It's used to merge glamor styles
 * from a className to make sure that specificity is not
 * a problem when passing a className to a component.
 * @param {String} [className=''] the className string
 * @return {Object} { glamorStyles, glamorlessClassName }
 *   - glamorStyles is an array of all the glamor styles objects
 *   - glamorlessClassName is the rest of the className string
 *     without the glamor classNames
 */
function extractGlamorStyles(className) {
  var glamorlessClassName = [];
  var glamorStyles = [];
  className.toString().split(' ').forEach(function (name) {
    if (name.indexOf('css-') === 0) {
      var style = buildGlamorSrcFromClassName(name);
      glamorStyles.push(style);
    } else {
      glamorlessClassName.push(name);
    }
  });

  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
}

/** Glamor's css function returns an object with the shape
 *
 * {
 *   [`data-css-${hash}`]: '',
 *   toString() { return `css-${hash}` }
 * }
 *
 * Whenever glamor's build function encounters an object with
 * this shape it just pulls the resulting styles from the cache.
 *
 * note: the toString method is not needed to qualify the shape
**/
function buildGlamorSrcFromClassName(className) {
  return defineProperty({}, 'data-' + className, '');
}

function getGlamorClassName$1(_ref2) {
  var styles = _ref2.styles,
      props = _ref2.props,
      cssOverrides = _ref2.cssOverrides,
      cssProp = _ref2.cssProp,
      theme = _ref2.theme,
      context = _ref2.context;

  var _handleStyles = handleStyles([].concat(toConsumableArray(styles), [props.className, cssOverrides, cssProp]), props, theme, context),
      mappedArgs = _handleStyles.mappedArgs,
      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;

  var glamorClassName = glamor.css.apply(undefined, toConsumableArray(mappedArgs)).toString();
  var extras = nonGlamorClassNames.join(' ').trim();
  return (glamorClassName + ' ' + extras).trim();
}

// this next function is on a "hot" code-path
// so it's pretty complex to make sure it's fast.
// eslint-disable-next-line complexity
function handleStyles(styles, props, theme, context) {
  var current = void 0;
  var mappedArgs = [];
  var nonGlamorClassNames = [];
  for (var i = 0; i < styles.length; i++) {
    current = styles[i];
    if (typeof current === 'function') {
      var result = current(props, theme, context);
      if (typeof result === 'string') {
        var _extractGlamorStyles = extractGlamorStyles(result),
            glamorStyles = _extractGlamorStyles.glamorStyles,
            glamorlessClassName = _extractGlamorStyles.glamorlessClassName;

        mappedArgs.push.apply(mappedArgs, toConsumableArray(glamorStyles));
        nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(glamorlessClassName));
      } else {
        mappedArgs.push(result);
      }
    } else if (typeof current === 'string') {
      var _extractGlamorStyles2 = extractGlamorStyles(current),
          _glamorStyles = _extractGlamorStyles2.glamorStyles,
          _glamorlessClassName = _extractGlamorStyles2.glamorlessClassName;

      mappedArgs.push.apply(mappedArgs, toConsumableArray(_glamorStyles));
      nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(_glamorlessClassName));
    } else if (Array.isArray(current)) {
      var recursed = handleStyles(current, props, theme, context);
      mappedArgs.push.apply(mappedArgs, toConsumableArray(recursed.mappedArgs));
      nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(recursed.nonGlamorClassNames));
    } else {
      mappedArgs.push(current);
    }
  }
  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
}

/*
 * This is a relatively small abstraction that's ripe for open sourcing.
 * Documentation is in the README.md
 */
function createGlamorous$1(splitProps) {
  // TODO: in a breaking version, make this default to true
  glamorous.config = { useDisplayNameInClassName: false };

  return glamorous;

  /**
  * This is the main export and the function that people
  * interact with most directly.
  *
  * It accepts a component which can be a string or
  * a React Component and returns
  * a "glamorousComponentFactory"
  * @param {String|ReactComponent} comp the component to render
  * @param {Object} options helpful info for the GlamorousComponents
  * @return {Function} the glamorousComponentFactory
  */
  function glamorous(comp) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        rootEl = _ref.rootEl,
        displayName = _ref.displayName,
        _ref$forwardProps = _ref.forwardProps,
        forwardProps = _ref$forwardProps === undefined ? [] : _ref$forwardProps;

    return glamorousComponentFactory;

    /**
     * This returns a React Component that renders the comp (closure)
     * with a className based on the given glamor styles object(s)
     * @param {...Object|Function} styles the styles to create with glamor.
     *   If any of these are functions, they are invoked with the component
     *   props and the return value is used.
     * @return {ReactComponent} the ReactComponent function
     */
    function glamorousComponentFactory() {
      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
        styles[_key] = arguments[_key];
      }

      /**
       * This is a component which will render the comp (closure)
       * with the glamorous styles (closure). Forwards any valid
       * props to the underlying component.
       */
      var GlamorousComponent = withTheme(function (props, context) {
        /* eslint no-use-before-define: 0 */
        var _splitProps = splitProps(props, GlamorousComponent),
            toForward = _splitProps.toForward,
            cssOverrides = _splitProps.cssOverrides,
            cssProp = _splitProps.cssProp;

        // freeze the theme object in dev mode


        var theme =  true ? props.theme : Object.freeze(props.theme);

        // create className to apply
        var fullClassName = getGlamorClassName$1({
          styles: GlamorousComponent.styles,
          props: props,
          cssOverrides: cssOverrides,
          cssProp: cssProp,
          theme: theme,
          context: context
        });
        var debugClassName = glamorous.config.useDisplayNameInClassName ? cleanClassname(GlamorousComponent.displayName) : '';
        var className = (fullClassName + ' ' + debugClassName).trim();

        return React__default.createElement(GlamorousComponent.comp, _extends({
          ref: props.innerRef
        }, toForward, {
          className: className
        }));
      }, { noWarn: true, createElement: false });

      GlamorousComponent.propTypes = {
        className: PropTypes.string,
        cssOverrides: PropTypes.object,
        theme: PropTypes.object,
        innerRef: PropTypes.func,
        glam: PropTypes.object
      };

      function withComponent(newComp) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return glamorous(newComp, _extends({
          forwardProps: GlamorousComponent.forwardProps
        }, options))(GlamorousComponent.styles);
      }

      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
        comp: comp,
        styles: styles,
        rootEl: rootEl,
        forwardProps: forwardProps,
        displayName: displayName
      }), { withComponent: withComponent, isGlamorousComponent: true });
      return GlamorousComponent;
    }
  }

  function getGlamorousComponentMetadata(_ref2) {
    var comp = _ref2.comp,
        styles = _ref2.styles,
        rootEl = _ref2.rootEl,
        forwardProps = _ref2.forwardProps,
        displayName = _ref2.displayName;

    var componentsComp = comp.comp ? comp.comp : comp;
    return {
      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
      styles: when(comp.styles, styles),
      // keep track of the ultimate rootEl to render (we never
      // actually render anything but
      // the base component, even when people wrap a glamorous
      // component in glamorous
      comp: componentsComp,
      rootEl: rootEl || componentsComp,
      // join forwardProps (for anyone doing: glamorous(glamorous.a({}), {}))
      forwardProps: when(comp.forwardProps, forwardProps),
      // set the displayName to something that's slightly more
      // helpful than `GlamorousComponent` :)
      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')'
    };
  }

  function when(comp, prop) {
    return comp ? comp.concat(prop) : prop;
  }

  function getDisplayName(comp) {
    return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
  }
}

function cleanClassname(className) {
  return className.replace(/ /g, '-').replace(/[^A-Za-z0-9\-_]/g, '_');
}

/* eslint no-unused-vars:0 */
function splitProps(_ref) {
  var cssProp = _ref.css,
      theme = _ref.theme,
      className = _ref.className,
      innerRef = _ref.innerRef,
      glam = _ref.glam,
      rest = objectWithoutProperties(_ref, ['css', 'theme', 'className', 'innerRef', 'glam']);

  return { toForward: rest, cssProp: cssProp };
}

var glamorous = createGlamorous$1(splitProps);

module.exports = glamorous;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function CustomerDeptSelect(_ref){var options=_ref.options,value=_ref.value,_onChange=_ref.onChange,disabled=_ref.disabled,pageName=_ref.pageName,className=_ref.className,notMandate=_ref.notMandate,toolTip=_ref.toolTip;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:pageName==="bNumber"?"form-group d-inline-flex":"form-group "+className,style:pageName==="bNumber"?{marginLeft:"34%"}:{marginLeft:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"Customer / Department",!notMandate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger madatory-asterisk"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"customer",title:toolTip?toolTip.custName+" - "+toolTip.deptName:null,value:value,onChange:function onChange(e){var _e$target$value$split=e.target.value.split("-"),_e$target$value$split2=_slicedToArray(_e$target$value$split,2),customer=_e$target$value$split2[0],departmentId=_e$target$value$split2[1];_onChange(e.target.name,customer,departmentId);},disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--select--"),options!==undefined&&Array.isArray(options)&&options.map(function(customer,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:index,id:"select",title:customer.customerName+"-"+customer.departmentName,name:index,value:customer._id+"-"+customer.departmentId},customer.customerName,"-",customer.departmentName);})));}/* harmony default export */ __webpack_exports__["a"] = (CustomerDeptSelect);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _paginator = _interopRequireDefault(__webpack_require__(605));

var _Page = _interopRequireDefault(__webpack_require__(606));

var _classnames = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "isFirstPageVisible",
    value: function isFirstPageVisible(has_previous_page) {
      var _this$props = this.props,
          hideDisabled = _this$props.hideDisabled,
          hideNavigation = _this$props.hideNavigation,
          hideFirstLastPages = _this$props.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isPrevPageVisible",
    value: function isPrevPageVisible(has_previous_page) {
      var _this$props2 = this.props,
          hideDisabled = _this$props2.hideDisabled,
          hideNavigation = _this$props2.hideNavigation;
      if (hideNavigation || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isNextPageVisible",
    value: function isNextPageVisible(has_next_page) {
      var _this$props3 = this.props,
          hideDisabled = _this$props3.hideDisabled,
          hideNavigation = _this$props3.hideNavigation;
      if (hideNavigation || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "isLastPageVisible",
    value: function isLastPageVisible(has_next_page) {
      var _this$props4 = this.props,
          hideDisabled = _this$props4.hideDisabled,
          hideNavigation = _this$props4.hideNavigation,
          hideFirstLastPages = _this$props4.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "buildPages",
    value: function buildPages() {
      var pages = [];
      var _this$props5 = this.props,
          itemsCountPerPage = _this$props5.itemsCountPerPage,
          pageRangeDisplayed = _this$props5.pageRangeDisplayed,
          activePage = _this$props5.activePage,
          prevPageText = _this$props5.prevPageText,
          nextPageText = _this$props5.nextPageText,
          firstPageText = _this$props5.firstPageText,
          lastPageText = _this$props5.lastPageText,
          totalItemsCount = _this$props5.totalItemsCount,
          onChange = _this$props5.onChange,
          activeClass = _this$props5.activeClass,
          itemClass = _this$props5.itemClass,
          itemClassFirst = _this$props5.itemClassFirst,
          itemClassPrev = _this$props5.itemClassPrev,
          itemClassNext = _this$props5.itemClassNext,
          itemClassLast = _this$props5.itemClassLast,
          activeLinkClass = _this$props5.activeLinkClass,
          disabledClass = _this$props5.disabledClass,
          hideDisabled = _this$props5.hideDisabled,
          hideNavigation = _this$props5.hideNavigation,
          linkClass = _this$props5.linkClass,
          linkClassFirst = _this$props5.linkClassFirst,
          linkClassPrev = _this$props5.linkClassPrev,
          linkClassNext = _this$props5.linkClassNext,
          linkClassLast = _this$props5.linkClassLast,
          hideFirstLastPages = _this$props5.hideFirstLastPages,
          getPageUrl = _this$props5.getPageUrl;
      var paginationInfo = new _paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);

      for (var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
        pages.push(_react["default"].createElement(_Page["default"], {
          isActive: i === activePage,
          key: i,
          href: getPageUrl(i),
          pageNumber: i,
          pageText: i + "",
          onClick: onChange,
          itemClass: itemClass,
          linkClass: linkClass,
          activeClass: activeClass,
          activeLinkClass: activeLinkClass,
          ariaLabel: "Go to page number ".concat(i)
        }));
      }

      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "prev" + paginationInfo.previous_page,
        href: getPageUrl(paginationInfo.previous_page),
        pageNumber: paginationInfo.previous_page,
        onClick: onChange,
        pageText: prevPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
        disabledClass: disabledClass,
        ariaLabel: "Go to previous page"
      }));
      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "first",
        href: getPageUrl(1),
        pageNumber: 1,
        onClick: onChange,
        pageText: firstPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
        disabledClass: disabledClass,
        ariaLabel: "Go to first page"
      }));
      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "next" + paginationInfo.next_page,
        href: getPageUrl(paginationInfo.next_page),
        pageNumber: paginationInfo.next_page,
        onClick: onChange,
        pageText: nextPageText,
        isDisabled: !paginationInfo.has_next_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
        disabledClass: disabledClass,
        ariaLabel: "Go to next page"
      }));
      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "last",
        href: getPageUrl(paginationInfo.total_pages),
        pageNumber: paginationInfo.total_pages,
        onClick: onChange,
        pageText: lastPageText,
        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
        disabledClass: disabledClass,
        ariaLabel: "Go to last page"
      }));
      return pages;
    }
  }, {
    key: "render",
    value: function render() {
      var pages = this.buildPages();
      return _react["default"].createElement("ul", {
        className: this.props.innerClass
      }, pages);
    }
  }]);

  return Pagination;
}(_react["default"].Component);

exports["default"] = Pagination;

_defineProperty(Pagination, "propTypes", {
  totalItemsCount: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  activePage: _propTypes["default"].number,
  itemsCountPerPage: _propTypes["default"].number,
  pageRangeDisplayed: _propTypes["default"].number,
  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  disabledClass: _propTypes["default"].string,
  hideDisabled: _propTypes["default"].bool,
  hideNavigation: _propTypes["default"].bool,
  innerClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  itemClassFirst: _propTypes["default"].string,
  itemClassPrev: _propTypes["default"].string,
  itemClassNext: _propTypes["default"].string,
  itemClassLast: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  linkClassFirst: _propTypes["default"].string,
  linkClassPrev: _propTypes["default"].string,
  linkClassNext: _propTypes["default"].string,
  linkClassLast: _propTypes["default"].string,
  hideFirstLastPages: _propTypes["default"].bool,
  getPageUrl: _propTypes["default"].func
});

_defineProperty(Pagination, "defaultProps", {
  itemsCountPerPage: 10,
  pageRangeDisplayed: 5,
  activePage: 1,
  prevPageText: "⟨",
  firstPageText: "«",
  nextPageText: "⟩",
  lastPageText: "»",
  innerClass: "pagination",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkClass: undefined,
  hideFirstLastPages: false,
  getPageUrl: function getPageUrl(i) {
    return "#";
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function QrCode(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col mt-2 nopadding border-1"},props.qr!==undefined&&props.qr!==null&&props.qr!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:props.qr,alt:props.qr,className:"w-100 h-100"}):"");}/* harmony default export */ __webpack_exports__["a"] = (QrCode);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRights;
/* unused harmony export updatedRights */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_common_options__ = __webpack_require__(32);
function getRights(moduleInfo){var neededInfo=__WEBPACK_IMPORTED_MODULE_0__services_common_options__["b" /* roleFilter */].filter(function(data){return data.moduleName===moduleInfo;});return function(dispatch){dispatch({type:"rights",payload:neededInfo[0]});};}function updatedRights(info){return function(dispatch){dispatch({type:"updated_rights",payload:info.rights});};}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    getRawTag = __webpack_require__(641),
    objectToString = __webpack_require__(642);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(8);

var OrderedMap = Immutable.OrderedMap;
var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};
module.exports = BlockMapBuilder;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;
  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }

      cursor = nextIndex;
    }

    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isHTMLElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }

  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }

  return false;
}

module.exports = isHTMLElement;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var gkx = __webpack_require__(50);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */

function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorBlock = content.getBlockForKey(anchorKey);

  if (experimentalTreeDataSupport) {
    if (direction === 'forward') {
      if (anchorKey !== focusKey) {
        // For now we ignore forward delete across blocks,
        // if there is demand for this we will implement it.
        return content;
      }
    }
  }

  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }

      if (experimentalTreeDataSupport) {
        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();

        if (isAtEndOfBlock) {
          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);

          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
            // For now we ignore forward delete at the end of a block,
            // if there is demand for this we will implement it.
            return content;
          }
        }
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);

    if (target === selection) {
      return content;
    }
  }

  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(324);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n0% { opacity: 0; }\n50% { opacity: 1; }\n'], ['\n0% { opacity: 0; }\n50% { opacity: 1; }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 250px;\n  max-width: 280px;\n  background: white;\n  text-align: center;\n  box-sizing: border-box;\n  margin: 0 auto;\n  animation: ', ' .5s linear 1 forwards;\n'], ['\n  width: 100%;\n  height: 250px;\n  max-width: 280px;\n  background: white;\n  text-align: center;\n  box-sizing: border-box;\n  margin: 0 auto;\n  animation: ', ' .5s linear 1 forwards;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fadeinout = (0, _styledComponents.keyframes)(_templateObject);
var Wrapper = _styledComponents2.default.div(_templateObject2, fadeinout);
exports.default = Wrapper;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(491);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(203);
var enumBugKeys = __webpack_require__(140);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(557);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(82);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function ImageTopLeft(props){var index=props.index,noRemove=props.noRemove,type=props.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:type==="type2"?"upload-photo-2":"upload-photo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:_typeof(props.image)=="object"?window.URL.createObjectURL(props.image):props.image!=""?__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].fileUrl()+props.image:__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default.a,onClick:function onClick(){return props.image&&props.modalData(props.image);}}),!props.disabled&&props.image==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black btn-img-upload"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons input-file-i"},"add")),!props.disabled&&props.image!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"positioing-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"pull-right p-1 edit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",className:"fileInputs",onChange:function onChange(e){return props.fileUpload(e.target.files);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit icon-fa-color print-hidden"})),props.noRemove==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"pull-right p-1 delete"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash icon-fa-color print-hidden",onClick:function onClick(e){return props.removeImage(e);}}))),!props.disabled&&props.image==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",accept:"image/*",className:"input-file",name:"profilePicture",style:{display:"none"},onChange:function onChange(e){return props.fileUpload(e.target.files);}}));}/* harmony default export */ __webpack_exports__["a"] = (ImageTopLeft);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAQAAABKIxwrAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiDA4OGzOuDw2dAAAA4ElEQVQ4y+2RsS5EQRSGv9lIkCVETaxQuAkdet7gvgJZxdYKm+g9he3EI2h4Au1G5xWWTiLufArcmOzstYXSX82c78uZyTmQjUtMH9eMruZIK+svEFicXp+Yf/2vdG/d+b7Y9jDFHtmuz1teoZZ14cDoOVioBdg3ulfTUhMdPLHy4lP3zGjvBxvXwVOjA3VgtJuQnA4eW2nauUEHu76lnRt1cD5TK7XFM+vjKLxmht5hhDcOnf19Qc756HVwkweeuGTI+0R3hl36bLAPWHhvtDmVd25D+HpqmZXGv4zCC8AHLw6qS+V2L94AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTItMTRUMTM6Mjc6NTErMDE6MDBNII4JAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEyLTE0VDEzOjI3OjUxKzAxOjAwPH02tQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(657),
    listCacheDelete = __webpack_require__(658),
    listCacheGet = __webpack_require__(659),
    listCacheHas = __webpack_require__(660),
    listCacheSet = __webpack_require__(661);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(154);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(663);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var randomizeBlockMapKeys = __webpack_require__(252);

var removeEntitiesAtEdges = __webpack_require__(253);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.

  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var DraftEntityInstance = __webpack_require__(258);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var uuid = __webpack_require__(746);

var Map = Immutable.Map;
var instances = Map();
var instanceKey = uuid();
/**
 * Temporary utility for generating the warnings
 */

function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * Get all the entities in the content state.
   */
  __getAll: function __getAll() {
    return instances;
  },

  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function __loadWithEntities(entities) {
    instances = entities;
    instanceKey = uuid();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({
      type: type,
      mutability: mutability,
      data: data || {}
    }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    instanceKey = uuid();
    instances = instances.set(instanceKey, instance);
    return instanceKey;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);

    var newData = _objectSpread({}, instance.getData(), toMerge);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};
module.exports = DraftEntity;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(8);

var Record = Immutable.Record;
var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
/* $FlowFixMe[unclear-type] This comment suppresses an error found when
 * automatically adding a type annotation with the codemod Komodo/Annotate_
 * exports. To see the error delete this comment and run Flow. */

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = /*#__PURE__*/function (_SelectionStateRecord) {
  _inheritsLoose(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    return _SelectionStateRecord.apply(this, arguments) || this;
  }

  var _proto = SelectionState.prototype;

  _proto.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  _proto.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  _proto.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  _proto.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  _proto.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  _proto.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  _proto.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  }
  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */
  ;

  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
      start <= selectionEnd && selectionEnd <= end // selectionEnd is between start and end
      ;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };

  _proto.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  _proto.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  _proto.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  _proto.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  _proto.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var invariant = __webpack_require__(9);

var NEUTRAL = 'NEUTRAL'; // No strong direction

var LTR = 'LTR'; // Left-to-Right direction

var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null; // == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */

function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */


function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */


function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
} // == Global Direction ==

/**
 * Set the global direction.
 */


function setGlobalDir(dir) {
  globalDir = dir;
}
/**
 * Initialize the global direction
 */


function initGlobalDir() {
  setGlobalDir(LTR);
}
/**
 * Get the global direction
 */


function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }

  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};
module.exports = UnicodeBidiDirection;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getCorrectDocumentFromNode = __webpack_require__(118);

var getSelectionOffsetKeyForNode = __webpack_require__(261);
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */


function findAncestorOffsetKey(node) {
  var searchNode = node;

  while (searchNode && searchNode !== getCorrectDocumentFromNode(node).documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getCorrectDocumentFromNode(node) {
  if (!node || !node.ownerDocument) {
    return document;
  }

  return node.ownerDocument;
}

module.exports = getCorrectDocumentFromNode;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getStyleProperty = __webpack_require__(769);
/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */


function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}
/**
 * Utilities for querying and mutating style properties.
 */


var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }

    var ownerDocument = node.ownerDocument;

    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }

      node = node.parentNode;
    }

    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
module.exports = Style;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var getDocumentScrollElement = __webpack_require__(773);

var getUnboundedScrollPosition = __webpack_require__(774);
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */


function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);

  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }

  var scrollPosition = getUnboundedScrollPosition(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(125);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(124);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])());

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SampleServices=function(){function SampleServices(){_classCallCheck(this,SampleServices);}_createClass(SampleServices,[{key:'getSampleQr',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequestQR',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function getSampleQr(){return _ref.apply(this,arguments);}return getSampleQr;}()},{key:'listSamples',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(page,_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/SampleRequests',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page,styleReferenceId:_id})});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function listSamples(_x,_x2){return _ref2.apply(this,arguments);}return listSamples;}()},{key:'getSampleRequestListById',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequestOneById',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:_id})});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function getSampleRequestListById(_x3){return _ref3.apply(this,arguments);}return getSampleRequestListById;}()},{key:'prefillSRDetails',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSR',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context4.sent;return _context4.abrupt('return',result.json());case 4:case'end':return _context4.stop();}}},_callee4,this);}));function prefillSRDetails(){return _ref4.apply(this,arguments);}return prefillSRDetails;}()},{key:'createSampleRequest',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/saveBasicDetails',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context5.sent;_context5.t0=result.status;_context5.next=6;return result.json();case 6:_context5.t1=_context5.sent;return _context5.abrupt('return',{status:_context5.t0,text:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function createSampleRequest(_x4){return _ref5.apply(this,arguments);}return createSampleRequest;}()},{key:'saveMeasurementChar',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(data,data1,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/sampleRequest/'+id+'/editMeasurementChat'),{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({measurementChat:data,shrinkagePercentage:data1})});case 2:result=_context6.sent;_context6.t0=result.status;_context6.next=6;return result.json();case 6:_context6.t1=_context6.sent;return _context6.abrupt('return',{status:_context6.t0,text:_context6.t1});case 8:case'end':return _context6.stop();}}},_callee6,this);}));function saveMeasurementChar(_x5,_x6,_x7){return _ref6.apply(this,arguments);}return saveMeasurementChar;}()},{key:'duplicateMeasurementChat',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(data,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/sampleRequest/'+id+'/duplicateMeasurementChat'),{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({targetSampleRequestId:data})});case 2:result=_context7.sent;_context7.t0=result.status;_context7.next=6;return result.json();case 6:_context7.t1=_context7.sent;return _context7.abrupt('return',{status:_context7.t0,text:_context7.t1});case 8:case'end':return _context7.stop();}}},_callee7,this);}));function duplicateMeasurementChat(_x8,_x9){return _ref7.apply(this,arguments);}return duplicateMeasurementChat;}()},{key:'addMoreTypeOfSize',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/addMoreTypeOfSizes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt('return',{status:_context8.t0,text:_context8.t1});case 8:case'end':return _context8.stop();}}},_callee8,this);}));function addMoreTypeOfSize(_x10){return _ref8.apply(this,arguments);}return addMoreTypeOfSize;}()},{key:'measurementChatDetails',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/sampleRequest/'+id+'/measurementChat'),{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context9.sent;_context9.t0=result.status;_context9.next=6;return result.json();case 6:_context9.t1=_context9.sent;return _context9.abrupt('return',{status:_context9.t0,text:_context9.t1});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function measurementChatDetails(_x11){return _ref9.apply(this,arguments);}return measurementChatDetails;}()},{key:'downloadExcel',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(id,value){var result,blob,url,link;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/sampleRequest/export/'+id+'/'+value),{method:"GET",headers:{'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',// Excel MIME type
'AuthToken':localStorage.getItem("authToken")}});case 3:result=_context10.sent;if(result.ok){_context10.next=6;break;}throw new Error('Error: '+result.status);case 6:_context10.next=8;return result.blob();case 8:blob=_context10.sent;url=window.URL.createObjectURL(blob);link=document.createElement("a");link.href=url;link.setAttribute("download",'SampleRequest_'+id+'.xlsx');// File name
document.body.appendChild(link);link.click();document.body.removeChild(link);_context10.next=21;break;case 18:_context10.prev=18;_context10.t0=_context10['catch'](0);console.error("Download failed:",_context10.t0);case 21:case'end':return _context10.stop();}}},_callee10,this,[[0,18]]);}));function downloadExcel(_x12,_x13){return _ref10.apply(this,arguments);}return downloadExcel;}()},{key:'editSampleRequest',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(data,styleInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/saveBasicDetails',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"_id":data._id,"originationOfRequest":data.originationOfRequest,"magnumStyleId":styleInfo.value,"styleReferenceId":styleInfo.referenceId,"typeOfRequest":data.typeOfRequest,"sampleType":data.sampleType,"requiredDate":data.requiredDate,"buyerName":data.buyerName,"assistantBuyer":data.assistantBuyer,"fabricTechnologist":data.fabricTechnologist,"garmentTechnology":data.garmentTechnology,"technologist":data.technologist,"customer":styleInfo.customerId,"customerDepartmentId":styleInfo.customerDepartmentId})});case 2:result=_context11.sent;return _context11.abrupt('return',result.json());case 4:case'end':return _context11.stop();}}},_callee11,this);}));function editSampleRequest(_x14,_x15){return _ref11.apply(this,arguments);}return editSampleRequest;}()},{key:'removeSample',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/deleteSampleRequest',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context12.sent;_context12.next=5;return result.json();case 5:_context12.t0=_context12.sent;_context12.t1=result.status;return _context12.abrupt('return',{text:_context12.t0,status:_context12.t1});case 8:case'end':return _context12.stop();}}},_callee12,this);}));function removeSample(_x16){return _ref12.apply(this,arguments);}return removeSample;}()},{key:'createSample',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/sampleDetails',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context13.sent;_context13.t0=result.status;_context13.next=6;return result.json();case 6:_context13.t1=_context13.sent;return _context13.abrupt('return',{status:_context13.t0,text:_context13.t1});case 8:case'end':return _context13.stop();}}},_callee13,this);}));function createSample(_x17){return _ref13.apply(this,arguments);}return createSample;}()},{key:'createPattern',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/pattern',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(value)});case 2:result=_context14.sent;_context14.t0=result.status;_context14.next=6;return result.json();case 6:_context14.t1=_context14.sent;return _context14.abrupt('return',{status:_context14.t0,text:_context14.t1});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function createPattern(_x18){return _ref14.apply(this,arguments);}return createPattern;}()},{key:'completePattern',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/patternComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context15.sent;_context15.t0=result.status;_context15.next=6;return result.json();case 6:_context15.t1=_context15.sent;return _context15.abrupt('return',{status:_context15.t0,text:_context15.t1});case 8:case'end':return _context15.stop();}}},_callee15,this);}));function completePattern(_x19){return _ref15.apply(this,arguments);}return completePattern;}()},{key:'createGarment',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/garmentTechnology',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(value)});case 2:result=_context16.sent;_context16.t0=result.status;_context16.next=6;return result.json();case 6:_context16.t1=_context16.sent;return _context16.abrupt('return',{status:_context16.t0,text:_context16.t1});case 8:case'end':return _context16.stop();}}},_callee16,this);}));function createGarment(_x20){return _ref16.apply(this,arguments);}return createGarment;}()},{key:'completeGarment',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/garmentTechnologyComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context17.sent;_context17.t0=result.status;_context17.next=6;return result.json();case 6:_context17.t1=_context17.sent;return _context17.abrupt('return',{status:_context17.t0,text:_context17.t1});case 8:case'end':return _context17.stop();}}},_callee17,this);}));function completeGarment(_x21){return _ref17.apply(this,arguments);}return completeGarment;}()},{key:'createFabric',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/fabric',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context18.sent;_context18.t0=result.status;_context18.next=6;return result.json();case 6:_context18.t1=_context18.sent;return _context18.abrupt('return',{status:_context18.t0,text:_context18.t1});case 8:case'end':return _context18.stop();}}},_callee18,this);}));function createFabric(_x22){return _ref18.apply(this,arguments);}return createFabric;}()},{key:'completeFabric',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/fabricComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context19.sent;_context19.t0=result.status;_context19.next=6;return result.json();case 6:_context19.t1=_context19.sent;return _context19.abrupt('return',{status:_context19.t0,text:_context19.t1});case 8:case'end':return _context19.stop();}}},_callee19,this);}));function completeFabric(_x23){return _ref19.apply(this,arguments);}return completeFabric;}()},{key:'createTrim',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/trim',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context20.sent;_context20.t0=result.status;_context20.next=6;return result.json();case 6:_context20.t1=_context20.sent;return _context20.abrupt('return',{status:_context20.t0,text:_context20.t1});case 8:case'end':return _context20.stop();}}},_callee20,this);}));function createTrim(_x24){return _ref20.apply(this,arguments);}return createTrim;}()},{key:'completeTrim',value:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/trimComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context21.sent;_context21.t0=result.status;_context21.next=6;return result.json();case 6:_context21.t1=_context21.sent;return _context21.abrupt('return',{status:_context21.t0,text:_context21.t1});case 8:case'end':return _context21.stop();}}},_callee21,this);}));function completeTrim(_x25){return _ref21.apply(this,arguments);}return completeTrim;}()},{key:'createEmbelishment',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/embellishment',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context22.sent;_context22.t0=result.status;_context22.next=6;return result.json();case 6:_context22.t1=_context22.sent;return _context22.abrupt('return',{status:_context22.t0,text:_context22.t1});case 8:case'end':return _context22.stop();}}},_callee22,this);}));function createEmbelishment(_x26){return _ref22.apply(this,arguments);}return createEmbelishment;}()},{key:'completeEmbelishment',value:function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/embellishmentCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context23.sent;_context23.t0=result.status;_context23.next=6;return result.json();case 6:_context23.t1=_context23.sent;return _context23.abrupt('return',{status:_context23.t0,text:_context23.t1});case 8:case'end':return _context23.stop();}}},_callee23,this);}));function completeEmbelishment(_x27){return _ref23.apply(this,arguments);}return completeEmbelishment;}()},{key:'createCutting',value:function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:_context24.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/cutting',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context24.sent;_context24.t0=result.status;_context24.next=6;return result.json();case 6:_context24.t1=_context24.sent;return _context24.abrupt('return',{status:_context24.t0,text:_context24.t1});case 8:case'end':return _context24.stop();}}},_callee24,this);}));function createCutting(_x28){return _ref24.apply(this,arguments);}return createCutting;}()},{key:'createQC',value:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/qc',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context25.sent;_context25.t0=result.status;_context25.next=6;return result.json();case 6:_context25.t1=_context25.sent;return _context25.abrupt('return',{status:_context25.t0,text:_context25.t1});case 8:case'end':return _context25.stop();}}},_callee25,this);}));function createQC(_x29){return _ref25.apply(this,arguments);}return createQC;}()},{key:'completeQC',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/qcCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context26.sent;_context26.t0=result.status;_context26.next=6;return result.json();case 6:_context26.t1=_context26.sent;return _context26.abrupt('return',{status:_context26.t0,text:_context26.t1});case 8:case'end':return _context26.stop();}}},_callee26,this);}));function completeQC(_x30){return _ref26.apply(this,arguments);}return completeQC;}()},{key:'completeCutting',value:function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/cuttingComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context27.sent;_context27.t0=result.status;_context27.next=6;return result.json();case 6:_context27.t1=_context27.sent;return _context27.abrupt('return',{status:_context27.t0,text:_context27.t1});case 8:case'end':return _context27.stop();}}},_callee27,this);}));function completeCutting(_x31){return _ref27.apply(this,arguments);}return completeCutting;}()},{key:'createSignOff',value:function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/signOff',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context28.sent;_context28.t0=result.status;_context28.next=6;return result.json();case 6:_context28.t1=_context28.sent;return _context28.abrupt('return',{status:_context28.t0,text:_context28.t1});case 8:case'end':return _context28.stop();}}},_callee28,this);}));function createSignOff(_x32){return _ref28.apply(this,arguments);}return createSignOff;}()},{key:'completeSignOff',value:function(){var _ref29=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee29(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29){while(1){switch(_context29.prev=_context29.next){case 0:_context29.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/signOffCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context29.sent;_context29.t0=result.status;_context29.next=6;return result.json();case 6:_context29.t1=_context29.sent;return _context29.abrupt('return',{status:_context29.t0,text:_context29.t1});case 8:case'end':return _context29.stop();}}},_callee29,this);}));function completeSignOff(_x33){return _ref29.apply(this,arguments);}return completeSignOff;}()},{key:'createSewing',value:function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee30(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30){while(1){switch(_context30.prev=_context30.next){case 0:_context30.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/sewing',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context30.sent;_context30.t0=result.status;_context30.next=6;return result.json();case 6:_context30.t1=_context30.sent;return _context30.abrupt('return',{status:_context30.t0,text:_context30.t1});case 8:case'end':return _context30.stop();}}},_callee30,this);}));function createSewing(_x34){return _ref30.apply(this,arguments);}return createSewing;}()},{key:'completeSewing',value:function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee31(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:_context31.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/sewingCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context31.sent;_context31.t0=result.status;_context31.next=6;return result.json();case 6:_context31.t1=_context31.sent;return _context31.abrupt('return',{status:_context31.t0,text:_context31.t1});case 8:case'end':return _context31.stop();}}},_callee31,this);}));function completeSewing(_x35){return _ref31.apply(this,arguments);}return completeSewing;}()},{key:'createDispatch',value:function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee32(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:_context32.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/dispatch',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context32.sent;_context32.t0=result.status;_context32.next=6;return result.json();case 6:_context32.t1=_context32.sent;return _context32.abrupt('return',{status:_context32.t0,text:_context32.t1});case 8:case'end':return _context32.stop();}}},_callee32,this);}));function createDispatch(_x36){return _ref32.apply(this,arguments);}return createDispatch;}()},{key:'completeDispatch',value:function(){var _ref33=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee33(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:_context33.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/dispatchCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context33.sent;_context33.t0=result.status;_context33.next=6;return result.json();case 6:_context33.t1=_context33.sent;return _context33.abrupt('return',{status:_context33.t0,text:_context33.t1});case 8:case'end':return _context33.stop();}}},_callee33,this);}));function completeDispatch(_x37){return _ref33.apply(this,arguments);}return completeDispatch;}()},{key:'cloneMeeting',value:function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee34(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34){while(1){switch(_context34.prev=_context34.next){case 0:_context34.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/cloneMN',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context34.sent;return _context34.abrupt('return',result.json());case 4:case'end':return _context34.stop();}}},_callee34,this);}));function cloneMeeting(_x38){return _ref34.apply(this,arguments);}return cloneMeeting;}()},{key:'SampleInfo',value:function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee35(id,SRNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35){while(1){switch(_context35.prev=_context35.next){case 0:_context35.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequest',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,requestNumber:SRNo})});case 2:result=_context35.sent;_context35.t0=result.status;_context35.next=6;return result.json();case 6:_context35.t1=_context35.sent;return _context35.abrupt('return',{status:_context35.t0,text:_context35.t1});case 8:case'end':return _context35.stop();}}},_callee35,this);}));function SampleInfo(_x39,_x40){return _ref35.apply(this,arguments);}return SampleInfo;}()},{key:'getSampleReqNo',value:function(){var _ref36=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee36(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36){while(1){switch(_context36.prev=_context36.next){case 0:_context36.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/searchSR',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:value!==''?JSON.stringify({requestNumber:value}):''});case 2:result=_context36.sent;_context36.t0=result.status;_context36.next=6;return result.json();case 6:_context36.t1=_context36.sent;return _context36.abrupt('return',{status:_context36.t0,text:_context36.t1});case 8:case'end':return _context36.stop();}}},_callee36,this);}));function getSampleReqNo(_x41){return _ref36.apply(this,arguments);}return getSampleReqNo;}()},{key:'getStyleInfo',value:function(){var _ref37=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee37(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37){while(1){switch(_context37.prev=_context37.next){case 0:_context37.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getSRData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({requestId:value})});case 2:result=_context37.sent;_context37.t0=result.status;_context37.next=6;return result.json();case 6:_context37.t1=_context37.sent;return _context37.abrupt('return',{status:_context37.t0,text:_context37.t1});case 8:case'end':return _context37.stop();}}},_callee37,this);}));function getStyleInfo(_x42){return _ref37.apply(this,arguments);}return getStyleInfo;}()},{key:'getFabricNo',value:function(){var _ref38=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee38(reqId,value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38){while(1){switch(_context38.prev=_context38.next){case 0:_context38.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getFabricData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({requestId:value,fabricNumber:reqId})});case 2:result=_context38.sent;return _context38.abrupt('return',result.json());case 4:case'end':return _context38.stop();}}},_callee38,this);}));function getFabricNo(_x43,_x44){return _ref38.apply(this,arguments);}return getFabricNo;}()},{key:'getAllFabrics',value:function(){var _ref39=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee39(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39){while(1){switch(_context39.prev=_context39.next){case 0:_context39.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getFabric',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricNumber:value})});case 2:result=_context39.sent;return _context39.abrupt('return',result.json());case 4:case'end':return _context39.stop();}}},_callee39,this);}));function getAllFabrics(_x45){return _ref39.apply(this,arguments);}return getAllFabrics;}()},{key:'getFabricName',value:function(){var _ref40=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee40(requestId,fabricNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40){while(1){switch(_context40.prev=_context40.next){case 0:_context40.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getFabricSR',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({requestId:requestId.value,fabricId:fabricNo.value})});case 2:result=_context40.sent;return _context40.abrupt('return',result.json());case 4:case'end':return _context40.stop();}}},_callee40,this);}));function getFabricName(_x46,_x47){return _ref40.apply(this,arguments);}return getFabricName;}()},{key:'getSupplierInfo',value:function(){var _ref41=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee41(fabricNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41){while(1){switch(_context41.prev=_context41.next){case 0:_context41.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getFabricSupplier',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricId:fabricNo.value})});case 2:result=_context41.sent;return _context41.abrupt('return',result.json());case 4:case'end':return _context41.stop();}}},_callee41,this);}));function getSupplierInfo(_x48){return _ref41.apply(this,arguments);}return getSupplierInfo;}()},{key:'getSupplierInfoForTrim',value:function(){var _ref42=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee42(trimNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42){while(1){switch(_context42.prev=_context42.next){case 0:_context42.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getTrimSupplier',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimId:trimNo.value})});case 2:result=_context42.sent;return _context42.abrupt('return',result.json());case 4:case'end':return _context42.stop();}}},_callee42,this);}));function getSupplierInfoForTrim(_x49){return _ref42.apply(this,arguments);}return getSupplierInfoForTrim;}()},{key:'getTrimNo',value:function(){var _ref43=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee43(reqId,value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43){while(1){switch(_context43.prev=_context43.next){case 0:_context43.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getTrimData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({requestId:value,trimNumber:reqId})});case 2:result=_context43.sent;return _context43.abrupt('return',result.json());case 4:case'end':return _context43.stop();}}},_callee43,this);}));function getTrimNo(_x50,_x51){return _ref43.apply(this,arguments);}return getTrimNo;}()},{key:'getAllTrims',value:function(){var _ref44=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee44(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44){while(1){switch(_context44.prev=_context44.next){case 0:_context44.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getTrim',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimNumber:value})});case 2:result=_context44.sent;return _context44.abrupt('return',result.json());case 4:case'end':return _context44.stop();}}},_callee44,this);}));function getAllTrims(_x52){return _ref44.apply(this,arguments);}return getAllTrims;}()},{key:'getTrimName',value:function(){var _ref45=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee45(requestId,fabricNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45){while(1){switch(_context45.prev=_context45.next){case 0:_context45.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getTrimSR',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({requestId:requestId.value,trimId:fabricNo.value})});case 2:result=_context45.sent;return _context45.abrupt('return',result.json());case 4:case'end':return _context45.stop();}}},_callee45,this);}));function getTrimName(_x53,_x54){return _ref45.apply(this,arguments);}return getTrimName;}()},{key:'searchSamplesBy',value:function(){var _ref46=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee46(searchStylesBy,searchFor){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46){while(1){switch(_context46.prev=_context46.next){case 0:_context46.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/search',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"for":searchFor,"by":searchStylesBy})});case 2:result=_context46.sent;_context46.t0=result.status;_context46.next=6;return result.json();case 6:_context46.t1=_context46.sent;return _context46.abrupt('return',{status:_context46.t0,text:_context46.t1});case 8:case'end':return _context46.stop();}}},_callee46,this);}));function searchSamplesBy(_x55,_x56){return _ref46.apply(this,arguments);}return searchSamplesBy;}()},{key:'getDoneBy',value:function(){var _ref47=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee47(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47){while(1){switch(_context47.prev=_context47.next){case 0:_context47.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getEmployees',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context47.sent;return _context47.abrupt('return',result.json());case 4:case'end':return _context47.stop();}}},_callee47,this);}));function getDoneBy(_x57){return _ref47.apply(this,arguments);}return getDoneBy;}()},{key:'createCAD',value:function(){var _ref48=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee48(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48){while(1){switch(_context48.prev=_context48.next){case 0:_context48.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/addCAD',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context48.sent;_context48.t0=result.status;_context48.next=6;return result.json();case 6:_context48.t1=_context48.sent;return _context48.abrupt('return',{status:_context48.t0,text:_context48.t1});case 8:case'end':return _context48.stop();}}},_callee48,this);}));function createCAD(_x58){return _ref48.apply(this,arguments);}return createCAD;}()},{key:'completeCAD',value:function(){var _ref49=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee49(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49){while(1){switch(_context49.prev=_context49.next){case 0:_context49.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/cadCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context49.sent;_context49.t0=result.status;_context49.next=6;return result.json();case 6:_context49.t1=_context49.sent;return _context49.abrupt('return',{status:_context49.t0,text:_context49.t1});case 8:case'end':return _context49.stop();}}},_callee49,this);}));function completeCAD(_x59){return _ref49.apply(this,arguments);}return completeCAD;}()},{key:'createCosting',value:function(){var _ref50=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee50(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50){while(1){switch(_context50.prev=_context50.next){case 0:_context50.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/costing',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context50.sent;_context50.t0=result.status;_context50.next=6;return result.json();case 6:_context50.t1=_context50.sent;return _context50.abrupt('return',{status:_context50.t0,text:_context50.t1});case 8:case'end':return _context50.stop();}}},_callee50,this);}));function createCosting(_x60){return _ref50.apply(this,arguments);}return createCosting;}()},{key:'completeCosting',value:function(){var _ref51=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee51(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51){while(1){switch(_context51.prev=_context51.next){case 0:_context51.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/costingCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context51.sent;_context51.t0=result.status;_context51.next=6;return result.json();case 6:_context51.t1=_context51.sent;return _context51.abrupt('return',{status:_context51.t0,text:_context51.t1});case 8:case'end':return _context51.stop();}}},_callee51,this);}));function completeCosting(_x61){return _ref51.apply(this,arguments);}return completeCosting;}()},{key:'createEmbroidery',value:function(){var _ref52=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee52(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52){while(1){switch(_context52.prev=_context52.next){case 0:_context52.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/embroidery',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context52.sent;_context52.t0=result.status;_context52.next=6;return result.json();case 6:_context52.t1=_context52.sent;return _context52.abrupt('return',{status:_context52.t0,text:_context52.t1});case 8:case'end':return _context52.stop();}}},_callee52,this);}));function createEmbroidery(_x62){return _ref52.apply(this,arguments);}return createEmbroidery;}()},{key:'completeEmbroidery',value:function(){var _ref53=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee53(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53){while(1){switch(_context53.prev=_context53.next){case 0:_context53.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/embroideryCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context53.sent;_context53.t0=result.status;_context53.next=6;return result.json();case 6:_context53.t1=_context53.sent;return _context53.abrupt('return',{status:_context53.t0,text:_context53.t1});case 8:case'end':return _context53.stop();}}},_callee53,this);}));function completeEmbroidery(_x63){return _ref53.apply(this,arguments);}return completeEmbroidery;}()},{key:'createWash',value:function(){var _ref54=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee54(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54){while(1){switch(_context54.prev=_context54.next){case 0:_context54.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/wash',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context54.sent;_context54.t0=result.status;_context54.next=6;return result.json();case 6:_context54.t1=_context54.sent;return _context54.abrupt('return',{status:_context54.t0,text:_context54.t1});case 8:case'end':return _context54.stop();}}},_callee54,this);}));function createWash(_x64){return _ref54.apply(this,arguments);}return createWash;}()},{key:'completeWash',value:function(){var _ref55=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee55(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55){while(1){switch(_context55.prev=_context55.next){case 0:_context55.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/washCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context55.sent;_context55.t0=result.status;_context55.next=6;return result.json();case 6:_context55.t1=_context55.sent;return _context55.abrupt('return',{status:_context55.t0,text:_context55.t1});case 8:case'end':return _context55.stop();}}},_callee55,this);}));function completeWash(_x65){return _ref55.apply(this,arguments);}return completeWash;}()},{key:'createMarker',value:function(){var _ref56=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee56(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56){while(1){switch(_context56.prev=_context56.next){case 0:_context56.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/addMarker',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context56.sent;_context56.t0=result.status;_context56.next=6;return result.json();case 6:_context56.t1=_context56.sent;return _context56.abrupt('return',{status:_context56.t0,text:_context56.t1});case 8:case'end':return _context56.stop();}}},_callee56,this);}));function createMarker(_x66){return _ref56.apply(this,arguments);}return createMarker;}()},{key:'completeMarker',value:function(){var _ref57=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee57(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57){while(1){switch(_context57.prev=_context57.next){case 0:_context57.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/markerCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context57.sent;_context57.t0=result.status;_context57.next=6;return result.json();case 6:_context57.t1=_context57.sent;return _context57.abrupt('return',{status:_context57.t0,text:_context57.t1});case 8:case'end':return _context57.stop();}}},_callee57,this);}));function completeMarker(_x67){return _ref57.apply(this,arguments);}return completeMarker;}()},{key:'completeSample',value:function(){var _ref58=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee58(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58){while(1){switch(_context58.prev=_context58.next){case 0:_context58.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/sampleDetailsComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:value._id,comments:value.comments})});case 2:result=_context58.sent;_context58.t0=result.status;_context58.next=6;return result.json();case 6:_context58.t1=_context58.sent;return _context58.abrupt('return',{status:_context58.t0,text:_context58.t1});case 8:case'end':return _context58.stop();}}},_callee58,this);}));function completeSample(_x68){return _ref58.apply(this,arguments);}return completeSample;}()},{key:'getCustomerData',value:function(){var _ref59=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee59(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59){while(1){switch(_context59.prev=_context59.next){case 0:_context59.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequestCustomerData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"customerId":value.customer,"departmentId":value.customerDepartmentId,"type":value.type})});case 2:result=_context59.sent;_context59.t0=result.status;_context59.next=6;return result.json();case 6:_context59.t1=_context59.sent;return _context59.abrupt('return',{status:_context59.t0,text:_context59.t1});case 8:case'end':return _context59.stop();}}},_callee59,this);}));function getCustomerData(_x69){return _ref59.apply(this,arguments);}return getCustomerData;}()},{key:'getCustomerData2',value:function(){var _ref60=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee60(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60){while(1){switch(_context60.prev=_context60.next){case 0:_context60.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequestCustandDepartData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"customerId":value.customer,"departmentId":value.customerDepartmentId})});case 2:result=_context60.sent;_context60.t0=result.status;_context60.next=6;return result.json();case 6:_context60.t1=_context60.sent;return _context60.abrupt('return',{status:_context60.t0,text:_context60.t1});case 8:case'end':return _context60.stop();}}},_callee60,this);}));function getCustomerData2(_x70){return _ref60.apply(this,arguments);}return getCustomerData2;}()//get fabric info for sampleRequest 
},{key:'getFabricInfo',value:function(){var _ref61=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee61(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61){while(1){switch(_context61.prev=_context61.next){case 0:_context61.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getFabric',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricId:_id})});case 2:result=_context61.sent;_context61.t0=result.status;_context61.next=6;return result.json();case 6:_context61.t1=_context61.sent;return _context61.abrupt('return',{status:_context61.t0,text:_context61.t1});case 8:case'end':return _context61.stop();}}},_callee61,this);}));function getFabricInfo(_x71){return _ref61.apply(this,arguments);}return getFabricInfo;}()//get trim info for sampleRequest 
},{key:'getTrimInfo',value:function(){var _ref62=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee62(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62){while(1){switch(_context62.prev=_context62.next){case 0:_context62.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getTrim',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimId:_id})});case 2:result=_context62.sent;_context62.t0=result.status;_context62.next=6;return result.json();case 6:_context62.t1=_context62.sent;return _context62.abrupt('return',{status:_context62.t0,text:_context62.t1});case 8:case'end':return _context62.stop();}}},_callee62,this);}));function getTrimInfo(_x72){return _ref62.apply(this,arguments);}return getTrimInfo;}()},{key:'getTrimNumber',value:function(){var _ref63=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee63(trimCategory,trimNumberSearch){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63){while(1){switch(_context63.prev=_context63.next){case 0:_context63.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getTrims',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimCategory:trimCategory,trimNumber:trimNumberSearch})});case 2:result=_context63.sent;_context63.t0=result.status;_context63.next=6;return result.json();case 6:_context63.t1=_context63.sent;return _context63.abrupt('return',{status:_context63.t0,text:_context63.t1});case 8:case'end':return _context63.stop();}}},_callee63,this);}));function getTrimNumber(_x73,_x74){return _ref63.apply(this,arguments);}return getTrimNumber;}()},{key:'auditForSample',value:function(){var _ref64=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee64(id,moduleName){var moduleVal,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64){while(1){switch(_context64.prev=_context64.next){case 0:moduleVal=moduleName==="garmenttechnologist"?"garmentTechnologist":moduleName;_context64.next=3;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/modulesLogs/getSampleLog/'+moduleVal+'/'+id),{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 3:result=_context64.sent;_context64.t0=result.status;_context64.next=7;return result.json();case 7:_context64.t1=_context64.sent;return _context64.abrupt('return',{status:_context64.t0,text:_context64.t1});case 9:case'end':return _context64.stop();}}},_callee64,this);}));function auditForSample(_x75,_x76){return _ref64.apply(this,arguments);}return auditForSample;}()},{key:'ProcessUpdates',value:function(){var _ref65=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee65(info){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65){while(1){switch(_context65.prev=_context65.next){case 0:_context65.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/updateSRProcessAll',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(info)});case 2:result=_context65.sent;_context65.t0=result.status;_context65.next=6;return result.json();case 6:_context65.t1=_context65.sent;return _context65.abrupt('return',{status:_context65.t0,text:_context65.t1});case 8:case'end':return _context65.stop();}}},_callee65,this);}));function ProcessUpdates(_x77){return _ref65.apply(this,arguments);}return ProcessUpdates;}()},{key:'sampleTagByStyle',value:function(){var _ref66=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee66(ids){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66){while(1){switch(_context66.prev=_context66.next){case 0:_context66.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/sampleTagByStyle',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({'ids':ids})});case 2:result=_context66.sent;_context66.t0=result.status;_context66.next=6;return result.json();case 6:_context66.t1=_context66.sent;return _context66.abrupt('return',{status:_context66.t0,text:_context66.t1});case 8:case'end':return _context66.stop();}}},_callee66,this);}));function sampleTagByStyle(_x78){return _ref66.apply(this,arguments);}return sampleTagByStyle;}()},{key:'bulkUpdateDispatch',value:function(){var _ref67=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee67(obj){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67){while(1){switch(_context67.prev=_context67.next){case 0:_context67.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/bulkUpdateDispatch',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 2:result=_context67.sent;_context67.t0=result.status;_context67.next=6;return result.json();case 6:_context67.t1=_context67.sent;return _context67.abrupt('return',{status:_context67.t0,text:_context67.t1});case 8:case'end':return _context67.stop();}}},_callee67,this);}));function bulkUpdateDispatch(_x79){return _ref67.apply(this,arguments);}return bulkUpdateDispatch;}()}]);return SampleServices;}();/* harmony default export */ __webpack_exports__["a"] = (new SampleServices());

/***/ }),
/* 129 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//alert css
var Alert={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo4.7fde869b.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 14px;\n  text-align: center;\n  color: #222222;\n  width:40px;\n  height:40px;\n  margin:15px;\n  display:inline-block;\n  line-height: 40px;\n  cursor : pointer;\n  overflow : auto;\n'], ['\n  font-size: 14px;\n  text-align: center;\n  color: #222222;\n  width:40px;\n  height:40px;\n  margin:15px;\n  display:inline-block;\n  line-height: 40px;\n  cursor : pointer;\n  overflow : auto;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Span = _styledComponents2.default.span(_templateObject);
exports.default = Span;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\nwidth:100%;\ntext-align : left;\n'], ['\nwidth:100%;\ntext-align : left;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Header = _styledComponents2.default.div(_templateObject);
exports.default = Header;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	autosize 4.0.4
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
		factory(module, exports);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod, mod.exports);
		global.autosize = mod.exports;
	}
})(this, function (module, exports) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			delete: function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	}();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function createEvent(name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = null;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				return;
			}

			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';
			ta.style.height = ta.scrollHeight + heightOffset + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that 
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight < styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map.delete(ta);
		}.bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function autosize(el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function autosize(el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	exports.default = autosize;
	module.exports = exports['default'];
});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(67);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(139)('keys');
var uid = __webpack_require__(101);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(46);
var global = __webpack_require__(45);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(100) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 141 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(136);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(499);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(511);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(80);
var dPs = __webpack_require__(504);
var enumBugKeys = __webpack_require__(140);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(202)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(505).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(52).f;
var has = __webpack_require__(53);
var TAG = __webpack_require__(69)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(69);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(46);
var LIBRARY = __webpack_require__(100);
var wksExt = __webpack_require__(147);
var defineProperty = __webpack_require__(52).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(213);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(229);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(646),
    mapCacheDelete = __webpack_require__(662),
    mapCacheGet = __webpack_require__(664),
    mapCacheHas = __webpack_require__(665),
    mapCacheSet = __webpack_require__(666);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimerModule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function TimerModule(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:props.disabled?"mt-3":""},props.time!==""?__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.time).format('MMMM Do YYYY, hh:mm'):""),!props.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Buttons_Button__["a" /* default */],{buttonName:props.buttonName,onClick:props.updatePatternCheck}));}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(89);

var CharacterMetadata = __webpack_require__(37);

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var DraftEntity = __webpack_require__(114);

var SelectionState = __webpack_require__(115);

var generateRandomKey = __webpack_require__(42);

var getOwnObjectValues = __webpack_require__(257);

var gkx = __webpack_require__(50);

var Immutable = __webpack_require__(8);

var sanitizeDraftText = __webpack_require__(259);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat,
    ImmutableMap = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;
var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentStateRecord = Record(defaultRecord);
/* $FlowFixMe[signature-verification-failure] Supressing a `signature-
 * verification-failure` error here. TODO: T65949050 Clean up the branch for
 * this GK */

var ContentBlockNodeRecord = gkx('draft_tree_data_support') ? ContentBlockNode : ContentBlock;

var ContentState = /*#__PURE__*/function (_ContentStateRecord) {
  _inheritsLoose(ContentState, _ContentStateRecord);

  function ContentState() {
    return _ContentStateRecord.apply(this, arguments) || this;
  }

  var _proto = ContentState.prototype;

  _proto.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  _proto.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  _proto.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  _proto.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  _proto.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  _proto.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  _proto.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  _proto.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  _proto.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  _proto.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || // make sure that there are no zero width space chars
    escape(blockMap.first().getText()).replace(/%u200B/g, '').length > 0;
  };

  _proto.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);

    return this;
  };

  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);

    return this;
  };

  _proto.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);

    return this;
  };

  _proto.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);

    return this;
  };

  _proto.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  _proto.getAllEntities = function getAllEntities() {
    return DraftEntity.__getAll();
  };

  _proto.loadWithEntities = function loadWithEntities(entities) {
    return DraftEntity.__loadWithEntities(entities);
  };

  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  ContentState.fromJS = function fromJS(state) {
    return new ContentState(_objectSpread({}, state, {
      blockMap: OrderedMap(state.blockMap).map(ContentState.createContentBlockFromJS),
      selectionBefore: new SelectionState(state.selectionBefore),
      selectionAfter: new SelectionState(state.selectionAfter)
    }));
  };

  ContentState.createContentBlockFromJS = function createContentBlockFromJS(block) {
    var characterList = block.characterList;
    return new ContentBlockNodeRecord(_objectSpread({}, block, {
      data: ImmutableMap(block.data),
      characterList: characterList != null ? List((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function (c) {
        return CharacterMetadata.fromJS(c);
      })) : undefined
    }));
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var UnicodeBidiDirection = __webpack_require__(116);

var invariant = __webpack_require__(9);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
};
var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */

function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */


function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);

  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }

  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */


function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;

  if (!str.length) {
    return fallback;
  }

  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */


function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }

  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */


function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}
/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */


function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};
module.exports = UnicodeBidi;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var React = __webpack_require__(0);

var cx = __webpack_require__(59);

var _require = __webpack_require__(8),
    Map = _require.Map;

var UL_WRAP = React.createElement("ul", {
  className: cx('public/DraftStyleDefault/ul')
});
var OL_WRAP = React.createElement("ol", {
  className: cx('public/DraftStyleDefault/ol')
});
var PRE_WRAP = React.createElement("pre", {
  className: cx('public/DraftStyleDefault/pre')
});
var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  section: {
    element: 'section'
  },
  article: {
    element: 'article'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});
module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _require = __webpack_require__(269),
    notEmptyKey = _require.notEmptyKey;
/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */


function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();

    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }

      return filterKey(contentState.getEntityMap(), entityKey);
    }

    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */


function filterKey(entityMap, entityKey) {
  if (notEmptyKey(entityKey)) {
    var entity = entityMap.__get(entityKey);

    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }

  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isTextNode = __webpack_require__(767);
/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */


function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */


var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
module.exports = Scroll;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(164);
/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionBackward should only be called with a collapsed SelectionState') : void 0;
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);

    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var emptyFunction = __webpack_require__(278);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning =  false ? function (condition, format) {
  if (format === undefined) {
    throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
  }

  if (!condition) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    printWarning.apply(void 0, [format].concat(args));
  }
} : emptyFunction;
module.exports = warning;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(23);

var isSoftNewlineEvent = __webpack_require__(795);

var isOSX = UserAgent.isPlatform('Mac OS X');
var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },
  usesMacOSHeuristics: function usesMacOSHeuristics() {
    return isOSX;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  },
  isSoftNewlineEvent: isSoftNewlineEvent
};
module.exports = KeyBindingUtil;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processNodes;

var _isEmptyTextNode = __webpack_require__(847);

var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);

var _convertNodeToElement = __webpack_require__(290);

var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes the nodes generated by htmlparser2 and convert them all into React elements
 *
 * @param {Object[]} nodes List of nodes to process
 * @param {Function} transform Transform function to optionally apply to nodes
 * @returns {React.Element[]} The list of processed React elements
 */
function processNodes(nodes, transform) {

  return nodes.filter(function (node) {
    return !(0, _isEmptyTextNode2.default)(node);
  }).map(function (node, index) {

    // return the result of the transform function if applicable
    var transformed = void 0;
    if (typeof transform === 'function') {
      transformed = transform(node, index);
      if (transformed === null || !!transformed) {
        return transformed;
      }
    }

    // otherwise convert the node as standard
    return (0, _convertNodeToElement2.default)(node, index, transform);
  });
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(14)):"function"==typeof define&&define.amd?define("lib",["react","react-dom"],t):"object"==typeof exports?exports.lib=t(require("react"),require("react-dom")):e.lib=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,(function(e,t){return function(){"use strict";var r={328:function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t.PrintContextConsumer=t.PrintContext=void 0;var n=r(496),o=Object.prototype.hasOwnProperty.call(n,"createContext");t.PrintContext=o?n.createContext({}):null,t.PrintContextConsumer=t.PrintContext?t.PrintContext.Consumer:function(){return null}},428:function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t.ReactToPrint=void 0;var n=r(316),o=r(496),i=r(190),a=r(328),c=r(940),s=function(e){function t(){var t=e.apply(this,n.__spreadArray([],n.__read(arguments),!1))||this;return t.startPrint=function(e){var r=t.props,n=r.onAfterPrint,o=r.onPrintError,i=r.print,a=r.documentTitle;setTimeout((function(){var r,c;if(e.contentWindow)if(e.contentWindow.focus(),i)i(e).then((function(){return null==n?void 0:n()})).then((function(){return t.handleRemoveIframe()})).catch((function(e){o?o("print",e):t.logMessages(["An error was thrown by the specified `print` function"])}));else{if(e.contentWindow.print){var s=null!==(c=null===(r=e.contentDocument)||void 0===r?void 0:r.title)&&void 0!==c?c:"",u=e.ownerDocument.title;a&&(e.ownerDocument.title=a,e.contentDocument&&(e.contentDocument.title=a)),e.contentWindow.print(),a&&(e.ownerDocument.title=u,e.contentDocument&&(e.contentDocument.title=s))}else t.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);null==n||n(),t.handleRemoveIframe()}else t.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"])}),500)},t.triggerPrint=function(e){var r=t.props,n=r.onBeforePrint,o=r.onPrintError;if(n){var i=n();i&&"function"==typeof i.then?i.then((function(){t.startPrint(e)})).catch((function(e){o&&o("onBeforePrint",e)})):t.startPrint(e)}else t.startPrint(e)},t.handlePrint=function(e){var r=t.props,o=r.bodyClass,a=r.content,c=r.copyStyles,s=r.fonts,u=r.pageStyle,l=r.nonce,f="function"==typeof e?e():null;if(f&&"function"==typeof a&&t.logMessages(['"react-to-print" received a `content` prop and a content param passed the callback return by `useReactToPrint. The `content` prop will be ignored.'],"warning"),f||"function"!=typeof a||(f=a()),void 0!==f)if(null!==f){var d=document.createElement("iframe");d.width="".concat(document.documentElement.clientWidth,"px"),d.height="".concat(document.documentElement.clientHeight,"px"),d.style.position="absolute",d.style.top="-".concat(document.documentElement.clientHeight+100,"px"),d.style.left="-".concat(document.documentElement.clientWidth+100,"px"),d.id="printWindow",d.srcdoc="<!DOCTYPE html>";var p=(0,i.findDOMNode)(f);if(p){var h=p.cloneNode(!0),y=h instanceof Text,b=document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"),v=y?[]:h.querySelectorAll("img"),g=y?[]:h.querySelectorAll("video"),m=s?s.length:0;t.numResourcesToLoad=b.length+v.length+g.length+m,t.resourcesLoaded=[],t.resourcesErrored=[];var _=function(e,r){t.resourcesLoaded.includes(e)?t.logMessages(["Tried to mark a resource that has already been handled",e],"debug"):(r?(t.logMessages(n.__spreadArray(['"react-to-print" was unable to load a resource but will continue attempting to print the page'],n.__read(r),!1)),t.resourcesErrored.push(e)):t.resourcesLoaded.push(e),t.resourcesLoaded.length+t.resourcesErrored.length===t.numResourcesToLoad&&t.triggerPrint(d))};d.onload=function(){var e,r,i,a;d.onload=null;var f=d.contentDocument||(null===(r=d.contentWindow)||void 0===r?void 0:r.document);if(f){f.body.appendChild(h),s&&((null===(i=d.contentDocument)||void 0===i?void 0:i.fonts)&&(null===(a=d.contentWindow)||void 0===a?void 0:a.FontFace)?s.forEach((function(e){var t=new FontFace(e.family,e.source,{weight:e.weight,style:e.style});d.contentDocument.fonts.add(t),t.loaded.then((function(){_(t)})).catch((function(e){_(t,["Failed loading the font:",t,"Load error:",e])}))})):(s.forEach((function(e){return _(e)})),t.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'])));var b="function"==typeof u?u():u;if("string"!=typeof b)t.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b,'". Styles from `pageStyle` will not be applied.')]);else{var m=f.createElement("style");l&&(m.setAttribute("nonce",l),f.head.setAttribute("nonce",l)),m.appendChild(f.createTextNode(b)),f.head.appendChild(m)}if(o&&(e=f.body.classList).add.apply(e,n.__spreadArray([],n.__read(o.split(" ")),!1)),!y){for(var w=y?[]:p.querySelectorAll("canvas"),P=f.querySelectorAll("canvas"),O=0;O<w.length;++O){var x=w[O],S=P[O].getContext("2d");S&&S.drawImage(x,0,0)}var E=function(e){var t=v[e],r=t.getAttribute("src");if(r){var n=new Image;n.onload=function(){return _(t)},n.onerror=function(e,r,n,o,i){return _(t,["Error loading <img>",t,"Error",i])},n.src=r}else _(t,['Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',t])};for(O=0;O<v.length;O++)E(O);var T=function(e){var t=g[e];t.preload="auto";var r=t.getAttribute("poster");if(r){var n=new Image;n.onload=function(){return _(t)},n.onerror=function(e,n,o,i,a){return _(t,["Error loading video poster",r,"for video",t,"Error:",a])},n.src=r}else t.readyState>=2?_(t):(t.onloadeddata=function(){return _(t)},t.onerror=function(e,r,n,o,i){return _(t,["Error loading video",t,"Error",i])},t.onstalled=function(){return _(t,["Loading video stalled, skipping",t])})};for(O=0;O<g.length;O++)T(O);var j="input",C=p.querySelectorAll(j),A=f.querySelectorAll(j);for(O=0;O<C.length;O++)A[O].value=C[O].value;var k="input[type=checkbox],input[type=radio]",R=p.querySelectorAll(k),M=f.querySelectorAll(k);for(O=0;O<R.length;O++)M[O].checked=R[O].checked;var D="select",I=p.querySelectorAll(D),q=f.querySelectorAll(D);for(O=0;O<I.length;O++)q[O].value=I[O].value}if(c)for(var F=document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']"),W=function(e,r){var n=F[e];if("style"===n.tagName.toLowerCase()){var o=f.createElement(n.tagName),i=n.sheet;if(i){var a="";try{for(var c=i.cssRules.length,s=0;s<c;++s)"string"==typeof i.cssRules[s].cssText&&(a+="".concat(i.cssRules[s].cssText,"\r\n"))}catch(e){t.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",n],"warning")}o.setAttribute("id","react-to-print-".concat(e)),l&&o.setAttribute("nonce",l),o.appendChild(f.createTextNode(a)),f.head.appendChild(o)}}else if(n.getAttribute("href"))if(n.hasAttribute("disabled"))t.logMessages(["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",n],"warning"),_(n);else{for(var u=f.createElement(n.tagName),d=(s=0,n.attributes.length);s<d;++s){var p=n.attributes[s];p&&u.setAttribute(p.nodeName,p.nodeValue||"")}u.onload=function(){return _(u)},u.onerror=function(e,t,r,n,o){return _(u,["Failed to load",u,"Error:",o])},l&&u.setAttribute("nonce",l),f.head.appendChild(u)}else t.logMessages(["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",n],"warning"),_(n)},L=(O=0,F.length);O<L;++O)W(O)}0!==t.numResourcesToLoad&&c||t.triggerPrint(d)},t.handleRemoveIframe(!0),document.body.appendChild(d)}else t.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop'])}else t.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);else t.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"])},t.handleRemoveIframe=function(e){var r=t.props.removeAfterPrint;if(e||r){var n=document.getElementById("printWindow");n&&document.body.removeChild(n)}},t.logMessages=function(e,r){void 0===r&&(r="error"),t.props.suppressErrors||("error"===r?console.error(e):"warning"===r?console.warn(e):"debug"===r&&console.debug(e))},t}return n.__extends(t,e),t.prototype.handleClick=function(e,t){var r=this,n=this.props,o=n.onBeforeGetContent,i=n.onPrintError;if(o){var a=o();a&&"function"==typeof a.then?a.then((function(){return r.handlePrint(t)})).catch((function(e){i&&i("onBeforeGetContent",e)})):this.handlePrint(t)}else this.handlePrint(t)},t.prototype.render=function(){var e=this.props,t=e.children,r=e.trigger;if(r)return o.cloneElement(r(),{onClick:this.handleClick.bind(this)});if(!a.PrintContext)return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']),null;var n={handlePrint:this.handleClick.bind(this)};return o.createElement(a.PrintContext.Provider,{value:n},t)},t.defaultProps=c.defaultProps,t}(o.Component);t.ReactToPrint=s},940:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.defaultProps=void 0,t.defaultProps={copyStyles:!0,pageStyle:"\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",removeAfterPrint:!1,suppressErrors:!1}},892:function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t.useReactToPrint=void 0;var n=r(316),o=r(496),i=r(428),a=r(940),c=r(860),s=Object.prototype.hasOwnProperty.call(o,"useMemo")&&Object.prototype.hasOwnProperty.call(o,"useCallback");t.useReactToPrint=function(e){if(!s)return e.suppressErrors||console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'),function(){throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"')};var t=o.useMemo((function(){return new i.ReactToPrint(n.__assign(n.__assign({},a.defaultProps),e))}),[e]);return o.useCallback((function(e,r){return(0,c.wrapCallbackWithArgs)(t,t.handleClick,r)(e)}),[t])}},860:function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t.wrapCallbackWithArgs=void 0;var n=r(316);t.wrapCallbackWithArgs=function(e,t){for(var r=[],o=2;o<arguments.length;o++)r[o-2]=arguments[o];return function(){for(var o=[],i=0;i<arguments.length;i++)o[i]=arguments[i];return t.apply(e,n.__spreadArray(n.__spreadArray([],n.__read(o),!1),n.__read(r),!1))}}},496:function(t){t.exports=e},190:function(e){e.exports=t},316:function(e,t,r){r.r(t),r.d(t,{__addDisposableResource:function(){return D},__assign:function(){return i},__asyncDelegator:function(){return S},__asyncGenerator:function(){return x},__asyncValues:function(){return E},__await:function(){return O},__awaiter:function(){return h},__classPrivateFieldGet:function(){return k},__classPrivateFieldIn:function(){return M},__classPrivateFieldSet:function(){return R},__createBinding:function(){return b},__decorate:function(){return c},__disposeResources:function(){return q},__esDecorate:function(){return u},__exportStar:function(){return v},__extends:function(){return o},__generator:function(){return y},__importDefault:function(){return A},__importStar:function(){return C},__makeTemplateObject:function(){return T},__metadata:function(){return p},__param:function(){return s},__propKey:function(){return f},__read:function(){return m},__rest:function(){return a},__runInitializers:function(){return l},__setFunctionName:function(){return d},__spread:function(){return _},__spreadArray:function(){return P},__spreadArrays:function(){return w},__values:function(){return g}});var n=function(e,t){return n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])},n(e,t)};function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var i=function(){return i=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},i.apply(this,arguments)};function a(e,t){var r={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(n=Object.getOwnPropertySymbols(e);o<n.length;o++)t.indexOf(n[o])<0&&Object.prototype.propertyIsEnumerable.call(e,n[o])&&(r[n[o]]=e[n[o]])}return r}function c(e,t,r,n){var o,i=arguments.length,a=i<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var c=e.length-1;c>=0;c--)(o=e[c])&&(a=(i<3?o(a):i>3?o(t,r,a):o(t,r))||a);return i>3&&a&&Object.defineProperty(t,r,a),a}function s(e,t){return function(r,n){t(r,n,e)}}function u(e,t,r,n,o,i){function a(e){if(void 0!==e&&"function"!=typeof e)throw new TypeError("Function expected");return e}for(var c,s=n.kind,u="getter"===s?"get":"setter"===s?"set":"value",l=!t&&e?n.static?e:e.prototype:null,f=t||(l?Object.getOwnPropertyDescriptor(l,n.name):{}),d=!1,p=r.length-1;p>=0;p--){var h={};for(var y in n)h[y]="access"===y?{}:n[y];for(var y in n.access)h.access[y]=n.access[y];h.addInitializer=function(e){if(d)throw new TypeError("Cannot add initializers after decoration has completed");i.push(a(e||null))};var b=(0,r[p])("accessor"===s?{get:f.get,set:f.set}:f[u],h);if("accessor"===s){if(void 0===b)continue;if(null===b||"object"!=typeof b)throw new TypeError("Object expected");(c=a(b.get))&&(f.get=c),(c=a(b.set))&&(f.set=c),(c=a(b.init))&&o.unshift(c)}else(c=a(b))&&("field"===s?o.unshift(c):f[u]=c)}l&&Object.defineProperty(l,n.name,f),d=!0}function l(e,t,r){for(var n=arguments.length>2,o=0;o<t.length;o++)r=n?t[o].call(e,r):t[o].call(e);return n?r:void 0}function f(e){return"symbol"==typeof e?e:"".concat(e)}function d(e,t,r){return"symbol"==typeof t&&(t=t.description?"[".concat(t.description,"]"):""),Object.defineProperty(e,"name",{configurable:!0,value:r?"".concat(r," ",t):t})}function p(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function h(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{s(n.next(e))}catch(e){i(e)}}function c(e){try{s(n.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,c)}s((n=n.apply(e,t||[])).next())}))}function y(e,t){var r,n,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(s){return function(c){if(r)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(a=0)),a;)try{if(r=1,n&&(o=2&c[0]?n.return:c[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,c[1])).done)return o;switch(n=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return a.label++,{value:c[1],done:!1};case 5:a.label++,n=c[1],c=[0];continue;case 7:c=a.ops.pop(),a.trys.pop();continue;default:if(!((o=(o=a.trys).length>0&&o[o.length-1])||6!==c[0]&&2!==c[0])){a=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){a.label=c[1];break}if(6===c[0]&&a.label<o[1]){a.label=o[1],o=c;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(c);break}o[2]&&a.ops.pop(),a.trys.pop();continue}c=t.call(e,a)}catch(e){c=[6,e],n=0}finally{r=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,s])}}}var b=Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]};function v(e,t){for(var r in e)"default"===r||Object.prototype.hasOwnProperty.call(t,r)||b(t,e,r)}function g(e){var t="function"==typeof Symbol&&Symbol.iterator,r=t&&e[t],n=0;if(r)return r.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&n>=e.length&&(e=void 0),{value:e&&e[n++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function m(e,t){var r="function"==typeof Symbol&&e[Symbol.iterator];if(!r)return e;var n,o,i=r.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(n=i.next()).done;)a.push(n.value)}catch(e){o={error:e}}finally{try{n&&!n.done&&(r=i.return)&&r.call(i)}finally{if(o)throw o.error}}return a}function _(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(m(arguments[t]));return e}function w(){for(var e=0,t=0,r=arguments.length;t<r;t++)e+=arguments[t].length;var n=Array(e),o=0;for(t=0;t<r;t++)for(var i=arguments[t],a=0,c=i.length;a<c;a++,o++)n[o]=i[a];return n}function P(e,t,r){if(r||2===arguments.length)for(var n,o=0,i=t.length;o<i;o++)!n&&o in t||(n||(n=Array.prototype.slice.call(t,0,o)),n[o]=t[o]);return e.concat(n||Array.prototype.slice.call(t))}function O(e){return this instanceof O?(this.v=e,this):new O(e)}function x(e,t,r){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var n,o=r.apply(e,t||[]),i=[];return n={},a("next"),a("throw"),a("return"),n[Symbol.asyncIterator]=function(){return this},n;function a(e){o[e]&&(n[e]=function(t){return new Promise((function(r,n){i.push([e,t,r,n])>1||c(e,t)}))})}function c(e,t){try{(r=o[e](t)).value instanceof O?Promise.resolve(r.value.v).then(s,u):l(i[0][2],r)}catch(e){l(i[0][3],e)}var r}function s(e){c("next",e)}function u(e){c("throw",e)}function l(e,t){e(t),i.shift(),i.length&&c(i[0][0],i[0][1])}}function S(e){var t,r;return t={},n("next"),n("throw",(function(e){throw e})),n("return"),t[Symbol.iterator]=function(){return this},t;function n(n,o){t[n]=e[n]?function(t){return(r=!r)?{value:O(e[n](t)),done:!1}:o?o(t):t}:o}}function E(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var t,r=e[Symbol.asyncIterator];return r?r.call(e):(e=g(e),t={},n("next"),n("throw"),n("return"),t[Symbol.asyncIterator]=function(){return this},t);function n(r){t[r]=e[r]&&function(t){return new Promise((function(n,o){!function(e,t,r,n){Promise.resolve(n).then((function(t){e({value:t,done:r})}),t)}(n,o,(t=e[r](t)).done,t.value)}))}}}function T(e,t){return Object.defineProperty?Object.defineProperty(e,"raw",{value:t}):e.raw=t,e}var j=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t};function C(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.prototype.hasOwnProperty.call(e,r)&&b(t,e,r);return j(t,e),t}function A(e){return e&&e.__esModule?e:{default:e}}function k(e,t,r,n){if("a"===r&&!n)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof t?e!==t||!n:!t.has(e))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===r?n:"a"===r?n.call(e):n?n.value:t.get(e)}function R(e,t,r,n,o){if("m"===n)throw new TypeError("Private method is not writable");if("a"===n&&!o)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof t?e!==t||!o:!t.has(e))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===n?o.call(e,r):o?o.value=r:t.set(e,r),r}function M(e,t){if(null===t||"object"!=typeof t&&"function"!=typeof t)throw new TypeError("Cannot use 'in' operator on non-object");return"function"==typeof e?t===e:e.has(t)}function D(e,t,r){if(null!=t){if("object"!=typeof t&&"function"!=typeof t)throw new TypeError("Object expected.");var n;if(r){if(!Symbol.asyncDispose)throw new TypeError("Symbol.asyncDispose is not defined.");n=t[Symbol.asyncDispose]}if(void 0===n){if(!Symbol.dispose)throw new TypeError("Symbol.dispose is not defined.");n=t[Symbol.dispose]}if("function"!=typeof n)throw new TypeError("Object not disposable.");e.stack.push({value:t,dispose:n,async:r})}else r&&e.stack.push({async:!0});return t}var I="function"==typeof SuppressedError?SuppressedError:function(e,t,r){var n=new Error(r);return n.name="SuppressedError",n.error=e,n.suppressed=t,n};function q(e){function t(t){e.error=e.hasError?new I(t,e.error,"An error was suppressed during disposal."):t,e.hasError=!0}return function r(){for(;e.stack.length;){var n=e.stack.pop();try{var o=n.dispose&&n.dispose.call(n.value);if(n.async)return Promise.resolve(o).then(r,(function(e){return t(e),r()}))}catch(e){t(e)}}if(e.hasError)throw e.error}()}t.default={__extends:o,__assign:i,__rest:a,__decorate:c,__param:s,__metadata:p,__awaiter:h,__generator:y,__createBinding:b,__exportStar:v,__values:g,__read:m,__spread:_,__spreadArrays:w,__spreadArray:P,__await:O,__asyncGenerator:x,__asyncDelegator:S,__asyncValues:E,__makeTemplateObject:T,__importStar:C,__importDefault:A,__classPrivateFieldGet:k,__classPrivateFieldSet:R,__classPrivateFieldIn:M,__addDisposableResource:D,__disposeResources:q}}},n={};function o(e){var t=n[e];if(void 0!==t)return t.exports;var i=n[e]={exports:{}};return r[e](i,i.exports,o),i.exports}o.d=function(e,t){for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var i={};return function(){var e=i;Object.defineProperty(e,"__esModule",{value:!0}),e.useReactToPrint=e.ReactToPrint=e.PrintContextConsumer=void 0;var t=o(328);Object.defineProperty(e,"PrintContextConsumer",{enumerable:!0,get:function(){return t.PrintContextConsumer}});var r=o(428);Object.defineProperty(e,"ReactToPrint",{enumerable:!0,get:function(){return r.ReactToPrint}});var n=o(892);Object.defineProperty(e,"useReactToPrint",{enumerable:!0,get:function(){return n.useReactToPrint}});var a=o(428);e.default=a.ReactToPrint}(),i}()}));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(315);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Switch; });
/* unused harmony export generatePath */
/* unused harmony export matchPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = __WEBPACK_IMPORTED_MODULE_0_create_react_context___default()();
  context.Provider.displayName = name + ".Provider";
  context.Consumer.displayName = name + ".Consumer";
  return context;
};

var context =
/*#__PURE__*/
createNamedContext('Router');

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevProps.to, location)) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        context = _this$props.context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Route, {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.func
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
// Height JS For Style View
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activities-card-height').css({'height':__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card-container-height').innerHeight()});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','a.changeselecteds',function(event){event.preventDefault();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.left-nav li').find('.selected').removeClass('selected');var $parent=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);$parent.addClass('selected');});});// JS for Filter Click
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.click-me',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".customer-filter").toggle("slow");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".supplier-filter").toggle("slow");});});// JS For Reference Add Image
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.clickme').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.upload-box').toggle(500);return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.clickme1').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.upload-box1').toggle(500);return false;});});// Dynamic Change On Customer-Edit, Supplier-Edit, Manage-Fabric-Edit, Manage-Trims-Edit JS Starts Here
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-add").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().parent().find(".add-site").fadeIn('fast');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().parent().find('.hide-customer-site').hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-add-go-back").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".add-site").hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-site').fadeIn('fast');return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".dept-add").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".add-dept").fadeIn('fast');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-dept').hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".dept-add-go-back").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".add-dept").hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-dept').fadeIn('fast');return false;});// Image Edit JS Starts Here
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".edit-img").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().find(".edit-site").fadeIn('fast');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().find('.hide-customer-site').hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-add-go-back").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".edit-site").hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-site').fadeIn('fast');return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".edit-img1").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".edit-site1").fadeIn('fast');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-site1').hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-add-go-back1").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".edit-site1").hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-site1').fadeIn('fast');return false;});});// Material Selector on ADD Materials JS Starts Here
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#material-selector').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.materials').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-add-go-back").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".materials").hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hide-customer-site').fadeIn('fast');return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#attribute-selector').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#dye-selector').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#style-selector').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.materials').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fabric-ib').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fabric').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#devType-selec').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.development').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sealer-selec').change(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sealer-yard').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".option-open").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".option-con").toggle(100);return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".add-options").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".options-con-open").show();return false;});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".addIB_Order").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().find(".ib-order").show();return false;});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".addIB_Shipment").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().find(".ib-shipment").show();return false;});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sec-close-btn").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().find(".second-address-con").hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".row-add-btn").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".row-address-con").show();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".row-close-btn").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".row-address-con").hide();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".wash-add-btn").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".wash-address-con").show();return false;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".-close-btn").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".row-address-con").hide();return false;});});// Department radio on click Change JS Starts here
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(':radio').change(function(event){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('id');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#'+id).addClass('none').siblings().removeClass('none');});});//Rights JS STARTS HERE
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){// Custom Check-Box
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#check-all').click(function(event){if(this.checked){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(':checkbox').each(function(){this.checked=true;});}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(':checkbox').each(function(){this.checked=false;});}});// Pattern JS
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".open-box").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().find(".show-box").toggle(200);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".clones").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".comparison-con").css("display","block");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".clear-close").click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".comparison-con").css("display","none");});});});/*PRASUN*/__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){var NumberOfDept=0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.clone-box',function(){var id=this.id.substr(9,1);var num=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.size-select-div'+id).length;var newNum=new Number(num+1);var NewSelectBox=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select-div"+id+":last").clone().attr('id','size-select-div'+id+'-'+newNum).appendTo("#multiple-clone-box"+id);NewSelectBox.find("#size-select").attr('id','size-select'+id+'-'+newNum);NewSelectBox.find("#remove-box").attr('id','remove-box'+id+'-'+newNum);NewSelectBox.find(".clone-box").remove();NewSelectBox.find(".remove-box").show();__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-show-box"+id+"-"+newNum).show();__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#remove-box"+id+"-"+newNum).show();});//SELECT SIZE CHANGE
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change','.size-select',function(){var id=this.id.substr(11,1);var selected_option=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select"+id).val();__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select"+id+":selected").attr('disabled','disabled').siblings().removeAttr('disabled');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().parent().find('#size-updater').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<li>').append(selected_option+'<span className="clear-size"><i className="material-icons">clear</i></span>')).trigger('create');//$('#size-updater').append($('<li>').append('A<span className="clear-size"><i className="material-icons">clear</i></span>')).trigger('create');
});var abc=' <li>M <span className="clear-size"><i className="material-icons">clear</i></span></li>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-qty-btn',function(){var id=this.id.substr(11,1);var num=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qty-box'+id).length;var newNum=new Number(num+1);var NewQtyBox=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qty-box"+id+":last").clone().attr('id','qty-box-div'+id+'-'+newNum).appendTo("#multiple-qty-box"+id);NewQtyBox.find("select").css({"width":"76px","float":"left"});NewQtyBox.find(".del-qty-box").show();//NewQtyBox.find(".del-qty-box").attr('id', 'del-qty-box'+id+'-'+newNum);
});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-qty-box',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().remove();});//Shipping Box
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-shipping-btn',function(){var id=this.id.substr(16,1);var num=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.shipping-box'+id).length;var newNum=new Number(num+1);var NewShippingBox=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shipping-box:last").clone().attr('id','shipping-box'+id+'-'+newNum).appendTo("#multiple-shipping-box"+id);NewShippingBox.find('select').css({"float":"left","width":"180px","margin-right":"15px","margin-top":"15px"});NewShippingBox.find(".del-shipping-box").show();NewShippingBox.find(".add-shipping-btn").remove();NewShippingBox.find(".del-shipping-box").css({"margin-top":"13px"});//
});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-shipping-box',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-staff-btn',function(){var id=this.id.substr(13,1);var num=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.staff-box'+id).length;var newNum=new Number(num+1);var NewStaffBox=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#staff-box:last").clone().attr('id','staff-box'+id+'-'+newNum).appendTo("#multiple-staff-box"+id);NewStaffBox.find("input").val('');NewStaffBox.find(".del-staff-btn").show();NewStaffBox.find(".add-staff-btn").hide();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-staff-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().remove();});/*ADDING EMPLOYEE PIC USING FA ICONS */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.input-file-i',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().find(".input-file").trigger('click');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-shipping-info-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.shipping-info-box').length;var newNum=new Number(id+1);var NewShippingBox=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shipping-info-box:last").clone().attr('id','shipping-info-box'+newNum).appendTo("#multiple-shipping-info-box");NewShippingBox.find(".del-shipping-info-box").attr('id','del-customer-info-btn'+newNum);NewShippingBox.find('input').val('');NewShippingBox.find('textarea').val('');NewShippingBox.find(".del-shipping-info-box").show();NewShippingBox.find(".add-shipping-info-btn").hide();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-shipping-info-box',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-up-btn').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({scrollTop:0},'slow');});//COSTING EDIT PAGE
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.ratio-costing-add-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ratio-costing-tr').length;var newNum=new Number(id+1);var NewRatioCostingtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-ratio-costing-tr").clone().attr('id','ratio-costing-tr'+newNum).appendTo("#ratio-costing-tbody");NewRatioCostingtr.find("input").val('');NewRatioCostingtr.find(".ratio-costing-del-btn").show();NewRatioCostingtr.find(".ratio-costing-add-btn").hide();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.ratio-costing-del-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-item-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.item-box').length;var newNum=new Number(id+1);var NewItemtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-item-box:last").clone().attr('id','main-item-box'+newNum).appendTo("#item-box-tbody");NewItemtr.show();NewItemtr.find(".del-item-btn").show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-item-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});// FABRIC ADD ITEMS
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.fab-add-item-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fabric-length').length;var newNum=new Number(id+1);var NewItemtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#fabric-items-add:last").clone().attr('id','fabric-items-add'+newNum).appendTo("#fabric-items");NewItemtr.show();NewItemtr.find(".fab-del-item-btn").show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.fab-del-item-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});// TRIM ADD ITEMS
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.trim-add-item-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.trim-length').length;var newNum=new Number(id+1);var NewItemtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#trim-items-add:last").clone().attr('id','trim-items-add'+newNum).appendTo("#trim-items");NewItemtr.show();NewItemtr.find(".trim-del-item-btn").show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.trim-del-item-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});// Embroidery ADD ITEMS
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.emb-add-item-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emb-length').length;var newNum=new Number(id+1);var NewItemtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#emb-items-add:last").clone().attr('id','emb-items-add'+newNum).appendTo("#emb-items");NewItemtr.show();NewItemtr.find(".emb-del-item-btn").show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.emb-del-item-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});// Embroidery ADD ITEMS
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.wash-add-item-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wash-length').length;var newNum=new Number(id+1);var NewItemtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wash-items-add:last").clone().attr('id','wash-items-add'+newNum).appendTo("#wash-items");NewItemtr.show();NewItemtr.find(".wash-del-item-btn").show();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.wash-del-item-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().remove();});//SAMPLE REQUEST 
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.sample-opt-chckbox',function(){var value=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop("checked")){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#"+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).show();}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#"+__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()).hide();}});//SAMPLE - ADD SIZE AND QTY MULTIPLE
//EMBROIDERY ARRAY LIST ON CLICK 
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.embroideryArray1',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('li:first').toggleClass('selected');});//EMBROIDERY ARRAY LIST 2 
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.embroideryArray2',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('li:first').toggleClass('selected');});//DISPATCH SIZE
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.add-dispatch-size-btn',function(){var id=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-dispatch-size-box').length;var newNum=new Number(id+1);var NewRatioCostingtr=__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-dispatch-size-box").clone().attr('id','main-dispatch-size-box'+newNum).appendTo("#multiple-dispatch-size-box");NewRatioCostingtr.find("input").val('');NewRatioCostingtr.find(".del-dispatch-size-btn").show();NewRatioCostingtr.find(".add-dispatch-size-btn").hide();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.del-dispatch-size-btn',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().parent().parent().parent().remove();});});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(173);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(356);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(355);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(349);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(182);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(126);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(385);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(386);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(129);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(389));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(397);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(399);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(402);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(404);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(189);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(401);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleChange;
//export const Header = 'Header';
function ToggleChange(toggle){return function(dispatch){dispatch({type:'togglechange',payload:toggle});};}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _addClass = _interopRequireDefault(__webpack_require__(184));

var _removeClass = _interopRequireDefault(__webpack_require__(185));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(193));

var _PropTypes = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _reactLifecyclesCompat = __webpack_require__(64);

var _PropTypes = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(64);

var _ChildMapping = __webpack_require__(449);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.load = load;
exports.loadAll = loadAll;
exports.select = select;
exports.save = save;
exports.remove = remove;
exports.setRawCookie = setRawCookie;
exports.plugToRequest = plugToRequest;

var _cookie = __webpack_require__(453);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_NODE = typeof document === 'undefined' || typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_ENV":"production"}) && "production" === 'test';
var _rawCookie = {};
var _res = void 0;

function _isResWritable() {
  return _res && !_res.headersSent;
}

function load(name, doNotParse) {
  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
  var cookieVal = cookies && cookies[name];

  if (typeof doNotParse === 'undefined') {
    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
  }

  if (!doNotParse) {
    try {
      cookieVal = JSON.parse(cookieVal);
    } catch (err) {
      // Not serialized object
    }
  }

  return cookieVal;
}

function loadAll(doNotParse) {
  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
  var cookieVal = cookies;

  if (typeof doNotParse === 'undefined') {
    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
  }

  if (!doNotParse) {
    try {
      cookieVal = JSON.parse(cookieVal);
    } catch (err) {
      // Not serialized object
    }
  }

  return cookieVal;
}

function select(regex) {
  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);

  if (!cookies) {
    return {};
  }

  if (!regex) {
    return cookies;
  }

  return Object.keys(cookies).reduce(function (accumulator, name) {
    if (!regex.test(name)) {
      return accumulator;
    }

    var newCookie = {};
    newCookie[name] = cookies[name];
    return (0, _objectAssign2.default)({}, accumulator, newCookie);
  }, {});
}

function save(name, val, opt) {
  _rawCookie[name] = val;

  // Allow you to work with cookies as objects.
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    _rawCookie[name] = JSON.stringify(val);
  }

  // Cookies only work in the browser
  if (!IS_NODE) {
    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
  }

  if (_isResWritable() && _res.cookie) {
    _res.cookie(name, val, opt);
  }
}

function remove(name, opt) {
  delete _rawCookie[name];

  if (typeof opt === 'undefined') {
    opt = {};
  } else if (typeof opt === 'string') {
    // Will be deprecated in future versions
    opt = { path: opt };
  } else {
    // Prevent mutation of opt below
    opt = (0, _objectAssign2.default)({}, opt);
  }

  if (typeof document !== 'undefined') {
    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
    opt.maxAge = 0;
    document.cookie = _cookie2.default.serialize(name, '', opt);
  }

  if (_isResWritable() && _res.clearCookie) {
    _res.clearCookie(name, opt);
  }
}

function setRawCookie(rawCookie) {
  if (rawCookie) {
    _rawCookie = _cookie2.default.parse(rawCookie);
  } else {
    _rawCookie = {};
  }
}

function plugToRequest(req, res) {
  if (req.cookie) {
    _rawCookie = req.cookie;
  } else if (req.cookies) {
    _rawCookie = req.cookies;
  } else if (req.headers && req.headers.cookie) {
    setRawCookie(req.headers.cookie);
  } else {
    _rawCookie = {};
  }

  _res = res;

  return function unplug() {
    _res = null;
    _rawCookie = {};
  };
}

exports.default = {
  setRawCookie: setRawCookie,
  load: load,
  loadAll: loadAll,
  select: select,
  save: save,
  remove: remove,
  plugToRequest: plugToRequest
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModernDatepicker = __webpack_require__(470);

var _ModernDatepicker2 = _interopRequireDefault(_ModernDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModernDatepicker2.default;

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimePicker__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TimePicker__["a"]; });


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(494);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(47) && !__webpack_require__(81)(function () {
  return Object.defineProperty(__webpack_require__(202)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67);
var document = __webpack_require__(45).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(53);
var toIObject = __webpack_require__(68);
var arrayIndexOf = __webpack_require__(496)(false);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(205);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(100);
var $export = __webpack_require__(65);
var redefine = __webpack_require__(207);
var hide = __webpack_require__(66);
var Iterators = __webpack_require__(144);
var $iterCreate = __webpack_require__(503);
var setToStringTag = __webpack_require__(146);
var getPrototypeOf = __webpack_require__(506);
var ITERATOR = __webpack_require__(69)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(66);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(203);
var hiddenKeys = __webpack_require__(140).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(102);
var createDesc = __webpack_require__(98);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(135);
var has = __webpack_require__(53);
var IE8_DOM_DEFINE = __webpack_require__(201);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(47) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(536), __esModule: true };

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fileType=[{name:"pdf",fileType:"application/pdf"},{name:"audio",fileType:"audio/mp3"},{name:"video",fileType:"video/x-matroska"},{name:"video",fileType:"video/quicktime"},{name:"video",fileType:"video/mp4"},{name:"video",fileType:"video/mpeg"},{name:"video",fileType:"video/x-msvideo"},{name:"video",fileType:"video/x-msvideo"},{name:"zip",fileType:"application/zip"},{name:"sheet",fileType:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},{name:"doc",fileType:"application/msword"},{name:"doc",fileType:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"},{name:"doc",fileType:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"},{name:"doc",fileType:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"},{name:'image',fileType:'image/svg+xml'},{name:'image',fileType:'image/png'},{name:'image',fileType:'image/gif'},{name:'image',fileType:'image/jpeg'}];/* harmony default export */ __webpack_exports__["a"] = (fileType);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Video(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding border-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{controls:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{src:props.src,type:'video/mp4'})));}/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdf.dcd7d659.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/microsoft-word-logo.cc4548fb.png";

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play-button.23f27f91.png";

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_history__ = __webpack_require__(127);
var ButtonCol=function ButtonCol(_ref){var disabled=_ref.disabled,saveFunc=_ref.saveFunc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 profile-btn text-center'},!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Buttons_Button__["a" /* default */],{buttonType:'save',buttonName:'Save',onClick:saveFunc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Buttons_Button__["a" /* default */],{buttonType:'cancel',buttonName:'cancel',history:__WEBPACK_IMPORTED_MODULE_2__containers_history__["a" /* default */]})));};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(105),
    _assign = __webpack_require__(13);

var ReactNoopUpdateQueue = __webpack_require__(228);

var canDefineProperty = __webpack_require__(230);
var emptyObject = __webpack_require__(571);
var invariant = __webpack_require__(106);
var lowPriorityWarning = __webpack_require__(572);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(150);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Buttons_UploadImageButton_UploadImageButton_css__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Buttons_UploadImageButton_UploadImageButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Buttons_UploadImageButton_UploadImageButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileUploadButton=function(_Component){_inherits(FileUploadButton,_Component);function FileUploadButton(){_classCallCheck(this,FileUploadButton);return _possibleConstructorReturn(this,(FileUploadButton.__proto__||Object.getPrototypeOf(FileUploadButton)).apply(this,arguments));}_createClass(FileUploadButton,[{key:'render',value:function render(){var _onChange=this.props.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'file-field upload-btn-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'btn',style:{marginBottom:0,padding:"0px 20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontSize:"10px"}},'Upload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',multiple:true,onChange:function onChange(e){return _onChange(e);}})));}}]);return FileUploadButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FileUploadButton);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _propTypes=__webpack_require__(3),_propTypes2=_interopRequireDefault(_propTypes),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var propTypes={on:_propTypes2.default.bool.isRequired,onClick:_propTypes2.default.func.isRequired,enabled:_propTypes2.default.bool,className:_propTypes2.default.string},defaultProps={enabled:!0,className:'',onDisabledClick:function onDisabledClick(){}};function Switch(a){var b=a.on,c=a.onClick,d=a.onDisabledClick,f=a.enabled,e=a.className,g=a.children,h=['switch',e,b?'on ':'',f?'':'disabled '].join(' ');return _react2.default.createElement('div',{className:h,onClick:function onClick(a){return f?c(a):d(a)}},_react2.default.createElement('div',{className:'switch-toggle',children:g}))}Switch.propTypes=propTypes,Switch.defaultProps=defaultProps,exports.default=Switch;


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JobWork__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullPackage__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(1);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services
var fullPackageTemplate={purpose:null,date:Date.now(),supplierName:null,supplierRef:"",leadTime:null,width:null,currency:"rupee",price:null,MY:"meter",GST:null,transport:null,totalCost:0,currencyData:{},moq:"",default:false,specialComments:""};var SupplierSection=function(_Component){_inherits(SupplierSection,_Component);function SupplierSection(){var _ref,_this$state;var _temp,_this,_ret;_classCallCheck(this,SupplierSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SupplierSection.__proto__||Object.getPrototypeOf(SupplierSection)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={selected:"",currencyOption:[],fullPackageData:[// {
//   purpose: null,
//   date: null,
//   supplierName: null,
//   supplierRef: "",
//   leadTime: null,
//   width: null,
//   currency: "rupee",
//   price: null,
//   MY: "meter",
//   GST: null,
//   transport: null,
//   totalCost: null,
//   currencyData: {},
//   moq: "",
//   default: false,
//   specialComments: ""
// }
],// jobWorkData: [],
isLoading:false,fabricInfo:[],portofpickup:{},jobWorkData:[{rowData:[],default:false,GST:null,moq:"",purpose:null,transport:null,totalLeadTime:null,finishedWidth:null,cuttableWidth:null,totalCost:0,specialComments:""}],USDtoINR:null},_defineProperty(_this$state,"currencyOption",[]),_defineProperty(_this$state,"isLoading",false),_defineProperty(_this$state,"jobWorkSequence",[]),_defineProperty(_this$state,"jobWorkSequenceValue",{}),_defineProperty(_this$state,"disabled",_this.props.disabled),_this$state),_this.componentWillMount=function(){console.log("supply ",_this.props);var _this$props=_this.props,fabricInfo=_this$props.fabricInfo,moduleName=_this$props.moduleName,action=_this$props.action;if(_this.props.fullPackageData.length>0){// console.log("coming in if props")
var fullPackageData=_this.props.fullPackageData;fullPackageData=fullPackageData.map(function(data,i){var dat=Object.assign({},data);dat.purposeLabel=fullPackageData[i].purpose&&fabricInfo&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(purpose){if(purpose.value===_this.props.fullPackageData.purpose){return purpose.label;}});if(data.supplierName!==null&&_typeof(data.supplierName)==="object"&&Object.keys(data.supplierName).length>0){dat.supplierName=dat.supplierName._id;}return dat;});_this.setState({fullPackageData:fullPackageData});}else{// console.log("coming in else props")
var _fullPackageData=[];var fullPackageTemp=Object.assign({},fullPackageTemplate);_fullPackageData.purposeLabel=_fullPackageData.purpose&&fabricInfo&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(purpose){if(purpose.value===_fullPackageData.purpose){return purpose.label;}});fullPackageTemp.GST=fullPackageTemp.GST===null&&_this.props.fabricInfo&&_this.props.fabricInfo.GST&&_this.props.fabricInfo.GST[0]&&_this.props.fabricInfo.GST[0].label?_this.props.fabricInfo.GST[0].label:fullPackageTemp.GST;fullPackageTemp.transport=fullPackageTemp.transport===null&&_this.props.fabricInfo&&_this.props.fabricInfo.TRANSPORT&&_this.props.fabricInfo.TRANSPORT[0]&&_this.props.fabricInfo.TRANSPORT[0].label?_this.props.fabricInfo.TRANSPORT[0].label:fullPackageTemp.transport;_fullPackageData.push(Object.assign({},fullPackageTemp));_this.setState({fullPackageData:_fullPackageData});}var jobWorkSequence=[].concat(_toConsumableArray(_this.state.jobWorkSequence));var jobWorkSequenceValue=Object.assign({},_this.state.jobWorkSequenceValue);fabricInfo&&fabricInfo.PROCESS&&fabricInfo.PROCESS.map(function(data,indexOfFabricInfo){jobWorkSequence.push({key:indexOfFabricInfo+1,value:data.label});jobWorkSequenceValue[indexOfFabricInfo+1]="";});_this.setState({jobWorkSequence:jobWorkSequence,jobWorkSequenceValue:jobWorkSequenceValue,fabricInfo:fabricInfo});if(_this.props.jobWorkData&&_this.props.jobWorkData.length>0){_this.props.jobWorkData&&_this.props.jobWorkData.map(function(data,index){data.purposeLabel=_this.props.jobWorkData[index].purpose&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(purpose){if(purpose.value===_this.props.jobWorkData[index].purpose){return purpose.label;}});});_this.setState({jobWorkData:_this.props.jobWorkData,disabled:_this.props.disabled});}else{var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData[0].purposeLabel=jobWorkData[0].purpose&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(purpose){if(purpose.value===_this.props.jobWorkData[0].purpose){return purpose.label;}});jobWorkData[0].GST=jobWorkData[0].GST===null&&_this.props.fabricInfo&&_this.props.fabricInfo.GST&&_this.props.fabricInfo.GST[0]&&_this.props.fabricInfo.GST[0].label?_this.props.fabricInfo.GST[0].label:null;jobWorkData[0].transport=jobWorkData[0].transport===null&&_this.props.fabricInfo&&_this.props.fabricInfo.TRANSPORT&&_this.props.fabricInfo.TRANSPORT[0]&&_this.props.fabricInfo.TRANSPORT[0].label?_this.props.fabricInfo.TRANSPORT[0].label:null;jobWorkSequence.forEach(function(data,i){var rowData={key:0,process:"",purpose:null,supplierRef:null,supplierName:null,date:Date.now(),currency:"rupee",leadTime:null,width:null,price:null,vl:null,cost:null};jobWorkData[0].rowData.push(rowData);});_this.setState({jobWorkData:jobWorkData});}},_this.addFullPackageCount=function(){var moduleName=_this.props.moduleName;var modulename=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;var fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));var fullPackageTemp=Object.assign({},fullPackageTemplate);__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(modulename).then(function(res){if(res.message==="Operation Successful"){fullPackageTemp.currencyData.freightCosts=res.data.freight;fullPackageTemp.currencyData.clearance=res.data.clearance;fullPackageTemp.currencyData.duty=res.data.duty;fullPackageTemp.GST=res.data.gst;fullPackageTemp.transport=res.data.transport;fullPackageData.push(Object.assign({},fullPackageTemp));var conversionRate=res.data.conversion;_this.setState({fullPackageData:fullPackageData,USDtoINR:conversionRate});}});},_this.updateMoqSupplierSectionHandler=function(name,value,index){var fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));fullPackageData[index][name]=value;_this.setState({fullPackageData:fullPackageData});},_this.updateValueFull=function(name,value,index){var moduleName=_this.props.moduleName;var modulename=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;var fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));fullPackageData[index][name]=value;if(fullPackageData[index].currency==="dollar"){__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(modulename).then(function(res){if(res.message==="Operation Successful"){fullPackageData[index].currencyData={clearance:res.data.clearance,duty:res.data.duty,freightCosts:res.data.freight,shipmentMode:null,portOfPickup:null,shipmentTerm:null,totalOrderQuantity:null,width:null,gsm:null,weightOfFabricPerMtr:null,weightForFullOrder:null,freightRatePerKg:null};_this.setState({fullPackageData:fullPackageData},function(){return _this.updateFullpackageCalc();});}});}else{_this.setState({fullPackageData:fullPackageData},function(){return _this.updateFullpackageCalc();});}},_this.updateINRCurrency=function(e){var USDtoINR=e.target.value;_this.setState({USDtoINR:USDtoINR},function(){return _this.updateFullpackageCalc();});},_this.removeFullPackage=function(index){var fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));fullPackageData.splice(index,1);// fullPackageData = fullPackageData.filter((data, i) => i !== index)
_this.setState({fullPackageData:fullPackageData},function(){return _this.props.getFullPackage(fullPackageData);});},_this._inputForCurrency=function(name,value,index){var fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));if(name==="portOfPickup"){if(value){fullPackageData[index].currencyData[name]=value;}else{fullPackageData[index].currencyData[name]=null;}}else{fullPackageData[index].currencyData[name]=value;}_this.setState({fullPackageData:fullPackageData},function(){return _this.updateFullpackageCalc();});},_this.addJobWork=function(){var moduleName=_this.props.moduleName;moduleName=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));var rowData=[];_this.state.jobWorkSequence.forEach(function(data,i){var rowData1={key:0,process:"",purpose:null,supplierRef:null,supplierName:null,date:Date.now(),currency:"rupee",leadTime:null,width:null,price:null,vl:null,cost:null};rowData.push(rowData1);});__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(moduleName).then(function(res){if(res.message==="Operation Successful"){var item={rowData:[].concat(rowData),default:false,toggle:false,GST:res.data.gst,transport:res.data.transport,totalLeadTime:null,finishedWidth:null,cuttableWidth:null,totalCost:0,specialComments:""};jobWorkData.push(item);_this.setState({jobWorkData:jobWorkData});}});},_this.removeJobWork=function(index){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData.splice(index,1);_this.setState({jobWorkData:jobWorkData},function(){return _this.props.getJobWork(_this.state.jobWorkData);});},_this.addingRow=function(e,index,key){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));var jobWorkSequenceValue=Object.assign({},_this.state.jobWorkSequenceValue);if(e.target.value!==""){jobWorkData[index]["rowData"][key-1]["key"]=_this.state.jobWorkSequence[e.target.value-1].key;jobWorkData[index]["rowData"][key-1]["process"]=_this.state.jobWorkSequence[e.target.value-1].value;}else{jobWorkData[index]["rowData"][key-1]["key"]="";jobWorkData[index]["rowData"][key-1]["process"]="";}jobWorkSequenceValue[key]=e.target.value;_this.setState({jobWorkData:jobWorkData,jobWorkSequenceValue:jobWorkSequenceValue});},_this.updateJobworkRow=function(name,value,index,i){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData[i].rowData[index][name]=value;_this.setState({jobWorkData:jobWorkData},_this.props.getJobWork(jobWorkData),_this.updateJobWorkRowDataTotalCost());},_this.updateJobworkDataKeyValue=function(e,i){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));var nameValue=e.target.name;jobWorkData[i][nameValue]=e.target.value;_this.setState({jobWorkData:jobWorkData},function(){return _this.props.getJobWork(jobWorkData);});},_this.updateValueJob=function(name,value,index){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData[index][name]=value;_this.setState({jobWorkData:jobWorkData});},_this.updateJobWorkRowDataTotalCost=function(){var jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData.map(function(data,i){var totalCost=0;var cost=0;data.rowData.map(function(row,index){if(row.price){var previousprice=cost+Number(row.price);var percentValue=0;// if(index == 0){
//   previousprice = parseInt(row.price)
// }
if(row.vl){var perc=parseInt(row.vl)/100;percentValue=previousprice*perc;}cost=Number(percentValue)+Number(previousprice);jobWorkData[i].rowData[index].cost=__WEBPACK_IMPORTED_MODULE_5__services__["m" /* UtilityService */].round(cost);totalCost=cost;}});if(data.GST){totalCost+=totalCost*(parseInt(data.GST)/100);}if(data.transport){totalCost+=parseInt(data.transport);}jobWorkData[i].totalCost=totalCost.toFixed(3);});_this.setState({jobWorkData:jobWorkData});},_this.updateValueForDefault=function(name,value,index,keyName,data){// let supplierSection = {};
var fullPackageData=void 0,jobWorkData=void 0;if(keyName==="fullpackage"){fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));fullPackageData[index].default=!fullPackageData[index].default;fullPackageData=fullPackageData.map(function(data,i){if(i!==index){data.default=false;}return data;});jobWorkData=_this.state.jobWorkData.map(function(data){data.default=false;return data;});}if(keyName==="jobwork"){jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));jobWorkData[index]["default"]=!jobWorkData[index]["default"];jobWorkData=jobWorkData.map(function(data,i){var dat=Object.assign({},data);if(i!=index){dat["default"]=false;}return dat;});fullPackageData=_this.state.fullPackageData.map(function(data){data.default=false;return data;});}_this.setState({fullPackageData:fullPackageData,jobWorkData:jobWorkData},function(){_this.props.getFullPackage(_this.state.fullPackageData);_this.props.getJobWork(_this.state.jobWorkData);});},_this.createSuppier=function(e){var data={};var supplierSection={};if(_this.state.fullPackageData&&_this.state.fullPackageData.length>0){supplierSection.fullPackageData=[].concat(_toConsumableArray(_this.state.fullPackageData));}if(_this.state.jobWorkData&&_this.state.jobWorkData.length>0){supplierSection.jobWorkData=[].concat(_toConsumableArray(_this.state.jobWorkData));}data._id=_this.props._id;data.supplierSection=supplierSection;if(_this.props.moduleName=="Fabric"){data.toggle=Object.assign({},_this.props.toggle);}if(supplierSection.jobWorkData&&supplierSection.jobWorkData.length>0&&supplierSection.fullPackageData&&supplierSection.fullPackageData.length>0){var count=0;supplierSection.fullPackageData.map(function(datafull){if(datafull.default){count++;}});supplierSection.jobWorkData.map(function(datajob){if(datajob.default){count++;}});if(count>1){_this.props.getalertMessage("error"," Default price must be one ");}else{__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].createSupplierForFabric(data,_this.props.moduleName==="Fabric"?"fabric":_this.props.moduleName==="trims"?"trim":"").then(function(response){if(response.status===200){_this.props.getalertMessage("success"," Supplier created ");}response.status===401&&_this.props.unauthorisedFunc();});}}else{__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].createSupplierForFabric(data,_this.props.moduleName==="Fabric"?"fabric":_this.props.moduleName==="trims"?"trim":"").then(function(response){if(response.status===200){_this.props.getalertMessage("success"," Supplier created ");}response.status===401&&_this.props.unauthorisedFunc();});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SupplierSection,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(this.props.moduleName==="Fabric"&&this.props.scrollSupplier){var fullPackageEle=document.getElementById("fullpackage");fullPackageEle.scrollIntoView({behavior:"smooth",block:"nearest",inline:"start"});}var _props=this.props,fabricInfo=_props.fabricInfo,moduleName=_props.moduleName,action=_props.action;if(action==="add"){if(!!moduleName){var modulename=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(modulename).then(function(res){if(res.message==="Operation Successful"){var fullPackageData=[].concat(_toConsumableArray(_this2.state.fullPackageData));var jobWorkData=[].concat(_toConsumableArray(_this2.state.jobWorkData));for(var i=0;i<fullPackageData.length;i++){fullPackageData[i].currencyData.freightCosts=res.data.freight;fullPackageData[i].currencyData.clearance=res.data.clearance;fullPackageData[i].currencyData.duty=res.data.duty;fullPackageData[i].GST=res.data.gst;fullPackageData[i].transport=res.data.transport;}for(var _i=0;_i<jobWorkData.length;_i++){jobWorkData[_i].GST=res.data.gst;jobWorkData[_i].transport=res.data.transport;}var conversionRate=res.data.conversion;_this2.setState({// supplierPart: {
//   fullpackage: fullPackageData
// },
USDtoINR:conversionRate});}});},1000);}}this.setState({fabricInfo:fabricInfo});if(action==="edit"&&(this.state.USDtoINR===null||this.state.USDtoINR===undefined)){if(!!moduleName){var _modulename=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(_modulename).then(function(res){if(res.message==="Operation Successful"){var fullPackageData=[].concat(_toConsumableArray(_this2.state.fullPackageData));for(var i=0;i<fullPackageData.length;i++){fullPackageData[i].currencyData.freightCosts=fullPackageData[i].currencyData.freightCosts===null?res.data.freight:_this2.state.fullPackageData[i].currencyData.freightCosts;fullPackageData[i].currencyData.clearance=fullPackageData[i].currencyData.clearance===null?res.data.clearance:_this2.state.fullPackageData[i].currencyData.clearance;fullPackageData[i].currencyData.duty=fullPackageData[i].currencyData.duty===null?res.data.duty:_this2.state.fullPackageData[i].currencyData.duty;fullPackageData[i].GST=fullPackageData[i].GST===null?res.data.gst:fullPackageData[i].GST;fullPackageData[i].transport=fullPackageData[i].transport===null?res.data.transport:fullPackageData[i].transport;}var jobWorkData=[].concat(_toConsumableArray(_this2.state.jobWorkData));for(var _i2=0;_i2<jobWorkData.length;_i2++){// jobWorkData[i].currencyData.freightCosts =
//   jobWorkData[i].currencyData.freightCosts === null
//     ? res.data.freight
//     : this.state.jobWorkData[i].currencyData.freightCosts
// jobWorkData[i].currencyData.clearance =
//   jobWorkData[i].currencyData.clearance === null
//     ? res.data.clearance
//     : this.state.jobWorkData[i].currencyData.clearance
// jobWorkData[i].currencyData.duty =
//   jobWorkData[i].currencyData.duty === null
//     ? res.data.duty
//     : this.state.jobWorkData[i].currencyData.duty
jobWorkData[_i2].GST=jobWorkData[_i2].GST===null?res.data.gst:jobWorkData[_i2].GST;jobWorkData[_i2].transport=jobWorkData[_i2].transport===null?res.data.transport:jobWorkData[_i2].transport;}var conversionRate=res.data.conversion;_this2.setState({// supplierPart: {
//   fullpackage: fullPackageData
// },
USDtoINR:conversionRate});}});},1000);}}setTimeout(function(){_this2.updateFullpackageCalc();_this2.props.getJobWork(_this2.state.jobWorkData);},1500);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var supplierSection=nextProps.supplierSection;if(nextProps.supplierSection!=this.props.supplierSection){this.setState({fullPackageData:supplierSection?supplierSection.fullPackageData:null,jobWorkData:supplierSection.jobWorkData});}if(nextProps.fabricInfo!=this.props.fabricInfo){this.setState({fabricInfo:nextProps.fabricInfo});}if(nextProps.fullPackageData&&nextProps.fullPackageData.length>0){// console.log("coming in if nextProps")
var fullPackageData=nextProps.fullPackageData;// console.log(nextProps.fullPackageData)
fullPackageData=fullPackageData.map(function(data){var dat=Object.assign({},data);if(data._id&&data.supplierName!==null&&_typeof(data.supplierName)=="object"&&Object.keys(data.supplierName).length>0){dat.supplierName=dat.supplierName.value;}dat.GST=dat.GST===null&&nextProps.fabricInfo&&nextProps.fabricInfo.GST?nextProps.fabricInfo.GST[0].label:dat.GST;dat.transport=dat.transport===null&&nextProps.fabricInfo&&nextProps.fabricInfo.TRANSPORT?nextProps.fabricInfo.TRANSPORT[0].label:dat.transport;return dat;});this.setState({fullPackageData:fullPackageData});}else{// console.log("coming in else nextProps")
// let fullPackageData = [...this.state.fullPackageData]
// // let fullPackageTemp = { ...fullPackageTemplate }
// console.log(fullPackageData)
// fullPackageData[0].GST =
//   fullPackageData[0].GST === null &&
//   nextProps.fabricInfo &&
//   nextProps.fabricInfo.GST &&
//   nextProps.fabricInfo.GST[0]
//     ? nextProps.fabricInfo.GST[0].label
//     : fullPackageData[0].GST
// fullPackageData[0].transport =
//   fullPackageData[0].transport === null &&
//   nextProps.fabricInfo &&
//   nextProps.fabricInfo.TRANSPORT &&
//   nextProps.fabricInfo.TRANSPORT[0]
//     ? nextProps.fabricInfo.TRANSPORT[0].label
//     : fullPackageData[0].transport
// // fullPackageData.push({ ...fullPackageData })
// this.setState({
//   fullPackageData
// })
var _props2=this.props,fabricInfo=_props2.fabricInfo,moduleName=_props2.moduleName,action=_props2.action;if(!!moduleName){var modulename=moduleName.toLowerCase()==="fabric"?"Fabrics":moduleName.toLowerCase()==="trims"?"Trims":null;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].getSupplierPart(modulename).then(function(res){if(res.message==="Operation Successful"){var _fullPackageData2=[].concat(_toConsumableArray(_this3.state.fullPackageData));var jobWorkData=[].concat(_toConsumableArray(_this3.state.jobWorkData));for(var i=0;i<_fullPackageData2.length;i++){_fullPackageData2[i].currencyData.freightCosts=res.data.freight;_fullPackageData2[i].currencyData.clearance=res.data.clearance;_fullPackageData2[i].currencyData.duty=res.data.duty;_fullPackageData2[i].GST=res.data.gst;_fullPackageData2[i].transport=res.data.transport;}for(var _i3=0;_i3<jobWorkData.length;_i3++){jobWorkData[_i3].GST=res.data.gst;jobWorkData[_i3].transport=res.data.transport;}var conversionRate=res.data.conversion;_this3.setState({// supplierPart: {
//   fullpackage: fullPackageData
// },
USDtoINR:conversionRate});}});},1000);}}if(nextProps.fabricInfo!=this.props.fabricInfo){this.setState({fabricInfo:nextProps.fabricInfo});}if(nextProps.fabricInfo!=this.props.fabricInfo){var _fabricInfo=nextProps.fabricInfo;this.setState({fabricInfo:_fabricInfo});var jobWorkSequence=[].concat(_toConsumableArray(this.state.jobWorkSequence));var jobWorkSequenceValue=Object.assign({},this.state.jobWorkSequenceValue);_fabricInfo&&_fabricInfo.PROCESS&&_fabricInfo.PROCESS.map(function(data,indexOfFabricInfo){jobWorkSequence.push({key:indexOfFabricInfo+1,value:data.label});jobWorkSequenceValue[indexOfFabricInfo+1]="";});this.setState({jobWorkSequence:jobWorkSequence,jobWorkSequenceValue:jobWorkSequenceValue});if(nextProps.jobWorkData&&nextProps.jobWorkData.length>0){var jobWorkData=[].concat(_toConsumableArray(nextProps.jobWorkData));jobWorkData=jobWorkData.map(function(data){var dat=Object.assign({},data);if(_typeof(data.supplierName)=="object"){dat.supplierName=data.supplierName.value;}return dat;});this.setState({jobWorkData:nextProps.jobWorkData,disabled:nextProps.disabled});}else{var _jobWorkData=[].concat(_toConsumableArray(this.state.jobWorkData));_jobWorkData[0].GST=_jobWorkData[0].GST===null&&nextProps.fabricInfo&&nextProps.fabricInfo.GST?nextProps.fabricInfo.GST[0].label:null;_jobWorkData[0].transport=_jobWorkData[0].transport===null&&nextProps.fabricInfo&&nextProps.fabricInfo.TRANSPORT?nextProps.fabricInfo.TRANSPORT[0].label:null;jobWorkSequence.forEach(function(data,i){var rowData={key:0,process:"",purpose:null,supplierRef:null,supplierName:null,date:Date.now(),currency:"rupee",leadTime:null,width:null,price:null,vl:null,cost:null};_jobWorkData[0].rowData.push(rowData);});this.setState({jobWorkData:_jobWorkData});}}}// fullpackage
},{key:"updateFullpackageCalc",value:function updateFullpackageCalc(){var _this4=this;var fullPackageData=[].concat(_toConsumableArray(this.state.fullPackageData));fullPackageData.map(function(data,index){if(fullPackageData[index].currency!=="dollar"){if(fullPackageData[index].price){fullPackageData[index].totalCost=+fullPackageData[index].price;}if(fullPackageData[index].price&&fullPackageData[index].GST&&fullPackageData[index].transport){fullPackageData[index].totalCost=+fullPackageData[index].price+ +(fullPackageData[index].price*(fullPackageData[index].GST/100))+ +fullPackageData[index].transport;fullPackageData[index].totalCost=(fullPackageData[index].totalCost*1).toFixed(3);}}else if(fullPackageData[index].currency=="dollar"){if(fullPackageData[index].price){if(fullPackageData[index].MY=="yard"){fullPackageData[index].currencyData.priceMTS=(fullPackageData[index].price/0.9144).toFixed(3);fullPackageData[index].currencyData.conversionToINR=(fullPackageData[index].currencyData.priceMTS*_this4.state.USDtoINR).toFixed(3);}else if(fullPackageData[index].MY=="meter"){fullPackageData[index].currencyData.priceMTS=fullPackageData[index].price;fullPackageData[index].currencyData.conversionToINR=(fullPackageData[index].currencyData.priceMTS*_this4.state.USDtoINR).toFixed(3);}else if(fullPackageData[index].MY==="gross"){fullPackageData[index].currencyData.priceMTS=Number(fullPackageData[index].price/144).toFixed(3);fullPackageData[index].currencyData.conversionToINR=Number(fullPackageData[index].currencyData.priceMTS*_this4.state.USDtoINR).toFixed(3);}else if(fullPackageData[index].MY==="pcs"||fullPackageData[index].MY==="sets"){fullPackageData[index].currencyData.priceMTS=Number(fullPackageData[index].price).toFixed(3);fullPackageData[index].currencyData.conversionToINR=Number(fullPackageData[index].currencyData.priceMTS*_this4.state.USDtoINR).toFixed(3);}else{fullPackageData[index].currencyData.priceMTS=Number(fullPackageData[index].price).toFixed(3);fullPackageData[index].currencyData.conversionToINR=Number(fullPackageData[index].currencyData.priceMTS*_this4.state.USDtoINR).toFixed(3);}fullPackageData[index].totalCost=(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance+(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance)*(fullPackageData[index].currencyData.duty/100)).toFixed(3);}if(fullPackageData[index].currencyData.shipmentTerm=="FOB"&&fullPackageData[index].currencyData.shipmentMode=="SEA"){if(fullPackageData[index].currencyData.portOfPickup){var portofpickup;_this4.state.fabricInfo.PORTOFPICKUP.map(function(data){if(data.name===fullPackageData[index].currencyData.portOfPickup){portofpickup=data;_this4.setState({portofpickup:data},function(){});fullPackageData[index].currencyData.freightCosts=portofpickup.seaFreightCost;}});fullPackageData[index].totalCost=(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance+(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance)*(fullPackageData[index].currencyData.duty/100)).toFixed(3);}}if(fullPackageData[index].currencyData.shipmentTerm=="CIF"&&fullPackageData[index].currencyData.shipmentMode=="SEA"){if(fullPackageData[index].currencyData.portOfPickup){fullPackageData[index].currencyData.freightCosts=0;}}if(fullPackageData[index].currencyData.shipmentTerm=="FOB"&&fullPackageData[index].currencyData.shipmentMode=="AIR"){fullPackageData[index].currencyData.freightCosts=0;}if(fullPackageData[index].currencyData.width>0&&fullPackageData[index].currencyData.gsm>0){fullPackageData[index].currencyData.weightOfFabricPerMtr=(fullPackageData[index].currencyData.gsm*fullPackageData[index].currencyData.width/40/1000).toFixed(3);}if(fullPackageData[index].currencyData.weightOfFabricPerMtr>0&&fullPackageData[index].currencyData.totalOrderQuantity>0){fullPackageData[index].currencyData.weightForFullOrder=(fullPackageData[index].currencyData.weightOfFabricPerMtr*fullPackageData[index].currencyData.totalOrderQuantity).toFixed(3);}if(fullPackageData[index].currencyData.weightForFullOrder>0){if(fullPackageData[index].currencyData.weightForFullOrder>=500){var portofpickup;if(fullPackageData[index].currencyData.portOfPickup){_this4.state.fabricInfo.PORTOFPICKUP.map(function(data){if(data.name===fullPackageData[index].currencyData.portOfPickup){portofpickup=data;}});}fullPackageData[index].currencyData.freightRatePerKg=portofpickup.freightCostAbove500;if(fullPackageData[index].currencyData.shipmentTerm!=="CIF"&&fullPackageData[index].currencyData.shipmentMode!=="AIR"){fullPackageData[index].currencyData.freightCosts=fullPackageData[index].currencyData.freightRatePerKg*fullPackageData[index].currencyData.weightOfFabricPerMtr;}else{fullPackageData[index].currencyData.freightCosts=0;}}if(fullPackageData[index].currencyData.weightForFullOrder<500){var portofpickup;if(fullPackageData[index].currencyData.portOfPickup){_this4.state.fabricInfo.PORTOFPICKUP.map(function(data){if(data.name===fullPackageData[index].currencyData.portOfPickup){portofpickup=data;}});}fullPackageData[index].currencyData.freightRatePerKg=portofpickup.freightCostBelow500;if(fullPackageData[index].currencyData.shipmentTerm!=="CIF"&&fullPackageData[index].currencyData.shipmentMode!=="AIR"){fullPackageData[index].currencyData.freightCosts=fullPackageData[index].currencyData.freightRatePerKg*fullPackageData[index].currencyData.weightOfFabricPerMtr;}else{fullPackageData[index].currencyData.freightCosts=0;}}fullPackageData[index].totalCost=(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance+(+fullPackageData[index].currencyData.conversionToINR+ +fullPackageData[index].currencyData.freightCosts+ +fullPackageData[index].currencyData.clearance)*(fullPackageData[index].currencyData.duty/100)).toFixed(3);}}});this.setState({fullPackageData:fullPackageData},function(){return _this4.props.getFullPackage(fullPackageData);});}// // //
// job work
//Add job work
//remove JobWork
//updating job work
// updateForDefaultDefault = (name, value, index) => {
//   let jobWorkData = [...this.state.jobWorkData];
//   jobWorkData[index]["default"] = !jobWorkData[index]["default"];
//   jobWorkData = jobWorkData.map((data, i) => {
//     let dat = { ...data };
//     if (i != index) {
//       dat["default"] = false;
//     }
//     return dat;
//   });
//   this.setState({ jobWorkData }, () => {
//     this.props.getFullPackage(this.state.fullPackageData);
//     this.props.getJobWork(jobWorkData);
//   });
// };
// updating calc in job work row data
// ///   ///
// onSubmit = () => { }
//getDataFrom full package component
// getFullPackage = fullPackageData => {
//   this.setState(
//     {
//       fullPackageData
//     },
//     () => this.props.getSupplier(fullPackageData, "fullPackageData")
//   );
// };
// getJobWork = jobWorkData => {
//
//   this.setState(
//     {
//       jobWorkData
//     },
//     () => this.props.getSupplier(jobWorkData, "jobWorkData")
//   );
// };
},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 py-0 px-5",id:"supplierParrt"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-green font-lg font-weight-bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Supplier")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FullPackage__["a" /* default */],{moduleName:this.props.moduleName,action:this.props.action,scrollSupplier:this.props.scrollSupplier,suppliersOption:this.props.suppliersOption,currencyOption:this.state.currencyOption,fullPackageData:this.state.fullPackageData,disabled:this.state.disabled,fabricInfo:this.state.fabricInfo,updateValueForDefault:this.updateValueForDefault,updateValue:this.updateValueFull,addFullPackageCount:this.addFullPackageCount,removeFullPackage:this.removeFullPackage,_inputForCurrency:this._inputForCurrency,updateFullpackageCalc:this.updateFullpackageCalc,updateINRCurrency:this.updateINRCurrency,USDtoINR:this.state.USDtoINR,updateMoqSupplierSectionHandler:this.updateMoqSupplierSectionHandler}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__JobWork__["a" /* default */],{moduleName:this.props.moduleName,suppliersOption:this.props.suppliersOption,currencyOption:this.state.currencyOption,jobWorkData:this.state.jobWorkData,fabricInfo:this.state.fabricInfo,disabled:this.state.disabled,scrollSupplier:this.props.scrollSupplier,jobWorkSequence:this.state.jobWorkSequence,updateValueForDefault:this.updateValueForDefault,updateValue:this.updateValueJob,addJobWork:this.addJobWork,addingRow:this.addingRow,removeJobWork:this.removeJobWork,updateJobWorkRowDataTotalCost:this.updateJobWorkRowDataTotalCost,updateJobworkDataKeyValue:this.updateJobworkDataKeyValue,updateJobworkRow:this.updateJobworkRow}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},!this.props.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:this.createSuppier}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{history:this.props.history,buttonType:"cancel",buttonName:"Cancel"}))));}}]);return SupplierSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SupplierSection);SupplierSection.propTypes={};SupplierSection.defaultProps={};

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_QrCode__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utility_service__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TrimSidebar=function(_Component){_inherits(TrimSidebar,_Component);function TrimSidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TrimSidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TrimSidebar.__proto__||Object.getPrototypeOf(TrimSidebar)).call.apply(_ref,[this].concat(args))),_this),_this.state={number:'',qr:'',image:"",HSN:'',moduleName:'',hsnOptions:[],openmodal:false,disabled:false},_this.openModal=function(e){if(_this.state.image!=""&&e.target.id!='editfile'){_this.setState({openmodal:true});}},_this.onClose=function(){_this.setState({openmodal:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TrimSidebar,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,number=_props.number,qr=_props.qr,image=_props.image,HSN=_props.HSN,handleImageUpload=_props.handleImageUpload,hsnOptions=_props.hsnOptions,moduleName=_props.moduleName,disabled=_props.disabled;this.setState({number:number,qr:qr,image:image,HSN:HSN,handleImageUpload:handleImageUpload,//IMAGE UPLOAD
hsnOptions:hsnOptions,//HSN OPTIONS
moduleName:moduleName,disabled:disabled});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props!==nextProps){var number=nextProps.number,qr=nextProps.qr,image=nextProps.image,HSN=nextProps.HSN,handleImageUpload=nextProps.handleImageUpload,hsnOptions=nextProps.hsnOptions,moduleName=nextProps.moduleName,disabled=nextProps.disabled;this.setState({number:number,qr:qr,image:image,HSN:HSN,handleImageUpload:handleImageUpload,//IMAGE UPLOAD
hsnOptions:hsnOptions,//HSN OPTIONS
moduleName:moduleName,disabled:disabled});}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,number=_state.number,qr=_state.qr,image=_state.image,HSN=_state.HSN,handleImageUpload=_state.handleImageUpload,hsnOptions=_state.hsnOptions,moduleName=_state.moduleName,disabled=_state.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-content-section no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col text-center bg-color padding-bottom-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-green font-lg font-weight-bold mt-2'},number!==null&&number!==''?number:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'opendiv',className:'img-responsive-fill border-1 inputWrapper mt-2',onClick:function onClick(e){return _this2.openModal(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'positioing-end'},!disabled?image!==undefined&&image!==null&&image!==''&&image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'pull-right p-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'editfile',type:'file',className:'fileInputs',accept:'image/*',onChange:function onChange(e){return handleImageUpload(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit icon-fa-color print-hidden'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'pull-right p-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'add',type:'file',className:'fileInputs',accept:'image/*',onChange:function onChange(e){return handleImageUpload(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-circle icon-fa-color print-hidden'})):null),image!==undefined&&image!==null&&image!==''&&image//SHOWING THIS LABEL WHEN FILE WAS'nt uploaded
?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__services_utility_service__["a" /* default */].fileUrl()+image}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex  align-items-center justify-content-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-sm'},'Add ',moduleName,' Image')),!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'positioing-bottom',onClick:function onClick(e){e.stopPropagation(),_this2.props.removeFabricImage();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'pull-right p-1'},image!==undefined&&image!==null&&image!==''&&image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash icon-fa-color print-hidden'}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-2  p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-prepend text-green mr-1'},'HSN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:'select',inputName:'HSN',value:HSN,options:hsnOptions,onChange:this.props.getFabricData,disabled:this.props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'input-group-append text-center d-inline-block ml-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'input-group-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'apply-color-a',href:'https://www.google.com',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-exclamation-circle'})))))),qr!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_QrCode__["a" /* default */],{qr:qr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{open:this.state.openmodal,onClose:this.onClose,center:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].fileUrl()+image})));}}]);return TrimSidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TrimSidebar);/*
DOCUMENTATION
 PROPS:
    heading:''(STRING)





*/

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(72),
    isKey = __webpack_require__(640),
    stringToPath = __webpack_require__(643),
    toString = __webpack_require__(667);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isObject = __webpack_require__(153);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(151);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function FloatMenuList(props){var moduleList=props.moduleList;return moduleList.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"fab-buttons__item",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return props.goToDiv(data);},className:"fab-buttons__link black-color pb-2 px-1 cursor-hover"},data==="cad"&&"3D"||data!=='qc'&&data.charAt(0).toUpperCase()+data.slice(1)||'Grading'));});}/* harmony default export */ __webpack_exports__["a"] = (FloatMenuList);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
function NumberField(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{title:props.value,style:props.style,type:"number",value:props.value,name:props.name,disabled:props.disabled,className:"number-field",onChange:function onChange(e){return props.onChange(e.target.name,e.target.value);}});}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableRowSelect=function(_Component){_inherits(TableRowSelect,_Component);function TableRowSelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TableRowSelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TableRowSelect.__proto__||Object.getPrototypeOf(TableRowSelect)).call.apply(_ref,[this].concat(args))),_this),_this.state={rowData:[],column:{},all:false},_this._handleCheckBox=function(name,value,index){if(name==="all"){var rowData=[].concat(_toConsumableArray(_this.state.rowData));rowData=rowData.map(function(data,index){console.log(data,"datadata");data["checkbox"+index]=true;return data;});_this.setState(_defineProperty({rowData:rowData},name,value),function(){return _this.props.getRowData(_this.state);});}else{var _rowData=[].concat(_toConsumableArray(_this.state.rowData));_rowData[index][name]=value;_this.setState({rowData:_rowData,all:false},function(){return _this.props.getRowData(_this.state);});}},_this._handleColumnCheckbox=function(name,value){var column=Object.assign({},_this.state.column);column[name]=value;_this.setState({column:column},function(){return _this.props.getRowData(_this.state);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TableRowSelect,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,tableHeaderData=_props.tableHeaderData,all=_props.all;var rowData=this.props.rowData;rowData=rowData.map(function(data){var dat=Object.assign({},data);data.checkbox=false;return dat;});var column=Object.assign({},this.state.column);tableHeaderData.map(function(data){column[data.tableKeyName]=true;});this.setState({rowData:rowData,tableHeaderData:tableHeaderData,column:column,all:all});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.rowData!==this.props.rowData){var tableHeaderData=nextProps.tableHeaderData,all=nextProps.all;var rowData=nextProps.rowData;rowData=rowData.map(function(data){var dat=Object.assign({},data);data.checkbox=false;return dat;});var column=Object.assign({},this.state.column);tableHeaderData.map(function(data){column[data.tableKeyName]=true;});this.setState({rowData:rowData,tableHeaderData:tableHeaderData,column:column,all:all});}// if (nextProps.selectedDate != '') {
//     this.setState({ rowData: nextProps.rowData })
// }
}},{key:"render",value:function render(){var _this2=this;var _state=this.state,rowData=_state.rowData,tableHeaderData=_state.tableHeaderData,all=_state.all,column=_state.column;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container table-responsive"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"striped table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"m-0 p-0"},"ALL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkbox",inputName:"all",value:all,onChange:this._handleCheckBox,className:"mx-auto d-flex w-100 justify-content-center"})),tableHeaderData.length>0&&tableHeaderData.map(function(data){return data.tableName!=="_id"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"m-0 p-0"},data.tableName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkbox",inputName:data.tableKeyName,value:column[data.tableKeyName],onChange:_this2._handleColumnCheckbox,className:"mx-auto d-flex w-100 justify-content-center"}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,rowData.length>0&&rowData.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:data._id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"checkbox"+index,value:data["checkbox"+index],index:index,onChange:_this2._handleCheckBox})),tableHeaderData.length>0&&tableHeaderData.map(function(keyName){return keyName.tableKeyName!=="_id"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data[keyName.tableKeyName]!==null&&data[keyName.tableKeyName]);}));}))));}}]);return TableRowSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableRowSelect);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_QrCode__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_magnum_logo_png__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_magnum_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_magnum_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintFabricPage=function(_Component){_inherits(PrintFabricPage,_Component);function PrintFabricPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintFabricPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintFabricPage.__proto__||Object.getPrototypeOf(PrintFabricPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedData:_this.props.selectedData,column:_this.props.column,tableHeaderData:_this.props.tableHeaderData},_this.componentWillReceiveProps=function(props){_this.setState({selectedData:props.selectedData,column:props.column,tableHeaderData:props.tableHeaderData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintFabricPage,[{key:"render",value:function render(){var _state=this.state,selectedData=_state.selectedData,column=_state.column,tableHeaderData=_state.tableHeaderData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"print-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {.w-100{width:100%;}\n             .print-h-w:not(:first-child) { margin-top:7px;}\n              body{font-family: 'Lato', sans-serif;font-size:1rem;}\n              .print-h-w{height:98%;width:100%;border:1px solid black;page-break-after: always; word-wrap: break-word;}\n              .td-border{border-bottom:1px solid black;width:100%;}\n              table > tbody > tr:nth-child(odd){background: transparent;}\n              table > tbody > tr td{font-size:11px;vertical-align:top;padding:0px 0px;max-width:100%;}\n              .border-bl{border:1px solid black;}\n              .text-right{text-align:right}.text-left{text-align:left}.text-center{text-align:center}\n              .text-center{text-align:center;}.f-15{font-size:10px;}.title-main{padding:0px 0px 3px 0px;}.qr-wrap{padding:0px;height:100%}.width-30{width:20%;}.width-70{width:80%;}}"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},selectedData.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overflow print-h-w"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"borderless-table w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"4",className:"text-center td-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title-main"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"MAGNUM CLOTHING PVT LTD")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowspan:"9",className:"qr-wrap text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"600px%",maxWidth:"600px",display:"flex",justifyContent:"center",alignItems:"center",margin:"20px 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"my-2 nopadding border-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_magnum_logo_png___default.a,style:{"width":'60px',height:"60px"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center f-15"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"FABRIC NO")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),val.fabricNumber)),tableHeaderData.map(function(data){if(data.tableKeyName!=="qr"&&data.tableKeyName!=="fabricNumber"){if(column[data.tableKeyName]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"",style:{"padding":"2px 0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.tableName==="CONSTRUCTION"?"CONSTRUCT.":data.tableName,":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:""},val[data.tableKeyName]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:""}," :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:""}," "));}}}))))));}))));}}]);return PrintFabricPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintFabricPage);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_QrCode__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Component
var PrintStylePage=function(_Component){_inherits(PrintStylePage,_Component);function PrintStylePage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintStylePage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintStylePage.__proto__||Object.getPrototypeOf(PrintStylePage)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedData:_this.props.selectedData,column:_this.props.column,tableHeaderData:_this.props.tableHeaderData},_this.componentWillReceiveProps=function(props){_this.setState({selectedData:props.selectedData,column:props.column,tableHeaderData:props.tableHeaderData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintStylePage,[{key:"render",value:function render(){var _state=this.state,selectedData=_state.selectedData,column=_state.column,tableHeaderData=_state.tableHeaderData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"print-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n\n@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');\n\n                .w-100 {\n                  width: 100%;\n                }\n                .print-h-w:not(:first-child) {\n                  margin-top: 0px;\n                }\n                body {\n                  font-family: 'Roboto', sans-serif;\n                  font-size: 10px; \n                }\n                .print-h-w {\n                  box-sizing: border-box;\n                  // max-height: 408px;\n                  height: 99%;\n                  width: 99%;\n                  margin: 0 0 0 10px;\n                  padding: 0;\n                  border: 1px solid black;\n                  page-break-after: always;\n                  word-wrap: break-word;\n                }\n                .td-border {\n                  border-bottom: 1px solid black;\n                  width: 100%;\n                }\n                table > tbody > tr:nth-child(odd) {\n                  background: transparent;\n                }\n                table > tbody > tr td {\n                  font-size: 10px;\n                  vertical-align: top;\n                  padding: 0px!important;\n                  margin: 0px!important;\n                  max-width: 100%;\n                }\n\n                td > p {\n                  padding: 0px!important;\n                  margin: 2.5px 0px 0px 0px!important;\n                }\n                .border-bl {\n                  border: 1px solid black;\n                }\n                .text-right {\n                  text-align: right;\n                }\n                .text-left {\n                  text-align: left;\n                }\n                .text-center {\n                  text-align: center;\n                }\n                .text-center {\n                  text-align: center;\n                }\n                .f-15 {\n                  font-size: 10px;\n                }\n                .title-main {\n                  padding: 0px 0px 3px 0px;\n                }\n                .qr-wrap {\n                  padding: 0px;\n                }\n                .width-30 {\n                  width: 20%;\n                }\n                .width-70 {\n                  width: 80%;\n                }\n\n                .l-height {\n                  line-height: 1.1\n                }\n              }\n              @page {\n                size: 3.98in 1.33in;\n              }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},selectedData&&selectedData.length>0&&selectedData.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overflow print-h-w"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"borderless-table w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"4",className:"text-center td-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title-main",style:{margin:"0",padding:"0",display:"flex",justifyContent:"space-around",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:"0",padding:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"MAGNUM CLOTHING PVT LTD"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:"0",padding:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,column.date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"DATED: ",val.date):""))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0 l-height"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"",style:{width:"60%",paddingRight:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.styleNo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"STYLE NO: "),val.styleNo):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.styleName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"STYLE NAME: "),val.styleName):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.sampleType?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SAMPLE TYPE: "),val.sampleType):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.fabric?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"FABRIC: ")," ",val.fabric.split(",").map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:index},item.trim(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));})):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.size?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SIZE: "),val.size):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.washType?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"WASH TYPE: "),val.washType):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.customer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"CUST/DEPT: "),val.customer):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.cusRef?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"CUST REF NO: "),val.cusRef):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,column.ItemNum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"CUST ITM NO: "),val.ItemNum):""))))))));}))));}}]);return PrintStylePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintStylePage);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=function(_Component){_inherits(Select,_Component);function Select(){_classCallCheck(this,Select);return _possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).apply(this,arguments));}_createClass(Select,[{key:"render",value:function render(){var _props=this.props,options=_props.options,name=_props.name,value=_props.value,onSelect=_props.onSelect,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:name,value:value,onChange:function onChange(e){return onSelect(name,e.target.value);},disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"select"),options!==undefined&&Array.isArray(options)&&options.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:data.value},data.label);}));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Select.defaultProps={options:[],value:"",disabled:false};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ButtonIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ButtonIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{float:"left"},"class":"btn-floating float-btn btn-small waves-effect waves-light add_item"+(props.buttonType=="add"?" green ":" red "),onClick:props.addRemoveFunc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},props.buttonType=="add"?"add":"clear"));}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var AtomicBlockUtils = __webpack_require__(734);

var BlockMapBuilder = __webpack_require__(89);

var CharacterMetadata = __webpack_require__(37);

var CompositeDraftDecorator = __webpack_require__(750);

var ContentBlock = __webpack_require__(58);

var ContentState = __webpack_require__(157);

var DefaultDraftBlockRenderMap = __webpack_require__(159);

var DefaultDraftInlineStyle = __webpack_require__(260);

var DraftEditor = __webpack_require__(751);

var DraftEditorBlock = __webpack_require__(276);

var DraftEntity = __webpack_require__(114);

var DraftModifier = __webpack_require__(21);

var DraftEntityInstance = __webpack_require__(258);

var EditorState = __webpack_require__(10);

var KeyBindingUtil = __webpack_require__(165);

var RawDraftContentState = __webpack_require__(817);

var RichTextEditorUtil = __webpack_require__(287);

var SelectionState = __webpack_require__(115);

var convertFromDraftStateToRaw = __webpack_require__(818);

var convertFromRawToDraftState = __webpack_require__(821);

var generateRandomKey = __webpack_require__(42);

var getDefaultKeyBinding = __webpack_require__(288);

var getVisibleSelectionRect = __webpack_require__(827);

var convertFromHTML = __webpack_require__(285);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,
  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,
  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  RawDraftContentState: RawDraftContentState,
  SelectionState: SelectionState,
  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,
  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
  convertFromHTML: convertFromHTML,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};
module.exports = DraftPublic;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(38);

var generateRandomKey = __webpack_require__(42);

var Immutable = __webpack_require__(8);

var OrderedMap = Immutable.OrderedMap;

var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

  var lastRootBlock;
  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey(); // new key that we will use to build linking

      var key = generateRandomKey(); // we will add it here to re-use it later

      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);

        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);

        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);

        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(37);

var findRangesImmutable = __webpack_require__(90);

var invariant = __webpack_require__(9);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);

  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}
/**
 * Given a list of characters and an offset that is in the middle of an entity,
 * returns the start and end of the entity that is overlapping the offset.
 * Note: This method requires that the offset be in an entity range.
 */


function getRemovalRange(characters, entityKey, offset) {
  var removalRange; // Iterates through a list looking for ranges of matching items
  // based on the 'isEqual' callback.
  // Then instead of returning the result, call the 'found' callback
  // with each range.
  // Then filters those ranges based on the 'filter' callback
  //
  // Here we use it to find ranges of characters with the same entity key.

  findRangesImmutable(characters, // the list to iterate through
  function (a, b) {
    return a.getEntity() === b.getEntity();
  }, // 'isEqual' callback
  function (element) {
    return element.getEntity() === entityKey;
  }, // 'filter' callback
  function (start, end) {
    // 'found' callback
    if (start <= offset && end >= offset) {
      // this entity overlaps the offset index
      removalRange = {
        start: start,
        end: end
      };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);

    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;

      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }

      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetListArg, toInsert, offset) {
  var targetList = targetListArg;

  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }

  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(8);

var Map = Immutable.Map;

function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var ContentBlockNode = __webpack_require__(38);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);

  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * 
 * @typechecks
 * @format
 */

/**
 * Retrieve an object's own values as an array. If you want the values in the
 * protoype chain, too, use getObjectValuesIncludingPrototype.
 *
 * If you are looking for a function that creates an Array instance based
 * on an "Array-like" object, use createArrayFrom instead.
 *
 * @param {object} obj An object.
 * @return {array}     The object's values.
 */
function getOwnObjectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

module.exports = getOwnObjectValues;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @legacyServerCallableInstance
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(8);

var Record = Immutable.Record;
var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});
/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = /*#__PURE__*/function (_DraftEntityInstanceR) {
  _inheritsLoose(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    return _DraftEntityInstanceR.apply(this, arguments) || this;
  }

  var _proto = DraftEntityInstance.prototype;

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getMutability = function getMutability() {
    return this.get('mutability');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },
  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

var isElement = __webpack_require__(60);

function getSelectionOffsetKeyForNode(node) {
  if (isElement(node)) {
    var castedNode = node;
    var offsetKey = castedNode.getAttribute('data-offset-key');

    if (offsetKey) {
      return offsetKey;
    }

    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(castedNode.childNodes[ii]);

      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }

  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getWindowForNode(node) {
  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
    return window;
  }

  return node.ownerDocument.defaultView;
}

module.exports = getWindowForNode;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftJsDebugLogging = __webpack_require__(264);

var EditorState = __webpack_require__(10);

var getContentEditableContainer = __webpack_require__(265);

var getDraftEditorSelection = __webpack_require__(266);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    if (editor._blockSelectEvents) {
      var _editorState = editor.props.editorState;

      var selectionState = _editorState.getSelection();

      DraftJsDebugLogging.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: 'N/A',
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    return;
  }

  var editorState = editor.props.editorState;
  var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }

    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(91);

function getContentEditableContainer(editor) {
  var editorNode = editor.editorContainer;
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !isHTMLElement(editorNode.firstChild) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var htmlElement = editorNode.firstChild;
  return htmlElement;
}

module.exports = getContentEditableContainer;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getDraftEditorSelectionWithNodes = __webpack_require__(267);
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */


function getDraftEditorSelection(editorState, root) {
  var selection = root.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset,
      rangeCount = selection.rangeCount;

  if ( // No active selection.
  rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
  // opening the document.
  anchorNode == null || focusNode == null) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset);
}

module.exports = getDraftEditorSelection;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var findAncestorOffsetKey = __webpack_require__(117);

var getSelectionOffsetKeyForNode = __webpack_require__(261);

var getUpdatedSelectionState = __webpack_require__(268);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(60);

var nullthrows = __webpack_require__(22);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.

  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.

    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}
/**
 * Identify the first leaf descendant for the given node.
 */


function getFirstLeaf(node) {
  while (node.firstChild && ( // data-blocks has no offset
  isElement(node.firstChild) && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Identify the last leaf descendant for the given node.
 */


function getLastLeaf(node) {
  while (node.lastChild && ( // data-blocks has no offset
  isElement(node.lastChild) && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }

  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0; // If the editorRoot is the selection, step downward into the content
  // wrapper.

  if (editorRoot === node) {
    node = node.firstChild;
    !isElement(node) ?  false ? invariant(false, 'Invalid DraftEditorContents node.') : invariant(false) : void 0;
    var castedNode = node; // assignment only added for flow :/
    // otherwise it throws in line 200 saying that node can be null or undefined

    node = castedNode;
    !(node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;

    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  } // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.


  if (childOffset === 0) {
    var key = null;

    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }

    return {
      key: key,
      offset: 0
    };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}
/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */


function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftOffsetKey = __webpack_require__(44);

var nullthrows = __webpack_require__(22);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());

  if (!anchorKey || !focusKey) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  if (!anchorLeaf || !focusLeaf) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;

  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');

    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Provides utilities for handling draftjs keys.
 *
 * @emails oncall+draft_js
 * 
 * @format
 */


function notEmptyKey(key) {
  return key != null && key != '';
}

module.exports = {
  notEmptyKey: notEmptyKey
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(13);

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorTextNode = __webpack_require__(765);

var React = __webpack_require__(0);

var invariant = __webpack_require__(9);

var isHTMLBRElement = __webpack_require__(271);

var setDraftEditorSelection = __webpack_require__(766).setDraftEditorSelection;

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "leaf", void 0);

    return _this;
  }

  var _proto = DraftEditorLeaf.prototype;

  _proto._setSelection = function _setSelection() {
    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _this$props = this.props,
        block = _this$props.block,
        start = _this$props.start,
        text = _this$props.text;
    var blockKey = block.getKey();
    var end = start + text.length;

    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    } // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.


    var node = this.leaf;
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (isHTMLBRElement(child)) {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = this.leaf;
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
    return shouldUpdate;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  _proto.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  _proto.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _this$props2 = this.props,
        customStyleMap = _this$props2.customStyleMap,
        customStyleFn = _this$props2.customStyleFn,
        offsetKey = _this$props2.offsetKey,
        styleSet = _this$props2.styleSet;
    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement("span", {
      "data-offset-key": offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React.createElement(DraftEditorTextNode, null, text));
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(60);

function isHTMLBRElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'BR';
}

module.exports = isHTMLBRElement;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  initODS: function initODS() {},
  handleExtensionCausedError: function handleExtensionCausedError() {}
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc)
/*?DOMElement*/
{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getElementRect = __webpack_require__(772);
/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */


function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks
 */
function getViewportWidth() {
  var width;

  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
}

function getViewportHeight() {
  var height;

  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}
/**
 * Gets the viewport dimensions including any scrollbars.
 */


function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
/**
 * Gets the viewport dimensions excluding any scrollbars.
 */


getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorLeaf = __webpack_require__(270);

var DraftOffsetKey = __webpack_require__(44);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(162);

var Style = __webpack_require__(120);

var UnicodeBidi = __webpack_require__(158);

var UnicodeBidiDirection = __webpack_require__(116);

var cx = __webpack_require__(59);

var getElementPosition = __webpack_require__(274);

var getScrollPosition = __webpack_require__(121);

var getViewportDimensions = __webpack_require__(275);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(91);

var nullthrows = __webpack_require__(22);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */


var DraftEditorBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    return _this;
  }

  var _proto = DraftEditorBlock.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programmatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.preventScroll) {
      return;
    }

    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this._node;

    if (blockNode == null) {
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
      var scrollBottom = pOffset + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves'); // T44088704

      if (leavesForLeafSet.size === 0) {
        return null;
      }

      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get('decoratorKey');

      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var start = leavesForLeafSet.first().get('start');
      var end = leavesForLeafSet.last().get('end');
      var decoratedText = text.slice(start, end);
      var entityKey = block.getEntityAt(leafSet.get('start')); // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
      var commonProps = {
        contentState: _this2.props.contentState,
        decoratedText: decoratedText,
        dir: dir,
        start: start,
        end: end,
        blockKey: blockKey,
        entityKey: entityKey,
        offsetKey: decoratorOffsetKey
      };
      return React.createElement(DecoratorComponent, _extends({}, decoratorProps, commonProps, {
        key: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        direction = _this$props.direction,
        offsetKey = _this$props.offsetKey;
    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });
    return React.createElement("div", {
      "data-offset-key": offsetKey,
      className: className,
      ref: function ref(_ref) {
        return _this3._node = _ref;
      }
    }, this._renderChildren());
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var PhotosMimeType = __webpack_require__(778);

var createArrayFromMixed = __webpack_require__(779);

var emptyFunction = __webpack_require__(278);

var CR_LF_REGEX = new RegExp("\r\n", 'g');
var LF_ONLY = "\n";
var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};
/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */

function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer =
/*#__PURE__*/
function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    this.data = data; // Types could be DOMStringList or array

    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }
  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  var _proto = DataTransfer.prototype;

  _proto.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    } // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.


    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };
  /**
   * Get raw text.
   *
   * @return {?string}
   */


  _proto.getText = function getText() {
    var text;

    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }

    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  _proto.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };
  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  _proto.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };
  /**
   * Get a link url.
   *
   * @return {?string}
   */


  _proto.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }

      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };
  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  _proto.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();

    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;

      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  _proto.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }

    return null;
  };
  /**
   * Get files.
   *
   * @return {array}
   */


  _proto.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  _proto.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

var TEXT_SIZE_UPPER_BOUND = 5000;
/**
 * Extract the text content from a file list.
 */

function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function (
  /*blob*/
  file) {
    readFile(file, function (
    /*string*/
    text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}
/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */


function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var _contents = ''; // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.

    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      _contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }

    callback(_contents);
    return;
  }

  var reader = new FileReader();

  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };

  reader.onerror = function () {
    callback('');
  };

  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getContentStateFragment = __webpack_require__(113);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

var UnicodeUtils = __webpack_require__(61);

var moveSelectionBackward = __webpack_require__(163);

var removeTextWithStrategy = __webpack_require__(92);
/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(23);

var invariant = __webpack_require__(9);

var isChrome = UserAgent.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437

/* eslint-disable consistent-return */

function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;

    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }

    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);

    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }

    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */


var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};
module.exports = getRangeClientRects;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var TokenizeUtil = __webpack_require__(800);

var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.

var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.

var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
module.exports = DraftRemovableWord;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(164);
/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionForward should only be called with a collapsed SelectionState') : void 0;
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset
  });
}

module.exports = moveSelectionForward;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _knownListItemDepthCl;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(37);

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var DefaultDraftBlockRenderMap = __webpack_require__(159);

var DraftEntity = __webpack_require__(114);

var URI = __webpack_require__(810);

var cx = __webpack_require__(59);

var generateRandomKey = __webpack_require__(42);

var getSafeBodyFromHTML = __webpack_require__(286);

var gkx = __webpack_require__(50);

var _require = __webpack_require__(8),
    List = _require.List,
    Map = _require.Map,
    OrderedSet = _require.OrderedSet;

var isHTMLAnchorElement = __webpack_require__(811);

var isHTMLBRElement = __webpack_require__(271);

var isHTMLElement = __webpack_require__(91);

var isHTMLImageElement = __webpack_require__(812);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var NBSP = '&nbsp;';
var SPACE = ' '; // used for replacing characters in HTML

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_LEADING_LF = new RegExp('^\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
var HTMLTagToRawInlineStyleMap = Map({
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE',
  mark: 'HIGHLIGHT'
});

/**
 * Build a mapping from HTML tags to draftjs block types
 * out of a BlockRenderMap.
 *
 * The BlockTypeMap for the default BlockRenderMap looks like this:
 *   Map({
 *     h1: 'header-one',
 *     h2: 'header-two',
 *     h3: 'header-three',
 *     h4: 'header-four',
 *     h5: 'header-five',
 *     h6: 'header-six',
 *     blockquote: 'blockquote',
 *     figure: 'atomic',
 *     pre: ['code-block'],
 *     div: 'unstyled',
 *     p: 'unstyled',
 *     li: ['ordered-list-item', 'unordered-list-item'],
 *   })
 */
var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
  var blockTypeMap = {};
  blockRenderMap.mapKeys(function (blockType, desc) {
    var elements = [desc.element];

    if (desc.aliasedElements !== undefined) {
      elements.push.apply(elements, desc.aliasedElements);
    }

    elements.forEach(function (element) {
      if (blockTypeMap[element] === undefined) {
        blockTypeMap[element] = blockType;
      } else if (typeof blockTypeMap[element] === 'string') {
        blockTypeMap[element] = [blockTypeMap[element], blockType];
      } else {
        blockTypeMap[element].push(blockType);
      }
    });
  });
  return Map(blockTypeMap);
};

var detectInlineStyle = function detectInlineStyle(node) {
  if (isHTMLElement(node)) {
    var element = node; // Currently only used to detect preformatted inline code

    if (element.style.fontFamily.includes('monospace')) {
      return 'CODE';
    }
  }

  return null;
};
/**
 * If we're pasting from one DraftEditor to another we can check to see if
 * existing list item depth classes are being used and preserve this style
 */


var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible link.
 */


var isValidAnchor = function isValidAnchor(node) {
  if (!isHTMLAnchorElement(node)) {
    return false;
  }

  var anchorNode = node;

  if (!anchorNode.href || anchorNode.protocol !== 'http:' && anchorNode.protocol !== 'https:' && anchorNode.protocol !== 'mailto:' && anchorNode.protocol !== 'tel:') {
    return false;
  }

  try {
    // Just checking whether we can actually create a URI
    var _ = new URI(anchorNode.href);

    return true; // We need our catch statements to have arguments, else
    // UglifyJS (which we use for our OSS builds) will crash.
    // eslint-disable-next-line fb-www/no-unused-catch-bindings
  } catch (_) {
    return false;
  }
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible image.
 */


var isValidImage = function isValidImage(node) {
  if (!isHTMLImageElement(node)) {
    return false;
  }

  var imageNode = node;
  return !!(imageNode.attributes.getNamedItem('src') && imageNode.attributes.getNamedItem('src').value);
};
/**
 * Try to guess the inline style of an HTML element based on its css
 * styles (font-weight, font-style and text-decoration).
 */


var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
  if (!isHTMLElement(node)) {
    return style;
  }

  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  return style.withMutations(function (style) {
    if (boldValues.indexOf(fontWeight) >= 0) {
      style.add('BOLD');
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      style.remove('BOLD');
    }

    if (fontStyle === 'italic') {
      style.add('ITALIC');
    } else if (fontStyle === 'normal') {
      style.remove('ITALIC');
    }

    if (textDecoration === 'underline') {
      style.add('UNDERLINE');
    }

    if (textDecoration === 'line-through') {
      style.add('STRIKETHROUGH');
    }

    if (textDecoration === 'none') {
      style.remove('UNDERLINE');
      style.remove('STRIKETHROUGH');
    }
  });
};
/**
 * Determine if a nodeName is a list type, 'ul' or 'ol'
 */


var isListNode = function isListNode(nodeName) {
  return nodeName === 'ul' || nodeName === 'ol';
};
/**
 *  ContentBlockConfig is a mutable data structure that holds all
 *  the information required to build a ContentBlock and an array of
 *  all the child nodes (childConfigs).
 *  It is being used a temporary data structure by the
 *  ContentBlocksBuilder class.
 */


/**
 * ContentBlocksBuilder builds a list of ContentBlocks and an Entity Map
 * out of one (or several) HTMLElement(s).
 *
 * The algorithm has two passes: first it builds a tree of ContentBlockConfigs
 * by walking through the HTML nodes and their children, then it walks the
 * ContentBlockConfigs tree to compute parents/siblings and create
 * the actual ContentBlocks.
 *
 * Typical usage is:
 *     new ContentBlocksBuilder()
 *        .addDOMNode(someHTMLNode)
 *        .addDOMNode(someOtherHTMLNode)
 *       .getContentBlocks();
 *
 */
var ContentBlocksBuilder = /*#__PURE__*/function () {
  // Most of the method in the class depend on the state of the content builder
  // (i.e. currentBlockType, currentDepth, currentEntity etc.). Though it may
  // be confusing at first, it made the code simpler than the alternative which
  // is to pass those values around in every call.
  // The following attributes are used to accumulate text and styles
  // as we are walking the HTML node tree.
  // Describes the future ContentState as a tree of content blocks
  // The content blocks generated from the blockConfigs
  // Entity map use to store links and images found in the HTML nodes
  // Map HTML tags to draftjs block types and disambiguation function
  function ContentBlocksBuilder(blockTypeMap, disambiguate) {
    _defineProperty(this, "characterList", List());

    _defineProperty(this, "currentBlockType", 'unstyled');

    _defineProperty(this, "currentDepth", 0);

    _defineProperty(this, "currentEntity", null);

    _defineProperty(this, "currentText", '');

    _defineProperty(this, "wrapper", null);

    _defineProperty(this, "blockConfigs", []);

    _defineProperty(this, "contentBlocks", []);

    _defineProperty(this, "entityMap", DraftEntity);

    _defineProperty(this, "blockTypeMap", void 0);

    _defineProperty(this, "disambiguate", void 0);

    this.clear();
    this.blockTypeMap = blockTypeMap;
    this.disambiguate = disambiguate;
  }
  /**
   * Clear the internal state of the ContentBlocksBuilder
   */


  var _proto = ContentBlocksBuilder.prototype;

  _proto.clear = function clear() {
    this.characterList = List();
    this.blockConfigs = [];
    this.currentBlockType = 'unstyled';
    this.currentDepth = 0;
    this.currentEntity = null;
    this.currentText = '';
    this.entityMap = DraftEntity;
    this.wrapper = null;
    this.contentBlocks = [];
  }
  /**
   * Add an HTMLElement to the ContentBlocksBuilder
   */
  ;

  _proto.addDOMNode = function addDOMNode(node) {
    var _this$blockConfigs;

    this.contentBlocks = [];
    this.currentDepth = 0; // Converts the HTML node to block config

    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet())); // There might be some left over text in the builder's
    // internal state, if so make a ContentBlock out of it.


    this._trimCurrentText();

    if (this.currentText !== '') {
      this.blockConfigs.push(this._makeBlockConfig());
    } // for chaining


    return this;
  }
  /**
   * Return the ContentBlocks and the EntityMap that corresponds
   * to the previously added HTML nodes.
   */
  ;

  _proto.getContentBlocks = function getContentBlocks() {
    if (this.contentBlocks.length === 0) {
      if (experimentalTreeDataSupport) {
        this._toContentBlocks(this.blockConfigs);
      } else {
        this._toFlatContentBlocks(this.blockConfigs);
      }
    }

    return {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  } // ***********************************WARNING******************************
  // The methods below this line are private - don't call them directly.

  /**
   * Generate a new ContentBlockConfig out of the current internal state
   * of the builder, then clears the internal state.
   */
  ;

  _proto._makeBlockConfig = function _makeBlockConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = config.key || generateRandomKey();

    var block = _objectSpread({
      key: key,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: List(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, config);

    this.characterList = List();
    this.currentBlockType = 'unstyled';
    this.currentText = '';
    return block;
  }
  /**
   * Converts an array of HTML elements to a multi-root tree of content
   * block configs. Some text content may be left in the builders internal
   * state to enable chaining sucessive calls.
   */
  ;

  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
    var blockConfigs = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeName = node.nodeName.toLowerCase();

      if (nodeName === 'body' || isListNode(nodeName)) {
        // body, ol and ul are 'block' type nodes so create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        } // body, ol and ul nodes are ignored, but their children are inlined in
        // the parent block config.


        var wasCurrentDepth = this.currentDepth;
        var wasWrapper = this.wrapper;

        if (isListNode(nodeName)) {
          this.wrapper = nodeName;

          if (isListNode(wasWrapper)) {
            this.currentDepth++;
          }
        }

        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
        this.currentDepth = wasCurrentDepth;
        this.wrapper = wasWrapper;
        continue;
      }

      var blockType = this.blockTypeMap.get(nodeName);

      if (blockType !== undefined) {
        // 'block' type node means we need to create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        }

        var _wasCurrentDepth = this.currentDepth;
        var _wasWrapper = this.wrapper;
        this.wrapper = nodeName === 'pre' ? 'pre' : this.wrapper;

        if (typeof blockType !== 'string') {
          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || 'unstyled';
        }

        if (!experimentalTreeDataSupport && isHTMLElement(node) && (blockType === 'unordered-list-item' || blockType === 'ordered-list-item')) {
          var htmlElement = node;
          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
        }

        var key = generateRandomKey();

        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);

        this._trimCurrentText();

        blockConfigs.push(this._makeBlockConfig({
          key: key,
          childConfigs: childConfigs,
          type: blockType
        }));
        this.currentDepth = _wasCurrentDepth;
        this.wrapper = _wasWrapper;
        continue;
      }

      if (nodeName === '#text') {
        this._addTextNode(node, style);

        continue;
      }

      if (nodeName === 'br') {
        this._addBreakNode(node, style);

        continue;
      }

      if (isValidImage(node)) {
        this._addImgNode(node, style);

        continue;
      }

      if (isValidAnchor(node)) {
        this._addAnchorNode(node, blockConfigs, style);

        continue;
      }

      var newStyle = style;

      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
      }

      newStyle = styleFromNodeAttributes(node, newStyle);
      var inlineStyle = detectInlineStyle(node);

      if (inlineStyle != null) {
        newStyle = newStyle.add(inlineStyle);
      }

      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
    }

    return blockConfigs;
  }
  /**
   * Append a string of text to the internal buffer.
   */
  ;

  _proto._appendText = function _appendText(text, style) {
    var _this$characterList;

    this.currentText += text;
    var characterMetadata = CharacterMetadata.create({
      style: style,
      entity: this.currentEntity
    });
    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
  }
  /**
   * Trim the text in the internal buffer.
   */
  ;

  _proto._trimCurrentText = function _trimCurrentText() {
    var l = this.currentText.length;
    var begin = l - this.currentText.trimLeft().length;
    var end = this.currentText.trimRight().length; // We should not trim whitespaces for which an entity is defined.

    var entity = this.characterList.findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    begin = entity !== undefined ? Math.min(begin, entity[0]) : begin;
    entity = this.characterList.reverse().findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    end = entity !== undefined ? Math.max(end, l - entity[0]) : end;

    if (begin > end) {
      this.currentText = '';
      this.characterList = List();
    } else {
      this.currentText = this.currentText.slice(begin, end);
      this.characterList = this.characterList.slice(begin, end);
    }
  }
  /**
   * Add the content of an HTML text node to the internal state
   */
  ;

  _proto._addTextNode = function _addTextNode(node, style) {
    var text = node.textContent;
    var trimmedText = text.trim(); // If we are not in a pre block and the trimmed content is empty,
    // normalize to a single space.

    if (trimmedText === '' && this.wrapper !== 'pre') {
      text = ' ';
    }

    if (this.wrapper !== 'pre') {
      // Trim leading line feed, which is invisible in HTML
      text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord

      text = text.replace(REGEX_LF, SPACE);
    }

    this._appendText(text, style);
  };

  _proto._addBreakNode = function _addBreakNode(node, style) {
    if (!isHTMLBRElement(node)) {
      return;
    }

    this._appendText('\n', style);
  }
  /**
   * Add the content of an HTML img node to the internal state
   */
  ;

  _proto._addImgNode = function _addImgNode(node, style) {
    if (!isHTMLImageElement(node)) {
      return;
    }

    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);

      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    }); // TODO: T15530363 update this when we remove DraftEntity entirely

    this.currentEntity = this.entityMap.__create('IMAGE', 'IMMUTABLE', entityConfig); // The child text node cannot just have a space or return as content (since
    // we strip those out), unless the image is for presentation only.
    // See https://github.com/facebook/draft-js/issues/231 for some context.

    if (gkx('draftjs_fix_paste_for_img')) {
      if (image.getAttribute('role') !== 'presentation') {
        this._appendText("\uD83D\uDCF7", style);
      }
    } else {
      this._appendText("\uD83D\uDCF7", style);
    }

    this.currentEntity = null;
  }
  /**
   * Add the content of an HTML 'a' node to the internal state. Child nodes
   * (if any) are converted to Block Configs and appended to the provided
   * blockConfig array.
   */
  ;

  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
    // The check has already been made by isValidAnchor but
    // we have to do it again to keep flow happy.
    if (!isHTMLAnchorElement(node)) {
      return;
    }

    var anchor = node;
    var entityConfig = {};
    anchorAttr.forEach(function (attr) {
      var anchorAttribute = anchor.getAttribute(attr);

      if (anchorAttribute) {
        entityConfig[attr] = anchorAttribute;
      }
    });
    entityConfig.url = new URI(anchor.href).toString(); // TODO: T15530363 update this when we remove DraftEntity completely

    this.currentEntity = this.entityMap.__create('LINK', 'MUTABLE', entityConfig || {});
    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
    this.currentEntity = null;
  }
  /**
   * Walk the BlockConfig tree, compute parent/children/siblings,
   * and generate the corresponding ContentBlockNode
   */
  ;

  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var l = blockConfigs.length - 1;

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      config.parent = parent;
      config.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
      config.nextSibling = i < l ? blockConfigs[i + 1].key : null;
      config.children = List(config.childConfigs.map(function (child) {
        return child.key;
      }));
      this.contentBlocks.push(new ContentBlockNode(_objectSpread({}, config)));

      this._toContentBlocks(config.childConfigs, config.key);
    }
  }
  /**
   * Remove 'useless' container nodes from the block config hierarchy, by
   * replacing them with their children.
   */
  ;

  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
    var _this = this;

    var hoisted = List(blockConfigs).flatMap(function (blockConfig) {
      // Don't mess with useful blocks
      if (blockConfig.type !== 'unstyled' || blockConfig.text !== '') {
        return [blockConfig];
      }

      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
    });
    return hoisted;
  } // ***********************************************************************
  // The two methods below are used for backward compatibility when
  // experimentalTreeDataSupport is disabled.

  /**
   * Same as _toContentBlocks but replaces nested blocks by their
   * text content.
   */
  ;

  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
    var _this2 = this;

    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);

    cleanConfigs.forEach(function (config) {
      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config.childConfigs),
          text = _this2$_extractTextFr.text,
          characterList = _this2$_extractTextFr.characterList;

      _this2.contentBlocks.push(new ContentBlock(_objectSpread({}, config, {
        text: config.text + text,
        characterList: config.characterList.concat(characterList)
      })));
    });
  }
  /**
   * Extract the text and the associated inline styles form an
   * array of content block configs.
   */
  ;

  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
    var l = blockConfigs.length - 1;
    var text = '';
    var characterList = List();

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      text += config.text;
      characterList = characterList.concat(config.characterList);

      if (text !== '' && config.type !== 'unstyled') {
        text += '\n';
        characterList = characterList.push(characterList.last());
      }

      var children = this._extractTextFromBlockConfigs(config.childConfigs);

      text += children.text;
      characterList = characterList.concat(children.characterList);
    }

    return {
      text: text,
      characterList: characterList
    };
  };

  return ContentBlocksBuilder;
}();
/**
 * Converts an HTML string to an array of ContentBlocks and an EntityMap
 * suitable to initialize the internal state of a Draftjs component.
 */


var convertFromHTMLToContentBlocks = function convertFromHTMLToContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  // Remove funky characters from the HTML string
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string

  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Build a BlockTypeMap out of the BlockRenderMap


  var blockTypeMap = buildBlockTypeMap(blockRenderMap); // Select the proper block type for the cases where the blockRenderMap
  // uses multiple block types for the same html tag.

  var disambiguate = function disambiguate(tag, wrapper) {
    if (tag === 'li') {
      return wrapper === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
    }

    return null;
  };

  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
};

module.exports = convertFromHTMLToContentBlocks;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(23);

var invariant = __webpack_require__(9);

var isOldIE = UserAgent.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null; // Provides a safe context

  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }

  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var adjustBlockDepthForContentState = __webpack_require__(813);

var nullthrows = __webpack_require__(22);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');

      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');

      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');

      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);

      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    } // First, try to remove a preceding atomic block.


    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });

      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    } // If that doesn't succeed, try to remove the current block style.


    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();

    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();

    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();
    var depth = block.getDepth();

    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.

    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.

    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    } // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.


    var content = editorState.getCurrentContent();
    var newContent; // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.

    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();

    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);

      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }

    return null;
  }
};
module.exports = RichTextEditorUtil;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KeyBindingUtil = __webpack_require__(165);

var Keys = __webpack_require__(119);

var UserAgent = __webpack_require__(23);

var isOSX = UserAgent.isPlatform('Mac OS X'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.

var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;

function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}
/**
 * Get the appropriate undo/redo command for a Z key command.
 */


function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }

  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for PCs on Shift + Delete.
  if (!isOSX && e.shiftKey) {
    return null;
  }

  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }

  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}
/**
 * Retrieve a bound key command for the given event.
 */


function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;

    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;

    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;

    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;

    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;

    case 75:
      // K
      return isOSX && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;

    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;

    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isOSX ? 'secondary-paste' : 'redo';
      }

      return null;

    case 90:
      // Z
      return getZCommand(e) || null;

    case Keys.RETURN:
      return 'split-block';

    case Keys.DELETE:
      return getDeleteCommand(e);

    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
module.exports = DraftStringKey;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertNodeToElement;

var _elementTypes = __webpack_require__(848);

var _elementTypes2 = _interopRequireDefault(_elementTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a htmlparser2 node to a React element
 *
 * @param {Object} node The htmlparser2 node to convert
 * @param {Number} index The index of the current node
 * @param {Function} transform Transform function to apply to children of the node
 * @returns {React.Element}
 */
function convertNodeToElement(node, index, transform) {
  return _elementTypes2.default[node.type](node, index, transform);
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(292);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
    input: true,
    option: true,
    optgroup: true,
    select: true,
    button: true,
    datalist: true,
    textarea: true
};

var openImpliesClose = {
    tr: { tr: true, th: true, td: true },
    th: { th: true },
    td: { thead: true, th: true, td: true },
    body: { head: true, link: true, script: true },
    li: { li: true },
    p: { p: true },
    h1: { p: true },
    h2: { p: true },
    h3: { p: true },
    h4: { p: true },
    h5: { p: true },
    h6: { p: true },
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: { option: true },
    optgroup: { optgroup: true }
};

var voidElements = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};

var foreignContextElements = {
    __proto__: null,
    math: true,
    svg: true
};
var htmlIntegrationElements = {
    __proto__: null,
    mi: true,
    mo: true,
    mn: true,
    ms: true,
    mtext: true,
    "annotation-xml": true,
    foreignObject: true,
    desc: true,
    title: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options) {
    this._options = options || {};
    this._cbs = cbs || {};

    this._tagname = "";
    this._attribname = "";
    this._attribvalue = "";
    this._attribs = null;
    this._stack = [];
    this._foreignContext = [];

    this.startIndex = 0;
    this.endIndex = null;

    this._lowerCaseTagNames =
        "lowerCaseTags" in this._options
            ? !!this._options.lowerCaseTags
            : !this._options.xmlMode;
    this._lowerCaseAttributeNames =
        "lowerCaseAttributeNames" in this._options
            ? !!this._options.lowerCaseAttributeNames
            : !this._options.xmlMode;

    if (this._options.Tokenizer) {
        Tokenizer = this._options.Tokenizer;
    }
    this._tokenizer = new Tokenizer(this._options, this);

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(82)(Parser, __webpack_require__(854).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset) {
    if (this.endIndex === null) {
        if (this._tokenizer._sectionStart <= initialOffset) {
            this.startIndex = 0;
        } else {
            this.startIndex = this._tokenizer._sectionStart - initialOffset;
        }
    } else this.startIndex = this.endIndex + 1;
    this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data) {
    this._updatePosition(1);
    this.endIndex--;

    if (this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name) {
    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    this._tagname = name;

    if (!this._options.xmlMode && name in openImpliesClose) {
        for (
            var el;
            (el = this._stack[this._stack.length - 1]) in
            openImpliesClose[name];
            this.onclosetag(el)
        );
    }

    if (this._options.xmlMode || !(name in voidElements)) {
        this._stack.push(name);
        if (name in foreignContextElements) this._foreignContext.push(true);
        else if (name in htmlIntegrationElements)
            this._foreignContext.push(false);
    }

    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
    if (this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function() {
    this._updatePosition(1);

    if (this._attribs) {
        if (this._cbs.onopentag)
            this._cbs.onopentag(this._tagname, this._attribs);
        this._attribs = null;
    }

    if (
        !this._options.xmlMode &&
        this._cbs.onclosetag &&
        this._tagname in voidElements
    ) {
        this._cbs.onclosetag(this._tagname);
    }

    this._tagname = "";
};

Parser.prototype.onclosetag = function(name) {
    this._updatePosition(1);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }
    
    if (name in foreignContextElements || name in htmlIntegrationElements) {
        this._foreignContext.pop();
    }

    if (
        this._stack.length &&
        (!(name in voidElements) || this._options.xmlMode)
    ) {
        var pos = this._stack.lastIndexOf(name);
        if (pos !== -1) {
            if (this._cbs.onclosetag) {
                pos = this._stack.length - pos;
                while (pos--) this._cbs.onclosetag(this._stack.pop());
            } else this._stack.length = pos;
        } else if (name === "p" && !this._options.xmlMode) {
            this.onopentagname(name);
            this._closeCurrentTag();
        }
    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
        this.onopentagname(name);
        this._closeCurrentTag();
    }
};

Parser.prototype.onselfclosingtag = function() {
    if (
        this._options.xmlMode ||
        this._options.recognizeSelfClosing ||
        this._foreignContext[this._foreignContext.length - 1]
    ) {
        this._closeCurrentTag();
    } else {
        this.onopentagend();
    }
};

Parser.prototype._closeCurrentTag = function() {
    var name = this._tagname;

    this.onopentagend();

    //self-closing tags will be on the top of the stack
    //(cheaper check than in onclosetag)
    if (this._stack[this._stack.length - 1] === name) {
        if (this._cbs.onclosetag) {
            this._cbs.onclosetag(name);
        }
        this._stack.pop();
        
    }
};

Parser.prototype.onattribname = function(name) {
    if (this._lowerCaseAttributeNames) {
        name = name.toLowerCase();
    }
    this._attribname = name;
};

Parser.prototype.onattribdata = function(value) {
    this._attribvalue += value;
};

Parser.prototype.onattribend = function() {
    if (this._cbs.onattribute)
        this._cbs.onattribute(this._attribname, this._attribvalue);
    if (
        this._attribs &&
        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
    ) {
        this._attribs[this._attribname] = this._attribvalue;
    }
    this._attribname = "";
    this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value) {
    var idx = value.search(re_nameEnd),
        name = idx < 0 ? value : value.substr(0, idx);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    return name;
};

Parser.prototype.ondeclaration = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("!" + name, "!" + value);
    }
};

Parser.prototype.onprocessinginstruction = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("?" + name, "?" + value);
    }
};

Parser.prototype.oncomment = function(value) {
    this._updatePosition(4);

    if (this._cbs.oncomment) this._cbs.oncomment(value);
    if (this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value) {
    this._updatePosition(1);

    if (this._options.xmlMode || this._options.recognizeCDATA) {
        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
        if (this._cbs.ontext) this._cbs.ontext(value);
        if (this._cbs.oncdataend) this._cbs.oncdataend();
    } else {
        this.oncomment("[CDATA[" + value + "]]");
    }
};

Parser.prototype.onerror = function(err) {
    if (this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function() {
    if (this._cbs.onclosetag) {
        for (
            var i = this._stack.length;
            i > 0;
            this._cbs.onclosetag(this._stack[--i])
        );
    }
    if (this._cbs.onend) this._cbs.onend();
};

//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function() {
    if (this._cbs.onreset) this._cbs.onreset();
    this._tokenizer.reset();

    this._tagname = "";
    this._attribname = "";
    this._attribs = null;
    this._stack = [];

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data) {
    this.reset();
    this.end(data);
};

Parser.prototype.write = function(chunk) {
    this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk) {
    this._tokenizer.end(chunk);
};

Parser.prototype.pause = function() {
    this._tokenizer.pause();
};

Parser.prototype.resume = function() {
    this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(849);
var entityMap = __webpack_require__(851);
var legacyMap = __webpack_require__(852);
var xmlMap = __webpack_require__(853);

var i = 0;

var TEXT = i++;
var BEFORE_TAG_NAME = i++; //after <
var IN_TAG_NAME = i++;
var IN_SELF_CLOSING_TAG = i++;
var BEFORE_CLOSING_TAG_NAME = i++;
var IN_CLOSING_TAG_NAME = i++;
var AFTER_CLOSING_TAG_NAME = i++;

//attributes
var BEFORE_ATTRIBUTE_NAME = i++;
var IN_ATTRIBUTE_NAME = i++;
var AFTER_ATTRIBUTE_NAME = i++;
var BEFORE_ATTRIBUTE_VALUE = i++;
var IN_ATTRIBUTE_VALUE_DQ = i++; // "
var IN_ATTRIBUTE_VALUE_SQ = i++; // '
var IN_ATTRIBUTE_VALUE_NQ = i++;

//declarations
var BEFORE_DECLARATION = i++; // !
var IN_DECLARATION = i++;

//processing instructions
var IN_PROCESSING_INSTRUCTION = i++; // ?

//comments
var BEFORE_COMMENT = i++;
var IN_COMMENT = i++;
var AFTER_COMMENT_1 = i++;
var AFTER_COMMENT_2 = i++;

//cdata
var BEFORE_CDATA_1 = i++; // [
var BEFORE_CDATA_2 = i++; // C
var BEFORE_CDATA_3 = i++; // D
var BEFORE_CDATA_4 = i++; // A
var BEFORE_CDATA_5 = i++; // T
var BEFORE_CDATA_6 = i++; // A
var IN_CDATA = i++; // [
var AFTER_CDATA_1 = i++; // ]
var AFTER_CDATA_2 = i++; // ]

//special tags
var BEFORE_SPECIAL = i++; //S
var BEFORE_SPECIAL_END = i++; //S

var BEFORE_SCRIPT_1 = i++; //C
var BEFORE_SCRIPT_2 = i++; //R
var BEFORE_SCRIPT_3 = i++; //I
var BEFORE_SCRIPT_4 = i++; //P
var BEFORE_SCRIPT_5 = i++; //T
var AFTER_SCRIPT_1 = i++; //C
var AFTER_SCRIPT_2 = i++; //R
var AFTER_SCRIPT_3 = i++; //I
var AFTER_SCRIPT_4 = i++; //P
var AFTER_SCRIPT_5 = i++; //T

var BEFORE_STYLE_1 = i++; //T
var BEFORE_STYLE_2 = i++; //Y
var BEFORE_STYLE_3 = i++; //L
var BEFORE_STYLE_4 = i++; //E
var AFTER_STYLE_1 = i++; //T
var AFTER_STYLE_2 = i++; //Y
var AFTER_STYLE_3 = i++; //L
var AFTER_STYLE_4 = i++; //E

var BEFORE_ENTITY = i++; //&
var BEFORE_NUMERIC_ENTITY = i++; //#
var IN_NAMED_ENTITY = i++;
var IN_NUMERIC_ENTITY = i++;
var IN_HEX_ENTITY = i++; //X

var j = 0;

var SPECIAL_NONE = j++;
var SPECIAL_SCRIPT = j++;
var SPECIAL_STYLE = j++;

function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();

    if (upper === lower) {
        return function(c) {
            if (c === lower) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    } else {
        return function(c) {
            if (c === lower || c === upper) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    }
}

function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();

    return function(c) {
        if (c === lower || c === upper) {
            this._state = NEXT_STATE;
        } else {
            this._state = IN_TAG_NAME;
            this._index--; //consume the token again
        }
    };
}

function Tokenizer(options, cbs) {
    this._state = TEXT;
    this._buffer = "";
    this._sectionStart = 0;
    this._index = 0;
    this._bufferOffset = 0; //chars removed from _buffer
    this._baseState = TEXT;
    this._special = SPECIAL_NONE;
    this._cbs = cbs;
    this._running = true;
    this._ended = false;
    this._xmlMode = !!(options && options.xmlMode);
    this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c) {
    if (c === "<") {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._state = BEFORE_TAG_NAME;
        this._sectionStart = this._index;
    } else if (
        this._decodeEntities &&
        this._special === SPECIAL_NONE &&
        c === "&"
    ) {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._baseState = TEXT;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeTagName = function(c) {
    if (c === "/") {
        this._state = BEFORE_CLOSING_TAG_NAME;
    } else if (c === "<") {
        this._cbs.ontext(this._getSection());
        this._sectionStart = this._index;
    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
        this._state = TEXT;
    } else if (c === "!") {
        this._state = BEFORE_DECLARATION;
        this._sectionStart = this._index + 1;
    } else if (c === "?") {
        this._state = IN_PROCESSING_INSTRUCTION;
        this._sectionStart = this._index + 1;
    } else {
        this._state =
            !this._xmlMode && (c === "s" || c === "S")
                ? BEFORE_SPECIAL
                : IN_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInTagName = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._emitToken("onopentagname");
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
    if (whitespace(c));
    else if (c === ">") {
        this._state = TEXT;
    } else if (this._special !== SPECIAL_NONE) {
        if (c === "s" || c === "S") {
            this._state = BEFORE_SPECIAL_END;
        } else {
            this._state = TEXT;
            this._index--;
        }
    } else {
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInCloseingTagName = function(c) {
    if (c === ">" || whitespace(c)) {
        this._emitToken("onclosetag");
        this._state = AFTER_CLOSING_TAG_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
    //skip everything until ">"
    if (c === ">") {
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeAttributeName = function(c) {
    if (c === ">") {
        this._cbs.onopentagend();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c === "/") {
        this._state = IN_SELF_CLOSING_TAG;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInSelfClosingTag = function(c) {
    if (c === ">") {
        this._cbs.onselfclosingtag();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateInAttributeName = function(c) {
    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
        this._cbs.onattribname(this._getSection());
        this._sectionStart = -1;
        this._state = AFTER_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterAttributeName = function(c) {
    if (c === "=") {
        this._state = BEFORE_ATTRIBUTE_VALUE;
    } else if (c === "/" || c === ">") {
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (!whitespace(c)) {
        this._cbs.onattribend();
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
    if (c === '"') {
        this._state = IN_ATTRIBUTE_VALUE_DQ;
        this._sectionStart = this._index + 1;
    } else if (c === "'") {
        this._state = IN_ATTRIBUTE_VALUE_SQ;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_VALUE_NQ;
        this._sectionStart = this._index;
        this._index--; //reconsume token
    }
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
    if (c === '"') {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
    if (c === "'") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
    if (whitespace(c) || c === ">") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeDeclaration = function(c) {
    this._state =
        c === "["
            ? BEFORE_CDATA_1
            : c === "-"
                ? BEFORE_COMMENT
                : IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c) {
    if (c === ">") {
        this._cbs.ondeclaration(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateInProcessingInstruction = function(c) {
    if (c === ">") {
        this._cbs.onprocessinginstruction(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeComment = function(c) {
    if (c === "-") {
        this._state = IN_COMMENT;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
    }
};

Tokenizer.prototype._stateInComment = function(c) {
    if (c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c) {
    if (c === "-") {
        this._state = AFTER_COMMENT_2;
    } else {
        this._state = IN_COMMENT;
    }
};

Tokenizer.prototype._stateAfterComment2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncomment(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "-") {
        this._state = IN_COMMENT;
    }
    // else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
    "C",
    BEFORE_CDATA_2,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
    "D",
    BEFORE_CDATA_3,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
    "A",
    BEFORE_CDATA_4,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
    "T",
    BEFORE_CDATA_5,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
    "A",
    BEFORE_CDATA_6,
    IN_DECLARATION
);

Tokenizer.prototype._stateBeforeCdata6 = function(c) {
    if (c === "[") {
        this._state = IN_CDATA;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
        this._index--;
    }
};

Tokenizer.prototype._stateInCdata = function(c) {
    if (c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = function(c) {
    if (c === "]") this._state = AFTER_CDATA_2;
    else this._state = IN_CDATA;
};

Tokenizer.prototype._stateAfterCdata2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncdata(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "]") {
        this._state = IN_CDATA;
    }
    //else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c) {
    if (c === "c" || c === "C") {
        this._state = BEFORE_SCRIPT_1;
    } else if (c === "t" || c === "T") {
        this._state = BEFORE_STYLE_1;
    } else {
        this._state = IN_TAG_NAME;
        this._index--; //consume the token again
    }
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
        this._state = AFTER_SCRIPT_1;
    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
        this._state = AFTER_STYLE_1;
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    BEFORE_SCRIPT_2
);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    BEFORE_SCRIPT_3
);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    BEFORE_SCRIPT_4
);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    BEFORE_SCRIPT_5
);

Tokenizer.prototype._stateBeforeScript5 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_SCRIPT;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 6;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    BEFORE_STYLE_2
);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    BEFORE_STYLE_3
);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    BEFORE_STYLE_4
);

Tokenizer.prototype._stateBeforeStyle4 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_STYLE;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 5;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState(
    "#",
    BEFORE_NUMERIC_ENTITY,
    IN_NAMED_ENTITY
);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
    "X",
    IN_HEX_ENTITY,
    IN_NUMERIC_ENTITY
);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function() {
    //offset = 1
    if (this._sectionStart + 1 < this._index) {
        var entity = this._buffer.substring(
                this._sectionStart + 1,
                this._index
            ),
            map = this._xmlMode ? xmlMap : entityMap;

        if (map.hasOwnProperty(entity)) {
            this._emitPartial(map[entity]);
            this._sectionStart = this._index + 1;
        }
    }
};

//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function() {
    var start = this._sectionStart + 1,
        limit = this._index - start;

    if (limit > 6) limit = 6; //the max length of legacy entities is 6

    while (limit >= 2) {
        //the min length of legacy entities is 2
        var entity = this._buffer.substr(start, limit);

        if (legacyMap.hasOwnProperty(entity)) {
            this._emitPartial(legacyMap[entity]);
            this._sectionStart += limit + 1;
            return;
        } else {
            limit--;
        }
    }
};

Tokenizer.prototype._stateInNamedEntity = function(c) {
    if (c === ";") {
        this._parseNamedEntityStrict();
        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
            this._parseLegacyEntity();
        }
        this._state = this._baseState;
    } else if (
        (c < "a" || c > "z") &&
        (c < "A" || c > "Z") &&
        (c < "0" || c > "9")
    ) {
        if (this._xmlMode);
        else if (this._sectionStart + 1 === this._index);
        else if (this._baseState !== TEXT) {
            if (c !== "=") {
                this._parseNamedEntityStrict();
            }
        } else {
            this._parseLegacyEntity();
        }

        this._state = this._baseState;
        this._index--;
    }
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
    var sectionStart = this._sectionStart + offset;

    if (sectionStart !== this._index) {
        //parse entity
        var entity = this._buffer.substring(sectionStart, this._index);
        var parsed = parseInt(entity, base);

        this._emitPartial(decodeCodePoint(parsed));
        this._sectionStart = this._index;
    } else {
        this._sectionStart--;
    }

    this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(2, 10);
        this._sectionStart++;
    } else if (c < "0" || c > "9") {
        if (!this._xmlMode) {
            this._decodeNumericEntity(2, 10);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._stateInHexEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(3, 16);
        this._sectionStart++;
    } else if (
        (c < "a" || c > "f") &&
        (c < "A" || c > "F") &&
        (c < "0" || c > "9")
    ) {
        if (!this._xmlMode) {
            this._decodeNumericEntity(3, 16);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._cleanup = function() {
    if (this._sectionStart < 0) {
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
    } else if (this._running) {
        if (this._state === TEXT) {
            if (this._sectionStart !== this._index) {
                this._cbs.ontext(this._buffer.substr(this._sectionStart));
            }
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else if (this._sectionStart === this._index) {
            //the section just started
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else {
            //remove everything unnecessary
            this._buffer = this._buffer.substr(this._sectionStart);
            this._index -= this._sectionStart;
            this._bufferOffset += this._sectionStart;
        }

        this._sectionStart = 0;
    }
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".write() after done!"));

    this._buffer += chunk;
    this._parse();
};

Tokenizer.prototype._parse = function() {
    while (this._index < this._buffer.length && this._running) {
        var c = this._buffer.charAt(this._index);
        if (this._state === TEXT) {
            this._stateText(c);
        } else if (this._state === BEFORE_TAG_NAME) {
            this._stateBeforeTagName(c);
        } else if (this._state === IN_TAG_NAME) {
            this._stateInTagName(c);
        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
            this._stateBeforeCloseingTagName(c);
        } else if (this._state === IN_CLOSING_TAG_NAME) {
            this._stateInCloseingTagName(c);
        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
            this._stateAfterCloseingTagName(c);
        } else if (this._state === IN_SELF_CLOSING_TAG) {
            this._stateInSelfClosingTag(c);
        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {

        /*
		*	attributes
		*/
            this._stateBeforeAttributeName(c);
        } else if (this._state === IN_ATTRIBUTE_NAME) {
            this._stateInAttributeName(c);
        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
            this._stateAfterAttributeName(c);
        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
            this._stateBeforeAttributeValue(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
            this._stateInAttributeValueDoubleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
            this._stateInAttributeValueSingleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
            this._stateInAttributeValueNoQuotes(c);
        } else if (this._state === BEFORE_DECLARATION) {

        /*
		*	declarations
		*/
            this._stateBeforeDeclaration(c);
        } else if (this._state === IN_DECLARATION) {
            this._stateInDeclaration(c);
        } else if (this._state === IN_PROCESSING_INSTRUCTION) {

        /*
		*	processing instructions
		*/
            this._stateInProcessingInstruction(c);
        } else if (this._state === BEFORE_COMMENT) {

        /*
		*	comments
		*/
            this._stateBeforeComment(c);
        } else if (this._state === IN_COMMENT) {
            this._stateInComment(c);
        } else if (this._state === AFTER_COMMENT_1) {
            this._stateAfterComment1(c);
        } else if (this._state === AFTER_COMMENT_2) {
            this._stateAfterComment2(c);
        } else if (this._state === BEFORE_CDATA_1) {

        /*
		*	cdata
		*/
            this._stateBeforeCdata1(c);
        } else if (this._state === BEFORE_CDATA_2) {
            this._stateBeforeCdata2(c);
        } else if (this._state === BEFORE_CDATA_3) {
            this._stateBeforeCdata3(c);
        } else if (this._state === BEFORE_CDATA_4) {
            this._stateBeforeCdata4(c);
        } else if (this._state === BEFORE_CDATA_5) {
            this._stateBeforeCdata5(c);
        } else if (this._state === BEFORE_CDATA_6) {
            this._stateBeforeCdata6(c);
        } else if (this._state === IN_CDATA) {
            this._stateInCdata(c);
        } else if (this._state === AFTER_CDATA_1) {
            this._stateAfterCdata1(c);
        } else if (this._state === AFTER_CDATA_2) {
            this._stateAfterCdata2(c);
        } else if (this._state === BEFORE_SPECIAL) {

        /*
		* special tags
		*/
            this._stateBeforeSpecial(c);
        } else if (this._state === BEFORE_SPECIAL_END) {
            this._stateBeforeSpecialEnd(c);
        } else if (this._state === BEFORE_SCRIPT_1) {

        /*
		* script
		*/
            this._stateBeforeScript1(c);
        } else if (this._state === BEFORE_SCRIPT_2) {
            this._stateBeforeScript2(c);
        } else if (this._state === BEFORE_SCRIPT_3) {
            this._stateBeforeScript3(c);
        } else if (this._state === BEFORE_SCRIPT_4) {
            this._stateBeforeScript4(c);
        } else if (this._state === BEFORE_SCRIPT_5) {
            this._stateBeforeScript5(c);
        } else if (this._state === AFTER_SCRIPT_1) {
            this._stateAfterScript1(c);
        } else if (this._state === AFTER_SCRIPT_2) {
            this._stateAfterScript2(c);
        } else if (this._state === AFTER_SCRIPT_3) {
            this._stateAfterScript3(c);
        } else if (this._state === AFTER_SCRIPT_4) {
            this._stateAfterScript4(c);
        } else if (this._state === AFTER_SCRIPT_5) {
            this._stateAfterScript5(c);
        } else if (this._state === BEFORE_STYLE_1) {

        /*
		* style
		*/
            this._stateBeforeStyle1(c);
        } else if (this._state === BEFORE_STYLE_2) {
            this._stateBeforeStyle2(c);
        } else if (this._state === BEFORE_STYLE_3) {
            this._stateBeforeStyle3(c);
        } else if (this._state === BEFORE_STYLE_4) {
            this._stateBeforeStyle4(c);
        } else if (this._state === AFTER_STYLE_1) {
            this._stateAfterStyle1(c);
        } else if (this._state === AFTER_STYLE_2) {
            this._stateAfterStyle2(c);
        } else if (this._state === AFTER_STYLE_3) {
            this._stateAfterStyle3(c);
        } else if (this._state === AFTER_STYLE_4) {
            this._stateAfterStyle4(c);
        } else if (this._state === BEFORE_ENTITY) {

        /*
		* entities
		*/
            this._stateBeforeEntity(c);
        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
            this._stateBeforeNumericEntity(c);
        } else if (this._state === IN_NAMED_ENTITY) {
            this._stateInNamedEntity(c);
        } else if (this._state === IN_NUMERIC_ENTITY) {
            this._stateInNumericEntity(c);
        } else if (this._state === IN_HEX_ENTITY) {
            this._stateInHexEntity(c);
        } else {
            this._cbs.onerror(Error("unknown _state"), this._state);
        }

        this._index++;
    }

    this._cleanup();
};

Tokenizer.prototype.pause = function() {
    this._running = false;
};
Tokenizer.prototype.resume = function() {
    this._running = true;

    if (this._index < this._buffer.length) {
        this._parse();
    }
    if (this._ended) {
        this._finish();
    }
};

Tokenizer.prototype.end = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
    if (chunk) this.write(chunk);

    this._ended = true;

    if (this._running) this._finish();
};

Tokenizer.prototype._finish = function() {
    //if there is remaining data, emit it in a reasonable way
    if (this._sectionStart < this._index) {
        this._handleTrailingData();
    }

    this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function() {
    var data = this._buffer.substr(this._sectionStart);

    if (
        this._state === IN_CDATA ||
        this._state === AFTER_CDATA_1 ||
        this._state === AFTER_CDATA_2
    ) {
        this._cbs.oncdata(data);
    } else if (
        this._state === IN_COMMENT ||
        this._state === AFTER_COMMENT_1 ||
        this._state === AFTER_COMMENT_2
    ) {
        this._cbs.oncomment(data);
    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
        this._parseLegacyEntity();
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(2, 10);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(3, 16);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (
        this._state !== IN_TAG_NAME &&
        this._state !== BEFORE_ATTRIBUTE_NAME &&
        this._state !== BEFORE_ATTRIBUTE_VALUE &&
        this._state !== AFTER_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
        this._state !== IN_CLOSING_TAG_NAME
    ) {
        this._cbs.ontext(data);
    }
    //else, ignore remaining data
    //TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function() {
    Tokenizer.call(
        this,
        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
        this._cbs
    );
};

Tokenizer.prototype.getAbsoluteIndex = function() {
    return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function() {
    return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name) {
    this._cbs[name](this._getSection());
    this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value) {
    if (this._baseState !== TEXT) {
        this._cbs.onattribdata(value); //TODO implement the new event
    } else {
        this._cbs.ontext(value);
    }
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(93);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(294);
var ElementPrototype = __webpack_require__(855);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices && elem){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(857),
	__webpack_require__(865),
	__webpack_require__(866),
	__webpack_require__(867),
	__webpack_require__(868),
	__webpack_require__(869)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
var entities_json_1 = __importDefault(__webpack_require__(297));
var legacy_json_1 = __importDefault(__webpack_require__(861));
var xml_json_1 = __importDefault(__webpack_require__(298));
var decode_codepoint_1 = __importDefault(__webpack_require__(862));
var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
exports.decodeXML = getStrictDecoder(xml_json_1.default);
exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
function getStrictDecoder(map) {
    var replace = getReplacer(map);
    return function (str) { return String(str).replace(strictEntityRe, replace); };
}
var sorter = function (a, b) { return (a < b ? 1 : -1); };
exports.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
    var keys = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
var xml_json_1 = __importDefault(__webpack_require__(298));
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeXML = getASCIIEncoder(inverseXML);
var entities_json_1 = __importDefault(__webpack_require__(297));
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function (str) { return str.codePointAt(0); }
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function (c) {
            return (c.charCodeAt(0) - 0xd800) * 0x400 +
                c.charCodeAt(1) -
                0xdc00 +
                0x10000;
        };
function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
        .toString(16)
        .toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
function escape(data) {
    return data.replace(reEscapeChars, singleCharReplacer);
}
exports.escape = escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
function escapeUTF8(data) {
    return data.replace(xmlReplacer, singleCharReplacer);
}
exports.escapeUTF8 = escapeUTF8;
function getASCIIEncoder(obj) {
    return function (data) {
        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
    };
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(291);
var WritableStream = __webpack_require__(871).Writable;
var StringDecoder = __webpack_require__(872).StringDecoder;
var Buffer = __webpack_require__(301).Buffer;

function Stream(cbs, options) {
    var parser = (this._parser = new Parser(cbs, options));
    var decoder = (this._decoder = new StringDecoder());

    WritableStream.call(this, { decodeStrings: false });

    this.once("finish", function() {
        parser.end(decoder.end());
    });
}

__webpack_require__(82)(Stream, WritableStream);

Stream.prototype._write = function(chunk, encoding, cb) {
    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
    this._parser.write(chunk);
    cb();
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(874)
var ieee754 = __webpack_require__(875)
var isArray = __webpack_require__(876)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = generatePropsFromAttributes;

var _htmlAttributesToReact = __webpack_require__(881);

var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);

var _inlineStyleToObject = __webpack_require__(884);

var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates props for a React element from an object of HTML attributes
 *
 * @param {Object} attributes The HTML attributes
 * @param {String} key The key to give the react element
 */
function generatePropsFromAttributes(attributes, key) {

  // generate props
  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });

  // if there is an inline/string style prop then convert it to a React style object
  // otherwise, it is invalid and omitted
  if (typeof props.style === 'string' || props.style instanceof String) {
    props.style = (0, _inlineStyleToObject2.default)(props.style);
  } else {
    delete props.style;
  }

  return props;
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidTagOrAttributeName;
var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;

var nameCache = {};

function isValidTagOrAttributeName(tagName) {
  if (!nameCache.hasOwnProperty(tagName)) {
    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
  }
  return nameCache[tagName];
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatch__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__dispatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__custOutstanding__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__custOutstanding__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bNumber__ = __webpack_require__(895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__bNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fabricPricePending__ = __webpack_require__(896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__fabricPricePending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fabricLibraryList__ = __webpack_require__(957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__fabricLibraryList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sampleLibraryList__ = __webpack_require__(958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__sampleLibraryList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__processCompleted__ = __webpack_require__(959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__processCompleted__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printYarn__ = __webpack_require__(960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__printYarn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__processUpdates__ = __webpack_require__(961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__processUpdates__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sampleReportByProcessesList__ = __webpack_require__(962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__sampleReportByProcessesList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__patternMaster__ = __webpack_require__(963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__patternMaster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StyleDownloadsList__ = __webpack_require__(964);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__StyleDownloadsList__["a"]; });


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DispatchForm__ = __webpack_require__(897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__DispatchForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustOutstandingForm__ = __webpack_require__(943);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__CustOutstandingForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FabricForm__ = __webpack_require__(944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__FabricForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FabricPricePending__ = __webpack_require__(945);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__FabricPricePending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FabricLibrary__ = __webpack_require__(946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__FabricLibrary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BNumber__ = __webpack_require__(947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__BNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SampleLibrary__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__SampleLibrary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BulkUpdateForDispatch__ = __webpack_require__(949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__BulkUpdateForDispatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProcessCompletedForm__ = __webpack_require__(950);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__ProcessCompletedForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrintYarnForm__ = __webpack_require__(951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__PrintYarnForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProcessUpdatesForm__ = __webpack_require__(952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__ProcessUpdatesForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SampleReportByProcesses__ = __webpack_require__(953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__SampleReportByProcesses__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PatternMaster__ = __webpack_require__(954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__PatternMaster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BulkProcessUpdates__ = __webpack_require__(955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__BulkProcessUpdates__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StyleDownloads__ = __webpack_require__(956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__StyleDownloads__["a"]; });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(908),
    arraySome = __webpack_require__(911),
    cacheHas = __webpack_require__(912);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(43),
    stubFalse = __webpack_require__(929);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(930),
    baseUnary = __webpack_require__(931),
    nodeUtil = __webpack_require__(932);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosize__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_time_picker__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rc_time_picker_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sampleMobileApp_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sampleMobileApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__sampleMobileApp_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import React, { Component } from 'react'
// import "./sampleMobileApp.css";
// export default class Field extends Component {
//     state = {
//         inputname: "",
//         label: "",
//         inputType: "",
//         inputSizeClass: "",
//         options: [],
//         value: "",
//         index: "",
//         readOnly: false,
//     }
//     componentDidMount() {
//         const { inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly } = this.props;
//         this.setState({
//             inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly
//         })
//     }
//     static getDerivedStateFromProps(nextProps, prevState) {
//         return {
//             ...prevState,
//             ...nextProps
//         };
//     }
//     render() {
//         const { inputname, label, inputType, inputSizeClass, options, onChange, value, index, readOnly, maxLength } = this.props;
//         var inputField = undefined;
//         switch (inputType) {
//             case 'text':
//                 inputField = <input type={inputType} name={inputname}  value={value} maxLength={maxLength}
//                     disabled={readOnly}
//                     onChange={(e) => onChange(inputname, e.target.value, index)} className="input1" />
//                 break;
//             case 'number':
//                 inputField = <input type={inputType} name={inputname}  value={value}
//                     disabled={readOnly}
//                     onChange={(e) => onChange(inputname, e.target.value, index)} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} />
//                 break;
//             case 'select':
//                 inputField = <select name="" id="" onChange={(e) => onChange(inputname, e.target.value, index)}
//                     disabled={readOnly}
//                     value={value}
//                     className="dropdown1">
//                     <option value="">select</option>
//                     {options.map((data, i) => <option value={data.value}>{data.label}</option>)}
//                 </select>
//                 break;
//             case 'readonly':
//                 inputField = <input type={inputType} name={inputname} disabled="disabled"  />
//                 break;
//             case 'file':
//                 inputField = <button >
//                     {/* className="primary upload-btn" */}
//                     <input type={inputType} name={inputname} onChange={(e) => onChange(e)} multiple />
//                     <div>{value}</div>
//                 </button>
//                 break;
//             case 'button':
//                 inputField = <button className="primary">
//                     <div>{value}</div>
//                 </button>
//                 break;
//             case "checkboxToggle":
//                 inputField = (
//                     <div class={`switch switch-mod`}>
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 class=""
//                                 name={inputname}
//                                 value={value}
//                                 checked={value}
//                                 disabled={readOnly}
//                                 onChange={e => onChange(inputname, e.target.checked, index)}
//                             />
//                             <span class="lever" />
//                         </label>
//                         {value && <span class="pr-2 font-apply-li">Active</span>}
//                         {!value && <span class="pl-2 font-apply-li">In-active</span>}
//                     </div>
//                 )
//                 break
//             default:
//                 inputField = <input type="name" className="form-control" />
//         }
//         return (
//                 <div className="select-qr1">
//                                     {/* <span className="label1">Completed Date</span> */}
//                                     {/* <select class="dropdown1" >
//                                     <option value="option1">Option 1</option>
//                                     <option value="option2">Option 2</option>
//                                     </select> */}
//                                     <span className="label1">{label}</span>
//                                     {inputField}
//                                 </div>
//         )
//     }
// }
var Field=function(_Component){_inherits(Field,_Component);function Field(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Field);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Field.__proto__||Object.getPrototypeOf(Field)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Field,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_autosize___default()(document.querySelectorAll("textarea"));var textArea=document.querySelector("textarea");if(textArea){textArea.style.overflow='hidden';textArea.style.height='0px';textArea.style.height=textArea.scrollHeight+'px';}}},{key:"render",value:function render(){var _props=this.props,inputName=_props.inputName,placeholder=_props.placeholder,label=_props.label,inputType=_props.inputType,options=_props.options,_onChange=_props.onChange,onInput=_props.onInput,value=_props.value,disabled=_props.disabled,isFormGroup=_props.isFormGroup,index=_props.index,i=_props.i,max=_props.max,className=_props.className,checked=_props.checked,size=_props.size,style=_props.style;var inputField=undefined;switch(inputType){case"text":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{style:this.props.style,type:inputType,name:inputName,title:value,value:value,disabled:disabled,placeholder:placeholder,maxLength:max,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);},className:"input1"});break;case"password":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputName,className:"form-control "+className,value:value,disabled:disabled,placeholder:placeholder,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);}});break;case"number":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{style:this.props.style,type:inputType,name:inputName,className:"input1",value:value,disabled:disabled,min:0,maxLength:max,placeholder:placeholder,size:size,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);}});break;case"select":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{title:this.props.title,style:this.props.style,onChange:function onChange(e){return _onChange(inputName,e.target.value,index,i);},onSelect:function onSelect(e){return onInput(inputName,e.target.value,index,i);},disabled:disabled,name:inputName,value:value,className:"dropdown1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:"",value:"",selected:true},"--select--"),options!==undefined&&Array.isArray(options)&&options.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:i,value:data.value,disabled:Object(__WEBPACK_IMPORTED_MODULE_8_util__["isBoolean"])(data.disabled)?!data.disabled:false},data.label);}));break;case"checkbox":var uniqueName=inputName;inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":className?"manage_permissions emb-chck "+className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox","class":"filled-in",id:uniqueName,name:uniqueName,value:value,checked:value,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.checked,index,i);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":uniqueName,"class":"font-apply-li"},label));break;case"checkboxToggle":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"switch switch-mod  "+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox","class":"",name:inputName,value:value,checked:value,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.checked,index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"lever"})),value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pr-2 font-apply-li"},"YES"),!value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pl-2 font-apply-li"},"NO"));break;case"textarea":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{type:"text",style:this.props.style,className:"com-txt",name:inputName,disabled:disabled,onChange:function onChange(e){return _onChange(inputName,e.target.value,index);},value:value});break;case"radio":uniqueName=inputName;inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio","class":"filled-in",id:value,name:uniqueName,value:value,checked:checked,disabled:disabled,onChange:function onChange(e){return _onChange(value,e.target.checked,index,i);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":value,"class":"font-apply-li"},label));break;case"date":if(this.props.durationETA){var _30DaysForward=new __WEBPACK_IMPORTED_MODULE_2_moment___default.a().add(this.props.durationETA,"day");var valueDate=inputName=="processDate"?null:value?new Date(value):new Date();inputField=!disabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default.a,{wrapperClassName:"mb-custome-datepicker",date:_30DaysForward,format:"DD MMM YYYY",onChange:function onChange(date){return _onChange(inputName,date,index,i);},placeholder:"dd mmm yyyy"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"dropdown1",name:inputName,value:valueDate!=""?__WEBPACK_IMPORTED_MODULE_2_moment___default()(valueDate).format("DD MMM YYYY"):"",disabled:true});break;}else{var _valueDate=inputName=="processDate"?null:value?new Date(value):new Date();inputField=!disabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modern_datepicker___default.a,{date:_valueDate,format:"DD MMM YYYY",onChange:function onChange(date){return _onChange(inputName,date,index,i);},placeholder:"dd mmm yyyy"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:inputName,value:_valueDate!=""?__WEBPACK_IMPORTED_MODULE_2_moment___default()(_valueDate).format("DD MMM YYYY"):"",disabled:true});break;}case"time":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_time_picker__["a" /* default */],{style:this.props.style,value:value!=""&&value!==null?__WEBPACK_IMPORTED_MODULE_2_moment___default()(value):__WEBPACK_IMPORTED_MODULE_2_moment___default()(""+(new Date().getFullYear(),new Date().getMonth(),new Date().getDay())),placeholder:"HH:MM",showSecond:false,disabled:disabled,format:"HH:mm",onChange:function onChange(value){return _onChange(inputName,value,index);}});break;default:inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputName,className:"form-control"});}return isFormGroup?//   <div class={`form-group ${className}`}>
//     <label for="">
//       {label && label.endsWith("*") ? label.split("*")[0] : label}
//       {label && label.endsWith("*") ? (
//         <span className="text-danger madatory-asterisk">
//           {label && label.match(/\*/g)}
//         </span>
//       ) : (
//           ""
//         )}
//     </label>
//     {inputField}
//   </div>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label1"},label),inputField):inputField;}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logout.4bb24fbe.svg";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(313);
module.exports = __webpack_require__(318);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(314).enable();
  window.Promise = __webpack_require__(316);
}

// fetch() polyfill for making API calls.
__webpack_require__(317);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(168);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(168);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Routes__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_store__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(994);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4__redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(13),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(13),r=__webpack_require__(321);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(322);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_react_toggle_switch_dist_css_switch_min_css__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_react_toggle_switch_dist_css_switch_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_react_toggle_switch_dist_css_switch_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_dashboard_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_master_css__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_master_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_master_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Alert__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mainLayout__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_printStyleNumber_page__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SampleRequest_PatternModule_MeasurementModal_MeasurementModal__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Sample_SampleMobileApp_SampleMobileApp__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Sample_SampleMobileApp_MobileLogin_js__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Sample_SampleMobileApp_MobileQRScanner_js__ = __webpack_require__(986);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//css
//redux
//services
//alert
//Main Layout
//history
var Routes=function(_Component){_inherits(Routes,_Component);function Routes(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Routes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Routes.__proto__||Object.getPrototypeOf(Routes)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:false,events:["load","mousemove","mousedown","click","scroll","keypress","touchstart"],isMobileOrTablet:_this.checkIfMobileOrTablet()},_this.clearTimeout=function(){if(_this.logoutTimeout)clearTimeout(_this.logoutTimeout);},_this.setTimeout=function(){_this.logoutTimeout=setTimeout(_this.unauthorisedFunc,15*60*1000);},_this.resetTimeout=function(){localStorage.setItem("session",Date.now());_this.clearTimeout();_this.setTimeout();},_this.logout=function(){// localStorage.removeItem("authToken");
// localStorage.removeItem("authToken");
// localStorage.clear();
// warn = () => {
//   alert("You will be logged out automatically in 1 minute.");
// };
var session=localStorage.getItem("session");session=__WEBPACK_IMPORTED_MODULE_12_moment___default()().diff(new Date(Number(session)).toString(),'seconds');if(session>900){//15mins
_this.props.actions.signOut();_this.props.history!==undefined&&_this.props.history.push("/");_this.authenticate();}},_this.componentDidMount=function(){_this.authenticate();_this.setState({isMobileOrTablet:_this.checkIfMobileOrTablet()});//  window.onbeforeunload = this.handleLeavePage;
},_this.componentWillReceiveProps=function(){_this.authenticate();},_this.handleLeavePage=function(e){e.preventDefault();if(!_this.props.rememberMe){localStorage.clear();}},_this.authenticate=function(){if(localStorage.getItem("authToken")){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].getUserInfo().then(function(response){if(response.status==200){var userDetails={_id:response.text.data._id,firstName:response.text.data.firstName,lastName:response.text.data.lastName,userId:"",authToken:localStorage.getItem("authToken"),profilePicture:response.text.data.profilePicture,rememberMe:response.text.data.rememberMe,isLoggedIn:true,rights:response.text.data.rights};_this.props.actions.updateBasicDetails(userDetails);_this.setState({loaded:true});}if(response.status===401){var _userDetails={isLoggedIn:false};_this.props.actions.updateBasicDetails(_userDetails);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_16__containers_history__["a" /* default */]!==undefined&&__WEBPACK_IMPORTED_MODULE_16__containers_history__["a" /* default */].push("/");window.location.reload();_this.setState({error:true});__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].errorMsg(_this.msg);});}else{var userDetails={isLoggedIn:false};_this.props.actions.updateBasicDetails(userDetails);}},_this.getalertMessage=function(msgType,msg,time){if(msgType=="success"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].successMsg(_this.msg,msg,time);}else if(msgType=="error"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].errorMsg(_this.msg,msg,time);}else if(msgType=="info"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].infoMsg(_this.msg,msg,time);}else if(msgType=="warning"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].warningMsg(_this.msg,msg,time);}else if(msgType=="edit"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].editMsg(_this.msg,msg,time);}else if(msgType=="delete"){__WEBPACK_IMPORTED_MODULE_9__services__["m" /* UtilityService */].deleteMsg(_this.msg,msg,time);}},_this.unauthorisedFunc=function(){var session=localStorage.getItem("session");session=__WEBPACK_IMPORTED_MODULE_12_moment___default()().diff(new Date(Number(session)).toString(),'seconds');if(session>=900){//15mins
localStorage.removeItem("authToken");localStorage.clear();_this.props.actions.signOut();__WEBPACK_IMPORTED_MODULE_16__containers_history__["a" /* default */]!==undefined&&__WEBPACK_IMPORTED_MODULE_16__containers_history__["a" /* default */].push("/");}},_this.HomeRoute=function(){return _this.state.isMobileOrTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Sample_SampleMobileApp_MobileQRScanner_js__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["j" /* Dashboard */],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Routes,[{key:"componentWillMount",value:function componentWillMount(){for(var i in this.state.events){window.addEventListener(this.state.events[i],this.resetTimeout);}this.setTimeout();}},{key:"componentWillUnmount",value:function componentWillUnmount(){for(var i in this.state.events){window.removeEventListener(this.state.events[i],this.resetTimeout);}}//Alert message of return api
},{key:"checkIfMobileOrTablet",// Function to detect if the device is a mobile or tablet
value:function checkIfMobileOrTablet(){return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);}},{key:"render",value:function render(){var _this2=this;var authorised_rout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"toggle-nav-bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_alert___default.a,Object.assign({ref:function ref(a){return _this2.msg=a;}},__WEBPACK_IMPORTED_MODULE_11__components_Common_Alert__["a" /* default */])),!this.state.isMobileOrTablet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_mainLayout__["a" /* Header */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_mainLayout__["b" /* Sidebar */],this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:"/",component:this.HomeRoute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/profile",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["y" /* Profile */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/list",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["s" /* List */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/CustomerPage",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["i" /* Customer */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/MeetingNote",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["u" /* MeetingNote */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/calendar",component:__WEBPACK_IMPORTED_MODULE_14__pages__["c" /* Calendar */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/communication",component:__WEBPACK_IMPORTED_MODULE_14__pages__["e" /* Communication */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/chat",component:__WEBPACK_IMPORTED_MODULE_14__pages__["d" /* Chat */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/StylePage",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["D" /* Style */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/createIB"// component={CreateIB}
,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["h" /* CreateIB */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/smv_ov_list",component:__WEBPACK_IMPORTED_MODULE_14__pages__["C" /* Smv_Ov_List */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/SmvThread",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["B" /* SmvThread */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/technicalIssues",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["H" /* TechnicalIssues */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/Sample",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["A" /* Sample */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/permissionRole",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["w" /* PermissionRole */],Object.assign({getalertMessage:_this2.getalertMessage},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/CostingPage",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["f" /* Costing */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/CostingComparison",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["g" /* CostingComparison */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/developmentCad",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["l" /* DevelopmentCAD */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/developmentFabric",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["m" /* DevelopmentFabric */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/bulkImport",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["b" /* BulkImport */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/printFabricNumber",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["x" /* PrintFabricNumber */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/printStyleNumber",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_printStyleNumber_page__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/BNumber",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["k" /* DevelopmentBNumber */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/measurementChat",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SampleRequest_PatternModule_MeasurementModal_MeasurementModal__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/mobileApp",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Sample_SampleMobileApp_SampleMobileApp__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/mobileLogin",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Sample_SampleMobileApp_MobileLogin_js__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/qr",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Sample_SampleMobileApp_MobileQRScanner_js__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/Trim",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["I" /* Trim */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/developmentSourcing",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["o" /* DevelopmentSourcing */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/developmentProduct",component:__WEBPACK_IMPORTED_MODULE_14__pages__["n" /* DevelopmentProduct */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/employeRights",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["p" /* EmployeRights */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/employee",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["q" /* Employee */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/generateTag",component:__WEBPACK_IMPORTED_MODULE_14__pages__["r" /* GenerateTag */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/system/Supplier",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["G" /* SystemSupplier */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/system",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["F" /* SystemSubmodulesPage */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:["/3D","/cad","/general","/COSTING","/CUSTOMER","/STYLE","/EMBROIDERY","/TRIMS","/FABRIC","/samplerequest"],render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["E" /* SystemCategoryList */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:["/VIEW","/EDIT","/ADD"],render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["a" /* AddCategory */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:"/Report",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["z" /* Report */],Object.assign({getalertMessage:_this2.getalertMessage,unauthorisedFunc:_this2.unauthorisedFunc},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["v" /* PageNotFound */],Object.assign({error:404},props));}})));var unauthorised_rout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_alert___default.a,Object.assign({ref:function ref(a){return _this2.msg=a;}},__WEBPACK_IMPORTED_MODULE_11__components_Common_Alert__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:"/",render:function render(props){return _this2.state.isMobileOrTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Sample_SampleMobileApp_MobileLogin_js__["a" /* default */],Object.assign({getalertMessage:_this2.getalertMessage},props)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["t" /* LogInPage */],Object.assign({getalertMessage:_this2.getalertMessage},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["v" /* PageNotFound */],Object.assign({error:404},props));}})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_16__containers_history__["a" /* default */]},this.props.isLoggedIn===null?this.state.error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages__["v" /* PageNotFound */],{error:500}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Common_Loading__["a" /* default */],null):this.props.isLoggedIn?authorised_rout:unauthorised_rout);}}]);return Routes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isLoggedIn:state.main.isLoggedIn,rememberMe:state.main.rememberMe};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_7__redux_action_main__,dispatch)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Routes));

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(326);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(328);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(329);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(170);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(330);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(334)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(63);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(126);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(63);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(364);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(181);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(352);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(350);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(177);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(354);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(357);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18), __webpack_require__(178)(module)))

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(179);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(180);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(181);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(182);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(365);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(126);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(367);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dev={// base_url: "http://192.168.10.167:2024/"  //janen
base_url:"http://127.0.0.1:2034/"//sasi
// base_url: "https://ancient-catfish-71.loca.lt/" //sasi
// base_url: "http://192.168.10.214:2034/" //rajendran
// base_url: "http://192.168.10.202:2024/"  //jp
};var staging={base_url:"https://apistaging.magnumclothing.com/"};var production={// base_url: "http://13.234.124.200:2024/" old one before PWA
base_url:" https://api.magnumclothing.com/"};var configVariables=Object.assign({},dev);//Change the config for production and development
switch("production"){case"staging":configVariables=Object.assign({},staging);break;case"production":configVariables=Object.assign({},production);break;default:configVariables=Object.assign({},dev);break;}/* harmony default export */ __webpack_exports__["a"] = (Object.assign({},configVariables));

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SystemService=function(){function SystemService(){_classCallCheck(this,SystemService);}_createClass(SystemService,[{key:'getSystemInfo',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getPage',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({type:value})});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function getSystemInfo(_x){return _ref.apply(this,arguments);}return getSystemInfo;}()},{key:'listSystemSuppliers',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemSuppliers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function listSystemSuppliers(_x2){return _ref2.apply(this,arguments);}return listSystemSuppliers;}()//for add and edit systemSupplier
},{key:'SystemSupplier',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(supplierData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemSuppliers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(supplierData)});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function SystemSupplier(_x3){return _ref3.apply(this,arguments);}return SystemSupplier;}()},{key:'viewystemSupplier',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemSupplier',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context4.sent;_context4.t0=result.status;_context4.next=6;return result.json();case 6:_context4.t1=_context4.sent;return _context4.abrupt('return',{status:_context4.t0,text:_context4.t1});case 8:case'end':return _context4.stop();}}},_callee4,this);}));function viewystemSupplier(_x4){return _ref4.apply(this,arguments);}return viewystemSupplier;}()},{key:'removeSystemSupplier',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemSuppliers',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context5.sent;_context5.next=5;return result.json();case 5:_context5.t0=_context5.sent;_context5.t1=result.status;return _context5.abrupt('return',{text:_context5.t0,status:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function removeSystemSupplier(_x5){return _ref5.apply(this,arguments);}return removeSystemSupplier;}()},{key:'listCategoryContent',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(value,heading,moduleSystem,page){var api,method,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:api=moduleSystem==="costings"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getCostingSystem':moduleSystem==="embroiderys"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemEmbroideries':moduleSystem!=="trims"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/System'+moduleSystem):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/System'+moduleSystem);method=moduleSystem==="general"?"GET":"POST";_context6.next=4;return fetch(api,{method:method,headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:heading,subHeading:value,page:page})});case 4:result=_context6.sent;return _context6.abrupt('return',result.json());case 6:case'end':return _context6.stop();}}},_callee6,this);}));function listCategoryContent(_x6,_x7,_x8,_x9){return _ref6.apply(this,arguments);}return listCategoryContent;}()},{key:'getSupplierPart',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(moduleName){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/System'+moduleName);_context7.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"heading":"SUPPLIER","subHeading":"SUPPLIERPART"})});case 3:result=_context7.sent;return _context7.abrupt('return',result.json());case 5:case'end':return _context7.stop();}}},_callee7,this);}));function getSupplierPart(_x10){return _ref7.apply(this,arguments);}return getSupplierPart;}()},{key:'getSpecificTrimCategory',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getSpecificTrim',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context8.sent;return _context8.abrupt('return',result.json());case 4:case'end':return _context8.stop();}}},_callee8,this);}));function getSpecificTrimCategory(_x11){return _ref8.apply(this,arguments);}return getSpecificTrimCategory;}()},{key:'addCategory',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(value,categoryName,subModule,systemModule,price,supplierData,id,moduleName,number){var api,jsonData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:api=systemModule==="COSTING"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addSystemCosting':systemModule==="EMBROIDERY"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemEmbroideries':categoryName==="SUPPLIERPART"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule):systemModule!=="TRIMS"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule.toLowerCase()+'s'):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule);jsonData={heading:subModule,subHeading:categoryName};if(categoryName==='ASSIGNEDTO'){jsonData.assignedTo=value;}else{jsonData.name=value;}if(supplierData&&moduleName){jsonData=Object.assign({},jsonData,supplierData,{moduleName:moduleName});}if(id){jsonData._id=id;}jsonData.price=price!=undefined||price===""?price:null;if(number){jsonData.number=number;}console.log(jsonData);_context9.next=10;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(jsonData)});case 10:result=_context9.sent;return _context9.abrupt('return',result.json());case 12:case'end':return _context9.stop();}}},_callee9,this);}));function addCategory(_x12,_x13,_x14,_x15,_x16,_x17,_x18,_x19,_x20){return _ref9.apply(this,arguments);}return addCategory;}()},{key:'editCategoryForCad',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(value,id,moduleName,categoryName){var api,jsonData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemcads';jsonData={_id:id};jsonData.name=value;_context10.next=5;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(jsonData)});case 5:result=_context10.sent;return _context10.abrupt('return',result.json());case 7:case'end':return _context10.stop();}}},_callee10,this);}));function editCategoryForCad(_x21,_x22,_x23,_x24){return _ref10.apply(this,arguments);}return editCategoryForCad;}()},{key:'addCategoryForPortofpickup',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(value,categoryName,subModule,systemModule){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:api=systemModule==="COSTING"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addSystemCosting':systemModule==="EMBROIDERY"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemEmbroideries':systemModule!=="TRIMS"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule.toLowerCase()+'s'):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule);_context11.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value.portofpickup,freightCostAbove500:value.freightCostAbove500,freightCostBelow500:value.freightCostBelow500,seaFreightCost:value.seaFreightCost})});case 3:result=_context11.sent;return _context11.abrupt('return',result.json());case 5:case'end':return _context11.stop();}}},_callee11,this);}));function addCategoryForPortofpickup(_x25,_x26,_x27,_x28){return _ref11.apply(this,arguments);}return addCategoryForPortofpickup;}()},{key:'editCategoryForPortofpickup',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(value,categoryName,subModule,id){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemfabrics';_context12.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value.portofpickup,freightCostAbove500:value.freightCostAbove500,freightCostBelow500:value.freightCostBelow500,seaFreightCost:value.seaFreightCost,_id:id})});case 3:result=_context12.sent;return _context12.abrupt('return',result.json());case 5:case'end':return _context12.stop();}}},_callee12,this);}));function editCategoryForPortofpickup(_x29,_x30,_x31,_x32){return _ref12.apply(this,arguments);}return editCategoryForPortofpickup;}()},{key:'addCategoryForTrimPack',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(value,categoryName,subModule,systemModule){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:api=systemModule==="COSTING"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addSystemCosting':systemModule==="EMBROIDERY"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemEmbroideries':systemModule!=="TRIMS"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule.toLowerCase()+'s'):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/AddSystem'+systemModule);_context13.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value.packingMaterialType})});case 3:result=_context13.sent;return _context13.abrupt('return',result.json());case 5:case'end':return _context13.stop();}}},_callee13,this);}));function addCategoryForTrimPack(_x33,_x34,_x35,_x36){return _ref13.apply(this,arguments);}return addCategoryForTrimPack;}()},{key:'editCategoryForTrimPack',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(value,categoryName,subModule,id){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemcustomers';_context14.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value.packingMaterialType,_id:id})});case 3:result=_context14.sent;return _context14.abrupt('return',result.json());case 5:case'end':return _context14.stop();}}},_callee14,this);}));function editCategoryForTrimPack(_x37,_x38,_x39,_x40){return _ref14.apply(this,arguments);}return editCategoryForTrimPack;}()//edit api
},{key:'getDataById',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(id,heading){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getSystemDataById';_context15.next=3;return fetch(api,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,systemType:heading})});case 3:result=_context15.sent;return _context15.abrupt('return',result.json());case 5:case'end':return _context15.stop();}}},_callee15,this);}));function getDataById(_x41,_x42){return _ref15.apply(this,arguments);}return getDataById;}()},{key:'addCategoryForTrimCat',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(value,trimRef,categoryName,units,status,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemTrims',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:value,referNo:trimRef,unit:units,status:status})});case 2:result=_context16.sent;return _context16.abrupt('return',result.json());case 4:case'end':return _context16.stop();}}},_callee16,this);}));function addCategoryForTrimCat(_x43,_x44,_x45,_x46,_x47,_x48){return _ref16.apply(this,arguments);}return addCategoryForTrimCat;}()// done by viswa
},{key:'addCategoryToParentTrim',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(value,categoryName,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemTrims',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:value})});case 2:result=_context17.sent;return _context17.abrupt('return',result.json());case 4:case'end':return _context17.stop();}}},_callee17,this);}));function addCategoryToParentTrim(_x49,_x50,_x51){return _ref17.apply(this,arguments);}return addCategoryToParentTrim;}()},{key:'addCategoryForCurrency',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(value,currencyValue,currency,categoryName,subModule){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemCustomers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value,currency:currency,currencyValue:parseInt(currencyValue)})});case 2:result=_context18.sent;return _context18.abrupt('return',result.json());case 4:case'end':return _context18.stop();}}},_callee18,this);}));function addCategoryForCurrency(_x52,_x53,_x54,_x55,_x56){return _ref18.apply(this,arguments);}return addCategoryForCurrency;}()},{key:'addCategoryForMachine',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(categoryValue,needleCode,factor,needle,looper,subModuleName,overLock,trimThread,sheeringNeedle){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addSystemStyles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:"MACHINE",name:categoryValue,needleCode:needleCode,factor:factor,needle:needle,looper:looper,overLock:overLock,trimThread:trimThread,sheeringNeedle:sheeringNeedle})});case 2:result=_context19.sent;return _context19.abrupt('return',result.json());case 4:case'end':return _context19.stop();}}},_callee19,this);}));function addCategoryForMachine(_x57,_x58,_x59,_x60,_x61,_x62,_x63,_x64,_x65){return _ref19.apply(this,arguments);}return addCategoryForMachine;}()},{key:'addCategoryForCity',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(value,categoryName,country,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemCustomers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:value,country:country})});case 2:result=_context20.sent;return _context20.abrupt('return',result.json());case 4:case'end':return _context20.stop();}}},_callee20,this);}));function addCategoryForCity(_x66,_x67,_x68,_x69){return _ref20.apply(this,arguments);}return addCategoryForCity;}()},{key:'addCategoryForBackingType',value:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(value,categoryName,subModuleName,typeMultiple){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemsamplerequests',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:value,typeMultiple:typeMultiple})});case 2:result=_context21.sent;return _context21.abrupt('return',result.json());case 4:case'end':return _context21.stop();}}},_callee21,this);}));function addCategoryForBackingType(_x70,_x71,_x72,_x73){return _ref21.apply(this,arguments);}return addCategoryForBackingType;}()},{key:'addCategoryForSmockingSheering',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemsamplerequests',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(Object.assign({heading:'TRIM',subHeading:"SHIRRINGORSMOCKING",name:'dummy'},value))});case 2:result=_context22.sent;return _context22.abrupt('return',result.json());case 4:case'end':return _context22.stop();}}},_callee22,this);}));function addCategoryForSmockingSheering(_x74){return _ref22.apply(this,arguments);}return addCategoryForSmockingSheering;}()},{key:'getCategoryForSmockingSheering',value:function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/Systemsamplerequest',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({subHeading:"SHIRRINGORSMOCKING"})});case 2:result=_context23.sent;return _context23.abrupt('return',result.json());case 4:case'end':return _context23.stop();}}},_callee23,this);}));function getCategoryForSmockingSheering(){return _ref23.apply(this,arguments);}return getCategoryForSmockingSheering;}()},{key:'editCategoryForBackingType',value:function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(value,_id,categoryName,subModuleName,typeMultiple){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:_context24.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemsamplerequests',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({// heading: subModuleName,
// subHeading: categoryName,
name:value,typeMultiple:typeMultiple,_id:_id})});case 2:result=_context24.sent;return _context24.abrupt('return',result.json());case 4:case'end':return _context24.stop();}}},_callee24,this);}));function editCategoryForBackingType(_x75,_x76,_x77,_x78,_x79){return _ref24.apply(this,arguments);}return editCategoryForBackingType;}()},{key:'addSampleRequestType',value:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(categoryName,id,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/setDefaultEmp',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,employeeId:id})});case 2:result=_context25.sent;return _context25.abrupt('return',result.json());case 4:case'end':return _context25.stop();}}},_callee25,this);}));function addSampleRequestType(_x80,_x81,_x82){return _ref25.apply(this,arguments);}return addSampleRequestType;}()},{key:'editCategoryForCity',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(value,country,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/editSystemCustomers',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,name:value,country:country})});case 2:result=_context26.sent;return _context26.abrupt('return',result.json());case 4:case'end':return _context26.stop();}}},_callee26,this);}));function editCategoryForCity(_x83,_x84,_x85){return _ref26.apply(this,arguments);}return editCategoryForCity;}()},{key:'addCategoryForAddress',value:function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(country,city,address,categoryName,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemCustomers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:address,city:city,country:country})});case 2:result=_context27.sent;return _context27.abrupt('return',result.json());case 4:case'end':return _context27.stop();}}},_callee27,this);}));function addCategoryForAddress(_x86,_x87,_x88,_x89,_x90){return _ref27.apply(this,arguments);}return addCategoryForAddress;}()},{key:'editCategoryForAddress',value:function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(categoryInfo,categoryName,id,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/editSystemCustomers',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,_id:id,subHeading:categoryInfo,name:categoryName!==undefined&&categoryName.categoryName,city:categoryName!==undefined&&categoryName.categoryFull!==undefined&&categoryName.categoryFull.city!==undefined&&categoryName.categoryFull.city!==undefined&&categoryName.categoryFull.city._id,country:categoryName!==undefined&&categoryName.countryId})});case 2:result=_context28.sent;return _context28.abrupt('return',result.json());case 4:case'end':return _context28.stop();}}},_callee28,this);}));function editCategoryForAddress(_x91,_x92,_x93,_x94){return _ref28.apply(this,arguments);}return editCategoryForAddress;}()},{key:'editCategoryForMachine',value:function(){var _ref29=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee29(id,categoryValue,needleCode,factor,needle,looper,subModuleName,overLock,trimThread,sheeringNeedle){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29){while(1){switch(_context29.prev=_context29.next){case 0:_context29.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/editSystemStyles',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,heading:subModuleName,subHeading:"MACHINE",name:categoryValue,needleCode:needleCode,factor:factor,needle:needle,looper:looper,overLock:overLock,trimThread:trimThread,sheeringNeedle:sheeringNeedle})});case 2:result=_context29.sent;return _context29.abrupt('return',result.json());case 4:case'end':return _context29.stop();}}},_callee29,this);}));function editCategoryForMachine(_x95,_x96,_x97,_x98,_x99,_x100,_x101,_x102,_x103,_x104){return _ref29.apply(this,arguments);}return editCategoryForMachine;}()},{key:'editCategory',value:function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee30(value,id,moduleName,categoryName,price,number){var api,jsonData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30){while(1){switch(_context30.prev=_context30.next){case 0:api=moduleName==="embroidery"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/editSystemEmbroideries':moduleName=="samplerequest"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/AddSystemsamplerequests':moduleName!=="trims"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/editSystem'+moduleName+'s'):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/editSystem'+moduleName);jsonData={_id:id};if(categoryName==='ASSIGNEDTO'){jsonData.assignedTo=value;}else{jsonData.name=value;}if(price!=""||price!=undefined){jsonData.price=price;}if(number){jsonData.number=number;}console.log(jsonData);_context30.next=8;return fetch(api,{method:moduleName=="samplerequest"?"POST":"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(jsonData)});case 8:result=_context30.sent;return _context30.abrupt('return',result.json());case 10:case'end':return _context30.stop();}}},_callee30,this);}));function editCategory(_x105,_x106,_x107,_x108,_x109,_x110){return _ref30.apply(this,arguments);}return editCategory;}()},{key:'editCategoryForTrimCat',value:function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee31(value,trimRef,categoryName,units,status,id,subModuleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:_context31.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/editSystemTrims',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModuleName,subHeading:categoryName,name:value,referNo:trimRef,unit:units,status:status,_id:id})});case 2:result=_context31.sent;return _context31.abrupt('return',result.json());case 4:case'end':return _context31.stop();}}},_callee31,this);}));function editCategoryForTrimCat(_x111,_x112,_x113,_x114,_x115,_x116,_x117){return _ref31.apply(this,arguments);}return editCategoryForTrimCat;}()},{key:'editCategoryForCurrency',value:function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee32(value,currencyValue,currency,categoryName,subModule,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:_context32.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/EditSystemCustomers',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value,currency:currency,currencyValue:parseInt(currencyValue),_id:id})});case 2:result=_context32.sent;return _context32.abrupt('return',result.json());case 4:case'end':return _context32.stop();}}},_callee32,this);}));function editCategoryForCurrency(_x118,_x119,_x120,_x121,_x122,_x123){return _ref32.apply(this,arguments);}return editCategoryForCurrency;}()},{key:'removeSystemCategory',value:function(){var _ref33=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee33(id,subModuleName){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:api=subModuleName=="SAMPLEREQUEST"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/deleteSystemSampleRequest':subModuleName!=="TRIMS"?__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/system/System'+subModuleName):__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemTrim';_context33.next=3;return fetch(api,{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 3:result=_context33.sent;return _context33.abrupt('return',result.json());case 5:case'end':return _context33.stop();}}},_callee33,this);}));function removeSystemCategory(_x124,_x125){return _ref33.apply(this,arguments);}return removeSystemCategory;}()},{key:'editCategoryForCurrency',value:function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee34(value,currencyValue,currency,categoryName,subModule,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34){while(1){switch(_context34.prev=_context34.next){case 0:_context34.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/EditSystemCustomers',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:subModule,subHeading:categoryName,name:value,currency:currency,currencyValue:parseInt(currencyValue),_id:id})});case 2:result=_context34.sent;return _context34.abrupt('return',result.json());case 4:case'end':return _context34.stop();}}},_callee34,this);}));function editCategoryForCurrency(_x126,_x127,_x128,_x129,_x130,_x131){return _ref34.apply(this,arguments);}return editCategoryForCurrency;}()//get All system fabrics
},{key:'getCountryList',value:function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee35(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35){while(1){switch(_context35.prev=_context35.next){case 0:_context35.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getAllSystemCountry',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context35.sent;_context35.t0=result.status;_context35.next=6;return result.json();case 6:_context35.t1=_context35.sent;return _context35.abrupt('return',{status:_context35.t0,text:_context35.t1});case 8:case'end':return _context35.stop();}}},_callee35,this);}));function getCountryList(){return _ref35.apply(this,arguments);}return getCountryList;}()},{key:'smvOthers',value:function(){var _ref36=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee36(heading,subHeading,wastage,otherSize,wash,_id){var obj,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36){while(1){switch(_context36.prev=_context36.next){case 0:obj={};obj.heading=heading;obj.subHeading=subHeading;obj.wastage=wastage;obj.wash=wash;obj.otherSize=otherSize;if(_id!==""){obj._id=_id;}_context36.next=9;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addSMVStyle',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 9:result=_context36.sent;_context36.t0=result.status;_context36.next=13;return result.json();case 13:_context36.t1=_context36.sent;return _context36.abrupt('return',{status:_context36.t0,text:_context36.t1});case 15:case'end':return _context36.stop();}}},_callee36,this);}));function smvOthers(_x132,_x133,_x134,_x135,_x136,_x137){return _ref36.apply(this,arguments);}return smvOthers;}()},{key:'getSmvOthers',value:function(){var _ref37=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee37(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37){while(1){switch(_context37.prev=_context37.next){case 0:_context37.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getSysSMVOthers',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context37.sent;_context37.t0=result.status;_context37.next=6;return result.json();case 6:_context37.t1=_context37.sent;return _context37.abrupt('return',{status:_context37.t0,text:_context37.t1});case 8:case'end':return _context37.stop();}}},_callee37,this);}));function getSmvOthers(){return _ref37.apply(this,arguments);}return getSmvOthers;}()// currency conversion
},{key:'currencyConversion',value:function(){var _ref38=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee38(heading,subHeading,usd,gbp,eur,_id){var obj,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38){while(1){switch(_context38.prev=_context38.next){case 0:obj={};obj.heading=heading;obj.subHeading=subHeading;obj.usd=usd;obj.gbp=gbp;obj.eur=eur;if(_id!==""){obj._id=_id;}_context38.next=9;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addCurrencyConversion',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 9:result=_context38.sent;_context38.t0=result.status;_context38.next=13;return result.json();case 13:_context38.t1=_context38.sent;return _context38.abrupt('return',{status:_context38.t0,text:_context38.t1});case 15:case'end':return _context38.stop();}}},_callee38,this);}));function currencyConversion(_x138,_x139,_x140,_x141,_x142,_x143){return _ref38.apply(this,arguments);}return currencyConversion;}()},{key:'costingOthers',value:function(){var _ref39=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee39(heading,subHeading,valueLoss,overHeads,conversionRate,freightCharges,processingCost,duty,orderQty,costPertailor,noOftailors,perMachine,idleDays,_id){var obj,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39){while(1){switch(_context39.prev=_context39.next){case 0:obj={};obj.heading=heading;obj.subHeading=subHeading;obj.valueLoss=valueLoss;obj.overHeads=overHeads;obj.conversionRate=conversionRate;obj.freightCharges=freightCharges;obj.processingCost=processingCost;obj.orderQty=orderQty;obj.duty=duty;obj.costPertailor=costPertailor;obj.noOftailors=noOftailors;obj.perMachine=perMachine;obj.idleDays=idleDays;if(_id!==""){obj._id=_id;}_context39.next=17;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addcostingOthers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 17:result=_context39.sent;_context39.t0=result.status;_context39.next=21;return result.json();case 21:_context39.t1=_context39.sent;return _context39.abrupt('return',{status:_context39.t0,text:_context39.t1});case 23:case'end':return _context39.stop();}}},_callee39,this);}));function costingOthers(_x144,_x145,_x146,_x147,_x148,_x149,_x150,_x151,_x152,_x153,_x154,_x155,_x156,_x157){return _ref39.apply(this,arguments);}return costingOthers;}()},{key:'editGstValue',value:function(){var _ref40=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee40(gst){var obj,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40){while(1){switch(_context40.prev=_context40.next){case 0:obj={};obj.gst=gst;_context40.next=4;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/addGST',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 4:result=_context40.sent;_context40.t0=result.status;_context40.next=8;return result.json();case 8:_context40.t1=_context40.sent;return _context40.abrupt('return',{status:_context40.t0,text:_context40.t1});case 10:case'end':return _context40.stop();}}},_callee40,this);}));function editGstValue(_x158){return _ref40.apply(this,arguments);}return editGstValue;}()},{key:'getcurrencyConversion',value:function(){var _ref41=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee41(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41){while(1){switch(_context41.prev=_context41.next){case 0:_context41.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getcurrencyConversion',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context41.sent;_context41.t0=result.status;_context41.next=6;return result.json();case 6:_context41.t1=_context41.sent;return _context41.abrupt('return',{status:_context41.t0,text:_context41.t1});case 8:case'end':return _context41.stop();}}},_callee41,this);}));function getcurrencyConversion(){return _ref41.apply(this,arguments);}return getcurrencyConversion;}()},{key:'getGstValue',value:function(){var _ref42=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee42(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42){while(1){switch(_context42.prev=_context42.next){case 0:_context42.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getGST',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context42.sent;_context42.t0=result.status;_context42.next=6;return result.json();case 6:_context42.t1=_context42.sent;return _context42.abrupt('return',{status:_context42.t0,text:_context42.t1});case 8:case'end':return _context42.stop();}}},_callee42,this);}));function getGstValue(){return _ref42.apply(this,arguments);}return getGstValue;}()//costing others
},{key:'getCostingOthers',value:function(){var _ref43=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee43(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43){while(1){switch(_context43.prev=_context43.next){case 0:_context43.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getCostingOthers',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context43.sent;_context43.t0=result.status;_context43.next=6;return result.json();case 6:_context43.t1=_context43.sent;return _context43.abrupt('return',{status:_context43.t0,text:_context43.t1});case 8:case'end':return _context43.stop();}}},_callee43,this);}));function getCostingOthers(){return _ref43.apply(this,arguments);}return getCostingOthers;}()}]);return SystemService;}();/* harmony default export */ __webpack_exports__["a"] = (new SystemService());

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CustomerServices=function(){function CustomerServices(){_classCallCheck(this,CustomerServices);}_createClass(CustomerServices,[{key:'listCustomer',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/customers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context.sent;_context.next=5;return result.json();case 5:_context.t0=_context.sent;_context.t1=result.status;return _context.abrupt('return',{text:_context.t0,status:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function listCustomer(_x){return _ref.apply(this,arguments);}return listCustomer;}()},{key:'customerInfo',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingnotes/customerDetails',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function customerInfo(){return _ref2.apply(this,arguments);}return customerInfo;}()},{key:'customerWithDepartmentInfo',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/report/listCustomersDeparts',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function customerWithDepartmentInfo(){return _ref3.apply(this,arguments);}return customerWithDepartmentInfo;}()},{key:'getCustomer',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/getCustomer',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context4.sent;_context4.next=5;return result.json();case 5:_context4.t0=_context4.sent;_context4.t1=result.status;return _context4.abrupt('return',{text:_context4.t0,status:_context4.t1});case 8:case'end':return _context4.stop();}}},_callee4,this);}));function getCustomer(_x2){return _ref4.apply(this,arguments);}return getCustomer;}()},{key:'removeCustomer',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/customer',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context5.sent;_context5.next=5;return result.json();case 5:_context5.t0=_context5.sent;_context5.t1=result.status;return _context5.abrupt('return',{text:_context5.t0,status:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function removeCustomer(_x3){return _ref5.apply(this,arguments);}return removeCustomer;}()},{key:'getSystemValuesForCustomer',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/Customers',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context6.sent;return _context6.abrupt('return',result.json());case 4:case'end':return _context6.stop();}}},_callee6,this);}));function getSystemValuesForCustomer(){return _ref6.apply(this,arguments);}return getSystemValuesForCustomer;}()},{key:'createCustomer',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(customer){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/AddNewCustomer',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(customer)});case 2:result=_context7.sent;_context7.t0=result.status;_context7.next=6;return result.json();case 6:_context7.t1=_context7.sent;return _context7.abrupt('return',{status:_context7.t0,text:_context7.t1});case 8:case'end':return _context7.stop();}}},_callee7,this);}));function createCustomer(_x4){return _ref7.apply(this,arguments);}return createCustomer;}()},{key:'addDepartment',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(value,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/addCustomerDepartment',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({departments:value,_id:id})});case 2:result=_context8.sent;return _context8.abrupt('return',result.json());case 4:case'end':return _context8.stop();}}},_callee8,this);}));function addDepartment(_x5,_x6){return _ref8.apply(this,arguments);}return addDepartment;}()},{key:'editCustomer',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(customerId,customerName,customerCode,customerCRRAccountDetails,auditType,customerDiscount,fabricBasicRequirements,sites){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/AddNewCustomer',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:customerId,customerName:customerName,customerCode:customerCode,customerCRRAccountDetails:customerCRRAccountDetails,auditType:auditType,customerDiscount:customerDiscount,sites:sites,fabricBasicRequirements:fabricBasicRequirements})});case 2:result=_context9.sent;return _context9.abrupt('return',result.json());case 4:case'end':return _context9.stop();}}},_callee9,this);}));function editCustomer(_x7,_x8,_x9,_x10,_x11,_x12,_x13,_x14){return _ref9.apply(this,arguments);}return editCustomer;}()},{key:'searchCustomersBy',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(customerType,value,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/searchCustomer',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:customerType,page:page})});case 2:result=_context10.sent;_context10.next=5;return result.json();case 5:_context10.t0=_context10.sent;_context10.t1=result.status;return _context10.abrupt('return',{text:_context10.t0,status:_context10.t1});case 8:case'end':return _context10.stop();}}},_callee10,this);}));function searchCustomersBy(_x15,_x16,_x17){return _ref10.apply(this,arguments);}return searchCustomersBy;}()},{key:'getShippingMethod',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/getShippingMethod',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context11.sent;return _context11.abrupt('return',result.json());case 4:case'end':return _context11.stop();}}},_callee11,this);}));function getShippingMethod(_x18){return _ref11.apply(this,arguments);}return getShippingMethod;}()},{key:'getShippingMode',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/getShippingMode',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context12.sent;return _context12.abrupt('return',result.json());case 4:case'end':return _context12.stop();}}},_callee12,this);}));function getShippingMode(_x19){return _ref12.apply(this,arguments);}return getShippingMode;}()},{key:'getShippingTerm',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/getShippingTerm',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context13.sent;return _context13.abrupt('return',result.json());case 4:case'end':return _context13.stop();}}},_callee13,this);}));function getShippingTerm(_x20){return _ref13.apply(this,arguments);}return getShippingTerm;}()},{key:'getSampleType',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/getSampleType',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context14.sent;return _context14.abrupt('return',result.json());case 4:case'end':return _context14.stop();}}},_callee14,this);}));function getSampleType(_x21){return _ref14.apply(this,arguments);}return getSampleType;}()},{key:'systemTrim',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/SystemTrims',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(value)});case 2:result=_context15.sent;return _context15.abrupt('return',result.json());case 4:case'end':return _context15.stop();}}},_callee15,this);}));function systemTrim(_x22){return _ref15.apply(this,arguments);}return systemTrim;}()},{key:'createpomMaster',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/Pom/createpomMaster',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(value)});case 2:result=_context16.sent;_context16.t0=result.status;_context16.next=6;return result.json();case 6:_context16.t1=_context16.sent;return _context16.abrupt('return',{status:_context16.t0,text:_context16.t1});case 8:case'end':return _context16.stop();}}},_callee16,this);}));function createpomMaster(_x23){return _ref16.apply(this,arguments);}return createpomMaster;}()},{key:'getPomMaster',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/Pom/getpomMaster/'+id),{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context17.sent;_context17.t0=result.status;_context17.next=6;return result.json();case 6:_context17.t1=_context17.sent;return _context17.abrupt('return',{status:_context17.t0,text:_context17.t1});case 8:case'end':return _context17.stop();}}},_callee17,this);}));function getPomMaster(_x24){return _ref17.apply(this,arguments);}return getPomMaster;}()},{key:'garmentPomSave',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(payload,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/customer/'+id+'/garmentdetails'),{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(payload)});case 2:result=_context18.sent;_context18.t0=result.status;_context18.next=6;return result.json();case 6:_context18.t1=_context18.sent;return _context18.abrupt('return',{status:_context18.t0,text:_context18.t1});case 8:case'end':return _context18.stop();}}},_callee18,this);}));function garmentPomSave(_x25,_x26){return _ref18.apply(this,arguments);}return garmentPomSave;}()},{key:'garmentPomDelete',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(customerId,garmId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/customer/'+customerId+'/pom/'+garmId),{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context19.sent;_context19.t0=result.status;_context19.next=6;return result.json();case 6:_context19.t1=_context19.sent;return _context19.abrupt('return',{status:_context19.t0,text:_context19.t1});case 8:case'end':return _context19.stop();}}},_callee19,this);}));function garmentPomDelete(_x27,_x28){return _ref19.apply(this,arguments);}return garmentPomDelete;}()}]);return CustomerServices;}();/* harmony default export */ __webpack_exports__["a"] = (new CustomerServices());

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MeetingNotesServices=function(){function MeetingNotesServices(){_classCallCheck(this,MeetingNotesServices);}_createClass(MeetingNotesServices,[{key:'listMeetingNotes',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(activePage){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/MeetingNotes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:activePage})});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function listMeetingNotes(_x){return _ref.apply(this,arguments);}return listMeetingNotes;}()},{key:'createMeetingNote',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(meetingNote){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/addMeetingNotes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(meetingNote)});case 2:result=_context2.sent;_context2.next=5;return result.json();case 5:_context2.t0=_context2.sent;_context2.t1=result.status;return _context2.abrupt('return',{text:_context2.t0,status:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function createMeetingNote(_x2){return _ref2.apply(this,arguments);}return createMeetingNote;}()},{key:'cloneMeeting',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/cloneMN',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context3.sent;return _context3.abrupt('return',result.json());case 4:case'end':return _context3.stop();}}},_callee3,this);}));function cloneMeeting(_x3){return _ref3.apply(this,arguments);}return cloneMeeting;}()},{key:'getMeetingNote',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/viewMeetingNote',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context4.sent;_context4.next=5;return result.json();case 5:_context4.t0=_context4.sent;_context4.t1=result.status;return _context4.abrupt('return',{text:_context4.t0,status:_context4.t1});case 8:case'end':return _context4.stop();}}},_callee4,this);}));function getMeetingNote(_x4){return _ref4.apply(this,arguments);}return getMeetingNote;}()},{key:'removeMeeting',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/MeetingNote',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context5.sent;_context5.next=5;return result.json();case 5:_context5.t0=_context5.sent;_context5.t1=result.status;return _context5.abrupt('return',{text:_context5.t0,status:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function removeMeeting(_x5){return _ref5.apply(this,arguments);}return removeMeeting;}()},{key:'searchMeetingNotesBy',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(by,value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/searchMeetingNotes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by})});case 2:result=_context6.sent;_context6.t0=result.status;_context6.next=6;return result.json();case 6:_context6.t1=_context6.sent;return _context6.abrupt('return',{status:_context6.t0,text:_context6.t1});case 8:case'end':return _context6.stop();}}},_callee6,this);}));function searchMeetingNotesBy(_x6,_x7){return _ref6.apply(this,arguments);}return searchMeetingNotesBy;}()//search and select meetingid
},{key:'searchAndSelectMeetingId',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(by,value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/listSearchMN',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by})});case 2:result=_context7.sent;_context7.t0=result.status;_context7.next=6;return result.json();case 6:_context7.t1=_context7.sent;return _context7.abrupt('return',{status:_context7.t0,text:_context7.t1});case 8:case'end':return _context7.stop();}}},_callee7,this);}));function searchAndSelectMeetingId(_x8,_x9){return _ref7.apply(this,arguments);}return searchAndSelectMeetingId;}()},{key:'getGarmentInfo',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(by,value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/Systemstyles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:"STYLE",subHeading:"GARMENTTYPE"})});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt('return',{status:_context8.t0,text:_context8.t1});case 8:case'end':return _context8.stop();}}},_callee8,this);}));function getGarmentInfo(_x10,_x11){return _ref8.apply(this,arguments);}return getGarmentInfo;}()},{key:'saveSketch',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(sketch){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/saveSketch',{method:"POST",headers:{'Accept':'application/json',// 'Content-Type': 'application/json',
'AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(sketch)});case 2:result=_context9.sent;_context9.t0=result.status;_context9.next=6;return result.json();case 6:_context9.t1=_context9.sent;return _context9.abrupt('return',{status:_context9.t0,text:_context9.t1});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function saveSketch(_x12){return _ref9.apply(this,arguments);}return saveSketch;}()},{key:'uploadNewImage',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(image){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:formData=new FormData();formData.append("referenceImages",image);_context10.next=4;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/uploadImagesSketch',{method:"POST",headers:{'Accept':'application/json',// 'Content-Type': 'application/json',
'AuthToken':localStorage.getItem("authToken")},body:formData});case 4:result=_context10.sent;return _context10.abrupt('return',result.json());case 6:case'end':return _context10.stop();}}},_callee10,this);}));function uploadNewImage(_x13){return _ref10.apply(this,arguments);}return uploadNewImage;}()},{key:'removeSketch',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(MNId,sketchId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/deleteSketch',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({sketchId:sketchId,meetingNoteId:MNId})});case 2:result=_context11.sent;return _context11.abrupt('return',result.json());case 4:case'end':return _context11.stop();}}},_callee11,this);}));function removeSketch(_x14,_x15){return _ref11.apply(this,arguments);}return removeSketch;}()},{key:'getSystemMeetingNote',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/MeetingNotes',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context12.sent;_context12.t0=result.status;_context12.next=6;return result.json();case 6:_context12.t1=_context12.sent;return _context12.abrupt('return',{status:_context12.t0,text:_context12.t1});case 8:case'end':return _context12.stop();}}},_callee12,this);}));function getSystemMeetingNote(){return _ref12.apply(this,arguments);}return getSystemMeetingNote;}()},{key:'getMeetingIDAndBarcode',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/meetingNotesQR',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context13.sent;_context13.t0=result.status;_context13.next=6;return result.json();case 6:_context13.t1=_context13.sent;return _context13.abrupt('return',{status:_context13.t0,text:_context13.t1});case 8:case'end':return _context13.stop();}}},_callee13,this);}));function getMeetingIDAndBarcode(){return _ref13.apply(this,arguments);}return getMeetingIDAndBarcode;}()}]);return MeetingNotesServices;}();/* harmony default export */ __webpack_exports__["a"] = (new MeetingNotesServices());

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var StyleServices=function(){function StyleServices(){_classCallCheck(this,StyleServices);}_createClass(StyleServices,[{key:'listStyles',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/styles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function listStyles(_x){return _ref.apply(this,arguments);}return listStyles;}()},{key:'getStylePrefilledData',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getStyle',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function getStylePrefilledData(){return _ref2.apply(this,arguments);}return getStylePrefilledData;}()},{key:'removeStyle',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/style',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleId:id})});case 2:result=_context3.sent;_context3.next=5;return result.json();case 5:_context3.t0=_context3.sent;_context3.t1=result.status;return _context3.abrupt('return',{text:_context3.t0,status:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function removeStyle(_x2){return _ref3.apply(this,arguments);}return removeStyle;}()},{key:'imageUpload',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(value){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:formData=new FormData();// formData.append("refImage",value)
// for (let i = 0; i < value.length; i++) {
formData.append("referenceImages",value);formData.append("fileType",'fabric');// }
_context4.next=5;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/uploadReferenceSketch',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 5:result=_context4.sent;_context4.t0=result.status;_context4.next=9;return result.json();case 9:_context4.t1=_context4.sent;return _context4.abrupt('return',{status:_context4.t0,text:_context4.t1});case 11:case'end':return _context4.stop();}}},_callee4,this);}));function imageUpload(_x3){return _ref4.apply(this,arguments);}return imageUpload;}()},{key:'getStyleOrigination',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getStyleOrigination',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:""})});case 2:result=_context5.sent;_context5.t0=result.status;_context5.next=6;return result.json();case 6:_context5.t1=_context5.sent;return _context5.abrupt('return',{status:_context5.t0,text:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function getStyleOrigination(_x4){return _ref5.apply(this,arguments);}return getStyleOrigination;}()},{key:'getActionedBy',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style//getActionedBy',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context6.sent;return _context6.abrupt('return',result.json());case 4:case'end':return _context6.stop();}}},_callee6,this);}));function getActionedBy(_x5){return _ref6.apply(this,arguments);}return getActionedBy;}()},{key:'createStyle',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/saveStyle',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context7.sent;_context7.next=5;return result.json();case 5:_context7.t0=_context7.sent;_context7.t1=result.status;return _context7.abrupt('return',{text:_context7.t0,status:_context7.t1});case 8:case'end':return _context7.stop();}}},_callee7,this);}));function createStyle(_x6){return _ref7.apply(this,arguments);}return createStyle;}()},{key:'createReference',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/saveOption',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt('return',{status:_context8.t0,text:_context8.t1});case 8:case'end':return _context8.stop();}}},_callee8,this);}));function createReference(_x7){return _ref8.apply(this,arguments);}return createReference;}()},{key:'deleteReference',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(styleId,referenceId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/option',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleId:styleId,referenceId:referenceId})});case 2:result=_context9.sent;_context9.next=5;return result.json();case 5:_context9.t0=_context9.sent;_context9.t1=result.status;return _context9.abrupt('return',{text:_context9.t0,status:_context9.t1});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function deleteReference(_x8,_x9){return _ref9.apply(this,arguments);}return deleteReference;}()},{key:'deleteReference1',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(styleId,referenceId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/deleteReference',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleId:styleId,referenceCode:referenceId})});case 2:result=_context10.sent;_context10.next=5;return result.json();case 5:_context10.t0=_context10.sent;_context10.t1=result.status;return _context10.abrupt('return',{text:_context10.t0,status:_context10.t1});case 8:case'end':return _context10.stop();}}},_callee10,this);}));function deleteReference1(_x10,_x11){return _ref10.apply(this,arguments);}return deleteReference1;}()},{key:'listIB',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(referenceId,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/IBList',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleReferenceId:referenceId,page:page})});case 2:result=_context11.sent;_context11.t0=result.status;_context11.next=6;return result.json();case 6:_context11.t1=_context11.sent;return _context11.abrupt('return',{status:_context11.t0,text:_context11.t1});case 8:case'end':return _context11.stop();}}},_callee11,this);}));function listIB(_x12,_x13){return _ref11.apply(this,arguments);}return listIB;}()},{key:'listSMV',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(referenceId,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/SMV',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleReferenceId:referenceId,page:page})});case 2:result=_context12.sent;_context12.t0=result.status;_context12.next=6;return result.json();case 6:_context12.t1=_context12.sent;return _context12.abrupt('return',{status:_context12.t0,text:_context12.t1});case 8:case'end':return _context12.stop();}}},_callee12,this);}));function listSMV(_x14,_x15){return _ref12.apply(this,arguments);}return listSMV;}()},{key:'listThreadConsumption',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/threadConsumptions',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({magnumStyleId:localStorage.getItem("styleId"),styleReferenceId:localStorage.getItem("referenceId")})});case 2:result=_context13.sent;return _context13.abrupt('return',result.json());case 4:case'end':return _context13.stop();}}},_callee13,this);}));function listThreadConsumption(){return _ref13.apply(this,arguments);}return listThreadConsumption;}()},{key:'prefillSMVInfo',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/SMVDetails',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context14.sent;_context14.t0=result.status;_context14.next=6;return result.json();case 6:_context14.t1=_context14.sent;return _context14.abrupt('return',{status:_context14.t0,text:_context14.t1});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function prefillSMVInfo(){return _ref14.apply(this,arguments);}return prefillSMVInfo;}()},{key:'createSMV',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(fullInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/AddSMV',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(fullInfo)});case 2:result=_context15.sent;_context15.t0=result.status;_context15.next=6;return result.json();case 6:_context15.t1=_context15.sent;return _context15.abrupt('return',{status:_context15.t0,text:_context15.t1});case 8:case'end':return _context15.stop();}}},_callee15,this);}));function createSMV(_x16){return _ref15.apply(this,arguments);}return createSMV;}()},{key:'editSMV',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(fullInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/editSMV',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({magnumStyleId:localStorage.getItem("styleId"),styleReferenceId:localStorage.getItem("referenceId"),smvId:fullInfo.smvId,sampleType:fullInfo.sampleType,sampleDate:fullInfo.sampleDate,size:fullInfo.size,chartPreparedOn:fullInfo.chartPreparedOn,data:fullInfo.data})});case 2:result=_context16.sent;return _context16.abrupt('return',result.json());case 4:case'end':return _context16.stop();}}},_callee16,this);}));function editSMV(_x17){return _ref16.apply(this,arguments);}return editSMV;}()},{key:'removeSmv',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/SMV',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({smvId:id})});case 2:result=_context17.sent;return _context17.abrupt('return',result.json());case 4:case'end':return _context17.stop();}}},_callee17,this);}));function removeSmv(_x18){return _ref17.apply(this,arguments);}return removeSmv;}()},{key:'getSMV',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getSMV',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({smvId:id})});case 2:result=_context18.sent;_context18.t0=result.status;_context18.next=6;return result.json();case 6:_context18.t1=_context18.sent;return _context18.abrupt('return',{status:_context18.t0,text:_context18.t1});case 8:case'end':return _context18.stop();}}},_callee18,this);}));function getSMV(_x19){return _ref18.apply(this,arguments);}return getSMV;}()},{key:'getSMVCustomerData',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(customerId,departmentId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getSMVCustomerData',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({customerId:customerId,departmentId:departmentId})});case 2:result=_context19.sent;_context19.t0=result.status;_context19.next=6;return result.json();case 6:_context19.t1=_context19.sent;return _context19.abrupt('return',{status:_context19.t0,text:_context19.t1});case 8:case'end':return _context19.stop();}}},_callee19,this);}));function getSMVCustomerData(_x20,_x21){return _ref19.apply(this,arguments);}return getSMVCustomerData;}()},{key:'removeThread',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/ThreadConsumption',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({tcId:id})});case 2:result=_context20.sent;_context20.t0=result.status;_context20.next=6;return result.json();case 6:_context20.t1=_context20.sent;return _context20.abrupt('return',{status:_context20.t0,text:_context20.t1});case 8:case'end':return _context20.stop();}}},_callee20,this);}));function removeThread(_x22){return _ref20.apply(this,arguments);}return removeThread;}()},{key:'getSpecificThread',value:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getThreadConsumption',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({tcId:id})});case 2:result=_context21.sent;_context21.t0=result.status;_context21.next=6;return result.json();case 6:_context21.t1=_context21.sent;return _context21.abrupt('return',{status:_context21.t0,text:_context21.t1});case 8:case'end':return _context21.stop();}}},_callee21,this);}));function getSpecificThread(_x23){return _ref21.apply(this,arguments);}return getSpecificThread;}()},{key:'createThread',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(fullData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/AddThreadConsumption',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(fullData)});case 2:result=_context22.sent;_context22.t0=result.status;_context22.next=6;return result.json();case 6:_context22.t1=_context22.sent;return _context22.abrupt('return',{status:_context22.t0,text:_context22.t1});case 8:case'end':return _context22.stop();}}},_callee22,this);}));function createThread(_x24){return _ref22.apply(this,arguments);}return createThread;}()},{key:'editThread',value:function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(fullData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/editThreadConsumption',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({tcId:fullData.threadId!==undefined?fullData.threadId:"",magnumStyleId:localStorage.getItem("styleId"),styleReferenceId:localStorage.getItem("referenceId"),sampleType:fullData.threadInfo.sampleType!==undefined&&fullData.threadInfo.sampleType.name!==undefined?fullData.threadInfo.sampleType._id:fullData.threadInfo.sampleType,sampleDate:fullData.threadInfo.sampleDate,size:fullData.threadInfo.size,chartPreparedOn:fullData.threadInfo.chartPreparedOn,data:fullData.threadCount,wastage:fullData.wastage,otherSizes:fullData.otherSizes})});case 2:result=_context23.sent;return _context23.abrupt('return',result.json());case 4:case'end':return _context23.stop();}}},_callee23,this);}));function editThread(_x25){return _ref23.apply(this,arguments);}return editThread;}()},{key:'createTechnicalIssue',value:function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(fullData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:_context24.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/technicalIssue',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(fullData)});case 2:result=_context24.sent;_context24.t0=result.status;_context24.next=6;return result.json();case 6:_context24.t1=_context24.sent;return _context24.abrupt('return',{status:_context24.t0,text:_context24.t1});case 8:case'end':return _context24.stop();}}},_callee24,this);}));function createTechnicalIssue(_x26){return _ref24.apply(this,arguments);}return createTechnicalIssue;}()},{key:'getStyleInfo',value:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getStyle',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context25.sent;_context25.t0=result.status;_context25.next=6;return result.json();case 6:_context25.t1=_context25.sent;return _context25.abrupt('return',{status:_context25.t0,text:_context25.t1});case 8:case'end':return _context25.stop();}}},_callee25,this);}));function getStyleInfo(_x27){return _ref25.apply(this,arguments);}return getStyleInfo;}()},{key:'getReferenceInfo',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getReferenceById',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({referenceId:id})});case 2:result=_context26.sent;return _context26.abrupt('return',result.json());case 4:case'end':return _context26.stop();}}},_callee26,this);}));function getReferenceInfo(_x28){return _ref26.apply(this,arguments);}return getReferenceInfo;}()},{key:'searchStylesBy',value:function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/searchStyleslist',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context27.sent;_context27.t0=result.status;_context27.next=6;return result.json();case 6:_context27.t1=_context27.sent;return _context27.abrupt('return',{status:_context27.t0,text:_context27.t1});case 8:case'end':return _context27.stop();}}},_callee27,this);}));function searchStylesBy(_x29,_x30,_x31){return _ref27.apply(this,arguments);}return searchStylesBy;}()},{key:'searchCosting',value:function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(costingBy,costingVal){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/searchCostinglist',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:costingVal,by:costingBy})});case 2:result=_context28.sent;return _context28.abrupt('return',result.json());case 4:case'end':return _context28.stop();}}},_callee28,this);}));function searchCosting(_x32,_x33){return _ref28.apply(this,arguments);}return searchCosting;}()},{key:'getSampleRequest',value:function(){var _ref29=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee29(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29){while(1){switch(_context29.prev=_context29.next){case 0:_context29.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getSRByReference',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({referenceId:id})});case 2:result=_context29.sent;return _context29.abrupt('return',result.json());case 4:case'end':return _context29.stop();}}},_callee29,this);}));function getSampleRequest(_x34){return _ref29.apply(this,arguments);}return getSampleRequest;}()//QRCode for reference
},{key:'getQRCodeForReferenceStyle',value:function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee30(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30){while(1){switch(_context30.prev=_context30.next){case 0:_context30.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/generateQrOptions',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleId:id})});case 2:result=_context30.sent;_context30.next=5;return result.json();case 5:_context30.t0=_context30.sent;_context30.t1=result.status;return _context30.abrupt('return',{text:_context30.t0,status:_context30.t1});case 8:case'end':return _context30.stop();}}},_callee30,this);}));function getQRCodeForReferenceStyle(_x35){return _ref30.apply(this,arguments);}return getQRCodeForReferenceStyle;}()//QRCode for reference
},{key:'getOptionsStyle',value:function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee31(styleId,referenceId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:_context31.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getOptionsStyle',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleId:styleId,referenceId:referenceId})});case 2:result=_context31.sent;_context31.t0=result.status;_context31.next=6;return result.json();case 6:_context31.t1=_context31.sent;return _context31.abrupt('return',{status:_context31.t0,text:_context31.t1});case 8:case'end':return _context31.stop();}}},_callee31,this);}));function getOptionsStyle(_x36,_x37){return _ref31.apply(this,arguments);}return getOptionsStyle;}()//saveIb
},{key:'saveIB',value:function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee32(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:_context32.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/saveStyleInfo',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context32.sent;_context32.t0=result.status;_context32.next=6;return result.json();case 6:_context32.t1=_context32.sent;return _context32.abrupt('return',{status:_context32.t0,text:_context32.t1});case 8:case'end':return _context32.stop();}}},_callee32,this);}));function saveIB(_x38){return _ref32.apply(this,arguments);}return saveIB;}()//listStyleSubModule
},{key:'listStyleSubModule',value:function(){var _ref33=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee33(moduleLink,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:_context33.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/style/'+moduleLink),{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context33.sent;_context33.t0=result.status;_context33.next=6;return result.json();case 6:_context33.t1=_context33.sent;return _context33.abrupt('return',{status:_context33.t0,text:_context33.t1});case 8:case'end':return _context33.stop();}}},_callee33,this);}));function listStyleSubModule(_x39,_x40){return _ref33.apply(this,arguments);}return listStyleSubModule;}()//search Style
},{key:'SearchStyle',value:function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee34(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34){while(1){switch(_context34.prev=_context34.next){case 0:_context34.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/Search',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleNumber:value})});case 2:result=_context34.sent;_context34.t0=result.status;_context34.next=6;return result.json();case 6:_context34.t1=_context34.sent;return _context34.abrupt('return',{status:_context34.t0,text:_context34.t1});case 8:case'end':return _context34.stop();}}},_callee34,this);}));function SearchStyle(_x41){return _ref34.apply(this,arguments);}return SearchStyle;}()//Bnumber
//Show Predefind values (Types Of Test, Greige Mill  ,Process Mill )
},{key:'getBNumberPrefilldData',value:function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee35(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35){while(1){switch(_context35.prev=_context35.next){case 0:_context35.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getBNumberPrefilledData',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}// body : JSON.stringify({
});case 2:result=_context35.sent;_context35.t0=result.status;_context35.next=6;return result.json();case 6:_context35.t1=_context35.sent;return _context35.abrupt('return',{status:_context35.t0,text:_context35.t1});case 8:case'end':return _context35.stop();}}},_callee35,this);}));function getBNumberPrefilldData(){return _ref35.apply(this,arguments);}return getBNumberPrefilldData;}()},{key:'searchFilterForStyleNumber',value:function(){var _ref36=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee36(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36){while(1){switch(_context36.prev=_context36.next){case 0:_context36.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getStyleByRange',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem('authToken')},body:JSON.stringify(data)});case 2:result=_context36.sent;return _context36.abrupt('return',result.json());case 4:case'end':return _context36.stop();}}},_callee36,this);}));function searchFilterForStyleNumber(_x42){return _ref36.apply(this,arguments);}return searchFilterForStyleNumber;}()},{key:'getStyleInfoByReference',value:function(){var _ref37=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee37(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37){while(1){switch(_context37.prev=_context37.next){case 0:_context37.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/costing/getSampleRequestByStyle',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"referenceId":id})});case 2:result=_context37.sent;_context37.t0=result.status;_context37.next=6;return result.json();case 6:_context37.t1=_context37.sent;return _context37.abrupt('return',{status:_context37.t0,text:_context37.t1});case 8:case'end':return _context37.stop();}}},_callee37,this);}));function getStyleInfoByReference(_x43){return _ref37.apply(this,arguments);}return getStyleInfoByReference;}()},{key:'getTechnicalIssues',value:function(){var _ref38=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee38(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38){while(1){switch(_context38.prev=_context38.next){case 0:_context38.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getTechnicalIssue',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({"_id":id})});case 2:result=_context38.sent;_context38.t0=result.status;_context38.next=6;return result.json();case 6:_context38.t1=_context38.sent;return _context38.abrupt('return',{status:_context38.t0,text:_context38.t1});case 8:case'end':return _context38.stop();}}},_callee38,this);}));function getTechnicalIssues(_x44){return _ref38.apply(this,arguments);}return getTechnicalIssues;}()},{key:'getSampleType',value:function(){var _ref39=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee39(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39){while(1){switch(_context39.prev=_context39.next){case 0:_context39.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/Systemstyles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({heading:"STYLE",subHeading:"SAMPLETYPE"})});case 2:result=_context39.sent;_context39.t0=result.status;_context39.next=6;return result.json();case 6:_context39.t1=_context39.sent;return _context39.abrupt('return',{status:_context39.t0,text:_context39.t1});case 8:case'end':return _context39.stop();}}},_callee39,this);}));function getSampleType(){return _ref39.apply(this,arguments);}return getSampleType;}()},{key:'getSMVByRefId',value:function(){var _ref40=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee40(referenceId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40){while(1){switch(_context40.prev=_context40.next){case 0:_context40.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/SMV',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleReferenceId:referenceId})});case 2:result=_context40.sent;_context40.t0=result.status;_context40.next=6;return result.json();case 6:_context40.t1=_context40.sent;return _context40.abrupt('return',{status:_context40.t0,text:_context40.t1});case 8:case'end':return _context40.stop();}}},_callee40,this);}));function getSMVByRefId(_x45){return _ref40.apply(this,arguments);}return getSMVByRefId;}()},{key:'searchSMVList',value:function(){var _ref41=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee41(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41){while(1){switch(_context41.prev=_context41.next){case 0:_context41.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/searchSMVlist',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context41.sent;_context41.t0=result.status;_context41.next=6;return result.json();case 6:_context41.t1=_context41.sent;return _context41.abrupt('return',{status:_context41.t0,text:_context41.t1});case 8:case'end':return _context41.stop();}}},_callee41,this);}));function searchSMVList(_x46,_x47,_x48){return _ref41.apply(this,arguments);}return searchSMVList;}()},{key:'listTI',value:function(){var _ref42=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee42(referenceId,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42){while(1){switch(_context42.prev=_context42.next){case 0:_context42.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/techIssueList',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleReferenceId:referenceId,page:page})});case 2:result=_context42.sent;_context42.t0=result.status;_context42.next=6;return result.json();case 6:_context42.t1=_context42.sent;return _context42.abrupt('return',{status:_context42.t0,text:_context42.t1});case 8:case'end':return _context42.stop();}}},_callee42,this);}));function listTI(_x49,_x50){return _ref42.apply(this,arguments);}return listTI;}()},{key:'removeTechIssue',value:function(){var _ref43=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee43(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43){while(1){switch(_context43.prev=_context43.next){case 0:_context43.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/techIssue',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context43.sent;_context43.t0=result.status;_context43.next=6;return result.json();case 6:_context43.t1=_context43.sent;return _context43.abrupt('return',{status:_context43.t0,text:_context43.t1});case 8:case'end':return _context43.stop();}}},_callee43,this);}));function removeTechIssue(_x51){return _ref43.apply(this,arguments);}return removeTechIssue;}()},{key:'searchTIlist',value:function(){var _ref44=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee44(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44){while(1){switch(_context44.prev=_context44.next){case 0:_context44.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/searchTIlist',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context44.sent;_context44.t0=result.status;_context44.next=6;return result.json();case 6:_context44.t1=_context44.sent;return _context44.abrupt('return',{status:_context44.t0,text:_context44.t1});case 8:case'end':return _context44.stop();}}},_callee44,this);}));function searchTIlist(_x52,_x53,_x54){return _ref44.apply(this,arguments);}return searchTIlist;}()}]);return StyleServices;}();/* harmony default export */ __webpack_exports__["a"] = (new StyleServices());

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CostingServices=function(){function CostingServices(){_classCallCheck(this,CostingServices);}_createClass(CostingServices,[{key:"listCostings",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page,sampleRequestId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getCostingList",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({page:page,sampleRequestId:sampleRequestId})});case 2:result=_context.sent;_context.next=5;return result.json();case 5:_context.t0=_context.sent;_context.t1=result.status;return _context.abrupt("return",{text:_context.t0,status:_context.t1});case 8:case"end":return _context.stop();}}},_callee,this);}));function listCostings(_x,_x2){return _ref.apply(this,arguments);}return listCostings;}()},{key:"removeCosting",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/deleteCostingById",{method:"DELETE",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context2.sent;_context2.next=5;return result.json();case 5:_context2.t0=_context2.sent;_context2.t1=result.status;return _context2.abrupt("return",{text:_context2.t0,status:_context2.t1});case 8:case"end":return _context2.stop();}}},_callee2,this);}));function removeCosting(_x3){return _ref2.apply(this,arguments);}return removeCosting;}()},{key:"cloneCostings",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/cloneCosting",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context3.sent;return _context3.abrupt("return",result.json());case 4:case"end":return _context3.stop();}}},_callee3,this);}));function cloneCostings(_x4){return _ref3.apply(this,arguments);}return cloneCostings;}()},{key:"addCosting",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/saveCosting",{method:"PUT",headers:{'Accept':"application/json","Content-Type":"application/json",'AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context4.sent;_context4.t0=result.status;_context4.next=6;return result.json();case 6:_context4.t1=_context4.sent;return _context4.abrupt("return",{status:_context4.t0,text:_context4.t1});case 8:case"end":return _context4.stop();}}},_callee4,this);}));function addCosting(_x5){return _ref4.apply(this,arguments);}return addCosting;}()},{key:"editCosting",value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(data,state,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/saveCosting",{method:"PUT",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({_id:id,styleRefNumber:state.styleInfo!==undefined&&state.styleInfo.styleReferenceId,customer:state.customerInfo._id,customerDeptId:state.department._id,magnumStyleId:state.styleInfo.magnumStyleId,sampleRequestId:state.sampleNo!==undefined&&state.sampleNo.value,customerRefNo:state.customerInfo!==undefined&&state.customerInfo.customerId,fabricType:state.costingFullInfo.fabricType,buyerName:state.costingFullInfo.buyerName,setBoolean:state.set,doneBy:state.costingFullInfo.doneBy,createdBy:state.costingFullInfo.createdAt,orderDate:state.costingFullInfo.createdAt,modifiedBy:state.modifiedBy,fabricCostDetails:data[0],trimCostDetails:data[1],embroderyCostDetails:data[2],washDetails:data[3],manufacturingAndPieceCost:data[4],otherPieceCostDetails:data[5],smvCalculation:data[6],retailMargin:data[7],ratioCosting:data[8]})});case 2:result=_context5.sent;return _context5.abrupt("return",result.json());case 4:case"end":return _context5.stop();}}},_callee5,this);}));function editCosting(_x6,_x7,_x8){return _ref5.apply(this,arguments);}return editCosting;}()},{key:"getCostingInfo",value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getCostingById",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context6.sent;_context6.t0=result.status;_context6.next=6;return result.json();case 6:_context6.t1=_context6.sent;return _context6.abrupt("return",{status:_context6.t0,text:_context6.t1});case 8:case"end":return _context6.stop();}}},_callee6,this);}));function getCostingInfo(_x9){return _ref6.apply(this,arguments);}return getCostingInfo;}()//search costing and listing
},{key:"searchCosting",value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/searchCostinglist",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context7.sent;_context7.t0=result.status;_context7.next=6;return result.json();case 6:_context7.t1=_context7.sent;return _context7.abrupt("return",{status:_context7.t0,text:_context7.t1});case 8:case"end":return _context7.stop();}}},_callee7,this);}));function searchCosting(_x10,_x11,_x12){return _ref7.apply(this,arguments);}return searchCosting;}()},{key:"getSampleRequestInfo",value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getSampleRequestInfo",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({requestId:value})});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt("return",{status:_context8.t0,text:_context8.t1});case 8:case"end":return _context8.stop();}}},_callee8,this);}));function getSampleRequestInfo(_x13){return _ref8.apply(this,arguments);}return getSampleRequestInfo;}()},{key:"getCostingSystem",value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/prefilledValues",{method:"get",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")}});case 2:result=_context9.sent;_context9.t0=result.status;_context9.next=6;return result.json();case 6:_context9.t1=_context9.sent;return _context9.abrupt("return",{status:_context9.t0,text:_context9.t1});case 8:case"end":return _context9.stop();}}},_callee9,this);}));function getCostingSystem(){return _ref9.apply(this,arguments);}return getCostingSystem;}()},{key:"getTrimPackByCustomer",value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(customer,customerDepartmentId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getTrimPack",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({customer:customer,customerDepartmentId:customerDepartmentId})});case 2:result=_context10.sent;_context10.t0=result.status;_context10.next=6;return result.json();case 6:_context10.t1=_context10.sent;return _context10.abrupt("return",{status:_context10.t0,text:_context10.t1});case 8:case"end":return _context10.stop();}}},_callee10,this);}));function getTrimPackByCustomer(_x14,_x15){return _ref10.apply(this,arguments);}return getTrimPackByCustomer;}()},{key:"getSupplierSectionFabric",value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(fabricId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getSupplier/fabric",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({fabricId:fabricId})});case 2:result=_context11.sent;_context11.t0=result.status;_context11.next=6;return result.json();case 6:_context11.t1=_context11.sent;return _context11.abrupt("return",{status:_context11.t0,text:_context11.t1});case 8:case"end":return _context11.stop();}}},_callee11,this);}));function getSupplierSectionFabric(_x16){return _ref11.apply(this,arguments);}return getSupplierSectionFabric;}()},{key:"getSupplierSectionTrim",value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(trimId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/getSupplier/trim",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({trimId:trimId})});case 2:result=_context12.sent;_context12.t0=result.status;_context12.next=6;return result.json();case 6:_context12.t1=_context12.sent;return _context12.abrupt("return",{status:_context12.t0,text:_context12.t1});case 8:case"end":return _context12.stop();}}},_callee12,this);}));function getSupplierSectionTrim(_x17){return _ref12.apply(this,arguments);}return getSupplierSectionTrim;}()},{key:"costingNumber",value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/generateCostingId",{method:"GET",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")}});case 2:result=_context13.sent;_context13.t0=result.status;_context13.next=6;return result.json();case 6:_context13.t1=_context13.sent;return _context13.abrupt("return",{status:_context13.t0,text:_context13.t1});case 8:case"end":return _context13.stop();}}},_callee13,this);}));function costingNumber(){return _ref13.apply(this,arguments);}return costingNumber;}()},{key:"costingCompare",value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(ids){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/costing/compareCostings",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({ids:ids})});case 2:result=_context14.sent;_context14.t0=result.status;_context14.next=6;return result.json();case 6:_context14.t1=_context14.sent;return _context14.abrupt("return",{status:_context14.t0,text:_context14.t1});case 8:case"end":return _context14.stop();}}},_callee14,this);}));function costingCompare(_x18){return _ref14.apply(this,arguments);}return costingCompare;}()}]);return CostingServices;}();/* harmony default export */ __webpack_exports__["a"] = (new CostingServices());

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PermissionService=function(){function PermissionService(){_classCallCheck(this,PermissionService);}_createClass(PermissionService,[{key:'listEmploye',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/Employees',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function listEmploye(_x){return _ref.apply(this,arguments);}return listEmploye;}()},{key:'searchEmploye',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(searchText){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/searchEmployees',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({searchText:searchText})});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function searchEmploye(_x2){return _ref2.apply(this,arguments);}return searchEmploye;}()},{key:'listRoles',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/roles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function listRoles(_x3){return _ref3.apply(this,arguments);}return listRoles;}()},{key:'updateRoleRights',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(obj){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/updateRoleRights',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 2:result=_context4.sent;_context4.t0=result.status;_context4.next=6;return result.json();case 6:_context4.t1=_context4.sent;return _context4.abrupt('return',{status:_context4.t0,text:_context4.t1});case 8:case'end':return _context4.stop();}}},_callee4,this);}));function updateRoleRights(_x4){return _ref4.apply(this,arguments);}return updateRoleRights;}()},{key:'getRoleRights',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/getRoleRights',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({roleId:_id})});case 2:result=_context5.sent;_context5.t0=result.status;_context5.next=6;return result.json();case 6:_context5.t1=_context5.sent;return _context5.abrupt('return',{status:_context5.t0,text:_context5.t1});case 8:case'end':return _context5.stop();}}},_callee5,this);}));function getRoleRights(_x5){return _ref5.apply(this,arguments);}return getRoleRights;}()},{key:'getRole',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/getRoleName',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({roleId:id})});case 2:result=_context6.sent;_context6.t0=result.status;_context6.next=6;return result.json();case 6:_context6.t1=_context6.sent;return _context6.abrupt('return',{status:_context6.t0,text:_context6.t1});case 8:case'end':return _context6.stop();}}},_callee6,this);}));function getRole(_x6){return _ref6.apply(this,arguments);}return getRole;}()},{key:'createRole',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(role,description){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/addRole',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({roleName:role,description:description})});case 2:result=_context7.sent;_context7.t0=result.status;_context7.next=6;return result.json();case 6:_context7.t1=_context7.sent;return _context7.abrupt('return',{status:_context7.t0,text:_context7.t1});case 8:case'end':return _context7.stop();}}},_callee7,this);}));function createRole(_x7,_x8){return _ref7.apply(this,arguments);}return createRole;}()},{key:'editRole',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(id,role,description){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/addRole',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,roleName:role,description:description})});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt('return',{status:_context8.t0,text:_context8.t1});case 8:case'end':return _context8.stop();}}},_callee8,this);}));function editRole(_x9,_x10,_x11){return _ref8.apply(this,arguments);}return editRole;}()},{key:'removeRole',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/deleteRole',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context9.sent;_context9.t0=result.status;_context9.next=6;return result.json();case 6:_context9.t1=_context9.sent;return _context9.abrupt('return',{status:_context9.t0,text:_context9.t1});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function removeRole(_x12){return _ref9.apply(this,arguments);}return removeRole;}()},{key:'searchRoles',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(by,value,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/permission/searchRoles',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by,page:page})});case 2:result=_context10.sent;_context10.t0=result.status;_context10.next=6;return result.json();case 6:_context10.t1=_context10.sent;return _context10.abrupt('return',{status:_context10.t0,text:_context10.t1});case 8:case'end':return _context10.stop();}}},_callee10,this);}));function searchRoles(_x13,_x14,_x15){return _ref10.apply(this,arguments);}return searchRoles;}()},{key:'searchEmployeeList',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(by,value,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/searchEmployeesByKey',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by,page:page})});case 2:result=_context11.sent;_context11.t0=result.status;_context11.next=6;return result.json();case 6:_context11.t1=_context11.sent;return _context11.abrupt('return',{status:_context11.t0,text:_context11.t1});case 8:case'end':return _context11.stop();}}},_callee11,this);}));function searchEmployeeList(_x16,_x17,_x18){return _ref11.apply(this,arguments);}return searchEmployeeList;}()},{key:'getEmploye',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/employee',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context12.sent;_context12.t0=result.status;_context12.next=6;return result.json();case 6:_context12.t1=_context12.sent;return _context12.abrupt('return',{status:_context12.t0,text:_context12.t1});case 8:case'end':return _context12.stop();}}},_callee12,this);}));function getEmploye(_x19){return _ref12.apply(this,arguments);}return getEmploye;}()},{key:'createEmploye',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/addEmployee',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context13.sent;_context13.t0=result.status;_context13.next=6;return result.json();case 6:_context13.t1=_context13.sent;return _context13.abrupt('return',{status:_context13.t0,text:_context13.t1});case 8:case'end':return _context13.stop();}}},_callee13,this);}));function createEmploye(_x20){return _ref13.apply(this,arguments);}return createEmploye;}()},{key:'updateEmploye',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/editEmployee',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context14.sent;_context14.t0=result.status;_context14.next=6;return result.json();case 6:_context14.t1=_context14.sent;return _context14.abrupt('return',{status:_context14.t0,text:_context14.t1});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function updateEmploye(_x21){return _ref14.apply(this,arguments);}return updateEmploye;}()},{key:'removeEmploye',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/Employee',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context15.sent;_context15.t0=result.status;_context15.next=6;return result.json();case 6:_context15.t1=_context15.sent;return _context15.abrupt('return',{status:_context15.t0,text:_context15.t1});case 8:case'end':return _context15.stop();}}},_callee15,this);}));function removeEmploye(_x22){return _ref15.apply(this,arguments);}return removeEmploye;}()},{key:'updateRights',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(obj){var api,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:api=obj.moduleName=="EMPLOYEE"?"api/employee/updateEmployeeRights":"api/permission/updateRoleRights";delete obj.moduleName;_context16.next=4;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+api,{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(obj)});case 4:result=_context16.sent;_context16.t0=result.status;_context16.next=8;return result.json();case 8:_context16.t1=_context16.sent;return _context16.abrupt('return',{status:_context16.t0,text:_context16.t1});case 10:case'end':return _context16.stop();}}},_callee16,this);}));function updateRights(_x23){return _ref16.apply(this,arguments);}return updateRights;}()},{key:'getEmployeeRights',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/EmployeeRights',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:_id})});case 2:result=_context17.sent;_context17.t0=result.status;_context17.next=6;return result.json();case 6:_context17.t1=_context17.sent;return _context17.abrupt('return',{status:_context17.t0,text:_context17.t1});case 8:case'end':return _context17.stop();}}},_callee17,this);}));function getEmployeeRights(_x24){return _ref17.apply(this,arguments);}return getEmployeeRights;}()}]);return PermissionService;}();/* harmony default export */ __webpack_exports__["a"] = (new PermissionService());

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DevelopmentServices=function(){function DevelopmentServices(){_classCallCheck(this,DevelopmentServices);}_createClass(DevelopmentServices,[{key:'getTrimDevelopmentQR',//TRIM QR
value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(val){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getTrimNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimRefNumber:val})});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function getTrimDevelopmentQR(_x){return _ref.apply(this,arguments);}return getTrimDevelopmentQR;}()//TRIM OPTIONS
},{key:'getTrimDevelopmentOptions',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/getAllSystemtrims',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function getTrimDevelopmentOptions(){return _ref2.apply(this,arguments);}return getTrimDevelopmentOptions;}()//TRIM HSN
},{key:'getTrimDevelopmentHSN',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getTrimHSN',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context3.sent;return _context3.abrupt('return',result.json());case 4:case'end':return _context3.stop();}}},_callee3,this);}));function getTrimDevelopmentHSN(_x2){return _ref3.apply(this,arguments);}return getTrimDevelopmentHSN;}()},{key:'getTrimSysUnits',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getTrimUnits',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:null});case 2:result=_context4.sent;return _context4.abrupt('return',result.json());case 4:case'end':return _context4.stop();}}},_callee4,this);}));function getTrimSysUnits(){return _ref4.apply(this,arguments);}return getTrimSysUnits;}()//fabric HSN
},{key:'getDevelopmentFabricHSN',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getHSN',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context5.sent;return _context5.abrupt('return',result.json());case 4:case'end':return _context5.stop();}}},_callee5,this);}));function getDevelopmentFabricHSN(_x3){return _ref5.apply(this,arguments);}return getDevelopmentFabricHSN;}()//TRIM MULTIPLE FILE UPLOAD
},{key:'getTrimDevelopmentMultipleFileUpload',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(value){var formData,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,iterator,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:formData=new FormData();// formData.append("refImage",value)
_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context6.prev=4;for(_iterator=value[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){iterator=_step.value;formData.append("referenceImages",iterator);}_context6.next=12;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](4);_didIteratorError=true;_iteratorError=_context6.t0;case 12:_context6.prev=12;_context6.prev=13;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 15:_context6.prev=15;if(!_didIteratorError){_context6.next=18;break;}throw _iteratorError;case 18:return _context6.finish(15);case 19:return _context6.finish(12);case 20:_context6.next=22;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/uploadReferenceImages',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 22:result=_context6.sent;return _context6.abrupt('return',result.json());case 24:case'end':return _context6.stop();}}},_callee6,this,[[4,8,12,20],[13,,15,19]]);}));function getTrimDevelopmentMultipleFileUpload(_x4){return _ref6.apply(this,arguments);}return getTrimDevelopmentMultipleFileUpload;}()//ADD NEW CUSTOMER
},{key:'addNewCustomer',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(payload){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/customer/AddNewCustomer',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({payload:payload})});case 2:result=_context7.sent;return _context7.abrupt('return',result.json());case 4:case'end':return _context7.stop();}}},_callee7,this);}));function addNewCustomer(_x5){return _ref7.apply(this,arguments);}return addNewCustomer;}()},{key:'listCAD',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/cadList',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:value})});case 2:result=_context8.sent;_context8.t0=result.status;_context8.next=6;return result.json();case 6:_context8.t1=_context8.sent;return _context8.abrupt('return',{status:_context8.t0,text:_context8.t1});case 8:case'end':return _context8.stop();}}},_callee8,this);}));function listCAD(_x6){return _ref8.apply(this,arguments);}return listCAD;}()},{key:'searchCadList',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/development/searchCADDev",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context9.sent;_context9.t0=result.status;_context9.next=6;return result.json();case 6:_context9.t1=_context9.sent;return _context9.abrupt('return',{status:_context9.t0,text:_context9.t1});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function searchCadList(_x7,_x8,_x9){return _ref9.apply(this,arguments);}return searchCadList;}()},{key:'prefillDataCadSystem',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getCAD',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context10.sent;_context10.t0=result.status;_context10.next=6;return result.json();case 6:_context10.t1=_context10.sent;return _context10.abrupt('return',{status:_context10.t0,text:_context10.t1});case 8:case'end':return _context10.stop();}}},_callee10,this);}));function prefillDataCadSystem(){return _ref10.apply(this,arguments);}return prefillDataCadSystem;}()},{key:'deleteCAD',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/deleteCAD',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context11.sent;_context11.next=5;return result.json();case 5:_context11.t0=_context11.sent;_context11.t1=result.status;return _context11.abrupt('return',{text:_context11.t0,status:_context11.t1});case 8:case'end':return _context11.stop();}}},_callee11,this);}));function deleteCAD(_x10){return _ref11.apply(this,arguments);}return deleteCAD;}()},{key:'getCAD',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/viewCAD',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context12.sent;_context12.next=5;return result.json();case 5:_context12.t0=_context12.sent;_context12.t1=result.status;return _context12.abrupt('return',{text:_context12.t0,status:_context12.t1});case 8:case'end':return _context12.stop();}}},_callee12,this);}));function getCAD(_x11){return _ref12.apply(this,arguments);}return getCAD;}()},{key:'createCAD',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(cadInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/CAD',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(cadInfo)});case 2:result=_context13.sent;_context13.next=5;return result.json();case 5:_context13.t0=_context13.sent;_context13.t1=result.status;return _context13.abrupt('return',{text:_context13.t0,status:_context13.t1});case 8:case'end':return _context13.stop();}}},_callee13,this);}));function createCAD(_x12){return _ref13.apply(this,arguments);}return createCAD;}()},{key:'createReference',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(cadInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/cadOptions',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(cadInfo)});case 2:result=_context14.sent;_context14.t0=result.status;_context14.next=6;return result.json();case 6:_context14.t1=_context14.sent;return _context14.abrupt('return',{status:_context14.t0,text:_context14.t1});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function createReference(_x13){return _ref14.apply(this,arguments);}return createReference;}()},{key:'removeCADReference',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(cadId,refId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/deleteCADoption',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:cadId,CadOptionId:refId})});case 2:result=_context15.sent;return _context15.abrupt('return',result.json());case 4:case'end':return _context15.stop();}}},_callee15,this);}));function removeCADReference(_x14,_x15){return _ref15.apply(this,arguments);}return removeCADReference;}()},{key:'listBNumber',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber/Bnumbers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context16.sent;_context16.t0=result.status;_context16.next=6;return result.json();case 6:_context16.t1=_context16.sent;return _context16.abrupt('return',{status:_context16.t0,text:_context16.t1});case 8:case'end':return _context16.stop();}}},_callee16,this);}));function listBNumber(_x16){return _ref16.apply(this,arguments);}return listBNumber;}()},{key:'removeBNumber',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context17.sent;_context17.next=5;return result.json();case 5:_context17.t0=_context17.sent;_context17.t1=result.status;return _context17.abrupt('return',{text:_context17.t0,status:_context17.t1});case 8:case'end':return _context17.stop();}}},_callee17,this);}));function removeBNumber(_x17){return _ref17.apply(this,arguments);}return removeBNumber;}()},{key:'searchBNumberDev',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(searchBy,searchVal,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchBNumberDev',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:searchVal,by:searchBy,page:page})});case 2:result=_context18.sent;_context18.t0=result.status;_context18.next=6;return result.json();case 6:_context18.t1=_context18.sent;return _context18.abrupt('return',{status:_context18.t0,text:_context18.t1});case 8:case'end':return _context18.stop();}}},_callee18,this);}));function searchBNumberDev(_x18,_x19,_x20){return _ref18.apply(this,arguments);}return searchBNumberDev;}()},{key:'getFabricInfo',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchFabricNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricNumber:value})});case 2:result=_context19.sent;return _context19.abrupt('return',result.json());case 4:case'end':return _context19.stop();}}},_callee19,this);}));function getFabricInfo(_x21){return _ref19.apply(this,arguments);}return getFabricInfo;}()},{key:'getPrefillInfoForBN',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getBN',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context20.sent;return _context20.abrupt('return',result.json());case 4:case'end':return _context20.stop();}}},_callee20,this);}));function getPrefillInfoForBN(){return _ref20.apply(this,arguments);}return getPrefillInfoForBN;}()},{key:'getMagnumStyleNo',value:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/Search',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({styleNumber:value})});case 2:result=_context21.sent;return _context21.abrupt('return',result.json());case 4:case'end':return _context21.stop();}}},_callee21,this);}));function getMagnumStyleNo(_x22){return _ref21.apply(this,arguments);}return getMagnumStyleNo;}()},{key:'getMagnumStyleNoWithReference',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/getStyleInfo',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:value!==''?JSON.stringify({styleNumber:value}):''});case 2:result=_context22.sent;_context22.t0=result.status;_context22.next=6;return result.json();case 6:_context22.t1=_context22.sent;return _context22.abrupt('return',{status:_context22.t0,text:_context22.t1});case 8:case'end':return _context22.stop();}}},_callee22,this);}));function getMagnumStyleNoWithReference(_x23){return _ref22.apply(this,arguments);}return getMagnumStyleNoWithReference;}()},{key:'getMagnumStyleNoWithReferenceById',value:function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSampleRequestStyleSelect',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:value!==''?JSON.stringify({styleReferenceId:value}):''});case 2:result=_context23.sent;_context23.t0=result.status;_context23.next=6;return result.json();case 6:_context23.t1=_context23.sent;return _context23.abrupt('return',{status:_context23.t0,text:_context23.t1});case 8:case'end':return _context23.stop();}}},_callee23,this);}));function getMagnumStyleNoWithReferenceById(_x24){return _ref23.apply(this,arguments);}return getMagnumStyleNoWithReferenceById;}()},{key:'getDevRefNo',value:function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:_context24.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/generateDevRefNumber',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context24.sent;_context24.t0=result.status;_context24.next=6;return result.json();case 6:_context24.t1=_context24.sent;return _context24.abrupt('return',{status:_context24.t0,text:_context24.t1});case 8:case'end':return _context24.stop();}}},_callee24,this);}));function getDevRefNo(){return _ref24.apply(this,arguments);}return getDevRefNo;}()},{key:'createBNum',value:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context25.sent;_context25.t0=result.status;_context25.next=6;return result.json();case 6:_context25.t1=_context25.sent;return _context25.abrupt('return',{status:_context25.t0,text:_context25.t1});case 8:case'end':return _context25.stop();}}},_callee25,this);}));function createBNum(_x25){return _ref25.apply(this,arguments);}return createBNum;}()},{key:'editBNum',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(maxData,fabric,styleNo,buyer,department,washType,garmentType,supplier){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:maxData._id!==undefined?maxData._id:"",fabric:fabric.value,dateOfSubmission:maxData.dateOfSubmission,magnumStyleId:styleNo.value,customer:buyer.value,department:department.value,fabricComposition:maxData.fabricComposition,fabricComposition2:maxData.fabricComposition2,fabricComposition3:maxData.fabricComposition3,fabricDescription:maxData.fabricDescription,count:parseInt(maxData.count),construction:maxData.construction,GSM:maxData.GSM,greigeMill:maxData.greigeMill,wetProcessingMill:maxData.wetProcessingMill,laundry:washType.value,garmentDying:garmentType.value,supplier:supplier.value,approvalStatusWithDate:maxData.approvalStatusWithDate,itemNumber:maxData.itemNumber,remarks:maxData.remarks})});case 2:result=_context26.sent;return _context26.abrupt('return',result.json());case 4:case'end':return _context26.stop();}}},_callee26,this);}));function editBNum(_x26,_x27,_x28,_x29,_x30,_x31,_x32,_x33){return _ref26.apply(this,arguments);}return editBNum;}()},{key:'getBNumber',value:function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context27.sent;_context27.t0=result.status;_context27.next=6;return result.json();case 6:_context27.t1=_context27.sent;return _context27.abrupt('return',{status:_context27.t0,text:_context27.t1});case 8:case'end':return _context27.stop();}}},_callee27,this);}));function getBNumber(_x34){return _ref27.apply(this,arguments);}return getBNumber;}()},{key:'listSourcing',value:function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sourcing',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context28.sent;return _context28.abrupt('return',result.json());case 4:case'end':return _context28.stop();}}},_callee28,this);}));function listSourcing(){return _ref28.apply(this,arguments);}return listSourcing;}()},{key:'createSource',value:function(){var _ref29=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee29(data){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29){while(1){switch(_context29.prev=_context29.next){case 0:formData=new FormData();if(data._id!==undefined){formData.append("_id",data._id);}formData.append("date",data.date);formData.append("magnumStyleId",data.magnumStyleId);formData.append("MNID",data.MNID);formData.append("sourcingFor",data.sourcingFor);formData.append("originationOfRequest",data.originationOfRequest);formData.append("season",data.season);formData.append("category",data.category);formData.append("requirement",data.requirement);formData.append("color",data.color);formData.append("quantity",data.quantity);formData.append("composition",data.composition);formData.append("measurement",data.measurement);formData.append("dateRequiredAtMagnum",data.dateRequiredAtMagnum);formData.append("dateReceivedAtMagnum",data.dateReceivedAtMagnum);formData.append("additionalInfo",data.additionalInfo);data.refImages.forEach(function(element){formData.append("referenceImages",element);});_context29.next=20;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/addSourcing',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 20:result=_context29.sent;_context29.t0=result.status;_context29.next=24;return result.json();case 24:_context29.t1=_context29.sent;return _context29.abrupt('return',{status:_context29.t0,text:_context29.t1});case 26:case'end':return _context29.stop();}}},_callee29,this);}));function createSource(_x35){return _ref29.apply(this,arguments);}return createSource;}()},{key:'editSource',value:function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee30(data){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30){while(1){switch(_context30.prev=_context30.next){case 0:formData=new FormData();if(data._id!==undefined){formData.append("_id",data._id);}formData.append("date",data.date);formData.append("magnumStyleId",data.magnumStyleId.value);formData.append("MNID",data.MNID);formData.append("sourcingFor",data.sourcingFor);formData.append("originationOfRequest",data.originationOfRequest);formData.append("season",data.season);formData.append("category",data.category);formData.append("requirecustomerDepartmentment",data.requirement);formData.append("color",data.color);formData.append("quantity",data.quantity);formData.append("composition",data.composition);formData.append("measurement",data.measurement);formData.append("dateRequiredAtMagnum",data.dateRequiredAtMagnum);formData.append("dateReceivedAtMagnum",data.dateReceivedAtMagnum);formData.append("additionalInfo",data.additionalInfo);data.refImages.forEach(function(element){formData.append("refImages",element);});data.referenceImages.forEach(function(element){formData.append("referenceImages",element);});_context30.next=21;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/addSourcing',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 21:result=_context30.sent;return _context30.abrupt('return',result.json());case 23:case'end':return _context30.stop();}}},_callee30,this);}));function editSource(_x36){return _ref30.apply(this,arguments);}return editSource;}()},{key:'removeSourcing',value:function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee31(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:_context31.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sourcing',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context31.sent;_context31.next=5;return result.json();case 5:_context31.t0=_context31.sent;_context31.t1=result.status;return _context31.abrupt('return',{text:_context31.t0,status:_context31.t1});case 8:case'end':return _context31.stop();}}},_callee31,this);}));function removeSourcing(_x37){return _ref31.apply(this,arguments);}return removeSourcing;}()},{key:'getSpecificSource',value:function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee32(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:_context32.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sourcingView',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context32.sent;return _context32.abrupt('return',result.json());case 4:case'end':return _context32.stop();}}},_callee32,this);}));function getSpecificSource(_x38){return _ref32.apply(this,arguments);}return getSpecificSource;}()},{key:'completeSource',value:function(){var _ref33=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee33(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:_context33.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sourcingCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context33.sent;_context33.t0=result.status;_context33.next=6;return result.json();case 6:_context33.t1=_context33.sent;return _context33.abrupt('return',{status:_context33.t0,text:_context33.t1});case 8:case'end':return _context33.stop();}}},_callee33,this);}));function completeSource(_x39){return _ref33.apply(this,arguments);}return completeSource;}()},{key:'listFabric',value:function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee34(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34){while(1){switch(_context34.prev=_context34.next){case 0:_context34.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabric/Fabrics',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:value})});case 2:result=_context34.sent;_context34.t0=result.status;_context34.next=6;return result.json();case 6:_context34.t1=_context34.sent;return _context34.abrupt('return',{status:_context34.t0,text:_context34.t1});case 8:case'end':return _context34.stop();}}},_callee34,this);}));function listFabric(_x40){return _ref34.apply(this,arguments);}return listFabric;}()},{key:'listSortedFabric',value:function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee35(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35){while(1){switch(_context35.prev=_context35.next){case 0:_context35.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getDevelopmentFabric',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:value})});case 2:result=_context35.sent;return _context35.abrupt('return',result.json());case 4:case'end':return _context35.stop();}}},_callee35,this);}));function listSortedFabric(_x41){return _ref35.apply(this,arguments);}return listSortedFabric;}()},{key:'removeFabric',value:function(){var _ref36=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee36(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36){while(1){switch(_context36.prev=_context36.next){case 0:_context36.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabric',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context36.sent;return _context36.abrupt('return',{text:result.json(),status:result.status});case 4:case'end':return _context36.stop();}}},_callee36,this);}));function removeFabric(_x42){return _ref36.apply(this,arguments);}return removeFabric;}()},{key:'prefillFabricDetails',value:function(){var _ref37=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee37(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37){while(1){switch(_context37.prev=_context37.next){case 0:_context37.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getFabric',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context37.sent;return _context37.abrupt('return',result.json());case 4:case'end':return _context37.stop();}}},_callee37,this);}));function prefillFabricDetails(){return _ref37.apply(this,arguments);}return prefillFabricDetails;}()},{key:'getBnoDropdown',value:function(){var _ref38=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee38(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38){while(1){switch(_context38.prev=_context38.next){case 0:_context38.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/bNumber-dropdown',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:value!==''?JSON.stringify({baseRefNumber:value}):''});case 2:result=_context38.sent;return _context38.abrupt('return',result.json());case 4:case'end':return _context38.stop();}}},_callee38,this);}));function getBnoDropdown(_x43){return _ref38.apply(this,arguments);}return getBnoDropdown;}()// async getBnoValues(value){
//     let result = await fetch(UtilityService.baseUrl() + 'api/development/getSingleBNumber',{
//         method: "POST",
//         headers:{
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//             'AuthToken': localStorage.getItem("authToken")
//         },
//         body: value !== '' ? JSON.stringify({
//             _id: value
//         }) : ''
//     });
//     return result.json();
// }
},{key:'getMeetingNoteId',value:function(){var _ref39=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee39(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39){while(1){switch(_context39.prev=_context39.next){case 0:_context39.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/searchMeetingNotes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({by:"MNId",for:value})});case 2:result=_context39.sent;return _context39.abrupt('return',result.json());case 4:case'end':return _context39.stop();}}},_callee39,this);}));function getMeetingNoteId(_x44){return _ref39.apply(this,arguments);}return getMeetingNoteId;}()},{key:'getMeetingNoteIdForFabric',value:function(){var _ref40=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee40(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40){while(1){switch(_context40.prev=_context40.next){case 0:_context40.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/meetingNotes/searchMeetingNotes',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({by:"MNId",for:value})});case 2:result=_context40.sent;return _context40.abrupt('return',result.json());case 4:case'end':return _context40.stop();}}},_callee40,this);}));function getMeetingNoteIdForFabric(_x45){return _ref40.apply(this,arguments);}return getMeetingNoteIdForFabric;}()},{key:'getPrefillInfoForEmbroidery',value:function(){var _ref41=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee41(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41){while(1){switch(_context41.prev=_context41.next){case 0:_context41.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/embroideryData',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context41.sent;return _context41.abrupt('return',result.json());case 4:case'end':return _context41.stop();}}},_callee41,this);}));function getPrefillInfoForEmbroidery(){return _ref41.apply(this,arguments);}return getPrefillInfoForEmbroidery;}()},{key:'getFabricNumber',value:function(){var _ref42=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee42(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42){while(1){switch(_context42.prev=_context42.next){case 0:_context42.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchFabricNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricNumber:value})});case 2:result=_context42.sent;_context42.t0=result.status;_context42.next=6;return result.json();case 6:_context42.t1=_context42.sent;return _context42.abrupt('return',{status:_context42.t0,text:_context42.t1});case 8:case'end':return _context42.stop();}}},_callee42,this);}));function getFabricNumber(_x46){return _ref42.apply(this,arguments);}return getFabricNumber;}()},{key:'getBNumberForFabric',value:function(){var _ref43=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee43(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43){while(1){switch(_context43.prev=_context43.next){case 0:_context43.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchBNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({baseRefNumber:value})});case 2:result=_context43.sent;_context43.t0=result.status;_context43.next=6;return result.json();case 6:_context43.t1=_context43.sent;return _context43.abrupt('return',{status:_context43.t0,text:_context43.t1});case 8:case'end':return _context43.stop();}}},_callee43,this);}));function getBNumberForFabric(_x47){return _ref43.apply(this,arguments);}return getBNumberForFabric;}()},{key:'getCADRefNumber',value:function(){var _ref44=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee44(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44){while(1){switch(_context44.prev=_context44.next){case 0:_context44.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchCAD',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({cadNumber:value})});case 2:result=_context44.sent;_context44.t0=result.status;_context44.next=6;return result.json();case 6:_context44.t1=_context44.sent;return _context44.abrupt('return',{status:_context44.t0,text:_context44.t1});case 8:case'end':return _context44.stop();}}},_callee44,this);}));function getCADRefNumber(_x48){return _ref44.apply(this,arguments);}return getCADRefNumber;}()},{key:'getCadNumber',value:function(){var _ref45=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee45(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45){while(1){switch(_context45.prev=_context45.next){case 0:_context45.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/generateCadNumber',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context45.sent;_context45.t0=result.status;_context45.next=6;return result.json();case 6:_context45.t1=_context45.sent;return _context45.abrupt('return',{status:_context45.t0,text:_context45.t1});case 8:case'end':return _context45.stop();}}},_callee45,this);}));function getCadNumber(){return _ref45.apply(this,arguments);}return getCadNumber;}()},{key:'createFabric',value:function(){var _ref46=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee46(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46){while(1){switch(_context46.prev=_context46.next){case 0:_context46.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabric/storeFabric',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context46.sent;_context46.t0=result.status;_context46.next=6;return result.json();case 6:_context46.t1=_context46.sent;return _context46.abrupt('return',{status:_context46.t0,text:_context46.t1});case 8:case'end':return _context46.stop();}}},_callee46,this);}));function createFabric(_x49){return _ref46.apply(this,arguments);}return createFabric;}()},{key:'generateFabric',value:function(){var _ref47=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee47(generateNo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47){while(1){switch(_context47.prev=_context47.next){case 0:_context47.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/generateFabric',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({count:generateNo})});case 2:result=_context47.sent;_context47.t0=result.status;_context47.next=6;return result.json();case 6:_context47.t1=_context47.sent;return _context47.abrupt('return',{status:_context47.t0,text:_context47.t1});case 8:case'end':return _context47.stop();}}},_callee47,this);}));function generateFabric(_x50){return _ref47.apply(this,arguments);}return generateFabric;}()},{key:'fabricStatus',value:function(){var _ref48=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee48(status,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48){while(1){switch(_context48.prev=_context48.next){case 0:_context48.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/updateFabricStatus',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({approvedStatus:status,fabricId:id})});case 2:result=_context48.sent;return _context48.abrupt('return',result.json());case 4:case'end':return _context48.stop();}}},_callee48,this);}));function fabricStatus(_x51,_x52){return _ref48.apply(this,arguments);}return fabricStatus;}()},{key:'cadStatus',value:function(){var _ref49=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee49(status,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49){while(1){switch(_context49.prev=_context49.next){case 0:_context49.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/updateApprovedStatusCad',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({approvedStatus:status,cadId:id})});case 2:result=_context49.sent;return _context49.abrupt('return',result.json());case 4:case'end':return _context49.stop();}}},_callee49,this);}));function cadStatus(_x53,_x54){return _ref49.apply(this,arguments);}return cadStatus;}()},{key:'createYarnDyed',value:function(){var _ref50=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee50(data,toggle,_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50){while(1){switch(_context50.prev=_context50.next){case 0:_context50.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Fabric/YarnDyed',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({yarnDyed:data,toggle:toggle,_id:_id})});case 2:result=_context50.sent;_context50.t0=result.status;_context50.next=6;return result.json();case 6:_context50.t1=_context50.sent;return _context50.abrupt('return',{status:_context50.t0,text:_context50.t1});case 8:case'end':return _context50.stop();}}},_callee50,this);}));function createYarnDyed(_x55,_x56,_x57){return _ref50.apply(this,arguments);}return createYarnDyed;}()},{key:'createPrint',value:function(){var _ref51=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee51(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51){while(1){switch(_context51.prev=_context51.next){case 0:_context51.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Fabric/print',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context51.sent;_context51.t0=result.status;_context51.next=6;return result.json();case 6:_context51.t1=_context51.sent;return _context51.abrupt('return',{status:_context51.t0,text:_context51.t1});case 8:case'end':return _context51.stop();}}},_callee51,this);}));function createPrint(_x58){return _ref51.apply(this,arguments);}return createPrint;}()},{key:'createSolid',value:function(){var _ref52=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee52(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52){while(1){switch(_context52.prev=_context52.next){case 0:_context52.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Fabric/Solid',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context52.sent;_context52.t0=result.status;_context52.next=6;return result.json();case 6:_context52.t1=_context52.sent;return _context52.abrupt('return',{status:_context52.t0,text:_context52.t1});case 8:case'end':return _context52.stop();}}},_callee52,this);}));function createSolid(_x59){return _ref52.apply(this,arguments);}return createSolid;}()},{key:'createSupplierForFabric',value:function(){var _ref53=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee53(data,moduleName){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53){while(1){switch(_context53.prev=_context53.next){case 0:_context53.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/'+moduleName+'/Supplier',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context53.sent;_context53.t0=result.status;_context53.next=6;return result.json();case 6:_context53.t1=_context53.sent;return _context53.abrupt('return',{status:_context53.t0,text:_context53.t1});case 8:case'end':return _context53.stop();}}},_callee53,this);}));function createSupplierForFabric(_x60,_x61){return _ref53.apply(this,arguments);}return createSupplierForFabric;}()},{key:'getSourcingInfo',value:function(){var _ref54=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee54(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54){while(1){switch(_context54.prev=_context54.next){case 0:_context54.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchSourcing',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({sourcingNumber:value})});case 2:result=_context54.sent;_context54.t0=result.status;_context54.next=6;return result.json();case 6:_context54.t1=_context54.sent;return _context54.abrupt('return',{status:_context54.t0,text:_context54.t1});case 8:case'end':return _context54.stop();}}},_callee54,this);}));function getSourcingInfo(_x62){return _ref54.apply(this,arguments);}return getSourcingInfo;}()},{key:'createEmbroidery',value:function(){var _ref55=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee55(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55){while(1){switch(_context55.prev=_context55.next){case 0:_context55.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Fabric/embroidery',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(data)});case 2:result=_context55.sent;_context55.t0=result.status;_context55.next=6;return result.json();case 6:_context55.t1=_context55.sent;return _context55.abrupt('return',{status:_context55.t0,text:_context55.t1});case 8:case'end':return _context55.stop();}}},_callee55,this);}));function createEmbroidery(_x63){return _ref55.apply(this,arguments);}return createEmbroidery;}()},{key:'getSpecificFabric',value:function(){var _ref56=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee56(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56){while(1){switch(_context56.prev=_context56.next){case 0:_context56.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabric',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context56.sent;_context56.t0=result.status;_context56.next=6;return result.json();case 6:_context56.t1=_context56.sent;return _context56.abrupt('return',{status:_context56.t0,text:_context56.t1});case 8:case'end':return _context56.stop();}}},_callee56,this);}));function getSpecificFabric(_x64){return _ref56.apply(this,arguments);}return getSpecificFabric;}()},{key:'listProduct',value:function(){var _ref57=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee57(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57){while(1){switch(_context57.prev=_context57.next){case 0:_context57.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/products',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context57.sent;return _context57.abrupt('return',result.json());case 4:case'end':return _context57.stop();}}},_callee57,this);}));function listProduct(){return _ref57.apply(this,arguments);}return listProduct;}()},{key:'createProduct',value:function(){var _ref58=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee58(data){var formData,i,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58){while(1){switch(_context58.prev=_context58.next){case 0:formData=new FormData();formData.append("MNId",data.MNId);for(i=0;i<data.refImages.length;i++){formData.append("referenceImages",data.refImages[i]);}if(data._id!==undefined){formData.append("_id",data._id);}formData.append("date",data.date);formData.append("magnumStyleId",data.magnumStyleId);formData.append("MNID",data.MNId);formData.append("requestGeneratedBy",data.requestGeneratedBy);formData.append("productDevelopmentFor",data.productDevelopmentFor);formData.append("originationOfRequest",data.originationOfRequest);formData.append("category",data.category);formData.append("embroideryTab",data.embroideryTab);formData.append("dateRequiredAtMagnum",data.dateRequiredAtMagnum);formData.append("dateReceivedAtMagnum",data.dateReceivedAtMagnum);formData.append("additionalInfo",data.additionalInfo);_context58.next=17;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/addProduct',{method:"POST",headers:{'Accept':'application/json','AuthToken':localStorage.getItem("authToken")},body:formData});case 17:result=_context58.sent;return _context58.abrupt('return',result.json());case 19:case'end':return _context58.stop();}}},_callee58,this);}));function createProduct(_x65){return _ref58.apply(this,arguments);}return createProduct;}()},{key:'completeProduct',value:function(){var _ref59=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee59(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59){while(1){switch(_context59.prev=_context59.next){case 0:_context59.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/productCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context59.sent;return _context59.abrupt('return',result.json());case 4:case'end':return _context59.stop();}}},_callee59,this);}));function completeProduct(_x66){return _ref59.apply(this,arguments);}return completeProduct;}()},{key:'removeProduct',value:function(){var _ref60=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee60(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60){while(1){switch(_context60.prev=_context60.next){case 0:_context60.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/product',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context60.sent;return _context60.abrupt('return',result.json());case 4:case'end':return _context60.stop();}}},_callee60,this);}));function removeProduct(_x67){return _ref60.apply(this,arguments);}return removeProduct;}()},{key:'createSample',value:function(){var _ref61=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee61(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61){while(1){switch(_context61.prev=_context61.next){case 0:_context61.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sampleDetails',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({awaitingDevSample:data.awaitingDevSample,date:data.date,awaitingSheet:data.designSheet,data:data.data,awaitingDevSheet:data.awaitingDevSheet,_id:data._id})});case 2:result=_context61.sent;return _context61.abrupt('return',result.json());case 4:case'end':return _context61.stop();}}},_callee61,this);}));function createSample(_x68){return _ref61.apply(this,arguments);}return createSample;}()},{key:'createTrimForProductDev',value:function(){var _ref62=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee62(data,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62){while(1){switch(_context62.prev=_context62.next){case 0:_context62.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/trim',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trim:data,_id:id})});case 2:result=_context62.sent;return _context62.abrupt('return',result.json());case 4:case'end':return _context62.stop();}}},_callee62,this);}));function createTrimForProductDev(_x69,_x70){return _ref62.apply(this,arguments);}return createTrimForProductDev;}()},{key:'getEmployeId',value:function(){var _ref63=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee63(value,role){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63){while(1){switch(_context63.prev=_context63.next){case 0:_context63.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/employee/searchEmployees',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({userId:value,role:role})});case 2:result=_context63.sent;return _context63.abrupt('return',result.json());case 4:case'end':return _context63.stop();}}},_callee63,this);}));function getEmployeId(_x71,_x72){return _ref63.apply(this,arguments);}return getEmployeId;}()},{key:'createPattern',value:function(){var _ref64=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee64(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64){while(1){switch(_context64.prev=_context64.next){case 0:_context64.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/pattern',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({date:value.date,trailRequired:value.trailRequired,existingBlockRefNumber:value.existingBlockRefNumber,followedBlockRequired:value.blockRequired,blockRefNumber:value.blockRefNumber,remarks:value.remarks,patternMaster:value.patternMaster,_id:value._id})});case 2:result=_context64.sent;return _context64.abrupt('return',result.json());case 4:case'end':return _context64.stop();}}},_callee64,this);}));function createPattern(_x73){return _ref64.apply(this,arguments);}return createPattern;}()},{key:'completePattern',value:function(){var _ref65=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee65(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65){while(1){switch(_context65.prev=_context65.next){case 0:_context65.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/patternComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context65.sent;return _context65.abrupt('return',result.json());case 4:case'end':return _context65.stop();}}},_callee65,this);}));function completePattern(_x74){return _ref65.apply(this,arguments);}return completePattern;}()},{key:'createGarment',value:function(){var _ref66=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee66(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66){while(1){switch(_context66.prev=_context66.next){case 0:_context66.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/garmentTechnology',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({sampleForm:value.sampleForm,garmentTechComments:value.garmentTechComments,trailRequired:value.trailRequired,mock:value.mock,smvAmmendment:value.smvAmmendment,markerRequirements:value.markerRequirements,_id:value._id})});case 2:result=_context66.sent;return _context66.abrupt('return',result.json());case 4:case'end':return _context66.stop();}}},_callee66,this);}));function createGarment(_x75){return _ref66.apply(this,arguments);}return createGarment;}()},{key:'completeGarment',value:function(){var _ref67=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee67(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67){while(1){switch(_context67.prev=_context67.next){case 0:_context67.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/garmentTechnologyComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context67.sent;return _context67.abrupt('return',result.json());case 4:case'end':return _context67.stop();}}},_callee67,this);}));function completeGarment(_x76){return _ref67.apply(this,arguments);}return completeGarment;}()},{key:'createSignOff',value:function(){var _ref68=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee68(date,master,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee68$(_context68){while(1){switch(_context68.prev=_context68.next){case 0:_context68.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/signOff',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:product,merchandiser:master.value,date:date})});case 2:result=_context68.sent;return _context68.abrupt('return',result.json());case 4:case'end':return _context68.stop();}}},_callee68,this);}));function createSignOff(_x77,_x78,_x79){return _ref68.apply(this,arguments);}return createSignOff;}()},{key:'completeSignOff',value:function(){var _ref69=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee69(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee69$(_context69){while(1){switch(_context69.prev=_context69.next){case 0:_context69.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/signOffCompleted',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context69.sent;return _context69.abrupt('return',result.json());case 4:case'end':return _context69.stop();}}},_callee69,this);}));function completeSignOff(_x80){return _ref69.apply(this,arguments);}return completeSignOff;}()},{key:'getSpecificTrim',value:function(){var _ref70=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee70(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee70$(_context70){while(1){switch(_context70.prev=_context70.next){case 0:_context70.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Trim',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context70.sent;_context70.t0=result.status;_context70.next=6;return result.json();case 6:_context70.t1=_context70.sent;return _context70.abrupt('return',{status:_context70.t0,text:_context70.t1});case 8:case'end':return _context70.stop();}}},_callee70,this);}));function getSpecificTrim(_x81){return _ref70.apply(this,arguments);}return getSpecificTrim;}()},{key:'createCutting',value:function(){var _ref71=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee71(info,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee71$(_context71){while(1){switch(_context71.prev=_context71.next){case 0:_context71.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/cutting',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:product,cutting:info})});case 2:result=_context71.sent;return _context71.abrupt('return',result.json());case 4:case'end':return _context71.stop();}}},_callee71,this);}));function createCutting(_x82,_x83){return _ref71.apply(this,arguments);}return createCutting;}()},{key:'completeCutting',value:function(){var _ref72=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee72(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee72$(_context72){while(1){switch(_context72.prev=_context72.next){case 0:_context72.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/cuttingComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context72.sent;return _context72.abrupt('return',result.json());case 4:case'end':return _context72.stop();}}},_callee72,this);}));function completeCutting(_x84){return _ref72.apply(this,arguments);}return completeCutting;}()},{key:'createSewing',value:function(){var _ref73=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee73(info,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee73$(_context73){while(1){switch(_context73.prev=_context73.next){case 0:_context73.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sewing',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:product,sewing:info})});case 2:result=_context73.sent;return _context73.abrupt('return',result.json());case 4:case'end':return _context73.stop();}}},_callee73,this);}));function createSewing(_x85,_x86){return _ref73.apply(this,arguments);}return createSewing;}()},{key:'completeSewing',value:function(){var _ref74=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee74(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee74$(_context74){while(1){switch(_context74.prev=_context74.next){case 0:_context74.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/sewingCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context74.sent;return _context74.abrupt('return',result.json());case 4:case'end':return _context74.stop();}}},_callee74,this);}));function completeSewing(_x87){return _ref74.apply(this,arguments);}return completeSewing;}()},{key:'getPrefillInfo',value:function(){var _ref75=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee75(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee75$(_context75){while(1){switch(_context75.prev=_context75.next){case 0:_context75.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/sampleRequest/getSR',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context75.sent;return _context75.abrupt('return',result.json());case 4:case'end':return _context75.stop();}}},_callee75,this);}));function getPrefillInfo(){return _ref75.apply(this,arguments);}return getPrefillInfo;}()},{key:'createDispatch',value:function(){var _ref76=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee76(info,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee76$(_context76){while(1){switch(_context76.prev=_context76.next){case 0:_context76.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/dispatch',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:product,dispatch:info})});case 2:result=_context76.sent;return _context76.abrupt('return',result.json());case 4:case'end':return _context76.stop();}}},_callee76,this);}));function createDispatch(_x88,_x89){return _ref76.apply(this,arguments);}return createDispatch;}()},{key:'completeDispatch',value:function(){var _ref77=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee77(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee77$(_context77){while(1){switch(_context77.prev=_context77.next){case 0:_context77.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/dispatchCompleted',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context77.sent;return _context77.abrupt('return',result.json());case 4:case'end':return _context77.stop();}}},_callee77,this);}));function completeDispatch(_x90){return _ref77.apply(this,arguments);}return completeDispatch;}()},{key:'searchSuppliersById',value:function(){var _ref78=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee78(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee78$(_context78){while(1){switch(_context78.prev=_context78.next){case 0:_context78.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/searchSuppliers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({supplierId:id})});case 2:result=_context78.sent;return _context78.abrupt('return',result.json());case 4:case'end':return _context78.stop();}}},_callee78,this);}));function searchSuppliersById(_x91){return _ref78.apply(this,arguments);}return searchSuppliersById;}()//generateQrCodeForFabric
},{key:'generateQrCode',value:function(){var _ref79=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee79(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee79$(_context79){while(1){switch(_context79.prev=_context79.next){case 0:_context79.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/generateQRFabric',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context79.sent;return _context79.abrupt('return',result.json());case 4:case'end':return _context79.stop();}}},_callee79,this);}));function generateQrCode(){return _ref79.apply(this,arguments);}return generateQrCode;}()//searchPrintFabricNumber
},{key:'searchFilterForFabricNumber',value:function(){var _ref80=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee80(data){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee80$(_context80){while(1){switch(_context80.prev=_context80.next){case 0:_context80.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getFabricByRange',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem('authToken')},body:JSON.stringify(data)});case 2:result=_context80.sent;return _context80.abrupt('return',result.json());case 4:case'end':return _context80.stop();}}},_callee80,this);}));function searchFilterForFabricNumber(_x92){return _ref80.apply(this,arguments);}return searchFilterForFabricNumber;}()},{key:'getTrimNumber',value:function(){var _ref81=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee81(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee81$(_context81){while(1){switch(_context81.prev=_context81.next){case 0:_context81.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchTrim',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimNumber:value})});case 2:result=_context81.sent;return _context81.abrupt('return',result.json());case 4:case'end':return _context81.stop();}}},_callee81,this);}));function getTrimNumber(_x93){return _ref81.apply(this,arguments);}return getTrimNumber;}()},{key:'createFabricForProduct',value:function(){var _ref82=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee82(info,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee82$(_context82){while(1){switch(_context82.prev=_context82.next){case 0:_context82.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabric',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:product,fabric:info})});case 2:result=_context82.sent;return _context82.abrupt('return',result.json());case 4:case'end':return _context82.stop();}}},_callee82,this);}));function createFabricForProduct(_x94,_x95){return _ref82.apply(this,arguments);}return createFabricForProduct;}()},{key:'completeFabric',value:function(){var _ref83=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee83(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee83$(_context83){while(1){switch(_context83.prev=_context83.next){case 0:_context83.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/fabricComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context83.sent;return _context83.abrupt('return',result.json());case 4:case'end':return _context83.stop();}}},_callee83,this);}));function completeFabric(_x96){return _ref83.apply(this,arguments);}return completeFabric;}()},{key:'createTrimForProduct',value:function(){var _ref84=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee84(info,product){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee84$(_context84){while(1){switch(_context84.prev=_context84.next){case 0:_context84.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/trim',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trim:info,_id:product})});case 2:result=_context84.sent;return _context84.abrupt('return',result.json());case 4:case'end':return _context84.stop();}}},_callee84,this);}));function createTrimForProduct(_x97,_x98){return _ref84.apply(this,arguments);}return createTrimForProduct;}()},{key:'completeTrim',value:function(){var _ref85=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee85(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee85$(_context85){while(1){switch(_context85.prev=_context85.next){case 0:_context85.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/trimComplete',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context85.sent;return _context85.abrupt('return',result.json());case 4:case'end':return _context85.stop();}}},_callee85,this);}));function completeTrim(_x99){return _ref85.apply(this,arguments);}return completeTrim;}()},{key:'createEmbelishment',value:function(){var _ref86=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee86(data,id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee86$(_context86){while(1){switch(_context86.prev=_context86.next){case 0:_context86.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/embellishment',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,aariData:data.aariData,manualData:data.manualData,tasselData:data.tasselData})});case 2:result=_context86.sent;return _context86.abrupt('return',result.json());case 4:case'end':return _context86.stop();}}},_callee86,this);}));function createEmbelishment(_x100,_x101){return _ref86.apply(this,arguments);}return createEmbelishment;}()},{key:'listTrim',value:function(){var _ref87=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee87(page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee87$(_context87){while(1){switch(_context87.prev=_context87.next){case 0:_context87.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Trims',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:page})});case 2:result=_context87.sent;_context87.t0=result.status;_context87.next=6;return result.json();case 6:_context87.t1=_context87.sent;return _context87.abrupt('return',{status:_context87.t0,text:_context87.t1});case 8:case'end':return _context87.stop();}}},_callee87,this);}));function listTrim(_x102){return _ref87.apply(this,arguments);}return listTrim;}()},{key:'removeTrim',value:function(){var _ref88=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee88(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee88$(_context88){while(1){switch(_context88.prev=_context88.next){case 0:_context88.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/Trim',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({trimId:id})});case 2:result=_context88.sent;_context88.next=5;return result.json();case 5:_context88.t0=_context88.sent;_context88.t1=result.status;return _context88.abrupt('return',{text:_context88.t0,status:_context88.t1});case 8:case'end':return _context88.stop();}}},_callee88,this);}));function removeTrim(_x103){return _ref88.apply(this,arguments);}return removeTrim;}()},{key:'getSupplierInfo',value:function(){var _ref89=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee89(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee89$(_context89){while(1){switch(_context89.prev=_context89.next){case 0:_context89.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/system/searchSuppliers',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({supplierId:value})});case 2:result=_context89.sent;return _context89.abrupt('return',result.json());case 4:case'end':return _context89.stop();}}},_callee89,this);}));function getSupplierInfo(_x104){return _ref89.apply(this,arguments);}return getSupplierInfo;}()},{key:'createTrimForMarket',value:function(){var _ref90=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee90(trimInfo){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee90$(_context90){while(1){switch(_context90.prev=_context90.next){case 0:_context90.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/createTrimDevelopment',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(trimInfo)});case 2:result=_context90.sent;_context90.t0=result.status;_context90.next=6;return result.json();case 6:_context90.t1=_context90.sent;return _context90.abrupt('return',{status:_context90.t0,text:_context90.t1});case 8:case'end':return _context90.stop();}}},_callee90,this);}));function createTrimForMarket(_x105){return _ref90.apply(this,arguments);}return createTrimForMarket;}()},{key:'createTrimForProduct',value:function(){var _ref91=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee91(trimInfo){var formData,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,iterator,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee91$(_context91){while(1){switch(_context91.prev=_context91.next){case 0:formData=new FormData();if(trimInfo._id!==undefined){formData.append("_id",trimInfo._id);}formData.append("trimDevelopment",trimInfo.trimDevelopment);formData.append("supplier",trimInfo.supplier);formData.append("trimCategory",trimInfo.trimCategory);formData.append("unit",trimInfo.unit);formData.append("size",trimInfo.size);formData.append("color",trimInfo.color);formData.append("quality",trimInfo.quality);formData.append("price",trimInfo.price);formData.append("contentOfTrim",trimInfo.contentOfTrim);_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context91.prev=14;for(_iterator2=trimInfo.referenceImages[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){iterator=_step2.value;formData.append("refImage",iterator);}_context91.next=22;break;case 18:_context91.prev=18;_context91.t0=_context91['catch'](14);_didIteratorError2=true;_iteratorError2=_context91.t0;case 22:_context91.prev=22;_context91.prev=23;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 25:_context91.prev=25;if(!_didIteratorError2){_context91.next=28;break;}throw _iteratorError2;case 28:return _context91.finish(25);case 29:return _context91.finish(22);case 30:formData.append("customerId",trimInfo.customerId);formData.append("magnumStyleId",trimInfo.magnumStyleId);formData.append("requirement",trimInfo.requirement);formData.append("isSupplierTestReport",trimInfo.isSupplierTestReport);formData.append("supplierTestReport",trimInfo.supplierTestReport);formData.append("trimSubCategory",trimInfo.trimSubCategory);formData.append("perGrossPrice",trimInfo.perGrossPrice);formData.append("source",trimInfo.source);formData.append("importedOptions",trimInfo.importedOptions);_context91.next=41;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/createTrimDevelopment',{method:"POST",headers:{'Accept':'application/json',// 'Content-Type': 'application/json',
'AuthToken':localStorage.getItem("authToken")},body:formData});case 41:result=_context91.sent;return _context91.abrupt('return',result.json());case 43:case'end':return _context91.stop();}}},_callee91,this,[[14,18,22,30],[23,,25,29]]);}));function createTrimForProduct(_x106){return _ref91.apply(this,arguments);}return createTrimForProduct;}()},{key:'createfullPackageSupplier',value:function(){var _ref92=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee92(type,id,value,fullPackage,jobWork,embroideryRequired,embroideryWidth,blankFabric,allowanceForFraming,selvadge,styleId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee92$(_context92){while(1){switch(_context92.prev=_context92.next){case 0:_context92.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/development/'+type+'/Supplier'),{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,fullPackage:fullPackage,jobWork:jobWork,fullPackageDatakey:value,embroideryRequired:embroideryRequired,embroideryWidth:embroideryWidth,blankFabric:blankFabric,allowanceForFraming:allowanceForFraming,selvadge:selvadge,styleId:styleId!==undefined?styleId.value:""})});case 2:result=_context92.sent;return _context92.abrupt('return',result.json());case 4:case'end':return _context92.stop();}}},_callee92,this);}));function createfullPackageSupplier(_x107,_x108,_x109,_x110,_x111,_x112,_x113,_x114,_x115,_x116,_x117){return _ref92.apply(this,arguments);}return createfullPackageSupplier;}()},{key:'createJobWorkSupplier',value:function(){var _ref93=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee93(type,id,value,fullPackage,jobWork,embroideryRequired,embroideryWidth,blankFabric,allowanceForFraming,selvadge,jobWorkProcess,styleId){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee93$(_context93){while(1){switch(_context93.prev=_context93.next){case 0:_context93.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/development/'+type+'/Supplier'),{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id,fullPackage:fullPackage,jobWork:jobWork,jobWorkData:value,embroideryRequired:embroideryRequired,embroideryWidth:embroideryWidth,blankFabric:blankFabric,allowanceForFraming:allowanceForFraming,selvadge:selvadge,jobWorkProcess:jobWorkProcess,styleId:styleId!==undefined?styleId.value:""})});case 2:result=_context93.sent;return _context93.abrupt('return',result.json());case 4:case'end':return _context93.stop();}}},_callee93,this);}));function createJobWorkSupplier(_x118,_x119,_x120,_x121,_x122,_x123,_x124,_x125,_x126,_x127,_x128,_x129){return _ref93.apply(this,arguments);}return createJobWorkSupplier;}()},{key:'getProductInfo',value:function(){var _ref94=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee94(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee94$(_context94){while(1){switch(_context94.prev=_context94.next){case 0:_context94.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/productView',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context94.sent;return _context94.abrupt('return',result.json());case 4:case'end':return _context94.stop();}}},_callee94,this);}));function getProductInfo(_x130){return _ref94.apply(this,arguments);}return getProductInfo;}()},{key:'ListEmbroidery',value:function(){var _ref95=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee95(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee95$(_context95){while(1){switch(_context95.prev=_context95.next){case 0:_context95.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getAllEmbroideries',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({page:1})});case 2:result=_context95.sent;return _context95.abrupt('return',result.json());case 4:case'end':return _context95.stop();}}},_callee95,this);}));function ListEmbroidery(){return _ref95.apply(this,arguments);}return ListEmbroidery;}()},{key:'deleteEmbroidery',value:function(){var _ref96=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee96(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee96$(_context96){while(1){switch(_context96.prev=_context96.next){case 0:_context96.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/embroidery',{method:"DELETE",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context96.sent;return _context96.abrupt('return',result.json());case 4:case'end':return _context96.stop();}}},_callee96,this);}));function deleteEmbroidery(_x131){return _ref96.apply(this,arguments);}return deleteEmbroidery;}()},{key:'getSpecificEmbroidery',value:function(){var _ref97=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee97(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee97$(_context97){while(1){switch(_context97.prev=_context97.next){case 0:_context97.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getSpecificEmbroidery',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context97.sent;return _context97.abrupt('return',result.json());case 4:case'end':return _context97.stop();}}},_callee97,this);}));function getSpecificEmbroidery(_x132){return _ref97.apply(this,arguments);}return getSpecificEmbroidery;}()},{key:'uploadNewImage',value:function(){var _ref98=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee98(image){var formData,numFiles,i,_numFiles,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee98$(_context98){while(1){switch(_context98.prev=_context98.next){case 0:formData=new FormData();numFiles=image.length;for(i=0,_numFiles=image.length;i<image.length;i++){formData.append("referenceImages",image[i]);}_context98.next=5;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/uploadReferenceImages',{method:"POST",headers:{'Accept':'application/json',// 'Content-Type': 'application/json',
'AuthToken':localStorage.getItem("authToken")},body:formData});case 5:result=_context98.sent;return _context98.abrupt('return',result.json());case 7:case'end':return _context98.stop();}}},_callee98,this);}));function uploadNewImage(_x133){return _ref98.apply(this,arguments);}return uploadNewImage;}()},{key:'createEmbroideryValue',value:function(){var _ref99=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee99(fullData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee99$(_context99){while(1){switch(_context99.prev=_context99.next){case 0:_context99.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/updateEmbroidery',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({cutPanel:fullData.cutPanel,allOver:fullData.allOver,garmentForm:fullData.garmentForm,semiGarmentForm:fullData.semiGarmentForm,tassel:fullData.tassle,smocking:fullData.smocking,sheering:fullData.sheering,additionalInfo:fullData.additionalInfo,selected:fullData.data,employee:fullData.patternMaster.value,refImages:fullData.refImages,// colorsNumber: parseInt(fullData.colorsNumber),
// frames: parseInt(fullData.frames),
// grading: fullData.grading,
isMachine:fullData.machine,machine:fullData.fullPackageLength,sampleRequestId:fullData.sampleNo.value,styleId:fullData.styleInfo.value,embroideryBacking:fullData.embroideryBacking,bitAttaching:fullData.bitAttaching,backing:{backingType:fullData.backingType,width:fullData.backingWidth,priceMeter:fullData.backingPrice,consumption:fullData.backingConsumption,totalPrice:fullData.backingConsumption*fullData.backingPrice,color:fullData.backingColor}})});case 2:result=_context99.sent;return _context99.abrupt('return',result.json());case 4:case'end':return _context99.stop();}}},_callee99,this);}));function createEmbroideryValue(_x134){return _ref99.apply(this,arguments);}return createEmbroideryValue;}()},{key:'updateEmbroideryValue',value:function(){var _ref100=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee100(fullData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee100$(_context100){while(1){switch(_context100.prev=_context100.next){case 0:_context100.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/updateEmbroidery',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:fullData._id,cutPanel:fullData.cutPanel,allOver:fullData.allOver,garmentForm:fullData.garmentForm,semiGarmentForm:fullData.semiGarmentForm,tassel:fullData.tassle,smocking:fullData.smocking,sheering:fullData.sheering,additionalInfo:fullData.additionalInfo,selected:fullData.data,employee:fullData.patternMaster.value,refImages:fullData.refImages,colorsNumber:parseInt(fullData.colorsNumber),frames:parseInt(fullData.frames),grading:fullData.grading,data:fullData.fullPackageLength})});case 2:result=_context100.sent;return _context100.abrupt('return',result.json());case 4:case'end':return _context100.stop();}}},_callee100,this);}));function updateEmbroideryValue(_x135){return _ref100.apply(this,arguments);}return updateEmbroideryValue;}()},{key:'getEmployeInfo',value:function(){var _ref101=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee101(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee101$(_context101){while(1){switch(_context101.prev=_context101.next){case 0:_context101.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/style/searchEmployee',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({text:value})});case 2:result=_context101.sent;return _context101.abrupt('return',result.json());case 4:case'end':return _context101.stop();}}},_callee101,this);}));function getEmployeInfo(_x136){return _ref101.apply(this,arguments);}return getEmployeInfo;}()//generateQR
},{key:'generateQRBNumber',value:function(){var _ref102=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee102(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee102$(_context102){while(1){switch(_context102.prev=_context102.next){case 0:_context102.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/generateQRBNumber',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context102.sent;_context102.t0=result.status;_context102.next=6;return result.json();case 6:_context102.t1=_context102.sent;return _context102.abrupt('return',{status:_context102.t0,text:_context102.t1});case 8:case'end':return _context102.stop();}}},_callee102,this);}));function generateQRBNumber(){return _ref102.apply(this,arguments);}return generateQRBNumber;}()//Get Fabric Info
},{key:'getBFabricInfo',value:function(){var _ref103=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee103(value){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee103$(_context103){while(1){switch(_context103.prev=_context103.next){case 0:_context103.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchFabricNumber',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({fabricNumber:value})});case 2:result=_context103.sent;_context103.t0=result.status;_context103.next=6;return result.json();case 6:_context103.t1=_context103.sent;return _context103.abrupt('return',{status:_context103.t0,text:_context103.t1});case 8:case'end':return _context103.stop();}}},_callee103,this);}));function getBFabricInfo(_x137){return _ref103.apply(this,arguments);}return getBFabricInfo;}()//Get Fabric PreFillData
},{key:'prefillSpecificFabricDetails',value:function(){var _ref104=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee104(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee104$(_context104){while(1){switch(_context104.prev=_context104.next){case 0:_context104.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/getFabric',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context104.sent;_context104.t0=result.status;_context104.next=6;return result.json();case 6:_context104.t1=_context104.sent;return _context104.abrupt('return',{status:_context104.t0,text:_context104.t1});case 8:case'end':return _context104.stop();}}},_callee104,this);}));function prefillSpecificFabricDetails(_x138){return _ref104.apply(this,arguments);}return prefillSpecificFabricDetails;}()},{key:'searchFabricBy',value:function(){var _ref105=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee105(by,value,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee105$(_context105){while(1){switch(_context105.prev=_context105.next){case 0:_context105.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchFabricDev',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by,page:page})});case 2:result=_context105.sent;_context105.t0=result.status;_context105.next=6;return result.json();case 6:_context105.t1=_context105.sent;return _context105.abrupt('return',{status:_context105.t0,text:_context105.t1});case 8:case'end':return _context105.stop();}}},_callee105,this);}));function searchFabricBy(_x139,_x140,_x141){return _ref105.apply(this,arguments);}return searchFabricBy;}()},{key:'searchTrimBy',value:function(){var _ref106=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee106(by,value,page){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee106$(_context106){while(1){switch(_context106.prev=_context106.next){case 0:_context106.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/development/searchTrimDev',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({for:value,by:by,page:page})});case 2:result=_context106.sent;_context106.t0=result.status;_context106.next=6;return result.json();case 6:_context106.t1=_context106.sent;return _context106.abrupt('return',{status:_context106.t0,text:_context106.t1});case 8:case'end':return _context106.stop();}}},_callee106,this);}));function searchTrimBy(_x142,_x143,_x144){return _ref106.apply(this,arguments);}return searchTrimBy;}()//getFabricbyId
},{key:'getFabricbyId',value:function(){var _ref107=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee107(_id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee107$(_context107){while(1){switch(_context107.prev=_context107.next){case 0:_context107.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+"api/development/getFABOneById ",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json",AuthToken:localStorage.getItem("authToken")},body:JSON.stringify({_id:_id})});case 2:result=_context107.sent;_context107.t0=result.status;_context107.next=6;return result.json();case 6:_context107.t1=_context107.sent;return _context107.abrupt('return',{status:_context107.t0,text:_context107.t1});case 8:case'end':return _context107.stop();}}},_callee107,this);}));function getFabricbyId(_x145){return _ref107.apply(this,arguments);}return getFabricbyId;}()}]);return DevelopmentServices;}();/* harmony default export */ __webpack_exports__["a"] = (new DevelopmentServices());

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CommunicationServices=function(){function CommunicationServices(){_classCallCheck(this,CommunicationServices);}_createClass(CommunicationServices,[{key:'getAllInfo',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/communication/getWindows',{method:"GET",headers:{'Accept':"application/json","Content-Type":"application/json","AuthToken":localStorage.getItem("authToken")}});case 2:result=_context.sent;return _context.abrupt('return',result.json());case 4:case'end':return _context.stop();}}},_callee,this);}));function getAllInfo(){return _ref.apply(this,arguments);}return getAllInfo;}()}]);return CommunicationServices;}();/* harmony default export */ __webpack_exports__["a"] = (new CommunicationServices());

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CountryServices=function(){function CountryServices(){_classCallCheck(this,CountryServices);}_createClass(CountryServices,[{key:"countryCode",value:function countryCode(){var test={"USD":{"symbol":"$","name":"US Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"USD","name_plural":"US dollars"},"CAD":{"symbol":"CA$","name":"Canadian Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"CAD","name_plural":"Canadian dollars"},"EUR":{"symbol":"€","name":"Euro","symbol_native":"€","decimal_digits":2,"rounding":0,"code":"EUR","name_plural":"euros"},"AED":{"symbol":"AED","name":"United Arab Emirates Dirham","symbol_native":"د.إ.‏","decimal_digits":2,"rounding":0,"code":"AED","name_plural":"UAE dirhams"},"AFN":{"symbol":"Af","name":"Afghan Afghani","symbol_native":"؋","decimal_digits":0,"rounding":0,"code":"AFN","name_plural":"Afghan Afghanis"},"ALL":{"symbol":"ALL","name":"Albanian Lek","symbol_native":"Lek","decimal_digits":0,"rounding":0,"code":"ALL","name_plural":"Albanian lekë"},"AMD":{"symbol":"AMD","name":"Armenian Dram","symbol_native":"դր.","decimal_digits":0,"rounding":0,"code":"AMD","name_plural":"Armenian drams"},"ARS":{"symbol":"AR$","name":"Argentine Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"ARS","name_plural":"Argentine pesos"},"AUD":{"symbol":"AU$","name":"Australian Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"AUD","name_plural":"Australian dollars"},"AZN":{"symbol":"man.","name":"Azerbaijani Manat","symbol_native":"ман.","decimal_digits":2,"rounding":0,"code":"AZN","name_plural":"Azerbaijani manats"},"BAM":{"symbol":"KM","name":"Bosnia-Herzegovina Convertible Mark","symbol_native":"KM","decimal_digits":2,"rounding":0,"code":"BAM","name_plural":"Bosnia-Herzegovina convertible marks"},"BDT":{"symbol":"Tk","name":"Bangladeshi Taka","symbol_native":"৳","decimal_digits":2,"rounding":0,"code":"BDT","name_plural":"Bangladeshi takas"},"BGN":{"symbol":"BGN","name":"Bulgarian Lev","symbol_native":"лв.","decimal_digits":2,"rounding":0,"code":"BGN","name_plural":"Bulgarian leva"},"BHD":{"symbol":"BD","name":"Bahraini Dinar","symbol_native":"د.ب.‏","decimal_digits":3,"rounding":0,"code":"BHD","name_plural":"Bahraini dinars"},"BIF":{"symbol":"FBu","name":"Burundian Franc","symbol_native":"FBu","decimal_digits":0,"rounding":0,"code":"BIF","name_plural":"Burundian francs"},"BND":{"symbol":"BN$","name":"Brunei Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"BND","name_plural":"Brunei dollars"},"BOB":{"symbol":"Bs","name":"Bolivian Boliviano","symbol_native":"Bs","decimal_digits":2,"rounding":0,"code":"BOB","name_plural":"Bolivian bolivianos"},"BRL":{"symbol":"R$","name":"Brazilian Real","symbol_native":"R$","decimal_digits":2,"rounding":0,"code":"BRL","name_plural":"Brazilian reals"},"BWP":{"symbol":"BWP","name":"Botswanan Pula","symbol_native":"P","decimal_digits":2,"rounding":0,"code":"BWP","name_plural":"Botswanan pulas"},"BYR":{"symbol":"BYR","name":"Belarusian Ruble","symbol_native":"BYR","decimal_digits":0,"rounding":0,"code":"BYR","name_plural":"Belarusian rubles"},"BZD":{"symbol":"BZ$","name":"Belize Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"BZD","name_plural":"Belize dollars"},"CDF":{"symbol":"CDF","name":"Congolese Franc","symbol_native":"FrCD","decimal_digits":2,"rounding":0,"code":"CDF","name_plural":"Congolese francs"},"CHF":{"symbol":"CHF","name":"Swiss Franc","symbol_native":"CHF","decimal_digits":2,"rounding":0.05,"code":"CHF","name_plural":"Swiss francs"},"CLP":{"symbol":"CL$","name":"Chilean Peso","symbol_native":"$","decimal_digits":0,"rounding":0,"code":"CLP","name_plural":"Chilean pesos"},"CNY":{"symbol":"CN¥","name":"Chinese Yuan","symbol_native":"CN¥","decimal_digits":2,"rounding":0,"code":"CNY","name_plural":"Chinese yuan"},"COP":{"symbol":"CO$","name":"Colombian Peso","symbol_native":"$","decimal_digits":0,"rounding":0,"code":"COP","name_plural":"Colombian pesos"},"CRC":{"symbol":"₡","name":"Costa Rican Colón","symbol_native":"₡","decimal_digits":0,"rounding":0,"code":"CRC","name_plural":"Costa Rican colóns"},"CVE":{"symbol":"CV$","name":"Cape Verdean Escudo","symbol_native":"CV$","decimal_digits":2,"rounding":0,"code":"CVE","name_plural":"Cape Verdean escudos"},"CZK":{"symbol":"Kč","name":"Czech Republic Koruna","symbol_native":"Kč","decimal_digits":2,"rounding":0,"code":"CZK","name_plural":"Czech Republic korunas"},"DJF":{"symbol":"Fdj","name":"Djiboutian Franc","symbol_native":"Fdj","decimal_digits":0,"rounding":0,"code":"DJF","name_plural":"Djiboutian francs"},"DKK":{"symbol":"Dkr","name":"Danish Krone","symbol_native":"kr","decimal_digits":2,"rounding":0,"code":"DKK","name_plural":"Danish kroner"},"DOP":{"symbol":"RD$","name":"Dominican Peso","symbol_native":"RD$","decimal_digits":2,"rounding":0,"code":"DOP","name_plural":"Dominican pesos"},"DZD":{"symbol":"DA","name":"Algerian Dinar","symbol_native":"د.ج.‏","decimal_digits":2,"rounding":0,"code":"DZD","name_plural":"Algerian dinars"},"EEK":{"symbol":"Ekr","name":"Estonian Kroon","symbol_native":"kr","decimal_digits":2,"rounding":0,"code":"EEK","name_plural":"Estonian kroons"},"EGP":{"symbol":"EGP","name":"Egyptian Pound","symbol_native":"ج.م.‏","decimal_digits":2,"rounding":0,"code":"EGP","name_plural":"Egyptian pounds"},"ERN":{"symbol":"Nfk","name":"Eritrean Nakfa","symbol_native":"Nfk","decimal_digits":2,"rounding":0,"code":"ERN","name_plural":"Eritrean nakfas"},"ETB":{"symbol":"Br","name":"Ethiopian Birr","symbol_native":"Br","decimal_digits":2,"rounding":0,"code":"ETB","name_plural":"Ethiopian birrs"},"GBP":{"symbol":"£","name":"British Pound Sterling","symbol_native":"£","decimal_digits":2,"rounding":0,"code":"GBP","name_plural":"British pounds sterling"},"GEL":{"symbol":"GEL","name":"Georgian Lari","symbol_native":"GEL","decimal_digits":2,"rounding":0,"code":"GEL","name_plural":"Georgian laris"},"GHS":{"symbol":"GH₵","name":"Ghanaian Cedi","symbol_native":"GH₵","decimal_digits":2,"rounding":0,"code":"GHS","name_plural":"Ghanaian cedis"},"GNF":{"symbol":"FG","name":"Guinean Franc","symbol_native":"FG","decimal_digits":0,"rounding":0,"code":"GNF","name_plural":"Guinean francs"},"GTQ":{"symbol":"GTQ","name":"Guatemalan Quetzal","symbol_native":"Q","decimal_digits":2,"rounding":0,"code":"GTQ","name_plural":"Guatemalan quetzals"},"HKD":{"symbol":"HK$","name":"Hong Kong Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"HKD","name_plural":"Hong Kong dollars"},"HNL":{"symbol":"HNL","name":"Honduran Lempira","symbol_native":"L","decimal_digits":2,"rounding":0,"code":"HNL","name_plural":"Honduran lempiras"},"HRK":{"symbol":"kn","name":"Croatian Kuna","symbol_native":"kn","decimal_digits":2,"rounding":0,"code":"HRK","name_plural":"Croatian kunas"},"HUF":{"symbol":"Ft","name":"Hungarian Forint","symbol_native":"Ft","decimal_digits":0,"rounding":0,"code":"HUF","name_plural":"Hungarian forints"},"IDR":{"symbol":"Rp","name":"Indonesian Rupiah","symbol_native":"Rp","decimal_digits":0,"rounding":0,"code":"IDR","name_plural":"Indonesian rupiahs"},"ILS":{"symbol":"₪","name":"Israeli New Sheqel","symbol_native":"₪","decimal_digits":2,"rounding":0,"code":"ILS","name_plural":"Israeli new sheqels"},"INR":{"symbol":"Rs","name":"Indian Rupee","symbol_native":"টকা","decimal_digits":2,"rounding":0,"code":"INR","name_plural":"Indian rupees"},"IQD":{"symbol":"IQD","name":"Iraqi Dinar","symbol_native":"د.ع.‏","decimal_digits":0,"rounding":0,"code":"IQD","name_plural":"Iraqi dinars"},"IRR":{"symbol":"IRR","name":"Iranian Rial","symbol_native":"﷼","decimal_digits":0,"rounding":0,"code":"IRR","name_plural":"Iranian rials"},"ISK":{"symbol":"Ikr","name":"Icelandic Króna","symbol_native":"kr","decimal_digits":0,"rounding":0,"code":"ISK","name_plural":"Icelandic krónur"},"JMD":{"symbol":"J$","name":"Jamaican Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"JMD","name_plural":"Jamaican dollars"},"JOD":{"symbol":"JD","name":"Jordanian Dinar","symbol_native":"د.أ.‏","decimal_digits":3,"rounding":0,"code":"JOD","name_plural":"Jordanian dinars"},"JPY":{"symbol":"¥","name":"Japanese Yen","symbol_native":"￥","decimal_digits":0,"rounding":0,"code":"JPY","name_plural":"Japanese yen"},"KES":{"symbol":"Ksh","name":"Kenyan Shilling","symbol_native":"Ksh","decimal_digits":2,"rounding":0,"code":"KES","name_plural":"Kenyan shillings"},"KHR":{"symbol":"KHR","name":"Cambodian Riel","symbol_native":"៛","decimal_digits":2,"rounding":0,"code":"KHR","name_plural":"Cambodian riels"},"KMF":{"symbol":"CF","name":"Comorian Franc","symbol_native":"FC","decimal_digits":0,"rounding":0,"code":"KMF","name_plural":"Comorian francs"},"KRW":{"symbol":"₩","name":"South Korean Won","symbol_native":"₩","decimal_digits":0,"rounding":0,"code":"KRW","name_plural":"South Korean won"},"KWD":{"symbol":"KD","name":"Kuwaiti Dinar","symbol_native":"د.ك.‏","decimal_digits":3,"rounding":0,"code":"KWD","name_plural":"Kuwaiti dinars"},"KZT":{"symbol":"KZT","name":"Kazakhstani Tenge","symbol_native":"тңг.","decimal_digits":2,"rounding":0,"code":"KZT","name_plural":"Kazakhstani tenges"},"LBP":{"symbol":"LB£","name":"Lebanese Pound","symbol_native":"ل.ل.‏","decimal_digits":0,"rounding":0,"code":"LBP","name_plural":"Lebanese pounds"},"LKR":{"symbol":"SLRs","name":"Sri Lankan Rupee","symbol_native":"SL Re","decimal_digits":2,"rounding":0,"code":"LKR","name_plural":"Sri Lankan rupees"},"LTL":{"symbol":"Lt","name":"Lithuanian Litas","symbol_native":"Lt","decimal_digits":2,"rounding":0,"code":"LTL","name_plural":"Lithuanian litai"},"LVL":{"symbol":"Ls","name":"Latvian Lats","symbol_native":"Ls","decimal_digits":2,"rounding":0,"code":"LVL","name_plural":"Latvian lati"},"LYD":{"symbol":"LD","name":"Libyan Dinar","symbol_native":"د.ل.‏","decimal_digits":3,"rounding":0,"code":"LYD","name_plural":"Libyan dinars"},"MAD":{"symbol":"MAD","name":"Moroccan Dirham","symbol_native":"د.م.‏","decimal_digits":2,"rounding":0,"code":"MAD","name_plural":"Moroccan dirhams"},"MDL":{"symbol":"MDL","name":"Moldovan Leu","symbol_native":"MDL","decimal_digits":2,"rounding":0,"code":"MDL","name_plural":"Moldovan lei"},"MGA":{"symbol":"MGA","name":"Malagasy Ariary","symbol_native":"MGA","decimal_digits":0,"rounding":0,"code":"MGA","name_plural":"Malagasy Ariaries"},"MKD":{"symbol":"MKD","name":"Macedonian Denar","symbol_native":"MKD","decimal_digits":2,"rounding":0,"code":"MKD","name_plural":"Macedonian denari"},"MMK":{"symbol":"MMK","name":"Myanma Kyat","symbol_native":"K","decimal_digits":0,"rounding":0,"code":"MMK","name_plural":"Myanma kyats"},"MOP":{"symbol":"MOP$","name":"Macanese Pataca","symbol_native":"MOP$","decimal_digits":2,"rounding":0,"code":"MOP","name_plural":"Macanese patacas"},"MUR":{"symbol":"MURs","name":"Mauritian Rupee","symbol_native":"MURs","decimal_digits":0,"rounding":0,"code":"MUR","name_plural":"Mauritian rupees"},"MXN":{"symbol":"MX$","name":"Mexican Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"MXN","name_plural":"Mexican pesos"},"MYR":{"symbol":"RM","name":"Malaysian Ringgit","symbol_native":"RM","decimal_digits":2,"rounding":0,"code":"MYR","name_plural":"Malaysian ringgits"},"MZN":{"symbol":"MTn","name":"Mozambican Metical","symbol_native":"MTn","decimal_digits":2,"rounding":0,"code":"MZN","name_plural":"Mozambican meticals"},"NAD":{"symbol":"N$","name":"Namibian Dollar","symbol_native":"N$","decimal_digits":2,"rounding":0,"code":"NAD","name_plural":"Namibian dollars"},"NGN":{"symbol":"₦","name":"Nigerian Naira","symbol_native":"₦","decimal_digits":2,"rounding":0,"code":"NGN","name_plural":"Nigerian nairas"},"NIO":{"symbol":"C$","name":"Nicaraguan Córdoba","symbol_native":"C$","decimal_digits":2,"rounding":0,"code":"NIO","name_plural":"Nicaraguan córdobas"},"NOK":{"symbol":"Nkr","name":"Norwegian Krone","symbol_native":"kr","decimal_digits":2,"rounding":0,"code":"NOK","name_plural":"Norwegian kroner"},"NPR":{"symbol":"NPRs","name":"Nepalese Rupee","symbol_native":"नेरू","decimal_digits":2,"rounding":0,"code":"NPR","name_plural":"Nepalese rupees"},"NZD":{"symbol":"NZ$","name":"New Zealand Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"NZD","name_plural":"New Zealand dollars"},"OMR":{"symbol":"OMR","name":"Omani Rial","symbol_native":"ر.ع.‏","decimal_digits":3,"rounding":0,"code":"OMR","name_plural":"Omani rials"},"PAB":{"symbol":"B/.","name":"Panamanian Balboa","symbol_native":"B/.","decimal_digits":2,"rounding":0,"code":"PAB","name_plural":"Panamanian balboas"},"PEN":{"symbol":"S/.","name":"Peruvian Nuevo Sol","symbol_native":"S/.","decimal_digits":2,"rounding":0,"code":"PEN","name_plural":"Peruvian nuevos soles"},"PHP":{"symbol":"₱","name":"Philippine Peso","symbol_native":"₱","decimal_digits":2,"rounding":0,"code":"PHP","name_plural":"Philippine pesos"},"PKR":{"symbol":"PKRs","name":"Pakistani Rupee","symbol_native":"₨","decimal_digits":0,"rounding":0,"code":"PKR","name_plural":"Pakistani rupees"},"PLN":{"symbol":"zł","name":"Polish Zloty","symbol_native":"zł","decimal_digits":2,"rounding":0,"code":"PLN","name_plural":"Polish zlotys"},"PYG":{"symbol":"₲","name":"Paraguayan Guarani","symbol_native":"₲","decimal_digits":0,"rounding":0,"code":"PYG","name_plural":"Paraguayan guaranis"},"QAR":{"symbol":"QR","name":"Qatari Rial","symbol_native":"ر.ق.‏","decimal_digits":2,"rounding":0,"code":"QAR","name_plural":"Qatari rials"},"RON":{"symbol":"RON","name":"Romanian Leu","symbol_native":"RON","decimal_digits":2,"rounding":0,"code":"RON","name_plural":"Romanian lei"},"RSD":{"symbol":"din.","name":"Serbian Dinar","symbol_native":"дин.","decimal_digits":0,"rounding":0,"code":"RSD","name_plural":"Serbian dinars"},"RUB":{"symbol":"RUB","name":"Russian Ruble","symbol_native":"руб.","decimal_digits":2,"rounding":0,"code":"RUB","name_plural":"Russian rubles"},"RWF":{"symbol":"RWF","name":"Rwandan Franc","symbol_native":"FR","decimal_digits":0,"rounding":0,"code":"RWF","name_plural":"Rwandan francs"},"SAR":{"symbol":"SR","name":"Saudi Riyal","symbol_native":"ر.س.‏","decimal_digits":2,"rounding":0,"code":"SAR","name_plural":"Saudi riyals"},"SDG":{"symbol":"SDG","name":"Sudanese Pound","symbol_native":"SDG","decimal_digits":2,"rounding":0,"code":"SDG","name_plural":"Sudanese pounds"},"SEK":{"symbol":"Skr","name":"Swedish Krona","symbol_native":"kr","decimal_digits":2,"rounding":0,"code":"SEK","name_plural":"Swedish kronor"},"SGD":{"symbol":"S$","name":"Singapore Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"SGD","name_plural":"Singapore dollars"},"SOS":{"symbol":"Ssh","name":"Somali Shilling","symbol_native":"Ssh","decimal_digits":0,"rounding":0,"code":"SOS","name_plural":"Somali shillings"},"SYP":{"symbol":"SY£","name":"Syrian Pound","symbol_native":"ل.س.‏","decimal_digits":0,"rounding":0,"code":"SYP","name_plural":"Syrian pounds"},"THB":{"symbol":"฿","name":"Thai Baht","symbol_native":"฿","decimal_digits":2,"rounding":0,"code":"THB","name_plural":"Thai baht"},"TND":{"symbol":"DT","name":"Tunisian Dinar","symbol_native":"د.ت.‏","decimal_digits":3,"rounding":0,"code":"TND","name_plural":"Tunisian dinars"},"TOP":{"symbol":"T$","name":"Tongan Paʻanga","symbol_native":"T$","decimal_digits":2,"rounding":0,"code":"TOP","name_plural":"Tongan paʻanga"},"TRY":{"symbol":"TL","name":"Turkish Lira","symbol_native":"TL","decimal_digits":2,"rounding":0,"code":"TRY","name_plural":"Turkish Lira"},"TTD":{"symbol":"TT$","name":"Trinidad and Tobago Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"TTD","name_plural":"Trinidad and Tobago dollars"},"TWD":{"symbol":"NT$","name":"New Taiwan Dollar","symbol_native":"NT$","decimal_digits":2,"rounding":0,"code":"TWD","name_plural":"New Taiwan dollars"},"TZS":{"symbol":"TSh","name":"Tanzanian Shilling","symbol_native":"TSh","decimal_digits":0,"rounding":0,"code":"TZS","name_plural":"Tanzanian shillings"},"UAH":{"symbol":"₴","name":"Ukrainian Hryvnia","symbol_native":"₴","decimal_digits":2,"rounding":0,"code":"UAH","name_plural":"Ukrainian hryvnias"},"UGX":{"symbol":"USh","name":"Ugandan Shilling","symbol_native":"USh","decimal_digits":0,"rounding":0,"code":"UGX","name_plural":"Ugandan shillings"},"UYU":{"symbol":"$U","name":"Uruguayan Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"UYU","name_plural":"Uruguayan pesos"},"UZS":{"symbol":"UZS","name":"Uzbekistan Som","symbol_native":"UZS","decimal_digits":0,"rounding":0,"code":"UZS","name_plural":"Uzbekistan som"},"VEF":{"symbol":"Bs.F.","name":"Venezuelan Bolívar","symbol_native":"Bs.F.","decimal_digits":2,"rounding":0,"code":"VEF","name_plural":"Venezuelan bolívars"},"VND":{"symbol":"₫","name":"Vietnamese Dong","symbol_native":"₫","decimal_digits":0,"rounding":0,"code":"VND","name_plural":"Vietnamese dong"},"XAF":{"symbol":"FCFA","name":"CFA Franc BEAC","symbol_native":"FCFA","decimal_digits":0,"rounding":0,"code":"XAF","name_plural":"CFA francs BEAC"},"XOF":{"symbol":"CFA","name":"CFA Franc BCEAO","symbol_native":"CFA","decimal_digits":0,"rounding":0,"code":"XOF","name_plural":"CFA francs BCEAO"},"YER":{"symbol":"YR","name":"Yemeni Rial","symbol_native":"ر.ي.‏","decimal_digits":0,"rounding":0,"code":"YER","name_plural":"Yemeni rials"},"ZAR":{"symbol":"R","name":"South African Rand","symbol_native":"R","decimal_digits":2,"rounding":0,"code":"ZAR","name_plural":"South African rand"},"ZMK":{"symbol":"ZK","name":"Zambian Kwacha","symbol_native":"ZK","decimal_digits":0,"rounding":0,"code":"ZMK","name_plural":"Zambian kwachas"}};var neededData=[];var countryCode=Object.values(test).map(function(value,index){var obj={};obj.label=value.code;obj.value=value.symbol;neededData.push(obj);});return neededData;}}]);return CountryServices;}();/* harmony default export */ __webpack_exports__["a"] = (new CountryServices());

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ReportServices=function(){function ReportServices(){_classCallCheck(this,ReportServices);}_createClass(ReportServices,[{key:'getReport',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filterData){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/report/'+filterData.reportType,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(filterData)});case 2:result=_context.sent;_context.t0=result.status;_context.next=6;return result.json();case 6:_context.t1=_context.sent;return _context.abrupt('return',{status:_context.t0,text:_context.t1});case 8:case'end':return _context.stop();}}},_callee,this);}));function getReport(_x){return _ref.apply(this,arguments);}return getReport;}()},{key:'getSampleType',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/report/getSampleType',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")}});case 2:result=_context2.sent;_context2.t0=result.status;_context2.next=6;return result.json();case 6:_context2.t1=_context2.sent;return _context2.abrupt('return',{status:_context2.t0,text:_context2.t1});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function getSampleType(){return _ref2.apply(this,arguments);}return getSampleType;}()},{key:'meetingNotesExcel',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/report/meetingNoteExcel',{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify({_id:id})});case 2:result=_context3.sent;_context3.t0=result.status;_context3.next=6;return result.json();case 6:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 8:case'end':return _context3.stop();}}},_callee3,this);}));function meetingNotesExcel(_x2){return _ref3.apply(this,arguments);}return meetingNotesExcel;}()},{key:'bulkUpdateProcess',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(obj){var result,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/report/updateProcess',{method:"PUT",headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':localStorage.getItem("authToken")},body:JSON.stringify(Object.assign({},obj))});case 2:result=_context4.sent;_context4.next=5;return result.json();case 5:data=_context4.sent;return _context4.abrupt('return',{status:result.status,text:data,message:data.message});case 7:case'end':return _context4.stop();}}},_callee4,this);}));function bulkUpdateProcess(_x3){return _ref4.apply(this,arguments);}return bulkUpdateProcess;}()}]);return ReportServices;}();/* harmony default export */ __webpack_exports__["a"] = (new ReportServices());

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_compressorjs__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_compressorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_compressorjs__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FileUploadService=function(){function FileUploadService(){_classCallCheck(this,FileUploadService);}_createClass(FileUploadService,[{key:'uploadFileForFabric',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file,moduleName){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return new Promise(function(resolve,reject){return new __WEBPACK_IMPORTED_MODULE_2_compressorjs___default.a(file,{quality:0.6,success:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:formData=new FormData();formData.append('file',data,data.name);formData.append('fileType',moduleName);_context.next=5;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/uploadFile/'+moduleName),{method:"POST",headers:{'AuthToken':localStorage.getItem("authToken")},body:formData});case 5:result=_context.sent;_context.t0=resolve;_context.t1=result.status;_context.next=10;return result.json();case 10:_context.t2=_context.sent;_context.t3={status:_context.t1,text:_context.t2};(0,_context.t0)(_context.t3);case 13:case'end':return _context.stop();}}},_callee,this);}));function success(_x3){return _ref2.apply(this,arguments);}return success;}(),error:function error(err){reject(err);}});});case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,this);}));function uploadFileForFabric(_x,_x2){return _ref.apply(this,arguments);}return uploadFileForFabric;}()},{key:'uploadFile',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(file,moduleName){var formData,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:formData=new FormData();formData.append('file',file);formData.append('fileType',moduleName);_context3.next=5;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+('api/uploadFile/'+moduleName),{method:"POST",headers:{// 'Accept': 'application/json',
// 'Content-Type': 'multipart/form-data',
'AuthToken':localStorage.getItem("authToken")},body:formData});case 5:result=_context3.sent;_context3.t0=result.status;_context3.next=9;return result.json();case 9:_context3.t1=_context3.sent;return _context3.abrupt('return',{status:_context3.t0,text:_context3.t1});case 11:case'end':return _context3.stop();}}},_callee3,this);}));function uploadFile(_x4,_x5){return _ref3.apply(this,arguments);}return uploadFile;}()},{key:'uploadMeetingNoteImage',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(files){var formData,i,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:formData=new FormData();for(i=0;i<files.length;i++){formData.append("file",files[i]);}_context4.next=4;return fetch(__WEBPACK_IMPORTED_MODULE_1__index__["m" /* UtilityService */].baseUrl()+'api/uploadFile/multiple/MeetingNote',{method:"POST",headers:{// 'Accept': 'application/json',
// 'Content-Type': 'multipart/form-data',
'AuthToken':localStorage.getItem("authToken")},body:formData});case 4:result=_context4.sent;_context4.t0=result.status;_context4.next=8;return result.json();case 8:_context4.t1=_context4.sent;return _context4.abrupt('return',{status:_context4.t0,text:_context4.t1});case 10:case'end':return _context4.stop();}}},_callee4,this);}));function uploadMeetingNoteImage(_x6){return _ref4.apply(this,arguments);}return uploadMeetingNoteImage;}()}]);return FileUploadService;}();/* harmony default export */ __webpack_exports__["a"] = (new FileUploadService());

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Compressor = factory());
})(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  var canvasToBlob = {exports: {}};

  /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */
  (function (module) {
  if (typeof window === 'undefined') {
    return;
  }
    (function (window) {

      var CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
      var hasBlobConstructor = window.Blob && function () {
        try {
          return Boolean(new Blob());
        } catch (e) {
          return false;
        }
      }();
      var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && function () {
        try {
          return new Blob([new Uint8Array(100)]).size === 100;
        } catch (e) {
          return false;
        }
      }();
      var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
      var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
      var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && function (dataURI) {
        var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
        // Parse the dataURI components as per RFC 2397
        matches = dataURI.match(dataURIPattern);
        if (!matches) {
          throw new Error('invalid data URI');
        }
        // Default to text/plain;charset=US-ASCII
        mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
        isBase64 = !!matches[4];
        dataString = dataURI.slice(matches[0].length);
        if (isBase64) {
          // Convert base64 to raw binary data held in a string:
          byteString = atob(dataString);
        } else {
          // Convert base64/URLEncoded data component to raw binary:
          byteString = decodeURIComponent(dataString);
        }
        // Write the bytes of the string to an ArrayBuffer:
        arrayBuffer = new ArrayBuffer(byteString.length);
        intArray = new Uint8Array(arrayBuffer);
        for (i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        }
        // Write the ArrayBuffer (or ArrayBufferView) to a blob:
        if (hasBlobConstructor) {
          return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
            type: mediaType
          });
        }
        bb = new BlobBuilder();
        bb.append(arrayBuffer);
        return bb.getBlob(mediaType);
      };
      if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
        if (CanvasPrototype.mozGetAsFile) {
          CanvasPrototype.toBlob = function (callback, type, quality) {
            var self = this;
            setTimeout(function () {
              if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              } else {
                callback(self.mozGetAsFile('blob', type));
              }
            });
          };
        } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
          if (CanvasPrototype.msToBlob) {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) {
                  callback(dataURLtoBlob(self.toDataURL(type, quality)));
                } else {
                  callback(self.msToBlob(type));
                }
              });
            };
          } else {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              });
            };
          }
        }
      }
      if (module.exports) {
        module.exports = dataURLtoBlob;
      } else {
        window.dataURLtoBlob = dataURLtoBlob;
      }
    })(window);
  })(canvasToBlob);
  var toBlob = canvasToBlob.exports;

  var isBlob = function isBlob(value) {
    if (typeof Blob === 'undefined') {
      return false;
    }
    return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
  };

  var DEFAULTS = {
    /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */
    strict: true,
    /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */
    checkOrientation: true,
    /**
     * Indicates if retain the image's Exif information after compressed.
     * @type {boolean}
    */
    retainExif: false,
    /**
     * The max width of the output image.
     * @type {number}
     */
    maxWidth: Infinity,
    /**
     * The max height of the output image.
     * @type {number}
     */
    maxHeight: Infinity,
    /**
     * The min width of the output image.
     * @type {number}
     */
    minWidth: 0,
    /**
     * The min height of the output image.
     * @type {number}
     */
    minHeight: 0,
    /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */
    width: undefined,
    /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */
    height: undefined,
    /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */
    resize: 'none',
    /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */
    quality: 0.8,
    /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */
    mimeType: 'auto',
    /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */
    convertTypes: ['image/png'],
    /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */
    convertSize: 5000000,
    /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */
    beforeDraw: null,
    /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */
    drew: null,
    /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */
    success: null,
    /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */
    error: null
  };

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};

  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */
  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  var slice = Array.prototype.slice;

  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */
  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  var REGEXP_IMAGE_TYPE = /^image\/.+$/;

  /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */
  function isImageType(value) {
    return REGEXP_IMAGE_TYPE.test(value);
  }

  /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */
  function imageTypeToExtension(value) {
    var extension = isImageType(value) ? value.substr(6) : '';
    if (extension === 'jpeg') {
      extension = 'jpg';
    }
    return ".".concat(extension);
  }
  var fromCharCode = String.fromCharCode;

  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */
  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    var i;
    length += start;
    for (i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }
    return str;
  }
  var btoa = WINDOW.btoa;

  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */
  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = [];
    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);
    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }
    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }

  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */
  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation;

    // Ignores range error when the image does not have correct Exif information
    try {
      var littleEndian;
      var app1Start;
      var ifdStart;

      // Only handle JPEG image (start by 0xFFD8)
      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;
        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }
          offset += 1;
        }
      }
      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;
        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;
          if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
            if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
              var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
              if (firstIFDOffset >= 0x00000008) {
                ifdStart = tiffOffset + firstIFDOffset;
              }
            }
          }
        }
      }
      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);
        var _offset;
        var i;
        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;
          if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */) {
            // 8 is the offset of the current tag's value
            _offset += 8;

            // Get the original orientation value
            orientation = dataView.getUint16(_offset, littleEndian);

            // Override the orientation with its default value
            dataView.setUint16(_offset, 1, littleEndian);
            break;
          }
        }
      }
    } catch (e) {
      orientation = 1;
    }
    return orientation;
  }

  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */
  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;
    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;

      // Rotate left 180°
      case 3:
        rotate = -180;
        break;

      // Flip vertical
      case 4:
        scaleY = -1;
        break;

      // Flip vertical and rotate right 90°
      case 5:
        rotate = 90;
        scaleY = -1;
        break;

      // Rotate right 90°
      case 6:
        rotate = 90;
        break;

      // Flip horizontal and rotate right 90°
      case 7:
        rotate = 90;
        scaleX = -1;
        break;

      // Rotate left 90°
      case 8:
        rotate = -90;
        break;
    }
    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;

  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */
  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }

  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */
  function getAdjustedSizes(_ref) {
    var aspectRatio = _ref.aspectRatio,
      height = _ref.height,
      width = _ref.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);
    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;
      if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }
    return {
      width: width,
      height: height
    };
  }

  /**
   * Get Exif information from the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {Array} The read Exif information.
   */
  function getExif(arrayBuffer) {
    var array = toArray(new Uint8Array(arrayBuffer));
    var length = array.length;
    var segments = [];
    var start = 0;
    while (start + 3 < length) {
      var value = array[start];
      var next = array[start + 1];

      // SOS (Start of Scan)
      if (value === 0xFF && next === 0xDA) {
        break;
      }

      // SOI (Start of Image)
      if (value === 0xFF && next === 0xD8) {
        start += 2;
      } else {
        var offset = array[start + 2] * 256 + array[start + 3];
        var end = start + offset + 2;
        var segment = array.slice(start, end);
        segments.push(segment);
        start = end;
      }
    }
    return segments.reduce(function (exifArray, current) {
      if (current[0] === 0xFF && current[1] === 0xE1) {
        return exifArray.concat(current);
      }
      return exifArray;
    }, []);
  }

  /**
   * Insert Exif information into the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {Array} exifArray - The Exif information to insert.
   * @returns {ArrayBuffer} The transformed array buffer.
   */
  function insertExif(arrayBuffer, exifArray) {
    var array = toArray(new Uint8Array(arrayBuffer));
    if (array[2] !== 0xFF || array[3] !== 0xE0) {
      return arrayBuffer;
    }
    var app0Length = array[4] * 256 + array[5];
    var newArrayBuffer = [0xFF, 0xD8].concat(exifArray, array.slice(4 + app0Length));
    return new Uint8Array(newArrayBuffer);
  }

  var ArrayBuffer$1 = WINDOW.ArrayBuffer,
    FileReader = WINDOW.FileReader;
  var URL = WINDOW.URL || WINDOW.webkitURL;
  var REGEXP_EXTENSION = /\.\w+$/;
  var AnotherCompressor = WINDOW.Compressor;

  /**
   * Creates a new image compressor.
   * @class
   */
  var Compressor = /*#__PURE__*/function () {
    /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */
    function Compressor(file, options) {
      _classCallCheck(this, Compressor);
      this.file = file;
      this.exif = [];
      this.image = new Image();
      this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
      this.aborted = false;
      this.result = null;
      this.init();
    }
    _createClass(Compressor, [{
      key: "init",
      value: function init() {
        var _this = this;
        var file = this.file,
          options = this.options;
        if (!isBlob(file)) {
          this.fail(new Error('The first argument must be a File or Blob object.'));
          return;
        }
        var mimeType = file.type;
        if (!isImageType(mimeType)) {
          this.fail(new Error('The first argument must be an image File or Blob object.'));
          return;
        }
        if (!URL || !FileReader) {
          this.fail(new Error('The current browser does not support image compression.'));
          return;
        }
        if (!ArrayBuffer$1) {
          options.checkOrientation = false;
          options.retainExif = false;
        }
        var isJPEGImage = mimeType === 'image/jpeg';
        var checkOrientation = isJPEGImage && options.checkOrientation;
        var retainExif = isJPEGImage && options.retainExif;
        if (URL && !checkOrientation && !retainExif) {
          this.load({
            url: URL.createObjectURL(file)
          });
        } else {
          var reader = new FileReader();
          this.reader = reader;
          reader.onload = function (_ref) {
            var target = _ref.target;
            var result = target.result;
            var data = {};
            var orientation = 1;
            if (checkOrientation) {
              // Reset the orientation value to its default value 1
              // as some iOS browsers will render image with its orientation
              orientation = resetAndGetOrientation(result);
              if (orientation > 1) {
                _extends(data, parseOrientation(orientation));
              }
            }
            if (retainExif) {
              _this.exif = getExif(result);
            }
            if (checkOrientation || retainExif) {
              if (!URL

              // Generate a new URL with the default orientation value 1.
              || orientation > 1) {
                data.url = arrayBufferToDataURL(result, mimeType);
              } else {
                data.url = URL.createObjectURL(file);
              }
            } else {
              data.url = result;
            }
            _this.load(data);
          };
          reader.onabort = function () {
            _this.fail(new Error('Aborted to read the image with FileReader.'));
          };
          reader.onerror = function () {
            _this.fail(new Error('Failed to read the image with FileReader.'));
          };
          reader.onloadend = function () {
            _this.reader = null;
          };
          if (checkOrientation || retainExif) {
            reader.readAsArrayBuffer(file);
          } else {
            reader.readAsDataURL(file);
          }
        }
      }
    }, {
      key: "load",
      value: function load(data) {
        var _this2 = this;
        var file = this.file,
          image = this.image;
        image.onload = function () {
          _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
            naturalWidth: image.naturalWidth,
            naturalHeight: image.naturalHeight
          }));
        };
        image.onabort = function () {
          _this2.fail(new Error('Aborted to load the image.'));
        };
        image.onerror = function () {
          _this2.fail(new Error('Failed to load the image.'));
        };

        // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.
        if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) {
          // Fix the `The operation is insecure` error (#57)
          image.crossOrigin = 'anonymous';
        }
        image.alt = file.name;
        image.src = data.url;
      }
    }, {
      key: "draw",
      value: function draw(_ref2) {
        var _this3 = this;
        var naturalWidth = _ref2.naturalWidth,
          naturalHeight = _ref2.naturalHeight,
          _ref2$rotate = _ref2.rotate,
          rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate,
          _ref2$scaleX = _ref2.scaleX,
          scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX,
          _ref2$scaleY = _ref2.scaleY,
          scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
        var file = this.file,
          image = this.image,
          options = this.options;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
        var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber(options.width) && isPositiveNumber(options.height);
        var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
        var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
        var minWidth = Math.max(options.minWidth, 0) || 0;
        var minHeight = Math.max(options.minHeight, 0) || 0;
        var aspectRatio = naturalWidth / naturalHeight;
        var width = options.width,
          height = options.height;
        if (is90DegreesRotated) {
          var _ref3 = [maxHeight, maxWidth];
          maxWidth = _ref3[0];
          maxHeight = _ref3[1];
          var _ref4 = [minHeight, minWidth];
          minWidth = _ref4[0];
          minHeight = _ref4[1];
          var _ref5 = [height, width];
          width = _ref5[0];
          height = _ref5[1];
        }
        if (resizable) {
          aspectRatio = width / height;
        }
        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: maxWidth,
          height: maxHeight
        }, 'contain');
        maxWidth = _getAdjustedSizes.width;
        maxHeight = _getAdjustedSizes.height;
        var _getAdjustedSizes2 = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minWidth,
          height: minHeight
        }, 'cover');
        minWidth = _getAdjustedSizes2.width;
        minHeight = _getAdjustedSizes2.height;
        if (resizable) {
          var _getAdjustedSizes3 = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: width,
            height: height
          }, options.resize);
          width = _getAdjustedSizes3.width;
          height = _getAdjustedSizes3.height;
        } else {
          var _getAdjustedSizes4 = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: width,
            height: height
          });
          var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
          width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
          var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
          height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
        }
        width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
        height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
        var destX = -width / 2;
        var destY = -height / 2;
        var destWidth = width;
        var destHeight = height;
        var params = [];
        if (resizable) {
          var srcX = 0;
          var srcY = 0;
          var srcWidth = naturalWidth;
          var srcHeight = naturalHeight;
          var _getAdjustedSizes5 = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: naturalWidth,
            height: naturalHeight
          }, {
            contain: 'cover',
            cover: 'contain'
          }[options.resize]);
          srcWidth = _getAdjustedSizes5.width;
          srcHeight = _getAdjustedSizes5.height;
          srcX = (naturalWidth - srcWidth) / 2;
          srcY = (naturalHeight - srcHeight) / 2;
          params.push(srcX, srcY, srcWidth, srcHeight);
        }
        params.push(destX, destY, destWidth, destHeight);
        if (is90DegreesRotated) {
          var _ref6 = [height, width];
          width = _ref6[0];
          height = _ref6[1];
        }
        canvas.width = width;
        canvas.height = height;
        if (!isImageType(options.mimeType)) {
          options.mimeType = file.type;
        }
        var fillStyle = 'transparent';

        // Converts PNG files over the `convertSize` to JPEGs.
        if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) {
          options.mimeType = 'image/jpeg';
        }
        var isJPEGImage = options.mimeType === 'image/jpeg';
        if (isJPEGImage) {
          fillStyle = '#fff';
        }

        // Override the default fill color (#000, black)
        context.fillStyle = fillStyle;
        context.fillRect(0, 0, width, height);
        if (options.beforeDraw) {
          options.beforeDraw.call(this, context, canvas);
        }
        if (this.aborted) {
          return;
        }
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.drawImage.apply(context, [image].concat(params));
        context.restore();
        if (options.drew) {
          options.drew.call(this, context, canvas);
        }
        if (this.aborted) {
          return;
        }
        var callback = function callback(blob) {
          if (!_this3.aborted) {
            var done = function done(result) {
              return _this3.done({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                result: result
              });
            };
            if (blob && isJPEGImage && options.retainExif && _this3.exif && _this3.exif.length > 0) {
              var next = function next(arrayBuffer) {
                return done(toBlob(arrayBufferToDataURL(insertExif(arrayBuffer, _this3.exif), options.mimeType)));
              };
              if (blob.arrayBuffer) {
                blob.arrayBuffer().then(next).catch(function () {
                  _this3.fail(new Error('Failed to read the compressed image with Blob.arrayBuffer().'));
                });
              } else {
                var reader = new FileReader();
                _this3.reader = reader;
                reader.onload = function (_ref7) {
                  var target = _ref7.target;
                  next(target.result);
                };
                reader.onabort = function () {
                  _this3.fail(new Error('Aborted to read the compressed image with FileReader.'));
                };
                reader.onerror = function () {
                  _this3.fail(new Error('Failed to read the compressed image with FileReader.'));
                };
                reader.onloadend = function () {
                  _this3.reader = null;
                };
                reader.readAsArrayBuffer(blob);
              }
            } else {
              done(blob);
            }
          }
        };
        if (canvas.toBlob) {
          canvas.toBlob(callback, options.mimeType, options.quality);
        } else {
          callback(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
        }
      }
    }, {
      key: "done",
      value: function done(_ref8) {
        var naturalWidth = _ref8.naturalWidth,
          naturalHeight = _ref8.naturalHeight,
          result = _ref8.result;
        var file = this.file,
          image = this.image,
          options = this.options;
        if (URL && image.src.indexOf('blob:') === 0) {
          URL.revokeObjectURL(image.src);
        }
        if (result) {
          // Returns original file if the result is greater than it and without size related options
          if (options.strict && !options.retainExif && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) {
            result = file;
          } else {
            var date = new Date();
            result.lastModified = date.getTime();
            result.lastModifiedDate = date;
            result.name = file.name;

            // Convert the extension to match its type
            if (result.name && result.type !== file.type) {
              result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
            }
          }
        } else {
          // Returns original file if the result is null in some cases.
          result = file;
        }
        this.result = result;
        if (options.success) {
          options.success.call(this, result);
        }
      }
    }, {
      key: "fail",
      value: function fail(err) {
        var options = this.options;
        if (options.error) {
          options.error.call(this, err);
        } else {
          throw err;
        }
      }
    }, {
      key: "abort",
      value: function abort() {
        if (!this.aborted) {
          this.aborted = true;
          if (this.reader) {
            this.reader.abort();
          } else if (!this.image.complete) {
            this.image.onload = null;
            this.image.onabort();
          } else {
            this.fail(new Error('The compression process has been aborted.'));
          }
        }
      }

      /**
       * Get the no conflict compressor class.
       * @returns {Compressor} The compressor class.
       */
    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Compressor = AnotherCompressor;
        return Compressor;
      }

      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */
    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        _extends(DEFAULTS, options);
      }
    }]);
    return Compressor;
  }();

  return Compressor;

}));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertContainer = __webpack_require__(382);

var _AlertContainer2 = _interopRequireDefault(_AlertContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AlertContainer2.default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(383);

var _nanoid = __webpack_require__(392);

var _nanoid2 = _interopRequireDefault(_nanoid);

var _Container = __webpack_require__(394);

var _Container2 = _interopRequireDefault(_Container);

var _alert = __webpack_require__(424);

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertContainer = function (_Component) {
  _inherits(AlertContainer, _Component);

  function AlertContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlertContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertContainer.__proto__ || Object.getPrototypeOf(AlertContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      alerts: []
    }, _this.success = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.type = 'success';
      return _this.show(message, options);
    }, _this.error = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.type = 'error';
      return _this.show(message, options);
    }, _this.info = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      options.type = 'info';
      return _this.show(message, options);
    }, _this.show = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          theme = _this$props.theme,
          time = _this$props.time;


      var alert = _extends({
        id: (0, _nanoid2.default)(7),
        message: message,
        time: time,
        theme: theme
      }, options);

      _this.setState(function (prevState) {
        return {
          alerts: prevState.alerts.concat(alert)
        };
      });
      return alert.id;
    }, _this.removeAll = function () {
      var alertsRemoved = _this.state.alerts;
      _this.setState({ alerts: [] });
      alertsRemoved.forEach(function (alert) {
        return alert.onClose && alert.onClose();
      });
    }, _this.removeAlert = function (id) {
      var alertRemoved = _this.state.alerts.filter(function (alert) {
        return alert.id === id;
      })[0];
      _this.setState(function (prevState) {
        return {
          alerts: prevState.alerts.filter(function (alert) {
            return alert.id !== id;
          })
        };
      });
      alertRemoved && alertRemoved.onClose && alertRemoved.onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlertContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          position = _props.position,
          offset = _props.offset,
          transition = _props.transition;


      return _react2.default.createElement(
        _Container2.default,
        { glam: { position: position, offset: offset } },
        _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: transition,
            transitionEnterTimeout: 250,
            transitionLeaveTimeout: 250
          },
          this.state.alerts.map(function (alert) {
            return _react2.default.createElement(_alert2.default, _extends({
              key: alert.id
            }, alert, {
              onRemoveAlert: _this2.removeAlert
            }));
          })
        )
      );
    }
  }]);

  return AlertContainer;
}(_react.Component);

AlertContainer.defaultProps = {
  offset: 14,
  position: 'bottom left',
  theme: 'dark',
  time: 5000,
  transition: 'scale'
};
AlertContainer.propTypes = {
  offset: _propTypes2.default.number,
  position: _propTypes2.default.oneOf(['bottom left', 'bottom right', 'top right', 'top left', 'top center', 'bottom center']),
  theme: _propTypes2.default.oneOf(['dark', 'light']),
  time: _propTypes2.default.number,
  transition: _propTypes2.default.oneOf(['scale', 'fade'])
};
exports.default = AlertContainer;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(384);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(183);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(183);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(388);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(184);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(185);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(390);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(391);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _PropTypes = __webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(129);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(186));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(129);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(186));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var random = __webpack_require__(393)

var url = '_~0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

/**
 * Generate secure URL-friendly unique ID.
 *
 * By default, ID will have 22 symbols to have same collisions probability
 * as UUID v4.
 *
 * @param {number} [size=22] The number of symbols in ID.
 *
 * @return {string} Random string.
 *
 * @example
 * var nanoid = require('nanoid')
 * model.id = nanoid() //=> "Uakgb_J5m9g~0JDMbcJqLJ"
 *
 * @name nanoid
 */
module.exports = function (size) {
  size = size || 22
  var id = ''
  var bytes = random(size)
  for (var i = 0; i < size; i++) {
    id += url[bytes[i] & 63]
  }
  return id
}


/***/ }),
/* 393 */
/***/ (function(module, exports) {

var crypto = window.crypto || window.msCrypto

module.exports = function (bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes))
}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorousCjs = __webpack_require__(77);

var _glamorousCjs2 = _interopRequireDefault(_glamorousCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (0, _glamorousCjs2.default)('div')({
  position: 'fixed',
  right: 0,
  bottom: 0,
  margin: '14px',
  zIndex: 999999
}, function (props) {
  switch (props.glam.position) {
    case 'top left':
      return {
        margin: props.glam.offset + 'px',
        top: 0,
        right: 'auto',
        bottom: 'auto',
        left: 0
      };
    case 'top right':
      return {
        margin: props.glam.offset + 'px',
        top: 0,
        right: 0,
        bottom: 'auto',
        left: 'auto'
      };
    case 'bottom left':
      return {
        margin: props.glam.offset + 'px',
        top: 'auto',
        right: 'auto',
        bottom: 0,
        left: 0
      };
    case 'bottom right':
      return {
        margin: props.glam.offset + 'px',
        top: 'auto',
        right: 0,
        bottom: 0,
        left: 'auto'
      };
    case 'top center':
      return {
        margin: props.glam.offset + 'px',
        top: 0,
        right: 'auto',
        bottom: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)'
      };
    case 'bottom center':
      return {
        margin: props.glam.offset + 'px',
        top: 'auto',
        right: 'auto',
        bottom: 0,
        left: '50%',
        transform: 'translate(-50%,0%)'
      };
  }
});

exports.default = Container;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(396);

var _CSSPropertyOperations = __webpack_require__(188);

var _clean = __webpack_require__(405);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(406);

var _hash = __webpack_require__(423);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(398);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(400);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(189);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(403);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(188);

var _prefixer = __webpack_require__(407);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(408);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(409);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(410);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(411);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(412);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(413);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(414);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(415);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(416);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(417);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(418);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(419);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(420);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(190);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(78);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(78);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(78);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(78);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(421);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(78);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(190);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(422);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertMessage = __webpack_require__(425);

var _AlertMessage2 = _interopRequireDefault(_AlertMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AlertMessage2.default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Alert = __webpack_require__(426);

var _Alert2 = _interopRequireDefault(_Alert);

var _Message = __webpack_require__(427);

var _Message2 = _interopRequireDefault(_Message);

var _Icon = __webpack_require__(428);

var _Icon2 = _interopRequireDefault(_Icon);

var _Close = __webpack_require__(429);

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertMessage = function (_Component) {
  _inherits(AlertMessage, _Component);

  function AlertMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlertMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertMessage.__proto__ || Object.getPrototypeOf(AlertMessage)).call.apply(_ref, [this].concat(args))), _this), _this._removeItself = function () {
      var _this$props = _this.props,
          onRemoveAlert = _this$props.onRemoveAlert,
          id = _this$props.id;

      onRemoveAlert(id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlertMessage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var time = this.props.time;


      if (time > 0) {
        setTimeout(function () {
          _this2._removeItself();
        }, time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          theme = _props.theme,
          icon = _props.icon,
          type = _props.type;

      var dark = theme === 'dark';

      return _react2.default.createElement(
        _Alert2.default,
        { glam: { dark: dark } },
        _react2.default.createElement(
          _Icon.IconPlaceholder,
          null,
          icon || _react2.default.createElement(_Icon2.default, { glam: { type: type } })
        ),
        _react2.default.createElement(
          _Message2.default,
          null,
          message
        ),
        _react2.default.createElement(_Close2.default, {
          glam: { dark: dark },
          onClick: this._removeItself
        })
      );
    }
  }]);

  return AlertMessage;
}(_react.Component);

AlertMessage.defaultProps = {
  id: '',
  icon: null,
  message: '',
  type: 'info',
  theme: 'dark',
  time: 0,
  onRemoveAlert: function onRemoveAlert() {}
};
AlertMessage.propTypes = {
  id: _propTypes2.default.string,
  icon: _propTypes2.default.element,
  message: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  type: _propTypes2.default.oneOf(['info', 'success', 'error']),
  theme: _propTypes2.default.oneOf(['dark', 'light']),
  time: _propTypes2.default.number,
  onRemoveAlert: _propTypes2.default.func
};
exports.default = AlertMessage;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorousCjs = __webpack_require__(77);

var _glamorousCjs2 = _interopRequireDefault(_glamorousCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = (0, _glamorousCjs2.default)('div')({
  width: '300px',
  minHeight: '50px',
  margin: '10px 0 0 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: '2px',
  fontSize: '11px',
  boxShadow: '0 8px 12px 0 rgba(0,0,0,0.3)',
  position: 'relative',
  '&.scale-enter': {
    transform: 'scale(0)'
  },
  '&.scale-enter.scale-enter-active': {
    transform: 'scale(1)',
    transition: 'all 250ms cubic-bezier(0, 0, 0.5, 1.5)'
  },
  '&.scale-leave': {
    transform: 'scale(1)'
  },
  '&.scale-leave.scale-leave-active': {
    transform: 'scale(0)',
    transition: 'all 250ms ease-in-out'
  },
  '&.fade-enter': {
    opacity: '0.1'
  },
  '&.fade-enter.fade-enter-active': {
    opacity: '1',
    transition: 'all 250ms ease-out'
  },
  '&.fade-leave': {
    opacity: '1'
  },
  '&.fade-leave.fade-leave-active': {
    opacity: '0.1',
    transition: 'all 250ms ease-in'
  }
}, function (props) {
  return {
    backgroundColor: '' + (props.glam.dark ? '#333' : '#fff'),
    color: '' + (props.glam.dark ? '#fff' : '#333')
  };
});

exports.default = Alert;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorousCjs = __webpack_require__(77);

var _glamorousCjs2 = _interopRequireDefault(_glamorousCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = (0, _glamorousCjs2.default)('div')({
  flex: 3,
  textAlign: 'center',
  textTransform: 'uppercase',
  padding: '8px 10px',
  marginRight: '50px'
});

exports.default = Message;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPlaceholder = undefined;

var _glamorousCjs = __webpack_require__(77);

var _glamorousCjs2 = _interopRequireDefault(_glamorousCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = (0, _glamorousCjs2.default)('div')({
  width: '32px',
  height: '32px'
}, function (props) {
  switch (props.glam.type) {
    case 'error':
      return {
        'background': 'url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAEKklEQVRIiZ2WzW5TRxTHf2dMEtckbYwi0tIgpVI3SJFYVO4uq+67ZUeRuuIVeAsCyBKlUrup2PIEfQCQWNBFpGYBsnBTtZZdnMSkxHO6mI87M/dahE40yvjcmfP/n88Z4f8PWbBuGtq0zg4dffP1NvArsH1uTRpkiu58xb/Xrn9/+fbtn98HDKgp9N76UGCNf24stVo//vHgwS2cYQIYKiMzY0vwc48KmGwCtJeWHg3v3/8uAQ4zJSAfBB6Uq+Zyq26m4o+Wlx+9vnfvZgGeETg3eGmhRbGQTMUuLWVnOisrPwz29hZ54P3gqTujTN20CtZW7kdBVdHENavt9sPB3t7NBgKL3Z6CBrA4UayHtKgjYuFs/zfs8dSfqUisttsPX929+y1Fwl1oAk0tdDK3sAWxMgRy/A+nT35BREBBBARBgAtqrwNPPAGtgduEWla/KVhweQBO1pGY1YSAAhKIB2ABtGZ5dHMKqqml6sHUW+0hNQLgcNXrMsiC/peCyyJgG4C8eVar71WJqTdJEZXoQo2G5vaV4FiLGKEGHADs2ifYy1uwvhHPGMCO/8b+OYDpBFXBCpiEgLMqEohpFcCTL9oArMy3vkQ3txrdZ7obmO4G88MBdnDglPlYB5cbicAx4dJSE4uNtDLgz7YjcOvSpRp4kLU+vUrryhdOv4pv7DGFU8sVf7FkASkTzC630SvbAHR6PTbv3KHT68X9pcx8vg0rK67MgtsFjHNFmAL1UpNWRkBdjP24uLsLwPqNG1EW1hd3dzl5+tSBbV5FB7876yWzLq3IenvNsl2Bzmr8Nur3eTccRtAA/G44ZNTvx33SWXU1HlNeMM4NWbfOYt5Ib2298sxsxqjfZz4eR9l8PGbU72Nns0rR2jppqvsQlDVXe0yk37z2s0za3tmh1e3G361ul/bOTn709K2Lt5RXUlTc7PbazjeTuO70epmr0xCkSagnR7VL3GQWuZGCFw87H7HJX3FDSLgQ4zQHwjf8mUxHA0YJ7ranXQlgdAinb92y3+fk2bMY45ADQQa4vaPDTMei3m6KHxr4iriuZBDswQuYn2FnMyaPH2fJlcnmZ9iDFxgEExLNUzCF1QE8E+ZvHd+lZsfY/efodFKej0OnE+z+c8zsODubvZuS7ZA3GTWeiwiICiZkqwKegF1bR9a6yMeuBPXNBJ2OkekEI4LBe0wqDzorTQQNo3afp89LgdAcQN0DwR5N0OkEHVZnHJjE/UbqT9amogvgCogxqLv6nPVGBYv6G8nJDZK1KYGkhVbAhqq1CoKYvHc1Wo7fbNB4LyvuOaSIa79S7icHIlwmDcXWYHlkJOJ6eiCg4XHhSahotZk0TFKQqID9cy6zGuql9hPwsqr1KmNDErVEMAgtPw3iZDHJ6sDAS6+75rGmIQ3r8n85yphqw7ds/AdwGih6rYATKAAAAABJRU5ErkJggg==\') no-repeat'
      };
    case 'info':
      return {
        'background': 'url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAACXBIWXMAAA7EAAAOxAGVKw4bAAADeUlEQVRIiaWXv28cRRTHPzOz9yPGiEuVLkpBhQQk/4AjUtBZAruhQBC3lPRRhOjzLwSnoiAxIR0SWL6WhkAbgUVDikg+O9h33tuZR7Eze7Ozu87ZftLT3s3NvM/3vdl9c6u4oMkzbgK7/utHap3fzxtDXRI88kOTiwjQ5+SqfIdbIuyKMBIB7yMRdvMdbp0rmHdZYh75Djczw68sMk5tUlju9D+tKnBm3Fa4L+toXnCoFCMF76D4RCm+rOZEK1Rz87bF8aPAIUBmEGCSbkuAVyrlGQ9FuEs8GMHkjFyCiOra/O07tc5WJ9z9tKhCDA6OahcQgsQCUhFKgVpfaMq6spAUGsacH+sAqyBAFmNec0N0CldtYAGcq4+HeWFRBZZF1kpA67qAoCPAazdco9Qe7AJUK3pvGXSmyPoaZwVXCPOZw55aFB7owc4tBKSWJQl0gp1AbyVjsGoWq0draEBPxmQDjbOG6WSOtYKJwNIglAk3yt4F7q9m9FdMffYHP5fX8RAAbRQrV/ucHOQ4KxVYfG3T7EOHqw1Xe+uvOtNNcIcpDYO3M6zz90l8j0id1Wiv8R0pVbmXAwfL+hrT06V46gISnSUnFRB7b3jeIwBMXzcf1URAHDVuODXVF7Gsr1ofyxR+wfBvtg5w955Tns2XtnnemlMtdgPuhHE6ls9cO2E8rB6z1IpT1+jtPnalKoYLINaxFxaEtnl6bNvha7PSE5ufOorcNQ6XELsNDsCrI55Wvdm7zR2z/zoEJCYOTg4LdBID4PWUp2fCr2+xbx2PoFykvU+PCqavEwF/fFy6N1sIR69yxMrioPFxRHh07XP2Y5218z74Pw+5cW3Ei7i9OgfWAVoxXDVkPUVvoLGFUMzLgyU/sWhdijWa6rPW8PKAd69v8TfR2ZXCKxHHP3A/M9xLBThp71ihSsrDjKY64Zzj2yubfMOifTTgcfYAevaEX5RiLYa2wcOe6ggYriKMhxvcScHQ/pxXE/7cZxPheVw+4z0zYIKH7/63MBfh+V8v2aCjkbW9NNTK/9sDrr5/g8dasVb7h9O2IL67hb0X/7L53lccpEktA6/FnT7mvtHcW+YPZGFre9wK7oJ3Cph8z4crAx4oxe2OdXvHM74efdb60tCQ/KZ3tTYRTJ9w22juasUXfmh7btm+slF1sBS09J5fZl5qZ56Y/wP3DczlGSWQRAAAAABJRU5ErkJggg==\') no-repeat'
      };
    case 'success':
      return {
        'background': 'url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAD9UlEQVRIiZ2WzWucRRzHPzO7efYlu8HmxfRiaMMWxByECnpaPAmezH9QC/0ThJ4LXmx79VRb0IMnT/4FBWuo8WBAaVEJ0q5IqzEbNLubZrN5xsO87Mw88ySpA5M8efLMfH7f39uM4P8PUfKcGir1HC66/+UF4D5w4eStVPLd+/PLvNdeuPZR560vTgMDSkZbXH1psFLehEq1eu/2L99fRQsTgGQqMhAbw19uRGArbKZWu3v7580PPbCdvgHi5eApdzsj8sCpM/X63VuPv7sSwQMDzg4PVCrIczOV+10XYQplzcZnNx89LPPAGeAWlvyf+aFw3yilUN73tdnmnZuPHl5JGHCC20+EGrX2txnf7P5Jf3xYMKI227zzyU8bHxAlXDW5cdk7D+SSTOEM6R+/4ONffwTf/VKAlHA0eRP42higivA8Dxf6HrAgm1XuXe49K7O33UfEHrRgAaii8hSUqKRc0pksd970jBSAUFp1iUd9+FRyDM6jTE9NCw92MspjbybdbpeVgDv1JmvtOeZnMrdgnOf0RgO29vYYTI50TitMbgtvhmAfHqkOwRnQPbfISqNZcF0mJZ3WHCvNFpu7O2zv7+skU2i32zBr9d6LsM6FKx9fcZ7TfWUhCY6N6C4tc75RNzBPOYCQNhvc9Jv+1CleLDvN2VPB/uguncf1Eetg4cTiP4RNJs9DQ3LF2uzcqcCVRptP197lxqW3aVWrdFptAvUIHYrwSE21V79mFfNZxuutc6wvr7KY1ZPg66uXaVaqLGYNABaymtldesqd6oLyoOHHJbS+fJH15YvcuPQOK412Ejw6nnDrtx8AmM8yDQxKUMSFXrhMJMe3/WcANCtVrq9eZqXRToJ7B/uALj8HDpuLDX6yzgtjnOds7Gn4tdfecAZYY2IwQP9oHNX4mWMejt5oCMDG3jPu/f7YQcvAAE9HQ6/EghxOwoNE8C3e+mdPuzEyoAzcGw3pj8eAV+Mll9uE24XODVMig+NjNvt/01181RkwOp6we/SiAO6PD3mw+5d2ccyVsnCyhHD7gW0KUhuwPRwwmEzoLi7Rqs6w9e9OweTecMCD3R3Gep9iXw/RLuFsv51aqkyC5MaQiuT5+JCv/ujRabZZyDLma7qWnx8c8HQ0pD8Z64uRNGvdYSKsMAdNKVfB2WsXS6kvGRJQku3RgO1R7EFzW7HwWHXxSA3gU/XCxFwJDcyNAbbpiKh+bfv0DxJXWt7fKj70iwkXxtwaoJiGwAc74V5Zxf28RHUMD0sNvEQRUPFuN37r9L9NeSElzoywyUj5OfBkqiKKm5A6BFInIRWbYCbeohT8xOwdjDKfiMTzyR1jqqoQW+JCM+M/oQ0MxVFidYQAAAAASUVORK5CYII=\') no-repeat'
      };
  }
});

var IconPlaceholder = exports.IconPlaceholder = (0, _glamorousCjs2.default)('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '50px'
});

exports.default = Icon;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorousCjs = __webpack_require__(77);

var _glamorousCjs2 = _interopRequireDefault(_glamorousCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = (0, _glamorousCjs2.default)('div')({
  width: '50px',
  height: '100%',
  borderRadius: '0 2px 2px 0',
  cursor: 'pointer',
  position: 'absolute',
  top: 0,
  right: 0,
  ':hover': {
    opacity: '0.5'
  }
}, function (props) {
  return {
    background: 'url(\'data:image/svg+xml;utf8,<svg fill="' + (props.glam.dark ? '%23fff' : '%23333') + '" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 48 48" width="48"><path d="M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z"/><path d="M0 0h48v48h-48z" fill="none"/></svg>\') no-repeat',
    backgroundPosition: '50%',
    backgroundSize: '25px',
    backgroundColor: (props.glam.dark ? '#444' : '#f3f3f3') + ' !important'
  };
});

exports.default = Close;

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(437);
/* unused harmony reexport Footer */
// export { Layout } from './layout';


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_logo4_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_logo4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_logo4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_default_profile_jpg__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_default_profile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_default_profile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Group_png__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Group_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_Group_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_action_Header__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_common_options__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//
var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={isOpen:false,toggle:true};_this.logOut=_this.logOut.bind(_this);_this.toggleChange=_this.toggleChange.bind(_this);return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'toggleChange',value:function toggleChange(){function hasClass(element,className){return(' '+element.className+' ').indexOf(' '+className+' ')>-1;}var toggleClass=document.getElementById("toggle-nav-bar");var toggle=hasClass(toggleClass,"class-nav-bar");this.setState({toggle:toggle});this.props.ToggleChange(toggle);}},{key:'logOut',value:function logOut(){localStorage.removeItem("authToken");localStorage.clear();this.props.signOut();this.props.history!==undefined&&this.props.history.push("/");}},{key:'render',value:function render(){var _this2=this;var toggle=this.state.toggle;var userDetails=this.props.userDetails;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:!this.props.toggle?__WEBPACK_IMPORTED_MODULE_3__assets_images_Group_png___default.a:__WEBPACK_IMPORTED_MODULE_1__assets_images_logo4_png___default.a,alt:'Magnum'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pro-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'pro-img-src',src:userDetails.profilePicture!==""?__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].fileUrl()+userDetails.profilePicture:__WEBPACK_IMPORTED_MODULE_2__assets_images_default_profile_jpg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-logged'},'HI! ',userDetails.firstName+' '+userDetails.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/profile");},style:{cursor:"pointer",color:"white"}},'PROFILE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(){return _this2.logOut();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:"pointer",color:"white"}},'LOGOUT'))))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{toggle:state.Header.toggle,userDetails:state.main};};var mapDispatchToProps=function mapDispatchToProps(dispatch){// options.filter((data) => data.moduleName == this.props.location.moduleName)
return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({"ToggleChange":__WEBPACK_IMPORTED_MODULE_8__redux_action_Header__["a" /* ToggleChange */],"signOut":__WEBPACK_IMPORTED_MODULE_9__redux_action_main__["signOut"]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Header)));

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Group.c054c5cf.png";

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_dashboard_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_action_Header__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sidebar=function(_Component){_inherits(Sidebar,_Component);function Sidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,status:1,toggle:{development:false,fabric:false,system:false,employee:false},rights:{},PageLeave:false,reportRights:false},_this.addClass=function(e){var toggleClass=document.getElementById("toggle-nav-bar");toggleClass.classList.add("class-nav-bar");_this.props.ToggleChange(true);},_this.removeClass=function(e){setTimeout(function(){var toggleClass=document.getElementById("toggle-nav-bar");toggleClass.classList.remove("class-nav-bar");var toggle=Object.assign({},_this.state.toggle);Object.keys(toggle).forEach(function(keyName){return toggle[keyName]=false;});_this.setState({toggle:toggle});_this.props.ToggleChange(false);},500);},_this.selected=function(e,pathVal){var el=document.getElementById(pathVal);if(pathVal!=="development"||pathVal!=="style"||pathVal!=="system"||pathVal!=="permission"){_this.props.history.push(pathVal);}},_this.setQueryString=function(modulename){_this.props.history.push({pathname:"/system",search:modulename});},_this.toggleOpen=function(moduleName){var toggle=Object.assign({},_this.state.toggle);toggle[moduleName]=!_this.state.toggle[moduleName];_this.setState({toggle:toggle});},_this.confirmLeavePage=function(obj){var pathname=_this.props.location.pathname;var pathNameList=['/CostingPage','/StylePage','/Sample','/MeetingNote','/developmentCad','developmentFabric','/Trim','/BNumber','/bulkImport','/printFabricNumber','/SmvThread','/technicalIssues','/printStyleNumber','/CustomerPage','/employee','/permissionRole','/Report'];if(pathNameList.includes(pathname)){// console.log("CLICKED")
Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" p-5 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You want to Leave this page?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.setState({PageLeave:true});obj.nextAction();onClose();}},"Yes"));},closeOnClickOutside:true});}else{// `${nextAction()}`
obj.nextAction();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sidebar,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,location=_props.location,rights=_props.rights;var r=Object.assign({},rights.reports);var reportRights=Object.keys(r).reduce(function(a,x){if(r[x].web&&r[x]['web'].create||r[x].web&&r[x]['web'].edit||r[x].web&&r[x]['web'].view||r[x].web&&r[x]['web'].delete){a=true;}return a;},false);this.setState({reportRights:reportRights});// console.log("sasasas", location)
// if (location.pathname === "/CostingPage") {
//     let query = document.getElementById("sideBar").querySelectorAll("a");
//     console.log(query, "Length")
//     query.forEach((x, i) => {
//         console.log(x, "sasasassa")
//         x.addEventListener('click', () => {
//             this.confirmLeavePage({ nextAction: () => { this.selected(x, '', this.props.history.push('/')) } })
//         });
//         // document.getElementsByTagName(x)[0].setAttribute("onclick", "e => {this.confirmLeavePage({nextAction: () => {this.selected(e, '', this.props.history.push('/'))}})}"); 
//     })
// }
}},{key:"render",value:function render(){var _this2=this;var _state=this.state,toggle=_state.toggle,rights=_state.rights,reportRights=_state.reportRights;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"left-section",id:"left-sec-id",onMouseOver:function onMouseOver(e){return _this2.addClass(e);},onMouseLeave:function onMouseLeave(e){return _this2.removeClass(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"nav"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"left-nav",id:"sideBar"},this.props.rights.dashboard.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",id:"dashboard",onClick:function onClick(e){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.selected(e,"",_this2.props.history.push("/"));}});//     if(this.state.costingPageLeave) {
//         console.log('PATH')
//     this.selected(e, "", this.props.history.push("/"))
// }
},className:"changeselecteds",style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-home icons"})," Dashboard"," ")),this.props.rights.meetingNotes.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",id:"listMeetingRoom",onClick:function onClick(e){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"MEETINGROOM",type:"list",byValue:"",inputSearch:""});}});},className:"changeselecteds",style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-clock icons"})," Meeting Notes"," ")),this.props.rights.communication.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",id:"communication",onClick:function onClick(e){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.selected(e,"communication");}});},className:"changeselecteds",style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-exchange"})," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"com-rel"},"Communication"))),(this.props.rights.cad.web.view||this.props.rights.fabric.fabric.web.view||this.props.rights.bNumber.web.view||this.props.rights.bulkImport.web.view||this.props.rights.printFabricNumber.web.view||this.props.rights.trim.trim.web.view||this.props.rights.sourcing.web.view||this.props.rights.product.product.web.view)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",id:"development",className:"changeselecteds",style:{cursor:"pointer"},onClick:function onClick(e){_this2.toggleOpen("development");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-flag-o"})," Development"," ")),toggle.development&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"development-sub-nav"},this.props.rights.cad.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"CAD",type:"list"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"CAD")),(this.props.rights.fabric.fabric.web.view||this.props.rights.bNumber.web.view||this.props.rights.bulkImport.web.view||this.props.rights.printFabricNumber.web.view||this.props.rights.trim.trim.web.view||this.props.rights.sourcing.web.view||this.props.rights.product.product.web.view)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"fabric_dev",role:"button",onClick:function onClick(e){_this2.toggleOpen("fabric");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"Master Fabric"," ")),toggle.fabric&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"fabric-sub-nav"},this.props.rights.fabric.fabric.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"FABRIC",type:"list"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"Fabric")),this.props.rights.bNumber.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"BNUMBER",type:"list"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"B Number"," ")),this.props.rights.bulkImport.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/bulkImport");}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Bulk Import"," ")),this.props.rights.printFabricNumber.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/printFabricNumber",{moduleName:"Fabric"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," PRINT FABRIC NUMBER"," "))),this.props.rights.trim.trim.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"TRIM",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Master Trim"," ")),this.props.rights.sourcing.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{// onClick={() => {
//     this.confirmLeavePage({
//         nextAction: () => {
//             this.props.history.push("/listSourcing", {
//                 moduleName: "SOURCING",
//                 type: "list"
//             })
//         }
//     })
// }}
style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Sourcing"," ")),this.props.rights.product.product.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{// onClick={() => {
//     this.confirmLeavePage({
//         nextAction: () => {
//             this.props.history.push("/listProduct")
//         }
//     })
// }}
style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Product"," "))),this.props.rights.style.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",id:"masterStyle",className:"changeselecteds",style:{cursor:"pointer"},onClick:function onClick(e){_this2.toggleOpen("masterStyle");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-star icons"})," Style"," ")),toggle.masterStyle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"style-sub-nav"},this.props.rights.style.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"listStyle",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"STYLE",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Style List")),this.props.rights.createIb.createIb.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"listStyle",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"STYLE",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," IB"," ")),this.props.rights.smvCalcThread.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"listStyle",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"SMVTHREAD",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Smv/Ob"," ")),this.props.rights.technicalIssues.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"listStyle",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"TECHNICALISSUES",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Technical Issues"," "))),(this.props.rights.sampleRequest.sampleRequest&&this.props.rights.sampleRequest.sampleRequest.web.view||this.props.rights.sampleRequest.sampleTag&&this.props.rights.sampleRequest.sampleTag.web.view)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"changeselecteds",id:"listSample"// className="fabric_dev"
,role:"button",onClick:function onClick(e){_this2.toggleOpen("sampleRequest");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-bell"})," Sample Request"," ")),toggle.sampleRequest&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"fabric-sub-nav"},this.props.rights.sampleRequest.sampleRequest.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"SAMPLEREQUEST",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"Sample Request")),this.props.rights.sampleRequest.sampleTag.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/printStyleNumber",{moduleName:"Style"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," SAMPLE TAG"," "))),this.props.rights.costing.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"changeselecteds",id:"listCost",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"COSTING",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-money"}),"Costing")),this.props.rights.system.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{role:"button",style:{cursor:"pointer"},className:"system changeselecteds",onClick:function onClick(e){_this2.toggleOpen("system");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})," System"," ")),toggle.system&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"system-sub-nav"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"cad"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," 3D"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"costing"});}});// this.props.history.push("system", { type: "costing" })
}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Costing"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"customer"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Customer"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"fabric"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Fabric"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"general"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," General"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"samplerequest"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),"Sample Request")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"style"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Style"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"SYSTEMSUPPLIER",type:"list"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Suppliers"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("system",{type:"trims"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Trims"," "))),this.props.rights&&this.props.rights.customer&&this.props.rights.customer.customer&&this.props.rights.customer.customer.web&&this.props.rights.customer.customer.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"changeselecteds",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"CUSTOMER",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-user icons"})," Customer"," ")),(this.props.rights.permissions.employeeDetails.web.view||this.props.rights.permissions.roleManagement.web.view)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},id:"permission",className:"prod changeselecteds",role:"button",onClick:function onClick(e){_this2.toggleOpen("employee");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-flag icons"})," Permissions"," ")),toggle.employee&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"product-sub-nav"},this.props.rights.permissions.employeeDetails.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"EMPLOYEE",type:"list"});}});},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Employee Details"," ")),this.props.rights.permissions.roleManagement.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/list",{moduleName:"ROLE",type:"list"});}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," Role Management"," "))),reportRights&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:"pointer"},className:"changeselecteds",onClick:function onClick(){_this2.confirmLeavePage({nextAction:function nextAction(){_this2.props.history.push("/Report");}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-file-excel-o"})," Reports"," "))))));}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{toggle:state.Header.toggle,rights:state.main.rights};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({ToggleChange:__WEBPACK_IMPORTED_MODULE_4__redux_action_Header__["a" /* ToggleChange */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Sidebar)));

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(438);
/* unused harmony reexport Footer */


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Copyrights \xA9 Magnum Clothing Pvt Ltd ",new Date().getFullYear(),". All Rights Reserved.")));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Footer);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home__ = __webpack_require__(440);
/* unused harmony reexport HomePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bulkImport__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bulkImport__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Customer__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__Customer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MeetingNote__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__MeetingNote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__dashboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__calendar__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__communication__ = __webpack_require__(589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__communication__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chat__ = __webpack_require__(591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__chat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Style__ = __webpack_require__(596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_9__Style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__createIB__ = __webpack_require__(598);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__createIB__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__listSMV__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_11__listSMV__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SmvThread__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_12__SmvThread__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__technicalIssues__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_13__technicalIssues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PermissionRole__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_14__PermissionRole__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__developmentCAD__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_15__developmentCAD__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__developmentSourcing__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__developmentSourcing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__developmentProduct__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_17__developmentProduct__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__developmentFabric__ = __webpack_require__(622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_18__developmentFabric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__developmentBNumber__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_19__developmentBNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__employeRights__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_20__employeRights__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Employee__ = __webpack_require__(676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_21__Employee__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__systemSubModules__ = __webpack_require__(678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_22__systemSubModules__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__systemCategoryList__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_23__systemCategoryList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__systemAddCategory__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_24__systemAddCategory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Costing__ = __webpack_require__(684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_25__Costing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CostingComparison__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_26__CostingComparison__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__generateTag__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_27__generateTag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__printFabricNumber__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_28__printFabricNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Profile__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_29__Profile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pageNotFound__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_30__pageNotFound__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__list__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_31__list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Trim__ = __webpack_require__(715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_32__Trim__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Sample__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_33__Sample__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__systemSupplier__ = __webpack_require__(889);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_34__systemSupplier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__report__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_35__report__["a"]; });
// export { ListCustomer } from './listCustomer';
// export { ListMeetingRoom } from './listMeetingRoom';
// export { AddMultipleMeeting } from './addMultipleMinuteNote';
// export { ViewMeeting } from './viewMeetingMin';
// export { EditMeeting } from './editMeetingMin';
// export { ListThreadConsumption } from './listThreadConsumption';
// export { ListSample } from './listSample';
// export { AddNewSample } from './addNewSample';
// export { CostList } from './listCosting';
// export { ViewCost } from './viewCost';
// export { EditCost } from './editCost';
// export { ListPermissionsRole } from './listPermissionRole';
// export { ViewPermissionRole } from './viewPermissionRole';
// export { ListDevelopmentTrim } from './listDevelopmentTrim';
// export { ListIB } from './listIB';
// export { ListDevelopmentCAD } from './listDevelopmentCAD';
// export { ListDevelopmentBNumber } from './listDevelopmentBNumber';
// export { EditCAD } from './editCAD';
// export { ViewCAD } from './viewCAD';
// export { ListDevelopmentProduct } from './listDevelopmentProduct';
// export { ListDevelopmentSourcing } from './listDevelopmentSourcing';
// export { ViewBNumber } from './viewBNumber';
// export { EditBNumber } from './editBNumber'; 
// export { ViewSourcing } from './viewSourcing';
// export { EditSourcing } from './editSourcing';
// export { ViewProduct } from './viewProduct';
// export { EditProduct } from './editProduct';
// export { ViewTrim } from './viewTrim';
// export { EditTrim } from './editTrim';
// export { ViewDevelopmentProduct } from './viewDevelopmentProduct';
// export { EditDevelopmentProduct } from './editDevelopmentProduct';
// export { ViewSMV } from './viewSMV';
// export { EditSMV } from './editSMV';
// export { ListEmbroidery } from './listEmbroidery';
// export { AddEmbroidery } from './addEmbroidery';
// export { ViewEmbroidery } from './viewEmbroidery';
// export { EditEmbroidery } from './editEmbroidery';
// export { ViewThread } from './viewThreadConsumption';
// export { EditThread } from './editThreadConsumption';
// export { ViewStyle } from './viewStyle';
// export { EditStyle } from './editStyle';
// export { ViewSample } from './viewSample';
// export { EditSample } from './editSample';
// export { NewCost } from './newCostPage';
//PRINT FABRIC NUMBER
//Profile
// Page not Found
//List for all modules
//Trim
//Sample
//SystemSupplier
//fabricReport 


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(441);
/* unused harmony reexport HomePage */


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(442);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { Layout } from '../../components'
//import { Grid, Image } from 'semantic-ui-react'
var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(props){_classCallCheck(this,HomePage);var _this=_possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};_this.toggle=_this.toggle.bind(_this);_this.state={isOpen:false};return _this;}_createClass(HomePage,[{key:'toggle',value:function toggle(){this.setState({isOpen:!this.state.isOpen});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_alert___default.a,Object.assign({ref:function ref(a){return _this2.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Navbar */],{color:'inverse',inverse:true,toggleable:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* NavbarToggler */],{right:true,onClick:this.toggle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["j" /* NavbarBrand */],{href:'/'},'OML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Collapse */],{isOpen:this.state.isOpen,navbar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["f" /* Nav */],{className:'ml-auto',navbar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* NavLink */],{href:'/components/'},'Components')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* NavLink */],{href:'#'},'Login'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Jumbotron */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Only Much Louder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Button */],{tag:'a',color:'success',size:'large',href:'#',target:'_blank'},'login')))))));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (HomePage);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NavbarBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NavbarToggler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NavItem; });
/* unused harmony export NavDropdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NavLink; });
/* unused harmony export Breadcrumb */
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export ButtonDropdown */
/* unused harmony export ButtonGroup */
/* unused harmony export ButtonToolbar */
/* unused harmony export Dropdown */
/* unused harmony export DropdownItem */
/* unused harmony export DropdownMenu */
/* unused harmony export DropdownToggle */
/* unused harmony export Fade */
/* unused harmony export Badge */
/* unused harmony export Card */
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* unused harmony export CardHeader */
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* unused harmony export CardTitle */
/* unused harmony export Popover */
/* unused harmony export PopoverContent */
/* unused harmony export PopoverTitle */
/* unused harmony export Progress */
/* unused harmony export Modal */
/* unused harmony export ModalHeader */
/* unused harmony export ModalBody */
/* unused harmony export ModalFooter */
/* unused harmony export TetherContent */
/* unused harmony export Tooltip */
/* unused harmony export Table */
/* unused harmony export ListGroup */
/* unused harmony export Form */
/* unused harmony export FormFeedback */
/* unused harmony export FormGroup */
/* unused harmony export FormText */
/* unused harmony export Input */
/* unused harmony export InputGroup */
/* unused harmony export InputGroupAddon */
/* unused harmony export InputGroupButton */
/* unused harmony export Label */
/* unused harmony export Media */
/* unused harmony export Pagination */
/* unused harmony export PaginationItem */
/* unused harmony export PaginationLink */
/* unused harmony export TabContent */
/* unused harmony export TabPane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Jumbotron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Collapse; });
/* unused harmony export ListGroupItem */
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* unused harmony export UncontrolledButtonDropdown */
/* unused harmony export UncontrolledDropdown */
/* unused harmony export UncontrolledNavDropdown */
/* unused harmony export UncontrolledTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isobject__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isfunction__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap_tether__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reactstrap_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);










function getTetherAttachments(placement) {
  var attachments = {};
  switch (placement) {
    case 'top':
    case 'top center':
      attachments = {
        attachment: 'bottom center',
        targetAttachment: 'top center'
      };
      break;
    case 'bottom':
    case 'bottom center':
      attachments = {
        attachment: 'top center',
        targetAttachment: 'bottom center'
      };
      break;
    case 'left':
    case 'left center':
      attachments = {
        attachment: 'middle right',
        targetAttachment: 'middle left'
      };
      break;
    case 'right':
    case 'right center':
      attachments = {
        attachment: 'middle left',
        targetAttachment: 'middle right'
      };
      break;
    case 'top left':
      attachments = {
        attachment: 'bottom left',
        targetAttachment: 'top left'
      };
      break;
    case 'top right':
      attachments = {
        attachment: 'bottom right',
        targetAttachment: 'top right'
      };
      break;
    case 'bottom left':
      attachments = {
        attachment: 'top left',
        targetAttachment: 'bottom left'
      };
      break;
    case 'bottom right':
      attachments = {
        attachment: 'top right',
        targetAttachment: 'bottom right'
      };
      break;
    case 'right top':
      attachments = {
        attachment: 'top left',
        targetAttachment: 'top right'
      };
      break;
    case 'right bottom':
      attachments = {
        attachment: 'bottom left',
        targetAttachment: 'bottom right'
      };
      break;
    case 'left top':
      attachments = {
        attachment: 'top right',
        targetAttachment: 'top left'
      };
      break;
    case 'left bottom':
      attachments = {
        attachment: 'bottom right',
        targetAttachment: 'bottom left'
      };
      break;
    default:
      attachments = {
        attachment: 'top center',
        targetAttachment: 'bottom center'
      };
  }

  return attachments;
}

var tetherAttachements = ['top', 'bottom', 'left', 'right', 'top left', 'top center', 'top right', 'right top', 'right middle', 'right bottom', 'bottom right', 'bottom center', 'bottom left', 'left top', 'left middle', 'left bottom'];

// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  return parseInt(window.getComputedStyle(document.body, null).getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L420
  var fixedContent = document.querySelectorAll('.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

function mapToCssModules(className, cssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: stringOrNumberProp,
  pull: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    if (!i && columnProp === undefined) {
      columnProp = true;
    }

    delete attributes[colWidth];

    if (!columnProp) {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_3_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'push' + colSizeInterfix + columnProp.push, columnProp.push || columnProp.push === 0), defineProperty(_classNames, 'pull' + colSizeInterfix + columnProp.pull, columnProp.pull || columnProp.pull === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  toggleable: false
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === false) {
    return false;
  } else if (toggleable === true || toggleable === 'xs') {
    return 'navbar-toggleable';
  }

  return 'navbar-toggleable-' + toggleable;
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      inverse = props.inverse,
      full = props.full,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'className', 'cssModule', 'light', 'inverse', 'full', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-inverse': inverse
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'navbar-full', full), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var navbarToggleIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'navbar-toggler-icon' });

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      right = props.right,
      left = props.left,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'right', 'left', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler', right && 'navbar-toggler-right', left && 'navbar-toggler-left'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || navbarToggleIcon
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul'
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      navbar = props.navbar,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'navbar', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', {
    'nav-tabs': tabs,
    'nav-pills': pills,
    'flex-column': vertical
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

var propTypes$10 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  tether: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  tetherRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  isOpen: false,
  tetherRef: function tetherRef() {}
};

var TetherContent = function (_React$Component) {
  inherits(TetherContent, _React$Component);

  function TetherContent(props) {
    classCallCheck(this, TetherContent);

    var _this = possibleConstructorReturn(this, (TetherContent.__proto__ || Object.getPrototypeOf(TetherContent)).call(this, props));

    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(TetherContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'getTarget',
    value: function getTarget() {
      var target = this.props.tether.target;

      if (__WEBPACK_IMPORTED_MODULE_5_lodash_isfunction___default()(target)) {
        return target();
      }

      return target;
    }
  }, {
    key: 'getTetherConfig',
    value: function getTetherConfig() {
      var config = _extends({}, this.props.tether);

      config.element = this._element;
      config.target = this.getTarget();
      return config;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      var container = this._element;
      if (e.target === container || !container.contains(e.target)) {
        this.toggle();
      }
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      document.removeEventListener('click', this.handleDocumentClick, true);

      if (this._element) {
        document.body.removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }

      if (this._tether) {
        this._tether.destroy();
        this._tether = null;
        this.props.tetherRef(this._tether);
      }
    }
  }, {
    key: 'show',
    value: function show() {
      document.addEventListener('click', this.handleDocumentClick, true);

      this._element = document.createElement('div');
      this._element.className = this.props.className;
      document.body.appendChild(this._element);
      this.renderIntoSubtree();
      this._tether = new __WEBPACK_IMPORTED_MODULE_6_reactstrap_tether___default.a(this.getTetherConfig());
      this.props.tetherRef(this._tether);
      this._tether.position();
      this._element.childNodes[0].focus();
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { style: style });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return TetherContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TetherContent.propTypes = propTypes$10;
TetherContent.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'div'
};

var contextTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', { 'dropdown-menu-right': right }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { tabIndex: '-1', 'aria-hidden': !context.isOpen, role: 'menu', className: classes }));
};

DropdownMenu.propTypes = propTypes$11;
DropdownMenu.defaultProps = defaultProps$11;
DropdownMenu.contextTypes = contextTypes;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$9 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tether: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$9 = {
  isOpen: false,
  tag: 'div'
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var defaultTetherConfig = {
  classPrefix: 'bs-tether',
  classes: { element: 'dropdown', enabled: 'show' },
  constraints: [{ to: 'scrollParent', attachment: 'together none' }, { to: 'window', attachment: 'together none' }]
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.getTetherConfig = _this.getTetherConfig.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getTetherTarget',
    value: function getTetherTarget() {
      var container = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);

      return container.querySelector('[data-toggle="dropdown"]');
    }
  }, {
    key: 'getTetherConfig',
    value: function getTetherConfig(childProps) {
      var _this2 = this;

      var target = function target() {
        return _this2.getTetherTarget();
      };
      var vElementAttach = 'top';
      var hElementAttach = 'left';
      var vTargetAttach = 'bottom';
      var hTargetAttach = 'left';

      if (childProps.right) {
        hElementAttach = 'right';
        hTargetAttach = 'right';
      }

      if (this.props.dropup) {
        vElementAttach = 'bottom';
        vTargetAttach = 'top';
      }

      return _extends({}, defaultTetherConfig, {
        attachment: vElementAttach + ' ' + hElementAttach,
        targetAttachment: vTargetAttach + ' ' + hTargetAttach,
        target: target
      }, this.props.tether);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      document.addEventListener('click', this.handleDocumentClick, true);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      document.removeEventListener('click', this.handleDocumentClick, true);
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      var container = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);

      if (container.contains(e.target) && container !== e.target) {
        return;
      }

      this.toggle();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.tether) {
        return;
      }

      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _this3 = this;

      var _props = this.props,
          tether = _props.tether,
          children = _props.children,
          attrs = objectWithoutProperties(_props, ['tether', 'children']);

      attrs.toggle = this.toggle;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children), function (child) {
        if (tether && child.type === DropdownMenu) {
          var tetherConfig = _this3.getTetherConfig(child.props);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TetherContent,
            _extends({}, attrs, { tether: tetherConfig }),
            child
          );
        }

        return child;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'tether']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          group = _omit.group,
          size = _omit.size,
          Tag = _omit.tag,
          isOpen = _omit.isOpen,
          attributes = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'group', 'size', 'tag', 'isOpen']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {
        'btn-group': group
      }, defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'dropup', dropup), _classNames)), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({}, attributes, {
          className: classes
        }),
        this.renderChildren()
      );
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$9;
Dropdown.defaultProps = defaultProps$9;
Dropdown.childContextTypes = childContextTypes;

var propTypes$8 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$8 = {
  tag: 'li'
};

var NavDropdown = function NavDropdown(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({}, attributes, { tag: Tag, className: classes }));
};

NavDropdown.propTypes = propTypes$8;
NavDropdown.defaultProps = defaultProps$8;

var propTypes$12 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$12 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          getRef = _props.getRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'getRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: getRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$12;
NavLink.defaultProps = defaultProps$12;

var propTypes$13 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$13 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$13;
Breadcrumb.defaultProps = defaultProps$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$14 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$14;
BreadcrumbItem.defaultProps = defaultProps$14;

var propTypes$15 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$15 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          getRef = _props.getRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'getRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: getRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$15;
Button.defaultProps = defaultProps$15;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$16;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$16 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$17;
ButtonGroup.defaultProps = defaultProps$16;

var propTypes$18 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$17 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$18;
ButtonToolbar.defaultProps = defaultProps$17;

var propTypes$19 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes$1 = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$18 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle();
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$19;
DropdownItem.defaultProps = defaultProps$18;
DropdownItem.contextTypes = contextTypes$1;

var propTypes$20 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'data-toggle': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$19 = {
  'data-toggle': 'dropdown',
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        active: this.context.isOpen,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
      } else {
        Tag = tag;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
        className: classes,
        onClick: this.onClick,
        'aria-haspopup': 'true',
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$20;
DropdownToggle.defaultProps = defaultProps$19;
DropdownToggle.contextTypes = contextTypes$2;

var propTypes$21 = {
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  transitionAppearTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  transitionEnterTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  transitionLeaveTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$20 = {
  tag: 'div',
  baseClass: 'fade',
  baseClassIn: 'show',
  transitionAppearTimeout: 0,
  transitionEnterTimeout: 0,
  transitionLeaveTimeout: 0,
  transitionAppear: true,
  transitionEnter: true,
  transitionLeave: true
};

var Fade = function (_React$Component) {
  inherits(Fade, _React$Component);

  function Fade(props) {
    classCallCheck(this, Fade);

    var _this = possibleConstructorReturn(this, (Fade.__proto__ || Object.getPrototypeOf(Fade)).call(this, props));

    _this.state = {
      mounted: !props.transitionAppear
    };

    _this.onLeave = _this.onLeave.bind(_this);
    _this.onEnter = _this.onEnter.bind(_this);
    _this.timers = [];
    return _this;
  }

  createClass(Fade, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timers.forEach(function (timer) {
        return clearTimeout(timer);
      });
    }
  }, {
    key: 'onEnter',
    value: function onEnter(cb) {
      var _this2 = this;

      return function () {
        cb();
        if (_this2.props.onEnter) {
          _this2.props.onEnter();
        }
      };
    }
  }, {
    key: 'onLeave',
    value: function onLeave(cb) {
      var _this3 = this;

      return function () {
        cb();
        if (_this3.props.onLeave) {
          _this3.props.onLeave();
        }
      };
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(cb) {
      if (!this.props.transitionAppear) {
        this.onEnter(cb)();
      }

      this.timers.push(setTimeout(this.onEnter(cb), this.props.transitionAppearTimeout));
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(cb) {
      if (!this.props.transitionEnter) {
        this.onEnter(cb)();
      }

      this.timers.push(setTimeout(this.onEnter(cb), this.props.transitionEnterTimeout));
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(cb) {
      this.setState({
        mounted: false
      });

      if (!this.props.transitionLeave) {
        this.onLeave(cb)();
      }

      this.timers.push(setTimeout(this.onLeave(cb), this.props.transitionLeaveTimeout));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          baseClass = _props.baseClass,
          baseClassIn = _props.baseClassIn,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;

      var attributes = omit(this.props, Object.keys(propTypes$21));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, this.state.mounted ? baseClassIn : false), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return Fade;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Fade.propTypes = propTypes$21;
Fade.defaultProps = defaultProps$20;

var propTypes$22 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  color: 'default',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$22;
Badge.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'card-inverse' : false, block ? 'card-block' : false, color ? 'card' + (outline ? '-outline' : '') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$23;
Card.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$24;
CardGroup.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$25;
CardDeck.defaultProps = defaultProps$24;

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$26;
CardColumns.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardBlock = function CardBlock(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBlock.propTypes = propTypes$27;
CardBlock.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      getRef = props.getRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'getRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: getRef, className: classes }));
};

CardLink.propTypes = propTypes$28;
CardLink.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$29;
CardFooter.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$30;
CardHeader.defaultProps = defaultProps$29;

var propTypes$31 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$31;
CardImg.defaultProps = defaultProps$30;

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$32;
CardImgOverlay.defaultProps = defaultProps$31;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$33;
CardSubtitle.defaultProps = defaultProps$32;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$33 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$34;
CardText.defaultProps = defaultProps$33;

var propTypes$35 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$34 = {
  tag: 'h4'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$35;
CardTitle.defaultProps = defaultProps$34;

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(tetherAttachements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tether: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tetherRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$35 = {
  isOpen: false,
  placement: 'bottom',
  toggle: function toggle() {}
};

var defaultTetherConfig$1 = {
  classPrefix: 'bs-tether',
  classes: {
    element: false,
    enabled: 'show'
  },
  constraints: [{ to: 'scrollParent', attachment: 'together none' }, { to: 'window', attachment: 'together none' }]
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.getTetherConfig = _this.getTetherConfig.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'getTetherConfig',
    value: function getTetherConfig() {
      var attachments = getTetherAttachments(this.props.placement);
      return _extends({}, defaultTetherConfig$1, attachments, {
        target: '#' + this.props.target
      }, this.props.tether);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var tetherConfig = this.getTetherConfig();

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.className), this.props.cssModule);

      var attributes = omit(this.props, Object.keys(propTypes$36));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        TetherContent,
        {
          className: mapToCssModules('popover', this.props.cssModule),
          tether: tetherConfig,
          tetherRef: this.props.tetherRef,
          isOpen: this.props.isOpen,
          toggle: this.props.toggle
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$35;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'h3'
};

var PopoverTitle = function PopoverTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverTitle.propTypes = propTypes$37;
PopoverTitle.defaultProps = defaultProps$36;

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div'
};

var PopoverContent = function PopoverContent(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-content'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverContent.propTypes = propTypes$38;
PopoverContent.defaultProps = defaultProps$37;

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$38 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$38;

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransitionTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backdropTransitionAppearTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backdropTransitionEnterTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  backdropTransitionLeaveTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  modalTransitionTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  modalTransitionAppearTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  modalTransitionEnterTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  modalTransitionLeaveTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$39 = {
  isOpen: false,
  autoFocus: true,
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  modalTransitionTimeout: 300,
  backdropTransitionTimeout: 150
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.originalBodyPadding = null;
    _this.isBodyOverflowing = false;
    _this.togglePortal = _this.togglePortal.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.destroy = _this.destroy.bind(_this);
    _this.onEnter = _this.onEnter.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.togglePortal();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        // handle portal events/dom updates
        this.togglePortal();
      } else if (this._element) {
        // rerender portal
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.onExit();
    }
  }, {
    key: 'onEnter',
    value: function onEnter() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    }
  }, {
    key: 'onExit',
    value: function onExit() {
      this.destroy();
      if (this.props.onExit) {
        this.props.onExit();
      }
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'hasTransition',
    value: function hasTransition() {
      if (this.props.fade === false) {
        return false;
      }

      return this.props.modalTransitionTimeout > 0;
    }
  }, {
    key: 'togglePortal',
    value: function togglePortal() {
      if (this.props.isOpen) {
        if (this.props.autoFocus) {
          this._focus = true;
        }
        this.show();
        if (!this.hasTransition()) {
          this.onEnter();
        }
      } else {
        this.hide();
        if (!this.hasTransition()) {
          this.onExit();
        }
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.unmountComponentAtNode(this._element);
        document.body.removeChild(this._element);
        this._element = null;
      }

      // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
      var classes = document.body.className.replace(/(^| )modal-open( |$)/, ' ');
      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes).trim(), this.props.cssModule);
      setScrollbarWidth(this.originalBodyPadding);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.renderIntoSubtree();
    }
  }, {
    key: 'show',
    value: function show() {
      var classes = document.body.className;
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this.originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, 'modal-open'), this.props.cssModule);

      this.renderIntoSubtree();
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _this2 = this;

      var attributes = omit(this.props, propsToOmit);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-dialog', this.props.className, defineProperty({}, 'modal-' + this.props.size, this.props.size)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            return _this2._dialog = c;
          }
        }, attributes),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);

      // check if modal should receive focus
      if (this._focus) {
        this._dialog.parentNode.focus();
        this._focus = false;
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          wrapClassName = _props.wrapClassName,
          modalClassName = _props.modalClassName,
          backdropClassName = _props.backdropClassName,
          cssModule = _props.cssModule,
          isOpen = _props.isOpen,
          backdrop = _props.backdrop,
          modalTransitionTimeout = _props.modalTransitionTimeout,
          backdropTransitionTimeout = _props.backdropTransitionTimeout;


      var modalAttributes = {
        onClickCapture: this.handleBackdropClick,
        onKeyUp: this.handleEscape,
        style: { display: 'block' },
        tabIndex: '-1'
      };

      if (this.hasTransition()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["TransitionGroup"],
          { component: 'div', className: mapToCssModules(wrapClassName) },
          isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Fade,
            _extends({
              key: 'modal-dialog',
              onEnter: this.onEnter,
              onLeave: this.onExit,
              transitionAppearTimeout: typeof this.props.modalTransitionAppearTimeout === 'number' ? this.props.modalTransitionAppearTimeout : modalTransitionTimeout,
              transitionEnterTimeout: typeof this.props.modalTransitionEnterTimeout === 'number' ? this.props.modalTransitionEnterTimeout : modalTransitionTimeout,
              transitionLeaveTimeout: typeof this.props.modalTransitionLeaveTimeout === 'number' ? this.props.modalTransitionLeaveTimeout : modalTransitionTimeout,
              cssModule: cssModule,
              className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
            }, modalAttributes),
            this.renderModalDialog()
          ),
          isOpen && backdrop && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, {
            key: 'modal-backdrop',
            transitionAppearTimeout: typeof this.props.backdropTransitionAppearTimeout === 'number' ? this.props.backdropTransitionAppearTimeout : backdropTransitionTimeout,
            transitionEnterTimeout: typeof this.props.backdropTransitionEnterTimeout === 'number' ? this.props.backdropTransitionEnterTimeout : backdropTransitionTimeout,
            transitionLeaveTimeout: typeof this.props.backdropTransitionLeaveTimeout === 'number' ? this.props.backdropTransitionLeaveTimeout : backdropTransitionTimeout,
            cssModule: cssModule,
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
          })
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: mapToCssModules(wrapClassName) },
        isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', 'show', modalClassName), cssModule)
          }, modalAttributes),
          this.renderModalDialog()
        ),
        isOpen && backdrop && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule)
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$39;

var propTypes$41 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$40 = {
  tag: 'h4',
  wrapTag: 'div'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: 'close', 'aria-label': 'Close' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$41;
ModalHeader.defaultProps = defaultProps$40;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$42;
ModalBody.defaultProps = defaultProps$41;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$42 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$43;
ModalFooter.defaultProps = defaultProps$42;

var propTypes$44 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(tetherAttachements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tether: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tetherRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 250
};

var defaultProps$43 = {
  isOpen: false,
  placement: 'bottom',
  delay: DEFAULT_DELAYS,
  autohide: true,
  toggle: function toggle() {}
};

var defaultTetherConfig$2 = {
  classPrefix: 'bs-tether',
  classes: {
    element: false,
    enabled: 'show'
  },
  constraints: [{ to: 'scrollParent', attachment: 'together none' }, { to: 'window', attachment: 'together none' }]
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.getTarget = _this.getTarget.bind(_this);
    _this.getTetherConfig = _this.getTetherConfig.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = this.getTarget();
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'getTarget',
    value: function getTarget() {
      var target = this.props.target;

      if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
        return target;
      }
      return document.getElementById(target);
    }
  }, {
    key: 'getTetherConfig',
    value: function getTetherConfig() {
      var attachments = getTetherAttachments(this.props.placement);
      return _extends({}, defaultTetherConfig$2, attachments, {
        target: this.getTarget
      }, this.props.tether);
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      document.addEventListener('click', this.handleDocumentClick, true);
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      document.removeEventListener('click', this.handleDocumentClick, true);
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$44));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.className), this.props.cssModule);

      var tetherConfig = this.getTetherConfig();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        TetherContent,
        {
          className: 'tooltip',
          tether: tetherConfig,
          tetherRef: this.props.tetherRef,
          isOpen: this.props.isOpen,
          toggle: this.toggle
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$44;
Tooltip.defaultProps = defaultProps$43;

var propTypes$45 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$44 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      hover = props.hover,
      reflow = props.reflow,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'hover', 'reflow', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, inverse ? 'table-inverse' : false, hover ? 'table-hover' : false, reflow ? 'table-reflow' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: 'table-responsive' },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$45;
Table.defaultProps = defaultProps$44;

var propTypes$46 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$46;
ListGroup.defaultProps = defaultProps$45;

var propTypes$47 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$46 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      getRef = props.getRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'getRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: getRef, className: classes }));
};

Form.propTypes = propTypes$47;
Form.defaultProps = defaultProps$46;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'form-control-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$48;
FormFeedback.defaultProps = defaultProps$47;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      color = props.color,
      check = props.check,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'color', 'check', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, color ? 'has-' + color : false, row ? 'row' : false, check ? 'form-check' : 'form-group', check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$49;
FormGroup.defaultProps = defaultProps$48;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  tag: 'small'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$50;
FormText.defaultProps = defaultProps$49;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'p',
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          size = _props.size,
          state = _props.state,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          getRef = _props.getRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'size', 'state', 'tag', 'addon', 'static', 'getRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = selectInput || textareaInput ? type : 'input';

      var formControlClass = 'form-control';

      if (staticInput) {
        formControlClass = formControlClass + '-static';
        Tag = tag;
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, state ? 'form-control-' + state : false, size ? 'form-control-' + size : false, formControlClass), cssModule);

      if (Tag === 'input') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: getRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$51;
Input.defaultProps = defaultProps$50;

var propTypes$52 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$52;
InputGroup.defaultProps = defaultProps$51;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-addon'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupAddon.propTypes = propTypes$53;
InputGroupAddon.defaultProps = defaultProps$52;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$53 = {
  tag: 'div'
};

var InputGroupButton = function InputGroupButton(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var groupClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(groupClassName, 'input-group-btn'), cssModule);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, groupAttributes, { className: groupClasses }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { className: className, children: children }))
    );
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-btn'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupButton.propTypes = propTypes$54;
InputGroupButton.defaultProps = defaultProps$53;

var colSizes = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: stringOrNumberProp$1,
  pull: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$55 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1
};

var defaultProps$54 = {
  tag: 'label'
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      Tag = props.tag,
      check = props.check,
      inline = props.inline,
      disabled = props.disabled,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'tag', 'check', 'inline', 'disabled', 'size', 'for']);


  var colClasses = [];

  colSizes.forEach(function (colSize) {
    var columnProp = props[colSize];
    delete attributes[colSize];

    if (columnProp && columnProp.size) {
      var _classNames;

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, 'col-' + colSize + '-' + columnProp.size, columnProp.size), defineProperty(_classNames, 'push-' + colSize + '-' + columnProp.push, columnProp.push), defineProperty(_classNames, 'pull-' + colSize + '-' + columnProp.pull, columnProp.pull), defineProperty(_classNames, 'offset-' + colSize + '-' + columnProp.offset, columnProp.offset), _classNames))), cssModule);
    } else if (columnProp) {
      colClasses.push('col-' + colSize + '-' + columnProp);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-' + (inline ? 'inline' : 'label') : false, check && inline && disabled ? 'disabled' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false, !check && !colClasses.length ? 'form-control-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$55;
Label.defaultProps = defaultProps$54;

var propTypes$56 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$56;

var propTypes$57 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$57;
Pagination.defaultProps = defaultProps$55;

var propTypes$58 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$58;
PaginationItem.defaultProps = defaultProps$56;

var propTypes$59 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$57 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$59;
PaginationLink.defaultProps = defaultProps$57;

var propTypes$60 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$58 = {
  tag: 'div'
};

var childContextTypes$1 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$60));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$60;
TabContent.defaultProps = defaultProps$58;
TabContent.childContextTypes = childContextTypes$1;

var propTypes$61 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$59 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$61;
TabPane.defaultProps = defaultProps$59;
TabPane.contextTypes = contextTypes$3;

var propTypes$62 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$60 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$62;
Jumbotron.defaultProps = defaultProps$60;

var FirstChild = function FirstChild(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children)[0] || null;
};

var propTypes$63 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transitionAppearTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  transitionEnterTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  transitionLeaveTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps$61 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  transitionAppearTimeout: 150,
  transitionEnterTimeout: 150,
  transitionLeaveTimeout: 150
};

var Alert = function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transitionAppearTimeout = props.transitionAppearTimeout,
      transitionEnterTimeout = props.transitionEnterTimeout,
      transitionLeaveTimeout = props.transitionLeaveTimeout,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transitionAppearTimeout', 'transitionEnterTimeout', 'transitionLeaveTimeout']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  var alert = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': 'Close', onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["CSSTransitionGroup"],
    {
      component: FirstChild,
      transitionName: {
        appear: 'fade',
        appearActive: 'show',
        enter: 'fade',
        enterActive: 'show',
        leave: 'fade',
        leaveActive: 'out'
      },
      transitionAppear: transitionAppearTimeout > 0,
      transitionAppearTimeout: transitionAppearTimeout,
      transitionEnter: transitionEnterTimeout > 0,
      transitionEnterTimeout: transitionEnterTimeout,
      transitionLeave: transitionLeaveTimeout > 0,
      transitionLeaveTimeout: transitionLeaveTimeout
    },
    isOpen ? alert : null
  );
};

Alert.propTypes = propTypes$63;
Alert.defaultProps = defaultProps$61;

var SHOW = 'SHOW';
var SHOWN = 'SHOWN';
var HIDE = 'HIDE';
var HIDDEN = 'HIDDEN';

var propTypes$64 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var DEFAULT_DELAYS$1 = {
  show: 350,
  hide: 350
};

var defaultProps$62 = {
  isOpen: false,
  tag: 'div',
  delay: DEFAULT_DELAYS$1,
  onOpened: function onOpened() {},
  onClosed: function onClosed() {}
};

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      collapse: props.isOpen ? SHOWN : HIDDEN,
      height: null
    };
    _this.element = null;
    return _this;
  }

  createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var willOpen = nextProps.isOpen;
      var collapse = this.state.collapse;

      if (willOpen && collapse === HIDDEN) {
        // will open
        this.setState({ collapse: SHOW }, function () {
          // the height transition will work after class "collapsing" applied
          _this2.setState({ height: _this2.getHeight() });
          _this2.transitionTag = setTimeout(function () {
            _this2.setState({
              collapse: SHOWN,
              height: null
            });
          }, _this2.getDelay('show'));
        });
      } else if (!willOpen && collapse === SHOWN) {
        // will hide
        this.setState({ height: this.getHeight() }, function () {
          _this2.setState({
            collapse: HIDE,
            height: _this2.getHeight()
          }, function () {
            _this2.setState({ height: 0 });
          });
        });

        this.transitionTag = setTimeout(function () {
          _this2.setState({
            collapse: HIDDEN,
            height: null
          });
        }, this.getDelay('hide'));
      }
      // else: do nothing.
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.collapse === SHOWN && prevState && prevState.collapse !== SHOWN) {
        this.props.onOpened();
      }

      if (this.state.collapse === HIDDEN && prevState && prevState.collapse !== HIDDEN) {
        this.props.onClosed();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.transitionTag);
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this.element.scrollHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _omit = omit(this.props, ['isOpen', 'delay', 'onOpened', 'onClosed']),
          navbar = _omit.navbar,
          className = _omit.className,
          cssModule = _omit.cssModule,
          Tag = _omit.tag,
          attributes = objectWithoutProperties(_omit, ['navbar', 'className', 'cssModule', 'tag']);

      var _state = this.state,
          collapse = _state.collapse,
          height = _state.height;

      var collapseClass = void 0;
      switch (collapse) {
        case SHOW:
          collapseClass = 'collapsing';
          break;
        case SHOWN:
          collapseClass = 'collapse show';
          break;
        case HIDE:
          collapseClass = 'collapsing';
          break;
        case HIDDEN:
          collapseClass = 'collapse';
          break;
        default:
          // HIDDEN
          collapseClass = 'collapse';
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : { height: height };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, {
        style: _extends({}, attributes.style, style),
        className: classes,
        ref: function ref(c) {
          _this3.element = c;
        }
      }));
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$64;
Collapse.defaultProps = defaultProps$62;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$63 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item');

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$65;
ListGroupItem.defaultProps = defaultProps$63;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$64 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$66;
ListGroupItemHeading.defaultProps = defaultProps$64;

var propTypes$67 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$65 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$67;
ListGroupItemText.defaultProps = defaultProps$65;

var Component$1 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

var components = {
  UncontrolledAlert: Alert,
  UncontrolledButtonDropdown: ButtonDropdown,
  UncontrolledDropdown: Dropdown,
  UncontrolledNavDropdown: NavDropdown,
  UncontrolledTooltip: Tooltip
};

Object.keys(components).forEach(function (key) {
  var Tag = components[key];
  var defaultValue = Tag === Alert;

  var Uncontrolled = function (_Component) {
    inherits(Uncontrolled, _Component);

    function Uncontrolled(props) {
      classCallCheck(this, Uncontrolled);

      var _this = possibleConstructorReturn(this, (Uncontrolled.__proto__ || Object.getPrototypeOf(Uncontrolled)).call(this, props));

      _this.state = { isOpen: defaultValue };

      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    createClass(Uncontrolled, [{
      key: 'toggle',
      value: function toggle() {
        this.setState({ isOpen: !this.state.isOpen });
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
      }
    }]);
    return Uncontrolled;
  }(Component$1);

  Uncontrolled.displayName = key;

  components[key] = Uncontrolled;
});

var UncontrolledAlert = components.UncontrolledAlert;
var UncontrolledButtonDropdown = components.UncontrolledButtonDropdown;
var UncontrolledDropdown = components.UncontrolledDropdown;
var UncontrolledNavDropdown = components.UncontrolledNavDropdown;
var UncontrolledTooltip = components.UncontrolledTooltip;


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*! tether 1.3.4 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Tether = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

var _TetherBase$Utils = _utils2['default'].Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

_utils2['default'].modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});

},{"./utils":5}],2:[function(require,module,exports){
'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

var _TetherBase$Utils = _utils2['default'].Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

_utils2['default'].modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});

},{"./utils":5}],3:[function(require,module,exports){
'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

_utils2['default'].modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});

},{"./utils":5}],4:[function(require,module,exports){
/* globals performance */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

require('./constraint');

require('./abutment');

require('./shift');

var _TetherBase$Utils = _utils2['default'].Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;
var Evented = _TetherBase$Utils.Evented;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance !== 'undefined' && typeof performance.now !== 'undefined') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    _utils2['default'].modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < _utils2['default'].modules.length; ++i) {
        var _module2 = _utils2['default'].modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (doc.body.scrollWidth > win.innerWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (doc.body.scrollHeight > win.innerHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          css[transformKey] = 'translateX(' + Math.round(xPos) + 'px) translateY(' + Math.round(yPos) + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        var offsetParentIsBody = true;
        var currentNode = this.element.parentNode;
        while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
          if (getComputedStyle(currentNode).position !== 'static') {
            offsetParentIsBody = false;
            break;
          }

          currentNode = currentNode.parentNode;
        }

        if (!offsetParentIsBody) {
          this.element.parentNode.removeChild(this.element);
          this.element.ownerDocument.body.appendChild(this.element);
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

_utils2['default'].position = position;

var Tether = extend(TetherClass, _utils2['default']);

exports['default'] = Tether;
module.exports = exports['default'];

},{"./abutment":1,"./constraint":2,"./shift":3,"./utils":5}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = { modules: [] };

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  if (node.ownerDocument !== document) {
    var _frameElement = node.ownerDocument.defaultView.frameElement;
    if (_frameElement) {
      var frameRect = getActualBoundingClientRect(_frameElement);
      rect.top += frameRect.top;
      rect.bottom += frameRect.top;
      rect.left += frameRect.left;
      rect.right += frameRect.left;
    }
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

function getScrollBarSize() {
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  return { width: width, height: width };
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};

exports['default'] = TetherBase;
module.exports = exports['default'];

},{}]},{},[4])(4)
});

/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(192));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(448));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(195));

var _Transition = _interopRequireDefault(__webpack_require__(193));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(14);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(195));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utility_service_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_cookies__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Common_Loading__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//redux
//component
var LogInPage=function(_Component){_inherits(LogInPage,_Component);function LogInPage(props){_classCallCheck(this,LogInPage);var _this=_possibleConstructorReturn(this,(LogInPage.__proto__||Object.getPrototypeOf(LogInPage)).call(this,props));_this.state={userId:"",password:"",remember:false,loader:false};_this.submitLogin=_this.submitLogin.bind(_this);_this.handleFormChange=_this.handleFormChange.bind(_this);_this.props.actions.updateBasicDetails=_this.props.actions.updateBasicDetails.bind(_this);_this.captureEnter=_this.captureEnter.bind(_this);return _this;}_createClass(LogInPage,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keypress',this.captureEnter);}},{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.load('userId')!==undefined&&__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.load('password')!==undefined){this.setState({userId:__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.load('userId'),password:__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.load("password"),remember:true});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keypress',this.captureEnter);}},{key:'captureEnter',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(e.key=="Enter"){this.submitLogin(e);}case 1:case'end':return _context.stop();}}},_callee,this);}));function captureEnter(_x){return _ref.apply(this,arguments);}return captureEnter;}()},{key:'submitLogin',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _this2=this;var userDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:e.preventDefault();userDetails={userId:this.state.userId,password:this.state.password,rememberMe:this.state.remember};if(!(this.state.userId==""||this.state.password=="")){_context2.next=5;break;}alert("Please fill all fields");return _context2.abrupt('return');case 5:this.setState({loader:true});_context2.next=8;return fetch(__WEBPACK_IMPORTED_MODULE_4__services_utility_service_js__["a" /* default */].baseUrl()+'api/employee/login',{method:"POST",body:JSON.stringify(userDetails),headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':__WEBPACK_IMPORTED_MODULE_4__services_utility_service_js__["a" /* default */].authToken()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.message==="Successfully logged in"){localStorage.setItem("authToken",responseJson.data.authToken);var _userDetails={userName:responseJson.data.name,userId:responseJson.data._id,authToken:responseJson.data.authToken,profilePicture:responseJson.data.profilePicture,isLoggedIn:true,rights:responseJson.data.rights};_this2.props.actions.updateBasicDetails(_userDetails);_this2.props.history.push('/');_this2.setState({loader:false});}else if(responseJson.message=='Wrong Password'){_this2.props.getalertMessage('error',responseJson.message);_this2.setState({password:""});_this2.setState({loader:false});}else{_this2.props.getalertMessage('error',responseJson.message);_this2.setState({loader:false});}}).catch(function(error){var userDetails={isLoggedIn:false};_this2.setState({loader:false});_this2.props.actions.updateBasicDetails(userDetails);_this2.props.getalertMessage('error',error);});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function submitLogin(_x2){return _ref2.apply(this,arguments);}return submitLogin;}()},{key:'changeRemember',value:function changeRemember(e){this.setState({remember:!this.state.remember},function(){if(this.state.remember===true&&this.state.userId!==""&&this.state.password!==""){__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.save('userId',this.state.userId,{path:'/'});__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.save('password',this.state.password,{path:'/'});}else if(this.state.userId!==""&&this.state.password!==""){__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.remove("userId");__WEBPACK_IMPORTED_MODULE_5_react_cookies___default.a.remove("password");}});}},{key:'handleFormChange',value:function handleFormChange(event){event.preventDefault();if(event.key==="Enter"){this.submitLogin();return;}var key=event.target.id,val=event.target.value;if(key=="userId"){this.setState({userId:val});}else if(key=="password"){this.setState({password:val});}else{this.setState({remember:val});}}},{key:'render',value:function render(){var _this3=this;if(!this.state.loader){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'grid-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:"relative"},className:'h-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login-left-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png___default.a,alt:'logo',className:'logo-image'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login-right-section h-100 d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login-form-container p-0 mx-auto w-75'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this3.submitLogin(e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'whiteColor lato'},'Magnum Login'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:'login-input whiteColor lato',value:this.state.userId,id:'userId',onChange:this.handleFormChange,placeholder:'UserId'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'password',className:'login-input whiteColor lato',id:'password',value:this.state.password,onChange:this.handleFormChange,placeholder:'Password'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'lato ml-3 pTag manage_permissions emb-chck'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:'remember',name:'remember',checked:this.state.remember,value:this.state.remember,onChange:function onChange(e){_this3.setState({remember:e.target.checked});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{'for':'remember',className:'text-white '},'Keep me logged in')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',className:'login-submit-btn lato',onClick:this.submitLogin},'LOGIN')))))));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Loading__["a" /* default */],null);}}}]);return LogInPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_8__redux_action_main__,dispatch)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null,mapDispatchToProps)(LogInPage));

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//service
//component
//alert
var BulkImport=function(_Component){_inherits(BulkImport,_Component);function BulkImport(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BulkImport);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkImport.__proto__||Object.getPrototypeOf(BulkImport)).call.apply(_ref,[this].concat(args))),_this),_this.state={fabrics:[],fabricsBulk:[],generateno:"",hasMore:true,isLoading:false,disabled:false},_this.generateConfirm=function(){Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-ui"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You want to generate?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(){_this.setState({isLoading:true,generateno:"",disabled:true});_this.generateFabric();onClose();}},"Yes, Generate it!"));},closeOnClickOutside:true// onClickOutside: () => {
//   console.log("onClickOutside")
// }
});},_this.generateFabric=function(e){var generateno=_this.state.generateno;__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].generateFabric(generateno).then(function(response){if(response.status===200){if(response.text.data.status){_this.setState({fabrics:response.text.data.dataArray.slice(0,10),fabricsBulk:response.text.data.dataArray,hasMore:true,generateno:"",isLoading:false,disabled:false});}else{_this.props.getalertMessage("info",response.text.message);setTimeout(function(){return _this.props.history.push("/");},2000);_this.setState({generateno:"",isLoading:false,disabled:false});}}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.loadFunc=function(arg){if(_this.state.fabrics.length==_this.state.fabricsBulk.length){_this.setState({hasMore:false});}else{arg=arg*10;var fabricsBulk=[].concat(_toConsumableArray(_this.state.fabricsBulk));var fabrics=[].concat(_toConsumableArray(_this.state.fabrics));_this.setState({fabrics:[].concat(_toConsumableArray(fabrics.concat(fabricsBulk.splice(arg,10))))});}},_this._handleInputChange=function(name,value){_this.setState({generateno:value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BulkImport,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.location.state){if(this.props.location.state.bulkimport){var _props$location$state=this.props.location.state.bulkimport,fabrics=_props$location$state.fabrics,fabricsBulk=_props$location$state.fabricsBulk,generateno=_props$location$state.generateno,hasMore=_props$location$state.hasMore,isLoading=_props$location$state.isLoading;this.setState({fabrics:fabrics,fabricsBulk:fabricsBulk,generateno:generateno,hasMore:hasMore,isLoading:isLoading});// if (this.props.history.location.state.bulkImport !== undefined) {
//   const state = { ...this.props.history.state.bulkImport }
//   this.setState({
//     state
//   })
// }
}}}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-section bg-white"},this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding bg-white panel2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Page_PageHeader_PageHeader__["a" /* default */],{header:"BULK IMPORT",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 text-right p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Input")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number","class":"form-control col-md-7",name:"generateno",value:this.state.generateno,onChange:function onChange(e){return _this2._handleInputChange(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":this.state.disabled?"not-allowed ":"primary ",name:"button",disabled:this.state.disabled,onClick:function onClick(e){return _this2.generateConfirm();}},"Generate"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary pull-right px-2 py-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons font-for-icon-big"},"file_download")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_audit__["a" /* default */],{_id:"bulkImport"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"QR Code ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Fabric Code")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding list-height-scroll"},!this.state.isLoading&&this.state.fabrics.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default.a,{pageStart:0,loadMore:function loadMore(arg){return _this2.loadFunc(arg);},hasMore:this.state.hasMore,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Loading__["a" /* default */],null),useWindow:false},this.state.fabrics.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding",key:data._id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"",src:data.qr,width:"50px",height:"50px"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 p-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"cursor-pointer under-line",onClick:function onClick(e){return _this2.props.history.push("/developmentFabric",{action:"edit",_id:data._id,bulkimport:Object.assign({},_this2.state),route:"bulkImport"});}},data.fabricNumber)));})))))))));}}]);return BulkImport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BulkImport);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(457)


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      } else {
        options = {
          passive: false
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
var isBrowser = typeof window !== 'undefined';

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isBrowser) {
        if (!this.props.container) {
          this.container = document.createElement('div');
          document.body.appendChild(this.container);
        } else {
          this.container = this.props.container;
        }
        this.renderLayer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom2.default.unmountComponentAtNode(this.container);
      }
      if (!this.props.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (useCreatePortal) {
        return _reactDom2.default.createPortal(this.props.children, this.container);
      }
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node, // eslint-disable-line
  container: _propTypes2.default.object // eslint-disable-line
};

exports.default = Portal;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var createFocusTrap = __webpack_require__(462);

var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setNode = function (el) {
      _this.node = el;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var elementProps = {
        ref: this.setNode
      };

      // This will get id, className, style, etc. -- arbitrary element props
      for (var prop in this.props) {
        if (!this.props.hasOwnProperty(prop)) continue;
        if (checkedProps.indexOf(prop) !== -1) continue;
        elementProps[prop] = this.props[prop];
      }

      return React.createElement(this.props.tag, elementProps, this.props.children);
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  tag: 'div',
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(463);
var xtend = __webpack_require__(464);

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active || listeningFocusTrap !== trap) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addNewCustomer_css__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addNewCustomer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__addNewCustomer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Field_Field__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_picky_dist_picky_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Customer_AssignmentOfWork__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_left_arrow_png__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AlertContainer from 'react-alert';
//components
// Include CSS
//import _ from "lodash"
var assignmentOfWorkTemplate={sample:null,cad:null,fabric:null,trim:null,pattern:null,cutting:null,sewing:null,garmentTechnologist:null,embellishment:null,embroidery:null,wash:null,dispatch:null,qc:null,marker:null,costing:null,signOff:null//console.log("StyleServices:", StyleServices);
//console.log("listStyles method:", StyleServices.getStylePrefilledData);
};var ArrayData=[{status:true,name:"Active"},{status:false,name:"Inactive"}];var options=[{label:"One",value:1},{label:"Two",value:2},{label:"Three",value:3}];var bigList=[];for(var i=1;i<=1000;i++){bigList.push({id:i,name:"Item "+i});}var Customer=function(_Component){_inherits(Customer,_Component);function Customer(){var _ref,_this$state,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Customer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Customer.__proto__||Object.getPrototypeOf(Customer)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={action:"",_id:"",disabled:false,recentCustomerId:"",masSizeType:[],searchInput:{},originalData:[],// unmodified full data
filteredData:[],// shown in UI
customer:{customerId:"",customerName:"",customerCode:"",customerStatus:true,refImages:[],sites:[{officeName:null,city:null,country:null,registeredAddress1:"",registeredAddress2:"",zipCode:""}],fabricBasicRequirements:{fixedCharge:null,approvedTestingLab:null,primaryLightSource:null,secondaryLightSource:null,attribute:null},departments:[_defineProperty({departmentId:null,departmentName:"",controller:null,merchandiser:null,juniorMerchandiser:null,seniorMerchandiser:null,garmentTechnologist:null,allSizes:[{size:null,period:null}],priceQuoteMethod:"SINGLE",priceQuotesizeSingle:[{size:null,period:null}],priceQuotesizeMultiple:[{start:null,end:null,period:null}],range:[],toggle:false,isDropdownOpen:false,selectedOptions:[],garmentTypeOptions:[{value:"C1",label:"Back Neck length",garmentType:"Length"},{value:"C2",label:"Lorem ipsum",garmentType:"Width"},{value:"C3",label:"Lorem ipsum",garmentType:"Length"},{value:"C4",label:"Lorem ipsum",garmentType:"Width"}],trimPack:[{trimPackNo:"TP-0001",typeOfGmt:null,packagingMethod:null,packingType:null,subType:null,trimPackForm:{},totalAmount:0,packingTypeDisabled:false,subTypeDisabled:false}],size:[{minimum:null,maximum:null,period:null}],assignmentOfWork:{initial:{},production:{},product:{}},staff:[{firstName:"",lastName:"",designation:"",email:"",reportingTo:"",office:null,status:false}]},"toggle",true)],pom:[],garmentDetails:[]},deptIndex:0,isLoading:false,//LOADING
officeOption:[],//OFFICE OPTIONS
cityOption:[],//CITY OPTIONS
countryOption:[],//COUNTRY OPTIONS
statusOption:[],approvedTestingLabOption:[],//APPROVED TESTING LAB OPTION
// primaryLightSourceOption: [], //PRIMARY LIGHT SOURCE OPTION
// secondaryLightSourceOption: [], //SECONDARY LIGHT SOURCE OPTION
lightSourceOption:[],attributesOption:[],//ATTRIBUTES OPTION
nameOfDepartmentOption:[],designationOption:[],//DESIGNATION OPTION
reportingToOption:[],//REPORTING TO OPTION
employeesOption:[],empOption1:[],rangeOption:[],imageTypeOption:[],departmentList:[],pomList:[],typeOfGmtOption:[],packagingMethodOption:[],packingTypeOption:[],subTypeOption:[],packagingMaterialsOption:[],openModal:false,modalType:"",assignTextContent:[],arrayOfPackagingMaterial:null,selected:[],multiValue:[],preFilledData:[],rows:[],rowId:null,selectedOptions:[],// To store the selected options
isDropdownOpen:false,selectedGarment:"",// Selected garment type
SHRINKAGETYPEOPTIONS:[],GARMENTTYPEOPTIONS:[],selectedGarmentType:null,// Currently selected garment type
selectedPOM:null},_defineProperty(_this$state,"selectedOptions",{}),_defineProperty(_this$state,"selectedOptions1",{}),_defineProperty(_this$state,"selectAll",false),_defineProperty(_this$state,"toggleState",{}),_defineProperty(_this$state,"tableToggleState",{}),_defineProperty(_this$state,"row1",[{garmentType:null,sizeTypeDetails:[]}]),_defineProperty(_this$state,"selectedRows",{}),_this$state),_this.onInputValChange=function(name,val){var customer=Object.assign({},_this.state.customer);customer[name]=val;_this.setState({customer:customer});},_this.departmentDynamicChange=function(name,val,indexOf){var customer=Object.assign({},_this.state.customer);customer.departments[indexOf][name]=val;_this.setState({customer:customer});},_this.allSizesDynamicChange=function(name,value,deptIndex,sizeIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].allSizes[sizeIndex][name]=value;_this.setState({customer:customer});},_this.addAllSizes=function(deptIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].allSizes.push({size:null,period:null});_this.setState({customer:customer});},_this.removeAllSizes=function(deptIndex,sizeIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].allSizes=customer.departments[deptIndex].allSizes.filter(function(data,i){return i!=sizeIndex;});_this.setState({customer:customer});},_this.addressDynamicChange=function(name,val,indexOf){var customer=Object.assign({},_this.state.customer);customer.sites[indexOf][name]=val;_this.setState({customer:customer});},_this.staffDynamicChange=function(name,val,indexOf,i){var customer=Object.assign({},_this.state.customer);customer.departments[i].staff[indexOf][name]=val;_this.setState({customer:customer});},_this.fabricDynamicChange=function(name,val,i,type){var customer=Object.assign({},_this.state.customer);customer.fabricBasicRequirements[name]=val;_this.setState({customer:customer});},_this.dynamicAddCount=function(e,changeOf,i){var customer=Object.assign({},_this.state.customer);switch(changeOf){case"department":var departmentObj={departmentId:null,departmentName:"",controller:null,merchandiser:null,juniorMerchandiser:null,seniorMerchandiser:null,allSizes:[{size:null,period:null}],garmentTechnologist:null,priceQuoteMethod:"SINGLE",priceQuotesizeSingle:[{size:null,period:null}],priceQuotesizeMultiple:[{start:null,end:null,period:null}],range:[],trimPack:[{trimPackNo:"TP-0001",typeOfGmt:null,default:false,packagingMethod:null,packingType:null,subType:null,trimPackForm:{},totalAmount:0,packingTypeDisabled:false,subTypeDisabled:false}],size:{minimum:null,maximum:null},assignmentOfWork:{initial:Object.assign({},assignmentOfWorkTemplate),production:Object.assign({},assignmentOfWorkTemplate),product:Object.assign({},assignmentOfWorkTemplate)},staff:[{firstName:"",lastName:"",designation:null,email:"",reportingTo:"",office:null,status:false}],toggle:false};customer.departments=customer.departments.map(function(data){return Object.assign({},data,{toggle:true});});customer.departments.push(Object.assign({},departmentObj));_this.setState({customer:customer},function(){var ele=document.getElementById("dept"+(_this.state.customer.departments.length-1));ele.scrollIntoView();});break;case"staff":var staffObj={firstName:"",lastName:"",designation:null,email:"",reportingTo:"",office:"",status:false};customer.departments[i].staff.push(Object.assign({},staffObj));_this.setState({customer:customer});break;case"addresses":var sitesObj={officeName:"",city:null,country:null,registeredAddress1:"",registeredAddress2:"",zipCode:""};customer.sites.push(Object.assign({},sitesObj));_this.setState({customer:customer});break;case"pom":// let garmentDetails ={
//   garmentType: null,
//   sizeType: [],
// }
// const garmentDetails = {
//   garmentType: null,
//   sizeTypeDetails: [],
//   _id: Date.now().toString() // Temporary ID for new entries
// };
// this.setState(prevState => ({
//   customer: {
//     ...prevState.customer,
//     garmentDetails: [...prevState.customer.garmentDetails, garmentDetails]
//   },
//   selectedRows: {
//     ...prevState.selectedRows,
//     [garmentDetails._id]: []
//   }
// }));
for(var _i=0;_i<_this.state.row1.length;_i++){var row=_this.state.row1[_i];if(!row.garmentType){var message="Garment Type is required";_this.props.getalertMessage("error",message);return;}}var firstSizeTypeDetails=_this.state.row1.length>0?_this.state.row1[0].sizeTypeDetails:[];var garmentDetails={garmentType:null,sizeTypeDetails:[].concat(_toConsumableArray(firstSizeTypeDetails))// _id: Date.now().toString() // Temporary ID for new entries
};// Update the state to add the new garmentDetails to row1 and selectedRows
//   this.setState(prevState => ({
//     row1: [...prevState.row1, garmentDetails], // Store in row1 instead of customer.garmentDetail
//   }));
//   customer.garmentDetails.push({ ...garmentDetails })  // Push the new pom object
//   this.setState({ customer }, () => {
//     var ele = document.getElementById(
//       `pom${this.state.customer.garmentDetails.length - 1}`
//     )
//   if (ele) {
//     ele.scrollIntoView()  // Scroll to the new pom element
//   }
// })  
_this.setState(function(prevState){return{customer:Object.assign({},prevState.customer,{garmentDetails:[].concat(_toConsumableArray(customer.garmentDetails||[]))}),row1:[].concat(_toConsumableArray(prevState.row1),[garmentDetails])};},function(){var ele=document.getElementById("pom"+(_this.state.row1.length-1));if(ele){ele.scrollIntoView();}});break;default:break;}},_this.dynamicRemoveCount=function(e,changeOf,i,index){var customer=Object.assign({},_this.state.customer);switch(changeOf){case"department":customer.departments.splice(i,1);_this.setState({customer:customer});break;case"staff":customer.departments[i].staff.splice(index,1);_this.setState({customer:customer});break;case"addresses":customer.sites.splice(i,1);_this.setState({customer:customer});case"pom":// Remove pom at index i
// customer.garmentDetails.splice(i, 1)
// this.setState({ customer })
_this.state.row1.splice(i,1);// this.state.selectedRows.splice(i,1)
if(_this.state.selectedRows&&_this.state.selectedRows[i]){_this.state.selectedRows.splice(i,1);}_this.setState({row1:_this.state.row1});_this.props.getalertMessage("error","Garment pom is removed");break;default:break;}},_this.getAssign=function(value){__WEBPACK_IMPORTED_MODULE_12__services__["h" /* PermissionServices */].searchEmploye(value).then(function(response){if(response.status==200){_this.setState({employeesOption:response.text.data});}}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.empOptions=function(value){__WEBPACK_IMPORTED_MODULE_12__services__["h" /* PermissionServices */].searchEmploye(value).then(function(response){if(response.status==200){_this.setState({empOption1:response.text.data});}}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.changeAssign=function(name,value,index,moduleName){var customer=Object.assign({},_this.state.customer);customer.departments[_this.state.deptIndex].assignmentOfWork[moduleName][name]=value?value.value:null;_this.setState({customer:customer});},_this.onSave=function(e){e.preventDefault();//Jayaprakash
var customer=Object.assign({},_this.state.customer);var selectedRows=_this.state.selectedRows;// const garmentDetails = this.state.row1.map(garment => ({
//   //_id: garment._id,
//   garmentType: garment.garmentType,
//   sizeTypeDetails: (selectedRows[garment._id] || []).map(id => ({
//     _id: id,
//     // Other fields will be populated from row1 data on backend
//   }))
// }));
if(_this.state._id!==""){var garmentDetails=_this.state.row1.map(function(garment,index){return{garmentType:garment.garmentType,// Directly use garmentType
sizeType:(selectedRows[index]||[]).map(function(id){return id;})// Only the _id values (as strings)
};});//console.log(garmentDetails,"whilesaving")
customer.pom=garmentDetails;}customer.departments=customer.departments.map(function(customerDepartment){var data=Object.assign({},customerDepartment);// if (!!data.garmentTechnologist) {
//   data.garmentTechnologist = data.garmentTechnologist.value
// }
// if (!!data.juniorMerchandiser) {
//   data.juniorMerchandiser = data.juniorMerchandiser.value
// }
// if (!!data.merchandiser) {
//   data.merchandiser = data.merchandiser.value
// }
// if (!!data.seniorMerchandiser) {
//   data.seniorMerchandiser = data.seniorMerchandiser.value
// }
// if (!!data.controller) {
//   data.controller = data.controller.value
// }
if(data.range.length){data.range=data.range.map(function(obj){return(typeof obj==="undefined"?"undefined":_typeof(obj))=="object"?obj.value:obj;});}Object.keys(data.assignmentOfWork).length>0&&Object.keys(data.assignmentOfWork).forEach(function(moduleName){Object.keys(data.assignmentOfWork[moduleName]).length>0&&Object.keys(data.assignmentOfWork[moduleName]).forEach(function(keyName){if(_typeof(data.assignmentOfWork[moduleName][keyName])==="object"&&data.assignmentOfWork[moduleName][keyName]!==null)data.assignmentOfWork[moduleName][keyName]=data.assignmentOfWork[moduleName][keyName].value;});return data;});return data;});if(_this.state._id!==""){customer._id=_this.state._id;}if(customer.departments.filter(function(data){return data.departmentName=="";}).length>0){_this.props.getalertMessage("error"," Department name cannot be empty");}else{__WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].createCustomer(customer).then(function(response){if(response.status==200){var updatedCus=_this.state.customer;updatedCus.departments=updatedCus.departments.map(function(x){x.toggle=true;return x;});_this.setState({_id:response.text.data._id,customer:updatedCus});_this.props.getalertMessage("success",response.text.message);}else{_this.props.getalertMessage("error",response.text.message);}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}},_this.updateAsyncValues=function(value,name,i){var customer=Object.assign({},_this.state.customer);customer.departments[i][name]=value?value.value:null;_this.setState({customer:customer});},_this.getRefImages=function(refImages){var customer=Object.assign({},_this.state.customer);customer.refImages=refImages;_this.setState({customer:customer});},_this.updateSize=function(name,value,index){var customer=Object.assign({},_this.state.customer);customer.departments[index].size[name]=value;_this.setState({customer:customer});},_this.handleDropdownChange=function(event){_this.setState({selectedGarment:event.target.value});},_this._handleInputChangeTrimPack=function(name,value,index){var customer=Object.assign({},_this.state.customer);if(name==="default"){var trimPack=customer.departments[_this.state.deptIndex].trimPack;trimPack.map(function(x,i){if(i==index){x.default=true;}else{x.default=false;}});customer.departments[_this.state.deptIndex].trimPack=trimPack;}else{customer.departments[_this.state.deptIndex].trimPack[index][name]=value;}// if(customer.departments[this.state.deptIndex].trimPack[index].packagingMethod === 'HANGING' && customer.departments[this.state.deptIndex].trimPack[index].typeOfGmt !== undefined ){
//   customer.departments[this.state.deptIndex].trimPack[index].packingTypeDisabled = true
//   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true
// } else if(name == 'packingType' && (value == 'WITH HANGER ' || value == 'WITHOUT HANGER'))
//   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true
// else if (customer.departments[this.state.deptIndex].trimPack[index].typeOfGmt !== undefined && customer.departments[this.state.deptIndex].trimPack[index].packagingMethod === 'BOXED' && customer.departments[this.state.deptIndex].trimPack[index].packingType === ('WITH HANGER' || 'WITHOUT HANGER') )
// customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true
// else{
//   customer.departments[this.state.deptIndex].trimPack[index].packingTypeDisabled = false
//   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = false
// }
_this.setState({customer:customer});},_this.addTrimPack=function(deptIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].trimPack.push({trimPackNo:"TP-000"+(customer.departments[deptIndex].trimPack.length+1),default:false,typeOfGmt:null,packagingMethod:null,packingType:null,subType:null,trimPackForm:{},totalAmount:0});_this.setState({customer:customer});},_this.removeTrimPack=function(deptIndex,trimPackIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].trimPack=customer.departments[deptIndex].trimPack.filter(function(data,ind){return trimPackIndex!=ind;});_this.setState({customer:customer});},_this.handleChangePackaging=function(name,value,index){var customer=Object.assign({},_this.state.customer);customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[name]=value;_this.setState({customer:customer});},_this.updateCalcPackaging=function(index){var customer=Object.assign({},_this.state.customer);customer.departments[_this.state.deptIndex].trimPack[index].totalAmount=0;Object.keys(customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm).forEach(function(keyName){if(customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[keyName]!==null){customer.departments[_this.state.deptIndex].trimPack[index].totalAmount=(Number(customer.departments[_this.state.deptIndex].trimPack[index].totalAmount)+Number(parseFloat(customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[keyName]))).toFixed(2);}});_this.setState({customer:customer});},_this.addPackagingMaterial=function(index){var customer=Object.assign({},_this.state.customer);var trimePackFormTempString=JSON.stringify(customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm);var trimePackFormTemp=JSON.parse(trimePackFormTempString);customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm={};_this.state.arrayOfPackagingMaterial[_this.state.deptIndex][index].map(function(value){if(trimePackFormTemp[value.name]===undefined){customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[value.name]=null;}else{customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[value.name]=trimePackFormTemp[value.name];}// if(!customer.departments[this.state.deptIndex].trimPack[index].trimPackForm.hasOwnProperty(value.name)){
// customer.departments[this.state.deptIndex].trimPack[index].trimPackForm[
//   value.name
// ] = null
// }
});_this.setState({customer:customer// arrayOfPackagingMaterial: []
// [`selectOpen${index}`] : false
},function(){return _this.updateCalcPackaging(index);});},_this.removeTrimPackForm=function(name,index){var state=Object.assign({},_this.state);var customer=state.customer,arrayOfPackagingMaterial=state.arrayOfPackagingMaterial;arrayOfPackagingMaterial[_this.state.deptIndex][index]=arrayOfPackagingMaterial[_this.state.deptIndex][index].filter(function(x){return x.name!==name;});delete customer.departments[_this.state.deptIndex].trimPack[index].trimPackForm[name];_this.setState({customer:customer,arrayOfPackagingMaterial:arrayOfPackagingMaterial},function(){return _this.updateCalcPackaging(index);});},_this.updatePriceQuoteSizeSingle=function(name,value,deptIndex,index){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].priceQuotesizeSingle[index][name]=value;_this.setState({customer:customer});},_this.priceQuoteSizeMultiDynamicChange=function(name,value,deptIndex,sizeIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].priceQuotesizeMultiple[sizeIndex][name]=value;_this.setState({customer:customer});},_this.addPriceQuoteSizeMulti=function(deptIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].priceQuotesizeMultiple.push({start:null,end:null,period:null});_this.setState({customer:customer});},_this.removePriceQuoteSizeMulti=function(deptIndex,sizeIndex){var customer=Object.assign({},_this.state.customer);customer.departments[deptIndex].priceQuotesizeMultiple=customer.departments[deptIndex].priceQuotesizeMultiple.filter(function(data,i){return i!=sizeIndex;});_this.setState({customer:customer});},_this.selectMultipleOption=function(value,trimPackIndex){var updateArrayOfPackagingMaterial=Object.assign({},_this.state.arrayOfPackagingMaterial);updateArrayOfPackagingMaterial[_this.state.deptIndex]=Object.assign({},updateArrayOfPackagingMaterial[_this.state.deptIndex],_defineProperty({},trimPackIndex,[].concat(_toConsumableArray(value))));_this.setState({arrayOfPackagingMaterial:updateArrayOfPackagingMaterial});},_this.changeToggleList=function(i){var customer=Object.assign({},_this.state.customer);customer.departments[i].toggle=!customer.departments[i].toggle;_this.setState({customer:customer});},_this.scrollToModule=function(id,index){_this.setState(function(prevState){return{toggleState:_defineProperty({},index,true),tableToggleState:_defineProperty({},index,true)};},function(){// Ensure state update is applied first, then scroll
var moduleEle=document.getElementById(id);if(moduleEle){moduleEle.scrollIntoView({behavior:"smooth",block:"start"});}});},_this.onPomSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state2,rows,_id,_i2,row,message,payload,response,newData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state2=_this.state,rows=_this$state2.rows,_id=_this$state2._id;if(!(rows.length===0)){_context.next=4;break;}_this.props.getalertMessage("error","There is nothing in the POM Master to save.");return _context.abrupt("return");case 4:_i2=0;case 5:if(!(_i2<rows.length)){_context.next=14;break;}row=rows[_i2];// console.log(row,"val")
if(!(!row.code&&!row.placeofMeasurement)){_context.next=11;break;}// Throw error message for the first invalid row
message="Row "+(_i2+1)+" is missing required fields.";_this.props.getalertMessage("error",message);return _context.abrupt("return");case 11:_i2++;_context.next=5;break;case 14:payload={customerId:_id,measurements:rows.map(function(row){return{code:row.code,placeofMeasurement:row.placeofMeasurement,shrinkageType:row.shrinkageType,_id:row._id};}),id:_this.state.rowId};//console.log(payload,"pay")
_context.prev=15;_context.next=18;return __WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].createpomMaster(payload);case 18:response=_context.sent;//console.log(response.text.data._id,"res cus")
if(response.status===200){newData=response.text.data;_this.props.getalertMessage("success","POM Master saved");//console.log(newData.measurements,"newmap")
// Update ONLY the master list of available POMs
_this.setState(function(prevState){return{rows:newData.measurements,// row1: newData.measurements.map(item => ({
//   ...item,
//   sizeTypeDetails: item.sizeTypeDetails || [] // Ensure sizeTypeDetails exists
// })),
row1:prevState.row1.map(function(item){return Object.assign({},item,{// sizeTypeDetails: [...newData.measurements] // ✅ Insert into each row1 object
sizeTypeDetails:newData.measurements.map(function(row){return Object.assign({},row);})// ✅ Creates new objects
});}),rowId:newData._id};});//console.log(this.state.row1,"row1whsavpom")
}else{_this.props.getalertMessage("error",response.text.message);}if(response.status===401){_this.props.unauthorisedFunc();}_context.next=26;break;case 23:_context.prev=23;_context.t0=_context["catch"](15);_this.props.getalertMessage("error",_context.t0.toString());case 26:case"end":return _context.stop();}}},_callee,_this2,[[15,23]]);})),_this.handleRowChange=function(field,value,index){_this.setState(function(prevState){// const rows = [...prevState.rows];
// rows[index][field] = value;
// return { rows };
var rows=prevState.rows.map(function(row,i){return i===index?Object.assign({},row,_defineProperty({},field,value)):row;}// ✅ Creates a new object
);return{rows:rows};});},_this.addRow=function(){var rows=_this.state.rows;// Validate each row
for(var _i3=0;_i3<rows.length;_i3++){// If BOTH fields are empty, show an error
var row=rows[_i3];if(!row.code&&!row.placeofMeasurement){// Throw error message for the first invalid row
var message="Row "+(_i3+1)+" is missing required fields.";_this.props.getalertMessage("error",message);return;}}_this.setState(function(prevState){return{rows:[].concat(_toConsumableArray(prevState.rows),[{code:"",placeofMeasurement:"",shrinkageType:""}])};});},_this.deleteRow=function(index){_this.setState(function(prevState){return{rows:prevState.rows.filter(function(_,i){return i!==index;})};});_this.props.getalertMessage("error","row is removed");},_this.toggleDropdown=function(index){var customer=_this.state.customer;customer.departments[index].isDropdownOpen=!customer.departments[index].isDropdownOpen;_this.setState({customer:customer});},_this.handleOptionChange=function(index,value){var customer=_this.state.customer;var department=customer.departments[index];var selectedOptions=[].concat(_toConsumableArray(department.selectedOptions));if(selectedOptions.includes(value)){var optionIndex=selectedOptions.indexOf(value);selectedOptions.splice(optionIndex,1);// Remove the option
}else{selectedOptions.push(value);// Add the option
}department.selectedOptions=selectedOptions;_this.setState({customer:customer});},_this.handleGarmentTypeSelection=function(garmentType){_this.setState({selectedGarmentType:garmentType,selectedPOM:null,selectedOptions:{}});},_this.handlePomSelection=function(pomName){_this.setState({selectedPOM:pomName});},_this.handlePomChange=function(field,value,index){// Copy the existing garmentDetails
var updatedRow1=[].concat(_toConsumableArray(_this.state.row1));// Ensure the row exists and update the field
if(updatedRow1[index]){updatedRow1[index][field]=value;}else{console.warn("Row at index "+index+" does not exist.");}// Update the state
_this.setState({// row1: [{
//   ...this.state.customer,
//   garmentDetails: updatedGarmentDetails
// }]
row1:updatedRow1},function(){//console.log(`Updated garmentDetails:`, this.state.row1);
});},_this.getGarmentTypeLabel=function(garmentTypeId){var option=_this.state.GARMENTTYPEOPTIONS.find(function(option){return option.value===garmentTypeId;});return option?option.label:null;},_this.handleRowSelect=function(rowIndex,sizeTypeId,isChecked){var updatedSelectedRows=[].concat(_toConsumableArray(_this.state.selectedRows));// Ensure the row index exists
if(!updatedSelectedRows[rowIndex]){updatedSelectedRows[rowIndex]=[];}// Add or remove the `sizeTypeId` based on the checkbox state
if(isChecked){if(!updatedSelectedRows[rowIndex].includes(sizeTypeId)){updatedSelectedRows[rowIndex].push(sizeTypeId);}}else{updatedSelectedRows[rowIndex]=updatedSelectedRows[rowIndex].filter(function(id){return id!==sizeTypeId;});}// Update the state
_this.setState({selectedRows:updatedSelectedRows});},_this.handleSelectAll=function(rowIndex,rows){var updatedSelectedRows=[].concat(_toConsumableArray(_this.state.selectedRows));// Check if we are selecting or unselecting
var isAllSelected=(updatedSelectedRows[rowIndex]||[]).length===rows.length;if(isAllSelected){// If all are selected, unselect all
updatedSelectedRows[rowIndex]=[];}else{// Otherwise, select all
var allIds=rows.map(function(row){return row._id;});// assuming each row has an _id field
updatedSelectedRows[rowIndex]=allIds;}// Update the state
_this.setState({selectedRows:updatedSelectedRows});},_this.handleToggle=function(index){_this.setState(function(prevState){var newToggleState=Object.assign({},prevState.toggleState,_defineProperty({},index,!prevState.toggleState[index]));// If opening, also open isTableToggled for this index
if(newToggleState[index]){return{toggleState:newToggleState,tableToggleState:Object.assign({},prevState.tableToggleState,_defineProperty({},index,true))};}return{toggleState:newToggleState};});},_this.renderShrinkageTypeLabel=function(id){var SHRINKAGETYPEOPTIONS=_this.state.SHRINKAGETYPEOPTIONS;if(!SHRINKAGETYPEOPTIONS)return"Loading...";//console.log(SHRINKAGETYPEOPTIONS,"SHRINKAGETYPEOPTIONS")
var type=SHRINKAGETYPEOPTIONS.find(function(item){return item.value===id;});//console.log(type, "type")
return type?type.label:"";},_this.tableToggle=function(index){_this.setState(function(prevState){return{tableToggleState:Object.assign({},prevState.tableToggleState,_defineProperty({},index,!prevState.tableToggleState[index]))};});},_this.preventLeadingSpaces=function(value){// if (value.startsWith(" ")) {
//   return value.trimStart(); // Remove leading spaces
// }
// return value;
// Remove leading spaces
value=value.trimStart();// Replace multiple spaces between words with a single space
return value.replace(/\s+/g," ");},_this.seperateGarmentPomSave=function(e,index){e.preventDefault();var _this$state3=_this.state,row1=_this$state3.row1,selectedRows=_this$state3.selectedRows;console.log(row1,"saver1");var pomData=row1[index];console.log(pomData,"save");var payload={pom:[{garmentType:pomData.garmentType,// sizeType: (selectedRows[index] || []).map(id => ({
//   _id: id,
// })),
sizeType:selectedRows[index]||[],_id:pomData._id}]};// CustomerServices.garmentPomSave(payload,this.state._id)
//   .then(response=>{
//     console.log(response,"saveres")
//     if(response.status === 200){
//       const newData = response.text.data.pom
//       this.setState(prevState => ({
//         // rows: newData.measurements,
//         // row1: newData.measurements.map(item => ({
//         //   ...item,
//         //   sizeTypeDetails: item.sizeTypeDetails || [] // Ensure sizeTypeDetails exists
//         // })),
//         row1: prevState.row1.map(item => ({
//           ...item,
//           // sizeTypeDetails: [...newData.measurements] // ✅ Insert into each row1 object
//           // sizeTypeDetails: newData.map(row => ({ ...row })) // ✅ Creates new objects
//         })),
//         rowId: newData._id
//       }));
//       console.log(this.state.row1,"row1")
//       this.props.getalertMessage("success", "Garment POM saved");
//     }else{
//       this.props.getalertMessage("error", "Error saving Garment POM")
//     }
//   })
__WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].garmentPomSave(payload,_this.state._id).then(function(response){if(response.status===200){var newData=response.text.data.pom;// Ensure response contains updated pom data
_this.setState(function(prevState){return{row1:prevState.row1.map(function(row){// Find the corresponding updated data
var updatedPom=newData.find(function(pomItem){return pomItem.garmentType===row.garmentType;});// If a match is found, update _id and sizeType
return updatedPom?Object.assign({},row,{_id:updatedPom._id}):row;})};});_this.props.getalertMessage("success","Garment POM saved");}else{_this.props.getalertMessage("error",response.text.message);}});},_this.hasPermission=function(module,action){var platform=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"web";var rights=_this.props.rights;// Get rights from props
// Check if the module exists in rights
if(rights&&rights[module]&&rights[module][platform]){return rights[module][platform][action]||false;}return false;// Default to false if any part is missing
},_this.hasPermission1=function(module,subModule,action){var platform=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"web";var rights=_this.props.rights;// Get rights from props
// Replace "add" with "create"
var normalizedAction=action==="add"?"create":action;// Check if the module exists in rights
if(rights&&rights[module]&&rights[module][platform]){return rights[module][subModule][platform][normalizedAction]||false;}return false;// Default to false if any part is missing
},_this.garmentPomDelete1=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(index){var _this$state4,row1,selectedRows,_id,pomData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://console.log(CustomerServices);
//console.log(typeof CustomerServices.garmentPomDelete);
_this$state4=_this.state,row1=_this$state4.row1,selectedRows=_this$state4.selectedRows,_id=_this$state4._id;pomData=row1[index];//console.log('pomData:', pomData, 'row1[index]:', row1[index], 'index:', index);
if(!(!pomData||!pomData._id)){_context2.next=8;break;}_this.state.row1.splice(index,1);// this.state.selectedRows.splice(index,1)
if(_this.state.selectedRows&&_this.state.selectedRows[i]){_this.state.selectedRows.splice(i,1);}_this.setState({row1:_this.state.row1});_this.props.getalertMessage("error","Garment pom is removed");return _context2.abrupt("return");case 8:__WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].garmentPomDelete(_this.state._id,pomData._id).then(function(response){console.log(response,"delres");if(response.status===200){_this.setState(function(prevState){var updatedRow1=[].concat(_toConsumableArray(prevState.row1));_this.state.selectedRows.splice(index,1);updatedRow1.splice(index,1);console.log(updatedRow1,"121");return{row1:updatedRow1};});_this.props.getalertMessage("success","Garment POM deleted successfully");}else{_this.props.getalertMessage("error","Error deleting Garment POM");}}).catch(function(error){console.error("Error deleting Garment POM:",error);_this.props.getalertMessage("error","Something went wrong while deleting Garment POM");});case 9:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}(),_this.handleBackNavigation=function(){Object(__WEBPACK_IMPORTED_MODULE_20_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref5){var onClose=_ref5.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Are you sure you want to leave"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Make sure your changes are saved"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%",marginRight:"10px"},onClick:function onClick(){onClose();_this.navigateBack();}},"Yes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"No"));},closeOnClickOutside:false});},_this.navigateBack=function(){var state=_this.props.history.location.state;var route=state&&state.route;// Avoids optional chaining
if(route!==undefined){_this.props.history.push("/"+route,_defineProperty({},route.toLowerCase(),state[route.toLowerCase()]||{}));}else{_this.props.history.goBack();}},_this.handleSearchChange=function(value,index){_this.setState(function(prevState){return{searchInput:Object.assign({},prevState.searchInput,_defineProperty({},index,value))};});},_this.clearSearch=function(index){_this.setState(function(prevState){var updatedSearchInput=Object.assign({},prevState.searchInput,_defineProperty({},index,""));return{searchInput:updatedSearchInput,filteredData:prevState.originalData};});},_this.getFilteredData=function(data,searchInput){if(!searchInput||searchInput.trim()==="")return data;var lowercasedInput=searchInput.toLowerCase().trim();var filteredData=data.filter(function(option){return option.code&&option.code.toLowerCase().includes(lowercasedInput)||option.placeofMeasurement&&option.placeofMeasurement.toLowerCase().includes(lowercasedInput);});return filteredData;},_temp),_possibleConstructorReturn(_this,_ret);}// LIFE CYCLE START
_createClass(Customer,[{key:"componentWillMount",value:function componentWillMount(){var _this3=this;var _props$location$state=this.props.location.state,action=_props$location$state.action,_id=_props$location$state._id;this.setState({action:action,_id:_id});if(_id!=""){__WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].getCustomer(_id).then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){var customer,pom,garmentDetails,selectedRows;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(response.status==200)){_context3.next=19;break;}customer=Object.assign({},_this3.state.customer);Object.keys(customer).forEach(function(keyname){customer[keyname]=response.text.data[keyname];});customer.departments=customer.departments.map(function(department){// department.range = department.range.map((data) => {
//   return data.value})
department.trimPack=department.trimPack.map(function(trimPack){if(trimPack.trimPackForm==undefined){trimPack.trimPackForm={};}return trimPack;});return department;});// const pom =  response.text.data.garmentDetails || [];
// customer.pom = pom;
// console.log(pom,"from api pm")
// const garmentDetails = response.text.data.pom || [];
// customer.garmentDetails = garmentDetails;
//console.log(pom, "pom");
pom=response.text.data.pom||[];garmentDetails=response.text.data.garmentDetails||[];//console.log(garmentDetails,"componentwill mount ")
// this.setState(prevState => {
//   // Update row1 with the garmentType from garmentDetails
//   const updatedRow1 = this.state.row1.map((garment, index) => {
//     // Find the corresponding garmentType in garmentDetails
//     const garmentDetail = garmentDetails[index];
//     // Update the garmentType in the row1 state
//     if (garmentDetail) {
//       return {
//         ...garment,
//         garmentType: garmentDetail.garmentType || "" // Update if there's a value, otherwise keep the old one
//       };
//     }
//     return garment; // Return the original garment if no match is found
//   });
// this.setState(prevState => {
//   // If row1 is empty, initialize it with garmentType from garmentDetails and sizeTypeDetails as empty array
//   const updatedRow1 = garmentDetails.map(garmentDetail => ({
//     garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
//     sizeTypeDetails: [] // Initialize sizeTypeDetails as empty array
//   }));
//   console.log(updatedRow1, "updaterow1");
//   // Return the updated state with new row1
//   return {
//     row1: updatedRow1
//   };
// });
// this.setState(prevState => {
//   // If garmentDetails is empty, do not update the state
//   if (!garmentDetails || garmentDetails.length === 0) {
//     return null;
//   }
//   // Initialize row1 with garmentType from garmentDetails and sizeTypeDetails as an empty array
//   const updatedRow1 = garmentDetails.map(garmentDetail => ({
//     garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
//     sizeTypeDetails: [], // Initialize sizeTypeDetails as an empty array
//     _id: garmentDetail._id
//   }));
//   //console.log(updatedRow1, "updatedRow1");
//   // Return the updated state with new row1
//   console.log(updatedRow1,"row1willmo")
//   return {
//     row1: updatedRow1
//   };
// });
// console.log(this.state.row1,"after up row1")
// const selectedRows = {};
// const selectedRows = {};
// garmentDetails.forEach(garment => {
//   selectedRows[garment._id] = garment.sizeTypeDetails.map(detail => detail._id);
// });
selectedRows=garmentDetails.map(function(garment){return garment.sizeTypeDetails.map(function(detail){return detail._id;});});_context3.t0=_this3;_context3.t1=customer;_context3.t2=pom;_context3.t3=selectedRows;_context3.next=13;return response.text.data._id;case 13:_context3.t4=_context3.sent;_context3.next=16;return response.text.data.arrayOfPackagingMaterial;case 16:_context3.t5=_context3.sent;_context3.t6={customer:_context3.t1,pom:_context3.t2,selectedRows:_context3.t3,_id:_context3.t4,arrayOfPackagingMaterial:_context3.t5};_context3.t0.setState.call(_context3.t0,_context3.t6);case 19:response.status==401&&_this3.props.unauthorisedFunc();case 20:case"end":return _context3.stop();}}},_callee3,_this3);}));return function(_x4){return _ref6.apply(this,arguments);};}());}if(action=="view"){this.setState({disabled:true});}//modal content for assignment of process
//assignofprocess
// const assignmodule = [
//   "Sample",
//   "CAD",
//   "Fabric",
//   "Trim",
//   "Pattern",
//   "Cutting",
//   "Sewing",
//   "Garment Tech",
//   "Embellishment",
//   "Embroidery",
//   "Wash",
//   "Dispatch",
//   "QC",
//   "Marker",
//   "Costing",
//   "Sign Off"
// ]
// const assignTextContent = [...this.state.assignTextContent]
// assignmodule.map((data, i) => {
//   assignTextContent.push({
//     modalType: data,
//     employeeId: ""
//   })
// })
// this.setState({
//   assignTextContent
// })
}},{key:"componentDidMount",value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _this4=this;var officeOption,cityOption,countryOption,statusOption,approvedTestingLabOption,attributesOption,designationOption,reportingToOption,employeesOption,rangeOption,imageTypeOption,typeOfGmtOption,packagingMethodOption,packingTypeOption,subTypeOption,packagingMaterialsOption,lightSourceOption,_id,data,measurements,_data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:officeOption=[];//OFFICE OPTIONS
cityOption=[];//CITY OPTIONS
countryOption=[];//COUNTRY OPTION
statusOption=[];// var primaryLightSourceOption = []; //PRIMARY LIGHT SOURCE OPTION
// var secondaryLightSourceOption = []; //SECONDARY LIGHT SOURCE OPTION
approvedTestingLabOption=[];//APPROVED TESTING LAB OPTION
attributesOption=[];//ATTRIBUTES OPTION
designationOption=[],reportingToOption=[];//REPORTING TO OPTION
employeesOption=[];rangeOption=[];imageTypeOption=[];typeOfGmtOption=[];packagingMethodOption=[];packingTypeOption=[];subTypeOption=[];packagingMaterialsOption=[];lightSourceOption=[];this.setState({isLoading:true});this.getAssign("");if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}_context7.next=21;return __WEBPACK_IMPORTED_MODULE_12__services__["k" /* StyleServices */].getStylePrefilledData().then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0://console.log(res.text.data,"res")
_this4.setState({preFilledData:res.text.data,SHRINKAGETYPEOPTIONS:res.text.data.SHRINKAGETYPE,GARMENTTYPEOPTIONS:res.text.data.GARMENTTYPE});case 1:case"end":return _context4.stop();}}},_callee4,_this4);}));return function(_x5){return _ref8.apply(this,arguments);};}());case 21:// await CustomerServices.getPomMaster(this.state._id).then(async data => {
//   console.log(data.text)
//   if (data.status == 200) {
//     this.setState({
//       rows: data.text.data.measurements,
//       rowId:data.text.data._id
//     })
//   }
// })
_id=this.props.location.state._id;// if (_id != "") {
//   CustomerServices.getCustomer(_id).then(async response => {
//     if (response.status == 200) {
//       let customer = { ...this.state.customer }
//       const pom = response.text.data.pom || [];
//       const garmentDetails = response.text.data.garmentDetails || [];
//       this.setState(prevState => {
//         // If garmentDetails is empty, do not update the state
//         if (!garmentDetails || garmentDetails.length === 0) {
//           return null;
//         }
//         // Initialize row1 with garmentType from garmentDetails and sizeTypeDetails as an empty array
//         const updatedRow1 = garmentDetails.map(garmentDetail => ({
//           garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
//           sizeTypeDetails: [], // Initialize sizeTypeDetails as an empty array
//           _id: garmentDetail._id
//         }));
//         //console.log(updatedRow1, "updatedRow1");
//         // Return the updated state with new row1
//         console.log(updatedRow1,"row1willmo")
//         return {
//           row1: updatedRow1
//         };
//       });
//       console.log(this.state.row1,"after up row1")
//       const selectedRows = garmentDetails.map(garment => 
//         garment.sizeTypeDetails.map(detail => detail._id)
//       );
//       this.setState({
//         customer,
//          pom,
//          selectedRows,
//       })
//     }
//     response.status == 401 && this.props.unauthorisedFunc()
//   })
// }
if(!this.state._id){_context7.next=33;break;}_context7.prev=23;_context7.next=26;return __WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].getPomMaster(this.state._id);case 26:data=_context7.sent;if(data.status===200){// Ensure measurements exist, or use an empty array
measurements=data.text.data.measurements||[];//console.log(measurements,"mm")
// this.setState(prevState => ({
//   customer: {
//     ...prevState.customer,  // Preserve existing customer properties
//     masSizeType: [...measurements] // Store masSizeType inside customer
//   }
// }));
// console.log(this.state.customer.masSizeType,"chmass")
this.setState({masSizeType:[].concat(_toConsumableArray(measurements))// Store masSizeType separately
},function(){//console.log(this.state.masSizeType, "Updated masSizeType outside customer");
});}_context7.next=33;break;case 30:_context7.prev=30;_context7.t0=_context7["catch"](23);console.error("Error fetching Pom Master data:",_context7.t0);case 33:if(_id!==""){__WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].getCustomer(_id).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){var customer,pom,garmentDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(response.status==200){customer=Object.assign({},_this4.state.customer);pom=response.text.data.pom||[];garmentDetails=response.text.data.garmentDetails||[];// Combine both updates in one state change
_this4.setState(function(prevState){// If garmentDetails is empty, do not update the state
if(!garmentDetails||garmentDetails.length===0){return null;}//console.log(this.state.customer,"mas")
// Initialize row1 with garmentType from garmentDetails and empty sizeTypeDetails
var updatedRow1=garmentDetails.map(function(garmentDetail){return{garmentType:garmentDetail.garmentType||null,sizeTypeDetails:_this4.state.masSizeType,// Initialize sizeTypeDetails as an empty array
_id:garmentDetail._id};});// Log to check the updated row1
//console.log(updatedRow1, "row1 after garmentType update");
// Now return the updated state with both row1 and the new pom data
return{row1:updatedRow1,customer:customer,pom:pom};});}response.status==401&&_this4.props.unauthorisedFunc();case 2:case"end":return _context5.stop();}}},_callee5,_this4);}));return function(_x6){return _ref9.apply(this,arguments);};}());}if(!this.state._id){_context7.next=47;break;}_context7.prev=35;_context7.next=38;return __WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].getPomMaster(this.state._id);case 38:_data=_context7.sent;//console.log(data.text.data.measurements,"setsiz")
if(_data.status===200){//console.log(this.state.row1,"rowsb")
this.setState(function(prevState){return{customer:Object.assign({},prevState.customer,{garmentDetails:[].concat(_toConsumableArray(prevState.customer.garmentDetails||[]),_toConsumableArray(_this4.state.action==="add"?[{sizeTypeDetails:_data.text.data.measurements}]// Add sizeTypeDetails only if action is "add"
:[]// Otherwise, add nothing
))}),row1:prevState.row1.map(function(item){return Object.assign({},item,{// sizeTypeDetails: [...data.text.data.measurements] // ✅ Insert into each row1 object
sizeTypeDetails:_this4.state.masSizeType});}),// masSizeType:[...data.text.data.measurements],
rows:_data.text.data.measurements,rowId:_data.text.data._id};});//console.log(this.state.masSizeType,"massiz")
//console.log(this.state.row1,"mastervaluemas")
// if(this.state.action === "add"){
//   this.setState(prevState=>({
//     customer:{
//       ...prevState.customer,
//       pom:data.text.data.measurements,
//     }
//   }))
//   console.log("add",this.state.customer.pom)
// }
}_context7.next=45;break;case 42:_context7.prev=42;_context7.t1=_context7["catch"](35);console.error("Error fetching data:",_context7.t1);// Handle error, such as showing a message to the user
case 45:_context7.next=49;break;case 47:console.log("No ID provided, skipping API call.");// Handle case where no ID is available (e.g., initialize default state or show a message)
this.setState({rows:[]// Default empty rows
});case 49:_context7.next=51;return __WEBPACK_IMPORTED_MODULE_12__services__["d" /* CustomerServices */].getSystemValuesForCustomer().then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(data){var customer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Promise.all(data.data.customer.OFFICE.map(function(office){officeOption.push({label:office.name,value:office._id});}));case 2:_context6.next=4;return Promise.all(data.data.customer.CITY.map(function(office){cityOption.push({label:office.name,value:office._id});}));case 4:_context6.next=6;return Promise.all(data.data.customer.COUNTRY.map(function(office){countryOption.push({label:office.name,value:office._id});}));case 6:_context6.next=8;return data.data.customer.LIGHTSOURCE;case 8:lightSourceOption=_context6.sent;_context6.next=11;return Promise.all(data.data.customer.APPROVEDTESTINGLAB.map(function(office){approvedTestingLabOption.push({label:office.name,value:office._id});}));case 11:_context6.next=13;return Promise.all(data.data.customer.ATTRIBUTES.map(function(office){attributesOption.push({label:office.name,value:office._id});}));case 13://     GETTING APPROVEDTESTINGLAB OPTIONS END
//STAFF
//     GETTING DESIGNAITON START
// await Promise.all(
//   data.data.customer.DESIGNATION.map(office => {
//     designationOption.push({
//       label: office.name,
//       value: office._id
//     });
//   })
// );
designationOption=[{label:"Asst Buyer",value:"asst buyer"},{label:"Buyer",value:"buyer"},{label:"Fab Tech",value:"fab tech"},{label:"Gmt Techr",value:"gmt tech"}];//     GETTING DESIGNAITON END
//     GETTING REPORTING TO START
_context6.next=16;return Promise.all(data.data.customer.REPORTINGTO.map(function(office){reportingToOption.push({label:office.name,value:office._id});}));case 16:_context6.next=18;return Promise.all(data.data.customer.RANGE.map(function(office){rangeOption.push({label:office.name,value:office._id});}));case 18:_context6.next=20;return Promise.all(data.data.customer.IMAGETYPE.map(function(office){imageTypeOption.push({label:office.name,value:office._id});}));case 20:_context6.next=22;return Promise.all(data.data.customer.TYPEOFGMT.map(function(office){typeOfGmtOption.push({label:office.name,value:office.name});}));case 22:_context6.next=24;return Promise.all(data.data.customer.PACKAGINGMETHOD.map(function(office){packagingMethodOption.push({label:office.name,value:office.name});}));case 24:_context6.next=26;return Promise.all(data.data.customer.PACKINGTYPE.map(function(office){packingTypeOption.push({label:office.name,value:office.name,cost:office.cost});}));case 26:_context6.next=28;return Promise.all(data.data.customer.SUBTYPE.map(function(office){subTypeOption.push({label:office.name,value:office.name});}));case 28:_context6.next=30;return Promise.all(data.data.customer.PACKINGMATERIALS.map(function(office){packagingMaterialsOption.push({name:office.name,id:office._id});}));case 30:if(_this4.props.location.state.action=="add"){customer=Object.assign({},_this4.state.customer);customer.departments=customer.departments.map(function(dept){Object.keys(dept.assignmentOfWork).map(function(keyName){dept.assignmentOfWork[keyName]=Object.assign({},assignmentOfWorkTemplate);});dept.trimPack.map(function(trimpackdata){trimpackdata.trimPackNo="TP-000"+dept.trimPack.length;return trimpackdata;});return dept;});_this4.setState({customer:customer});}//GETTING REPORTING TO END
ArrayData.map(function(status){statusOption.push({label:status.name,value:status.status});});case 32:case"end":return _context6.stop();}}},_callee6,_this4);}));return function(_x7){return _ref10.apply(this,arguments);};}());case 51:this.setState({officeOption:officeOption,//office option
cityOption:cityOption,//city options
statusOption:statusOption,countryOption:countryOption,//country options
lightSourceOption:lightSourceOption,//lightSource
// primaryLightSourceOption, //PRIMARY LIGHT SOURCE OPTION
rangeOption:rangeOption,//range option
// secondaryLightSourceOption, //SECONDARY LIGHT SOURCE OPTION
approvedTestingLabOption:approvedTestingLabOption,//APPROVED TESING LAB OPTIONS
attributesOption:attributesOption,//ATTRIBUTES OPTIONS
designationOption:designationOption,//DESIGNATION OPTION
reportingToOption:reportingToOption,//REPORTING TO OPTION
employeesOption:employeesOption,//employeesOption
imageTypeOption:imageTypeOption,typeOfGmtOption:typeOfGmtOption,packagingMethodOption:packagingMethodOption,packingTypeOption:packingTypeOption,subTypeOption:subTypeOption,packagingMaterialsOption:packagingMaterialsOption,isLoading:false});if(!this.state.customer.pom){this.setState(function(prevState){return{customer:Object.assign({},prevState.customer,{pom:[{garmentType:null,sizeType:[]}]// Only update the pom property
})};});}console.log(this.state.masSizeType,"test");this.setState({originalData:this.state.masSizeType,filteredData:this.state.masSizeType});_context7.next=57;return this.empOptions();case 57:case"end":return _context7.stop();}}},_callee7,this,[[23,30],[35,42]]);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()// componentDidUpdate(prevProps, prevState) {
//   if (prevState.row1 !== this.state.row1) {
//     console.log("Updated row1:", this.state.row1);
//   }
// }
// LIFE CYCLE END
},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}// BASIC ON FORM FIELD CHNAGE
//CHNAGE DYNAMIC DEPARTMENT FIELD GROUP
//CHANGE ALLSIZES DEPARTMENT
//CHANGE DYNAMIC ADDRESS FIELD GROUP
//DYNAIMC ADD COUNt
//DYNAIMC REMOVE COUNt
//assign of procee
// handleMultiChange = (option) => {
//   this.setState(state => {
//     return {
//       multiValue: option
//     };
//   });
// }
//price quote size single
//price quote size multiple
//scroll
// scrollToModule = (id,index) => {
//   let moduleEle = document.getElementById(id)
//   moduleEle.scrollIntoView({ behavior: "smooth", block: "start" });
//   this.setState(prevState => ({
//     toggleState: { [index]: true},
//     tableToggleState: { [index]:true}
//   }))
// }
// Toggle dropdown visibility
// Handle checkbox selection
// handleRowSelect = (garmentId, sizeTypeId, isChecked) => {
//   const { selectedRows } = this.state;
//   // Clone the current state to avoid direct mutation
//   const updatedSelectedRows = { ...selectedRows };
//   // Initialize an array for the garment if it doesn't exist
//   if (!updatedSelectedRows[garmentId]) {
//     updatedSelectedRows[garmentId] = [];
//   }
//   // Add or remove the `sizeTypeId` based on the checkbox state
//   if (isChecked) {
//     if (!updatedSelectedRows[garmentId].includes(sizeTypeId)) {
//       updatedSelectedRows[garmentId].push(sizeTypeId);
//     }
//   } else {
//     updatedSelectedRows[garmentId] = updatedSelectedRows[garmentId].filter(
//       (id) => id !== sizeTypeId
//     );
//   }
//   // Update the state with the new selected rows
//   this.setState({ selectedRows: updatedSelectedRows });
// };
// handleSelectAll = (pomIndex, rows) => {
//   this.setState((prevState) => {
//     const pomList = [...prevState.customer.pom];
//     const currentPom = pomList[pomIndex];
//     const isSelected = currentPom.sizeType.length === rows.length;
//     // Select all or clear all
//     currentPom.sizeType = isSelected ? [] : rows.map((row) => row._id);
//     return { pom: pomList };
//   });
// };
// handleSelectAll = (rowIndex, rows) => {
//   const updatedSelectedRows = [...this.state.selectedRows];
//   // Check if all sizeTypeIds need to be selected
//   const allIds = rows.map(row => row._id); // assuming each row has an _id field
//   // If the current rowIndex doesn't have selected rows, initialize it
//   if (!updatedSelectedRows[rowIndex]) {
//     updatedSelectedRows[rowIndex] = [];
//   }
//   // If checkbox is selected, select all the IDs for this row
//   updatedSelectedRows[rowIndex] = allIds;
//   // Update the state
//   this.setState({ selectedRows: updatedSelectedRows });
// };
// handleToggle = (index) => {
//   this.setState((prevState) => ({
//     toggleState: {
//       ...prevState.toggleState,
//       [index]: !prevState.toggleState[index], // Toggle the current index
//     },
//   }));
// };
// hasPermission1 = (module,subModule, action, platform = "web") => {
//   const { rights } = this.props; // Get rights from props
//   // Check if the module exists in rights
//   if (rights && rights[module] && rights[module][platform]) {
//       return rights[module][subModule][platform][action] || false;
//   }
//   return false; // Default to false if any part is missing
// };
//this.props.rights.customer.masterpom.create
// handleSearchChange = (index, value) => {
//   this.setState((prevState) => ({
//     searchQueries: { ...prevState.searchQueries, [index]: value },
//   }));
// };
// handleSearchClear = (index) => {
//   this.setState((prevState) => ({
//     searchQueries: { ...prevState.searchQueries, [index]: "" },
//   }));
// };
// handleSearchChange = (value, index) => {
//   this.setState(prevState => {
//     const updatedSearchInput = {
//       ...prevState.searchInput,
//       [index]: value
//     };
//     const filteredData = this.getFilteredData(prevState.originalData, updatedSearchInput[index]);
//     return {
//       searchInput: updatedSearchInput,
//       filteredData
//     };
//   });
// };
// clearSearch = (index) => {
//   this.setState(prevState => ({
//     searchInput: {
//       ...prevState.searchInput,
//       [index]: "",
//     }
//   }));
// }
// Function to filter data based on search input
// getFilteredData = (data, searchInput) => {
//   if (!searchInput) return data; // Show all data when search is empty
//   const lowercasedInput = searchInput.toLowerCase();
//   return data.filter(option =>
//     option.code.toLowerCase().includes(lowercasedInput) ||
//     option.placeofMeasurement.toLowerCase().includes(lowercasedInput)
//   );
// };
// getFilteredData = (data, searchInput) => {
//   //console.log('Search Input:', searchInput);
//   if (!searchInput) return data; // Show all data when search is empty
//   const lowercasedInput = searchInput.toLowerCase().trim();
//   //console.log('Lowercased Search Input:', lowercasedInput);
//   const filteredData = data.filter(option => 
//     option.code.toLowerCase().includes(lowercasedInput) ||
//     option.placeofMeasurement.toLowerCase().includes(lowercasedInput)
//   );
//   //console.log('Filtered Data:', filteredData);
//   return filteredData;
// }
},{key:"render",value:function render(){var _this5=this;var _state=this.state,customer=_state.customer,employeesOption=_state.employeesOption,rangeOption=_state.rangeOption,rows=_state.rows,pom=_state.pom,selectedGarmentType=_state.selectedGarmentType,selectedPOM=_state.selectedPOM,selectedOptions1=_state.selectedOptions1,selectAll=_state.selectAll,row1=_state.row1;//console.log(this.state.SHRINKAGETYPEOPTIONS)
//console.log(this.state.row1,"row1")
//console.log(this.state.selectedRows,"selectedRows")
// console.log(this.props,"prop");
// console.log(this.state.action,"curig")
//console.log(this.state.customer,"cus")
var currentPOM=selectedPOM?customer.pom.find(function(pomItem){return pomItem.garmentType===selectedPOM;}):null;//console.log(this.state.row1,"rendeerr")
//console.log(this.getFilteredData(),"meth")
//console.log(this.state.masSizeType,"massiz")
// console.log(this.state.rows,"mrow")
// const hasDepartmentWithPOM = this.hasPermission1("customer", "deptwithpom", this.state.action, "web");
// const hasDepartmentOnly = this.hasPermission1("customer", "deptonly", this.state.action, "web");
// const hasPOMOnly = this.hasPermission1("customer", "pomonly", this.state.action, "web");
// // Determine what to render
// const showComp1 = hasDepartmentWithPOM || hasDepartmentOnly; // Comp1 for Department or Department with POM
// const showComp2 = hasDepartmentWithPOM; // Comp2 only for Department with POM
// const showComp3 = hasDepartmentWithPOM || hasDepartmentOnly || hasPOMOnly; // Comp3 for all cases
// Filter garments to find the one matching the selected type
var selectedGarment=Array.isArray(customer.pom)?customer.pom.find(function(pomItem){return pomItem.garmentType===selectedGarmentType;}):null;//console.log(this.state.action,"action")
//console.log(this.state.customer,"customer")
//console.log(this.state.action,"action")
//console.log(row1,"row1")
var assignModalContent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row modal_override mb-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"text-color-green font-weight-bold pb-3"},"Assignment of process")),customer.departments&&customer.departments[this.state.deptIndex]&&customer.departments[this.state.deptIndex].assignmentOfWork&&Object.keys(customer.departments[this.state.deptIndex].assignmentOfWork).map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Customer_AssignmentOfWork__["a" /* default */],{moduleName:[data],assignmentOfWork:customer.departments[_this5.state.deptIndex].assignmentOfWork[data],action:_this5.state.action,employeesOption:_this5.state.employeesOption,changeAssign:_this5.changeAssign,getAssign:_this5.getAssign,disabled:_this5.state.disabled,searchOption:_this5.state.empOption1});}),this.state.action!=="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.onSave})));var trimPackModal=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row modal_override mb-0 p-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"text-color-green font-weight-bold pb-3"},"Trim Pack")),customer&&customer.departments&&customer.departments[this.state.deptIndex]&&customer.departments[this.state.deptIndex].trimPack&&customer.departments[this.state.deptIndex].trimPack.map(function(data,trimPackIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 br-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12",key:trimPackIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:_this5.state.action!=="view"?"pull-right":"d-none"},!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:trimPackIndex==0?"add":"remove",buttonName:trimPackIndex==0?"add":"remove",onClick:function onClick(){trimPackIndex==0?_this5.addTrimPack(_this5.state.deptIndex):_this5.removeTrimPack(_this5.state.deptIndex,trimPackIndex);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"10%"},"TRIM PACK No. ",trimPackIndex+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"15%"},"TYPE OF GMT"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"15%"},"PACKAGING METHOD"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"15%"},"PACKAGING TYPE"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"15%"},"SUB TYPE"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"20%"},"PACKAGING MATERIALS",!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{style:{display:"inlineBlock"},className:"btn-floating btn-small waves-effect waves-light green float-btn ",onClick:function onClick(e){return _this5.addPackagingMaterial(trimPackIndex);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons"},"add")),!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_picky___default.a,{value:_this5.state.arrayOfPackagingMaterial&&_this5.state.arrayOfPackagingMaterial[_this5.state.deptIndex]&&_this5.state.arrayOfPackagingMaterial[_this5.state.deptIndex][trimPackIndex]||[],options:_this5.state.packagingMaterialsOption,onChange:function onChange(e){return _this5.selectMultipleOption(e,trimPackIndex);},open:false,valueKey:"id",labelKey:"name",multiple:true,includeSelectAll:true,includeFilter:true,dropdownHeight:600,id:"trimPackPick"+trimPackIndex})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-left",width:"10%"},"COST"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left",style:{display:"flex",alignItems:"center",justifyContent:"space-evenly"}},data.trimPackNo,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,className:"pl-1",inputType:"radio",inputName:"default",value:"default"+trimPackIndex,checked:data.default,index:trimPackIndex,onChange:function onChange(name,value){return _this5._handleInputChangeTrimPack("default",value,trimPackIndex);},disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"typeOfGmt",value:data.typeOfGmt,index:trimPackIndex,options:_this5.state.typeOfGmtOption,onChange:_this5._handleInputChangeTrimPack,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"packagingMethod",value:data.packagingMethod,index:trimPackIndex,options:_this5.state.packagingMethodOption,onChange:_this5._handleInputChangeTrimPack,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"packingType",value:data.packingType,index:trimPackIndex,options:_this5.state.packingTypeOption,onChange:_this5._handleInputChangeTrimPack,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"subType",value:data.subType,index:trimPackIndex,options:customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].typeOfGmt!==undefined&&customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].packagingMethod==="BOXED"&&customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].packingType==="BDCM"?[_this5.state.subTypeOption[0],_this5.state.subTypeOption[1]]:customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].typeOfGmt!==undefined&&customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].packagingMethod==="BOXED"&&customer.departments[_this5.state.deptIndex].trimPack[trimPackIndex].packingType==="REFURB"?[_this5.state.subTypeOption[2],_this5.state.subTypeOption[3],_this5.state.subTypeOption[4]]:_this5.state.subTypeOption,onChange:_this5._handleInputChangeTrimPack,disabled:_this5.state.disabled})),data.trimPackForm!==undefined&&data.trimPackForm!==null&&Object.keys(data.trimPackForm).length>0&&Object.keys(data.trimPackForm).map(function(trimpackLabel,packIndex){if(packIndex==0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,trimpackLabel),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"form-control",type:"number",name:trimpackLabel,value:data.trimPackForm[trimpackLabel]!==null?data.trimPackForm[trimpackLabel]:"",disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.state.action!=="view"&&_this5.handleChangePackaging(e.target.name,e.target.value,trimPackIndex);},onBlur:function onBlur(e){return _this5.updateCalcPackaging(trimPackIndex);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this5.removeTrimPackForm(trimpackLabel,trimPackIndex);}})));}})),data.trimPackForm!==undefined&&data.trimPackForm!==null&&Object.keys(data.trimPackForm).length>0&&Object.keys(data.trimPackForm).map(function(trimpackLabel,packIndex){if(packIndex!=0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:packIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"5"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,trimpackLabel),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"form-control",type:"number",name:trimpackLabel,value:data.trimPackForm[trimpackLabel]!==null?data.trimPackForm[trimpackLabel]:"",disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.state.action!=="view"&&_this5.handleChangePackaging(e.target.name,e.target.value,trimPackIndex);},onBlur:function onBlur(e){return _this5.updateCalcPackaging(trimPackIndex);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this5.removeTrimPackForm(trimpackLabel,trimPackIndex);}})));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"5"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"TOTAL TRIM PACK COST: ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},data.totalAmount)))))));}),this.state.action!=="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.onSave})));//pomList
var pomList=[];// customer.pom.map((data, index) => {
//   pomList.push({
//     name: this.getGarmentTypeLabel(data.garmentType) || "",
//     key: index
//   })
// })
// Check if customer and customer.pom exist and are arrays
this.state.row1.map(function(data,index){pomList.push({name:_this5.getGarmentTypeLabel(data.garmentType)||"",key:index});});//departmentList
var departmentList=[];customer.departments.map(function(data,index){departmentList.push({name:data.departmentName,key:index});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container-fluid"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row m-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"customer-wrap",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:this.handleBackNavigation},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_22__assets_images_left_arrow_png___default.a,alt:"Back"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,"Customer")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 mb-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{action:"","class":"form-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"customerName",label:"Customer Name",inputType:"text",inputSizeClass:"col-md-3",value:customer.customerName,onChange:this.onInputValChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"customerCode",label:"Customer Code",inputType:"text",inputSizeClass:"col-md-3",value:customer.customerCode,onChange:this.onInputValChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"customerStatus",label:"Customer Status",inputType:"checkboxToggle",inputSizeClass:"col-md-3",value:customer.customerStatus,onChange:this.onInputValChange,readOnly:this.state.disabled})),(this.hasPermission1("customer","withoutpoms",this.state.action,"web")||this.hasPermission1("customer","masterpom",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"fw-600 mb-3 text-left"},"Addresses"),customer.sites.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row p-r br-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"officeName",label:"Office Name",index:i,inputType:"select",inputSizeClass:"col-md-3",options:_this5.state.officeOption,value:customer.sites[i].officeName,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"city",label:"City",index:i,inputType:"select",inputSizeClass:"col-md-3",options:_this5.state.cityOption,value:customer.sites[i].city,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"registeredAddress1",label:"Registered Address 1",inputType:"text",index:i,inputSizeClass:"col-md-6",value:customer.sites[i].registeredAddress1,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"country",label:"Country",inputType:"select",index:i,inputSizeClass:"col-md-3",options:_this5.state.countryOption,value:customer.sites[i].country,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"registeredAddress2",label:"Registered Address 2",inputType:"text",index:i,inputSizeClass:"col-md-6",value:customer.sites[i].registeredAddress2,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"zipCode",label:"ZIPCODE",inputType:"text",index:i,inputSizeClass:"col-md-3",value:customer.sites[i].zipCode,onChange:_this5.addressDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"Field-toggle-wrapper"},!_this5.state.disabled&&i===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:function onClick(e){return _this5.dynamicAddCount(e,"addresses");}}),!_this5.state.disabled&&i!==0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(e){return _this5.dynamicRemoveCount(e,"addresses",i);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"fw-600 mb-3"},"Miscellaneous"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row br-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"fixedCharge",label:"Fixed Charges",inputType:"number",inputSizeClass:"col-md-3",value:customer.fabricBasicRequirements.fixedCharge,onChange:this.fabricDynamicChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"approvedTestingLab",label:"Approved Testing Lab",inputType:"select",inputSizeClass:"col-md-3",options:this.state.approvedTestingLabOption,value:customer.fabricBasicRequirements.approvedTestingLab,onChange:this.fabricDynamicChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"primaryLightSource",label:"Primary Light Source",inputType:"select",inputSizeClass:"col-md-3",options:this.state.lightSourceOption,value:customer.fabricBasicRequirements.primaryLightSource,onChange:this.fabricDynamicChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"attribute",label:"Attribute",inputType:"select",inputSizeClass:"col-md-3",options:this.state.attributesOption,value:customer.fabricBasicRequirements.attribute,onChange:this.fabricDynamicChange,readOnly:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"secondaryLightSource",label:"Secondary Light Source",inputType:"select",inputSizeClass:"col-md-3",options:this.state.lightSourceOption,value:customer.fabricBasicRequirements.secondaryLightSource,onChange:this.fabricDynamicChange,readOnly:this.state.disabled}))),(this.hasPermission1("customer","garmentpom",this.state.action,"web")||this.hasPermission1("customer","withoutpoms",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"fw-600 mb-3"},"Master POM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row br-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container scrolle",style:{maxHeight:"500px",overflowY:"auto",overflowX:"hidden"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row mb-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-2  pl-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Code")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-7  pl-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Description")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-1"},rows.length===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:" mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"btn green",style:{borderRadius:"50%",color:"white",width:"27px",height:"27px",padding:"0px"},onClick:this.addRow,disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"13px",fontWeight:"bold"}},"add")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-1"})),rows.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row mb-2",key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-2",style:{paddingLeft:"0px",paddingRight:"25px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"w-100-f-12",type:"text",name:"code",value:row.code,onChange:function onChange(e){var trimmedValue=_this5.preventLeadingSpaces(e.target.value);_this5.handleRowChange("code",trimmedValue,index);},readOnly:_this5.state.disabled,maxLength:10})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-7",style:{paddingLeft:"0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{ref:function ref(el){if(el){el.style.height="auto";// Reset height first
if(el.scrollHeight>el.clientHeight){el.style.height=el.scrollHeight+"px";// Expand only if needed
}}},name:"placeofMeasurement",className:"w-100-f-12",value:row.placeofMeasurement,onChange:function onChange(e){_this5.handleRowChange("placeofMeasurement",e.target.value,index);// Auto-expand only when needed
e.target.style.height="auto";if(e.target.scrollHeight>e.target.clientHeight){e.target.style.height=e.target.scrollHeight+"px";}},onBlur:function onBlur(e){var trimmedValue=_this5.preventLeadingSpaces(e.target.value);var pascalCaseValue=trimmedValue.toLowerCase().replace(/\s+/g," ").split(" ").map(function(word){return word.charAt(0).toUpperCase()+word.slice(1);}).join(" ");_this5.handleRowChange("placeofMeasurement",pascalCaseValue,index);},readOnly:_this5.state.disabled,maxLength:150,rows:"1",style:{overflow:"hidden",resize:"none"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-1 text-center flex-jcenter-acenter"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn",style:{backgroundColor:"#F443361A",color:"#F44336",borderRadius:"50%",width:"25px",height:"25px",padding:"0px",margin:"0px"},type:"button",onClick:function onClick(){return _this5.deleteRow(index);},disabled:_this5.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"13px",fontWeight:"bold"}},"clear"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-1 text-center flex-jcenter-acenter",style:{justifyContent:"start",padding:"0px",marginLeft:"-17px"}},index===rows.length-1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"btn green",style:{borderRadius:"50%",color:"white",width:"27px",height:"27px",padding:"0px",marginRight:"16px"},onClick:_this5.addRow,disabled:_this5.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"13px",fontWeight:"bold"}},"add"))));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"save",buttonType:"save",onClick:this.onPomSave,disabled:this.state.disabled||this.state._id===""})))),(this.hasPermission1("customer","garmentpom",this.state.action,"web")||this.hasPermission1("customer","withoutpoms",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"fw-600 py-3"}," Garment POM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0 mb-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"upload-container br-col p-r"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"list-inline mb-0 mt-2 ml-2"},pomList.map(function(data,co){return data.name!=""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"card card-design"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"primary-text",href:"javascript:;",onClick:function onClick(){return _this5.scrollToModule("pom"+co,co);}},data.name)));})))),row1.map(function(data,i){var isToggled=_this5.state.toggleState[i]||false;var isTableToggled=_this5.state.tableToggleState[i]||false;var filteredRows=_this5.getFilteredData(data.sizeTypeDetails,_this5.state.searchInput[i]);// const searchQuery = this.state.searchQueries && this.state.searchQueries[i] || ""; // Track search query for each row
// const filteredData = data.sizeTypeDetails
//   ? data.sizeTypeDetails.filter(
//       (option) =>
//         option.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         option.placeofMeasurement.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   : [];
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0 mb-5",id:"pom"+i,key:"pom"+i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"upload-container br-col p-r p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"inline-center nopadding"},isToggled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{onClick:function onClick(){return _this5.handleToggle(i);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-up font-icon"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{onClick:function onClick(){return _this5.handleToggle(i);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-down font-icon"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row p-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"garmentType",label:"Garment Type",inputType:"select",options:_this5.state.GARMENTTYPEOPTIONS,inputSizeClass:"col-md-3",value:data.garmentType||"",onChange:function onChange(field,value){return _this5.handlePomChange("garmentType",value,i);},readOnly:_this5.state.disabled}),isToggled&&data.garmentType&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row align-items-center",style:{marginLeft:"68px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"fw-600 py-3 "},_this5.getGarmentTypeLabel(data.garmentType)+" POM"||""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:i,className:"toggle-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"toggle-box",onClick:function onClick(){return _this5.tableToggle(i);},style:{display:"flex",justifyContent:"space-between",// Spread items
alignItems:"center",border:"1px solid #ddd",padding:"10px",cursor:"pointer",marginBottom:"21px",width:"1100px",backgroundColor:"#f9f9f9"// Light background for clarity
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{flex:1,position:"relative",marginRight:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",placeholder:"Search Code or Measurement",value:_this5.state.searchInput&&_this5.state.searchInput[i]||"",onChange:function onChange(e){return _this5.handleSearchChange(e.target.value,i);},onClick:function onClick(e){return e.stopPropagation();}// Prevents toggle when clicking input
,style:{width:"100%",paddingRight:"30px",padding:"5px 10px",borderRadius:"4px",border:"1px solid #ccc"}}),_this5.state.searchInput[i]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-times",onClick:function onClick(e){e.stopPropagation();// Prevents accidental toggle when clearing
_this5.clearSearch(i);},style:{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",cursor:"pointer",color:"#777"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(isTableToggled?"fa-angle-up":"fa-angle-down"),style:{fontSize:"16px",marginLeft:"10px"}})),(data.garmentType||isTableToggled)&&isTableToggled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"scrolle",style:{minHeight:"100px",maxHeight:"272px",overflow:"auto",border:"1px solid #dddddd",borderRadius:"14px",padding:"4px"}},data.sizeTypeDetails&&data.sizeTypeDetails.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"border-0",style:{marginBottom:"40px",width:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",style:{position:"static",left:"auto",opacity:1,display:"inline-block"}// checked={this.state.action !== "add" &&
//   data.sizeTypeDetails.length === rows.length}
// onChange={() => this.handleSelectAll(i, data.sizeTypeDetails)}
// disabled={this.state.disabled}
,onChange:function onChange(){return _this5.handleSelectAll(i,data.sizeTypeDetails);},disabled:_this5.state.disabled// checked={(this.state.selectedRows[i] || []).length === data.sizeTypeDetails.length}
,checked:data.sizeTypeDetails.length>0&&// Ensure there are rows to select
(_this5.state.selectedRows[i]||[]).length===data.sizeTypeDetails.length&&data.sizeTypeDetails.length!==0// Ensure both aren't 0
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{padding:"10px"}},"Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{padding:"10px",textAlign:"left"}},"Place of Measurement"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,filteredRows.map(function(option,index){//console.log(data.sizeTypeDetails,"sizetypede")
//console.log(option,"opt");
//console.log(option.code,"co")
//console.log(option.placeofMeasurement,"pac")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",left:"auto",opacity:1,display:"inline-block"},type:"checkbox"// checked={(this.state.selectedRows[data._id] || []).includes(option._id)}
// onChange={(e) => this.handleRowSelect(
//   data._id, 
//   option._id, 
//   e.target.checked
// )}
,checked:(_this5.state.selectedRows[i]||[]).includes(option._id)// ✅ Use index instead of garmentId
,onChange:function onChange(e){return _this5.handleRowSelect(i,option._id,e.target.checked);}// ✅ Pass index
,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{fontSize:"12px"}},option.code),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"left",fontSize:"12px"}},option.placeofMeasurement));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"loading...")),(data.sizeTypeDetails&&data.sizeTypeDetails.length>0||data.length>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"second-table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{style:{marginBottom:"20px",marginTop:"15px"}},"Selected ",_this5.getGarmentTypeLabel(data.garmentType)," POM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"scrolle",style:{minHeight:"100px",maxHeight:"272px",overflow:"auto",border:"1px solid #dddddd",borderRadius:"14px",padding:"4px"}},data.sizeTypeDetails&&data.sizeTypeDetails.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"border-0",style:{width:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",style:{visibility:"hidden",position:"static",left:"auto",display:"inline-block"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{padding:"10px"}},"Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{padding:"10px",textAlign:"left"}},"Place of Measurement"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,data.sizeTypeDetails.filter(function(option){return(_this5.state.selectedRows[i]||[]).includes(option._id);}).map(function(option){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:option._id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",style:{visibility:"hidden",position:"static",left:"auto",display:"inline-block"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{fontSize:"12px"}},option.code),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"left",fontSize:"12px"}},option.placeofMeasurement));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"loading...")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center-mtb-15"}," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary",onClick:function onClick(e){return _this5.seperateGarmentPomSave(e,i);}},"save")))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"Field-toggle-wrapper"},!_this5.state.disabled&&i===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:function onClick(e){return _this5.dynamicAddCount(e,"pom");}}),!_this5.state.disabled&&i!==0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(){return _this5.garmentPomDelete1(i);}}))));})),(this.hasPermission1("customer","withoutpoms",this.state.action,"web")||this.hasPermission1("customer","masterpom",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"fw-600 py-3"},"Fabric spec"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding mb-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",getRefImages:this.getRefImages,moduleName:"customer",disabled:this.state.disabled,uploadedDocs:customer.refImages.length>0?customer.refImages:null,imageTypeOption:this.state.imageTypeOption})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"fw-600 py-3"}," Departments"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0 mb-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"upload-container br-col p-r"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"list-inline mb-0 mt-2 ml-2"},departmentList.map(function(data,co){return data.name!=""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"card card-design"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"primary-text",href:"javascript:;",onClick:function onClick(){return _this5.scrollToModule("dept"+co);}},data.name)));}))))),(this.hasPermission1("customer","withoutpoms",this.state.action,"web")||this.hasPermission1("customer","masterpom",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,customer.departments.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0 mb-5",id:"dept"+i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"upload-container br-col p-r p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"inline-center nopadding"},data.toggle?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{onClick:function onClick(){return _this5.changeToggleList(i);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-up font-icon "})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{onClick:function onClick(){return _this5.changeToggleList(i);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-down font-icon "}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row p-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"departmentName",label:"Name of the Dept",inputType:"text",options:[],index:i,inputSizeClass:"col-md-3",value:data.departmentName,onChange:_this5.departmentDynamicChange,readOnly:_this5.state.disabled}),!data.toggle&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Controller")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"controller"// value={data.controller}
,value:_this5.state.empOption1&&_this5.state.empOption1.find(function(option){return option.value===data.controller;})||null,onFocus:function onFocus(){return _this5.getAssign("");},onInputChange:_this5.getAssign,onChange:function onChange(val){return _this5.updateAsyncValues(val,"controller",i);},placeholder:"Find Controller",options:employeesOption,disabled:_this5.state.disabled,isClearable:true,clearValue:_this5.clearValue}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"All sizes")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-9 dis-flex","flex-wrap"].join(" ")},data.allSizes.map(function(size,allsizeInd){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"dis-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",style:{width:"50px"},value:size.size,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.allSizesDynamicChange("size",e.target.value,i,allsizeInd);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{style:{width:"70px"},className:"form-control ml-1",value:size.period,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.allSizesDynamicChange("period",e.target.value,i,allsizeInd);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"year"},"year"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"month"},"month")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"ml-1"},!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:allsizeInd==0?"add":"remove",addRemoveFunc:function addRemoveFunc(){allsizeInd==0?_this5.addAllSizes(i):_this5.removeAllSizes(i,allsizeInd);}})));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_Field__["a" /* default */],{inputname:"priceQuoteMethod",label:"Price Quote Method",inputType:"select",inputSizeClass:"col-md-3",index:i,options:[{label:"MULTIPLE",value:"MULTIPLE"},{label:"SINGLE",value:"SINGLE"}],value:data.priceQuoteMethod,onChange:_this5.departmentDynamicChange,readOnly:_this5.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Senior Merchandiser")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"seniorMerchandiser"// value={data.seniorMerchandiser}
,value:_this5.state.empOption1&&_this5.state.empOption1.find(function(option){return option.value===data.seniorMerchandiser;})||null,onFocus:function onFocus(){return _this5.getAssign("");},onInputChange:_this5.getAssign,onChange:function onChange(val){return _this5.updateAsyncValues(val,"seniorMerchandiser",i);},placeholder:"Find SeniorMerchandiser",options:employeesOption,disabled:_this5.state.disabled,isClearable:true,clearValue:_this5.clearValue}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Range")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-6"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_picky___default.a,{value:data.range,options:rangeOption,onChange:function onChange(val){return _this5.departmentDynamicChange("range",val,i);},open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,includeFilter:true,dropdownHeight:300,disabled:_this5.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Merchandiser")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"merchandiser"// value={data.merchandiser}
,value:_this5.state.empOption1&&_this5.state.empOption1.find(function(option){return option.value===data.merchandiser;})||null,onFocus:function onFocus(){return _this5.getAssign("");},onInputChange:_this5.getAssign,onChange:function onChange(val){return _this5.updateAsyncValues(val,"merchandiser",i);},placeholder:"Find Merchandiser",options:employeesOption,disabled:_this5.state.disabled,isClearable:true,clearValue:_this5.clearValue}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Trim Pack")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"p-0 col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{"class":"primary-small",type:"button",onClick:function onClick(e){_this5.setState({deptIndex:i},function(){return _this5.setState({openModal:true,modalType:"trimpack"});});}},"Trim pack")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Junior Merchandiser")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"juniorMerchandiser"// value={data.juniorMerchandiser}
,value:_this5.state.empOption1&&_this5.state.empOption1.find(function(option){return option.value===data.juniorMerchandiser;})||null,onFocus:function onFocus(){return _this5.getAssign("");},onInputChange:_this5.getAssign,onChange:function onChange(val){return _this5.updateAsyncValues(val,"juniorMerchandiser",i);},placeholder:"Find Junior Merchandiser",options:employeesOption,disabled:_this5.state.disabled,isClearable:true,clearValue:_this5.clearValue}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Assignment Of Process")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"p-0 col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{"class":"primary-small",type:"button",onClick:function onClick(e){_this5.setState({deptIndex:i},function(){return _this5.setState({openModal:true,modalType:"assign"});});}},"Assigment of process")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Magnum Garment Technologist")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"garmentTechnologist"// value={data.garmentTechnologist}
,value:_this5.state.empOption1&&_this5.state.empOption1.find(function(option){return option.value===data.garmentTechnologist;})||null,onInputChange:_this5.getAssign,onChange:function onChange(val){return _this5.updateAsyncValues(val,"garmentTechnologist",i);},placeholder:"Find Magnum Garment Technologist",options:employeesOption,disabled:_this5.state.disabled,isClearable:true,clearValue:_this5.clearValue}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Price Quote Size")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},data.priceQuoteMethod=="MULTIPLE"&&data.priceQuotesizeMultiple.map(function(priceSize,priceInd){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"dis-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",style:{width:"50px"},value:priceSize.start,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.priceQuoteSizeMultiDynamicChange("start",e.target.value,i,priceInd);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"px-1"}," ","-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",style:{width:"50px"},value:priceSize.end,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.priceQuoteSizeMultiDynamicChange("end",e.target.value,i,priceInd);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ml-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{style:{width:"70px"},className:"form-control",value:priceSize.period,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.priceQuoteSizeMultiDynamicChange("period",e.target.value,i,priceInd);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"year"},"year"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"month"},"month"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ml-2"},!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:priceInd==0?"add":"remove",addRemoveFunc:function addRemoveFunc(){priceInd==0?_this5.addPriceQuoteSizeMulti(i):_this5.removePriceQuoteSizeMulti(i,priceInd);}})));}),data.priceQuoteMethod=="SINGLE"&&data.priceQuotesizeSingle.map(function(priceSize,priceInd){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"dis-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",style:{width:"50px"},value:priceSize.size,disabled:_this5.state.disabled,onChange:function onChange(e){return _this5.updatePriceQuoteSizeSingle("size",e.target.value,i,priceInd);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ml-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{style:{width:"70px"},className:"form-control",disabled:_this5.state.disabled,value:priceSize.period,onChange:function onChange(e){return _this5.updatePriceQuoteSizeSingle("period",e.target.value,i,priceInd);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"year"},"year"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"month"},"month"))));}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":""},"Status")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":["p-0","col-md-3"].join(" ")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"deptstatus"+i,value:data.status,className:"",onChange:function onChange(name,value){return _this5.departmentDynamicChange("status",value,i);},disabled:_this5.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"upload-container br-col mt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"fw-600 my-3 text-center"}," ","Staff"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0 mb-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"staff-table text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"First Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Last Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Designation"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Email Id"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Reporting to"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Office"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Employee status"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),data.staff.map(function(s,count){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("firstName",e.target.value,count,i);},value:s.firstName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("lastName",e.target.value,count,i);},value:s.lastName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{name:"",id:"",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("designation",e.target.value,count,i);},value:s.designation},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--select--"),_this5.state.designationOption.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("email",e.target.value,count,i);},value:s.email})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("reportingTo",e.target.value,count,i);},value:s.reportingTo})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{name:"office",id:"office",className:"form-control",readOnly:_this5.state.disabled,onChange:function onChange(e){return _this5.staffDynamicChange("office",e.target.value,count,i);},value:s.office},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--select--"),_this5.state.officeOption.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"employeestatus"+i+count,value:s.status,className:"form-control_2 text-center d-flex flex-column align-items-center mt-0 pt-0",onChange:function onChange(name,value){return _this5.staffDynamicChange("status",value,count,i);},disabled:_this5.state.disabled})),!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"d-flex justify-content-center"},count===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:function onClick(e){return _this5.dynamicAddCount(e,"staff",i,count);}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(e){return _this5.dynamicRemoveCount(e,"staff",i,count);}})));})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"Field-toggle-wrapper"},!_this5.state.disabled&&i===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:function onClick(e){return _this5.dynamicAddCount(e,"department");}}),!_this5.state.disabled&&i!==0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(e){return _this5.dynamicRemoveCount(e,"department",i);}}))));})),(this.hasPermission1("customer","withoutpoms",this.state.action,"web")||this.hasPermission1("customer","masterpom",this.state.action,"web"))&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"save",buttonType:"save",onClick:this.onSave}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"cancel",buttonType:"cancel",history:this.props.history})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this5.setState({openModal:false});}},this.state.modalType=="assign"?assignModalContent:this.state.modalType=="trimpack"?trimPackModal:null));}}]);return Customer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{toggle:state.Header.toggle,// Getting 'toggle' from 'Header' slice of state
rights:state.main.rights// Getting 'rights' from 'main' slice of state
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(Customer)));

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Field=function(_Component){_inherits(Field,_Component);function Field(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Field);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Field.__proto__||Object.getPrototypeOf(Field)).call.apply(_ref,[this].concat(args))),_this),_this.state={inputname:"",label:"",inputType:"",inputSizeClass:"",options:[],value:"",index:"",readOnly:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Field,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,inputname=_props.inputname,label=_props.label,inputType=_props.inputType,inputSizeClass=_props.inputSizeClass,options=_props.options,onChange=_props.onChange,value=_props.value,index=_props.index,readOnly=_props.readOnly;this.setState({inputname:inputname,label:label,inputType:inputType,inputSizeClass:inputSizeClass,options:options,onChange:onChange,value:value,index:index,readOnly:readOnly});}},{key:"render",value:function render(){var _props2=this.props,inputname=_props2.inputname,label=_props2.label,inputType=_props2.inputType,inputSizeClass=_props2.inputSizeClass,options=_props2.options,_onChange=_props2.onChange,value=_props2.value,index=_props2.index,readOnly=_props2.readOnly;var inputField=undefined;switch(inputType){case'text':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputname,className:"form-control",value:value,disabled:readOnly,onChange:function onChange(e){return _onChange(inputname,e.target.value,index);}});break;case'number':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputname,className:"form-control",value:value,disabled:readOnly,onChange:function onChange(e){return _onChange(inputname,e.target.value,index);},onKeyDown:function onKeyDown(evt){return evt.key==='e'&&evt.preventDefault();}});break;case'select':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"",id:"",onChange:function onChange(e){return _onChange(inputname,e.target.value,index);},disabled:readOnly,value:value,className:"form-control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"select"),options.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:data.value},data.label);}));break;case'readonly':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputname,disabled:"disabled",className:"form-control"});break;case'file':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary upload-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:inputType,name:inputname,onChange:function onChange(e){return _onChange(e);},multiple:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,value));break;case'button':inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,value));break;case"checkboxToggle":inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"switch switch-mod"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox","class":"",name:inputname,value:value,checked:value,disabled:readOnly,onChange:function onChange(e){return _onChange(inputname,e.target.checked,index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"lever"})),value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pr-2 font-apply-li"},"Active"),!value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"pl-2 font-apply-li"},"In-active"));break;default:inputField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"name",className:"form-control"});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row align-items-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-auto label-standard-w"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":["p-0",inputSizeClass].join(" ")},inputField)));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,prevState){return Object.assign({},prevState,nextProps);}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _Label = __webpack_require__(471);

var _Label2 = _interopRequireDefault(_Label);

var _Input = __webpack_require__(477);

var _Input2 = _interopRequireDefault(_Input);

var _Icon = __webpack_require__(478);

var _Icon2 = _interopRequireDefault(_Icon);

var _Container = __webpack_require__(479);

var _Container2 = _interopRequireDefault(_Container);

var _CalendarContainer = __webpack_require__(480);

var _CalendarContainer2 = _interopRequireDefault(_CalendarContainer);

var _CalendarHeading = __webpack_require__(481);

var _CalendarHeading2 = _interopRequireDefault(_CalendarHeading);

var _SingleArrow = __webpack_require__(482);

var _SingleArrow2 = _interopRequireDefault(_SingleArrow);

var _DoubleArrow = __webpack_require__(483);

var _DoubleArrow2 = _interopRequireDefault(_DoubleArrow);

var _DateEditor = __webpack_require__(484);

var _DateEditor2 = _interopRequireDefault(_DateEditor);

var _CalendarBody = __webpack_require__(485);

var _CalendarBody2 = _interopRequireDefault(_CalendarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModernDatepicker = function (_Component) {
  _inherits(ModernDatepicker, _Component);

  function ModernDatepicker(props) {
    _classCallCheck(this, ModernDatepicker);

    var _this = _possibleConstructorReturn(this, (ModernDatepicker.__proto__ || Object.getPrototypeOf(ModernDatepicker)).call(this, props));

    _this.state = {
      showContainer: false,
      setViewFor: 'date',
      yearBlock: (0, _moment2.default)().get('year') - 8,
      dateToEdit: props.date ? (0, _moment2.default)(props.date, props.format || 'DD-MM-YYYY').format(props.format || 'DD-MM-YYYY') : '',
      isValid: props.date ? (0, _moment2.default)(props.date, props.format || 'DD-MM-YYYY').isValid() : true,
      isMaxValid: props.maxDate ? (0, _moment2.default)(props.maxDate, props.format || 'DD-MM-YYYY').isValid() : true,
      isMinValid: props.minDate ? (0, _moment2.default)(props.minDate, props.format || 'DD-MM-YYYY').isValid() : true
    };
    _this.handleDateChange = _this.handleDateChange.bind(_this);

    return _this;
  }

  _createClass(ModernDatepicker, [{
    key: 'handleDateChange',
    value: function handleDateChange(value, unit) {
      var _props = this.props,
          format = _props.format,
          onChange = _props.onChange,
          maxDate = _props.maxDate,
          minDate = _props.minDate;
      var yearBlock = this.state.yearBlock;

      var defaultDate = (0, _moment2.default)(this.state.dateToEdit || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days').format(format || 'DD-MM-YYYY') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days').format(format || 'DD-MM-YYYY') : (0, _moment2.default)().format(format || 'DD-MM-YYYY');
      var date = (0, _moment2.default)(this.state.dateToEdit || defaultDate, format || 'DD-MM-YYYY').set(unit, value);
      var year = date.get('year');
      var newYearBlock = this.getNewYearBlock(yearBlock, year);
      var dateToEdit = date.format(format || 'DD-MM-YYYY');
      this.setState({
        dateToEdit: dateToEdit,
        yearBlock: newYearBlock
      });
      onChange(dateToEdit);
      if (unit === 'date') {
        this.toggleCalendar(false);
      }
    }
  }, {
    key: 'addDate',
    value: function addDate(value, unit) {
      var _props2 = this.props,
          format = _props2.format,
          onChange = _props2.onChange,
          maxDate = _props2.maxDate,
          minDate = _props2.minDate;
      var _state = this.state,
          yearBlock = _state.yearBlock,
          dateToEdit = _state.dateToEdit;

      var firstDateToBeSet = false,
          lastDateToBeSet = false;
      var defaultDate = (0, _moment2.default)(this.state.dateToEdit || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days').format(format || 'DD-MM-YYYY') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days').format(format || 'DD-MM-YYYY') : (0, _moment2.default)().format(format || 'DD-MM-YYYY');
      var date = (0, _moment2.default)(dateToEdit || defaultDate, format || 'DD-MM-YYYY').add(value, unit);
      var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
      var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
      if (maxDate && date.isAfter(endDate) || minDate && date.isBefore(startDate)) {
        if (maxDate && date.isAfter(endDate) && maxDate.get('year') === date.get('year') && maxDate.get('month') === date.get('month')) {
          firstDateToBeSet = true;
        } else if (minDate && date.isBefore(startDate) && minDate.get('year') === date.get('year') && minDate.get('month') === date.get('month')) {
          lastDateToBeSet = true;
        } else {
          return;
        }
      }
      var year = date.get('year');
      var newYearBlock = this.getNewYearBlock(yearBlock, year);
      var newDateToEdit = date.format(format || 'DD-MM-YYYY');
      if (firstDateToBeSet) {
        newDateToEdit = date.startOf('month').format(format || 'DD-MM-YYYY');
      } else if (lastDateToBeSet) {
        newDateToEdit = date.endOf('month').format(format || 'DD-MM-YYYY');
      } else {
        newDateToEdit = date.format(format || 'DD-MM-YYYY');
      }
      this.setState({
        dateToEdit: newDateToEdit,
        yearBlock: newYearBlock
      });
      onChange(newDateToEdit);
    }
  }, {
    key: 'subDate',
    value: function subDate(value, unit) {
      var _props3 = this.props,
          format = _props3.format,
          onChange = _props3.onChange,
          maxDate = _props3.maxDate,
          minDate = _props3.minDate;
      var _state2 = this.state,
          yearBlock = _state2.yearBlock,
          dateToEdit = _state2.dateToEdit;

      var firstDateToBeSet = false,
          lastDateToBeSet = false;
      var defaultDate = (0, _moment2.default)(this.state.dateToEdit || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(this.state.dateToEdit) ? (0, _moment2.default)().format(format || 'DD-MM-YYYY') : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days').format(format || 'DD-MM-YYYY') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days').format(format || 'DD-MM-YYYY') : (0, _moment2.default)().format(format || 'DD-MM-YYYY');
      var date = (0, _moment2.default)(dateToEdit || defaultDate, format || 'DD-MM-YYYY').subtract(value, unit);
      var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
      var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
      if (maxDate && date.isAfter(endDate) || minDate && date.isBefore(startDate)) {
        if (maxDate && date.isAfter(endDate) && maxDate.get('year') === date.get('year') && maxDate.get('month') === date.get('month')) {
          firstDateToBeSet = true;
        } else if (minDate && date.isBefore(startDate) && minDate.get('year') === date.get('year') && minDate.get('month') === date.get('month')) {
          lastDateToBeSet = true;
        } else {
          return;
        }
      }
      var year = date.get('year');
      var newYearBlock = this.getNewYearBlock(yearBlock, year);
      var newDateToEdit = date.format(format || 'DD-MM-YYYY');
      if (firstDateToBeSet) {
        newDateToEdit = date.startOf('month').format(format || 'DD-MM-YYYY');
      } else if (lastDateToBeSet) {
        newDateToEdit = date.endOf('month').format(format || 'DD-MM-YYYY');
      } else {
        newDateToEdit = date.format(format || 'DD-MM-YYYY');
      }
      this.setState({
        dateToEdit: newDateToEdit,
        yearBlock: newYearBlock
      });
      onChange(newDateToEdit);
    }
  }, {
    key: 'getNewYearBlock',
    value: function getNewYearBlock(yearBlock, value) {
      var newYearBlock = void 0;
      var year = value;
      if (year < yearBlock) {
        newYearBlock = year - 15;
      } else if (year > yearBlock + 15) {
        newYearBlock = year;
      } else {
        newYearBlock = yearBlock;
      }
      return newYearBlock;
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var _this2 = this;

      var currentTarget = e.currentTarget;
      setTimeout(function () {
        if (!currentTarget.contains(document.activeElement)) {
          _this2.toggleCalendar(false);
        }
      }, 0);
    }
  }, {
    key: 'toggleCalendar',
    value: function toggleCalendar(bool, e) {
      var _props4 = this.props,
          date = _props4.date,
          format = _props4.format,
          onFocus = _props4.onFocus,
          onBlur = _props4.onBlur;

      if (bool && onFocus) {
        onFocus(e);
      } else if (!bool && onBlur) {
        onBlur();
      }
      this.setState({
        showContainer: bool,
        setViewFor: bool ? 'date' : this.state.setViewFor,
        dateToEdit: bool ? date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format(format || 'DD-MM-YYYY') : '' : this.state.dateToEdit,
        isValid: date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').isValid() : this.state.isValid
      });
    }
  }, {
    key: 'openViewFor',
    value: function openViewFor(setViewFor) {
      this.setState({
        setViewFor: setViewFor
      });
    }
  }, {
    key: 'checkAndReturnDate',
    value: function checkAndReturnDate() {
      var _state3 = this.state,
          isValid = _state3.isValid,
          isMaxValid = _state3.isMaxValid,
          isMinValid = _state3.isMinValid;
      var _props5 = this.props,
          format = _props5.format,
          date = _props5.date,
          maxDate = _props5.maxDate,
          minDate = _props5.minDate,
          lang = _props5.lang;

      var currentDate = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY') : '';
      var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
      var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
      if (!isValid || !isMaxValid || !isMinValid) {
        return 'Invalid date';
      } else if (startDate && endDate && !endDate.startOf('day').isAfter(startDate)) {
        return 'Invalid max/min date';
      } else if (currentDate && startDate && !startDate.startOf('day').isSameOrBefore(currentDate)) {
        return 'Invalid min date';
      } else if (currentDate && endDate && !endDate.startOf('day').isSameOrAfter(currentDate)) {
        return 'Invalid max date';
      } else if (date) {
        _moment2.default.locale(lang || 'en');
        return (0, _moment2.default)(date, format || 'DD-MM-YYYY').format(format || 'DD-MM-YYYY');
      } else {
        return '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state4 = this.state,
          showContainer = _state4.showContainer,
          setViewFor = _state4.setViewFor,
          dateToEdit = _state4.dateToEdit,
          isValid = _state4.isValid,
          yearBlock = _state4.yearBlock;
      var _props6 = this.props,
          format = _props6.format,
          placeholder = _props6.placeholder,
          showBorder = _props6.showBorder,
          className = _props6.className,
          id = _props6.id,
          icon = _props6.icon,
          iconClass = _props6.iconClass,
          maxDate = _props6.maxDate,
          minDate = _props6.minDate,
          label = _props6.label,
          labelClass = _props6.labelClass,
          lang = _props6.lang;

      return _react2.default.createElement(
        _Container2.default,
        { onBlur: function onBlur(e) {
            return _this3.onBlur(e);
          } },
        label && _react2.default.createElement(
          _Label2.default,
          {
            className: labelClass,
            htmlFor: id
          },
          label
        ),
        _react2.default.createElement(_Input2.default, {
          className: className,
          id: id,
          onChange: function onChange(e) {
            return e.preventDefault();
          },
          onFocus: function onFocus(e) {
            return _this3.toggleCalendar(true, e);
          },
          placeholder: placeholder,
          showBorder: showBorder,
          type: 'text',
          value: this.checkAndReturnDate()
        }),
        icon && _react2.default.createElement(_Icon2.default, {
          className: iconClass,
          icon: icon,
          onClick: function onClick() {
            return _this3.toggleCalendar(true);
          }
        }),
        showContainer && isValid && (this.checkAndReturnDate() === '' || (0, _moment2.default)(this.checkAndReturnDate(), format || 'DD-MM-YYYY').isValid()) && _react2.default.createElement(
          _CalendarContainer2.default,
          null,
          _react2.default.createElement(
            _CalendarHeading2.default,
            null,
            _react2.default.createElement(_SingleArrow2.default, {
              left: true,
              onClick: function onClick() {
                return _this3.subDate(1, 'month');
              }
            }),
            _react2.default.createElement(_DoubleArrow2.default, {
              left: true,
              onClick: function onClick() {
                return _this3.subDate(1, 'year');
              }
            }),
            _react2.default.createElement(_DateEditor2.default, {
              date: dateToEdit,
              format: format,
              lang: lang,
              maxDate: maxDate,
              minDate: minDate,
              onDateClick: function onDateClick() {
                return _this3.openViewFor('date');
              },
              onMonthClick: function onMonthClick() {
                return _this3.openViewFor('month');
              },
              onYearClick: function onYearClick() {
                return _this3.openViewFor('year');
              },
              viewFor: setViewFor
            }),
            _react2.default.createElement(_SingleArrow2.default, { onClick: function onClick() {
                return _this3.addDate(1, 'month');
              } }),
            _react2.default.createElement(_DoubleArrow2.default, { onClick: function onClick() {
                return _this3.addDate(1, 'year');
              } })
          ),
          _react2.default.createElement(_CalendarBody2.default, {
            date: dateToEdit,
            format: format,
            maxDate: maxDate,
            minDate: minDate,
            onChange: function onChange(value, unit) {
              return _this3.handleDateChange(value, unit);
            },
            viewFor: setViewFor,
            yearBlock: yearBlock
          })
        )
      );
    }
  }]);

  return ModernDatepicker;
}(_react.Component);

ModernDatepicker.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  iconClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  labelClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  lang: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  showBorder: _propTypes2.default.bool
};

exports.default = ModernDatepicker;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 15px;\n  color: #000;\n'], ['\n  font-size: 15px;\n  color: #000;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DLabel = _styledComponents2.default.label(_templateObject);
var Label = function Label(props) {
  return _react2.default.createElement(DLabel, _extends({}, props, {
    className: props.className
  }));
};

Label.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = Label;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(473);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  width:100%;\n  padding: 5px;\n  color: black;\n  background: white;\n  border: ', ';\n  border-radius: 3px;\n  box-sizing : border-box;\n  &:focus {\n    outline: none;\n  }\n'], ['\n  width:100%;\n  padding: 5px;\n  color: black;\n  background: white;\n  border: ', ';\n  border-radius: 3px;\n  box-sizing : border-box;\n  &:focus {\n    outline: none;\n  }\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DInput = _styledComponents2.default.input(_templateObject, function (props) {
  return !props.showBorder ? 'none' : '1px solid';
});

var Input = function Input(props) {
  return _react2.default.createElement(DInput, _extends({}, props, {
    className: props.className
  }));
};

Input.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = Input;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    width: 22px;\n    height: 22px;\n    position : absolute;\n    cursor: pointer;\n    bottom: 3px;\n    margin: auto;\n    right: 10px;\n'], ['\n    width: 22px;\n    height: 22px;\n    position : absolute;\n    cursor: pointer;\n    bottom: 3px;\n    margin: auto;\n    right: 10px;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Img = _styledComponents2.default.img(_templateObject);

var Icon = function Icon(props) {
  return _react2.default.createElement(Img, _extends({}, props, {
    className: props.className,
    src: props.icon
  }));
};
Icon.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  icon: _propTypes2.default.string.isRequired
};
exports.default = Icon;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width : 100%;\n    position : relative;\n    font-family: \'Open Sans\', sans-serif;\n'], ['\n    width : 100%;\n    position : relative;\n    font-family: \'Open Sans\', sans-serif;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);
exports.default = Container;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width : 100%;\n    height : 315px;\n    max-width : 325px;\n    min-width: 315px;\n    max-height : 315px;\n    position : absolute;\n    top : 100%;\n    background-color : white;\n    border: solid 1px #f4f4f4;\n    border-radius: 6px;\n    &:focus{\n        outline : none;\n    }\n'], ['\n    width : 100%;\n    height : 315px;\n    max-width : 325px;\n    min-width: 315px;\n    max-height : 315px;\n    position : absolute;\n    top : 100%;\n    background-color : white;\n    border: solid 1px #f4f4f4;\n    border-radius: 6px;\n    &:focus{\n        outline : none;\n    }\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarContainer = _styledComponents2.default.div.attrs({
    // we can define static props
    tabIndex: '1'
})(_templateObject);
exports.default = CalendarContainer;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width : 100%;\n    height : 64px;\n    max-width : 325px;\n    max-height : 64px;\n    position : relative;\n    background-color : white;\n    border-bottom: solid 1px #f4f4f4;\n    border-radius: 6px;\n'], ['\n    width : 100%;\n    height : 64px;\n    max-width : 325px;\n    max-height : 64px;\n    position : relative;\n    background-color : white;\n    border-bottom: solid 1px #f4f4f4;\n    border-radius: 6px;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarHeading = _styledComponents2.default.div(_templateObject);
exports.default = CalendarHeading;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 35px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n        color: #b8c2cb;\n    }\n'], ['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 35px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n        color: #b8c2cb;\n    }\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SingleArrow = _styledComponents2.default.span(_templateObject, function (props) {
    return props.left ? 'left' : 'right';
}, function (props) {
    return props.left ? '"<"' : '">"';
});

exports.default = SingleArrow;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 10px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        color: #b8c2cb;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n    }\n'], ['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 10px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        color: #b8c2cb;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n    }\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DoubleArrow = _styledComponents2.default.span(_templateObject, function (props) {
    return props.left ? 'left' : 'right';
}, function (props) {
    return props.left ? '"<<"' : '">>"';
});

exports.default = DoubleArrow;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 1.5em;\n  text-align: center;\n  color: #222222;\n  font-size: 20px;\n  font-weight: 600;\n  margin-right: 10px;\n  line-height: 64px;\n  cursor: pointer;\n\n'], ['\n  font-size: 1.5em;\n  text-align: center;\n  color: #222222;\n  font-size: 20px;\n  font-weight: 600;\n  margin-right: 10px;\n  line-height: 64px;\n  cursor: pointer;\n\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #b8c2cb;\n'], ['\n  color: #b8c2cb;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  min-width: 170px;\n  background: white;\n  text-align: center;\n  border-radius: 6px;\n'], ['\n  min-width: 170px;\n  background: white;\n  text-align: center;\n  border-radius: 6px;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Span = _styledComponents2.default.span(_templateObject);
var SelectedSpan = Span.extend(_templateObject2);
var Wrapper = _styledComponents2.default.div(_templateObject3);
var DateEditor = function DateEditor(props) {
  var onDateClick = props.onDateClick,
      onMonthClick = props.onMonthClick,
      onYearClick = props.onYearClick,
      date = props.date,
      format = props.format,
      viewFor = props.viewFor,
      maxDate = props.maxDate,
      minDate = props.minDate,
      lang = props.lang;

  _moment2.default.locale(lang || 'en');
  var defaultDate = (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var day = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('DD') : defaultDate.format('DD');
  var month = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('MMM') : defaultDate.format('MMM');
  var year = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('YYYY') : defaultDate.format('YYYY');
  return _react2.default.createElement(
    Wrapper,
    null,
    viewFor !== 'date' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onDateClick },
      day
    ) : _react2.default.createElement(
      Span,
      { onClick: onDateClick },
      day
    ),
    viewFor !== 'month' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onMonthClick },
      month
    ) : _react2.default.createElement(
      Span,
      { onClick: onMonthClick },
      month
    ),
    viewFor !== 'year' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onYearClick },
      year
    ) : _react2.default.createElement(
      Span,
      { onClick: onYearClick },
      year
    )
  );
};
DateEditor.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onDateClick: _propTypes2.default.func,
  onMonthClick: _propTypes2.default.func,
  onYearClick: _propTypes2.default.func,
  viewFor: _propTypes2.default.string
};
exports.default = DateEditor;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateView = __webpack_require__(486);

var _DateView2 = _interopRequireDefault(_DateView);

var _MonthView = __webpack_require__(487);

var _MonthView2 = _interopRequireDefault(_MonthView);

var _YearView = __webpack_require__(488);

var _YearView2 = _interopRequireDefault(_YearView);

var _Wrapper = __webpack_require__(96);

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarBody = function CalendarBody(props) {
  var viewFor = props.viewFor,
      date = props.date,
      format = props.format,
      onChange = props.onChange,
      yearBlock = props.yearBlock,
      maxDate = props.maxDate,
      minDate = props.minDate;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    viewFor === 'date' && _react2.default.createElement(_DateView2.default, {
      date: date,
      format: format,
      maxDate: maxDate,
      minDate: minDate,
      onDateChange: function onDateChange(value) {
        return onChange(value, 'date');
      }
    }),
    viewFor === 'month' && _react2.default.createElement(_MonthView2.default, {
      date: date,
      format: format,
      maxDate: maxDate,
      minDate: minDate,
      onMonthChange: function onMonthChange(value) {
        return onChange(value, 'month');
      }
    }),
    viewFor === 'year' && _react2.default.createElement(_YearView2.default, {
      date: date,
      format: format,
      maxDate: maxDate,
      minDate: minDate,
      onYearChange: function onYearChange(value) {
        return onChange(value, 'year');
      },
      yearBlock: yearBlock
    })
  );
};

CalendarBody.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onChange: _propTypes2.default.func,
  viewFor: _propTypes2.default.string,
  yearBlock: _propTypes2.default.number
};

exports.default = CalendarBody;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height:30px;\n  line-height: 30px; \n  margin: 0; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n'], ['\n  height:30px;\n  line-height: 30px; \n  margin: 0; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color:', ';\n  color : ', ';\n  height:30px;\n  line-height: 30px; \n  margin: 0;\n'], ['\n  background-color:', ';\n  color : ', ';\n  height:30px;\n  line-height: 30px; \n  margin: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #b8c2cb;\n  font-weight: 600;\n  margin: 0;\n'], ['\n  color: #b8c2cb;\n  font-weight: 600;\n  margin: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width:100%;\n  text-align : left;\n'], ['\n  width:100%;\n  text-align : left;\n']);

var _styledComponents = __webpack_require__(27);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _Wrapper = __webpack_require__(96);

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Span = __webpack_require__(132);

var _Span2 = _interopRequireDefault(_Span);

var _Header = __webpack_require__(133);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DSpan = _Span2.default.extend(_templateObject, function (props) {
  return props.isMax || props.isMin ? 'none' : 'auto';
}, function (props) {
  return props.isMax || props.isMin ? 'default' : 'pointer';
}, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#fff';
});
var SelectedSpan = _Span2.default.extend(_templateObject2, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#00b9f5';
}, function (props) {
  return props.isMax || props.isMin ? '#000' : 'white';
});
var HeadSpan = _Span2.default.extend(_templateObject3);
var Body = _styledComponents2.default.div(_templateObject4);

var DateView = function DateView(props) {
  var date = props.date,
      format = props.format,
      onDateChange = props.onDateChange,
      maxDate = props.maxDate,
      minDate = props.minDate;

  var mainDate = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY') : (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
  var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
  var currentDate = mainDate.get('date');
  var days = mainDate.daysInMonth(5);
  var daysToAdd = mainDate.startOf('month').format('e');
  var daysArray = [];
  for (var i = 1; i <= days; i++) {
    daysArray[i - 1] = {
      d: i,
      isMax: endDate ? mainDate.startOf('day').date(i).isAfter(endDate) : false,
      isMin: startDate ? mainDate.startOf('day').date(i).isBefore(startDate) : false
    };
  }
  var extraDaysArray = [];
  for (var _i = 0; _i < daysToAdd; _i++) {
    extraDaysArray[_i] = 0;
  }
  var totalDays = extraDaysArray.concat(daysArray);
  var d = [];
  var chunk = 7;
  for (var _i2 = 0, j = totalDays.length; _i2 < j; _i2 += chunk) {
    d.push(totalDays.slice(_i2, _i2 + chunk));
  }
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Header2.default,
      null,
      _react2.default.createElement(
        HeadSpan,
        null,
        'S'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'M'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'T'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'W'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'T'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'F'
      ),
      _react2.default.createElement(
        HeadSpan,
        null,
        'S'
      )
    ),
    d.map(function (week, k) {
      return _react2.default.createElement(
        Body,
        { key: k },
        week.map(function (day, i) {
          return currentDate === day.d && !d.isMax ? _react2.default.createElement(
            SelectedSpan,
            {
              isMax: day.isMax,
              isMin: day.isMin,
              key: i,
              onClick: function onClick() {
                return !d.isMax && !day.isMin && onDateChange(day.d);
              }
            },
            day ? day.d : ''
          ) : _react2.default.createElement(
            DSpan,
            {
              isMax: day.isMax,
              isMin: day.isMin,
              key: i,
              onClick: function onClick() {
                return !d.isMax && !day.isMin && onDateChange(day.d);
              }
            },
            day ? day.d : ''
          );
        })
      );
    })
  );
};

DateView.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onDateChange: _propTypes2.default.func
};
exports.default = DateView;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 5px 15px; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n'], ['\n  margin: 5px 15px; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color:', ';\n  color : ', ';\n  margin: 5px 15px; \n'], ['\n  background-color:', ';\n  color : ', ';\n  margin: 5px 15px; \n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _Wrapper = __webpack_require__(96);

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Span = __webpack_require__(132);

var _Span2 = _interopRequireDefault(_Span);

var _Header = __webpack_require__(133);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var YSpan = _Span2.default.extend(_templateObject, function (props) {
  return props.isMax || props.isMin ? 'none' : 'auto';
}, function (props) {
  return props.isMax || props.isMin ? 'default' : 'pointer';
}, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#fff';
});
var SelectedSpan = _Span2.default.extend(_templateObject2, function (props) {
  return props.isMax ? '#eee' : '#00b9f5';
}, function (props) {
  return props.isMax || props.isMin ? '#000' : 'white';
});
var MonthView = function MonthView(props) {
  var date = props.date,
      format = props.format,
      onMonthChange = props.onMonthChange,
      maxDate = props.maxDate,
      minDate = props.minDate;

  var mainDate = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY') : (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
  var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
  var currentMonth = mainDate.format('MMM');
  var rawMonths = _moment2.default.monthsShort();
  var months = [];
  for (var i = 0; i < rawMonths.length; i++) {
    months.push({
      m: rawMonths[i],
      isMax: endDate ? mainDate.month(rawMonths[i]).isAfter(endDate) : false,
      isMin: startDate ? mainDate.month(rawMonths[i]).isBefore(startDate) : false
    });
  }
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Header2.default,
      null,
      months.map(function (month, k) {
        return currentMonth === month.m ? _react2.default.createElement(
          SelectedSpan,
          {
            isMax: month.isMax,
            isMin: month.isMin,
            key: k,
            onClick: function onClick() {
              return !month.isMax && !month.isMin && onMonthChange(k);
            }
          },
          month.m
        ) : _react2.default.createElement(
          YSpan,
          {
            isMax: month.isMax,
            isMin: month.isMin,
            key: k,
            onClick: function onClick() {
              return !month.isMax && !month.isMin && onMonthChange(k);
            }
          },
          month.m
        );
      })
    )
  );
};

MonthView.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onMonthChange: _propTypes2.default.func
};
exports.default = MonthView;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 5px 15px; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n'], ['\n  margin: 5px 15px; \n  pointer-events : ', ';\n  cursor : ', ';\n  background-color:', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color:', ';\n  color : ', ';\n  margin: 5px 15px; \n'], ['\n  background-color:', ';\n  color : ', ';\n  margin: 5px 15px; \n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _Wrapper = __webpack_require__(96);

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Span = __webpack_require__(132);

var _Span2 = _interopRequireDefault(_Span);

var _Header = __webpack_require__(133);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var YSpan = _Span2.default.extend(_templateObject, function (props) {
  return props.isMax || props.isMin ? 'none' : 'auto';
}, function (props) {
  return props.isMax || props.isMin ? 'default' : 'pointer';
}, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#fff';
});
var SelectedSpan = _Span2.default.extend(_templateObject2, function (props) {
  return props.isMax || props.isMin ? '#eee' : '#00b9f5';
}, function (props) {
  return props.isMax || props.isMin ? '#000' : 'white';
});
var getYears = function getYears(year, main, end, start) {
  var startYear = year;
  var endYear = year + 15;
  var years = [];
  for (var i = startYear; i <= endYear; i++) {
    years.push({
      y: i,
      isMax: end ? main.year(i).isAfter(end) : false,
      isMin: start ? main.year(i).isBefore(start) : false
    });
  }
  return years;
};
var YearView = function YearView(props) {
  var date = props.date,
      format = props.format,
      onYearChange = props.onYearChange,
      yearBlock = props.yearBlock,
      maxDate = props.maxDate,
      minDate = props.minDate;

  var mainDate = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY') : (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var endDate = maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY') : null;
  var startDate = minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY') : null;
  var currentYear = mainDate.get('year');
  var years = getYears(yearBlock, mainDate, endDate, startDate);
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Header2.default,
      null,
      years.map(function (year, k) {
        return currentYear === year.y ? _react2.default.createElement(
          SelectedSpan,
          {
            isMax: year.isMax,
            isMin: year.isMin,
            key: k,
            onClick: function onClick() {
              return !year.isMax && !year.isMin && onYearChange(year.y);
            }
          },
          year.y
        ) : _react2.default.createElement(
          YSpan,
          {
            isMax: year.isMax,
            isMin: year.isMin,
            key: k,
            onClick: function onClick() {
              return !year.isMax && !year.isMin && onYearChange(year.y);
            }
          },
          year.y
        );
      })
    )
  );
};
YearView.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onYearChange: _propTypes2.default.func,
  yearBlock: _propTypes2.default.number
};
exports.default = YearView;

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_trigger__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Panel__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__placements__ = __webpack_require__(556);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint jsx-a11y/no-autofocus: 0 */









function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker =
/*#__PURE__*/
function (_Component) {
  _inherits(Picker, _Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
      event.stopPropagation();

      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          use12Hours = _this$props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          placeholder = _this$props2.placeholder,
          disabledHours = _this$props2.disabledHours,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          inputReadOnly = _this$props2.inputReadOnly,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          clearIcon = _this$props2.clearIcon;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Panel__["a" /* default */], {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props3 = this.props,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          use12Hours = _this$props3.use12Hours,
          prefixCls = _this$props3.prefixCls,
          popupClassName = _this$props3.popupClassName;
      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      } // Keep it for old compatibility


      return __WEBPACK_IMPORTED_MODULE_5_classnames___default()(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props4 = this.props,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowEmpty = _this$props5.allowEmpty,
          clearIcon = _this$props5.clearIcon,
          clearText = _this$props5.clearText,
          disabled = _this$props5.disabled;

      if (!allowEmpty || !value || disabled) {
        return null;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(clearIcon)) {
        var _ref = clearIcon.props || {},
            _onClick = _ref.onClick;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(clearIcon, {
          onClick: function onClick() {
            if (_onClick) _onClick.apply(void 0, arguments);

            _this2.onClear.apply(_this2, arguments);
          }
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear"),
        title: clearText,
        onClick: this.onClear,
        tabIndex: 0
      }, clearIcon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "".concat(prefixCls, "-clear-icon")
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          placeholder = _this$props6.placeholder,
          placement = _this$props6.placement,
          align = _this$props6.align,
          id = _this$props6.id,
          disabled = _this$props6.disabled,
          transitionName = _this$props6.transitionName,
          style = _this$props6.style,
          className = _this$props6.className,
          getPopupContainer = _this$props6.getPopupContainer,
          name = _this$props6.name,
          autoComplete = _this$props6.autoComplete,
          onFocus = _this$props6.onFocus,
          onBlur = _this$props6.onBlur,
          autoFocus = _this$props6.autoFocus,
          inputReadOnly = _this$props6.inputReadOnly,
          inputIcon = _this$props6.inputIcon,
          popupStyle = _this$props6.popupStyle;
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      var popupClassName = this.getPopupClassName();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["a" /* default */], {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_7__placements__["a" /* default */],
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(prefixCls, className),
        style: style
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "".concat(prefixCls, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: placeholder,
        name: name,
        onKeyDown: this.onKeyDown,
        disabled: disabled,
        value: value && value.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        onChange: noop,
        readOnly: !!inputReadOnly,
        id: id
      }), inputIcon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }), this.renderClearButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = {};

      if ('value' in props) {
        newState.value = props.value;
      }

      if (props.open !== undefined) {
        newState.open = props.open;
      }

      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
    }
  }]);

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Picker, "propTypes", {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popupStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideDisabledOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minuteStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  secondStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  align: {},
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_3_moment___default()(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
});

Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Picker);
/* harmony default export */ __webpack_exports__["a"] = (Picker);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(533);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(492), __esModule: true };

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(493);
module.exports = __webpack_require__(46).Object.assign;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(65);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(495) });


/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(47);
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(141);
var pIE = __webpack_require__(102);
var toObject = __webpack_require__(142);
var IObject = __webpack_require__(204);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(81)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(68);
var toLength = __webpack_require__(497);
var toAbsoluteIndex = __webpack_require__(498);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(137);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(137);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(500), __esModule: true };

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(501);
__webpack_require__(507);
module.exports = __webpack_require__(147).f('iterator');


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(502)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(206)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(137);
var defined = __webpack_require__(136);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(145);
var descriptor = __webpack_require__(98);
var setToStringTag = __webpack_require__(146);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(66)(IteratorPrototype, __webpack_require__(69)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(52);
var anObject = __webpack_require__(80);
var getKeys = __webpack_require__(99);

module.exports = __webpack_require__(47) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(45).document;
module.exports = document && document.documentElement;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(53);
var toObject = __webpack_require__(142);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(508);
var global = __webpack_require__(45);
var hide = __webpack_require__(66);
var Iterators = __webpack_require__(144);
var TO_STRING_TAG = __webpack_require__(69)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(509);
var step = __webpack_require__(510);
var Iterators = __webpack_require__(144);
var toIObject = __webpack_require__(68);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(206)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
module.exports = __webpack_require__(46).Symbol;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(45);
var has = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(47);
var $export = __webpack_require__(65);
var redefine = __webpack_require__(207);
var META = __webpack_require__(514).KEY;
var $fails = __webpack_require__(81);
var shared = __webpack_require__(139);
var setToStringTag = __webpack_require__(146);
var uid = __webpack_require__(101);
var wks = __webpack_require__(69);
var wksExt = __webpack_require__(147);
var wksDefine = __webpack_require__(148);
var enumKeys = __webpack_require__(515);
var isArray = __webpack_require__(516);
var anObject = __webpack_require__(80);
var isObject = __webpack_require__(67);
var toObject = __webpack_require__(142);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(135);
var createDesc = __webpack_require__(98);
var _create = __webpack_require__(145);
var gOPNExt = __webpack_require__(517);
var $GOPD = __webpack_require__(209);
var $GOPS = __webpack_require__(141);
var $DP = __webpack_require__(52);
var $keys = __webpack_require__(99);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(208).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(102).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(100)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(66)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(101)('meta');
var isObject = __webpack_require__(67);
var has = __webpack_require__(53);
var setDesc = __webpack_require__(52).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(81)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(141);
var pIE = __webpack_require__(102);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(205);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(68);
var gOPN = __webpack_require__(208).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 518 */
/***/ (function(module, exports) {



/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148)('asyncIterator');


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148)('observable');


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(522), __esModule: true };

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(523);
module.exports = __webpack_require__(46).Object.setPrototypeOf;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(65);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(524).set });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(67);
var anObject = __webpack_require__(80);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(200)(Function.call, __webpack_require__(209).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(526), __esModule: true };

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
var $Object = __webpack_require__(46).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(65);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(145) });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(529);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(530);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(13);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(212);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(535);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(539);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(537);
var $Object = __webpack_require__(46).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(65);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(47), 'Object', { defineProperty: __webpack_require__(52).f });


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(210);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(215);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(213);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(215);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(214);
} catch (err) {
  var index = __webpack_require__(214);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(216);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Combobox__ = __webpack_require__(552);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: newValue
      });

      onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    return _this;
  }

  _createClass(Panel, [{
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      var onEsc = this.props.onEsc;
      onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var defaultOpenValue = this.props.defaultOpenValue;
      var value = this.state.value;
      var realValue = value || defaultOpenValue;
      return realValue.hour() >= 0 && realValue.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format = _this$props2.format,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          onEsc = _this$props2.onEsc,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          inputReadOnly = _this$props2.inputReadOnly,
          clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, "".concat(prefixCls, "-inner"))
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: validDefaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Combobox__["a" /* default */], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        onEsc: onEsc,
        isAM: this.isAM()
      }), addon(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props) {
        return _objectSpread({}, state, {
          value: props.value
        });
      }

      return null;
    }
  }]);

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Panel, "propTypes", {
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideDisabledOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minuteStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  secondStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_2_moment___default()(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  onAmPmChange: noop,
  inputReadOnly: false
});

Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Panel);
/* harmony default export */ __webpack_exports__["a"] = (Panel);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var str = event.target.value;

      _this.setState({
        str: str
      });

      var _this$props = _this.props,
          format = _this$props.format,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          secondOptions = _this$props.secondOptions,
          disabledHours = _this$props.disabledHours,
          disabledMinutes = _this$props.disabledMinutes,
          disabledSeconds = _this$props.disabledSeconds,
          onChange = _this$props.onChange;

      if (str) {
        var originalValue = _this.props.value;

        var value = _this.getProtoValue().clone();

        var parsed = __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, format, true);

        if (!parsed.isValid()) {
          _this.setState({
            invalid: true
          });

          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          _this.setState({
            invalid: true
          });

          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          _this.setState({
            invalid: true
          });

          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());
            onChange(changedValue);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        onChange(null);
      }

      _this.setState({
        invalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onEsc = _this$props2.onEsc,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 27) {
        onEsc();
      }

      onKeyDown(e);
    });

    var _value = props.value,
        _format = props.format;
    _this.state = {
      str: _value && _value.format(_format) || '',
      invalid: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var focusOnOpen = this.props.focusOnOpen;

      if (focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refInput.focus();

          _this2.refInput.select();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          format = _this$props3.format;

      if (value !== prevProps.value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          str: value && value.format(format) || '',
          invalid: false
        });
      }
    }
  }, {
    key: "getProtoValue",
    value: function getProtoValue() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          defaultOpenValue = _this$props4.defaultOpenValue;
      return value || defaultOpenValue;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          inputReadOnly = _this$props5.inputReadOnly;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-input"), invalidClass),
        ref: function ref(_ref) {
          _this3.refInput = _ref;
        },
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, this.getInput());
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Header, "propTypes", {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabledDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  minuteOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentSelectPanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Header, "defaultProps", {
  inputReadOnly: false
});

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select__ = __webpack_require__(553);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox =
/*#__PURE__*/
function (_Component) {
  _inherits(Combobox, _Component);

  function Combobox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours,
          propValue = _this$props.value,
          isAM = _this$props.isAM,
          onAmPmChange = _this$props.onAmPmChange;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        onAmPmChange(ampm);
      } else {
        value.second(+itemValue);
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
      onCurrentSelectPanelChange(range);
    });

    return _this;
  }

  _createClass(Combobox, [{
    key: "getHourSelect",
    value: function getHourSelect(hour) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          hourOptions = _this$props2.hourOptions,
          disabledHours = _this$props2.disabledHours,
          showHour = _this$props2.showHour,
          use12Hours = _this$props2.use12Hours,
          onEsc = _this$props2.onEsc;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this2.onEnterSelectPanel('hour');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function getMinuteSelect(minute) {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          minuteOptions = _this$props3.minuteOptions,
          disabledMinutes = _this$props3.disabledMinutes,
          defaultOpenValue = _this$props3.defaultOpenValue,
          showMinute = _this$props3.showMinute,
          propValue = _this$props3.value,
          onEsc = _this$props3.onEsc;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this3.onEnterSelectPanel('minute');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getSecondSelect",
    value: function getSecondSelect(second) {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          secondOptions = _this$props4.secondOptions,
          disabledSeconds = _this$props4.disabledSeconds,
          showSecond = _this$props4.showSecond,
          defaultOpenValue = _this$props4.defaultOpenValue,
          propValue = _this$props4.value,
          onEsc = _this$props4.onEsc;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this4.onEnterSelectPanel('second');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function getAMPMSelect() {
      var _this5 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          use12Hours = _this$props5.use12Hours,
          format = _this$props5.format,
          isAM = _this$props5.isAM,
          onEsc = _this$props5.onEsc;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this5.onEnterSelectPanel('ampm');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          defaultOpenValue = _this$props6.defaultOpenValue,
          propValue = _this$props6.value;
      var value = propValue || defaultOpenValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-combobox")
      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
    }
  }]);

  return Combobox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Combobox, "propTypes", {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  minuteOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCurrentSelectPanelChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isAM: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Combobox);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raf__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint jsx-a11y/no-noninteractive-element-to-interactive-role: 0 */






var scrollTo = function scrollTo(element, to, duration) {
  // jump to target if duration zero
  if (duration <= 0) {
    __WEBPACK_IMPORTED_MODULE_4_raf___default()(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  __WEBPACK_IMPORTED_MODULE_4_raf___default()(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;
      onSelect(type, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        active: true
      });

      onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
      _this.list = node;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option

      if (prevProps.selectedIndex !== selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          selectedIndex = _this$props2.selectedIndex,
          prefixCls = _this$props2.prefixCls,
          onEsc = _this$props2.onEsc;
      return options.map(function (item, index) {
        var _classNames;

        var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
        var onClick = item.disabled ? undefined : function () {
          _this2.onSelect(item.value);
        };

        var onKeyDown = function onKeyDown(e) {
          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          role: "button",
          onClick: onClick,
          className: cls,
          key: index,
          disabled: item.disabled,
          tabIndex: "0",
          onKeyDown: onKeyDown
        }, item.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function scrollToSelected(duration) {
      // move to selected item
      var selectedIndex = this.props.selectedIndex;
      var select = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
      var list = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.list);

      if (!list) {
        return;
      }

      var index = selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          options = _this$props3.options;
      var active = this.state.active;

      if (options.length === 0) {
        return null;
      }

      var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cls,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "propTypes", {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(555)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AssigmentOfWork;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
var assignmentOfWorkTemplate={sample:null,cad:null,fabric:null,trim:null,pattern:null,cutting:null,sewing:null,garmentTechnologist:null,embellishment:null,embroidery:null,wash:null,dispatch:null,qc:null,//GRADING
marker:null,costing:null,signOff:null};function AssigmentOfWork(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row m-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-color-green font-weight-bold pb-3 ml-5"},props.moduleName)),Object.keys(assignmentOfWorkTemplate).map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 mb-3",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"d-flex justify-content-between align-items-center",onFocus:function onFocus(){return props.getAssign("");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pr-3 text-right mx-w-35"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-uppercase"},data==="garmentTechnologist"?"garment Technologist":data==="qc"?'GRADING':data==="cad"?"3D/Cad":[data])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mx-w"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{options:props.employeesOption,name:[data]//value={props.assignmentOfWork[data]}
,value:props.assignmentOfWork[data]&&props.searchOption.find(function(option){return option.value===props.assignmentOfWork[data];})||null,onChange:function onChange(val){return props.changeAssign(data,val,index,props.moduleName);}//here val is getting the object from the search emp options and send whole object to the state 
// onFocus={() => props.getAssign("")}
// autoFocus={(index == 0 && true) || props.action == "view"}
,onInputChange:props.getAssign,disabled:props.disabled})))));}));}

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_excel_gif__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_excel_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_excel_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Field_CustomerDeptSelect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ImageTopLeft__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MeetingNote_AddImageIcon__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MeetingNote_SubModule__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ButtonCol__ = __webpack_require__(226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _sketchTemplate;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//services
//components
var sketchTemplate=(_sketchTemplate={imageName:"",imageDescription:"",sketchImage:"",sampleStyle:"",path:"",blockRefNumber:"",blockRefFrom:"",sketch:"",sampleDeadline:null,fabric:"",quality:"",artwork:"",trim:"",fitComments:"",wash:"",print:"",embroidery:"",garmentType:null,magnumStyleId:null,styleReferenceId:null,magnumStyleName:"",customerRefNumber:"",remarks:"",pendingItem:[],mocks:[]},_defineProperty(_sketchTemplate,"customerRefNumber",""),_defineProperty(_sketchTemplate,"IB",[{price:null,qty:null,ibDate:null}]),_defineProperty(_sketchTemplate,"order",[{price:null,qty:null,ibDate:null}]),_defineProperty(_sketchTemplate,"shipmentDetails",[{quantity:null,date:null}]),_defineProperty(_sketchTemplate,"additionalInfo",""),_defineProperty(_sketchTemplate,"refImages",[]),_sketchTemplate);var MeetingNote=function(_Component){_inherits(MeetingNote,_Component);function MeetingNote(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,MeetingNote);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MeetingNote.__proto__||Object.getPrototypeOf(MeetingNote)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,meetingNote:{customer:null,MNId:"",customerDepartmentId:null,dateOfMeeting:null,buyerName:"",present:"",placeOfMeeting:"",sketches:[]},currentIndex:null,currentSketchData:null,openSubModule:false,customerList:[],imageTypeOption:[],garmentTypeOption:[],styleList:[],toggle:"imagelist",openmodal:false,isLoading:false,meetingNoteIDandBarcode:{MNId:"",qr:null,_id:null}},_this.componentDidMount=function(){var _this$props$location$=_this.props.location.state,action=_this$props$location$.action,_id=_this$props$location$._id;if(action=="view"){_this.setState({disabled:true});}if(action==="add"){// Get meeting Id and barcode
__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].getMeetingIDAndBarcode().then(function(response){// console.log('meeting notes -id-----', response);
var meetingNote=_this.state.meetingNote;meetingNote.MNId=response.text.data.MNId;_this.setState({meetingNote:meetingNote});});}if(action!=="add"){if(_id!==""){__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].getMeetingNote(_id).then(function(response){if(response.status==200){var meetingNote=Object.assign({},_this.state.meetingNote);Object.keys(meetingNote).forEach(function(keyName){meetingNote[keyName]=response.text.data[keyName];});_this.setState({meetingNote:meetingNote});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});}}_this.setState({meetingNote:Object.assign({},_this.state.meetingNote,{dateOfMeeting:_this.state.meetingNote.dateOfMeeting!==null?_this.state.meetingNote.dateOfMeeting:new Date()})});_this.setState({action:action,_id:_id});if(_this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}_this.getCustomerInfo();_this.getGarmentInfo();_this.getStyleInfo("");},_this.getGarmentInfo=function(){__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].getGarmentInfo().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var garmentTypeOption;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status==200)){_context.next=5;break;}garmentTypeOption=[];_context.next=4;return response.text.data.sysData.map(function(data){garmentTypeOption.push({label:data.name,value:data._id});});case 4:_this.setState({garmentTypeOption:garmentTypeOption});case 5:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){_this.props.getalertMessage("error",error);});},_this.getCustomerInfo=function(){__WEBPACK_IMPORTED_MODULE_8__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:response.text.data});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.createMeetingNote=function(e){var meetingNote=Object.assign({},_this.state.meetingNote);if(_this.state._id!=="")meetingNote._id=_this.state._id;if(_this.state._id!==""){meetingNote._id=_this.state._id;}meetingNote.sketches=meetingNote.sketches.map(function(sketch,index){var data=Object.assign({},sketch);if(Array.isArray(data.pendingItem)&&data.pendingItem.length>0){if(data.pendingItem[0]!==null){if(Object.keys(data.pendingItem[0]).length>0){data.pendingItem=data.pendingItem.map(function(dat){return dat=dat.value;});}}}if(Array.isArray(data.mocks)&&data.mocks.length>0){if(data.mocks[0]!==null){if(Object.keys(data.mocks[0]).length>0){data.mocks=data.mocks.map(function(dat){return dat=dat.value;});}}}return data;});__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].createMeetingNote(meetingNote).then(function(response){if(response.status==200){_this.setState({_id:response.text.data._id});_this.props.getalertMessage("success",response.text.message);// this.props.history.push("/list", { moduleName: "MEETINGROOM" });
}response.status==401&&_this.props.unauthorisedFunc();response.status==404&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){_this.props.getalertMessage("error",JSON.stringify(error));});},_this._handleInputChange=function(name,value){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote[name]=value;_this.setState({meetingNote:meetingNote});},_this._handleCustDeptChange=function(index,customer,customerDepartmentId){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.customer=customer;meetingNote.customerDepartmentId=customerDepartmentId;_this.setState({meetingNote:meetingNote});},_this.getRefImages=function(refImages,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index].refImages=refImages;_this.setState({meetingNote:meetingNote});},_this.selectNewSample=function(index){var meetingNote=Object.assign({},_this.state.meetingNote);var sketches=meetingNote.sketches;sketches[index].sampleStyle="New Sample";meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.selectExistingSample=function(index){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;sketches[index].sampleStyle="Existing Sample";meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.selectNewIB=function(index){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;sketches[index].sampleStyle="IB";meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.selectNewOrder=function(index){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;sketches[index].sampleStyle="Order";meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.sketchDataChange=function(e,index){var meetingNote=_this.state.meetingNote;var singleSketch=meetingNote.sketches[index];singleSketch[e.target.name]=e.target.value;meetingNote.sketches[index]=singleSketch;_this.setState({meetingNote:meetingNote});var staffDetails={};var allShipping=[];var shipping={};staffDetails.MNId=window.location.href.split("/")[3].split("?")[1];staffDetails._id=_this.state.meetingNote.sketches[index]._id;var sketch=_this.state.meetingNote.sketches;staffDetails.sketchImage=_this.state["productImage"+index]===undefined||_this.state["productImage"+index]===null?sketch[index].path:_this.state["productImage"+index];staffDetails.referenceImages=_this.state["images"+index];var form=document.forms[""+index];staffDetails.sampleStyle=_this.state.meetingNote.sketches[index].sampleStyle;for(var i=0;i<form.elements.length;i++){if(form.elements[i].name==="qty"||form.elements[i].name==="date"){shipping[form.elements[i].name]=form.elements[i].value;if(Object.keys(shipping).length==2){allShipping.push(shipping);shipping={};}}else{staffDetails[form.elements[i].name]=form.elements[i].value;}}if(form.elements["IB"+index]!==undefined&&form.elements["IB"+index].checked===true&&form.elements["existingSample"+index].checked===true){staffDetails.sampleStyle="IB";staffDetails.IB=allShipping;}else if(form.elements["order"+index]!==undefined&&form.elements["order"+index].checked===true&&form.elements["existingSample"+index].checked===true){staffDetails.order=allShipping;staffDetails.sampleStyle="Order";}},_this.changeMeetingData=function(e){var meetingNote=_this.state.meetingNote;meetingNote[e.target.name]=e.target.value;_this.setState({meetingNote:meetingNote});},_this.customerInfoChange=function(customerId,departmentId){var meetingNote=_this.state.meetingNote;meetingNote.customerDepartmentId=departmentId;var customer=meetingNote.customer;customer._id=customerId;meetingNote.customer=customer;_this.setState({meetingNote:meetingNote});},_this.magnumStyleChange=function(e,index,name){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;sketches[index].magnumStyleId!==undefined?sketches[index].magnumStyleId[name]=e.target.value:sketches[index].magnumStyleId={};if(sketches[index].magnumStyleId==={}){sketches[index].magnumStyleId[name]=e.target.value;}meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.magnumStyleNameChange=function(e,index){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;sketches[index].magnumStyleId.styleName=e.target.value;meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.ibValueChange=function(name,value,index,indexVal){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;var IB=sketches[index].IB;IB[indexVal][name]=value;sketches[index].IB=IB;meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.shippingValueChange=function(name,value,indexVal,index){var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;var shipmentDetails=sketches[index].shipmentDetails;shipmentDetails[indexVal][name]=value;sketches[index].shipmentDetails=shipmentDetails;meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.generateStyle=function(e){_this.props.history.push("/StylePage",{action:"add",_id:"",MNId:_this.state._id});},_this.updateValue=function(name,value,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index][name]=value;_this.setState({meetingNote:meetingNote});},_this.addSketch=function(){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches.push(Object.assign({},sketchTemplate));_this.setState({meetingNote:meetingNote});},_this.removeSketch=function(index){var meetingNote=Object.assign({},_this.state.meetingNote);var sketches=meetingNote.sketches;sketches.splice(index,1);meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote},function(){return _this.backToList();});},_this.changeGarmentType=function(garmentType,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index].garmentType=garmentType;_this.setState({meetingNote:meetingNote});},_this._handleInputChangeForSketch=function(name,value,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index][name]=value;_this.setState({meetingNote:meetingNote});},_this.changeImg=function(files,index){__WEBPACK_IMPORTED_MODULE_8__services__["f" /* FileUploadService */].uploadFile(files[0],"meetingnotes").then(function(response){if(response.status===200){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index].sketchImage=response.text.data.url;_this.setState({meetingNote:meetingNote});}else if(response.status===401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.removeMNoteImage=function(index){var meetingNote=_this.state.meetingNote;if(meetingNote!==undefined){meetingNote.sketches[index].sketchImage="";_this.setState({meetingNote:meetingNote});}},_this.changePendingItem=function(value,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index].pendingItem=value;_this.setState({meetingNote:meetingNote});},_this.changeMocks=function(value,index){var meetingNote=Object.assign({},_this.state.meetingNote);meetingNote.sketches[index].mocks=value;_this.setState({meetingNote:meetingNote});},_this.saveMeetingNote=function(e){e.preventDefault();var meetingNote=Object.assign({},_this.state.meetingNote);if(_this.state._id!=="")meetingNote._id=_this.state._id;meetingNote.sketches=meetingNote.sketches.map(function(sketch,index){var data=Object.assign({},sketch);data.imageName=_this.state.meetingNoteIDandBarcode.MNId+"-"+parseInt(index)+1;// data.imageDescription = 'mydesc'
if(Array.isArray(data.pendingItem)&&data.pendingItem.length>0){if(data.pendingItem[0]!==null){if(Object.keys(data.pendingItem[0]).length>0){data.pendingItem=data.pendingItem.map(function(dat){return dat=dat.value;});}}}if(Array.isArray(data.mocks)&&data.mocks.length>0){if(data.mocks[0]!==null){if(Object.keys(data.mocks[0]).length>0){data.mocks=data.mocks.map(function(dat){return dat=dat.value;});}}}return data;});__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].createMeetingNote(meetingNote).then(function(response){if(response.status==200){_this.props.getalertMessage("success",response.text.message);_this.setState({_id:response.text.data._id,meetingNoteIDandBarcode:Object.assign({},_this.state.meetingNoteIDandBarcode,{_id:response.text.data._id})});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeIBSize=function(index,indexVal,methodName){var meetingNote=_this.state.meetingNote;var sketch=meetingNote.sketches[index];methodName==="add"?sketch.IB.push({price:null,qty:null,date:null}):sketch.IB.splice(indexVal,1);meetingNote.sketches[index]=sketch;_this.setState({meetingNote:meetingNote});},_this.changeShippingSize=function(index,indexVal,methodName){var meetingNote=_this.state.meetingNote;var sketch=meetingNote.sketches[index];methodName==="add"?sketch.shipmentDetails.push({quantity:null,date:""}):sketch.shipmentDetails.splice(indexVal,1);meetingNote.sketches[index]=sketch;_this.setState({meetingNote:meetingNote});},_this.removeShippingValueDetails=function(e,indexVal,index){e.preventDefault();var meetingNote=_this.state.meetingNote;var sketches=meetingNote.sketches;var shipmentDetails=sketches[index].shipmentDetails;// shipmentDetails.filter(value => shipmentDetails.indexOf(value) !== indexVal)
shipmentDetails.splice(indexVal,1);sketches[index].shipmentDetails=shipmentDetails;meetingNote.sketches=sketches;_this.setState({meetingNote:meetingNote});},_this.getStyleInfo=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleList:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.changeStyleInfo=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(styleValue,index){var meetingNote,_meetingNote;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(styleValue!==null)){_context2.next=9;break;}meetingNote=_this.state.meetingNote;meetingNote.sketches[index].styleReferenceId=styleValue.value;_context2.next=5;return _this.getStyleInfoById(styleValue.value);case 5:_context2.next=7;return __WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getStyleInfoByReference(styleValue.value).then(function(response){if(response.status===200){meetingNote.sketches[index].magnumStyleName=response.text.data.magnumStyleName;meetingNote.sketches[index].customerRefNumber=response.text.data.customerRefNumber;meetingNote.sketches[index].magnumStyleId=response.text.data.magnumStyleId;_this.setState({meetingNote:meetingNote});}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});case 7:_context2.next=15;break;case 9:_meetingNote=_this.state.meetingNote;_meetingNote.sketches[index].magnumStyleName="";_meetingNote.sketches[index].customerRefNumber="";_meetingNote.sketches[index].magnumStyleId=null;_meetingNote.sketches[index].styleReferenceId=null;_this.setState({meetingNote:_meetingNote});case 15:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}(),_this.getStyleInfoById=function(id){if(id!==null){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReferenceById(id).then(function(response){if(response.status===200){var styleList=[].concat(_toConsumableArray(_this.state.styleList),_toConsumableArray(response.text.data));_this.setState({styleList:styleList});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.openModal=function(image){if(image!=""&&image!==undefined){_this.setState({openmodal:true,image:image});}},_this.onClose=function(){_this.setState({openmodal:false});},_this.addSketchImages=function(files){var meetingNote=Object.assign({},_this.state.meetingNote);_this.setState({isLoading:true});if(files.length>0){__WEBPACK_IMPORTED_MODULE_8__services__["f" /* FileUploadService */].uploadMeetingNoteImage(files).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(response.status==200){response.text.data.map(function(data){var _meetingNote$sketches;meetingNote.sketches.push((_meetingNote$sketches={sketchImage:data.url,sampleStyle:"",path:"",blockRefNumber:"",blockRefFrom:"",sketch:"",sampleDeadline:null,fabric:"",quality:"",artwork:"",trim:"",fitComments:"",wash:"",print:"",embroidery:"",garmentType:null,magnumStyleId:null,styleReferenceId:null,magnumStyleName:"",customerRefNumber:"",remarks:"",pendingItem:[],mocks:[]},_defineProperty(_meetingNote$sketches,"customerRefNumber",""),_defineProperty(_meetingNote$sketches,"IB",[{price:null,qty:null,ibDate:null}]),_defineProperty(_meetingNote$sketches,"order",[{price:null,qty:null,ibDate:null}]),_defineProperty(_meetingNote$sketches,"shipmentDetails",[{quantity:null,date:null}]),_defineProperty(_meetingNote$sketches,"additionalInfo",""),_defineProperty(_meetingNote$sketches,"refImages",[]),_meetingNote$sketches));});_this.setState({meetingNote:meetingNote,isLoading:false});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}case 1:case"end":return _context3.stop();}}},_callee3,_this2);}));return function(_x4){return _ref4.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.backToList=function(){_this.setState({currentIndex:null,currentSketchData:null,openSubModule:false});},_this.exportExcel=function(){_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_8__services__["i" /* ReportServices */].meetingNotesExcel(_this.state._id).then(function(res){var data=res.text.data;var anchor=document.createElement("a");anchor.href=__WEBPACK_IMPORTED_MODULE_8__services__["m" /* UtilityService */].baseUrl()+data.link;anchor.target="_blank";anchor.download=__WEBPACK_IMPORTED_MODULE_8__services__["m" /* UtilityService */].baseUrl()+data.link;_this.setState({isLoading:false});anchor.click();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MeetingNote,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"render",value:function render(){var _this3=this;var meetingNote=this.state.meetingNote;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section bg-white"},this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"Meeting Notes"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{cursor:"pointer"},className:"primary pull-right px-2 mr-3",onClick:function onClick(e){return _this3.exportExcel();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_excel_gif___default.a,width:"20px"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",value:meetingNote.MNId,inputName:"meetingID",label:"Meeting ID",disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Field_CustomerDeptSelect__["a" /* default */],{options:this.state.customerList,value:meetingNote.customer+"-"+meetingNote.customerDepartmentId,onChange:this._handleCustDeptChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",value:meetingNote.dateOfMeeting,inputName:"dateOfMeeting",label:"Date of meeting",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"buyerName",value:meetingNote.buyerName,label:"Buyer Name",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"present",value:meetingNote.present,label:"Present",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"placeOfMeeting",value:meetingNote.placeOfMeeting,label:"Place of the meeting",onChange:this._handleInputChange,disabled:this.state.disabled}))),!this.state.openSubModule&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-5 mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_MeetingNote_AddImageIcon__["a" /* default */],{onChange:this.addSketchImages}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 px-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"image-list"},meetingNote.sketches.map(function(sketch,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"image-card-index"},meetingNote.MNId+"-"+(index+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"image-card cursor-hover",onClick:function onClick(){return _this3.setState({openSubModule:true,currentIndex:index,currentSketchData:sketch});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__services__["m" /* UtilityService */].fileUrl()+sketch.sketchImage}))));}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},this.state.openSubModule&&this.state.currentIndex!==null&&meetingNote.sketches.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_MeetingNote_SubModule__["a" /* default */],{options:this.state.customerList,meetingNoteID:this.state.meetingNoteIDandBarcode.MNId,data:meetingNote.sketches[this.state.currentIndex],meetingNote:this.state.meetingNote,index:this.state.currentIndex,changeImg:this.changeImg,removeMNoteImage:this.removeMNoteImage,changeStyleInfo:this.changeStyleInfo,getStyleInfo:this.getStyleInfo,getStyleInfoById:this.getStyleInfoById,selectNewSample:this.selectNewSample,selectExistingSample:this.selectExistingSample,selectNewIB:this.selectNewIB,selectNewOrder:this.selectNewOrder,updateValue:this.updateValue,changeGarmentType:this.changeGarmentType,changePendingItem:this.changePendingItem,changeMocks:this.changeMocks,ibValueChange:this.ibValueChange,changeIBSize:this.changeIBSize,shippingValueChange:this.shippingValueChange,changeShippingSize:this.changeShippingSize,getRefImages:this.getRefImages,saveMeetingNote:this.saveMeetingNote,generateStyle:this.generateStyle,backToList:this.backToList,removeSketch:this.removeSketch,styleList:this.state.styleList,garmentTypeOption:this.state.garmentTypeOption,imageTypeOption:this.state.imageTypeOption,disabled:this.state.disabled,history:this.props.history})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ButtonCol__["a" /* ButtonCol */],{saveFunc:function saveFunc(){_this3.createMeetingNote();// setTimeout(() => this.props.history.goBack(), 1200)
},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__["a" /* default */],{open:this.state.openmodal,onClose:this.onClose,center:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__services__["m" /* UtilityService */].fileUrl()+this.state.image})));}}]);return MeetingNote;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MeetingNote);

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhIwAiAOYAADyFLWGlTEOJQ1+mTWyhbPr8+6bGrLHNs3+sfleUV4evhqjGrYmyizV8Nfb9+TJ8IkGHMGudbAZeCfr++gBeAKTCpD6JMIi7aazKrrfVtfj89QBRAO727WSZZAVhBS18LJW7lwBlAH+tgP7//wBZAAZhCQBVAP39+/j8+iRzJOHt4wJiAT6HLn2sfgJhBICtf1+fR3KlbwZeBQBPAFZaXautrrW3uPT19Wtvcb/BwpSWmMrLzN/g4Xl8fn2rfWFkZ6jGqerq6/v+/KCipPn/+H2sff3//X6tfPf498Xcvv/7/SN5KXKice7y7vr+//v9/b/bwoiyhcDZwdXW1l+nT+Dq3Pv++vn8+e708Pn++whfCz6FQD+IPKDEojGBMTqDNzmFOfn7+s7kzvH58/P69PL99PT483KlVvX991uhTVyhTS14IgFaBP7+/AJdBN3s3XqzfiR5J6rLpoSyhIayiU2UTbjLuPv7/ARmAxBsEQVVBej16v/8/whjC/j9/P///yH5BAAAAAAALAAAAAAjACIAAAf/gH+Cg4SFhoeIiYqLjI2Oh2cQECyULACXlRYPm5trF44AFB5aEqWmpyUlfX0eJDCOEB4xGAa1tre1CxgJJgGOLFoHj3Qbvo0WEgt/RCdKTw5lGg4OBVZERH8txY7IyhxvKipIfE4FTVh7HHd/CNvHyX8KH0spEWNGCA1bDUwT2e6MWMCrICCOCRIERJBwQ0IPiBF/fABcJNDAHyMYOnygQMFFiBBuGPwR8qfIREUClTkRYieGFwofZRyB6KfkyUTIgPxB8ycMAQECVlD4ICeDFBTsbiLK+aeNEAUe3NQBQwFPVAH+tBljxLTAHBkrQnhI8CVsiS6CJG6lCA/EDBJw4knI4JJnRQk4ZCIqPZTyT5cOBAITiBAhBYUVbIRp5QavwJUCkCGbEQMlSYYqf47sNQQBXpYsE6xYmcCMEEQRvWBJEOYoyuZCFlwkYCCiNoLbthGIeCGCgQASaxUBIGFig/ENM5IbV76cxIZXjS6koTKguvXr2Kmk+fSou/fv4G/gwHGDB40cNWgMuqGDBo0ePL5PoTGkh44/6QfZoBHkT4743w1BA3n4qSdIDgPqkAN4f+z3Q3/5DbKDDjic9515NvzQQ4ES7vBHEDTY4N0N9jUYYnru1bBDhT/ocAODMMb4SCAAOw=="

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AddImageIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function AddImageIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"upload-btn-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary"},"Upload image"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",accept:"image/png, image/jpeg",multiple:true,onChange:function onChange(e){return props.onChange(e.target.files);}}));}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageTopLeft__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var SubModule=function(_Component){_inherits(SubModule,_Component);function SubModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SubModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SubModule.__proto__||Object.getPrototypeOf(SubModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:_this.props.disabled},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SubModule,[{key:"render",value:function render(){var _this2=this;var _props=this.props,data=_props.data,index=_props.index,meetingNote=_props.meetingNote,disabled=_props.disabled,styleList=_props.styleList,garmentTypeOption=_props.garmentTypeOption,imageTypeOption=_props.imageTypeOption,meetingNoteID=_props.meetingNoteID,options=_props.options;var mocksOption=[{value:"Embellishment",label:"Embellishment"},{value:"Embroidery",label:"Embroidery"},{value:"Wash",label:"Wash"},{value:"Construction",label:"Construction"}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:{paddingBottom:"2%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 product-form no-padding meeting-notes",style:{marginTop:"3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(){return _this2.props.backToList();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeSketch(index);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 multiple-mm-con no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3",style:{padding:"35px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.props.meetingNote.MNId+" - "+(index+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ImageTopLeft__["a" /* default */],{image:data.sketchImage==undefined?"":data.sketchImage// removeImage={this.props.removeMNoteImage}
,noRemove:true,fileUpload:function fileUpload(files){return _this2.props.changeImg(files,index);},disabled:this.state.disabled,type:"type2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),(data.sampleStyle==="Existing Sample"||data.sampleStyle==="IB"||data.sampleStyle==="Order")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8 step-one no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"magnumStyleNumer"},"Magnum Style Number"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"magnumStyleId",value:data.styleReferenceId,onInputChange:function onInputChange(value){return _this2.props.getStyleInfo(value);},onChange:function onChange(value){return _this2.props.changeStyleInfo(value,index);},onSelectResetsInput:false,placeholder:"Find Style",options:styleList,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 step-one no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"magnumStyleName"},"Magnum Style Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",placeholder:"",name:"styleName",value:data.magnumStyleName,disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 step-one no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"customerRefNumber"},"Customer Ref No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:"customerRefNumber"// value={options
//   .map(x => {
//     return x._id === meetingNote.customer &&
//       x.departmentId ===
//         meetingNote.customerDepartmentId
//       ? `${x.customerName}-${x.departmentName}`
//       : null
//   })
//   .filter(Boolean)}
,value:data.customerRefNumber?data.customerRefNumber:null,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-9"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 mul-check check-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group col-md-2 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"city"},"Sample Style")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"newSample"+index,type:"radio",className:"filled-in hide-all",id:"newSample"+index,checked:data.sampleStyle==="New Sample"&&true,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"newSample"+index,onClick:function onClick(){return _this2.props.selectNewSample(index);}},"New Sample")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"newSample"+index,type:"radio",className:"filled-in hide-all",id:"existingSample"+index,checked:(data.sampleStyle==="Existing Sample"||data.sampleStyle==="IB"||data.sampleStyle==="Order")&&true,disabled:this.state.disabled,onClick:function onClick(){return _this2.props.selectExistingSample(index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"existingSample"+index},"Existing Sample")),(data.sampleStyle==="Existing Sample"||data.sampleStyle==="IB"||data.sampleStyle==="Order")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"IB"+index,type:"radio",className:"filled-in ib",id:"IB"+index,checked:data.sampleStyle==="IB"&&true,onClick:function onClick(){return _this2.props.selectNewIB(index);},disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"IB"+index},"IB")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"IB"+index,type:"radio",className:"filled-in order",id:"order"+index,checked:data.sampleStyle==="Order"&&true,onClick:function onClick(){return _this2.props.selectNewOrder(index);},disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"order"+index},"Order"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline justify-content-end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",inputName:"sampleDeadline",value:data.sampleDeadline?data.sampleDeadline:new Date(),index:index,label:"Sample Deadline",onChange:this.props.updateValue,disabled:this.props.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Block / Historic Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:"blockRefNumber",index:index,placeholder:"",value:data.blockRefNumber,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Block / Historic Ref from"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control",name:"blockRefFrom",index:index,value:data.blockRefFrom,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"select"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Customer Block"},"Customer Block"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Magnum Ref Number"},"Magnum Ref Number"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Development Sample"},"Development Sample")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Sketch"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control",name:"sketch",value:data.sketch,index:index,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Select"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Designer Tech Park"},"Designer Tech Park"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Buyer Tech Park"},"Buyer Tech Park"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Image"},"Image")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"fabric"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",name:"fabric",rows:"4",index:index,cols:"50",placeholder:"",value:data.fabric,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"quality",value:data.quality,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Artwork / Color Ref"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"artwork",value:data.artwork,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"trim"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"trim",value:data.trim,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Fit Comments / Styling Changes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"fitComments",value:data.fitComments,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"wash",value:data.wash,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"print"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"print",value:data.print,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Embroidery"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"embroidery",value:data.embroidery,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Action / Remarks"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{type:"text",className:"form-control",rows:"4",cols:"50",index:index,placeholder:"",name:"remarks",value:data.remarks,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"garment Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"garmentType",value:data.garmentType,index:index,onInputChange:this.props.getGarmentInfo,onChange:function onChange(value){return _this2.props.changeGarmentType(value.value,index);},placeholder:"Find GarmentType",options:garmentTypeOption||[],disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 mul-check"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"city"},"Pending Item from"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:data.pendingItem,options:[{value:"Magnum",label:"Magnum"},{value:"Udare",label:"Udare"},{value:"Buyer",label:"Buyer"}],onChange:function onChange(val){return _this2.props.changePendingItem(val,index);},open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,includeFilter:true,dropdownHeight:300,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 pl-0 mul-check"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"city"},"Mocks"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:data.mocks,options:mocksOption,onChange:function onChange(value){return _this2.props.changeMocks(value,index);},open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,includeFilter:true,dropdownHeight:300,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"})),(data.sampleStyle==="IB"||data.sampleStyle==="Order")&&data.IB!==undefined&&Array.isArray(data.IB)&&data.IB.length>0&&data.IB.map(function(ib,indexVal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ib-select ib order"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 multiple-mm-con no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},indexVal===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib"},"IB/Order"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},indexVal===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"price"),indexVal!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0",index:index,className:"form-control",placeholder:"",value:ib.price,name:"price",onChange:function onChange(e){return _this2.props.ibValueChange(e.target.name,e.target.value,index,indexVal,"IB");},disabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:indexVal!==0?"d-none":""},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0",index:index,className:"form-control",placeholder:"",value:ib.qty,name:"qty",onChange:function onChange(e){return _this2.props.ibValueChange(e.target.name,e.target.value,index,indexVal,"IB");},disabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:indexVal!==0?"d-none":""},"Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"ibDate",value:ib.ibDate?ib.ibDate:"",index:index,onChange:function onChange(name,value){return _this2.props.ibValueChange(name,value,index,indexVal,"IB");},disabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},!_this2.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:indexVal===0?{display:"block"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light green addIB_Shipment",onClick:function onClick(e){return _this2.props.changeIBSize(index,indexVal,"add");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:indexVal!==0?{display:"block"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light red remove-box",id:"remove-box",onClick:function onClick(e){return _this2.props.changeIBSize(index,indexVal,"remove");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"clear"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row nopadding"}));}),(data.sampleStyle==="Order"||data.sampleStyle==="IB")&&data.shipmentDetails!==undefined&&Array.isArray(data.shipmentDetails)&&data.shipmentDetails.length>0&&data.shipmentDetails.map(function(shipment,indexVal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ib-select ib order"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 multiple-mm-con no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-5 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},indexVal===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib"},"ShipmentDetail"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"quantity")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0",className:"form-control",placeholder:"",value:shipment.quantity,name:"quantity",onChange:function onChange(e){return _this2.props.shippingValueChange(e.target.name,e.target.value,indexVal,index);},diabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-5 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},indexVal===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"date",value:shipment.date?shipment.date:"",index:index,onChange:function onChange(name,value){return _this2.props.shippingValueChange(name,value,indexVal,index);},diabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},!_this2.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:indexVal===0?{display:"block"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light green addIB_Shipment",onClick:function onClick(e){return _this2.props.changeShippingSize(index,indexVal,"add");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:indexVal!==0?{display:"block"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light red  remove-box",id:"remove-box",onClick:function onClick(e){return _this2.props.changeShippingSize(index,indexVal,"remove");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"clear"))))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-5 mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"meetingnote",getRefImages:this.props.getRefImages,disabled:disabled,index:index,uploadedDocs:meetingNote.sketches[index].refImages.length>0?meetingNote.sketches[index].refImages:null,imageTypeOption:imageTypeOption?imageTypeOption:[]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 px-5 mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"additionalInfo",className:"active"},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{type:"text",className:"form-control",rows:"4",index:index,cols:"50",name:"additionalInfo",value:data.additionalInfo,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center"},!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary",onClick:function onClick(e){_this2.props.saveMeetingNote(e);// setTimeout(() => this.props.history.goBack(), 700)
}},"Save")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"back",onClick:function onClick(){return _this2.props.backToList();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Generate Style",onClick:this.props.generateStyle}))))))));}}]);return SubModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SubModule);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { withAlert } from 'react-alert'
// import Message from '../../components/Dashboard/Message';
// import MessageRead from '../../components/Dashboard/MessageRead';
var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:'openTab',value:function openTab(evt,tabName){var i,tabcontent,tablinks;tabcontent=document.getElementsByClassName("tabcontent");for(i=0;i<tabcontent.length;i++){tabcontent[i].style.display="none";}tablinks=document.getElementsByClassName("tablinks");for(i=0;i<tablinks.length;i++){tablinks[i].className=tablinks[i].className.replace(" active","");}document.getElementById(tabName).style.display="block";evt.currentTarget.className+=" active";}},{key:'openChat',value:function openChat(evt,chatName){var i,chatcontent,chatlinks;chatcontent=document.getElementsByClassName("chatcontent");for(i=0;i<chatcontent.length;i++){chatcontent[i].style.display="none";}chatlinks=document.getElementsByClassName("chatlinks");for(i=0;i<chatlinks.length;i++){chatlinks[i].className=chatlinks[i].className.replace("selected"," ");}document.getElementById(chatName).style.display="block";evt.currentTarget.className+=" selected";}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'tab col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'class':'tablinks w-50',onClick:function onClick(e){return _this2.openTab(e,"overdue");}},'overdue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'class':'tablinks w-50',onClick:function onClick(e){return _this2.openTab(e,"ontrack");}},'ontrack')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'overdue',style:{display:"block"},'class':'col-md-12 nopadding tabcontent active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':' col-md-8 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'selected chatlinks',onClick:function onClick(e){return _this2.openChat(e,"all");}},'All')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'chatlinks',onClick:function onClick(e){return _this2.openChat(e,"read");}},'Read')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'chatlinks',onClick:function onClick(e){return _this2.openChat(e,"unread");}},'Unread')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'all','class':'chatcontent'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'load-more'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'class':'next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},'Next')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'class':'prev'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'inactive'},'Prev')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section-more'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'activites-card text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Magnum Calendar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'icons icon-calendar'}),' ',__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD MMM YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/calendar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'primary'},'Create Event'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'activites-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Magnum Messenger'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chatNotifyerBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/communication'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Style 36502'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Style 36402'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'11'))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ontrack','class':'tabcontent col-md-12 nopadding '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'ontrack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ontrack is the capital of ontrack.'))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Dashboard);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar_reactwrapper__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar_reactwrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar_reactwrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_fullcalendar_reactwrapper_dist_css_fullcalendar_min_css__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_fullcalendar_reactwrapper_dist_css_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_fullcalendar_reactwrapper_dist_css_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { profilePic } from '../../assets/images/pro1.jpg';
//import { Grid, Image } from 'semantic-ui-react'
var AddNewCustomer=function(_Component){_inherits(AddNewCustomer,_Component);function AddNewCustomer(props){_classCallCheck(this,AddNewCustomer);var _this=_possibleConstructorReturn(this,(AddNewCustomer.__proto__||Object.getPrototypeOf(AddNewCustomer)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};_this.state={events:[{title:'All Day Event',start:'2018-07-01'},{title:'Long Event',start:'2017-05-07',end:'2017-05-10'},{id:999,title:'Repeating Event',start:'2017-05-09T16:00:00'},{id:999,title:'Repeating Event',start:'2017-05-16T16:00:00'},{title:'Conference',start:'2017-05-11',end:'2017-05-13'},{title:'Meeting',start:'2017-05-12T10:30:00',end:'2017-05-12T12:30:00'},{title:'Birthday Party',start:'2017-05-13T07:00:00'},{title:'Click for Google',url:'http://google.com/',start:'2017-05-28'}]};return _this;}_createClass(AddNewCustomer,[{key:'componentDidMount',value:function componentDidMount(){this.enableMultiSelect();}},{key:'enableMultiSelect',value:function enableMultiSelect(){// $(document).ready(function () {
//     $('#range-slct').multiselect();
// });
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'panel calendarPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'example-component'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_fullcalendar_reactwrapper___default.a,{id:'your-custom-ID',header:{left:'prev,next today myCustomButton',center:'title',right:'month,basicWeek,basicDay'},defaultDate:'2018-07-12',navLinks:true// can click day/week names to navigate views
,editable:true,eventLimit:true// allow "more" link when too many events
,events:this.state.events})))))));}}]);return AddNewCustomer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddNewCustomer);{/* <script>
    $(document).ready(function() {
        $('#calendar').fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            defaultDate: '2017-08-22',
            navLinks: true, // can click day/week names to navigate views
            businessHours: true, // display business hours
            editable: true,
            events: [{
                title: 'MAKE NK TAPE',
                start: '2017-09-01T10:35:00',
                End: '2017-09-01T19:35:00',
                color: '#00BCD4'
            }
            ]
        });

    });
   </script> */}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(569));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_122__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(120)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(122);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _fullcalendar = __webpack_require__(119);

var _fullcalendar2 = _interopRequireDefault(_fullcalendar);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _fullcalendarObjectMapper = __webpack_require__(118);

var _fullcalendarObjectMapper2 = _interopRequireDefault(_fullcalendarObjectMapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullCalendar = function (_React$Component) {
	_inherits(FullCalendar, _React$Component);

	function FullCalendar() {
		_classCallCheck(this, FullCalendar);

		var _this = _possibleConstructorReturn(this, (FullCalendar.__proto__ || Object.getPrototypeOf(FullCalendar)).call(this));

		_this.jq = _jquery2.default.noConflict();
		_this.fullcalendarObjectMapper = new _fullcalendarObjectMapper2.default();
		_this.root = null;
		_this.instance = null;
		_this.date = new Date();
		return _this;
	}

	_createClass(FullCalendar, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var objectMapperSettings = this.fullcalendarObjectMapper.getSettings(this.props);
			this.instance = this.jq("#" + this.root).fullCalendar(objectMapperSettings);
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			this.jq("#" + this.root).fullCalendar('destroy');
			var objectMapperSettings = this.fullcalendarObjectMapper.getSettings(nextProps);
			this.instance = this.jq("#" + this.root).fullCalendar(objectMapperSettings);
		}
	}, {
		key: "render",
		value: function render() {
			this.root = this.props.id || 'ID' + this.date.getTime();
			return _react2.default.createElement("div", { id: this.root });
		}
	}]);

	return FullCalendar;
}(_react2.default.Component);

exports.default = FullCalendar;
module.exports = exports["default"];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import fullCalendar from "fullcalendar";

var FullcalendarObjectMapper = function () {
	function FullcalendarObjectMapper() {
		_classCallCheck(this, FullcalendarObjectMapper);
	}

	_createClass(FullcalendarObjectMapper, [{
		key: "getSettings",
		value: function getSettings(properties) {
			var newSettings = {};
			for (var key in properties) {
				if (properties.hasOwnProperty(key)) {
					newSettings[key] = properties[key];
				}
			}
			return newSettings;
		}
	}]);

	return FullcalendarObjectMapper;
}();

exports.default = FullcalendarObjectMapper;
module.exports = exports["default"];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * FullCalendar v3.4.0
 * Docs & License: https://fullcalendar.io/
 * (c) 2017 Adam Shaw
 */

(function(factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1), __webpack_require__(0) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof exports === 'object') { // Node/CommonJS
		module.exports = factory(require('jquery'), require('moment'));
	}
	else {
		factory(jQuery, moment);
	}
})(function($, moment) {

;;

var FC = $.fullCalendar = {
	version: "3.4.0",
	// When introducing internal API incompatibilities (where fullcalendar plugins would break),
	// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
	// and the below integer should be incremented.
	internalApiVersion: 9
};
var fcViews = FC.views = {};


$.fn.fullCalendar = function(options) {
	var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
	var res = this; // what this function will return (this jQuery object by default)

	this.each(function(i, _element) { // loop each DOM element involved
		var element = $(_element);
		var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
		var singleRes; // the returned value of this single method call

		// a method call
		if (typeof options === 'string') {
			if (calendar && $.isFunction(calendar[options])) {
				singleRes = calendar[options].apply(calendar, args);
				if (!i) {
					res = singleRes; // record the first method call result
				}
				if (options === 'destroy') { // for the destroy method, must remove Calendar object data
					element.removeData('fullCalendar');
				}
			}
		}
		// a new calendar initialization
		else if (!calendar) { // don't initialize twice
			calendar = new Calendar(element, options);
			element.data('fullCalendar', calendar);
			calendar.render();
		}
	});

	return res;
};


var complexOptions = [ // names of options that are objects whose properties should be combined
	'header',
	'footer',
	'buttonText',
	'buttonIcons',
	'themeButtonIcons'
];


// Merges an array of option objects into a single object
function mergeOptions(optionObjs) {
	return mergeProps(optionObjs, complexOptions);
}

;;

// exports
FC.intersectRanges = intersectRanges;
FC.applyAll = applyAll;
FC.debounce = debounce;
FC.isInt = isInt;
FC.htmlEscape = htmlEscape;
FC.cssToStr = cssToStr;
FC.proxy = proxy;
FC.capitaliseFirstLetter = capitaliseFirstLetter;


/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/


// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
function compensateScroll(rowEls, scrollbarWidths) {
	if (scrollbarWidths.left) {
		rowEls.css({
			'border-left-width': 1,
			'margin-left': scrollbarWidths.left - 1
		});
	}
	if (scrollbarWidths.right) {
		rowEls.css({
			'border-right-width': 1,
			'margin-right': scrollbarWidths.right - 1
		});
	}
}


// Undoes compensateScroll and restores all borders/margins
function uncompensateScroll(rowEls) {
	rowEls.css({
		'margin-left': '',
		'margin-right': '',
		'border-left-width': '',
		'border-right-width': ''
	});
}


// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
	$('body').addClass('fc-not-allowed');
}


// Returns the mouse cursor to its original look
function enableCursor() {
	$('body').removeClass('fc-not-allowed');
}


// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and 
// reduces the available height.
function distributeHeight(els, availableHeight, shouldRedistribute) {

	// *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
	// and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.

	var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
	var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
	var flexEls = []; // elements that are allowed to expand. array of DOM nodes
	var flexOffsets = []; // amount of vertical space it takes up
	var flexHeights = []; // actual css height
	var usedHeight = 0;

	undistributeHeight(els); // give all elements their natural height

	// find elements that are below the recommended height (expandable).
	// important to query for heights in a single first pass (to avoid reflow oscillation).
	els.each(function(i, el) {
		var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
		var naturalOffset = $(el).outerHeight(true);

		if (naturalOffset < minOffset) {
			flexEls.push(el);
			flexOffsets.push(naturalOffset);
			flexHeights.push($(el).height());
		}
		else {
			// this element stretches past recommended height (non-expandable). mark the space as occupied.
			usedHeight += naturalOffset;
		}
	});

	// readjust the recommended height to only consider the height available to non-maxed-out rows.
	if (shouldRedistribute) {
		availableHeight -= usedHeight;
		minOffset1 = Math.floor(availableHeight / flexEls.length);
		minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
	}

	// assign heights to all expandable elements
	$(flexEls).each(function(i, el) {
		var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
		var naturalOffset = flexOffsets[i];
		var naturalHeight = flexHeights[i];
		var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding

		if (naturalOffset < minOffset) { // we check this again because redistribution might have changed things
			$(el).height(newHeight);
		}
	});
}


// Undoes distrubuteHeight, restoring all els to their natural height
function undistributeHeight(els) {
	els.height('');
}


// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
// cells to be that width.
// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
function matchCellWidths(els) {
	var maxInnerWidth = 0;

	els.find('> *').each(function(i, innerEl) {
		var innerWidth = $(innerEl).outerWidth();
		if (innerWidth > maxInnerWidth) {
			maxInnerWidth = innerWidth;
		}
	});

	maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance

	els.width(maxInnerWidth);

	return maxInnerWidth;
}


// Given one element that resides inside another,
// Subtracts the height of the inner element from the outer element.
function subtractInnerElHeight(outerEl, innerEl) {
	var both = outerEl.add(innerEl);
	var diff;

	// effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
	both.css({
		position: 'relative', // cause a reflow, which will force fresh dimension recalculation
		left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
	});
	diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
	both.css({ position: '', left: '' }); // undo hack

	return diff;
}


/* Element Geom Utilities
----------------------------------------------------------------------------------------------------------------------*/

FC.getOuterRect = getOuterRect;
FC.getClientRect = getClientRect;
FC.getContentRect = getContentRect;
FC.getScrollbarWidths = getScrollbarWidths;


// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
function getScrollParent(el) {
	var position = el.css('position'),
		scrollParent = el.parents().filter(function() {
			var parent = $(this);
			return (/(auto|scroll)/).test(
				parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x')
			);
		}).eq(0);

	return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
}


// Queries the outer bounding area of a jQuery element.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getOuterRect(el, origin) {
	var offset = el.offset();
	var left = offset.left - (origin ? origin.left : 0);
	var top = offset.top - (origin ? origin.top : 0);

	return {
		left: left,
		right: left + el.outerWidth(),
		top: top,
		bottom: top + el.outerHeight()
	};
}


// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
// WARNING: given element can't have borders
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getClientRect(el, origin) {
	var offset = el.offset();
	var scrollbarWidths = getScrollbarWidths(el);
	var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
	var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);

	return {
		left: left,
		right: left + el[0].clientWidth, // clientWidth includes padding but NOT scrollbars
		top: top,
		bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
	};
}


// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getContentRect(el, origin) {
	var offset = el.offset(); // just outside of border, margin not included
	var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
		(origin ? origin.left : 0);
	var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
		(origin ? origin.top : 0);

	return {
		left: left,
		right: left + el.width(),
		top: top,
		bottom: top + el.height()
	};
}


// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
// WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getScrollbarWidths(el) {
	var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
	var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
	var widths;

	leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
	bottomWidth = sanitizeScrollbarWidth(bottomWidth);

	widths = { left: 0, right: 0, top: 0, bottom: bottomWidth };

	if (getIsLeftRtlScrollbars() && el.css('direction') == 'rtl') { // is the scrollbar on the left side?
		widths.left = leftRightWidth;
	}
	else {
		widths.right = leftRightWidth;
	}

	return widths;
}


// The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
// retina displays, rounding, and IE11. Massage them into a usable value.
function sanitizeScrollbarWidth(width) {
	width = Math.max(0, width); // no negatives
	width = Math.round(width);
	return width;
}


// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side

var _isLeftRtlScrollbars = null;

function getIsLeftRtlScrollbars() { // responsible for caching the computation
	if (_isLeftRtlScrollbars === null) {
		_isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
	}
	return _isLeftRtlScrollbars;
}

function computeIsLeftRtlScrollbars() { // creates an offscreen test element, then removes it
	var el = $('<div><div/></div>')
		.css({
			position: 'absolute',
			top: -1000,
			left: 0,
			border: 0,
			padding: 0,
			overflow: 'scroll',
			direction: 'rtl'
		})
		.appendTo('body');
	var innerEl = el.children();
	var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
	el.remove();
	return res;
}


// Retrieves a jQuery element's computed CSS value as a floating-point number.
// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
function getCssFloat(el, prop) {
	return parseFloat(el.css(prop)) || 0;
}


/* Mouse / Touch Utilities
----------------------------------------------------------------------------------------------------------------------*/

FC.preventDefault = preventDefault;


// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
	return ev.which == 1 && !ev.ctrlKey;
}


function getEvX(ev) {
	var touches = ev.originalEvent.touches;

	// on mobile FF, pageX for touch events is present, but incorrect,
	// so, look at touch coordinates first.
	if (touches && touches.length) {
		return touches[0].pageX;
	}

	return ev.pageX;
}


function getEvY(ev) {
	var touches = ev.originalEvent.touches;

	// on mobile FF, pageX for touch events is present, but incorrect,
	// so, look at touch coordinates first.
	if (touches && touches.length) {
		return touches[0].pageY;
	}

	return ev.pageY;
}


function getEvIsTouch(ev) {
	return /^touch/.test(ev.type);
}


function preventSelection(el) {
	el.addClass('fc-unselectable')
		.on('selectstart', preventDefault);
}


function allowSelection(el) {
	el.removeClass('fc-unselectable')
		.off('selectstart', preventDefault);
}


// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
	ev.preventDefault();
}


/* General Geometry Utils
----------------------------------------------------------------------------------------------------------------------*/

FC.intersectRects = intersectRects;

// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
	var res = {
		left: Math.max(rect1.left, rect2.left),
		right: Math.min(rect1.right, rect2.right),
		top: Math.max(rect1.top, rect2.top),
		bottom: Math.min(rect1.bottom, rect2.bottom)
	};

	if (res.left < res.right && res.top < res.bottom) {
		return res;
	}
	return false;
}


// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
	return {
		left: Math.min(Math.max(point.left, rect.left), rect.right),
		top: Math.min(Math.max(point.top, rect.top), rect.bottom)
	};
}


// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
	return {
		left: (rect.left + rect.right) / 2,
		top: (rect.top + rect.bottom) / 2
	};
}


// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
	return {
		left: point1.left - point2.left,
		top: point1.top - point2.top
	};
}


/* Object Ordering by Field
----------------------------------------------------------------------------------------------------------------------*/

FC.parseFieldSpecs = parseFieldSpecs;
FC.compareByFieldSpecs = compareByFieldSpecs;
FC.compareByFieldSpec = compareByFieldSpec;
FC.flexibleCompare = flexibleCompare;


function parseFieldSpecs(input) {
	var specs = [];
	var tokens = [];
	var i, token;

	if (typeof input === 'string') {
		tokens = input.split(/\s*,\s*/);
	}
	else if (typeof input === 'function') {
		tokens = [ input ];
	}
	else if ($.isArray(input)) {
		tokens = input;
	}

	for (i = 0; i < tokens.length; i++) {
		token = tokens[i];

		if (typeof token === 'string') {
			specs.push(
				token.charAt(0) == '-' ?
					{ field: token.substring(1), order: -1 } :
					{ field: token, order: 1 }
			);
		}
		else if (typeof token === 'function') {
			specs.push({ func: token });
		}
	}

	return specs;
}


function compareByFieldSpecs(obj1, obj2, fieldSpecs) {
	var i;
	var cmp;

	for (i = 0; i < fieldSpecs.length; i++) {
		cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i]);
		if (cmp) {
			return cmp;
		}
	}

	return 0;
}


function compareByFieldSpec(obj1, obj2, fieldSpec) {
	if (fieldSpec.func) {
		return fieldSpec.func(obj1, obj2);
	}
	return flexibleCompare(obj1[fieldSpec.field], obj2[fieldSpec.field]) *
		(fieldSpec.order || 1);
}


function flexibleCompare(a, b) {
	if (!a && !b) {
		return 0;
	}
	if (b == null) {
		return -1;
	}
	if (a == null) {
		return 1;
	}
	if ($.type(a) === 'string' || $.type(b) === 'string') {
		return String(a).localeCompare(String(b));
	}
	return a - b;
}


/* FullCalendar-specific Misc Utilities
----------------------------------------------------------------------------------------------------------------------*/


// Computes the intersection of the two ranges. Will return fresh date clones in a range.
// Returns undefined if no intersection.
// Expects all dates to be normalized to the same timezone beforehand.
// TODO: move to date section?
function intersectRanges(subjectRange, constraintRange) {
	var subjectStart = subjectRange.start;
	var subjectEnd = subjectRange.end;
	var constraintStart = constraintRange.start;
	var constraintEnd = constraintRange.end;
	var segStart, segEnd;
	var isStart, isEnd;

	if (subjectEnd > constraintStart && subjectStart < constraintEnd) { // in bounds at all?

		if (subjectStart >= constraintStart) {
			segStart = subjectStart.clone();
			isStart = true;
		}
		else {
			segStart = constraintStart.clone();
			isStart =  false;
		}

		if (subjectEnd <= constraintEnd) {
			segEnd = subjectEnd.clone();
			isEnd = true;
		}
		else {
			segEnd = constraintEnd.clone();
			isEnd = false;
		}

		return {
			start: segStart,
			end: segEnd,
			isStart: isStart,
			isEnd: isEnd
		};
	}
}


/* Date Utilities
----------------------------------------------------------------------------------------------------------------------*/

FC.computeGreatestUnit = computeGreatestUnit;
FC.divideRangeByDuration = divideRangeByDuration;
FC.divideDurationByDuration = divideDurationByDuration;
FC.multiplyDuration = multiplyDuration;
FC.durationHasTime = durationHasTime;

var dayIDs = [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat' ];
var unitsDesc = [ 'year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond' ]; // descending


// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
// Moments will have their timezones normalized.
function diffDayTime(a, b) {
	return moment.duration({
		days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
		ms: a.time() - b.time() // time-of-day from day start. disregards timezone
	});
}


// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
function diffDay(a, b) {
	return moment.duration({
		days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
	});
}


// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
function diffByUnit(a, b, unit) {
	return moment.duration(
		Math.round(a.diff(b, unit, true)), // returnFloat=true
		unit
	);
}


// Computes the unit name of the largest whole-unit period of time.
// For example, 48 hours will be "days" whereas 49 hours will be "hours".
// Accepts start/end, a range object, or an original duration object.
function computeGreatestUnit(start, end) {
	var i, unit;
	var val;

	for (i = 0; i < unitsDesc.length; i++) {
		unit = unitsDesc[i];
		val = computeRangeAs(unit, start, end);

		if (val >= 1 && isInt(val)) {
			break;
		}
	}

	return unit; // will be "milliseconds" if nothing else matches
}


// like computeGreatestUnit, but has special abilities to interpret the source input for clues
function computeDurationGreatestUnit(duration, durationInput) {
	var unit = computeGreatestUnit(duration);

	// prevent days:7 from being interpreted as a week
	if (unit === 'week' && typeof durationInput === 'object' && durationInput.days) {
		unit = 'day';
	}

	return unit;
}


// Computes the number of units (like "hours") in the given range.
// Range can be a {start,end} object, separate start/end args, or a Duration.
// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
// of month-diffing logic (which tends to vary from version to version).
function computeRangeAs(unit, start, end) {

	if (end != null) { // given start, end
		return end.diff(start, unit, true);
	}
	else if (moment.isDuration(start)) { // given duration
		return start.as(unit);
	}
	else { // given { start, end } range object
		return start.end.diff(start.start, unit, true);
	}
}


// Intelligently divides a range (specified by a start/end params) by a duration
function divideRangeByDuration(start, end, dur) {
	var months;

	if (durationHasTime(dur)) {
		return (end - start) / dur;
	}
	months = dur.asMonths();
	if (Math.abs(months) >= 1 && isInt(months)) {
		return end.diff(start, 'months', true) / months;
	}
	return end.diff(start, 'days', true) / dur.asDays();
}


// Intelligently divides one duration by another
function divideDurationByDuration(dur1, dur2) {
	var months1, months2;

	if (durationHasTime(dur1) || durationHasTime(dur2)) {
		return dur1 / dur2;
	}
	months1 = dur1.asMonths();
	months2 = dur2.asMonths();
	if (
		Math.abs(months1) >= 1 && isInt(months1) &&
		Math.abs(months2) >= 1 && isInt(months2)
	) {
		return months1 / months2;
	}
	return dur1.asDays() / dur2.asDays();
}


// Intelligently multiplies a duration by a number
function multiplyDuration(dur, n) {
	var months;

	if (durationHasTime(dur)) {
		return moment.duration(dur * n);
	}
	months = dur.asMonths();
	if (Math.abs(months) >= 1 && isInt(months)) {
		return moment.duration({ months: months * n });
	}
	return moment.duration({ days: dur.asDays() * n });
}


function cloneRange(range) {
	return {
		start: range.start.clone(),
		end: range.end.clone()
	};
}


// Trims the beginning and end of inner range to be completely within outerRange.
// Returns a new range object.
function constrainRange(innerRange, outerRange) {
	innerRange = cloneRange(innerRange);

	if (outerRange.start) {
		// needs to be inclusively before outerRange's end
		innerRange.start = constrainDate(innerRange.start, outerRange);
	}

	if (outerRange.end) {
		innerRange.end = minMoment(innerRange.end, outerRange.end);
	}

	return innerRange;
}


// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
// Always returns a new moment.
function constrainDate(date, range) {
	date = date.clone();

	if (range.start) {
		date = maxMoment(date, range.start);
	}

	if (range.end && date >= range.end) {
		date = range.end.clone().subtract(1);
	}

	return date;
}


function isDateWithinRange(date, range) {
	return (!range.start || date >= range.start) &&
		(!range.end || date < range.end);
}


// TODO: deal with repeat code in intersectRanges
// constraintRange can have unspecified start/end, an open-ended range.
function doRangesIntersect(subjectRange, constraintRange) {
	return (!constraintRange.start || subjectRange.end >= constraintRange.start) &&
		(!constraintRange.end || subjectRange.start < constraintRange.end);
}


function isRangeWithinRange(innerRange, outerRange) {
	return (!outerRange.start || innerRange.start >= outerRange.start) &&
		(!outerRange.end || innerRange.end <= outerRange.end);
}


function isRangesEqual(range0, range1) {
	return ((range0.start && range1.start && range0.start.isSame(range1.start)) || (!range0.start && !range1.start)) &&
		((range0.end && range1.end && range0.end.isSame(range1.end)) || (!range0.end && !range1.end));
}


// Returns the moment that's earlier in time. Always a copy.
function minMoment(mom1, mom2) {
	return (mom1.isBefore(mom2) ? mom1 : mom2).clone();
}


// Returns the moment that's later in time. Always a copy.
function maxMoment(mom1, mom2) {
	return (mom1.isAfter(mom2) ? mom1 : mom2).clone();
}


// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
function durationHasTime(dur) {
	return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
}


function isNativeDate(input) {
	return  Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
}


// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
function isTimeString(str) {
	return /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
}


/* Logging and Debug
----------------------------------------------------------------------------------------------------------------------*/

FC.log = function() {
	var console = window.console;

	if (console && console.log) {
		return console.log.apply(console, arguments);
	}
};

FC.warn = function() {
	var console = window.console;

	if (console && console.warn) {
		return console.warn.apply(console, arguments);
	}
	else {
		return FC.log.apply(FC, arguments);
	}
};


/* General Utilities
----------------------------------------------------------------------------------------------------------------------*/

var hasOwnPropMethod = {}.hasOwnProperty;


// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexProps) {
	var dest = {};
	var i, name;
	var complexObjs;
	var j, val;
	var props;

	if (complexProps) {
		for (i = 0; i < complexProps.length; i++) {
			name = complexProps[i];
			complexObjs = [];

			// collect the trailing object values, stopping when a non-object is discovered
			for (j = propObjs.length - 1; j >= 0; j--) {
				val = propObjs[j][name];

				if (typeof val === 'object') {
					complexObjs.unshift(val);
				}
				else if (val !== undefined) {
					dest[name] = val; // if there were no objects, this value will be used
					break;
				}
			}

			// if the trailing values were objects, use the merged value
			if (complexObjs.length) {
				dest[name] = mergeProps(complexObjs);
			}
		}
	}

	// copy values into the destination, going from last to first
	for (i = propObjs.length - 1; i >= 0; i--) {
		props = propObjs[i];

		for (name in props) {
			if (!(name in dest)) { // if already assigned by previous props or complex props, don't reassign
				dest[name] = props[name];
			}
		}
	}

	return dest;
}


// Create an object that has the given prototype. Just like Object.create
function createObject(proto) {
	var f = function() {};
	f.prototype = proto;
	return new f();
}
FC.createObject = createObject;


function copyOwnProps(src, dest) {
	for (var name in src) {
		if (hasOwnProp(src, name)) {
			dest[name] = src[name];
		}
	}
}


function hasOwnProp(obj, name) {
	return hasOwnPropMethod.call(obj, name);
}


// Is the given value a non-object non-function value?
function isAtomic(val) {
	return /undefined|null|boolean|number|string/.test($.type(val));
}


function applyAll(functions, thisObj, args) {
	if ($.isFunction(functions)) {
		functions = [ functions ];
	}
	if (functions) {
		var i;
		var ret;
		for (i=0; i<functions.length; i++) {
			ret = functions[i].apply(thisObj, args) || ret;
		}
		return ret;
	}
}


function firstDefined() {
	for (var i=0; i<arguments.length; i++) {
		if (arguments[i] !== undefined) {
			return arguments[i];
		}
	}
}


function htmlEscape(s) {
	return (s + '').replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/'/g, '&#039;')
		.replace(/"/g, '&quot;')
		.replace(/\n/g, '<br />');
}


function stripHtmlEntities(text) {
	return text.replace(/&.*?;/g, '');
}


// Given a hash of CSS properties, returns a string of CSS.
// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
function cssToStr(cssProps) {
	var statements = [];

	$.each(cssProps, function(name, val) {
		if (val != null) {
			statements.push(name + ':' + val);
		}
	});

	return statements.join(';');
}


// Given an object hash of HTML attribute names to values,
// generates a string that can be injected between < > in HTML
function attrsToStr(attrs) {
	var parts = [];

	$.each(attrs, function(name, val) {
		if (val != null) {
			parts.push(name + '="' + htmlEscape(val) + '"');
		}
	});

	return parts.join(' ');
}


function capitaliseFirstLetter(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}


function compareNumbers(a, b) { // for .sort()
	return a - b;
}


function isInt(n) {
	return n % 1 === 0;
}


// Returns a method bound to the given object context.
// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
// different contexts as identical when binding/unbinding events.
function proxy(obj, methodName) {
	var method = obj[methodName];

	return function() {
		return method.apply(obj, arguments);
	};
}


// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
function debounce(func, wait, immediate) {
	var timeout, args, context, timestamp, result;

	var later = function() {
		var last = +new Date() - timestamp;
		if (last < wait) {
			timeout = setTimeout(later, wait - last);
		}
		else {
			timeout = null;
			if (!immediate) {
				result = func.apply(context, args);
				context = args = null;
			}
		}
	};

	return function() {
		context = this;
		args = arguments;
		timestamp = +new Date();
		var callNow = immediate && !timeout;
		if (!timeout) {
			timeout = setTimeout(later, wait);
		}
		if (callNow) {
			result = func.apply(context, args);
			context = args = null;
		}
		return result;
	};
}

;;

/*
GENERAL NOTE on moments throughout the *entire rest* of the codebase:
All moments are assumed to be ambiguously-zoned unless otherwise noted,
with the NOTABLE EXCEOPTION of start/end dates that live on *Event Objects*.
Ambiguously-TIMED moments are assumed to be ambiguously-zoned by nature.
*/

var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
var ambigTimeOrZoneRegex =
	/^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
var newMomentProto = moment.fn; // where we will attach our new methods
var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods

// tell momentjs to transfer these properties upon clone
var momentProperties = moment.momentProperties;
momentProperties.push('_fullCalendar');
momentProperties.push('_ambigTime');
momentProperties.push('_ambigZone');


// Creating
// -------------------------------------------------------------------------------------------------

// Creates a new moment, similar to the vanilla moment(...) constructor, but with
// extra features (ambiguous time, enhanced formatting). When given an existing moment,
// it will function as a clone (and retain the zone of the moment). Anything else will
// result in a moment in the local zone.
FC.moment = function() {
	return makeMoment(arguments);
};

// Sames as FC.moment, but forces the resulting moment to be in the UTC timezone.
FC.moment.utc = function() {
	var mom = makeMoment(arguments, true);

	// Force it into UTC because makeMoment doesn't guarantee it
	// (if given a pre-existing moment for example)
	if (mom.hasTime()) { // don't give ambiguously-timed moments a UTC zone
		mom.utc();
	}

	return mom;
};

// Same as FC.moment, but when given an ISO8601 string, the timezone offset is preserved.
// ISO8601 strings with no timezone offset will become ambiguously zoned.
FC.moment.parseZone = function() {
	return makeMoment(arguments, true, true);
};

// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
// native Date, or called with no arguments (the current time), the resulting moment will be local.
// Anything else needs to be "parsed" (a string or an array), and will be affected by:
//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
//    parseZone - if there is zone information, should we force the zone of the moment?
function makeMoment(args, parseAsUTC, parseZone) {
	var input = args[0];
	var isSingleString = args.length == 1 && typeof input === 'string';
	var isAmbigTime;
	var isAmbigZone;
	var ambigMatch;
	var mom;

	if (moment.isMoment(input) || isNativeDate(input) || input === undefined) {
		mom = moment.apply(null, args);
	}
	else { // "parsing" is required
		isAmbigTime = false;
		isAmbigZone = false;

		if (isSingleString) {
			if (ambigDateOfMonthRegex.test(input)) {
				// accept strings like '2014-05', but convert to the first of the month
				input += '-01';
				args = [ input ]; // for when we pass it on to moment's constructor
				isAmbigTime = true;
				isAmbigZone = true;
			}
			else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
				isAmbigTime = !ambigMatch[5]; // no time part?
				isAmbigZone = true;
			}
		}
		else if ($.isArray(input)) {
			// arrays have no timezone information, so assume ambiguous zone
			isAmbigZone = true;
		}
		// otherwise, probably a string with a format

		if (parseAsUTC || isAmbigTime) {
			mom = moment.utc.apply(moment, args);
		}
		else {
			mom = moment.apply(null, args);
		}

		if (isAmbigTime) {
			mom._ambigTime = true;
			mom._ambigZone = true; // ambiguous time always means ambiguous zone
		}
		else if (parseZone) { // let's record the inputted zone somehow
			if (isAmbigZone) {
				mom._ambigZone = true;
			}
			else if (isSingleString) {
				mom.utcOffset(input); // if not a valid zone, will assign UTC
			}
		}
	}

	mom._fullCalendar = true; // flag for extended functionality

	return mom;
}


// Week Number
// -------------------------------------------------------------------------------------------------


// Returns the week number, considering the locale's custom week number calcuation
// `weeks` is an alias for `week`
newMomentProto.week = newMomentProto.weeks = function(input) {
	var weekCalc = this._locale._fullCalendar_weekCalc;

	if (input == null && typeof weekCalc === 'function') { // custom function only works for getter
		return weekCalc(this);
	}
	else if (weekCalc === 'ISO') {
		return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
	}

	return oldMomentProto.week.apply(this, arguments); // local getter/setter
};


// Time-of-day
// -------------------------------------------------------------------------------------------------

// GETTER
// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
// If the moment has an ambiguous time, a duration of 00:00 will be returned.
//
// SETTER
// You can supply a Duration, a Moment, or a Duration-like argument.
// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
newMomentProto.time = function(time) {

	// Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
	// `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
	if (!this._fullCalendar) {
		return oldMomentProto.time.apply(this, arguments);
	}

	if (time == null) { // getter
		return moment.duration({
			hours: this.hours(),
			minutes: this.minutes(),
			seconds: this.seconds(),
			milliseconds: this.milliseconds()
		});
	}
	else { // setter

		this._ambigTime = false; // mark that the moment now has a time

		if (!moment.isDuration(time) && !moment.isMoment(time)) {
			time = moment.duration(time);
		}

		// The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
		// Only for Duration times, not Moment times.
		var dayHours = 0;
		if (moment.isDuration(time)) {
			dayHours = Math.floor(time.asDays()) * 24;
		}

		// We need to set the individual fields.
		// Can't use startOf('day') then add duration. In case of DST at start of day.
		return this.hours(dayHours + time.hours())
			.minutes(time.minutes())
			.seconds(time.seconds())
			.milliseconds(time.milliseconds());
	}
};

// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
// but preserving its YMD. A moment with a stripped time will display no time
// nor timezone offset when .format() is called.
newMomentProto.stripTime = function() {

	if (!this._ambigTime) {

		this.utc(true); // keepLocalTime=true (for keeping *date* value)

		// set time to zero
		this.set({
			hours: 0,
			minutes: 0,
			seconds: 0,
			ms: 0
		});

		// Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
		// which clears all ambig flags.
		this._ambigTime = true;
		this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
	}

	return this; // for chaining
};

// Returns if the moment has a non-ambiguous time (boolean)
newMomentProto.hasTime = function() {
	return !this._ambigTime;
};


// Timezone
// -------------------------------------------------------------------------------------------------

// Converts the moment to UTC, stripping out its timezone offset, but preserving its
// YMD and time-of-day. A moment with a stripped timezone offset will display no
// timezone offset when .format() is called.
newMomentProto.stripZone = function() {
	var wasAmbigTime;

	if (!this._ambigZone) {

		wasAmbigTime = this._ambigTime;

		this.utc(true); // keepLocalTime=true (for keeping date and time values)

		// the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
		this._ambigTime = wasAmbigTime || false;

		// Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
		// which clears the ambig flags.
		this._ambigZone = true;
	}

	return this; // for chaining
};

// Returns of the moment has a non-ambiguous timezone offset (boolean)
newMomentProto.hasZone = function() {
	return !this._ambigZone;
};


// implicitly marks a zone
newMomentProto.local = function(keepLocalTime) {

	// for when converting from ambiguously-zoned to local,
	// keep the time values when converting from UTC -> local
	oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);

	// ensure non-ambiguous
	// this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
	this._ambigTime = false;
	this._ambigZone = false;

	return this; // for chaining
};


// implicitly marks a zone
newMomentProto.utc = function(keepLocalTime) {

	oldMomentProto.utc.call(this, keepLocalTime);

	// ensure non-ambiguous
	// this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
	this._ambigTime = false;
	this._ambigZone = false;

	return this;
};


// implicitly marks a zone (will probably get called upon .utc() and .local())
newMomentProto.utcOffset = function(tzo) {

	if (tzo != null) { // setter
		// these assignments needs to happen before the original zone method is called.
		// I forget why, something to do with a browser crash.
		this._ambigTime = false;
		this._ambigZone = false;
	}

	return oldMomentProto.utcOffset.apply(this, arguments);
};


// Formatting
// -------------------------------------------------------------------------------------------------

newMomentProto.format = function() {

	if (this._fullCalendar && arguments[0]) { // an enhanced moment? and a format string provided?
		return formatDate(this, arguments[0]); // our extended formatting
	}
	if (this._ambigTime) {
		return oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	}
	if (this._ambigZone) {
		return oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	}
	if (this._fullCalendar) { // enhanced non-ambig moment?
		// moment.format() doesn't ensure english, but we want to.
		return oldMomentFormat(englishMoment(this));
	}

	return oldMomentProto.format.apply(this, arguments);
};

newMomentProto.toISOString = function() {

	if (this._ambigTime) {
		return oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	}
	if (this._ambigZone) {
		return oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	}
	if (this._fullCalendar) { // enhanced non-ambig moment?
		// depending on browser, moment might not output english. ensure english.
		// https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
		return oldMomentProto.toISOString.apply(englishMoment(this), arguments);
	}

	return oldMomentProto.toISOString.apply(this, arguments);
};

function englishMoment(mom) {
	if (mom.locale() !== 'en') {
		return mom.clone().locale('en');
	}
	return mom;
}

;;
(function() {

// exports
FC.formatDate = formatDate;
FC.formatRange = formatRange;
FC.oldMomentFormat = oldMomentFormat;
FC.queryMostGranularFormatUnit = queryMostGranularFormatUnit;


// Config
// ---------------------------------------------------------------------------------------------------------------------

/*
Inserted between chunks in the fake ("intermediate") formatting string.
Important that it passes as whitespace (\s) because moment often identifies non-standalone months
via a regexp with an \s.
*/
var PART_SEPARATOR = '\u000b'; // vertical tab

/*
Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
but rather, a "special" token that has custom rendering (see specialTokens map).
*/
var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1

/*
Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
Handling of these markers is done in a post-processing step at the very end of text rendering.
*/
var MAYBE_MARKER = '\u001e'; // information separator 2
var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global

/*
Addition formatting tokens we want recognized
*/
var specialTokens = {
	t: function(date) { // "a" or "p"
		return oldMomentFormat(date, 'a').charAt(0);
	},
	T: function(date) { // "A" or "P"
		return oldMomentFormat(date, 'A').charAt(0);
	}
};

/*
The first characters of formatting tokens for units that are 1 day or larger.
`value` is for ranking relative size (lower means bigger).
`unit` is a normalized unit, used for comparing moments.
*/
var largeTokenMap = {
	Y: { value: 1, unit: 'year' },
	M: { value: 2, unit: 'month' },
	W: { value: 3, unit: 'week' }, // ISO week
	w: { value: 3, unit: 'week' }, // local week
	D: { value: 4, unit: 'day' }, // day of month
	d: { value: 4, unit: 'day' } // day of week
};


// Single Date Formatting
// ---------------------------------------------------------------------------------------------------------------------

/*
Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
*/
function formatDate(date, formatStr) {
	return renderFakeFormatString(
		getParsedFormatString(formatStr).fakeFormatString,
		date
	);
}

/*
Call this if you want Moment's original format method to be used
*/
function oldMomentFormat(mom, formatStr) {
	return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
}


// Date Range Formatting
// -------------------------------------------------------------------------------------------------
// TODO: make it work with timezone offset

/*
Using a formatting string meant for a single date, generate a range string, like
"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
If the dates are the same as far as the format string is concerned, just return a single
rendering of one date, without any separator.
*/
function formatRange(date1, date2, formatStr, separator, isRTL) {
	var localeData;

	date1 = FC.moment.parseZone(date1);
	date2 = FC.moment.parseZone(date2);

	localeData = date1.localeData();

	// Expand localized format strings, like "LL" -> "MMMM D YYYY".
	// BTW, this is not important for `formatDate` because it is impossible to put custom tokens
	// or non-zero areas in Moment's localized format strings.
	formatStr = localeData.longDateFormat(formatStr) || formatStr;

	return renderParsedFormat(
		getParsedFormatString(formatStr),
		date1,
		date2,
		separator || ' - ',
		isRTL
	);
}

/*
Renders a range with an already-parsed format string.
*/
function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
	var sameUnits = parsedFormat.sameUnits;
	var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
	var unzonedDate2 = date2.clone().stripZone(); // "

	var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
	var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);

	var leftI;
	var leftStr = '';
	var rightI;
	var rightStr = '';
	var middleI;
	var middleStr1 = '';
	var middleStr2 = '';
	var middleStr = '';

	// Start at the leftmost side of the formatting string and continue until you hit a token
	// that is not the same between dates.
	for (
		leftI = 0;
		leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI]));
		leftI++
	) {
		leftStr += renderedParts1[leftI];
	}

	// Similarly, start at the rightmost side of the formatting string and move left
	for (
		rightI = sameUnits.length - 1;
		rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI]));
		rightI--
	) {
		// If current chunk is on the boundary of unique date-content, and is a special-case
		// date-formatting postfix character, then don't consume it. Consider it unique date-content.
		// TODO: make configurable
		if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
			break;
		}

		rightStr = renderedParts1[rightI] + rightStr;
	}

	// The area in the middle is different for both of the dates.
	// Collect them distinctly so we can jam them together later.
	for (middleI = leftI; middleI <= rightI; middleI++) {
		middleStr1 += renderedParts1[middleI];
		middleStr2 += renderedParts2[middleI];
	}

	if (middleStr1 || middleStr2) {
		if (isRTL) {
			middleStr = middleStr2 + separator + middleStr1;
		}
		else {
			middleStr = middleStr1 + separator + middleStr2;
		}
	}

	return processMaybeMarkers(
		leftStr + middleStr + rightStr
	);
}


// Format String Parsing
// ---------------------------------------------------------------------------------------------------------------------

var parsedFormatStrCache = {};

/*
Returns a parsed format string, leveraging a cache.
*/
function getParsedFormatString(formatStr) {
	return parsedFormatStrCache[formatStr] ||
		(parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
}

/*
Parses a format string into the following:
- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
  that indicates how similar a range's start & end must be in order to share the same formatted text.
  If not a token, then the value is null.
  Always a flat array (not nested liked "chunks").
*/
function parseFormatString(formatStr) {
	var chunks = chunkFormatString(formatStr);
	
	return {
		fakeFormatString: buildFakeFormatString(chunks),
		sameUnits: buildSameUnits(chunks)
	};
}

/*
Break the formatting string into an array of chunks.
A 'maybe' chunk will have nested chunks.
*/
function chunkFormatString(formatStr) {
	var chunks = [];
	var match;

	// TODO: more descrimination
	// \4 is a backreference to the first character of a multi-character set.
	var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;

	while ((match = chunker.exec(formatStr))) {
		if (match[1]) { // a literal string inside [ ... ]
			chunks.push.apply(chunks, // append
				splitStringLiteral(match[1])
			);
		}
		else if (match[2]) { // non-zero formatting inside ( ... )
			chunks.push({ maybe: chunkFormatString(match[2]) });
		}
		else if (match[3]) { // a formatting token
			chunks.push({ token: match[3] });
		}
		else if (match[5]) { // an unenclosed literal string
			chunks.push.apply(chunks, // append
				splitStringLiteral(match[5])
			);
		}
	}

	return chunks;
}

/*
Potentially splits a literal-text string into multiple parts. For special cases.
*/
function splitStringLiteral(s) {
	if (s === '. ') {
		return [ '.', ' ' ]; // for locales with periods bound to the end of each year/month/date
	}
	else {
		return [ s ];
	}
}

/*
Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
characters that will eventually be given to moment for formatting, and then post-processed.
*/
function buildFakeFormatString(chunks) {
	var parts = [];
	var i, chunk;

	for (i = 0; i < chunks.length; i++) {
		chunk = chunks[i];

		if (typeof chunk === 'string') {
			parts.push('[' + chunk + ']');
		}
		else if (chunk.token) {
			if (chunk.token in specialTokens) {
				parts.push(
					SPECIAL_TOKEN_MARKER + // useful during post-processing
					'[' + chunk.token + ']' // preserve as literal text
				);
			}
			else {
				parts.push(chunk.token); // unprotected text implies a format string
			}
		}
		else if (chunk.maybe) {
			parts.push(
				MAYBE_MARKER + // useful during post-processing
				buildFakeFormatString(chunk.maybe) +
				MAYBE_MARKER
			);
		}
	}

	return parts.join(PART_SEPARATOR);
}

/*
Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
in which regard two dates must be similar in order to share range formatting text.
The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
*/
function buildSameUnits(chunks) {
	var units = [];
	var i, chunk;
	var tokenInfo;

	for (i = 0; i < chunks.length; i++) {
		chunk = chunks[i];

		if (chunk.token) {
			tokenInfo = largeTokenMap[chunk.token.charAt(0)];
			units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
		}
		else if (chunk.maybe) {
			units.push.apply(units, // append
				buildSameUnits(chunk.maybe)
			);
		}
		else {
			units.push(null);
		}
	}

	return units;
}


// Rendering to text
// ---------------------------------------------------------------------------------------------------------------------

/*
Formats a date with a fake format string, post-processes the control characters, then returns.
*/
function renderFakeFormatString(fakeFormatString, date) {
	return processMaybeMarkers(
		renderFakeFormatStringParts(fakeFormatString, date).join('')
	);
}

/*
Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
*/
function renderFakeFormatStringParts(fakeFormatString, date) {
	var parts = [];
	var fakeRender = oldMomentFormat(date, fakeFormatString);
	var fakeParts = fakeRender.split(PART_SEPARATOR);
	var i, fakePart;

	for (i = 0; i < fakeParts.length; i++) {
		fakePart = fakeParts[i];

		if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
			parts.push(
				// the literal string IS the token's name.
				// call special token's registered function.
				specialTokens[fakePart.substring(1)](date)
			);
		}
		else {
			parts.push(fakePart);
		}
	}

	return parts;
}

/*
Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
*/
function processMaybeMarkers(s) {
	return s.replace(MAYBE_REGEXP, function(m0, m1) { // regex assumed to have 'g' flag
		if (m1.match(/[1-9]/)) { // any non-zero numeric characters?
			return m1;
		}
		else {
			return '';
		}
	});
}


// Misc Utils
// -------------------------------------------------------------------------------------------------

/*
Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
*/
function queryMostGranularFormatUnit(formatStr) {
	var chunks = chunkFormatString(formatStr);
	var i, chunk;
	var candidate;
	var best;

	for (i = 0; i < chunks.length; i++) {
		chunk = chunks[i];

		if (chunk.token) {
			candidate = largeTokenMap[chunk.token.charAt(0)];
			if (candidate) {
				if (!best || candidate.value > best.value) {
					best = candidate;
				}
			}
		}
	}

	if (best) {
		return best.unit;
	}

	return null;
};

})();

// quick local references
var formatDate = FC.formatDate;
var formatRange = FC.formatRange;
var oldMomentFormat = FC.oldMomentFormat;

;;

FC.Class = Class; // export

// Class that all other classes will inherit from
function Class() { }


// Called on a class to create a subclass.
// Last argument contains instance methods. Any argument before the last are considered mixins.
Class.extend = function() {
	var len = arguments.length;
	var i;
	var members;

	for (i = 0; i < len; i++) {
		members = arguments[i];
		if (i < len - 1) { // not the last argument?
			mixIntoClass(this, members);
		}
	}

	return extendClass(this, members || {}); // members will be undefined if no arguments
};


// Adds new member variables/methods to the class's prototype.
// Can be called with another class, or a plain object hash containing new members.
Class.mixin = function(members) {
	mixIntoClass(this, members);
};


function extendClass(superClass, members) {
	var subClass;

	// ensure a constructor for the subclass, forwarding all arguments to the super-constructor if it doesn't exist
	if (hasOwnProp(members, 'constructor')) {
		subClass = members.constructor;
	}
	if (typeof subClass !== 'function') {
		subClass = members.constructor = function() {
			superClass.apply(this, arguments);
		};
	}

	// build the base prototype for the subclass, which is an new object chained to the superclass's prototype
	subClass.prototype = createObject(superClass.prototype);

	// copy each member variable/method onto the the subclass's prototype
	copyOwnProps(members, subClass.prototype);

	// copy over all class variables/methods to the subclass, such as `extend` and `mixin`
	copyOwnProps(superClass, subClass);

	return subClass;
}


function mixIntoClass(theClass, members) {
	copyOwnProps(members, theClass.prototype);
}
;;

var Model = Class.extend(EmitterMixin, ListenerMixin, {

	_props: null,
	_watchers: null,
	_globalWatchArgs: null,

	constructor: function() {
		this._watchers = {};
		this._props = {};
		this.applyGlobalWatchers();
	},

	applyGlobalWatchers: function() {
		var argSets = this._globalWatchArgs || [];
		var i;

		for (i = 0; i < argSets.length; i++) {
			this.watch.apply(this, argSets[i]);
		}
	},

	has: function(name) {
		return name in this._props;
	},

	get: function(name) {
		if (name === undefined) {
			return this._props;
		}

		return this._props[name];
	},

	set: function(name, val) {
		var newProps;

		if (typeof name === 'string') {
			newProps = {};
			newProps[name] = val === undefined ? null : val;
		}
		else {
			newProps = name;
		}

		this.setProps(newProps);
	},

	reset: function(newProps) {
		var oldProps = this._props;
		var changeset = {}; // will have undefined's to signal unsets
		var name;

		for (name in oldProps) {
			changeset[name] = undefined;
		}

		for (name in newProps) {
			changeset[name] = newProps[name];
		}

		this.setProps(changeset);
	},

	unset: function(name) { // accepts a string or array of strings
		var newProps = {};
		var names;
		var i;

		if (typeof name === 'string') {
			names = [ name ];
		}
		else {
			names = name;
		}

		for (i = 0; i < names.length; i++) {
			newProps[names[i]] = undefined;
		}

		this.setProps(newProps);
	},

	setProps: function(newProps) {
		var changedProps = {};
		var changedCnt = 0;
		var name, val;

		for (name in newProps) {
			val = newProps[name];

			// a change in value?
			// if an object, don't check equality, because might have been mutated internally.
			// TODO: eventually enforce immutability.
			if (
				typeof val === 'object' ||
				val !== this._props[name]
			) {
				changedProps[name] = val;
				changedCnt++;
			}
		}

		if (changedCnt) {

			this.trigger('before:batchChange', changedProps);

			for (name in changedProps) {
				val = changedProps[name];

				this.trigger('before:change', name, val);
				this.trigger('before:change:' + name, val);
			}

			for (name in changedProps) {
				val = changedProps[name];

				if (val === undefined) {
					delete this._props[name];
				}
				else {
					this._props[name] = val;
				}

				this.trigger('change:' + name, val);
				this.trigger('change', name, val);
			}

			this.trigger('batchChange', changedProps);
		}
	},

	watch: function(name, depList, startFunc, stopFunc) {
		var _this = this;

		this.unwatch(name);

		this._watchers[name] = this._watchDeps(depList, function(deps) {
			var res = startFunc.call(_this, deps);

			if (res && res.then) {
				_this.unset(name); // put in an unset state while resolving
				res.then(function(val) {
					_this.set(name, val);
				});
			}
			else {
				_this.set(name, res);
			}
		}, function() {
			_this.unset(name);

			if (stopFunc) {
				stopFunc.call(_this);
			}
		});
	},

	unwatch: function(name) {
		var watcher = this._watchers[name];

		if (watcher) {
			delete this._watchers[name];
			watcher.teardown();
		}
	},

	_watchDeps: function(depList, startFunc, stopFunc) {
		var _this = this;
		var queuedChangeCnt = 0;
		var depCnt = depList.length;
		var satisfyCnt = 0;
		var values = {}; // what's passed as the `deps` arguments
		var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
		var isCallingStop = false;

		function onBeforeDepChange(depName, val, isOptional) {
			queuedChangeCnt++;
			if (queuedChangeCnt === 1) { // first change to cause a "stop" ?
				if (satisfyCnt === depCnt) { // all deps previously satisfied?
					isCallingStop = true;
					stopFunc();
					isCallingStop = false;
				}
			}
		}

		function onDepChange(depName, val, isOptional) {

			if (val === undefined) { // unsetting a value?

				// required dependency that was previously set?
				if (!isOptional && values[depName] !== undefined) {
					satisfyCnt--;
				}

				delete values[depName];
			}
			else { // setting a value?

				// required dependency that was previously unset?
				if (!isOptional && values[depName] === undefined) {
					satisfyCnt++;
				}

				values[depName] = val;
			}

			queuedChangeCnt--;
			if (!queuedChangeCnt) { // last change to cause a "start"?

				// now finally satisfied or satisfied all along?
				if (satisfyCnt === depCnt) {

					// if the stopFunc initiated another value change, ignore it.
					// it will be processed by another change event anyway.
					if (!isCallingStop) {
						startFunc(values);
					}
				}
			}
		}

		// intercept for .on() that remembers handlers
		function bind(eventName, handler) {
			_this.on(eventName, handler);
			bindTuples.push([ eventName, handler ]);
		}

		// listen to dependency changes
		depList.forEach(function(depName) {
			var isOptional = false;

			if (depName.charAt(0) === '?') { // TODO: more DRY
				depName = depName.substring(1);
				isOptional = true;
			}

			bind('before:change:' + depName, function(val) {
				onBeforeDepChange(depName, val, isOptional);
			});

			bind('change:' + depName, function(val) {
				onDepChange(depName, val, isOptional);
			});
		});

		// process current dependency values
		depList.forEach(function(depName) {
			var isOptional = false;

			if (depName.charAt(0) === '?') { // TODO: more DRY
				depName = depName.substring(1);
				isOptional = true;
			}

			if (_this.has(depName)) {
				values[depName] = _this.get(depName);
				satisfyCnt++;
			}
			else if (isOptional) {
				satisfyCnt++;
			}
		});

		// initially satisfied
		if (satisfyCnt === depCnt) {
			startFunc(values);
		}

		return {
			teardown: function() {
				// remove all handlers
				for (var i = 0; i < bindTuples.length; i++) {
					_this.off(bindTuples[i][0], bindTuples[i][1]);
				}
				bindTuples = null;

				// was satisfied, so call stopFunc
				if (satisfyCnt === depCnt) {
					stopFunc();
				}
			},
			flash: function() {
				if (satisfyCnt === depCnt) {
					stopFunc();
					startFunc(values);
				}
			}
		};
	},

	flash: function(name) {
		var watcher = this._watchers[name];

		if (watcher) {
			watcher.flash();
		}
	}

});


Model.watch = function(/* same arguments as this.watch() */) {
	var proto = this.prototype;

	if (!proto._globalWatchArgs) {
		proto._globalWatchArgs = [];
	}

	proto._globalWatchArgs.push(arguments);
};


FC.Model = Model;


;;

var Promise = {

	construct: function(executor) {
		var deferred = $.Deferred();
		var promise = deferred.promise();

		if (typeof executor === 'function') {
			executor(
				function(val) { // resolve
					deferred.resolve(val);
					attachImmediatelyResolvingThen(promise, val);
				},
				function() { // reject
					deferred.reject();
					attachImmediatelyRejectingThen(promise);
				}
			);
		}

		return promise;
	},

	resolve: function(val) {
		var deferred = $.Deferred().resolve(val);
		var promise = deferred.promise();

		attachImmediatelyResolvingThen(promise, val);

		return promise;
	},

	reject: function() {
		var deferred = $.Deferred().reject();
		var promise = deferred.promise();

		attachImmediatelyRejectingThen(promise);

		return promise;
	}

};


function attachImmediatelyResolvingThen(promise, val) {
	promise.then = function(onResolve) {
		if (typeof onResolve === 'function') {
			onResolve(val);
		}
		return promise; // for chaining
	};
}


function attachImmediatelyRejectingThen(promise) {
	promise.then = function(onResolve, onReject) {
		if (typeof onReject === 'function') {
			onReject();
		}
		return promise; // for chaining
	};
}


FC.Promise = Promise;

;;

var TaskQueue = Class.extend(EmitterMixin, {

	q: null,
	isPaused: false,
	isRunning: false,


	constructor: function() {
		this.q = [];
	},


	queue: function(/* taskFunc, taskFunc... */) {
		this.q.push.apply(this.q, arguments); // append
		this.tryStart();
	},


	pause: function() {
		this.isPaused = true;
	},


	resume: function() {
		this.isPaused = false;
		this.tryStart();
	},


	tryStart: function() {
		if (!this.isRunning && this.canRunNext()) {
			this.isRunning = true;
			this.trigger('start');
			this.runNext();
		}
	},


	canRunNext: function() {
		return !this.isPaused && this.q.length;
	},


	runNext: function() { // does not check canRunNext
		this.runTask(this.q.shift());
	},


	runTask: function(task) {
		this.runTaskFunc(task);
	},


	runTaskFunc: function(taskFunc) {
		var _this = this;
		var res = taskFunc();

		if (res && res.then) {
			res.then(done);
		}
		else {
			done();
		}

		function done() {
			if (_this.canRunNext()) {
				_this.runNext();
			}
			else {
				_this.isRunning = false;
				_this.trigger('stop');
			}
		}
	}

});

FC.TaskQueue = TaskQueue;

;;

var RenderQueue = TaskQueue.extend({

	waitsByNamespace: null,
	waitNamespace: null,
	waitId: null,


	constructor: function(waitsByNamespace) {
		TaskQueue.call(this); // super-constructor

		this.waitsByNamespace = waitsByNamespace || {};
	},


	queue: function(taskFunc, namespace, type) {
		var task = {
			func: taskFunc,
			namespace: namespace,
			type: type
		};
		var waitMs;

		if (namespace) {
			waitMs = this.waitsByNamespace[namespace];
		}

		if (this.waitNamespace) {
			if (namespace === this.waitNamespace && waitMs != null) {
				this.delayWait(waitMs);
			}
			else {
				this.clearWait();
				this.tryStart();
			}
		}

		if (this.compoundTask(task)) { // appended to queue?

			if (!this.waitNamespace && waitMs != null) {
				this.startWait(namespace, waitMs);
			}
			else {
				this.tryStart();
			}
		}
	},


	startWait: function(namespace, waitMs) {
		this.waitNamespace = namespace;
		this.spawnWait(waitMs);
	},


	delayWait: function(waitMs) {
		clearTimeout(this.waitId);
		this.spawnWait(waitMs);
	},


	spawnWait: function(waitMs) {
		var _this = this;

		this.waitId = setTimeout(function() {
			_this.waitNamespace = null;
			_this.tryStart();
		}, waitMs);
	},


	clearWait: function() {
		if (this.waitNamespace) {
			clearTimeout(this.waitId);
			this.waitId = null;
			this.waitNamespace = null;
		}
	},


	canRunNext: function() {
		if (!TaskQueue.prototype.canRunNext.apply(this, arguments)) {
			return false;
		}

		// waiting for a certain namespace to stop receiving tasks?
		if (this.waitNamespace) {

			// if there was a different namespace task in the meantime,
			// that forces all previously-waiting tasks to suddenly execute.
			// TODO: find a way to do this in constant time.
			for (var q = this.q, i = 0; i < q.length; i++) {
				if (q[i].namespace !== this.waitNamespace) {
					return true; // allow execution
				}
			}

			return false;
		}

		return true;
	},


	runTask: function(task) {
		this.runTaskFunc(task.func);
	},


	compoundTask: function(newTask) {
		var q = this.q;
		var shouldAppend = true;
		var i, task;

		if (newTask.namespace) {

			if (newTask.type === 'destroy' || newTask.type === 'init') {

				// remove all add/remove ops with same namespace, regardless of order
				for (i = q.length - 1; i >= 0; i--) {
					task = q[i];

					if (
						task.namespace === newTask.namespace &&
						(task.type === 'add' || task.type === 'remove')
					) {
						q.splice(i, 1); // remove task
					}
				}

				if (newTask.type === 'destroy') {
					// eat away final init/destroy operation
					if (q.length) {
						task = q[q.length - 1]; // last task

						if (task.namespace === newTask.namespace) {

							// the init and our destroy cancel each other out
							if (task.type === 'init') {
								shouldAppend = false;
								q.pop();
							}
							// prefer to use the destroy operation that's already present
							else if (task.type === 'destroy') {
								shouldAppend = false;
							}
						}
					}
				}
				else if (newTask.type === 'init') {
					// eat away final init operation
					if (q.length) {
						task = q[q.length - 1]; // last task

						if (
							task.namespace === newTask.namespace &&
							task.type === 'init'
						) {
							// our init operation takes precedence
							q.pop();
						}
					}
				}
			}
		}

		if (shouldAppend) {
			q.push(newTask);
		}

		return shouldAppend;
	}

});

FC.RenderQueue = RenderQueue;

;;

var EmitterMixin = FC.EmitterMixin = {

	// jQuery-ification via $(this) allows a non-DOM object to have
	// the same event handling capabilities (including namespaces).


	on: function(types, handler) {
		$(this).on(types, this._prepareIntercept(handler));
		return this; // for chaining
	},


	one: function(types, handler) {
		$(this).one(types, this._prepareIntercept(handler));
		return this; // for chaining
	},


	_prepareIntercept: function(handler) {
		// handlers are always called with an "event" object as their first param.
		// sneak the `this` context and arguments into the extra parameter object
		// and forward them on to the original handler.
		var intercept = function(ev, extra) {
			return handler.apply(
				extra.context || this,
				extra.args || []
			);
		};

		// mimick jQuery's internal "proxy" system (risky, I know)
		// causing all functions with the same .guid to appear to be the same.
		// https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
		// this is needed for calling .off with the original non-intercept handler.
		if (!handler.guid) {
			handler.guid = $.guid++;
		}
		intercept.guid = handler.guid;

		return intercept;
	},


	off: function(types, handler) {
		$(this).off(types, handler);

		return this; // for chaining
	},


	trigger: function(types) {
		var args = Array.prototype.slice.call(arguments, 1); // arguments after the first

		// pass in "extra" info to the intercept
		$(this).triggerHandler(types, { args: args });

		return this; // for chaining
	},


	triggerWith: function(types, context, args) {

		// `triggerHandler` is less reliant on the DOM compared to `trigger`.
		// pass in "extra" info to the intercept.
		$(this).triggerHandler(types, { context: context, args: args });

		return this; // for chaining
	}

};

;;

/*
Utility methods for easily listening to events on another object,
and more importantly, easily unlistening from them.
*/
var ListenerMixin = FC.ListenerMixin = (function() {
	var guid = 0;
	var ListenerMixin = {

		listenerId: null,

		/*
		Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
		The `callback` will be called with the `this` context of the object that .listenTo is being called on.
		Can be called:
			.listenTo(other, eventName, callback)
		OR
			.listenTo(other, {
				eventName1: callback1,
				eventName2: callback2
			})
		*/
		listenTo: function(other, arg, callback) {
			if (typeof arg === 'object') { // given dictionary of callbacks
				for (var eventName in arg) {
					if (arg.hasOwnProperty(eventName)) {
						this.listenTo(other, eventName, arg[eventName]);
					}
				}
			}
			else if (typeof arg === 'string') {
				other.on(
					arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
					$.proxy(callback, this) // always use `this` context
						// the usually-undesired jQuery guid behavior doesn't matter,
						// because we always unbind via namespace
				);
			}
		},

		/*
		Causes the current object to stop listening to events on the `other` object.
		`eventName` is optional. If omitted, will stop listening to ALL events on `other`.
		*/
		stopListeningTo: function(other, eventName) {
			other.off((eventName || '') + '.' + this.getListenerNamespace());
		},

		/*
		Returns a string, unique to this object, to be used for event namespacing
		*/
		getListenerNamespace: function() {
			if (this.listenerId == null) {
				this.listenerId = guid++;
			}
			return '_listener' + this.listenerId;
		}

	};
	return ListenerMixin;
})();
;;

/* A rectangular panel that is absolutely positioned over other content
------------------------------------------------------------------------------------------------------------------------
Options:
	- className (string)
	- content (HTML string or jQuery element set)
	- parentEl
	- top
	- left
	- right (the x coord of where the right edge should be. not a "CSS" right)
	- autoHide (boolean)
	- show (callback)
	- hide (callback)
*/

var Popover = Class.extend(ListenerMixin, {

	isHidden: true,
	options: null,
	el: null, // the container element for the popover. generated by this object
	margin: 10, // the space required between the popover and the edges of the scroll container


	constructor: function(options) {
		this.options = options || {};
	},


	// Shows the popover on the specified position. Renders it if not already
	show: function() {
		if (this.isHidden) {
			if (!this.el) {
				this.render();
			}
			this.el.show();
			this.position();
			this.isHidden = false;
			this.trigger('show');
		}
	},


	// Hides the popover, through CSS, but does not remove it from the DOM
	hide: function() {
		if (!this.isHidden) {
			this.el.hide();
			this.isHidden = true;
			this.trigger('hide');
		}
	},


	// Creates `this.el` and renders content inside of it
	render: function() {
		var _this = this;
		var options = this.options;

		this.el = $('<div class="fc-popover"/>')
			.addClass(options.className || '')
			.css({
				// position initially to the top left to avoid creating scrollbars
				top: 0,
				left: 0
			})
			.append(options.content)
			.appendTo(options.parentEl);

		// when a click happens on anything inside with a 'fc-close' className, hide the popover
		this.el.on('click', '.fc-close', function() {
			_this.hide();
		});

		if (options.autoHide) {
			this.listenTo($(document), 'mousedown', this.documentMousedown);
		}
	},


	// Triggered when the user clicks *anywhere* in the document, for the autoHide feature
	documentMousedown: function(ev) {
		// only hide the popover if the click happened outside the popover
		if (this.el && !$(ev.target).closest(this.el).length) {
			this.hide();
		}
	},


	// Hides and unregisters any handlers
	removeElement: function() {
		this.hide();

		if (this.el) {
			this.el.remove();
			this.el = null;
		}

		this.stopListeningTo($(document), 'mousedown');
	},


	// Positions the popover optimally, using the top/left/right options
	position: function() {
		var options = this.options;
		var origin = this.el.offsetParent().offset();
		var width = this.el.outerWidth();
		var height = this.el.outerHeight();
		var windowEl = $(window);
		var viewportEl = getScrollParent(this.el);
		var viewportTop;
		var viewportLeft;
		var viewportOffset;
		var top; // the "position" (not "offset") values for the popover
		var left; //

		// compute top and left
		top = options.top || 0;
		if (options.left !== undefined) {
			left = options.left;
		}
		else if (options.right !== undefined) {
			left = options.right - width; // derive the left value from the right value
		}
		else {
			left = 0;
		}

		if (viewportEl.is(window) || viewportEl.is(document)) { // normalize getScrollParent's result
			viewportEl = windowEl;
			viewportTop = 0; // the window is always at the top left
			viewportLeft = 0; // (and .offset() won't work if called here)
		}
		else {
			viewportOffset = viewportEl.offset();
			viewportTop = viewportOffset.top;
			viewportLeft = viewportOffset.left;
		}

		// if the window is scrolled, it causes the visible area to be further down
		viewportTop += windowEl.scrollTop();
		viewportLeft += windowEl.scrollLeft();

		// constrain to the view port. if constrained by two edges, give precedence to top/left
		if (options.viewportConstrain !== false) {
			top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
			top = Math.max(top, viewportTop + this.margin);
			left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
			left = Math.max(left, viewportLeft + this.margin);
		}

		this.el.css({
			top: top - origin.top,
			left: left - origin.left
		});
	},


	// Triggers a callback. Calls a function in the option hash of the same name.
	// Arguments beyond the first `name` are forwarded on.
	// TODO: better code reuse for this. Repeat code
	trigger: function(name) {
		if (this.options[name]) {
			this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
		}
	}

});

;;

/*
A cache for the left/right/top/bottom/width/height values for one or more elements.
Works with both offset (from topleft document) and position (from offsetParent).

options:
- els
- isHorizontal
- isVertical
*/
var CoordCache = FC.CoordCache = Class.extend({

	els: null, // jQuery set (assumed to be siblings)
	forcedOffsetParentEl: null, // options can override the natural offsetParent
	origin: null, // {left,top} position of offsetParent of els
	boundingRect: null, // constrain cordinates to this rectangle. {left,right,top,bottom} or null
	isHorizontal: false, // whether to query for left/right/width
	isVertical: false, // whether to query for top/bottom/height

	// arrays of coordinates (offsets from topleft of document)
	lefts: null,
	rights: null,
	tops: null,
	bottoms: null,


	constructor: function(options) {
		this.els = $(options.els);
		this.isHorizontal = options.isHorizontal;
		this.isVertical = options.isVertical;
		this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
	},


	// Queries the els for coordinates and stores them.
	// Call this method before using and of the get* methods below.
	build: function() {
		var offsetParentEl = this.forcedOffsetParentEl;
		if (!offsetParentEl && this.els.length > 0) {
			offsetParentEl = this.els.eq(0).offsetParent();
		}

		this.origin = offsetParentEl ?
			offsetParentEl.offset() :
			null;

		this.boundingRect = this.queryBoundingRect();

		if (this.isHorizontal) {
			this.buildElHorizontals();
		}
		if (this.isVertical) {
			this.buildElVerticals();
		}
	},


	// Destroys all internal data about coordinates, freeing memory
	clear: function() {
		this.origin = null;
		this.boundingRect = null;
		this.lefts = null;
		this.rights = null;
		this.tops = null;
		this.bottoms = null;
	},


	// When called, if coord caches aren't built, builds them
	ensureBuilt: function() {
		if (!this.origin) {
			this.build();
		}
	},


	// Populates the left/right internal coordinate arrays
	buildElHorizontals: function() {
		var lefts = [];
		var rights = [];

		this.els.each(function(i, node) {
			var el = $(node);
			var left = el.offset().left;
			var width = el.outerWidth();

			lefts.push(left);
			rights.push(left + width);
		});

		this.lefts = lefts;
		this.rights = rights;
	},


	// Populates the top/bottom internal coordinate arrays
	buildElVerticals: function() {
		var tops = [];
		var bottoms = [];

		this.els.each(function(i, node) {
			var el = $(node);
			var top = el.offset().top;
			var height = el.outerHeight();

			tops.push(top);
			bottoms.push(top + height);
		});

		this.tops = tops;
		this.bottoms = bottoms;
	},


	// Given a left offset (from document left), returns the index of the el that it horizontally intersects.
	// If no intersection is made, returns undefined.
	getHorizontalIndex: function(leftOffset) {
		this.ensureBuilt();

		var lefts = this.lefts;
		var rights = this.rights;
		var len = lefts.length;
		var i;

		for (i = 0; i < len; i++) {
			if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
				return i;
			}
		}
	},


	// Given a top offset (from document top), returns the index of the el that it vertically intersects.
	// If no intersection is made, returns undefined.
	getVerticalIndex: function(topOffset) {
		this.ensureBuilt();

		var tops = this.tops;
		var bottoms = this.bottoms;
		var len = tops.length;
		var i;

		for (i = 0; i < len; i++) {
			if (topOffset >= tops[i] && topOffset < bottoms[i]) {
				return i;
			}
		}
	},


	// Gets the left offset (from document left) of the element at the given index
	getLeftOffset: function(leftIndex) {
		this.ensureBuilt();
		return this.lefts[leftIndex];
	},


	// Gets the left position (from offsetParent left) of the element at the given index
	getLeftPosition: function(leftIndex) {
		this.ensureBuilt();
		return this.lefts[leftIndex] - this.origin.left;
	},


	// Gets the right offset (from document left) of the element at the given index.
	// This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
	getRightOffset: function(leftIndex) {
		this.ensureBuilt();
		return this.rights[leftIndex];
	},


	// Gets the right position (from offsetParent left) of the element at the given index.
	// This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
	getRightPosition: function(leftIndex) {
		this.ensureBuilt();
		return this.rights[leftIndex] - this.origin.left;
	},


	// Gets the width of the element at the given index
	getWidth: function(leftIndex) {
		this.ensureBuilt();
		return this.rights[leftIndex] - this.lefts[leftIndex];
	},


	// Gets the top offset (from document top) of the element at the given index
	getTopOffset: function(topIndex) {
		this.ensureBuilt();
		return this.tops[topIndex];
	},


	// Gets the top position (from offsetParent top) of the element at the given position
	getTopPosition: function(topIndex) {
		this.ensureBuilt();
		return this.tops[topIndex] - this.origin.top;
	},

	// Gets the bottom offset (from the document top) of the element at the given index.
	// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	getBottomOffset: function(topIndex) {
		this.ensureBuilt();
		return this.bottoms[topIndex];
	},


	// Gets the bottom position (from the offsetParent top) of the element at the given index.
	// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	getBottomPosition: function(topIndex) {
		this.ensureBuilt();
		return this.bottoms[topIndex] - this.origin.top;
	},


	// Gets the height of the element at the given index
	getHeight: function(topIndex) {
		this.ensureBuilt();
		return this.bottoms[topIndex] - this.tops[topIndex];
	},


	// Bounding Rect
	// TODO: decouple this from CoordCache

	// Compute and return what the elements' bounding rectangle is, from the user's perspective.
	// Right now, only returns a rectangle if constrained by an overflow:scroll element.
	// Returns null if there are no elements
	queryBoundingRect: function() {
		var scrollParentEl;

		if (this.els.length > 0) {
			scrollParentEl = getScrollParent(this.els.eq(0));

			if (!scrollParentEl.is(document)) {
				return getClientRect(scrollParentEl);
			}
		}

		return null;
	},

	isPointInBounds: function(leftOffset, topOffset) {
		return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
	},

	isLeftInBounds: function(leftOffset) {
		return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
	},

	isTopInBounds: function(topOffset) {
		return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
	}

});

;;

/* Tracks a drag's mouse movement, firing various handlers
----------------------------------------------------------------------------------------------------------------------*/
// TODO: use Emitter

var DragListener = FC.DragListener = Class.extend(ListenerMixin, {

	options: null,
	subjectEl: null,

	// coordinates of the initial mousedown
	originX: null,
	originY: null,

	// the wrapping element that scrolls, or MIGHT scroll if there's overflow.
	// TODO: do this for wrappers that have overflow:hidden as well.
	scrollEl: null,

	isInteracting: false,
	isDistanceSurpassed: false,
	isDelayEnded: false,
	isDragging: false,
	isTouch: false,
	isGeneric: false, // initiated by 'dragstart' (jqui)

	delay: null,
	delayTimeoutId: null,
	minDistance: null,

	shouldCancelTouchScroll: true,
	scrollAlwaysKills: false,


	constructor: function(options) {
		this.options = options || {};
	},


	// Interaction (high-level)
	// -----------------------------------------------------------------------------------------------------------------


	startInteraction: function(ev, extraOptions) {

		if (ev.type === 'mousedown') {
			if (GlobalEmitter.get().shouldIgnoreMouse()) {
				return;
			}
			else if (!isPrimaryMouseButton(ev)) {
				return;
			}
			else {
				ev.preventDefault(); // prevents native selection in most browsers
			}
		}

		if (!this.isInteracting) {

			// process options
			extraOptions = extraOptions || {};
			this.delay = firstDefined(extraOptions.delay, this.options.delay, 0);
			this.minDistance = firstDefined(extraOptions.distance, this.options.distance, 0);
			this.subjectEl = this.options.subjectEl;

			preventSelection($('body'));

			this.isInteracting = true;
			this.isTouch = getEvIsTouch(ev);
			this.isGeneric = ev.type === 'dragstart';
			this.isDelayEnded = false;
			this.isDistanceSurpassed = false;

			this.originX = getEvX(ev);
			this.originY = getEvY(ev);
			this.scrollEl = getScrollParent($(ev.target));

			this.bindHandlers();
			this.initAutoScroll();
			this.handleInteractionStart(ev);
			this.startDelay(ev);

			if (!this.minDistance) {
				this.handleDistanceSurpassed(ev);
			}
		}
	},


	handleInteractionStart: function(ev) {
		this.trigger('interactionStart', ev);
	},


	endInteraction: function(ev, isCancelled) {
		if (this.isInteracting) {
			this.endDrag(ev);

			if (this.delayTimeoutId) {
				clearTimeout(this.delayTimeoutId);
				this.delayTimeoutId = null;
			}

			this.destroyAutoScroll();
			this.unbindHandlers();

			this.isInteracting = false;
			this.handleInteractionEnd(ev, isCancelled);

			allowSelection($('body'));
		}
	},


	handleInteractionEnd: function(ev, isCancelled) {
		this.trigger('interactionEnd', ev, isCancelled || false);
	},


	// Binding To DOM
	// -----------------------------------------------------------------------------------------------------------------


	bindHandlers: function() {
		// some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
		// so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
		var globalEmitter = GlobalEmitter.get();

		if (this.isGeneric) {
			this.listenTo($(document), { // might only work on iOS because of GlobalEmitter's bind :(
				drag: this.handleMove,
				dragstop: this.endInteraction
			});
		}
		else if (this.isTouch) {
			this.listenTo(globalEmitter, {
				touchmove: this.handleTouchMove,
				touchend: this.endInteraction,
				scroll: this.handleTouchScroll
			});
		}
		else {
			this.listenTo(globalEmitter, {
				mousemove: this.handleMouseMove,
				mouseup: this.endInteraction
			});
		}

		this.listenTo(globalEmitter, {
			selectstart: preventDefault, // don't allow selection while dragging
			contextmenu: preventDefault // long taps would open menu on Chrome dev tools
		});
	},


	unbindHandlers: function() {
		this.stopListeningTo(GlobalEmitter.get());
		this.stopListeningTo($(document)); // for isGeneric
	},


	// Drag (high-level)
	// -----------------------------------------------------------------------------------------------------------------


	// extraOptions ignored if drag already started
	startDrag: function(ev, extraOptions) {
		this.startInteraction(ev, extraOptions); // ensure interaction began

		if (!this.isDragging) {
			this.isDragging = true;
			this.handleDragStart(ev);
		}
	},


	handleDragStart: function(ev) {
		this.trigger('dragStart', ev);
	},


	handleMove: function(ev) {
		var dx = getEvX(ev) - this.originX;
		var dy = getEvY(ev) - this.originY;
		var minDistance = this.minDistance;
		var distanceSq; // current distance from the origin, squared

		if (!this.isDistanceSurpassed) {
			distanceSq = dx * dx + dy * dy;
			if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
				this.handleDistanceSurpassed(ev);
			}
		}

		if (this.isDragging) {
			this.handleDrag(dx, dy, ev);
		}
	},


	// Called while the mouse is being moved and when we know a legitimate drag is taking place
	handleDrag: function(dx, dy, ev) {
		this.trigger('drag', dx, dy, ev);
		this.updateAutoScroll(ev); // will possibly cause scrolling
	},


	endDrag: function(ev) {
		if (this.isDragging) {
			this.isDragging = false;
			this.handleDragEnd(ev);
		}
	},


	handleDragEnd: function(ev) {
		this.trigger('dragEnd', ev);
	},


	// Delay
	// -----------------------------------------------------------------------------------------------------------------


	startDelay: function(initialEv) {
		var _this = this;

		if (this.delay) {
			this.delayTimeoutId = setTimeout(function() {
				_this.handleDelayEnd(initialEv);
			}, this.delay);
		}
		else {
			this.handleDelayEnd(initialEv);
		}
	},


	handleDelayEnd: function(initialEv) {
		this.isDelayEnded = true;

		if (this.isDistanceSurpassed) {
			this.startDrag(initialEv);
		}
	},


	// Distance
	// -----------------------------------------------------------------------------------------------------------------


	handleDistanceSurpassed: function(ev) {
		this.isDistanceSurpassed = true;

		if (this.isDelayEnded) {
			this.startDrag(ev);
		}
	},


	// Mouse / Touch
	// -----------------------------------------------------------------------------------------------------------------


	handleTouchMove: function(ev) {

		// prevent inertia and touchmove-scrolling while dragging
		if (this.isDragging && this.shouldCancelTouchScroll) {
			ev.preventDefault();
		}

		this.handleMove(ev);
	},


	handleMouseMove: function(ev) {
		this.handleMove(ev);
	},


	// Scrolling (unrelated to auto-scroll)
	// -----------------------------------------------------------------------------------------------------------------


	handleTouchScroll: function(ev) {
		// if the drag is being initiated by touch, but a scroll happens before
		// the drag-initiating delay is over, cancel the drag
		if (!this.isDragging || this.scrollAlwaysKills) {
			this.endInteraction(ev, true); // isCancelled=true
		}
	},


	// Utils
	// -----------------------------------------------------------------------------------------------------------------


	// Triggers a callback. Calls a function in the option hash of the same name.
	// Arguments beyond the first `name` are forwarded on.
	trigger: function(name) {
		if (this.options[name]) {
			this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
		}
		// makes _methods callable by event name. TODO: kill this
		if (this['_' + name]) {
			this['_' + name].apply(this, Array.prototype.slice.call(arguments, 1));
		}
	}


});

;;
/*
this.scrollEl is set in DragListener
*/
DragListener.mixin({

	isAutoScroll: false,

	scrollBounds: null, // { top, bottom, left, right }
	scrollTopVel: null, // pixels per second
	scrollLeftVel: null, // pixels per second
	scrollIntervalId: null, // ID of setTimeout for scrolling animation loop

	// defaults
	scrollSensitivity: 30, // pixels from edge for scrolling to start
	scrollSpeed: 200, // pixels per second, at maximum speed
	scrollIntervalMs: 50, // millisecond wait between scroll increment


	initAutoScroll: function() {
		var scrollEl = this.scrollEl;

		this.isAutoScroll =
			this.options.scroll &&
			scrollEl &&
			!scrollEl.is(window) &&
			!scrollEl.is(document);

		if (this.isAutoScroll) {
			// debounce makes sure rapid calls don't happen
			this.listenTo(scrollEl, 'scroll', debounce(this.handleDebouncedScroll, 100));
		}
	},


	destroyAutoScroll: function() {
		this.endAutoScroll(); // kill any animation loop

		// remove the scroll handler if there is a scrollEl
		if (this.isAutoScroll) {
			this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
		}
	},


	// Computes and stores the bounding rectangle of scrollEl
	computeScrollBounds: function() {
		if (this.isAutoScroll) {
			this.scrollBounds = getOuterRect(this.scrollEl);
			// TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
		}
	},


	// Called when the dragging is in progress and scrolling should be updated
	updateAutoScroll: function(ev) {
		var sensitivity = this.scrollSensitivity;
		var bounds = this.scrollBounds;
		var topCloseness, bottomCloseness;
		var leftCloseness, rightCloseness;
		var topVel = 0;
		var leftVel = 0;

		if (bounds) { // only scroll if scrollEl exists

			// compute closeness to edges. valid range is from 0.0 - 1.0
			topCloseness = (sensitivity - (getEvY(ev) - bounds.top)) / sensitivity;
			bottomCloseness = (sensitivity - (bounds.bottom - getEvY(ev))) / sensitivity;
			leftCloseness = (sensitivity - (getEvX(ev) - bounds.left)) / sensitivity;
			rightCloseness = (sensitivity - (bounds.right - getEvX(ev))) / sensitivity;

			// translate vertical closeness into velocity.
			// mouse must be completely in bounds for velocity to happen.
			if (topCloseness >= 0 && topCloseness <= 1) {
				topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
			}
			else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
				topVel = bottomCloseness * this.scrollSpeed;
			}

			// translate horizontal closeness into velocity
			if (leftCloseness >= 0 && leftCloseness <= 1) {
				leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
			}
			else if (rightCloseness >= 0 && rightCloseness <= 1) {
				leftVel = rightCloseness * this.scrollSpeed;
			}
		}

		this.setScrollVel(topVel, leftVel);
	},


	// Sets the speed-of-scrolling for the scrollEl
	setScrollVel: function(topVel, leftVel) {

		this.scrollTopVel = topVel;
		this.scrollLeftVel = leftVel;

		this.constrainScrollVel(); // massages into realistic values

		// if there is non-zero velocity, and an animation loop hasn't already started, then START
		if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
			this.scrollIntervalId = setInterval(
				proxy(this, 'scrollIntervalFunc'), // scope to `this`
				this.scrollIntervalMs
			);
		}
	},


	// Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
	constrainScrollVel: function() {
		var el = this.scrollEl;

		if (this.scrollTopVel < 0) { // scrolling up?
			if (el.scrollTop() <= 0) { // already scrolled all the way up?
				this.scrollTopVel = 0;
			}
		}
		else if (this.scrollTopVel > 0) { // scrolling down?
			if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) { // already scrolled all the way down?
				this.scrollTopVel = 0;
			}
		}

		if (this.scrollLeftVel < 0) { // scrolling left?
			if (el.scrollLeft() <= 0) { // already scrolled all the left?
				this.scrollLeftVel = 0;
			}
		}
		else if (this.scrollLeftVel > 0) { // scrolling right?
			if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) { // already scrolled all the way right?
				this.scrollLeftVel = 0;
			}
		}
	},


	// This function gets called during every iteration of the scrolling animation loop
	scrollIntervalFunc: function() {
		var el = this.scrollEl;
		var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by

		// change the value of scrollEl's scroll
		if (this.scrollTopVel) {
			el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
		}
		if (this.scrollLeftVel) {
			el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
		}

		this.constrainScrollVel(); // since the scroll values changed, recompute the velocities

		// if scrolled all the way, which causes the vels to be zero, stop the animation loop
		if (!this.scrollTopVel && !this.scrollLeftVel) {
			this.endAutoScroll();
		}
	},


	// Kills any existing scrolling animation loop
	endAutoScroll: function() {
		if (this.scrollIntervalId) {
			clearInterval(this.scrollIntervalId);
			this.scrollIntervalId = null;

			this.handleScrollEnd();
		}
	},


	// Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
	handleDebouncedScroll: function() {
		// recompute all coordinates, but *only* if this is *not* part of our scrolling animation
		if (!this.scrollIntervalId) {
			this.handleScrollEnd();
		}
	},


	// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	handleScrollEnd: function() {
	}

});
;;

/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
------------------------------------------------------------------------------------------------------------------------
options:
- subjectEl
- subjectCenter
*/

var HitDragListener = DragListener.extend({

	component: null, // converts coordinates to hits
		// methods: hitsNeeded, hitsNotNeeded, queryHit

	origHit: null, // the hit the mouse was over when listening started
	hit: null, // the hit the mouse is over
	coordAdjust: null, // delta that will be added to the mouse coordinates when computing collisions


	constructor: function(component, options) {
		DragListener.call(this, options); // call the super-constructor

		this.component = component;
	},


	// Called when drag listening starts (but a real drag has not necessarily began).
	// ev might be undefined if dragging was started manually.
	handleInteractionStart: function(ev) {
		var subjectEl = this.subjectEl;
		var subjectRect;
		var origPoint;
		var point;

		this.component.hitsNeeded();
		this.computeScrollBounds(); // for autoscroll

		if (ev) {
			origPoint = { left: getEvX(ev), top: getEvY(ev) };
			point = origPoint;

			// constrain the point to bounds of the element being dragged
			if (subjectEl) {
				subjectRect = getOuterRect(subjectEl); // used for centering as well
				point = constrainPoint(point, subjectRect);
			}

			this.origHit = this.queryHit(point.left, point.top);

			// treat the center of the subject as the collision point?
			if (subjectEl && this.options.subjectCenter) {

				// only consider the area the subject overlaps the hit. best for large subjects.
				// TODO: skip this if hit didn't supply left/right/top/bottom
				if (this.origHit) {
					subjectRect = intersectRects(this.origHit, subjectRect) ||
						subjectRect; // in case there is no intersection
				}

				point = getRectCenter(subjectRect);
			}

			this.coordAdjust = diffPoints(point, origPoint); // point - origPoint
		}
		else {
			this.origHit = null;
			this.coordAdjust = null;
		}

		// call the super-method. do it after origHit has been computed
		DragListener.prototype.handleInteractionStart.apply(this, arguments);
	},


	// Called when the actual drag has started
	handleDragStart: function(ev) {
		var hit;

		DragListener.prototype.handleDragStart.apply(this, arguments); // call the super-method

		// might be different from this.origHit if the min-distance is large
		hit = this.queryHit(getEvX(ev), getEvY(ev));

		// report the initial hit the mouse is over
		// especially important if no min-distance and drag starts immediately
		if (hit) {
			this.handleHitOver(hit);
		}
	},


	// Called when the drag moves
	handleDrag: function(dx, dy, ev) {
		var hit;

		DragListener.prototype.handleDrag.apply(this, arguments); // call the super-method

		hit = this.queryHit(getEvX(ev), getEvY(ev));

		if (!isHitsEqual(hit, this.hit)) { // a different hit than before?
			if (this.hit) {
				this.handleHitOut();
			}
			if (hit) {
				this.handleHitOver(hit);
			}
		}
	},


	// Called when dragging has been stopped
	handleDragEnd: function() {
		this.handleHitDone();
		DragListener.prototype.handleDragEnd.apply(this, arguments); // call the super-method
	},


	// Called when a the mouse has just moved over a new hit
	handleHitOver: function(hit) {
		var isOrig = isHitsEqual(hit, this.origHit);

		this.hit = hit;

		this.trigger('hitOver', this.hit, isOrig, this.origHit);
	},


	// Called when the mouse has just moved out of a hit
	handleHitOut: function() {
		if (this.hit) {
			this.trigger('hitOut', this.hit);
			this.handleHitDone();
			this.hit = null;
		}
	},


	// Called after a hitOut. Also called before a dragStop
	handleHitDone: function() {
		if (this.hit) {
			this.trigger('hitDone', this.hit);
		}
	},


	// Called when the interaction ends, whether there was a real drag or not
	handleInteractionEnd: function() {
		DragListener.prototype.handleInteractionEnd.apply(this, arguments); // call the super-method

		this.origHit = null;
		this.hit = null;

		this.component.hitsNotNeeded();
	},


	// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	handleScrollEnd: function() {
		DragListener.prototype.handleScrollEnd.apply(this, arguments); // call the super-method

		// hits' absolute positions will be in new places after a user's scroll.
		// HACK for recomputing.
		if (this.isDragging) {
			this.component.releaseHits();
			this.component.prepareHits();
		}
	},


	// Gets the hit underneath the coordinates for the given mouse event
	queryHit: function(left, top) {

		if (this.coordAdjust) {
			left += this.coordAdjust.left;
			top += this.coordAdjust.top;
		}

		return this.component.queryHit(left, top);
	}

});


// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
// Two null values will be considered equal, as two "out of the component" states are the same.
function isHitsEqual(hit0, hit1) {

	if (!hit0 && !hit1) {
		return true;
	}

	if (hit0 && hit1) {
		return hit0.component === hit1.component &&
			isHitPropsWithin(hit0, hit1) &&
			isHitPropsWithin(hit1, hit0); // ensures all props are identical
	}

	return false;
}


// Returns true if all of subHit's non-standard properties are within superHit
function isHitPropsWithin(subHit, superHit) {
	for (var propName in subHit) {
		if (!/^(component|left|right|top|bottom)$/.test(propName)) {
			if (subHit[propName] !== superHit[propName]) {
				return false;
			}
		}
	}
	return true;
}

;;

/*
Listens to document and window-level user-interaction events, like touch events and mouse events,
and fires these events as-is to whoever is observing a GlobalEmitter.
Best when used as a singleton via GlobalEmitter.get()

Normalizes mouse/touch events. For examples:
- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
- compensates for various buggy scenarios where a touchend does not fire
*/

FC.touchMouseIgnoreWait = 500;

var GlobalEmitter = Class.extend(ListenerMixin, EmitterMixin, {

	isTouching: false,
	mouseIgnoreDepth: 0,
	handleScrollProxy: null,


	bind: function() {
		var _this = this;

		this.listenTo($(document), {
			touchstart: this.handleTouchStart,
			touchcancel: this.handleTouchCancel,
			touchend: this.handleTouchEnd,
			mousedown: this.handleMouseDown,
			mousemove: this.handleMouseMove,
			mouseup: this.handleMouseUp,
			click: this.handleClick,
			selectstart: this.handleSelectStart,
			contextmenu: this.handleContextMenu
		});

		// because we need to call preventDefault
		// because https://www.chromestatus.com/features/5093566007214080
		// TODO: investigate performance because this is a global handler
		window.addEventListener(
			'touchmove',
			this.handleTouchMoveProxy = function(ev) {
				_this.handleTouchMove($.Event(ev));
			},
			{ passive: false } // allows preventDefault()
		);

		// attach a handler to get called when ANY scroll action happens on the page.
		// this was impossible to do with normal on/off because 'scroll' doesn't bubble.
		// http://stackoverflow.com/a/32954565/96342
		window.addEventListener(
			'scroll',
			this.handleScrollProxy = function(ev) {
				_this.handleScroll($.Event(ev));
			},
			true // useCapture
		);
	},

	unbind: function() {
		this.stopListeningTo($(document));

		window.removeEventListener(
			'touchmove',
			this.handleTouchMoveProxy
		);

		window.removeEventListener(
			'scroll',
			this.handleScrollProxy,
			true // useCapture
		);
	},


	// Touch Handlers
	// -----------------------------------------------------------------------------------------------------------------

	handleTouchStart: function(ev) {

		// if a previous touch interaction never ended with a touchend, then implicitly end it,
		// but since a new touch interaction is about to begin, don't start the mouse ignore period.
		this.stopTouch(ev, true); // skipMouseIgnore=true

		this.isTouching = true;
		this.trigger('touchstart', ev);
	},

	handleTouchMove: function(ev) {
		if (this.isTouching) {
			this.trigger('touchmove', ev);
		}
	},

	handleTouchCancel: function(ev) {
		if (this.isTouching) {
			this.trigger('touchcancel', ev);

			// Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
			// If touchend fires later, it won't have any effect b/c isTouching will be false.
			this.stopTouch(ev);
		}
	},

	handleTouchEnd: function(ev) {
		this.stopTouch(ev);
	},


	// Mouse Handlers
	// -----------------------------------------------------------------------------------------------------------------

	handleMouseDown: function(ev) {
		if (!this.shouldIgnoreMouse()) {
			this.trigger('mousedown', ev);
		}
	},

	handleMouseMove: function(ev) {
		if (!this.shouldIgnoreMouse()) {
			this.trigger('mousemove', ev);
		}
	},

	handleMouseUp: function(ev) {
		if (!this.shouldIgnoreMouse()) {
			this.trigger('mouseup', ev);
		}
	},

	handleClick: function(ev) {
		if (!this.shouldIgnoreMouse()) {
			this.trigger('click', ev);
		}
	},


	// Misc Handlers
	// -----------------------------------------------------------------------------------------------------------------

	handleSelectStart: function(ev) {
		this.trigger('selectstart', ev);
	},

	handleContextMenu: function(ev) {
		this.trigger('contextmenu', ev);
	},

	handleScroll: function(ev) {
		this.trigger('scroll', ev);
	},


	// Utils
	// -----------------------------------------------------------------------------------------------------------------

	stopTouch: function(ev, skipMouseIgnore) {
		if (this.isTouching) {
			this.isTouching = false;
			this.trigger('touchend', ev);

			if (!skipMouseIgnore) {
				this.startTouchMouseIgnore();
			}
		}
	},

	startTouchMouseIgnore: function() {
		var _this = this;
		var wait = FC.touchMouseIgnoreWait;

		if (wait) {
			this.mouseIgnoreDepth++;
			setTimeout(function() {
				_this.mouseIgnoreDepth--;
			}, wait);
		}
	},

	shouldIgnoreMouse: function() {
		return this.isTouching || Boolean(this.mouseIgnoreDepth);
	}

});


// Singleton
// ---------------------------------------------------------------------------------------------------------------------

(function() {
	var globalEmitter = null;
	var neededCount = 0;


	// gets the singleton
	GlobalEmitter.get = function() {

		if (!globalEmitter) {
			globalEmitter = new GlobalEmitter();
			globalEmitter.bind();
		}

		return globalEmitter;
	};


	// called when an object knows it will need a GlobalEmitter in the near future.
	GlobalEmitter.needed = function() {
		GlobalEmitter.get(); // ensures globalEmitter
		neededCount++;
	};


	// called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
	GlobalEmitter.unneeded = function() {
		neededCount--;

		if (!neededCount) { // nobody else needs it
			globalEmitter.unbind();
			globalEmitter = null;
		}
	};

})();

;;

/* Creates a clone of an element and lets it track the mouse as it moves
----------------------------------------------------------------------------------------------------------------------*/

var MouseFollower = Class.extend(ListenerMixin, {

	options: null,

	sourceEl: null, // the element that will be cloned and made to look like it is dragging
	el: null, // the clone of `sourceEl` that will track the mouse
	parentEl: null, // the element that `el` (the clone) will be attached to

	// the initial position of el, relative to the offset parent. made to match the initial offset of sourceEl
	top0: null,
	left0: null,

	// the absolute coordinates of the initiating touch/mouse action
	y0: null,
	x0: null,

	// the number of pixels the mouse has moved from its initial position
	topDelta: null,
	leftDelta: null,

	isFollowing: false,
	isHidden: false,
	isAnimating: false, // doing the revert animation?

	constructor: function(sourceEl, options) {
		this.options = options = options || {};
		this.sourceEl = sourceEl;
		this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
	},


	// Causes the element to start following the mouse
	start: function(ev) {
		if (!this.isFollowing) {
			this.isFollowing = true;

			this.y0 = getEvY(ev);
			this.x0 = getEvX(ev);
			this.topDelta = 0;
			this.leftDelta = 0;

			if (!this.isHidden) {
				this.updatePosition();
			}

			if (getEvIsTouch(ev)) {
				this.listenTo($(document), 'touchmove', this.handleMove);
			}
			else {
				this.listenTo($(document), 'mousemove', this.handleMove);
			}
		}
	},


	// Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
	// `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
	stop: function(shouldRevert, callback) {
		var _this = this;
		var revertDuration = this.options.revertDuration;

		function complete() { // might be called by .animate(), which might change `this` context
			_this.isAnimating = false;
			_this.removeElement();

			_this.top0 = _this.left0 = null; // reset state for future updatePosition calls

			if (callback) {
				callback();
			}
		}

		if (this.isFollowing && !this.isAnimating) { // disallow more than one stop animation at a time
			this.isFollowing = false;

			this.stopListeningTo($(document));

			if (shouldRevert && revertDuration && !this.isHidden) { // do a revert animation?
				this.isAnimating = true;
				this.el.animate({
					top: this.top0,
					left: this.left0
				}, {
					duration: revertDuration,
					complete: complete
				});
			}
			else {
				complete();
			}
		}
	},


	// Gets the tracking element. Create it if necessary
	getEl: function() {
		var el = this.el;

		if (!el) {
			el = this.el = this.sourceEl.clone()
				.addClass(this.options.additionalClass || '')
				.css({
					position: 'absolute',
					visibility: '', // in case original element was hidden (commonly through hideEvents())
					display: this.isHidden ? 'none' : '', // for when initially hidden
					margin: 0,
					right: 'auto', // erase and set width instead
					bottom: 'auto', // erase and set height instead
					width: this.sourceEl.width(), // explicit height in case there was a 'right' value
					height: this.sourceEl.height(), // explicit width in case there was a 'bottom' value
					opacity: this.options.opacity || '',
					zIndex: this.options.zIndex
				});

			// we don't want long taps or any mouse interaction causing selection/menus.
			// would use preventSelection(), but that prevents selectstart, causing problems.
			el.addClass('fc-unselectable');

			el.appendTo(this.parentEl);
		}

		return el;
	},


	// Removes the tracking element if it has already been created
	removeElement: function() {
		if (this.el) {
			this.el.remove();
			this.el = null;
		}
	},


	// Update the CSS position of the tracking element
	updatePosition: function() {
		var sourceOffset;
		var origin;

		this.getEl(); // ensure this.el

		// make sure origin info was computed
		if (this.top0 === null) {
			sourceOffset = this.sourceEl.offset();
			origin = this.el.offsetParent().offset();
			this.top0 = sourceOffset.top - origin.top;
			this.left0 = sourceOffset.left - origin.left;
		}

		this.el.css({
			top: this.top0 + this.topDelta,
			left: this.left0 + this.leftDelta
		});
	},


	// Gets called when the user moves the mouse
	handleMove: function(ev) {
		this.topDelta = getEvY(ev) - this.y0;
		this.leftDelta = getEvX(ev) - this.x0;

		if (!this.isHidden) {
			this.updatePosition();
		}
	},


	// Temporarily makes the tracking element invisible. Can be called before following starts
	hide: function() {
		if (!this.isHidden) {
			this.isHidden = true;
			if (this.el) {
				this.el.hide();
			}
		}
	},


	// Show the tracking element after it has been temporarily hidden
	show: function() {
		if (this.isHidden) {
			this.isHidden = false;
			this.updatePosition();
			this.getEl().show();
		}
	}

});

;;

/* An abstract class comprised of a "grid" of areas that each represent a specific datetime
----------------------------------------------------------------------------------------------------------------------*/

var Grid = FC.Grid = Class.extend(ListenerMixin, {

	// self-config, overridable by subclasses
	hasDayInteractions: true, // can user click/select ranges of time?

	view: null, // a View object
	isRTL: null, // shortcut to the view's isRTL option

	start: null,
	end: null,

	el: null, // the containing element
	elsByFill: null, // a hash of jQuery element sets used for rendering each fill. Keyed by fill name.

	// derived from options
	eventTimeFormat: null,
	displayEventTime: null,
	displayEventEnd: null,

	minResizeDuration: null, // TODO: hack. set by subclasses. minumum event resize duration

	// if defined, holds the unit identified (ex: "year" or "month") that determines the level of granularity
	// of the date areas. if not defined, assumes to be day and time granularity.
	// TODO: port isTimeScale into same system?
	largeUnit: null,

	dayClickListener: null,
	daySelectListener: null,
	segDragListener: null,
	segResizeListener: null,
	externalDragListener: null,


	constructor: function(view) {
		this.view = view;
		this.isRTL = view.opt('isRTL');
		this.elsByFill = {};

		this.dayClickListener = this.buildDayClickListener();
		this.daySelectListener = this.buildDaySelectListener();
	},


	/* Options
	------------------------------------------------------------------------------------------------------------------*/


	// Generates the format string used for event time text, if not explicitly defined by 'timeFormat'
	computeEventTimeFormat: function() {
		return this.view.opt('smallTimeFormat');
	},


	// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventTime'.
	// Only applies to non-all-day events.
	computeDisplayEventTime: function() {
		return true;
	},


	// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventEnd'
	computeDisplayEventEnd: function() {
		return true;
	},


	/* Dates
	------------------------------------------------------------------------------------------------------------------*/


	// Tells the grid about what period of time to display.
	// Any date-related internal data should be generated.
	setRange: function(range) {
		this.start = range.start.clone();
		this.end = range.end.clone();

		this.rangeUpdated();
		this.processRangeOptions();
	},


	// Called when internal variables that rely on the range should be updated
	rangeUpdated: function() {
	},


	// Updates values that rely on options and also relate to range
	processRangeOptions: function() {
		var view = this.view;
		var displayEventTime;
		var displayEventEnd;

		this.eventTimeFormat =
			view.opt('eventTimeFormat') ||
			view.opt('timeFormat') || // deprecated
			this.computeEventTimeFormat();

		displayEventTime = view.opt('displayEventTime');
		if (displayEventTime == null) {
			displayEventTime = this.computeDisplayEventTime(); // might be based off of range
		}

		displayEventEnd = view.opt('displayEventEnd');
		if (displayEventEnd == null) {
			displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
		}

		this.displayEventTime = displayEventTime;
		this.displayEventEnd = displayEventEnd;
	},


	// Converts a span (has unzoned start/end and any other grid-specific location information)
	// into an array of segments (pieces of events whose format is decided by the grid).
	spanToSegs: function(span) {
		// subclasses must implement
	},


	// Diffs the two dates, returning a duration, based on granularity of the grid
	// TODO: port isTimeScale into this system?
	diffDates: function(a, b) {
		if (this.largeUnit) {
			return diffByUnit(a, b, this.largeUnit);
		}
		else {
			return diffDayTime(a, b);
		}
	},


	/* Hit Area
	------------------------------------------------------------------------------------------------------------------*/

	hitsNeededDepth: 0, // necessary because multiple callers might need the same hits

	hitsNeeded: function() {
		if (!(this.hitsNeededDepth++)) {
			this.prepareHits();
		}
	},

	hitsNotNeeded: function() {
		if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
			this.releaseHits();
		}
	},


	// Called before one or more queryHit calls might happen. Should prepare any cached coordinates for queryHit
	prepareHits: function() {
	},


	// Called when queryHit calls have subsided. Good place to clear any coordinate caches.
	releaseHits: function() {
	},


	// Given coordinates from the topleft of the document, return data about the date-related area underneath.
	// Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
	// Must have a `grid` property, a reference to this current grid. TODO: avoid this
	// The returned object will be processed by getHitSpan and getHitEl.
	queryHit: function(leftOffset, topOffset) {
	},


	// like getHitSpan, but returns null if the resulting span's range is invalid
	getSafeHitSpan: function(hit) {
		var hitSpan = this.getHitSpan(hit);

		if (!isRangeWithinRange(hitSpan, this.view.activeRange)) {
			return null;
		}

		return hitSpan;
	},


	// Given position-level information about a date-related area within the grid,
	// should return an object with at least a start/end date. Can provide other information as well.
	getHitSpan: function(hit) {
	},


	// Given position-level information about a date-related area within the grid,
	// should return a jQuery element that best represents it. passed to dayClick callback.
	getHitEl: function(hit) {
	},


	/* Rendering
	------------------------------------------------------------------------------------------------------------------*/


	// Sets the container element that the grid should render inside of.
	// Does other DOM-related initializations.
	setElement: function(el) {
		this.el = el;

		if (this.hasDayInteractions) {
			preventSelection(el);

			this.bindDayHandler('touchstart', this.dayTouchStart);
			this.bindDayHandler('mousedown', this.dayMousedown);
		}

		// attach event-element-related handlers. in Grid.events
		// same garbage collection note as above.
		this.bindSegHandlers();

		this.bindGlobalHandlers();
	},


	bindDayHandler: function(name, handler) {
		var _this = this;

		// attach a handler to the grid's root element.
		// jQuery will take care of unregistering them when removeElement gets called.
		this.el.on(name, function(ev) {
			if (
				!$(ev.target).is(
					_this.segSelector + ',' + // directly on an event element
					_this.segSelector + ' *,' + // within an event element
					'.fc-more,' + // a "more.." link
					'a[data-goto]' // a clickable nav link
				)
			) {
				return handler.call(_this, ev);
			}
		});
	},


	// Removes the grid's container element from the DOM. Undoes any other DOM-related attachments.
	// DOES NOT remove any content beforehand (doesn't clear events or call unrenderDates), unlike View
	removeElement: function() {
		this.unbindGlobalHandlers();
		this.clearDragListeners();

		this.el.remove();

		// NOTE: we don't null-out this.el for the same reasons we don't do it within View::removeElement
	},


	// Renders the basic structure of grid view before any content is rendered
	renderSkeleton: function() {
		// subclasses should implement
	},


	// Renders the grid's date-related content (like areas that represent days/times).
	// Assumes setRange has already been called and the skeleton has already been rendered.
	renderDates: function() {
		// subclasses should implement
	},


	// Unrenders the grid's date-related content
	unrenderDates: function() {
		// subclasses should implement
	},


	/* Handlers
	------------------------------------------------------------------------------------------------------------------*/


	// Binds DOM handlers to elements that reside outside the grid, such as the document
	bindGlobalHandlers: function() {
		this.listenTo($(document), {
			dragstart: this.externalDragStart, // jqui
			sortstart: this.externalDragStart // jqui
		});
	},


	// Unbinds DOM handlers from elements that reside outside the grid
	unbindGlobalHandlers: function() {
		this.stopListeningTo($(document));
	},


	// Process a mousedown on an element that represents a day. For day clicking and selecting.
	dayMousedown: function(ev) {
		var view = this.view;

		// HACK
		// This will still work even though bindDayHandler doesn't use GlobalEmitter.
		if (GlobalEmitter.get().shouldIgnoreMouse()) {
			return;
		}

		this.dayClickListener.startInteraction(ev);

		if (view.opt('selectable')) {
			this.daySelectListener.startInteraction(ev, {
				distance: view.opt('selectMinDistance')
			});
		}
	},


	dayTouchStart: function(ev) {
		var view = this.view;
		var selectLongPressDelay;

		// On iOS (and Android?) when a new selection is initiated overtop another selection,
		// the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
		// HACK: simply don't allow this to happen.
		// ALSO: prevent selection when an *event* is already raised.
		if (view.isSelected || view.selectedEvent) {
			return;
		}

		selectLongPressDelay = view.opt('selectLongPressDelay');
		if (selectLongPressDelay == null) {
			selectLongPressDelay = view.opt('longPressDelay'); // fallback
		}

		this.dayClickListener.startInteraction(ev);

		if (view.opt('selectable')) {
			this.daySelectListener.startInteraction(ev, {
				delay: selectLongPressDelay
			});
		}
	},


	// Creates a listener that tracks the user's drag across day elements, for day clicking.
	buildDayClickListener: function() {
		var _this = this;
		var view = this.view;
		var dayClickHit; // null if invalid dayClick

		var dragListener = new HitDragListener(this, {
			scroll: view.opt('dragScroll'),
			interactionStart: function() {
				dayClickHit = dragListener.origHit;
			},
			hitOver: function(hit, isOrig, origHit) {
				// if user dragged to another cell at any point, it can no longer be a dayClick
				if (!isOrig) {
					dayClickHit = null;
				}
			},
			hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
				dayClickHit = null;
			},
			interactionEnd: function(ev, isCancelled) {
				var hitSpan;

				if (!isCancelled && dayClickHit) {
					hitSpan = _this.getSafeHitSpan(dayClickHit);

					if (hitSpan) {
						view.triggerDayClick(hitSpan, _this.getHitEl(dayClickHit), ev);
					}
				}
			}
		});

		// because dayClickListener won't be called with any time delay, "dragging" will begin immediately,
		// which will kill any touchmoving/scrolling. Prevent this.
		dragListener.shouldCancelTouchScroll = false;

		dragListener.scrollAlwaysKills = true;

		return dragListener;
	},


	// Creates a listener that tracks the user's drag across day elements, for day selecting.
	buildDaySelectListener: function() {
		var _this = this;
		var view = this.view;
		var selectionSpan; // null if invalid selection

		var dragListener = new HitDragListener(this, {
			scroll: view.opt('dragScroll'),
			interactionStart: function() {
				selectionSpan = null;
			},
			dragStart: function() {
				view.unselect(); // since we could be rendering a new selection, we want to clear any old one
			},
			hitOver: function(hit, isOrig, origHit) {
				var origHitSpan;
				var hitSpan;

				if (origHit) { // click needs to have started on a hit

					origHitSpan = _this.getSafeHitSpan(origHit);
					hitSpan = _this.getSafeHitSpan(hit);

					if (origHitSpan && hitSpan) {
						selectionSpan = _this.computeSelection(origHitSpan, hitSpan);
					}
					else {
						selectionSpan = null;
					}

					if (selectionSpan) {
						_this.renderSelection(selectionSpan);
					}
					else if (selectionSpan === false) {
						disableCursor();
					}
				}
			},
			hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
				selectionSpan = null;
				_this.unrenderSelection();
			},
			hitDone: function() { // called after a hitOut OR before a dragEnd
				enableCursor();
			},
			interactionEnd: function(ev, isCancelled) {
				if (!isCancelled && selectionSpan) {
					// the selection will already have been rendered. just report it
					view.reportSelection(selectionSpan, ev);
				}
			}
		});

		return dragListener;
	},


	// Kills all in-progress dragging.
	// Useful for when public API methods that result in re-rendering are invoked during a drag.
	// Also useful for when touch devices misbehave and don't fire their touchend.
	clearDragListeners: function() {
		this.dayClickListener.endInteraction();
		this.daySelectListener.endInteraction();

		if (this.segDragListener) {
			this.segDragListener.endInteraction(); // will clear this.segDragListener
		}
		if (this.segResizeListener) {
			this.segResizeListener.endInteraction(); // will clear this.segResizeListener
		}
		if (this.externalDragListener) {
			this.externalDragListener.endInteraction(); // will clear this.externalDragListener
		}
	},


	/* Event Helper
	------------------------------------------------------------------------------------------------------------------*/
	// TODO: should probably move this to Grid.events, like we did event dragging / resizing


	// Renders a mock event at the given event location, which contains zoned start/end properties.
	// Returns all mock event elements.
	renderEventLocationHelper: function(eventLocation, sourceSeg) {
		var fakeEvent = this.fabricateHelperEvent(eventLocation, sourceSeg);

		return this.renderHelper(fakeEvent, sourceSeg); // do the actual rendering
	},


	// Builds a fake event given zoned event date properties and a segment is should be inspired from.
	// The range's end can be null, in which case the mock event that is rendered will have a null end time.
	// `sourceSeg` is the internal segment object involved in the drag. If null, something external is dragging.
	fabricateHelperEvent: function(eventLocation, sourceSeg) {
		var fakeEvent = sourceSeg ? createObject(sourceSeg.event) : {}; // mask the original event object if possible

		fakeEvent.start = eventLocation.start.clone();
		fakeEvent.end = eventLocation.end ? eventLocation.end.clone() : null;
		fakeEvent.allDay = null; // force it to be freshly computed by normalizeEventDates
		this.view.calendar.normalizeEventDates(fakeEvent);

		// this extra className will be useful for differentiating real events from mock events in CSS
		fakeEvent.className = (fakeEvent.className || []).concat('fc-helper');

		// if something external is being dragged in, don't render a resizer
		if (!sourceSeg) {
			fakeEvent.editable = false;
		}

		return fakeEvent;
	},


	// Renders a mock event. Given zoned event date properties.
	// Must return all mock event elements.
	renderHelper: function(eventLocation, sourceSeg) {
		// subclasses must implement
	},


	// Unrenders a mock event
	unrenderHelper: function() {
		// subclasses must implement
	},


	/* Selection
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of a selection. Will highlight by default but can be overridden by subclasses.
	// Given a span (unzoned start/end and other misc data)
	renderSelection: function(span) {
		this.renderHighlight(span);
	},


	// Unrenders any visual indications of a selection. Will unrender a highlight by default.
	unrenderSelection: function() {
		this.unrenderHighlight();
	},


	// Given the first and last date-spans of a selection, returns another date-span object.
	// Subclasses can override and provide additional data in the span object. Will be passed to renderSelection().
	// Will return false if the selection is invalid and this should be indicated to the user.
	// Will return null/undefined if a selection invalid but no error should be reported.
	computeSelection: function(span0, span1) {
		var span = this.computeSelectionSpan(span0, span1);

		if (span && !this.view.calendar.isSelectionSpanAllowed(span)) {
			return false;
		}

		return span;
	},


	// Given two spans, must return the combination of the two.
	// TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
	computeSelectionSpan: function(span0, span1) {
		var dates = [ span0.start, span0.end, span1.start, span1.end ];

		dates.sort(compareNumbers); // sorts chronologically. works with Moments

		return { start: dates[0].clone(), end: dates[3].clone() };
	},


	/* Highlight
	------------------------------------------------------------------------------------------------------------------*/


	// Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
	renderHighlight: function(span) {
		this.renderFill('highlight', this.spanToSegs(span));
	},


	// Unrenders the emphasis on a date range
	unrenderHighlight: function() {
		this.unrenderFill('highlight');
	},


	// Generates an array of classNames for rendering the highlight. Used by the fill system.
	highlightSegClasses: function() {
		return [ 'fc-highlight' ];
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	renderBusinessHours: function() {
	},


	unrenderBusinessHours: function() {
	},


	/* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/


	getNowIndicatorUnit: function() {
	},


	renderNowIndicator: function(date) {
	},


	unrenderNowIndicator: function() {
	},


	/* Fill System (highlight, background events, business hours)
	--------------------------------------------------------------------------------------------------------------------
	TODO: remove this system. like we did in TimeGrid
	*/


	// Renders a set of rectangles over the given segments of time.
	// MUST RETURN a subset of segs, the segs that were actually rendered.
	// Responsible for populating this.elsByFill. TODO: better API for expressing this requirement
	renderFill: function(type, segs) {
		// subclasses must implement
	},


	// Unrenders a specific type of fill that is currently rendered on the grid
	unrenderFill: function(type) {
		var el = this.elsByFill[type];

		if (el) {
			el.remove();
			delete this.elsByFill[type];
		}
	},


	// Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
	// Only returns segments that successfully rendered.
	// To be harnessed by renderFill (implemented by subclasses).
	// Analagous to renderFgSegEls.
	renderFillSegEls: function(type, segs) {
		var _this = this;
		var segElMethod = this[type + 'SegEl'];
		var html = '';
		var renderedSegs = [];
		var i;

		if (segs.length) {

			// build a large concatenation of segment HTML
			for (i = 0; i < segs.length; i++) {
				html += this.fillSegHtml(type, segs[i]);
			}

			// Grab individual elements from the combined HTML string. Use each as the default rendering.
			// Then, compute the 'el' for each segment.
			$(html).each(function(i, node) {
				var seg = segs[i];
				var el = $(node);

				// allow custom filter methods per-type
				if (segElMethod) {
					el = segElMethod.call(_this, seg, el);
				}

				if (el) { // custom filters did not cancel the render
					el = $(el); // allow custom filter to return raw DOM node

					// correct element type? (would be bad if a non-TD were inserted into a table for example)
					if (el.is(_this.fillSegTag)) {
						seg.el = el;
						renderedSegs.push(seg);
					}
				}
			});
		}

		return renderedSegs;
	},


	fillSegTag: 'div', // subclasses can override


	// Builds the HTML needed for one fill segment. Generic enough to work with different types.
	fillSegHtml: function(type, seg) {

		// custom hooks per-type
		var classesMethod = this[type + 'SegClasses'];
		var cssMethod = this[type + 'SegCss'];

		var classes = classesMethod ? classesMethod.call(this, seg) : [];
		var css = cssToStr(cssMethod ? cssMethod.call(this, seg) : {});

		return '<' + this.fillSegTag +
			(classes.length ? ' class="' + classes.join(' ') + '"' : '') +
			(css ? ' style="' + css + '"' : '') +
			' />';
	},



	/* Generic rendering utilities for subclasses
	------------------------------------------------------------------------------------------------------------------*/


	// Computes HTML classNames for a single-day element
	getDayClasses: function(date, noThemeHighlight) {
		var view = this.view;
		var classes = [];
		var today;

		if (!isDateWithinRange(date, view.activeRange)) {
			classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
		}
		else {
			classes.push('fc-' + dayIDs[date.day()]);

			if (
				view.currentRangeAs('months') == 1 && // TODO: somehow get into MonthView
				date.month() != view.currentRange.start.month()
			) {
				classes.push('fc-other-month');
			}

			today = view.calendar.getNow();

			if (date.isSame(today, 'day')) {
				classes.push('fc-today');

				if (noThemeHighlight !== true) {
					classes.push(view.highlightStateClass);
				}
			}
			else if (date < today) {
				classes.push('fc-past');
			}
			else {
				classes.push('fc-future');
			}
		}

		return classes;
	}

});

;;

/* Event-rendering and event-interaction methods for the abstract Grid class
----------------------------------------------------------------------------------------------------------------------

Data Types:
	event - { title, id, start, (end), whatever }
	location - { start, (end), allDay }
	rawEventRange - { start, end }
	eventRange - { start, end, isStart, isEnd }
	eventSpan - { start, end, isStart, isEnd, whatever }
	eventSeg - { event, whatever }
	seg - { whatever }
*/

Grid.mixin({

	// self-config, overridable by subclasses
	segSelector: '.fc-event-container > *', // what constitutes an event element?

	mousedOverSeg: null, // the segment object the user's mouse is over. null if over nothing
	isDraggingSeg: false, // is a segment being dragged? boolean
	isResizingSeg: false, // is a segment being resized? boolean
	isDraggingExternal: false, // jqui-dragging an external element? boolean
	segs: null, // the *event* segments currently rendered in the grid. TODO: rename to `eventSegs`


	// Renders the given events onto the grid
	renderEvents: function(events) {
		var bgEvents = [];
		var fgEvents = [];
		var i;

		for (i = 0; i < events.length; i++) {
			(isBgEvent(events[i]) ? bgEvents : fgEvents).push(events[i]);
		}

		this.segs = [].concat( // record all segs
			this.renderBgEvents(bgEvents),
			this.renderFgEvents(fgEvents)
		);
	},


	renderBgEvents: function(events) {
		var segs = this.eventsToSegs(events);

		// renderBgSegs might return a subset of segs, segs that were actually rendered
		return this.renderBgSegs(segs) || segs;
	},


	renderFgEvents: function(events) {
		var segs = this.eventsToSegs(events);

		// renderFgSegs might return a subset of segs, segs that were actually rendered
		return this.renderFgSegs(segs) || segs;
	},


	// Unrenders all events currently rendered on the grid
	unrenderEvents: function() {
		this.handleSegMouseout(); // trigger an eventMouseout if user's mouse is over an event
		this.clearDragListeners();

		this.unrenderFgSegs();
		this.unrenderBgSegs();

		this.segs = null;
	},


	// Retrieves all rendered segment objects currently rendered on the grid
	getEventSegs: function() {
		return this.segs || [];
	},


	/* Foreground Segment Rendering
	------------------------------------------------------------------------------------------------------------------*/


	// Renders foreground event segments onto the grid. May return a subset of segs that were rendered.
	renderFgSegs: function(segs) {
		// subclasses must implement
	},


	// Unrenders all currently rendered foreground segments
	unrenderFgSegs: function() {
		// subclasses must implement
	},


	// Renders and assigns an `el` property for each foreground event segment.
	// Only returns segments that successfully rendered.
	// A utility that subclasses may use.
	renderFgSegEls: function(segs, disableResizing) {
		var view = this.view;
		var html = '';
		var renderedSegs = [];
		var i;

		if (segs.length) { // don't build an empty html string

			// build a large concatenation of event segment HTML
			for (i = 0; i < segs.length; i++) {
				html += this.fgSegHtml(segs[i], disableResizing);
			}

			// Grab individual elements from the combined HTML string. Use each as the default rendering.
			// Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
			$(html).each(function(i, node) {
				var seg = segs[i];
				var el = view.resolveEventEl(seg.event, $(node));

				if (el) {
					el.data('fc-seg', seg); // used by handlers
					seg.el = el;
					renderedSegs.push(seg);
				}
			});
		}

		return renderedSegs;
	},


	// Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
	fgSegHtml: function(seg, disableResizing) {
		// subclasses should implement
	},


	/* Background Segment Rendering
	------------------------------------------------------------------------------------------------------------------*/


	// Renders the given background event segments onto the grid.
	// Returns a subset of the segs that were actually rendered.
	renderBgSegs: function(segs) {
		return this.renderFill('bgEvent', segs);
	},


	// Unrenders all the currently rendered background event segments
	unrenderBgSegs: function() {
		this.unrenderFill('bgEvent');
	},


	// Renders a background event element, given the default rendering. Called by the fill system.
	bgEventSegEl: function(seg, el) {
		return this.view.resolveEventEl(seg.event, el); // will filter through eventRender
	},


	// Generates an array of classNames to be used for the default rendering of a background event.
	// Called by fillSegHtml.
	bgEventSegClasses: function(seg) {
		var event = seg.event;
		var source = event.source || {};

		return [ 'fc-bgevent' ].concat(
			event.className,
			source.className || []
		);
	},


	// Generates a semicolon-separated CSS string to be used for the default rendering of a background event.
	// Called by fillSegHtml.
	bgEventSegCss: function(seg) {
		return {
			'background-color': this.getSegSkinCss(seg)['background-color']
		};
	},


	// Generates an array of classNames to be used for the rendering business hours overlay. Called by the fill system.
	// Called by fillSegHtml.
	businessHoursSegClasses: function(seg) {
		return [ 'fc-nonbusiness', 'fc-bgevent' ];
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	// Compute business hour segs for the grid's current date range.
	// Caller must ask if whole-day business hours are needed.
	// If no `businessHours` configuration value is specified, assumes the calendar default.
	buildBusinessHourSegs: function(wholeDay, businessHours) {
		return this.eventsToSegs(
			this.buildBusinessHourEvents(wholeDay, businessHours)
		);
	},


	// Compute business hour *events* for the grid's current date range.
	// Caller must ask if whole-day business hours are needed.
	// If no `businessHours` configuration value is specified, assumes the calendar default.
	buildBusinessHourEvents: function(wholeDay, businessHours) {
		var calendar = this.view.calendar;
		var events;

		if (businessHours == null) {
			// fallback
			// access from calendawr. don't access from view. doesn't update with dynamic options.
			businessHours = calendar.opt('businessHours');
		}

		events = calendar.computeBusinessHourEvents(wholeDay, businessHours);

		// HACK. Eventually refactor business hours "events" system.
		// If no events are given, but businessHours is activated, this means the entire visible range should be
		// marked as *not* business-hours, via inverse-background rendering.
		if (!events.length && businessHours) {
			events = [
				$.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, {
					start: this.view.activeRange.end, // guaranteed out-of-range
					end: this.view.activeRange.end,   // "
					dow: null
				})
			];
		}

		return events;
	},


	/* Handlers
	------------------------------------------------------------------------------------------------------------------*/


	// Attaches event-element-related handlers for *all* rendered event segments of the view.
	bindSegHandlers: function() {
		this.bindSegHandlersToEl(this.el);
	},


	// Attaches event-element-related handlers to an arbitrary container element. leverages bubbling.
	bindSegHandlersToEl: function(el) {
		this.bindSegHandlerToEl(el, 'touchstart', this.handleSegTouchStart);
		this.bindSegHandlerToEl(el, 'mouseenter', this.handleSegMouseover);
		this.bindSegHandlerToEl(el, 'mouseleave', this.handleSegMouseout);
		this.bindSegHandlerToEl(el, 'mousedown', this.handleSegMousedown);
		this.bindSegHandlerToEl(el, 'click', this.handleSegClick);
	},


	// Executes a handler for any a user-interaction on a segment.
	// Handler gets called with (seg, ev), and with the `this` context of the Grid
	bindSegHandlerToEl: function(el, name, handler) {
		var _this = this;

		el.on(name, this.segSelector, function(ev) {
			var seg = $(this).data('fc-seg'); // grab segment data. put there by View::renderEvents

			// only call the handlers if there is not a drag/resize in progress
			if (seg && !_this.isDraggingSeg && !_this.isResizingSeg) {
				return handler.call(_this, seg, ev); // context will be the Grid
			}
		});
	},


	handleSegClick: function(seg, ev) {
		var res = this.view.publiclyTrigger('eventClick', seg.el[0], seg.event, ev); // can return `false` to cancel
		if (res === false) {
			ev.preventDefault();
		}
	},


	// Updates internal state and triggers handlers for when an event element is moused over
	handleSegMouseover: function(seg, ev) {
		if (
			!GlobalEmitter.get().shouldIgnoreMouse() &&
			!this.mousedOverSeg
		) {
			this.mousedOverSeg = seg;
			if (this.view.isEventResizable(seg.event)) {
				seg.el.addClass('fc-allow-mouse-resize');
			}
			this.view.publiclyTrigger('eventMouseover', seg.el[0], seg.event, ev);
		}
	},


	// Updates internal state and triggers handlers for when an event element is moused out.
	// Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
	handleSegMouseout: function(seg, ev) {
		ev = ev || {}; // if given no args, make a mock mouse event

		if (this.mousedOverSeg) {
			seg = seg || this.mousedOverSeg; // if given no args, use the currently moused-over segment
			this.mousedOverSeg = null;
			if (this.view.isEventResizable(seg.event)) {
				seg.el.removeClass('fc-allow-mouse-resize');
			}
			this.view.publiclyTrigger('eventMouseout', seg.el[0], seg.event, ev);
		}
	},


	handleSegMousedown: function(seg, ev) {
		var isResizing = this.startSegResize(seg, ev, { distance: 5 });

		if (!isResizing && this.view.isEventDraggable(seg.event)) {
			this.buildSegDragListener(seg)
				.startInteraction(ev, {
					distance: 5
				});
		}
	},


	handleSegTouchStart: function(seg, ev) {
		var view = this.view;
		var event = seg.event;
		var isSelected = view.isEventSelected(event);
		var isDraggable = view.isEventDraggable(event);
		var isResizable = view.isEventResizable(event);
		var isResizing = false;
		var dragListener;
		var eventLongPressDelay;

		if (isSelected && isResizable) {
			// only allow resizing of the event is selected
			isResizing = this.startSegResize(seg, ev);
		}

		if (!isResizing && (isDraggable || isResizable)) { // allowed to be selected?

			eventLongPressDelay = view.opt('eventLongPressDelay');
			if (eventLongPressDelay == null) {
				eventLongPressDelay = view.opt('longPressDelay'); // fallback
			}

			dragListener = isDraggable ?
				this.buildSegDragListener(seg) :
				this.buildSegSelectListener(seg); // seg isn't draggable, but still needs to be selected

			dragListener.startInteraction(ev, { // won't start if already started
				delay: isSelected ? 0 : eventLongPressDelay // do delay if not already selected
			});
		}
	},


	// returns boolean whether resizing actually started or not.
	// assumes the seg allows resizing.
	// `dragOptions` are optional.
	startSegResize: function(seg, ev, dragOptions) {
		if ($(ev.target).is('.fc-resizer')) {
			this.buildSegResizeListener(seg, $(ev.target).is('.fc-start-resizer'))
				.startInteraction(ev, dragOptions);
			return true;
		}
		return false;
	},



	/* Event Dragging
	------------------------------------------------------------------------------------------------------------------*/


	// Builds a listener that will track user-dragging on an event segment.
	// Generic enough to work with any type of Grid.
	// Has side effect of setting/unsetting `segDragListener`
	buildSegDragListener: function(seg) {
		var _this = this;
		var view = this.view;
		var el = seg.el;
		var event = seg.event;
		var isDragging;
		var mouseFollower; // A clone of the original element that will move with the mouse
		var dropLocation; // zoned event date properties

		if (this.segDragListener) {
			return this.segDragListener;
		}

		// Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
		// of the view.
		var dragListener = this.segDragListener = new HitDragListener(view, {
			scroll: view.opt('dragScroll'),
			subjectEl: el,
			subjectCenter: true,
			interactionStart: function(ev) {
				seg.component = _this; // for renderDrag
				isDragging = false;
				mouseFollower = new MouseFollower(seg.el, {
					additionalClass: 'fc-dragging',
					parentEl: view.el,
					opacity: dragListener.isTouch ? null : view.opt('dragOpacity'),
					revertDuration: view.opt('dragRevertDuration'),
					zIndex: 2 // one above the .fc-view
				});
				mouseFollower.hide(); // don't show until we know this is a real drag
				mouseFollower.start(ev);
			},
			dragStart: function(ev) {
				if (dragListener.isTouch && !view.isEventSelected(event)) {
					// if not previously selected, will fire after a delay. then, select the event
					view.selectEvent(event);
				}
				isDragging = true;
				_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
				_this.segDragStart(seg, ev);
				view.hideEvent(event); // hide all event segments. our mouseFollower will take over
			},
			hitOver: function(hit, isOrig, origHit) {
				var isAllowed = true;
				var origHitSpan;
				var hitSpan;
				var dragHelperEls;

				// starting hit could be forced (DayGrid.limit)
				if (seg.hit) {
					origHit = seg.hit;
				}

				// hit might not belong to this grid, so query origin grid
				origHitSpan = origHit.component.getSafeHitSpan(origHit);
				hitSpan = hit.component.getSafeHitSpan(hit);

				if (origHitSpan && hitSpan) {
					dropLocation = _this.computeEventDrop(origHitSpan, hitSpan, event);
					isAllowed = dropLocation && _this.isEventLocationAllowed(dropLocation, event);
				}
				else {
					isAllowed = false;
				}

				if (!isAllowed) {
					dropLocation = null;
					disableCursor();
				}

				// if a valid drop location, have the subclass render a visual indication
				if (dropLocation && (dragHelperEls = view.renderDrag(dropLocation, seg))) {

					dragHelperEls.addClass('fc-dragging');
					if (!dragListener.isTouch) {
						_this.applyDragOpacity(dragHelperEls);
					}

					mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
				}
				else {
					mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
				}

				if (isOrig) {
					dropLocation = null; // needs to have moved hits to be a valid drop
				}
			},
			hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
				view.unrenderDrag(); // unrender whatever was done in renderDrag
				mouseFollower.show(); // show in case we are moving out of all hits
				dropLocation = null;
			},
			hitDone: function() { // Called after a hitOut OR before a dragEnd
				enableCursor();
			},
			interactionEnd: function(ev) {
				delete seg.component; // prevent side effects

				// do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
				mouseFollower.stop(!dropLocation, function() {
					if (isDragging) {
						view.unrenderDrag();
						_this.segDragStop(seg, ev);
					}

					if (dropLocation) {
						// no need to re-show original, will rerender all anyways. esp important if eventRenderWait
						view.reportSegDrop(seg, dropLocation, _this.largeUnit, el, ev);
					}
					else {
						view.showEvent(event);
					}
				});
				_this.segDragListener = null;
			}
		});

		return dragListener;
	},


	// seg isn't draggable, but let's use a generic DragListener
	// simply for the delay, so it can be selected.
	// Has side effect of setting/unsetting `segDragListener`
	buildSegSelectListener: function(seg) {
		var _this = this;
		var view = this.view;
		var event = seg.event;

		if (this.segDragListener) {
			return this.segDragListener;
		}

		var dragListener = this.segDragListener = new DragListener({
			dragStart: function(ev) {
				if (dragListener.isTouch && !view.isEventSelected(event)) {
					// if not previously selected, will fire after a delay. then, select the event
					view.selectEvent(event);
				}
			},
			interactionEnd: function(ev) {
				_this.segDragListener = null;
			}
		});

		return dragListener;
	},


	// Called before event segment dragging starts
	segDragStart: function(seg, ev) {
		this.isDraggingSeg = true;
		this.view.publiclyTrigger('eventDragStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
	},


	// Called after event segment dragging stops
	segDragStop: function(seg, ev) {
		this.isDraggingSeg = false;
		this.view.publiclyTrigger('eventDragStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
	},


	// Given the spans an event drag began, and the span event was dropped, calculates the new zoned start/end/allDay
	// values for the event. Subclasses may override and set additional properties to be used by renderDrag.
	// A falsy returned value indicates an invalid drop.
	// DOES NOT consider overlap/constraint.
	computeEventDrop: function(startSpan, endSpan, event) {
		var calendar = this.view.calendar;
		var dragStart = startSpan.start;
		var dragEnd = endSpan.start;
		var delta;
		var dropLocation; // zoned event date properties

		if (dragStart.hasTime() === dragEnd.hasTime()) {
			delta = this.diffDates(dragEnd, dragStart);

			// if an all-day event was in a timed area and it was dragged to a different time,
			// guarantee an end and adjust start/end to have times
			if (event.allDay && durationHasTime(delta)) {
				dropLocation = {
					start: event.start.clone(),
					end: calendar.getEventEnd(event), // will be an ambig day
					allDay: false // for normalizeEventTimes
				};
				calendar.normalizeEventTimes(dropLocation);
			}
			// othewise, work off existing values
			else {
				dropLocation = pluckEventDateProps(event);
			}

			dropLocation.start.add(delta);
			if (dropLocation.end) {
				dropLocation.end.add(delta);
			}
		}
		else {
			// if switching from day <-> timed, start should be reset to the dropped date, and the end cleared
			dropLocation = {
				start: dragEnd.clone(),
				end: null, // end should be cleared
				allDay: !dragEnd.hasTime()
			};
		}

		return dropLocation;
	},


	// Utility for apply dragOpacity to a jQuery set
	applyDragOpacity: function(els) {
		var opacity = this.view.opt('dragOpacity');

		if (opacity != null) {
			els.css('opacity', opacity);
		}
	},


	/* External Element Dragging
	------------------------------------------------------------------------------------------------------------------*/


	// Called when a jQuery UI drag is initiated anywhere in the DOM
	externalDragStart: function(ev, ui) {
		var view = this.view;
		var el;
		var accept;

		if (view.opt('droppable')) { // only listen if this setting is on
			el = $((ui ? ui.item : null) || ev.target);

			// Test that the dragged element passes the dropAccept selector or filter function.
			// FYI, the default is "*" (matches all)
			accept = view.opt('dropAccept');
			if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
				if (!this.isDraggingExternal) { // prevent double-listening if fired twice
					this.listenToExternalDrag(el, ev, ui);
				}
			}
		}
	},


	// Called when a jQuery UI drag starts and it needs to be monitored for dropping
	listenToExternalDrag: function(el, ev, ui) {
		var _this = this;
		var view = this.view;
		var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
		var dropLocation; // a null value signals an unsuccessful drag

		// listener that tracks mouse movement over date-associated pixel regions
		var dragListener = _this.externalDragListener = new HitDragListener(this, {
			interactionStart: function() {
				_this.isDraggingExternal = true;
			},
			hitOver: function(hit) {
				var isAllowed = true;
				var hitSpan = hit.component.getSafeHitSpan(hit); // hit might not belong to this grid

				if (hitSpan) {
					dropLocation = _this.computeExternalDrop(hitSpan, meta);
					isAllowed = dropLocation && _this.isExternalLocationAllowed(dropLocation, meta.eventProps);
				}
				else {
					isAllowed = false;
				}

				if (!isAllowed) {
					dropLocation = null;
					disableCursor();
				}

				if (dropLocation) {
					_this.renderDrag(dropLocation); // called without a seg parameter
				}
			},
			hitOut: function() {
				dropLocation = null; // signal unsuccessful
			},
			hitDone: function() { // Called after a hitOut OR before a dragEnd
				enableCursor();
				_this.unrenderDrag();
			},
			interactionEnd: function(ev) {
				if (dropLocation) { // element was dropped on a valid hit
					view.reportExternalDrop(meta, dropLocation, el, ev, ui);
				}
				_this.isDraggingExternal = false;
				_this.externalDragListener = null;
			}
		});

		dragListener.startDrag(ev); // start listening immediately
	},


	// Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
	// returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
	// Returning a null value signals an invalid drop hit.
	// DOES NOT consider overlap/constraint.
	computeExternalDrop: function(span, meta) {
		var calendar = this.view.calendar;
		var dropLocation = {
			start: calendar.applyTimezone(span.start), // simulate a zoned event start date
			end: null
		};

		// if dropped on an all-day span, and element's metadata specified a time, set it
		if (meta.startTime && !dropLocation.start.hasTime()) {
			dropLocation.start.time(meta.startTime);
		}

		if (meta.duration) {
			dropLocation.end = dropLocation.start.clone().add(meta.duration);
		}

		return dropLocation;
	},



	/* Drag Rendering (for both events and an external elements)
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of an event or external element being dragged.
	// `dropLocation` contains hypothetical start/end/allDay values the event would have if dropped. end can be null.
	// `seg` is the internal segment object that is being dragged. If dragging an external element, `seg` is null.
	// A truthy returned value indicates this method has rendered a helper element.
	// Must return elements used for any mock events.
	renderDrag: function(dropLocation, seg) {
		// subclasses must implement
	},


	// Unrenders a visual indication of an event or external element being dragged
	unrenderDrag: function() {
		// subclasses must implement
	},


	/* Resizing
	------------------------------------------------------------------------------------------------------------------*/


	// Creates a listener that tracks the user as they resize an event segment.
	// Generic enough to work with any type of Grid.
	buildSegResizeListener: function(seg, isStart) {
		var _this = this;
		var view = this.view;
		var calendar = view.calendar;
		var el = seg.el;
		var event = seg.event;
		var eventEnd = calendar.getEventEnd(event);
		var isDragging;
		var resizeLocation; // zoned event date properties. falsy if invalid resize

		// Tracks mouse movement over the *grid's* coordinate map
		var dragListener = this.segResizeListener = new HitDragListener(this, {
			scroll: view.opt('dragScroll'),
			subjectEl: el,
			interactionStart: function() {
				isDragging = false;
			},
			dragStart: function(ev) {
				isDragging = true;
				_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
				_this.segResizeStart(seg, ev);
			},
			hitOver: function(hit, isOrig, origHit) {
				var isAllowed = true;
				var origHitSpan = _this.getSafeHitSpan(origHit);
				var hitSpan = _this.getSafeHitSpan(hit);

				if (origHitSpan && hitSpan) {
					resizeLocation = isStart ?
						_this.computeEventStartResize(origHitSpan, hitSpan, event) :
						_this.computeEventEndResize(origHitSpan, hitSpan, event);

					isAllowed = resizeLocation && _this.isEventLocationAllowed(resizeLocation, event);
				}
				else {
					isAllowed = false;
				}

				if (!isAllowed) {
					resizeLocation = null;
					disableCursor();
				}
				else {
					if (
						resizeLocation.start.isSame(event.start.clone().stripZone()) &&
						resizeLocation.end.isSame(eventEnd.clone().stripZone())
					) {
						// no change. (FYI, event dates might have zones)
						resizeLocation = null;
					}
				}

				if (resizeLocation) {
					view.hideEvent(event);
					_this.renderEventResize(resizeLocation, seg);
				}
			},
			hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
				resizeLocation = null;
				view.showEvent(event); // for when out-of-bounds. show original
			},
			hitDone: function() { // resets the rendering to show the original event
				_this.unrenderEventResize();
				enableCursor();
			},
			interactionEnd: function(ev) {
				if (isDragging) {
					_this.segResizeStop(seg, ev);
				}

				if (resizeLocation) { // valid date to resize to?
					// no need to re-show original, will rerender all anyways. esp important if eventRenderWait
					view.reportSegResize(seg, resizeLocation, _this.largeUnit, el, ev);
				}
				else {
					view.showEvent(event);
				}
				_this.segResizeListener = null;
			}
		});

		return dragListener;
	},


	// Called before event segment resizing starts
	segResizeStart: function(seg, ev) {
		this.isResizingSeg = true;
		this.view.publiclyTrigger('eventResizeStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
	},


	// Called after event segment resizing stops
	segResizeStop: function(seg, ev) {
		this.isResizingSeg = false;
		this.view.publiclyTrigger('eventResizeStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
	},


	// Returns new date-information for an event segment being resized from its start
	computeEventStartResize: function(startSpan, endSpan, event) {
		return this.computeEventResize('start', startSpan, endSpan, event);
	},


	// Returns new date-information for an event segment being resized from its end
	computeEventEndResize: function(startSpan, endSpan, event) {
		return this.computeEventResize('end', startSpan, endSpan, event);
	},


	// Returns new zoned date information for an event segment being resized from its start OR end
	// `type` is either 'start' or 'end'.
	// DOES NOT consider overlap/constraint.
	computeEventResize: function(type, startSpan, endSpan, event) {
		var calendar = this.view.calendar;
		var delta = this.diffDates(endSpan[type], startSpan[type]);
		var resizeLocation; // zoned event date properties
		var defaultDuration;

		// build original values to work from, guaranteeing a start and end
		resizeLocation = {
			start: event.start.clone(),
			end: calendar.getEventEnd(event),
			allDay: event.allDay
		};

		// if an all-day event was in a timed area and was resized to a time, adjust start/end to have times
		if (resizeLocation.allDay && durationHasTime(delta)) {
			resizeLocation.allDay = false;
			calendar.normalizeEventTimes(resizeLocation);
		}

		resizeLocation[type].add(delta); // apply delta to start or end

		// if the event was compressed too small, find a new reasonable duration for it
		if (!resizeLocation.start.isBefore(resizeLocation.end)) {

			defaultDuration =
				this.minResizeDuration || // TODO: hack
				(event.allDay ?
					calendar.defaultAllDayEventDuration :
					calendar.defaultTimedEventDuration);

			if (type == 'start') { // resizing the start?
				resizeLocation.start = resizeLocation.end.clone().subtract(defaultDuration);
			}
			else { // resizing the end?
				resizeLocation.end = resizeLocation.start.clone().add(defaultDuration);
			}
		}

		return resizeLocation;
	},


	// Renders a visual indication of an event being resized.
	// `range` has the updated dates of the event. `seg` is the original segment object involved in the drag.
	// Must return elements used for any mock events.
	renderEventResize: function(range, seg) {
		// subclasses must implement
	},


	// Unrenders a visual indication of an event being resized.
	unrenderEventResize: function() {
		// subclasses must implement
	},


	/* Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Compute the text that should be displayed on an event's element.
	// `range` can be the Event object itself, or something range-like, with at least a `start`.
	// If event times are disabled, or the event has no time, will return a blank string.
	// If not specified, formatStr will default to the eventTimeFormat setting,
	// and displayEnd will default to the displayEventEnd setting.
	getEventTimeText: function(range, formatStr, displayEnd) {

		if (formatStr == null) {
			formatStr = this.eventTimeFormat;
		}

		if (displayEnd == null) {
			displayEnd = this.displayEventEnd;
		}

		if (this.displayEventTime && range.start.hasTime()) {
			if (displayEnd && range.end) {
				return this.view.formatRange(range, formatStr);
			}
			else {
				return range.start.format(formatStr);
			}
		}

		return '';
	},


	// Generic utility for generating the HTML classNames for an event segment's element
	getSegClasses: function(seg, isDraggable, isResizable) {
		var view = this.view;
		var classes = [
			'fc-event',
			seg.isStart ? 'fc-start' : 'fc-not-start',
			seg.isEnd ? 'fc-end' : 'fc-not-end'
		].concat(this.getSegCustomClasses(seg));

		if (isDraggable) {
			classes.push('fc-draggable');
		}
		if (isResizable) {
			classes.push('fc-resizable');
		}

		// event is currently selected? attach a className.
		if (view.isEventSelected(seg.event)) {
			classes.push('fc-selected');
		}

		return classes;
	},


	// List of classes that were defined by the caller of the API in some way
	getSegCustomClasses: function(seg) {
		var event = seg.event;

		return [].concat(
			event.className, // guaranteed to be an array
			event.source ? event.source.className : []
		);
	},


	// Utility for generating event skin-related CSS properties
	getSegSkinCss: function(seg) {
		return {
			'background-color': this.getSegBackgroundColor(seg),
			'border-color': this.getSegBorderColor(seg),
			color: this.getSegTextColor(seg)
		};
	},


	// Queries for caller-specified color, then falls back to default
	getSegBackgroundColor: function(seg) {
		return seg.event.backgroundColor ||
			seg.event.color ||
			this.getSegDefaultBackgroundColor(seg);
	},


	getSegDefaultBackgroundColor: function(seg) {
		var source = seg.event.source || {};

		return source.backgroundColor ||
			source.color ||
			this.view.opt('eventBackgroundColor') ||
			this.view.opt('eventColor');
	},


	// Queries for caller-specified color, then falls back to default
	getSegBorderColor: function(seg) {
		return seg.event.borderColor ||
			seg.event.color ||
			this.getSegDefaultBorderColor(seg);
	},


	getSegDefaultBorderColor: function(seg) {
		var source = seg.event.source || {};

		return source.borderColor ||
			source.color ||
			this.view.opt('eventBorderColor') ||
			this.view.opt('eventColor');
	},


	// Queries for caller-specified color, then falls back to default
	getSegTextColor: function(seg) {
		return seg.event.textColor ||
			this.getSegDefaultTextColor(seg);
	},


	getSegDefaultTextColor: function(seg) {
		var source = seg.event.source || {};

		return source.textColor ||
			this.view.opt('eventTextColor');
	},


	/* Event Location Validation
	------------------------------------------------------------------------------------------------------------------*/


	isEventLocationAllowed: function(eventLocation, event) {
		if (this.isEventLocationInRange(eventLocation)) {
			var calendar = this.view.calendar;
			var eventSpans = this.eventToSpans(eventLocation);
			var i;

			if (eventSpans.length) {
				for (i = 0; i < eventSpans.length; i++) {
					if (!calendar.isEventSpanAllowed(eventSpans[i], event)) {
						return false;
					}
				}

				return true;
			}
		}

		return false;
	},


	isExternalLocationAllowed: function(eventLocation, metaProps) { // FOR the external element
		if (this.isEventLocationInRange(eventLocation)) {
			var calendar = this.view.calendar;
			var eventSpans = this.eventToSpans(eventLocation);
			var i;

			if (eventSpans.length) {
				for (i = 0; i < eventSpans.length; i++) {
					if (!calendar.isExternalSpanAllowed(eventSpans[i], eventLocation, metaProps)) {
						return false;
					}
				}

				return true;
			}
		}

		return false;
	},


	isEventLocationInRange: function(eventLocation) {
		return isRangeWithinRange(
			this.eventToRawRange(eventLocation),
			this.view.validRange
		);
	},


	/* Converting events -> eventRange -> eventSpan -> eventSegs
	------------------------------------------------------------------------------------------------------------------*/


	// Generates an array of segments for the given single event
	// Can accept an event "location" as well (which only has start/end and no allDay)
	eventToSegs: function(event) {
		return this.eventsToSegs([ event ]);
	},


	// Generates spans (always unzoned) for the given event.
	// Does not do any inverting for inverse-background events.
	// Can accept an event "location" as well (which only has start/end and no allDay)
	eventToSpans: function(event) {
		var eventRange = this.eventToRange(event); // { start, end, isStart, isEnd }

		if (eventRange) {
			return this.eventRangeToSpans(eventRange, event);
		}
		else { // out of view's valid range
			return [];
		}
	},



	// Converts an array of event objects into an array of event segment objects.
	// A custom `segSliceFunc` may be given for arbitrarily slicing up events.
	// Doesn't guarantee an order for the resulting array.
	eventsToSegs: function(allEvents, segSliceFunc) {
		var _this = this;
		var eventsById = groupEventsById(allEvents);
		var segs = [];

		$.each(eventsById, function(id, events) {
			var visibleEvents = [];
			var eventRanges = [];
			var eventRange; // { start, end, isStart, isEnd }
			var i;

			for (i = 0; i < events.length; i++) {
				eventRange = _this.eventToRange(events[i]); // might be null if completely out of range

				if (eventRange) {
					eventRanges.push(eventRange);
					visibleEvents.push(events[i]);
				}
			}

			// inverse-background events (utilize only the first event in calculations)
			if (isInverseBgEvent(events[0])) {
				eventRanges = _this.invertRanges(eventRanges); // will lose isStart/isEnd

				for (i = 0; i < eventRanges.length; i++) {
					segs.push.apply(segs, // append to
						_this.eventRangeToSegs(eventRanges[i], events[0], segSliceFunc)
					);
				}
			}
			// normal event ranges
			else {
				for (i = 0; i < eventRanges.length; i++) {
					segs.push.apply(segs, // append to
						_this.eventRangeToSegs(eventRanges[i], visibleEvents[i], segSliceFunc)
					);
				}
			}
		});

		return segs;
	},


	// Generates the unzoned start/end dates an event appears to occupy
	// Can accept an event "location" as well (which only has start/end and no allDay)
	// returns { start, end, isStart, isEnd }
	// If the event is completely outside of the grid's valid range, will return undefined.
	eventToRange: function(event) {
		return this.refineRawEventRange(
			this.eventToRawRange(event)
		);
	},


	// Ensures the given range is within the view's activeRange and is correctly localized.
	// Always returns a result
	refineRawEventRange: function(rawRange) {
		var view = this.view;
		var calendar = view.calendar;
		var range = intersectRanges(rawRange, view.activeRange);

		if (range) { // otherwise, event doesn't have valid range

			// hack: dynamic locale change forgets to upate stored event localed
			calendar.localizeMoment(range.start);
			calendar.localizeMoment(range.end);

			return range;
		}
	},


	// not constrained to valid dates
	// not given localizeMoment hack
	eventToRawRange: function(event) {
		var calendar = this.view.calendar;
		var start = event.start.clone().stripZone();
		var end = (
				event.end ?
					event.end.clone() :
					// derive the end from the start and allDay. compute allDay if necessary
					calendar.getDefaultEventEnd(
						event.allDay != null ?
							event.allDay :
							!event.start.hasTime(),
						event.start
					)
			).stripZone();

		return { start: start, end: end };
	},


	// Given an event's range (unzoned start/end), and the event itself,
	// slice into segments (using the segSliceFunc function if specified)
	// eventRange - { start, end, isStart, isEnd }
	eventRangeToSegs: function(eventRange, event, segSliceFunc) {
		var eventSpans = this.eventRangeToSpans(eventRange, event);
		var segs = [];
		var i;

		for (i = 0; i < eventSpans.length; i++) {
			segs.push.apply(segs, // append to
				this.eventSpanToSegs(eventSpans[i], event, segSliceFunc)
			);
		}

		return segs;
	},


	// Given an event's unzoned date range, return an array of eventSpan objects.
	// eventSpan - { start, end, isStart, isEnd, otherthings... }
	// Subclasses can override.
	// Subclasses are obligated to forward eventRange.isStart/isEnd to the resulting spans.
	eventRangeToSpans: function(eventRange, event) {
		return [ $.extend({}, eventRange) ]; // copy into a single-item array
	},


	// Given an event's span (unzoned start/end and other misc data), and the event itself,
	// slices into segments and attaches event-derived properties to them.
	// eventSpan - { start, end, isStart, isEnd, otherthings... }
	eventSpanToSegs: function(eventSpan, event, segSliceFunc) {
		var segs = segSliceFunc ? segSliceFunc(eventSpan) : this.spanToSegs(eventSpan);
		var i, seg;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];

			// the eventSpan's isStart/isEnd takes precedence over the seg's
			if (!eventSpan.isStart) {
				seg.isStart = false;
			}
			if (!eventSpan.isEnd) {
				seg.isEnd = false;
			}

			seg.event = event;
			seg.eventStartMS = +eventSpan.start; // TODO: not the best name after making spans unzoned
			seg.eventDurationMS = eventSpan.end - eventSpan.start;
		}

		return segs;
	},


	// Produces a new array of range objects that will cover all the time NOT covered by the given ranges.
	// SIDE EFFECT: will mutate the given array and will use its date references.
	invertRanges: function(ranges) {
		var view = this.view;
		var viewStart = view.activeRange.start.clone(); // need a copy
		var viewEnd = view.activeRange.end.clone(); // need a copy
		var inverseRanges = [];
		var start = viewStart; // the end of the previous range. the start of the new range
		var i, range;

		// ranges need to be in order. required for our date-walking algorithm
		ranges.sort(compareRanges);

		for (i = 0; i < ranges.length; i++) {
			range = ranges[i];

			// add the span of time before the event (if there is any)
			if (range.start > start) { // compare millisecond time (skip any ambig logic)
				inverseRanges.push({
					start: start,
					end: range.start
				});
			}

			if (range.end > start) {
				start = range.end;
			}
		}

		// add the span of time after the last event (if there is any)
		if (start < viewEnd) { // compare millisecond time (skip any ambig logic)
			inverseRanges.push({
				start: start,
				end: viewEnd
			});
		}

		return inverseRanges;
	},


	sortEventSegs: function(segs) {
		segs.sort(proxy(this, 'compareEventSegs'));
	},


	// A cmp function for determining which segments should take visual priority
	compareEventSegs: function(seg1, seg2) {
		return seg1.eventStartMS - seg2.eventStartMS || // earlier events go first
			seg2.eventDurationMS - seg1.eventDurationMS || // tie? longer events go first
			seg2.event.allDay - seg1.event.allDay || // tie? put all-day events first (booleans cast to 0/1)
			compareByFieldSpecs(seg1.event, seg2.event, this.view.eventOrderSpecs);
	}

});


/* Utilities
----------------------------------------------------------------------------------------------------------------------*/


function pluckEventDateProps(event) {
	return {
		start: event.start.clone(),
		end: event.end ? event.end.clone() : null,
		allDay: event.allDay // keep it the same
	};
}
FC.pluckEventDateProps = pluckEventDateProps;


function isBgEvent(event) { // returns true if background OR inverse-background
	var rendering = getEventRendering(event);
	return rendering === 'background' || rendering === 'inverse-background';
}
FC.isBgEvent = isBgEvent; // export


function isInverseBgEvent(event) {
	return getEventRendering(event) === 'inverse-background';
}


function getEventRendering(event) {
	return firstDefined((event.source || {}).rendering, event.rendering);
}


function groupEventsById(events) {
	var eventsById = {};
	var i, event;

	for (i = 0; i < events.length; i++) {
		event = events[i];
		(eventsById[event._id] || (eventsById[event._id] = [])).push(event);
	}

	return eventsById;
}


// A cmp function for determining which non-inverted "ranges" (see above) happen earlier
function compareRanges(range1, range2) {
	return range1.start - range2.start; // earlier ranges go first
}


/* External-Dragging-Element Data
----------------------------------------------------------------------------------------------------------------------*/

// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
FC.dataAttrPrefix = '';

// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
// to be used for Event Object creation.
// A defined `.eventProps`, even when empty, indicates that an event should be created.
function getDraggedElMeta(el) {
	var prefix = FC.dataAttrPrefix;
	var eventProps; // properties for creating the event, not related to date/time
	var startTime; // a Duration
	var duration;
	var stick;

	if (prefix) { prefix += '-'; }
	eventProps = el.data(prefix + 'event') || null;

	if (eventProps) {
		if (typeof eventProps === 'object') {
			eventProps = $.extend({}, eventProps); // make a copy
		}
		else { // something like 1 or true. still signal event creation
			eventProps = {};
		}

		// pluck special-cased date/time properties
		startTime = eventProps.start;
		if (startTime == null) { startTime = eventProps.time; } // accept 'time' as well
		duration = eventProps.duration;
		stick = eventProps.stick;
		delete eventProps.start;
		delete eventProps.time;
		delete eventProps.duration;
		delete eventProps.stick;
	}

	// fallback to standalone attribute values for each of the date/time properties
	if (startTime == null) { startTime = el.data(prefix + 'start'); }
	if (startTime == null) { startTime = el.data(prefix + 'time'); } // accept 'time' as well
	if (duration == null) { duration = el.data(prefix + 'duration'); }
	if (stick == null) { stick = el.data(prefix + 'stick'); }

	// massage into correct data types
	startTime = startTime != null ? moment.duration(startTime) : null;
	duration = duration != null ? moment.duration(duration) : null;
	stick = Boolean(stick);

	return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
}


;;

/*
A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
Prerequisite: the object being mixed into needs to be a *Grid*
*/
var DayTableMixin = FC.DayTableMixin = {

	breakOnWeeks: false, // should create a new row for each week?
	dayDates: null, // whole-day dates for each column. left to right
	dayIndices: null, // for each day from start, the offset
	daysPerRow: null,
	rowCnt: null,
	colCnt: null,
	colHeadFormat: null,


	// Populates internal variables used for date calculation and rendering
	updateDayTable: function() {
		var view = this.view;
		var date = this.start.clone();
		var dayIndex = -1;
		var dayIndices = [];
		var dayDates = [];
		var daysPerRow;
		var firstDay;
		var rowCnt;

		while (date.isBefore(this.end)) { // loop each day from start to end
			if (view.isHiddenDay(date)) {
				dayIndices.push(dayIndex + 0.5); // mark that it's between indices
			}
			else {
				dayIndex++;
				dayIndices.push(dayIndex);
				dayDates.push(date.clone());
			}
			date.add(1, 'days');
		}

		if (this.breakOnWeeks) {
			// count columns until the day-of-week repeats
			firstDay = dayDates[0].day();
			for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
				if (dayDates[daysPerRow].day() == firstDay) {
					break;
				}
			}
			rowCnt = Math.ceil(dayDates.length / daysPerRow);
		}
		else {
			rowCnt = 1;
			daysPerRow = dayDates.length;
		}

		this.dayDates = dayDates;
		this.dayIndices = dayIndices;
		this.daysPerRow = daysPerRow;
		this.rowCnt = rowCnt;

		this.updateDayTableCols();
	},


	// Computes and assigned the colCnt property and updates any options that may be computed from it
	updateDayTableCols: function() {
		this.colCnt = this.computeColCnt();
		this.colHeadFormat = this.view.opt('columnFormat') || this.computeColHeadFormat();
	},


	// Determines how many columns there should be in the table
	computeColCnt: function() {
		return this.daysPerRow;
	},


	// Computes the ambiguously-timed moment for the given cell
	getCellDate: function(row, col) {
		return this.dayDates[
				this.getCellDayIndex(row, col)
			].clone();
	},


	// Computes the ambiguously-timed date range for the given cell
	getCellRange: function(row, col) {
		var start = this.getCellDate(row, col);
		var end = start.clone().add(1, 'days');

		return { start: start, end: end };
	},


	// Returns the number of day cells, chronologically, from the first of the grid (0-based)
	getCellDayIndex: function(row, col) {
		return row * this.daysPerRow + this.getColDayIndex(col);
	},


	// Returns the numner of day cells, chronologically, from the first cell in *any given row*
	getColDayIndex: function(col) {
		if (this.isRTL) {
			return this.colCnt - 1 - col;
		}
		else {
			return col;
		}
	},


	// Given a date, returns its chronolocial cell-index from the first cell of the grid.
	// If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
	// If before the first offset, returns a negative number.
	// If after the last offset, returns an offset past the last cell offset.
	// Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
	getDateDayIndex: function(date) {
		var dayIndices = this.dayIndices;
		var dayOffset = date.diff(this.start, 'days');

		if (dayOffset < 0) {
			return dayIndices[0] - 1;
		}
		else if (dayOffset >= dayIndices.length) {
			return dayIndices[dayIndices.length - 1] + 1;
		}
		else {
			return dayIndices[dayOffset];
		}
	},


	/* Options
	------------------------------------------------------------------------------------------------------------------*/


	// Computes a default column header formatting string if `colFormat` is not explicitly defined
	computeColHeadFormat: function() {
		// if more than one week row, or if there are a lot of columns with not much space,
		// put just the day numbers will be in each cell
		if (this.rowCnt > 1 || this.colCnt > 10) {
			return 'ddd'; // "Sat"
		}
		// multiple days, so full single date string WON'T be in title text
		else if (this.colCnt > 1) {
			return this.view.opt('dayOfMonthFormat'); // "Sat 12/10"
		}
		// single day, so full single date string will probably be in title text
		else {
			return 'dddd'; // "Saturday"
		}
	},


	/* Slicing
	------------------------------------------------------------------------------------------------------------------*/


	// Slices up a date range into a segment for every week-row it intersects with
	sliceRangeByRow: function(range) {
		var daysPerRow = this.daysPerRow;
		var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
		var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
		var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
		var segs = [];
		var row;
		var rowFirst, rowLast; // inclusive day-index range for current row
		var segFirst, segLast; // inclusive day-index range for segment

		for (row = 0; row < this.rowCnt; row++) {
			rowFirst = row * daysPerRow;
			rowLast = rowFirst + daysPerRow - 1;

			// intersect segment's offset range with the row's
			segFirst = Math.max(rangeFirst, rowFirst);
			segLast = Math.min(rangeLast, rowLast);

			// deal with in-between indices
			segFirst = Math.ceil(segFirst); // in-between starts round to next cell
			segLast = Math.floor(segLast); // in-between ends round to prev cell

			if (segFirst <= segLast) { // was there any intersection with the current row?
				segs.push({
					row: row,

					// normalize to start of row
					firstRowDayIndex: segFirst - rowFirst,
					lastRowDayIndex: segLast - rowFirst,

					// must be matching integers to be the segment's start/end
					isStart: segFirst === rangeFirst,
					isEnd: segLast === rangeLast
				});
			}
		}

		return segs;
	},


	// Slices up a date range into a segment for every day-cell it intersects with.
	// TODO: make more DRY with sliceRangeByRow somehow.
	sliceRangeByDay: function(range) {
		var daysPerRow = this.daysPerRow;
		var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
		var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
		var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
		var segs = [];
		var row;
		var rowFirst, rowLast; // inclusive day-index range for current row
		var i;
		var segFirst, segLast; // inclusive day-index range for segment

		for (row = 0; row < this.rowCnt; row++) {
			rowFirst = row * daysPerRow;
			rowLast = rowFirst + daysPerRow - 1;

			for (i = rowFirst; i <= rowLast; i++) {

				// intersect segment's offset range with the row's
				segFirst = Math.max(rangeFirst, i);
				segLast = Math.min(rangeLast, i);

				// deal with in-between indices
				segFirst = Math.ceil(segFirst); // in-between starts round to next cell
				segLast = Math.floor(segLast); // in-between ends round to prev cell

				if (segFirst <= segLast) { // was there any intersection with the current row?
					segs.push({
						row: row,

						// normalize to start of row
						firstRowDayIndex: segFirst - rowFirst,
						lastRowDayIndex: segLast - rowFirst,

						// must be matching integers to be the segment's start/end
						isStart: segFirst === rangeFirst,
						isEnd: segLast === rangeLast
					});
				}
			}
		}

		return segs;
	},


	/* Header Rendering
	------------------------------------------------------------------------------------------------------------------*/


	renderHeadHtml: function() {
		var view = this.view;

		return '' +
			'<div class="fc-row ' + view.widgetHeaderClass + '">' +
				'<table>' +
					'<thead>' +
						this.renderHeadTrHtml() +
					'</thead>' +
				'</table>' +
			'</div>';
	},


	renderHeadIntroHtml: function() {
		return this.renderIntroHtml(); // fall back to generic
	},


	renderHeadTrHtml: function() {
		return '' +
			'<tr>' +
				(this.isRTL ? '' : this.renderHeadIntroHtml()) +
				this.renderHeadDateCellsHtml() +
				(this.isRTL ? this.renderHeadIntroHtml() : '') +
			'</tr>';
	},


	renderHeadDateCellsHtml: function() {
		var htmls = [];
		var col, date;

		for (col = 0; col < this.colCnt; col++) {
			date = this.getCellDate(0, col);
			htmls.push(this.renderHeadDateCellHtml(date));
		}

		return htmls.join('');
	},


	// TODO: when internalApiVersion, accept an object for HTML attributes
	// (colspan should be no different)
	renderHeadDateCellHtml: function(date, colspan, otherAttrs) {
		var view = this.view;
		var isDateValid = isDateWithinRange(date, view.activeRange); // TODO: called too frequently. cache somehow.
		var classNames = [
			'fc-day-header',
			view.widgetHeaderClass
		];
		var innerHtml = htmlEscape(date.format(this.colHeadFormat));

		// if only one row of days, the classNames on the header can represent the specific days beneath
		if (this.rowCnt === 1) {
			classNames = classNames.concat(
				// includes the day-of-week class
				// noThemeHighlight=true (don't highlight the header)
				this.getDayClasses(date, true)
			);
		}
		else {
			classNames.push('fc-' + dayIDs[date.day()]); // only add the day-of-week class
		}

		return '' +
            '<th class="' + classNames.join(' ') + '"' +
				((isDateValid && this.rowCnt) === 1 ?
					' data-date="' + date.format('YYYY-MM-DD') + '"' :
					'') +
				(colspan > 1 ?
					' colspan="' + colspan + '"' :
					'') +
				(otherAttrs ?
					' ' + otherAttrs :
					'') +
				'>' +
				(isDateValid ?
					// don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
					view.buildGotoAnchorHtml(
						{ date: date, forceOff: this.rowCnt > 1 || this.colCnt === 1 },
						innerHtml
					) :
					// if not valid, display text, but no link
					innerHtml
				) +
			'</th>';
	},


	/* Background Rendering
	------------------------------------------------------------------------------------------------------------------*/


	renderBgTrHtml: function(row) {
		return '' +
			'<tr>' +
				(this.isRTL ? '' : this.renderBgIntroHtml(row)) +
				this.renderBgCellsHtml(row) +
				(this.isRTL ? this.renderBgIntroHtml(row) : '') +
			'</tr>';
	},


	renderBgIntroHtml: function(row) {
		return this.renderIntroHtml(); // fall back to generic
	},


	renderBgCellsHtml: function(row) {
		var htmls = [];
		var col, date;

		for (col = 0; col < this.colCnt; col++) {
			date = this.getCellDate(row, col);
			htmls.push(this.renderBgCellHtml(date));
		}

		return htmls.join('');
	},


	renderBgCellHtml: function(date, otherAttrs) {
		var view = this.view;
		var isDateValid = isDateWithinRange(date, view.activeRange); // TODO: called too frequently. cache somehow.
		var classes = this.getDayClasses(date);

		classes.unshift('fc-day', view.widgetContentClass);

		return '<td class="' + classes.join(' ') + '"' +
			(isDateValid ?
				' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
				'') +
			(otherAttrs ?
				' ' + otherAttrs :
				'') +
			'></td>';
	},


	/* Generic
	------------------------------------------------------------------------------------------------------------------*/


	// Generates the default HTML intro for any row. User classes should override
	renderIntroHtml: function() {
	},


	// TODO: a generic method for dealing with <tr>, RTL, intro
	// when increment internalApiVersion
	// wrapTr (scheduler)


	/* Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Applies the generic "intro" and "outro" HTML to the given cells.
	// Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
	bookendCells: function(trEl) {
		var introHtml = this.renderIntroHtml();

		if (introHtml) {
			if (this.isRTL) {
				trEl.append(introHtml);
			}
			else {
				trEl.prepend(introHtml);
			}
		}
	}

};

;;

/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
----------------------------------------------------------------------------------------------------------------------*/

var DayGrid = FC.DayGrid = Grid.extend(DayTableMixin, {

	numbersVisible: false, // should render a row for day/week numbers? set by outside view. TODO: make internal
	bottomCoordPadding: 0, // hack for extending the hit area for the last row of the coordinate grid

	rowEls: null, // set of fake row elements
	cellEls: null, // set of whole-day elements comprising the row's background
	helperEls: null, // set of cell skeleton elements for rendering the mock event "helper"

	rowCoordCache: null,
	colCoordCache: null,


	// Renders the rows and columns into the component's `this.el`, which should already be assigned.
	// isRigid determins whether the individual rows should ignore the contents and be a constant height.
	// Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
	renderDates: function(isRigid) {
		var view = this.view;
		var rowCnt = this.rowCnt;
		var colCnt = this.colCnt;
		var html = '';
		var row;
		var col;

		for (row = 0; row < rowCnt; row++) {
			html += this.renderDayRowHtml(row, isRigid);
		}
		this.el.html(html);

		this.rowEls = this.el.find('.fc-row');
		this.cellEls = this.el.find('.fc-day, .fc-disabled-day');

		this.rowCoordCache = new CoordCache({
			els: this.rowEls,
			isVertical: true
		});
		this.colCoordCache = new CoordCache({
			els: this.cellEls.slice(0, this.colCnt), // only the first row
			isHorizontal: true
		});

		// trigger dayRender with each cell's element
		for (row = 0; row < rowCnt; row++) {
			for (col = 0; col < colCnt; col++) {
				view.publiclyTrigger(
					'dayRender',
					null,
					this.getCellDate(row, col),
					this.getCellEl(row, col)
				);
			}
		}
	},


	unrenderDates: function() {
		this.removeSegPopover();
	},


	renderBusinessHours: function() {
		var segs = this.buildBusinessHourSegs(true); // wholeDay=true
		this.renderFill('businessHours', segs, 'bgevent');
	},


	unrenderBusinessHours: function() {
		this.unrenderFill('businessHours');
	},


	// Generates the HTML for a single row, which is a div that wraps a table.
	// `row` is the row number.
	renderDayRowHtml: function(row, isRigid) {
		var view = this.view;
		var classes = [ 'fc-row', 'fc-week', view.widgetContentClass ];

		if (isRigid) {
			classes.push('fc-rigid');
		}

		return '' +
			'<div class="' + classes.join(' ') + '">' +
				'<div class="fc-bg">' +
					'<table>' +
						this.renderBgTrHtml(row) +
					'</table>' +
				'</div>' +
				'<div class="fc-content-skeleton">' +
					'<table>' +
						(this.numbersVisible ?
							'<thead>' +
								this.renderNumberTrHtml(row) +
							'</thead>' :
							''
							) +
					'</table>' +
				'</div>' +
			'</div>';
	},


	/* Grid Number Rendering
	------------------------------------------------------------------------------------------------------------------*/


	renderNumberTrHtml: function(row) {
		return '' +
			'<tr>' +
				(this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
				this.renderNumberCellsHtml(row) +
				(this.isRTL ? this.renderNumberIntroHtml(row) : '') +
			'</tr>';
	},


	renderNumberIntroHtml: function(row) {
		return this.renderIntroHtml();
	},


	renderNumberCellsHtml: function(row) {
		var htmls = [];
		var col, date;

		for (col = 0; col < this.colCnt; col++) {
			date = this.getCellDate(row, col);
			htmls.push(this.renderNumberCellHtml(date));
		}

		return htmls.join('');
	},


	// Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
	// The number row will only exist if either day numbers or week numbers are turned on.
	renderNumberCellHtml: function(date) {
		var view = this.view;
		var html = '';
		var isDateValid = isDateWithinRange(date, view.activeRange); // TODO: called too frequently. cache somehow.
		var isDayNumberVisible = view.dayNumbersVisible && isDateValid;
		var classes;
		var weekCalcFirstDoW;

		if (!isDayNumberVisible && !view.cellWeekNumbersVisible) {
			// no numbers in day cell (week number must be along the side)
			return '<td/>'; //  will create an empty space above events :(
		}

		classes = this.getDayClasses(date);
		classes.unshift('fc-day-top');

		if (view.cellWeekNumbersVisible) {
			// To determine the day of week number change under ISO, we cannot
			// rely on moment.js methods such as firstDayOfWeek() or weekday(),
			// because they rely on the locale's dow (possibly overridden by
			// our firstDay option), which may not be Monday. We cannot change
			// dow, because that would affect the calendar start day as well.
			if (date._locale._fullCalendar_weekCalc === 'ISO') {
				weekCalcFirstDoW = 1;  // Monday by ISO 8601 definition
			}
			else {
				weekCalcFirstDoW = date._locale.firstDayOfWeek();
			}
		}

		html += '<td class="' + classes.join(' ') + '"' +
			(isDateValid ?
				' data-date="' + date.format() + '"' :
				''
				) +
			'>';

		if (view.cellWeekNumbersVisible && (date.day() == weekCalcFirstDoW)) {
			html += view.buildGotoAnchorHtml(
				{ date: date, type: 'week' },
				{ 'class': 'fc-week-number' },
				date.format('w') // inner HTML
			);
		}

		if (isDayNumberVisible) {
			html += view.buildGotoAnchorHtml(
				date,
				{ 'class': 'fc-day-number' },
				date.date() // inner HTML
			);
		}

		html += '</td>';

		return html;
	},


	/* Options
	------------------------------------------------------------------------------------------------------------------*/


	// Computes a default event time formatting string if `timeFormat` is not explicitly defined
	computeEventTimeFormat: function() {
		return this.view.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
	},


	// Computes a default `displayEventEnd` value if one is not expliclty defined
	computeDisplayEventEnd: function() {
		return this.colCnt == 1; // we'll likely have space if there's only one day
	},


	/* Dates
	------------------------------------------------------------------------------------------------------------------*/


	rangeUpdated: function() {
		this.updateDayTable();
	},


	// Slices up the given span (unzoned start/end with other misc data) into an array of segments
	spanToSegs: function(span) {
		var segs = this.sliceRangeByRow(span);
		var i, seg;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			if (this.isRTL) {
				seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
				seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
			}
			else {
				seg.leftCol = seg.firstRowDayIndex;
				seg.rightCol = seg.lastRowDayIndex;
			}
		}

		return segs;
	},


	/* Hit System
	------------------------------------------------------------------------------------------------------------------*/


	prepareHits: function() {
		this.colCoordCache.build();
		this.rowCoordCache.build();
		this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
	},


	releaseHits: function() {
		this.colCoordCache.clear();
		this.rowCoordCache.clear();
	},


	queryHit: function(leftOffset, topOffset) {
		if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
			var col = this.colCoordCache.getHorizontalIndex(leftOffset);
			var row = this.rowCoordCache.getVerticalIndex(topOffset);

			if (row != null && col != null) {
				return this.getCellHit(row, col);
			}
		}
	},


	getHitSpan: function(hit) {
		return this.getCellRange(hit.row, hit.col);
	},


	getHitEl: function(hit) {
		return this.getCellEl(hit.row, hit.col);
	},


	/* Cell System
	------------------------------------------------------------------------------------------------------------------*/
	// FYI: the first column is the leftmost column, regardless of date


	getCellHit: function(row, col) {
		return {
			row: row,
			col: col,
			component: this, // needed unfortunately :(
			left: this.colCoordCache.getLeftOffset(col),
			right: this.colCoordCache.getRightOffset(col),
			top: this.rowCoordCache.getTopOffset(row),
			bottom: this.rowCoordCache.getBottomOffset(row)
		};
	},


	getCellEl: function(row, col) {
		return this.cellEls.eq(row * this.colCnt + col);
	},


	/* Event Drag Visualization
	------------------------------------------------------------------------------------------------------------------*/
	// TODO: move to DayGrid.event, similar to what we did with Grid's drag methods


	// Renders a visual indication of an event or external element being dragged.
	// `eventLocation` has zoned start and end (optional)
	renderDrag: function(eventLocation, seg) {
		var eventSpans = this.eventToSpans(eventLocation);
		var i;

		// always render a highlight underneath
		for (i = 0; i < eventSpans.length; i++) {
			this.renderHighlight(eventSpans[i]);
		}

		// if a segment from the same calendar but another component is being dragged, render a helper event
		if (seg && seg.component !== this) {
			return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
		}
	},


	// Unrenders any visual indication of a hovering event
	unrenderDrag: function() {
		this.unrenderHighlight();
		this.unrenderHelper();
	},


	/* Event Resize Visualization
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of an event being resized
	renderEventResize: function(eventLocation, seg) {
		var eventSpans = this.eventToSpans(eventLocation);
		var i;

		for (i = 0; i < eventSpans.length; i++) {
			this.renderHighlight(eventSpans[i]);
		}

		return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
	},


	// Unrenders a visual indication of an event being resized
	unrenderEventResize: function() {
		this.unrenderHighlight();
		this.unrenderHelper();
	},


	/* Event Helper
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
	renderHelper: function(event, sourceSeg) {
		var helperNodes = [];
		var segs = this.eventToSegs(event);
		var rowStructs;

		segs = this.renderFgSegEls(segs); // assigns each seg's el and returns a subset of segs that were rendered
		rowStructs = this.renderSegRows(segs);

		// inject each new event skeleton into each associated row
		this.rowEls.each(function(row, rowNode) {
			var rowEl = $(rowNode); // the .fc-row
			var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
			var skeletonTop;

			// If there is an original segment, match the top position. Otherwise, put it at the row's top level
			if (sourceSeg && sourceSeg.row === row) {
				skeletonTop = sourceSeg.el.position().top;
			}
			else {
				skeletonTop = rowEl.find('.fc-content-skeleton tbody').position().top;
			}

			skeletonEl.css('top', skeletonTop)
				.find('table')
					.append(rowStructs[row].tbodyEl);

			rowEl.append(skeletonEl);
			helperNodes.push(skeletonEl[0]);
		});

		return ( // must return the elements rendered
			this.helperEls = $(helperNodes) // array -> jQuery set
		);
	},


	// Unrenders any visual indication of a mock helper event
	unrenderHelper: function() {
		if (this.helperEls) {
			this.helperEls.remove();
			this.helperEls = null;
		}
	},


	/* Fill System (highlight, background events, business hours)
	------------------------------------------------------------------------------------------------------------------*/


	fillSegTag: 'td', // override the default tag name


	// Renders a set of rectangles over the given segments of days.
	// Only returns segments that successfully rendered.
	renderFill: function(type, segs, className) {
		var nodes = [];
		var i, seg;
		var skeletonEl;

		segs = this.renderFillSegEls(type, segs); // assignes `.el` to each seg. returns successfully rendered segs

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			skeletonEl = this.renderFillRow(type, seg, className);
			this.rowEls.eq(seg.row).append(skeletonEl);
			nodes.push(skeletonEl[0]);
		}

		this.elsByFill[type] = $(nodes);

		return segs;
	},


	// Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
	renderFillRow: function(type, seg, className) {
		var colCnt = this.colCnt;
		var startCol = seg.leftCol;
		var endCol = seg.rightCol + 1;
		var skeletonEl;
		var trEl;

		className = className || type.toLowerCase();

		skeletonEl = $(
			'<div class="fc-' + className + '-skeleton">' +
				'<table><tr/></table>' +
			'</div>'
		);
		trEl = skeletonEl.find('tr');

		if (startCol > 0) {
			trEl.append('<td colspan="' + startCol + '"/>');
		}

		trEl.append(
			seg.el.attr('colspan', endCol - startCol)
		);

		if (endCol < colCnt) {
			trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
		}

		this.bookendCells(trEl);

		return skeletonEl;
	}

});

;;

/* Event-rendering methods for the DayGrid class
----------------------------------------------------------------------------------------------------------------------*/

DayGrid.mixin({

	rowStructs: null, // an array of objects, each holding information about a row's foreground event-rendering


	// Unrenders all events currently rendered on the grid
	unrenderEvents: function() {
		this.removeSegPopover(); // removes the "more.." events popover
		Grid.prototype.unrenderEvents.apply(this, arguments); // calls the super-method
	},


	// Retrieves all rendered segment objects currently rendered on the grid
	getEventSegs: function() {
		return Grid.prototype.getEventSegs.call(this) // get the segments from the super-method
			.concat(this.popoverSegs || []); // append the segments from the "more..." popover
	},


	// Renders the given background event segments onto the grid
	renderBgSegs: function(segs) {

		// don't render timed background events
		var allDaySegs = $.grep(segs, function(seg) {
			return seg.event.allDay;
		});

		return Grid.prototype.renderBgSegs.call(this, allDaySegs); // call the super-method
	},


	// Renders the given foreground event segments onto the grid
	renderFgSegs: function(segs) {
		var rowStructs;

		// render an `.el` on each seg
		// returns a subset of the segs. segs that were actually rendered
		segs = this.renderFgSegEls(segs);

		rowStructs = this.rowStructs = this.renderSegRows(segs);

		// append to each row's content skeleton
		this.rowEls.each(function(i, rowNode) {
			$(rowNode).find('.fc-content-skeleton > table').append(
				rowStructs[i].tbodyEl
			);
		});

		return segs; // return only the segs that were actually rendered
	},


	// Unrenders all currently rendered foreground event segments
	unrenderFgSegs: function() {
		var rowStructs = this.rowStructs || [];
		var rowStruct;

		while ((rowStruct = rowStructs.pop())) {
			rowStruct.tbodyEl.remove();
		}

		this.rowStructs = null;
	},


	// Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
	// Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
	// PRECONDITION: each segment shoud already have a rendered and assigned `.el`
	renderSegRows: function(segs) {
		var rowStructs = [];
		var segRows;
		var row;

		segRows = this.groupSegRows(segs); // group into nested arrays

		// iterate each row of segment groupings
		for (row = 0; row < segRows.length; row++) {
			rowStructs.push(
				this.renderSegRow(row, segRows[row])
			);
		}

		return rowStructs;
	},


	// Builds the HTML to be used for the default element for an individual segment
	fgSegHtml: function(seg, disableResizing) {
		var view = this.view;
		var event = seg.event;
		var isDraggable = view.isEventDraggable(event);
		var isResizableFromStart = !disableResizing && event.allDay &&
			seg.isStart && view.isEventResizableFromStart(event);
		var isResizableFromEnd = !disableResizing && event.allDay &&
			seg.isEnd && view.isEventResizableFromEnd(event);
		var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
		var skinCss = cssToStr(this.getSegSkinCss(seg));
		var timeHtml = '';
		var timeText;
		var titleHtml;

		classes.unshift('fc-day-grid-event', 'fc-h-event');

		// Only display a timed events time if it is the starting segment
		if (seg.isStart) {
			timeText = this.getEventTimeText(event);
			if (timeText) {
				timeHtml = '<span class="fc-time">' + htmlEscape(timeText) + '</span>';
			}
		}

		titleHtml =
			'<span class="fc-title">' +
				(htmlEscape(event.title || '') || '&nbsp;') + // we always want one line of height
			'</span>';
		
		return '<a class="' + classes.join(' ') + '"' +
				(event.url ?
					' href="' + htmlEscape(event.url) + '"' :
					''
					) +
				(skinCss ?
					' style="' + skinCss + '"' :
					''
					) +
			'>' +
				'<div class="fc-content">' +
					(this.isRTL ?
						titleHtml + ' ' + timeHtml : // put a natural space in between
						timeHtml + ' ' + titleHtml   //
						) +
				'</div>' +
				(isResizableFromStart ?
					'<div class="fc-resizer fc-start-resizer" />' :
					''
					) +
				(isResizableFromEnd ?
					'<div class="fc-resizer fc-end-resizer" />' :
					''
					) +
			'</a>';
	},


	// Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
	// the segments. Returns object with a bunch of internal data about how the render was calculated.
	// NOTE: modifies rowSegs
	renderSegRow: function(row, rowSegs) {
		var colCnt = this.colCnt;
		var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
		var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
		var tbody = $('<tbody/>');
		var segMatrix = []; // lookup for which segments are rendered into which level+col cells
		var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
		var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
		var i, levelSegs;
		var col;
		var tr;
		var j, seg;
		var td;

		// populates empty cells from the current column (`col`) to `endCol`
		function emptyCellsUntil(endCol) {
			while (col < endCol) {
				// try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
				td = (loneCellMatrix[i - 1] || [])[col];
				if (td) {
					td.attr(
						'rowspan',
						parseInt(td.attr('rowspan') || 1, 10) + 1
					);
				}
				else {
					td = $('<td/>');
					tr.append(td);
				}
				cellMatrix[i][col] = td;
				loneCellMatrix[i][col] = td;
				col++;
			}
		}

		for (i = 0; i < levelCnt; i++) { // iterate through all levels
			levelSegs = segLevels[i];
			col = 0;
			tr = $('<tr/>');

			segMatrix.push([]);
			cellMatrix.push([]);
			loneCellMatrix.push([]);

			// levelCnt might be 1 even though there are no actual levels. protect against this.
			// this single empty row is useful for styling.
			if (levelSegs) {
				for (j = 0; j < levelSegs.length; j++) { // iterate through segments in level
					seg = levelSegs[j];

					emptyCellsUntil(seg.leftCol);

					// create a container that occupies or more columns. append the event element.
					td = $('<td class="fc-event-container"/>').append(seg.el);
					if (seg.leftCol != seg.rightCol) {
						td.attr('colspan', seg.rightCol - seg.leftCol + 1);
					}
					else { // a single-column segment
						loneCellMatrix[i][col] = td;
					}

					while (col <= seg.rightCol) {
						cellMatrix[i][col] = td;
						segMatrix[i][col] = seg;
						col++;
					}

					tr.append(td);
				}
			}

			emptyCellsUntil(colCnt); // finish off the row
			this.bookendCells(tr);
			tbody.append(tr);
		}

		return { // a "rowStruct"
			row: row, // the row number
			tbodyEl: tbody,
			cellMatrix: cellMatrix,
			segMatrix: segMatrix,
			segLevels: segLevels,
			segs: rowSegs
		};
	},


	// Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
	// NOTE: modifies segs
	buildSegLevels: function(segs) {
		var levels = [];
		var i, seg;
		var j;

		// Give preference to elements with certain criteria, so they have
		// a chance to be closer to the top.
		this.sortEventSegs(segs);
		
		for (i = 0; i < segs.length; i++) {
			seg = segs[i];

			// loop through levels, starting with the topmost, until the segment doesn't collide with other segments
			for (j = 0; j < levels.length; j++) {
				if (!isDaySegCollision(seg, levels[j])) {
					break;
				}
			}
			// `j` now holds the desired subrow index
			seg.level = j;

			// create new level array if needed and append segment
			(levels[j] || (levels[j] = [])).push(seg);
		}

		// order segments left-to-right. very important if calendar is RTL
		for (j = 0; j < levels.length; j++) {
			levels[j].sort(compareDaySegCols);
		}

		return levels;
	},


	// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
	groupSegRows: function(segs) {
		var segRows = [];
		var i;

		for (i = 0; i < this.rowCnt; i++) {
			segRows.push([]);
		}

		for (i = 0; i < segs.length; i++) {
			segRows[segs[i].row].push(segs[i]);
		}

		return segRows;
	}

});


// Computes whether two segments' columns collide. They are assumed to be in the same row.
function isDaySegCollision(seg, otherSegs) {
	var i, otherSeg;

	for (i = 0; i < otherSegs.length; i++) {
		otherSeg = otherSegs[i];

		if (
			otherSeg.leftCol <= seg.rightCol &&
			otherSeg.rightCol >= seg.leftCol
		) {
			return true;
		}
	}

	return false;
}


// A cmp function for determining the leftmost event
function compareDaySegCols(a, b) {
	return a.leftCol - b.leftCol;
}

;;

/* Methods relate to limiting the number events for a given day on a DayGrid
----------------------------------------------------------------------------------------------------------------------*/
// NOTE: all the segs being passed around in here are foreground segs

DayGrid.mixin({

	segPopover: null, // the Popover that holds events that can't fit in a cell. null when not visible
	popoverSegs: null, // an array of segment objects that the segPopover holds. null when not visible


	removeSegPopover: function() {
		if (this.segPopover) {
			this.segPopover.hide(); // in handler, will call segPopover's removeElement
		}
	},


	// Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
	// `levelLimit` can be false (don't limit), a number, or true (should be computed).
	limitRows: function(levelLimit) {
		var rowStructs = this.rowStructs || [];
		var row; // row #
		var rowLevelLimit;

		for (row = 0; row < rowStructs.length; row++) {
			this.unlimitRow(row);

			if (!levelLimit) {
				rowLevelLimit = false;
			}
			else if (typeof levelLimit === 'number') {
				rowLevelLimit = levelLimit;
			}
			else {
				rowLevelLimit = this.computeRowLevelLimit(row);
			}

			if (rowLevelLimit !== false) {
				this.limitRow(row, rowLevelLimit);
			}
		}
	},


	// Computes the number of levels a row will accomodate without going outside its bounds.
	// Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
	// `row` is the row number.
	computeRowLevelLimit: function(row) {
		var rowEl = this.rowEls.eq(row); // the containing "fake" row div
		var rowHeight = rowEl.height(); // TODO: cache somehow?
		var trEls = this.rowStructs[row].tbodyEl.children();
		var i, trEl;
		var trHeight;

		function iterInnerHeights(i, childNode) {
			trHeight = Math.max(trHeight, $(childNode).outerHeight());
		}

		// Reveal one level <tr> at a time and stop when we find one out of bounds
		for (i = 0; i < trEls.length; i++) {
			trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)

			// with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
			// so instead, find the tallest inner content element.
			trHeight = 0;
			trEl.find('> td > :first-child').each(iterInnerHeights);

			if (trEl.position().top + trHeight > rowHeight) {
				return i;
			}
		}

		return false; // should not limit at all
	},


	// Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
	// `row` is the row number.
	// `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
	limitRow: function(row, levelLimit) {
		var _this = this;
		var rowStruct = this.rowStructs[row];
		var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
		var col = 0; // col #, left-to-right (not chronologically)
		var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
		var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
		var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
		var i, seg;
		var segsBelow; // array of segment objects below `seg` in the current `col`
		var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
		var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
		var td, rowspan;
		var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
		var j;
		var moreTd, moreWrap, moreLink;

		// Iterates through empty level cells and places "more" links inside if need be
		function emptyCellsUntil(endCol) { // goes from current `col` to `endCol`
			while (col < endCol) {
				segsBelow = _this.getCellSegs(row, col, levelLimit);
				if (segsBelow.length) {
					td = cellMatrix[levelLimit - 1][col];
					moreLink = _this.renderMoreLink(row, col, segsBelow);
					moreWrap = $('<div/>').append(moreLink);
					td.append(moreWrap);
					moreNodes.push(moreWrap[0]);
				}
				col++;
			}
		}

		if (levelLimit && levelLimit < rowStruct.segLevels.length) { // is it actually over the limit?
			levelSegs = rowStruct.segLevels[levelLimit - 1];
			cellMatrix = rowStruct.cellMatrix;

			limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
				.addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array

			// iterate though segments in the last allowable level
			for (i = 0; i < levelSegs.length; i++) {
				seg = levelSegs[i];
				emptyCellsUntil(seg.leftCol); // process empty cells before the segment

				// determine *all* segments below `seg` that occupy the same columns
				colSegsBelow = [];
				totalSegsBelow = 0;
				while (col <= seg.rightCol) {
					segsBelow = this.getCellSegs(row, col, levelLimit);
					colSegsBelow.push(segsBelow);
					totalSegsBelow += segsBelow.length;
					col++;
				}

				if (totalSegsBelow) { // do we need to replace this segment with one or many "more" links?
					td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
					rowspan = td.attr('rowspan') || 1;
					segMoreNodes = [];

					// make a replacement <td> for each column the segment occupies. will be one for each colspan
					for (j = 0; j < colSegsBelow.length; j++) {
						moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
						segsBelow = colSegsBelow[j];
						moreLink = this.renderMoreLink(
							row,
							seg.leftCol + j,
							[ seg ].concat(segsBelow) // count seg as hidden too
						);
						moreWrap = $('<div/>').append(moreLink);
						moreTd.append(moreWrap);
						segMoreNodes.push(moreTd[0]);
						moreNodes.push(moreTd[0]);
					}

					td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
					limitedNodes.push(td[0]);
				}
			}

			emptyCellsUntil(this.colCnt); // finish off the level
			rowStruct.moreEls = $(moreNodes); // for easy undoing later
			rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
		}
	},


	// Reveals all levels and removes all "more"-related elements for a grid's row.
	// `row` is a row number.
	unlimitRow: function(row) {
		var rowStruct = this.rowStructs[row];

		if (rowStruct.moreEls) {
			rowStruct.moreEls.remove();
			rowStruct.moreEls = null;
		}

		if (rowStruct.limitedEls) {
			rowStruct.limitedEls.removeClass('fc-limited');
			rowStruct.limitedEls = null;
		}
	},


	// Renders an <a> element that represents hidden event element for a cell.
	// Responsible for attaching click handler as well.
	renderMoreLink: function(row, col, hiddenSegs) {
		var _this = this;
		var view = this.view;

		return $('<a class="fc-more"/>')
			.text(
				this.getMoreLinkText(hiddenSegs.length)
			)
			.on('click', function(ev) {
				var clickOption = view.opt('eventLimitClick');
				var date = _this.getCellDate(row, col);
				var moreEl = $(this);
				var dayEl = _this.getCellEl(row, col);
				var allSegs = _this.getCellSegs(row, col);

				// rescope the segments to be within the cell's date
				var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
				var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);

				if (typeof clickOption === 'function') {
					// the returned value can be an atomic option
					clickOption = view.publiclyTrigger('eventLimitClick', null, {
						date: date,
						dayEl: dayEl,
						moreEl: moreEl,
						segs: reslicedAllSegs,
						hiddenSegs: reslicedHiddenSegs
					}, ev);
				}

				if (clickOption === 'popover') {
					_this.showSegPopover(row, col, moreEl, reslicedAllSegs);
				}
				else if (typeof clickOption === 'string') { // a view name
					view.calendar.zoomTo(date, clickOption);
				}
			});
	},


	// Reveals the popover that displays all events within a cell
	showSegPopover: function(row, col, moreLink, segs) {
		var _this = this;
		var view = this.view;
		var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
		var topEl; // the element we want to match the top coordinate of
		var options;

		if (this.rowCnt == 1) {
			topEl = view.el; // will cause the popover to cover any sort of header
		}
		else {
			topEl = this.rowEls.eq(row); // will align with top of row
		}

		options = {
			className: 'fc-more-popover',
			content: this.renderSegPopoverContent(row, col, segs),
			parentEl: this.view.el, // attach to root of view. guarantees outside of scrollbars.
			top: topEl.offset().top,
			autoHide: true, // when the user clicks elsewhere, hide the popover
			viewportConstrain: view.opt('popoverViewportConstrain'),
			hide: function() {
				// kill everything when the popover is hidden
				// notify events to be removed
				if (_this.popoverSegs) {
					var seg;
					for (var i = 0; i < _this.popoverSegs.length; ++i) {
						seg = _this.popoverSegs[i];
						view.publiclyTrigger('eventDestroy', seg.event, seg.event, seg.el);
					}
				}
				_this.segPopover.removeElement();
				_this.segPopover = null;
				_this.popoverSegs = null;
			}
		};

		// Determine horizontal coordinate.
		// We use the moreWrap instead of the <td> to avoid border confusion.
		if (this.isRTL) {
			options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
		}
		else {
			options.left = moreWrap.offset().left - 1; // -1 to be over cell border
		}

		this.segPopover = new Popover(options);
		this.segPopover.show();

		// the popover doesn't live within the grid's container element, and thus won't get the event
		// delegated-handlers for free. attach event-related handlers to the popover.
		this.bindSegHandlersToEl(this.segPopover.el);
	},


	// Builds the inner DOM contents of the segment popover
	renderSegPopoverContent: function(row, col, segs) {
		var view = this.view;
		var isTheme = view.opt('theme');
		var title = this.getCellDate(row, col).format(view.opt('dayPopoverFormat'));
		var content = $(
			'<div class="fc-header ' + view.widgetHeaderClass + '">' +
				'<span class="fc-close ' +
					(isTheme ? 'ui-icon ui-icon-closethick' : 'fc-icon fc-icon-x') +
				'"></span>' +
				'<span class="fc-title">' +
					htmlEscape(title) +
				'</span>' +
				'<div class="fc-clear"/>' +
			'</div>' +
			'<div class="fc-body ' + view.widgetContentClass + '">' +
				'<div class="fc-event-container"></div>' +
			'</div>'
		);
		var segContainer = content.find('.fc-event-container');
		var i;

		// render each seg's `el` and only return the visible segs
		segs = this.renderFgSegEls(segs, true); // disableResizing=true
		this.popoverSegs = segs;

		for (i = 0; i < segs.length; i++) {

			// because segments in the popover are not part of a grid coordinate system, provide a hint to any
			// grids that want to do drag-n-drop about which cell it came from
			this.hitsNeeded();
			segs[i].hit = this.getCellHit(row, col);
			this.hitsNotNeeded();

			segContainer.append(segs[i].el);
		}

		return content;
	},


	// Given the events within an array of segment objects, reslice them to be in a single day
	resliceDaySegs: function(segs, dayDate) {

		// build an array of the original events
		var events = $.map(segs, function(seg) {
			return seg.event;
		});

		var dayStart = dayDate.clone();
		var dayEnd = dayStart.clone().add(1, 'days');
		var dayRange = { start: dayStart, end: dayEnd };

		// slice the events with a custom slicing function
		segs = this.eventsToSegs(
			events,
			function(range) {
				var seg = intersectRanges(range, dayRange); // undefind if no intersection
				return seg ? [ seg ] : []; // must return an array of segments
			}
		);

		// force an order because eventsToSegs doesn't guarantee one
		this.sortEventSegs(segs);

		return segs;
	},


	// Generates the text that should be inside a "more" link, given the number of events it represents
	getMoreLinkText: function(num) {
		var opt = this.view.opt('eventLimitText');

		if (typeof opt === 'function') {
			return opt(num);
		}
		else {
			return '+' + num + ' ' + opt;
		}
	},


	// Returns segments within a given cell.
	// If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
	getCellSegs: function(row, col, startLevel) {
		var segMatrix = this.rowStructs[row].segMatrix;
		var level = startLevel || 0;
		var segs = [];
		var seg;

		while (level < segMatrix.length) {
			seg = segMatrix[level][col];
			if (seg) {
				segs.push(seg);
			}
			level++;
		}

		return segs;
	}

});

;;

/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
// We mixin DayTable, even though there is only a single row of days

var TimeGrid = FC.TimeGrid = Grid.extend(DayTableMixin, {

	slotDuration: null, // duration of a "slot", a distinct time segment on given day, visualized by lines
	snapDuration: null, // granularity of time for dragging and selecting
	snapsPerSlot: null,
	labelFormat: null, // formatting string for times running along vertical axis
	labelInterval: null, // duration of how often a label should be displayed for a slot

	colEls: null, // cells elements in the day-row background
	slatContainerEl: null, // div that wraps all the slat rows
	slatEls: null, // elements running horizontally across all columns
	nowIndicatorEls: null,

	colCoordCache: null,
	slatCoordCache: null,


	constructor: function() {
		Grid.apply(this, arguments); // call the super-constructor

		this.processOptions();
	},


	// Renders the time grid into `this.el`, which should already be assigned.
	// Relies on the view's colCnt. In the future, this component should probably be self-sufficient.
	renderDates: function() {
		this.el.html(this.renderHtml());
		this.colEls = this.el.find('.fc-day, .fc-disabled-day');
		this.slatContainerEl = this.el.find('.fc-slats');
		this.slatEls = this.slatContainerEl.find('tr');

		this.colCoordCache = new CoordCache({
			els: this.colEls,
			isHorizontal: true
		});
		this.slatCoordCache = new CoordCache({
			els: this.slatEls,
			isVertical: true
		});

		this.renderContentSkeleton();
	},


	// Renders the basic HTML skeleton for the grid
	renderHtml: function() {
		return '' +
			'<div class="fc-bg">' +
				'<table>' +
					this.renderBgTrHtml(0) + // row=0
				'</table>' +
			'</div>' +
			'<div class="fc-slats">' +
				'<table>' +
					this.renderSlatRowHtml() +
				'</table>' +
			'</div>';
	},


	// Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
	renderSlatRowHtml: function() {
		var view = this.view;
		var isRTL = this.isRTL;
		var html = '';
		var slotTime = moment.duration(+this.view.minTime); // wish there was .clone() for durations
		var slotDate; // will be on the view's first day, but we only care about its time
		var isLabeled;
		var axisHtml;

		// Calculate the time for each slot
		while (slotTime < this.view.maxTime) {
			slotDate = this.start.clone().time(slotTime);
			isLabeled = isInt(divideDurationByDuration(slotTime, this.labelInterval));

			axisHtml =
				'<td class="fc-axis fc-time ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
					(isLabeled ?
						'<span>' + // for matchCellWidths
							htmlEscape(slotDate.format(this.labelFormat)) +
						'</span>' :
						''
						) +
				'</td>';

			html +=
				'<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
					(isLabeled ? '' : ' class="fc-minor"') +
					'>' +
					(!isRTL ? axisHtml : '') +
					'<td class="' + view.widgetContentClass + '"/>' +
					(isRTL ? axisHtml : '') +
				"</tr>";

			slotTime.add(this.slotDuration);
		}

		return html;
	},


	/* Options
	------------------------------------------------------------------------------------------------------------------*/


	// Parses various options into properties of this object
	processOptions: function() {
		var view = this.view;
		var slotDuration = view.opt('slotDuration');
		var snapDuration = view.opt('snapDuration');
		var input;

		slotDuration = moment.duration(slotDuration);
		snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;

		this.slotDuration = slotDuration;
		this.snapDuration = snapDuration;
		this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?

		this.minResizeDuration = snapDuration; // hack

		// might be an array value (for TimelineView).
		// if so, getting the most granular entry (the last one probably).
		input = view.opt('slotLabelFormat');
		if ($.isArray(input)) {
			input = input[input.length - 1];
		}

		this.labelFormat =
			input ||
			view.opt('smallTimeFormat'); // the computed default

		input = view.opt('slotLabelInterval');
		this.labelInterval = input ?
			moment.duration(input) :
			this.computeLabelInterval(slotDuration);
	},


	// Computes an automatic value for slotLabelInterval
	computeLabelInterval: function(slotDuration) {
		var i;
		var labelInterval;
		var slotsPerLabel;

		// find the smallest stock label interval that results in more than one slots-per-label
		for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
			labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
			slotsPerLabel = divideDurationByDuration(labelInterval, slotDuration);
			if (isInt(slotsPerLabel) && slotsPerLabel > 1) {
				return labelInterval;
			}
		}

		return moment.duration(slotDuration); // fall back. clone
	},


	// Computes a default event time formatting string if `timeFormat` is not explicitly defined
	computeEventTimeFormat: function() {
		return this.view.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
	},


	// Computes a default `displayEventEnd` value if one is not expliclty defined
	computeDisplayEventEnd: function() {
		return true;
	},


	/* Hit System
	------------------------------------------------------------------------------------------------------------------*/


	prepareHits: function() {
		this.colCoordCache.build();
		this.slatCoordCache.build();
	},


	releaseHits: function() {
		this.colCoordCache.clear();
		// NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
	},


	queryHit: function(leftOffset, topOffset) {
		var snapsPerSlot = this.snapsPerSlot;
		var colCoordCache = this.colCoordCache;
		var slatCoordCache = this.slatCoordCache;

		if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
			var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
			var slatIndex = slatCoordCache.getVerticalIndex(topOffset);

			if (colIndex != null && slatIndex != null) {
				var slatTop = slatCoordCache.getTopOffset(slatIndex);
				var slatHeight = slatCoordCache.getHeight(slatIndex);
				var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
				var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
				var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
				var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
				var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;

				return {
					col: colIndex,
					snap: snapIndex,
					component: this, // needed unfortunately :(
					left: colCoordCache.getLeftOffset(colIndex),
					right: colCoordCache.getRightOffset(colIndex),
					top: snapTop,
					bottom: snapBottom
				};
			}
		}
	},


	getHitSpan: function(hit) {
		var start = this.getCellDate(0, hit.col); // row=0
		var time = this.computeSnapTime(hit.snap); // pass in the snap-index
		var end;

		start.time(time);
		end = start.clone().add(this.snapDuration);

		return { start: start, end: end };
	},


	getHitEl: function(hit) {
		return this.colEls.eq(hit.col);
	},


	/* Dates
	------------------------------------------------------------------------------------------------------------------*/


	rangeUpdated: function() {
		this.updateDayTable();
	},


	// Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
	computeSnapTime: function(snapIndex) {
		return moment.duration(this.view.minTime + this.snapDuration * snapIndex);
	},


	// Slices up the given span (unzoned start/end with other misc data) into an array of segments
	spanToSegs: function(span) {
		var segs = this.sliceRangeByTimes(span);
		var i;

		for (i = 0; i < segs.length; i++) {
			if (this.isRTL) {
				segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
			}
			else {
				segs[i].col = segs[i].dayIndex;
			}
		}

		return segs;
	},


	sliceRangeByTimes: function(range) {
		var segs = [];
		var seg;
		var dayIndex;
		var dayDate;
		var dayRange;

		for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
			dayDate = this.dayDates[dayIndex].clone().time(0); // TODO: better API for this?
			dayRange = {
				start: dayDate.clone().add(this.view.minTime), // don't use .time() because it sux with negatives
				end: dayDate.clone().add(this.view.maxTime)
			};
			seg = intersectRanges(range, dayRange); // both will be ambig timezone
			if (seg) {
				seg.dayIndex = dayIndex;
				segs.push(seg);
			}
		}

		return segs;
	},


	/* Coordinates
	------------------------------------------------------------------------------------------------------------------*/


	updateSize: function(isResize) { // NOT a standard Grid method
		this.slatCoordCache.build();

		if (isResize) {
			this.updateSegVerticals(
				[].concat(this.fgSegs || [], this.bgSegs || [], this.businessSegs || [])
			);
		}
	},


	getTotalSlatHeight: function() {
		return this.slatContainerEl.outerHeight();
	},


	// Computes the top coordinate, relative to the bounds of the grid, of the given date.
	// A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
	computeDateTop: function(date, startOfDayDate) {
		return this.computeTimeTop(
			moment.duration(
				date - startOfDayDate.clone().stripTime()
			)
		);
	},


	// Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
	computeTimeTop: function(time) {
		var len = this.slatEls.length;
		var slatCoverage = (time - this.view.minTime) / this.slotDuration; // floating-point value of # of slots covered
		var slatIndex;
		var slatRemainder;

		// compute a floating-point number for how many slats should be progressed through.
		// from 0 to number of slats (inclusive)
		// constrained because minTime/maxTime might be customized.
		slatCoverage = Math.max(0, slatCoverage);
		slatCoverage = Math.min(len, slatCoverage);

		// an integer index of the furthest whole slat
		// from 0 to number slats (*exclusive*, so len-1)
		slatIndex = Math.floor(slatCoverage);
		slatIndex = Math.min(slatIndex, len - 1);

		// how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
		// could be 1.0 if slatCoverage is covering *all* the slots
		slatRemainder = slatCoverage - slatIndex;

		return this.slatCoordCache.getTopPosition(slatIndex) +
			this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
	},



	/* Event Drag Visualization
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of an event being dragged over the specified date(s).
	// A returned value of `true` signals that a mock "helper" event has been rendered.
	renderDrag: function(eventLocation, seg) {
		var eventSpans;
		var i;

		if (seg) { // if there is event information for this drag, render a helper event

			// returns mock event elements
			// signal that a helper has been rendered
			return this.renderEventLocationHelper(eventLocation, seg);
		}
		else { // otherwise, just render a highlight
			eventSpans = this.eventToSpans(eventLocation);

			for (i = 0; i < eventSpans.length; i++) {
				this.renderHighlight(eventSpans[i]);
			}
		}
	},


	// Unrenders any visual indication of an event being dragged
	unrenderDrag: function() {
		this.unrenderHelper();
		this.unrenderHighlight();
	},


	/* Event Resize Visualization
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of an event being resized
	renderEventResize: function(eventLocation, seg) {
		return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
	},


	// Unrenders any visual indication of an event being resized
	unrenderEventResize: function() {
		this.unrenderHelper();
	},


	/* Event Helper
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a mock "helper" event. `sourceSeg` is the original segment object and might be null (an external drag)
	renderHelper: function(event, sourceSeg) {
		return this.renderHelperSegs(this.eventToSegs(event), sourceSeg); // returns mock event elements
	},


	// Unrenders any mock helper event
	unrenderHelper: function() {
		this.unrenderHelperSegs();
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	renderBusinessHours: function() {
		this.renderBusinessSegs(
			this.buildBusinessHourSegs()
		);
	},


	unrenderBusinessHours: function() {
		this.unrenderBusinessSegs();
	},


	/* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/


	getNowIndicatorUnit: function() {
		return 'minute'; // will refresh on the minute
	},


	renderNowIndicator: function(date) {
		// seg system might be overkill, but it handles scenario where line needs to be rendered
		//  more than once because of columns with the same date (resources columns for example)
		var segs = this.spanToSegs({ start: date, end: date });
		var top = this.computeDateTop(date, date);
		var nodes = [];
		var i;

		// render lines within the columns
		for (i = 0; i < segs.length; i++) {
			nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
				.css('top', top)
				.appendTo(this.colContainerEls.eq(segs[i].col))[0]);
		}

		// render an arrow over the axis
		if (segs.length > 0) { // is the current time in view?
			nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
				.css('top', top)
				.appendTo(this.el.find('.fc-content-skeleton'))[0]);
		}

		this.nowIndicatorEls = $(nodes);
	},


	unrenderNowIndicator: function() {
		if (this.nowIndicatorEls) {
			this.nowIndicatorEls.remove();
			this.nowIndicatorEls = null;
		}
	},


	/* Selection
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
	renderSelection: function(span) {
		if (this.view.opt('selectHelper')) { // this setting signals that a mock helper event should be rendered

			// normally acceps an eventLocation, span has a start/end, which is good enough
			this.renderEventLocationHelper(span);
		}
		else {
			this.renderHighlight(span);
		}
	},


	// Unrenders any visual indication of a selection
	unrenderSelection: function() {
		this.unrenderHelper();
		this.unrenderHighlight();
	},


	/* Highlight
	------------------------------------------------------------------------------------------------------------------*/


	renderHighlight: function(span) {
		this.renderHighlightSegs(this.spanToSegs(span));
	},


	unrenderHighlight: function() {
		this.unrenderHighlightSegs();
	}

});

;;

/* Methods for rendering SEGMENTS, pieces of content that live on the view
 ( this file is no longer just for events )
----------------------------------------------------------------------------------------------------------------------*/

TimeGrid.mixin({

	colContainerEls: null, // containers for each column

	// inner-containers for each column where different types of segs live
	fgContainerEls: null,
	bgContainerEls: null,
	helperContainerEls: null,
	highlightContainerEls: null,
	businessContainerEls: null,

	// arrays of different types of displayed segments
	fgSegs: null,
	bgSegs: null,
	helperSegs: null,
	highlightSegs: null,
	businessSegs: null,


	// Renders the DOM that the view's content will live in
	renderContentSkeleton: function() {
		var cellHtml = '';
		var i;
		var skeletonEl;

		for (i = 0; i < this.colCnt; i++) {
			cellHtml +=
				'<td>' +
					'<div class="fc-content-col">' +
						'<div class="fc-event-container fc-helper-container"></div>' +
						'<div class="fc-event-container"></div>' +
						'<div class="fc-highlight-container"></div>' +
						'<div class="fc-bgevent-container"></div>' +
						'<div class="fc-business-container"></div>' +
					'</div>' +
				'</td>';
		}

		skeletonEl = $(
			'<div class="fc-content-skeleton">' +
				'<table>' +
					'<tr>' + cellHtml + '</tr>' +
				'</table>' +
			'</div>'
		);

		this.colContainerEls = skeletonEl.find('.fc-content-col');
		this.helperContainerEls = skeletonEl.find('.fc-helper-container');
		this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
		this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
		this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
		this.businessContainerEls = skeletonEl.find('.fc-business-container');

		this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
		this.el.append(skeletonEl);
	},


	/* Foreground Events
	------------------------------------------------------------------------------------------------------------------*/


	renderFgSegs: function(segs) {
		segs = this.renderFgSegsIntoContainers(segs, this.fgContainerEls);
		this.fgSegs = segs;
		return segs; // needed for Grid::renderEvents
	},


	unrenderFgSegs: function() {
		this.unrenderNamedSegs('fgSegs');
	},


	/* Foreground Helper Events
	------------------------------------------------------------------------------------------------------------------*/


	renderHelperSegs: function(segs, sourceSeg) {
		var helperEls = [];
		var i, seg;
		var sourceEl;

		segs = this.renderFgSegsIntoContainers(segs, this.helperContainerEls);

		// Try to make the segment that is in the same row as sourceSeg look the same
		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			if (sourceSeg && sourceSeg.col === seg.col) {
				sourceEl = sourceSeg.el;
				seg.el.css({
					left: sourceEl.css('left'),
					right: sourceEl.css('right'),
					'margin-left': sourceEl.css('margin-left'),
					'margin-right': sourceEl.css('margin-right')
				});
			}
			helperEls.push(seg.el[0]);
		}

		this.helperSegs = segs;

		return $(helperEls); // must return rendered helpers
	},


	unrenderHelperSegs: function() {
		this.unrenderNamedSegs('helperSegs');
	},


	/* Background Events
	------------------------------------------------------------------------------------------------------------------*/


	renderBgSegs: function(segs) {
		segs = this.renderFillSegEls('bgEvent', segs); // TODO: old fill system
		this.updateSegVerticals(segs);
		this.attachSegsByCol(this.groupSegsByCol(segs), this.bgContainerEls);
		this.bgSegs = segs;
		return segs; // needed for Grid::renderEvents
	},


	unrenderBgSegs: function() {
		this.unrenderNamedSegs('bgSegs');
	},


	/* Highlight
	------------------------------------------------------------------------------------------------------------------*/


	renderHighlightSegs: function(segs) {
		segs = this.renderFillSegEls('highlight', segs); // TODO: old fill system
		this.updateSegVerticals(segs);
		this.attachSegsByCol(this.groupSegsByCol(segs), this.highlightContainerEls);
		this.highlightSegs = segs;
	},


	unrenderHighlightSegs: function() {
		this.unrenderNamedSegs('highlightSegs');
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	renderBusinessSegs: function(segs) {
		segs = this.renderFillSegEls('businessHours', segs); // TODO: old fill system
		this.updateSegVerticals(segs);
		this.attachSegsByCol(this.groupSegsByCol(segs), this.businessContainerEls);
		this.businessSegs = segs;
	},


	unrenderBusinessSegs: function() {
		this.unrenderNamedSegs('businessSegs');
	},


	/* Seg Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
	groupSegsByCol: function(segs) {
		var segsByCol = [];
		var i;

		for (i = 0; i < this.colCnt; i++) {
			segsByCol.push([]);
		}

		for (i = 0; i < segs.length; i++) {
			segsByCol[segs[i].col].push(segs[i]);
		}

		return segsByCol;
	},


	// Given segments grouped by column, insert the segments' elements into a parallel array of container
	// elements, each living within a column.
	attachSegsByCol: function(segsByCol, containerEls) {
		var col;
		var segs;
		var i;

		for (col = 0; col < this.colCnt; col++) { // iterate each column grouping
			segs = segsByCol[col];

			for (i = 0; i < segs.length; i++) {
				containerEls.eq(col).append(segs[i].el);
			}
		}
	},


	// Given the name of a property of `this` object, assumed to be an array of segments,
	// loops through each segment and removes from DOM. Will null-out the property afterwards.
	unrenderNamedSegs: function(propName) {
		var segs = this[propName];
		var i;

		if (segs) {
			for (i = 0; i < segs.length; i++) {
				segs[i].el.remove();
			}
			this[propName] = null;
		}
	},



	/* Foreground Event Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Given an array of foreground segments, render a DOM element for each, computes position,
	// and attaches to the column inner-container elements.
	renderFgSegsIntoContainers: function(segs, containerEls) {
		var segsByCol;
		var col;

		segs = this.renderFgSegEls(segs); // will call fgSegHtml
		segsByCol = this.groupSegsByCol(segs);

		for (col = 0; col < this.colCnt; col++) {
			this.updateFgSegCoords(segsByCol[col]);
		}

		this.attachSegsByCol(segsByCol, containerEls);

		return segs;
	},


	// Renders the HTML for a single event segment's default rendering
	fgSegHtml: function(seg, disableResizing) {
		var view = this.view;
		var event = seg.event;
		var isDraggable = view.isEventDraggable(event);
		var isResizableFromStart = !disableResizing && seg.isStart && view.isEventResizableFromStart(event);
		var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventResizableFromEnd(event);
		var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
		var skinCss = cssToStr(this.getSegSkinCss(seg));
		var timeText;
		var fullTimeText; // more verbose time text. for the print stylesheet
		var startTimeText; // just the start time text

		classes.unshift('fc-time-grid-event', 'fc-v-event');

		if (view.isMultiDayEvent(event)) { // if the event appears to span more than one day...
			// Don't display time text on segments that run entirely through a day.
			// That would appear as midnight-midnight and would look dumb.
			// Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
			if (seg.isStart || seg.isEnd) {
				timeText = this.getEventTimeText(seg);
				fullTimeText = this.getEventTimeText(seg, 'LT');
				startTimeText = this.getEventTimeText(seg, null, false); // displayEnd=false
			}
		} else {
			// Display the normal time text for the *event's* times
			timeText = this.getEventTimeText(event);
			fullTimeText = this.getEventTimeText(event, 'LT');
			startTimeText = this.getEventTimeText(event, null, false); // displayEnd=false
		}

		return '<a class="' + classes.join(' ') + '"' +
			(event.url ?
				' href="' + htmlEscape(event.url) + '"' :
				''
				) +
			(skinCss ?
				' style="' + skinCss + '"' :
				''
				) +
			'>' +
				'<div class="fc-content">' +
					(timeText ?
						'<div class="fc-time"' +
						' data-start="' + htmlEscape(startTimeText) + '"' +
						' data-full="' + htmlEscape(fullTimeText) + '"' +
						'>' +
							'<span>' + htmlEscape(timeText) + '</span>' +
						'</div>' :
						''
						) +
					(event.title ?
						'<div class="fc-title">' +
							htmlEscape(event.title) +
						'</div>' :
						''
						) +
				'</div>' +
				'<div class="fc-bg"/>' +
				/* TODO: write CSS for this
				(isResizableFromStart ?
					'<div class="fc-resizer fc-start-resizer" />' :
					''
					) +
				*/
				(isResizableFromEnd ?
					'<div class="fc-resizer fc-end-resizer" />' :
					''
					) +
			'</a>';
	},


	/* Seg Position Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Refreshes the CSS top/bottom coordinates for each segment element.
	// Works when called after initial render, after a window resize/zoom for example.
	updateSegVerticals: function(segs) {
		this.computeSegVerticals(segs);
		this.assignSegVerticals(segs);
	},


	// For each segment in an array, computes and assigns its top and bottom properties
	computeSegVerticals: function(segs) {
		var i, seg;
		var dayDate;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			dayDate = this.dayDates[seg.dayIndex];

			seg.top = this.computeDateTop(seg.start, dayDate);
			seg.bottom = this.computeDateTop(seg.end, dayDate);
		}
	},


	// Given segments that already have their top/bottom properties computed, applies those values to
	// the segments' elements.
	assignSegVerticals: function(segs) {
		var i, seg;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			seg.el.css(this.generateSegVerticalCss(seg));
		}
	},


	// Generates an object with CSS properties for the top/bottom coordinates of a segment element
	generateSegVerticalCss: function(seg) {
		return {
			top: seg.top,
			bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
		};
	},


	/* Foreground Event Positioning Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Given segments that are assumed to all live in the *same column*,
	// compute their verical/horizontal coordinates and assign to their elements.
	updateFgSegCoords: function(segs) {
		this.computeSegVerticals(segs); // horizontals relies on this
		this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
		this.assignSegVerticals(segs);
		this.assignFgSegHorizontals(segs);
	},


	// Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
	// NOTE: Also reorders the given array by date!
	computeFgSegHorizontals: function(segs) {
		var levels;
		var level0;
		var i;

		this.sortEventSegs(segs); // order by certain criteria
		levels = buildSlotSegLevels(segs);
		computeForwardSlotSegs(levels);

		if ((level0 = levels[0])) {

			for (i = 0; i < level0.length; i++) {
				computeSlotSegPressures(level0[i]);
			}

			for (i = 0; i < level0.length; i++) {
				this.computeFgSegForwardBack(level0[i], 0, 0);
			}
		}
	},


	// Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
	// from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
	// seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
	//
	// The segment might be part of a "series", which means consecutive segments with the same pressure
	// who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
	// segments behind this one in the current series, and `seriesBackwardCoord` is the starting
	// coordinate of the first segment in the series.
	computeFgSegForwardBack: function(seg, seriesBackwardPressure, seriesBackwardCoord) {
		var forwardSegs = seg.forwardSegs;
		var i;

		if (seg.forwardCoord === undefined) { // not already computed

			if (!forwardSegs.length) {

				// if there are no forward segments, this segment should butt up against the edge
				seg.forwardCoord = 1;
			}
			else {

				// sort highest pressure first
				this.sortForwardSegs(forwardSegs);

				// this segment's forwardCoord will be calculated from the backwardCoord of the
				// highest-pressure forward segment.
				this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
				seg.forwardCoord = forwardSegs[0].backwardCoord;
			}

			// calculate the backwardCoord from the forwardCoord. consider the series
			seg.backwardCoord = seg.forwardCoord -
				(seg.forwardCoord - seriesBackwardCoord) / // available width for series
				(seriesBackwardPressure + 1); // # of segments in the series

			// use this segment's coordinates to computed the coordinates of the less-pressurized
			// forward segments
			for (i=0; i<forwardSegs.length; i++) {
				this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
			}
		}
	},


	sortForwardSegs: function(forwardSegs) {
		forwardSegs.sort(proxy(this, 'compareForwardSegs'));
	},


	// A cmp function for determining which forward segment to rely on more when computing coordinates.
	compareForwardSegs: function(seg1, seg2) {
		// put higher-pressure first
		return seg2.forwardPressure - seg1.forwardPressure ||
			// put segments that are closer to initial edge first (and favor ones with no coords yet)
			(seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
			// do normal sorting...
			this.compareEventSegs(seg1, seg2);
	},


	// Given foreground event segments that have already had their position coordinates computed,
	// assigns position-related CSS values to their elements.
	assignFgSegHorizontals: function(segs) {
		var i, seg;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			seg.el.css(this.generateFgSegHorizontalCss(seg));

			// if the height is short, add a className for alternate styling
			if (seg.bottom - seg.top < 30) {
				seg.el.addClass('fc-short');
			}
		}
	},


	// Generates an object with CSS properties/values that should be applied to an event segment element.
	// Contains important positioning-related properties that should be applied to any event element, customized or not.
	generateFgSegHorizontalCss: function(seg) {
		var shouldOverlap = this.view.opt('slotEventOverlap');
		var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
		var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
		var props = this.generateSegVerticalCss(seg); // get top/bottom first
		var left; // amount of space from left edge, a fraction of the total width
		var right; // amount of space from right edge, a fraction of the total width

		if (shouldOverlap) {
			// double the width, but don't go beyond the maximum forward coordinate (1.0)
			forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
		}

		if (this.isRTL) {
			left = 1 - forwardCoord;
			right = backwardCoord;
		}
		else {
			left = backwardCoord;
			right = 1 - forwardCoord;
		}

		props.zIndex = seg.level + 1; // convert from 0-base to 1-based
		props.left = left * 100 + '%';
		props.right = right * 100 + '%';

		if (shouldOverlap && seg.forwardPressure) {
			// add padding to the edge so that forward stacked events don't cover the resizer's icon
			props[this.isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
		}

		return props;
	}

});


// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
function buildSlotSegLevels(segs) {
	var levels = [];
	var i, seg;
	var j;

	for (i=0; i<segs.length; i++) {
		seg = segs[i];

		// go through all the levels and stop on the first level where there are no collisions
		for (j=0; j<levels.length; j++) {
			if (!computeSlotSegCollisions(seg, levels[j]).length) {
				break;
			}
		}

		seg.level = j;

		(levels[j] || (levels[j] = [])).push(seg);
	}

	return levels;
}


// For every segment, figure out the other segments that are in subsequent
// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
function computeForwardSlotSegs(levels) {
	var i, level;
	var j, seg;
	var k;

	for (i=0; i<levels.length; i++) {
		level = levels[i];

		for (j=0; j<level.length; j++) {
			seg = level[j];

			seg.forwardSegs = [];
			for (k=i+1; k<levels.length; k++) {
				computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
			}
		}
	}
}


// Figure out which path forward (via seg.forwardSegs) results in the longest path until
// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
function computeSlotSegPressures(seg) {
	var forwardSegs = seg.forwardSegs;
	var forwardPressure = 0;
	var i, forwardSeg;

	if (seg.forwardPressure === undefined) { // not already computed

		for (i=0; i<forwardSegs.length; i++) {
			forwardSeg = forwardSegs[i];

			// figure out the child's maximum forward path
			computeSlotSegPressures(forwardSeg);

			// either use the existing maximum, or use the child's forward pressure
			// plus one (for the forwardSeg itself)
			forwardPressure = Math.max(
				forwardPressure,
				1 + forwardSeg.forwardPressure
			);
		}

		seg.forwardPressure = forwardPressure;
	}
}


// Find all the segments in `otherSegs` that vertically collide with `seg`.
// Append into an optionally-supplied `results` array and return.
function computeSlotSegCollisions(seg, otherSegs, results) {
	results = results || [];

	for (var i=0; i<otherSegs.length; i++) {
		if (isSlotSegCollision(seg, otherSegs[i])) {
			results.push(otherSegs[i]);
		}
	}

	return results;
}


// Do these segments occupy the same vertical space?
function isSlotSegCollision(seg1, seg2) {
	return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
}

;;

/* An abstract class from which other views inherit from
----------------------------------------------------------------------------------------------------------------------*/

var View = FC.View = Model.extend({

	type: null, // subclass' view name (string)
	name: null, // deprecated. use `type` instead
	title: null, // the text that will be displayed in the header's title

	calendar: null, // owner Calendar object
	viewSpec: null,
	options: null, // hash containing all options. already merged with view-specific-options
	el: null, // the view's containing element. set by Calendar

	renderQueue: null,
	batchRenderDepth: 0,
	isDatesRendered: false,
	isEventsRendered: false,
	isBaseRendered: false, // related to viewRender/viewDestroy triggers

	queuedScroll: null,

	isRTL: false,
	isSelected: false, // boolean whether a range of time is user-selected or not
	selectedEvent: null,

	eventOrderSpecs: null, // criteria for ordering events when they have same date/time

	// classNames styled by jqui themes
	widgetHeaderClass: null,
	widgetContentClass: null,
	highlightStateClass: null,

	// for date utils, computed from options
	nextDayThreshold: null,
	isHiddenDayHash: null,

	// now indicator
	isNowIndicatorRendered: null,
	initialNowDate: null, // result first getNow call
	initialNowQueriedMs: null, // ms time the getNow was called
	nowIndicatorTimeoutID: null, // for refresh timing of now indicator
	nowIndicatorIntervalID: null, // "


	constructor: function(calendar, viewSpec) {
		Model.prototype.constructor.call(this);

		this.calendar = calendar;
		this.viewSpec = viewSpec;

		// shortcuts
		this.type = viewSpec.type;
		this.options = viewSpec.options;

		// .name is deprecated
		this.name = this.type;

		this.nextDayThreshold = moment.duration(this.opt('nextDayThreshold'));
		this.initThemingProps();
		this.initHiddenDays();
		this.isRTL = this.opt('isRTL');

		this.eventOrderSpecs = parseFieldSpecs(this.opt('eventOrder'));

		this.renderQueue = this.buildRenderQueue();
		this.initAutoBatchRender();

		this.initialize();
	},


	buildRenderQueue: function() {
		var _this = this;
		var renderQueue = new RenderQueue({
			event: this.opt('eventRenderWait')
		});

		renderQueue.on('start', function() {
			_this.freezeHeight();
			_this.addScroll(_this.queryScroll());
		});

		renderQueue.on('stop', function() {
			_this.thawHeight();
			_this.popScroll();
		});

		return renderQueue;
	},


	initAutoBatchRender: function() {
		var _this = this;

		this.on('before:change', function() {
			_this.startBatchRender();
		});

		this.on('change', function() {
			_this.stopBatchRender();
		});
	},


	startBatchRender: function() {
		if (!(this.batchRenderDepth++)) {
			this.renderQueue.pause();
		}
	},


	stopBatchRender: function() {
		if (!(--this.batchRenderDepth)) {
			this.renderQueue.resume();
		}
	},


	// A good place for subclasses to initialize member variables
	initialize: function() {
		// subclasses can implement
	},


	// Retrieves an option with the given name
	opt: function(name) {
		return this.options[name];
	},


	// Triggers handlers that are view-related. Modifies args before passing to calendar.
	publiclyTrigger: function(name, thisObj) { // arguments beyond thisObj are passed along
		var calendar = this.calendar;

		return calendar.publiclyTrigger.apply(
			calendar,
			[name, thisObj || this].concat(
				Array.prototype.slice.call(arguments, 2), // arguments beyond thisObj
				[ this ] // always make the last argument a reference to the view. TODO: deprecate
			)
		);
	},


	/* Title and Date Formatting
	------------------------------------------------------------------------------------------------------------------*/


	// Sets the view's title property to the most updated computed value
	updateTitle: function() {
		this.title = this.computeTitle();
		this.calendar.setToolbarsTitle(this.title);
	},


	// Computes what the title at the top of the calendar should be for this view
	computeTitle: function() {
		var range;

		// for views that span a large unit of time, show the proper interval, ignoring stray days before and after
		if (/^(year|month)$/.test(this.currentRangeUnit)) {
			range = this.currentRange;
		}
		else { // for day units or smaller, use the actual day range
			range = this.activeRange;
		}

		return this.formatRange(
			{
				// in case currentRange has a time, make sure timezone is correct
				start: this.calendar.applyTimezone(range.start),
				end: this.calendar.applyTimezone(range.end)
			},
			this.opt('titleFormat') || this.computeTitleFormat(),
			this.opt('titleRangeSeparator')
		);
	},


	// Generates the format string that should be used to generate the title for the current date range.
	// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
	computeTitleFormat: function() {
		if (this.currentRangeUnit == 'year') {
			return 'YYYY';
		}
		else if (this.currentRangeUnit == 'month') {
			return this.opt('monthYearFormat'); // like "September 2014"
		}
		else if (this.currentRangeAs('days') > 1) {
			return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
		}
		else {
			return 'LL'; // one day. longer, like "September 9 2014"
		}
	},


	// Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
	// Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
	// The timezones of the dates within `range` will be respected.
	formatRange: function(range, formatStr, separator) {
		var end = range.end;

		if (!end.hasTime()) { // all-day?
			end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
		}

		return formatRange(range.start, end, formatStr, separator, this.opt('isRTL'));
	},


	getAllDayHtml: function() {
		return this.opt('allDayHtml') || htmlEscape(this.opt('allDayText'));
	},


	/* Navigation
	------------------------------------------------------------------------------------------------------------------*/


	// Generates HTML for an anchor to another view into the calendar.
	// Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
	// `gotoOptions` can either be a moment input, or an object with the form:
	// { date, type, forceOff }
	// `type` is a view-type like "day" or "week". default value is "day".
	// `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
	buildGotoAnchorHtml: function(gotoOptions, attrs, innerHtml) {
		var date, type, forceOff;
		var finalOptions;

		if ($.isPlainObject(gotoOptions)) {
			date = gotoOptions.date;
			type = gotoOptions.type;
			forceOff = gotoOptions.forceOff;
		}
		else {
			date = gotoOptions; // a single moment input
		}
		date = FC.moment(date); // if a string, parse it

		finalOptions = { // for serialization into the link
			date: date.format('YYYY-MM-DD'),
			type: type || 'day'
		};

		if (typeof attrs === 'string') {
			innerHtml = attrs;
			attrs = null;
		}

		attrs = attrs ? ' ' + attrsToStr(attrs) : ''; // will have a leading space
		innerHtml = innerHtml || '';

		if (!forceOff && this.opt('navLinks')) {
			return '<a' + attrs +
				' data-goto="' + htmlEscape(JSON.stringify(finalOptions)) + '">' +
				innerHtml +
				'</a>';
		}
		else {
			return '<span' + attrs + '>' +
				innerHtml +
				'</span>';
		}
	},


	// Rendering Non-date-related Content
	// -----------------------------------------------------------------------------------------------------------------


	// Sets the container element that the view should render inside of, does global DOM-related initializations,
	// and renders all the non-date-related content inside.
	setElement: function(el) {
		this.el = el;
		this.bindGlobalHandlers();
		this.bindBaseRenderHandlers();
		this.renderSkeleton();
	},


	// Removes the view's container element from the DOM, clearing any content beforehand.
	// Undoes any other DOM-related attachments.
	removeElement: function() {
		this.unsetDate();
		this.unrenderSkeleton();

		this.unbindGlobalHandlers();
		this.unbindBaseRenderHandlers();

		this.el.remove();
		// NOTE: don't null-out this.el in case the View was destroyed within an API callback.
		// We don't null-out the View's other jQuery element references upon destroy,
		//  so we shouldn't kill this.el either.
	},


	// Renders the basic structure of the view before any content is rendered
	renderSkeleton: function() {
		// subclasses should implement
	},


	// Unrenders the basic structure of the view
	unrenderSkeleton: function() {
		// subclasses should implement
	},


	// Date Setting/Unsetting
	// -----------------------------------------------------------------------------------------------------------------


	setDate: function(date) {
		var currentDateProfile = this.get('dateProfile');
		var newDateProfile = this.buildDateProfile(date, null, true); // forceToValid=true

		if (
			!currentDateProfile ||
			!isRangesEqual(currentDateProfile.activeRange, newDateProfile.activeRange)
		) {
			this.set('dateProfile', newDateProfile);
		}

		return newDateProfile.date;
	},


	unsetDate: function() {
		this.unset('dateProfile');
	},


	// Date Rendering
	// -----------------------------------------------------------------------------------------------------------------


	requestDateRender: function(dateProfile) {
		var _this = this;

		this.renderQueue.queue(function() {
			_this.executeDateRender(dateProfile);
		}, 'date', 'init');
	},


	requestDateUnrender: function() {
		var _this = this;

		this.renderQueue.queue(function() {
			_this.executeDateUnrender();
		}, 'date', 'destroy');
	},


	// Event Data
	// -----------------------------------------------------------------------------------------------------------------


	fetchInitialEvents: function(dateProfile) {
		return this.calendar.requestEvents(
			dateProfile.activeRange.start,
			dateProfile.activeRange.end
		);
	},


	bindEventChanges: function() {
		this.listenTo(this.calendar, 'eventsReset', this.resetEvents);
	},


	unbindEventChanges: function() {
		this.stopListeningTo(this.calendar, 'eventsReset');
	},


	setEvents: function(events) {
		this.set('currentEvents', events);
		this.set('hasEvents', true);
	},


	unsetEvents: function() {
		this.unset('currentEvents');
		this.unset('hasEvents');
	},


	resetEvents: function(events) {
		this.startBatchRender();
		this.unsetEvents();
		this.setEvents(events);
		this.stopBatchRender();
	},


	// Event Rendering
	// -----------------------------------------------------------------------------------------------------------------


	requestEventsRender: function(events) {
		var _this = this;

		this.renderQueue.queue(function() {
			_this.executeEventsRender(events);
		}, 'event', 'init');
	},


	requestEventsUnrender: function() {
		var _this = this;

		this.renderQueue.queue(function() {
			_this.executeEventsUnrender();
		}, 'event', 'destroy');
	},


	// Date High-level Rendering
	// -----------------------------------------------------------------------------------------------------------------


	// if dateProfile not specified, uses current
	executeDateRender: function(dateProfile, skipScroll) {

		this.setDateProfileForRendering(dateProfile);
		this.updateTitle();
		this.calendar.updateToolbarButtons();

		if (this.render) {
			this.render(); // TODO: deprecate
		}

		this.renderDates();
		this.updateSize();
		this.renderBusinessHours(); // might need coordinates, so should go after updateSize()
		this.startNowIndicator();

		if (!skipScroll) {
			this.addScroll(this.computeInitialDateScroll());
		}

		this.isDatesRendered = true;
		this.trigger('datesRendered');
	},


	executeDateUnrender: function() {

		this.unselect();
		this.stopNowIndicator();

		this.trigger('before:datesUnrendered');

		this.unrenderBusinessHours();
		this.unrenderDates();

		if (this.destroy) {
			this.destroy(); // TODO: deprecate
		}

		this.isDatesRendered = false;
	},


	// Date Low-level Rendering
	// -----------------------------------------------------------------------------------------------------------------


	// date-cell content only
	renderDates: function() {
		// subclasses should implement
	},


	// date-cell content only
	unrenderDates: function() {
		// subclasses should override
	},


	// Determing when the "meat" of the view is rendered (aka the base)
	// -----------------------------------------------------------------------------------------------------------------


	bindBaseRenderHandlers: function() {
		var _this = this;

		this.on('datesRendered.baseHandler', function() {
			_this.onBaseRender();
		});

		this.on('before:datesUnrendered.baseHandler', function() {
			_this.onBeforeBaseUnrender();
		});
	},


	unbindBaseRenderHandlers: function() {
		this.off('.baseHandler');
	},


	onBaseRender: function() {
		this.applyScreenState();
		this.publiclyTrigger('viewRender', this, this, this.el);
	},


	onBeforeBaseUnrender: function() {
		this.applyScreenState();
		this.publiclyTrigger('viewDestroy', this, this, this.el);
	},


	// Misc view rendering utils
	// -----------------------------------------------------------------------------------------------------------------


	// Binds DOM handlers to elements that reside outside the view container, such as the document
	bindGlobalHandlers: function() {
		this.listenTo(GlobalEmitter.get(), {
			touchstart: this.processUnselect,
			mousedown: this.handleDocumentMousedown
		});
	},


	// Unbinds DOM handlers from elements that reside outside the view container
	unbindGlobalHandlers: function() {
		this.stopListeningTo(GlobalEmitter.get());
	},


	// Initializes internal variables related to theming
	initThemingProps: function() {
		var tm = this.opt('theme') ? 'ui' : 'fc';

		this.widgetHeaderClass = tm + '-widget-header';
		this.widgetContentClass = tm + '-widget-content';
		this.highlightStateClass = tm + '-state-highlight';
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	// Renders business-hours onto the view. Assumes updateSize has already been called.
	renderBusinessHours: function() {
		// subclasses should implement
	},


	// Unrenders previously-rendered business-hours
	unrenderBusinessHours: function() {
		// subclasses should implement
	},


	/* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/


	// Immediately render the current time indicator and begins re-rendering it at an interval,
	// which is defined by this.getNowIndicatorUnit().
	// TODO: somehow do this for the current whole day's background too
	startNowIndicator: function() {
		var _this = this;
		var unit;
		var update;
		var delay; // ms wait value

		if (this.opt('nowIndicator')) {
			unit = this.getNowIndicatorUnit();
			if (unit) {
				update = proxy(this, 'updateNowIndicator'); // bind to `this`

				this.initialNowDate = this.calendar.getNow();
				this.initialNowQueriedMs = +new Date();
				this.renderNowIndicator(this.initialNowDate);
				this.isNowIndicatorRendered = true;

				// wait until the beginning of the next interval
				delay = this.initialNowDate.clone().startOf(unit).add(1, unit) - this.initialNowDate;
				this.nowIndicatorTimeoutID = setTimeout(function() {
					_this.nowIndicatorTimeoutID = null;
					update();
					delay = +moment.duration(1, unit);
					delay = Math.max(100, delay); // prevent too frequent
					_this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
				}, delay);
			}
		}
	},


	// rerenders the now indicator, computing the new current time from the amount of time that has passed
	// since the initial getNow call.
	updateNowIndicator: function() {
		if (this.isNowIndicatorRendered) {
			this.unrenderNowIndicator();
			this.renderNowIndicator(
				this.initialNowDate.clone().add(new Date() - this.initialNowQueriedMs) // add ms
			);
		}
	},


	// Immediately unrenders the view's current time indicator and stops any re-rendering timers.
	// Won't cause side effects if indicator isn't rendered.
	stopNowIndicator: function() {
		if (this.isNowIndicatorRendered) {

			if (this.nowIndicatorTimeoutID) {
				clearTimeout(this.nowIndicatorTimeoutID);
				this.nowIndicatorTimeoutID = null;
			}
			if (this.nowIndicatorIntervalID) {
				clearTimeout(this.nowIndicatorIntervalID);
				this.nowIndicatorIntervalID = null;
			}

			this.unrenderNowIndicator();
			this.isNowIndicatorRendered = false;
		}
	},


	// Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
	// should be refreshed. If something falsy is returned, no time indicator is rendered at all.
	getNowIndicatorUnit: function() {
		// subclasses should implement
	},


	// Renders a current time indicator at the given datetime
	renderNowIndicator: function(date) {
		// subclasses should implement
	},


	// Undoes the rendering actions from renderNowIndicator
	unrenderNowIndicator: function() {
		// subclasses should implement
	},


	/* Dimensions
	------------------------------------------------------------------------------------------------------------------*/


	// Refreshes anything dependant upon sizing of the container element of the grid
	updateSize: function(isResize) {
		var scroll;

		if (isResize) {
			scroll = this.queryScroll();
		}

		this.updateHeight(isResize);
		this.updateWidth(isResize);
		this.updateNowIndicator();

		if (isResize) {
			this.applyScroll(scroll);
		}
	},


	// Refreshes the horizontal dimensions of the calendar
	updateWidth: function(isResize) {
		// subclasses should implement
	},


	// Refreshes the vertical dimensions of the calendar
	updateHeight: function(isResize) {
		var calendar = this.calendar; // we poll the calendar for height information

		this.setHeight(
			calendar.getSuggestedViewHeight(),
			calendar.isHeightAuto()
		);
	},


	// Updates the vertical dimensions of the calendar to the specified height.
	// if `isAuto` is set to true, height becomes merely a suggestion and the view should use its "natural" height.
	setHeight: function(height, isAuto) {
		// subclasses should implement
	},


	/* Scroller
	------------------------------------------------------------------------------------------------------------------*/


	addForcedScroll: function(scroll) {
		this.addScroll(
			$.extend(scroll, { isForced: true })
		);
	},


	addScroll: function(scroll) {
		var queuedScroll = this.queuedScroll || (this.queuedScroll = {});

		if (!queuedScroll.isForced) {
			$.extend(queuedScroll, scroll);
		}
	},


	popScroll: function() {
		this.applyQueuedScroll();
		this.queuedScroll = null;
	},


	applyQueuedScroll: function() {
		if (this.queuedScroll) {
			this.applyScroll(this.queuedScroll);
		}
	},


	queryScroll: function() {
		var scroll = {};

		if (this.isDatesRendered) {
			$.extend(scroll, this.queryDateScroll());
		}

		return scroll;
	},


	applyScroll: function(scroll) {
		if (this.isDatesRendered) {
			this.applyDateScroll(scroll);
		}
	},


	computeInitialDateScroll: function() {
		return {}; // subclasses must implement
	},


	queryDateScroll: function() {
		return {}; // subclasses must implement
	},


	applyDateScroll: function(scroll) {
		; // subclasses must implement
	},


	/* Height Freezing
	------------------------------------------------------------------------------------------------------------------*/


	freezeHeight: function() {
		this.calendar.freezeContentHeight();
	},


	thawHeight: function() {
		this.calendar.thawContentHeight();
	},


	// Event High-level Rendering
	// -----------------------------------------------------------------------------------------------------------------


	executeEventsRender: function(events) {
		this.renderEvents(events);
		this.isEventsRendered = true;

		this.onEventsRender();
	},


	executeEventsUnrender: function() {
		this.onBeforeEventsUnrender();

		if (this.destroyEvents) {
			this.destroyEvents(); // TODO: deprecate
		}

		this.unrenderEvents();
		this.isEventsRendered = false;
	},


	// Event Rendering Triggers
	// -----------------------------------------------------------------------------------------------------------------


	// Signals that all events have been rendered
	onEventsRender: function() {
		this.applyScreenState();

		this.renderedEventSegEach(function(seg) {
			this.publiclyTrigger('eventAfterRender', seg.event, seg.event, seg.el);
		});
		this.publiclyTrigger('eventAfterAllRender');
	},


	// Signals that all event elements are about to be removed
	onBeforeEventsUnrender: function() {
		this.applyScreenState();

		this.renderedEventSegEach(function(seg) {
			this.publiclyTrigger('eventDestroy', seg.event, seg.event, seg.el);
		});
	},


	applyScreenState: function() {
		this.thawHeight();
		this.freezeHeight();
		this.applyQueuedScroll();
	},


	// Event Low-level Rendering
	// -----------------------------------------------------------------------------------------------------------------


	// Renders the events onto the view.
	renderEvents: function(events) {
		// subclasses should implement
	},


	// Removes event elements from the view.
	unrenderEvents: function() {
		// subclasses should implement
	},


	// Event Rendering Utils
	// -----------------------------------------------------------------------------------------------------------------


	// Given an event and the default element used for rendering, returns the element that should actually be used.
	// Basically runs events and elements through the eventRender hook.
	resolveEventEl: function(event, el) {
		var custom = this.publiclyTrigger('eventRender', event, event, el);

		if (custom === false) { // means don't render at all
			el = null;
		}
		else if (custom && custom !== true) {
			el = $(custom);
		}

		return el;
	},


	// Hides all rendered event segments linked to the given event
	showEvent: function(event) {
		this.renderedEventSegEach(function(seg) {
			seg.el.css('visibility', '');
		}, event);
	},


	// Shows all rendered event segments linked to the given event
	hideEvent: function(event) {
		this.renderedEventSegEach(function(seg) {
			seg.el.css('visibility', 'hidden');
		}, event);
	},


	// Iterates through event segments that have been rendered (have an el). Goes through all by default.
	// If the optional `event` argument is specified, only iterates through segments linked to that event.
	// The `this` value of the callback function will be the view.
	renderedEventSegEach: function(func, event) {
		var segs = this.getEventSegs();
		var i;

		for (i = 0; i < segs.length; i++) {
			if (!event || segs[i].event._id === event._id) {
				if (segs[i].el) {
					func.call(this, segs[i]);
				}
			}
		}
	},


	// Retrieves all the rendered segment objects for the view
	getEventSegs: function() {
		// subclasses must implement
		return [];
	},


	/* Event Drag-n-Drop
	------------------------------------------------------------------------------------------------------------------*/


	// Computes if the given event is allowed to be dragged by the user
	isEventDraggable: function(event) {
		return this.isEventStartEditable(event);
	},


	isEventStartEditable: function(event) {
		return firstDefined(
			event.startEditable,
			(event.source || {}).startEditable,
			this.opt('eventStartEditable'),
			this.isEventGenerallyEditable(event)
		);
	},


	isEventGenerallyEditable: function(event) {
		return firstDefined(
			event.editable,
			(event.source || {}).editable,
			this.opt('editable')
		);
	},


	// Must be called when an event in the view is dropped onto new location.
	// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
	reportSegDrop: function(seg, dropLocation, largeUnit, el, ev) {
		var calendar = this.calendar;
		var mutateResult = calendar.mutateSeg(seg, dropLocation, largeUnit);
		var undoFunc = function() {
			mutateResult.undo();
			calendar.reportEventChange();
		};

		this.triggerEventDrop(seg.event, mutateResult.dateDelta, undoFunc, el, ev);
		calendar.reportEventChange(); // will rerender events
	},


	// Triggers event-drop handlers that have subscribed via the API
	triggerEventDrop: function(event, dateDelta, undoFunc, el, ev) {
		this.publiclyTrigger('eventDrop', el[0], event, dateDelta, undoFunc, ev, {}); // {} = jqui dummy
	},


	/* External Element Drag-n-Drop
	------------------------------------------------------------------------------------------------------------------*/


	// Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
	// `meta` is the parsed data that has been embedded into the dragging event.
	// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
	reportExternalDrop: function(meta, dropLocation, el, ev, ui) {
		var eventProps = meta.eventProps;
		var eventInput;
		var event;

		// Try to build an event object and render it. TODO: decouple the two
		if (eventProps) {
			eventInput = $.extend({}, eventProps, dropLocation);
			event = this.calendar.renderEvent(eventInput, meta.stick)[0]; // renderEvent returns an array
		}

		this.triggerExternalDrop(event, dropLocation, el, ev, ui);
	},


	// Triggers external-drop handlers that have subscribed via the API
	triggerExternalDrop: function(event, dropLocation, el, ev, ui) {

		// trigger 'drop' regardless of whether element represents an event
		this.publiclyTrigger('drop', el[0], dropLocation.start, ev, ui);

		if (event) {
			this.publiclyTrigger('eventReceive', null, event); // signal an external event landed
		}
	},


	/* Drag-n-Drop Rendering (for both events and external elements)
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of a event or external-element drag over the given drop zone.
	// If an external-element, seg will be `null`.
	// Must return elements used for any mock events.
	renderDrag: function(dropLocation, seg) {
		// subclasses must implement
	},


	// Unrenders a visual indication of an event or external-element being dragged.
	unrenderDrag: function() {
		// subclasses must implement
	},


	/* Event Resizing
	------------------------------------------------------------------------------------------------------------------*/


	// Computes if the given event is allowed to be resized from its starting edge
	isEventResizableFromStart: function(event) {
		return this.opt('eventResizableFromStart') && this.isEventResizable(event);
	},


	// Computes if the given event is allowed to be resized from its ending edge
	isEventResizableFromEnd: function(event) {
		return this.isEventResizable(event);
	},


	// Computes if the given event is allowed to be resized by the user at all
	isEventResizable: function(event) {
		var source = event.source || {};

		return firstDefined(
			event.durationEditable,
			source.durationEditable,
			this.opt('eventDurationEditable'),
			event.editable,
			source.editable,
			this.opt('editable')
		);
	},


	// Must be called when an event in the view has been resized to a new length
	reportSegResize: function(seg, resizeLocation, largeUnit, el, ev) {
		var calendar = this.calendar;
		var mutateResult = calendar.mutateSeg(seg, resizeLocation, largeUnit);
		var undoFunc = function() {
			mutateResult.undo();
			calendar.reportEventChange();
		};

		this.triggerEventResize(seg.event, mutateResult.durationDelta, undoFunc, el, ev);
		calendar.reportEventChange(); // will rerender events
	},


	// Triggers event-resize handlers that have subscribed via the API
	triggerEventResize: function(event, durationDelta, undoFunc, el, ev) {
		this.publiclyTrigger('eventResize', el[0], event, durationDelta, undoFunc, ev, {}); // {} = jqui dummy
	},


	/* Selection (time range)
	------------------------------------------------------------------------------------------------------------------*/


	// Selects a date span on the view. `start` and `end` are both Moments.
	// `ev` is the native mouse event that begin the interaction.
	select: function(span, ev) {
		this.unselect(ev);
		this.renderSelection(span);
		this.reportSelection(span, ev);
	},


	// Renders a visual indication of the selection
	renderSelection: function(span) {
		// subclasses should implement
	},


	// Called when a new selection is made. Updates internal state and triggers handlers.
	reportSelection: function(span, ev) {
		this.isSelected = true;
		this.triggerSelect(span, ev);
	},


	// Triggers handlers to 'select'
	triggerSelect: function(span, ev) {
		this.publiclyTrigger(
			'select',
			null,
			this.calendar.applyTimezone(span.start), // convert to calendar's tz for external API
			this.calendar.applyTimezone(span.end), // "
			ev
		);
	},


	// Undoes a selection. updates in the internal state and triggers handlers.
	// `ev` is the native mouse event that began the interaction.
	unselect: function(ev) {
		if (this.isSelected) {
			this.isSelected = false;
			if (this.destroySelection) {
				this.destroySelection(); // TODO: deprecate
			}
			this.unrenderSelection();
			this.publiclyTrigger('unselect', null, ev);
		}
	},


	// Unrenders a visual indication of selection
	unrenderSelection: function() {
		// subclasses should implement
	},


	/* Event Selection
	------------------------------------------------------------------------------------------------------------------*/


	selectEvent: function(event) {
		if (!this.selectedEvent || this.selectedEvent !== event) {
			this.unselectEvent();
			this.renderedEventSegEach(function(seg) {
				seg.el.addClass('fc-selected');
			}, event);
			this.selectedEvent = event;
		}
	},


	unselectEvent: function() {
		if (this.selectedEvent) {
			this.renderedEventSegEach(function(seg) {
				seg.el.removeClass('fc-selected');
			}, this.selectedEvent);
			this.selectedEvent = null;
		}
	},


	isEventSelected: function(event) {
		// event references might change on refetchEvents(), while selectedEvent doesn't,
		// so compare IDs
		return this.selectedEvent && this.selectedEvent._id === event._id;
	},


	/* Mouse / Touch Unselecting (time range & event unselection)
	------------------------------------------------------------------------------------------------------------------*/
	// TODO: move consistently to down/start or up/end?
	// TODO: don't kill previous selection if touch scrolling


	handleDocumentMousedown: function(ev) {
		if (isPrimaryMouseButton(ev)) {
			this.processUnselect(ev);
		}
	},


	processUnselect: function(ev) {
		this.processRangeUnselect(ev);
		this.processEventUnselect(ev);
	},


	processRangeUnselect: function(ev) {
		var ignore;

		// is there a time-range selection?
		if (this.isSelected && this.opt('unselectAuto')) {
			// only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
			ignore = this.opt('unselectCancel');
			if (!ignore || !$(ev.target).closest(ignore).length) {
				this.unselect(ev);
			}
		}
	},


	processEventUnselect: function(ev) {
		if (this.selectedEvent) {
			if (!$(ev.target).closest('.fc-selected').length) {
				this.unselectEvent();
			}
		}
	},


	/* Day Click
	------------------------------------------------------------------------------------------------------------------*/


	// Triggers handlers to 'dayClick'
	// Span has start/end of the clicked area. Only the start is useful.
	triggerDayClick: function(span, dayEl, ev) {
		this.publiclyTrigger(
			'dayClick',
			dayEl,
			this.calendar.applyTimezone(span.start), // convert to calendar's timezone for external API
			ev
		);
	},


	/* Date Utils
	------------------------------------------------------------------------------------------------------------------*/


	// Returns the date range of the full days the given range visually appears to occupy.
	// Returns a new range object.
	computeDayRange: function(range) {
		var startDay = range.start.clone().stripTime(); // the beginning of the day the range starts
		var end = range.end;
		var endDay = null;
		var endTimeMS;

		if (end) {
			endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
			endTimeMS = +end.time(); // # of milliseconds into `endDay`

			// If the end time is actually inclusively part of the next day and is equal to or
			// beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
			// Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
			if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
				endDay.add(1, 'days');
			}
		}

		// If no end was specified, or if it is within `startDay` but not past nextDayThreshold,
		// assign the default duration of one day.
		if (!end || endDay <= startDay) {
			endDay = startDay.clone().add(1, 'days');
		}

		return { start: startDay, end: endDay };
	},


	// Does the given event visually appear to occupy more than one day?
	isMultiDayEvent: function(event) {
		var range = this.computeDayRange(event); // event is range-ish

		return range.end.diff(range.start, 'days') > 1;
	}

});


View.watch('displayingDates', [ 'dateProfile' ], function(deps) {
	this.requestDateRender(deps.dateProfile);
}, function() {
	this.requestDateUnrender();
});


View.watch('initialEvents', [ 'dateProfile' ], function(deps) {
	return this.fetchInitialEvents(deps.dateProfile);
});


View.watch('bindingEvents', [ 'initialEvents' ], function(deps) {
	this.setEvents(deps.initialEvents);
	this.bindEventChanges();
}, function() {
	this.unbindEventChanges();
	this.unsetEvents();
});


View.watch('displayingEvents', [ 'displayingDates', 'hasEvents' ], function() {
	this.requestEventsRender(this.get('currentEvents')); // if there were event mutations after initialEvents
}, function() {
	this.requestEventsUnrender();
});

;;

View.mixin({

	// range the view is formally responsible for.
	// for example, a month view might have 1st-31st, excluding padded dates
	currentRange: null,
	currentRangeUnit: null, // name of largest unit being displayed, like "month" or "week"

	// date range with a rendered skeleton
	// includes not-active days that need some sort of DOM
	renderRange: null,

	// dates that display events and accept drag-n-drop
	activeRange: null,

	// constraint for where prev/next operations can go and where events can be dragged/resized to.
	// an object with optional start and end properties.
	validRange: null,

	// how far the current date will move for a prev/next operation
	dateIncrement: null,

	minTime: null, // Duration object that denotes the first visible time of any given day
	maxTime: null, // Duration object that denotes the exclusive visible end time of any given day
	usesMinMaxTime: false, // whether minTime/maxTime will affect the activeRange. Views must opt-in.

	// DEPRECATED
	start: null, // use activeRange.start
	end: null, // use activeRange.end
	intervalStart: null, // use currentRange.start
	intervalEnd: null, // use currentRange.end


	/* Date Range Computation
	------------------------------------------------------------------------------------------------------------------*/


	setDateProfileForRendering: function(dateProfile) {
		this.currentRange = dateProfile.currentRange;
		this.currentRangeUnit = dateProfile.currentRangeUnit;
		this.renderRange = dateProfile.renderRange;
		this.activeRange = dateProfile.activeRange;
		this.validRange = dateProfile.validRange;
		this.dateIncrement = dateProfile.dateIncrement;
		this.minTime = dateProfile.minTime;
		this.maxTime = dateProfile.maxTime;

		// DEPRECATED, but we need to keep it updated
		this.start = dateProfile.activeRange.start;
		this.end = dateProfile.activeRange.end;
		this.intervalStart = dateProfile.currentRange.start;
		this.intervalEnd = dateProfile.currentRange.end;
	},


	// Builds a structure with info about what the dates/ranges will be for the "prev" view.
	buildPrevDateProfile: function(date) {
		var prevDate = date.clone().startOf(this.currentRangeUnit).subtract(this.dateIncrement);

		return this.buildDateProfile(prevDate, -1);
	},


	// Builds a structure with info about what the dates/ranges will be for the "next" view.
	buildNextDateProfile: function(date) {
		var nextDate = date.clone().startOf(this.currentRangeUnit).add(this.dateIncrement);

		return this.buildDateProfile(nextDate, 1);
	},


	// Builds a structure holding dates/ranges for rendering around the given date.
	// Optional direction param indicates whether the date is being incremented/decremented
	// from its previous value. decremented = -1, incremented = 1 (default).
	buildDateProfile: function(date, direction, forceToValid) {
		var validRange = this.buildValidRange();
		var minTime = null;
		var maxTime = null;
		var currentInfo;
		var renderRange;
		var activeRange;
		var isValid;

		if (forceToValid) {
			date = constrainDate(date, validRange);
		}

		currentInfo = this.buildCurrentRangeInfo(date, direction);
		renderRange = this.buildRenderRange(currentInfo.range, currentInfo.unit);
		activeRange = cloneRange(renderRange);

		if (!this.opt('showNonCurrentDates')) {
			activeRange = constrainRange(activeRange, currentInfo.range);
		}

		minTime = moment.duration(this.opt('minTime'));
		maxTime = moment.duration(this.opt('maxTime'));
		this.adjustActiveRange(activeRange, minTime, maxTime);

		activeRange = constrainRange(activeRange, validRange);
		date = constrainDate(date, activeRange);

		// it's invalid if the originally requested date is not contained,
		// or if the range is completely outside of the valid range.
		isValid = doRangesIntersect(currentInfo.range, validRange);

		return {
			validRange: validRange,
			currentRange: currentInfo.range,
			currentRangeUnit: currentInfo.unit,
			activeRange: activeRange,
			renderRange: renderRange,
			minTime: minTime,
			maxTime: maxTime,
			isValid: isValid,
			date: date,
			dateIncrement: this.buildDateIncrement(currentInfo.duration)
				// pass a fallback (might be null) ^
		};
	},


	// Builds an object with optional start/end properties.
	// Indicates the minimum/maximum dates to display.
	buildValidRange: function() {
		return this.getRangeOption('validRange', this.calendar.getNow()) || {};
	},


	// Builds a structure with info about the "current" range, the range that is
	// highlighted as being the current month for example.
	// See buildDateProfile for a description of `direction`.
	// Guaranteed to have `range` and `unit` properties. `duration` is optional.
	buildCurrentRangeInfo: function(date, direction) {
		var duration = null;
		var unit = null;
		var range = null;
		var dayCount;

		if (this.viewSpec.duration) {
			duration = this.viewSpec.duration;
			unit = this.viewSpec.durationUnit;
			range = this.buildRangeFromDuration(date, direction, duration, unit);
		}
		else if ((dayCount = this.opt('dayCount'))) {
			unit = 'day';
			range = this.buildRangeFromDayCount(date, direction, dayCount);
		}
		else if ((range = this.buildCustomVisibleRange(date))) {
			unit = computeGreatestUnit(range.start, range.end);
		}
		else {
			duration = this.getFallbackDuration();
			unit = computeGreatestUnit(duration);
			range = this.buildRangeFromDuration(date, direction, duration, unit);
		}

		this.normalizeCurrentRange(range, unit); // modifies in-place

		return { duration: duration, unit: unit, range: range };
	},


	getFallbackDuration: function() {
		return moment.duration({ days: 1 });
	},


	// If the range has day units or larger, remove times. Otherwise, ensure times.
	normalizeCurrentRange: function(range, unit) {

		if (/^(year|month|week|day)$/.test(unit)) { // whole-days?
			range.start.stripTime();
			range.end.stripTime();
		}
		else { // needs to have a time?
			if (!range.start.hasTime()) {
				range.start.time(0); // give 00:00 time
			}
			if (!range.end.hasTime()) {
				range.end.time(0); // give 00:00 time
			}
		}
	},


	// Mutates the given activeRange to have time values (un-ambiguate)
	// if the minTime or maxTime causes the range to expand.
	// TODO: eventually activeRange should *always* have times.
	adjustActiveRange: function(range, minTime, maxTime) {
		var hasSpecialTimes = false;

		if (this.usesMinMaxTime) {

			if (minTime < 0) {
				range.start.time(0).add(minTime);
				hasSpecialTimes = true;
			}

			if (maxTime > 24 * 60 * 60 * 1000) { // beyond 24 hours?
				range.end.time(maxTime - (24 * 60 * 60 * 1000));
				hasSpecialTimes = true;
			}

			if (hasSpecialTimes) {
				if (!range.start.hasTime()) {
					range.start.time(0);
				}
				if (!range.end.hasTime()) {
					range.end.time(0);
				}
			}
		}
	},


	// Builds the "current" range when it is specified as an explicit duration.
	// `unit` is the already-computed computeGreatestUnit value of duration.
	buildRangeFromDuration: function(date, direction, duration, unit) {
		var alignment = this.opt('dateAlignment');
		var start = date.clone();
		var end;
		var dateIncrementInput;
		var dateIncrementDuration;

		// if the view displays a single day or smaller
		if (duration.as('days') <= 1) {
			if (this.isHiddenDay(start)) {
				start = this.skipHiddenDays(start, direction);
				start.startOf('day');
			}
		}

		// compute what the alignment should be
		if (!alignment) {
			dateIncrementInput = this.opt('dateIncrement');

			if (dateIncrementInput) {
				dateIncrementDuration = moment.duration(dateIncrementInput);

				// use the smaller of the two units
				if (dateIncrementDuration < duration) {
					alignment = computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
				}
				else {
					alignment = unit;
				}
			}
			else {
				alignment = unit;
			}
		}

		start.startOf(alignment);
		end = start.clone().add(duration);

		return { start: start, end: end };
	},


	// Builds the "current" range when a dayCount is specified.
	buildRangeFromDayCount: function(date, direction, dayCount) {
		var customAlignment = this.opt('dateAlignment');
		var runningCount = 0;
		var start = date.clone();
		var end;

		if (customAlignment) {
			start.startOf(customAlignment);
		}

		start.startOf('day');
		start = this.skipHiddenDays(start, direction);

		end = start.clone();
		do {
			end.add(1, 'day');
			if (!this.isHiddenDay(end)) {
				runningCount++;
			}
		} while (runningCount < dayCount);

		return { start: start, end: end };
	},


	// Builds a normalized range object for the "visible" range,
	// which is a way to define the currentRange and activeRange at the same time.
	buildCustomVisibleRange: function(date) {
		var visibleRange = this.getRangeOption(
			'visibleRange',
			this.calendar.moment(date) // correct zone. also generates new obj that avoids mutations
		);

		if (visibleRange && (!visibleRange.start || !visibleRange.end)) {
			return null;
		}

		return visibleRange;
	},


	// Computes the range that will represent the element/cells for *rendering*,
	// but which may have voided days/times.
	buildRenderRange: function(currentRange, currentRangeUnit) {
		// cut off days in the currentRange that are hidden
		return this.trimHiddenDays(currentRange);
	},


	// Compute the duration value that should be added/substracted to the current date
	// when a prev/next operation happens.
	buildDateIncrement: function(fallback) {
		var dateIncrementInput = this.opt('dateIncrement');
		var customAlignment;

		if (dateIncrementInput) {
			return moment.duration(dateIncrementInput);
		}
		else if ((customAlignment = this.opt('dateAlignment'))) {
			return moment.duration(1, customAlignment);
		}
		else if (fallback) {
			return fallback;
		}
		else {
			return moment.duration({ days: 1 });
		}
	},


	// Remove days from the beginning and end of the range that are computed as hidden.
	trimHiddenDays: function(inputRange) {
		return {
			start: this.skipHiddenDays(inputRange.start),
			end: this.skipHiddenDays(inputRange.end, -1, true) // exclusively move backwards
		};
	},


	// Compute the number of the give units in the "current" range.
	// Will return a floating-point number. Won't round.
	currentRangeAs: function(unit) {
		var currentRange = this.currentRange;
		return currentRange.end.diff(currentRange.start, unit, true);
	},


	// Arguments after name will be forwarded to a hypothetical function value
	// WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
	// Always clone your objects if you fear mutation.
	getRangeOption: function(name) {
		var val = this.opt(name);

		if (typeof val === 'function') {
			val = val.apply(
				null,
				Array.prototype.slice.call(arguments, 1)
			);
		}

		if (val) {
			return this.calendar.parseRange(val);
		}
	},


	/* Hidden Days
	------------------------------------------------------------------------------------------------------------------*/


	// Initializes internal variables related to calculating hidden days-of-week
	initHiddenDays: function() {
		var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
		var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
		var dayCnt = 0;
		var i;

		if (this.opt('weekends') === false) {
			hiddenDays.push(0, 6); // 0=sunday, 6=saturday
		}

		for (i = 0; i < 7; i++) {
			if (
				!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)
			) {
				dayCnt++;
			}
		}

		if (!dayCnt) {
			throw 'invalid hiddenDays'; // all days were hidden? bad.
		}

		this.isHiddenDayHash = isHiddenDayHash;
	},


	// Is the current day hidden?
	// `day` is a day-of-week index (0-6), or a Moment
	isHiddenDay: function(day) {
		if (moment.isMoment(day)) {
			day = day.day();
		}
		return this.isHiddenDayHash[day];
	},


	// Incrementing the current day until it is no longer a hidden day, returning a copy.
	// DOES NOT CONSIDER validRange!
	// If the initial value of `date` is not a hidden day, don't do anything.
	// Pass `isExclusive` as `true` if you are dealing with an end date.
	// `inc` defaults to `1` (increment one day forward each time)
	skipHiddenDays: function(date, inc, isExclusive) {
		var out = date.clone();
		inc = inc || 1;
		while (
			this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]
		) {
			out.add(inc, 'days');
		}
		return out;
	}

});

;;

/*
Embodies a div that has potential scrollbars
*/
var Scroller = FC.Scroller = Class.extend({

	el: null, // the guaranteed outer element
	scrollEl: null, // the element with the scrollbars
	overflowX: null,
	overflowY: null,


	constructor: function(options) {
		options = options || {};
		this.overflowX = options.overflowX || options.overflow || 'auto';
		this.overflowY = options.overflowY || options.overflow || 'auto';
	},


	render: function() {
		this.el = this.renderEl();
		this.applyOverflow();
	},


	renderEl: function() {
		return (this.scrollEl = $('<div class="fc-scroller"></div>'));
	},


	// sets to natural height, unlocks overflow
	clear: function() {
		this.setHeight('auto');
		this.applyOverflow();
	},


	destroy: function() {
		this.el.remove();
	},


	// Overflow
	// -----------------------------------------------------------------------------------------------------------------


	applyOverflow: function() {
		this.scrollEl.css({
			'overflow-x': this.overflowX,
			'overflow-y': this.overflowY
		});
	},


	// Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
	// Useful for preserving scrollbar widths regardless of future resizes.
	// Can pass in scrollbarWidths for optimization.
	lockOverflow: function(scrollbarWidths) {
		var overflowX = this.overflowX;
		var overflowY = this.overflowY;

		scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();

		if (overflowX === 'auto') {
			overflowX = (
					scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
					// OR scrolling pane with massless scrollbars?
					this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth
						// subtract 1 because of IE off-by-one issue
				) ? 'scroll' : 'hidden';
		}

		if (overflowY === 'auto') {
			overflowY = (
					scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
					// OR scrolling pane with massless scrollbars?
					this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight
						// subtract 1 because of IE off-by-one issue
				) ? 'scroll' : 'hidden';
		}

		this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
	},


	// Getters / Setters
	// -----------------------------------------------------------------------------------------------------------------


	setHeight: function(height) {
		this.scrollEl.height(height);
	},


	getScrollTop: function() {
		return this.scrollEl.scrollTop();
	},


	setScrollTop: function(top) {
		this.scrollEl.scrollTop(top);
	},


	getClientWidth: function() {
		return this.scrollEl[0].clientWidth;
	},


	getClientHeight: function() {
		return this.scrollEl[0].clientHeight;
	},


	getScrollbarWidths: function() {
		return getScrollbarWidths(this.scrollEl);
	}

});

;;
function Iterator(items) {
    this.items = items || [];
}


/* Calls a method on every item passing the arguments through */
Iterator.prototype.proxyCall = function(methodName) {
    var args = Array.prototype.slice.call(arguments, 1);
    var results = [];

    this.items.forEach(function(item) {
        results.push(item[methodName].apply(item, args));
    });

    return results;
};

;;

/* Toolbar with buttons and title
----------------------------------------------------------------------------------------------------------------------*/

function Toolbar(calendar, toolbarOptions) {
	var t = this;

	// exports
	t.setToolbarOptions = setToolbarOptions;
	t.render = render;
	t.removeElement = removeElement;
	t.updateTitle = updateTitle;
	t.activateButton = activateButton;
	t.deactivateButton = deactivateButton;
	t.disableButton = disableButton;
	t.enableButton = enableButton;
	t.getViewsWithButtons = getViewsWithButtons;
	t.el = null; // mirrors local `el`

	// locals
	var el;
	var viewsWithButtons = [];
	var tm;

	// method to update toolbar-specific options, not calendar-wide options
	function setToolbarOptions(newToolbarOptions) {
		toolbarOptions = newToolbarOptions;
	}

	// can be called repeatedly and will rerender
	function render() {
		var sections = toolbarOptions.layout;

		tm = calendar.opt('theme') ? 'ui' : 'fc';

		if (sections) {
			if (!el) {
				el = this.el = $("<div class='fc-toolbar "+ toolbarOptions.extraClasses + "'/>");
			}
			else {
				el.empty();
			}
			el.append(renderSection('left'))
				.append(renderSection('right'))
				.append(renderSection('center'))
				.append('<div class="fc-clear"/>');
		}
		else {
			removeElement();
		}
	}


	function removeElement() {
		if (el) {
			el.remove();
			el = t.el = null;
		}
	}


	function renderSection(position) {
		var sectionEl = $('<div class="fc-' + position + '"/>');
		var buttonStr = toolbarOptions.layout[position];
		var calendarCustomButtons = calendar.opt('customButtons') || {};
		var calendarButtonText = calendar.opt('buttonText') || {};

		if (buttonStr) {
			$.each(buttonStr.split(' '), function(i) {
				var groupChildren = $();
				var isOnlyButtons = true;
				var groupEl;

				$.each(this.split(','), function(j, buttonName) {
					var customButtonProps;
					var viewSpec;
					var buttonClick;
					var overrideText; // text explicitly set by calendar's constructor options. overcomes icons
					var defaultText;
					var themeIcon;
					var normalIcon;
					var innerHtml;
					var classes;
					var button; // the element

					if (buttonName == 'title') {
						groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
						isOnlyButtons = false;
					}
					else {
						if ((customButtonProps = calendarCustomButtons[buttonName])) {
							buttonClick = function(ev) {
								if (customButtonProps.click) {
									customButtonProps.click.call(button[0], ev);
								}
							};
							overrideText = ''; // icons will override text
							defaultText = customButtonProps.text;
						}
						else if ((viewSpec = calendar.getViewSpec(buttonName))) {
							buttonClick = function() {
								calendar.changeView(buttonName);
							};
							viewsWithButtons.push(buttonName);
							overrideText = viewSpec.buttonTextOverride;
							defaultText = viewSpec.buttonTextDefault;
						}
						else if (calendar[buttonName]) { // a calendar method
							buttonClick = function() {
								calendar[buttonName]();
							};
							overrideText = (calendar.overrides.buttonText || {})[buttonName];
							defaultText = calendarButtonText[buttonName]; // everything else is considered default
						}

						if (buttonClick) {

							themeIcon =
								customButtonProps ?
									customButtonProps.themeIcon :
									calendar.opt('themeButtonIcons')[buttonName];

							normalIcon =
								customButtonProps ?
									customButtonProps.icon :
									calendar.opt('buttonIcons')[buttonName];

							if (overrideText) {
								innerHtml = htmlEscape(overrideText);
							}
							else if (themeIcon && calendar.opt('theme')) {
								innerHtml = "<span class='ui-icon ui-icon-" + themeIcon + "'></span>";
							}
							else if (normalIcon && !calendar.opt('theme')) {
								innerHtml = "<span class='fc-icon fc-icon-" + normalIcon + "'></span>";
							}
							else {
								innerHtml = htmlEscape(defaultText);
							}

							classes = [
								'fc-' + buttonName + '-button',
								tm + '-button',
								tm + '-state-default'
							];

							button = $( // type="button" so that it doesn't submit a form
								'<button type="button" class="' + classes.join(' ') + '">' +
									innerHtml +
								'</button>'
								)
								.click(function(ev) {
									// don't process clicks for disabled buttons
									if (!button.hasClass(tm + '-state-disabled')) {

										buttonClick(ev);

										// after the click action, if the button becomes the "active" tab, or disabled,
										// it should never have a hover class, so remove it now.
										if (
											button.hasClass(tm + '-state-active') ||
											button.hasClass(tm + '-state-disabled')
										) {
											button.removeClass(tm + '-state-hover');
										}
									}
								})
								.mousedown(function() {
									// the *down* effect (mouse pressed in).
									// only on buttons that are not the "active" tab, or disabled
									button
										.not('.' + tm + '-state-active')
										.not('.' + tm + '-state-disabled')
										.addClass(tm + '-state-down');
								})
								.mouseup(function() {
									// undo the *down* effect
									button.removeClass(tm + '-state-down');
								})
								.hover(
									function() {
										// the *hover* effect.
										// only on buttons that are not the "active" tab, or disabled
										button
											.not('.' + tm + '-state-active')
											.not('.' + tm + '-state-disabled')
											.addClass(tm + '-state-hover');
									},
									function() {
										// undo the *hover* effect
										button
											.removeClass(tm + '-state-hover')
											.removeClass(tm + '-state-down'); // if mouseleave happens before mouseup
									}
								);

							groupChildren = groupChildren.add(button);
						}
					}
				});

				if (isOnlyButtons) {
					groupChildren
						.first().addClass(tm + '-corner-left').end()
						.last().addClass(tm + '-corner-right').end();
				}

				if (groupChildren.length > 1) {
					groupEl = $('<div/>');
					if (isOnlyButtons) {
						groupEl.addClass('fc-button-group');
					}
					groupEl.append(groupChildren);
					sectionEl.append(groupEl);
				}
				else {
					sectionEl.append(groupChildren); // 1 or 0 children
				}
			});
		}

		return sectionEl;
	}


	function updateTitle(text) {
		if (el) {
			el.find('h2').text(text);
		}
	}


	function activateButton(buttonName) {
		if (el) {
			el.find('.fc-' + buttonName + '-button')
				.addClass(tm + '-state-active');
		}
	}


	function deactivateButton(buttonName) {
		if (el) {
			el.find('.fc-' + buttonName + '-button')
				.removeClass(tm + '-state-active');
		}
	}


	function disableButton(buttonName) {
		if (el) {
			el.find('.fc-' + buttonName + '-button')
				.prop('disabled', true)
				.addClass(tm + '-state-disabled');
		}
	}


	function enableButton(buttonName) {
		if (el) {
			el.find('.fc-' + buttonName + '-button')
				.prop('disabled', false)
				.removeClass(tm + '-state-disabled');
		}
	}


	function getViewsWithButtons() {
		return viewsWithButtons;
	}

}

;;

var Calendar = FC.Calendar = Class.extend(EmitterMixin, {

	view: null, // current View object
	viewsByType: null, // holds all instantiated view instances, current or not
	currentDate: null, // unzoned moment. private (public API should use getDate instead)
	loadingLevel: 0, // number of simultaneous loading tasks


	constructor: function(el, overrides) {

		// declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
		// unneeded() is called in destroy.
		GlobalEmitter.needed();

		this.el = el;
		this.viewsByType = {};
		this.viewSpecCache = {};

		this.initOptionsInternals(overrides);
		this.initMomentInternals(); // needs to happen after options hash initialized
		this.initCurrentDate();

		EventManager.call(this); // needs options immediately
		this.initialize();
	},


	// Subclasses can override this for initialization logic after the constructor has been called
	initialize: function() {
	},


	// Public API
	// -----------------------------------------------------------------------------------------------------------------


	getCalendar: function() {
		return this;
	},


	getView: function() {
		return this.view;
	},


	publiclyTrigger: function(name, thisObj) {
		var args = Array.prototype.slice.call(arguments, 2);
		var optHandler = this.opt(name);

		thisObj = thisObj || this.el[0];
		this.triggerWith(name, thisObj, args); // Emitter's method

		if (optHandler) {
			return optHandler.apply(thisObj, args);
		}
	},


	// View
	// -----------------------------------------------------------------------------------------------------------------


	// Given a view name for a custom view or a standard view, creates a ready-to-go View object
	instantiateView: function(viewType) {
		var spec = this.getViewSpec(viewType);

		return new spec['class'](this, spec);
	},


	// Returns a boolean about whether the view is okay to instantiate at some point
	isValidViewType: function(viewType) {
		return Boolean(this.getViewSpec(viewType));
	},


	changeView: function(viewName, dateOrRange) {

		if (dateOrRange) {

			if (dateOrRange.start && dateOrRange.end) { // a range
				this.recordOptionOverrides({ // will not rerender
					visibleRange: dateOrRange
				});
			}
			else { // a date
				this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
			}
		}

		this.renderView(viewName);
	},


	// Forces navigation to a view for the given date.
	// `viewType` can be a specific view name or a generic one like "week" or "day".
	zoomTo: function(newDate, viewType) {
		var spec;

		viewType = viewType || 'day'; // day is default zoom
		spec = this.getViewSpec(viewType) || this.getUnitViewSpec(viewType);

		this.currentDate = newDate.clone();
		this.renderView(spec ? spec.type : null);
	},


	// Current Date
	// -----------------------------------------------------------------------------------------------------------------


	initCurrentDate: function() {
		var defaultDateInput = this.opt('defaultDate');

		// compute the initial ambig-timezone date
		if (defaultDateInput != null) {
			this.currentDate = this.moment(defaultDateInput).stripZone();
		}
		else {
			this.currentDate = this.getNow(); // getNow already returns unzoned
		}
	},


	prev: function() {
		var prevInfo = this.view.buildPrevDateProfile(this.currentDate);

		if (prevInfo.isValid) {
			this.currentDate = prevInfo.date;
			this.renderView();
		}
	},


	next: function() {
		var nextInfo = this.view.buildNextDateProfile(this.currentDate);

		if (nextInfo.isValid) {
			this.currentDate = nextInfo.date;
			this.renderView();
		}
	},


	prevYear: function() {
		this.currentDate.add(-1, 'years');
		this.renderView();
	},


	nextYear: function() {
		this.currentDate.add(1, 'years');
		this.renderView();
	},


	today: function() {
		this.currentDate = this.getNow(); // should deny like prev/next?
		this.renderView();
	},


	gotoDate: function(zonedDateInput) {
		this.currentDate = this.moment(zonedDateInput).stripZone();
		this.renderView();
	},


	incrementDate: function(delta) {
		this.currentDate.add(moment.duration(delta));
		this.renderView();
	},


	// for external API
	getDate: function() {
		return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
	},


	// Loading Triggering
	// -----------------------------------------------------------------------------------------------------------------


	// Should be called when any type of async data fetching begins
	pushLoading: function() {
		if (!(this.loadingLevel++)) {
			this.publiclyTrigger('loading', null, true, this.view);
		}
	},


	// Should be called when any type of async data fetching completes
	popLoading: function() {
		if (!(--this.loadingLevel)) {
			this.publiclyTrigger('loading', null, false, this.view);
		}
	},


	// Selection
	// -----------------------------------------------------------------------------------------------------------------


	// this public method receives start/end dates in any format, with any timezone
	select: function(zonedStartInput, zonedEndInput) {
		this.view.select(
			this.buildSelectSpan.apply(this, arguments)
		);
	},


	unselect: function() { // safe to be called before renderView
		if (this.view) {
			this.view.unselect();
		}
	},


	// Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
	buildSelectSpan: function(zonedStartInput, zonedEndInput) {
		var start = this.moment(zonedStartInput).stripZone();
		var end;

		if (zonedEndInput) {
			end = this.moment(zonedEndInput).stripZone();
		}
		else if (start.hasTime()) {
			end = start.clone().add(this.defaultTimedEventDuration);
		}
		else {
			end = start.clone().add(this.defaultAllDayEventDuration);
		}

		return { start: start, end: end };
	},


	// Misc
	// -----------------------------------------------------------------------------------------------------------------


	// will return `null` if invalid range
	parseRange: function(rangeInput) {
		var start = null;
		var end = null;

		if (rangeInput.start) {
			start = this.moment(rangeInput.start).stripZone();
		}

		if (rangeInput.end) {
			end = this.moment(rangeInput.end).stripZone();
		}

		if (!start && !end) {
			return null;
		}

		if (start && end && end.isBefore(start)) {
			return null;
		}

		return { start: start, end: end };
	},


	rerenderEvents: function() { // API method. destroys old events if previously rendered.
		if (this.elementVisible()) {
			this.reportEventChange(); // will re-trasmit events to the view, causing a rerender
		}
	}

});

;;
/*
Options binding/triggering system.
*/
Calendar.mixin({

	dirDefaults: null, // option defaults related to LTR or RTL
	localeDefaults: null, // option defaults related to current locale
	overrides: null, // option overrides given to the fullCalendar constructor
	dynamicOverrides: null, // options set with dynamic setter method. higher precedence than view overrides.
	optionsModel: null, // all defaults combined with overrides


	initOptionsInternals: function(overrides) {
		this.overrides = $.extend({}, overrides); // make a copy
		this.dynamicOverrides = {};
		this.optionsModel = new Model();

		this.populateOptionsHash();
	},


	// public getter/setter
	option: function(name, value) {
		var newOptionHash;

		if (typeof name === 'string') {
			if (value === undefined) { // getter
				return this.optionsModel.get(name);
			}
			else { // setter for individual option
				newOptionHash = {};
				newOptionHash[name] = value;
				this.setOptions(newOptionHash);
			}
		}
		else if (typeof name === 'object') { // compound setter with object input
			this.setOptions(name);
		}
	},


	// private getter
	opt: function(name) {
		return this.optionsModel.get(name);
	},


	setOptions: function(newOptionHash) {
		var optionCnt = 0;
		var optionName;

		this.recordOptionOverrides(newOptionHash);

		for (optionName in newOptionHash) {
			optionCnt++;
		}

		// special-case handling of single option change.
		// if only one option change, `optionName` will be its name.
		if (optionCnt === 1) {
			if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
				this.updateSize(true); // true = allow recalculation of height
				return;
			}
			else if (optionName === 'defaultDate') {
				return; // can't change date this way. use gotoDate instead
			}
			else if (optionName === 'businessHours') {
				if (this.view) {
					this.view.unrenderBusinessHours();
					this.view.renderBusinessHours();
				}
				return;
			}
			else if (optionName === 'timezone') {
				this.rezoneArrayEventSources();
				this.refetchEvents();
				return;
			}
		}

		// catch-all. rerender the header and footer and rebuild/rerender the current view
		this.renderHeader();
		this.renderFooter();

		// even non-current views will be affected by this option change. do before rerender
		// TODO: detangle
		this.viewsByType = {};

		this.reinitView();
	},


	// Computes the flattened options hash for the calendar and assigns to `this.options`.
	// Assumes this.overrides and this.dynamicOverrides have already been initialized.
	populateOptionsHash: function() {
		var locale, localeDefaults;
		var isRTL, dirDefaults;
		var rawOptions;

		locale = firstDefined( // explicit locale option given?
			this.dynamicOverrides.locale,
			this.overrides.locale
		);
		localeDefaults = localeOptionHash[locale];
		if (!localeDefaults) { // explicit locale option not given or invalid?
			locale = Calendar.defaults.locale;
			localeDefaults = localeOptionHash[locale] || {};
		}

		isRTL = firstDefined( // based on options computed so far, is direction RTL?
			this.dynamicOverrides.isRTL,
			this.overrides.isRTL,
			localeDefaults.isRTL,
			Calendar.defaults.isRTL
		);
		dirDefaults = isRTL ? Calendar.rtlDefaults : {};

		this.dirDefaults = dirDefaults;
		this.localeDefaults = localeDefaults;

		rawOptions = mergeOptions([ // merge defaults and overrides. lowest to highest precedence
			Calendar.defaults, // global defaults
			dirDefaults,
			localeDefaults,
			this.overrides,
			this.dynamicOverrides
		]);
		populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options

		this.optionsModel.reset(rawOptions);
	},


	// stores the new options internally, but does not rerender anything.
	recordOptionOverrides: function(newOptionHash) {
		var optionName;

		for (optionName in newOptionHash) {
			this.dynamicOverrides[optionName] = newOptionHash[optionName];
		}

		this.viewSpecCache = {}; // the dynamic override invalidates the options in this cache, so just clear it
		this.populateOptionsHash(); // this.options needs to be recomputed after the dynamic override
	}

});

;;

Calendar.mixin({

	defaultAllDayEventDuration: null,
	defaultTimedEventDuration: null,
	localeData: null,


	initMomentInternals: function() {
		var _this = this;

		this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
		this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));

		// Called immediately, and when any of the options change.
		// Happens before any internal objects rebuild or rerender, because this is very core.
		this.optionsModel.watch('buildingMomentLocale', [
			'?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
			'?firstDay', '?weekNumberCalculation'
		], function(opts) {
			var weekNumberCalculation = opts.weekNumberCalculation;
			var firstDay = opts.firstDay;
			var _week;

			// normalize
			if (weekNumberCalculation === 'iso') {
				weekNumberCalculation = 'ISO'; // normalize
			}

			var localeData = createObject( // make a cheap copy
				getMomentLocaleData(opts.locale) // will fall back to en
			);

			if (opts.monthNames) {
				localeData._months = opts.monthNames;
			}
			if (opts.monthNamesShort) {
				localeData._monthsShort = opts.monthNamesShort;
			}
			if (opts.dayNames) {
				localeData._weekdays = opts.dayNames;
			}
			if (opts.dayNamesShort) {
				localeData._weekdaysShort = opts.dayNamesShort;
			}

			if (firstDay == null && weekNumberCalculation === 'ISO') {
				firstDay = 1;
			}
			if (firstDay != null) {
				_week = createObject(localeData._week); // _week: { dow: # }
				_week.dow = firstDay;
				localeData._week = _week;
			}

			if ( // whitelist certain kinds of input
				weekNumberCalculation === 'ISO' ||
				weekNumberCalculation === 'local' ||
				typeof weekNumberCalculation === 'function'
			) {
				localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
			}

			_this.localeData = localeData;

			// If the internal current date object already exists, move to new locale.
			// We do NOT need to do this technique for event dates, because this happens when converting to "segments".
			if (_this.currentDate) {
				_this.localizeMoment(_this.currentDate); // sets to localeData
			}
		});
	},


	// Builds a moment using the settings of the current calendar: timezone and locale.
	// Accepts anything the vanilla moment() constructor accepts.
	moment: function() {
		var mom;

		if (this.opt('timezone') === 'local') {
			mom = FC.moment.apply(null, arguments);

			// Force the moment to be local, because FC.moment doesn't guarantee it.
			if (mom.hasTime()) { // don't give ambiguously-timed moments a local zone
				mom.local();
			}
		}
		else if (this.opt('timezone') === 'UTC') {
			mom = FC.moment.utc.apply(null, arguments); // process as UTC
		}
		else {
			mom = FC.moment.parseZone.apply(null, arguments); // let the input decide the zone
		}

		this.localizeMoment(mom); // TODO

		return mom;
	},


	// Updates the given moment's locale settings to the current calendar locale settings.
	localizeMoment: function(mom) {
		mom._locale = this.localeData;
	},


	// Returns a boolean about whether or not the calendar knows how to calculate
	// the timezone offset of arbitrary dates in the current timezone.
	getIsAmbigTimezone: function() {
		return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
	},


	// Returns a copy of the given date in the current timezone. Has no effect on dates without times.
	applyTimezone: function(date) {
		if (!date.hasTime()) {
			return date.clone();
		}

		var zonedDate = this.moment(date.toArray());
		var timeAdjust = date.time() - zonedDate.time();
		var adjustedZonedDate;

		// Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
		if (timeAdjust) { // is the time result different than expected?
			adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
			if (date.time() - adjustedZonedDate.time() === 0) { // does it match perfectly now?
				zonedDate = adjustedZonedDate;
			}
		}

		return zonedDate;
	},


	// Returns a moment for the current date, as defined by the client's computer or from the `now` option.
	// Will return an moment with an ambiguous timezone.
	getNow: function() {
		var now = this.opt('now');
		if (typeof now === 'function') {
			now = now();
		}
		return this.moment(now).stripZone();
	},


	// Produces a human-readable string for the given duration.
	// Side-effect: changes the locale of the given duration.
	humanizeDuration: function(duration) {
		return duration.locale(this.opt('locale')).humanize();
	},



	// Event-Specific Date Utilities. TODO: move
	// -----------------------------------------------------------------------------------------------------------------


	// Get an event's normalized end date. If not present, calculate it from the defaults.
	getEventEnd: function(event) {
		if (event.end) {
			return event.end.clone();
		}
		else {
			return this.getDefaultEventEnd(event.allDay, event.start);
		}
	},


	// Given an event's allDay status and start date, return what its fallback end date should be.
	// TODO: rename to computeDefaultEventEnd
	getDefaultEventEnd: function(allDay, zonedStart) {
		var end = zonedStart.clone();

		if (allDay) {
			end.stripTime().add(this.defaultAllDayEventDuration);
		}
		else {
			end.add(this.defaultTimedEventDuration);
		}

		if (this.getIsAmbigTimezone()) {
			end.stripZone(); // we don't know what the tzo should be
		}

		return end;
	}

});

;;

Calendar.mixin({

	viewSpecCache: null, // cache of view definitions (initialized in Calendar.js)


	// Gets information about how to create a view. Will use a cache.
	getViewSpec: function(viewType) {
		var cache = this.viewSpecCache;

		return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
	},


	// Given a duration singular unit, like "week" or "day", finds a matching view spec.
	// Preference is given to views that have corresponding buttons.
	getUnitViewSpec: function(unit) {
		var viewTypes;
		var i;
		var spec;

		if ($.inArray(unit, unitsDesc) != -1) {

			// put views that have buttons first. there will be duplicates, but oh well
			viewTypes = this.header.getViewsWithButtons(); // TODO: include footer as well?
			$.each(FC.views, function(viewType) { // all views
				viewTypes.push(viewType);
			});

			for (i = 0; i < viewTypes.length; i++) {
				spec = this.getViewSpec(viewTypes[i]);
				if (spec) {
					if (spec.singleUnit == unit) {
						return spec;
					}
				}
			}
		}
	},


	// Builds an object with information on how to create a given view
	buildViewSpec: function(requestedViewType) {
		var viewOverrides = this.overrides.views || {};
		var specChain = []; // for the view. lowest to highest priority
		var defaultsChain = []; // for the view. lowest to highest priority
		var overridesChain = []; // for the view. lowest to highest priority
		var viewType = requestedViewType;
		var spec; // for the view
		var overrides; // for the view
		var durationInput;
		var duration;
		var unit;

		// iterate from the specific view definition to a more general one until we hit an actual View class
		while (viewType) {
			spec = fcViews[viewType];
			overrides = viewOverrides[viewType];
			viewType = null; // clear. might repopulate for another iteration

			if (typeof spec === 'function') { // TODO: deprecate
				spec = { 'class': spec };
			}

			if (spec) {
				specChain.unshift(spec);
				defaultsChain.unshift(spec.defaults || {});
				durationInput = durationInput || spec.duration;
				viewType = viewType || spec.type;
			}

			if (overrides) {
				overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
				durationInput = durationInput || overrides.duration;
				viewType = viewType || overrides.type;
			}
		}

		spec = mergeProps(specChain);
		spec.type = requestedViewType;
		if (!spec['class']) {
			return false;
		}

		// fall back to top-level `duration` option
		durationInput = durationInput ||
			this.dynamicOverrides.duration ||
			this.overrides.duration;

		if (durationInput) {
			duration = moment.duration(durationInput);

			if (duration.valueOf()) { // valid?

				unit = computeDurationGreatestUnit(duration, durationInput);

				spec.duration = duration;
				spec.durationUnit = unit;

				// view is a single-unit duration, like "week" or "day"
				// incorporate options for this. lowest priority
				if (duration.as(unit) === 1) {
					spec.singleUnit = unit;
					overridesChain.unshift(viewOverrides[unit] || {});
				}
			}
		}

		spec.defaults = mergeOptions(defaultsChain);
		spec.overrides = mergeOptions(overridesChain);

		this.buildViewSpecOptions(spec);
		this.buildViewSpecButtonText(spec, requestedViewType);

		return spec;
	},


	// Builds and assigns a view spec's options object from its already-assigned defaults and overrides
	buildViewSpecOptions: function(spec) {
		spec.options = mergeOptions([ // lowest to highest priority
			Calendar.defaults, // global defaults
			spec.defaults, // view's defaults (from ViewSubclass.defaults)
			this.dirDefaults,
			this.localeDefaults, // locale and dir take precedence over view's defaults!
			this.overrides, // calendar's overrides (options given to constructor)
			spec.overrides, // view's overrides (view-specific options)
			this.dynamicOverrides // dynamically set via setter. highest precedence
		]);
		populateInstanceComputableOptions(spec.options);
	},


	// Computes and assigns a view spec's buttonText-related options
	buildViewSpecButtonText: function(spec, requestedViewType) {

		// given an options object with a possible `buttonText` hash, lookup the buttonText for the
		// requested view, falling back to a generic unit entry like "week" or "day"
		function queryButtonText(options) {
			var buttonText = options.buttonText || {};
			return buttonText[requestedViewType] ||
				// view can decide to look up a certain key
				(spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
				// a key like "month"
				(spec.singleUnit ? buttonText[spec.singleUnit] : null);
		}

		// highest to lowest priority
		spec.buttonTextOverride =
			queryButtonText(this.dynamicOverrides) ||
			queryButtonText(this.overrides) || // constructor-specified buttonText lookup hash takes precedence
			spec.overrides.buttonText; // `buttonText` for view-specific options is a string

		// highest to lowest priority. mirrors buildViewSpecOptions
		spec.buttonTextDefault =
			queryButtonText(this.localeDefaults) ||
			queryButtonText(this.dirDefaults) ||
			spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
			queryButtonText(Calendar.defaults) ||
			(spec.duration ? this.humanizeDuration(spec.duration) : null) || // like "3 days"
			requestedViewType; // fall back to given view name
	}

});

;;

Calendar.mixin({

	el: null,
	contentEl: null,
	suggestedViewHeight: null,
	windowResizeProxy: null,
	ignoreWindowResize: 0,


	render: function() {
		if (!this.contentEl) {
			this.initialRender();
		}
		else if (this.elementVisible()) {
			// mainly for the public API
			this.calcSize();
			this.renderView();
		}
	},


	initialRender: function() {
		var _this = this;
		var el = this.el;

		el.addClass('fc');

		// event delegation for nav links
		el.on('click.fc', 'a[data-goto]', function(ev) {
			var anchorEl = $(this);
			var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
			var date = _this.moment(gotoOptions.date);
			var viewType = gotoOptions.type;

			// property like "navLinkDayClick". might be a string or a function
			var customAction = _this.view.opt('navLink' + capitaliseFirstLetter(viewType) + 'Click');

			if (typeof customAction === 'function') {
				customAction(date, ev);
			}
			else {
				if (typeof customAction === 'string') {
					viewType = customAction;
				}
				_this.zoomTo(date, viewType);
			}
		});

		// called immediately, and upon option change
		this.optionsModel.watch('applyingThemeClasses', [ '?theme' ], function(opts) {
			el.toggleClass('ui-widget', opts.theme);
			el.toggleClass('fc-unthemed', !opts.theme);
		});

		// called immediately, and upon option change.
		// HACK: locale often affects isRTL, so we explicitly listen to that too.
		this.optionsModel.watch('applyingDirClasses', [ '?isRTL', '?locale' ], function(opts) {
			el.toggleClass('fc-ltr', !opts.isRTL);
			el.toggleClass('fc-rtl', opts.isRTL);
		});

		this.contentEl = $("<div class='fc-view-container'/>").prependTo(el);

		this.initToolbars();
		this.renderHeader();
		this.renderFooter();
		this.renderView(this.opt('defaultView'));

		if (this.opt('handleWindowResize')) {
			$(window).resize(
				this.windowResizeProxy = debounce( // prevents rapid calls
					this.windowResize.bind(this),
					this.opt('windowResizeDelay')
				)
			);
		}
	},


	destroy: function() {

		if (this.view) {
			this.view.removeElement();

			// NOTE: don't null-out this.view in case API methods are called after destroy.
			// It is still the "current" view, just not rendered.
		}

		this.toolbarsManager.proxyCall('removeElement');
		this.contentEl.remove();
		this.el.removeClass('fc fc-ltr fc-rtl fc-unthemed ui-widget');

		this.el.off('.fc'); // unbind nav link handlers

		if (this.windowResizeProxy) {
			$(window).unbind('resize', this.windowResizeProxy);
			this.windowResizeProxy = null;
		}

		GlobalEmitter.unneeded();
	},


	elementVisible: function() {
		return this.el.is(':visible');
	},



	// View Rendering
	// -----------------------------------------------------------------------------------


	// Renders a view because of a date change, view-type change, or for the first time.
	// If not given a viewType, keep the current view but render different dates.
	// Accepts an optional scroll state to restore to.
	renderView: function(viewType, forcedScroll) {

		this.ignoreWindowResize++;

		var needsClearView = this.view && viewType && this.view.type !== viewType;

		// if viewType is changing, remove the old view's rendering
		if (needsClearView) {
			this.freezeContentHeight(); // prevent a scroll jump when view element is removed
			this.clearView();
		}

		// if viewType changed, or the view was never created, create a fresh view
		if (!this.view && viewType) {
			this.view =
				this.viewsByType[viewType] ||
				(this.viewsByType[viewType] = this.instantiateView(viewType));

			this.view.setElement(
				$("<div class='fc-view fc-" + viewType + "-view' />").appendTo(this.contentEl)
			);
			this.toolbarsManager.proxyCall('activateButton', viewType);
		}

		if (this.view) {

			if (forcedScroll) {
				this.view.addForcedScroll(forcedScroll);
			}

			if (this.elementVisible()) {
				this.currentDate = this.view.setDate(this.currentDate);
			}
		}

		if (needsClearView) {
			this.thawContentHeight();
		}

		this.ignoreWindowResize--;
	},


	// Unrenders the current view and reflects this change in the Header.
	// Unregsiters the `view`, but does not remove from viewByType hash.
	clearView: function() {
		this.toolbarsManager.proxyCall('deactivateButton', this.view.type);
		this.view.removeElement();
		this.view = null;
	},


	// Destroys the view, including the view object. Then, re-instantiates it and renders it.
	// Maintains the same scroll state.
	// TODO: maintain any other user-manipulated state.
	reinitView: function() {
		this.ignoreWindowResize++;
		this.freezeContentHeight();

		var viewType = this.view.type;
		var scrollState = this.view.queryScroll();
		this.clearView();
		this.calcSize();
		this.renderView(viewType, scrollState);

		this.thawContentHeight();
		this.ignoreWindowResize--;
	},


	// Resizing
	// -----------------------------------------------------------------------------------


	getSuggestedViewHeight: function() {
		if (this.suggestedViewHeight === null) {
			this.calcSize();
		}
		return this.suggestedViewHeight;
	},


	isHeightAuto: function() {
		return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
	},


	updateSize: function(shouldRecalc) {
		if (this.elementVisible()) {

			if (shouldRecalc) {
				this._calcSize();
			}

			this.ignoreWindowResize++;
			this.view.updateSize(true); // isResize=true. will poll getSuggestedViewHeight() and isHeightAuto()
			this.ignoreWindowResize--;

			return true; // signal success
		}
	},


	calcSize: function() {
		if (this.elementVisible()) {
			this._calcSize();
		}
	},


	_calcSize: function() { // assumes elementVisible
		var contentHeightInput = this.opt('contentHeight');
		var heightInput = this.opt('height');

		if (typeof contentHeightInput === 'number') { // exists and not 'auto'
			this.suggestedViewHeight = contentHeightInput;
		}
		else if (typeof contentHeightInput === 'function') { // exists and is a function
			this.suggestedViewHeight = contentHeightInput();
		}
		else if (typeof heightInput === 'number') { // exists and not 'auto'
			this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
		}
		else if (typeof heightInput === 'function') { // exists and is a function
			this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
		}
		else if (heightInput === 'parent') { // set to height of parent element
			this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
		}
		else {
			this.suggestedViewHeight = Math.round(
				this.contentEl.width() /
				Math.max(this.opt('aspectRatio'), .5)
			);
		}
	},


	windowResize: function(ev) {
		if (
			!this.ignoreWindowResize &&
			ev.target === window && // so we don't process jqui "resize" events that have bubbled up
			this.view.renderRange // view has already been rendered
		) {
			if (this.updateSize(true)) {
				this.view.publiclyTrigger('windowResize', this.el[0]);
			}
		}
	},


	/* Height "Freezing"
	-----------------------------------------------------------------------------*/


	freezeContentHeight: function() {
		this.contentEl.css({
			width: '100%',
			height: this.contentEl.height(),
			overflow: 'hidden'
		});
	},


	thawContentHeight: function() {
		this.contentEl.css({
			width: '',
			height: '',
			overflow: ''
		});
	}

});

;;

Calendar.mixin({

	header: null,
	footer: null,
	toolbarsManager: null,


	initToolbars: function() {
		this.header = new Toolbar(this, this.computeHeaderOptions());
		this.footer = new Toolbar(this, this.computeFooterOptions());
		this.toolbarsManager = new Iterator([ this.header, this.footer ]);
	},


	computeHeaderOptions: function() {
		return {
			extraClasses: 'fc-header-toolbar',
			layout: this.opt('header')
		};
	},


	computeFooterOptions: function() {
		return {
			extraClasses: 'fc-footer-toolbar',
			layout: this.opt('footer')
		};
	},


	// can be called repeatedly and Header will rerender
	renderHeader: function() {
		var header = this.header;

		header.setToolbarOptions(this.computeHeaderOptions());
		header.render();

		if (header.el) {
			this.el.prepend(header.el);
		}
	},


	// can be called repeatedly and Footer will rerender
	renderFooter: function() {
		var footer = this.footer;

		footer.setToolbarOptions(this.computeFooterOptions());
		footer.render();

		if (footer.el) {
			this.el.append(footer.el);
		}
	},


	setToolbarsTitle: function(title) {
		this.toolbarsManager.proxyCall('updateTitle', title);
	},


	updateToolbarButtons: function() {
		var now = this.getNow();
		var view = this.view;
		var todayInfo = view.buildDateProfile(now);
		var prevInfo = view.buildPrevDateProfile(this.currentDate);
		var nextInfo = view.buildNextDateProfile(this.currentDate);

		this.toolbarsManager.proxyCall(
			(todayInfo.isValid && !isDateWithinRange(now, view.currentRange)) ?
				'enableButton' :
				'disableButton',
			'today'
		);

		this.toolbarsManager.proxyCall(
			prevInfo.isValid ?
				'enableButton' :
				'disableButton',
			'prev'
		);

		this.toolbarsManager.proxyCall(
			nextInfo.isValid ?
				'enableButton' :
				'disableButton',
			'next'
		);
	},


	queryToolbarsHeight: function() {
		return this.toolbarsManager.items.reduce(function(accumulator, toolbar) {
			var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
			return accumulator + toolbarHeight;
		}, 0);
	}

});

;;

Calendar.defaults = {

	titleRangeSeparator: ' \u2013 ', // en dash
	monthYearFormat: 'MMMM YYYY', // required for en. other locales rely on datepicker computable option

	defaultTimedEventDuration: '02:00:00',
	defaultAllDayEventDuration: { days: 1 },
	forceEventDuration: false,
	nextDayThreshold: '09:00:00', // 9am

	// display
	defaultView: 'month',
	aspectRatio: 1.35,
	header: {
		left: 'title',
		center: '',
		right: 'today prev,next'
	},
	weekends: true,
	weekNumbers: false,

	weekNumberTitle: 'W',
	weekNumberCalculation: 'local',
	
	//editable: false,

	//nowIndicator: false,

	scrollTime: '06:00:00',
	minTime: '00:00:00',
	maxTime: '24:00:00',
	showNonCurrentDates: true,
	
	// event ajax
	lazyFetching: true,
	startParam: 'start',
	endParam: 'end',
	timezoneParam: 'timezone',

	timezone: false,

	//allDayDefault: undefined,

	// locale
	isRTL: false,
	buttonText: {
		prev: "prev",
		next: "next",
		prevYear: "prev year",
		nextYear: "next year",
		year: 'year', // TODO: locale files need to specify this
		today: 'today',
		month: 'month',
		week: 'week',
		day: 'day'
	},

	buttonIcons: {
		prev: 'left-single-arrow',
		next: 'right-single-arrow',
		prevYear: 'left-double-arrow',
		nextYear: 'right-double-arrow'
	},

	allDayText: 'all-day',
	
	// jquery-ui theming
	theme: false,
	themeButtonIcons: {
		prev: 'circle-triangle-w',
		next: 'circle-triangle-e',
		prevYear: 'seek-prev',
		nextYear: 'seek-next'
	},

	//eventResizableFromStart: false,
	dragOpacity: .75,
	dragRevertDuration: 500,
	dragScroll: true,
	
	//selectable: false,
	unselectAuto: true,
	//selectMinDistance: 0,
	
	dropAccept: '*',

	eventOrder: 'title',
	//eventRenderWait: null,

	eventLimit: false,
	eventLimitText: 'more',
	eventLimitClick: 'popover',
	dayPopoverFormat: 'LL',
	
	handleWindowResize: true,
	windowResizeDelay: 100, // milliseconds before an updateSize happens

	longPressDelay: 1000
	
};


Calendar.englishDefaults = { // used by locale.js
	dayPopoverFormat: 'dddd, MMMM D'
};


Calendar.rtlDefaults = { // right-to-left defaults
	header: { // TODO: smarter solution (first/center/last ?)
		left: 'next,prev today',
		center: '',
		right: 'title'
	},
	buttonIcons: {
		prev: 'right-single-arrow',
		next: 'left-single-arrow',
		prevYear: 'right-double-arrow',
		nextYear: 'left-double-arrow'
	},
	themeButtonIcons: {
		prev: 'circle-triangle-e',
		next: 'circle-triangle-w',
		nextYear: 'seek-prev',
		prevYear: 'seek-next'
	}
};

;;

var localeOptionHash = FC.locales = {}; // initialize and expose


// TODO: document the structure and ordering of a FullCalendar locale file


// Initialize jQuery UI datepicker translations while using some of the translations
// Will set this as the default locales for datepicker.
FC.datepickerLocale = function(localeCode, dpLocaleCode, dpOptions) {

	// get the FullCalendar internal option hash for this locale. create if necessary
	var fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {});

	// transfer some simple options from datepicker to fc
	fcOptions.isRTL = dpOptions.isRTL;
	fcOptions.weekNumberTitle = dpOptions.weekHeader;

	// compute some more complex options from datepicker
	$.each(dpComputableOptions, function(name, func) {
		fcOptions[name] = func(dpOptions);
	});

	// is jQuery UI Datepicker is on the page?
	if ($.datepicker) {

		// Register the locale data.
		// FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
		// does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
		// Make an alias so the locale can be referenced either way.
		$.datepicker.regional[dpLocaleCode] =
			$.datepicker.regional[localeCode] = // alias
				dpOptions;

		// Alias 'en' to the default locale data. Do this every time.
		$.datepicker.regional.en = $.datepicker.regional[''];

		// Set as Datepicker's global defaults.
		$.datepicker.setDefaults(dpOptions);
	}
};


// Sets FullCalendar-specific translations. Will set the locales as the global default.
FC.locale = function(localeCode, newFcOptions) {
	var fcOptions;
	var momOptions;

	// get the FullCalendar internal option hash for this locale. create if necessary
	fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {});

	// provided new options for this locales? merge them in
	if (newFcOptions) {
		fcOptions = localeOptionHash[localeCode] = mergeOptions([ fcOptions, newFcOptions ]);
	}

	// compute locale options that weren't defined.
	// always do this. newFcOptions can be undefined when initializing from i18n file,
	// so no way to tell if this is an initialization or a default-setting.
	momOptions = getMomentLocaleData(localeCode); // will fall back to en
	$.each(momComputableOptions, function(name, func) {
		if (fcOptions[name] == null) {
			fcOptions[name] = func(momOptions, fcOptions);
		}
	});

	// set it as the default locale for FullCalendar
	Calendar.defaults.locale = localeCode;
};


// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
// configs, so make sure there are English fallbacks for these in the defaults file.
var dpComputableOptions = {

	buttonText: function(dpOptions) {
		return {
			// the translations sometimes wrongly contain HTML entities
			prev: stripHtmlEntities(dpOptions.prevText),
			next: stripHtmlEntities(dpOptions.nextText),
			today: stripHtmlEntities(dpOptions.currentText)
		};
	},

	// Produces format strings like "MMMM YYYY" -> "September 2014"
	monthYearFormat: function(dpOptions) {
		return dpOptions.showMonthAfterYear ?
			'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
			'MMMM YYYY[' + dpOptions.yearSuffix + ']';
	}

};

var momComputableOptions = {

	// Produces format strings like "ddd M/D" -> "Fri 9/15"
	dayOfMonthFormat: function(momOptions, fcOptions) {
		var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"

		// strip the year off the edge, as well as other misc non-whitespace chars
		format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');

		if (fcOptions.isRTL) {
			format += ' ddd'; // for RTL, add day-of-week to end
		}
		else {
			format = 'ddd ' + format; // for LTR, add day-of-week to beginning
		}
		return format;
	},

	// Produces format strings like "h:mma" -> "6:00pm"
	mediumTimeFormat: function(momOptions) { // can't be called `timeFormat` because collides with option
		return momOptions.longDateFormat('LT')
			.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	},

	// Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
	smallTimeFormat: function(momOptions) {
		return momOptions.longDateFormat('LT')
			.replace(':mm', '(:mm)')
			.replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
			.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	},

	// Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
	extraSmallTimeFormat: function(momOptions) {
		return momOptions.longDateFormat('LT')
			.replace(':mm', '(:mm)')
			.replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
			.replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
	},

	// Produces format strings like "ha" / "H" -> "6pm" / "18"
	hourFormat: function(momOptions) {
		return momOptions.longDateFormat('LT')
			.replace(':mm', '')
			.replace(/(\Wmm)$/, '') // like above, but for foreign locales
			.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	},

	// Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
	noMeridiemTimeFormat: function(momOptions) {
		return momOptions.longDateFormat('LT')
			.replace(/\s*a$/i, ''); // remove trailing AM/PM
	}

};


// options that should be computed off live calendar options (considers override options)
// TODO: best place for this? related to locale?
// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
var instanceComputableOptions = {

	// Produces format strings for results like "Mo 16"
	smallDayDateFormat: function(options) {
		return options.isRTL ?
			'D dd' :
			'dd D';
	},

	// Produces format strings for results like "Wk 5"
	weekFormat: function(options) {
		return options.isRTL ?
			'w[ ' + options.weekNumberTitle + ']' :
			'[' + options.weekNumberTitle + ' ]w';
	},

	// Produces format strings for results like "Wk5"
	smallWeekFormat: function(options) {
		return options.isRTL ?
			'w[' + options.weekNumberTitle + ']' :
			'[' + options.weekNumberTitle + ']w';
	}

};

// TODO: make these computable properties in optionsModel
function populateInstanceComputableOptions(options) {
	$.each(instanceComputableOptions, function(name, func) {
		if (options[name] == null) {
			options[name] = func(options);
		}
	});
}


// Returns moment's internal locale data. If doesn't exist, returns English.
function getMomentLocaleData(localeCode) {
	return moment.localeData(localeCode) || moment.localeData('en');
}


// Initialize English by forcing computation of moment-derived options.
// Also, sets it as the default.
FC.locale('en', Calendar.englishDefaults);

;;

FC.sourceNormalizers = [];
FC.sourceFetchers = [];

var ajaxDefaults = {
	dataType: 'json',
	cache: false
};

var eventGUID = 1;


function EventManager() { // assumed to be a calendar
	var t = this;


	// exports
	t.requestEvents = requestEvents;
	t.reportEventChange = reportEventChange;
	t.isFetchNeeded = isFetchNeeded;
	t.fetchEvents = fetchEvents;
	t.fetchEventSources = fetchEventSources;
	t.refetchEvents = refetchEvents;
	t.refetchEventSources = refetchEventSources;
	t.getEventSources = getEventSources;
	t.getEventSourceById = getEventSourceById;
	t.addEventSource = addEventSource;
	t.removeEventSource = removeEventSource;
	t.removeEventSources = removeEventSources;
	t.updateEvent = updateEvent;
	t.updateEvents = updateEvents;
	t.renderEvent = renderEvent;
	t.renderEvents = renderEvents;
	t.removeEvents = removeEvents;
	t.clientEvents = clientEvents;
	t.mutateEvent = mutateEvent;
	t.normalizeEventDates = normalizeEventDates;
	t.normalizeEventTimes = normalizeEventTimes;


	// locals
	var stickySource = { events: [] };
	var sources = [ stickySource ];
	var rangeStart, rangeEnd;
	var pendingSourceCnt = 0; // outstanding fetch requests, max one per source
	var cache = []; // holds events that have already been expanded
	var prunedCache; // like cache, but only events that intersect with rangeStart/rangeEnd


	$.each(
		(t.opt('events') ? [ t.opt('events') ] : []).concat(t.opt('eventSources') || []),
		function(i, sourceInput) {
			var source = buildEventSource(sourceInput);
			if (source) {
				sources.push(source);
			}
		}
	);



	function requestEvents(start, end) {
		if (!t.opt('lazyFetching') || isFetchNeeded(start, end)) {
			return fetchEvents(start, end);
		}
		else {
			return Promise.resolve(prunedCache);
		}
	}


	function reportEventChange() {
		prunedCache = filterEventsWithinRange(cache);
		t.trigger('eventsReset', prunedCache);
	}


	function filterEventsWithinRange(events) {
		var filteredEvents = [];
		var i, event;

		for (i = 0; i < events.length; i++) {
			event = events[i];

			if (
				event.start.clone().stripZone() < rangeEnd &&
				t.getEventEnd(event).stripZone() > rangeStart
			) {
				filteredEvents.push(event);
			}
		}

		return filteredEvents;
	}


	t.getEventCache = function() {
		return cache;
	};



	/* Fetching
	-----------------------------------------------------------------------------*/


	// start and end are assumed to be unzoned
	function isFetchNeeded(start, end) {
		return !rangeStart || // nothing has been fetched yet?
			start < rangeStart || end > rangeEnd; // is part of the new range outside of the old range?
	}


	function fetchEvents(start, end) {
		rangeStart = start;
		rangeEnd = end;
		return refetchEvents();
	}


	// poorly named. fetches all sources with current `rangeStart` and `rangeEnd`.
	function refetchEvents() {
		return fetchEventSources(sources, 'reset');
	}


	// poorly named. fetches a subset of event sources.
	function refetchEventSources(matchInputs) {
		return fetchEventSources(getEventSourcesByMatchArray(matchInputs));
	}


	// expects an array of event source objects (the originals, not copies)
	// `specialFetchType` is an optimization parameter that affects purging of the event cache.
	function fetchEventSources(specificSources, specialFetchType) {
		var i, source;

		if (specialFetchType === 'reset') {
			cache = [];
		}
		else if (specialFetchType !== 'add') {
			cache = excludeEventsBySources(cache, specificSources);
		}

		for (i = 0; i < specificSources.length; i++) {
			source = specificSources[i];

			// already-pending sources have already been accounted for in pendingSourceCnt
			if (source._status !== 'pending') {
				pendingSourceCnt++;
			}

			source._fetchId = (source._fetchId || 0) + 1;
			source._status = 'pending';
		}

		for (i = 0; i < specificSources.length; i++) {
			source = specificSources[i];
			tryFetchEventSource(source, source._fetchId);
		}

		if (pendingSourceCnt) {
			return Promise.construct(function(resolve) {
				t.one('eventsReceived', resolve); // will send prunedCache
			});
		}
		else { // executed all synchronously, or no sources at all
			return Promise.resolve(prunedCache);
		}
	}


	// fetches an event source and processes its result ONLY if it is still the current fetch.
	// caller is responsible for incrementing pendingSourceCnt first.
	function tryFetchEventSource(source, fetchId) {
		_fetchEventSource(source, function(eventInputs) {
			var isArraySource = $.isArray(source.events);
			var i, eventInput;
			var abstractEvent;

			if (
				// is this the source's most recent fetch?
				// if not, rely on an upcoming fetch of this source to decrement pendingSourceCnt
				fetchId === source._fetchId &&
				// event source no longer valid?
				source._status !== 'rejected'
			) {
				source._status = 'resolved';

				if (eventInputs) {
					for (i = 0; i < eventInputs.length; i++) {
						eventInput = eventInputs[i];

						if (isArraySource) { // array sources have already been convert to Event Objects
							abstractEvent = eventInput;
						}
						else {
							abstractEvent = buildEventFromInput(eventInput, source);
						}

						if (abstractEvent) { // not false (an invalid event)
							cache.push.apply( // append
								cache,
								expandEvent(abstractEvent) // add individual expanded events to the cache
							);
						}
					}
				}

				decrementPendingSourceCnt();
			}
		});
	}


	function rejectEventSource(source) {
		var wasPending = source._status === 'pending';

		source._status = 'rejected';

		if (wasPending) {
			decrementPendingSourceCnt();
		}
	}


	function decrementPendingSourceCnt() {
		pendingSourceCnt--;
		if (!pendingSourceCnt) {
			reportEventChange(cache); // updates prunedCache
			t.trigger('eventsReceived', prunedCache);
		}
	}


	function _fetchEventSource(source, callback) {
		var i;
		var fetchers = FC.sourceFetchers;
		var res;

		for (i=0; i<fetchers.length; i++) {
			res = fetchers[i].call(
				t, // this, the Calendar object
				source,
				rangeStart.clone(),
				rangeEnd.clone(),
				t.opt('timezone'),
				callback
			);

			if (res === true) {
				// the fetcher is in charge. made its own async request
				return;
			}
			else if (typeof res == 'object') {
				// the fetcher returned a new source. process it
				_fetchEventSource(res, callback);
				return;
			}
		}

		var events = source.events;
		if (events) {
			if ($.isFunction(events)) {
				t.pushLoading();
				events.call(
					t, // this, the Calendar object
					rangeStart.clone(),
					rangeEnd.clone(),
					t.opt('timezone'),
					function(events) {
						callback(events);
						t.popLoading();
					}
				);
			}
			else if ($.isArray(events)) {
				callback(events);
			}
			else {
				callback();
			}
		}else{
			var url = source.url;
			if (url) {
				var success = source.success;
				var error = source.error;
				var complete = source.complete;

				// retrieve any outbound GET/POST $.ajax data from the options
				var customData;
				if ($.isFunction(source.data)) {
					// supplied as a function that returns a key/value object
					customData = source.data();
				}
				else {
					// supplied as a straight key/value object
					customData = source.data;
				}

				// use a copy of the custom data so we can modify the parameters
				// and not affect the passed-in object.
				var data = $.extend({}, customData || {});

				var startParam = firstDefined(source.startParam, t.opt('startParam'));
				var endParam = firstDefined(source.endParam, t.opt('endParam'));
				var timezoneParam = firstDefined(source.timezoneParam, t.opt('timezoneParam'));

				if (startParam) {
					data[startParam] = rangeStart.format();
				}
				if (endParam) {
					data[endParam] = rangeEnd.format();
				}
				if (t.opt('timezone') && t.opt('timezone') != 'local') {
					data[timezoneParam] = t.opt('timezone');
				}

				t.pushLoading();
				$.ajax($.extend({}, ajaxDefaults, source, {
					data: data,
					success: function(events) {
						events = events || [];
						var res = applyAll(success, this, arguments);
						if ($.isArray(res)) {
							events = res;
						}
						callback(events);
					},
					error: function() {
						applyAll(error, this, arguments);
						callback();
					},
					complete: function() {
						applyAll(complete, this, arguments);
						t.popLoading();
					}
				}));
			}else{
				callback();
			}
		}
	}



	/* Sources
	-----------------------------------------------------------------------------*/


	function addEventSource(sourceInput) {
		var source = buildEventSource(sourceInput);
		if (source) {
			sources.push(source);
			fetchEventSources([ source ], 'add'); // will eventually call reportEventChange
		}
	}


	function buildEventSource(sourceInput) { // will return undefined if invalid source
		var normalizers = FC.sourceNormalizers;
		var source;
		var i;

		if ($.isFunction(sourceInput) || $.isArray(sourceInput)) {
			source = { events: sourceInput };
		}
		else if (typeof sourceInput === 'string') {
			source = { url: sourceInput };
		}
		else if (typeof sourceInput === 'object') {
			source = $.extend({}, sourceInput); // shallow copy
		}

		if (source) {

			// TODO: repeat code, same code for event classNames
			if (source.className) {
				if (typeof source.className === 'string') {
					source.className = source.className.split(/\s+/);
				}
				// otherwise, assumed to be an array
			}
			else {
				source.className = [];
			}

			// for array sources, we convert to standard Event Objects up front
			if ($.isArray(source.events)) {
				source.origArray = source.events; // for removeEventSource
				source.events = $.map(source.events, function(eventInput) {
					return buildEventFromInput(eventInput, source);
				});
			}

			for (i=0; i<normalizers.length; i++) {
				normalizers[i].call(t, source);
			}

			return source;
		}
	}


	function removeEventSource(matchInput) {
		removeSpecificEventSources(
			getEventSourcesByMatch(matchInput)
		);
	}


	// if called with no arguments, removes all.
	function removeEventSources(matchInputs) {
		if (matchInputs == null) {
			removeSpecificEventSources(sources, true); // isAll=true
		}
		else {
			removeSpecificEventSources(
				getEventSourcesByMatchArray(matchInputs)
			);
		}
	}


	function removeSpecificEventSources(targetSources, isAll) {
		var i;

		// cancel pending requests
		for (i = 0; i < targetSources.length; i++) {
			rejectEventSource(targetSources[i]);
		}

		if (isAll) { // an optimization
			sources = [];
			cache = [];
		}
		else {
			// remove from persisted source list
			sources = $.grep(sources, function(source) {
				for (i = 0; i < targetSources.length; i++) {
					if (source === targetSources[i]) {
						return false; // exclude
					}
				}
				return true; // include
			});

			cache = excludeEventsBySources(cache, targetSources);
		}

		reportEventChange();
	}


	function getEventSources() {
		return sources.slice(1); // returns a shallow copy of sources with stickySource removed
	}


	function getEventSourceById(id) {
		return $.grep(sources, function(source) {
			return source.id && source.id === id;
		})[0];
	}


	// like getEventSourcesByMatch, but accepts multple match criteria (like multiple IDs)
	function getEventSourcesByMatchArray(matchInputs) {

		// coerce into an array
		if (!matchInputs) {
			matchInputs = [];
		}
		else if (!$.isArray(matchInputs)) {
			matchInputs = [ matchInputs ];
		}

		var matchingSources = [];
		var i;

		// resolve raw inputs to real event source objects
		for (i = 0; i < matchInputs.length; i++) {
			matchingSources.push.apply( // append
				matchingSources,
				getEventSourcesByMatch(matchInputs[i])
			);
		}

		return matchingSources;
	}


	// matchInput can either by a real event source object, an ID, or the function/URL for the source.
	// returns an array of matching source objects.
	function getEventSourcesByMatch(matchInput) {
		var i, source;

		// given an proper event source object
		for (i = 0; i < sources.length; i++) {
			source = sources[i];
			if (source === matchInput) {
				return [ source ];
			}
		}

		// an ID match
		source = getEventSourceById(matchInput);
		if (source) {
			return [ source ];
		}

		return $.grep(sources, function(source) {
			return isSourcesEquivalent(matchInput, source);
		});
	}


	function isSourcesEquivalent(source1, source2) {
		return source1 && source2 && getSourcePrimitive(source1) == getSourcePrimitive(source2);
	}


	function getSourcePrimitive(source) {
		return (
			(typeof source === 'object') ? // a normalized event source?
				(source.origArray || source.googleCalendarId || source.url || source.events) : // get the primitive
				null
		) ||
		source; // the given argument *is* the primitive
	}


	// util
	// returns a filtered array without events that are part of any of the given sources
	function excludeEventsBySources(specificEvents, specificSources) {
		return $.grep(specificEvents, function(event) {
			for (var i = 0; i < specificSources.length; i++) {
				if (event.source === specificSources[i]) {
					return false; // exclude
				}
			}
			return true; // keep
		});
	}



	/* Manipulation
	-----------------------------------------------------------------------------*/


	// Only ever called from the externally-facing API
	function updateEvent(event) {
		updateEvents([ event ]);
	}


	// Only ever called from the externally-facing API
	function updateEvents(events) {
		var i, event;

		for (i = 0; i < events.length; i++) {
			event = events[i];

			// massage start/end values, even if date string values
			event.start = t.moment(event.start);
			if (event.end) {
				event.end = t.moment(event.end);
			}
			else {
				event.end = null;
			}

			mutateEvent(event, getMiscEventProps(event)); // will handle start/end/allDay normalization
		}

		reportEventChange(); // reports event modifications (so we can redraw)
	}


	// Returns a hash of misc event properties that should be copied over to related events.
	function getMiscEventProps(event) {
		var props = {};

		$.each(event, function(name, val) {
			if (isMiscEventPropName(name)) {
				if (val !== undefined && isAtomic(val)) { // a defined non-object
					props[name] = val;
				}
			}
		});

		return props;
	}

	// non-date-related, non-id-related, non-secret
	function isMiscEventPropName(name) {
		return !/^_|^(id|allDay|start|end)$/.test(name);
	}


	// returns the expanded events that were created
	function renderEvent(eventInput, stick) {
		return renderEvents([ eventInput ], stick);
	}


	// returns the expanded events that were created
	function renderEvents(eventInputs, stick) {
		var renderedEvents = [];
		var renderableEvents;
		var abstractEvent;
		var i, j, event;

		for (i = 0; i < eventInputs.length; i++) {
			abstractEvent = buildEventFromInput(eventInputs[i]);

			if (abstractEvent) { // not false (a valid input)
				renderableEvents = expandEvent(abstractEvent);

				for (j = 0; j < renderableEvents.length; j++) {
					event = renderableEvents[j];

					if (!event.source) {
						if (stick) {
							stickySource.events.push(event);
							event.source = stickySource;
						}
						cache.push(event);
					}
				}

				renderedEvents = renderedEvents.concat(renderableEvents);
			}
		}

		if (renderedEvents.length) { // any new events rendered?
			reportEventChange();
		}

		return renderedEvents;
	}


	function removeEvents(filter) {
		var eventID;
		var i;

		if (filter == null) { // null or undefined. remove all events
			filter = function() { return true; }; // will always match
		}
		else if (!$.isFunction(filter)) { // an event ID
			eventID = filter + '';
			filter = function(event) {
				return event._id == eventID;
			};
		}

		// Purge event(s) from our local cache
		cache = $.grep(cache, filter, true); // inverse=true

		// Remove events from array sources.
		// This works because they have been converted to official Event Objects up front.
		// (and as a result, event._id has been calculated).
		for (i=0; i<sources.length; i++) {
			if ($.isArray(sources[i].events)) {
				sources[i].events = $.grep(sources[i].events, filter, true);
			}
		}

		reportEventChange();
	}


	function clientEvents(filter) {
		if ($.isFunction(filter)) {
			return $.grep(cache, filter);
		}
		else if (filter != null) { // not null, not undefined. an event ID
			filter += '';
			return $.grep(cache, function(e) {
				return e._id == filter;
			});
		}
		return cache; // else, return all
	}


	// Makes sure all array event sources have their internal event objects
	// converted over to the Calendar's current timezone.
	t.rezoneArrayEventSources = function() {
		var i;
		var events;
		var j;

		for (i = 0; i < sources.length; i++) {
			events = sources[i].events;
			if ($.isArray(events)) {

				for (j = 0; j < events.length; j++) {
					rezoneEventDates(events[j]);
				}
			}
		}
	};

	function rezoneEventDates(event) {
		event.start = t.moment(event.start);
		if (event.end) {
			event.end = t.moment(event.end);
		}
		backupEventDates(event);
	}


	/* Event Normalization
	-----------------------------------------------------------------------------*/


	// Given a raw object with key/value properties, returns an "abstract" Event object.
	// An "abstract" event is an event that, if recurring, will not have been expanded yet.
	// Will return `false` when input is invalid.
	// `source` is optional
	function buildEventFromInput(input, source) {
		var calendarEventDataTransform = t.opt('eventDataTransform');
		var out = {};
		var start, end;
		var allDay;

		if (calendarEventDataTransform) {
			input = calendarEventDataTransform(input);
		}
		if (source && source.eventDataTransform) {
			input = source.eventDataTransform(input);
		}

		// Copy all properties over to the resulting object.
		// The special-case properties will be copied over afterwards.
		$.extend(out, input);

		if (source) {
			out.source = source;
		}

		out._id = input._id || (input.id === undefined ? '_fc' + eventGUID++ : input.id + '');

		if (input.className) {
			if (typeof input.className == 'string') {
				out.className = input.className.split(/\s+/);
			}
			else { // assumed to be an array
				out.className = input.className;
			}
		}
		else {
			out.className = [];
		}

		start = input.start || input.date; // "date" is an alias for "start"
		end = input.end;

		// parse as a time (Duration) if applicable
		if (isTimeString(start)) {
			start = moment.duration(start);
		}
		if (isTimeString(end)) {
			end = moment.duration(end);
		}

		if (input.dow || moment.isDuration(start) || moment.isDuration(end)) {

			// the event is "abstract" (recurring) so don't calculate exact start/end dates just yet
			out.start = start ? moment.duration(start) : null; // will be a Duration or null
			out.end = end ? moment.duration(end) : null; // will be a Duration or null
			out._recurring = true; // our internal marker
		}
		else {

			if (start) {
				start = t.moment(start);
				if (!start.isValid()) {
					return false;
				}
			}

			if (end) {
				end = t.moment(end);
				if (!end.isValid()) {
					end = null; // let defaults take over
				}
			}

			allDay = input.allDay;
			if (allDay === undefined) { // still undefined? fallback to default
				allDay = firstDefined(
					source ? source.allDayDefault : undefined,
					t.opt('allDayDefault')
				);
				// still undefined? normalizeEventDates will calculate it
			}

			assignDatesToEvent(start, end, allDay, out);
		}

		t.normalizeEvent(out); // hook for external use. a prototype method

		return out;
	}
	t.buildEventFromInput = buildEventFromInput;


	// Normalizes and assigns the given dates to the given partially-formed event object.
	// NOTE: mutates the given start/end moments. does not make a copy.
	function assignDatesToEvent(start, end, allDay, event) {
		event.start = start;
		event.end = end;
		event.allDay = allDay;
		normalizeEventDates(event);
		backupEventDates(event);
	}


	// Ensures proper values for allDay/start/end. Accepts an Event object, or a plain object with event-ish properties.
	// NOTE: Will modify the given object.
	function normalizeEventDates(eventProps) {

		normalizeEventTimes(eventProps);

		if (eventProps.end && !eventProps.end.isAfter(eventProps.start)) {
			eventProps.end = null;
		}

		if (!eventProps.end) {
			if (t.opt('forceEventDuration')) {
				eventProps.end = t.getDefaultEventEnd(eventProps.allDay, eventProps.start);
			}
			else {
				eventProps.end = null;
			}
		}
	}


	// Ensures the allDay property exists and the timeliness of the start/end dates are consistent
	function normalizeEventTimes(eventProps) {
		if (eventProps.allDay == null) {
			eventProps.allDay = !(eventProps.start.hasTime() || (eventProps.end && eventProps.end.hasTime()));
		}

		if (eventProps.allDay) {
			eventProps.start.stripTime();
			if (eventProps.end) {
				// TODO: consider nextDayThreshold here? If so, will require a lot of testing and adjustment
				eventProps.end.stripTime();
			}
		}
		else {
			if (!eventProps.start.hasTime()) {
				eventProps.start = t.applyTimezone(eventProps.start.time(0)); // will assign a 00:00 time
			}
			if (eventProps.end && !eventProps.end.hasTime()) {
				eventProps.end = t.applyTimezone(eventProps.end.time(0)); // will assign a 00:00 time
			}
		}
	}


	// If the given event is a recurring event, break it down into an array of individual instances.
	// If not a recurring event, return an array with the single original event.
	// If given a falsy input (probably because of a failed buildEventFromInput call), returns an empty array.
	// HACK: can override the recurring window by providing custom rangeStart/rangeEnd (for businessHours).
	function expandEvent(abstractEvent, _rangeStart, _rangeEnd) {
		var events = [];
		var dowHash;
		var dow;
		var i;
		var date;
		var startTime, endTime;
		var start, end;
		var event;

		_rangeStart = _rangeStart || rangeStart;
		_rangeEnd = _rangeEnd || rangeEnd;

		if (abstractEvent) {
			if (abstractEvent._recurring) {

				// make a boolean hash as to whether the event occurs on each day-of-week
				if ((dow = abstractEvent.dow)) {
					dowHash = {};
					for (i = 0; i < dow.length; i++) {
						dowHash[dow[i]] = true;
					}
				}

				// iterate through every day in the current range
				date = _rangeStart.clone().stripTime(); // holds the date of the current day
				while (date.isBefore(_rangeEnd)) {

					if (!dowHash || dowHash[date.day()]) { // if everyday, or this particular day-of-week

						startTime = abstractEvent.start; // the stored start and end properties are times (Durations)
						endTime = abstractEvent.end; // "
						start = date.clone();
						end = null;

						if (startTime) {
							start = start.time(startTime);
						}
						if (endTime) {
							end = date.clone().time(endTime);
						}

						event = $.extend({}, abstractEvent); // make a copy of the original
						assignDatesToEvent(
							start, end,
							!startTime && !endTime, // allDay?
							event
						);
						events.push(event);
					}

					date.add(1, 'days');
				}
			}
			else {
				events.push(abstractEvent); // return the original event. will be a one-item array
			}
		}

		return events;
	}
	t.expandEvent = expandEvent;



	/* Event Modification Math
	-----------------------------------------------------------------------------------------*/


	// Modifies an event and all related events by applying the given properties.
	// Special date-diffing logic is used for manipulation of dates.
	// If `props` does not contain start/end dates, the updated values are assumed to be the event's current start/end.
	// All date comparisons are done against the event's pristine _start and _end dates.
	// Returns an object with delta information and a function to undo all operations.
	// For making computations in a granularity greater than day/time, specify largeUnit.
	// NOTE: The given `newProps` might be mutated for normalization purposes.
	function mutateEvent(event, newProps, largeUnit) {
		var miscProps = {};
		var oldProps;
		var clearEnd;
		var startDelta;
		var endDelta;
		var durationDelta;
		var undoFunc;

		// diffs the dates in the appropriate way, returning a duration
		function diffDates(date1, date0) { // date1 - date0
			if (largeUnit) {
				return diffByUnit(date1, date0, largeUnit);
			}
			else if (newProps.allDay) {
				return diffDay(date1, date0);
			}
			else {
				return diffDayTime(date1, date0);
			}
		}

		newProps = newProps || {};

		// normalize new date-related properties
		if (!newProps.start) {
			newProps.start = event.start.clone();
		}
		if (newProps.end === undefined) {
			newProps.end = event.end ? event.end.clone() : null;
		}
		if (newProps.allDay == null) { // is null or undefined?
			newProps.allDay = event.allDay;
		}
		normalizeEventDates(newProps);

		// create normalized versions of the original props to compare against
		// need a real end value, for diffing
		oldProps = {
			start: event._start.clone(),
			end: event._end ? event._end.clone() : t.getDefaultEventEnd(event._allDay, event._start),
			allDay: newProps.allDay // normalize the dates in the same regard as the new properties
		};
		normalizeEventDates(oldProps);

		// need to clear the end date if explicitly changed to null
		clearEnd = event._end !== null && newProps.end === null;

		// compute the delta for moving the start date
		startDelta = diffDates(newProps.start, oldProps.start);

		// compute the delta for moving the end date
		if (newProps.end) {
			endDelta = diffDates(newProps.end, oldProps.end);
			durationDelta = endDelta.subtract(startDelta);
		}
		else {
			durationDelta = null;
		}

		// gather all non-date-related properties
		$.each(newProps, function(name, val) {
			if (isMiscEventPropName(name)) {
				if (val !== undefined) {
					miscProps[name] = val;
				}
			}
		});

		// apply the operations to the event and all related events
		undoFunc = mutateEvents(
			clientEvents(event._id), // get events with this ID
			clearEnd,
			newProps.allDay,
			startDelta,
			durationDelta,
			miscProps
		);

		return {
			dateDelta: startDelta,
			durationDelta: durationDelta,
			undo: undoFunc
		};
	}


	// Modifies an array of events in the following ways (operations are in order):
	// - clear the event's `end`
	// - convert the event to allDay
	// - add `dateDelta` to the start and end
	// - add `durationDelta` to the event's duration
	// - assign `miscProps` to the event
	//
	// Returns a function that can be called to undo all the operations.
	//
	// TODO: don't use so many closures. possible memory issues when lots of events with same ID.
	//
	function mutateEvents(events, clearEnd, allDay, dateDelta, durationDelta, miscProps) {
		var isAmbigTimezone = t.getIsAmbigTimezone();
		var undoFunctions = [];

		// normalize zero-length deltas to be null
		if (dateDelta && !dateDelta.valueOf()) { dateDelta = null; }
		if (durationDelta && !durationDelta.valueOf()) { durationDelta = null; }

		$.each(events, function(i, event) {
			var oldProps;
			var newProps;

			// build an object holding all the old values, both date-related and misc.
			// for the undo function.
			oldProps = {
				start: event.start.clone(),
				end: event.end ? event.end.clone() : null,
				allDay: event.allDay
			};
			$.each(miscProps, function(name) {
				oldProps[name] = event[name];
			});

			// new date-related properties. work off the original date snapshot.
			// ok to use references because they will be thrown away when backupEventDates is called.
			newProps = {
				start: event._start,
				end: event._end,
				allDay: allDay // normalize the dates in the same regard as the new properties
			};
			normalizeEventDates(newProps); // massages start/end/allDay

			// strip or ensure the end date
			if (clearEnd) {
				newProps.end = null;
			}
			else if (durationDelta && !newProps.end) { // the duration translation requires an end date
				newProps.end = t.getDefaultEventEnd(newProps.allDay, newProps.start);
			}

			if (dateDelta) {
				newProps.start.add(dateDelta);
				if (newProps.end) {
					newProps.end.add(dateDelta);
				}
			}

			if (durationDelta) {
				newProps.end.add(durationDelta); // end already ensured above
			}

			// if the dates have changed, and we know it is impossible to recompute the
			// timezone offsets, strip the zone.
			if (
				isAmbigTimezone &&
				!newProps.allDay &&
				(dateDelta || durationDelta)
			) {
				newProps.start.stripZone();
				if (newProps.end) {
					newProps.end.stripZone();
				}
			}

			$.extend(event, miscProps, newProps); // copy over misc props, then date-related props
			backupEventDates(event); // regenerate internal _start/_end/_allDay

			undoFunctions.push(function() {
				$.extend(event, oldProps);
				backupEventDates(event); // regenerate internal _start/_end/_allDay
			});
		});

		return function() {
			for (var i = 0; i < undoFunctions.length; i++) {
				undoFunctions[i]();
			}
		};
	}

}


// returns an undo function
Calendar.prototype.mutateSeg = function(seg, newProps) {
	return this.mutateEvent(seg.event, newProps);
};


// hook for external libs to manipulate event properties upon creation.
// should manipulate the event in-place.
Calendar.prototype.normalizeEvent = function(event) {
};


// Does the given span (start, end, and other location information)
// fully contain the other?
Calendar.prototype.spanContainsSpan = function(outerSpan, innerSpan) {
	var eventStart = outerSpan.start.clone().stripZone();
	var eventEnd = this.getEventEnd(outerSpan).stripZone();

	return innerSpan.start >= eventStart && innerSpan.end <= eventEnd;
};


// Returns a list of events that the given event should be compared against when being considered for a move to
// the specified span. Attached to the Calendar's prototype because EventManager is a mixin for a Calendar.
Calendar.prototype.getPeerEvents = function(span, event) {
	var cache = this.getEventCache();
	var peerEvents = [];
	var i, otherEvent;

	for (i = 0; i < cache.length; i++) {
		otherEvent = cache[i];
		if (
			!event ||
			event._id !== otherEvent._id // don't compare the event to itself or other related [repeating] events
		) {
			peerEvents.push(otherEvent);
		}
	}

	return peerEvents;
};


// updates the "backup" properties, which are preserved in order to compute diffs later on.
function backupEventDates(event) {
	event._allDay = event.allDay;
	event._start = event.start.clone();
	event._end = event.end ? event.end.clone() : null;
}


/* Overlapping / Constraining
-----------------------------------------------------------------------------------------*/


// Determines if the given event can be relocated to the given span (unzoned start/end with other misc data)
Calendar.prototype.isEventSpanAllowed = function(span, event) {
	var source = event.source || {};
	var eventAllowFunc = this.opt('eventAllow');

	var constraint = firstDefined(
		event.constraint,
		source.constraint,
		this.opt('eventConstraint')
	);

	var overlap = firstDefined(
		event.overlap,
		source.overlap,
		this.opt('eventOverlap')
	);

	return this.isSpanAllowed(span, constraint, overlap, event) &&
		(!eventAllowFunc || eventAllowFunc(span, event) !== false);
};


// Determines if an external event can be relocated to the given span (unzoned start/end with other misc data)
Calendar.prototype.isExternalSpanAllowed = function(eventSpan, eventLocation, eventProps) {
	var eventInput;
	var event;

	// note: very similar logic is in View's reportExternalDrop
	if (eventProps) {
		eventInput = $.extend({}, eventProps, eventLocation);
		event = this.expandEvent(
			this.buildEventFromInput(eventInput)
		)[0];
	}

	if (event) {
		return this.isEventSpanAllowed(eventSpan, event);
	}
	else { // treat it as a selection

		return this.isSelectionSpanAllowed(eventSpan);
	}
};


// Determines the given span (unzoned start/end with other misc data) can be selected.
Calendar.prototype.isSelectionSpanAllowed = function(span) {
	var selectAllowFunc = this.opt('selectAllow');

	return this.isSpanAllowed(span, this.opt('selectConstraint'), this.opt('selectOverlap')) &&
		(!selectAllowFunc || selectAllowFunc(span) !== false);
};


// Returns true if the given span (caused by an event drop/resize or a selection) is allowed to exist
// according to the constraint/overlap settings.
// `event` is not required if checking a selection.
Calendar.prototype.isSpanAllowed = function(span, constraint, overlap, event) {
	var constraintEvents;
	var anyContainment;
	var peerEvents;
	var i, peerEvent;
	var peerOverlap;

	// the range must be fully contained by at least one of produced constraint events
	if (constraint != null) {

		// not treated as an event! intermediate data structure
		// TODO: use ranges in the future
		constraintEvents = this.constraintToEvents(constraint);
		if (constraintEvents) { // not invalid

			anyContainment = false;
			for (i = 0; i < constraintEvents.length; i++) {
				if (this.spanContainsSpan(constraintEvents[i], span)) {
					anyContainment = true;
					break;
				}
			}

			if (!anyContainment) {
				return false;
			}
		}
	}

	peerEvents = this.getPeerEvents(span, event);

	for (i = 0; i < peerEvents.length; i++)  {
		peerEvent = peerEvents[i];

		// there needs to be an actual intersection before disallowing anything
		if (this.eventIntersectsRange(peerEvent, span)) {

			// evaluate overlap for the given range and short-circuit if necessary
			if (overlap === false) {
				return false;
			}
			// if the event's overlap is a test function, pass the peer event in question as the first param
			else if (typeof overlap === 'function' && !overlap(peerEvent, event)) {
				return false;
			}

			// if we are computing if the given range is allowable for an event, consider the other event's
			// EventObject-specific or Source-specific `overlap` property
			if (event) {
				peerOverlap = firstDefined(
					peerEvent.overlap,
					(peerEvent.source || {}).overlap
					// we already considered the global `eventOverlap`
				);
				if (peerOverlap === false) {
					return false;
				}
				// if the peer event's overlap is a test function, pass the subject event as the first param
				if (typeof peerOverlap === 'function' && !peerOverlap(event, peerEvent)) {
					return false;
				}
			}
		}
	}

	return true;
};


// Given an event input from the API, produces an array of event objects. Possible event inputs:
// 'businessHours'
// An event ID (number or string)
// An object with specific start/end dates or a recurring event (like what businessHours accepts)
Calendar.prototype.constraintToEvents = function(constraintInput) {

	if (constraintInput === 'businessHours') {
		return this.getCurrentBusinessHourEvents();
	}

	if (typeof constraintInput === 'object') {
		if (constraintInput.start != null) { // needs to be event-like input
			return this.expandEvent(this.buildEventFromInput(constraintInput));
		}
		else {
			return null; // invalid
		}
	}

	return this.clientEvents(constraintInput); // probably an ID
};


// Does the event's date range intersect with the given range?
// start/end already assumed to have stripped zones :(
Calendar.prototype.eventIntersectsRange = function(event, range) {
	var eventStart = event.start.clone().stripZone();
	var eventEnd = this.getEventEnd(event).stripZone();

	return range.start < eventEnd && range.end > eventStart;
};


/* Business Hours
-----------------------------------------------------------------------------------------*/

var BUSINESS_HOUR_EVENT_DEFAULTS = {
	id: '_fcBusinessHours', // will relate events from different calls to expandEvent
	start: '09:00',
	end: '17:00',
	dow: [ 1, 2, 3, 4, 5 ], // monday - friday
	rendering: 'inverse-background'
	// classNames are defined in businessHoursSegClasses
};

// Return events objects for business hours within the current view.
// Abuse of our event system :(
Calendar.prototype.getCurrentBusinessHourEvents = function(wholeDay) {
	return this.computeBusinessHourEvents(wholeDay, this.opt('businessHours'));
};

// Given a raw input value from options, return events objects for business hours within the current view.
Calendar.prototype.computeBusinessHourEvents = function(wholeDay, input) {
	if (input === true) {
		return this.expandBusinessHourEvents(wholeDay, [ {} ]);
	}
	else if ($.isPlainObject(input)) {
		return this.expandBusinessHourEvents(wholeDay, [ input ]);
	}
	else if ($.isArray(input)) {
		return this.expandBusinessHourEvents(wholeDay, input, true);
	}
	else {
		return [];
	}
};

// inputs expected to be an array of objects.
// if ignoreNoDow is true, will ignore entries that don't specify a day-of-week (dow) key.
Calendar.prototype.expandBusinessHourEvents = function(wholeDay, inputs, ignoreNoDow) {
	var view = this.getView();
	var events = [];
	var i, input;

	for (i = 0; i < inputs.length; i++) {
		input = inputs[i];

		if (ignoreNoDow && !input.dow) {
			continue;
		}

		// give defaults. will make a copy
		input = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, input);

		// if a whole-day series is requested, clear the start/end times
		if (wholeDay) {
			input.start = null;
			input.end = null;
		}

		events.push.apply(events, // append
			this.expandEvent(
				this.buildEventFromInput(input),
				view.activeRange.start,
				view.activeRange.end
			)
		);
	}

	return events;
};

;;

/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.

var BasicView = FC.BasicView = View.extend({

	scroller: null,

	dayGridClass: DayGrid, // class the dayGrid will be instantiated from (overridable by subclasses)
	dayGrid: null, // the main subcomponent that does most of the heavy lifting

	dayNumbersVisible: false, // display day numbers on each day cell?
	colWeekNumbersVisible: false, // display week numbers along the side?
	cellWeekNumbersVisible: false, // display week numbers in day cell?

	weekNumberWidth: null, // width of all the week-number cells running down the side

	headContainerEl: null, // div that hold's the dayGrid's rendered date header
	headRowEl: null, // the fake row element of the day-of-week header


	initialize: function() {
		this.dayGrid = this.instantiateDayGrid();

		this.scroller = new Scroller({
			overflowX: 'hidden',
			overflowY: 'auto'
		});
	},


	// Generates the DayGrid object this view needs. Draws from this.dayGridClass
	instantiateDayGrid: function() {
		// generate a subclass on the fly with BasicView-specific behavior
		// TODO: cache this subclass
		var subclass = this.dayGridClass.extend(basicDayGridMethods);

		return new subclass(this);
	},


	// Computes the date range that will be rendered.
	buildRenderRange: function(currentRange, currentRangeUnit) {
		var renderRange = View.prototype.buildRenderRange.apply(this, arguments);

		// year and month views should be aligned with weeks. this is already done for week
		if (/^(year|month)$/.test(currentRangeUnit)) {
			renderRange.start.startOf('week');

			// make end-of-week if not already
			if (renderRange.end.weekday()) {
				renderRange.end.add(1, 'week').startOf('week'); // exclusively move backwards
			}
		}

		return this.trimHiddenDays(renderRange);
	},


	// Renders the view into `this.el`, which should already be assigned
	renderDates: function() {

		this.dayGrid.breakOnWeeks = /year|month|week/.test(this.currentRangeUnit); // do before Grid::setRange
		this.dayGrid.setRange(this.renderRange);

		this.dayNumbersVisible = this.dayGrid.rowCnt > 1; // TODO: make grid responsible
		if (this.opt('weekNumbers')) {
			if (this.opt('weekNumbersWithinDays')) {
				this.cellWeekNumbersVisible = true;
				this.colWeekNumbersVisible = false;
			}
			else {
				this.cellWeekNumbersVisible = false;
				this.colWeekNumbersVisible = true;
			};
		}
		this.dayGrid.numbersVisible = this.dayNumbersVisible ||
			this.cellWeekNumbersVisible || this.colWeekNumbersVisible;

		this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
		this.renderHead();

		this.scroller.render();
		var dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
		var dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
		this.el.find('.fc-body > tr > td').append(dayGridContainerEl);

		this.dayGrid.setElement(dayGridEl);
		this.dayGrid.renderDates(this.hasRigidRows());
	},


	// render the day-of-week headers
	renderHead: function() {
		this.headContainerEl =
			this.el.find('.fc-head-container')
				.html(this.dayGrid.renderHeadHtml());
		this.headRowEl = this.headContainerEl.find('.fc-row');
	},


	// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
	// always completely kill the dayGrid's rendering.
	unrenderDates: function() {
		this.dayGrid.unrenderDates();
		this.dayGrid.removeElement();
		this.scroller.destroy();
	},


	renderBusinessHours: function() {
		this.dayGrid.renderBusinessHours();
	},


	unrenderBusinessHours: function() {
		this.dayGrid.unrenderBusinessHours();
	},


	// Builds the HTML skeleton for the view.
	// The day-grid component will render inside of a container defined by this HTML.
	renderSkeletonHtml: function() {
		return '' +
			'<table>' +
				'<thead class="fc-head">' +
					'<tr>' +
						'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
					'</tr>' +
				'</thead>' +
				'<tbody class="fc-body">' +
					'<tr>' +
						'<td class="' + this.widgetContentClass + '"></td>' +
					'</tr>' +
				'</tbody>' +
			'</table>';
	},


	// Generates an HTML attribute string for setting the width of the week number column, if it is known
	weekNumberStyleAttr: function() {
		if (this.weekNumberWidth !== null) {
			return 'style="width:' + this.weekNumberWidth + 'px"';
		}
		return '';
	},


	// Determines whether each row should have a constant height
	hasRigidRows: function() {
		var eventLimit = this.opt('eventLimit');
		return eventLimit && typeof eventLimit !== 'number';
	},


	/* Dimensions
	------------------------------------------------------------------------------------------------------------------*/


	// Refreshes the horizontal dimensions of the view
	updateWidth: function() {
		if (this.colWeekNumbersVisible) {
			// Make sure all week number cells running down the side have the same width.
			// Record the width for cells created later.
			this.weekNumberWidth = matchCellWidths(
				this.el.find('.fc-week-number')
			);
		}
	},


	// Adjusts the vertical dimensions of the view to the specified values
	setHeight: function(totalHeight, isAuto) {
		var eventLimit = this.opt('eventLimit');
		var scrollerHeight;
		var scrollbarWidths;

		// reset all heights to be natural
		this.scroller.clear();
		uncompensateScroll(this.headRowEl);

		this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed

		// is the event limit a constant level number?
		if (eventLimit && typeof eventLimit === 'number') {
			this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
		}

		// distribute the height to the rows
		// (totalHeight is a "recommended" value if isAuto)
		scrollerHeight = this.computeScrollerHeight(totalHeight);
		this.setGridHeight(scrollerHeight, isAuto);

		// is the event limit dynamically calculated?
		if (eventLimit && typeof eventLimit !== 'number') {
			this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
		}

		if (!isAuto) { // should we force dimensions of the scroll container?

			this.scroller.setHeight(scrollerHeight);
			scrollbarWidths = this.scroller.getScrollbarWidths();

			if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?

				compensateScroll(this.headRowEl, scrollbarWidths);

				// doing the scrollbar compensation might have created text overflow which created more height. redo
				scrollerHeight = this.computeScrollerHeight(totalHeight);
				this.scroller.setHeight(scrollerHeight);
			}

			// guarantees the same scrollbar widths
			this.scroller.lockOverflow(scrollbarWidths);
		}
	},


	// given a desired total height of the view, returns what the height of the scroller should be
	computeScrollerHeight: function(totalHeight) {
		return totalHeight -
			subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	},


	// Sets the height of just the DayGrid component in this view
	setGridHeight: function(height, isAuto) {
		if (isAuto) {
			undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
		}
		else {
			distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
		}
	},


	/* Scroll
	------------------------------------------------------------------------------------------------------------------*/


	computeInitialDateScroll: function() {
		return { top: 0 };
	},


	queryDateScroll: function() {
		return { top: this.scroller.getScrollTop() };
	},


	applyDateScroll: function(scroll) {
		if (scroll.top !== undefined) {
			this.scroller.setScrollTop(scroll.top);
		}
	},


	/* Hit Areas
	------------------------------------------------------------------------------------------------------------------*/
	// forward all hit-related method calls to dayGrid


	hitsNeeded: function() {
		this.dayGrid.hitsNeeded();
	},


	hitsNotNeeded: function() {
		this.dayGrid.hitsNotNeeded();
	},


	prepareHits: function() {
		this.dayGrid.prepareHits();
	},


	releaseHits: function() {
		this.dayGrid.releaseHits();
	},


	queryHit: function(left, top) {
		return this.dayGrid.queryHit(left, top);
	},


	getHitSpan: function(hit) {
		return this.dayGrid.getHitSpan(hit);
	},


	getHitEl: function(hit) {
		return this.dayGrid.getHitEl(hit);
	},


	/* Events
	------------------------------------------------------------------------------------------------------------------*/


	// Renders the given events onto the view and populates the segments array
	renderEvents: function(events) {
		this.dayGrid.renderEvents(events);

		this.updateHeight(); // must compensate for events that overflow the row
	},


	// Retrieves all segment objects that are rendered in the view
	getEventSegs: function() {
		return this.dayGrid.getEventSegs();
	},


	// Unrenders all event elements and clears internal segment data
	unrenderEvents: function() {
		this.dayGrid.unrenderEvents();

		// we DON'T need to call updateHeight() because
		// a renderEvents() call always happens after this, which will eventually call updateHeight()
	},


	/* Dragging (for both events and external elements)
	------------------------------------------------------------------------------------------------------------------*/


	// A returned value of `true` signals that a mock "helper" event has been rendered.
	renderDrag: function(dropLocation, seg) {
		return this.dayGrid.renderDrag(dropLocation, seg);
	},


	unrenderDrag: function() {
		this.dayGrid.unrenderDrag();
	},


	/* Selection
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of a selection
	renderSelection: function(span) {
		this.dayGrid.renderSelection(span);
	},


	// Unrenders a visual indications of a selection
	unrenderSelection: function() {
		this.dayGrid.unrenderSelection();
	}

});


// Methods that will customize the rendering behavior of the BasicView's dayGrid
var basicDayGridMethods = {


	// Generates the HTML that will go before the day-of week header cells
	renderHeadIntroHtml: function() {
		var view = this.view;

		if (view.colWeekNumbersVisible) {
			return '' +
				'<th class="fc-week-number ' + view.widgetHeaderClass + '" ' + view.weekNumberStyleAttr() + '>' +
					'<span>' + // needed for matchCellWidths
						htmlEscape(view.opt('weekNumberTitle')) +
					'</span>' +
				'</th>';
		}

		return '';
	},


	// Generates the HTML that will go before content-skeleton cells that display the day/week numbers
	renderNumberIntroHtml: function(row) {
		var view = this.view;
		var weekStart = this.getCellDate(row, 0);

		if (view.colWeekNumbersVisible) {
			return '' +
				'<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
					view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
						{ date: weekStart, type: 'week', forceOff: this.colCnt === 1 },
						weekStart.format('w') // inner HTML
					) +
				'</td>';
		}

		return '';
	},


	// Generates the HTML that goes before the day bg cells for each day-row
	renderBgIntroHtml: function() {
		var view = this.view;

		if (view.colWeekNumbersVisible) {
			return '<td class="fc-week-number ' + view.widgetContentClass + '" ' +
				view.weekNumberStyleAttr() + '></td>';
		}

		return '';
	},


	// Generates the HTML that goes before every other type of row generated by DayGrid.
	// Affects helper-skeleton and highlight-skeleton rows.
	renderIntroHtml: function() {
		var view = this.view;

		if (view.colWeekNumbersVisible) {
			return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
		}

		return '';
	}

};

;;

/* A month view with day cells running in rows (one-per-week) and columns
----------------------------------------------------------------------------------------------------------------------*/

var MonthView = FC.MonthView = BasicView.extend({


	// Computes the date range that will be rendered.
	buildRenderRange: function() {
		var renderRange = BasicView.prototype.buildRenderRange.apply(this, arguments);
		var rowCnt;

		// ensure 6 weeks
		if (this.isFixedWeeks()) {
			rowCnt = Math.ceil( // could be partial weeks due to hiddenDays
				renderRange.end.diff(renderRange.start, 'weeks', true) // dontRound=true
			);
			renderRange.end.add(6 - rowCnt, 'weeks');
		}

		return renderRange;
	},


	// Overrides the default BasicView behavior to have special multi-week auto-height logic
	setGridHeight: function(height, isAuto) {

		// if auto, make the height of each row the height that it would be if there were 6 weeks
		if (isAuto) {
			height *= this.rowCnt / 6;
		}

		distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
	},


	isFixedWeeks: function() {
		return this.opt('fixedWeekCount');
	}

});

;;

fcViews.basic = {
	'class': BasicView
};

fcViews.basicDay = {
	type: 'basic',
	duration: { days: 1 }
};

fcViews.basicWeek = {
	type: 'basic',
	duration: { weeks: 1 }
};

fcViews.month = {
	'class': MonthView,
	duration: { months: 1 }, // important for prev/next
	defaults: {
		fixedWeekCount: true
	}
};
;;

/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
----------------------------------------------------------------------------------------------------------------------*/
// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
// Responsible for managing width/height.

var AgendaView = FC.AgendaView = View.extend({

	scroller: null,

	timeGridClass: TimeGrid, // class used to instantiate the timeGrid. subclasses can override
	timeGrid: null, // the main time-grid subcomponent of this view

	dayGridClass: DayGrid, // class used to instantiate the dayGrid. subclasses can override
	dayGrid: null, // the "all-day" subcomponent. if all-day is turned off, this will be null

	axisWidth: null, // the width of the time axis running down the side

	headContainerEl: null, // div that hold's the timeGrid's rendered date header
	noScrollRowEls: null, // set of fake row elements that must compensate when scroller has scrollbars

	// when the time-grid isn't tall enough to occupy the given height, we render an <hr> underneath
	bottomRuleEl: null,

	// indicates that minTime/maxTime affects rendering
	usesMinMaxTime: true,


	initialize: function() {
		this.timeGrid = this.instantiateTimeGrid();

		if (this.opt('allDaySlot')) { // should we display the "all-day" area?
			this.dayGrid = this.instantiateDayGrid(); // the all-day subcomponent of this view
		}

		this.scroller = new Scroller({
			overflowX: 'hidden',
			overflowY: 'auto'
		});
	},


	// Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
	instantiateTimeGrid: function() {
		var subclass = this.timeGridClass.extend(agendaTimeGridMethods);

		return new subclass(this);
	},


	// Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
	instantiateDayGrid: function() {
		var subclass = this.dayGridClass.extend(agendaDayGridMethods);

		return new subclass(this);
	},


	/* Rendering
	------------------------------------------------------------------------------------------------------------------*/


	// Renders the view into `this.el`, which has already been assigned
	renderDates: function() {

		this.timeGrid.setRange(this.renderRange);

		if (this.dayGrid) {
			this.dayGrid.setRange(this.renderRange);
		}

		this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
		this.renderHead();

		this.scroller.render();
		var timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
		var timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
		this.el.find('.fc-body > tr > td').append(timeGridWrapEl);

		this.timeGrid.setElement(timeGridEl);
		this.timeGrid.renderDates();

		// the <hr> that sometimes displays under the time-grid
		this.bottomRuleEl = $('<hr class="fc-divider ' + this.widgetHeaderClass + '"/>')
			.appendTo(this.timeGrid.el); // inject it into the time-grid

		if (this.dayGrid) {
			this.dayGrid.setElement(this.el.find('.fc-day-grid'));
			this.dayGrid.renderDates();

			// have the day-grid extend it's coordinate area over the <hr> dividing the two grids
			this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
		}

		this.noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)'); // fake rows not within the scroller
	},


	// render the day-of-week headers
	renderHead: function() {
		this.headContainerEl =
			this.el.find('.fc-head-container')
				.html(this.timeGrid.renderHeadHtml());
	},


	// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
	// always completely kill each grid's rendering.
	unrenderDates: function() {
		this.timeGrid.unrenderDates();
		this.timeGrid.removeElement();

		if (this.dayGrid) {
			this.dayGrid.unrenderDates();
			this.dayGrid.removeElement();
		}

		this.scroller.destroy();
	},


	// Builds the HTML skeleton for the view.
	// The day-grid and time-grid components will render inside containers defined by this HTML.
	renderSkeletonHtml: function() {
		return '' +
			'<table>' +
				'<thead class="fc-head">' +
					'<tr>' +
						'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
					'</tr>' +
				'</thead>' +
				'<tbody class="fc-body">' +
					'<tr>' +
						'<td class="' + this.widgetContentClass + '">' +
							(this.dayGrid ?
								'<div class="fc-day-grid"/>' +
								'<hr class="fc-divider ' + this.widgetHeaderClass + '"/>' :
								''
								) +
						'</td>' +
					'</tr>' +
				'</tbody>' +
			'</table>';
	},


	// Generates an HTML attribute string for setting the width of the axis, if it is known
	axisStyleAttr: function() {
		if (this.axisWidth !== null) {
			 return 'style="width:' + this.axisWidth + 'px"';
		}
		return '';
	},


	/* Business Hours
	------------------------------------------------------------------------------------------------------------------*/


	renderBusinessHours: function() {
		this.timeGrid.renderBusinessHours();

		if (this.dayGrid) {
			this.dayGrid.renderBusinessHours();
		}
	},


	unrenderBusinessHours: function() {
		this.timeGrid.unrenderBusinessHours();

		if (this.dayGrid) {
			this.dayGrid.unrenderBusinessHours();
		}
	},


	/* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/


	getNowIndicatorUnit: function() {
		return this.timeGrid.getNowIndicatorUnit();
	},


	renderNowIndicator: function(date) {
		this.timeGrid.renderNowIndicator(date);
	},


	unrenderNowIndicator: function() {
		this.timeGrid.unrenderNowIndicator();
	},


	/* Dimensions
	------------------------------------------------------------------------------------------------------------------*/


	updateSize: function(isResize) {
		this.timeGrid.updateSize(isResize);

		View.prototype.updateSize.call(this, isResize); // call the super-method
	},


	// Refreshes the horizontal dimensions of the view
	updateWidth: function() {
		// make all axis cells line up, and record the width so newly created axis cells will have it
		this.axisWidth = matchCellWidths(this.el.find('.fc-axis'));
	},


	// Adjusts the vertical dimensions of the view to the specified values
	setHeight: function(totalHeight, isAuto) {
		var eventLimit;
		var scrollerHeight;
		var scrollbarWidths;

		// reset all dimensions back to the original state
		this.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
		this.scroller.clear(); // sets height to 'auto' and clears overflow
		uncompensateScroll(this.noScrollRowEls);

		// limit number of events in the all-day area
		if (this.dayGrid) {
			this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed

			eventLimit = this.opt('eventLimit');
			if (eventLimit && typeof eventLimit !== 'number') {
				eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
			}
			if (eventLimit) {
				this.dayGrid.limitRows(eventLimit);
			}
		}

		if (!isAuto) { // should we force dimensions of the scroll container?

			scrollerHeight = this.computeScrollerHeight(totalHeight);
			this.scroller.setHeight(scrollerHeight);
			scrollbarWidths = this.scroller.getScrollbarWidths();

			if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?

				// make the all-day and header rows lines up
				compensateScroll(this.noScrollRowEls, scrollbarWidths);

				// the scrollbar compensation might have changed text flow, which might affect height, so recalculate
				// and reapply the desired height to the scroller.
				scrollerHeight = this.computeScrollerHeight(totalHeight);
				this.scroller.setHeight(scrollerHeight);
			}

			// guarantees the same scrollbar widths
			this.scroller.lockOverflow(scrollbarWidths);

			// if there's any space below the slats, show the horizontal rule.
			// this won't cause any new overflow, because lockOverflow already called.
			if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
				this.bottomRuleEl.show();
			}
		}
	},


	// given a desired total height of the view, returns what the height of the scroller should be
	computeScrollerHeight: function(totalHeight) {
		return totalHeight -
			subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	},


	/* Scroll
	------------------------------------------------------------------------------------------------------------------*/


	// Computes the initial pre-configured scroll state prior to allowing the user to change it
	computeInitialDateScroll: function() {
		var scrollTime = moment.duration(this.opt('scrollTime'));
		var top = this.timeGrid.computeTimeTop(scrollTime);

		// zoom can give weird floating-point values. rather scroll a little bit further
		top = Math.ceil(top);

		if (top) {
			top++; // to overcome top border that slots beyond the first have. looks better
		}

		return { top: top };
	},


	queryDateScroll: function() {
		return { top: this.scroller.getScrollTop() };
	},


	applyDateScroll: function(scroll) {
		if (scroll.top !== undefined) {
			this.scroller.setScrollTop(scroll.top);
		}
	},


	/* Hit Areas
	------------------------------------------------------------------------------------------------------------------*/
	// forward all hit-related method calls to the grids (dayGrid might not be defined)


	hitsNeeded: function() {
		this.timeGrid.hitsNeeded();
		if (this.dayGrid) {
			this.dayGrid.hitsNeeded();
		}
	},


	hitsNotNeeded: function() {
		this.timeGrid.hitsNotNeeded();
		if (this.dayGrid) {
			this.dayGrid.hitsNotNeeded();
		}
	},


	prepareHits: function() {
		this.timeGrid.prepareHits();
		if (this.dayGrid) {
			this.dayGrid.prepareHits();
		}
	},


	releaseHits: function() {
		this.timeGrid.releaseHits();
		if (this.dayGrid) {
			this.dayGrid.releaseHits();
		}
	},


	queryHit: function(left, top) {
		var hit = this.timeGrid.queryHit(left, top);

		if (!hit && this.dayGrid) {
			hit = this.dayGrid.queryHit(left, top);
		}

		return hit;
	},


	getHitSpan: function(hit) {
		// TODO: hit.component is set as a hack to identify where the hit came from
		return hit.component.getHitSpan(hit);
	},


	getHitEl: function(hit) {
		// TODO: hit.component is set as a hack to identify where the hit came from
		return hit.component.getHitEl(hit);
	},


	/* Events
	------------------------------------------------------------------------------------------------------------------*/


	// Renders events onto the view and populates the View's segment array
	renderEvents: function(events) {
		var dayEvents = [];
		var timedEvents = [];
		var daySegs = [];
		var timedSegs;
		var i;

		// separate the events into all-day and timed
		for (i = 0; i < events.length; i++) {
			if (events[i].allDay) {
				dayEvents.push(events[i]);
			}
			else {
				timedEvents.push(events[i]);
			}
		}

		// render the events in the subcomponents
		timedSegs = this.timeGrid.renderEvents(timedEvents);
		if (this.dayGrid) {
			daySegs = this.dayGrid.renderEvents(dayEvents);
		}

		// the all-day area is flexible and might have a lot of events, so shift the height
		this.updateHeight();
	},


	// Retrieves all segment objects that are rendered in the view
	getEventSegs: function() {
		return this.timeGrid.getEventSegs().concat(
			this.dayGrid ? this.dayGrid.getEventSegs() : []
		);
	},


	// Unrenders all event elements and clears internal segment data
	unrenderEvents: function() {

		// unrender the events in the subcomponents
		this.timeGrid.unrenderEvents();
		if (this.dayGrid) {
			this.dayGrid.unrenderEvents();
		}

		// we DON'T need to call updateHeight() because
		// a renderEvents() call always happens after this, which will eventually call updateHeight()
	},


	/* Dragging (for events and external elements)
	------------------------------------------------------------------------------------------------------------------*/


	// A returned value of `true` signals that a mock "helper" event has been rendered.
	renderDrag: function(dropLocation, seg) {
		if (dropLocation.start.hasTime()) {
			return this.timeGrid.renderDrag(dropLocation, seg);
		}
		else if (this.dayGrid) {
			return this.dayGrid.renderDrag(dropLocation, seg);
		}
	},


	unrenderDrag: function() {
		this.timeGrid.unrenderDrag();
		if (this.dayGrid) {
			this.dayGrid.unrenderDrag();
		}
	},


	/* Selection
	------------------------------------------------------------------------------------------------------------------*/


	// Renders a visual indication of a selection
	renderSelection: function(span) {
		if (span.start.hasTime() || span.end.hasTime()) {
			this.timeGrid.renderSelection(span);
		}
		else if (this.dayGrid) {
			this.dayGrid.renderSelection(span);
		}
	},


	// Unrenders a visual indications of a selection
	unrenderSelection: function() {
		this.timeGrid.unrenderSelection();
		if (this.dayGrid) {
			this.dayGrid.unrenderSelection();
		}
	}

});


// Methods that will customize the rendering behavior of the AgendaView's timeGrid
// TODO: move into TimeGrid
var agendaTimeGridMethods = {


	// Generates the HTML that will go before the day-of week header cells
	renderHeadIntroHtml: function() {
		var view = this.view;
		var weekText;

		if (view.opt('weekNumbers')) {
			weekText = this.start.format(view.opt('smallWeekFormat'));

			return '' +
				'<th class="fc-axis fc-week-number ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '>' +
					view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
						{ date: this.start, type: 'week', forceOff: this.colCnt > 1 },
						htmlEscape(weekText) // inner HTML
					) +
				'</th>';
		}
		else {
			return '<th class="fc-axis ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '></th>';
		}
	},


	// Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
	renderBgIntroHtml: function() {
		var view = this.view;

		return '<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '></td>';
	},


	// Generates the HTML that goes before all other types of cells.
	// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	renderIntroHtml: function() {
		var view = this.view;

		return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	}

};


// Methods that will customize the rendering behavior of the AgendaView's dayGrid
var agendaDayGridMethods = {


	// Generates the HTML that goes before the all-day cells
	renderBgIntroHtml: function() {
		var view = this.view;

		return '' +
			'<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
				'<span>' + // needed for matchCellWidths
					view.getAllDayHtml() +
				'</span>' +
			'</td>';
	},


	// Generates the HTML that goes before all other types of cells.
	// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	renderIntroHtml: function() {
		var view = this.view;

		return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	}

};

;;

var AGENDA_ALL_DAY_EVENT_LIMIT = 5;

// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var AGENDA_STOCK_SUB_DURATIONS = [
	{ hours: 1 },
	{ minutes: 30 },
	{ minutes: 15 },
	{ seconds: 30 },
	{ seconds: 15 }
];

fcViews.agenda = {
	'class': AgendaView,
	defaults: {
		allDaySlot: true,
		slotDuration: '00:30:00',
		slotEventOverlap: true // a bad name. confused with overlap/constraint system
	}
};

fcViews.agendaDay = {
	type: 'agenda',
	duration: { days: 1 }
};

fcViews.agendaWeek = {
	type: 'agenda',
	duration: { weeks: 1 }
};
;;

/*
Responsible for the scroller, and forwarding event-related actions into the "grid"
*/
var ListView = View.extend({

	grid: null,
	scroller: null,

	initialize: function() {
		this.grid = new ListViewGrid(this);
		this.scroller = new Scroller({
			overflowX: 'hidden',
			overflowY: 'auto'
		});
	},

	renderSkeleton: function() {
		this.el.addClass(
			'fc-list-view ' +
			this.widgetContentClass
		);

		this.scroller.render();
		this.scroller.el.appendTo(this.el);

		this.grid.setElement(this.scroller.scrollEl);
	},

	unrenderSkeleton: function() {
		this.scroller.destroy(); // will remove the Grid too
	},

	setHeight: function(totalHeight, isAuto) {
		this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
	},

	computeScrollerHeight: function(totalHeight) {
		return totalHeight -
			subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	},

	renderDates: function() {
		this.grid.setRange(this.renderRange); // needs to process range-related options
	},

	renderEvents: function(events) {
		this.grid.renderEvents(events);
	},

	unrenderEvents: function() {
		this.grid.unrenderEvents();
	},

	isEventResizable: function(event) {
		return false;
	},

	isEventDraggable: function(event) {
		return false;
	}

});

/*
Responsible for event rendering and user-interaction.
Its "el" is the inner-content of the above view's scroller.
*/
var ListViewGrid = Grid.extend({

	segSelector: '.fc-list-item', // which elements accept event actions
	hasDayInteractions: false, // no day selection or day clicking

	// slices by day
	spanToSegs: function(span) {
		var view = this.view;
		var dayStart = view.renderRange.start.clone().time(0); // timed, so segs get times!
		var dayIndex = 0;
		var seg;
		var segs = [];

		while (dayStart < view.renderRange.end) {

			seg = intersectRanges(span, {
				start: dayStart,
				end: dayStart.clone().add(1, 'day')
			});

			if (seg) {
				seg.dayIndex = dayIndex;
				segs.push(seg);
			}

			dayStart.add(1, 'day');
			dayIndex++;

			// detect when span won't go fully into the next day,
			// and mutate the latest seg to the be the end.
			if (
				seg && !seg.isEnd && span.end.hasTime() &&
				span.end < dayStart.clone().add(this.view.nextDayThreshold)
			) {
				seg.end = span.end.clone();
				seg.isEnd = true;
				break;
			}
		}

		return segs;
	},

	// like "4:00am"
	computeEventTimeFormat: function() {
		return this.view.opt('mediumTimeFormat');
	},

	// for events with a url, the whole <tr> should be clickable,
	// but it's impossible to wrap with an <a> tag. simulate this.
	handleSegClick: function(seg, ev) {
		var url;

		Grid.prototype.handleSegClick.apply(this, arguments); // super. might prevent the default action

		// not clicking on or within an <a> with an href
		if (!$(ev.target).closest('a[href]').length) {
			url = seg.event.url;
			if (url && !ev.isDefaultPrevented()) { // jsEvent not cancelled in handler
				window.location.href = url; // simulate link click
			}
		}
	},

	// returns list of foreground segs that were actually rendered
	renderFgSegs: function(segs) {
		segs = this.renderFgSegEls(segs); // might filter away hidden events

		if (!segs.length) {
			this.renderEmptyMessage();
		}
		else {
			this.renderSegList(segs);
		}

		return segs;
	},

	renderEmptyMessage: function() {
		this.el.html(
			'<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
			'<div class="fc-list-empty-wrap1">' +
			'<div class="fc-list-empty">' +
				htmlEscape(this.view.opt('noEventsMessage')) +
			'</div>' +
			'</div>' +
			'</div>'
		);
	},

	// render the event segments in the view
	renderSegList: function(allSegs) {
		var segsByDay = this.groupSegsByDay(allSegs); // sparse array
		var dayIndex;
		var daySegs;
		var i;
		var tableEl = $('<table class="fc-list-table"><tbody/></table>');
		var tbodyEl = tableEl.find('tbody');

		for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
			daySegs = segsByDay[dayIndex];
			if (daySegs) { // sparse array, so might be undefined

				// append a day header
				tbodyEl.append(this.dayHeaderHtml(
					this.view.renderRange.start.clone().add(dayIndex, 'days')
				));

				this.sortEventSegs(daySegs);

				for (i = 0; i < daySegs.length; i++) {
					tbodyEl.append(daySegs[i].el); // append event row
				}
			}
		}

		this.el.empty().append(tableEl);
	},

	// Returns a sparse array of arrays, segs grouped by their dayIndex
	groupSegsByDay: function(segs) {
		var segsByDay = []; // sparse array
		var i, seg;

		for (i = 0; i < segs.length; i++) {
			seg = segs[i];
			(segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
				.push(seg);
		}

		return segsByDay;
	},

	// generates the HTML for the day headers that live amongst the event rows
	dayHeaderHtml: function(dayDate) {
		var view = this.view;
		var mainFormat = view.opt('listDayFormat');
		var altFormat = view.opt('listDayAltFormat');

		return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
			'<td class="' + view.widgetHeaderClass + '" colspan="3">' +
				(mainFormat ?
					view.buildGotoAnchorHtml(
						dayDate,
						{ 'class': 'fc-list-heading-main' },
						htmlEscape(dayDate.format(mainFormat)) // inner HTML
					) :
					'') +
				(altFormat ?
					view.buildGotoAnchorHtml(
						dayDate,
						{ 'class': 'fc-list-heading-alt' },
						htmlEscape(dayDate.format(altFormat)) // inner HTML
					) :
					'') +
			'</td>' +
		'</tr>';
	},

	// generates the HTML for a single event row
	fgSegHtml: function(seg) {
		var view = this.view;
		var classes = [ 'fc-list-item' ].concat(this.getSegCustomClasses(seg));
		var bgColor = this.getSegBackgroundColor(seg);
		var event = seg.event;
		var url = event.url;
		var timeHtml;

		if (event.allDay) {
			timeHtml = view.getAllDayHtml();
		}
		else if (view.isMultiDayEvent(event)) { // if the event appears to span more than one day
			if (seg.isStart || seg.isEnd) { // outer segment that probably lasts part of the day
				timeHtml = htmlEscape(this.getEventTimeText(seg));
			}
			else { // inner segment that lasts the whole day
				timeHtml = view.getAllDayHtml();
			}
		}
		else {
			// Display the normal time text for the *event's* times
			timeHtml = htmlEscape(this.getEventTimeText(event));
		}

		if (url) {
			classes.push('fc-has-url');
		}

		return '<tr class="' + classes.join(' ') + '">' +
			(this.displayEventTime ?
				'<td class="fc-list-item-time ' + view.widgetContentClass + '">' +
					(timeHtml || '') +
				'</td>' :
				'') +
			'<td class="fc-list-item-marker ' + view.widgetContentClass + '">' +
				'<span class="fc-event-dot"' +
				(bgColor ?
					' style="background-color:' + bgColor + '"' :
					'') +
				'></span>' +
			'</td>' +
			'<td class="fc-list-item-title ' + view.widgetContentClass + '">' +
				'<a' + (url ? ' href="' + htmlEscape(url) + '"' : '') + '>' +
					htmlEscape(seg.event.title || '') +
				'</a>' +
			'</td>' +
		'</tr>';
	}

});

;;

fcViews.list = {
	'class': ListView,
	buttonTextKey: 'list', // what to lookup in locale files
	defaults: {
		buttonText: 'list', // text to display for English
		listDayFormat: 'LL', // like "January 1, 2016"
		noEventsMessage: 'No events to display'
	}
};

fcViews.listDay = {
	type: 'list',
	duration: { days: 1 },
	defaults: {
		listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
	}
};

fcViews.listWeek = {
	type: 'list',
	duration: { weeks: 1 },
	defaults: {
		listDayFormat: 'dddd', // day-of-week is more important
		listDayAltFormat: 'LL'
	}
};

fcViews.listMonth = {
	type: 'list',
	duration: { month: 1 },
	defaults: {
		listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	}
};

fcViews.listYear = {
	type: 'list',
	duration: { year: 1 },
	defaults: {
		listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	}
};

;;

return FC; // export for Node/CommonJS
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 2,
	"./af.js": 2,
	"./ar": 9,
	"./ar-dz": 3,
	"./ar-dz.js": 3,
	"./ar-kw": 4,
	"./ar-kw.js": 4,
	"./ar-ly": 5,
	"./ar-ly.js": 5,
	"./ar-ma": 6,
	"./ar-ma.js": 6,
	"./ar-sa": 7,
	"./ar-sa.js": 7,
	"./ar-tn": 8,
	"./ar-tn.js": 8,
	"./ar.js": 9,
	"./az": 10,
	"./az.js": 10,
	"./be": 11,
	"./be.js": 11,
	"./bg": 12,
	"./bg.js": 12,
	"./bn": 13,
	"./bn.js": 13,
	"./bo": 14,
	"./bo.js": 14,
	"./br": 15,
	"./br.js": 15,
	"./bs": 16,
	"./bs.js": 16,
	"./ca": 17,
	"./ca.js": 17,
	"./cs": 18,
	"./cs.js": 18,
	"./cv": 19,
	"./cv.js": 19,
	"./cy": 20,
	"./cy.js": 20,
	"./da": 21,
	"./da.js": 21,
	"./de": 24,
	"./de-at": 22,
	"./de-at.js": 22,
	"./de-ch": 23,
	"./de-ch.js": 23,
	"./de.js": 24,
	"./dv": 25,
	"./dv.js": 25,
	"./el": 26,
	"./el.js": 26,
	"./en-au": 27,
	"./en-au.js": 27,
	"./en-ca": 28,
	"./en-ca.js": 28,
	"./en-gb": 29,
	"./en-gb.js": 29,
	"./en-ie": 30,
	"./en-ie.js": 30,
	"./en-nz": 31,
	"./en-nz.js": 31,
	"./eo": 32,
	"./eo.js": 32,
	"./es": 34,
	"./es-do": 33,
	"./es-do.js": 33,
	"./es.js": 34,
	"./et": 35,
	"./et.js": 35,
	"./eu": 36,
	"./eu.js": 36,
	"./fa": 37,
	"./fa.js": 37,
	"./fi": 38,
	"./fi.js": 38,
	"./fo": 39,
	"./fo.js": 39,
	"./fr": 42,
	"./fr-ca": 40,
	"./fr-ca.js": 40,
	"./fr-ch": 41,
	"./fr-ch.js": 41,
	"./fr.js": 42,
	"./fy": 43,
	"./fy.js": 43,
	"./gd": 44,
	"./gd.js": 44,
	"./gl": 45,
	"./gl.js": 45,
	"./gom-latn": 46,
	"./gom-latn.js": 46,
	"./he": 47,
	"./he.js": 47,
	"./hi": 48,
	"./hi.js": 48,
	"./hr": 49,
	"./hr.js": 49,
	"./hu": 50,
	"./hu.js": 50,
	"./hy-am": 51,
	"./hy-am.js": 51,
	"./id": 52,
	"./id.js": 52,
	"./is": 53,
	"./is.js": 53,
	"./it": 54,
	"./it.js": 54,
	"./ja": 55,
	"./ja.js": 55,
	"./jv": 56,
	"./jv.js": 56,
	"./ka": 57,
	"./ka.js": 57,
	"./kk": 58,
	"./kk.js": 58,
	"./km": 59,
	"./km.js": 59,
	"./kn": 60,
	"./kn.js": 60,
	"./ko": 61,
	"./ko.js": 61,
	"./ky": 62,
	"./ky.js": 62,
	"./lb": 63,
	"./lb.js": 63,
	"./lo": 64,
	"./lo.js": 64,
	"./lt": 65,
	"./lt.js": 65,
	"./lv": 66,
	"./lv.js": 66,
	"./me": 67,
	"./me.js": 67,
	"./mi": 68,
	"./mi.js": 68,
	"./mk": 69,
	"./mk.js": 69,
	"./ml": 70,
	"./ml.js": 70,
	"./mr": 71,
	"./mr.js": 71,
	"./ms": 73,
	"./ms-my": 72,
	"./ms-my.js": 72,
	"./ms.js": 73,
	"./my": 74,
	"./my.js": 74,
	"./nb": 75,
	"./nb.js": 75,
	"./ne": 76,
	"./ne.js": 76,
	"./nl": 78,
	"./nl-be": 77,
	"./nl-be.js": 77,
	"./nl.js": 78,
	"./nn": 79,
	"./nn.js": 79,
	"./pa-in": 80,
	"./pa-in.js": 80,
	"./pl": 81,
	"./pl.js": 81,
	"./pt": 83,
	"./pt-br": 82,
	"./pt-br.js": 82,
	"./pt.js": 83,
	"./ro": 84,
	"./ro.js": 84,
	"./ru": 85,
	"./ru.js": 85,
	"./sd": 86,
	"./sd.js": 86,
	"./se": 87,
	"./se.js": 87,
	"./si": 88,
	"./si.js": 88,
	"./sk": 89,
	"./sk.js": 89,
	"./sl": 90,
	"./sl.js": 90,
	"./sq": 91,
	"./sq.js": 91,
	"./sr": 93,
	"./sr-cyrl": 92,
	"./sr-cyrl.js": 92,
	"./sr.js": 93,
	"./ss": 94,
	"./ss.js": 94,
	"./sv": 95,
	"./sv.js": 95,
	"./sw": 96,
	"./sw.js": 96,
	"./ta": 97,
	"./ta.js": 97,
	"./te": 98,
	"./te.js": 98,
	"./tet": 99,
	"./tet.js": 99,
	"./th": 100,
	"./th.js": 100,
	"./tl-ph": 101,
	"./tl-ph.js": 101,
	"./tlh": 102,
	"./tlh.js": 102,
	"./tr": 103,
	"./tr.js": 103,
	"./tzl": 104,
	"./tzl.js": 104,
	"./tzm": 106,
	"./tzm-latn": 105,
	"./tzm-latn.js": 105,
	"./tzm.js": 106,
	"./uk": 107,
	"./uk.js": 107,
	"./ur": 108,
	"./ur.js": 108,
	"./uz": 110,
	"./uz-latn": 109,
	"./uz-latn.js": 109,
	"./uz.js": 110,
	"./vi": 111,
	"./vi.js": 111,
	"./x-pseudo": 112,
	"./x-pseudo.js": 112,
	"./yo": 113,
	"./yo.js": 113,
	"./zh-cn": 114,
	"./zh-cn.js": 114,
	"./zh-hk": 115,
	"./zh-hk.js": 115,
	"./zh-tw": 116,
	"./zh-tw.js": 116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_122__;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(117);


/***/ })
/******/ ]);
});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(570);


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(13);

var ReactBaseClasses = __webpack_require__(227);
var ReactChildren = __webpack_require__(573);
var ReactDOMFactories = __webpack_require__(578);
var ReactElement = __webpack_require__(71);
var ReactPropTypes = __webpack_require__(579);
var ReactVersion = __webpack_require__(584);

var createReactClass = __webpack_require__(585);
var onlyChild = __webpack_require__(587);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(574);
var ReactElement = __webpack_require__(71);

var emptyFunction = __webpack_require__(229);
var traverseAllChildren = __webpack_require__(575);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(105);

var invariant = __webpack_require__(106);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(105);

var ReactCurrentOwner = __webpack_require__(231);
var REACT_ELEMENT_TYPE = __webpack_require__(232);

var getIteratorFn = __webpack_require__(576);
var invariant = __webpack_require__(106);
var KeyEscapeUtils = __webpack_require__(577);
var warning = __webpack_require__(150);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(71);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(71),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(580);

module.exports = factory(isValidElement);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(581);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(63);
var assign = __webpack_require__(13);

var ReactPropTypesSecret = __webpack_require__(170);
var has = __webpack_require__(582);
var checkPropTypes = __webpack_require__(583);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(227),
    Component = _require.Component;

var _require2 = __webpack_require__(71),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(228);
var factory = __webpack_require__(586);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(13);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(105);

var ReactElement = __webpack_require__(71);

var invariant = __webpack_require__(106);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { profilePic } from '../../assets/images/pro1.jpg';
//import { Grid, Image } from 'semantic-ui-react'
var Communication=function(_Component){_inherits(Communication,_Component);function Communication(props){_classCallCheck(this,Communication);var _this=_possibleConstructorReturn(this,(Communication.__proto__||Object.getPrototypeOf(Communication)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};return _this;}_createClass(Communication,[{key:'componentWillMount',value:function componentWillMount(){__WEBPACK_IMPORTED_MODULE_2__services__["a" /* CommunicationServices */].getAllInfo().then(function(response){}).catch(function(error){// UtilityService.errorMsg(this.msg)
});}},{key:'componentDidMount',value:function componentDidMount(){this.enableMultiSelect();}},{key:'enableMultiSelect',value:function enableMultiSelect(){// $(document).ready(function () {
//     $('#range-slct').multiselect();
// });
}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Communication')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'class':'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row styles-select-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 style-card-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.history.push("/chat");},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'style-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Name ABSC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Cust Ref - 1002')))))))))))));}}]);return Communication;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Communication);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(592);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_download_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_file_svg__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_file_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_file_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_send_svg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_send_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_send_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chat=function(_Component){_inherits(Chat,_Component);function Chat(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Chat);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Chat.__proto__||Object.getPrototypeOf(Chat)).call.apply(_ref,[this].concat(args))),_this),_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Chat,[{key:'componentDidMount',value:function componentDidMount(){this.enableMultiSelect();}},{key:'enableMultiSelect',value:function enableMultiSelect(){// $(document).ready(function () {
//     $('#range-slct').multiselect();
// });
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'chat_css'},'Style 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row chat-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding left-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-left pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Hey')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding right-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 no-padding pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-right pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Hi')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding left-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-left pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chats'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__assets_images_download_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'text-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},' XX XX XX')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'pull-right chat-date'},'17th Jan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'pull-right chat-time'},'7.30 PM'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding right-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 no-padding pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-right pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'MM File ? updated..... Bring all the files into single ZIP... Lorem ipsum dolor sit amet, animal delicata usu id, mollis aliquip probatus pri et, no sed forensibus referrentur. His movet saperet te, ius no eros nonumy. Tantas ubique fabellas cum cu, movet definiebas persequeris in duo, no ocurreret similique has. Quot mentitum eos no, summo placerat qui ex. Pro tamquam detraxit consequat ex, ad per everti audire accusata, ad ponderum pericula nam.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding left-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-left pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'MM File ? updated..... Bring all the files into single ZIP... Lorem ipsum dolor sit amet, animal delicata usu id, mollis aliquip probatus pri et, no sed forensibus referrentur. His movet saperet te, ius no eros nonumy. Tantas ubique fabellas cum cu, movet definiebas persequeris in duo, no ocurreret similique has. Quot mentitum eos no, summo placerat qui ex. Pro tamquam detraxit consequat ex, ad per everti audire accusata, ad ponderum pericula nam.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding left-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-left pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'MM File Folder !')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding right-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 no-padding pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-right pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chats'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_file_svg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'text-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},'YY YY YY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'pull-right chat-date'},'17th Jan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'pull-right chat-time'},'11.30 PM'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding left-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-7 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-box-left pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Thank you!'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row chat-footer-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-10 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'chat-textarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text','class':'form-control',rows:'2',cols:'50',placeholder:'Write a message'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 chat-footer-btns no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'file-field input-field mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'primary text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'fa fa-paperclip',style:{fontSize:"30px"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-8 no-padding text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','class':'primary w-75 mx-auto text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_send_svg___default.a,alt:''}))))))))));}}]);return Chat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Chat);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/download.15f95e24.svg";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/file.d907d313.svg";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/send.ce50ad40.svg";

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Field_CustomerDeptSelect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ImageTopLeft__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_picky_dist_picky_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_confirm_alert_src_react_confirm_alert_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
//components
// Include CSS
var goToTopStyling={padding:"4px",border:"0.5px solid #009688",backgroundColor:"#009688",borderRadius:"5px",color:"#fff","& :hover":{textDecoration:"none",color:"#fff !important"}};var Style=function(_Component){_inherits(Style,_Component);function Style(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Style);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Style.__proto__||Object.getPrototypeOf(Style)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,filePreviewIframe:'',isSaved:false,firstRender:true,style:{styleNumber:null,date:null,styleOrigination:null,customer:null,customerDepartmentId:null,blockRefNumber:"",refDetail:null,garmentType:null,embroidery:true,embelishment:true,setType:false,styleImage:"",MNId:null,refImages:[],reference:[]},//systemMaster styles
systemStyleValues:{FABRICTYPE:[],GARMENTTYPE:[],RANGE:[],STYLEORIGINATION:[]},customerList:[],meetingNoteList:[],oldStyleOption:[],actionedByOption:[],isLoading:false,isPositionTop:false,openModal:false,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},goBack:-1},_this.getStyleInfo=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({oldStyleOption:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.changeImg=function(files){_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_8__services__["f" /* FileUploadService */].uploadFile(files[0],"style").then(function(response){if(response.status===200){var style=Object.assign({},_this.state.style);style.styleImage=response.text.data.url;_this.setState({style:style,isLoading:false});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.creatStyle=function(e){e.preventDefault();var style=Object.assign({},_this.state.style);if(_this.state._id!==""){style._id=_this.state._id;}// Object.keys(style).forEach(keyname => {
//   if (
//     style[keyname] !== null &&
//     typeof style[keyname] == "object" &&
//     !style[keyname].isArray &&
//     keyname != "date"
//   ) {
//     style[keyname] = style[keyname].value;
//   }
// });
// style.reference = style.reference.map(ref => {
//   let data = { ...ref }
//   if (data.range && data.range.length > 0) {
//     data.range = data.range.map(dat => {
//       return dat !== "" ? dat.value : dat
//     })
//   }
//   return data
// })
__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].createStyle(style).then(function(response){if(response.status===200){var _style=response.text.data;_style.styleNumber=response.text.data.styleNumber;if(_this.state._id!=""){delete _style.reference;}_this.props.getalertMessage("success",response.text.message);_this.setState({style:Object.assign({},_this.state.style,_style),_id:response.text.data._id});}else if(response.status===401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.searchMeetingNote=function(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].searchAndSelectMeetingId(_this.state.searchMeetingNotesBy,_this.state.meetingNoteValue).then(function(response){if(response.message==="List Displayed"){_this.setState({meetingNotes:response.data});}}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.addReferenceCount=function(){var style=_this.state.style;// this.state.isSaved = false;
// Check if there are any references
if(style.reference.length>0){var lastIndex=0;var lastReference=style.reference[lastIndex];//console.log(lastReference, "lastReference", lastIndex,"las");
if(_this.state.firstRender){_this.setState({firstRender:false});// this.props.getalertMessage("error", "Please save the current reference before adding a new one.");
//  return; // Prevent adding a new reference
}else if(_this.state.isSaved===false){_this.props.getalertMessage("error","Please save the current reference before adding a new one.");return;// Prevent adding a new reference
}// Perform validation on the last reference
if(!_this.validateArrayObject2(lastReference,"actionedBy","")||!_this.validateArrayObject2(lastReference,"fabricType","")||!_this.validateArrayObject2(lastReference,"magnumStyleName","")){_this.props.getalertMessage("error","Please fill all required fields in the last reference.");return;// Prevent adding a new reference if validation fails
}}_this.setState({isSaved:false});// Proceed to add a new reference if validation passes
__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getQRCodeForReferenceStyle(_this.state._id).then(function(response){if(response.status===200){var updatedStyle=Object.assign({},_this.state.style);updatedStyle.reference=[Object.assign({},response.text.data,{fabricType:""})].concat(_toConsumableArray(updatedStyle.reference));_this.setState({style:updatedStyle});}if(response.status===401){_this.props.unauthorisedFunc();}}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.removeReferenceCount=function(index){var style=Object.assign({},_this.state.style);__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].deleteReference1(_this.state._id,style.reference[index].referenceCode).then(function(res){if(res.status==200){style.reference=style.reference.filter(function(item,i){return i!==index;});_this.setState({style:style});_this.props.getalertMessage("error",res.text.message);}if(res.status==401){_this.props.unauthorisedFunc();}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeImgForReference=function(files,index){var style=Object.assign({},_this.state.style);var reference=[].concat(_toConsumableArray(style.reference));_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_8__services__["f" /* FileUploadService */].uploadFile(files[0],"styleReference").then(function(response){if(response.status===200){reference[index].sketchImage=response.text.data.url;style.reference=reference;_this.setState({style:style,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.removeRefImage=function(index){var style=Object.assign({},_this.state.style);style.reference[index].sketchImage="";_this.setState({style:style});},_this.createReference=function(e,index){e.preventDefault();var style=Object.assign({},_this.state.style);var reference=[].concat(_toConsumableArray(style.reference));reference[index].styleId=_this.state._id;if(_typeof(reference[index].actionedBy)=="object"&&!Array.isArray(reference[index].actionedBy)){reference[index].actionedBy=reference[index].actionedBy.value;}reference[index].range=reference[index].range.map(function(data){return data!==""?data.value:data;});__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].createReference(reference[index]).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);reference[index]=response.text.data.reference[0];style.reference=reference;_this.setState({style:style});}else{_this.props.getalertMessage("error",response.text.message);}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.createOption=function(e){e.preventDefault();if(_this.state.style.styleNumber!==null){var style=Object.assign({},_this.state.style);__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getQRCodeForReferenceStyle(_this.state._id).then(function(response){if(response.status==200){var referenceobj=Object.assign({},response.text.data);style.reference.push(referenceobj);_this.setState({style:style});_this.props.getalertMessage("success",response.text.message);}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});}},_this.changeGarment=function(garmentType){var style=Object.assign({},_this.state.style);style.garmentType=garmentType;_this.setState({style:style});},_this.getStyleOrigination=function(value){__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getStyleOrigination(value).then(function(response){if(response.status===200){if(Array.isArray(response.text.data.styleOrigination)&&response.text.data.styleOrigination.length>0){_this.setState({styleOrigination:response.text.data.styleOrigination});}}}).catch(function(error){});},_this.changeStyleOrigination=function(styleOriginationVal){var style=Object.assign({},_this.state.style);style.styleOrigination=styleOriginationVal.value;_this.setState({style:style});},_this.getActionedBy=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_8__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var actionedByOption;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status===200)){_context.next=6;break;}actionedByOption=[];_context.next=4;return[].concat(_toConsumableArray(response.text.data));case 4:actionedByOption=_context.sent;_this.setState({actionedByOption:actionedByOption});case 6:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error);});}},_this.changeActionedBy=function(actionedByData,index){var style=Object.assign({},_this.state.style);style.reference[index].actionedBy=actionedByData;_this.setState({style:style});},_this.getMeetingIdList=function(value){var by="MNId";if(value!==""){__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].searchAndSelectMeetingId(by,value).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(response.status===200){_this.setState({meetingNoteList:response.text.data});}case 1:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){alert("Something Went Wrong...Try Again Later");});}},_this.changeMeetingId=function(meetingIdVal){var style=Object.assign({},_this.state.style);if(meetingIdVal){style.MNId=meetingIdVal.value;}else{style.MNId=null;}_this.setState({style:style});},_this._handleInputChange=function(name,value){var style=Object.assign({},_this.state.style);style[name]=value;_this.setState({style:style});},_this._handleInputChangeForReference=function(name,value,index){var style=Object.assign({},_this.state.style);if(name==="magnumStyleName"){// Remove leading whitespace
var sanitizedValue=value.replace(/^\s+/,"")// Remove leading whitespace
.replace(/\s{3,}/g,"  ");// Replace more than two spaces with two spaces
//console.log(sanitizedValue, "sanitizedValue");
style.reference[index][name]=sanitizedValue;}else{// Update other fields as is
style.reference[index][name]=value;}_this.setState({style:style});},_this._handleCustDeptChange=function(index,customer,customerDepartmentId){var style=Object.assign({},_this.state.style);style.customer=customer;style.customerDepartmentId=customerDepartmentId;_this.setState({style:style});},_this.changeOldRef=function(val){var style=Object.assign({},_this.state.style);if(val){style.refDetail=val.value;}else{style.refDetail=null;}_this.setState({style:style});},_this.getRefImages=function(refImages){var style=Object.assign({},_this.state.style);style.refImages=refImages;_this.setState({style:style});},_this.getRefImagesForReference=function(refImages,index){var style=Object.assign({},_this.state.style);style.reference[index].refImages=refImages;_this.setState({style:style});},_this.removeStyleImage=function(){var style=Object.assign({},_this.state.style);style.styleImage="";_this.setState({style:style});},_this.detectScroll=function(){var ele=document.getElementById("right-sec");_this.setState({isPositionTop:ele.scrollTop===0?false:true});},_this.scrollRef=function(data){if(_this.props.location.state&&_this.props.location.state.hash){_this.setState({isLoading:true});var elmnt=document.getElementById(data);console.log(elmnt,"elmntelmnt");if(elmnt!=null){elmnt.scrollIntoView({block:"start",behavior:"instant",inline:"start"});}_this.setState({isLoading:false});}},_this.checkValidation=function(data,element){if(_this.validateArrayObject(_this.state.style,"styleOrigination",null)&&_this.validateArrayObject(_this.state.style,"customer",null)&&_this.validateArrayObject(_this.state.style,"garmentType",null)){_this.creatStyle(element);}else{_this.props.getalertMessage("error","Please fill all mandatory fields");}},_this.checkValidation2=function(data,index,element){//this.state.isSaved=true
if(_this.validateArrayObject2(_this.state.style.reference[index],"actionedBy","")&&_this.validateArrayObject2(_this.state.style.reference[index],"fabricType","")&&_this.validateArrayObject2(_this.state.style.reference[index],"magnumStyleName","")){_this.createReference(element,index);_this.setState({isSaved:true});}else{_this.props.getalertMessage("error","Please fill all mandatory fields");}},_this.deleteFunc=function(id){Object(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref4){var onClose=_ref4.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-ui"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{style:{marginBottom:"17px"}},"You want to delete this Reference?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(){// this.setState({
//   isLoading: true
// });
_this.removeReferenceCount(id);_this.setState({firstRender:true});onClose();}},"Yes, Delete it!"));},closeOnClickOutside:true});},_this.modalData=function(data){var filePreviewIframe=_this.state.filePreviewIframe;filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__services__["m" /* UtilityService */].fileUrl()+data});_this.setState({filePreviewIframe:filePreviewIframe,openModal:true});},_this.goBackStyle=function(){var _this$state=_this.state,style=_this$state.style,isSaved=_this$state.isSaved,goBack=_this$state.goBack;// Check if there are any references
if(style.reference.length>0){var lastReference=style.reference[0];// Validate the fields of the last reference
var isValid=_this.validateArrayObject2(lastReference,"actionedBy","")&&_this.validateArrayObject2(lastReference,"fabricType","")&&_this.validateArrayObject2(lastReference,"magnumStyleName","");if(!isValid){// Validation failed, show a message to save the reference
Object(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref5){var onClose=_ref5.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Save the Reference"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"The last style reference is not saved. Please save it before exiting."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"OK"));},closeOnClickOutside:true});return;// Prevent navigation
}if(!isSaved&&!_this.state.firstRender){_this.setState({firstRender:false});// Show confirmation if there are unsaved changes
Object(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref6){var onClose=_ref6.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Save the Reference"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"The last style reference is not saved. Please save it before exiting."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"OK"));},closeOnClickOutside:true});return;// Prevent further action
}// If validation is successful and saved, ask for confirmation to leave
Object(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref7){var onClose=_ref7.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null," You want to leave this page?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%",marginRight:"10px"},onClick:function onClick(){onClose();// Close modal
_this.navigateBack();// Proceed with navigation
}},"Yes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"No"));},closeOnClickOutside:false});return;// Prevent navigation
}else{// No references, ask the user if they are sure they want to leave
Object(__WEBPACK_IMPORTED_MODULE_18_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref8){var onClose=_ref8.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null," You want to leave this page?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%",marginRight:"10px"},onClick:function onClick(){onClose();// Close modal
_this.navigateBack();// Proceed with navigation
}},"Yes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"No"));},closeOnClickOutside:false});return;// Prevent navigation
}},_this.navigateBack=function(){var goBack=_this.state.goBack;if(_this.props.history.location.state){var route=_this.props.history.location.state.route;if(route){_this.props.history.push({pathname:"/"+route,state:_defineProperty({},route.toLowerCase(),Object.assign({},_this.props.history.location.state[route.toLowerCase()]))});}else{goBack<-1?_this.props.history.go(goBack):_this.props.history.goBack();}}else{_this.props.history.push({pathname:"/list",state:{moduleName:"STYLE",type:"list"}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Style,[{key:"componentWillMount",value:function componentWillMount(){var _this3=this;var action=void 0,_id=void 0;if(this.props.location.state){action=this.props.location.state.action;_id=this.props.location.state._id;}else{var urlParams=new URLSearchParams(this.props.location.search);action=urlParams.get("action");_id=urlParams.get("_id");var hash=this.props.location.hash;this.props.history.replace('/StylePage',{action:action,_id:_id,hash:hash});}this.setState({action:action,_id:_id});if(action=="add"){var style=Object.assign({},this.state.style);if(this.props.location.state.MNId!==null){style.MNId=this.props.location.state.MNId;}style.date=new Date();this.setState({style:style});}if(action=="view"){this.setState({disabled:true});}if(action=="view"||action=="edit"){if(_id!==""){__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getStyleInfo(_id).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){var _style2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(response.status==200){_style2=Object.assign({},_this3.state.style);Object.keys(_style2).forEach(function(keyName){_style2[keyName]=response.text.data[keyName];});_this3.setState({style:_style2});if(response.text.data.refDetail){__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getReferenceInfo(response.text.data.refDetail).then(function(res){_this3.setState({style:Object.assign({},_this3.state.style,{refDetail:res.data?{label:res.data.refDetail?res.data.refDetail.referenceCode:"",value:res.data.refDetail?res.data.refDetail._id:""}:{}})});});}}case 1:case"end":return _context3.stop();}}},_callee3,_this3);}));return function(_x3){return _ref9.apply(this,arguments);};}()).catch(function(error){return _this3.props.getalertMessage("error",error);});}}//getSTyle
this.getStyleInfo("");__WEBPACK_IMPORTED_MODULE_8__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status==200){_this3.setState({customerList:response.text.data});}}).catch(function(error){_this3.props.getalertMessage("error",error.toString());});//meeting note no option
var by="MNId";__WEBPACK_IMPORTED_MODULE_8__services__["g" /* MeetingNotesServices */].searchAndSelectMeetingId(by).then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(response.status===200){_this3.setState({meetingNoteList:response.text.data});}case 1:case"end":return _context4.stop();}}},_callee4,_this3);}));return function(_x4){return _ref10.apply(this,arguments);};}()).catch(function(error){});__WEBPACK_IMPORTED_MODULE_8__services__["k" /* StyleServices */].getStylePrefilledData().then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(response.status===200)){_context5.next=7;break;}_context5.t0=_this3;_context5.next=4;return response.text.data;case 4:_context5.t1=_context5.sent;_context5.t2={systemStyleValues:_context5.t1};_context5.t0.setState.call(_context5.t0,_context5.t2);case 7:response.status===401&&_this3.props.unauthorisedFunc();case 8:case"end":return _context5.stop();}}},_callee5,_this3);}));return function(_x5){return _ref11.apply(this,arguments);};}()).catch(function(error){_this3.props.getalertMessage("error",error);});__WEBPACK_IMPORTED_MODULE_8__services__["h" /* PermissionServices */].searchEmploye("").then(function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(response.status===200)){_context6.next=7;break;}_context6.t0=_this3;_context6.next=4;return response.text.data;case 4:_context6.t1=_context6.sent;_context6.t2={actionedByOption:_context6.t1};_context6.t0.setState.call(_context6.t0,_context6.t2);case 7:case"end":return _context6.stop();}}},_callee6,_this3);}));return function(_x6){return _ref12.apply(this,arguments);};}()).catch(function(error){return _this3.props.getalertMessage("error",error);});setTimeout(function(){if(_this3.props.history.location&&_this3.props.history.location.state&&_this3.props.history.location.state.hash){var _hash=_this3.props.history.location.state.hash;if(/#/.test(_hash)==false){_hash="#"+_hash;}_this3.scrollRef(_hash);}},500);}//refImages Style Func start
//RefImages style end
//save style
//reference start func
// addReferenceCount = () => {
//   StyleServices.getQRCodeForReferenceStyle(this.state._id)
//     .then(response => {
//       if (response.status === 200) {
//         let style = { ...this.state.style }
//         style.reference = [{ ...response.text.data, fabricType: "" }, ...style.reference]
//         this.setState({ style })
//       }
//       response.status === 401 && this.props.unauthorisedFunc()
//     })
//     .catch(error => {
//       this.props.getalertMessage("error", error)
//     })
// }
//remove reference func
//RefImages Reference Start
//RefImages Reference end
//getMeetingIdList
// componentDidUpdate() {
//   function scrollRef(data) {
//     var elmnt = document.getElementById(data)
//     if (elmnt != null) {
//       elmnt.scrollIntoView({
//         block: "start",
//         behavior: "instant",
//         inline: "start"
//       })
//     }
//     this.setState({ isLoading: false })
//   }
//   if (this.props.location.state && this.props.location.hash) {
//     this.setState({ isLoading: true })
//     scrollRef(this.props.location.hash)
//   }
// }
// componentDidMount() {
//   if (this.props.location.state && this.props.location.state.hash) {
//     this.setState({ isLoading: true })
//     setTimeout(() => {
//       var elmnt = document.getElementById(`#${this.props.location.state.hash}`)
//       if (elmnt != null) {
//         elmnt.scrollIntoView({ behavior: "instant", block: "center" })
//         this.setState({ isLoading: false })
//       }
//       this.props.location.state.hash = null
//     }, 1000)
//   }
//    else {
//     this.setState({ isLoading: true })
//     setTimeout(() => {
//       var elmnt = document.getElementById(`${this.props.location.hash}`)
//       if (elmnt != null) {
//         elmnt.scrollIntoView({ behavior: "instant", block: "center" })
//         this.setState({ isLoading: false })
//       }
//       this.props.location.hash = null
//     }, 1000)
//     this.setState({ isLoading: false })
//   }
// }
},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data[key]!==val?true:false;return values;}},{key:"validateArrayObject2",value:function validateArrayObject2(data,key,val){if(key==="magnumStyleName"){// Check if the magnumStyleName is empty or contains only whitespace
if(!data[key]||data[key].trim()===""){return false;// Invalid if empty or whitespace-only
}}if(!data[key]){return false;}else{var values=data[key]!==val?true:false;return values;}}// Function to navigate back after confirmation
},{key:"render",// goBackStyle = () => {
//   const { style, action, firstRender, isSaved, goBack } = this.state;
//   if (style.reference.length > 0) {
//     const lastReference = style.reference[0];
//     console.log(lastReference, "re");
//     if (firstRender) {
//       this.setState({ firstRender: false });
//     } else if (!isSaved) {
//       // Alert for unsaved reference
//       confirmAlert({
//         customUI: ({ onClose }) => (
//           <div className="p-5 text-center">
//             <button onClick={onClose} className="close">X</button>
//             <h1>Save the Reference</h1>
//             <p>
//             The last style reference is not saved. Please save it before exiting
//             </p>
//             <button
//               type="button"
//               className="primary"
//               style={{ width: "20%" }}
//               onClick={onClose}
//             >
//               OK
//             </button>
//           </div>
//         ),
//         closeOnClickOutside: true,
//       });
//       return; // Prevent further action
//     }
//     // Validate the fields of the last reference
//     if (
//       !this.validateArrayObject2(lastReference, "actionedBy", "") ||
//       !this.validateArrayObject2(lastReference, "fabricType", "") ||
//       !this.validateArrayObject2(lastReference, "magnumStyleName", "")
//     ) {
//       confirmAlert({
//         customUI: ({ onClose }) => (
//           <div className="p-5 text-center">
//             <button onClick={onClose} className="close">X</button>
//             <h1>Save the Reference</h1>
//             <p>
//             The last style reference is not saved. Please save it before exiting
//             </p>
//             <button
//               type="button"
//               className="primary"
//               style={{ width: "20%" }}
//               onClick={onClose}
//             >
//               OK
//             </button>
//           </div>
//         ),
//         closeOnClickOutside: true,
//       });
//       return; // Prevent further action
//      }
//     // // Navigate back
//      //this.navigateBack();
//   }else {
//     // If no reference, show confirmation for leaving the page
//     confirmAlert({
//       customUI: ({ onClose }) => (
//         <div className="p-5 text-center">
//           <button onClick={onClose} className="close">X</button>
//           <h1>Are you sure?</h1>
//           <p>There are unsaved changes. Are you sure you want to leave this page?</p>
//           <button
//             type="button"
//             className="primary"
//             style={{ width: "20%" }}
//             onClick={() => {
//               onClose(); // Close modal
//               this.navigateBack(); // Proceed with navigation
//             }}
//           >
//             Yes
//           </button>
//           <button
//             type="button"
//             className="secondary"
//             style={{ width: "20%" }}
//             onClick={onClose}
//           >
//             No
//           </button>
//         </div>
//       ),
//       closeOnClickOutside: false,
//     });
//     return; // Prevent navigation
//   }
//   // if(style.reference.length === 0){
//   //   confirmAlert({
//   //     customUI: ({ onClose }) => (
//   //       <div className="p-5 text-center">
//   //         <button onClick={onClose} className="close">X</button>
//   //         <h1>Save the Reference</h1>
//   //         <p>
//   //         The last style reference is not saved. Please save it before exiting
//   //         </p>
//   //         <button
//   //           type="button"
//   //           className="primary"
//   //           style={{ width: "20%" }}
//   //           onClick={onClose}
//   //         >
//   //           OK
//   //         </button>
//   //       </div>
//   //     ),
//   //     closeOnClickOutside: true,
//   //   });
//   //   return; 
//   // }
// };
// navigateBack = () => {
//   const { goBack } = this.state;
//   if (this.props.history.location.state) {
//     const { route } = this.props.history.location.state;
//     if (route) {
//       this.props.history.push({
//         pathname: `/${route}`,
//         state: {
//           [route.toLowerCase()]: {
//             ...this.props.history.location.state[route.toLowerCase()],
//           },
//         },
//       });
//     } else {
//       goBack < -1
//         ? this.props.history.go(goBack)
//         : this.props.history.goBack();
//     }
//   } else {
//     this.props.history.push({
//       pathname: "/list",
//       state: {
//         moduleName: "STYLE",
//         type: "list",
//       },
//     });
//   }
// };
// goBackStyle = () => {
//   const { style, action, firstRender, isSaved, goBack } = this.state;
//   // Check if there are any references
//   if (style.reference.length > 0) {
//     const lastReference = style.reference[0];
//     console.log(lastReference, "re");
//     // Handle first render logic
//     if (firstRender) {
//       this.setState({ firstRender: false });
//       return;
//     }
//     // Validate the fields of the last reference
//     if (
//       !this.validateArrayObject2(lastReference, "actionedBy", "") ||
//       !this.validateArrayObject2(lastReference, "fabricType", "") ||
//       !this.validateArrayObject2(lastReference, "magnumStyleName", "")
//     ) {
//       // Show alert if validation fails
//       confirmAlert({
//         customUI: ({ onClose }) => (
//           <div className="p-5 text-center">
//             <button onClick={() => onClose()} className="close">X</button>
//             <h1>Incomplete Reference</h1>
//             <p>
//               The last reference of the style is incomplete. Please fill in the
//               required fields or delete the reference before exiting.
//             </p>
//             <button
//               type="button"
//               className="primary"
//               style={{ width: "20%" }}
//               onClick={() => onClose()}
//             >
//               OK
//             </button>
//           </div>
//         ),
//         closeOnClickOutside: true,
//       });
//       return; // Prevent navigation
//     }
//     // Check if the reference is saved
//     if (!isSaved) {
//       confirmAlert({
//         customUI: ({ onClose }) => (
//           <div className="p-5 text-center">
//             <button onClick={() => onClose()} className="close">X</button>
//             <h1>Save the Reference</h1>
//             <p>
//               The last reference of the style is not saved. Please save the
//               reference before exiting.
//             </p>
//             <button
//               type="button"
//               className="primary"
//               style={{ width: "20%" }}
//               onClick={() => onClose()}
//             >
//               OK
//             </button>
//           </div>
//         ),
//         closeOnClickOutside: true,
//       });
//       return; // Prevent adding a new reference
//     }
//     // Handle navigation
//     if (this.props.history.location.state) {
//       const { route } = this.props.history.location.state;
//       if (route !== undefined) {
//         this.props.history.push(`/${route}`, {
//           [`${route.toLowerCase()}`]: {
//             ...this.props.history.location.state[`${route.toLowerCase()}`],
//           },
//         });
//       } else if (goBack < -1) {
//         this.props.history.go(goBack);
//       } else {
//         this.props.history.goBack();
//       }
//     } else {
//       this.props.history.push({
//         pathname: "/list",
//         state: {
//           moduleName: "STYLE",
//           type: "list",
//         },
//       });
//     }
//   } else {
//     // Handle navigation when there are no references
//     if (this.props.history.location.state) {
//       const { route } = this.props.history.location.state;
//       if (route !== undefined) {
//         this.props.history.push(`/${route}`, {
//           [`${route.toLowerCase()}`]: {
//             ...this.props.history.location.state[`${route.toLowerCase()}`],
//           },
//         });
//       } else if (goBack < -1) {
//         this.props.history.go(goBack);
//       } else {
//         this.props.history.goBack();
//       }
//     } else {
//       this.props.history.push({
//         pathname: "/list",
//         state: {
//           moduleName: "STYLE",
//           type: "list",
//         },
//       });
//     }
//   }
// };
value:function render(){var _this4=this;var _state2=this.state,style=_state2.style,systemStyleValues=_state2.systemStyleValues;//console.log(this.state.isSaved,"issaved",this.state.firstRender,"fr")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"right-sec","class":"right-section bg-white"// onScroll={e => this.detectScroll()}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{id:"addStyle"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"left-content-section-style no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col text-center bg-none pb-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"text-green font-lg font-weight-bold mt-2"},this.state.style.styleNumber!==null?this.state.style.styleNumber:""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col nopadding mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ImageTopLeft__["a" /* default */],{image:style.styleImage,removeImage:this.removeStyleImage,fileUpload:this.changeImg,disabled:this.state.disabled,modalData:this.modalData})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-content-section-style overflow-scroll "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 text-center p-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-header-style"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":this.state.isPositionTop?"position-top-back":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover text-left",onClick:function onClick(){_this4.goBackStyle();// if (this.props.history.location.state) {
//   const { route } = this.props.history.location.state
//   route !== undefined
//     ? this.props.history.push(`/${route}`, {
//       [`${route.toLowerCase()}`]: {
//         ...this.props.history.location.state[
//         `${route.toLowerCase()}`
//         ]
//       }
//     })
//     : this.state.goBack < -1
//       ? this.props.history.go(this.state.goBack)
//       : this.props.history.goBack()
// } else {
//   this.props.history.push({
//     pathname: "/list",
//     state: {
//       moduleName: 'STYLE',
//       type: "list"
//     }
//   })
// }
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_4__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"top"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,"Style")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Common_audit__["a" /* default */],{_id:this.state._id,moduleName:"style"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary pull-right bulk-padding-margin px-3 py-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons font-for-icon-big"},"file_download")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary pull-right bulk-padding-margin px-3 py-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons font-for-icon-big"},"print"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",inputName:"date",label:"Date",value:style.date,onChange:this._handleInputChange,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"item"},"Meeting Note No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"MNId",value:style.MNId,onInputChange:this.getMeetingIdList,onChange:function onChange(val){return _this4.changeMeetingId(val);},placeholder:"Meeting Id",options:this.state.meetingNoteList,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"styleOrigination",label:"Style Origination*",value:style.styleOrigination,options:this.state.systemStyleValues.STYLEORIGINATION,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 step-one pt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Field_CustomerDeptSelect__["a" /* default */],{options:this.state.customerList,value:style.customer+"-"+style.customerDepartmentId,onChange:this._handleCustDeptChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"ref-no"},"Old Magnum Ref"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"refDetail",value:style.refDetail,onInputChange:this.getStyleInfo,onChange:function onChange(val){return _this4.changeOldRef(val);},placeholder:"Find style no.",options:this.state.oldStyleOption,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"blockRefNumber",label:"Block ref number",value:style.blockRefNumber,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"garmentType",label:"Garment Type*",value:style.garmentType,options:systemStyleValues.GARMENTTYPE,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embroidery",value:style.embroidery,label:"Embroidery",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embelishment",value:style.embelishment,label:"Embelishment",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"setType",value:style.setType,label:"set",onChange:this._handleInputChange,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 col px-5 mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"style",getRefImages:this.getRefImages,disabled:this.state.disabled,uploadedDocs:style.refImages.length>0?style.refImages:null,imageTypeOption:this.state.systemStyleValues.IMAGETYPE?this.state.systemStyleValues.IMAGETYPE:[]})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center pb-2"},this.state._id!=""&&style.reference.length==0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Create Option",onClick:!this.state.disabled?this.createOption:function(){_this4.props.getalertMessage("info","View option only enable");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Save",onClick:!this.state.disabled?function(e){return _this4.checkValidation("save",e);}:function(){_this4.props.getalertMessage("info","View option only enable");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Back",onClick:function onClick(){return _this4.goBackStyle();}})))),style.styleNumber!==null&&style.reference.length>0&&style.reference.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding mt-3",id:"#seleted"+data.referenceCode.split("-").join("")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"left-content-section-style nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col text-center bg-color "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col nopadding mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ImageTopLeft__["a" /* default */],{image:data.sketchImage,removeImage:function removeImage(){return _this4.removeRefImage(index);},fileUpload:function fileUpload(files){return _this4.changeImgForReference(files,index);},disabled:_this4.state.disabled,modalData:_this4.modalData})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col mt-4 height-for-image-div"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex  align-items-center justify-content-center h-100 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:data.qrCode}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-content-section-style overflow-scroll"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 product-form no-padding margin-variation"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:index===0&&_this4.state.isPositionTop?"positioing-end margin-variation-negative position-top":"positioing-end margin-variation-negative"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{style:index===0?{display:"block",marginLeft:"7px"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light green pull-right "+(_this4.state.disabled?"d-none":""),onClick:function onClick(e){_this4.addReferenceCount();// this.setState({
//   goBack: this.state.goBack - 1
// })
// setTimeout(() => {
//   this.props.history.push(
//     `/StylePage#seleted${style.reference[0].referenceCode
//       .split("-")
//       .join("")}`
//   )
// }, 600)
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons"},"add")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{// style={
//   index !== 0
//     ? { display: "block" }
//     : { display: "none" }
// }
"class":"btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right "+(_this4.state.disabled?"d-none":""),id:"del-sample-size-btn pull-rog pull-right",onClick:function onClick(e){if(_this4.props.rights.web.delete){_this4.deleteFunc(index);}else{_this4.props.getalertMessage('info',"You don't have permission");}}// onClick={e => }
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"clear"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-1 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"item"},"Reference"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,data.referenceCode)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"item"},"Range"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_picky___default.a,{value:data.range,options:systemStyleValues.RANGE,onChange:function onChange(val){return _this4._handleInputChangeForReference("range",val,index);},open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"No Items selected",disabled:_this4.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"phone"},"Actioned By",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-danger madatory-asterisk"},"*")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"actionedBy",value:data.actionedBy,onFocus:function onFocus(){return _this4.getActionedBy("");}// onInputChange={this.getActionedBy}
,onChange:function onChange(data){return _this4.changeActionedBy(data,index);},placeholder:"actionedBy",options:_this4.state.systemStyleValues.ACTIONEDBY||[],disabled:_this4.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"customerRefNumber",label:" Customer Ref No",value:data.customerRefNumber,index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"itemNumber",label:"Item No",value:data.itemNumber,index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"referenceColor",label:"Reference Color",value:data.referenceColor,index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"fabricType",value:data.fabricType,options:systemStyleValues.FABRICTYPE,label:"Fabric Type*",index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"magnumStyleName",label:"Magnum Style Name*",value:data.magnumStyleName,max:40,index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"buyerStyleName",label:"Buyer Style Name",value:data.buyerStyleName,index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"season",label:"Season",value:data.season,index:index,options:_this4.state.systemStyleValues.SEASONS,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one pr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"washApplicable",value:data.washApplicable,label:" wash applicable",index:index,onChange:_this4._handleInputChangeForReference,disabled:_this4.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-5 mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FileUpload_FileUpload__["a" /* default */],{getRefImages:_this4.getRefImagesForReference,moduleName:"styleReference",index:index,Heading:"Upload Images",uploadedDocs:data.refImages.length>0?data.refImages:null,imageTypeOption:[]}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",name:"button","class":"primary mr-2",onClick:_this4.state.disabled==false?function(e){return _this4.checkValidation2("save",index,e);}:function(){_this4.props.getalertMessage("info","View option only enable");}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",name:"button","class":"primary mr-2","data-toggle":"modal","data-target":"#req_modal",onClick:function onClick(){return _this4.props.history.push("/list",{moduleName:"SAMPLEREQUEST",type:"list",referenceId:data._id});}}," ","View Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this4.props.history.push("/Sample",{referenceId:data._id,styleId:_this4.state._id,action:"add",setStyleId:true,_id:""});},className:"primary m-1 "+(_this4.state.disabled?"d-none":"")},"Create Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this4.props.history.push("/createIB",{referenceId:data._id,styleId:_this4.state._id,action:"add",_id:""});},className:"primary m-1 "+(_this4.state.disabled?"d-none":"")},"Create IB"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonName:"View IB",onClick:function onClick(){return _this4.props.history.push("/list",{moduleName:"CREATEIB",type:"list",referenceId:data._id});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Back",onClick:function onClick(){return _this4.goBackStyle();}})),style.styleNumber!==null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center pt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonName:"View SMV/OB & Thread Consumption",onClick:function onClick(){return _this4.props.history.push("/list",{moduleName:"SMVTHREAD",type:"list",referenceId:data._id});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonName:" SMV/OB & Thread Consumption",onClick:function onClick(){return _this4.props.history.push("/SmvThread",{styleReferenceId:data._id,// styleId: this.state._id,
// styleNumber: this.state.style
//   .styleNumber,
action:"add",_id:""});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{title:"Create Technical Issues",buttonName:"Create TI",onClick:function onClick(){return _this4.props.history.push("/technicalIssues",{styleReferenceId:data._id,action:"add",_id:""});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{title:"View Technical Issues",buttonName:"View TI",onClick:function onClick(){return _this4.props.history.push("/list",{moduleName:"TECHNICALISSUES",type:"list",referenceId:data._id});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Buttons_Button__["a" /* default */],{buttonName:"Go to Top",onClick:function onClick(){var elmnt=document.getElementById('top');if(elmnt!=null){elmnt.scrollIntoView({block:"start",behavior:"smooth",inline:"start"});}}}))));}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"myModal","class":"modal fade",role:"dialog"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"modal-dialog"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"modal-content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"modal-body no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"meeting-min-con"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-8 product-form no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"phone"},"Search Style"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"BY"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{"class":"form-control",name:"",onChange:function onChange(e){return _this4.setState({searchMeetingNotesBy:e.target.value});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"MNId"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"customerName"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"customerDepartment"},"Departement Name"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"ref-no"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"FOR"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control",name:"meetingNoteValue",value:this.state.meetingNoteValue,onChange:function onChange(e){return _this4.setState({meetingNoteValue:e.target.value});}}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4 product-form"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 mm-btns",style:{marginTop:"20%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",name:"button",onClick:function onClick(e){return _this4.searchMeetingNote(e);}},"Search")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"table-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"striped"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"num"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"name"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"name"},"Deptartment Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"act"},"Action"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"select"},"Select"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.meetingNotes!==undefined&&Array.isArray(this.state.meetingNotes)&&this.state.meetingNotes.length>0&&this.state.meetingNotes.map(function(meetingNote,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,meetingNote.MNId!==null&&meetingNote.MNId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,meetingNote.customerName!==null&&meetingNote.customerName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,meetingNote.customerDepartmentName!==null&&meetingNote.customerDepartmentName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"","class":"view",title:"View",onClick:function onClick(){return _this4.props.history.push("/viewMeeting?"+meetingNote._id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"visibility"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"radio",name:"gender","data-dismiss":"modal","class":"sourcingOption",onClick:function onClick(){return _this4.setState({MNId:meetingNote.MNId,meetingNoteId:meetingNote._id});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null)));}))))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this4.setState({openModal:false});},s:true,center:true},this.state.filePreviewIframe));}}]);return Style;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights.style};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,null)(Style));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CreateIBComponents_StyleInfo_StyleInfo__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CreateIBComponents_uploadSectionOrder_UploadSection__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FileUploadButton_FileUploadButton__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var CreateIB=function(_Component){_inherits(CreateIB,_Component);function CreateIB(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreateIB);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateIB.__proto__||Object.getPrototypeOf(CreateIB)).call.apply(_ref,[this].concat(args))),_this),_this.state={uploadedFiles:[],//style
styleInfo:{},additionalStyleInformation:"",styleId:"",referenceid:"",// order objects
order:{},orderFileUpload:[],data:[{}],//order upload fileTypes
categories:["Order Confirmation - Booking Form","Buyer CP","Price Confirmation Email","SCS/NPS/OCS","Testing Docs","Supplier Details","Others","CAD Marker"],//garmentprocess
garmentProcess:{},//fabric
fabric:{},//trims
trims:[{}],trimAdditionalInfo:"",//embroidery
embroiedry:{backing:false},backingData:{},emblishmentDetails:{bitAttaching:false},embroiedryLeftValue:["Bit Attaching","Cutting","Embroidery","Recut","Garment Made","Sample Made","Block Cutting"],embroiedryRightValue:[],emb:[{}],selectedValueLeft:"",selectedValueRight:"",//sealingDetails
sealingDetails:{},//otherDetails
otherDetails:{},isLoading:false},_this.updateValueForkeys=function(keyName,name,value){var obj=Object.assign({},_this.state[keyName]);obj[name]=value;_this.setState(_defineProperty({},keyName,obj));},_this.updateAdditionalStyleInfo=function(value){_this.setState({additionalStyleInformation:value});},_this.moveToRight=function(){if(_this.state.selectedValueLeft!==""){var embroiedryRightValue=[].concat(_toConsumableArray(_this.state.embroiedryRightValue));var embroiedryLeftValue=[].concat(_toConsumableArray(_this.state.embroiedryLeftValue));embroiedryRightValue.push(_this.state.embroiedryLeftValue[_this.state.selectedValueLeft]);embroiedryLeftValue.splice(_this.state.selectedValueLeft,1);_this.setState({embroiedryRightValue:embroiedryRightValue,embroiedryLeftValue:embroiedryLeftValue});}},_this.moveToLeft=function(){if(_this.state.selectedValueRight!==""){var embroiedryRightValue=[].concat(_toConsumableArray(_this.state.embroiedryRightValue));var embroiedryLeftValue=[].concat(_toConsumableArray(_this.state.embroiedryLeftValue));embroiedryLeftValue.push(_this.state.embroiedryRightValue[_this.state.selectedValueRight]);embroiedryRightValue.splice(_this.state.selectedValueRight,1);_this.setState({embroiedryRightValue:embroiedryRightValue,embroiedryLeftValue:embroiedryLeftValue});}},_this.moveToTop=function(){if(_this.state.selectedValueRight!==""&&_this.state.embroiedryRightValue.length>0&&_this.state.selectedValueRight!=0){var embroiedryRightValue=[].concat(_toConsumableArray(_this.state.embroiedryRightValue));var temp="";temp=embroiedryRightValue[_this.state.selectedValueRight-1];embroiedryRightValue[_this.state.selectedValueRight-1]=embroiedryRightValue[_this.state.selectedValueRight];embroiedryRightValue[_this.state.selectedValueRight]=temp;_this.setState({embroiedryRightValue:embroiedryRightValue});}},_this.moveToBottom=function(){if(_this.state.selectedValueRight!==""&&_this.state.embroiedryRightValue.length>0&&_this.state.selectedValueRight!=_this.state.embroiedryRightValue.length-1){var embroiedryRightValue=[].concat(_toConsumableArray(_this.state.embroiedryRightValue));var temp="";temp=embroiedryRightValue[+_this.state.selectedValueRight+ +1];embroiedryRightValue[+_this.state.selectedValueRight+ +1]=embroiedryRightValue[_this.state.selectedValueRight];embroiedryRightValue[_this.state.selectedValueRight]=temp;_this.setState({embroiedryRightValue:embroiedryRightValue});}},_this.embPlacementAdd=function(){var emb=[].concat(_toConsumableArray(_this.state.emb));emb.push({});_this.setState({emb:emb});},_this.removeEmbPlacement=function(i){var emb=[].concat(_toConsumableArray(_this.state.emb));emb.splice(i,1);_this.setState({emb:emb});},_this.updateEmbValues=function(i,name,value){var emb=[].concat(_toConsumableArray(_this.state.emb));emb[i][name]=value;_this.setState({emb:emb});},_this.addDataOrder=function(){var data=[].concat(_toConsumableArray(_this.state.data));data.push({});_this.setState({data:data});},_this.removeDataOrder=function(i){var data=[].concat(_toConsumableArray(_this.state.data));data.splice(i,1);_this.setState({data:data});},_this.uploadFiles=function(e){var files=e.target.files==1?e.target.files[0]:e.target.files;__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].uploadNewImage(files).then(function(response){if(response.message==="Operation Successful"){var orderFileUpload=[].concat(_toConsumableArray(_this.state.orderFileUpload));response.data.map(function(value){orderFileUpload.push({path:value,fileType:""});});_this.setState({orderFileUpload:orderFileUpload});}}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.selectCategory=function(value,i){var orderFileUpload=[].concat(_toConsumableArray(_this.state.orderFileUpload));orderFileUpload[i].fileType=value;_this.setState({orderFileUpload:orderFileUpload});},_this.addTrims=function(){var trims=[].concat(_toConsumableArray(_this.state.trims));trims.push({});_this.setState({trims:trims});},_this.removeTrims=function(i){var trims=[].concat(_toConsumableArray(_this.state.trims));trims.splice(i,1);_this.setState({trims:trims});},_this.updateTrimsValues=function(i,e){var trims=[].concat(_toConsumableArray(_this.state.trims));trims[i][e.target.name]=e.target.value;_this.setState({trims:trims});},_this.saveIb=function(e){e.preventDefault();var data={};//embroidery data
data.embroiedry=_this.state.embroiedry;data.embroiedry.emb=_this.state.emb;data.embroiedry.backingData=_this.state.backingData;data.embroiedry.array1=_this.state.embroiedryLeftValue;data.embroiedry.array2=_this.state.embroiedryRightValue;//order data
data.order=_this.state.order;data.order.data=_this.state.data;var orderFileUpload=[].concat(_toConsumableArray(_this.state.orderFileUpload));var orderFileUploadDup=[];orderFileUpload.map(function(data,index){orderFileUploadDup.push({path:data.path,fileType:data.fileType.slice(0,-1)});});data.order.orderFileUpload=orderFileUploadDup;//garmentprocess data
data.garmentProcess=_this.state.garmentProcess;//emblishmentdetails data
data.emblishmentDetails=_this.state.emblishmentDetails;//sealingdetails data
data.sealingDetails=_this.state.sealingDetails;//otherdetails data
data.otherDetails=_this.state.otherDetails;//magnumStyleid
data.magnumStyleId=_this.state.styleId;//referenceid
data.styleReferenceId=_this.state.referenceid;__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].saveIB(data).then(function(response){if(response.status===200){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this.msg);_this.props.history.push("/list",{moduleName:"STYLE"});}}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.historyGo=function(){// console.log(this.props.history, "historyGo");
_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreateIB,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _props$location$state=this.props.location.state,referenceId=_props$location$state.referenceId,styleId=_props$location$state.styleId;__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getOptionsStyle(styleId,referenceId).then(function(response){if(response.status==200){_this2.setState({styleInfo:response.text.data,isLoading:true,referenceId:referenceId,styleId:styleId});}}).catch(function(error){return _this2.props.getalertmessage("error",error.toString());});}//style func
//embroidery func start
//embPlacementAdd
// embroidery func end
//order section func start
//fileType func
//order section func end
//Trims section func start
},{key:"render",value:function render(){var _this3=this,_React$createElement,_React$createElement2,_React$createElement3,_React$createElement4,_React$createElement5,_React$createElement6;// if (
//   this.state.styleInfo !== undefined &&
//   Object.keys(this.state.styleInfo).length !== 0 &&
//   this.state.styleInfo.constructor === Object
// ) {
var styleInfo=this.state.styleInfo;var styleImage=styleInfo.styleImage?"http://192.168.10.121:2024/"+styleInfo.styleImage:__WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png___default.a;return this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-2 cursor-hover text-left",onClick:function onClick(){return _this3.historyGo();},title:"Go Back"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-center p-2 pull-right"},"Create IB")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary pull-right px-2 py-1 mr-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"fa fa-calendar-check-o font-for-icon-big"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-11 nopadding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"text-center text-green"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Style Information"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CreateIBComponents_StyleInfo_StyleInfo__["a" /* default */],{styleInfo:styleInfo,styleImage:styleImage,onChange:this.updateAdditionalStyleInfo})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Order Details"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Tentative Order Confirm Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",placeholder:"",name:"tentativeOrderConfirmDate",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Link to Costsheet"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-md-6",placeholder:"",name:"costSheet",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Order hand Over"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",placeholder:"",name:"orderHandOver",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib","class":"active col-md-6"},"Agreed PRice"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-md-6",placeholder:"100.00",name:"agreedPrice",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"PCD at Hand Over"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",placeholder:"",name:"PCDAtHandOver",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib","class":"active col-md-6"},"Buying house Margin %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-md-6",placeholder:"10",name:"buyingHouseMargin",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"address"},"Packaging method"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"packingMethod",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Hanging"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Boxed")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"address"},"Shipping Mode"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"shippingMethod",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Hanging"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Boxed")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"address"},"Packaging Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"packingType",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Hanging"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pack"},"Boxed")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"address"},"Shipment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-md-6",name:"shipmentTerm",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}})))),this.state.data.map(function(aa,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 my-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib","class":"active"},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-xs-5",placeholder:"10",name:"quantity",onChange:function onChange(e){var data=[].concat(_toConsumableArray(_this3.state.data));data[i][e.target.name]=e.target.value;_this3.setState({data:data});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"active"},"Shipment Date/ into DC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",placeholder:"",name:"shipDate",onChange:function onChange(e){var data=[].concat(_toConsumableArray(_this3.state.data));data[i][e.target.name]=e.target.value;_this3.setState({data:data});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"active"},"Ex-factory Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",placeholder:"",name:"exFactory",onChange:function onChange(e){var data=[].concat(_toConsumableArray(_this3.state.data));data[i][e.target.name]=e.target.value;_this3.setState({data:data});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"add-address"},i==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this3.addDataOrder();},"class":"btn-floating btn-small waves-effect waves-light green address-click-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"add")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this3.removeDataOrder(i);},"class":"btn-floating btn-small waves-effect waves-light red address-click-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"clear"))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 my-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null," Total Qty: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_CreateIBComponents_uploadSectionOrder_UploadSection__["a" /* default */],{onChangeFileFunc:this.uploadFiles,categories:this.state.categories,onChangeCategoryFunc:this.selectCategory,orderFileUpload:this.state.orderFileUpload})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary",name:"button"},"SMV/OB CALCULATION/THREAD CONSUMPTION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary ml-2",name:"button"},"TECHNICAL ISSUES")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{name:"additionalInfo","class":"form-control",rows:"4",cols:"80",onChange:function onChange(e){return _this3.updateValueForkeys("order",e.target.name,e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Garment Process"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 my-3 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Process Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"processType",onChange:function onChange(e){return _this3.updateValueForkeys("garmentProcess",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Acid Wash"},"Acid Wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Soft Washz"},"Soft Wash")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Tolerance"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"toleranceSheet",onChange:function onChange(e){return _this3.updateValueForkeys("garmentProcess",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Requested/not requested")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Laundry Unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"LaundryUnit",onChange:function onChange(e){return _this3.updateValueForkeys("garmentProcess",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Evershine"},"Evershine")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Recipe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"upload-box",style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_FileUploadButton_FileUploadButton__["a" /* default */],{onChange:function onChange(){}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 my-3 style-td-border"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{padding:"15px 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item","class":""},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{name:"additionalInfo","class":"form-control",rows:"4",cols:"80",onChange:function onChange(e){return _this3.updateValueForkeys("garmentProcess",e.target.name,e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light green pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"add"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"FABRIC NO"),true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"positioing-end pr-3",onClick:function onClick(e){return _this3.changeToggleList(e,"dispatch");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-up"})):React.createElement("span",{className:"positioing-end pr-3",onClick:function onClick(e){return _this3.changeToggleList(e,"dispatch");}},React.createElement("i",{className:"fa fa-angle-down"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Fabric Details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-light ib-list-view"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Position"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"Position",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Fabric No "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"42590"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Fabric origination "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"fabricOrigination",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Development Type "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"developmentType",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Submission Date "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"submissionDate",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Approval Date "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"approvalDate",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1st of Bulk Submission ETA "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"firstOfBulkSubmissionETA",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Flow Start "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"flowStart",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Flow Stop"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"flowStop",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Are you working on options?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"isWorkingOnOptions",onChange:function onChange(e){return _this3.setState(_defineProperty({},e.target.name,e.target.value));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"yes"},"Yes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"no"},"No"))))),this.state.isWorkingOnOptions==="yes"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Development Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"developmentType",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"no"},"Labdip"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1st Submission Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"firstSubmissionDate",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"2nd Submission Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"secondSubmissionDate",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Flow Start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"flowStart2",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Flow Stop"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"flowStop2",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Sealer Ydg"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"sealerYdg",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"no"},"Labdip"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"sealerYdg",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"no"},"Labdip"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"ETA "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control",name:"approvalDate",onChange:function onChange(e){return _this3.updateValueForkeys("fabric",e.target.name,e.target.value);}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Testing Details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-light ib-list-view"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Base Approval Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"baseApproval",onChange:function onChange(e){return _this3.updateValueForkeys("testDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"BNO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"42590"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Can you proceed with FOM?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"processWithFOM",onChange:function onChange(e){return _this3.updateValueForkeys("testDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Magnum Risk"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"magnumRisk",onChange:function onChange(e){return _this3.updateValueForkeys("testDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"slct"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"wash"},"Evershine"))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 py-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group form-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ib","class":"active"},"Fabric Ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-xs-5 ml-1",placeholder:"10"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group form-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"active"},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control ml-1",placeholder:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"pt-2"},"Check Report")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_FileUploadButton_FileUploadButton__["a" /* default */],{onChange:function onChange(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 view-ib-right style-td-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list-inline pt-3"},this.state.uploadedFiles.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index,className:"img-responsive-fill-list p-3"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:window.URL.createObjectURL(image),className:"mr-2"}));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Trims"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding thickBorder p-3"},this.state.trims.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,i==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this3.addTrims();},"class":"btn-floating btn-small waves-effect waves-light green address-click-btn pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"add")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this3.removeTrims(i);},"class":"btn-floating btn-small waves-effect waves-light red address-click-btn pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"clear")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Trim Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Trim Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Supplier"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Price/Unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Trigger Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Col Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"},"Labdip ETA"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"9.09090909091%"}," ","Special Trims Testing"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"category",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"button"},"Button"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"trimRefNumber",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"description",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"quality",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"price",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"supplier",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"size",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"triggerDate",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"colStatus",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"labDipETA",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"TBU-101",name:"leadTime",onChange:function onChange(e){return _this3.updateTrimsValues(i,e);}}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{padding:"15px 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item","class":""},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{name:"trimAdditionalInfo","class":"form-control",rows:"4",cols:"80",onChange:function onChange(e){_this3.setState({trimAdditionalInfo:e.target.value});}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title",style:{paddingBottom:"10px",float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Embroidery"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"embroideryForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Emb Design"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"embDesign",onChange:function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"approved"},"Approved"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notapproved"},"Not Approved")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-4 active","for":"item"},"Design Sheet"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-4",name:"designSignSheet",onChange:function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"attached"},"Attached"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notattached"},"Not Attached")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"upload-box col-md-4",style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_FileUploadButton_FileUploadButton__["a" /* default */],{onChange:function onChange(){}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Grading"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"grading",onChange:function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"agreed"},"Agreed"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notagreed"},"Not Agreed")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"smocking",value:this.state.smocking,label:"Bit Attaching",onChange:function onChange(name,value){return _this3.setState(_defineProperty({},name,value));},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Emb Thread Approval"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"embThreadApproval",onChange:function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"approved"},"Approved"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notapproved"},"Not Approved")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Further Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control col-md-6",name:"furtherInfo",onChange:function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 embroid-mul"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box1",checked:this.state.embroiedry.cutPanel,onChange:function onChange(e){var embroidery=Object.assign({},_this3.state.embroiedry);embroidery.cutPanel!=_this3.state.embroiedry.cutPanel;_this3.setState({embroidery:embroidery});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box1"},"Cut Panel"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box2",checked:this.state.embroiedry.allOver,onChange:function onChange(e){var embroidery=Object.assign({},_this3.state.embroiedry);embroidery.allOver!=_this3.state.embroiedry.allOver;_this3.setState({embroidery:embroidery});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box2"},"All Over"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box3",checked:this.state.embroiedry.garmentForm,onChange:function onChange(e){var embroidery=Object.assign({},_this3.state.embroiedry);embroidery.garmentForm!=_this3.state.embroiedry.garmentForm;_this3.setState({embroidery:embroidery});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box3"},"Garment Form"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box4",checked:this.state.embroiedry.semiGarmentForm,onChange:function onChange(e){var embroidery=Object.assign({},_this3.state.embroiedry);embroidery.semiGarmentForm!=_this3.state.embroiedry.semiGarmentForm;_this3.setState({embroidery:embroidery});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box4"},"Semi garment Form"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box5",checked:this.state.embroiedry.tassle,onChange:function onChange(e){var embroidery=Object.assign({},_this3.state.embroiedry);embroidery.tassle!=_this3.state.embroiedry.tassle;_this3.setState({embroidery:embroidery});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box5"},"Tassle")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8 col-md-offset-2 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-allocation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-alloc-con process-left-con col-md-4 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"mySelect",className:"mySelectLeft",size:"10",style:{display:"block"},onChange:function onChange(e){_this3.setState({selectedValueLeft:e.target.value});}},this.state.embroiedryLeftValue.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:i},data);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-left-arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",onClick:function onClick(){return _this3.moveToRight();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"up"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",onClick:function onClick(){return _this3.moveToBottom();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-down"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-alloc-con col-md-4 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"mySelect2",className:"mySelectRight",size:"10",style:{display:"block"},onChange:function onChange(e){_this3.setState({selectedValueRight:e.target.value});}},this.state.embroiedryRightValue.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:i},data);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-nav-arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",onClick:function onClick(){return _this3.moveToTop();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"up"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-up"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",onClick:function onClick(){return _this3.moveToLeft();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Emb Placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Emb form"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"No of Colors"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Frames"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Stitches/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Consumption/Unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Stitches Count"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Prices/1000 Stitches"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Total(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.emb.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"",name:"embPlacement",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"",name:"embForm",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"noOfCols",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:1},"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:2},"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:3},"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:4},"4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:5},"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:6},"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:7},"7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:8},"8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:9},"9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:10},"10"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"frames",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:1},"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:2},"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:3},"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:4},"4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:5},"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:6},"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:7},"7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:8},"8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:9},"9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:10},"10"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"stitchesPerMrt",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"consumption",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"stitchesCount",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"pricePer1000Stitches",onChange:function onChange(e){return _this3.updateEmbValues(i,e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"totalValue",value:(_this3.state.emb[i].stitchesCount*_this3.state.emb[i].pricePer1000Stitches/1000).toFixed(2)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 pt-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:i===0?{display:"block"}:{display:"none"},"class":"btn-floating btn-small waves-effect waves-light green pull-right",onClick:function onClick(e){return _this3.embPlacementAdd();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:i!==0?{display:"block"}:{display:"none"},className:"btn-floating btn-small waves-effect waves-light red del-customer-info-btn pull-right",id:"del-customer-info-btn",onClick:function onClick(){return _this3.removeEmbPlacement(i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"clear"))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"backing",value:this.state.backing,label:"Backing",onChange:function onChange(name,value){return _this3.setState(_defineProperty({},name,value));},disabled:this.state.disabled})),this.state.embroiedry.backing&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"sample"},"Backing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Backing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"backingValue",onChange:function onChange(e){return _this3.updateValueForkeys("backingData",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"paper"},"Paper"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"waterSoluble"},"WaterSoluble"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"NA"},"NA")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"backingWidth",onChange:function onChange(e){return _this3.updateValueForkeys("backingData",e.target.name,e.target.value);},type:"number","class":"form-control",placeholder:"TBN-00659"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"backingPlacement",onChange:function onChange(e){return _this3.updateValueForkeys("backingData",e.target.name,e.target.value);},type:"number","class":"form-control",placeholder:"TBN-00659"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Total(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:0,name:"price","class":"form-control",placeholder:"0.38 mts"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Price/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:0,name:"pricedMtr",onChange:function onChange(e){return _this3.updateValueForkeys("backingData",e.target.name,e.target.value);},"class":"form-control",placeholder:"0.38 mts"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Consumption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",(_React$createElement={type:"text",name:"consumption",onChange:function onChange(e){return _this3.updateValueForkeys("backingData",e.target.name,e.target.value);},"class":"form-control"},_defineProperty(_React$createElement,"onChange",function onChange(e){return _this3.setState(_defineProperty({},e.target.name,e.target.value));}),_defineProperty(_React$createElement,"placeholder","-"),_React$createElement))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{padding:"15px 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item","class":""},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",(_React$createElement2={name:"name","class":"form-control",rows:"4",cols:"80"},_defineProperty(_React$createElement2,"name","additionaDetails"),_defineProperty(_React$createElement2,"onChange",function onChange(e){return _this3.updateValueForkeys("embroiedry",e.target.name,e.target.value);}),_React$createElement2))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"EMBELLISHMENT"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Embellishment Design"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"emblishmentDesign",onChange:function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"approved"},"Approved"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notapproved"},"Not Approved")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Grading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"grading",onChange:function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"agreed"},"Agreed"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notagreed"},"Not Agreed"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"bitAttaching",value:this.state.bitAttaching,label:"Bit Attaching",onChange:function onChange(name,value){return _this3.setState(_defineProperty({},name,value));},disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"EMBELLISHMENT COST DETAILS"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light green pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",(_React$createElement3={type:"text","class":"form-control",name:"embellismentType"},_defineProperty(_React$createElement3,"name","buyingSampleDated"),_defineProperty(_React$createElement3,"onChange",function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}),_React$createElement3)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"HH:MM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",(_React$createElement4={type:"text","class":"form-control",name:"embellismentType"},_defineProperty(_React$createElement4,"name","buyingSampleDated"),_defineProperty(_React$createElement4,"onChange",function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}),_React$createElement4)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"Price/30mins"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",(_React$createElement5={type:"text","class":"form-control",name:"embellismentType"},_defineProperty(_React$createElement5,"name","buyingSampleDated"),_defineProperty(_React$createElement5,"onChange",function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}),_React$createElement5))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{padding:"15px 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item","class":""},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",(_React$createElement6={name:"name","class":"form-control",rows:"4",cols:"80"},_defineProperty(_React$createElement6,"name","buyingSampleDated"),_defineProperty(_React$createElement6,"onChange",function onChange(e){return _this3.updateValueForkeys("emblishmentDetails",e.target.name,e.target.value);}),_React$createElement6))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SEALING DETAILS"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Buying Sample Dated"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"buyingSampleDated",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Initial Sample Dated"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"initialsSampleDated",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Fit Comments Expected"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"fitCommentExpected",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6","for":"item"},"Photo Pack"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"photoPack",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"actioned"},"Actioned"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notactioned"},"Not Actioned")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Fabric for Photo Pack"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"fabricForPhotoPack",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"actioned"},"Actioned"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notactioned"},"Not Actioned")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Fabric for Photo Pack ETA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"fabricForPhotoPackETA",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Revised Fit Submission"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"revisedFitSubmission",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Revised Fit Submission Expected"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"revisedFitSubmissionExpected",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Sealing Submission"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"sealingSubmission",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Sealing comments Expected"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"sealingCommentExpexted",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group  col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Revised Sealing Expected"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"revisedSealingSubmission",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Revised Sealing comments Expected"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"revisedSealingCommentsExpected",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Sealing Deadline"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"sealingDeadline",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{padding:"15px 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item","class":""},"Additional Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{"class":"form-control",rows:"4",cols:"80",name:"additionalInfo",onChange:function onChange(e){return _this3.updateValueForkeys("sealingDetails",e.target.name,e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row",style:{padding:"1% 0 1% 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"OTHER DETAILS"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Style Handover Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"styleHandoverDate",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Customer Selling price"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number","class":"form-control col-md-6",name:"customerSellingPrice",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Style Sold"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"styleSold",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Fusing Recommend sheet"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",name:"fusingRecommendsheet",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"actioned"},"Actioned"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notactioned"},"not Actioned")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-4 active","for":"item"},"Style Dropped"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-4",name:"styleDropped",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-4",name:"",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"},"Thread recommend sheet"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control col-md-6",nmae:"threadRecommendSheet",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"actioned"},"Actioned"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"notactioned"},"not Actioned")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"class":"col-md-6 active","for":"item"}," ","ETA Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date","class":"form-control col-md-6",name:"etaDate",onChange:function onChange(e){return _this3.updateValueForkeys("otherDetails",e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"submit",name:"button","class":"primary",onClick:function onClick(e){return _this3.saveIb(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",name:"button","class":"primary ml-2"}," ","Confirm Order"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",name:"button","class":"primary ml-2"}," ","Provisional Order")))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"myModal","class":"modal fade",role:"dialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-dialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-body no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"meeting-min-con"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-8 product-form no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Search Style"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"BY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Departement Name"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"FOR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:""}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-4 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 mm-btns",style:{marginTop:"20%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",name:"button"},"Search")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"striped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"num"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"name"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"name"},"Deptartment Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"act"},"Action"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"MN-00324"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Virat"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Gemma"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"","class":"view",title:"View"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"visibility")))))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"scroll-up pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#top","class":"btn-floating btn-large black",title:"Add multiple"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"fa fa-chevron-up"}))));// } else {
//   return (
//       <Loading />
//   );
// }
}}]);return CreateIB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreateIB);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styleInfo=function(_Component){_inherits(styleInfo,_Component);function styleInfo(){_classCallCheck(this,styleInfo);return _possibleConstructorReturn(this,(styleInfo.__proto__||Object.getPrototypeOf(styleInfo)).apply(this,arguments));}_createClass(styleInfo,[{key:"render",value:function render(){var _props=this.props,styleInfo=_props.styleInfo,styleImage=_props.styleImage,_onChange=_props.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"img ml-1"},"IMAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding ib-fields"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 ib-right no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"upload-photo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:styleImage,alt:""})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 view-ib-left nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-light ib-list-view"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Created Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.createdAt))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Style No ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.styleNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Ref ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Customer Dept",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.customer.customerName+" "+styleInfo.customer.departments.departmentName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Reference Color ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.reference.referenceColor))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Magnum Style Name ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.reference.magnumStyleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Customer Ref No",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.reference.customerRefNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Buyer Style Name",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.reference.buyerStyleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Fabric Type",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.reference.fabricType)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 view-ib-right nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-light ib-list-view"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Season ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Story Name",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Buyer Name",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Assistant Buyer",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Fabric technologist",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"garment technologist",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," ",styleInfo.garmentType===null?null:styleInfo.garmentType.name," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Range",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Set",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,styleInfo.setType?"YES":"NO")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 view-ib-bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Style Orgination"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,styleInfo.styleOrigination.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Block Reference"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,styleInfo.blockRefNumber)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-3 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Sketch from"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",readOnly:true,placeholder:"",value:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Action by"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"",readOnly:true// value={styleInfo.reference.actionedBy}
})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fabric-textarea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"item"},"Aditional Style Information"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{type:"text","class":"form-control",rows:"3",id:"",onChange:function onChange(e){return _onChange(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary",name:"button"},"Save to Continue")));}}]);return styleInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (styleInfo);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FileUploadButton_FileUploadButton__ = __webpack_require__(233);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadSection=function(_Component){_inherits(UploadSection,_Component);function UploadSection(){_classCallCheck(this,UploadSection);return _possibleConstructorReturn(this,(UploadSection.__proto__||Object.getPrototypeOf(UploadSection)).apply(this,arguments));}_createClass(UploadSection,[{key:'render',value:function render(){var _props=this.props,onChangeFileFunc=_props.onChangeFileFunc,onChangeCategoryFunc=_props.onChangeCategoryFunc,categories=_props.categories,orderFileUpload=_props.orderFileUpload;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 my-3 style-td-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{'class':'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{'class':'border-bottom-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{'class':'border-bottom-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'class':'border-bottom-0 text-left',width:'12.5%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FileUploadButton_FileUploadButton__["a" /* default */],{onChange:function onChange(e){return onChangeFileFunc(e);}})),categories.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:i,'class':'border-bottom-0 text-left',width:'12.5%'},data);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,orderFileUpload.map(function(filedata,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'border-top-0 text-left'},filedata.path.split('/').slice(-1).pop()),categories.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,'class':'border-top-0 text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'radio-inline nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'group'+index,type:'radio',className:'filled-in hide-all',id:filedata.path+i,value:data+index,checked:filedata.fileType==data+index,onChange:function onChange(e){return onChangeCategoryFunc(e.target.value,index);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':filedata.path+i})));}));}))));}}]);return UploadSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UploadSection);

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Smv_Ov_List=function(_Component){_inherits(Smv_Ov_List,_Component);function Smv_Ov_List(props){_classCallCheck(this,Smv_Ov_List);var _this=_possibleConstructorReturn(this,(Smv_Ov_List.__proto__||Object.getPrototypeOf(Smv_Ov_List)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};_this.state={smvList:[],styleId:'',referenceId:'',activePage:1};_this.handlePageChange=_this.handlePageChange.bind(_this);return _this;}_createClass(Smv_Ov_List,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props$location$state=this.props.location.state,referenceId=_props$location$state.referenceId,styleId=_props$location$state.styleId;this.setState({referenceId:referenceId,styleId:styleId});__WEBPACK_IMPORTED_MODULE_1__services__["k" /* StyleServices */].listSMV(this.props.location.state.styleId,this.props.location.state.referenceId).then(function(response){if(response.message==="Operation Successful"){_this2.setState({smvList:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}},{key:'submit',value:function submit(id){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref){var onClose=_ref.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-ui'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Are you sure?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You want to delete this file?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',onClick:onClose},'No'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',onClick:function onClick(){_this3.removeSmv(id);onClose();}},'Yes, Delete it!'));}});}},{key:'removeSmv',value:function removeSmv(id){var _this4=this;__WEBPACK_IMPORTED_MODULE_1__services__["k" /* StyleServices */].removeSmv(id).then(function(response){if(response.message==="Successfully Deleted"){__WEBPACK_IMPORTED_MODULE_1__services__["k" /* StyleServices */].listSMV().then(function(response){if(response.message==="Operation Successful"){_this4.setState({smvList:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this4.msg);});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this4.msg);});}},{key:'handlePageChange',value:function handlePageChange(pageNumber){this.setState({activePage:pageNumber});}},{key:'navigationToNew',value:function navigationToNew(){var state=this.props.location.state;this.props.history.push('/SmvThread',{refId:this.state.referenceId,styleId:this.state.styleId,styleNumber:this.props.location.state.styleNumber});}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_alert___default.a,Object.assign({ref:function ref(a){return _this5.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 text-center p-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'class':'list-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Smv / ob calculation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'class':'pull-right',onClick:function onClick(){return _this5.navigationToNew();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{href:'',style:{color:"#179286",paddingRight:"29px"}},'Add New')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{'class':'striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sample Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'chartPreparedBy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'amendmentNumber'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colspan:'4'},'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.smvList!=undefined&&Array.isArray(this.state.smvList)&&this.state.smvList.length>0&&this.state.smvList.map(function(smv,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,smv.sampleType.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,smv.size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,smv.chartPreparedBy.firstName,smv.chartPreparedBy.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,smv.amendmentNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:"pointer"},onClick:function onClick(){return _this5.props.history.push("/viewSMV?"+smv._id);},className:'view',title:'view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'visibility'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:"pointer"},onClick:function onClick(){return _this5.props.history.push("/editSMV?"+smv._id);},className:'edit',title:'edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'create'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:"pointer"},onClick:function onClick(){return _this5.submit(smv._id);},className:'delete',title:'delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'delete'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:this.state.activePage,itemsCountPerPage:2,totalItemsCount:30,pageRangeDisplayed:5,onChange:this.handlePageChange})))));}}]);return Smv_Ov_List;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Smv_Ov_List);

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = Paginator;

// Paginator constructor
//
// `per_page` is the number of results per page, `length` is the number of
// pages to display. They default to `25` and `10` respectively.
function Paginator(per_page, length) {
  // You really should be calling this with `new Paginator`, but WHATEVER.
  if (!(this instanceof Paginator)) {
    return new Paginator(per_page, length);
  }

  // Woo, defaults!
  this.per_page = per_page || 25;
  this.length = length || 10;
}

// Build an object with all the necessary information for outputting pagination
// controls.
//
// (new Paginator(paginator.build(100, 2)
Paginator.prototype.build = function(total_results, current_page) {
  // We want the number of pages, rounded up to the nearest page.
  var total_pages = Math.ceil(total_results / this.per_page);

  // Ensure both total_results and current_page are treated as Numbers
  total_results = parseInt(total_results, 10);
  current_page  = parseInt(current_page, 10) || 1;

  // Obviously we can't be on a negative or 0 page.
  if (current_page < 1) { current_page = 1; }
  // If the user has done something like /page/99999 we want to clamp that back
  // down.
  if (current_page > total_pages) { current_page = total_pages; }

  // This is the first page to be displayed as a numbered link.
  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));

  // And here's the last page to be displayed specifically.
  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));

  // This is triggered if we're at or near one of the extremes; we won't have
  // enough page links. We need to adjust our bounds accordingly.
  if (last_page - first_page + 1 < this.length) {
    if (current_page < (total_pages / 2)) {
      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
    } else {
      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
    }
  }

  // This can be triggered if the user wants an odd number of pages.
  if (last_page - first_page + 1 > this.length) {
    // We want to move towards whatever extreme we're closest to at the time.
    if (current_page > (total_pages / 2)) {
      first_page++;
    } else {
      last_page--;
    }
  }

  // First result on the page. This, along with the field below, can be used to
  // do "showing x to y of z results" style things.
  var first_result = this.per_page * (current_page - 1);
  if (first_result < 0) { first_result = 0; }

  // Last result on the page.
  var last_result = (this.per_page * current_page) - 1;
  if (last_result < 0) { last_result = 0; }
  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }

  // GIMME THAT OBJECT
  return {
    total_pages: total_pages,
    pages: Math.min(last_page - first_page + 1, total_pages),
    current_page: current_page,
    first_page: first_page,
    last_page: last_page,
    previous_page: current_page - 1,
    next_page: current_page + 1,
    has_previous_page: current_page > 1,
    has_next_page: current_page < total_pages,
    total_results: total_results,
    results: Math.min(last_result - first_result + 1, total_results),
    first_result: first_result,
    last_result: last_result,
  };
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Page =
/*#__PURE__*/
function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, _getPrototypeOf(Page).apply(this, arguments));
  }

  _createClass(Page, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props = this.props,
          isDisabled = _this$props.isDisabled,
          pageNumber = _this$props.pageNumber;
      e.preventDefault();

      if (isDisabled) {
        return;
      }

      this.props.onClick(pageNumber);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props2 = this.props,
          pageText = _this$props2.pageText,
          pageNumber = _this$props2.pageNumber,
          activeClass = _this$props2.activeClass,
          itemClass = _this$props2.itemClass,
          linkClass = _this$props2.linkClass,
          activeLinkClass = _this$props2.activeLinkClass,
          disabledClass = _this$props2.disabledClass,
          isActive = _this$props2.isActive,
          isDisabled = _this$props2.isDisabled,
          href = _this$props2.href,
          ariaLabel = _this$props2.ariaLabel;
      var css = (0, _classnames["default"])(itemClass, (_cx = {}, _defineProperty(_cx, activeClass, isActive), _defineProperty(_cx, disabledClass, isDisabled), _cx));
      var linkCss = (0, _classnames["default"])(linkClass, _defineProperty({}, activeLinkClass, isActive));
      return _react["default"].createElement("li", {
        className: css,
        onClick: this.handleClick.bind(this)
      }, _react["default"].createElement("a", {
        className: linkCss,
        href: href,
        "aria-label": ariaLabel
      }, pageText));
    }
  }]);

  return Page;
}(_react.Component);

exports["default"] = Page;

_defineProperty(Page, "propTypes", {
  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  pageNumber: _propTypes["default"].number.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  disabledClass: _propTypes["default"].string,
  href: _propTypes["default"].string
});

_defineProperty(Page, "defaultProps", {
  activeClass: "active",
  disabledClass: "disabled",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkCLass: undefined,
  isActive: false,
  isDisabled: false,
  href: "#"
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_table_to_excel__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_table_to_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_html_table_to_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__printSmv__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_utility_service__ = __webpack_require__(75);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services
var smvDataTemplate={operations:null,machine:null,folder:null,seconds:null,SAM:null,targetPerHour:null};var threadConsumptionTemplate={operations:null,machine:null,length:null,factor:null,rating:null,total:null,needle:null,looper:null,overLock:null,trimThread:null,sheeringNeedle:null// threadElastic: "",
};var SmvThread=function(_Component){_inherits(SmvThread,_Component);function SmvThread(){var _ref,_this$state;var _temp,_this,_ret;_classCallCheck(this,SmvThread);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SmvThread.__proto__||Object.getPrototypeOf(SmvThread)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={//header title
header:"SMV/OB and Thread Consumption",action:"",_id:"",threadId:"",active:false,disabled:false,smvNumber:null,magnumStyleId:null,styleReferenceId:null,sampleType:null,sampleDate:null,size:"",chartPreparedOn:null,chartPreparedBy:_this.props.chartPreparedBy,smvdata:[],totalSam:null,targetSAM:null,"100Target":null,"80Target":null,minutesPerDay:480,sizes:null,customer:null,customerDepartmentId:null,//thread Consumption
threadData:[],wash:null,wastage:null,otherSizes:null,totalLooper:null,totalLooperRound:null,totalNeedle:null,totalNeedleRound:null,magnumStyleName:"",customerName:"",departmentName:"",smvId:"",styleNoInfo:[],amendmentNumber:null,allSizes:[],prefillInfo:{MACHINE:[],OPERATION:[],SAMPLETYPE:[],OTHERS:{}},readOnlyClass:false,dragIndex:0,dropIndex:0,printLoading:false,threadCreated:false,isLoading:false,smvObData:{},styleNo:"",sampleLabel:"",totalVal:""},_defineProperty(_this$state,"totalNeedle",""),_defineProperty(_this$state,"totalLooper",""),_defineProperty(_this$state,"totalOverLock",""),_defineProperty(_this$state,"totalSheeringNeedle",""),_defineProperty(_this$state,"totalTrimThread",""),_defineProperty(_this$state,"totalNeedleRound",""),_defineProperty(_this$state,"totalLooperRound",""),_defineProperty(_this$state,"totalOverLockRound",""),_defineProperty(_this$state,"totalSheeringNeedleRound",""),_defineProperty(_this$state,"totalTrimThreadRound",""),_defineProperty(_this$state,"selectedsize",""),_this$state),_this.handleActive=function(){var active=_this.state.active;_this.setState({active:!active});},_this.systemValues=function(){__WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].prefillSMVInfo().then(function(response){if(response.status==200){response.text.data.MACHINE=response.text.data.MACHINE.map(function(data){var dat=Object.assign({},data);dat.label=data.name;dat.value=data._id;return dat;});_this.setState({prefillInfo:response.text.data,wash:_this.state.wash===null?Number(response.text.data.OTHERS.wash):Number(_this.state.wash),otherSizes:_this.state.otherSizes==null?Number(response.text.data.OTHERS.otherSize):Number(_this.state.otherSizes),wastage:_this.state.wastage==null?Number(response.text.data.OTHERS.wastage):Number(_this.state.wastage)});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleNoInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getStyleReferenceInfo=function(styleReferenceId){if(styleReferenceId!==null){styleReferenceId=(typeof styleReferenceId==="undefined"?"undefined":_typeof(styleReferenceId))=="object"?styleReferenceId.value:styleReferenceId;__WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].getStyleInfoByReference(styleReferenceId).then(function(response){if(response.status===200){_this.setState({magnumStyleName:response.text.data.magnumStyleName,magnumStyleId:response.text.data.magnumStyleId,customer:response.text.data.customer!==""?response.text.data.customer:null,customerDepartmentId:response.text.data.customerDepartmentId,customerName:response.text.data.customerName,departmentName:response.text.data.departmentName,styleReferenceId:styleReferenceId},function(){return _this.getMagnumStyleById(styleReferenceId);},_this.getSMVCustomerData(response.text.data.customer,response.text.data.customerDepartmentId));}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{_this.setState({styleReferenceId:null,customer:null,customerDepartmentId:null,customerName:"",departmentName:"",magnumStyleId:null,magnumStyleName:""},function(){return _this.getMagnumStyleNo("");});}},_this.getMagnumStyleById=function(value){__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReferenceById(value).then(function(response){if(response.status===200){var styleNoInfo=[];response.text.data.map(function(data){if(data!==null)styleNoInfo.push(Object.assign({},data));});_this.setState({styleNoInfo:styleNoInfo});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getSMVCustomerData=function(customer,customerDepartmentId){__WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].getSMVCustomerData(customer,customerDepartmentId).then(function(response){if(response.status==200){_this.setState({allSizes:response.text.data.allSizes});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.addSmv=function(){var smvdata=[].concat(_toConsumableArray(_this.state.smvdata));var threadData=[].concat(_toConsumableArray(_this.state.threadData));smvdata.push(Object.assign({},smvDataTemplate));threadData.push(Object.assign({},threadConsumptionTemplate));_this.setState({smvdata:smvdata,threadData:threadData});},_this.removeSmv=function(index){if(_this.state.smvdata.length>0&&_this.state.threadData.length>0){var smvdata=[].concat(_toConsumableArray(_this.state.smvdata));var threadData=[].concat(_toConsumableArray(_this.state.threadData));smvdata.splice(index,1);threadData.splice(index,1);_this.setState({smvdata:smvdata,threadData:threadData},function(){_this.updateCalcForSAM(),threadData.length?_this.updateValuesforThreadCons("length",threadData[threadData.length-1].length,threadData.length-1):_this.calcForTotal();});}},_this._onDragStart=function(e,index){_this.setState({dragIndex:index});},_this._onDragOver=function(event){event.stopPropagation();event.preventDefault();},_this._onDropEnd=function(e,index){// this.setState({ dropIndex: index })
// let smvdata = [...this.state.smvdata]
// let count = [...smvdata]
// let tmp = { ...this.state.smvdata[this.state.dragIndex] }
// count[this.state.dragIndex] = { ...count[index] }
// count[index] = { ...tmp }
// smvdata = count
// this.setState({
//   smvdata
// })
// let threadData = [...this.state.threadData]
// let tmp1 = threadData[this.state.dragIndex]
// threadData[this.state.dragIndex] = threadData[index]
// threadData[index] = tmp1
// this.setState({ threadData })
var iData=[].concat(_toConsumableArray(_this.state.smvdata)).find(function(x,i){return _this.state.dragIndex==i;});var filterData=[].concat(_toConsumableArray(_this.state.smvdata)).filter(function(x,i){return _this.state.dragIndex!=i;});filterData.splice(index,0,iData);var itData=[].concat(_toConsumableArray(_this.state.threadData)).find(function(x,i){return _this.state.dragIndex==i;});var tfilterData=[].concat(_toConsumableArray(_this.state.threadData)).filter(function(x,i){return _this.state.dragIndex!=i;});tfilterData.splice(index,0,itData);_this.setState({smvdata:filterData,threadData:tfilterData});},_this.updateValueSmvCalc=function(name,value,index){var smvdata=[].concat(_toConsumableArray(_this.state.smvdata));smvdata[index][name]=value;_this.setState({smvdata:smvdata});},_this.updateValueForRowdata=function(name,value,index){var data=[].concat(_toConsumableArray(_this.state.smvdata));data[index][name]=value;if(name==="operations"||name==="machine"){var threadData=[].concat(_toConsumableArray(_this.state.threadData));threadData[index][name]=value;if(name=="machine"){_this.state.prefillInfo.MACHINE.map(function(data){if(data.value==value){// threadData[index].length = Number(data.length);
// threadData[index].factor = Number(data.factor);
threadData[index].needle=Number(data.needle);threadData[index].looper=Number(data.looper);// Need to change in data.factor as data.rating, after backend is fixed
threadData[index].rating=Number(data.factor);threadData[index].sheeringNeedle=Number(data.sheeringNeedle);threadData[index].overLock=Number(data.overLock);threadData[index].trimThread=Number(data.trimThread);}});}_this.setState({threadData:threadData});}_this.setState({smvdata:data},function(){return _this.updateCalcForSAM();});},_this.updateCalcForSAM=function(){var smvdata=[].concat(_toConsumableArray(_this.state.smvdata));var totalSam=0;smvdata=smvdata.map(function(data){if(data.seconds!==null){data.SAM=(Number(data.seconds)/60).toFixed(2);data.targetPerHour=(60/Number(data.SAM)).toFixed(2);}else{data.SAM=0;data.TargetPerHour=0;}if(data.SAM!==null){totalSam=(Number(totalSam)+Number(data.SAM)).toFixed(2);}else{totalSam=0;}return data;});_this.setState({smvdata:smvdata,totalSam:totalSam},function(){return _this.updateCalcForSMV();});},_this.updateCalcForSMV=function(){if(_this.state.totalSam!==null){var _this$setState;var hundredtarget=Math.round(Number(_this.state.minutesPerDay)/Number(_this.state.totalSam)).toFixed(2);var eightytarget=Math.round(hundredtarget*(80/100)).toFixed(2);_this.setState((_this$setState={},_defineProperty(_this$setState,"100Target",hundredtarget),_defineProperty(_this$setState,"80Target",eightytarget),_this$setState));}},_this.createSMV=function(duplicate){if(!_this.state.magnumStyleId)return _this.props.getalertMessage("error","Please select Style Options");_this.setState({isLoading:true});var smv={};smv.sampleType=_this.state.sampleType;smv.sampleDate=duplicate?new Date():_this.state.sampleDate;smv.magnumStyleId=_this.state.magnumStyleId;smv.styleReferenceId=_this.state.styleReferenceId;smv.size=_this.state.size;smv.chartPreparedOn=duplicate?new Date():_this.state.chartPreparedOn;smv.chartPreparedBy=_this.state.chartPreparedBy;smv.data=[].concat(_toConsumableArray(_this.state.smvdata));smv.totalSam=_this.state.totalSam;smv.minutesPerDay=_this.state.minutesPerDay;smv["100Target"]=_this.state["100Target"];smv["80Target"]=_this.state["80Target"];smv.customer=_this.state.customer;smv.customerDepartmentId=_this.state.customerDepartmentId;if(_this.state._id&&!duplicate){smv.smvId=_this.state.smvId;smv._id=_this.state._id;}__WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].createSMV(smv).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);_this.setState({readOnlyClass:!duplicate?true:false,smvId:response.text.data._id,_id:response.text.data.threadId,threadId:response.text.data.threadId,smvNumber:response.text.data.smvNumber,isLoading:false});_this.createThread();}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.setState({isLoading:false});_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){_this.setState({isLoading:false});_this.props.getalertMessage("error",error.toString());});},_this.updateValuesforThreadCons=function(name,value,index){if(name!=="thread"){value=Number(value);}var threadData=[].concat(_toConsumableArray(_this.state.threadData)).map(function(x){// x.machine = isNaN(x.machine) ? x.machine : parseInt(x.machine);
x.length=isNaN(x.length)?x.length:parseFloat(x.length);x.factor=isNaN(x.factor)?x.factor:parseFloat(x.factor);x.rating=isNaN(x.rating)?x.rating:parseFloat(x.rating);x.total=isNaN(x.total)?x.total:parseInt(x.total);x.needle=isNaN(x.needle)?x.needle:parseInt(x.needle);x.looper=isNaN(x.looper)?x.looper:parseInt(x.looper);x.overLock=isNaN(x.overLock)?x.overLock:parseInt(x.overLock);x.trimThread=isNaN(x.trimThread)?x.trimThread:parseInt(x.trimThread);return x;});threadData[index][name]=isNaN(value)?value:Number(value);_this.setState({threadData:threadData},function(){return _this.calcForTotal();});},_this.calcForTotal=function(){var threadData=[].concat(_toConsumableArray(_this.state.threadData)).map(function(x){// x.machine = isNaN(x.machine) ? 0 : parseInt(x.machine);
x.length=isNaN(x.length)?0:parseInt(x.length);x.factor=isNaN(x.factor)?0:parseInt(x.factor);x.rating=isNaN(x.rating)?0:parseFloat(x.rating);x.total=isNaN(x.total)?0:parseInt(x.total);x.needle=isNaN(x.needle)?0:parseInt(x.needle);x.looper=isNaN(x.looper)?0:parseInt(x.looper);x.overLock=isNaN(x.overLock)?0:parseInt(x.overLock);x.trimThread=isNaN(x.trimThread)?0:parseInt(x.trimThread);return x;});var totalVal=null;var totalNeedle=null;var totalLooper=null;var totalOverLock=null;var totalSheeringNeedle=null;var totalTrimThread=null;var totalNeedleRound=null;var totalLooperRound=null;var totalOverLockRound=null;var totalSheeringNeedleRound=null;var totalTrimThreadRound=null;var TPERCENT=Number(_this.state.wash)+Number(_this.state.wastage)+Number(_this.state.otherSizes);threadData=threadData.map(function(thread){if(thread.length!==null&&thread.factor!==null&&thread.rating!==null&&thread.trimThread!==null&&thread.overLock!==null&&thread.sheeringNeedle!==null){thread.total=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])((Number(thread.length)+5)*Number(thread.factor)*Number(thread.rating))/100;totalVal=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalVal)+Number(thread.total));totalNeedle=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalNeedle)+Number(thread.total)*(Number(thread.needle)/100));totalLooper=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalLooper)+Number(thread.total)*(Number(thread.looper)/100));totalOverLock=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalOverLock)+Number(thread.total)*(Number(thread.overLock)/100));totalSheeringNeedle=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalSheeringNeedle)+Number(thread.total)*(Number(thread.sheeringNeedle)/100));totalTrimThread=Object(__WEBPACK_IMPORTED_MODULE_15__services_utility_service__["b" /* getFixedTwo */])(Number(totalTrimThread)+Number(thread.total)*(Number(thread.trimThread)/100));totalNeedleRound=Math.round(Number(totalNeedle)+Number(totalNeedle)*TPERCENT/100);totalLooperRound=Math.round(Number(totalLooper)+Number(totalLooper)*TPERCENT/100);totalOverLockRound=Math.round(Number(totalOverLock)+Number(totalOverLock)*TPERCENT/100);totalSheeringNeedleRound=Math.round(Number(totalSheeringNeedle)+Number(totalSheeringNeedle)*TPERCENT/100);totalTrimThreadRound=Math.round(Number(totalTrimThread)+Number(totalTrimThread)*TPERCENT/100);}return thread;});_this.setState({threadData:threadData,totalVal:totalVal,totalNeedle:totalNeedle,totalLooper:totalLooper,totalOverLock:totalOverLock,totalSheeringNeedle:totalSheeringNeedle,totalTrimThread:totalTrimThread,totalNeedleRound:totalNeedleRound,totalLooperRound:totalLooperRound,totalOverLockRound:totalOverLockRound,totalSheeringNeedleRound:totalSheeringNeedleRound,totalTrimThreadRound:totalTrimThreadRound});},_this.createThread=function(threadUpdted){var thread={};thread.magnumStyleId=_this.state.magnumStyleId;thread.styleReferenceId=_this.state.styleReferenceId;thread.data=_this.state.threadData;thread.sampleDate=_this.state.sampleDate;thread.sampleType=_this.state.sampleType;thread.size=_this.state.size;thread.wash=_this.state.wash;thread.wastage=_this.state.wastage;thread.otherSizes=_this.state.otherSizes;thread.totalNeedle=_this.state.totalNeedle;thread.totalNeedleRound=_this.state.totalNeedleRound;thread.totalLooper=_this.state.totalLooper;thread.totalLooperRound=_this.state.totalLooperRound;// thread.sizes = this.state.sizes
thread.chartPreparedBy=_this.state.chartPreparedBy;thread.chartPreparedOn=_this.state.chartPreparedOn;thread.customer=_this.state.customer;thread.customerDepartmentId=_this.state.customerDepartmentId;thread.smvId=_this.state.smvId;thread.allSizes=_this.state.sizes;thread.totalOverLock=_this.state.totalOverLock;thread.totalOverLockRound=_this.state.totalOverLockRound;thread.totalSheeringNeedle=_this.state.totalSheeringNeedle;thread.totalSheeringNeedleRound=_this.state.totalSheeringNeedleRound;thread.totalTrimThread=_this.state.totalTrimThread;thread.totalTrimThreadRound=_this.state.totalTrimThreadRound;thread.totalVal=_this.state.totalVal;if(_this.state.threadId!==""){thread._id=_this.state.threadId;}__WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].createThread(thread).then(function(response){if(response.status==200){if(threadUpdted)_this.props.getalertMessage("success",response.text.message);_this.setState({threadCreated:true});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.openPrint=function(val){var smvObData=JSON.parse(JSON.stringify(_this.state.smvObData));_this.setState({smvObData:smvObData,printLoading:true},function(){var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.print();newWin.close();});},_this.openXL=function(){var smvObData=JSON.parse(JSON.stringify(_this.state.smvObData));_this.setState({smvObData:smvObData,// threadCalculation,
printLoading:true},function(){});},_this.createDuplicate=function(){_this.setState({threadCreated:false,styleReferenceId:null,sampleType:null,size:null,customerName:"",departmentName:"",customer:null,customerDepartmentId:null,magnumStyleName:"",magnumStyleId:null,allSizes:[]});_this.getMagnumStyleNo("");return _this.createSMV(true);},_this._handleInputChange=function(name,value){_this.setState(_defineProperty({},name,value));},_this.smvObPrintData=function(){var smvObData={smv:[],threadCalculation:{threadCalculationArray:[]}};var state=Object.assign({},_this.state);var smv=smvObData.smv;if(!!_this.state.styleReferenceId){smvObData.styleReferenceId=_this.state.styleNoInfo&&_this.state.styleNoInfo.length>0&&_this.state.styleNoInfo.map(function(data,index){if(data.value===_this.state.styleReferenceId){_this.setState({styleNo:data.label});return data.label;}}).filter(Boolean)[0];}if(!!_this.state.sampleType){smvObData.sampleType=_this.state.prefillInfo.SAMPLETYPE&&_this.state.prefillInfo.SAMPLETYPE.length>0&&_this.state.prefillInfo.SAMPLETYPE.map(function(data,index){if(data.value===_this.state.sampleType){_this.setState({sampleLabel:data.label});return data.label;}}).filter(Boolean)[0];}smvObData.magnumStyleName=_this.state.magnumStyleName;smvObData.customerName=_this.state.customerName;smvObData.departmentName=_this.state.departmentName;smvObData.sampleDate=_this.state.sampleDate;smvObData.size=_this.state.size;smvObData.chartPreparedOn=_this.state.chartPreparedOn;smvObData.firstName=_this.state.firstName;smvObData.lastName=_this.state.lastName;var radios=_this.state.allSizes;if(_this.state.sizes)smvObData.selectedsize=radios.find(function(data,index){return data._id===_this.state.sizes;}).size;// smvObData.allSizes = this.state.sizes&&document.getElementById(this.state.sizes).checked
if(_this.state.smvdata&&_this.state.smvdata.length>0){_this.state.smvdata.map(function(value,index){var Data={};Data.index=index+1;Data.operations=_this.state.prefillInfo.OPERATION&&_this.state.prefillInfo.OPERATION.length>0&&_this.state.prefillInfo.OPERATION.map(function(data,index){if(data.value===value.operations){return data.label;}}).filter(Boolean)[0];Data.machine=_this.state.prefillInfo.MACHINE&&_this.state.prefillInfo.MACHINE.length>0&&_this.state.prefillInfo.MACHINE.map(function(data,index){if(data.value===value.machine){return data.name;}}).filter(Boolean)[0];Data.folder=_this.state.prefillInfo["FOLDER/GUIDE"]&&_this.state.prefillInfo["FOLDER/GUIDE"].length>0&&_this.state.prefillInfo["FOLDER/GUIDE"].map(function(data,index){if(data.value===value.folder){return data.label;}}).filter(Boolean)[0];Data.seconds=value.seconds;Data.sam=value.SAM!==Number.POSITIVE_INFINITY||value.SAM!==Number.NEGATIVE_INFINITY?value.SAM:null;Data.targetPerHour=value.SAM!==Number.POSITIVE_INFINITY||value.targetPerHour!==Number.NEGATIVE_INFINITY?Math.ceil(value.targetPerHour).toFixed(0):null;smvObData.smv.push(Data);});}smvObData.totalSam=Number(state.totalSam);smvObData.minutesPerDay=Number(state.minutesPerDay);smvObData.target100=Math.ceil(state["100Target"]);smvObData.target80=Math.ceil(state["80Target"]);setTimeout(function(){return _this.setState({smvObData:smvObData});},500);// Thread Calculation Data
var threadCalculation=smvObData.threadCalculation;var threadCalculationArray=threadCalculation.threadCalculationArray;if(_this.state.threadData&&_this.state.threadData.length>0){_this.state.threadData.map(function(value,index){var threadData={};threadData.index=index+1;threadData.length=value.length;threadData.factor=value.factor;threadData.rating=value.rating;threadData.rating=value.rating;threadData.total=value.total;threadData.needle=value.total*(Number(value.needle)/100);threadData.looper=value.total*(Number(value.looper)/100);threadData.overLock=value.total*(Number(value.overLock)/100);threadData.trimThread=value.total*(Number(value.trimThread)/100);threadData.sheeringNeedle=value.total*(Number(value.sheeringNeedle)/100);threadData.machine=_this.state.prefillInfo.MACHINE&&_this.state.prefillInfo.MACHINE.length>0&&_this.state.prefillInfo.MACHINE.map(function(data,index){if(data.value===value.machine){return data.name;}}).filter(Boolean)[0];threadData.operation=_this.state.prefillInfo.OPERATION&&_this.state.prefillInfo.OPERATION.length>0&&_this.state.prefillInfo.OPERATION.map(function(data,index){if(data.value===value.operations){return data.label;}}).filter(Boolean)[0];threadData.thread=_this.state.prefillInfo.THREAD&&_this.state.prefillInfo.THREAD.length>0&&_this.state.prefillInfo.THREAD.map(function(data,index){if(data.value===value.thread){return data.label;}}).filter(Boolean)[0];threadCalculationArray.push(threadData);});}threadCalculation.totalVal=_this.state.totalVal;threadCalculation.totalNeedle=_this.state.totalNeedle;threadCalculation.totalLooper=_this.state.totalLooper;threadCalculation.totalOverLock=_this.state.totalOverLock;threadCalculation.totalTrimThread=_this.state.totalTrimThread;threadCalculation.totalSheeringNeedle=_this.state.totalSheeringNeedle;threadCalculation.wastage=_this.state.wastage;threadCalculation.add=Number(_this.state.wastage)+Number(_this.state.otherSizes)+Number(_this.state.wash);threadCalculation.otherSizes=_this.state.otherSizes;threadCalculation.totalNeedleRound=_this.state.totalNeedleRound;threadCalculation.wash=_this.state.wash;threadCalculation.totalLooperRound=_this.state.totalLooperRound;threadCalculation.totalOverLockRound=_this.state.totalOverLockRound;threadCalculation.totalTrimThreadRound=_this.state.totalTrimThreadRound;threadCalculation.totalSheeringNeedleRound=_this.state.totalSheeringNeedleRound;threadCalculation.allSizes=_this.state.allSizes.length;setTimeout(function(){return _this.setState({smvObData:Object.assign({},_this.state.smvObData,{smv:smv,threadCalculation:threadCalculation// threadCalculationArray
})});},500);},_this.confirmDuplicate=function(){Object(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:" p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Do you want to create a duplicate SMV/OB and Thread Consumption?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.createDuplicate();onClose();}},"Yes"));},closeOnClickOutside:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SmvThread,[{key:"componentWillMount",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this2=this;var _props$location$state,styleReferenceId,action,_id,smvId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.setState({isLoading:true});case 2:_props$location$state=this.props.location.state,styleReferenceId=_props$location$state.styleReferenceId,action=_props$location$state.action,_id=_props$location$state._id,smvId=_props$location$state.smvId;if(!(styleReferenceId!=="")){_context2.next=9;break;}_context2.next=6;return this.getMagnumStyleNo("");case 6:_context2.next=8;return this.setState({styleReferenceId:styleReferenceId});case 8:setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.getStyleReferenceInfo(styleReferenceId);case 2:case"end":return _context.stop();}}},_callee,_this2);})),200);case 9:if(!(action=="edit")){_context2.next=12;break;}_context2.next=12;return this.setState({readOnlyClass:true});case 12:if(!(action=="add")){_context2.next=15;break;}_context2.next=15;return this.setState({sampleDate:new Date(),chartPreparedOn:new Date(),firstName:this.props.firstName,lastName:this.props.lastName});case 15:if(!(action=="view")){_context2.next=18;break;}_context2.next=18;return this.setState({disabled:true});case 18:if(!(action=="view"||action=="edit")){_context2.next=24;break;}if(!(_id!=""&&smvId!=="")){_context2.next=24;break;}_context2.next=22;return __WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].getSMV(smvId).then(function(response){if(response.status==200){var _this2$setState;var hundredtarget=response.text.data["100Target"]?response.text.data["100Target"]:null;var eightytarget=response.text.data["80Target"]?response.text.data["80Target"]:null;var amendmentNumber=response.text.data.amendmentNumber?response.text.data.amendmentNumber:null;var firstName=Object.keys(response.text.data.chartPreparedBy).length>0?response.text.data.chartPreparedBy.firstName:"";var lastName=Object.keys(response.text.data.chartPreparedBy).length>0?response.text.data.chartPreparedBy.lastName:"";var chartPreparedBy=Object.keys(response.text.data.chartPreparedBy).length>0?response.text.data.chartPreparedBy._id:"";var chartPreparedOn=response.text.data.chartPreparedOn?response.text.data.chartPreparedOn:null;var customer=response.text.data.customer?response.text.data.customer:null;var customerDepartmentId=response.text.data.customerDepartmentId?response.text.data.customerDepartmentId:null;var smvdata=response.text.data.data.length>0?[].concat(_toConsumableArray(response.text.data.data)):_this2.state.smvdata;var magnumStyleId=response.text.data.magnumStyleId?response.text.data.magnumStyleId:null;var minutesPerDay=response.text.data.minutesPerDay?response.text.data.minutesPerDay:null;var sampleType=response.text.data.sampleType?response.text.data.sampleType:null;var size=response.text.data.size?response.text.data.size:null;var _styleReferenceId=response.text.data.styleReferenceId?response.text.data.styleReferenceId:null;var totalSam=response.text.data.totalSam?response.text.data.totalSam:null;var smvNumber=response.text.data.smvNumber?response.text.data.smvNumber:null;if(_styleReferenceId!==null||_styleReferenceId!==""){_this2.getStyleReferenceInfo(_styleReferenceId);_this2.getMagnumStyleById(_styleReferenceId);}_this2.setState((_this2$setState={},_defineProperty(_this2$setState,"100Target",hundredtarget),_defineProperty(_this2$setState,"80Target",eightytarget),_defineProperty(_this2$setState,"amendmentNumber",amendmentNumber),_defineProperty(_this2$setState,"firstName",firstName),_defineProperty(_this2$setState,"lastName",lastName),_defineProperty(_this2$setState,"chartPreparedBy",chartPreparedBy),_defineProperty(_this2$setState,"chartPreparedOn",chartPreparedOn),_defineProperty(_this2$setState,"customer",customer),_defineProperty(_this2$setState,"customerDepartmentId",customerDepartmentId),_defineProperty(_this2$setState,"smvdata",smvdata),_defineProperty(_this2$setState,"magnumStyleId",magnumStyleId),_defineProperty(_this2$setState,"minutesPerDay",minutesPerDay),_defineProperty(_this2$setState,"sampleDate",response.text.data.sampleDate),_defineProperty(_this2$setState,"sampleType",sampleType),_defineProperty(_this2$setState,"size",size),_defineProperty(_this2$setState,"styleReferenceId",_styleReferenceId),_defineProperty(_this2$setState,"totalSam",totalSam),_defineProperty(_this2$setState,"smvNumber",smvNumber),_this2$setState));}}).catch(function(error){return _this2.props.getalertMessage("error",error.toString());});case 22:_context2.next=24;return __WEBPACK_IMPORTED_MODULE_5__services__["k" /* StyleServices */].getSpecificThread(_id).then(function(response){if(response.status==200){var threadId=response.text.data._id;var threadData=response.text.data.data.length>0?[].concat(_toConsumableArray(response.text.data.data)):[].concat(_toConsumableArray(_this2.state.threadData));var _smvId=response.text.data.smvId?response.text.data.smvId:"";var totalLooper=response.text.data.totalLooper?response.text.data.totalLooper:null;var totalLooperRound=response.text.data.totalLooperRound?response.text.data.totalLooperRound:null;var totalNeedle=response.text.data.totalNeedle?response.text.data.totalNeedle:null;var totalNeedleRound=response.text.data.totalNeedleRound?response.text.data.totalNeedleRound:null;var wash=response.text.data.wash?response.text.data.wash:null;var wastage=response.text.data.wastage?response.text.data.wastage:null;var otherSizes=response.text.data.otherSizes?response.text.data.otherSizes:null;var sizes=response.text.data.allSizes?response.text.data.allSizes:null;//
var totalOverLock=response.text.data.totalOverLock?response.text.data.totalOverLock:null;var totalOverLockRound=response.text.data.totalOverLockRound?response.text.data.totalOverLockRound:null;var totalSheeringNeedle=response.text.data.totalSheeringNeedle?response.text.data.totalSheeringNeedle:null;var totalSheeringNeedleRound=response.text.data.totalSheeringNeedleRound?response.text.data.totalSheeringNeedleRound:null;var totalTrimThread=response.text.data.totalTrimThread?response.text.data.totalTrimThread:null;var totalTrimThreadRound=response.text.data.totalTrimThreadRound?response.text.data.totalTrimThreadRound:null;_this2.setState({threadData:threadData,smvId:_smvId,threadId:threadId,totalLooper:totalLooper,totalLooperRound:totalLooperRound,totalNeedle:totalNeedle,totalNeedleRound:totalNeedleRound,wash:wash,wastage:wastage,otherSizes:otherSizes,sizes:sizes,totalOverLock:totalOverLock,totalOverLockRound:totalOverLockRound,totalSheeringNeedle:totalSheeringNeedle,totalSheeringNeedleRound:totalSheeringNeedleRound,totalTrimThread:totalTrimThread,totalTrimThreadRound:totalTrimThreadRound});}}).catch(function(error){return _this2.props.getalertMessage("error",error.toString());});case 24:_context2.next=26;return this.setState({action:action,_id:_id,smvId:smvId});case 26:_context2.next=28;return this.systemValues();case 28:_context2.next=30;return this.setState({isLoading:false});case 30:case"end":return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _ref3.apply(this,arguments);}return componentWillMount;}()},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;var action=this.props.location.state.action;if(action==="edit"||action==="view"){setTimeout(function(){_this3.calcForTotal();},1500);}if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}//list smv system master
// list and search style reference
//style select
/*****************************************************************************/// SMB & CALC func start
// SMV & CALC func end
/*****************************************************************************//**************************************************************************** *///Thread func start
// Thread func end
/*****************************************************************************///handle input values
},{key:"render",value:function render(){var _this4=this;var _state=this.state,active=_state.active,smvNumber=_state.smvNumber,styleReferenceId=_state.styleReferenceId,magnumStyleName=_state.magnumStyleName,customerName=_state.customerName,departmentName=_state.departmentName,sampleDate=_state.sampleDate,sampleType=_state.sampleType,chartPreparedOn=_state.chartPreparedOn,size=_state.size,smvdata=_state.smvdata,minutesPerDay=_state.minutesPerDay,totalSam=_state.totalSam,threadData=_state.threadData,styleNo=_state.styleNo,sampleLabel=_state.sampleLabel,totalVal=_state.totalVal,totalNeedle=_state.totalNeedle,totalLooper=_state.totalLooper,totalOverLock=_state.totalOverLock,totalTrimThread=_state.totalTrimThread,totalSheeringNeedle=_state.totalSheeringNeedle,wastage=_state.wastage,otherSizes=_state.otherSizes,totalNeedleRound=_state.totalNeedleRound,wash=_state.wash,totalLooperRound=_state.totalLooperRound,totalOverLockRound=_state.totalOverLockRound,totalTrimThreadRound=_state.totalTrimThreadRound,totalSheeringNeedleRound=_state.totalSheeringNeedleRound,allSizes=_state.allSizes;var _state$smvObData=this.state.smvObData,threadCalculation=_state$smvObData.threadCalculation,smv=_state$smvObData.smv,firstName=_state$smvObData.firstName,lastName=_state$smvObData.lastName,target100=_state$smvObData.target100,target80=_state$smvObData.target80,threadCalculationArray=_state$smvObData.threadCalculationArray,selectedsize=_state$smvObData.selectedsize;var overlayApply="";var opacityApply="card-filter meeting-min-con ";if(!this.state.readOnlyClass){overlayApply="overlay-apply";opacityApply+="opacity-apply";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon mr-3 pull-right download-xl",onClick:function onClick(e){_this4.handleActive();_this4.smvObPrintData();_this4.calcForTotal();setTimeout(function(){return _this4.openXL();},500);}},"Download ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"keyboard_arrow_down"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"Excel "+(active?'active':'not-active ml-3')},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_html_table_to_excel___default.a,{id:"test-table-xls-button",className:"download-table-xls-button",table:"table-to-xls",filename:"tablexls",sheet:"tablexls",buttonText:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{id:"xlSheet",src:"https://cdn0.iconfinder.com/data/icons/document-file-types/512/xls-512.png"}),open:this.openXL}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon mr-3 pull-right ",onClick:function onClick(e){_this4.setState({isLoading:true});setTimeout(function(){_this4.smvObPrintData();_this4.systemValues();_this4.setState({isLoading:false});setTimeout(function(){return _this4.openPrint("printSmv_Ob");},2000);},2000);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_printer_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{id:"table-to-xls",className:"d-none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bold text-center p-1 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Create SMV/OB and Thread Consumption")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Style No")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Style Name")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Customer Name"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},styleNo),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},magnumStyleName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},customerName+"/"+departmentName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Sample Type")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Sample Date")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Size")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Chart Prepared On")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Chart Prepared By"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},sampleLabel),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_3_moment___default()(sampleDate).format("HH:mm DD MMM YYYY")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},size),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_3_moment___default()(chartPreparedOn).format("HH:mm DD MMM YYYY")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},(firstName?firstName:'')+" "+(lastName?lastName:''))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"S.No")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Operations ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Machine")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Folder/Guide")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Seconds")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"SAM")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Target Per Hour"))),smv&&smv.length>0&&smv.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.index),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.operations),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.machine),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.folder),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.seconds),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.sam),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.targetPerHour));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"5",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Total SAM")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalSam)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"MINUTES PER DAY")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},minutesPerDay)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"100% TARGET")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},target100),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"PCS PER TAILOR"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"80% TARGET")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},target80),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"PCS PER TAILOR"))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"bold text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Thread Consumption")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"w-100"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"S.No")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Operations")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Machine")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Length")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Factor")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Rating")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Total")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Needle")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Looper")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Over Lock")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"TRD Elastic")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Sheering Needle"))),threadCalculation&&threadCalculation.threadCalculationArray&&threadCalculation.threadCalculationArray.length>0&&threadCalculation.threadCalculationArray.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.index),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.operation),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.machine),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.length),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.factor),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},value.rating),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.total).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.needle).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.looper).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.overLock).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.trimThread).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},Number(value.sheeringNeedle).toFixed(2)));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"6",className:"label-text text-right "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null," Total:"," ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalVal),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalNeedle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalLooper),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalOverLock),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalTrimThread),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalSheeringNeedle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Wastage")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},wastage,"%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Other sizes")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},otherSizes," %")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Wash")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},wash," %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"7"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Needle")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"looper")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Over lock")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"TRD Elastic")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Sheering Needle"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Add %")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},wash+otherSizes+wastage,"%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3",className:"label-text text-right padding-top-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null," Total MTRS of REQD (Incl. Add%)")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalNeedleRound?totalNeedleRound:''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalLooperRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalOverLockRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalTrimThreadRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"},totalSheeringNeedleRound)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Size")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,selectedsize)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"7"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__["a" /* default */],{header:this.state.header,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},smvNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,smvNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-8 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Magnum Style No."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{name:"styleReferenceId",value:styleReferenceId,onInputChange:function onInputChange(value){return _this4.getMagnumStyleNo(value);},onChange:function onChange(val){return _this4.getStyleReferenceInfo(val);},placeholder:"Find Style",options:this.state.styleNoInfo,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name"},"Style Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null," ",magnumStyleName)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name"},"Customer/Department name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,customerName+"-"+departmentName)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"sampleType",value:sampleType,options:this.state.prefillInfo.SAMPLETYPE,label:"Sample Type",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",inputName:"sampleDate",label:"Sample Date",value:sampleDate,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"size",label:"Size",value:size,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",inputName:"chartPreparedOn",label:"Chart Prepared On",value:chartPreparedOn,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name"},"Chart Prepared By"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,this.state.firstName+" "+this.state.lastName)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 thread-consumption-sec2 smv-sec2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"lined bordered responsive-table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"5%"},"S. No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"20%"},"Operations"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"20%"},"Machine"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"20%"},"Folder / Guide "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"10%"},"Seconds"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"10%"},"SAM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"10%"},"Target Per Hour"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,smvdata.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{draggable:true,className:"droppable",onDrag:function onDrag(e){return _this4._onDragStart(e,index);},onDragOver:function onDragOver(event){return _this4._onDragOver(event);},onDrop:function onDrop(e){return _this4._onDropEnd(e,index);},key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,index+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"operations",value:value.operations,options:_this4.state.prefillInfo.OPERATION,index:index,onChange:_this4.updateValueForRowdata,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"machine",value:value.machine,options:_this4.state.prefillInfo.MACHINE,index:index,onChange:_this4.updateValueForRowdata,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"folder",value:value.folder,options:_this4.state.prefillInfo["FOLDER/GUIDE"],index:index,onChange:_this4.updateValueForRowdata,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"seconds",value:value.seconds,index:index,onChange:_this4.updateValueForRowdata,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"SAM",value:value.SAM!==Number.POSITIVE_INFINITY||value.SAM!==Number.NEGATIVE_INFINITY?value.SAM:null,index:index,onChange:_this4.updateValueForRowdata,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"targetPerHour",value:value.SAM!==Number.POSITIVE_INFINITY||value.targetPerHour!==Number.NEGATIVE_INFINITY?Math.ceil(value.targetPerHour).toFixed(0):null,index:index,onChange:_this4.updateValueForRowdata,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,_this4.state.action!="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this4.removeSmv(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"Total Sam"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number","class":"form-control customized-height-inputform",value:totalSam,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.action!="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this4.addSmv();}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"Minutes Per Day"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control customized-height-inputform",name:"minutesPerDay",value:minutesPerDay,onChange:function onChange(e){return _this4._handleInputChange(e.target.name,e.target.value);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"100% target"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control customized-height-inputform",name:"100Target",value:Math.ceil(this.state["100Target"]),onChange:function onChange(e){return _this4._handleInputChange(e.target.name,e.target.value);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label text-left"},"pcs per tailor"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"80% target"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control customized-height-inputform",name:"80Target",value:Math.ceil(this.state["80Target"]),onChange:function onChange(e){return _this4._handleInputChange(e.target.name,e.target.value);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label text-left"},"pcs per tailor"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"3"}))))),this.state.action!="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:function onClick(){return _this4.createSMV(false);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"p-3"},"Thread consumption")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:overlayApply}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:opacityApply,style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 product-form nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 thread-consumption-sec2 smv-sec2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"lined bordered responsive-table p-0",width:"100%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"3%"},"S.No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"12%"},"Operations"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"10%"},"Machine"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"12%"},"Thread"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"7%"},"Length"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"7%"},"Factor"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"6%"},"Rating"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"9%"},"Total"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"8%"},"Needle"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"8%"},"Looper"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"8%"},"over Lock"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"8%"},"TRD Elastic"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{width:"8%"},"Sheering needle")),threadData.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,index+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"operations",value:value.operations,options:_this4.state.prefillInfo.OPERATION,index:index// onChange={this.updateValuesforThreadCons}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"machine",value:value.machine,options:_this4.state.prefillInfo.MACHINE,index:index// onChange={this.updateValuesforThreadCons}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"thread",value:value.thread,options:_this4.state.prefillInfo.THREAD,index:index,onChange:_this4.updateValuesforThreadCons,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"length",style:{textAlign:"center"},value:value.length,index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"factor",style:{textAlign:"center"},value:value.factor,index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"rating",style:{textAlign:"center"},value:value.rating,index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"total",style:{textAlign:"center"},value:value.total,index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"needle",style:{textAlign:"center"},value:Number(value.total*(Number(value.needle)/100)).toFixed(2),index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"looper",style:{textAlign:"center"},value:Number(value.total*(Number(value.looper)/100)).toFixed(2),index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"overLock",style:{textAlign:"center"},value:Number(value.total*(Number(value.overLock)/100)).toFixed(2),index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"trimThread",style:{textAlign:"center"},value:Number(value.total*(Number(value.trimThread)/100)).toFixed(2),index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"sheeringNeedle",style:{textAlign:"center"},value:Number(value.total*(Number(value.sheeringNeedle)/100)).toFixed(2),index:index,onChange:_this4.updateValuesforThreadCons,disabled:_this4.state.disabled})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalVal).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalNeedle).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalLooper).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalOverLock).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalTrimThread).toFixed(2)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{textAlign:"center"}},Number(totalSheeringNeedle).toFixed(2))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"Wastage"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.wastage+" %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"Add"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,Number(this.state.wastage)+Number(this.state.otherSizes)+Number(this.state.wash)+" % "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"Other Sizes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.otherSizes+" %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"}," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"Needle"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.totalNeedleRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"  "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"},"wash"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.wash+" %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"class":"thread-label"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"Looper"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.totalLooperRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"O/L"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.totalOverLockRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"TRD ELASTIC"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.totalTrimThreadRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"thread-label"},"SHEERING NEEDLE TRD"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,this.state.totalSheeringNeedleRound),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"4"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table-bordered"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:this.state.allSizes.length},"Sizes")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,this.state.allSizes.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"group",type:"radio",className:"filled-in-size hide-all",id:data._id,value:data._id,checked:_this4.state.sizes===data._id,onChange:function onChange(name,value){return _this4._handleInputChange("sizes",data._id);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":data._id})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,data.size));}))))),this.state.action!="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(){return _this4.createThread(true);}}),this.state.threadId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonName:"Duplicate",onClick:this.confirmDuplicate}))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"printSmv_Ob",className:"d-none"},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__printSmv__["a" /* default */],{smvObData:this.state.smvObData})));}}]);return SmvThread;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{chartPreparedBy:state.main._id,firstName:state.main.firstName,lastName:state.main.lastName};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,null)(SmvThread));

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, document, Blob */


var propTypes = {
  table: _propTypes2.default.string.isRequired,
  filename: _propTypes2.default.string.isRequired,
  sheet: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  buttonText: _propTypes2.default.string
};

var defaultProps = {
  id: 'button-download-as-xls',
  className: 'button-download',
  buttonText: 'Download'
};

var ReactHTMLTableToExcel = function (_Component) {
  _inherits(ReactHTMLTableToExcel, _Component);

  function ReactHTMLTableToExcel(props) {
    _classCallCheck(this, ReactHTMLTableToExcel);

    var _this = _possibleConstructorReturn(this, (ReactHTMLTableToExcel.__proto__ || Object.getPrototypeOf(ReactHTMLTableToExcel)).call(this, props));

    _this.handleDownload = _this.handleDownload.bind(_this);
    return _this;
  }

  _createClass(ReactHTMLTableToExcel, [{
    key: 'handleDownload',
    value: function handleDownload() {
      if (!document) {
        if (false) {
          console.error('Failed to access document object');
        }

        return null;
      }

      if (document.getElementById(this.props.table).nodeType !== 1 || document.getElementById(this.props.table).nodeName !== 'TABLE') {
        if (false) {
          console.error('Provided table property is not html table element');
        }

        return null;
      }

      var table = document.getElementById(this.props.table).outerHTML;
      var sheet = String(this.props.sheet);
      var filename = String(this.props.filename) + '.xls';

      var uri = 'data:application/vnd.ms-excel;base64,';
      var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>{table}</body></html>';

      var context = {
        worksheet: sheet || 'Worksheet',
        table: table
      };

      // If IE11
      if (window.navigator.msSaveOrOpenBlob) {
        var fileData = ['' + ('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>') + table + '</body></html>'];
        var blobObject = new Blob(fileData);
        document.getElementById('react-html-table-to-excel').click()(function () {
          window.navigator.msSaveOrOpenBlob(blobObject, filename);
        });

        return true;
      }

      var element = window.document.createElement('a');
      element.href = uri + ReactHTMLTableToExcel.base64(ReactHTMLTableToExcel.format(template, context));
      element.download = filename;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        {
          id: this.props.id,
          className: this.props.className,
          type: 'button',
          onClick: this.handleDownload
        },
        this.props.buttonText
      );
    }
  }], [{
    key: 'base64',
    value: function base64(s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    }
  }, {
    key: 'format',
    value: function format(s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    }
  }]);

  return ReactHTMLTableToExcel;
}(_react.Component);

ReactHTMLTableToExcel.propTypes = propTypes;
ReactHTMLTableToExcel.defaultProps = defaultProps;

exports.default = ReactHTMLTableToExcel;


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
var PrintSmv=function(_Component){_inherits(PrintSmv,_Component);function PrintSmv(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintSmv);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintSmv.__proto__||Object.getPrototypeOf(PrintSmv)).call.apply(_ref,[this].concat(args))),_this),_this.state={smvObData:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintSmv,[{key:"componentWillMount",value:function componentWillMount(){var smvObData=this.props.smvObData;this.setState({smvObData:smvObData});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.smvObData!=this.props.smvObData){this.setState({smvObData:nextProps.smvObData});//   this.calculateTotal()
}}},{key:"render",value:function render(){var smvObData=this.state.smvObData;var threadCalculation=smvObData.threadCalculation,smv=smvObData.smv,styleReferenceId=smvObData.styleReferenceId,sampleType=smvObData.sampleType,magnumStyleName=smvObData.magnumStyleName,customerName=smvObData.customerName,departmentName=smvObData.departmentName,sampleDate=smvObData.sampleDate,size=smvObData.size,selectedsize=smvObData.selectedsize,chartPreparedOn=smvObData.chartPreparedOn,firstName=smvObData.firstName,lastName=smvObData.lastName,totalSam=smvObData.totalSam,minutesPerDay=smvObData.minutesPerDay,target100=smvObData.target100,target80=smvObData.target80;var threadCalculationArray=threadCalculation.threadCalculationArray,totalVal=threadCalculation.totalVal,totalNeedle=threadCalculation.totalNeedle,totalLooper=threadCalculation.totalLooper,totalOverLock=threadCalculation.totalOverLock,totalTrimThread=threadCalculation.totalTrimThread,totalSheeringNeedle=threadCalculation.totalSheeringNeedle,wastage=threadCalculation.wastage,add=threadCalculation.add,otherSizes=threadCalculation.otherSizes,totalNeedleRound=threadCalculation.totalNeedleRound,wash=threadCalculation.wash,totalLooperRound=threadCalculation.totalLooperRound,totalOverLockRound=threadCalculation.totalOverLockRound,totalTrimThreadRound=threadCalculation.totalTrimThreadRound,totalSheeringNeedleRound=threadCalculation.totalSheeringNeedleRound,allSizes=threadCalculation.allSizes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n                body{\n                    font-family: 'Montserrat', sans-serif;\n                    font-size:12px;\n                }\n                .fabricPrintDiv{\n                    border : 2px solid black;\n                    top : 0;\n                    bottom : 0;\n                }\n\n                .printrow {\n\n                    width: 100%;\n                }\n\n                .printcolumn {\n                    display: flex;\n                    flex-direction: column;\n                    flex-basis: 100%;\n                    flex: 1;\n                }\n                table>tbody>tr td{\n                    font-size:12px;\n                    text-align:center;\n                }\n                .label-text{\n                    color:#279588;\n                    font-size : 12px;\n                    font-weight:bold;\n                }\n                .blue{\n                    color : #146FF9;\n                }\n                .padding-for-heading{\n                    padding: 5px;\n                }\n\n\n                .specialComments{\n                    width: 75%;\n                    border : 1px solid black;\n                    height : 60px;\n                    margin: 10px;\n                }\n\n                .b{\n                    border: 1px solid black;\n                    margin: 10px;\n                    padding: 5px;\n                }\n                .fabric-text{\n                    font-size:16px;\n                    color: #279588;\n                    font-weight: 1000;\n                }\n\n                .bold{\n                    font-weight:bold;\n                }\n                .bb-p{\n                    border-bottom: 1px solid black;\n                    margin-bottom: 10px ;\n                }\n                .w-50 {\n                    width: 50%;\n                }\n                table.grid{\n                    border-collapse: collapse;\n                    margin-right: 5px;\n                    margin-left: 5px;\n                }\n                table.grid>tbody>tr td {\n                    border: 0.5px solid black;\n                    text-align: center;\n                    padding: 2px;\n                }\n                .width-for-table{\n                    width: 50%;\n                }\n                .text-center{\n                    text-align: center;\n                }\n                .p-1{\n                    padding : 5px;\n                }\n                .pl-1{\n                    padding-left: 23px;\n                }\n                .border-bot{\n                    border-bottom : 1px solid black;\n                }\n                .mt{\n                    margin-top:10px;\n                }\n                .mtl{\n                    margin-top:30px;\n                }\n                .margin{\n                    margin : 5px;\n                }\n                .pl-2{\n                    padding: 5px;\n                }\n                .table-heading{\n                    padding-left:5px;\n                    margin:0;\n                    color:#4285f4;\n                    text-transform:uppercase;\n\n                }\n\n                .text-capitalize{\n                    text-transform: capitalize;\n                }\n\n                .padding-option{\n                    padding:0px 20px 0px 20px;\n\n                }\n                .paddingleft{\n                    padding-left:25px !important;\n                }\n                table{\n                    width:100%;\n                }\n                .test-class{\n                    width:40%;\n\n                    display:inline-block\n                }\n                .test-class1{\n                    width:20%;\n                    display:inline-block\n                }\n                .test-class2{\n                    width:40%;\n                    display:inline-block\n                }\n\n                .float-left{\n                    float:left !important;\n                }\n                .text-right{\n                    text-align:right !important;\n                }\n                .text-left{\n                    text-align:left !important;\n                }\n                .padding-top-align{\n                    padding-top:15px !important;\n                }\n                }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 "},"Create SMV/OB and Thread Consumption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"style no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"style name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"customer name")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},styleReferenceId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},magnumStyleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},customerName+"/"+departmentName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sample type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sample date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"chart prepared on"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"chart prepared by")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_1_moment___default()(sampleDate).format("HH:mm DD MMM YYYY")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_1_moment___default()(chartPreparedOn).format("HH:mm DD MMM YYYY")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},firstName+" "+lastName)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"s.no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"operations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"machine"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"folder/guide"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"seconds"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SAM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"target per hour")),smv&&smv.length>0&&smv.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.index),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.operations),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.machine),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.folder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.seconds),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.sam),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.targetPerHour));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"5",className:"label-text text-right"},"Total SAM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalSam)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"MINUTES PER DAY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},minutesPerDay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"100% TARGET"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},target100),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},"PCS PER TAILOR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"80% TARGET"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},target80),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},"PCS PER TAILOR")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold text-center"},"Thread Consumption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"s.no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"operations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"machine"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"length"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"factor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"rating"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"needle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"looper"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"over lock"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TRD Elastic"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sheering needle")),threadCalculationArray&&threadCalculationArray.length>0&&threadCalculationArray.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.index),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.operation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.machine),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.length),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.factor),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},value.rating),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.total).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.needle).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.looper).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.overLock).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.trimThread).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Number(value.sheeringNeedle).toFixed(2)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"6",className:"label-text text-right "},"Total:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalVal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalNeedle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalLooper),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalOverLock),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalTrimThread),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalSheeringNeedle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"Wastage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},wastage,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"Other sizes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},otherSizes," %")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"Wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},wash," %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Needle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"looper"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"over lock"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TRD Elastic"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sheering needle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"},"Add %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},wash+otherSizes+wastage,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3",className:"label-text text-right padding-top-align"},"Total MTRS of REQD (Incl. Add%)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalNeedleRound),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalLooperRound),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalOverLockRound),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalTrimThreadRound),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},totalSheeringNeedleRound)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},selectedsize)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"2",className:"label-text text-right"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3"}))))))));}}]);return PrintSmv;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintSmv);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__printTechnical__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Loading__ = __webpack_require__(12);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TechnicalIssues=function(_Component){_inherits(TechnicalIssues,_Component);function TechnicalIssues(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TechnicalIssues);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TechnicalIssues.__proto__||Object.getPrototypeOf(TechnicalIssues)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",magnumStyleId:null,styleReferenceId:null,styleReferenceCode:" ",styleNumber:" ",customerName:" ",departmentName:" ",magnumStyleName:" ",createdBy:" ",createdAt:null,technicalIssue:{},technicalData:{},isLoading:false,disabled:false},_this.getSampleType=function(){__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getSampleType().then(function(response){if(response.status==200){var SAMPLETYPELIST=response.text.data.sysData;// response.text.data.sysData.map(data =>
//   SAMPLETYPELIST.push({ label: data.name, value: data._id })
// )
_this.setState({SAMPLETYPELIST:SAMPLETYPELIST});}}).catch(function(error){return _this.props.getalertMessage("error ",error.toString());});},_this.createTechnicalIssue=function(){var technicalIssue=Object.assign({},_this.state.technicalIssue);technicalIssue.styleReferenceId=_this.state.styleReferenceId;technicalIssue.magnumStyleId=_this.state.magnumStyleId;technicalIssue.date=technicalIssue.date==null?new Date():technicalIssue.date;__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].createTechnicalIssue(technicalIssue).then(function(response){if(response.status===200){if(_this.state.action===""||_this.state.action==="add"){technicalIssue._id=response.text.data._id;_this.setState({technicalIssue:Object.assign({},_this.state.technicalIssue,{_id:response.text.data._id})});}_this.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.handleChange=function(name,value){// console.log(name, value)
var technicalIssue=Object.assign({},_this.state.technicalIssue);technicalIssue[name]=value;_this.setState({technicalIssue:technicalIssue});// console.log(this.state.technicalIssue)
},_this.technicalIssuePrint=function(){setTimeout(function(){var technicalData={};var state=Object.assign({},_this.state);var technicalIssue=Object.assign({},_this.state.technicalIssue);if(state.technicalIssue.sampleType!==null){technicalData.sampleType=_this.state.SAMPLETYPELIST&&_this.state.SAMPLETYPELIST.length>0&&_this.state.SAMPLETYPELIST.map(function(data,index){if(data.value===state.technicalIssue.sampleType){return data.label;}}).filter(Boolean)[0];}technicalData.styleNumber=state.styleReferenceCode.split('-')[0];technicalData.styleReferenceCode=state.styleReferenceCode;technicalData.customerName=state.customerName;technicalData.departmentName=state.departmentName;technicalData.magnumStyleName=state.magnumStyleName;technicalData.createdAt=technicalIssue.createdAt&&__WEBPACK_IMPORTED_MODULE_7_moment___default()(technicalIssue.createdAt).format("DD MMM YYYY")||"";technicalData.createdBy=state.createdBy;technicalData.date=__WEBPACK_IMPORTED_MODULE_7_moment___default()(technicalIssue.date).format("DD MMM YYYY");technicalData.attendees=technicalIssue.attendees;technicalData.fabric=technicalIssue.fabric;technicalData.trims=technicalIssue.trims;technicalData.embelishmentAndEmbroidery=technicalIssue.embelishmentAndEmbroidery;technicalData.pattern=technicalIssue.pattern;technicalData.cutting=technicalIssue.cutting;technicalData.makeupOrsewingOrconstruction=technicalIssue.makeupOrsewingOrconstruction;technicalData.safety=technicalIssue.safety;technicalData.additionalInfo=technicalIssue.additionalInfo;technicalData.washing=technicalIssue.washing;technicalData.machinery=technicalIssue.machinery;_this.setState({technicalData:technicalData});},500);},_this.openPrint=function(val){var technicalData=JSON.parse(JSON.stringify(_this.state.technicalData));_this.setState({technicalData:technicalData,printLoading:true},function(){var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.print();newWin.close();});},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleNoInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getStyleReferenceInfo=function(styleReferenceId){if(styleReferenceId!==null){styleReferenceId=(typeof styleReferenceId==="undefined"?"undefined":_typeof(styleReferenceId))=="object"?styleReferenceId.value:styleReferenceId;__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getStyleInfoByReference(styleReferenceId).then(function(response){if(response.status===200){_this.setState({magnumStyleName:response.text.data.magnumStyleName,magnumStyleId:response.text.data.magnumStyleId,customer:response.text.data.customer!==""?response.text.data.customer:null,customerDepartmentId:response.text.data.customerDepartmentId,customerName:response.text.data.customerName,departmentName:response.text.data.departmentName,styleReferenceId:styleReferenceId}// () => this.getMagnumStyleById(styleReferenceId),
// this.getSMVCustomerData(response.text.data.customer, response.text.data.customerDepartmentId)
);}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}else{_this.setState({styleReferenceId:null,customer:null,customerDepartmentId:null,customerName:"",departmentName:"",magnumStyleId:null,magnumStyleName:""},function(){return _this.getMagnumStyleNo("");});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TechnicalIssues,[{key:"componentWillMount",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;var _props$location$state,styleReferenceId,action,_id,search;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.setState({isLoading:true});// this.getMagnumStyleNo("");
if(this.props.location.state){_props$location$state=this.props.location.state,styleReferenceId=_props$location$state.styleReferenceId,action=_props$location$state.action,_id=_props$location$state._id;action==='add'&&this.getMagnumStyleNo("");}else{this.getMagnumStyleNo("");this.setState({isLoading:false});}if(!styleReferenceId&&!action&&!_id){// this.getMagnumStyleNo("");
this.setState({isLoading:false});}if(!(styleReferenceId!=="")){_context3.next=8;break;}// this.getMagnumStyleNo("");
this.setState({styleReferenceId:styleReferenceId,action:action});setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.getStyleReferenceInfo(styleReferenceId);case 2:case"end":return _context.stop();}}},_callee,_this2);})),200);_context3.next=8;return __WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getStyleInfoByReference(styleReferenceId).then(function(response){if(response.status===200){_this2.setState({magnumStyleName:response.text.data.magnumStyleName,styleReferenceCode:response.text.data.referenceCode,customerName:response.text.data.customerName,departmentName:response.text.data.departmentName,magnumStyleId:response.text.data.magnumStyleId,// styleNumber: response.text.data.styleNumber,
// createdBy: `${response.text.data.createdBy.firstName}-${response.text.data.createdBy.lastName}`,
styleReferenceId:styleReferenceId,isLoading:false});}response.status==401&&_this2.props.unauthorisedFunc();}).catch(function(error){return _this2.props.getalertMessage("error ",error.toString());});case 8:if(!(action==='edit'||action==="view")){_context3.next=13;break;}search=true;_context3.next=12;return __WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getTechnicalIssues(_id).then(function(response){if(response.status===200){var jsonData=[];if(response.text.data.styleReferenceId){jsonData=[{label:response.text.data.styleReferenceCode,value:response.text.data.styleReferenceId}];}_this2.setState({styleNoInfo:jsonData,technicalIssue:response.text.data,magnumStyleName:response.text.data.magnumStyleName,styleReferenceCode:response.text.data.styleReferenceCode,customerName:response.text.data.customerName||"",departmentName:response.text.data.departmentName,magnumStyleId:response.text.data.magnumStyleId,styleReferenceId:response.text.data.styleReferenceId,createdBy:response.text.data.createdBy.firstName+"-"+response.text.data.createdBy.lastName,isLoading:false,action:action,disabled:action==="view"&&true||false});}response.status==401&&_this2.props.unauthorisedFunc();}).catch(function(error){return _this2.props.getalertMessage("error ",error.toString());});case 12:setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.getStyleReferenceInfo(_this2.state.styleReferenceId);case 2:case"end":return _context2.stop();}}},_callee2,_this2);})),200);case 13:_context3.next=15;return this.getSampleType();case 15:case"end":return _context3.stop();}}},_callee3,this);}));function componentWillMount(){return _ref2.apply(this,arguments);}return componentWillMount;}()},{key:"render",value:function render(){var _this3=this;var _state=this.state,styleNumber=_state.styleNumber,styleReferenceId=_state.styleReferenceId,styleReferenceCode=_state.styleReferenceCode,customerName=_state.customerName,departmentName=_state.departmentName,magnumStyleName=_state.magnumStyleName,technicalIssue=_state.technicalIssue,createdAt=_state.createdAt,createdBy=_state.createdBy;if(this.state.isLoading===false){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("fieldset",{disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon pull-right ml-auto mr-5",onClick:function onClick(e){_this3.setState({isLoading:true});setTimeout(function(){_this3.technicalIssuePrint();_this3.setState({isLoading:false});setTimeout(function(){return _this3.openPrint("printTechnical");},500);},500);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_printer_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding bg-white "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Page_PageHeader_PageHeader__["a" /* default */],{header:"Technical Issues ",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding thread-consumption-sec1 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Style Ref No."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"styleReferenceId",value:styleReferenceId,onInputChange:function onInputChange(value){return _this3.getMagnumStyleNo(value);},onChange:function onChange(val){return _this3.getStyleReferenceInfo(val);},placeholder:"Find Style",options:this.state.styleNoInfo,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name "},"Style Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,magnumStyleName)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name "},"Customer & Department Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,customerName+"-\n                          "+departmentName)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name ","class":"active "},"Created Date"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,technicalIssue.createdAt&&__WEBPACK_IMPORTED_MODULE_7_moment___default()(technicalIssue.createdAt).format("DD MMM YYYY ")||__WEBPACK_IMPORTED_MODULE_7_moment___default()().format("DD MMM YYYY ")))),createdBy!==" "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name","class":"active"},"Chart Prepared By"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,createdBy)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"sampleType",value:technicalIssue.sampleType,options:this.state.SAMPLETYPELIST,label:"Sample Type",onChange:this.handleChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 step-one "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"date",value:technicalIssue.date||new Date(),inputName:"date",label:"Date ",onChange:this.handleChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 step-one meeting_count "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"attendees",value:technicalIssue.attendees,label:"Who Attended Meeting",onChange:this.handleChange,disabled:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 ti_table "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{name:"technicalIssues "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"lined bordered responsive-table "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Check Point"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Comments"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Fabric"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"fabric","class":"form-control",cols:"80",rows:"4",value:technicalIssue.fabric,onChange:function onChange(e){return _this3.handleChange("fabric",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Trims"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"trims","class":"form-control",cols:"80",rows:"4",value:technicalIssue.trims,onChange:function onChange(e){return _this3.handleChange("trims",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null," Embelishment & Embroidery"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"embelishmentAndEmbroidery","class":"form-control",cols:"80",rows:"4",value:technicalIssue.embelishmentAndEmbroidery,onChange:function onChange(e){return _this3.handleChange("embelishmentAndEmbroidery",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"PATTERN"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"pattern","class":"form-control",cols:"80",rows:"4",value:technicalIssue.pattern,onChange:function onChange(e){return _this3.handleChange("pattern",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"CUTTING"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"cutting","class":"form-control",cols:"80",rows:"4",value:technicalIssue.cutting,onChange:function onChange(e){return _this3.handleChange("cutting",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"MAKEUP/SEWING/CONSTRUCTION"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"makeupOrsewingOrconstruction","class":"form-control",cols:"80",rows:"4",value:technicalIssue.makeupOrsewingOrconstruction,onChange:function onChange(e){return _this3.handleChange("makeupOrsewingOrconstruction",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"SAFETY"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"safety","class":"form-control",cols:"80",rows:"4",value:technicalIssue.safety,onChange:function onChange(e){return _this3.handleChange("safety",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"ADDITIONAL INFORMATION"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"additionalInfo","class":"form-control",cols:"80",rows:"4",value:technicalIssue.additionalInfo,onChange:function onChange(e){return _this3.handleChange("additionalInfo",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"WASHING"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"washing","class":"form-control",cols:"80",rows:"4",value:technicalIssue.washing,onChange:function onChange(e){return _this3.handleChange("washing",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"MACHINERY"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{name:"machinery","class":"form-control",cols:"80",rows:"4",value:technicalIssue.machinery,onChange:function onChange(e){return _this3.handleChange("machinery",e.target.value);}}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 text-center align-items-center "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Buttons_Button__["a" /* default */],{buttonType:"save ",buttonName:"save ",onClick:this.createTechnicalIssue}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"printTechnical",className:"d-none"},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__printTechnical__["a" /* default */],{technicalData:this.state.technicalData})));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Loading__["a" /* default */],null);}}}]);return TechnicalIssues;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TechnicalIssues);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
var PrintSmv=function(_Component){_inherits(PrintSmv,_Component);function PrintSmv(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintSmv);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintSmv.__proto__||Object.getPrototypeOf(PrintSmv)).call.apply(_ref,[this].concat(args))),_this),_this.state={technicalData:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintSmv,[{key:"componentWillMount",value:function componentWillMount(){var technicalData=this.props.technicalData;this.setState({technicalData:technicalData});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.technicalData!=this.props.technicalData){this.setState({technicalData:nextProps.technicalData});//   this.calculateTotal()
}}},{key:"render",value:function render(){var technicalData=this.state.technicalData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n                body{\n                    font-family: 'Montserrat', sans-serif;\n                    font-size:12px;\n                }\n                .fabricPrintDiv{\n                    border : 2px solid black;\n                    top : 0;\n                    bottom : 0;\n                }\n\n                .printrow {\n\n                    width: 100%;\n                }\n\n                .centerTextOnly {\n                  text-align:left;\n                  margin: 20px 10px ;\n                  padding: 20px 10px;\n                }\n                .printcolumn {\n                    display: flex;\n                    flex-direction: column;\n                    flex-basis: 100%;\n                    flex: 1;\n                }\n                table>tbody>tr td{\n                    font-size:12px;\n                    text-align:center;\n                }\n                .label-text{\n                    color:#279588;\n                    font-size : 12px;\n                    font-weight:bold;\n                }\n                .blue{\n                    color : #146FF9;\n                }\n                .padding-for-heading{\n                    padding: 5px;\n                }\n\n\n                .specialComments{\n                    width: 75%;\n                    border : 1px solid black;\n                    height : 60px;\n                    margin: 10px;\n                }\n\n                .b{\n                    border: 1px solid black;\n                    margin: 10px;\n                    padding: 5px;\n                }\n                .fabric-text{\n                    font-size:16px;\n                    color: #279588;\n                    font-weight: 1000;\n                }\n\n                .bold{\n                    font-weight:bold;\n                }\n                .bb-p{\n                    border-bottom: 1px solid black;\n                    margin-bottom: 10px ;\n                }\n                .w-50 {\n                    width: 50%;\n                }\n                table.grid{\n                    border-collapse: collapse;\n                    margin-right: 5px;\n                    margin-left: 5px;\n                }\n                table.grid>tbody>tr td {\n                    border: 0.5px solid black;\n                    text-align: center;\n                    padding: 2px;\n                }\n                .width-for-table{\n                    width: 50%;\n                }\n                .text-center{\n                    text-align: center;\n                }\n                .p-1{\n                    padding : 5px;\n                }\n                .pl-1{\n                    padding-left: 23px;\n                }\n                .border-bot{\n                    border-bottom : 1px solid black;\n                }\n                .mt{\n                    margin-top:10px;\n                }\n                .mtl{\n                    margin-top:30px;\n                }\n                .margin{\n                    margin : 5px;\n                }\n                .pl-2{\n                    padding: 5px;\n                }\n                .table-heading{\n                    padding-left:5px;\n                    margin:0;\n                    color:#4285f4;\n                    text-transform:uppercase;\n\n                }\n\n                .text-capitalize{\n                    text-transform: capitalize;\n                }\n\n                .padding-option{\n                    padding:0px 20px 0px 20px;\n\n                }\n                .paddingleft{\n                    padding-left:25px !important;\n                }\n                table{\n                    width:100%;\n                }\n                .test-class{\n                    width:40%;\n\n                    display:inline-block\n                }\n                .test-class1{\n                    width:20%;\n                    display:inline-block\n                }\n                .test-class2{\n                    width:40%;\n                    display:inline-block\n                }\n\n                .float-left{\n                    float:left !important;\n                }\n                .text-right{\n                    text-align:right !important;\n                }\n                .text-left{\n                    text-align:left !important;\n                }\n                .padding-top-align{\n                    padding-top:15px !important;\n                }\n                }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 "},"Technical Issues"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"style no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Style Ref No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Style Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Created Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Chart Prepared By")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.styleNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.styleReferenceCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.magnumStyleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.createdAt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.createdBy)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Customer & Department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Who Attended Meeting")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.customerName+"/"+technicalData.departmentName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.sampleType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},technicalData.attendees)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Fabric")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.fabric))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Trim")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.trims))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Embellishment & Embroidery")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.embelishmentAndEmbroidery))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Pattern")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.pattern))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Cutting")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.cutting))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Makeup / Sewing / Construction")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.makeupOrsewingOrconstruction))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Safety")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.safety))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Additional Information")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.additionalInfo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Washing")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.washing))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-left"},"Machinery")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bb-p centerTextOnly"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,technicalData.machinery)))))));}}]);return PrintSmv;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintSmv);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var PermissionRole=function(_Component){_inherits(PermissionRole,_Component);function PermissionRole(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PermissionRole);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PermissionRole.__proto__||Object.getPrototypeOf(PermissionRole)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,roleName:"",description:""},_this.createRole=function(){if(_this.state.action==="add"){__WEBPACK_IMPORTED_MODULE_1__services__["h" /* PermissionServices */].createRole(_this.state.roleName,_this.state.description).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);_this.setState({roleName:"",description:""});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else if(_this.state.action==="edit"){__WEBPACK_IMPORTED_MODULE_1__services__["h" /* PermissionServices */].editRole(_this.state._id,_this.state.roleName,_this.state.description).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);_this.setState({roleName:"",description:""});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PermissionRole,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var _props$location$state=this.props.location.state,action=_props$location$state.action,_id=_props$location$state._id;if(action=="add"){}if(action=="view"||action=="edit"){}if(action=="view"){this.setState({disabled:true});}if(action==="edit"||action==="view"){__WEBPACK_IMPORTED_MODULE_1__services__["h" /* PermissionServices */].getRole(_id).then(function(response){if(response.status===200){_this2.setState({roleName:response.text.data.roleName,description:response.text.data.description});}else if(response.status==401){_this2.props.unauthorisedFunc();}else{_this2.props.getalertMessage('error',response.text.message);}}).catch(function(error){return _this2.props.getalertMessage("error",error.toString());});}this.setState({action:action,_id:_id});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,roleName=_state.roleName,description=_state.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__["a" /* default */],{header:"Role",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 col-md-offset-3",style:{marginTop:"2%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"roleName",value:roleName,label:"Role Name",onChange:function onChange(name,value){return _this3.setState(_defineProperty({},name,value));},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"description",value:description,label:"Description",onChange:function onChange(name,value){return _this3.setState(_defineProperty({},name,value));},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:this.createRole}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Buttons_Button__["a" /* default */],{history:this.props.history,buttonType:"cancel",buttonName:"Cancel"})))))));}}]);return PermissionRole;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PermissionRole);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Field_CustomerDeptSelect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_picky_dist_picky_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ButtonCol__ = __webpack_require__(226);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
// Include CSS
//css
// import './cad.css'
var DevelopmentCAD=function(_Component){_inherits(DevelopmentCAD,_Component);function DevelopmentCAD(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DevelopmentCAD);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DevelopmentCAD.__proto__||Object.getPrototypeOf(DevelopmentCAD)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,prefillData:{IMAGETYPE:[],CATEGORY:[],BORDERTYPE:[],SEASONS:[],BASICFABRICQUALITY:[],CADTYPE:[],PRINTEMBTYPE:[],COLORREFERENCE:[]},cadReferenceName:"",cadReferenceCountName:"",cadRefId:[],cadReferenceCount:[],createOption:false,CADId:"",uploadCAD:"",uploadPatternEmb:"",sampleRequestNumbers:[],assignedToOptions:[],cadObj:{cadName:"",qr:"",cadType:[],cadImage:"",assignedTo:null,sampleRequestId:null,cadNumber:null,basicFabricQuality:null,magnumStyleId:null,styleReferenceId:null,category:null,customer:null,customerDepartmentId:null,seasons:null,storyName:"",printType:null,borderType:null,options:[],refImages:[]},cadTypeArr:[],selectedOptions:[],customerList:[],style:{customer:null,customerDepartmentId:null},styleInfo:null},_this.prefillInfo=function(){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].prefillDataCadSystem().then(function(response){if(response.status===200){_this.setState({prefillData:response.text.data});}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.saveCAD=function(e){e.preventDefault();var cadObj=Object.assign({},_this.state.cadObj);if(cadObj.magnumStyleId!==null&&_typeof(cadObj.magnumStyleId)==="object"){cadObj.magnumStyleId=cadObj.magnumStyleId.value;}if(cadObj.sampleRequestId!==null&&_typeof(cadObj.sampleRequestId)==="object"){cadObj.sampleRequestId=cadObj.sampleRequestId.value;}if(cadObj.assignedTo!==null&&_typeof(cadObj.assignedTo)==="object"){cadObj.assignedTo=cadObj.assignedTo.value;}if(cadObj.styleReferenceId!==null&&_typeof(cadObj.styleReferenceId)==="object"){cadObj.styleReferenceId=cadObj.styleReferenceId.value;}cadObj.cadType=cadObj.cadType.map(function(data){return typeof data!=="string"?data.value:data;});if(_this.state._id!==""){cadObj._id=_this.state._id;}__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].createCAD(cadObj).then(function(response){if(response.status===200){_this.setState({createOption:true,_id:response.text.data._id});_this.props.getalertMessage("success",response.text.message);}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.createCAD=function(){var cadObj=_this.state.cadObj;cadObj.options.push({cadRef:null,cadName:"",cadImage:"",colourRefFrom:null,colourDetails:"",cadRefImages:[]});_this.setState({cadObj:cadObj});},_this.createReference=function(e,index){// e.preventDefault()
var cadObj=Object.assign({},_this.state.cadObj);var options=Object.assign({},cadObj.options[index]);options.cadId=_this.state._id;__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].createReference(options).then(function(res){if(res.status===200){var cad=res.text.data;_this.props.getalertMessage("success","Cad Reference Updated");var _cadObj=Object.assign({},_this.state.cadObj);_cadObj.options=cad.options;_this.setState({createOption:false,cadObj:_cadObj});}res.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.removeCADReference=function(id){var cadObj=_this.state.cadObj;cadObj.options=cadObj.options.filter(function(x){return x._id!=id;});_this.setState({cadObj:cadObj});__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].removeCADReference(_this.state._id,id).then(function(response){if(response.message==="Operation Successful"){_this.props.getalertMessage("success","Cad Reference removed success");// this.setState({ cadRefId: this.state.cadRefId.push(a._id) })
}}).catch(function(error){});},_this.uploadNewImage=function(e,index){var b={};b=e.target.files[0];b.imageName=_this.state["imageInfo"+index].imageName;b.imageDescription=_this.state["imageInfo"+index].imageDescription;_this.setState(_defineProperty({},"uploadNewImage"+index,b));},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleInfo:jsonData});}}).catch(function(error){//this.props.getalertMessage('error',error.toString())
});},_this.changeStyleNo=function(styleValue){if(styleValue!==null){var cadObj=_this.state.cadObj;cadObj.styleReferenceId=styleValue.value;__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].getStyleInfoByReference(styleValue.value).then(function(response){if(response.status===200){cadObj.magnumStyleName=response.text.data.magnumStyleName;cadObj.customerRefNumber=response.text.data.customerRefNumber;cadObj.magnumStyleId=response.text.data.magnumStyleId;cadObj.customer=response.text.data.customer;cadObj.customerDepartmentId=response.text.data.customerDepartmentId;_this.setState({cadObj:cadObj,sampleRequestNumbers:response.text.data.sampleRequest});if(!response.text.data.sampleRequest||!response.text.data.sampleRequest.length){_this.props.getalertMessage("info","This style ref no does'nt have Requests");}}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{var _cadObj2=_this.state.cadObj;_cadObj2.styleReferenceId=null;_cadObj2.magnumStyleId=null;_cadObj2.magnumStyleName="";_cadObj2.customer=null;_cadObj2.customerDepartmentId=null;_this.setState({cadObj:_cadObj2});}},_this.getSampleRqNo=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["j" /* SampleServices */].getSampleReqNo(value).then(function(response){if(response.status===200){_this.setState({sampleRequestNumbers:response.text.data});}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeSampleNo=function(sampleNo){if(sampleNo!==null&&sampleNo.value!==undefined&&sampleNo.value!==""){__WEBPACK_IMPORTED_MODULE_3__services__["j" /* SampleServices */].getStyleInfo(sampleNo.value).then(function(response){if(response.status===200){var cadObj=Object.assign({},_this.state.cadObj);cadObj.sampleRequestId=sampleNo.value;cadObj.customer=response.text.data.customer;cadObj.customerDepartmentId=response.text.data.customerDepartmentId;cadObj.magnumStyleId=response.text.data.magnumStyleId._id;cadObj.styleReferenceId=response.text.data.styleReferenceId;_this.setState({cadObj:cadObj});}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{var cadObj=Object.assign({},_this.state.cadObj);cadObj.sampleRequestId=null;cadObj.customer=null;cadObj.customerDepartmentId=null;cadObj.magnumStyleId=null;cadObj.styleReferenceId=null;_this.setState({cadObj:cadObj});}},_this.cadStatus=function(e){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].cadStatus(e.target.checked,_this.state.CADId).then(function(response){}).catch(function(error){_this.msg.show("Try Again Later",{time:2000,type:"info"});});},_this.getCadImages=function(cadRefImages,index){var cadObj=_this.state.cadObj;cadObj.options[index].cadRefImages=cadRefImages;_this.setState({cadObj:cadObj});},_this.imageUploadCadRefImage=function(files,index){__WEBPACK_IMPORTED_MODULE_3__services__["f" /* FileUploadService */].uploadFile(files[0],"cadOptions").then(function(response){if(response.status===200){var cadObj=Object.assign({},_this.state.cadObj);cadObj.options[index].cadImage=response.text.data.url;_this.setState({cadObj:cadObj});}else if(response.status===401){_this.props.unauthorisedFunc();}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].manualErrorMsg(_this.msg," Something went wrong ");}}).catch(function(error){});},_this.searchAssignedTo=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status==200){_this.setState({actionedByOption:[].concat(_toConsumableArray(response.text.data))});}case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());}},_this.getAssignedTo=function(data){var cadObj=Object.assign({},_this.state.cadObj);if(data!==null){cadObj.assignedTo=data.value;_this.setState({cadObj:cadObj,assignedToObj:data});}else{cadObj.assignedTo=null;_this.setState({cadObj:cadObj,assignedToObj:null});}},_this._onChange=function(name,value){var cadObj=Object.assign({},_this.state.cadObj);cadObj[name]=value;_this.setState({cadObj:cadObj});},_this.getRefImages=function(refImages){var cadObj=Object.assign({},_this.state.cadObj);cadObj.refImages=refImages;_this.setState({cadObj:cadObj});},_this.onMultiSelect=function(val){var cadTypeArr=[];cadTypeArr.push(val);_this.setState({cadTypeArr:cadTypeArr});},_this.handleSelectedChanged=function(selected){},_this.imageUploadForCad=function(files){__WEBPACK_IMPORTED_MODULE_3__services__["f" /* FileUploadService */].uploadFile(files[0],"cad").then(function(response){if(response.status===200){var cadObj=Object.assign({},_this.state.cadObj);cadObj.cadImage=response.text.data.url;_this.setState({cadObj:cadObj});}else if(response.status===401){_this.props.unauthorisedFunc();}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].manualErrorMsg(_this.msg," Something went wrong ");}}).catch(function(error){});},_this._handleChangeCadType=function(val){var cadObj=Object.assign({},_this.state.cadObj);cadObj.cadType=val;_this.setState({cadObj:cadObj});},_this._handleCustDeptChange=function(index,customer,customerDepartmentId){var cadObj=Object.assign({},_this.state.cadObj);cadObj.customer=customer;cadObj.customerDepartmentId=customerDepartmentId;_this.setState({cadObj:cadObj});},_this.removeCadImageOptions=function(e,index){var cadObj=_this.state.cadObj;cadObj.options[index].cadImage="";_this.setState({cadObj:cadObj});},_this.removeCadImage=function(){var cadObj=_this.state.cadObj;cadObj.cadImage="";_this.setState({cadObj:cadObj});},_this.updateOptionValue=function(name,value,index){var cadObj=_this.state.cadObj;cadObj.options[index][name]=value;_this.setState({cadObj:cadObj});},_this.checkValidation=function(e){if(_this.validateArrayObject(_this.state.cadObj,"cadName",null)&&_this.state.cadObj.cadType.length>0&&_this.validateArrayObject(_this.state.cadObj,"category",null)&&_this.validateArrayObject(_this.state.cadObj,"printType",null)&&_this.validateArrayObject(_this.state.cadObj,"customer",null)&&_this.validateArrayObject(_this.state.cadObj,"customerDepartmentId",null)){_this.saveCAD(e);}else{_this.props.getalertMessage("error","Please fill all mandatory fields");}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DevelopmentCAD,[{key:"componentWillMount",value:function componentWillMount(){var _this3=this;var _props$location$state=this.props.location.state,action=_props$location$state.action,_id=_props$location$state._id;if(action==="view"){this.setState({disabled:true});}if(_id!==""){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getCAD(_id).then(function(response){if(response.status===200){var obj=Object.assign({},response.text.data);// Object.keys(obj).forEach(function (keyn) {
//   if (keyn in cadObj) {
//     cadObj[keyn] = response.text.data[keyn]
//   }
// })
_this3.setState({cadObj:obj,createOption:obj.options.length?false:true});// this.setState({ styleInfo: cadObj.magnumStyleId })
}}).catch(function(error){});}this.setState({action:action,_id:_id});this.prefillInfo();this.getSampleRqNo("");this.getMagnumStyleNo("");//actioned By
__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].searchEmploye("").then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){var actionedByOption;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:actionedByOption=[].concat(_toConsumableArray(response.text.data));_this3.setState({actionedByOption:actionedByOption,isLoading:true});case 2:case"end":return _context2.stop();}}},_callee2,_this3);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){return _this3.props.getalertMessage("error",error);});//Get Customer List
__WEBPACK_IMPORTED_MODULE_3__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this3.setState({customerList:response.text.data});}}).catch(function(error){_this3.props.getalertMessage("error",error.toString());});}},{key:"componentDidMount",value:function componentDidMount(){var _this4=this;var action=this.props.location.state.action;if(action==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getCadNumber().then(function(response){if(response.status===200){var cadNumber=response.text.data.cadNumber;_this4.setState({cadObj:Object.assign({},_this4.state.cadObj,{cadNumber:cadNumber})});response.status===401&&_this4.props.unauthorisedFunc();}}).catch(function(error){_this4.props.getalertMessage("error",error.toString());});}this.getSampleRqNo("");if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}//image updload for cad ref images
},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data[key]!==val?true:false;return values;}},{key:"render",value:function render(){var _this5=this;var _state=this.state,cadObj=_state.cadObj,prefillData=_state.prefillData,selectedOptions=_state.selectedOptions,style=_state.style;// let cadType = ""
// let styleNOInfoVal =
//   cadObj.magnumStyleId !== null && cadObj.magnumStyleId.label
// let customerDeptName =
//   cadObj.customer !== null &&
//   cadObj.customer.customerDepartmentName +
//   "-" +
//   cadObj.customer.customerName
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"3D"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{name:"cadInfo",id:"test"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},this.state.CADId!==""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"nav-locator fabric-status"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{"for":"status"},"Status"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"switch switch-mod"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{value:"status","class":"sample-opt-chckbox",type:"checkbox",onChange:function onChange(e){return _this5.cadStatus(e);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{"class":"lever"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-2"},this.state.cadReferenceName!==""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"cat"},"3D Ref No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control",name:"cadReferenceName",value:this.state.cadReferenceName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group pl-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{style:{paddingLeft:"3em"}},this.state.cadObj.cadNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"upload-photo"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:this.state.cadObj.cadImage!=""?__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+this.state.cadObj.cadImage:__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default.a}),this.state.cadObj.cadImage!=""&&this.state.cadObj.cadImage!==""?"":__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black btn-img-upload"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons input-file-i"},"add")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"positioing-section"},this.state.cadObj.cadImage!=""&&!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pull-right p-1 edit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",className:"fileInputs",onChange:function onChange(e){return _this5.imageUploadForCad(e.target.files);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-edit icon-fa-color print-hidden"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pull-right p-1 delete"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-trash icon-fa-color print-hidden",onClick:function onClick(e){return _this5.removeCadImage(e);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",accept:"image/*",className:"input-file",name:"profilePicture",style:{display:"none"},onChange:function onChange(e){return _this5.imageUploadForCad(e.target.files);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-9 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"Assigned To"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"assignedTo",value:cadObj.assignedTo,onInputChange:this.searchAssignedTo,onChange:this.getAssignedTo,options:this.state.actionedByOption,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"cadName",value:cadObj.cadName,label:"3D NAME*",onChange:this._onChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"3D TYPE",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-danger madatory-asterisk"},"*")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_picky___default.a,{value:cadObj.cadType,className:"picky-custom-width",options:prefillData.CADTYPE,onChange:function onChange(val){return _this5._handleChangeCadType(val);},open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,includeFilter:true,dropdownHeight:300,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"basicFabricQuality",value:cadObj.basicFabricQuality,label:"Basic Fabric Quality",options:prefillData.BASICFABRICQUALITY,onChange:this._onChange,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"storyName",value:cadObj.storyName,label:"Story / Col Name",onChange:this._onChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"printType",value:cadObj.printType,label:"Print/Emb Type*",options:prefillData.PRINTEMBTYPE,onChange:this._onChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"borderType",value:cadObj.borderType,label:"Border Type",options:prefillData.BORDERTYPE,onChange:this._onChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"category",value:cadObj.category,label:"Category*",options:prefillData.CATEGORY,onChange:this._onChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"seasons",value:cadObj.seasons,label:"seasons",options:prefillData.SEASONS,onChange:this._onChange,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"Magnum Style No."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"magnumStyleId",value:this.state.cadObj.styleReferenceId,onInputChange:this.getMagnumStyleNo,onChange:this.changeStyleNo,placeholder:"Find Style",options:this.state.styleInfo,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"Sample Request No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"magnumStyleId",value:this.state.cadObj.sampleRequestId,onInputChange:function onInputChange(e){return _this5.getSampleRqNo(e);},onChange:this.changeSampleNo,placeholder:"Find Sample",options:this.state.sampleRequestNumbers,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_CustomerDeptSelect__["a" /* default */],{options:this.state.customerList,value:cadObj.customer+"-"+cadObj.customerDepartmentId,onChange:this._handleCustDeptChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 pl-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"name"},"Magnum Style Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"",name:"styleName",value:cadObj.magnumStyleName,disabled:this.state.disabled}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding px-5 mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"cad",getRefImages:this.getRefImages,disabled:this.state.disabled,uploadedDocs:this.state.cadObj.refImages.length>0?this.state.cadObj.refImages:null,imageTypeOption:this.state.prefillData?this.state.prefillData.IMAGETYPE:[]})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},!this.state.disabled&&this.state.createOption===true&&this.state.cadObj.options.length===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(){return _this5.createReference();},name:"button"}," ","Create Option"),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:function onClick(e){return _this5.checkValidation(e);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))))),this.state.cadObj.options.map(function(cad,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{id:index+1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{"class":"dev-title",style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null),!_this5.state.disabled?index===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:function onClick(){return _this5.createReference();}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(){return _this5.removeCADReference(cad._id);}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"upload-photo"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:cad.cadImage!=""?__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+cad.cadImage:__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default.a}),!_this5.state.disabled?cad.cadImage!=""&&cad.cadImage!==""?"":__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black btn-img-upload"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons input-file-i"},"add")):null,!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"positioing-section"},cad.cadImage!=""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pull-right p-1 edit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",className:"fileInputs",onChange:function onChange(e){return _this5.imageUploadCadRefImage(e.target.files,index);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-edit icon-fa-color print-hidden"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pull-right p-1 delete"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-trash icon-fa-color print-hidden",onClick:function onClick(e){return _this5.removeCadImageOptions(e,index);}}))):null),!_this5.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",accept:"image/*",className:"input-file",name:"profilePicture",style:{display:"none"},onChange:function onChange(e){return _this5.imageUploadCadRefImage(e.target.files,index);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-10",style:{marginBotton:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"item"},"CAD Reference"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,cad.cadRef)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"cadName",value:cad.cadName,index:index,label:"Cad Name",onChange:_this5.updateOptionValue,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"colourRefFrom",value:cad.colourRefFrom,index:index,label:"Colour Ref From",options:_this5.state.prefillData.COLORREFERENCE||[],onChange:_this5.updateOptionValue,disabled:_this5.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"colourDetails",value:cad.colourDetails,index:index,label:"Colour Details",onChange:_this5.updateOptionValue,disabled:_this5.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-5 mt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"cad",getRefImages:_this5.getCadImages,index:index,disabled:_this5.state.disabled,uploadedDocs:cad.cadRefImages.length>0?cad.cadRefImages:null,imageTypeOption:[]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ButtonCol__["a" /* ButtonCol */],{action:_this5.state.action,saveFunc:function saveFunc(e){return _this5.createReference(e,index);},disabled:_this5.state.disabled}))));})))));}}]);return DevelopmentCAD;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DevelopmentCAD);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//redux
//components
var DevelopmentSourcing=function(_Component){_inherits(DevelopmentSourcing,_Component);function DevelopmentSourcing(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DevelopmentSourcing);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DevelopmentSourcing.__proto__||Object.getPrototypeOf(DevelopmentSourcing)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",meetingNoteValue:"",soucingReqNo:"",images:[],imageForModal:"",openModal:false,sourceId:"",sourcingData:{sourcingNumber:null,date:null,magnumStyleId:null,MNID:null,requestGeneratedBy:null,sourcingFor:"",originationOfRequest:"",season:"",category:"",requirement:"",color:"",quantity:"",composition:"",measurement:"",dateRequiredAtMagnum:undefined,dateReceivedAtMagnum:undefined,additionalInfo:"",refImages:[]},//dummy value for selecting Async
styleNo:null,disabled:false},_this.searchMeetingNote=function(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].searchMeetingNotesBy(_this.state.searchMeetingNotesBy,_this.state.meetingNoteValue).then(function(response){if(response.status===200){_this.setState({meetingNotes:response.text.data.MN});}}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.createSourcing=function(e){e.preventDefault();var data=Object.assign({},_this.state.sourcingData);__WEBPACK_IMPORTED_MODULE_1__services__["e" /* DevelopmentServices */].createSource(data).then(function(response){if(response.status===200){_this.props.getalertMessage("success",_this.msg);_this.props.history.push("/list",{moduleName:'SOURCING'});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage('error',error.toString());_this.props.get;});},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_1__services__["e" /* DevelopmentServices */].getMagnumStyleNo(value).then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this.setState({styleNoInfo:jsonData});}}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.changeStyleNo=function(styleNo){alert(styleNo," style value onchagen");var sourcingData=Object.assign({},_this.state.sourcingData);sourcingData.magnumStyleId=styleNo.value;_this.setState({styleNo:styleNo,sourcingData:sourcingData});},_this.completeSource=function(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_1__services__["e" /* DevelopmentServices */].completeSource(_this.state.sourceId).then(function(response){if(response.status===200){}response.status===401;}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.updateValue=function(name,value){var sourcingData=Object.assign({},_this.state.sourcingData);sourcingData[name]=value;_this.setState({sourcingData:sourcingData});},_this.getSourcingImages=function(refImages){var sourcingData=Object.assign({},_this.state.sourcingData);sourcingData.refImages=refImages;_this.setState({sourcingData:sourcingData});},_this.updateMeetingNotes=function(meetingNote){var sourcingData=Object.assign({},_this.state.sourcingData);sourcingData.MNID=meetingNote._id;_this.setState({meetingNoteId:meetingNote.MNId,sourcingData:sourcingData});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DevelopmentSourcing,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;this.getMagnumStyleNo("");var action=this.props.location.state.action;var _id=this.props.location.state._id;if(action==="view"){this.setState({disabled:true});}if(_id!==""){__WEBPACK_IMPORTED_MODULE_1__services__["e" /* DevelopmentServices */].getSpecificSource(_id).then(function(response){if(response.status===200){var _sourcingData=response.text.data;var meetingNoteId=_sourcingData.MNID.MNId;_sourcingData.MNID=_sourcingData.MNID._d;_sourcingData.requestGeneratedBy=_sourcingData.requestGeneratedBy.firstName+" "+_sourcingData.requestGeneratedBy.lastName;_sourcingData.date=new Date(_sourcingData.date);_sourcingData.dateRequiredAtMagnum=new Date(_sourcingData.dateRequiredAtMagnum);_sourcingData.dateReceivedAtMagnum=new Date(_sourcingData.dateReceivedAtMagnum);var styleNo={label:_sourcingData.magnumStyleId.styleNumber,value:_sourcingData.magnumStyleId._id};_sourcingData.magnumStyleId=_sourcingData.magnumStyleId._id;_this2.setState({sourcingData:_sourcingData,meetingNoteId:meetingNoteId,styleNo:styleNo});}response.status===401&&_this2.props.unauthorisedFunc();}).catch(function(error){_this2.props.getalertMessage('error',error.toString());});}this.setState({action:action,_id:_id});var sourcingData=Object.assign({},this.state.sourcingData);sourcingData.requestGeneratedBy=this.props.userData.userName;this.setState({sourcingData:sourcingData});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){}//jayaprakash
},{key:"render",value:function render(){var _this3=this;var _state=this.state,sourcingData=_state.sourcingData,meetingNoteId=_state.meetingNoteId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"Sourcing"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"sourcing",className:"sourceTableWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"responsive-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.sourcingData.sourcingNumber!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Sourcing Req No.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",value:sourcingData.sourcingNumber,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Date")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:sourcingData.date,inputName:"date",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Magnum Style No.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"form-field-name",value:this.state.styleNo,onInputChange:function onInputChange(e){return _this3.getMagnumStyleNo(e);},onChange:this.changeStyleNo,placeholder:"Find Style",options:this.state.styleNoInfo,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Meeting Notes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"",name:"",value:meetingNoteId,disabled:this.state.disabled})),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"popup-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",style:{borderRadius:0},"data-toggle":"modal","data-target":"#myModal"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Request generated by")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",placeholder:"userName",name:"requestGeneratedBy",value:sourcingData.requestGeneratedBy,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Sourcing For")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"sourcingFor",placeholder:"MATLAN-GIRLSWEAR",value:sourcingData.sourcingFor,onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Origination Of Request")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"originationOfRequest",options:[{label:"Meeting Notes",value:"Meeting Notes"}],value:sourcingData.originationOfRequest,onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Season")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"season",placeholder:"AW18",value:sourcingData.season,onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Category")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"category",options:[{label:"Fabric",value:"Fabric"},{label:"Trim",value:"Trim"}],value:sourcingData.category,onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Requirement")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"requirement",placeholder:"PATCHWORK",value:sourcingData.requirement,onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Color Stds")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"color",placeholder:"AW 18 COL PALETTE",value:sourcingData.color,onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Quantity")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"quantity",placeholder:"20 SWATCHES",value:sourcingData.quantity,onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Composition")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"composition",placeholder:"POLYESTER",value:sourcingData.composition,onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Measurement")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"measurement",placeholder:"",value:sourcingData.measurement,onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Date Reqd At Magnum")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:sourcingData.dateRequiredAtMagnum,inputName:"dateRequiredAtMagnum",onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Date Received At Magnum")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:sourcingData.dateReceivedAtMagnum,inputName:"dateReceivedAtMagnum",onChange:this.updateValue,disabled:this.state.disabled})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"additionalInfo",value:sourcingData.additionalInfo,label:"Additional Info",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",getRefImages:this.getSourcingImages,disabled:this.state.disabled,uploadedDocs:this.state.action==="view"||this.state.action==="edit"?sourcingData.refImages:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonName:"save",buttonType:"save",onClick:this.createSourcing}),this.state.sourcingData.sourcingNumber!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(e){return _this3.completeSource(e);},name:"button"},"Complete"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonName:"cancel",buttonType:"cancel",history:this.props.history})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"myModal","class":"modal fade",role:"dialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-dialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"modal-body no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-8 product-form no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone"},"Search Style"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"BY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"form-control",name:"",onChange:function onChange(e){return _this3.setState({searchMeetingNotesBy:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"style"},"Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MNId"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"customerName"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"customerDepartment"},"Departement Name")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"FOR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"meetingNoteValue",value:this.state.meetingNoteValue,onChange:function onChange(e){return _this3.setState({meetingNoteValue:e.target.value});}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-4 product-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 mm-btns",style:{marginTop:"32%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",name:"button",onClick:function onClick(e){return _this3.searchMeetingNote(e);}},"Search")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"num"},"Meeting Notes No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"name"},"Customer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"name"},"Deptartment Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"act"},"Action"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"select"},"Select"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.meetingNotes!==undefined&&Array.isArray(this.state.meetingNotes)&&this.state.meetingNotes.length>0&&this.state.meetingNotes.map(function(meetingNote,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,meetingNote.MNId!==null&&meetingNote.MNId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,meetingNote.customerName!==null&&meetingNote.customerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,meetingNote.customerDepartmentName!==null&&meetingNote.customerDepartmentName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"","class":"view",title:"View",onClick:function onClick(){return _this3.props.history.push("/viewMeeting?"+meetingNote._id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"visibility"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",name:"gender","class":"sourcingOption","data-dismiss":"modal",onClick:function onClick(){return _this3.updateMeetingNotes(meetingNote);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this3.setState({openModal:false});},s:true,center:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.imageForModal!==""&&window.URL.createObjectURL(this.state.imageForModal),style:{width:"100%"}})));}}]);return DevelopmentSourcing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// export default DevelopmentSourcing;
var mapStateToProps=function mapStateToProps(state){return{userData:state.main};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,null)(DevelopmentSourcing));

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle_switch__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FileUpload_FileUpload__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var DevelopmentProduct=function(_Component){_inherits(DevelopmentProduct,_Component);function DevelopmentProduct(props){_classCallCheck(this,DevelopmentProduct);var _this=_possibleConstructorReturn(this,(DevelopmentProduct.__proto__||Object.getPrototypeOf(DevelopmentProduct)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};_this.changeStyleNo=function(styleNo){_this.setState({styleNo:styleNo});};_this.changePatternMaster=function(patternMaster){_this.setState({patternMaster:patternMaster});};_this.getProductImages=function(refImages){_this.setState({images:refImages});};_this.updateDate=function(name,value){_this.setState(_defineProperty({},name,value));};_this.imageUploadForSample=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].imageUpload(e.target.files).then(function(response){if(response.status===200){_this.setState({awaitingDevSheet:response.text.data[0]});}}).catch(function(error){});};_this.updateFabric=function(name,value,index){var fabricCount=[].concat(_toConsumableArray(_this.state.fabricCount));fabricCount[index][name]=value;_this.setState({fabricCount:fabricCount});};_this.updateTrim=function(name,value,index){var trimCount=[].concat(_toConsumableArray(_this.state.trimCount));trimCount[index][name]=value;_this.setState({trimCount:trimCount});};_this.state={pdRefNo:"",fabricCount:[{original:false,fabricId:null,fabricPosition:null,devRefNumber:'',status:null,ETA:null}],trailRequired:false,blockRequired:false,trimCount:[{trimType:null,trimId:null,devRefNumber:'',status:null,ETA:null,comments:''}],cuttingCount:[1],sewingCount:[1],manualQty:[1],dispatchCount:[1],garmentTypeForms:[1],meetingNoteValue:"",images:[],imageEdit:false,imageInfo:'',uploadNewImage:'',imageForModal:'',openModal:false,sampleQty:[1],dispatchQty:[1],embroideryArray2:[],designSheet:false,awaitingDevSample:false,markerRequired:false,smvAmmendment:false,mock:false,gramentTechTrail:false,date:null,dateReceivedAtMagnum:null,dateRequiredAtMagnum:null,sampleDate:null,awaitingDevSheet:'',fabricId:{},//options
patternMasterOptions:[]};return _this;}_createClass(DevelopmentProduct,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getPrefillInfo().then(function(response){if(response.message==="Operation Successful"){_this2.setState({styleInfo:response.data.Style,fabricInfo:response.data.Fabric,trimInfo:response.data.Trims},function(){});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this2.msg);});this.getMagnumStyleNo('');this.getFabricNumber('');this.getTrimNumber('');}},{key:'searchMeetingNote',value:function searchMeetingNote(e){var _this3=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_4__services__["g" /* MeetingNotesServices */].searchMeetingNotesBy(this.state.searchMeetingNotesBy,this.state.meetingNoteValue).then(function(response){if(response.status===200){_this3.setState({meetingNotes:response.text.data.MN});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this3.msg);});}},{key:'getMagnumStyleNo',value:function getMagnumStyleNo(value){var _this4=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getMagnumStyleNo(value).then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this4.setState({styleNoInfo:jsonData});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this4.msg);});}},{key:'getFabricNumber',value:function getFabricNumber(value){var _this5=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.message==="List Displayed"){_this5.setState({fabricNumberInfo:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this5.msg);});}},{key:'getTrimNumber',value:function getTrimNumber(value){var _this6=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getTrimNumber(value).then(function(response){if(response.message==="List Displayed"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.trimNumber;objData.value=info._id;jsonData.push(objData);});_this6.setState({trimNumberInfo:jsonData});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this6.msg);});}},{key:'addEmbellishment',value:function addEmbellishment(e){e.preventDefault();var manualQty=this.state.manualQty;manualQty.push(manualQty.length+1);this.setState({manualQty:manualQty});}},{key:'removeEmbellishment',value:function removeEmbellishment(e,index){var manualQty=this.state.manualQty;manualQty.splice(index,1);this.setState({manualQty:manualQty});}},{key:'createEmbellishment',value:function createEmbellishment(e){var _this7=this;var aariData={};aariData.chappa=this.state.chappa;aariData.reCutGuideStitch=this.state.reCut;var runningTime={};runningTime.hh=this.state.hh;runningTime.mm=this.state.mm;aariData["runningTime"]=runningTime;var manualData={};var time={};time.hh=this.state.timehh;time.mm=this.state.timemm;manualData["time"]=time;manualData.numberOfBeads=this.state.numberOfBeads;var tasselData={};var trimObj={};var trimData=[];tasselData.beading=this.state.beading;tasselData.numberOfTassel=this.state.numberOfTassel;tasselData.method=this.state.method;this.state.manualQty.map(function(manual,index){trimObj["trimId"]=_this7.state['manualTrim'+index].value;trimObj["quantity"]=parseInt(_this7.state['manualQtyValue'+index]);trimData.push(trimObj);trimObj={};});manualData["trimData"]=trimData;var allInfo={};allInfo["aariData"]=aariData;allInfo["tasselData"]=tasselData;allInfo["manualData"]=manualData;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createEmbelishment(allInfo,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this7.msg);_this7.setState({embellishmentId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this7.msg);});}},{key:'getPatternMaster',value:function getPatternMaster(value,name){var _this8=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getEmployeId(value,name).then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.userId;objData.value=info._id;jsonData.push(objData);});_this8.setState({patternMasterInfo:jsonData});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this8.msg);});}},{key:'imageUpload',value:function imageUpload(e){this.setState({images:this.state.images.concat(e.target.files[0])},function(){var a=[];this.state.images.map(function(image,index){var b={};b=image;b.imageName='Sketch'+ ++index;b.imageDescription='';a.push(b);});this.setState({images:a});});}},{key:'imageInfo',value:function imageInfo(image,index){this.setState({imageInfo:image,imageIndex:index});}},{key:'uploadNewImage',value:function uploadNewImage(e){var b={};b=e.target.files[0];b.imageName=this.state.imageInfo.imageName;b.imageDescription=this.state.imageInfo.imageDescription;this.setState({uploadNewImage:b});}},{key:'updateImage',value:function updateImage(){var _this9=this;this.state.images.map(function(image,index){if(index===_this9.state.imageIndex){_this9.state.images[index]=_this9.state.uploadNewImage!==""?_this9.state.uploadNewImage:_this9.state.imageInfo;}});}},{key:'changeImageName',value:function changeImageName(value){var a=this.state.imageInfo;a.imageName=value;this.setState({imageInfo:a});}},{key:'changeImageDescription',value:function changeImageDescription(value){var a=this.state.imageInfo;a.imageDescription=value;this.setState({imageInfo:a});}},{key:'removeImage',value:function removeImage(image,indexVal){var a=this.state.images;a.splice(indexVal,1);this.setState({images:a});}},{key:'changeFabricNumber',value:function changeFabricNumber(e,index){var fabricCount=[].concat(_toConsumableArray(this.state.fabricCount));fabricCount[index].fabricId=e.value;this.setState(_defineProperty({fabricCount:fabricCount},"fabricId"+index,e));}},{key:'changeTrimNumber',value:function changeTrimNumber(e,index){var _setState2;var trimCount=[].concat(_toConsumableArray(this.state.trimCount));trimCount.trimId=e.value;this.setState((_setState2={},_defineProperty(_setState2,'trim'+index,e),_defineProperty(_setState2,'trimCount',trimCount),_setState2));}},{key:'changeManualTrimNumber',value:function changeManualTrimNumber(e,index){this.setState(_defineProperty({},'manualTrim'+index,e));}},{key:'changePatternMasterDynamic',value:function changePatternMasterDynamic(e,index){this.setState(_defineProperty({},'patternMaster'+index,e));}},{key:'changeCuttingMasterDynamic',value:function changeCuttingMasterDynamic(e,index){this.setState(_defineProperty({},'cuttingMaster'+index,e));}},{key:'createProduct',value:function createProduct(e){var _this10=this;e.preventDefault();var data={};data.embroideryTab=this.state.embroideryActive;data.MNId=this.state.meetingNoteId;data.magnumStyleId=this.state.styleNo.value;data.refImages=this.state.images;var form=document.forms['createProduct'];for(var i=0;i<form.elements.length;i++){data[form.elements[i].name]=form.elements[i].value;}data.date=this.state.date;data.dateReceivedAtMagnum=this.state.dateReceivedAtMagnum;data.dateRequiredAtMagnum=this.state.dateRequiredAtMagnum;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createProduct(data).then(function(response){if(response.message==="Successfully Updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this10.msg);_this10.setState({productId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this10.msg);});}},{key:'completeProduct',value:function completeProduct(e){var _this11=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeProduct(this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this11.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this11.msg);});}},{key:'createFabric',value:function createFabric(e){var _this12=this;e.preventDefault();var data={};var info=[].concat(_toConsumableArray(this.state.fabricCount));// let form = document.forms['fabricForm'];
// for (var i = 0; i < form.elements.length; i++) {
//     data[i].ETA = this.state['ETA'+i]
//     data[i].original = this.state['original'+i]
//     data[form.elements[i].name] = form.elements[i].value
//     if (Object.keys(data).length == 6) {
//         data.original = this.state[`original${info.length}`] === true ? true : false
//         data[i].ETA = this.state['ETA'+i]
//         data[i].original = this.state['original'+i]
//         info.push(data);
//         data = {};
//     }
// }
__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createFabricForProduct(info,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this12.msg);_this12.setState({FabricId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this12.msg);});}},{key:'completeFabric',value:function completeFabric(e){var _this13=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeFabric(this.state.FabricId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this13.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this13.msg);});}},{key:'createTrim',value:function createTrim(e){var _this14=this;e.preventDefault();var data={};var info=[].concat(_toConsumableArray(this.state.trimCount));// let form = document.forms['trimForm'];
// for (var i = 0; i < form.elements.length; i++) {
//     data[form.elements[i].name] = form.elements[i].value
//     if (Object.keys(data).length == 7) {
//         
//         data.trimId = this.state[`trim${info.length}`].value
//         data.ETA = this.state[`ETA${info.length}`]
//         info.push(data);
//         data = {};
//     }
// }
__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createTrimForProductDev(info,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this14.msg);_this14.setState({trimId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this14.msg);});}},{key:'completeTrim',value:function completeTrim(e){var _this15=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeTrim(this.state.trimId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this15.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this15.msg);});}},{key:'addCategoryCount',value:function addCategoryCount(e,name){if(name==="fabricCount"){var fabricCount=[].concat(_toConsumableArray(this.state.fabricCount));fabricCount.push({original:false,fabricId:null,fabricPosition:null,devRefNumber:'',status:null,ETA:null});this.setState({fabricCount:fabricCount});}else if(name='trimCount'){var trimCount=[].concat(_toConsumableArray(this.state.trimCount));trimCount.push({trimType:null,trimId:null,devRefNumber:'',status:null,ETA:null,comments:''});this.setState({trimCount:trimCount});}else{var data=this.state[''+name];var length=this.state[''+name].length;data.push(length);this.setState(_defineProperty({},''+name,data));}}},{key:'removeCategoryCount',value:function removeCategoryCount(index,name){var data=this.state[''+name];data.splice(index,1);this.setState(_defineProperty({},''+name,data));}},{key:'addSize',value:function addSize(e){var sampleQty=this.state.sampleQty;sampleQty.push(this.state.sampleQty.length+1);this.setState({sampleQty:sampleQty});}},{key:'removeSize',value:function removeSize(e,index){alert(index);var sampleQty=this.state.sampleQty;sampleQty.splice(index,1);this.setState({sampleQty:sampleQty},function(){});}},{key:'addSizeForDispatch',value:function addSizeForDispatch(e){var dispatchQty=this.state.dispatchQty;dispatchQty.push(this.state.dispatchQty.length+1);this.setState({dispatchQty:dispatchQty});}},{key:'removeSizeForDispatch',value:function removeSizeForDispatch(e,index){var dispatchQty=this.state.dispatchQty;dispatchQty.splice(index,1);this.setState({dispatchQty:dispatchQty},function(){});}},{key:'createSample',value:function createSample(e,index){var _this16=this;var info={};var data=[];var countData={};info._id=this.state.productId;info.awaitingDevSample=this.state.awaitingDevSample;info.designSheet=this.state.designSheet;info.awaitingDevSheet=this.state.awaitingDevSheet;var form=document.forms["sampleForm"];for(var i=0;i<form.elements.length;i++){info[form.elements[i].name]=form.elements[i].value;if(form.elements[i].name==="size"||form.elements[i].name==="quantity"){countData[form.elements[i].name]=parseInt(form.elements[i].value);if(Object.keys(countData).length==2){data.push(countData);countData={};}}}info.date=this.state.sampleDate;info["data"]=data;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createSample(info).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this16.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this16.msg);});}},{key:'createPattern',value:function createPattern(e){var _this17=this;e.preventDefault();var info={};info._id=this.state.productId;info.patternMaster=this.state.patternMaster.value;info.blockRequired=this.state.blockRequired;info.trailRequired=this.state.trailRequired;var form=document.forms["patternForm"];for(var i=0;i<form.elements.length;i++){info[form.elements[i].name]=form.elements[i].value;}info.date=this.state.patternDate;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createPattern(info).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this17.msg);_this17.setState({patternId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this17.msg);});}},{key:'completePattern',value:function completePattern(e){var _this18=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completePattern(this.state.patternId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this18.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this18.msg);});}},{key:'createGarment',value:function createGarment(e){var _this19=this;e.preventDefault();var info={};var countData={};var data=[];info._id=this.state.productId;info.markerRequirements=this.state.markerRequired;info.smvAmmendment=this.state.smvAmmendment;info.trailRequired=this.state.gramentTechTrail;info.mock=this.state.mock;var form=document.forms["garmentForm"];for(var i=0;i<form.elements.length;i++){info[form.elements[i].name]=form.elements[i].value;if(form.elements[i].name==="fitComments"||form.elements[i].name==="fab"||form.elements[i].name==="trims"||form.elements[i].name==="workManShip"||form.elements[i].name==="buyerChanges"||form.elements[i].name==="pat"||form.elements[i].name==="remarks"){countData[form.elements[i].name]=form.elements[i].value==="true"?true:form.elements[i].value==="false"?false:form.elements[i].value===""?false:form.elements[i].value;if(Object.keys(countData).length==7){data.push(countData);countData={};}}}info["sampleForm"]=data;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createGarment(info).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this19.msg);_this19.setState({garmentId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this19.msg);});}},{key:'addGarment',value:function addGarment(e){var garmentTypeForms=this.state.garmentTypeForms;garmentTypeForms.push(garmentTypeForms.length+1);this.setState({garmentTypeForms:garmentTypeForms});}},{key:'removeGarment',value:function removeGarment(e,index){var garmentTypeForms=this.state.garmentTypeForms;garmentTypeForms.splice(index,1);this.setState({garmentTypeForms:garmentTypeForms});}},{key:'checkboxChange',value:function checkboxChange(e){this.setState(_defineProperty({},e.target.id,e.target.checked));}},{key:'completeGarment',value:function completeGarment(e){var _this20=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeGarment(this.state.garmentId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this20.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this20.msg);});}},{key:'createCutting',value:function createCutting(e){var _this21=this;var data={};var info=[];var form=document.forms["cuttingForm"];for(var i=0;i<form.elements.length;i++){data[form.elements[i].name]=form.elements[i].value;if(Object.keys(data).length===4){data.fabricIssues=this.state['fabricIssue'+info.length]===true?true:false;info.push(data);data={};}}__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createCutting(info,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this21.msg);_this21.setState({cuttingId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this21.msg);});}},{key:'completeCutting',value:function completeCutting(e){var _this22=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeCutting(this.state.cuttingId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this22.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this22.msg);});}},{key:'createSignOff',value:function createSignOff(e){var _this23=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createSignOff(this.state.signOffDate,this.state.patternMaster,this.state.productId).then(function(response){if(response.message==="Successfully Stored"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this23.msg);_this23.setState({signOffId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this23.msg);});}},{key:'completeSignOff',value:function completeSignOff(e){var _this24=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeSignOff(this.state.signOffId).then(function(response){if(response.message==="Sign Off Completed"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this24.msg);_this24.setState({signOffId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this24.msg);});}},{key:'createSewing',value:function createSewing(e){var _this25=this;e.preventDefault();var data={};var form=document.forms["sewingForm"];var info=[];for(var i=0;i<form.elements.length;i++){data[form.elements[i].name]=form.elements[i].value;if(Object.keys(data).length===6){info.push(data);data={};}}__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createSewing(info,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this25.msg);_this25.setState({sewingId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this25.msg);});}},{key:'completeSewing',value:function completeSewing(e){var _this26=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeSewing(this.state.sewingId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this26.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this26.msg);});}},{key:'createDispatch',value:function createDispatch(e){var _this27=this;e.preventDefault();var allSizes={};var data=[];var objData={};var form=document.forms["dispatchForm"];var info=[];for(var i=0;i<form.elements.length;i++){if(form.elements[i].name==="size"||form.elements[i].name==="quantity"){allSizes[form.elements[i].name]=form.elements[i].value;if(Object.keys(allSizes).length===2){data.push(allSizes);allSizes={};}}else{objData[form.elements[i].name]=form.elements[i].value;if(info[info.length-1]!==undefined&&info[info.length-1].data!==undefined&&info[info.length-1].data!==[]){data=[];}if(Object.keys(objData).length===6){objData["data"]=data;info.push(objData);info[info.length-1].magnum=this.state['magnum'+(info.length-1)]===true?true:false;objData={};}}}__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createDispatch(info,this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this27.msg);_this27.setState({dispatchId:response.data._id});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this27.msg);});}},{key:'completeDispatch',value:function completeDispatch(e){var _this28=this;__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].completeDispatch(this.state.dispatchId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].successMsg(_this28.msg);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__services__["m" /* UtilityService */].errorMsg(_this28.msg);});}},{key:'render',value:function render(){var _this29=this;var styleInfo=this.state.styleInfo;var fabricInfo=this.state.fabricInfo;var trimInfo=this.state.trimInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_alert___default.a,Object.assign({ref:function ref(a){return _this29.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section listFieldSetWrapper',id:'development-product'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:'Add Product'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_audit__["a" /* default */],{_id:this.state.productId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding mt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'createProduct'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter',style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'sourcingTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{'class':'responsive-table w-75 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.pdRefNo!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'PD Req No.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',placeholder:'SC-00001',readonly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:'date',value:this.state.date,inputName:'date',onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Magnum Style No.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'magnumStyleId',value:this.state.styleNo,onInputChange:function onInputChange(e){return _this29.getMagnumStyleNo(e);},onChange:this.changeStyleNo,placeholder:'Find Style',options:this.state.styleNoInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Meeting Notes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-10 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',placeholder:'',name:'',value:this.state.MNId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'popup-box',style:{position:"absolute",borderRadius:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',style:{borderRadius:0},'data-toggle':'modal','data-target':'#myModal'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Request generated by')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',placeholder:'userName',name:'requestGeneratedBy',value:localStorage.getItem("userName"),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Product Development For')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',placeholder:'MATLAN-GIRLSWEAR',name:'productDevelopmentFor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Origination Of Request')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',placeholder:'',name:'originationOfRequest'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'category'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Tassel'},'Tassel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Construction'},'Construction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Smocking'},'Smocking'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Embroidery')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:'checkboxToggle',inputName:'embroideryActive',value:this.state.embroideryActive,onChange:this.updateDate,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Date Reqd At Magnum')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:'date',value:this.state.dateRequiredAtMagnum,inputName:'dateRequiredAtMagnum',onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Date Received At Magnum')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'class':'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:'date',value:this.state.dateReceivedAtMagnum,inputName:'dateReceivedAtMagnum',onChange:this.updateDate,disabled:this.state.disabled})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group w-75 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'name','class':''},'Additional Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'additionalInfo','class':'form-control',rows:'3',cols:'80'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_FileUpload_FileUpload__["a" /* default */],{Heading:'Upload Images',getRefImages:this.getProductImages,disabled:this.state.disabled,uploadedDocs:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{margin:'5px'},'class':'primary',name:'button',onClick:function onClick(e){return _this29.createProduct(e);}},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{margin:'5px'},'class':'primary',name:'button',onClick:function onClick(e){return _this29.completeProduct(e);}},'Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{margin:'5px'},'class':'primary',name:'button'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 px-5 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'class':'nav-locator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Sample'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'sample','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Pattern'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'pattern','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Garment Tech'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'garment-tech','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Fabric'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'fabric','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Trim'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'trim','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Embellishment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'embellishment','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Cutting'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'cutting','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Sewing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'sewing','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Dispatch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'dispatch','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'sample'},'Sign Off'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'sign-off','class':'sample-opt-chckbox',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'sample',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'sampleForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sample'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding await-sec'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'awaitingDevSample',label:'Awaiting Dev Sample',value:this.state.awaitingDevSample,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'date',value:this.state.sampleDate,inputName:'sampleDate',label:'Date',onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'designSheet',label:'Awaiting / Design Sheet',value:this.state.designSheet,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'upload-box spec-box float-none mt-3',style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'file-field input-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'btn',style:{marginBottom:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontSize:"11px"}},'Upload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',multiple:true,onChange:function onChange(e){return _this29.imageUploadForSample(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'file-path-wrapper',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'file-path form-control',type:'text',style:{marginTop:"9px"}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-sample-size-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.state.sampleQty!==undefined&&Array.isArray(this.state.sampleQty)&&this.state.sampleQty.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 size-mngr size-mngr-mod px-1 pr-4 mb-4',style:{marginBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-4-shadow px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control select-box-min',name:'size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'slct'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:2},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:3},'3')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'quantity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 add-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:'block'}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green add-multiple-sample-size-btn',onClick:function onClick(e){return _this29.addSize(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:'block'}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn',onClick:function onClick(e){return _this29.removeSize(e,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'15px'},className:'multiple-sample-size-box',id:'multiple-sample-size-box'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'second-address-con',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 size-mngr',style:{marginBottom:"5px",marginLeft:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'slct'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'no.'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'no.'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'no.'},'6')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'add-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'class':'btn-floating btn-small waves-effect waves-light red sec-close-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'clear'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createSample(e);}},'Save')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'pattern',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'patternForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Pattern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Pattern Master Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'patternMaster',value:this.state.patternMaster,onInputChange:function onInputChange(e){return _this29.getPatternMaster(e,"patternMaster");},onChange:this.changePatternMaster,placeholder:'Find Style',options:this.state.patternMasterInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'date',value:this.state.patternDate,inputName:'patternDate',label:'Date',onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'trailRequired',label:'Trail Required?',value:this.state.trailRequired,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Existing Block Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'existingBlockRefNumber'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'blockRequired',label:'Have you followed the block required ?',value:this.state.blockRequired,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Block Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'blockRefNumber'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'remarks'},'Remarks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'remarks'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createPattern(e);}},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completePattern(e);}},'Complete')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter',id:'garment-tech',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'garmentForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Garment Technologist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'printer pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'fa fa-print'}),' Print')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'SAMPLE RELEASE FORM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'srf-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{'class':'striped manage_permissions garment-tech-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'comment'},'Comments recieved from buyer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'fab'},'Fab.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'trim'},'Trims'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'work'},'Workmanship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'change'},'Buyer\'s changes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'pat'},'Pat.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'remark'},'Remarks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.garmentTypeForms!==undefined&&Array.isArray(this.state.garmentTypeForms)&&this.state.garmentTypeForms.length>0&&this.state.garmentTypeForms.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{'class':'mod-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:"left"}},'Fit Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colspan:'7'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'fitComments',rows:'4',cols:'80','class':'form-control',style:{resize:"none"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:"FAB"+index,'class':'filled-in',name:'fab',value:_this29.state['FAB'+index],onChange:function onChange(e){return _this29.checkboxChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':"FAB"+index}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:"TRM"+index,name:'trims',value:_this29.state['TRM'+index],onChange:function onChange(e){return _this29.checkboxChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':"TRM"+index}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:"MAN"+index,value:_this29.state['MAN'+index],onChange:function onChange(e){return _this29.checkboxChange(e);},name:'workManShip'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':"MAN"+index}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:"CHN"+index,value:_this29.state['CHN'+index],onChange:function onChange(e){return _this29.checkboxChange(e);},name:'buyerChanges'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':"CHN"+index}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:"PAT"+index,name:'pat',value:_this29.state['PAT'+index],onChange:function onChange(e){return _this29.checkboxChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':"PAT"+index}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:"25%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'remarks',rows:'4',cols:'80','class':'form-control',style:{resize:"none"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-small waves-effect waves-light green pull-right add-a-new-tr-btn',onClick:function onClick(e){return _this29.addGarment(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},'class':'btn-small waves-effect waves-light red pull-right del-tr-btn',onClick:function onClick(e){return _this29.removeGarment(e,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'clear')))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding comments-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Garment Tech Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',rows:'6','class':'form-control',placeholder:'',name:'garmentTechComments'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-10 col-md-offset-1 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'markerRequired',label:'Marker Requirement',value:this.state.markerRequired,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'smvAmmendment',label:'SMV Ammendment',value:this.state.smvAmmendment,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'gramentTechTrail',label:'Trail Required?',value:this.state.gramentTechTrail,onChange:this.updateDate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'mock',label:'Mock',value:this.state.mock,onChange:this.updateDate,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary mr-2',onClick:function onClick(e){return _this29.createGarment(e);},name:'button'},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeGarment(e);}},'Complete')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'fabric',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'fabricForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fabric'))),this.state.fabricCount.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-11 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'original',label:'Original / Substitute',value:value.original,index:index,onChange:_this29.updateFabric,disabled:_this29.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'fab-no'},'Fabric No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'fabricId',value:_this29.state['fabricId'+index],onInputChange:function onInputChange(e){return _this29.getFabricNumber(e);},onChange:function onChange(e){return _this29.changeFabricNumber(e,index);},placeholder:'Find Fabric',options:_this29.state.fabricNumberInfo})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Fabric Position'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'fabricPosition',onChange:function onChange(e){return _this29.updateFabric(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),fabricInfo!==undefined&&fabricInfo.FABRICPOSITION!==undefined&&Array.isArray(fabricInfo.FABRICPOSITION)&&fabricInfo.FABRICPOSITION.length>0&&fabricInfo.FABRICPOSITION.map(function(fabric,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:fabric._id},fabric.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'item'},'Dev Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'',name:'devRefNumber',onChange:function onChange(e){return _this29.updateFabric(e.target.name,e.target.value,index);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'status',onChange:function onChange(e){return _this29.updateFabric(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),fabricInfo!==undefined&&fabricInfo.STATUS!==undefined&&Array.isArray(fabricInfo.STATUS)&&fabricInfo.STATUS.length>0&&fabricInfo.STATUS.map(function(fabric,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:fabric._id},fabric.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'date',value:value.ETA,inputName:'ETA',label:'ETA',index:index,onChange:_this29.updateFabric,disabled:_this29.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green pull-right mt-3',name:'fabricCount',onClick:function onClick(e){return _this29.addCategoryCount(e,"fabricCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3',id:'del-sample-size-btn',onClick:function onClick(e){return _this29.removeCategoryCount(index,"fabricCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createFabric(e);}},'SAVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeFabric(e);}},'Complete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'trim',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'trimForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title pl-3',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'trim'))),this.state.trimCount!==undefined&&Array.isArray(this.state.trimCount)&&this.state.trimCount.length>0&&this.state.trimCount.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-11 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'type'},'Trim Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'trimType',onChange:function onChange(e){return _this29.updateTrim(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'type'},'Select'),trimInfo!==undefined&&trimInfo.TRIMTYPE!==undefined&&Array.isArray(trimInfo.TRIMTYPE)&&trimInfo.TRIMTYPE.length>0&&trimInfo.TRIMTYPE.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:trim._id},trim.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'item'},'Trim Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'trimId',value:_this29.state['trim'+index],onInputChange:function onInputChange(e){return _this29.getTrimNumber(e);},onChange:function onChange(e){return _this29.changeTrimNumber(e,index);},placeholder:'Find Trim',options:_this29.state.trimNumberInfo})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'item'},'Dev Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'',name:'devRefNumber',onChange:function onChange(e){return _this29.updateTrim(e.target.name,e.target.value,index);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'type'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'status',onChange:function onChange(e){return _this29.updateTrim(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'type'},'Select'),trimInfo!==undefined&&trimInfo.TRIMSTATUS!==undefined&&Array.isArray(trimInfo.TRIMSTATUS)&&trimInfo.TRIMSTATUS.length>0&&trimInfo.TRIMSTATUS.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:trim._id},trim.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'date',value:value.ETA,inputName:'ETA',label:'ETA',index:index,onChange:_this29.updateTrim,disabled:_this29.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'type'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'comments','class':'form-control',rows:'4',onChange:function onChange(e){return _this29.updateTrim(e.target.name,e.target.value,index);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green pull-right mt-4',onClick:function onClick(e){return _this29.addCategoryCount(e,"trimCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-4',id:'del-sample-size-btn',onClick:function onClick(e){return _this29.removeCategoryCount(index,"trimCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createTrim(e);}},'Save'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeTrim(e);}},'Complete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'embellishment',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Embellishment Process ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'process-title sub_title'},'Embellishment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 embroid-mul mt-0 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one text-left pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'manage_permissions emb-chck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:'filled-in-box6',value:this.state.aari,onChange:function onChange(e){return _this29.setState({aari:!_this29.state.aari});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'filled-in-box6'},'Aari'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one text-left pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'manage_permissions emb-chck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:'filled-in-box7',value:this.state.manual,onChange:function onChange(e){return _this29.setState({manual:!_this29.state.manual});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'filled-in-box7'},'Manual'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one text-left pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'manage_permissions emb-chck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox','class':'filled-in',id:'filled-in-box8',value:this.state.tassle,onChange:function onChange(e){return _this29.setState({tassle:!_this29.state.tassle});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'filled-in-box8'},'Tassle'))))),this.state.aari&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'process-title sub_title pl-0 mt-0'},'Aari'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'aariForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 embroid-mul mt-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Running Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6',style:{paddingLeft:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'hh',name:'hh',value:this.state.hh,onChange:function onChange(e){return _this29.setState({hh:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6',style:{paddingLeft:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'mm',name:'mm',value:this.state.mm,onChange:function onChange(e){return _this29.setState({mm:e.target.value});}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'phone'},'Chappa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'No',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'sample-opt-chckbox',type:'checkbox',value:this.state.chappa,onChange:function onChange(e){return _this29.setState({chappa:!_this29.state.chappa});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}),'yes')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'phone'},'Re-Cut Guide Stitch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'No',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'sample-opt-chckbox',type:'checkbox',value:this.state.reCut,onChange:function onChange(e){return _this29.setState({reCut:!_this29.state.reCut});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}),'yes'))))))),this.state.manual&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'manualForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'process-title sub_title pl-0 mt-0'},'Manual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 embroid-mul mt-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6',style:{paddingLeft:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'hh',value:this.state.timehh,onChange:function onChange(e){return _this29.setState({timehh:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6',style:{paddingLeft:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',placeholder:'mm',value:this.state.timemm,onChange:function onChange(e){return _this29.setState({timemm:e.target.value});}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'no. Of beads / Sequins'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'',onChange:function onChange(e){return _this29.setState({numberOfBeads:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10-15'},'10 - 15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15-20'},'15 - 20')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 hand-req-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-embellishment-trim-box',id:'main-embellishment-trim-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.state.manualQty!==undefined&&Array.isArray(this.state.manualQty)&&this.state.manualQty.length>0&&this.state.manualQty.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 size-mngr size-mngr-mod px-1 pr-4 mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-4-shadow px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Trim No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'trimId',value:_this29.state['manualTrim'+index],onInputChange:function onInputChange(e){return _this29.getTrimNumber(e);},onChange:function onChange(e){return _this29.changeManualTrimNumber(e,index);},placeholder:'Find Trim',options:_this29.state.trimNumberInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'quantity',value:_this29.state['manualQtyValue'+index],onChange:function onChange(e){return _this29.setState(_defineProperty({},'manualQtyValue'+index,e.target.value));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 add-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green add-multiple-embellishment-trim-btn',onClick:function onClick(e){return _this29.addEmbellishment(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-embellishment-trim-btn',onClick:function onClick(e){return _this29.removeEmbellishment(e,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'15px'},className:'multiple-embellishment-trim-box',id:'multiple-embellishment-trim-box'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'second-address-con',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 size-mngr size-mngr-mod',style:{marginBottom:"5px",marginLeft:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Trim No'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'quantity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'add-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'class':'btn-floating btn-small waves-effect waves-light red sec-close-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'clear')))))))))),this.state.tassle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'tassleForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'process-title sub_title pl-0 mt-0'},'Tassle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 embroid-mul mt-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'No. Of tassle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'numberOfTassel',onChange:function onChange(e){return _this29.setState({numberOfTassel:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'method',onChange:function onChange(e){return _this29.setState({method:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),styleInfo!==undefined&&styleInfo.LOCATION!==undefined&&Array.isArray(styleInfo.LOCATION)&&styleInfo.LOCATION.length>0&&styleInfo.LOCATION.map(function(style,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:style._id},style.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'phone'},'Beading'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'No',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'sample-opt-chckbox',type:'checkbox',value:this.state.beading,onChange:function onChange(e){return _this29.setState({beading:!_this29.state.beading});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}),'yes'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createEmbellishment(e);}},'Save'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'cutting',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'cuttingForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title pl-3',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CUTTing'))),this.state.cuttingCount!==undefined&&Array.isArray(this.state.cuttingCount)&&this.state.cuttingCount.length>0&&this.state.cuttingCount.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green pull-right mt-3',onClick:function onClick(e){return _this29.addCategoryCount(e,"cuttingCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3',id:'del-sample-size-btn',onClick:function onClick(e){return _this29.removeCategoryCount(index,"cuttingCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Cutting Master Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'cuttingMaster',value:_this29.state['cuttingMaster'+index],onInputChange:function onInputChange(e){return _this29.getPatternMaster(e,"cuttingMaster");},onChange:function onChange(e){return _this29.changeCuttingMasterDynamic(e,index);},placeholder:'Find Style',options:_this29.state.patternMasterInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date','class':'form-control',name:'date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Any Pattern Issues?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'patternIssues'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Any Fabric Issues?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'sample-opt-chckbox',type:'checkbox',id:"fabricIssue"+index,value:_this29.state['fabricIssue'+index],onChange:function onChange(e){return _this29.checkboxChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}))))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createCutting(e);}},'Save'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeCutting(e);}},'Complete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'sewing',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'sewingForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title pl-3',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sewing'))),this.state.sewingCount!==undefined&&Array.isArray(this.state.sewingCount)&&this.state.sewingCount.length>0&&this.state.sewingCount.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-11 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},' Tailor Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'tailerId',value:_this29.state['patternMaster'+index],onInputChange:function onInputChange(e){return _this29.getPatternMaster(e,"patternMaster");},onChange:function onChange(e){return _this29.changePatternMasterDynamic(e,index);},placeholder:'Find Style',options:_this29.state.patternMasterInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'size'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'quantity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'pending'},'Pending'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'completed'},'Completed')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date','class':'form-control',name:'date'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green pull-right mt-3',onClick:function onClick(e){return _this29.addCategoryCount(e,"sewingCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3',id:'del-sample-size-btn',onClick:function onClick(e){return _this29.removeCategoryCount(index,"sewingCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createSewing(e);}},'save'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeSewing();}},'Complete')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'dispatch',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'dispatchForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Dispatch'))),this.state.dispatchCount!==undefined&&Array.isArray(this.state.dispatchCount)&&this.state.dispatchCount.length>0&&this.state.dispatchCount.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-11 no-padding',style:{marginBottom:" 15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'location'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'cust'},'Select'),styleInfo!==undefined&&styleInfo.LOCATION!==undefined&&Array.isArray(styleInfo.LOCATION)&&styleInfo.LOCATION.length>0&&styleInfo.LOCATION.map(function(style,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:style._id},style.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Courier'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'courier'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'cust'},'Select'),styleInfo!==undefined&&styleInfo.COURIER!==undefined&&Array.isArray(styleInfo.COURIER)&&styleInfo.COURIER.length>0&&styleInfo.COURIER.map(function(style,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:style._id},style.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'AWB No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'awbNumber'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date','class':'form-control',name:'date'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Attention'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'attention'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),styleInfo!==undefined&&styleInfo.ATTENTION!==undefined&&Array.isArray(styleInfo.ATTENTION)&&styleInfo.ATTENTION.length>0&&styleInfo.ATTENTION.map(function(style,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:style._id},style.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'phone'},'Magnum'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'switch switch-mod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'class':'sample-opt-chckbox',type:'checkbox',id:"magnum"+index,value:_this29.state['magnum'+index],onChange:function onChange(e){return _this29.checkboxChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'lever'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'ETA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date','class':'form-control',name:'date'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:"block"}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green pull-right mt-3',onClick:function onClick(e){return _this29.addCategoryCount(e,"dispatchCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:"block"}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3',id:'del-sample-size-btn',onClick:function onClick(e){return _this29.removeCategoryCount(index,"dispatchCount");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'samp-req-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-dispatch-size-box mb-3',id:'main-dispatch-size-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},_this29.state.dispatchQty!==undefined&&Array.isArray(_this29.state.dispatchQty)&&_this29.state.dispatchQty.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 size-mngr size-mngr-mod px-1',style:{marginBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-4-shadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control select-box-min',name:'size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'slct'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:2},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:3},'3')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 step-one mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'address'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'quantity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 add-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index===0?{display:'block'}:{display:"none"},'class':'btn-floating btn-small waves-effect waves-light green add-multiple-sample-size-btn',onClick:function onClick(e){return _this29.addSizeForDispatch(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:index!==0?{display:'block'}:{display:"none"},className:'btn-floating btn-small waves-effect waves-light red del-sample-size-btn',onClick:function onClick(e){return _this29.removeSizeForDispatch(e,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multiple-dispatch-size-box',id:'multiple-dispatch-size-box'}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.createDispatch(e);}},'Save'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeDispatch(e);}},'Complete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-filter meeting-min-con',id:'sign-off',style:{marginBottom:".5%",display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form',style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'wash-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title pl-3',style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sign Off'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Merchandiser Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:'patternMaster',value:this.state.patternMaster,onInputChange:function onInputChange(e){return _this29.getPatternMaster(e,"merchandiser");},onChange:this.changePatternMaster,placeholder:'Find Style',options:this.state.patternMasterInfo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-3 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'date',value:this.state.signOffDate,inputName:'signOffDate',label:'Date',onChange:this.updateDate,disabled:this.state.disabled}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',onClick:function onClick(e){return _this29.createSignOff(e);},name:'button'},'save'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.completeSignOff(e);}},'Complete'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this29.setState({openModal:false});},s:true,center:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.imageForModal!==""&&window.URL.createObjectURL(this.state.imageForModal),style:{width:'100%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'myModal','class':'modal fade',role:'dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'modal-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'modal-body no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'meeting-min-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-8 product-form no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'phone'},'Search Style'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'BY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:'',onChange:function onChange(e){return _this29.setState({searchMeetingNotesBy:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'MNId'},'Meeting Notes No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'customerName'},'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'customerDepartment'},'Departement Name'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-6 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 step-one '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'FOR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'meetingNoteValue',value:this.state.meetingNoteValue,onChange:function onChange(e){return _this29.setState({meetingNoteValue:e.target.value});}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 product-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 mm-btns',style:{marginTop:"20%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button',onClick:function onClick(e){return _this29.searchMeetingNote(e);}},'Search')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{'class':'striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'num'},'Meeting Notes No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'name'},'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'name'},'Deptartment Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'act'},'Action'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{'data-field':'select'},'Select'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.meetingNotes!==undefined&&Array.isArray(this.state.meetingNotes)&&this.state.meetingNotes.length>0&&this.state.meetingNotes.map(function(meetingNote,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,meetingNote.MNId!==null&&meetingNote.MNId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,meetingNote.customerName!==null&&meetingNote.customerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,meetingNote.customerDepartmentName!==null&&meetingNote.customerDepartmentName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'','class':'view',title:'View',onClick:function onClick(){return _this29.props.history.push('/viewMeeting?'+meetingNote._id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'visibility'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'gender','class':'sourcingOption','data-dismiss':'modal',onClick:function onClick(){return _this29.setState({MNId:meetingNote.MNId,meetingNoteId:meetingNote._id});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}))))))))))));}}]);return DevelopmentProduct;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DevelopmentProduct);{/* <script type="text/javascript">
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    });
  </script> */}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developmentFabric_css__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developmentFabric_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__developmentFabric_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Fabric__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SupplierSection_SupplierMain_SupplierSection__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TrimSidebar_index__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_download_png__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_download_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_download_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PrintDevelopmentFabric__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__redux_action_rights__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(16);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//Assets
//redux
var DevelopmentFabric=function(_Component){_inherits(DevelopmentFabric,_Component);function DevelopmentFabric(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DevelopmentFabric);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DevelopmentFabric.__proto__||Object.getPrototypeOf(DevelopmentFabric)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,isLoading:false,duplicate:false,disableBtn:false,isLoadingSideBar:false,//options
supplierInfo:[],bNumberInfo:[],embroideryInfo:{},fabricInfo:{ATTRIBUTE:[],PRINTBORDER:[],ORIGINATIONOFARTWORK:[],FILETRANSFER:[],PRINTDIRECTION:[],PRINTROUTE:[],PRINTINGMETHOD:[],BASICQUALITY:[],FABRICHSN:[],CLASSIFICATIONOFFABRIC:[],REQUIREMENT:[],FABRICBASE:[],COMPOSITION:[],DYESTUFF:[],WEAVE:[],FINISH:[],SHIPMENTTERM:[],SHIPMENTMODE:[],MACHINETYPE:[],EMBTECHNIQUE:[],PORTOFPICKUP:[],BUYERPRIMARYLIGHTSOURCE:[],WASH:[],NOOFCOLSONWEFT:[],DESIGNDESCRIPTION:[],NOOFCOLOURS:[],DESIGN:[],YARNDYED:{ASSIGNEDTO:[],TYPEOFLOOM:[],WEAVE:[]}},customerList:[],buyerPrimarySourceInfo:[],actionedByOption:[],//values
fabric:{HSN:null,fabricImage:"",fabricNumber:"",customer:null,qr:"",selectedType:"market",devRefNumber:"",priority:null,status:"pending",magnumETADate:null,requestDate:null,supplierETADate:null,//upload Images
refImages:[],supplierName:null,gsm:"",width:"",classificationOfFabric:null,custDefNo:"",quality:null,colorWay:"",composition:null,orginationOfArtwork:null,requirement:null,magCadRefNo:"",refFabNo:"",customerDepartmentId:null,supplierRefNo:"",magnumStyleId:null,quantityReceived:"",attribute:null,buyerPrimarySource:null,dateRequiredAtMagnum:"",bNumber:null,fileTransfer:null,linktoBno:false,specialComments:"",yarnDyed:{designRepeatSize:"",actionedBy:null,wash:null,weave:null},embroidery:{scalloping:false,targetRateIncludingFigure:"",marker:false,gradingRequired:false,backing:false,backingDetails:"",// sourcing: null,
actionedBy:null},print:{layerFile:false,artworkWithColSquare:false,fluroscentCols:false,rotaryRepeatSize:"",actionedBy:null},solidGreige:{actionedBy:null,typeOfLoom:null},supplierSection:{fullPackageData:[],jobWorkData:[]},count:{warp:"",weft:""},construction:{warp:"",weft:""}},fabricPrint:{},//development
development:null,//toggle
toggle:{yarnDyed:false,embroidery:false,print:false,solidGreige:false,supplierSection:false},scroll:true,printLoading:false,forceUpdateCall:false,fabricId:"",rights:{supplier:{},yarnDyed:{},embroidery:{},print:{},solidGreige:{}}},_this.prefillData=function(){//customer
__WEBPACK_IMPORTED_MODULE_8__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:response.text.data},function(){});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());}).finally(function(response){});__WEBPACK_IMPORTED_MODULE_8__services__["l" /* SystemServices */].listCategoryContent("CURRENCY","DELIVERYTERMS","customers").then(function(response){if(response.message==="Operation Successful"){_this.setState({currency:response.data});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});//get fabric section from system
__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].prefillFabricDetails().then(function(response){var fabric=Object.assign({},_this.state.fabric);fabric.yarnDyed.actionedBy=response.data.Fabric.YARNDYED.ASSIGNEDTO&&response.data.Fabric.YARNDYED.ASSIGNEDTO.length>0?response.data.Fabric.YARNDYED.ASSIGNEDTO[0].value:null;fabric.print.actionedBy=response.data.Fabric.PRINT.ASSIGN1EDTO&&response.data.Fabric.PRINT.ASSIGNEDTO.length>0?response.data.Fabric.PRINT.ASSIGNEDTO[0].value:null;fabric.embroidery.actionedBy=response.data.Fabric.EMBROIDERY.ASSIGNEDTO&&response.data.Fabric.EMBROIDERY.ASSIGNEDTO.length>0?response.data.Fabric.EMBROIDERY.ASSIGNEDTO[0].value:null;fabric.solidGreige.actionedBy=response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO&&response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO.length>0?response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO[0].value:null;_this.setState({fabricInfo:response.data.Fabric,embroideryInfo:response.data.Embroidery,fabric:fabric});}).catch(function(error){_this.props.getalertMessage("error",error.toString());});//listBNumber
__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].listBNumber().then(function(response){if(response.message==="List Displayed"){_this.setState({bNumberInfo:response.data},function(){});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});//buyer light primary source
__WEBPACK_IMPORTED_MODULE_8__services__["l" /* SystemServices */].listCategoryContent("PRIMARYLIGHTSOURCE","CUSTOMER","fabrics").then(function(response){if(response.message==="Operation Successful"){_this.setState({buyerPrimarySourceInfo:response.data});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});//generateQrCode
},_this.changeImg=function(e){var file=e.target.files[0];if(file.size/1024>1536){_this.props.getalertMessage("error","Image cannot be more than 1.5 mb");}else{var moduleName="fabric";_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_8__services__["f" /* FileUploadService */].uploadFileForFabric(file,moduleName).then(function(response){if(response.status===200){var fabric=Object.assign({},_this.state.fabric);fabric.fabricImage=response.text.data.url;_this.setState({fabric:fabric,isLoading:false});}else if(response.status===401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){_this.props.getalertMessage("error",error);});}},_this.createFabric=function(e){e.preventDefault();_this.setState({disableBtn:true});// data.development = { ...this.state.development }
var fabric=Object.assign({},_this.state.fabric);delete fabric.yarnDyed;delete fabric.embroidery;delete fabric.print;delete fabric.solidGreige;delete fabric.supplierSection;if(fabric.supplierName!==null&&_typeof(fabric.supplierName)==="object"){fabric.supplierName=fabric.supplierName.value;}if(fabric.magnumStyleId!==null&&_typeof(fabric.magnumStyleId)==="object"){fabric.magnumStyleId=fabric.magnumStyleId.value;}if(fabric.bNumber!==null&&_typeof(fabric.bNumber)==="object"){fabric.bNumber=fabric.bNumber.value;}if(_this.state._id){fabric._id=_this.state._id;}//delete fabric.bNumber;
fabric.toggle=Object.assign({},_this.state.toggle);if(fabric.fabricNumber==""){_this.props.getalertMessage("error"," No Fabric Number ");//  this.props.history.push('/developmentFabric',{ action : 'add', _id : "" })
setTimeout(function(){return window.location.reload(true);},1000);_this.setState({disableBtn:false});}else{__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].createFabric(fabric).then(function(response){_this.setState({disableBtn:false});if(response.status===200){if(_this.state._id){_this.props.getalertMessage("success"," Fabric Updated ");}else{_this.props.getalertMessage("success"," Fabric Created ");}_this.setState({_id:response.text.data._id,// fabric: response.text.data,
duplicate:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.setState({disableBtn:false});_this.msg.show("Try Again Later",{time:2000,type:"info"});});}},_this.getFabricData=function(name,value){var fabric=Object.assign({},_this.state.fabric);if(name=="customerDepartmentId"){_this.state.customerList.map(function(data){if(value==data.departmentId){fabric[name]=data.departmentId;fabric.customer=data._id;}});}else{fabric[name]=value;}_this.setState({fabric:fabric});},_this.getRefImages=function(refImages){var fabric=Object.assign({},_this.state.fabric);fabric.refImages=refImages;_this.setState({fabric:fabric});},_this.getSubModuleData=function(keyname,name,value){var fabric=Object.assign({},_this.state.fabric);fabric[keyname][name]=value;_this.setState({fabric:fabric});},_this.getSourcingData=function(sourcing){var fabric=Object.assign({},_this.state.fabric);fabric.embroidery.sourcing=sourcing;_this.setState({fabric:fabric});},_this.updateCountConstruction=function(e,keyname){var fabric=Object.assign({},_this.state.fabric);fabric[keyname][e.target.name]=e.target.value;_this.setState({fabric:fabric});},_this.handleFabricDataUpdate=function(updatedFabricData){//console.log("Updating fabric state:", updatedFabricData);
_this.setState(function(prevState){return{fabric:Object.assign({},prevState.fabric,updatedFabricData)};});},_this.getSelectData=function(name,value){var fabric=Object.assign({},_this.state.fabric);fabric[name]=value;_this.setState({fabric:fabric});},_this.toggleChange=function(name,value){var toggle=Object.assign({},_this.state.toggle);toggle[name]=value;_this.setState({toggle:toggle,scroll:true});},_this.getSupplier=function(data,name){var fabric=Object.assign({},_this.state.fabric);fabric.supplierSection.supplierData=name==="fullPackageData"?"fullPackage":"jobWork";fabric.supplierSection[name]=data;_this.setState({fabric:fabric});},_this.getSupplierForDefault=function(supplierSection){var fabric=Object.assign({},_this.state.fabric);fabric.supplierSection=supplierSection;_this.setState({fabric:fabric});},_this.getDevRefNo=function(){if(_this.state.fabric.devRefNumber===""){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].getDevRefNo().then(function(response){if(response.status===200){var fabric=Object.assign({},_this.state.fabric);fabric.devRefNumber=response.text.data;_this.setState({fabric:fabric});}});}},_this.removeFabricImage=function(){var fabric=Object.assign({},_this.state.fabric);fabric.fabricImage="";_this.setState({fabric:fabric});},_this.openPrint=function(val){var fabricPrint=JSON.parse(JSON.stringify(_this.state.fabric));var fabricArray=[{keyName:"REQUIREMENT",keyValue:"requirement"},{keyName:"CLASSIFICATIONOFFABRIC",keyValue:"classificationOfFabric"},{keyName:"BASICQUALITY",keyValue:"quality"},{keyName:"COMPOSITION",keyValue:"composition"},{keyName:"BUYERPRIMARYLIGHTSOURCE",keyValue:"buyerPrimarySource"},{keyName:"ORIGINATIONOFARTWORK",keyValue:"orginationOfArtwork"},{keyName:"FILETRANSFER",keyValue:"fileTransfer"},{keyName:"ATTRIBUTE",keyValue:"attribute"}];var yarnDyedArray=[{keyName:"TYPEOFLOOM",keyValue:"typeOfLoom"},{keyName:"DYESTUFF",keyValue:"dyeStuff"},{keyName:"WEAVE",keyValue:"weave"},{keyName:"FINISH",keyValue:"finish"},{keyName:"WASH",keyValue:"wash"},{keyName:"NOOFCOLSONWEFT",keyValue:"noOfColsWeft"}];var embroideryArray=[{keyName:"EMBTECHNIQUE",keyValue:"embTechinique"},{keyName:"MACHINETYPE",keyValue:"machineType"},{keyName:"THREADQUALITY",keyValue:"threadQuality"},{keyName:"BASICQUALITY",keyValue:"fabricBase"},{keyName:"DESIGNDESCRIPTION",keyValue:"designDescription"}];var printArray=[{keyName:"PRINTTYPE",keyValue:"printType"},{keyName:"PRINTDIRECTION",keyValue:"printDirection"},{keyName:"PRINTROUTE",keyValue:"printRoute"},{keyName:"NOOFCOLOURS",keyValue:"noOfColors"}];var solidGreigeArray=[{keyName:"WEAVE",keyValue:"weave"},{keyName:"TYPEOFLOOM",keyValue:"typeOfLoom"},{keyName:"DESIGN",keyValue:"designDescription"}];var fabricInfo=Object.assign({},_this.state.fabricInfo);fabricPrint.specialComments=_this.state.fabric.specialComments;fabricArray.map(function(key){fabricInfo[key.keyName].map(function(data){if(data.value==fabricPrint[key.keyValue]){fabricPrint[key.keyValue]=data.label;}});});yarnDyedArray.map(function(key){if(key.keyValue=="weave"||key.keyValue=="typeOfLoom"){fabricInfo.YARNDYED[key.keyName].map(function(data){if(data.value==fabricPrint.yarnDyed[key.keyValue]){fabricPrint.yarnDyed[key.keyValue]=data.label;}});}else{fabricInfo[key.keyName].map(function(data){if(data.value==fabricPrint.yarnDyed[key.keyValue]){fabricPrint.yarnDyed[key.keyValue]=data.label;}});}});embroideryArray.map(function(key){fabricInfo[key.keyName].map(function(data){if(data.value==fabricPrint.embroidery[key.keyValue]){fabricPrint.embroidery[key.keyValue]=data.label;}});});printArray.map(function(key){fabricInfo[key.keyName].map(function(data){if(data.value==fabricPrint.print[key.keyValue]){fabricPrint.print[key.keyValue]=data.label;}});});solidGreigeArray.map(function(key){if(key.keyValue=="designDescription"){fabricInfo[key.keyName].map(function(data){if(data.value==fabricPrint.solidGreige[key.keyValue]){fabricPrint.solidGreige[key.keyValue]=data.label;}});}else{fabricInfo["GREIGE/DENIM"][key.keyName].map(function(data){if(data.value==fabricPrint.solidGreige[key.keyValue]){fabricPrint.solidGreige[key.keyValue]=data.label;}});}});if(typeof fabricPrint.supplierName=="string"){fabricInfo.SUPPLIERNAME.map(function(data){if(data.value==fabricPrint.supplierName){fabricPrint.supplierName=data;}});}var fabricModule=[{keyName:"GREIGE/DENIM",keyValue:"solidGreige"},{keyName:"YARNDYED",keyValue:"yarnDyed"},{keyName:"EMBROIDERY",keyValue:"embroidery"},{keyName:"PRINT",keyValue:"print"}];fabricModule.map(function(modulee){fabricInfo[modulee.keyName].ASSIGNEDTO.map(function(data){if(data.value==fabricPrint[modulee.keyValue].actionedBy){fabricPrint[modulee.keyValue].actionedBy=data.label;}});});_this.state.customerList.map(function(data){if(data.departmentId==fabricPrint.customerDepartmentId){fabricPrint.customer=data.customerName+"-"+data.departmentName;}});var toggle=Object.assign({},_this.state.toggle);Object.keys(toggle).forEach(function(keyName){if(!toggle[keyName]){fabricPrint[keyName]=null;}});fabricPrint.development=false;fabricPrint.magnumETADate=_this.state.fabric.magnumETADate;fabricPrint.requestDate=_this.state.fabric.requestDate;var fabricDevRadio=document.getElementsByName("fabricDevRadio");fabricDevRadio.forEach(function(dev){if(dev.checked&&dev.value=="development"){fabricPrint.development=true;}});_this.setState({fabricPrint:fabricPrint,printLoading:true},function(){if(toggle.supplierSection){var fullPackage=void 0,jobWork=void 0;var _this$state$fabric=Object.assign({},_this.state.fabric),supplierSection=_this$state$fabric.supplierSection;supplierSection.fullPackageData&&supplierSection.fullPackageData.find(function(x,i){if(x.default){fullPackage="fullPack"+i;}});supplierSection.jobWorkData&&supplierSection.jobWorkData.find(function(x,i){if(x.default){jobWork="jobWrk"+i;}});var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.document.close();newWin.onload=function(){newWin.focus();newWin.print();newWin.close();};}else{var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.document.close();newWin.onload=function(){newWin.focus();newWin.print();newWin.close();};// newWin.focus();
// newWin.print();
// // this.onPrintFinished(newWin.print())
// newWin.close();
}});},_this.onPrintFinished=function(){if(_this.state.action!=="view"){_this.props.history.push("/developmentFabric",{action:"edit",_id:_this.state._id});}// setTimeout(() => document.location.reload(true), 100)
},_this.updateSelectedRadio=function(value){var fabric=Object.assign({},_this.state.fabric);fabric.selectedType=value;if(value=="market"){fabric.devRefNumber="";}_this.setState({fabric:fabric});},_this.getFullPackage=function(fullPackageData){var fabric=Object.assign({},_this.state.fabric);fullPackageData.map(function(data,index){data.purposeLabel=data.purpose!==null&&_this.state.fabricInfo.PURPOSE&&_this.state.fabricInfo.PURPOSE.map(function(purpose,i){if(purpose.value===data.purpose){return purpose.label;}}).filter(Boolean)[0];data.SupplierNameLabel=data.supplierName!==null&&_this.state.fabricInfo.SUPPLIERNAME&&_this.state.fabricInfo.SUPPLIERNAME.map(function(SUPPLIERNAME,i){if(SUPPLIERNAME.value===data.supplierName){return SUPPLIERNAME.label;}}).filter(Boolean)[0];});fabric.supplierSection.fullPackageData=fullPackageData;_this.setState({fabric:fabric});},_this.getJobwork=function(jobWorkData){var fabric=Object.assign({},_this.state.fabric);jobWorkData.map(function(data,index){data.purposeLabel=data.purpose!==null&&_this.state.fabricInfo.PURPOSE&&_this.state.fabricInfo.PURPOSE.map(function(purpose,i){if(purpose.value===data.purpose){return purpose.label;}}).filter(Boolean)[0];data.rowData.map(function(dat,i){dat.SupplierNameLabel=dat.supplierName!==null&&_this.state.fabricInfo.SUPPLIERNAME&&_this.state.fabricInfo.SUPPLIERNAME.map(function(SUPPLIERNAME,i){if(SUPPLIERNAME.value===dat.supplierName){return SUPPLIERNAME.label;}}).filter(Boolean)[0];});});fabric.supplierSection.jobWorkData=jobWorkData;_this.setState({fabric:fabric});},_this.confirmDuplicate=function(){Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" p-5 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Do you want to create a duplicate Development Fabric sheet?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.createDuplicate();onClose();}},"Yes"));},closeOnClickOutside:true});},_this.createDuplicate=function(){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].generateQrCode().then(function(response){var fabric=Object.assign({},_this.state.fabric);fabric.fabricNumber=response.data.fabricNumber;fabric.qr=response.data.qr;fabric.requestDate=new Date();fabric.magnumETADate=new Date(),fabric.supplierETADate=new Date(),_this.setState({fabric:fabric,isLoadingSideBar:true,duplicate:false,action:"add",_id:""});_this.props.getalertMessage("success","Duplicate Success!",5000);}).catch(function(error){_this.props.getalertMessage("error");});// SampleServices.getSampleQr()
//   .then(response => {
//     if (response.status === 200) {
//       let sampleRequest = { ...this.state.sampleRequest }
//       sampleRequest.qr = response.text.data.qr
//       sampleRequest.requestNumber = response.text.data.requestNumber
//       sampleRequest.typeOfRequest = ""
//       sampleRequest.sampleType = null
//       this.setState({
//         sampleRequest,
//         action: "add",
//         _id: ""
//         // isLoading: false
//       })
//       this.props.getalertMessage(
//         "success",
//         "Duplicate Success! Please select Source of Request and Sample Type",
//         5000
//       )
//     }
//     response.status === 401 && this.props.unauthorisedFunc()
//   })
//   .catch(err => {
//     this.props.getalertMessage("error")
//   })
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DevelopmentFabric,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var _state=this.state,action=_state.action,_id=_state._id,fabric=_state.fabric;if(this.props.location.state){action=this.props.location.state.action,_id=this.props.location.state._id;}if(action===""&&_id===""){var urlParams=new URLSearchParams(this.props.location.search);action=urlParams.get("action");_id=urlParams.get("_id");this.props.history.replace('/developmentFabric',{action:action,_id:_id});}if(action!="add"){this.setState({scroll:false});}if(action==="edit"){this.setState({duplicate:true});}// window.addEventListener("afterprint", () =>  {alert("print")});
this.setState({action:action,_id:_id,fabric:fabric,disabled:action==="view"?true:false},function(){if(_this2.state._id!==""){__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].getSpecificFabric(_this2.state._id).then(function(response){if(response.status===200){_this2.setState({fabricId:response.text.data._id});var _fabric=Object.assign({},_this2.state.fabric);var obj=Object.assign({},response.text.data);var toggle=Object.assign({},response.text.data.toggle);Object.keys(obj).forEach(function(key){if(key in _fabric){_fabric[key]=obj[key];}});_fabric.dateRequiredAtMagnum=new Date(_fabric.dateRequiredAtMagnum);_this2.setState({fabric:_fabric,toggle:toggle,isLoadingSideBar:true});}response.status===401&&_this2.props.unauthorisedFunc();}).catch(function(error){_this2.props.getalertMessage("error",error.toString());});}else{__WEBPACK_IMPORTED_MODULE_8__services__["e" /* DevelopmentServices */].generateQrCode().then(function(response){var fabric=Object.assign({},_this2.state.fabric);fabric.fabricNumber=response.data.fabricNumber;fabric.qr=response.data.qr;fabric.requestDate=new Date();fabric.magnumETADate=new Date(),fabric.supplierETADate=new Date(),_this2.setState({fabric:fabric,isLoadingSideBar:true});}).catch(function(error){});}});}},{key:"componentDidMount",value:function componentDidMount(){this.prefillData();if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}var rights={solidGreige:this.props.rights.solidGreige,embroidery:this.props.rights.embroidery,print:this.props.rights.print,yarnDyed:this.props.rights.yarnDyed,supplier:this.props.rights.supplier};this.setState({rights:rights});}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}//fabric image func
//submit Fabric to backend
//updating Value for count and construction
// Function to update fabric data in the parent component's state
//bnumber,style,supplier
//toggle
//supplierSection
//development
//selectedRadio
//fullpackage
},{key:"render",// rendering func
value:function render(){var _this3=this;var _state2=this.state,fabric=_state2.fabric,isLoadingSideBar=_state2.isLoadingSideBar,toggle=_state2.toggle,rights=_state2.rights;// console.log(rights, "RIGHTS")
// console.log(this.props, "PROPS")
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-section remove-scroll-for-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row nopadding bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"fabricCreation",className:"w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_Loading__["a" /* default */],null),isLoadingSideBar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_TrimSidebar_index__["a" /* default */],{moduleName:"fabric",number:this.state.fabric.fabricNumber,qr:this.state.fabric.qr,image:this.state.fabric.fabricImage,HSN:this.state.fabric.HSN,handleImageUpload:this.changeImg,onInputChange:this.getHsnOptions,onChange:this.onChange,hsnOptions:this.state.fabricInfo.FABRICHSN,disabled:this.state.action==="view"?true:false,getFabricData:this.getFabricData,removeFabricImage:this.removeFabricImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-content-section overflow-scroll "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(){var route=_this3.props.history.location.state.route;route!==undefined?_this3.props.history.push("/"+route,_defineProperty({},""+route.toLowerCase(),Object.assign({},_this3.props.history.location.state[""+route.toLowerCase()]))):_this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_5__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Fabric Development")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_audit__["a" /* default */],{_id:this.state._id,locationInfo:this.props.location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"btn-green-icon mr-3",onClick:function onClick(e){return _this3.openPrint("printDevelopmentFabric");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_printer_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"btn-green-icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_download_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Fabric__["b" /* FabricMainSection */],{fabricInfo:this.state.fabricInfo,fabric:fabric,getFabricData:this.getFabricData,updateCountConstruction:this.updateCountConstruction,updateFabricData:this.handleFabricDataUpdate,updateSelectedRadio:this.updateSelectedRadio,getSelectData:this.getSelectData,getDevRefNo:this.getDevRefNo,disabled:this.state.action==="view"?true:this.state.disabled// this.props.rights.fabric.web.view
//   ? this.props.rights.fabric.web.create ||
//     this.props.rights.fabric.web.edit
//     ? false
//     : true
//   : this.state.disabled
,getalertMessage:this.props.getalertMessage,unauthorisedFunc:this.props.unauthorisedFunc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding px-5 mt-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"fabric",getRefImages:this.getRefImages,disabled:this.state.disabled,uploadedDocs:(this.state.action==="edit"||this.state.action==="add")&&isLoadingSideBar?fabric.refImages:null,imageTypeOption:this.state.fabricInfo&&this.state.fabricInfo.IMAGETYPE?this.state.fabricInfo.IMAGETYPE:[]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},this.state.action!=="view"&&this.state.duplicate===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Create Duplicae",onClick:this.confirmDuplicate}),this.state.action!="view"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",disabled:this.state.disableBtn,onClick:this.createFabric}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Buttons_Button__["a" /* default */],{history:this.props.history,buttonType:"cancel",buttonName:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 my-5 px-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav-locator mt-0 d-flex flex-row justify-content-center align-items-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"yarnDyed",className:toggle.yarnDyed?"":"print-hidden",value:toggle.yarnDyed,label:"Yarn Dyed",onChange:this.toggleChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embroidery",label:"Embroidery",className:toggle.embroidery?"":"print-hidden",value:toggle.embroidery,onChange:this.toggleChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"print",label:"Print",className:toggle.print?"":"print-hidden",value:toggle.print,onChange:this.toggleChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"solidGreige",value:toggle.solidGreige,label:"Greige/Denim",className:toggle.solidGreige?"":"print-hidden",onChange:this.toggleChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"supplierSection",label:"Supplier",className:toggle.supplierSection?"":"print-hidden",value:toggle.supplierSection,onChange:this.toggleChange,disabled:this.state.disabled})))),toggle.yarnDyed&&this.props.rights.yarnDyed.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Fabric__["e" /* YarnDyed */],{fabricInfo:this.state.fabricInfo,yarnDyed:fabric.yarnDyed,action:this.state.action,toggle:this.state.toggle,_id:this.state._id,getYarnDyed:this.getSubModuleData,disabled:this.state.action!=="view"?this.props.rights.yarnDyed.web.create||this.props.rights.yarnDyed.web.edit?false:true:!this.state.disabled,unauthorisedFunc:this.props.unauthorisedFunc,getalertMessage:this.props.getalertMessage,history:this.props.history,scroll:this.state.scroll}),toggle.embroidery&&this.props.rights.embroidery.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Fabric__["a" /* Embroidery */],{fabricInfo:this.state.fabricInfo,action:this.state.action,embroideryInfo:this.state.embroideryInfo,embroidery:fabric.embroidery,toggle:this.state.toggle,_id:this.state._id,getEmbroidery:this.getSubModuleData,getSourcingData:this.getSourcingData,disabled:this.state.action!=="view"?this.props.rights.embroidery.web.create||this.props.rights.embroidery.web.edit?false:true:!this.state.disabled,unauthorisedFunc:this.props.unauthorisedFunc,getalertMessage:this.props.getalertMessage,history:this.props.history,scroll:this.state.scroll}),toggle.print&&this.props.rights.print.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Fabric__["c" /* Print */],{fabricInfo:this.state.fabricInfo,action:this.state.action,print:fabric.print,toggle:this.state.toggle,_id:this.state._id,getPrint:this.getSubModuleData,disabled:this.state.action!=="view"?this.props.rights.print.web.create||this.props.rights.print.web.edit?false:true:!this.state.disabled,unauthorisedFunc:this.props.unauthorisedFunc,getalertMessage:this.props.getalertMessage,history:this.props.history,scroll:this.state.scroll}),toggle.solidGreige&&this.props.rights.solidGreige.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Fabric__["d" /* SolidGreige */],{forceUpdateCall:this.state.forceUpdateCall,solidGreige:fabric.solidGreige,action:this.state.action,toggle:this.state.toggle,_id:this.state._id,getSolidGreige:this.getSubModuleData,fabricInfo:this.state.fabricInfo,disabled:this.state.action!=="view"?this.props.rights.solidGreige.web.create||this.props.rights.solidGreige.web.edit?false:true:!this.state.disabled,unauthorisedFunc:this.props.unauthorisedFunc,getalertMessage:this.props.getalertMessage,history:this.props.history,scroll:this.state.scroll}),toggle.supplierSection&&this.props.rights.supplier.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_SupplierSection_SupplierMain_SupplierSection__["a" /* default */],{moduleName:"Fabric",action:this.state.action,scrollSupplier:this.state.scroll// scrollSupplier = {toggle.supplierSection}
,getFullPackage:this.getFullPackage,getJobWork:this.getJobwork,suppliersOption:this.state.supplierInfo,fullPackageData:fabric.supplierSection.fullPackageData,jobWorkData:fabric.supplierSection.jobWorkData,toggle:this.state.toggle,_id:this.state._id,disabled:this.state.action!=="view"?this.props.rights.supplier.web.create||this.props.rights.supplier.web.edit?false:true:!this.state.disabled,unauthorisedFunc:this.props.unauthorisedFunc,getalertMessage:this.props.getalertMessage,fabricInfo:this.state.fabricInfo,history:this.props.history,getSupplierForDefault:this.getSupplierForDefault}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"printDevelopmentFabric",className:"d-none"},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_PrintDevelopmentFabric__["a" /* default */],{fabric:this.state.fabricPrint})))))))));}}]);return DevelopmentFabric;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// export default ;
var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights.fabric,selectedRight:state.rights.rightsInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_18_redux__["b" /* bindActionCreators */])({getRights:__WEBPACK_IMPORTED_MODULE_17__redux_action_rights__["a" /* default */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DevelopmentFabric));

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YarnDyed_YarnDyed__ = __webpack_require__(626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__YarnDyed_YarnDyed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SolidGreige_SolidGreige__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__SolidGreige_SolidGreige__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Embroidery_Embroidery__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Embroidery_Embroidery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Print_Print__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Print_Print__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FabricMainSection_FabricMainSection__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__FabricMainSection_FabricMainSection__["a"]; });


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services 
var YarnDyed=function(_Component){_inherits(YarnDyed,_Component);function YarnDyed(){var _ref;var _temp,_this,_ret;_classCallCheck(this,YarnDyed);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=YarnDyed.__proto__||Object.getPrototypeOf(YarnDyed)).call.apply(_ref,[this].concat(args))),_this),_this.state={yarnDyed:{}},_this.updateValue=function(name,value){_this.props.getYarnDyed('yarnDyed',name,value);},_this.createYarnDyed=function(e){e.preventDefault();var yarnDyed=Object.assign({},_this.state.yarnDyed);var _id=_this.props._id;yarnDyed.actionedBy=null;var toggle=Object.assign({},_this.props.toggle);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createYarnDyed(yarnDyed,toggle,_id).then(function(response){if(response.status===200){_this.props.getalertMessage('success',' Yarndyed created ');}response.status===401&&_this.props.unauthorisedFunc();});},_this.resetYarnDyedForm=function(e){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(YarnDyed,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,actionedByOption=_props.actionedByOption,fabricInfo=_props.fabricInfo,yarnDyed=_props.yarnDyed,noOfColsWeftOptions=_props.noOfColsWeftOptions;this.setState({actionedByOption:actionedByOption,fabricInfo:fabricInfo,yarnDyed:yarnDyed,noOfColsWeftOptions:noOfColsWeftOptions});}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.scroll){var yarnDyedEle=document.getElementById('yarnDyedId');yarnDyedEle.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var actionedByOption=nextProps.actionedByOption,fabricInfo=nextProps.fabricInfo,yarnDyed=nextProps.yarnDyed,noOfColsWeftOptions=nextProps.noOfColsWeftOptions;this.setState({actionedByOption:actionedByOption,fabricInfo:fabricInfo,yarnDyed:yarnDyed,noOfColsWeftOptions:noOfColsWeftOptions});}},{key:'render',value:function render(){var _state=this.state,fabricInfo=_state.fabricInfo,yarnDyed=_state.yarnDyed,noOfColsWeftOptions=_state.noOfColsWeftOptions;var _props2=this.props,disabled=_props2.disabled,washoptions=_props2.washoptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 px-5 ',id:'yarnDyedId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-green font-lg font-weight-bold'},'Yarn Dyed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'actionedBy',value:fabricInfo&&fabricInfo.YARNDYED&&fabricInfo.YARNDYED.ASSIGNEDTO&&fabricInfo.YARNDYED.ASSIGNEDTO.length>0&&fabricInfo.YARNDYED.ASSIGNEDTO[0].value,options:fabricInfo&&fabricInfo.YARNDYED&&fabricInfo.YARNDYED.ASSIGNEDTO?fabricInfo.YARNDYED.ASSIGNEDTO:[],label:'Assigned To',onChange:this.updateValue,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'typeOfLoom',value:yarnDyed.typeOfLoom,options:fabricInfo&&fabricInfo.YARNDYED?fabricInfo.YARNDYED.TYPEOFLOOM:[],label:'Type of loom',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'dyeStuff',value:yarnDyed.dyeStuff,options:fabricInfo.DYESTUFF,label:'Dye stuff',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'noOfColsWeft',value:yarnDyed.noOfColsWeft,options:fabricInfo.NOOFCOLSONWEFT,label:'No of cols on weft',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'number',inputName:'designRepeatSize',value:yarnDyed.designRepeatSize,label:'Design Repeat Size',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'weave',value:yarnDyed.weave,options:fabricInfo&&fabricInfo.YARNDYED?fabricInfo.YARNDYED.WEAVE:[],label:'Weave',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'finish',value:yarnDyed.finish,options:fabricInfo.FINISH,label:'Finish',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'wash',label:'Wash',value:yarnDyed.wash,options:fabricInfo.WASH,onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 profile-btn text-center'},this.state.action!='view'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:'Save',onClick:this.createYarnDyed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:'Cancel',buttonType:'cancel',history:this.props.history})));}}]);return YarnDyed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YarnDyed);YarnDyed.propTypes={};YarnDyed.defaultProps={};

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services
var SolidGreige=function(_Component){_inherits(SolidGreige,_Component);function SolidGreige(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SolidGreige);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SolidGreige.__proto__||Object.getPrototypeOf(SolidGreige)).call.apply(_ref,[this].concat(args))),_this),_this.state={solidGreige:{},fabricInfo:{},disabled:false},_this.updateValue=function(name,value){_this.props.getSolidGreige('solidGreige',name,value);},_this.createSolid=function(e){e.preventDefault();var solidGreige=Object.assign({},_this.props.solidGreige);var _id=_this.props._id;solidGreige.actionedBy=null;var toggle=Object.assign({},_this.props.toggle);var data={solidGreige:solidGreige,toggle:toggle,_id:_id};__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createSolid(data).then(function(response){if(response.status===200){_this.props.getalertMessage('success','GREIGE / DENIM created ');}response.status===401&&_this.props.unauthorisedFunc();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SolidGreige,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.scroll){var solidGreigeEle=document.getElementById('solidGreigeId');solidGreigeEle.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});}this.setState({solidGreige:this.props.solidGreige,fabricInfo:this.props.fabricInfo,disabled:this.props.disabled});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({solidGreige:nextProps.solidGreige,fabricInfo:nextProps.fabricInfo,disabled:nextProps.disabled});if(nextProps.forceUpdateCall){}}},{key:'render',value:function render(){var _state=this.state,solidGreige=_state.solidGreige,disabled=_state.disabled,fabricInfo=_state.fabricInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 px-5',id:'solidGreigeId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-green font-lg font-weight-bold'},' GREIGE / DENIM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 product-form px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'actionedBy',value:fabricInfo&&fabricInfo['GREIGE/DENIM']&&fabricInfo['GREIGE/DENIM'].ASSIGNEDTO&&fabricInfo['GREIGE/DENIM'].ASSIGNEDTO.length>0&&fabricInfo['GREIGE/DENIM'].ASSIGNEDTO[0].value,options:fabricInfo['GREIGE/DENIM']?fabricInfo['GREIGE/DENIM'].ASSIGNEDTO:[],label:'Assigned To',onChange:this.updateValue,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'typeOfLoom',value:solidGreige.typeOfLoom,options:fabricInfo&&fabricInfo['GREIGE/DENIM']?fabricInfo['GREIGE/DENIM'].TYPEOFLOOM:[],label:'Type of loom',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'weave',value:solidGreige.weave,options:fabricInfo['GREIGE/DENIM']?fabricInfo['GREIGE/DENIM'].WEAVE:[],label:'Weave',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'designDescription',value:solidGreige.designDescription,options:fabricInfo.DESIGN,label:'Design',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 profile-btn text-center'},this.state.action!='view'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:'Save',onClick:this.createSolid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:'Cancel',buttonType:'cancel',history:this.props.history}))));}}]);return SolidGreige;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SolidGreige);SolidGreige.propTypes={};SolidGreige.defaultProps={};

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services
var Embroidery=function(_Component){_inherits(Embroidery,_Component);function Embroidery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Embroidery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Embroidery.__proto__||Object.getPrototypeOf(Embroidery)).call.apply(_ref,[this].concat(args))),_this),_this.state={sourcingOptions:[],sourcingValue:null,embroidery:{}},_this.getSourcingInfo=function(e){if(e.length>0){__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getSourcingInfo(e).then(function(response){if(response.status===200){_this.setState({sourcingOptions:response.text.data});}}).catch(function(error){});}},_this.changeSourcingInfo=function(sourcingValue){sourcingValue!==null&&_this.setState({sourcingValue:sourcingValue},_this.props.getSourcingData(sourcingValue.value));},_this.updateValue=function(name,value){_this.props.getEmbroidery('embroidery',name,value);},_this.createEmbroidery=function(e){e.preventDefault();var embroidery=Object.assign({},_this.props.embroidery);Object.keys(embroidery).forEach(function(x){if(embroidery[x]===""||embroidery[x]==false)delete embroidery[x];});embroidery._id=_this.props._id;embroidery.actionedBy=null;var data={embroidery:embroidery,_id:_this.props._id,toggle:Object.assign({},_this.props.toggle)};__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].createEmbroidery(data).then(function(response){if(response.status===200){_this.props.getalertMessage('success',' Embroidery Created ');}response.status===401&&_this.props.unauthorizedFunc();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Embroidery,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props=this.props,actionedByOption=_props.actionedByOption,fabricInfo=_props.fabricInfo,embroideryInfo=_props.embroideryInfo,embroidery=_props.embroidery,sourcingInfo=_props.sourcingInfo;this.setState({actionedByOption:actionedByOption,fabricInfo:fabricInfo,embroideryInfo:embroideryInfo,embroidery:embroidery,sourcingInfo:sourcingInfo,sourcingValue:embroidery.sourcing});__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getSourcingInfo('').then(function(response){if(response.status===200){_this2.setState({sourcingOptions:response.text.data});}}).catch(function(error){});}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.scroll){var embroideryEle=document.getElementById('embroideryId');embroideryEle.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var actionedByOption=nextProps.actionedByOption,fabricInfo=nextProps.fabricInfo,embroideryInfo=nextProps.embroideryInfo,fabric=nextProps.fabric,sourcingInfo=nextProps.sourcingInfo;this.setState({actionedByOption:actionedByOption,fabricInfo:fabricInfo,embroideryInfo:embroideryInfo,fabric:fabric,sourcingInfo:sourcingInfo});}//sourcing info
},{key:'render',value:function render(){var _React$createElement;var _props2=this.props,getEmbroidery=_props2.getEmbroidery,embroidery=_props2.embroidery,disabled=_props2.disabled,designDescriptionOptions=_props2.designDescriptionOptions;var _state=this.state,actionedByOption=_state.actionedByOption,fabricInfo=_state.fabricInfo,embroideryInfo=_state.embroideryInfo,sourcingValue=_state.sourcingValue,sourcingOptions=_state.sourcingOptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 px-5',id:'embroideryId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-green font-lg font-weight-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Embroidery')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 product-form px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'actionedBy',value:fabricInfo&&fabricInfo.EMBROIDERY&&fabricInfo.EMBROIDERY.ASSIGNEDTO&&fabricInfo.EMBROIDERY.ASSIGNEDTO.length>0&&fabricInfo.EMBROIDERY.ASSIGNEDTO[0].value,options:fabricInfo.EMBROIDERY&&fabricInfo.EMBROIDERY.ASSIGNEDTO?fabricInfo.EMBROIDERY.ASSIGNEDTO:[],label:'Assigned To',onChange:this.updateValue,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'fabricBase',value:embroidery.fabricBase,options:fabricInfo.BASICQUALITY,label:'Basic Quality',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'threadQuality',value:embroidery.threadQuality,options:fabricInfo.THREADQUALITY||[],label:'Thread Quality',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'machineType',value:embroidery.machineType,options:fabricInfo.MACHINETYPE,label:'Machine type',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'designDescription',value:embroidery.designDescription,options:fabricInfo.DESIGNDESCRIPTION,label:'Design Description',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'text',inputName:'targetRate',value:embroidery.targetRate,label:'Target rate including fabric',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'embTechinique',value:embroidery.embTechinique,options:fabricInfo.EMBTECHNIQUE,label:'Emb Technique',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'text',inputName:'backingDetails',value:embroidery.backingDetails,label:'Backing Details',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],(_React$createElement={isFormGroup:true,inputType:'checkboxToggle',inputName:'backing',value:embroidery.backing,label:'Backing'},_defineProperty(_React$createElement,'value',embroidery.backing),_defineProperty(_React$createElement,'onChange',this.updateValue),_defineProperty(_React$createElement,'disabled',disabled),_React$createElement))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'gradingRequired',label:'Grading reqd',value:embroidery.gradingRequired,onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'marker',label:'Marker',value:embroidery.marker,onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'scalloping',label:'Scalloping',value:embroidery.scalloping,onChange:this.updateValue,disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 profile-btn text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:'Save',onClick:this.createEmbroidery}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:'Cancel',buttonType:'cancel',history:this.props.history})))));}}]);return Embroidery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Embroidery);Embroidery.propTypes={};Embroidery.defaultProps={};

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services 
var Print=function(_Component){_inherits(Print,_Component);function Print(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Print);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Print.__proto__||Object.getPrototypeOf(Print)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.updateValue=function(name,value){_this.props.getPrint('print',name,value);},_this.createPrint=function(e){e.preventDefault();var print=Object.assign({},_this.props.print);print.actionedBy=null;var data={print:print,toggle:Object.assign({},_this.props.toggle),_id:_this.props._id};__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].createPrint(data).then(function(response){if(response.status===200){_this.props.getalertMessage('success',' Print Created ');}response.status===401&&_this.props.unauthorisedFunc();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Print,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.scroll){var printEle=document.getElementById('printId');printEle.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});}}},{key:'render',value:function render(){var _props=this.props,fabricInfo=_props.fabricInfo,actionedByOption=_props.actionedByOption,print=_props.print,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 px-5',id:'printId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-green font-lg font-weight-bold'},'Print'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 product-form px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'actionedBy',value:fabricInfo&&fabricInfo.PRINT&&fabricInfo.PRINT.ASSIGNEDTO&&fabricInfo.PRINT.ASSIGNEDTO.length>0&&fabricInfo.PRINT.ASSIGNEDTO[0].value,options:fabricInfo.PRINT&&fabricInfo.PRINT.ASSIGNEDTO?fabricInfo.PRINT.ASSIGNEDTO:[],label:'Assigned To',onChange:this.updateValue,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'printType',value:print.printType,options:fabricInfo.PRINTTYPE||[],label:'Print Type',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'printDirection',value:print.printDirection,options:fabricInfo.PRINTDIRECTION||[],label:'Print Direction',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'printRoute',value:print.printRoute,options:fabricInfo.PRINTROUTE||[],label:'Print Route',onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'select',inputName:'noOfColors',value:print.noOfColors,options:fabricInfo.NOOFCOLOURS,label:'No Of Colors',onChange:this.updateValue,disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'text',inputName:'rotaryRepeatSize',value:print.rotaryRepeatSize,label:'Rotary Repeat Size',onChange:this.updateValue,disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'layerFile',label:'Layer File',value:print.layerFile,onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'artworkWithColSquare',label:'Artwork wit col square',value:print.artworkWithColSquare,onChange:this.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 step-one pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:'checkboxToggle',inputName:'fluroscentCols',label:'Fluroscent cols',value:print.fluroscentCols,onChange:this.updateValue,disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 profile-btn text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Buttons_Button__["a" /* default */],{buttonName:'Save',onClick:this.createPrint}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Buttons_Button__["a" /* default */],{buttonName:'Cancel',buttonType:'cancel',history:this.props.history}))));}}]);return Print;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Print);Print.propTypes={};Print.defaultProps={};

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//field
var FabricMainSection=function(_Component){_inherits(FabricMainSection,_Component);function FabricMainSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FabricMainSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FabricMainSection.__proto__||Object.getPrototypeOf(FabricMainSection)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:"market",suppliers:[],fabricInfo:{},development:"",styleList:[],buyerPrimarySourceInfo:[],bNumberInfo:[],supplierInfo:[],customerList:[],// bnumberValue : {},
// styleValue : {},
supplierNameValue:"",disabled:_this.props.disabled,priorityOptions:[],dropDown1:[]},_this.handleBaseNoDropdownChange=function(inputValue,selectedBaseNo){// If there is input, fetch dropdown options
if(inputValue){_this.props.getSelectData(inputValue,selectedBaseNo);}// If there is a selected Base No, fetch additional data based on the selection
if(!selectedBaseNo){_this.props.updateFabricData({classificationOfFabric:"",quality:"",composition:"",count:{warp:"",weft:""},construction:{warp:"",weft:""}});}else{// If a valid base number is selected, call the getBNumber function
_this.getBNumber(selectedBaseNo);}},_this.getBnoDropdown=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getBnoDropdown(value).then(function(response){//console.log(response, "responsebno");
if(response.status===200){var jsonData=response.data.bNumbers.map(function(info){return{label:info.label,// Base No label
value:info.value// Base No ID
};});_this.setState({dropDown1:[].concat(_toConsumableArray(jsonData))// Storing the search results in state
});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.getBNumber=function(selectedBaseNo){//console.log(selectedBaseNo, "selectedBaseNo");
if(selectedBaseNo){//console.log(selectedBaseNo.value, "selectedBaseNo");
__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getBNumber(selectedBaseNo.value).then(function(response){if(response.status===200){// Update fabric data with the new response
//console.log(response.text.data, "response.data");
// let count = {};
//   if (response && response.text && response.text.data && response.text.data.count) {
//     count.warp = response.text.data.count.warp || 0; // Default to 0 if undefined
//     count.weft = response.text.data.count.weft || 0; // Default to 0 if undefined
//     console.log(response.text.data.count.warp,"df")
//   }
//   let construction = {};
//   if (response && response.text && response.text.data && response.text.data.construction) {
//     construction.warp = response.text.data.construction.warp || 0; // Default to 0 if undefined
//     construction.weft = response.text.data.construction.weft || 0; // Default to 0 if undefined
//   }
var count={};var construction={};// Check and set values if response.data.fabricValues exists
if(response.text&&response.text.data&&response.text.data.fabricValues){count={warp:response.text.data.fabricValues.count.warp||0,weft:response.text.data.fabricValues.count.weft||0};construction={warp:response.text.data.fabricValues.construction.warp||0,weft:response.text.data.fabricValues.construction.weft||0};}_this.props.updateFabricData({classificationOfFabric:response.text.data.fabricValues.classificationOfFabric||"",quality:response.text.data.fabricValues.quality||"",composition:response.text.data.fabricValues.composition||"",// requirement: response.data.requirement,
// countConstruction: response.data.countConstruction,
// pick: response.data.pick,
// reed: response.data.reed,
count:response.text.data.fabricValues.count,construction:response.text.data.fabricValues.construction});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}},_this.getCustomerList=function(){__WEBPACK_IMPORTED_MODULE_3__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:[].concat(_toConsumableArray(response.text.data))});}}).catch(function(error){_this.props.getalertMessage("error",error.toString);});},_this.getStyleInfo=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleList:[].concat(jsonData)});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.getStyleInfoById=function(id){if(id!==null){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReferenceById(id).then(function(response){if(response.status===200){var styleList=[].concat(_toConsumableArray(_this.state.styleList),_toConsumableArray(response.text.data));_this.setState({styleList:styleList});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.getSupplierInfo=function(e){if(e.length>0){__WEBPACK_IMPORTED_MODULE_3__services__["k" /* StyleServices */].SearchStyle(e).then(function(response){if(response.status===200){_this.setState({supplierInfo:response.text.data});}}).catch(function(error){});}},_this.changeSupplierInfo=function(supplierNameValue){supplierNameValue!==null?_this.setState({supplierNameValue:supplierNameValue},function(){}):_this.setState({supplierNameValue:""},function(){_this.props.getSelectData("supplierName",null);});},_this.clearValue=function(){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FabricMainSection,[{key:"componentDidMount",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var priorityOptions,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.getCustomerList();case 2:_context.next=4;return this.getStyleInfo("");case 4:_context.next=6;return this.getStyleInfoById(this.props.fabric.magnumStyleId);case 6:_context.next=8;return this.getBnoDropdown("");case 8:_context.next=10;return this.getBNumber("");case 10:_context.next=12;return __WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].prefillFabricDetails().then(function(response){//console.log(response,"res");
_this2.setState({fabricInfo:response.data.Fabric,embroideryInfo:response.data.Embroidery});}).catch(function(error){_this2.props.getalertMessage("error",error.toString);});case 12:// await DevelopmentServices.getBnoDropdown()
//   .then(response => {
//     console.log(response,"res2");
//     this.setState({
//       dropDown1: response.data
//     });
//   })
//   .catch(error=>{
//     this.props.getalertMessage(
//       "error",
//       error.toString
//     );
//   });
priorityOptions=[];i=1;while(i<=10){priorityOptions.push({value:i,label:i});i++;}_context.next=17;return this.setState({priorityOptions:priorityOptions});case 17:case"end":return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()// componentDidUpdate(prevProps, prevState) {
//   console.log("fabric state updted")
//   if (prevState.fabric !== this.state.fabric) {
//     console.log("Fabric state updated:", this.state.fabric);
//   }
// }
// Existing function to fetch Base No dropdown options
// Existing function to handle when a Base No is selected
//supplier
},{key:"render",value:function render(){var _this3=this;var _state=this.state,buyerPrimarySourceInfo=_state.buyerPrimarySourceInfo,bNumberInfo=_state.bNumberInfo,customerList=_state.customerList,styleList=_state.styleList,bnumberValue=_state.bnumberValue,supplierInfo=_state.supplierInfo,supplierNameValue=_state.supplierNameValue,priorityOptions=_state.priorityOptions,dropDown1=_state.dropDown1;// console.log(bNumberInfo,"bNumberInfo");
// console.log(bnumberValue,"bnumberValue");
var _props=this.props,fabric=_props.fabric,fabricInfo=_props.fabricInfo,suppliers=_props.suppliers;//console.log(fabric, "fabricMainSection");
//console.log(fabric.bNumber.value, "fabric.bNumber");
//console.log(fabricInfo, "fabricInfo");
//console.log(this.props.getFabricData,"console.eh")
var statusOptions=[{value:"pending",label:"Pending"},{value:"completed",label:"Completed"},{value:"cancelled",label:"Cancelled"}];var countConstruction="";countConstruction+=fabric.count.warp;fabric.count.weft!==""&&(countConstruction+=" * "+fabric.count.weft);fabric.construction.warp!==""&&(countConstruction+=" / "+fabric.construction.warp);fabric.construction.weft!==""&&(countConstruction+=" * "+fabric.construction.weft);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mul-check check-padding pl-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"radio-inline nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"fabricDevRadio",type:"radio",className:"filled-in hide-all",id:"rad1",value:"market",checked:fabric.selectedType==="market",onChange:function onChange(e){return _this3.props.updateSelectedRadio(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"rad1"},"Market/Supplier")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"fabricDevRadio",type:"radio",className:"filled-in hide-all",id:"rad2",value:"development",checked:fabric.selectedType==="development",onChange:function onChange(e){_this3.props.updateSelectedRadio(e.target.value),_this3.props.getDevRefNo();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"rad2"},"Development")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xs-5 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Supplier Name"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"supplierName",value:fabric.supplierName,onInputChange:this.getSupplierInfo,onChange:function onChange(supplierNameValue){return _this3.props.getSelectData("supplierName",supplierNameValue);},placeholder:"Find Suppliername",options:fabricInfo.SUPPLIERNAME,disabled:this.state.disabled,isClearable:true,clearValue:this.clearValue})))),fabric.selectedType==="development"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Request Date"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:fabric.requestDate?fabric.requestDate:"",inputName:"requestDate",onChange:this.props.getFabricData,disabled:this.state.disabled}))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"height-27"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Status"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"status",value:fabric.status,options:statusOptions,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"print-hidden"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"padding-for-li"},"Count"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"print-hidden"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Warp",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control width-150",name:"warp",tabIndex:"1",value:fabric.count.warp,onChange:function onChange(e){return _this3.props.updateCountConstruction(e,"count");},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Weft"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control width-150",name:"weft",tabIndex:"2",value:fabric.count.weft,onChange:function onChange(e){return _this3.props.updateCountConstruction(e,"count");},disabled:this.state.disabled}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xs-5 view-ib-right nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list"},fabric.selectedType==="development"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:""},"Dev Ref No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:""},this.state.development!==null&&fabric.devRefNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Priority")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"priority",value:fabric.priority,options:priorityOptions,onChange:this.props.getFabricData,disabled:this.state.disabled})))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"height-27"}),fabric.selectedType==="development"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Magnum ETA"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:fabric.magnumETADate?fabric.magnumETADate:"",inputName:"magnumETADate",onChange:this.props.getFabricData,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{"class":""},"Supplier ETA"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",value:fabric.supplierETADate,inputName:"supplierETADate",onChange:this.props.getFabricData,disabled:this.state.disabled})))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"height-27"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"height-27"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"print-hidden"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"padding-for-li"},"Construction"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"print-hidden"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Reed",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",style:{width:"150px"},className:"form-control",name:"warp",tabIndex:"3",value:fabric.construction.warp,onChange:function onChange(e){return _this3.props.updateCountConstruction(e,"construction");},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Pick"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",style:{width:"150px"},className:"form-control",name:"weft",tabIndex:"4",value:fabric.construction.weft,onChange:function onChange(e){return _this3.props.updateCountConstruction(e,"construction");},disabled:this.state.disabled}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xs-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xs-3 nopadding text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Count & Construction"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xs-6 nopadding px-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",name:"countconstruction",readOnly:true,value:countConstruction}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xs-5  view-ib-right nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Classification of fabric"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"classificationOfFabric",value:fabric.classificationOfFabric,options:fabricInfo.CLASSIFICATIONOFFABRIC,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Quality"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"quality",value:fabric.quality,options:fabricInfo.BASICQUALITY,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Composition"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"composition",value:fabric.composition,options:fabricInfo.COMPOSITION,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Requirement"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"requirement",value:fabric.requirement,options:fabricInfo.REQUIREMENT,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Ref Fab No."," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"refFabNo",value:fabric.refFabNo,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Supplier Ref no"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"supplierRefNo",value:fabric.supplierRefNo,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"quantity received"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"quantityReceived",value:fabric.quantityReceived,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Buyer primary light source"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"buyerPrimarySource",value:fabric.buyerPrimarySource,options:fabricInfo.BUYERPRIMARYLIGHTSOURCE,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Base No"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"bNumber",value:fabric.bNumber,onInputChange:this.getBnoDropdown,onChange:function onChange(value){return _this3.handleBaseNoDropdownChange("bNumber",value);},placeholder:"Find Base No",options:dropDown1,disabled:this.state.disabled}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xs-5 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"GSM/OZ"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"gsm",value:fabric.gsm,onChange:this.props.getFabricData,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"width")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"width",value:fabric.width,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Cust Design Ref no"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"custDefNo",value:fabric.custDefNo,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Color"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"colorWay",value:fabric.colorWay,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Origination of artwork",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"orginationOfArtwork",value:fabric.orginationOfArtwork,options:fabricInfo.ORIGINATIONOFARTWORK,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"}," ","MAG 3D Ref No.",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"magCadRefNo",value:fabric.magCadRefNo,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Customer-Dept"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control",name:"customerDepartmentId",onChange:function onChange(e){return _this3.props.getFabricData(e.target.name,e.target.value);},value:fabric.customerDepartmentId,disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"select"),customerList.map(function(data){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:data.departmentId},data.customerName+" - "+data.departmentName);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"}," ","MAG Style No.",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,":")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{name:"magnumStyleId",value:fabric.magnumStyleId,onInputChange:this.getStyleInfo,onChange:function onChange(value){return _this3.props.getSelectData("magnumStyleId",value);},placeholder:"Find Style",options:styleList,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"Attribute"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"attribute",value:fabric.attribute,options:fabricInfo.ATTRIBUTE,onChange:this.props.getFabricData,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right"},"File Transfer"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"fileTransfer",value:fabric.fileTransfer,options:fabricInfo.FILETRANSFER,onChange:this.props.getFabricData,disabled:this.state.disabled}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 py-0 px-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"specialComments",value:fabric.specialComments,label:"special comments",onChange:this.props.getFabricData,disabled:this.state.disabled})));}}]);return FabricMainSection;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);FabricMainSection.propTypes={};FabricMainSection.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (FabricMainSection);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//values
//components
var JobWork=function(_Component){_inherits(JobWork,_Component);function JobWork(){_classCallCheck(this,JobWork);return _possibleConstructorReturn(this,(JobWork.__proto__||Object.getPrototypeOf(JobWork)).apply(this,arguments));}_createClass(JobWork,[{key:"render",value:function render(){var _this2=this;var _props=this.props,disabled=_props.disabled,jobWorkSequence=_props.jobWorkSequence,jobWorkData=_props.jobWorkData,fabricInfo=_props.fabricInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"jobwork",name:"jobWorkForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 p-0 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"font-weight-bold"},"Job Work"),!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{display:"block"},className:"btn-floating btn-small waves-effect waves-light green pull-right",onClick:function onClick(e){return _this2.props.addJobWork();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"add"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,jobWorkData&&jobWorkData.length>0&&jobWorkData.map(function(data,i){// console.log(data, "RowData");
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding",key:i,id:"jobWrk"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Option ",i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"select-currency",name:"purpose",onChange:function onChange(e){return _this2.props.updateJobworkDataKeyValue(e,i);},disabled:disabled,value:data.purpose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"select"),fabricInfo&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(dat,indexOfFabricInfo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:indexOfFabricInfo,value:dat.value},dat.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{display:"block"},"class":"btn-floating btn-small waves-effect waves-light red pull-right my-3 mr-3",id:"del-sample-size-btn pull-rog pull-right",onClick:function onClick(e){return _this2.props.removeJobWork(i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"clear")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"10%"},"Sequence"),jobWorkSequence.map(function(Data,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:90/jobWorkSequence.length-1+"%"},ind+1);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Process"),jobWorkSequence.map(function(job,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control",onChange:function onChange(e){return _this2.props.addingRow(e,i,ind+1);},disabled:disabled,value:data.rowData&&data.rowData.length&&!!data.rowData[ind]&&"key"in data.rowData[ind]&&data.rowData[ind].key||""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"select"),jobWorkSequence.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:data.key},data.value);})));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"5%"},"Process"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"11%"},"Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"20%"},"Supp Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"15%"},"Supp Ref"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"7%"},"LT(days)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"7%"},"Width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"6%"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"11%"},"Price"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"8%"},"VL%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col",width:"10%"},"Cost"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,data.rowData.map(function(data,index){return data.key&&data.process!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"row"},data.process),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"date",value:data.date,index:index,i:i,onChange:_this2.props.updateJobworkRow,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"supplierName",value:data.supplierName,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),fabricInfo&&fabricInfo.SUPPLIERNAME&&fabricInfo.SUPPLIERNAME.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:index,value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"supplierRef",value:data.supplierRef,index:index,i:i,onChange:_this2.props.updateJobworkRow,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number","class":"form-control",name:"leadTime",value:data.leadTime,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"width",value:data.width,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{"class":"select-currency",name:"currency",value:data.currency,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_2__services_common_options__["a" /* default */].currency.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:value.value,key:index},value.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"price",value:data.price,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"vl",value:data.vl,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkRow(e.target.name,e.target.value,index,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.cost?data.cost:"")):null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"8",className:"text-right border-0 pt-3"},"GST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"width-30 text-right",name:"GST",value:data.GST,disabled:disabled,onChange:function onChange(e){_this2.props.updateJobworkDataKeyValue(e,i),setTimeout(function(){return _this2.props.updateJobWorkRowDataTotalCost();},100);}}),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.totalCost>0&&Number(Number(data.totalCost)-Number(data.transport)).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"8",className:"text-right border-0"},"Transport"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"width-30 text-right",name:"transport",value:data.transport,disabled:disabled,onChange:function onChange(e){_this2.props.updateJobworkDataKeyValue(e,i),setTimeout(function(){return _this2.props.updateJobWorkRowDataTotalCost();},100);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.totalCost>0&&data.totalCost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"8",className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"font-apply-li"},"MOQ")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control width-100 d-inline",value:data.moq,disabled:disabled,name:"moq",onChange:function onChange(e){return _this2.props.updateJobworkDataKeyValue(e,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"font-apply-li"},"Total Lead time")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control width-100 d-inline",id:"totalleadtime",value:data.totalLeadTime,disabled:disabled,name:"totalLeadTime",onChange:function onChange(e){return _this2.props.updateJobworkDataKeyValue(e,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"font-apply-li"},"Finished width")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control width-100 d-inline",id:"finishedwidth",name:"finishedWidth",value:data.finishedWidth,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkDataKeyValue(e,i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"font-apply-li"},"Cuttable width")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control width-100 d-inline",id:"cuttablewidth",name:"cuttableWidth",value:data.cuttableWidth,disabled:disabled,onChange:function onChange(e){return _this2.props.updateJobworkDataKeyValue(e,i);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"font-apply-li pt-1"},"Total cost")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0 thicker"},data.totalCost>0&&data.totalCost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"default",value:"jobwork"+i,checked:data.default,index:i,onChange:function onChange(name,value){return _this2.props.updateValueForDefault(name,value,i,"jobwork",jobWorkData);},disabled:disabled})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"specialComments",value:data.specialComments,index:i,label:"Special Comments",onChange:_this2.props.updateValue,disabled:disabled}))));})));}}]);return JobWork;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (JobWork);JobWork.propTypes={};JobWork.defaultProps={};

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_common_options__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var FullPackage=function(_Component){_inherits(FullPackage,_Component);function FullPackage(){_classCallCheck(this,FullPackage);return _possibleConstructorReturn(this,(FullPackage.__proto__||Object.getPrototypeOf(FullPackage)).apply(this,arguments));}_createClass(FullPackage,[{key:"render",value:function render(){var _this2=this;var _props=this.props,fullPackageData=_props.fullPackageData,fabricInfo=_props.fabricInfo,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"fullPackageForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 fullPackCon p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"font-weight-bold"},"Full Package"),!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{display:"block"},className:"btn-floating btn-small waves-effect waves-light green pull-right",onClick:function onClick(e){return _this2.props.addFullPackageCount();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"add"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,fullPackageData.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding",key:index,id:"fullPack"+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"p-3"},index+1)),!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{display:"block"},"class":"btn-floating btn-small waves-effect waves-light red pull-right my-3 mr-3",id:"del-sample-size-btn pull-rog pull-right",onClick:function onClick(){return _this2.props.removeFullPackage(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"clear")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"fullpackage",className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table sizing-for-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"9%"},"Purpose"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"12%"},"Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"15%"},"Supplier Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"8%"},"Supplier Ref"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"6%"},"LT",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(days)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"8%"},"Width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"6%"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"11%"},"Price"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"7%"},"Units"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"5%"},"GST%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"5%"},"Trans"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"8%"},"Total cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"5%"},"Default"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"style-table-border"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"select-currency",name:"purpose",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled,value:data.purpose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"select"),fabricInfo&&fabricInfo.PURPOSE&&fabricInfo.PURPOSE.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"date",value:data.date?data.date:"",index:index,onChange:_this2.props.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-currency",name:"supplierName",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled,value:data.supplierName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),fabricInfo&&fabricInfo.SUPPLIERNAME&&fabricInfo.SUPPLIERNAME.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"supplierRef",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled,value:data.supplierRef})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",max:3,value:data.leadTime,inputName:"leadTime",index:index,onChange:_this2.props.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"width",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled,value:data.width})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"select-currency",name:"currency",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled,value:data.currency},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_3__services_common_options__["a" /* default */].currency.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:value.value,key:index},value.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"price",value:data.price,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"select-currency",name:"MY",value:data.MY,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled},_this2.props.moduleName.toLowerCase()==="trims"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"gross"},"GROSS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"meter"},"MTRS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"yard"},"YD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pcs"},"PCS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"sets"},"SETS")):_this2.props.moduleName.toLowerCase()==="fabric"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"meter"},"MTRS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"yard"},"YD")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"GST",value:data.currency!=="dollar"?data.GST:"",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled||data.currency=="dollar"// value={data.GST}
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0","class":"form-control",name:"transport",value:data.currency!=="dollar"?data.transport:"",onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled||data.currency=="dollar"// value={data.transport}
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fullPackageData[index].totalCost?fullPackageData[index].totalCost:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"default",value:"fullpackage"+index,checked:data.default,index:index,onChange:function onChange(name,value){return _this2.props.updateValueForDefault(name,value,index,"fullpackage",fullPackageData);},disabled:disabled})))))),data.currency=="dollar"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Price $ "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"price",value:data.price,index:index,onChange:_this2.props.updateValue,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"select-currency",name:"MY",value:data.MY,onChange:function onChange(e){return _this2.props.updateValue(e.target.name,e.target.value,index);},disabled:disabled},_this2.props.moduleName.toLowerCase()==="trims"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"gross"},"GROSS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"meter"},"MTRS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"yard"},"YD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"pcs"},"PCS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"sets"},"SETS")):_this2.props.moduleName.toLowerCase()==="fabric"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"meter"},"MTRS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"yard"},"YD")):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.currencyData.priceMTS),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.MY==="gross"?"PER PC":data.MY)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Convertion to INR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.currencyData.conversionToINR),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.05rem"}},"$"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",style:{width:"25%"},value:_this2.props.USDtoINR,onChange:function onChange(e){return _this2.props.updateINRCurrency(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"}},"\u20B9"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Shipment term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-currency",name:"shipmentTerm",value:data.currencyData.shipmentTerm,disabled:disabled,onChange:function onChange(e){return _this2.props._inputForCurrency(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),fabricInfo.SHIPMENTTERM.map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:dat.label},dat.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Ship Mode"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-currency",name:"shipmentMode",value:data.currencyData.shipmentMode,disabled:disabled,onChange:function onChange(e){return _this2.props._inputForCurrency(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),fabricInfo.SHIPMENTMODE.map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:dat.label},dat.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Port of Pick up"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:"form-control select-currency",name:"portOfPickup",value:data.currencyData.portOfPickup,disabled:disabled,onChange:function onChange(e){return _this2.props._inputForCurrency(e.target.name,e.target.value,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Select"),fabricInfo.PORTOFPICKUP.map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:dat.name},dat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Freight costs \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"freightCosts",value:data.currencyData.freightCosts,index:index,onChange:_this2.props._inputForCurrency,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Clearance \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"clearance",value:data.currencyData.clearance,index:index,onChange:_this2.props._inputForCurrency,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Duty %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"duty",value:data.currencyData.duty,index:index,onChange:_this2.props._inputForCurrency,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"pt-2"},"Total ",_this2.props.moduleName," Cost")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"thicker border-0"},"\u20B9 ",data.totalCost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8"},_this2.props.moduleName.toLowerCase()==="trims"?null:_this2.props.moduleName.toLowerCase()==="fabric"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Total Order quantity"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"totalOrderQuantity",value:data.currencyData.totalOrderQuantity?data.currencyData.totalOrderQuantity:"",index:index,onChange:_this2.props._inputForCurrency,disabled:data.currencyData.portOfPickup===null?true:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"width",value:data.currencyData.width?data.currencyData.width:"",index:index,onChange:_this2.props._inputForCurrency,disabled:data.currencyData.portOfPickup===null?true:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"GSM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"gsm",value:data.currencyData.gsm?data.currencyData.gsm:"",index:index,onChange:_this2.props._inputForCurrency,disabled:data.currencyData.portOfPickup===null?true:disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Weight of Fabric Per Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.currencyData.weightOfFabricPerMtr?data.currencyData.weightOfFabricPerMtr:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Weight for Full Order"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.currencyData.weightForFullOrder?data.currencyData.weightForFullOrder:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},"Freight Rate per kg"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-0"},data.currencyData.freightRatePerKg?data.currencyData.freightRatePerKg:"")))):null))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"moq",value:data.moq,index:index,label:"Moq ",onChange:_this2.props.updateMoqSupplierSectionHandler,disabled:disabled// disabled={true}
}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"specialComments",value:data.specialComments,index:index,label:"Special Comments",onChange:_this2.props.updateValue,disabled:disabled}))));})));}}]);return FullPackage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FullPackage);FullPackage.propTypes={};FullPackage.defaultProps={};

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
var PrintDevelopmentFabric=function(_Component){_inherits(PrintDevelopmentFabric,_Component);function PrintDevelopmentFabric(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintDevelopmentFabric);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintDevelopmentFabric.__proto__||Object.getPrototypeOf(PrintDevelopmentFabric)).call.apply(_ref,[this].concat(args))),_this),_this.state={fabric:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintDevelopmentFabric,[{key:"componentWillMount",value:function componentWillMount(){this.setState({fabric:this.props.fabric});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.fabric!=this.props.fabric){this.setState({fabric:nextProps.fabric});}}},{key:"render",value:function render(){var fabric=this.state.fabric;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n              body{\n                  font-family: 'Montserrat', sans-serif;\n                  font-size:12px;\n              }\n              .fabricPrintDiv{\n                padding: 10px\n                border : 2px solid black;\n                top : 0;\n                bottom : 0;\n              }\n\n              .printrow {\n                display: flex;\n                flex-direction: row;\n                flex-wrap: wrap;\n                width: 100%;\n              }\n\n              .printcolumn {\n                display: flex;\n                flex-direction: column;\n                flex-basis: 100%;\n                flex: 1;\n              }\n              table>tbody>tr td{\n                  font-size:12px;\n              }\n              .label-text{\n                  color:#279588;\n                  font-size : 12px;\n                  font-weight:bold;\n              }\n              .blue{\n                  color : #146FF9;\n              }\n              .padding-for-heading{\n                padding: 5px;\n              }\n\n\n              .specialComments{\n                  width: 100%;\n                  border : 1px solid black;\n                  min-height : 60px;\n                  margin: 10px;\n                  padding: 10px!important;\n              }\n\n              .b{\n                  border: 1px solid black;\n                  margin: 10px;\n                  padding: 5px;\n              }\n              .fabric-text{\n                font-size:16px;\n                color: #279588;\n                font-weight: 1000;\n              }\n\n              .bold{\n                  font-weight:bold;\n              }\n              .bb-p{\n                border-bottom: 1px solid black;\n                margin-bottom: 10px ;\n              }\n              .w-50 {\n                  width: 50%;\n              }\n              table.grid{\n                border-collapse: collapse;\n                margin-right: 5px;\n                margin-left: 5px;\n              }\n              table.grid>tbody>tr td {\n                border: 0.5px solid black;\n                text-align: center;\n                padding: 2px;\n              }\n              .width-for-table{\n                  width: 50%;\n              }\n              .text-center{\n                text-align: center;\n              }\n              .p-1{\n                padding : 5px;\n              }\n              .pl-1{\n                padding-left: 23px;\n              }\n              .border-bot{\n                border-bottom : 1px solid black;\n              }\n              .mt{\n                margin-top:10px;\n              }\n              .mtl{\n                margin-top:30px;\n              }\n              .margin{\n                margin : 5px;\n              }\n              .pl-2{\n                padding: 5px;\n              }\n            }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 "},"MAGNUM CLOTHING PVT LTD - FABRIC DEVELOPMENT SHEET - FDS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow mtl pl-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabric-text pl-1 "},fabric&&fabric.fabricNumber||"F-00009"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"100px",height:"100px",src:__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].fileUrl()+fabric.fabricImage,alt:fabric.fabricImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,fabric.development&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DEV NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.devRefNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPPLIER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.supplierName!==null?fabric.supplierName.label:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"REQUIREMENT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.requirement!==null?fabric.requirement:""))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},fabric.development&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,fabric.development&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"REQUEST DATE "),fabric.development&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.requestDate!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(fabric.requestDate).format("DD MMM YYYY"):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MAGNUM ETA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.magnumETADate!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(fabric.magnumETADate).format("DD MMM YYYY"):"")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"GENERAL INFORMATION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"COUNT & CONSTRUCTION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-bot-dot"},fabric.count.warp+" * "+fabric.count.weft+" /\n                        "+fabric.construction.warp+" * "+fabric.construction.weft)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CLASSIFICATION OF FABRIC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.classificationOfFabric)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"QUALITY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null," ",fabric.quality)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"COMPOSITION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.composition)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"BUYER LIGHT SOURCE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.buyerPrimarySource," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GSM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.gsm," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.width," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"BASE NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.bNumber!==null?fabric.bNumber.label:""," "))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CUST DESIGN REF NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.custDefNo," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"COLOUR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.colorWay," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"ORIGINATION OF ARTWORK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.orginationOfArtwork!==null?fabric.orginationOfArtwork:""," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MAG CAD REF NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.magCadRefNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CUSTOMER - DEPT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.customer!==null?fabric.customer:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MAG STYLE NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.magnumStyleId!==null?fabric.magnumStyleId.label:""," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"ATTRIBUTES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.attribute!==null?fabric.attribute:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FILE TRANSFER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.fileTransfer!==null?fabric.fileTransfer:"")))))),fabric.yarnDyed!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow blue padding-for-heading"},"YARN DYED"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TYPE OF LOOM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DYE STUFF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"NO OF COLS ON WEFT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DESIGN REPEAT SIZE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WEAVE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FINISH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WASH")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.typeOfLoom!==null?fabric.yarnDyed.typeOfLoom:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.dyeStuff!==null?fabric.yarnDyed.dyeStuff:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.noOfColsWeft!==null?fabric.yarnDyed.noOfColsWeft:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.designRepeatSize!==null?fabric.yarnDyed.designRepeatSize:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.weave!==null?fabric.yarnDyed.weave:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.finish!==null?fabric.yarnDyed.finish:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.yarnDyed.wash!==null?fabric.yarnDyed.wash:""))))))),fabric.print!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"PRINT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRINT TYPE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRINT DIRECTION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRINT ROUTE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"NO OF COLS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"ROTARY REPEAT SIZE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"LAYER FILE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"ARTWORK WITH COL SQUARES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FLUROSCENT COLS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.printType!==null?fabric.print.printType:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.printDirection!==null?fabric.print.printDirection:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.printRoute!==null?fabric.print.printRoute:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.noOfColors!==null?fabric.print.noOfColors:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.rotaryRepeatSize!==null?fabric.print.rotaryRepeatSize:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.layerFile!==null?fabric.print.layerFile?"YES":"NO":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.artworkWithColSquare!==null?fabric.print.artworkWithColSquare?"YES":"NO":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.print.fluroscentCols!==null?fabric.print.fluroscentCols?"YES":"NO":""))))))),fabric.embroidery!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"EMBROIDERY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"BASE QUALITY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"THREAD QUALITY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MACHINE TYPE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DESIGN DESCRIPTION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"EMB TECHNIQUE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TARGET PRICE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"BACKING DETAILS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.fabricBase!==null?fabric.embroidery.fabricBase:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.threadQuality!==null?fabric.embroidery.threadQuality:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.machineType!==null?fabric.embroidery.machineType:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.designDescription!==null?fabric.embroidery.designDescription:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.embTechinique!==null?fabric.embroidery.embTechinique:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.targetRate!==null?fabric.embroidery.targetRate:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.backingDetails!==null?fabric.embroidery.backingDetails:"")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow mt"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"BACKING "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GRADING REQD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MARKER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SCALLOPING")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.backing!==null?fabric.embroidery.backing?"YES":"NO":""," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.gradingRequired!==null?fabric.embroidery.gradingRequired?"YES":"NO":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.marker!==null?fabric.embroidery.marker?"YES":"NO":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.embroidery.scalloping!==null?fabric.embroidery.scalloping?"YES":"NO":""))))))),fabric.solidGreige!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"GREIGE / DENIM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid width-for-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TYPE OF LOOM "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WEAVE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DESIGN")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.solidGreige.typeOfLoom!==null?fabric.solidGreige.typeOfLoom:""," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.solidGreige.weave!==null?fabric.solidGreige.weave:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,fabric.solidGreige.designDescription!==null?fabric.solidGreige.designDescription:""))))))),fabric.supplierSection!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"SUPPLIER SECTION"),fabric.supplierSection.fullPackageData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,fabric.supplierSection.fullPackageData&&fabric.supplierSection.fullPackageData.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,data.default&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"FULL PACKAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PURPOSE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPPLIER NAME"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPPLIER REF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"LT (DAYS)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRICE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"UNITS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TRANS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TOTAL COST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DEFAULT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.purposeLabel!==null?data.purposeLabel:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.date!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.date).format("MMM Do YYYY"):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.SupplierNameLabel!==null?data.SupplierNameLabel:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.supplierRef!==null?data.supplierRef:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.leadTime!==null?data.leadTime:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.width!==null?data.width:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currency!==null?data.currency==="rupee"?"₹":"$":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.price!==null?data.currency==="rupee"?"\u20B9"+data.price:"$"+data.price:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.MY!==null?data.MY:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.GST!==null&&data.currency==="rupee"?data.GST:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.transport!==null&&data.currency==="rupee"?data.transport:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.totalCost!==null?data.totalCost:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.default!==null?data.default?"YES":"NO":"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),data.currency==="dollar"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CONVERSION TO INR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SHIPMENT TERM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SHIPMENT MODE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PORT OF PICKUP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FREIGHT COSTS \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CLEARANCE \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DUTY %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TOTAL ORDER QUANTITY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GSM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WEIGHT - FABRIC/MTR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WEIGHT - FULL ORDER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FREIGHT RATE/KG"," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.conversionToINR!==null&&data.currencyData.conversionToINR!==undefined?data.currencyData.conversionToINR:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.shipmentTerm!==null&&data.currencyData.shipmentTerm!==undefined?data.currencyData.shipmentTerm:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.shipmentMode!==null&&data.currencyData.shipmentMode!==undefined?data.currencyData.shipmentMode:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.portOfPickup!==null&&data.currencyData.portOfPickup!==undefined?data.currencyData.portOfPickup:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.freightCosts!==null&&data.currencyData.freightCosts!==undefined?data.currencyData.freightCosts:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.clearance!==null&&data.currencyData.clearance!==undefined?data.currencyData.clearance:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.duty!==null&&data.currencyData.duty!==undefined?data.currencyData.duty:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.totalOrderQuantity!==null&&data.currencyData.totalOrderQuantity!==undefined?data.currencyData.totalOrderQuantity:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.width!==null&&data.currencyData.width!==undefined?data.currencyData.width:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.gsm!==null&&data.currencyData.gsm!==undefined?data.currencyData.gsm:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.weightOfFabricPerMtr!==null&&data.currencyData.weightOfFabricPerMtr!==undefined?data.currencyData.weightOfFabricPerMtr:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.weightForFullOrder!==null&&data.currencyData.weightForFullOrder!==undefined?data.currencyData.weightForFullOrder:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.currencyData&&data.currencyData.freightRatePerKg!==null&&data.currencyData.freightRatePerKg!==undefined?data.currencyData.freightRatePerKg:""))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"FULL PACKAGE - SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},data.specialComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);})))))));})),fabric.supplierSection.jobWorkData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,fabric.supplierSection&&fabric.supplierSection.jobWorkData&&fabric.supplierSection.jobWorkData.length>0&&fabric.supplierSection.jobWorkData.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,data.default&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"JOB WORK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"OPTION - ",data.purposeLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PROCESS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPPLIER NAME"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"LT (DAYS)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRICE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"VL%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"COST")),data.rowData.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,row.process.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.process),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.date!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(row.date).format("MMM Do YYYY"):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.SupplierNameLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.leadTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.width),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.currency==="dollar"?"$":"₹"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.vl),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.cost)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.GST,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.totalCost-data.transport)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Transport"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.transport),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.totalCost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MOQ - ",data.moq),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Total Lead Time - ",data.totalLeadTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Finished Width - ",data.finishedWidth),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Cuttable Width - ",data.cuttableWidth),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Total Cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.totalCost)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"JOB WORK - SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},data.specialComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);})))))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},fabric.specialComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"IMAGES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},fabric.refImages&&fabric.refImages.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"50px",height:"50px",src:__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].fileUrl()+data.path}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"imgsupplier",className:"printrow"})));}}]);return PrintDevelopmentFabric;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintDevelopmentFabric);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Field_CustomerDeptSelect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_picky_dist_picky_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Component
//components
// Include CSS
//Assets
var letters=function(){// object to expose as public properties and methods such as clock.now
var pub={};var letterArray=[];//letters.increment('a')
pub.increment=function(c){letterArray=c.split("");if(isLetters(letterArray)){localStorage.setItem("letter",next(c));return next(c);}else{throw new Error("Letters Only");}};function isLetters(arr){for(var i=0;i<arr.length;i++){if(arr[i].toLowerCase()!==arr[i].toUpperCase()){}else{return false;}}return true;}function next(c){var u=c.toUpperCase();if(same(u,"Z")){var txt="";var i=u.length;while(i--){txt+="A";}return txt+"A";}else{var p="";var q="";if(u.length>1){p=u.substring(0,u.length-1);q=String.fromCharCode(p.slice(-1).charCodeAt(0));}var l=u.slice(-1).charCodeAt(0);var z=nextLetter(l);if(z==="A"){return p.slice(0,-1)+nextLetter(q.slice(-1).charCodeAt(0))+z;}else{return p+z;}}}function nextLetter(l){if(l<90){return String.fromCharCode(l+1);}else{return"A";}}function same(str,char){var i=str.length;while(i--){if(str[i]!==char){return false;}}return true;}//API
return pub;}();var DevelopmentBNumber=function(_Component){_inherits(DevelopmentBNumber,_Component);function DevelopmentBNumber(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DevelopmentBNumber);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DevelopmentBNumber.__proto__||Object.getPrototypeOf(DevelopmentBNumber)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",qr:null,quality:"",GSM:"",imageForModal:"",styleId:"",fabricInfo:[],openModal:false,_id:"",bNumber:{dateOfSubmission:null,customer:null,customerDepartmentId:null,qr:"",baseRefNumber:"",refImages:[],magnumStyleId:null,fabric:null,// customer : null,
// department : null,
finishedWidth:"",reportStatus:null,failedText:"",bNumberRefernce:[],testingLab:null,typeOfWash:null,typeOfTest:[],slippageSeam:null},departmentName:"",customerName:"",styleOptions:[],bnumberOptions:{},fabricValues:{},styleValues:{},washValues:[],disabled:false,fabQuality:[],classificationOfFabrics:[],compositionFab:[]},_this.componentWillMount=function(){var action=void 0,_id=void 0;if(_this.props.location.state){action=_this.props.location.state.action;_id=_this.props.location.state._id;}else{var urlParams=new URLSearchParams(_this.props.location.search);action=urlParams.get("action");_id=urlParams.get("_id");_this.props.history.replace('/BNumber',{action:action,_id:_id,hash:false});}_this.setState({action:action,_id:_id});localStorage.setItem("letter","a");__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:response.text.data,customerId:response.text.data[0]._id,departmentId:response.text.data[0].departmentId});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});if(action==="add"){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].generateQRBNumber().then(function(response){if(response.status===200){var bNumber=Object.assign({},_this.state.bNumber);bNumber.qr=response.text.data.qr;bNumber.baseRefNumber=response.text.data.baseRefNumber;bNumber.dateOfSubmission=new Date();bNumber.bNumberRefernce.push({bNumberRef:bNumber.baseRefNumber,fabricId:null,greigeMill:null,processMill:null,linkToFabric:false});_this.setState({bNumber:bNumber});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{if(action==="view"){_this.setState({disabled:true});}if((action==="edit"||action==="view")&&_id!==""){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getBNumber(_id).then(function(res){if(res.status===200){var bNumber=Object.assign({},_this.state.bNumber);Object.keys(bNumber).forEach(function(key){if(res.text.data[key]!==undefined){bNumber[key]=res.text.data[key];}});if(res.text.data.fabric!==null){_this.getFabricById(res.text.data.fabric);}res.text.data.bNumberRefernce.map(function(data){if(data.fabricId!==null){_this.getFabricById(data.fabricId);}});_this.setState({bNumber:bNumber,fabricValues:res.text.data.fabricValues});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}}_this.getFabrics("");//List of styles
__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].SearchStyle().then(function(response){if(response.status===200){var styleOptions=[].concat(_toConsumableArray(_this.state.styleOptions));response.text.data.map(function(data){return styleOptions.push({value:data._id,label:data.styleNumber});});_this.setState({styleOptions:styleOptions});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});//Get BNumber Predefind values
__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getBNumberPrefilldData().then(function(response){if(response.status===200){_this.setState({bnumberOptions:response.text.data});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});//Get Fabric Prefilled Data
__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].prefillFabricDetails().then(function(response){if(response.message==="Operation Successful"){var fabQuality=[].concat(_toConsumableArray(_this.state.fabQuality));var classificationOfFabrics=[].concat(_toConsumableArray(_this.state.classificationOfFabrics));var compositionFab=[].concat(_toConsumableArray(_this.state.compositionFab));response.data.Fabric.BASICQUALITY.map(function(data){return fabQuality.push({value:data.value,label:data.label});});response.data.Fabric.CLASSIFICATIONOFFABRIC.map(function(data){return classificationOfFabrics.push({value:data.value,label:data.label});});response.data.Fabric.COMPOSITION.map(function(data){return compositionFab.push({value:data.value,label:data.label});});_this.setState({fabQuality:fabQuality,classificationOfFabrics:classificationOfFabrics,compositionFab:compositionFab});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.addBNumber=function(e){e.preventDefault();var bNumber=Object.assign({},_this.state.bNumber);if(_this.state.action=="edit"){bNumber._id=_this.state._id;}if(bNumber.fabric==null){_this.props.getalertMessage("error","Please fill mandatory fields");}else{// bNumber.fabric = bNumber.fabric ? bNumber.fabric.value : null;
if(bNumber.magnumStyleId!==null&&_typeof(bNumber.magnumStyleId)==="object")bNumber.magnumStyleId=bNumber.magnumStyleId.value;// bNumber.typeOfTest = bNumber.typeOfTest ? bNumber.typeOfTest.value : null;
bNumber.bNumberRefernce=_this.state.bNumber.bNumberRefernce.map(function(data){data.fabricId=data.fabricId!==null?_typeof(data.fabricId)==="object"&&data.fabricId.value||data.fabricId:data.fabricId;data.greigeMill=data.greigeMill!==null?_typeof(data.greigeMill)==='object'&&data.greigeMill.value||data.greigeMill:data.greigeMill;data.processMill=data.processMill!==null?_typeof(data.processMill)==="object"&&data.processMill.value||data.processMill:data.processMill;data.linkToFabric=data.linkToFabric;return data;});__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].createBNum(bNumber).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);if(response.text.data){_this.setState({_id:response.text.data._id,bNumber:Object.assign({},_this.state.bNumber,{_id:response.text.data._id})});}// this.props.history.push("/list", { moduleName: "BNUMBER" });
}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.getFabrics=function(value){if(value!==null){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){//  let fabricInfo = [...this.state.fabricInfo]
//  if(fabricInfo.length > 0){
//    response.text.data.map((data) =>{
//    fabricInfo.map((fabric) =>{
//     if(fabric.value !== data.value){
//       fabricInfo.push({...data})
//     }
//    })
//  })}
//  else{
//  fabricInfo = [...this.state.fabricInfo,...response.text.data]
//  }
_this.setState({fabricInfo:[].concat(_toConsumableArray(response.text.data))});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.getFabricById=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getFabricbyId(value).then(function(response){if(response.status==200){var fabricInfo=[].concat(_toConsumableArray(_this.state.fabricInfo));fabricInfo.push(Object.assign({},response.text.data));_this.setState({fabricInfo:fabricInfo});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].SearchStyle(value).then(function(response){if(response.status==200){var jsonData=[];response.text.data.map(function(info){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this.setState({styleOptions:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getTypeBStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getBNumberPrefilldData(value).then(function(response){if(response.status==200){var jsonData=[];response.data.map(function(info){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this.setState({bnumberOptions:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getGreigeBStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getBNumberPrefilldData(value).then(function(response){if(response.status==200){var jsonData=[];response.text.data.map(function(info){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this.setState({bnumberOptions:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getProcessBStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getBNumberPrefilldData(value).then(function(response){if(response.status==200){var jsonData=[];response.text.data.map(function(info){var objData={};objData.label=info.styleNumber;objData.value=info._id;jsonData.push(objData);});_this.setState({bnumberOptions:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getBuyer=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.message==="all customer details"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.customerName;objData.value=info._id;jsonData.push(objData);});_this.setState({customerInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getDepartment=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.message==="all customer details"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.departmentName;objData.value=info.departmentId;jsonData.push(objData);});_this.setState({departmentInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getSupplier=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["l" /* SystemServices */].listSystemSupplier().then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.supplierName;objData.value=info._id;jsonData.push(objData);});_this.setState({supplierInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getWashType=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getPrefillInfoForBN().then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.Style.LAUNDRYTYPE.map(function(info,index){var objData={};objData.label=info.name;objData.value=info._id;jsonData.push(objData);});_this.setState({washTypeInfo:jsonData},function(){});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getgarmentType=function(e){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getPrefillInfoForBN().then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.Style.GARMENTTYPE.map(function(info,index){var objData={};objData.label=info.name;objData.value=info._id;jsonData.push(objData);});_this.setState({garmentInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeStyleNo=function(style){var bNumber=Object.assign({},_this.state.bNumber);if(style!==null){__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getStyleInfo(style.value).then(function(response){if(response.status===200){bNumber.magnumStyleId=style.value;bNumber.customer=response.text.data.customer;bNumber.customerDepartmentId=response.text.data.customerDepartmentId;_this.setState({bNumber:bNumber});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{bNumber.magnumStyleId=null;bNumber.customer=null;bNumber.customerDepartmentId=null;_this.setState({bNumber:bNumber});}},_this.changetypeOfTest=function(typeOfTest){var bNumber=Object.assign({},_this.state.bNumber);bNumber.typeOfTest=typeOfTest;_this.setState({bNumber:bNumber});//console.log(bNumber.typeOfTest, "bNumber")
},_this.changeGreige=function(greigemill){_this.setState({greigemill:greigemill});},_this.changeProcess=function(processmill){_this.setState({processmill:processmill});},_this.changeFabric=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fabric){var bNumber;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:bNumber=Object.assign({},_this.state.bNumber);if(!(fabric!==null)){_context.next=8;break;}_context.next=4;return _this.getFabricById(fabric.value);case 4:_context.next=6;return __WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getSpecificFabric(fabric.value).then(function(response){if(response.status==200){bNumber.fabric=fabric.value;bNumber.bNumberRefernce.length>0&&(bNumber.bNumberRefernce[0].fabricId=fabric.value);_this.setState({fabricValues:response.text.data,bNumber:bNumber});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});case 6:_context.next=11;break;case 8:bNumber.fabric=null;_context.next=11;return _this.setState({bNumber:bNumber,fabricValues:{}});case 11:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.changeWashType=function(washType){_this.setState({washType:washType});},_this.changeGarmentType=function(garmentType){_this.setState({garmentType:garmentType});},_this.changeBuyer=function(buyer){_this.setState({buyer:buyer});},_this.changeDepartment=function(department){_this.setState({department:department});},_this.changeSupplier=function(supplier){_this.setState({supplier:supplier});},_this.__handleChange=function(name,value,index){var bNumber=Object.assign({},_this.state.bNumber);bNumber.bNumberRefernce[index][name]=value;_this.setState({bNumber:bNumber});localStorage.setItem("letter","a");},_this.increasebNumberRefernce=function(){var bNumber=Object.assign({},_this.state.bNumber);var item={bNumberRef:bNumber.baseRefNumber,fabricId:null,greigeMill:null,processMill:null,linkToFabric:false};bNumber.bNumberRefernce=[].concat(_toConsumableArray(bNumber.bNumberRefernce),[item]);_this.setState({bNumber:bNumber});localStorage.setItem("letter","a");},_this.decreasebNumberRefernce=function(index){var bNumber=Object.assign({},_this.state.bNumber);localStorage.setItem("letter","a");bNumber.bNumberRefernce.splice(index,1);_this.setState({bNumber:bNumber});},_this.updateLinkValue=function(name,value,index){var bNumber=Object.assign({},_this.state.bNumber);bNumber.bNumberRefernce[index][name]=value;_this.setState({bNumber:bNumber});},_this.addReportStatus=function(e){var bNumber=Object.assign({},_this.state.bNumber);bNumber.reportStatus=e.target.value=="failed"?false:true;_this.setState({bNumber:bNumber});},_this.imageUpload=function(e){_this.setState({images:_this.state.images.concat(e.target.files[0])},function(){var a=[];this.state.images.map(function(image,index){var b={};b=image;b.imageName="Sketch"+ ++index;b.imageDescription="";a.push(b);});this.setState({images:a});});},_this.imageInfo=function(image,index){_this.setState({imageInfo:image,imageIndex:index});},_this.uploadNewImage=function(e){var b={};b=e.target.files[0];b.imageName=_this.state.imageInfo.imageName;b.imageDescription=_this.state.imageInfo.imageDescription;_this.setState({uploadNewImage:b});},_this.updateImage=function(){_this.state.images.map(function(image,index){if(index===_this.state.imageIndex){_this.state.images[index]=_this.state.uploadNewImage!==""?_this.state.uploadNewImage:_this.state.imageInfo;}});},_this.changeImageName=function(value){var a=_this.state.imageInfo;a.imageName=value;_this.setState({imageInfo:a});},_this.changeImageDescription=function(value){var a=_this.state.imageInfo;a.imageDescription=value;_this.setState({imageInfo:a});},_this.removeImage=function(image,indexVal){var a=_this.state.images;a.splice(indexVal,1);_this.setState({images:a});},_this.getRefImages=function(refImages){var bNumber=Object.assign({},_this.state.bNumber);bNumber.refImages=refImages;_this.setState({bNumber:bNumber});},_this.updateValue=function(name,value){var bNumber=Object.assign({},_this.state.bNumber);if(!Array.isArray(value)){value=[value];}bNumber[name]=value;_this.setState({bNumber:bNumber});},_this._handleCustDeptChange=function(index,customer,customerDepartmentId){var bNumber=Object.assign({},_this.state.bNumber);bNumber.customer=customer;bNumber.customerDepartmentId=customerDepartmentId;_this.setState({bNumber:bNumber});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DevelopmentBNumber,[{key:"componentDidMount",value:function componentDidMount(){if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentDidUpdate",value:function componentDidUpdate(){localStorage.setItem("letter","a");}//Jayaprakash E
},{key:"render",value:function render(){var _this3=this;var _state=this.state,bNumber=_state.bNumber,failed=_state.failed,styleOptions=_state.styleOptions,bnumberOptions=_state.bnumberOptions,fabricInfo=_state.fabricInfo,fabricValues=_state.fabricValues,styleValues=_state.styleValues,fabQuality=_state.fabQuality,classificationOfFabrics=_state.classificationOfFabrics,compositionFab=_state.compositionFab;//console.log(bnumberOptions, "bnumberOptions")
//console.log(bNumber.typeOfTest, "bNumber")
if(Object.keys(bnumberOptions).length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section  remove-scroll-for-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{id:"first"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 product-form nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"no-padding  left-content-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col text-center bg-color padding-bottom-bg"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"text-green font-lg font-weight-bold mt-2"},this.state.bNumber.baseRefNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"img-responsive-fill border-1 inputWrapper mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:this.state.bNumber.qr})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"product-form overflow-scroll right-content-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"B number"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-5 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list mb-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Submission Date"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"dateOfSubmission",value:bNumber.dateOfSubmission,onChange:this.updateValue,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Fabric",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{"class":"text-danger madatory-asterisk"},"*")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{value:this.state.bNumber.fabric,onInputChange:this.getFabrics,onChange:this.changeFabric,placeholder:"Search Fabric",options:fabricInfo,onSelectResetsInput:false,disabled:this.state.disabled,onBlurResetsInput:false}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Count & Construction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",name:"countConstruction",value:Object.keys(fabricValues).length>0?fabricValues.count.warp+"*"+fabricValues.count.weft+"/"+fabricValues.construction.warp+"*"+fabricValues.construction.weft:"",readOnly:true})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Classification of fabric"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"cofabric",value:fabricValues.classificationOfFabric,readOnly:true,disabled:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"Select"),classificationOfFabrics.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Quality"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"fabquality",value:fabricValues.quality,readOnly:true,disabled:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),fabQuality.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Composition"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"composition",value:fabricValues.composition,readOnly:true,disabled:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),compositionFab.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"GSM/OZ"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"gsm",readOnly:true,className:"form-control",value:fabricValues.gsm&&fabricValues.width?fabricValues.gsm+"/"+fabricValues.width:""})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Finished Width"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"fabquality",className:"form-control",onChange:function onChange(e){return _this3.updateValue("finishedWidth",e.target.value);},value:this.state.bNumber.finishedWidth,disabled:this.state.disabled}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-5 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ib-list-view listFieldWrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Style"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{value:this.state.bNumber.magnumStyleId,onInputChange:this.getMagnumStyleNo,name:'magnumStyleId',onChange:this.changeStyleNo,placeholder:"Select Style",options:styleOptions,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Field_CustomerDeptSelect__["a" /* default */],{options:this.state.customerList,value:this.state.bNumber.customer+"-"+this.state.bNumber.customerDepartmentId,onChange:this._handleCustDeptChange,disabled:this.state.disabled,pageName:"bNumber",notMandate:"true"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Types of test"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_picky___default.a,{value:this.state.bNumber.typeOfTest,options:bnumberOptions.TYPESOFTEST,onChange:function onChange(val){return _this3.updateValue("typeOfTest",val);},className:"picky-custom-width",open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Testing Lab"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"testingLab",onChange:function onChange(e){return _this3.updateValue("testingLab",e.target.value);},value:this.state.bNumber.testingLab,disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),bnumberOptions.TESTINGLAB.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Slippage Seam"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"slippageSeam",onChange:function onChange(e){return _this3.updateValue("slippageSeam",e.target.value);},value:this.state.bNumber.slippageSeam,disabled:this.state.disabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),bnumberOptions.SLIPPAGESEAM.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Type of Wash"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"quality",value:this.state.bNumber.typeOfWash,disabled:this.state.disabled,onChange:function onChange(e){return _this3.updateValue("typeOfWash",e.target.value);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"style"},"Select"),bnumberOptions.TYPEOFWASH.map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:value.value},value.label);}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"},"Report Status"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"form-control select-height customized-height-inputform",name:"classificationOfFabric",onChange:function onChange(e){return _this3.addReportStatus(e);},disabled:this.state.disabled,value:this.state.bNumber.reportStatus===null?"":this.state.bNumber.reportStatus?"success":"failed"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"Select"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"success"},"Success"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"failed"},"Failed"))))),!this.state.bNumber.reportStatus&&this.state.bNumber.reportStatus!==null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"text-right pt-2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"font-apply-li"},"if failed :"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{className:"form-control",rows:"2",cols:"50",name:"failed",disabled:this.state.disabled,onChange:function onChange(e){return _this3.updateValue("failedText",e.target.value);},value:bNumber.failedText})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"table table-borderless btable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"20%",className:"font-apply-li"},"B number"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"20%",className:"font-apply-li"},"Fabric Number"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"20%",className:"font-apply-li"},"Greige Mill"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"20%",className:"font-apply-li"},"Process Mill"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"5%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:this.increasebNumberRefernce}))),this.state.bNumber.bNumberRefernce.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"form-inline"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",readOnly:true,name:"bnumber","class":"form-control col-8",value:value.bNumberRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"px-2 font-apply-li"},index===0?String.fromCharCode(65+index):letters.increment(localStorage.getItem("letter"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"fabricNumber",value:value.fabricId,onInputChange:_this3.getFabrics,onChange:function onChange(data){return _this3.__handleChange("fabricId",data,index);},placeholder:"Search Fabric",options:fabricInfo,disabled:_this3.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"input-group-append"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{"class":"input-group-text p-1 font-apply-li"},localStorage.getItem("letter"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"greigeMill",value:value.greigeMill// onInputChange={
//   this.getGreigeBStyleNo
// }
,onChange:function onChange(data){return _this3.__handleChange("greigeMill",data,index);},placeholder:"Select Greige Mill",options:bnumberOptions.GREIGEMILL,disabled:_this3.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"input-group-append"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{"class":"input-group-text p-1 font-apply-li"},localStorage.getItem("letter"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"processMill",value:value.processMill// onInputChange={
//   this.getProcessBStyleNo
// }
,onChange:function onChange(data){return _this3.__handleChange("processMill",data,index);},placeholder:"Select Process Mill",options:bnumberOptions.PROCESSMILL,disabled:_this3.state.disabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,!_this3.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(){return _this3.decreasebNumberRefernce(index);}})));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 col step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"bnumber",getRefImages:this.getRefImages,disabled:this.state.disabled,uploadedDocs:this.state.action==="edit"||this.state.action==="view"?this.state.bNumber.refImages:null})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center p-2 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.addBNumber}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"Cancel",history:this.props.history})))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this3.setState({openModal:false});},s:true,center:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:this.state.imageForModal!==""&&window.URL.createObjectURL(this.state.imageForModal),style:{width:"100%"}})));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__["a" /* default */],null);}}}]);return DevelopmentBNumber;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DevelopmentBNumber);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_common_rights__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import productPic from '../../assets/images/no-product-image.png';
// import cloth from '../../assets/images/cloth/1.jpg';
//components
var EmployeRights=function(_Component){_inherits(EmployeRights,_Component);function EmployeRights(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,EmployeRights);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EmployeRights.__proto__||Object.getPrototypeOf(EmployeRights)).call.apply(_ref,[this].concat(args))),_this),_this.state={moduleName:"",_id:"",name:"",allCheckBox:false,rights:__WEBPACK_IMPORTED_MODULE_10__services_common_rights__["a" /* default */],isLoading:false},_this.componentWillMount=function(){var _this$props$location$=_this.props.location.state,moduleName=_this$props$location$.moduleName,_id=_this$props$location$._id;_this.setState({moduleName:moduleName,_id:_id});},_this.onPageChange=function(path){if(path.split(".").indexOf("create")!==-1){var path1=path.split(".");var path2=path.split(".");var path3=path1.splice(path.split(".").indexOf("create"),1,"view");var path4=path2.splice(path.split(".").indexOf("create"),1,"edit");var viewChecked=document.getElementById(path1.join(".")).checked;var editChecked=document.getElementById(path2.join(".")).checked;var neededArray=!viewChecked&&!editChecked?[path,path1.join("."),path2.join(".")]:!viewChecked?[path,path1.join(".")]:!editChecked?[path,path2.join(".")]:[path];_this.selectRights(neededArray);}else if(path.split(".").indexOf("edit")!==-1){// let path1 = path.split('.');
// let path2 = path1.splice(path.split('.').indexOf('create'),1,"view");
// // let a = document.getElementById(path1.join('.')).checked;
// let neededArray = (!document.getElementById(path).checked) ? [path] : [path,path1.join('.')]
// this.selectRights(neededArray)
var _neededArray=[path];_this.selectRights(_neededArray);}else if(path.split(".").indexOf("view")!==-1){var _neededArray2=[path];_this.selectRights(_neededArray2);}else if(path.split(".").indexOf("delete")!==-1){var _neededArray3=[path];_this.selectRights(_neededArray3);}},_this.selectRights=function(array){var rights=_this.state.rights;array.map(function(data,i){__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(rights,data,!__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(rights,data));_this.setState({rights:rights});});},_this.selectAllCheckBox=function(){var rights=__WEBPACK_IMPORTED_MODULE_10__services_common_rights__["a" /* default */];for(var i=0;i<Object.keys(rights).length;i++){var neededObj=rights[Object.keys(rights)[i]];if(Object.keys(rights)[i]==="fabric"||Object.keys(rights)[i]==="trim"||Object.keys(rights)[i]==="product"||Object.keys(rights)[i]==="createIb"||Object.keys(rights)[i]==="sampleRequest"||Object.keys(rights)[i]==="permissions"||Object.keys(rights)[i]==="reports"||Object.keys(rights)[i]==="customer"){for(var j=0;j<Object.keys(neededObj).length;j++){var filteredObj=_this.changeValue(neededObj[Object.keys(neededObj)[j]]);neededObj[Object.keys(neededObj)[j]]=filteredObj;rights[Object.keys(rights)[i]]=neededObj;}}else{var _filteredObj=_this.changeValue(neededObj);rights[Object.keys(rights)[i]]=_filteredObj;}_this.setState({rights:rights});}},_this.changeValue=function(filteredObj){filteredObj.web={create:_this.state.allCheckBox,view:_this.state.allCheckBox,edit:_this.state.allCheckBox,delete:_this.state.allCheckBox};filteredObj.mobile={create:_this.state.allCheckBox,view:_this.state.allCheckBox,edit:_this.state.allCheckBox,delete:_this.state.allCheckBox};return filteredObj;},_this.renderCheckbox=function(path){var rights=_this.state.rights;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:path},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:path,"class":"filled-in",checked:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(rights,path),onChange:function onChange(){return _this.onPageChange(path);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":path})));},_this.UpdateRoleRights=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var rights,obj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.setState({isLoading:true});case 2:rights=_this.state.rights;obj={_id:_this.state._id,moduleName:_this.state.moduleName};if(_this.state.moduleName=="EMPLOYEE"){obj.userBasedRole=rights;}else{obj.rights=rights;}_context.next=7;return __WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].updateRights(obj).then(function(response){if(response.status==200){// let rights = this.state.moduleName == 'EMPLOYEE' ? obj.userBasedRole : obj.rights
if(_this.state.moduleName=="EMPLOYEE"){if(_this.state._id===_this.props._id)_this.props.actions.updateRights(rights);}_this.props.getalertMessage("success",response.text.message);}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});case 7:_context.next=9;return _this.setState({isLoading:false});case 9:case"end":return _context.stop();}}},_callee,_this2);})),_this.getRoleRights=function(_id){__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].getRoleRights(_id).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(response.status===200)){_context2.next=13;break;}if(!(response.text.data.rights!==undefined&&response.text.data.rights!==null&&Object.keys(response.text.data.rights).length>0)){_context2.next=12;break;}_context2.t0=_this;_context2.t1=Object;_context2.t2={};_context2.t3=_this.state.rights;_context2.next=8;return response.text.data.rights;case 8:_context2.t4=_context2.sent;_context2.t5=_context2.t1.assign.call(_context2.t1,_context2.t2,_context2.t3,_context2.t4);_context2.t6={rights:_context2.t5};_context2.t0.setState.call(_context2.t0,_context2.t6);case 12:_this.setState({name:response.text.data.roleName});case 13:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getEmployeeRights=function(_id){__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].getEmployeeRights(_id).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(response.status===200)){_context3.next=9;break;}if(!(response.text.data.userBasedRole!==undefined&&response.text.data.userBasedRole!==null&&Object.keys(response.text.data.userBasedRole).length>0)){_context3.next=8;break;}_context3.t0=_this;_context3.next=5;return response.text.data.userBasedRole;case 5:_context3.t1=_context3.sent;_context3.t2={rights:_context3.t1};_context3.t0.setState.call(_context3.t0,_context3.t2);case 8:_this.setState({name:response.text.data.empName});case 9:case"end":return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EmployeRights,[{key:"componentDidMount",value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.setState({isLoading:true});case 2:if(!(this.props.location.state.moduleName=="ROLE")){_context4.next=5;break;}_context4.next=5;return this.getRoleRights(this.props.location.state._id);case 5:if(!(this.props.location.state.moduleName=="EMPLOYEE")){_context4.next=8;break;}_context4.next=8;return this.getEmployeeRights(this.props.location.state._id);case 8:_context4.next=10;return this.setState({isLoading:false});case 10:case"end":return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref5.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this3=this;var rights=this.state.rights;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(e){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_9__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,"Permissions")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"check-rights"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{"class":"manage_permissions",onChange:function onChange(){return _this3.setState({allCheckBox:!_this3.state.allCheckBox},function(){return _this3.selectAllCheckBox(_this3.state.allCheckBox);});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox","class":"filled-in",id:"check-all"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"check-all",style:{fontSize:"12px",color:"#424242",fontWeight:"lighter"}},"Check All Rights"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,this.state.moduleName.charAt(0).toUpperCase()+this.state.moduleName.substr(1).toLowerCase()," ","Name"," "),":",this.state.name)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 fixed-height-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{"class":"striped manage_permissions white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{"class":"permission_head"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"module",className:"position-top-stick"},"Modules"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"data-field":"submodules",className:"position-top-stick"},"Sub Modules"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{"date-field":"divisions",className:"position-top-stick"},"Divisions"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colspan:"4","data-field":"web",className:"position-top-stick"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"th-flex"},"Web"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"th-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Create"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"View"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Edit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Delete"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colspan:"4","data-field":"Mobile",className:"position-top-stick"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"th-flex"},"Mobile (Android & iOS)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"th-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Create"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"View"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Edit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Delete"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Dashboard"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("dashboard.web.create"),this.renderCheckbox("dashboard.web.view"),this.renderCheckbox("dashboard.web.edit"),this.renderCheckbox("dashboard.web.delete"),this.renderCheckbox("dashboard.mobile.create"),this.renderCheckbox("dashboard.mobile.view"),this.renderCheckbox("dashboard.mobile.edit"),this.renderCheckbox("dashboard.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Meeting Notes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("meetingNotes.web.create"),this.renderCheckbox("meetingNotes.web.view"),this.renderCheckbox("meetingNotes.web.edit"),this.renderCheckbox("meetingNotes.web.delete"),this.renderCheckbox("meetingNotes.mobile.create"),this.renderCheckbox("meetingNotes.mobile.view"),this.renderCheckbox("meetingNotes.mobile.edit"),this.renderCheckbox("meetingNotes.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Communication"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"-")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"24"},"Development"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"3D"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("cad.web.create"),this.renderCheckbox("cad.web.view"),this.renderCheckbox("cad.web.edit"),this.renderCheckbox("cad.web.delete"),this.renderCheckbox("cad.mobile.create"),this.renderCheckbox("cad.mobile.view"),this.renderCheckbox("cad.mobile.edit"),this.renderCheckbox("cad.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"6"},"Fabric"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Fabric"),this.renderCheckbox("fabric.fabric.web.create"),this.renderCheckbox("fabric.fabric.web.view"),this.renderCheckbox("fabric.fabric.web.edit"),this.renderCheckbox("fabric.fabric.web.delete"),this.renderCheckbox("fabric.fabric.mobile.create"),this.renderCheckbox("fabric.fabric.mobile.view"),this.renderCheckbox("fabric.fabric.mobile.edit"),this.renderCheckbox("fabric.fabric.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Yarn Dyed"),this.renderCheckbox("fabric.yarnDyed.web.create"),this.renderCheckbox("fabric.yarnDyed.web.view"),this.renderCheckbox("fabric.yarnDyed.web.edit"),this.renderCheckbox("fabric.yarnDyed.web.delete"),this.renderCheckbox("fabric.yarnDyed.mobile.create"),this.renderCheckbox("fabric.yarnDyed.mobile.view"),this.renderCheckbox("fabric.yarnDyed.mobile.edit"),this.renderCheckbox("fabric.yarnDyed.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embroidery"),this.renderCheckbox("fabric.embroidery.web.create"),this.renderCheckbox("fabric.embroidery.web.view"),this.renderCheckbox("fabric.embroidery.web.edit"),this.renderCheckbox("fabric.embroidery.web.delete"),this.renderCheckbox("fabric.embroidery.mobile.create"),this.renderCheckbox("fabric.embroidery.mobile.view"),this.renderCheckbox("fabric.embroidery.mobile.edit"),this.renderCheckbox("fabric.embroidery.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Print"),this.renderCheckbox("fabric.print.web.create"),this.renderCheckbox("fabric.print.web.view"),this.renderCheckbox("fabric.print.web.edit"),this.renderCheckbox("fabric.print.web.delete"),this.renderCheckbox("fabric.print.mobile.create"),this.renderCheckbox("fabric.print.mobile.view"),this.renderCheckbox("fabric.print.mobile.edit"),this.renderCheckbox("fabric.print.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Solid/Greige"),this.renderCheckbox("fabric.solidGreige.web.create"),this.renderCheckbox("fabric.solidGreige.web.view"),this.renderCheckbox("fabric.solidGreige.web.edit"),this.renderCheckbox("fabric.solidGreige.web.delete"),this.renderCheckbox("fabric.solidGreige.mobile.create"),this.renderCheckbox("fabric.solidGreige.mobile.view"),this.renderCheckbox("fabric.solidGreige.mobile.edit"),this.renderCheckbox("fabric.solidGreige.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Supplier"),this.renderCheckbox("fabric.supplier.web.create"),this.renderCheckbox("fabric.supplier.web.view"),this.renderCheckbox("fabric.supplier.web.edit"),this.renderCheckbox("fabric.supplier.web.delete"),this.renderCheckbox("fabric.supplier.mobile.create"),this.renderCheckbox("fabric.supplier.mobile.view"),this.renderCheckbox("fabric.supplier.mobile.edit"),this.renderCheckbox("fabric.supplier.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"B Number"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("bNumber.web.create"),this.renderCheckbox("bNumber.web.view"),this.renderCheckbox("bNumber.web.edit"),this.renderCheckbox("bNumber.web.delete"),this.renderCheckbox("bNumber.mobile.create"),this.renderCheckbox("bNumber.mobile.view"),this.renderCheckbox("bNumber.mobile.edit"),this.renderCheckbox("bNumber.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Bulk Import"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("bulkImport.web.create"),this.renderCheckbox("bulkImport.web.view"),this.renderCheckbox("bulkImport.web.edit"),this.renderCheckbox("bulkImport.web.delete"),this.renderCheckbox("bulkImport.mobile.create"),this.renderCheckbox("bulkImport.mobile.view"),this.renderCheckbox("bulkImport.mobile.edit"),this.renderCheckbox("bulkImport.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Print Fabric Number"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("printFabricNumber.web.create"),this.renderCheckbox("printFabricNumber.web.view"),this.renderCheckbox("printFabricNumber.web.edit"),this.renderCheckbox("printFabricNumber.web.delete"),this.renderCheckbox("printFabricNumber.mobile.create"),this.renderCheckbox("printFabricNumber.mobile.view"),this.renderCheckbox("printFabricNumber.mobile.edit"),this.renderCheckbox("printFabricNumber.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"2",className:"text-center"},"Trim"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Tirm"),this.renderCheckbox("trim.trim.web.create"),this.renderCheckbox("trim.trim.web.view"),this.renderCheckbox("trim.trim.web.edit"),this.renderCheckbox("trim.trim.web.delete"),this.renderCheckbox("trim.trim.mobile.create"),this.renderCheckbox("trim.trim.mobile.view"),this.renderCheckbox("trim.trim.mobile.edit"),this.renderCheckbox("trim.trim.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Supplier"),this.renderCheckbox("trim.supplier.web.create"),this.renderCheckbox("trim.supplier.web.view"),this.renderCheckbox("trim.supplier.web.edit"),this.renderCheckbox("trim.supplier.web.delete"),this.renderCheckbox("trim.supplier.mobile.create"),this.renderCheckbox("trim.supplier.mobile.view"),this.renderCheckbox("trim.supplier.mobile.edit"),this.renderCheckbox("trim.supplier.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Sourcing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("sourcing.web.create"),this.renderCheckbox("sourcing.web.view"),this.renderCheckbox("sourcing.web.edit"),this.renderCheckbox("sourcing.web.delete"),this.renderCheckbox("sourcing.mobile.create"),this.renderCheckbox("sourcing.mobile.view"),this.renderCheckbox("sourcing.mobile.edit"),this.renderCheckbox("sourcing.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"11"},"Product"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Product"),this.renderCheckbox("product.product.web.create"),this.renderCheckbox("product.product.web.view"),this.renderCheckbox("product.product.web.edit"),this.renderCheckbox("product.product.web.delete"),this.renderCheckbox("product.product.mobile.create"),this.renderCheckbox("product.product.mobile.view"),this.renderCheckbox("product.product.mobile.edit"),this.renderCheckbox("product.product.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample"),this.renderCheckbox("product.sample.web.create"),this.renderCheckbox("product.sample.web.view"),this.renderCheckbox("product.sample.web.edit"),this.renderCheckbox("product.sample.web.delete"),this.renderCheckbox("product.sample.mobile.create"),this.renderCheckbox("product.sample.mobile.view"),this.renderCheckbox("product.sample.mobile.edit"),this.renderCheckbox("product.sample.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Pattern"),this.renderCheckbox("product.pattern.web.create"),this.renderCheckbox("product.pattern.web.view"),this.renderCheckbox("product.pattern.web.edit"),this.renderCheckbox("product.pattern.web.delete"),this.renderCheckbox("product.pattern.mobile.create"),this.renderCheckbox("product.pattern.mobile.view"),this.renderCheckbox("product.pattern.mobile.edit"),this.renderCheckbox("product.pattern.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Garment Tech"),this.renderCheckbox("product.garmentTech.web.create"),this.renderCheckbox("product.garmentTech.web.view"),this.renderCheckbox("product.garmentTech.web.edit"),this.renderCheckbox("product.garmentTech.web.delete"),this.renderCheckbox("product.garmentTech.mobile.create"),this.renderCheckbox("product.garmentTech.mobile.view"),this.renderCheckbox("product.garmentTech.mobile.edit"),this.renderCheckbox("product.garmentTech.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric"),this.renderCheckbox("product.fabric.web.create"),this.renderCheckbox("product.fabric.web.view"),this.renderCheckbox("product.fabric.web.edit"),this.renderCheckbox("product.fabric.web.delete"),this.renderCheckbox("product.fabric.mobile.create"),this.renderCheckbox("product.fabric.mobile.view"),this.renderCheckbox("product.fabric.mobile.edit"),this.renderCheckbox("product.fabric.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Trim"),this.renderCheckbox("product.trim.web.create"),this.renderCheckbox("product.trim.web.view"),this.renderCheckbox("product.trim.web.edit"),this.renderCheckbox("product.trim.web.delete"),this.renderCheckbox("product.trim.mobile.create"),this.renderCheckbox("product.trim.mobile.view"),this.renderCheckbox("product.trim.mobile.edit"),this.renderCheckbox("product.trim.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embellishment"),this.renderCheckbox("product.embellishment.web.create"),this.renderCheckbox("product.embellishment.web.view"),this.renderCheckbox("product.embellishment.web.edit"),this.renderCheckbox("product.embellishment.web.delete"),this.renderCheckbox("product.embellishment.mobile.create"),this.renderCheckbox("product.embellishment.mobile.view"),this.renderCheckbox("product.embellishment.mobile.edit"),this.renderCheckbox("product.embellishment.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Cutting"),this.renderCheckbox("product.cutting.web.create"),this.renderCheckbox("product.cutting.web.view"),this.renderCheckbox("product.cutting.web.edit"),this.renderCheckbox("product.cutting.web.delete"),this.renderCheckbox("product.cutting.mobile.create"),this.renderCheckbox("product.cutting.mobile.view"),this.renderCheckbox("product.cutting.mobile.edit"),this.renderCheckbox("product.cutting.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sewing"),this.renderCheckbox("product.sewing.web.create"),this.renderCheckbox("product.sewing.web.view"),this.renderCheckbox("product.sewing.web.edit"),this.renderCheckbox("product.sewing.web.delete"),this.renderCheckbox("product.sewing.mobile.create"),this.renderCheckbox("product.sewing.mobile.view"),this.renderCheckbox("product.sewing.mobile.edit"),this.renderCheckbox("product.sewing.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Dispatch"),this.renderCheckbox("product.dispatch.web.create"),this.renderCheckbox("product.dispatch.web.view"),this.renderCheckbox("product.dispatch.web.edit"),this.renderCheckbox("product.dispatch.web.delete"),this.renderCheckbox("product.dispatch.mobile.create"),this.renderCheckbox("product.dispatch.mobile.view"),this.renderCheckbox("product.dispatch.mobile.edit"),this.renderCheckbox("product.dispatch.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sign off"),this.renderCheckbox("product.signOff.web.create"),this.renderCheckbox("product.signOff.web.view"),this.renderCheckbox("product.signOff.web.edit"),this.renderCheckbox("product.signOff.web.delete"),this.renderCheckbox("product.signOff.mobile.create"),this.renderCheckbox("product.signOff.mobile.view"),this.renderCheckbox("product.signOff.mobile.edit"),this.renderCheckbox("product.signOff.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"12"},"Style"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Style"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("style.web.create"),this.renderCheckbox("style.web.view"),this.renderCheckbox("style.web.edit"),this.renderCheckbox("style.web.delete"),this.renderCheckbox("style.mobile.create"),this.renderCheckbox("style.mobile.view"),this.renderCheckbox("style.mobile.edit"),this.renderCheckbox("style.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"9"},"Create IB"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Create IB"),this.renderCheckbox("createIb.createIb.web.create"),this.renderCheckbox("createIb.createIb.web.view"),this.renderCheckbox("createIb.createIb.web.edit"),this.renderCheckbox("createIb.createIb.web.delete"),this.renderCheckbox("createIb.createIb.mobile.create"),this.renderCheckbox("createIb.createIb.mobile.view"),this.renderCheckbox("createIb.createIb.mobile.edit"),this.renderCheckbox("createIb.createIb.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Order details"),this.renderCheckbox("createIb.orderDetails.web.create"),this.renderCheckbox("createIb.orderDetails.web.view"),this.renderCheckbox("createIb.orderDetails.web.edit"),this.renderCheckbox("createIb.orderDetails.web.delete"),this.renderCheckbox("createIb.orderDetails.mobile.create"),this.renderCheckbox("createIb.orderDetails.mobile.view"),this.renderCheckbox("createIb.orderDetails.mobile.edit"),this.renderCheckbox("createIb.orderDetails.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Garment Process"),this.renderCheckbox("createIb.garmentProcess.web.create"),this.renderCheckbox("createIb.garmentProcess.web.view"),this.renderCheckbox("createIb.garmentProcess.web.edit"),this.renderCheckbox("createIb.garmentProcess.web.delete"),this.renderCheckbox("createIb.garmentProcess.mobile.create"),this.renderCheckbox("createIb.garmentProcess.mobile.view"),this.renderCheckbox("createIb.garmentProcess.mobile.edit"),this.renderCheckbox("createIb.garmentProcess.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric details"),this.renderCheckbox("createIb.fabricDetails.web.create"),this.renderCheckbox("createIb.fabricDetails.web.view"),this.renderCheckbox("createIb.fabricDetails.web.edit"),this.renderCheckbox("createIb.fabricDetails.web.delete"),this.renderCheckbox("createIb.fabricDetails.mobile.create"),this.renderCheckbox("createIb.fabricDetails.mobile.view"),this.renderCheckbox("createIb.fabricDetails.mobile.edit"),this.renderCheckbox("createIb.fabricDetails.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Trim"),this.renderCheckbox("createIb.trim.web.create"),this.renderCheckbox("createIb.trim.web.view"),this.renderCheckbox("createIb.trim.web.edit"),this.renderCheckbox("createIb.trim.web.delete"),this.renderCheckbox("createIb.trim.mobile.create"),this.renderCheckbox("createIb.trim.mobile.view"),this.renderCheckbox("createIb.trim.mobile.edit"),this.renderCheckbox("createIb.trim.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embroidery"),this.renderCheckbox("createIb.embroidery.web.create"),this.renderCheckbox("createIb.embroidery.web.view"),this.renderCheckbox("createIb.embroidery.web.edit"),this.renderCheckbox("createIb.embroidery.web.delete"),this.renderCheckbox("createIb.embroidery.mobile.create"),this.renderCheckbox("createIb.embroidery.mobile.view"),this.renderCheckbox("createIb.embroidery.mobile.edit"),this.renderCheckbox("createIb.embroidery.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embellishment"),this.renderCheckbox("createIb.embellishment.web.create"),this.renderCheckbox("createIb.embellishment.web.view"),this.renderCheckbox("createIb.embellishment.web.edit"),this.renderCheckbox("createIb.embellishment.web.delete"),this.renderCheckbox("createIb.embellishment.mobile.create"),this.renderCheckbox("createIb.embellishment.mobile.view"),this.renderCheckbox("createIb.embellishment.mobile.edit"),this.renderCheckbox("createIb.embellishment.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sealing details"),this.renderCheckbox("createIb.sealingDetails.web.create"),this.renderCheckbox("createIb.sealingDetails.web.view"),this.renderCheckbox("createIb.sealingDetails.web.edit"),this.renderCheckbox("createIb.sealingDetails.web.delete"),this.renderCheckbox("createIb.sealingDetails.mobile.create"),this.renderCheckbox("createIb.sealingDetails.mobile.view"),this.renderCheckbox("createIb.sealingDetails.mobile.edit"),this.renderCheckbox("createIb.sealingDetails.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Other details"),this.renderCheckbox("createIb.otherDetails.web.create"),this.renderCheckbox("createIb.otherDetails.web.view"),this.renderCheckbox("createIb.otherDetails.web.edit"),this.renderCheckbox("createIb.otherDetails.web.delete"),this.renderCheckbox("createIb.otherDetails.mobile.create"),this.renderCheckbox("createIb.otherDetails.mobile.view"),this.renderCheckbox("createIb.otherDetails.mobile.edit"),this.renderCheckbox("createIb.otherDetails.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"SMV Calc. & Thread"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("smvCalcThread.web.create"),this.renderCheckbox("smvCalcThread.web.view"),this.renderCheckbox("smvCalcThread.web.edit"),this.renderCheckbox("smvCalcThread.web.delete"),this.renderCheckbox("smvCalcThread.mobile.create"),this.renderCheckbox("smvCalcThread.mobile.view"),this.renderCheckbox("smvCalcThread.mobile.edit"),this.renderCheckbox("smvCalcThread.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Technical Issues"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("technicalIssues.web.create"),this.renderCheckbox("technicalIssues.web.view"),this.renderCheckbox("technicalIssues.web.edit"),this.renderCheckbox("technicalIssues.web.delete"),this.renderCheckbox("technicalIssues.mobile.create"),this.renderCheckbox("technicalIssues.mobile.view"),this.renderCheckbox("technicalIssues.mobile.edit"),this.renderCheckbox("technicalIssues.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"17"},"Sample Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"17",className:"text-center"},"Sample Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample Request"),this.renderCheckbox("sampleRequest.sampleRequest.web.create"),this.renderCheckbox("sampleRequest.sampleRequest.web.view"),this.renderCheckbox("sampleRequest.sampleRequest.web.edit"),this.renderCheckbox("sampleRequest.sampleRequest.web.delete"),this.renderCheckbox("sampleRequest.sampleRequest.mobile.create"),this.renderCheckbox("sampleRequest.sampleRequest.mobile.view"),this.renderCheckbox("sampleRequest.sampleRequest.mobile.edit"),this.renderCheckbox("sampleRequest.sampleRequest.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample"),this.renderCheckbox("sampleRequest.sample.web.create"),this.renderCheckbox("sampleRequest.sample.web.view"),this.renderCheckbox("sampleRequest.sample.web.edit"),this.renderCheckbox("sampleRequest.sample.web.delete"),this.renderCheckbox("sampleRequest.sample.mobile.create"),this.renderCheckbox("sampleRequest.sample.mobile.view"),this.renderCheckbox("sampleRequest.sample.mobile.edit"),this.renderCheckbox("sampleRequest.sample.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"3D"),this.renderCheckbox("sampleRequest.cad.web.create"),this.renderCheckbox("sampleRequest.cad.web.view"),this.renderCheckbox("sampleRequest.cad.web.edit"),this.renderCheckbox("sampleRequest.cad.web.delete"),this.renderCheckbox("sampleRequest.cad.mobile.create"),this.renderCheckbox("sampleRequest.cad.mobile.view"),this.renderCheckbox("sampleRequest.cad.mobile.edit"),this.renderCheckbox("sampleRequest.cad.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric"),this.renderCheckbox("sampleRequest.fabric.web.create"),this.renderCheckbox("sampleRequest.fabric.web.view"),this.renderCheckbox("sampleRequest.fabric.web.edit"),this.renderCheckbox("sampleRequest.fabric.web.delete"),this.renderCheckbox("sampleRequest.fabric.mobile.create"),this.renderCheckbox("sampleRequest.fabric.mobile.view"),this.renderCheckbox("sampleRequest.fabric.mobile.edit"),this.renderCheckbox("sampleRequest.fabric.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Trim"),this.renderCheckbox("sampleRequest.trim.web.create"),this.renderCheckbox("sampleRequest.trim.web.view"),this.renderCheckbox("sampleRequest.trim.web.edit"),this.renderCheckbox("sampleRequest.trim.web.delete"),this.renderCheckbox("sampleRequest.trim.mobile.create"),this.renderCheckbox("sampleRequest.trim.mobile.view"),this.renderCheckbox("sampleRequest.trim.mobile.edit"),this.renderCheckbox("sampleRequest.trim.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Pattern"),this.renderCheckbox("sampleRequest.pattern.web.create"),this.renderCheckbox("sampleRequest.pattern.web.view"),this.renderCheckbox("sampleRequest.pattern.web.edit"),this.renderCheckbox("sampleRequest.pattern.web.delete"),this.renderCheckbox("sampleRequest.pattern.mobile.create"),this.renderCheckbox("sampleRequest.pattern.mobile.view"),this.renderCheckbox("sampleRequest.pattern.mobile.edit"),this.renderCheckbox("sampleRequest.pattern.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Cutting"),this.renderCheckbox("sampleRequest.cutting.web.create"),this.renderCheckbox("sampleRequest.cutting.web.view"),this.renderCheckbox("sampleRequest.cutting.web.edit"),this.renderCheckbox("sampleRequest.cutting.web.delete"),this.renderCheckbox("sampleRequest.cutting.mobile.create"),this.renderCheckbox("sampleRequest.cutting.mobile.view"),this.renderCheckbox("sampleRequest.cutting.mobile.edit"),this.renderCheckbox("sampleRequest.cutting.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sewing"),this.renderCheckbox("sampleRequest.sewing.web.create"),this.renderCheckbox("sampleRequest.sewing.web.view"),this.renderCheckbox("sampleRequest.sewing.web.edit"),this.renderCheckbox("sampleRequest.sewing.web.delete"),this.renderCheckbox("sampleRequest.sewing.mobile.create"),this.renderCheckbox("sampleRequest.sewing.mobile.view"),this.renderCheckbox("sampleRequest.sewing.mobile.edit"),this.renderCheckbox("sampleRequest.sewing.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Garment Tech"),this.renderCheckbox("sampleRequest.garmentTech.web.create"),this.renderCheckbox("sampleRequest.garmentTech.web.view"),this.renderCheckbox("sampleRequest.garmentTech.web.edit"),this.renderCheckbox("sampleRequest.garmentTech.web.delete"),this.renderCheckbox("sampleRequest.garmentTech.mobile.create"),this.renderCheckbox("sampleRequest.garmentTech.mobile.view"),this.renderCheckbox("sampleRequest.garmentTech.mobile.edit"),this.renderCheckbox("sampleRequest.garmentTech.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embellishment"),this.renderCheckbox("sampleRequest.embellishment.web.create"),this.renderCheckbox("sampleRequest.embellishment.web.view"),this.renderCheckbox("sampleRequest.embellishment.web.edit"),this.renderCheckbox("sampleRequest.embellishment.web.delete"),this.renderCheckbox("sampleRequest.embellishment.mobile.create"),this.renderCheckbox("sampleRequest.embellishment.mobile.view"),this.renderCheckbox("sampleRequest.embellishment.mobile.edit"),this.renderCheckbox("sampleRequest.embellishment.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Embroidery"),this.renderCheckbox("sampleRequest.embroidery.web.create"),this.renderCheckbox("sampleRequest.embroidery.web.view"),this.renderCheckbox("sampleRequest.embroidery.web.edit"),this.renderCheckbox("sampleRequest.embroidery.web.delete"),this.renderCheckbox("sampleRequest.embroidery.mobile.create"),this.renderCheckbox("sampleRequest.embroidery.mobile.view"),this.renderCheckbox("sampleRequest.embroidery.mobile.edit"),this.renderCheckbox("sampleRequest.embroidery.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Wash"),this.renderCheckbox("sampleRequest.wash.web.create"),this.renderCheckbox("sampleRequest.wash.web.view"),this.renderCheckbox("sampleRequest.wash.web.edit"),this.renderCheckbox("sampleRequest.wash.web.delete"),this.renderCheckbox("sampleRequest.wash.mobile.create"),this.renderCheckbox("sampleRequest.wash.mobile.view"),this.renderCheckbox("sampleRequest.wash.mobile.edit"),this.renderCheckbox("sampleRequest.wash.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Dispatch"),this.renderCheckbox("sampleRequest.dispatch.web.create"),this.renderCheckbox("sampleRequest.dispatch.web.view"),this.renderCheckbox("sampleRequest.dispatch.web.edit"),this.renderCheckbox("sampleRequest.dispatch.web.delete"),this.renderCheckbox("sampleRequest.dispatch.mobile.create"),this.renderCheckbox("sampleRequest.dispatch.mobile.view"),this.renderCheckbox("sampleRequest.dispatch.mobile.edit"),this.renderCheckbox("sampleRequest.dispatch.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"QC"),this.renderCheckbox("sampleRequest.QC.web.create"),this.renderCheckbox("sampleRequest.QC.web.view"),this.renderCheckbox("sampleRequest.QC.web.edit"),this.renderCheckbox("sampleRequest.QC.web.delete"),this.renderCheckbox("sampleRequest.QC.mobile.create"),this.renderCheckbox("sampleRequest.QC.mobile.view"),this.renderCheckbox("sampleRequest.QC.mobile.edit"),this.renderCheckbox("sampleRequest.QC.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Marker"),this.renderCheckbox("sampleRequest.marker.web.create"),this.renderCheckbox("sampleRequest.marker.web.view"),this.renderCheckbox("sampleRequest.marker.web.edit"),this.renderCheckbox("sampleRequest.marker.web.delete"),this.renderCheckbox("sampleRequest.marker.mobile.create"),this.renderCheckbox("sampleRequest.marker.mobile.view"),this.renderCheckbox("sampleRequest.marker.mobile.edit"),this.renderCheckbox("sampleRequest.marker.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Costing"),this.renderCheckbox("sampleRequest.costing.web.create"),this.renderCheckbox("sampleRequest.costing.web.view"),this.renderCheckbox("sampleRequest.costing.web.edit"),this.renderCheckbox("sampleRequest.costing.web.delete"),this.renderCheckbox("sampleRequest.costing.mobile.create"),this.renderCheckbox("sampleRequest.costing.mobile.view"),this.renderCheckbox("sampleRequest.costing.mobile.edit"),this.renderCheckbox("sampleRequest.costing.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sign off"),this.renderCheckbox("sampleRequest.signoff.web.create"),this.renderCheckbox("sampleRequest.signoff.web.view"),this.renderCheckbox("sampleRequest.signoff.web.edit"),this.renderCheckbox("sampleRequest.signoff.web.delete"),this.renderCheckbox("sampleRequest.signoff.mobile.create"),this.renderCheckbox("sampleRequest.signoff.mobile.view"),this.renderCheckbox("sampleRequest.signoff.mobile.edit"),this.renderCheckbox("sampleRequest.signoff.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Sample Tag"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample Tag"),this.renderCheckbox("sampleRequest.sampleTag.web.create"),this.renderCheckbox("sampleRequest.sampleTag.web.view"),this.renderCheckbox("sampleRequest.sampleTag.web.edit"),this.renderCheckbox("sampleRequest.sampleTag.web.delete"),this.renderCheckbox("sampleRequest.sampleTag.mobile.create"),this.renderCheckbox("sampleRequest.sampleTag.mobile.view"),this.renderCheckbox("sampleRequest.sampleTag.mobile.edit"),this.renderCheckbox("sampleRequest.sampleTag.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Costing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("costing.web.create"),this.renderCheckbox("costing.web.view"),this.renderCheckbox("costing.web.edit"),this.renderCheckbox("costing.web.delete"),this.renderCheckbox("costing.mobile.create"),this.renderCheckbox("costing.mobile.view"),this.renderCheckbox("costing.mobile.edit"),this.renderCheckbox("costing.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"System"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("system.web.create"),this.renderCheckbox("system.web.view"),this.renderCheckbox("system.web.edit"),this.renderCheckbox("system.web.delete"),this.renderCheckbox("system.mobile.create"),this.renderCheckbox("system.mobile.view"),this.renderCheckbox("system.mobile.edit"),this.renderCheckbox("system.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"4"},"Customer"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Customer"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("customer.customer.web.create"),this.renderCheckbox("customer.customer.web.view"),this.renderCheckbox("customer.customer.web.edit"),this.renderCheckbox("customer.customer.web.delete"),this.renderCheckbox("customer.customer.mobile.create"),this.renderCheckbox("customer.customer.mobile.view"),this.renderCheckbox("customer.customer.mobile.edit"),this.renderCheckbox("customer.customer.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Customer - Department with POM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("customer.withoutpoms.web.create"),this.renderCheckbox("customer.withoutpoms.web.view"),this.renderCheckbox("customer.withoutpoms.web.edit"),this.renderCheckbox("customer.withoutpoms.web.delete"),this.renderCheckbox("customer.withoutpoms.mobile.create"),this.renderCheckbox("customer.withoutpoms.mobile.view"),this.renderCheckbox("customer.withoutpoms.mobile.edit"),this.renderCheckbox("customer.withoutpoms.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Customer - Department only"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("customer.masterpom.web.create"),this.renderCheckbox("customer.masterpom.web.view"),this.renderCheckbox("customer.masterpom.web.edit"),this.renderCheckbox("customer.masterpom.web.delete"),this.renderCheckbox("customer.masterpom.mobile.create"),this.renderCheckbox("customer.masterpom.mobile.view"),this.renderCheckbox("customer.masterpom.mobile.edit"),this.renderCheckbox("customer.masterpom.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Customer - POM only"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("customer.garmentpom.web.create"),this.renderCheckbox("customer.garmentpom.web.view"),this.renderCheckbox("customer.garmentpom.web.edit"),this.renderCheckbox("customer.garmentpom.web.delete"),this.renderCheckbox("customer.garmentpom.mobile.create"),this.renderCheckbox("customer.garmentpom.mobile.view"),this.renderCheckbox("customer.garmentpom.mobile.edit"),this.renderCheckbox("customer.garmentpom.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"2"},"Permissions"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},"Employee Details"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("permissions.employeeDetails.web.create"),this.renderCheckbox("permissions.employeeDetails.web.view"),this.renderCheckbox("permissions.employeeDetails.web.edit"),this.renderCheckbox("permissions.employeeDetails.web.delete"),this.renderCheckbox("permissions.employeeDetails.mobile.create"),this.renderCheckbox("permissions.employeeDetails.mobile.view"),this.renderCheckbox("permissions.employeeDetails.mobile.edit"),this.renderCheckbox("permissions.employeeDetails.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Role Management"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),this.renderCheckbox("permissions.roleManagement.web.create"),this.renderCheckbox("permissions.roleManagement.web.view"),this.renderCheckbox("permissions.roleManagement.web.edit"),this.renderCheckbox("permissions.roleManagement.web.delete"),this.renderCheckbox("permissions.roleManagement.mobile.create"),this.renderCheckbox("permissions.roleManagement.mobile.view"),this.renderCheckbox("permissions.roleManagement.mobile.edit"),this.renderCheckbox("permissions.roleManagement.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"17"},"Reports"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{rowspan:"17",className:"text-center"},"Reports"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric"),this.renderCheckbox("reports.fabric.web.create"),this.renderCheckbox("reports.fabric.web.view"),this.renderCheckbox("reports.fabric.web.edit"),this.renderCheckbox("reports.fabric.web.delete"),this.renderCheckbox("reports.fabric.mobile.create"),this.renderCheckbox("reports.fabric.mobile.view"),this.renderCheckbox("reports.fabric.mobile.edit"),this.renderCheckbox("reports.fabric.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Dispatch"),this.renderCheckbox("reports.dispatch.web.create"),this.renderCheckbox("reports.dispatch.web.view"),this.renderCheckbox("reports.dispatch.web.edit"),this.renderCheckbox("reports.dispatch.web.delete"),this.renderCheckbox("reports.dispatch.mobile.create"),this.renderCheckbox("reports.dispatch.mobile.view"),this.renderCheckbox("reports.dispatch.mobile.edit"),this.renderCheckbox("reports.dispatch.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Outstanding Customer"),this.renderCheckbox("reports.outstandingCustomer.web.create"),this.renderCheckbox("reports.outstandingCustomer.web.view"),this.renderCheckbox("reports.outstandingCustomer.web.edit"),this.renderCheckbox("reports.outstandingCustomer.web.delete"),this.renderCheckbox("reports.outstandingCustomer.mobile.create"),this.renderCheckbox("reports.outstandingCustomer.mobile.view"),this.renderCheckbox("reports.outstandingCustomer.mobile.edit"),this.renderCheckbox("reports.outstandingCustomer.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"BNumber"),this.renderCheckbox("reports.bNumber.web.create"),this.renderCheckbox("reports.bNumber.web.view"),this.renderCheckbox("reports.bNumber.web.edit"),this.renderCheckbox("reports.bNumber.web.delete"),this.renderCheckbox("reports.bNumber.mobile.create"),this.renderCheckbox("reports.bNumber.mobile.view"),this.renderCheckbox("reports.bNumber.mobile.edit"),this.renderCheckbox("reports.bNumber.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Process Completed"),this.renderCheckbox("reports.processCompleted.web.create"),this.renderCheckbox("reports.processCompleted.web.view"),this.renderCheckbox("reports.processCompleted.web.edit"),this.renderCheckbox("reports.processCompleted.web.delete"),this.renderCheckbox("reports.processCompleted.mobile.create"),this.renderCheckbox("reports.processCompleted.mobile.view"),this.renderCheckbox("reports.processCompleted.mobile.edit"),this.renderCheckbox("reports.processCompleted.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Samples Awaiting Materials"),this.renderCheckbox("reports.processUpdates.web.create"),this.renderCheckbox("reports.processUpdates.web.view"),this.renderCheckbox("reports.processUpdates.web.edit"),this.renderCheckbox("reports.processUpdates.web.delete"),this.renderCheckbox("reports.processUpdates.mobile.create"),this.renderCheckbox("reports.processUpdates.mobile.view"),this.renderCheckbox("reports.processUpdates.mobile.edit"),this.renderCheckbox("reports.processUpdates.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric Price Pending"),this.renderCheckbox("reports.fabPricePending.web.create"),this.renderCheckbox("reports.fabPricePending.web.view"),this.renderCheckbox("reports.fabPricePending.web.edit"),this.renderCheckbox("reports.fabPricePending.web.delete"),this.renderCheckbox("reports.fabPricePending.mobile.create"),this.renderCheckbox("reports.fabPricePending.mobile.view"),this.renderCheckbox("reports.fabPricePending.mobile.edit"),this.renderCheckbox("reports.fabPricePending.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Fabric Library"),this.renderCheckbox("reports.fabricLibrary.web.create"),this.renderCheckbox("reports.fabricLibrary.web.view"),this.renderCheckbox("reports.fabricLibrary.web.edit"),this.renderCheckbox("reports.fabricLibrary.web.delete"),this.renderCheckbox("reports.fabricLibrary.mobile.create"),this.renderCheckbox("reports.fabricLibrary.mobile.view"),this.renderCheckbox("reports.fabricLibrary.mobile.edit"),this.renderCheckbox("reports.fabricLibrary.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample Library"),this.renderCheckbox("reports.sampleLibrary.web.create"),this.renderCheckbox("reports.sampleLibrary.web.view"),this.renderCheckbox("reports.sampleLibrary.web.edit"),this.renderCheckbox("reports.sampleLibrary.web.delete"),this.renderCheckbox("reports.sampleLibrary.mobile.create"),this.renderCheckbox("reports.sampleLibrary.mobile.view"),this.renderCheckbox("reports.sampleLibrary.mobile.edit"),this.renderCheckbox("reports.sampleLibrary.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample Report By Process"),this.renderCheckbox("reports.sampleProcesses.web.create"),this.renderCheckbox("reports.sampleProcesses.web.view"),this.renderCheckbox("reports.sampleProcesses.web.edit"),this.renderCheckbox("reports.sampleProcesses.web.delete"),this.renderCheckbox("reports.sampleProcesses.mobile.create"),this.renderCheckbox("reports.sampleProcesses.mobile.view"),this.renderCheckbox("reports.sampleProcesses.mobile.edit"),this.renderCheckbox("reports.sampleProcesses.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Bulk Updates For Dispatch"),this.renderCheckbox("reports.bulkUpdateDispatch.web.create"),this.renderCheckbox("reports.bulkUpdateDispatch.web.view"),this.renderCheckbox("reports.bulkUpdateDispatch.web.edit"),this.renderCheckbox("reports.bulkUpdateDispatch.web.delete"),this.renderCheckbox("reports.bulkUpdateDispatch.mobile.create"),this.renderCheckbox("reports.bulkUpdateDispatch.mobile.view"),this.renderCheckbox("reports.bulkUpdateDispatch.mobile.edit"),this.renderCheckbox("reports.bulkUpdateDispatch.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Pattern Master Report"),this.renderCheckbox("reports.patternMasterReport.web.create"),this.renderCheckbox("reports.patternMasterReport.web.view"),this.renderCheckbox("reports.patternMasterReport.web.edit"),this.renderCheckbox("reports.patternMasterReport.web.delete"),this.renderCheckbox("reports.patternMasterReport.mobile.create"),this.renderCheckbox("reports.patternMasterReport.mobile.view"),this.renderCheckbox("reports.patternMasterReport.mobile.edit"),this.renderCheckbox("reports.patternMasterReport.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Process Updates"),this.renderCheckbox("reports.bulkUpdateProcess.web.create"),this.renderCheckbox("reports.bulkUpdateProcess.web.view"),this.renderCheckbox("reports.bulkUpdateProcess.web.edit"),this.renderCheckbox("reports.bulkUpdateProcess.web.delete"),this.renderCheckbox("reports.bulkUpdateProcess.mobile.create"),this.renderCheckbox("reports.bulkUpdateProcess.mobile.view"),this.renderCheckbox("reports.bulkUpdateProcess.mobile.edit"),this.renderCheckbox("reports.bulkUpdateProcess.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Style Downloads"),this.renderCheckbox("reports.styleDownloads.web.create"),this.renderCheckbox("reports.styleDownloads.web.view"),this.renderCheckbox("reports.styleDownloads.web.edit"),this.renderCheckbox("reports.styleDownloads.web.delete"),this.renderCheckbox("reports.styleDownloads.mobile.create"),this.renderCheckbox("reports.styleDownloads.mobile.view"),this.renderCheckbox("reports.styleDownloads.mobile.edit"),this.renderCheckbox("reports.styleDownloads.mobile.delete")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-left"},"Sample Request Downloads"),this.renderCheckbox("reports.sampleRequestDownloads.web.create"),this.renderCheckbox("reports.sampleRequestDownloads.web.view"),this.renderCheckbox("reports.sampleRequestDownloads.web.edit"),this.renderCheckbox("reports.sampleRequestDownloads.web.delete"),this.renderCheckbox("reports.sampleRequestDownloads.mobile.create"),this.renderCheckbox("reports.sampleRequestDownloads.mobile.view"),this.renderCheckbox("reports.sampleRequestDownloads.mobile.edit"),this.renderCheckbox("reports.sampleRequestDownloads.mobile.delete"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"rights-btn text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary mr-3",name:"button",onClick:function onClick(){return _this3.UpdateRoleRights();}},"Update Rights"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Buttons_Button__["a" /* default */],{buttonName:"Back",buttonType:"cancel",history:this.props.history}))))))));}}]);return EmployeRights;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{_id:state.main._id};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_8__redux_action_main__,dispatch)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(EmployeRights));

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(639);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(237),
    toKey = __webpack_require__(241);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(72),
    isSymbol = __webpack_require__(151);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 642 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(644);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(645);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(152);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(647),
    ListCache = __webpack_require__(110),
    Map = __webpack_require__(155);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(648),
    hashDelete = __webpack_require__(653),
    hashGet = __webpack_require__(654),
    hashHas = __webpack_require__(655),
    hashSet = __webpack_require__(656);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(109);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(239),
    isMasked = __webpack_require__(650),
    isObject = __webpack_require__(153),
    toSource = __webpack_require__(240);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(651);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(109);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(109);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(668);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    arrayMap = __webpack_require__(669),
    isArray = __webpack_require__(72),
    isSymbol = __webpack_require__(151);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 669 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(671);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(672),
    castPath = __webpack_require__(237),
    isIndex = __webpack_require__(242),
    isObject = __webpack_require__(153),
    toKey = __webpack_require__(241);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(673),
    eq = __webpack_require__(154);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(674);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rights={dashboard:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},meetingNotes:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},communication:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},cad:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabric:{fabric:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},yarnDyed:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embroidery:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},print:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},solidGreige:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},supplier:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},bNumber:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},bulkImport:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},printFabricNumber:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},trim:{trim:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},supplier:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},sourcing:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},product:{product:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sample:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},pattern:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},garmentTech:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabric:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},trim:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embellishment:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},cutting:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sewing:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},dispatch:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},signOff:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},style:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},createIb:{createIb:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},orderDetails:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},garmentProcess:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabricDetails:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},trim:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embroidery:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embellishment:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sealingDetails:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},otherDetails:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},smvCalcThread:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},technicalIssues:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sampleRequest:{sampleRequest:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sampleTag:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sample:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},cad:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabric:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},trim:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},pattern:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},cutting:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sewing:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},garmentTech:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embellishment:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},embroidery:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},wash:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},dispatch:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},QC:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},marker:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},costing:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},signoff:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},costing:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},system:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},customer:{customer:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false},withoutpoms:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},masterpom:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},garmentpom:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},permissions:{employeeDetails:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},roleManagement:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}},reports:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false},fabric:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},dispatch:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},outstandingCustomer:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},bNumber:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},processCompleted:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},patternMasterReport:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},processUpdates:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabPricePending:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},fabricLibrary:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sampleLibrary:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sampleProcesses:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},bulkUpdateDispatch:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},bulkUpdateProcess:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},sampleRequestDownloads:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}},styleDownloads:{web:{create:false,view:false,edit:false,delete:false},mobile:{create:false,view:false,edit:false,delete:false}}}};/* harmony default export */ __webpack_exports__["a"] = (rights);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ImageTopLeft__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
//components
var Employee=function(_Component){_inherits(Employee,_Component);function Employee(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Employee);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Employee.__proto__||Object.getPrototypeOf(Employee)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,employee:{firstName:"",lastName:"",userId:"",password:"",active:false,profilePicture:"",role:null},firstName:"",lastName:"",userId:"",password:"",confirmPassword:"",// roleName: "",
roleId:null,active:false,image:"",imageURL:"",allGroups:false,roleList:[],isLoading:false},_this.createEmploye=function(){if(_this.state.employee.password!==""&&_this.state.employee.confirmPassword!==""){if(_this.state.employee.password!==_this.state.employee.confirmPassword){_this.props.getalertMessage("error",'Password not matching');return false;}}if(_this.state.employee.firstName!==""&&_this.state.employee.lastName!==""&&_this.state.employee.userId!==""&&_this.state.employee.roleId!==null// this.state.active !== "" 
){if(_this.state.action==="add"){_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].createEmploye(_this.state.employee).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);// this.props.history.push('/listemploye')
}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}_this.setState({isLoading:false});}).catch(function(error){_this.props.getalertMessage("error",error.toString());});// this.props.getalertMessage(
//   "success",
//   "Password and Confirm password not match"
// );
}else if(_this.state.action==="edit"){var employee=Object.assign({},_this.state.employee);employee._id=_this.state._id;_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].updateEmploye(employee).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);// this.props.history.push('/listemploye')
}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}_this.setState({isLoading:false});}).catch(function(error){return _this.props.getalertMessage('error',error.toString());});}}else{_this.props.getalertMessage('error','Fill Mantadary Fields');}},_this.fileUpload=function(file){__WEBPACK_IMPORTED_MODULE_3__services__["f" /* FileUploadService */].uploadFile(file[0],'employee').then(function(response){if(response.status===200){var employee=Object.assign({},_this.state.employee);employee.profilePicture=response.text.data.url;_this.setState({employee:employee});}else if(response.status===401){_this.props.unauthorisedFunc();}}).catch(function(error){return _this.props.getalertMessage('error',error.toString());});},_this.removeImage=function(){var employee=Object.assign({},_this.state.employee);employee.profilePicture="";_this.setState({employee:employee});},_this._handleInputChange=function(name,value){var employee=Object.assign({},_this.state.employee);employee[name]=value;_this.setState({employee:employee});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Employee,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var _props$location$state=this.props.location.state,action=_props$location$state.action,_id=_props$location$state._id;this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].listRoles(1).then(function(response){if(response.status===200){var roleList=[];response.text.data.roleList.map(function(data){roleList.push({label:data.roleName,value:data._id});});_this2.setState({roleList:roleList,isLoading:false});}}).catch(function(error){return _this2.props.getalertMessage("error",error.toString());});if(action=="view"){this.setState({disabled:true});}if(action=="edit"||action=="view"){this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].getEmploye(_id).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var employee;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status===200){employee=Object.assign({},response.text.data);_this2.setState({employee:employee,isLoading:false});}response.status==401&&_this2.props.unauthorisedFunc();case 2:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){return _this2.props.getalertMessage('error',error.toString());});}this.setState({action:action,_id:_id});}},{key:"render",value:function render(){var _this3=this;var _state$employee=this.state.employee,firstName=_state$employee.firstName,lastName=_state$employee.lastName,userId=_state$employee.userId,active=_state$employee.active,password=_state$employee.password,confirmPassword=_state$employee.confirmPassword,profilePicture=_state$employee.profilePicture,role=_state$employee.role;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"PERMISSION DETAILS"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ImageTopLeft__["a" /* default */],{image:profilePicture,removeImage:this.removeImage,fileUpload:this.fileUpload}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-9"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"firstName",value:firstName,label:"First Name",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"lastName",value:lastName,label:"Last Name",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"userId",value:userId,label:"User ID",onChange:this._handleInputChange,disabled:this.state.disabled})),this.state.action!=="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"password",inputName:"password",value:password,label:"Password",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"password",inputName:"confirmPassword",value:confirmPassword,label:"Confirm Password",onChange:this._handleInputChange,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"role",value:role,options:this.state.roleList,label:"Role Name",onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"active",label:"Active",value:active,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary ",name:"button",onClick:function onClick(){return _this3.createEmploye();}},this.state.action==="add"?"ADD":this.state.action==="edit"?"EDIT":"VIEW"," ","Details")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history})))))));}}]);return Employee;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Employee);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var SystemSubmodulesPage=function(_React$Component){_inherits(SystemSubmodulesPage,_React$Component);function SystemSubmodulesPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SystemSubmodulesPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SystemSubmodulesPage.__proto__||Object.getPrototypeOf(SystemSubmodulesPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={type:"",systemSubModule:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SystemSubmodulesPage,[{key:"componentWillMount",value:function componentWillMount(){var type=this.props.location.state.type;this.setState({type:type});this.getParticularSubmoduleList(type);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.type!==this.state.type){var type=nextProps.location.state.type;this.setState({type:type});this.getParticularSubmoduleList(type);}}},{key:"getParticularSubmoduleList",value:function getParticularSubmoduleList(subModule){var _this2=this;__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getSystemInfo(subModule).then(function(response){if(response.status==200){_this2.setState({systemSubModule:response.text.data});}response.status===401&&_this2.props.unauthorisedFunc();}).catch(function(error){_this2.props.getalertMessage("error",error);});}},{key:"pageNavigate",value:function pageNavigate(moduleName,categoryName){if(moduleName!=="EMBROIDERY / EMBELISHMENT"&&moduleName!=="GREIGE / DENIM"&&categoryName!=="FINISH(FEEL)"){// this.props.history.push(
//   `/${this.state.type}?${moduleName.replace(
//     /\s/g,
//     ""
//   )}?${categoryName.replace(/\s/g, "_")}`
// );
this.props.history.push({pathname:"/"+this.state.type,search:"?"+moduleName.replace(/\s/g,"")+"?"+categoryName.replace(/\s/g,"_")});}else if(categoryName==="FINISH(FEEL)"){this.props.history.push({pathname:"/"+this.state.type,search:"?"+moduleName.replace(/\s/g,"")+"?FINISH(FEEL)"});}else if(moduleName==="GREIGE / DENIM"){this.props.history.push({pathname:"/"+this.state.type,search:"?GREIGE&DENIM?"+categoryName.replace(/\s/g,"_")});}else if(moduleName===" "){this.props.history.push({pathname:"/"+this.state.type,search:"?GREIGE&DENIM?"+categoryName.replace(/\s/g,"_")});}else if(moduleName==="GREIGE / DENIM"){this.props.history.push({pathname:"/"+this.state.type,search:"?GREIGE&DENIM?"+categoryName.replace(/\s/g,"_")});}else{this.props.history.push("/"+this.state.type+"?EMBROIDERY&EMBELISHMENT?"+categoryName.replace(/\s/g,"_"));this.props.history.push({pathname:"/"+this.state.type,search:"?EMBROIDERY&EMBELISHMENT?"+categoryName.replace(/\s/g,"_")});}}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row fabric-list-con"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__["a" /* default */],{header:this.state.type,history:this.props.history}))),this.state.systemSubModule?this.state.systemSubModule.map(function(moduleValue,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",key:moduleValue._id,style:{marginBottom:"0.5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row fabric-list-con"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"dev-title",style:{paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,moduleValue.module)),moduleValue.categories.map(function(category,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:key,"class":"col-md-3",onClick:function onClick(){return _this3.pageNavigate(moduleValue.module,category.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"box-con"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"cart-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this3.pageNavigate(moduleValue.module,category.name);},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{"class":"line"},category.name))))));}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null," Loading ")))));}}]);return SystemSubmodulesPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SystemSubmodulesPage);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_sample_service__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { profilePic } from '../../assets/images/pro1.jpg';
// import { Grid, Image } from 'semantic-ui-react'
var SystemCategoryList=function(_Component){_inherits(SystemCategoryList,_Component);function SystemCategoryList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SystemCategoryList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SystemCategoryList.__proto__||Object.getPrototypeOf(SystemCategoryList)).call.apply(_ref,[this].concat(args))),_this),_this.state={activePage:1,queryUrl:[],count:0,wastage:"",otherSize:"",wash:"",usd:"",gbp:"",eur:"",gst:"",valueLoss:"",overHeads:"",conversionRate:"",freightCharges:"",processingCost:"",price:"",duty:"",orderQty:"",noOftailors:null,listHide:false,_id:"",componentLoaded:false,supplierPartFabric:{gst:null,transport:null,freight:null,clearance:null,duty:null,conversion:null},supplierPartTrim:{gst:null,transport:null,freight:null,clearance:null,duty:null,conversion:null},smockingorElastic:{},toptthElastic:{}},_this.alertOptions={offset:65,position:"top left",theme:"dark",time:1000,transition:"scale"},_this.setSystemCategoryList=function(){var subModuleName=_this.props.location.search;var fullValue=[_this.props.location.pathname.slice(1)].concat(_toConsumableArray(subModuleName.split("?").slice(1)));_this.setState({queryUrl:[].concat(_toConsumableArray(fullValue))});_this.setState({categoryHeading:fullValue[0]==="EMBROIDERY&EMBELISHMENT"?"EMBROIDERY/EMBELISHMENT":fullValue[0]==="GREIGE&DENIM"?"GREIGE/DENIM":fullValue[0],categoryValue:fullValue[2],componentMounted:true});if(fullValue[1]==="TRIM"&&fullValue[2]==="SHIRRING_OR_SMOCKING"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getCategoryForSmockingSheering().then(function(res){var smokingSheeringObject=Object.assign({},_this.state.smokingSheeringObject);smokingSheeringObject.smockingorElastic=res.data.data.smockingorElastic;smokingSheeringObject.toptthElastic=res.data.data.toptthElastic;_this.setState(Object.assign({},smokingSheeringObject));});}if(fullValue[1]==="SUPPLIER"&&fullValue[2]==='SUPPLIER_PART'){if(fullValue[0]==='fabric'){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getSupplierPart('Fabrics').then(function(res){if(res.message==="Operation Successful"){_this.setState({_id:res.data._id,supplierPartFabric:{gst:res.data.gst,conversion:res.data.conversion,duty:res.data.duty,freight:res.data.freight,transport:res.data.transport,clearance:res.data.clearance}});}});}else if(fullValue[0]==='trims'){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getSupplierPart('Trims').then(function(res){if(res.message==="Operation Successful"){_this.setState({_id:res.data._id,supplierPartTrim:{gst:res.data.gst,conversion:res.data.conversion,duty:res.data.duty,freight:res.data.freight,transport:res.data.transport,clearance:res.data.clearance}});}});}}if(fullValue[1]==="EMBROIDERY&EMBELISHMENT"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(fullValue[2].split("_").join("").toLocaleUpperCase(),"EMBROIDERY/EMBELISHMENT",fullValue[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count,componentMounted:true});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else if(fullValue[1]==="GREIGE&DENIM"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(fullValue[2].split("_").join("").toLocaleUpperCase(),"GREIGE/DENIM",fullValue[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count,componentMounted:true});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}else if(fullValue[1]==="GREIGE&DENIM"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(fullValue[2].split("_").join("").toLocaleUpperCase(),"GREIGE/DENIM",fullValue[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count,componentMounted:true});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}else if(fullValue[1]==="SMV&THREADCONSUMPTION"&&fullValue[2]==="OTHERS"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getSmvOthers().then(function(response){if(response.status===200){if(response.text.data!==null){_this.setState({wastage:response.text.data.wastage,wash:response.text.data.wash,otherSize:response.text.data.otherSize,_id:response.text.data._id,componentMounted:true});}}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});_this.setState({listHide:true});}else if(fullValue[1]=="COSTING"&&fullValue[2]=="CURRENCY_CONVERSION"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getcurrencyConversion().then(function(response){if(response.status===200){if(response.text.data!==null){_this.setState({usd:response.text.data.usd,gbp:response.text.data.gbp,eur:response.text.data.eur,_id:response.text.data._id,componentMounted:true});}}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});_this.setState({listHide:true});}else if(fullValue[1]=="FABRIC"&&fullValue[2]=="GST"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getGstValue().then(function(response){if(response.status===200){if(response.text.data!==null){_this.setState({gst:response.text.data.gst,componentMounted:true});}}});_this.setState({listHide:true});}else if(fullValue[1]=="COSTING"&&fullValue[2]=="OTHERS"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].getCostingOthers().then(function(response){if(response.status===200){if(response.text.data!==null){_this.setState({valueLoss:response.text.data.valueLoss,overHeads:response.text.data.overHeads,conversionRate:response.text.data.conversionRate,freightCharges:response.text.data.freightCharges,processingCost:response.text.data.processingCost,duty:response.text.data.duty,orderQty:response.text.data.orderQty,noOftailors:response.text.data.noOftailors,costPertailor:response.text.data.costPertailor,perMachine:response.text.data.perMachine,idleDays:response.text.data.idleDays,_id:response.text.data._id,componentMounted:true});}}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});_this.setState({listHide:true});}else{if(fullValue[2]==="SHIPMENT_TERM"||fullValue[2]==="SHIPMENT_MODE"||fullValue[2]==="PORT_OF_PICK_UP"||fullValue[2]==="FABRIC_HSN"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(fullValue[2].split("_").join("").toLocaleUpperCase(),fullValue[1].split("_").join(" ").toLocaleUpperCase(),fullValue[0]==="trims"?fullValue[0]:fullValue[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count,componentMounted:true});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}else{__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(fullValue[2].split("_").join("").toLocaleUpperCase(),fullValue[1].split("_").join("").toLocaleUpperCase(),fullValue[0]==="trims"?fullValue[0]:fullValue[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count,componentMounted:true});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}}},_this.pageNavigate=function(value){_this.props.history.push("/"+value+"?"+_this.props.location.pathname.slice(1)+"?"+_this.props.location.search.slice(1));},_this.pageAction=function(value,id,categoryValue,category){if(_this.state.categoryValue==="FINISH(FEEL)"){_this.props.history.push("/"+value+"?"+id+"?"+_this.props.location.pathname.slice(1)+"?"+"FINISH");}else{_this.props.history.push("/"+value+"?"+id+"?"+_this.props.location.pathname.slice(1)+"?"+_this.props.location.search.slice(1));}},_this.pageChangeForCity=function(value,id,categoryValue,country,countryId,category){var categoryData={categoryName:categoryValue,country:country,countryId:countryId,categoryFull:category};_this.props.history.push("/"+value+"?"+id+"?"+_this.props.location.pathname.slice(1)+"?"+_this.props.location.search.slice(1));},_this.submit=function(id){Object(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-ui"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You want to delete this file?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(){_this.removeCategory(id);onClose();}},"Yes, Delete it!"));}});},_this.removeCategory=function(id){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].removeSystemCategory(id,_this.state.categoryHeading.split("_").join("").toLocaleUpperCase()).then(function(response){if(response.message==="Successfully deleted"){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].listCategoryContent(_this.state.queryUrl[2].split("_").join("").toLocaleUpperCase(),_this.state.queryUrl[1].split("_").join("").toLocaleUpperCase(),_this.state.queryUrl[0]==="trims"?_this.state.queryUrl[0]:_this.state.queryUrl[0]+"s",_this.state.activePage).then(function(response){if(response.message==="Operation Successful"){_this.setState({categoryDataList:response.data.sysData,count:response.data.count});__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].deleteMsg(_this.msg);}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});},_this.handlePageChange=function(pageNumber){_this.setState({activePage:pageNumber},function(){_this.setSystemCategoryList();});},_this.updateValue=function(name,value){_this.setState(_defineProperty({},name,value));},_this.sheeringSmookingtoptthElastic=function(name,value){var toptthElastic=Object.assign({},_this.state.toptthElastic);toptthElastic[name]=value;_this.setState({toptthElastic:toptthElastic});},_this.sheeringSmookingsmockingorElastic=function(name,value){var smockingorElastic=Object.assign({},_this.state.smockingorElastic);smockingorElastic[name]=value;_this.setState({smockingorElastic:smockingorElastic});},_this.sheeringSmookingSubmit=function(){var _this$state=_this.state,smockingorElastic=_this$state.smockingorElastic,toptthElastic=_this$state.toptthElastic;var value={smockingorElastic:smockingorElastic,toptthElastic:toptthElastic};__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].addCategoryForSmockingSheering(Object.assign({},value)).then(function(res){if(res.message==='Success'){_this.props.getalertMessage("success",res.message);}});},_this.smvOthers=function(){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].smvOthers(_this.state.queryUrl[1],_this.state.queryUrl[2],_this.state.wastage,_this.state.otherSize,_this.state.wash,_this.state._id).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this.props.getalertMessage(error.toString());});},_this.currencyConversion=function(){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].currencyConversion(_this.state.queryUrl[1],_this.state.queryUrl[2],_this.state.usd,_this.state.gbp,_this.state.eur,_this.state._id).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this.props.getalertMessage(error.toString());});},_this.editGstValue=function(){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].editGstValue(_this.state.gst).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this.props.getalertMessage(error.toString());});},_this.generalSupplierPart=function(queryUrl){// const {
//   clearance,
//   conversion,
//   duty,
//   freight,
//   gst,
//   transport
// } = supplierPart
if(queryUrl==='fabric'){var supplierPartFabric=Object.assign({},_this.state.supplierPartFabric);__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].addCategory("dummy","SUPPLIERPART","SUPPLIER","Fabrics",null,supplierPartFabric,_this.state._id,'Fabrics').then(function(response){_this.props.getalertMessage("success",response.message);});}else if(queryUrl==='trims'){var supplierPartTrim=Object.assign({},_this.state.supplierPartTrim);__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].addCategory("dummy","SUPPLIERPART","SUPPLIER","Trims",null,supplierPartTrim,_this.state._id,'Trims').then(function(response){_this.props.getalertMessage("success",response.message);});}},_this.updateValueSupplier=function(name,value,queryUrl){if(queryUrl==='fabric'){var supplierPartFabric=Object.assign({},_this.state.supplierPartFabric);supplierPartFabric[name]=value;_this.setState({supplierPartFabric:supplierPartFabric});}else if(queryUrl==='trims'){var supplierPartTrim=Object.assign({},_this.state.supplierPartTrim);supplierPartTrim[name]=value;_this.setState({supplierPartTrim:supplierPartTrim});}},_this.costingOthers=function(){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].costingOthers(_this.state.queryUrl[1],_this.state.queryUrl[2],_this.state.valueLoss,_this.state.overHeads,_this.state.conversionRate,_this.state.freightCharges,_this.state.processingCost,_this.state.duty,_this.state.orderQty,_this.state.costPertailor,_this.state.noOftailors,_this.state.perMachine,_this.state.idleDays,_this.state._id).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this.props.getalertMessage(error.toString());});},_this.preventSpecialChars=function(e){var invalidChars=['-','+','e','E','.'];if(invalidChars.includes(e.key)){e.preventDefault();// Prevent these characters from being entered
}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SystemCategoryList,[{key:"componentWillMount",value:function componentWillMount(){this.setSystemCategoryList();}},{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_alert___default.a,Object.assign({ref:function ref(a){return _this2.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center p-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"pull-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(e){return _this2.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_6__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,this.state.queryUrl[2].split("_").join(" "))),this.props.rights.create&&this.state.categoryValue!="SHIRRING_OR_SMOCKING"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"pull-right",style:{cursor:"pointer"}},this.state.categoryDataList&&this.state.categoryDataList.length>0&&(this.state.categoryValue==="ASSIGNED_TO"||this.state.categoryValue==="BOTH_ELASTIC"||this.state.categoryValue==="TOP_TTH_OR_BOTTOM_ELASTIC")?"":this.state.listHide?null:this.state.componentMounted===true?this.state.categoryValue==="DURATION"?this.state.categoryDataList!==undefined?this.state.categoryDataList.length<1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary",onClick:function onClick(){return _this2.pageNavigate("add");}}," ","Add New"):null:null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary",onClick:function onClick(){return _this2.pageNavigate("add");}}," ","Add New"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary",onClick:function onClick(){return _this2.pageNavigate("add");}}," ","Add New")))),this.state.queryUrl[1]=="SMV&THREADCONSUMPTION"&&this.state.categoryValue=="OTHERS"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 col-md-offset-5 small-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Wastage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"4",value:this.state.wastage,className:"form-control",onChange:function onChange(e){return _this2.updateValue("wastage",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Other Sizes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"4",value:this.state.otherSize,className:"form-control",onChange:function onChange(e){return _this2.updateValue("otherSize",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",size:"4",value:this.state.wash,className:"form-control",onChange:function onChange(e){return _this2.updateValue("wash",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.smvOthers}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))):this.state.queryUrl[1]=="COSTING"&&this.state.categoryValue=="CURRENCY_CONVERSION"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 col-md-offset-5 small-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"USD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",value:this.state.usd,className:"form-control",onChange:function onChange(e){return _this2.updateValue("usd",e.target.value);},onKeyDown:this.preventSpecialChars})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"GBP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",value:this.state.gbp,className:"form-control",onChange:function onChange(e){return _this2.updateValue("gbp",e.target.value);},onKeyDown:this.preventSpecialChars})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"EUR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",value:this.state.eur,className:"form-control",onChange:function onChange(e){return _this2.updateValue("eur",e.target.value);},onKeyDown:this.preventSpecialChars// Prevent special characters
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.currencyConversion}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))):this.state.queryUrl[1]=="COSTING"&&this.state.categoryValue=="OTHERS"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex flex-column align-items-center medium-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"COST SHEET")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Value Loss")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.valueLoss,className:"form-control",onChange:function onChange(e){return _this2.updateValue("valueLoss",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Contribution % ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.overHeads,className:"form-control",onChange:function onChange(e){return _this2.updateValue("overHeads",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"LANDED CALCULATION WORKING")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Conversion Rate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.conversionRate,className:"form-control",onChange:function onChange(e){return _this2.updateValue("conversionRate",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Freight Charges")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.freightCharges,className:"form-control",onChange:function onChange(e){return _this2.updateValue("freightCharges",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Processing Cost")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.processingCost,className:"form-control",onChange:function onChange(e){return _this2.updateValue("processingCost",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Duty")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.duty,className:"form-control",onChange:function onChange(e){return _this2.updateValue("duty",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"SMV CALCULATION WORKING ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"SMV Order Qty")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.orderQty,className:"form-control",onChange:function onChange(e){return _this2.updateValue("orderQty",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"No of TAILORS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.noOftailors,className:"form-control",onChange:function onChange(e){return _this2.updateValue("noOftailors",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Cost Per Tailor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.costPertailor,className:"form-control",onChange:function onChange(e){return _this2.updateValue("costPertailor",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Per Machine Cost")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.perMachine,className:"form-control",onChange:function onChange(e){return _this2.updateValue("perMachine",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Idle Days")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:this.state.idleDays,className:"form-control",onChange:function onChange(e){return _this2.updateValue("idleDays",e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.costingOthers}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))):this.state.queryUrl[1]=="FABRIC"&&this.state.categoryValue=="GST"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 col-md-offset-5 small-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"GST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",value:this.state.gst,className:"form-control",onChange:function onChange(e){return _this2.updateValue("gst",e.target.value);},onKeyDown:this.preventSpecialChars})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.editGstValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))):this.state.queryUrl[1]=="SUPPLIER"&&this.state.categoryValue=="SUPPLIER_PART"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex flex-column align-items-center medium-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"DEVELOPMENT ",this.state.queryUrl[0].toUpperCase()," - SUPPLIER PART")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"GST %")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.gst)||Number(this.state.supplierPartTrim.gst),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("gst",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Transport \u20B9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.transport)||Number(this.state.supplierPartTrim.transport),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("transport",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Freight \u20B9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.freight)||Number(this.state.supplierPartTrim.freight),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("freight",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Clearance \u20B9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.clearance)||Number(this.state.supplierPartTrim.clearance),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("clearance",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Duty %")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.duty)||Number(this.state.supplierPartTrim.duty),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("duty",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Conversion Rate - $ to \u20B9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",size:"4",width:"",value:Number(this.state.supplierPartFabric.conversion)||Number(this.state.supplierPartTrim.conversion),className:"form-control",onChange:function onChange(e){return _this2.updateValueSupplier("conversion",e.target.value,_this2.state.queryUrl[0].toLowerCase());}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(){return _this2.generalSupplierPart(_this2.state.queryUrl[0].toLowerCase());}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-container cust-card-con"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"striped list-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,this.state.categoryValue==="CITY"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"COUNTRY Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"}," CITY Name")):this.state.categoryValue==="ADDRESS"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"COUNTRY Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"}," CITY Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"}," ADDRESS")):this.state.categoryValue==="MACHINE"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"MACHINE Code (M/C)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Needle Code "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Rating "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Needle %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Looper %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Over Lock % (O/L)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Trim Threading % (TRD)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Shirring Needle %")):this.state.categoryValue==="SHIRRING_OR_SMOCKING"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"MULTIPLE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"WASTAGE")):this.state.categoryValue==="TAILORS_NAME"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Number")):this.state.categoryValue==="VALUE_LOSS"||this.state.categoryValue==="DYING/PRINT"||this.state.categoryValue==="UPCHARGE"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},this.state.categoryValue.split("_").join(" ")," "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},this.state.categoryValue.split("_").join(" ")," ","Name"),(this.state.categoryValue==="WASH_TYPE"||this.state.categoryValue==="EMB_FORM")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"id"},"Price"),this.state.categoryValue!="SHIRRING_OR_SMOCKING"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{colspan:"3","data-field":"price"},"Action"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.categoryValue==="SHIRRING_OR_SMOCKING"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"25%"},"SMOCKING OR BOTH ELASTIC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",id:"",value:this.state.smockingorElastic.multiple,name:"multiple",placeholder:"",onChange:function onChange(e){return _this2.sheeringSmookingsmockingorElastic('multiple',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",id:"",value:this.state.smockingorElastic.wastage,name:"wastage",placeholder:"",onChange:function onChange(e){return _this2.sheeringSmookingsmockingorElastic('wastage',e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"d-inline p-0 font-weight-bold"},"%"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"25%"},"TOP TTH / BOTTOM ELASTIC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",id:"",value:this.state.toptthElastic.multiple,name:"multiple",placeholder:"",onChange:function onChange(e){return _this2.sheeringSmookingtoptthElastic('multiple',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",id:"",value:this.state.toptthElastic.wastage,name:"wastage",placeholder:"",onChange:function onChange(e){return _this2.sheeringSmookingtoptthElastic('wastage',e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"d-inline p-0 font-weight-bold"},"%"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"primary",onClick:function onClick(){_this2.sheeringSmookingSubmit();}},"Update")," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null)))||this.state.categoryDataList!==undefined&&Array.isArray(this.state.categoryDataList)&&this.state.categoryDataList.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,_this2.state.categoryValue==="CITY"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.country&&category.country.name||"")),_this2.state.categoryValue==="ADDRESS"&&category.city!==undefined&&category.country!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.country.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.city.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.name),(_this2.state.categoryValue==="WASH_TYPE"||_this2.state.categoryValue==="EMB_FORM")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.price),_this2.state.categoryValue==="MACHINE"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.needleCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.factor),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.needle+"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.looper+"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.overLock+"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.trimThread+"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.sheeringNeedle+"%")),_this2.state.categoryValue==="TAILORS_NAME"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,category.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"view cursor-hover",title:"view",onClick:function onClick(){return _this2.state.categoryValue==="CITY"||_this2.state.categoryValue==="ADDRESS"?_this2.pageChangeForCity("view",category._id,category.name,category.country.name,category.country._id,category):_this2.pageAction("view",category._id,category.name,category);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"visibility"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2.props.rights.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"edit cursor-hover",title:"edit",onClick:function onClick(){return _this2.state.categoryValue==="CITY"||_this2.state.categoryValue==="ADDRESS"?_this2.pageChangeForCity("edit",category._id,category.name,category.country.name,category.country._id,category):_this2.pageAction("edit",category._id,category.name,category);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"create"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2.props.rights.delete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:function onClick(){return _this2.submit(category._id);},"class":"delete cursor-hover",title:"delete"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"delete"))));}))))),this.state.componentMounted===true&&this.state.categoryValue!=="DURATION"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{activePage:this.state.activePage,itemsCountPerPage:50,totalItemsCount:this.state.count,pageRangeDisplayed:5,onChange:this.handlePageChange}):null))));}}]);return SystemCategoryList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights.system.web};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,null)(SystemCategoryList));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddCategory=function(_Component){_inherits(AddCategory,_Component);function AddCategory(props){_classCallCheck(this,AddCategory);var _this=_possibleConstructorReturn(this,(AddCategory.__proto__||Object.getPrototypeOf(AddCategory)).call(this,props));_this.alertOptions={offset:65,position:"top left",theme:"dark",time:1000,transition:"scale"};_this.changeCountry=function(categoryValue){_this.setState({categoryValue:categoryValue});};_this.getDoneBy=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["j" /* SampleServices */].getDoneBy(value).then(function(response){if(response.message==="list displayed"){var jsonData=[];response.data.map(function(value,index){var empObj={};empObj.label=value.firstName;empObj.value=value._id;jsonData.push(empObj);});_this.setState({doneBy:jsonData});}}).catch(function(error){_this.props.getalertMessage('error',error.toString());});};_this.changeCADDoneBy=function(cadDoneBy){_this.setState({cadDoneBy:cadDoneBy});};_this.changeAsync=function(currency){_this.setState({categoryValue:currency.label,currency:currency});};_this.updatePortOfPickup=function(name,value){var portOfPickup=Object.assign({},_this.state.portOfPickup);portOfPickup[name]=value;_this.setState({portOfPickup:portOfPickup});};_this.getAssignedTo=function(data){if(data!==null){_this.setState({assignedTo:data.value,assignedToObj:data});}else{_this.setState({assignedToObj:null});}};_this.updateTypeMultiple=function(name,value,index){var typeMultiple=[].concat(_toConsumableArray(_this.state.typeMultiple));typeMultiple[index][name]=value;_this.setState({typeMultiple:typeMultiple});};_this.addTypeMultiple=function(){// alert("add" )
var typeMultiple=[].concat(_toConsumableArray(_this.state.typeMultiple));typeMultiple.push({width:null,price:null});_this.setState({typeMultiple:typeMultiple});};_this.removeMultiple=function(index){var typeMultiple=[].concat(_toConsumableArray(_this.state.typeMultiple));typeMultiple.splice(index,1);_this.setState({typeMultiple:typeMultiple});};_this.state={systemModule:[],editData:{},objectId:"",heading:"",categoryContentHeading:"",categoryValue:"",country:null,ratio:"",needle:"",looper:"",overLock:"",trimThread:"",sheeringNeedle:"",operationWholeData:"",operationId:"",operationName:"",trimRef:"",currencyValue:"",price:"",number:'',portOfPickup:{},unitsOption:[],typeMultiple:[{width:null,price:null}],status:false};// this.countriesList = this.countriesList.bind(this);
_this.submitValue=_this.submitValue.bind(_this);return _this;}_createClass(AddCategory,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var fullValue=[this.props.location.pathname.slice(1)].concat(_toConsumableArray(this.props.location.search.split("?").slice(1)));this.setState({systemModule:[].concat(_toConsumableArray(fullValue))});this.setState({categoryId:fullValue[1]});this.setState({categoryType:fullValue[0]});if(fullValue[0]=="add"){this.setState({categoryContentHeading:fullValue[3],heading:fullValue[2]==='GREIGE&DENIM'?'GREIGE/DENIM':fullValue[2]});}else{this.setState({categoryContentHeading:fullValue[4],objectId:fullValue[1],heading:fullValue[3]==='GREIGE&DENIM'?'GREIGE/DENIM':fullValue[3]});}if(fullValue[0]==='add'&&fullValue[3]==='TRIM_CATEGORY'||fullValue[0]==='edit'&&fullValue[4]==='TRIM_CATEGORY'){//TRIMCATEGORY By
var unitsOption=[];__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getTrimSysUnits().then(function(data){data.data.map(function(unit){unitsOption.push({label:unit.name,value:unit._id});_this2.setState({unitsOption:unitsOption});});}).catch(function(err){return err;});}if(fullValue[0]==='add'&&fullValue[3]==='ASSIGNED_TO'||fullValue[0]==='edit'&&fullValue[4]==='ASSIGNED_TO'){//actioned By
var actionedByOption=[];__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].searchEmploye("").then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status===200)){_context.next=5;break;}_context.next=3;return response.text.data;case 3:actionedByOption=_context.sent;_this2.setState({actionedByOption:actionedByOption,isLoading:true});case 5:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}());}if(fullValue[3]==='CITY'&&fullValue[0]==='add'||fullValue[4]==='CITY'&&(fullValue[0]==='edit'||fullValue[0]==='view')){//countriesList
var countriesList=[];__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].getCountryList().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(response.status===200)){_context2.next=5;break;}_context2.next=3;return response.text.data;case 3:countriesList=_context2.sent;_this2.setState({countriesList:countriesList,isLoading:true});case 5:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}());}__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].getDataById(fullValue[1],fullValue[2]).then(function(response){if(response.message==="system data"){_this2.setState({categoryValue:response.data.name});if(response.data.subHeading==="CURRENCY"){_this2.setState({currency:response.data.currency,currencyValue:response.data.currencyValue});}if(response.data.subHeading==="PORTOFPICKUP"){var portOfPickup={portofpickup:response.data.name,freightCostAbove500:response.data.freightCostAbove500,freightCostBelow500:response.data.freightCostBelow500,seaFreightCost:response.data.seaFreightCost};_this2.setState({portOfPickup:portOfPickup});}if(response.data.subHeading==="ASSIGNEDTO"){var assignedToObj={label:response.data.assignedTo.firstName+" "+response.data.assignedTo.lastName,value:response.data.assignedTo._id};_this2.setState({assignedToObj:assignedToObj});}if(response.data.subHeading==='TRIMCATEGORY'){_this2.setState({trimRef:response.data.referNo,units:response.data.unit,status:response.data.status});}if(response.data.subHeading==='CITY'){_this2.setState({country:response.data.country});}if(response.data.subHeading=='BACKINGTYPE'){_this2.setState({typeMultiple:response.data.typeMultiple});}if(response.data.subHeading=='MACHINE'){_this2.setState({needleCode:response.data.needleCode,factor:response.data.factor,needle:response.data.needle,looper:response.data.looper,overLock:response.data.overLock,trimThread:response.data.trimThread,sheeringNeedle:response.data.sheeringNeedle});}if(response.data.subHeading=='WASHTYPE'||response.data.subHeading=='EMBFORM'){_this2.setState({price:response.data.price});}if(response.data.subHeading=='TAILORSNAME'){_this2.setState({number:response.data.number});}}}).catch(function(error){_this2.props.getalertMessage('error',error.toString());});// this.countriesList();
}//Submitting value add and edit happens
},{key:"submitValue",value:function submitValue(e){var _this3=this;if(this.state.categoryContentHeading==="MACHINE"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForMachine(this.state.categoryValue,this.state.needleCode,this.state.factor,this.state.needle,this.state.looper,this.state.heading,this.state.overLock,this.state.trimThread,this.state.sheeringNeedle).then(function(response){if(response.message==="Successfully Added"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({categoryValue:"",needleCode:"",factor:"",needle:"",looper:"",overLock:"",trimThread:"",sheeringNeedle:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="MACHINE"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForMachine(this.state.categoryId,this.state.categoryValue,this.state.needleCode,this.state.factor,this.state.needle,this.state.looper,this.state.heading,this.state.overLock,this.state.trimThread,this.state.sheeringNeedle).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="ADDRESS"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForAddress(this.state.categoryValue,this.state.cityName,this.state.address,this.state.categoryContentHeading.split("_").join(""),this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});_this3.setState({categoryValue:"",address:"",cityName:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="ADDRESS"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForAddress(this.state.categoryContentHeading.split("_").join(""),this.state.categoryInfo,this.state.categoryId,this.state.heading).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="CITY"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForCity(this.state.categoryValue,this.state.categoryContentHeading.split("_").join(""),this.state.country,this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="CITY"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForCity(this.state.categoryValue,this.state.country,this.state.categoryId).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="TRIM_CATEGORY"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForTrimCat(this.state.categoryValue,this.state.trimRef,this.state.categoryContentHeading.split("_").join(""),this.state.units,this.state.status,this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}// done by viswa
else if(this.state.categoryContentHeading==="TRIM_COLOR"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryToParentTrim(this.state.categoryValue,this.state.categoryContentHeading.split("_").join(""),this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}//viswa
else if(this.state.categoryContentHeading==="TRIM_CATEGORY"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForTrimCat(this.state.categoryValue,this.state.trimRef,this.state.categoryContentHeading.split("_").join(""),this.state.units,this.state.status,this.state.categoryId,this.state.heading).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="CURRENCY"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForCurrency(this.state.categoryValue,this.state.currencyValue,this.state.currency,this.state.categoryContentHeading.split("_").join(""),this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="CURRENCY"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForCurrency(this.state.categoryValue,this.state.currencyValue,this.state.currency,this.state.categoryContentHeading.split("_").join(""),this.state.heading,this.state.categoryId).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if((this.state.categoryContentHeading==="INITIAL"||this.state.categoryContentHeading==="PRODUCTION")&&(this.state.categoryType==="edit"||this.state.categoryType==="add")){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addSampleRequestType(this.state.categoryContentHeading.split("_").join(""),this.state.cadDoneBy.value,this.state.heading).then(function(response){if(response.message==="Successfully Added"){_this3.msg.show("Successfully Added",{time:2000,type:"success"});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="PORT_OF_PICK_UP"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForPortofpickup(this.state.portOfPickup,this.state.categoryContentHeading.split("_").join(""),this.state.systemModule[2].toUpperCase(),this.state.systemModule[1].toUpperCase()).then(function(response){if(response.message==="Successfully Added"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({portOfPickup:{}});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="PORT_OF_PICK_UP"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForPortofpickup(this.state.portOfPickup,this.state.categoryContentHeading.split("_").join(""),this.state.heading,this.state.categoryId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="ASSIGNED_TO"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategory(this.state.assignedTo,this.state.categoryContentHeading.split("_").join(""),this.state.systemModule[2].toUpperCase().replace('&','/'),this.state.systemModule[1].toUpperCase()).then(function(response){if(response.message==="Successfully Added"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="ASSIGNED_TO"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategory(this.state.assignedTo,this.state.categoryId,this.state.systemModule[2],this.state.categoryContentHeading.split("_").join("")).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="BACKING_TYPE"&&this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategoryForBackingType(this.state.categoryValue,this.state.categoryContentHeading.split("_").join(""),this.state.systemModule[2].toUpperCase().replace('&','/'),this.state.typeMultiple).then(function(response){if(response.message==="Successfully Added"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({categoryValue:"",typeMultiple:[{width:null,price:null}]});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryContentHeading==="BACKING_TYPE"&&this.state.categoryType==="edit"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForBackingType(this.state.categoryValue,this.state.categoryId,this.state.categoryContentHeading.split("_").join(""),this.state.systemModule[2].toUpperCase().replace('&','/'),this.state.typeMultiple).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});_this3.setState({categoryValue:"",typeMultiple:[{width:null,price:null}]});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryType==="add"){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].addCategory(this.state.categoryValue,this.state.categoryContentHeading.split("_").join(""),this.state.systemModule[2]=="SMV&THREADCONSUMPTION"?this.state.systemModule[2]:this.state.systemModule[2].toUpperCase().replace('&','/'),this.state.systemModule[1].toUpperCase(),this.state.price,null,null,null,this.state.number).then(function(response){if(response.message==="Successfully Added"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].successMsg(_this3.msg);_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else if(this.state.categoryType=="edit"&&this.state.heading=='CAD'){__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategoryForCad(this.state.categoryValue,this.state.categoryId,this.state.systemModule[2]).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}else{__WEBPACK_IMPORTED_MODULE_3__services__["l" /* SystemServices */].editCategory(this.state.categoryValue,this.state.categoryId,this.state.systemModule[2],null,this.state.price,this.state.number).then(function(response){if(response.message==="Successfully updated"){_this3.msg.show("Successfully Updated",{time:2000,type:"success"});_this3.setState({categoryValue:""});}else if(response.message==="Entry already exists"){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].warningMsg(_this3.msg);}}).catch(function(error){_this3.props.getalertMessage('error',error.toString());});}}},{key:"addSubCategoryCount",value:function addSubCategoryCount(){var subCategoryQty=this.state.subCategoryQty;subCategoryQty.push({name:""});this.setState({subCategoryQty:subCategoryQty});}},{key:"changeSubCategory",value:function changeSubCategory(e,index){var subCategoryQty=this.state.subCategoryQty;subCategoryQty[index][e.target.name]=e.target.value;this.setState({subCategoryQty:subCategoryQty},function(){});}},{key:"removeCategoryCount",value:function removeCategoryCount(e,index){var subCategoryQty=this.state.subCategoryQty;subCategoryQty.splice(index,1);this.setState({subCategoryQty:subCategoryQty});}},{key:"changeAddress",value:function changeAddress(e){var categoryInfo=this.state.categoryInfo;categoryInfo.categoryName=e.target.value;this.setState({categoryInfo:categoryInfo});}},{key:"render",value:function render(){var _this4=this;var portOfPickup=this.state.portOfPickup;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_alert___default.a,Object.assign({ref:function ref(a){return _this4.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding bg-white full-width"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(e){return _this4.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,this.state.categoryType==="add"?"Add":this.state.categoryType==="edit"?"Edit":this.state.categoryType==="view"?"View":""," ",this.state.categoryContentHeading!==undefined&&this.state.categoryContentHeading.split("_").join(" "))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"form-group"},this.state.categoryContentHeading==="MACHINE"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name (M/C)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryValue,onChange:function onChange(e){return _this4.setState({categoryValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Needle Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.needleCode,onChange:function onChange(e){return _this4.setState({needleCode:e.target.value});},disabled:this.state.categoryType==="view"?true:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Rating"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.factor,onChange:function onChange(e){return _this4.setState({factor:e.target.value});},disabled:this.state.categoryType==="view"?true:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Needle %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.needle,onChange:function onChange(e){return _this4.setState({needle:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-1"},"%")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Looper %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.looper,onChange:function onChange(e){return _this4.setState({looper:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-1"},"%"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Over Lock % (O/L)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.overLock,onChange:function onChange(e){return _this4.setState({overLock:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-1"},"%")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Trim Thread Elastic % (TRD)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.trimThread,onChange:function onChange(e){return _this4.setState({trimThread:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-1"},"%")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Shirring Needle %"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",max:"100",step:"0.01","class":"form-control height-for-input-system",placeholder:"",value:this.state.sheeringNeedle,onChange:function onChange(e){return _this4.setState({sheeringNeedle:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-1"},"%"))))))):this.state.categoryContentHeading==="CITY"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Country Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{"class":"form-control height-for-input-system",value:this.state.country,onChange:function onChange(e){return _this4.setState({country:e.target.value});},disabled:this.state.categoryType==="view"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"select"),this.state.countriesList!==undefined&&Array.isArray(this.state.countriesList)&&this.state.countriesList.length>0&&this.state.countriesList.map(function(country,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:country.value},country.label);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",value:// this.state.categoryContentHeading ===
//   "CITY" ||
this.state.categoryContentHeading==="ADDRESS"&&this.state.categoryValue!==undefined?this.state.categoryValue.categoryName:this.state.categoryValue,onChange:function onChange(e){return _this4.setState({categoryValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false})):this.state.categoryContentHeading==="ADDRESS"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Country Name"),this.state.categoryType==="view"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryInfo!==undefined&&this.state.categoryInfo.country,disabled:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{"class":"form-control height-for-input-system",onChange:function onChange(e){return _this4.setState({country:e.target.value});},value:this.state.categoryValue},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"Select"),this.state.uniqueCountries!==undefined&&Array.isArray(this.state.uniqueCountries)&&this.state.uniqueCountries.length>0&&this.state.uniqueCountries.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:data._id},data.name);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"City Name"),this.state.categoryType==="view"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryInfo!==undefined&&this.state.categoryInfo.categoryFull!==undefined&&this.state.categoryInfo.categoryFull.city!==undefined&&this.state.categoryInfo.categoryFull.city!==undefined&&this.state.categoryInfo.categoryFull.city.name,disabled:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{"class":"form-control height-for-input-system",onChange:function onChange(e){return _this4.setState({cityName:e.target.value});},value:this.state.cityName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"Select"),this.state.wholeData!==undefined&&Array.isArray(this.state.wholeData)&&this.state.wholeData.length>0&&this.state.wholeData.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:data._id},data.name);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),this.state.categoryType==="edit"||this.state.categoryType==="view"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryInfo!==undefined&&this.state.categoryInfo.categoryName,onChange:function onChange(e){return _this4.changeAddress(e);},disabled:this.state.categoryType==="view"?true:false}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.address,onChange:function onChange(e){return _this4.setState({address:e.target.value});},disabled:this.state.categoryType==="view"?true:false})):this.state.categoryContentHeading==="COUNTRY"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:this.state.categoryValue,"class":"form-control height-for-input-system",placeholder:"",onChange:function onChange(e){return _this4.setState({categoryValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false})):this.state.categoryContentHeading==="TRIM_CATEGORY"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryValue,onChange:function onChange(e){return _this4.setState({categoryValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Trim Ref"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text","class":"form-control height-for-input-system",placeholder:"",name:"trimRef",value:this.state.trimRef,onChange:function onChange(e){return _this4.setState({trimRef:e.target.value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Units"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"form-control height-for-input-system",inputType:'select',inputName:'units',value:this.state.units,options:this.state.unitsOption,onChange:function onChange(name,value){_this4.setState({units:value});},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Status"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",inputType:"checkbox",inputName:"status",value:this.state.status,onChange:function onChange(name,value){_this4.setState({status:value});}})):this.state.categoryContentHeading==="CURRENCY"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:"height-for-input-system",name:"countryCode",value:this.state.currency,onChange:this.changeAsync,placeholder:"Find Style",options:__WEBPACK_IMPORTED_MODULE_3__services__["c" /* CountryServices */].countryCode(),disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Value"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number","class":"form-control height-for-input-system",placeholder:"",name:"currencyValue",value:this.state.currencyValue,onChange:function onChange(e){return _this4.setState({currencyValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false})):this.state.categoryContentHeading==="INITIAL"||this.state.categoryContentHeading==="PRODUCTION"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:"height-for-input-system",name:"doneBy",value:this.state.cadDoneBy,onInputChange:this.getDoneBy,onChange:this.changeCADDoneBy,options:this.state.doneBy,disabled:this.state.categoryType==="view"?true:false})):this.state.categoryContentHeading==="PORT_OF_PICK_UP"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"class":"text-center"},this.state.categoryContentHeading.split("_").join(" ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"portofpickup",label:" Port of Pick up",value:portOfPickup.portofpickup,onChange:this.updatePortOfPickup}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"freightCostAbove500",value:portOfPickup.freightCostAbove500,label:"AIR FREIGHT COST ≥ 500 KGS",onChange:this.updatePortOfPickup}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"freightCostBelow500",value:portOfPickup.freightCostBelow500,label:"AIR FREIGHT COST < 500 KGS",onChange:this.updatePortOfPickup}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"seaFreightCost",value:portOfPickup.seaFreightCost,label:" Sea port",onChange:this.updatePortOfPickup})):this.state.categoryContentHeading==="ASSIGNED_TO"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading.split("_").join(" ")," ","Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:"height-for-input-system",name:"assignedTo",value:this.state.assignedToObj// onInputChange = {this.searchEmploye}
,onChange:this.getAssignedTo,options:this.state.actionedByOption,disabled:this.state.categoryType==="view"?true:false}))):this.state.categoryContentHeading==="BACKING_TYPE"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"categoryValue",value:this.state.categoryValue,label:this.state.categoryContentHeading.split("_").join(" ")+" name",onChange:function onChange(name,value){return _this4.setState(_defineProperty({},name,value));},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12"},this.state.typeMultiple.map(function(mul,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"dis-flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"number",inputName:"width",value:mul.width,label:"Width",index:index,onChange:_this4.updateTypeMultiple,disabled:_this4.state.categoryType==="view"?true:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ml-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"number",inputName:"price",value:mul.price,label:"Price",index:index,onChange:_this4.updateTypeMultiple,disabled:_this4.state.categoryType==="view"?true:false})),index===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"add",onClick:_this4.addTypeMultiple}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Buttons_Button__["a" /* default */],{buttonType:"remove",onClick:function onClick(index){return _this4.removeMultiple(index);}}));}))):this.state.categoryContentHeading==="WASH_TYPE"||this.state.categoryContentHeading==="EMB_FORM"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"categoryValue",value:this.state.categoryValue,label:this.state.categoryContentHeading.split("_").join(" ")+" name",onChange:function onChange(name,value){return _this4.setState(_defineProperty({},name,value));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"number",inputName:"price",value:this.state.price,label:"Price",onChange:function onChange(name,value){return _this4.setState(_defineProperty({},name,value));}}))):this.state.categoryContentHeading==="TAILORS_NAME"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"categoryValue",value:this.state.categoryValue,label:this.state.categoryContentHeading.split("_").join(" ")+" name",onChange:function onChange(name,value){return _this4.setState(_defineProperty({},name,value));},disabled:this.state.categoryType==="view"?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Field_Field__["a" /* default */],{className:"height-for-input-system",isFormGroup:true,inputType:"text",inputName:"number",value:this.state.number,label:"Number",onChange:function onChange(name,value){return _this4.setState(_defineProperty({},name,value));},disabled:this.state.categoryType==="view"?true:false}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,this.state.categoryContentHeading!==undefined&&this.state.categoryContentHeading.split("_").join(" ")," ",["VALUE_LOSS","DYING/PRINT","UPCHARGE"].includes(this.state.categoryContentHeading)?"":" Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{// type={
//   this.state.categoryContentHeading
//     .split("_")
//     .join(" ") === "RATING" ||
//     this.state.categoryContentHeading
//       .split("_")
//       .join(" ") === "LOOPER" ||
//     this.state.categoryContentHeading
//       .split("_")
//       .join(" ") === "NEEDLE"
//     ? "number"
//     : "text"
// }
type:["DYING/PRINT","VALUE_LOSS","UPCHARGE","RATING","LOOPER","NEEDLE"].includes(this.state.categoryContentHeading)?"number":"text","class":"form-control height-for-input-system",placeholder:"",value:this.state.categoryValue,onChange:function onChange(e){return _this4.setState({categoryValue:e.target.value});},disabled:this.state.categoryType==="view"?true:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},this.state.categoryType!=="view"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",name:"button",onClick:function onClick(e){_this4.submitValue(e);setTimeout(function(){window.history.back();},1500);}},this.state.categoryType==="add"?"Add":this.state.categoryType==="edit"?"Edit":this.state.categoryType==="view"?"View":""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return window.history.back();},"class":"primary ml-1",style:{cursor:"pointer",color:"white"}},"BACK")))))));}}]);return AddCategory;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddCategory);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_css__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_select_png__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_select_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_select_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__printCosting_js__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Costing_FloatMenuList__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(11);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var fabricTemplate={fabricNumber:null,countAndConstruction:"",qualityClassification:"",supplierName:"",supplierSectionId:"",fabricPosition:null,size:"",width:"",consumption:"0.00",price:"0.00",totalCost:"0.00",fabricList:[],greige:"",valueLoss:null,EmbValueLoss:null,dyingPrint:null,gst:null,embCost:"",yardDyedCost:"",marker:null,printDirection:null};var trimTemplate={trimCategory:null,trimRefNumber:null,description:"",quality:"",supplierName:"",size:"",sizeNumber:"",consumption:"0.00",price:"0.00",totalCost:"0.00",unit:"",trimList:[]};var tempTrimPack=void 0,girlsTable=void 0;var smockingSheeringTemplate={trimCategory:null,trimNumber:null,placement:null,number:null,type:null,noOfRow:null,length:null,totalReq:null,price:"0.00",totalCost:"0.00"};var embroideryTemplate={embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:null,consumption:null,stitchCount:null,priceForStitches:"0.00",totalCost:"0.00"};var backingTemplate={backingType:null,width:null,placement:null,consumption:null,price:"0.00",totalCost:"0.00"};var embellishmentTemplate={embType:null,hoursMinutes:null,pricePerHalfHour:"0.00",totalCost:"0.00"};var washTemplate={washType:null,washFrom:null,weight:null,laundryUnit:null,price:"0.00",totalCost:"0.00"};var Costing=function(_Component){_inherits(Costing,_Component);function Costing(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Costing);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Costing.__proto__||Object.getPrototypeOf(Costing)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,isLoading:false,costing:{costingNumber:"",landedPrice:'0.00',agreedPrice:'0.00',agreedCurrency:null,currencyConversion:{eur:"",gbp:"",usd:""},orderDate:new Date(),styleReferenceId:null,customer:null,customerDepartmentId:null,magnumStyleId:null,magnumStyleName:"",customerRefNumber:"",sampleRequestId:null,costingType:null,shipmentTerm:null,shipMode:"",comments:null,fabric:[],trimPack:{trimPackNo:"",typeOfGmt:"",packagingMethod:"",packingType:"",subType:"",consumption:"",price:""},trim:[],smockingSheering:[],embroidery:[],embroideryBacking:false,bitAttaching:false,tacking:false,backing:[],embellishment:[],wash:[],otherCostDetails:[],manufacturingAndPieceCostDetails:{orderQty:null,smv:null,revTailer:null,revMachine:null,sample:null,pattern:null,noOftailors:null,costPertailor:null,perMachine:null,minutesperDay:480,setOffMinutes:960,targetPcsAt:null,avgOutputNeeded:null,daysFortailorLine:null,idleDays:null,totalDays:null,smv80:null,smv100:null,sam:null,totalSmv:null},manufacturingAndPieceCost:{fixedCharge:'0.00',CMT:0,valueLoss:0,//percentage
overHeads:0,//percentage
valueLossCost:0,overHeadsCost:0,totalCost:0},//all modules total
fabricTotalCost:0,trimTotalCost:0,trimPackTotalCost:0,embroideryTotalCost:0,backingTotalCost:0,smockingSheeringTotalCost:0,embelishmentTotalCost:0,washTotalCost:0,otherTotalCost:0,manufacturingTotalCost:0,costingTotal:0,sampleType:"",toggle:{fabric:true,trim:true,embellishment:false,//false
embroidery:false,//false
smockingSheering:false,//false
wash:true,girlsWearing:false//false
},landedData:{toValue:null,rateValue:0,freightChargesTotal:0,dutyValue:0,processValue:0,totalLandedValue:0},fromCurrencyConvertion:"usd",toCurrencyConversion:"usd",selectedConversion:"usd",selectedMenu:{name:null,value:null,date:null},girlsWearing:{grouping:[]},usdTotal:0,gbpTotal:0,euroTotal:0},usdTotal:0,gbpTotal:0,euroTotal:0,girlswearData:[],fabricIndex:null,trimIndex:null,printLoading:false,minPerDay:480,ratio:false,// createdOn: new Date(),
netSale:false,smvDisplay:false,smv80:null,smv100:null,girlswear:false,showLandedCalc:false,selected:"usd",fabricSupplier:{_id:"",supplierName:""},targetPiece80:80,ratioCosting:[{sizes:0,quantity:0,unitPrice:0,amt:0}],idleDays:2,embelishment:false,tacking:false,styleInfo:[],modalToggle:false,costingId:"",customerList:[],moduleList:["fabric","trim","smockingshirring","embroidery","embelishment","wash","manufacturing"],//list populate
sampleRequestNumbersList:[],costingTypeList:[],shipModeList:[],shipmentTermList:[],positionList:[],laundryUnitList:[],priceperkgList:[],washTypeList:[],placementList:[],embTypeList:[],backingTypeList:[],embPlacementList:[],noOfColorList:[],framesList:[],embFormList:[],trimCategoryList:[],trimPlacementList:[],units:"",supplierSectionList:[],selectSmv:[],smvList:[],patternList:[],sampleList:[],currencies:{},dyingPrint:{},valueLoss:{},//valueLossSearch:{},
upCharge:{},gst:"",// others: {},
trimPackList:[],fabricSizeList:[],goBack:-1,styleNoInfo:[]},_this.convertoFixed2=function(costing){var inputs=['consumption','price','pricePerHalfHour','weight'];var arr=Object.keys(costing);arr.forEach(function(key){if(_typeof(costing[key])==='object'&&Array.isArray(costing[key])){costing[key].map(function(x){Object.keys(x).forEach(function(k){if(inputs.includes(k)){x[k]=Number(x[k]).toFixed(2);}});});}});if(costing.manufacturingAndPieceCost&&costing.manufacturingAndPieceCost.fixedCharge)costing.manufacturingAndPieceCost.fixedCharge=Number(costing.manufacturingAndPieceCost.fixedCharge).toFixed(2);_this.setState({costing:costing});},_this.getCostingNumber=function(){__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].costingNumber().then(function(response){if(response.status==200){var costing=_this.state.costing;costing.costingNumber=response.text.data.costingNumber;_this.setState({costing:costing});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getCostingSystem=function(){__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getCostingSystem().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var _this$setState,costing,showLandedCalc;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status==200){costing=_this.state.costing;showLandedCalc=false;if(!costing.manufacturingAndPieceCostDetails.perMachine||costing.manufacturingAndPieceCostDetails.perMachine==="")costing.manufacturingAndPieceCostDetails.perMachine=response.text.data.OTHERS.perMachine;if(!costing.manufacturingAndPieceCostDetails.costPertailor||costing.manufacturingAndPieceCostDetails.costPertailor==="")costing.manufacturingAndPieceCostDetails.costPertailor=response.text.data.OTHERS.costPertailor;if(!costing.manufacturingAndPieceCostDetails.noOftailors||costing.manufacturingAndPieceCostDetails.noOftailors==="")costing.manufacturingAndPieceCostDetails.noOftailors=response.text.data.OTHERS.noOftailors;if(!costing.manufacturingAndPieceCostDetails.orderQty||costing.manufacturingAndPieceCostDetails.orderQty==="")costing.manufacturingAndPieceCostDetails.orderQty=response.text.data.OTHERS.orderQty;if(!costing.manufacturingAndPieceCost.valueLoss||costing.manufacturingAndPieceCost.valueLoss==="")costing.manufacturingAndPieceCost.valueLoss=response.text.data.OTHERS.valueLoss;if(!costing.manufacturingAndPieceCost.overHeads||costing.manufacturingAndPieceCost.overHeads==="")costing.manufacturingAndPieceCost.overHeads=response.text.data.OTHERS.overHeads;if(!costing.manufacturingAndPieceCostDetails.idleDays||costing.manufacturingAndPieceCostDetails.idleDays==="")costing.manufacturingAndPieceCostDetails.idleDays=response.text.data.OTHERS.idleDays;// ------*****************----------------------
if(!costing.landedData.conversionRate||costing.landedData.conversionRate==="")costing.landedData.conversionRate=response.text.data.OTHERS.conversionRate;// costing.landedData.conversionRate =
//   response.text.data.OTHERS.conversionRate
if(!costing.landedData.freightCharges||costing.landedData.freightCharges==="")costing.landedData.freightCharges=response.text.data.OTHERS.freightCharges;// costing.landedData.freightCharges =
//   response.text.data.OTHERS.freightCharges
if(!costing.landedData.duty||costing.landedData.duty==="")costing.landedData.duty=response.text.data.OTHERS.duty;// costing.landedData.duty = response.text.data.OTHERS.duty
// costing.landedData.processingCost =
//   response.text.data.OTHERS.processingCost
if(!costing.landedData.processingCost||costing.landedData.processingCost==="")costing.landedData.processingCost=response.text.data.OTHERS.processingCost;if(costing.landedData.totalLandedValue){showLandedCalc=true;}_this.setState((_this$setState={// showLandedCalc,
costing:costing,costingTypeList:response.text.data.COSTINGTYPE,shipModeList:response.text.data.SHIPMENTMODE,shipmentTermList:response.text.data.SHIPMENTTERM,units:response.text.data.UNITS,// selectSmv: response.text.data.SELECTSMV,
smvList:response.text.data.SMV,// patternList: response.text.data.PATTERN,
// sampleList: response.text.data.SAMPLE,
currencies:response.text.data.CURRENCY_CONVERSION},_defineProperty(_this$setState,"costing",Object.assign({},_this.state.costing,{currencyConversion:{usd:response.text.data.CURRENCY_CONVERSION.usd||'',gbp:response.text.data.CURRENCY_CONVERSION.gbp||'',eur:response.text.data.CURRENCY_CONVERSION.eur||''}})),_defineProperty(_this$setState,"dyingPrint",response.text.data['DYING/PRINT']),_defineProperty(_this$setState,"valueLoss",response.text.data.VALUELOSS),_defineProperty(_this$setState,"upCharge",response.text.data.UPCHARGE),_defineProperty(_this$setState,"gst",response.text.data.GST.gst),_defineProperty(_this$setState,"markerList",response.text.data.MARKER),_defineProperty(_this$setState,"printDirectionList",response.text.data.PRINTDIRECTION),_this$setState),function(){if(_this.state.action==="edit"){setTimeout(function(){_this.convertOthers();},500);}});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getSampleReqNoListById=function(_id){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSampleRequestListById(_id).then(function(response){if(response.status==200){_this.setState({sampleRequestNumbersList:response.text.data});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.getCustomerList=function(){__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:response.text.data});}}).catch(function(error){});},_this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this.setState({styleNoInfo:jsonData});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeStyleNo=function(styleInfo){var costing=_this.state.costing;costing.styleReferenceId=null;if(styleInfo&&styleInfo.value){costing.styleReferenceId=styleInfo.value;}_this.setState({styleInfo:styleInfo});if(styleInfo!==null){_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getStyleInfoByReference(styleInfo.value).then(function(response){_this.setState({samAsync:!_this.state.samAsync});if(response.text.message==="Sample Request Data"){if(response.text.data.sampleRequest.length==0){_this.props.getalertMessage("info","This style ref no does'nt have Requests");}costing.customerName=response.text.data.customerName+"-"+response.text.data.departmentName;costing.customer=response.text.data.customer;costing.customerDepartmentId=response.text.data.customerDepartmentId;costing.magnumStyleId=response.text.data.magnumStyleId;costing.magnumStyleName=response.text.data.magnumStyleName;costing.customerRefNumber=response.text.data.customerRefNumber;costing.manufacturingAndPieceCost.fixedCharge=response.text.data.fixedCharge;_this.setState({sampleRequestNumbersList:response.text.data.sampleRequest,costing:costing},function(){_this._handleCustDeptChange(null,costing.customer,costing.customerDepartmentId);setTimeout(function(){_this.calConsumPrice();_this.updateCostTotal();_this.landedCalc("shipmentTerm",costing.landedData.toValue);_this.setState({isLoading:false});},500);});}}).catch(function(error){alert("Something Went Wrong...Try Again Later");});}},_this.getSampleRqNo=function(value){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSampleReqNo(value).then(function(response){if(response.status===200){_this.setState({sampleRequestNumbersList:response.text.data});}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.changeSampleNo=function(sampleNo){if(sampleNo!==null){sampleNo=(typeof sampleNo==="undefined"?"undefined":_typeof(sampleNo))=="object"?sampleNo.value:sampleNo;_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getSampleRequestInfo(sampleNo).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){var costing;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(response.status===200){costing=Object.assign({},_this.state.costing);costing.sampleRequestId=sampleNo;costing.customerName=response.text.data.customerName;costing.customer=response.text.data.customer;costing.customerDepartmentId=response.text.data.customerDepartmentId;costing.magnumStyleId=response.text.data.magnumStyleId;costing.styleReferenceId=response.text.data.styleReferenceId;costing.magnumStyleName=response.text.data.magnumStyleName;costing.customerRefNumber=response.text.data.customerRefNumber;costing.fabric=response.text.data.fabric;costing.trim=response.text.data.trim;costing.smockingSheering=response.text.data.smockingSheering;costing.embroidery=response.text.data.embroidery;costing.backing=response.text.data.backing;costing.bitAttaching=response.text.data.bitAttaching;costing.embellishment=response.text.data.embellishment;costing.wash=response.text.data.wash;costing.tacking=response.text.data.tacking;costing.embroideryBacking=response.text.data.embroideryBacking;costing.sampleType=response.text.data.sampleType;costing.manufacturingAndPieceCost.fixedCharge=response.text.data.fixedCharge;costing.toggle=Object.assign({},costing.toggle,{fabric:response.text.data.fabric.length&&true||false,trim:response.text.data.trim.length&&true||false,embellishment:response.text.data.embellishment.length&&true||false,embroidery:response.text.data.embroidery.length&&true||false,smockingSheering:response.text.data.smockingSheering.length&&true||false,wash:response.text.data.wash.length&&true||false// costing.fabric = [1]
});_this.setState({costing:costing},function(){// this.getTrimPack(costing.customer, costing.customerDepartmentId)
_this.getSampleReqNoListById(costing.sampleRequestId);_this.getSMVList(costing.styleReferenceId);_this._handleCustDeptChange(null,costing.customer,costing.customerDepartmentId);_this.calConsumPrice();setTimeout(function(){_this.updateCostTotal();_this.setState({isLoading:false});if(costing.smockingSheering&&costing.smockingSheering.length){costing.smockingSheering.forEach(function(x,index){_this.updateSmockingSheering(null,null,index);});}},4000);});}else{_this.setState({isLoading:false});_this.props.getalertMessage("error",response.text.message,9000);}case 1:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{var costing=Object.assign({},_this.state.costing);costing.sampleRequestId=null;costing.styleReferenceId=null;costing.customer=null;costing.customerDepartmentId=null;costing.magnumStyleId=null;_this.setState({costing:costing});}},_this.costingPrintData=function(data,type){var Toggles=Object.assign({},_this.state.costing.toggle);var showLandedCalc=_this.state.showLandedCalc;_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{key:_this.state.costing.costingNumber,// costingType : this.state.costing.costingType,
costingType:document.getElementsByName('costingType')[0].selectedOptions[0].innerHTML,Toggles:Toggles,showLandedCalc:showLandedCalc})});var costingPrint=Object.assign({},_this.state.costingPrint);var name=data.name,value=data.value,listToMap=data.listToMap;switch(type){case"single":costingPrint[name]=value;_this.setState({costingPrint:costingPrint});break;case"list":if(listToMap==="costingTypeList"){var costingType=_this.state.costingTypeList.length>0&&_this.state.costingTypeList.map(function(data){if(data.value===value){return data.label;}}).filter(Boolean)[0];_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{costingType:costingType})});}else if(listToMap==="customerList"){var customerName=void 0;var departmentName=void 0;if(name==="customerName"){customerName=_this.state.customerList.length>0&&_this.state.customerList.map(function(data){if(data._id===value){return data.customerName;}}).filter(Boolean)[0];_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{customerName:customerName})});}else if(name==="departmentName"){departmentName=_this.state.customerList.length>0&&_this.state.customerList.map(function(data){if(data.departmentId===value){return data.departmentName;}}).filter(Boolean)[0];_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{departmentName:departmentName})});}}else if(listToMap==="sampleRequestNumbersList"){var sampleRequestId=value&&_this.state.sampleRequestNumbersList.length>0&&_this.state.sampleRequestNumbersList.find(function(data){return data.value===value;}).label||"";_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{sampleRequestId:sampleRequestId})});}else if(listToMap==="styleNoInfo"){var styNo=value&&_this.state.styleNoInfo.find(function(data){return data.value===value;})||null;var styleReferenceId=_this.state.styleNoInfo.length>0&&styNo&&styNo.label||_this.state.costing.styleReferenceId&&_this.state.costing.styleReferenceId.label||"";_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{styleReferenceId:styleReferenceId})});}}},_this.costingPrintFabricData=function(){var Fabric={FabricArrayData:[],totalCost:0};_this.state.costing.fabric&&_this.state.costing.fabric.length>0&&_this.state.costing.fabric.forEach(function(fabric,index){var fabricArray={};if(fabric.fabricNumber&&fabric.fabricList&&fabric.fabricList.length)fabricArray.fabricNumber=fabric.fabricList.find(function(data){return data.value===fabric.fabricNumber;}).label;if(fabric.fabricPosition&&_this.state.positionList&&_this.state.positionList.length)fabricArray.fabricPosition=_this.state.positionList.find(function(data){return data.value===fabric.fabricPosition;}).label;// if (fabric.size && this.state.fabricSizeList && this.state.fabricSizeList.length)
//   fabricArray.fabricSize = this.state.fabricSizeList.find(data => data.value === fabric.size).label
if(fabric.size)fabricArray.fabricSize=fabric.size;if(fabric.printDirection&&_this.state.printDirectionList&&_this.state.printDirectionList.length)fabricArray.printDirection=_this.state.printDirectionList.find(function(data){return data.value===fabric.printDirection;}).label;if(fabric.marker&&_this.state.markerList&&_this.state.markerList.length)fabricArray.marker=_this.state.markerList.find(function(data){return data.value===fabric.marker;}).label;if(fabric.valueLoss&&_this.state.valueLoss&&_this.state.valueLoss.length){fabricArray.valueLoss=_this.state.valueLoss.find(function(data){return data.value===fabric.valueLoss;}).label;}if(fabric.EmbValueLoss&&_this.state.valueLoss&&_this.state.valueLoss.length){fabricArray.EmbValueLoss=_this.state.valueLoss.find(function(data){return data.value===fabric.EmbValueLoss;}).label;}if(fabric.dyingPrint&&_this.state.dyingPrint&&_this.state.dyingPrint.length){fabricArray.dyingPrint=_this.state.dyingPrint.find(function(data){return data.value===fabric.dyingPrint;}).label;}if(fabric.upcharge&&_this.state.upCharge&&_this.state.upCharge.length){fabricArray.upCharge=_this.state.upCharge.find(function(data){return data.value===fabric.upcharge;}).label;}fabricArray.countAndConstruction=fabric.countAndConstruction;fabricArray.qualityClassification=fabric.qualityClassification;fabricArray.supplierName=fabric.supplierName;fabricArray.width=fabric.width;fabricArray.consumption=fabric.consumption;fabricArray.price=fabric.price;fabricArray.emb=fabric.emb;fabricArray.greigeset=fabric.greigeset;fabricArray.yarn=fabric.yarn;fabricArray.embCost=fabric.embCost;fabricArray.greige=fabric.greige;fabricArray.gst=fabric.gst;fabricArray.defaultGst=_this.state.gst;fabricArray.totalCost=fabric.totalCost?Number(fabric.totalCost).toFixed(2):0.0;Fabric.FabricArrayData.push(fabricArray);});Fabric.totalCost=Number(_this.state.costing.fabricTotalCost).toFixed(2);_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{Fabric:Fabric})});},_this.costingPrintTrimData=function(){var TrimObject={trimPack:{},trimArrayData:[],totalCost:0};var costing=Object.assign({},_this.state.costing);// Trim Pack
TrimObject.trimPack.trimPackNo=costing.trimPack?costing.trimPack.trimPackNo:null;TrimObject.trimPack.typeOfGmt=costing.trimPack?costing.trimPack.typeOfGmt:null;TrimObject.trimPack.packagingMethod=costing.trimPack?costing.trimPack.packagingMethod:null;TrimObject.trimPack.packingType=costing.trimPack?costing.trimPack.packingType:null;TrimObject.trimPack.subType=costing.trimPack?costing.trimPack.subType:null;TrimObject.trimPack.consumption=costing.trimPack?costing.trimPack.consumption:null;TrimObject.trimPack.price=costing.trimPack?costing.trimPack.price:null;TrimObject.trimPack.trimPackTotalCost=costing.trimPackTotalCost?costing.trimPackTotalCost:null;// trim Array
_this.state.costing.trim&&_this.state.costing.trim.length>0&&_this.state.costing.trim.forEach(function(trim,index){var trimArray={};if(trim.trimCategory&&_this.state.trimCategoryList&&_this.state.trimCategoryList)trimArray.trimCategory=_this.state.trimCategoryList.find(function(data){return data.value===trim.trimCategory;}).label;if(trim.trimNumber&&_this.state.costing.trim[index].trimList&&_this.state.costing.trim[index].trimList.length)trimArray.trimNumber=_this.state.costing.trim[index].trimList.find(function(data){return data.value===trim.trimNumber;}).label;trimArray.description=trim.description;trimArray.quality=trim.quality;trimArray.supplierName=trim.supplierName;trimArray.size=trim.size;trimArray.consumption=trim.consumption;trimArray.price=trim.price;trimArray.totalCost=trim.totalCost?Number(trim.totalCost).toFixed(2):0.0;TrimObject.trimArrayData.push(trimArray);});TrimObject.totalCost=_this.state.costing.trimTotalCost;_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{TrimObject:TrimObject})});},_this.costingPrintSmockingData=function(){var SmockingShirring={smockingShirringArray:[]};_this.state.costing.smockingSheering&&_this.state.costing.smockingSheering.length>0&&_this.state.costing.smockingSheering.forEach(function(smock,index){var smocking={};smocking.trimCategory=_this.state.trimCategoryList&&_this.state.trimCategoryList.length>0&&_this.state.trimCategoryList.map(function(data){if(data.value===smock.trimCategory){return data.label;}}).filter(Boolean)[0];smocking.trimNumber=_this.state.costing.smockingSheering[index].trimList&&_this.state.costing.smockingSheering[index].trimList.length>0&&_this.state.costing.smockingSheering[index].trimList.map(function(data){if(data.value===smock.trimNumber){return data.label;}}).filter(Boolean)[0];smocking.placement=_this.state.trimPlacementList&&_this.state.trimPlacementList.length>0&&_this.state.trimPlacementList.map(function(data){if(data.value===smock.placement){return data.label;}}).filter(Boolean)[0];smocking.type=smock.type;smocking.noOfRow=smock.noOfRow;smocking.length=smock.length;smocking.totalReq=smock.totalReq;smocking.price=smock.price;smocking.totalCost=smock.totalCost;SmockingShirring.smockingShirringArray.push(smocking);});SmockingShirring.totalCost=_this.state.costing.smockingSheeringTotalCost;_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{SmockingShirring:SmockingShirring})});},_this.costingPrintEmbroideryData=function(){var Embroidery={EmbroideryArray:[],embroideryBacking:_this.state.costing.embroideryBacking,bitAttaching:_this.state.costing.bitAttaching,embroideryTotalCost:_this.state.costing.embroideryTotalCost,BackingArray:[]};_this.state.costing.embroidery&&_this.state.costing.embroidery.length>0&&_this.state.costing.embroidery.forEach(function(embroideryData,index){var embroidery={};if(embroideryData.embPlacement&&_this.state.embPlacementList&&_this.state.embPlacementList.length)embroidery.embPlacement=_this.state.embPlacementList.find(function(data){return data.value===embroideryData.embPlacement;}).label;if(embroideryData.embForm&&_this.state.embFormList&&_this.state.embFormList.length)embroidery.embForm=_this.state.embFormList.find(function(data){return data.value===embroideryData.embForm;}).label;if(embroideryData.noOfCols&&_this.state.noOfColorList&&_this.state.noOfColorList.length)embroidery.noOfCols=_this.state.noOfColorList.find(function(data){return data.value===embroideryData.noOfCols;}).label;if(embroideryData.frames&&_this.state.framesList&&_this.state.framesList.length)embroidery.frames=_this.state.framesList.find(function(data){return data.value===embroideryData.frames;}).label;embroidery.stitchesMtr=embroideryData.stitchesMtr;embroidery.consumption=embroideryData.consumption;embroidery.stitchCount=embroideryData.stitchCount;embroidery.priceForStitches=embroideryData.priceForStitches;embroidery.totalCost=embroideryData.totalCost;Embroidery.EmbroideryArray.push(embroidery);});if(_this.state.costing.embroideryBacking)_this.state.costing.backing&&_this.state.costing.backing.length>0&&_this.state.costing.backing.forEach(function(back,Index){var backingData={};if(back.backingType)backingData.backingType=_this.state.backingTypeList&&_this.state.backingTypeList.length>0&&_this.state.backingTypeList.find(function(data,index){return data.value===back.backingType;}).label;if(back.placement)backingData.placement=_this.state.embPlacementList&&_this.state.embPlacementList.length&&_this.state.embPlacementList.find(function(data,index){return data.value===back.placement;}).label;backingData.width=back.width;backingData.consumption=back.consumption;backingData.price=back.price;backingData.totalCost=back.totalCost;Embroidery.BackingArray.push(backingData);});Embroidery.backingTotalCost=_this.state.costing.backingTotalCost;Embroidery.totalCost=_this.state.costing.embroideryTotalCost;_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{Embroidery:Embroidery})});},_this.costingPrintEmbellishmentData=function(){var Embellishment={totalCost:_this.state.costing.embelishmentTotalCost,embellishmentArray:[]};if(!!_this.state.costing.embellishment){_this.state.costing.embellishment.forEach(function(emb,index){var embellishment={};embellishment.embType=_this.state.embTypeList&&_this.state.embTypeList.length>0&&_this.state.embTypeList.map(function(data){if(data.value===emb.embType){return data.label;}}).filter(Boolean)[0];embellishment.hoursMinutes=emb.hoursMinutes;embellishment.pricePerHalfHour=emb.pricePerHalfHour;embellishment.totalCost=emb.totalCost;Embellishment.embellishmentArray.push(embellishment);});}_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{Embellishment:Embellishment})});},_this.costingPrintWashData=function(){var Wash={washCost:_this.state.costing.washTotalCost,washArray:[],washTacking:_this.state.costing.tacking};if(!!_this.state.costing.wash){_this.state.costing.wash.forEach(function(washData,index){var wash={};wash.washType=_this.state.washTypeList&&_this.state.washTypeList.length>0&&_this.state.washTypeList.map(function(data){if(data.value===washData.washType){return data.label;}}).filter(Boolean)[0];wash.laundryUnit=_this.state.laundryUnitList&&_this.state.laundryUnitList.length>0&&_this.state.laundryUnitList.map(function(data){if(data.value===washData.laundryUnit){return data.label;}}).filter(Boolean)[0];wash.weight=washData.weight;wash.price=washData.price;wash.totalCost=washData.totalCost;Wash.washArray.push(wash);});}_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{Wash:Wash})});},_this.costingPrintOtherChargesData=function(){var OtherCharges={otherTotalCost:_this.state.costing.otherTotalCost,otherChargesArray:[]};_this.state.costing.otherCostDetails.map(function(otherChargeData,index){var otherCharge={};otherCharge.label=otherChargeData.label;otherCharge.value=otherChargeData.value;OtherCharges.otherChargesArray.push(otherCharge);});_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{OtherCharges:OtherCharges})});},_this.costingPrintManufacturingData=function(){var Manufacturing={ManufacturingArray:[],fixedCharge:_this.state.costing.manufacturingAndPieceCost.fixedCharge};var manufacturingAndPieceCostDetails=Object.assign({},_this.state.costing.manufacturingAndPieceCostDetails);var manufacturingAndPieceCost=Object.assign({},_this.state.costing.manufacturingAndPieceCost);Manufacturing.smv=_this.state.selectSmv&&_this.state.selectSmv.length>0&&_this.state.selectSmv.map(function(data){if(data.value===manufacturingAndPieceCostDetails.smv){return data.label;}}).filter(Boolean)[0];Manufacturing.orderQty=manufacturingAndPieceCostDetails.orderQty;Manufacturing.smv80=manufacturingAndPieceCostDetails.smv80;Manufacturing.perMachine=manufacturingAndPieceCostDetails.perMachine;Manufacturing.smv100=manufacturingAndPieceCostDetails.smv100;Manufacturing.revTailer=manufacturingAndPieceCostDetails.revTailer;Manufacturing.revMachine=manufacturingAndPieceCostDetails.revMachine;Manufacturing.CMT=manufacturingAndPieceCost.CMT;Manufacturing.CMTSelected=manufacturingAndPieceCost.CMT===Manufacturing.revTailer?2800:manufacturingAndPieceCost.CMT===Manufacturing.revMachine?1750:"";Manufacturing.totalCost=manufacturingAndPieceCost.totalCost;Manufacturing.selectedMenu={name:_this.state.costing.selectedMenu.name,value:_this.state.costing.selectedMenu.value&&_this.state.sampleList.find(function(x){return x.value===_this.state.costing.selectedMenu.value;}).label||null,data:_this.state.costing.selectedMenu.date};Manufacturing.others={valueLoss:{value:_this.state.costing.manufacturingAndPieceCost.valueLoss,total:_this.state.costing.manufacturingAndPieceCost.valueLossCost},overHeads:{value:_this.state.costing.manufacturingAndPieceCost.overHeads,total:_this.state.costing.manufacturingAndPieceCost.overHeadsCost}};Manufacturing.costingTotal=_this.state.costing.costingTotal;Manufacturing.currencies={usd:{value:_this.state.currencies.usd,total:_this.state.costing.usdTotal},gbp:{value:_this.state.currencies.gbp,total:_this.state.costing.gbpTotal},eur:{value:_this.state.currencies.eur,total:_this.state.costing.euroTotal}};Manufacturing.shipment={shipmentTerm:_this.state.costing.shipmentTerm,shipmentMode:null};Manufacturing.shipment.shipmentMode=_this.state.shipModeList&&_this.state.shipModeList.length>0&&_this.state.shipModeList.map(function(data,index){if(data.value===_this.state.costing.shipMode){return data.label;}}).filter(Boolean)[0];Manufacturing.landedPrice=_this.state.costing.landedData.totalLandedValue&&Number(_this.state.costing.landedData.totalLandedValue).toFixed(2);Manufacturing.agreedPrice=_this.state.costing.agreedPrice&&Number(_this.state.costing.agreedPrice).toFixed(2);Manufacturing.agreedCurrency=_this.state.costing.agreedCurrency;Manufacturing.fromCurrencyConvertion=_this.state.costing.fromCurrencyConvertion||"USD";Manufacturing.toCurrencyConvertion=_this.state.costing.toCurrencyConversion.toUpperCase();Manufacturing.conversionTotal=_this.state.costing.landedPrice;Manufacturing.coversionRate=Number(_this.state.costing.landedData.conversionRate);Manufacturing.rateValue=_this.state.costing.landedData.rateValue;Manufacturing.freightCharges=_this.state.costing.landedData.freightCharges;Manufacturing.freightTotal=_this.state.costing.landedData.freightChargesTotal;Manufacturing.dutyValue=Number(_this.state.costing.landedData.duty);Manufacturing.dutyTotal=_this.state.costing.landedData.dutyValue;Manufacturing.totalLanding=_this.state.costing.landedData.totalLandedValue;Manufacturing.processingCost=Number(_this.state.costing.landedData.processingCost);Manufacturing.processValue=_this.state.costing.landedData.processValue;Manufacturing.comments=_this.state.costing.comments;// Manufacturing.totalLandingCost = this.state.usdTotal
var customerName=document.getElementsByName('customerName')[0].value;_this.setState({costingPrint:Object.assign({},_this.state.costingPrint,{selectedConversion:_this.state.costing.selectedConversion,Manufacturing:Manufacturing,customerName:customerName})});},_this.updateCostingPrintValues=function(){var newUserCosting=_this.props.userDetails.firstName+" "+_this.props.userDetails.lastName;setTimeout(function(){var costingData=Object.assign({},_this.state.costing);_this.costingPrintData({name:"createdBy",value:costingData.createdBy?costingData.createdBy.firstName+" "+costingData.createdBy.lastName:newUserCosting,listtoMap:""},"single");_this.costingPrintData({name:"modifiedBy",value:costingData.modifiedBy?costingData.modifiedBy.firstName+" "+costingData.modifiedBy.lastName:newUserCosting,listtoMap:""},"single");_this.costingPrintData({name:"costingCreatedTime",value:__WEBPACK_IMPORTED_MODULE_21_moment___default()(costingData.costingCreatedTime).format("HH:mm DD MMM YYYY"),listtoMap:""},"single");_this.costingPrintData({name:"updatedAt",value:__WEBPACK_IMPORTED_MODULE_21_moment___default()(costingData.updatedAt).format("HH:mm DD MMM YYYY"),listtoMap:""},"single");//
_this.costingPrintData({name:"magnumStyleId",value:costingData.magnumStyleId,listToMap:""},"single");_this.costingPrintData({name:"currencyUpdate",value:costingData.currencyConversion,listToMap:""},"single");_this.costingPrintData({name:"magnumStyleName",value:costingData.magnumStyleName,listToMap:""},"single");_this.costingPrintData({name:"customerRefNumber",value:costingData.customerRefNumber,listToMap:""},"single");_this.costingPrintData({name:"styleReferenceId",value:costingData.styleReferenceId,listToMap:"styleNoInfo"},"list");// this.costingPrintData(
//   {
//     name: "customerName",
//     value: costingData.customer,
//     listToMap: "customerList"
//   },
//   "list"
// )
_this.costingPrintData({name:"departmentName",value:costingData.customerDepartmentId,listToMap:"customerList"},"list");_this.costingPrintData({name:"costingType",value:costingData.costingTypeList,listToMap:"costingTypeList"},"list");_this.costingPrintData({name:"sampleRequestId",value:costingData.sampleRequestId,listToMap:"sampleRequestNumbersList"},"list");_this.costingPrintFabricData();_this.costingPrintTrimData();_this.costingPrintEmbroideryData();_this.costingPrintEmbellishmentData();_this.costingPrintWashData();_this.costingPrintSmockingData();_this.costingPrintOtherChargesData();_this.costingPrintManufacturingData();},1000);},_this.getOneSmv=function(name,value){var costing=_this.state.costing;if(name==="smv100"||name==="minutesperDay"){var orderQty=Number(costing.manufacturingAndPieceCostDetails.orderQty);var sam=name==="smv100"&&Number(value)||0;var totalSmv=(sam/0.8).toFixed(2);var minutesperDay=name==="minutesperDay"&&Number(value)||Number(costing.manufacturingAndPieceCostDetails.minutesperDay);var smv80=Number(totalSmv);var smv100=name==="smv100"&&Number(value)||0;var tailers=Number(costing.manufacturingAndPieceCostDetails.noOftailors);var costPerTailer=Number(costing.manufacturingAndPieceCostDetails.costPertailor);var perMachine=Number(costing.manufacturingAndPieceCostDetails.perMachine);var targetPcsAt=minutesperDay/totalSmv;var avgOutputNeeded=orderQty/targetPcsAt;var daysFortailorLine=Number(avgOutputNeeded)/tailers;var totalDays=Number(daysFortailorLine)+2;//idle days
var totalCost1750=totalDays*tailers*costPerTailer;var revTailer=Number(totalCost1750)/Number(orderQty);var totalCost2800=totalDays*tailers*perMachine;var revMachine=Number(totalCost2800)/Number(orderQty);costing.manufacturingAndPieceCostDetails.smv=null;costing.manufacturingAndPieceCostDetails.minutesperDay=minutesperDay;costing.manufacturingAndPieceCostDetails.targetPcsAt=targetPcsAt;costing.manufacturingAndPieceCostDetails.avgOutputNeeded=avgOutputNeeded;costing.manufacturingAndPieceCostDetails.daysFortailorLine=daysFortailorLine;costing.manufacturingAndPieceCostDetails.totalDays=totalDays;costing.manufacturingAndPieceCostDetails.revMachine=Number(revTailer).toFixed(2);costing.manufacturingAndPieceCostDetails.revTailer=Number(revMachine).toFixed(2);costing.manufacturingAndPieceCostDetails.smv80=smv80;costing.manufacturingAndPieceCostDetails.smv100=smv100;costing.manufacturingAndPieceCostDetails.sam=sam;costing.manufacturingAndPieceCostDetails.totalSmv=totalSmv;costing.manufacturingAndPieceCost.CMT=revMachine.toFixed(2);costing.manufacturingAndPieceCost.CMTSelected=costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revTailer?"2800":costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revMachine?"1750":"";_this.setState({costing:costing},function(){return _this.updateCostTotal();});}else{if(!value){_this.props.getalertMessage("info","invalid smv request",5000);}else{__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getSMV(value).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){var orderQty,sam,totalSmv,minutesperDay,smv80,smv100,tailers,costPerTailer,perMachine,targetPcsAt,avgOutputNeeded,daysFortailorLine,totalDays,totalCost1750,revTailer,totalCost2800,revMachine;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:orderQty=Number(costing.manufacturingAndPieceCostDetails.orderQty);sam=Number(response.text.data.totalSam);totalSmv=(sam/0.8).toFixed(2);minutesperDay=Number(response.text.data.minutesPerDay);smv80=Number(totalSmv);smv100=Number(response.text.data.totalSam);tailers=Number(costing.manufacturingAndPieceCostDetails.noOftailors);costPerTailer=Number(costing.manufacturingAndPieceCostDetails.costPertailor);perMachine=Number(costing.manufacturingAndPieceCostDetails.perMachine);targetPcsAt=minutesperDay/totalSmv;avgOutputNeeded=orderQty/targetPcsAt;daysFortailorLine=Number(avgOutputNeeded)/tailers;totalDays=Number(daysFortailorLine)+2;//idle days
// console.log(totalSmv, "SMVVV", minutesperDay, targetPcsAt, avgOutputNeeded, daysFortailorLine, totalDays)
totalCost1750=totalDays*tailers*costPerTailer;revTailer=Number(totalCost1750)/Number(orderQty);totalCost2800=totalDays*tailers*perMachine;revMachine=Number(totalCost2800)/Number(orderQty);costing.manufacturingAndPieceCostDetails.smv=value;costing.manufacturingAndPieceCostDetails.minutesperDay=minutesperDay;costing.manufacturingAndPieceCostDetails.targetPcsAt=targetPcsAt;costing.manufacturingAndPieceCostDetails.avgOutputNeeded=avgOutputNeeded;costing.manufacturingAndPieceCostDetails.daysFortailorLine=daysFortailorLine;costing.manufacturingAndPieceCostDetails.totalDays=totalDays;costing.manufacturingAndPieceCostDetails.revMachine=Number(revTailer).toFixed(2);costing.manufacturingAndPieceCostDetails.revTailer=Number(revMachine).toFixed(2);costing.manufacturingAndPieceCostDetails.smv80=smv80;costing.manufacturingAndPieceCostDetails.smv100=smv100;costing.manufacturingAndPieceCostDetails.sam=sam;costing.manufacturingAndPieceCostDetails.totalSmv=totalSmv;costing.manufacturingAndPieceCost.CMT=revMachine.toFixed(2);costing.manufacturingAndPieceCost.CMTSelected=costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revTailer?"2800":costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revMachine?"1750":"";_this.setState({costing:costing},function(){return _this.updateCostTotal();});case 32:case"end":return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}}},_this.changeFabricNo=function(fabricNo,indexVal){_this.setState(_defineProperty({},"fabricNo"+indexVal,fabricNo));if(fabricNo!==null&&fabricNo.value!==undefined&&fabricNo.value!==""&&_this.state.sampleNo!==undefined){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getFabricName(_this.state.sampleNo,fabricNo).then(function(response){//
if(response.message==="Fabric details from sample request"){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSupplierInfo(fabricNo).then(function(response){if(response.message==="Fabric Supplier"){//
var jsonData=[];var fabricCountArray=_this.state.fabricCountArray;response.data.supplier.map(function(info,index){var objData={};objData.label=info.supplierName;objData.value=info._id;jsonData.push(objData);});fabricCountArray[indexVal].supplier=jsonData;_this.setState({fabricSupplier:jsonData,fabricCountArray:fabricCountArray},function(){//
});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});_this.setState(_defineProperty({},"selectedFabricInfo"+indexVal,response.data.fabric));}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSupplierInfo(fabricNo).then(function(response){if(response.message==="Fabric Supplier"){//
var jsonData=[];var fabricCountArray=_this.state.fabricCountArray;response.data.supplier.map(function(info,index){var objData={};objData.label=info.supplierName;objData.value=info._id;jsonData.push(objData);});fabricCountArray[indexVal].supplier=jsonData;_this.setState({fabricSupplier:jsonData,fabricCountArray:fabricCountArray},function(){});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}},_this.changeSupplierInfoForFabric=function(supplierNo,indexVal){//
_this.setState(_defineProperty({},"selectedSupplierInfo"+indexVal,supplierNo));},_this.changeSupplierNoForTrim=function(supplierNo,indexVal){_this.setState(_defineProperty({},"trimSupplierNo"+indexVal,supplierNo));},_this.changeTrimNo=function(trimNo,indexVal){_this.setState(_defineProperty({},"trimNo"+indexVal,trimNo));if(trimNo!==null&&trimNo.value!==undefined&&trimNo.value!==""){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getTrimName(_this.state.sampleNo,trimNo).then(function(response){if(response.message==="Trim details from sample request"){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSupplierInfoForTrim(trimNo).then(function(response){if(response.message==="Trim Supplier"){var jsonData=[];response.data.supplier.map(function(info,index){var objData={};objData.label=info.supplierName;objData.value=info._id;jsonData.push(objData);});var trimCountArray=_this.state.trimCountArray;trimCountArray[indexVal].supplier=jsonData;_this.setState({trimSupplier:jsonData,trimCountArray:trimCountArray});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});_this.setState(_defineProperty({},"selectedTrimInfo"+indexVal,response.data.trim));// this.setState({ customerInfo: response.data.customer, departmentInfo: response.data.department, styleInfo: response.data.magnumStyle })
}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}},_this.addFabric=function(){var costing=Object.assign({},_this.state.costing);costing.fabric.push(Object.assign({},fabricTemplate));var index=costing.fabric.length;_this.setState({costing:costing});_this.getFabricNumber("",index-1);},_this.removeFabric=function(index){var costing=Object.assign({},_this.state.costing);// costing.fabric[index].totalCost = 0
// console.log(costing.fabric[index].totalCost, "costing.fabric[index].totalCost")
// costing.fabricTotalCost = Number(costing.fabric.reduce((arr, cur) => arr + (cur.totalCost || 0), 0)).toFixed(2);
// console.log(costing.fabricTotalCost, "costing.fabricTotalCost")
// costing.fabric = costing.fabric.filter((data, i) => i !== index)
// Remove the selected fabric entry
costing.fabric=costing.fabric.filter(function(data,i){return i!==index;});// Calculate fabricTotalCost, ensuring each fabric entry's totalCost defaults to 0 if undefined or NaN
costing.fabricTotalCost=Number(costing.fabric.reduce(function(arr,cur){return arr+(Number(cur.totalCost)||0);},0)).toFixed(2);_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.getFabricInfo=function(fabric,index){var costing=Object.assign({},_this.state.costing);if(fabric!=null){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getFabricInfo(fabric.value).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(response.status==200){costing.fabric[index].qualityClassification=(response.text.data.quality!==null?response.text.data.quality.name:"")+" / "+(response.text.data.classificationOfFabric!==null?response.text.data.classificationOfFabric.name:"");costing.fabric[index].countAndConstruction=response.text.data.count.warp+"*"+response.text.data.count.weft+"/"+response.text.data.construction.warp+"*"+response.text.data.construction.weft;costing.fabric[index].fabricNumber=fabric.value;costing.fabric[index].printDirection=response.text.data.printDirection;costing.fabric[index].price=response.text.data.price;costing.fabric[index].supplierName=response.text.data.supplierName;costing.fabric[index].width=response.text.data.width;costing.fabric[index].valueLoss=response.text.data.valueLoss;costing.fabric[index].EmbValueLoss=response.text.data.EmbValueLoss;costing.fabric[index].greige=response.text.data.greige;costing.fabric[index].dyingPrint=response.text.data.dyingPrint;costing.fabric[index].upCharge=response.text.data.upcharge;costing.fabric[index].gst=response.text.data.gst;costing.fabric[index].embCost=response.text.data.embCost;costing.fabric[index].yardDyedCost=response.text.data.yardDyedCost;_this.setState({costing:costing},function(){costing.fabric.forEach(function(x,i){_this.calcTotalCost(null,null,i,"fabric");});});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status==401&&_this.props.unauthorisedFunc();case 3:case"end":return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref5.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{costing.fabric[index].fabricNumber=null;}_this.setState({costing:costing});},_this.getSupplierSectionList=function(_id,name){switch(name){case"fabric":__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getSupplierSectionFabric(_id).then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(response.status==200){_this.setState({supplierSectionList:response.text.data.supplier},function(){return _this.setState({supplier:name,modalToggle:true});});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}case 1:case"end":return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref6.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});break;case"trim":__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getSupplierSectionTrim(_id).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(response.status==200){_this.setState({supplierSectionList:response.text.data.supplier},function(){return _this.setState({supplier:name,modalToggle:true});});}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}case 1:case"end":return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref7.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});break;}},_this.selectSupplierSec=function(index){var costing=Object.assign({},_this.state.costing);var supplier=_this.state.supplier;costing[supplier][_this.state[supplier+"Index"]].supplierName=_this.state.supplierSectionList[index].supplier;costing[supplier][_this.state[supplier+"Index"]].price=_this.state.supplierSectionList[index].totalCost;// suppliers[
//   this.state[`${supplier}Index`]
// ].totalCost = (suppliers[this.state[`${supplier}Index`]].price * suppliers[this.state[`${supplier}Index`]].consumption).toFixed(2)
if(supplier==="trim"){// costing.trim[this.state.trimIndex][name] = value
var consumption=costing.trim[_this.state.trimIndex].consumption||0;var price=costing.trim[_this.state.trimIndex].price||0;costing.trim[_this.state.trimIndex].totalCost=consumption*price;costing.trimTotalCost=Number((Number(costing.trimPackTotalCost)||0)+Number(costing.trim.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0))).toFixed(2);}_this.setState({costing:costing,modalToggle:false},function(){if(supplier==='fabric'){_this.calcTotalCost(null,null,_this.state[supplier+"Index"],"fabric");}},function(){_this.updateCostTotal();});// costing.fabric[
//   this.state.fabricIndex
// ].supplierName = this.state.supplierSectionList[index].supplier
// costing.fabric[
//   this.state.fabricIndex
// ].price = this.state.supplierSectionList[index].totalCost
// this.setState({
//   costing,
//   modalToggle: false
// })
},_this.addTrim=function(){var costing=Object.assign({},_this.state.costing);costing.trim.push(Object.assign({},trimTemplate));_this.setState({costing:costing});},_this.removeTrim=function(index){var costing=Object.assign({},_this.state.costing);// Set the totalCost of the selected trim to 0 (if valid index)
if(costing.trim&&costing.trim[index]){costing.trim[index].totalCost=0;}// Safeguard the trimPackTotalCost
var trimPackTotalCost=Number(costing.trimPackTotalCost)||0;// Safeguard reduce to avoid NaN
var trimTotalCost=Array.isArray(costing.trim)?costing.trim.reduce(function(arr,cur){return arr+(cur.totalCost?Number(cur.totalCost):0);},0):0;// Update trimTotalCost
costing.trimTotalCost=Number(trimPackTotalCost+trimTotalCost).toFixed(2);// Filter out the trim at the given index
costing.trim=costing.trim?costing.trim.filter(function(_,i){return i!==index;}):[];// Update state and recalculate total cost
_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.updateTrim=function(name,value,index){var costing=Object.assign({},_this.state.costing);costing.trim[index][name]=value;if(name=="trimCategory"){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getTrimNumber(value,"").then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(response.status==200)costing.trim[index].trimList=response.text.data;_this.setState({costing:costing});case 2:case"end":return _context7.stop();}}},_callee7,_this2);}));return function(_x7){return _ref8.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.updateSmockingSheering=function(name,value,index){var costing=Object.assign({},_this.state.costing);if(value!==null){costing.smockingSheering[index][name]=value;}var _this$state$SHIRRINGO=_this.state.SHIRRINGORSMOCKING,smockingorElastic=_this$state$SHIRRINGO.smockingorElastic,toptthElastic=_this$state$SHIRRINGO.toptthElastic;if(!smockingorElastic||!toptthElastic){_this.props.getalertMessage("info","Create System master(SHIRRINGORSMOCKING)");}if(name=="trimCategory"){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getTrimNumber(value,"").then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(response.status==200)costing.smockingSheering[index].trimList=response.text.data;_this.setState({costing:costing});case 2:case"end":return _context8.stop();}}},_callee8,_this2);}));return function(_x8){return _ref9.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}else{var rows=costing.smockingSheering[index].noOfRow?costing.smockingSheering[index].noOfRow:0;var length=costing.smockingSheering[index].length?costing.smockingSheering[index].length:0;var type=costing.smockingSheering[index].type?costing.smockingSheering[index].type:"";var totalReq=0;var price=0;if(type==="Both Elastic"){//No of Rows *Length * 7 +10% (wastage)
var mult=Number(smockingorElastic.multiple);var wast=Number(smockingorElastic.wastage);totalReq=(rows*length*mult+rows*length*mult/wast).toFixed(2);price=costing.smockingSheering[index].price?costing.smockingSheering[index].price:null;costing.smockingSheering[index].totalReq=totalReq;costing.smockingSheering[index].price=price;costing.smockingSheering[index].totalCost=totalReq*price;}else if(type==="Top TTH / Bottom Elastic"){var _mult=toptthElastic.multiple;var _wast=toptthElastic.wastage;// No of Rows *Length * 4 +10% (wastage)
totalReq=(rows*length*_mult+rows*length*_mult/_wast).toFixed(2);price=costing.smockingSheering[index].price?costing.smockingSheering[index].price:"";costing.smockingSheering[index].totalReq=totalReq?totalReq:null;costing.smockingSheering[index].price=price?price:null;costing.smockingSheering[index].totalCost=(totalReq*price).toFixed(2);}costing.smockingSheeringTotalCost=costing.smockingSheering.reduce(function(arr,cur){return cur.totalCost?arr+Number(cur.totalCost):arr+0;},0).toFixed(2);_this.setState({costing:costing},function(){return _this.updateCostTotal();});}},_this.updateEmbellishment=function(name,value,index){var costing=Object.assign({},_this.state.costing);if(value){costing.embellishment[index][name]=value||"";}else{costing.embellishment[index][name]="";}// console.log(Math.round(moment.duration(moment(costing.embellishment[index].hoursMinutes).format('HH:mm'), 'minutes').asMinutes() / 30));
var hoursMinutes=costing.embellishment[index].hoursMinutes?Math.round(__WEBPACK_IMPORTED_MODULE_21_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_21_moment___default()(costing.embellishment[index].hoursMinutes).format("HH:mm"),"minutes").asMinutes()/1):"";var pricePerHalfHour=costing.embellishment[index].pricePerHalfHour?costing.embellishment[index].pricePerHalfHour:"";var pricePerMinute=pricePerHalfHour&&pricePerHalfHour*2/60||"";costing.embellishment[index].totalCost=Number(hoursMinutes*pricePerMinute).toFixed(2);var embelishmentTotalCost=costing.embellishment.reduce(function(arr,cur){return cur.totalCost?Number(arr)+Number(cur.totalCost):arr+0;},0);costing.embelishmentTotalCost=Number(embelishmentTotalCost).toFixed(2);_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.manufactureUpdate=function(name,value){var costing=Object.assign({},_this.state.costing);if(name==="fixedCharge"){costing.manufacturingAndPieceCost[name]=value;var cmt=costing.manufacturingAndPieceCost.CMT;costing.manufacturingAndPieceCost.totalCost=value+(cmt&&Number(cmt)||0);}else if(name==="sampleDate"||name==="patternDate"){costing.selectedMenu.date=value;}else if(name==="orderQty"){costing.manufacturingAndPieceCostDetails.orderQty=value;if(costing.manufacturingAndPieceCostDetails.smv){_this.getOneSmv(null,costing.manufacturingAndPieceCostDetails.smv);}else{_this.getOneSmv('smv100',costing.manufacturingAndPieceCostDetails.smv100||0);}}else if(name==="CMT"){costing.manufacturingAndPieceCost[name]=value;}else{costing.manufacturingAndPieceCostDetails[name]=value;if(name==="revTailer"){costing.manufacturingAndPieceCost.CMT=Number(value).toFixed(2);}}_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.updateManufacturingProcess=function(){var costing=Object.assign({},_this.state.costing);// Variables
var minutesperDay=costing.manufacturingAndPieceCostDetails.minutesperDay;var smv80=costing.manufacturingAndPieceCostDetails.smv80;var orderQty=costing.manufacturingAndPieceCostDetails.orderQty;var tailers=costing.manufacturingAndPieceCostDetails.noOftailors;var costPerTailer=costing.manufacturingAndPieceCostDetails.costPertailor;var perMachine=costing.manufacturingAndPieceCostDetails.perMachine;// Calculations
var targetPcsAt=minutesperDay/smv80;var avgOutputNeeded=orderQty/targetPcsAt;var daysFortailorLine=avgOutputNeeded/tailers;var totalDays=daysFortailorLine+2;//idle days
var totalCost1750=totalDays*tailers*costPerTailer;var revTailer=totalCost1750/orderQty;var totalCost2800=totalDays*tailers*perMachine;var revMachine=totalCost2800/orderQty;costing.manufacturingAndPieceCostDetails.minutesperDay=minutesperDay;costing.manufacturingAndPieceCostDetails.targetPcsAt=targetPcsAt;costing.manufacturingAndPieceCostDetails.avgOutputNeeded=avgOutputNeeded;costing.manufacturingAndPieceCostDetails.daysFortailorLine=daysFortailorLine;costing.manufacturingAndPieceCostDetails.totalDays=totalDays;costing.manufacturingAndPieceCostDetails.revMachine=revMachine.toFixed(2);costing.manufacturingAndPieceCostDetails.revTailer=revTailer.toFixed(2);costing.manufacturingAndPieceCost.CMT=revTailer.toFixed(2);costing.manufacturingAndPieceCost.CMTSelected=costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revTailer?"2800":costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revMachine?"1750":"";_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.updateWash=function(name,value,index){var costing=Object.assign({},_this.state.costing);if(name==="washType"){var _price=_this.state.washTypeList.find(function(x){return x.value===value;}).price;costing.wash[index].price=_price&&Number(_price).toFixed(2)||'0.00';}if(name){costing.wash[index][name]=value;}var weight=costing.wash[index].weight&&Number(costing.wash[index].weight)||0;var price=costing.wash[index].price&&Number(costing.wash[index].price)||0;costing.wash[index].totalCost=Number(weight*price).toFixed(2);costing.washTotalCost=costing.wash.reduce(function(arr,cur){return cur.totalCost?arr+Number(cur.totalCost):arr+0;},0).toFixed(2);_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.updateCostTotal=function(){var costing=Object.assign({},_this.state.costing);var _this$state$costing=_this.state.costing,fabricTotalCost=_this$state$costing.fabricTotalCost,trimTotalCost=_this$state$costing.trimTotalCost,embroideryTotalCost=_this$state$costing.embroideryTotalCost,backingTotalCost=_this$state$costing.backingTotalCost,embelishmentTotalCost=_this$state$costing.embelishmentTotalCost,washTotalCost=_this$state$costing.washTotalCost,otherTotalCost=_this$state$costing.otherTotalCost,smockingSheeringTotalCost=_this$state$costing.smockingSheeringTotalCost;var _costing$manufacturin=costing.manufacturingAndPieceCost,fixedCharge=_costing$manufacturin.fixedCharge,CMT=_costing$manufacturin.CMT;var totalCost=Number(fabricTotalCost||0)+Number(trimTotalCost||0)+Number(embroideryTotalCost||0)+Number(backingTotalCost||0)+Number(embelishmentTotalCost||0)+Number(washTotalCost||0)+Number(otherTotalCost||0)+// Number(trimPackTotalCost||0) +
Number(smockingSheeringTotalCost||0)+Number(fixedCharge||0)+Number(CMT||0);var overHeads=Number(_this.state.costing.manufacturingAndPieceCost.overHeads);var valueLoss=Number(_this.state.costing.manufacturingAndPieceCost.valueLoss);costing.manufacturingAndPieceCost.totalCost=totalCost.toFixed(2);costing.manufacturingAndPieceCost.valueLossCost=valueLoss*costing.manufacturingAndPieceCost.totalCost/100;costing.manufacturingAndPieceCost.overHeadsCost=overHeads*(Number(costing.manufacturingAndPieceCost.totalCost)+Number(costing.manufacturingAndPieceCost.valueLossCost))/100;costing.costingTotal=Number(totalCost)+Number(costing.manufacturingAndPieceCost.overHeadsCost)+Number(costing.manufacturingAndPieceCost.valueLossCost);costing.costingTotal=Number(costing.costingTotal).toFixed(2);setTimeout(function(){_this.setState({costing:costing},function(){return _this.convertOthers();});},100);},_this.convertOthers=function(){var _this$state=Object.assign({},_this.state),costing=_this$state.costing;// Check if it's "add" or "edit" mode based on currency data
var usd=void 0,gbp=void 0,eur=void 0;if(_this.state.action==="add"){//console.log(usd,gbp,eur,"usd,gpb,eur")
var _this$state$currencie=_this.state.currencies;// In "add" mode, always use currencies from this.state.currencies
usd=_this$state$currencie.usd;gbp=_this$state$currencie.gbp;eur=_this$state$currencie.eur;}else if(_this.state.action==="edit"){// In "edit" mode, first check if currencyConversion exists, otherwise use currencies
if(_this.state.costing&&_this.state.costing.currencyConversion){//console.log(usd,gbp,eur,"usd,gpb,eur")
var _this$state$costing$c=_this.state.costing.currencyConversion;usd=_this$state$costing$c.usd;gbp=_this$state$costing$c.gbp;eur=_this$state$costing$c.eur;}else{//console.log(usd,gbp,eur,"usd,gpb,eur")
var _this$state$currencie2=_this.state.currencies;// If currencyConversion does not exist, use values from currencies
usd=_this$state$currencie2.usd;gbp=_this$state$currencie2.gbp;eur=_this$state$currencie2.eur;}}costing.landedPrice=((Number(costing.costingTotal)||0)/usd).toFixed(2);// costing.agreedPrice = ((costing.costingTotal || 0) / usd).toFixed(2)
costing.usdTotal=((Number(costing.costingTotal)||0)/usd).toFixed(2);//console.log(costing.usdTotal,"usdTotal")
costing.gbpTotal=((Number(costing.costingTotal)||0)/gbp).toFixed(2);costing.euroTotal=((Number(costing.costingTotal)||0)/eur).toFixed(2);//console.log(costing, "costing")
//console.log(this.state.costing.euroTotal,"this.state.costing.euroTotal")
_this.setState({costing:costing},function(){return _this.landedCalc("shipmentTerm",costing.landedData.toValue);});},_this.getTrimRefNo=function(trimCategory,value,index,keyname){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getTrimNumber(trimCategory,value).then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(response){var costing;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(index.toString()){costing=Object.assign({},_this.state.costing);costing[keyname][index].trimList=response.text.data;_this.setState({costing:costing});}else{_this.setState({trimNumberList:response.text.data});}case 1:case"end":return _context9.stop();}}},_callee9,_this2);}));return function(_x9){return _ref10.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});},_this.getTrimInfo=function(trim,index,keyname){var costing=Object.assign({},_this.state.costing);if(keyname==="trim"){if(trim!==null){costing.trim[index].trimNumber=trim._id;costing.trim[index].description=trim.description;costing.trim[index].quality=trim.quality;costing.trim[index].sizeNumber=trim.sizeNumber;costing.trim[index].size=trim.sizeNumber+"-"+trim.size;costing.trim[index].unit=trim.unit;costing.trim[index].supplierName=trim.supplierName;costing.trim[index].price=trim.price;}else{costing.trim[index].trimNumber=null;}}else if(keyname==="smockingSheering"){var _costing=Object.assign({},_this.state.costing);if(trim!==null){_costing.smockingSheering[index].trimNumber=trim._id;_costing.smockingSheering[index].description=trim.description;_costing.smockingSheering[index].quality=trim.quality;_costing.smockingSheering[index].sizeNumber=trim.sizeNumber;_costing.smockingSheering[index].size=trim.size;_costing.smockingSheering[index].price=trim.price;}else{_costing.smockingSheering[index].trimNumber=null;}}setTimeout(function(){_this.setState({costing:costing});},1000);},_this.addSmocking=function(){var costing=Object.assign({},_this.state.costing);costing.smockingSheering.push(Object.assign({},smockingSheeringTemplate));_this.setState({costing:costing});},_this.removeSmocking=function(index){var costing=Object.assign({},_this.state.costing);costing.smockingSheering[index].totalCost=0;var cost=costing.smockingSheering.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0);costing.smockingSheeringTotalCost=Number(cost).toFixed(2);costing.smockingSheering=costing.smockingSheering.filter(function(data,i){return i!==index;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.addEmbroidery=function(){var costing=Object.assign({},_this.state.costing);costing.embroidery.push(Object.assign({},embroideryTemplate));_this.setState({costing:costing});},_this.removeEmbroidery=function(index){var costing=Object.assign({},_this.state.costing);costing.embroidery[index].totalCost=0;costing.embroideryTotalCost=Number(costing.embroidery.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0)).toFixed(2);costing.embroidery=costing.embroidery.filter(function(data,i){return i!==index;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.addBacking=function(){var costing=Object.assign({},_this.state.costing);costing.backing.push(Object.assign({},backingTemplate));_this.setState({costing:costing});},_this.removeBacking=function(index){var costing=Object.assign({},_this.state.costing);var totalCost=costing.backing.find(function(x,i){return i==index;}).totalCost;costing.backingTotalCost=Number(costing.backingTotalCost)-Number(totalCost);costing.backing=costing.backing.filter(function(data,i){return i!==index;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.addEmbellishment=function(){var costing=Object.assign({},_this.state.costing);costing.embellishment.push(Object.assign({},embellishmentTemplate));_this.setState({costing:costing});},_this.removeEmbellishment=function(index){var costing=Object.assign({},_this.state.costing);costing.embellishment[index].totalCost=0;costing.embelishmentTotalCost=Number(Number(costing.embellishment.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0))).toFixed(2);costing.embellishment=costing.embellishment.filter(function(data,i){return i!==index;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.addWash=function(){var costing=Object.assign({},_this.state.costing);costing.wash.push(Object.assign({},washTemplate));_this.setState({costing:costing});},_this.removeWash=function(index){var costing=Object.assign({},_this.state.costing);costing.wash[index].totalCost=0;costing.washTotalCost=Number(costing.wash.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0)).toFixed(2);costing.wash=costing.wash.filter(function(data,i){return i!==index;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.addGirlsWearArray=function(e,keyName,index){var _e$target=e.target,name=_e$target.name,value=_e$target.value;var costing=Object.assign({},_this.state.costing);var grouping=[].concat(_toConsumableArray(costing.girlsWearing.grouping));grouping=grouping.map(function(data,i){var x=Object.assign({},data);if(x.name===keyName){x.values=x.values.map(function(y,j){if(index===j){y.value=Number(value)||0;}return y;});}x.total=x.values.reduce(function(acc,c){return(Number(c.value)||0)+acc;},0);return x;});costing.girlsWearing.grouping=[].concat(_toConsumableArray(grouping));costing.girlsWearing.groupTotal=grouping.reduce(function(x,ac){return x+(ac.total||0);},0);_this.setState({costing:costing},function(){return _this.toQuate();});},_this.toQuate=function(){var costing=Object.assign({},_this.state.costing);if(costing.girlsWearing&&Object.keys(costing.girlsWearing).length)if(!costing.landedData||!costing.landedData.totalLandedValue){// costing.landedData.totalLandedValue = 6.50 //SHOULD DELETE
_this.props.getalertMessage("info","Total landed cost Empty!",5000);}else{var total=Number(costing.landedData.totalLandedValue);var grouping=[].concat(_toConsumableArray(costing.girlsWearing.grouping));var groupTotal=costing.girlsWearing.groupTotal||0;var obj={};//A,B,C,D,...
var obj1={};//A+B,C+D,...
var obj2={};//(C+D/groupTotal),(A+B/groupTotal),..
var obj3={};//(A/A+B),(B/A+B),..
var obj4={};// TOTAL-(C+D),TOTAL-(A+B), ...
var obj5={};//
grouping.forEach(function(x,i){var charAt=String.fromCharCode(65+i);obj[charAt]=x.total;});var j=0;var i,length=Object.keys(obj).length;for(i=0;i<length;){var one=Number(obj[Object.keys(obj)[i]]);var two=Number(obj[Object.keys(obj)[i+1]]);var s=String.fromCharCode(65+j);obj1[s]=Number(one+two);obj3[String.fromCharCode(65+(i?i+1:i+1))]=Number(Number(one)/Number(obj1[s])).toFixed(2);obj3[String.fromCharCode(65+(i?i:0))]=Number(Number(two)/Number(obj1[s])).toFixed(2);i=i+2;j++;}// Object.keys(obj3).map(x => { obj3[x] = Number(obj3[x]).toFixed(2) })
Object.keys(obj1).map(function(x,i){var charAt=String.fromCharCode(65+i);obj2[charAt]=Number(obj1[Object.keys(obj1)[i]]/groupTotal).toFixed(2);});Object.keys(obj2).reverse().map(function(x,i){var charAt=String.fromCharCode(65+i);if((i+1)%2==0){obj4[charAt]=Number(total+Number(obj2[x])).toFixed(2);}else{obj4[charAt]=Number(total-Number(obj2[x])).toFixed(2);}});var k=0;Object.keys(obj4).forEach(function(x,i){var charAt1=String.fromCharCode(65+k);var charAt2=String.fromCharCode(65+(k?k+1:k+1));obj5[charAt1]=Number(Number(obj4[x])-Number(obj3[Object.keys(obj3)[k+1]])).toFixed(2);obj5[charAt2]=Number(Number(obj4[x])+Number(obj3[Object.keys(obj3)[k]])).toFixed(2);k=k+2;});costing.girlsWearing.toQuote=Object.values(obj5).map(function(x){return Number(x);});costing.girlsWearing.canQuote=Object.values(obj5).map(function(x){return 0.0;});costing.girlsWearing.agreedQuote=Object.values(obj5).map(function(x){return 0.0;});costing.girlsWearing.toQuateAvg=costing.girlsWearing.toQuote.reduce(function(ac,c,i){return Number(ac)+Number(c)*Number([obj[Object.keys(obj)[i]]]);},0);costing.girlsWearing.toQuateAvg=(Number(costing.girlsWearing.toQuateAvg)/Number(groupTotal)).toFixed(2);_this.setState({costing:costing});}},_this.canQuote=function(e,index){var _e$target2=e.target,name=_e$target2.name,value=_e$target2.value;var costing=_this.state.costing;var grouping=costing.girlsWearing.grouping;var groupTotal=costing.girlsWearing.groupTotal||0;var obj={};//A,B,C,D,...
grouping.forEach(function(x,i){var charAt=String.fromCharCode(65+i);obj[charAt]=x.total;});costing.girlsWearing.canQuote=costing.girlsWearing.canQuote.map(function(x,i){if(i==index){x=Number(value);return x;}return Number(x);});costing.girlsWearing.canQuateAvg=costing.girlsWearing.canQuote.reduce(function(ac,c,i){return Number(ac)+Number(c)*Number([obj[Object.keys(obj)[i]]]);},0);costing.girlsWearing.canQuateAvg=(Number(costing.girlsWearing.canQuateAvg)/Number(groupTotal)).toFixed(2);_this.setState({costing:costing});},_this.agreedQuote=function(e,index){var _e$target3=e.target,name=_e$target3.name,value=_e$target3.value;var costing=_this.state.costing;var grouping=costing.girlsWearing.grouping;var groupTotal=costing.girlsWearing.groupTotal||0;var obj={};//A,B,C,D,...
grouping.forEach(function(x,i){var charAt=String.fromCharCode(65+i);obj[charAt]=x.total;});costing.girlsWearing.agreedQuote=costing.girlsWearing.agreedQuote.map(function(x,i){if(i==index){x=Number(value);return x;}return Number(x);});costing.girlsWearing.agreedQuoteAvg=costing.girlsWearing.agreedQuote.reduce(function(ac,c,i){return Number(ac)+Number(c)*Number([obj[Object.keys(obj)[i]]]);},0);costing.girlsWearing.agreedQuoteAvg=(Number(costing.girlsWearing.agreedQuoteAvg)/Number(groupTotal)).toFixed(2);_this.setState({costing:costing});},_this.openPrint=function(val){var costingPrint=JSON.parse(JSON.stringify(_this.state.costingPrint));_this.setState({costingPrint:costingPrint,printLoading:true},function(){var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);_this.onPrintFinished(newWin.print());newWin.close();});},_this.onPrintFinished=function(){if(_this.state.action!=="view"){_this.props.history.push("/CostingPage",{action:_this.state.action,_id:_this.state._id});}// setTimeout(() => document.location.reload(true), 100)
},_this.toggleChange=function(name,value){var costing=Object.assign({},_this.state.costing);costing.toggle[name]=value;if(value==false){costing[(name==="embellishment"&&"embelishment"||name)+"TotalCost"]=0.0;if(name==="trim"){costing.trimPackTotalCost=0.0;costing.trimPack={};}else if(name==="embroidery"){costing.backing=[];costing.embroideryBacking=false;costing.bitAttaching=false;costing.backingTotalCost=0.0;}if(Array.isArray(costing[name])){costing[name]=[];}else{costing[name]={};}_this.setState({costing:costing},function(){return _this.updateCostTotal();});}else{costing[name]=[];_this.setState({costing:costing},function(){return _this.updateCostTotal();});}if(name==='girlsWearing'&&_this.state.costing.customer){if(value==true){_this._handleCustDeptChange(null,_this.state.costing.customer,_this.state.costing.customerDepartmentId);}}},_this.toggleModal=function(){_this.setState({modalToggle:true});},_this.closeModal=function(){_this.setState({modalToggle:false});},_this.goToDiv=function(moduleName){var ele=document.getElementById(moduleName);ele.scrollIntoView({behavior:"smooth",block:"center"});},_this._handleCustDeptChange=function(name,customer,customerDepartmentId){var costing=Object.assign({},_this.state.costing);costing.customer=customer;costing.customerDepartmentId=customerDepartmentId;// setTimeout(() => {
//   this.setState({ costing })
// }, 10)
if(customer){__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].getCustomer(customer).then(function(res){if(res.status===200){var result=res.text.data.departments;result=result.find(function(x){return x._id.toString()===customerDepartmentId;});costing.manufacturingAndPieceCost.fixedCharge=costing.manufacturingAndPieceCost.fixedCharge||Number(res.text.data.fabricBasicRequirements.fixedCharge).toFixed(2)||"0.00";if(result.priceQuoteMethod==="SINGLE"){var fabricSizeList=result.priceQuotesizeSingle&&result.priceQuotesizeSingle.length>0?result.priceQuotesizeSingle.filter(function(x){return Boolean(x.size);}).map(function(x){return{label:x.period&&(x.size+" "+x.period).trim()||x.size,value:x.period&&(x.size+" "+x.period).trim()||x.size};}):[];costing.girlswear=false,_this.setState({// costing,
fabricSizeList:fabricSizeList});}else{if(_this.state.action==="add"||Array.isArray(costing.girlsWearing)&&!costing.girlsWearing.length||!costing.girlsWearing){// costing.toggle.girlsWearing = true
girlsTable=[];var girlsWearing=[];result.priceQuotesizeMultiple.forEach(function(x,i){var obj={};obj.name=x.start+"-"+x.end+(x.period?x.period.toUpperCase():"");var table=[];for(var j=Number(x.start);j<=Number(x.end);j++){table.push({to:j,value:0});}obj.values=table;obj.total=obj.values.reduce(function(x,ac){return x+(ac.value||0);},0);girlsWearing.push(obj);});costing.girlsWearing.grouping=girlsWearing;costing.girlsWearing.groupTotal=girlsWearing.reduce(function(x,ac){return x+(ac.total||0);},0);}var _fabricSizeList=result.priceQuotesizeMultiple&&result.priceQuotesizeMultiple.length>0?result.priceQuotesizeMultiple.map(function(x){return x.start&&{label:x.end&&(x.start+"-"+x.end+" "+(x.period||'')).trim()||x.start,value:x.end&&(x.start+"-"+x.end+" "+(x.period||'')).trim()||x.start};}):[];_this.setState({// costing,
// girlswearData,
isLoading:false,fabricSizeList:_fabricSizeList});}if(result.trimPack&&result.trimPack.length>0){var trimPackList=result.trimPack.map(function(x){return{label:x.trimPackNo,value:x.trimPackNo};});if(costing.trimPack&&!costing.trimPack.totalAmount){tempTrimPack=result.trimPack.map(function(x){x.price=x.totalAmount;x.consumption=x.consumption&&Number(x.consumption).toFixed(2)||"0.00";return x;});var trPack=result.trimPack.find(function(x){return x.default==true;});console.log(result.trimPack,"trPacktrPack");console.log(trPack,"trPacktrPack");if(trPack&&trPack.price){trPack.price=Number(trPack.price).toFixed(2);}else{trPack={price:'0.00'};}costing.trimPack=trPack;}_this.setState({trimPackList:trimPackList});}}}).then(function(){console.log("here","trPacktrPack");_this.setState({costing:costing});}).catch(function(err){_this.props.getalertMessage("error",err.text.message);});}else{console.log(costing.trimPack,"trPacktrPack");_this.setState({costing:costing});}},_this._handleInputChange=function(name,value){var costing=Object.assign({},_this.state.costing);if(name==="sampleRequestId"){_this.changeSampleNo(value);}else{costing[name]=value;_this.setState({costing:costing});}},_this.getFabricNumber=function(value,i){__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){var costing=_this.state.costing;costing.fabric[i].fabricList=response.text.data;_this.setState({costing:costing});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.addOtherCost=function(){var costing=Object.assign({},_this.state.costing);costing.otherCostDetails.push({label:"",value:"0.00"});_this.setState({costing:costing});},_this.removeOtherCost=function(index){var costing=Object.assign({},_this.state.costing);costing.otherCostDetails[index].totalCost=0;costing.otherTotalCost=Number(costing.otherCostDetails.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0)).toFixed(2);costing.otherCostDetails=costing.otherCostDetails.filter(function(d,i){return index!==i;});_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.updateOtherCostdetails=function(name,value,index){var costing=Object.assign({},_this.state.costing);costing.otherCostDetails[index][name]=value;if(name==="value"){var otherTotalCost=costing.otherCostDetails.reduce(function(arr,cur){return cur.value?arr+Number(cur.value):arr+0;},0);costing.otherTotalCost=otherTotalCost.toFixed(2);}_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.getTrimPack=function(customer,customerDepartmentId){__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getTrimPackByCustomer(customer,customerDepartmentId).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(response){var costing,trimPackList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(response.status==200){if(Object.keys(response.text.data).length){costing=Object.assign({},_this.state.costing);trimPackList=response.text.data.map(function(x){return{label:x.trimPackNo,value:x.trimPackNo};});tempTrimPack=response.text.data;if(_this.state.action!=='add'){if(costing.trimPack&&costing.trimPack.trimPackNo)tempTrimPack.map(function(x){if(x.trimPackNo===costing.trimPack.trimPackNo){x.consumption=costing.trimPack.consumption;}});}else{costing.trimPack=response.text.data.find(function(x){return x.default==true;});}setTimeout(function(){_this.setState({trimPackList:trimPackList,costing:costing});},100);}}case 1:case"end":return _context10.stop();}}},_callee10,_this2);}));return function(_x10){return _ref11.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.updateTrimPack=function(name,val){var costing=_this.state.costing;if(name==="trimPackList"){var trimPackList=_this.state.trimPackList;tempTrimPack=tempTrimPack.map(function(x){x.default=false;if(x.trimPackNo===val){x.default=true;var consumption=costing.trimPack.consumption?costing.trimPack.consumption:0.0;costing.trimPack=x;costing.trimPack.consumption=consumption;costing.trimPackTotalCost=((costing.trimPack.price?Number(costing.trimPack.price):0.0)*(costing.trimPack.consumption?Number(costing.trimPack.consumption):0.0)).toFixed(2);costing.trimTotalCost=Number((Number(costing.trimPackTotalCost)||0)+Number(costing.trim.reduce(function(arr,cur){return(cur.totalCost||0)+arr;},0))).toFixed(2);}return x;});}_this.setState({costing:costing});},_this.getFabric=function(value,index){var costing=Object.assign({},_this.state.costing);costing.fabric[index].fabricNumber=value!==null?value.value:null;_this.setState({costing:costing});},_this.updateValModules=function(name,value,index,keyName){// embroideryData.stitchesMtr
var costing=Object.assign({},_this.state.costing);costing[keyName][index][name]=value;if(name==="embForm"){costing[keyName][index].priceForStitches=_this.state.embFormList.find(function(x){return x.label===value;}).price;if(value.toLowerCase()==='panel'){costing[keyName][index].stitchesMtr="";costing[keyName][index].consumption="";}}if(keyName==="embroidery"&&name==="consumption"||keyName==="embroidery"&&name==="stitchesMtr"){var consumption=costing.embroidery[index].consumption?costing.embroidery[index].consumption:0;var stitches=costing.embroidery[index].stitchesMtr?costing.embroidery[index].stitchesMtr:0;costing.embroidery[index].stitchCount=(consumption*stitches).toFixed(2);}_this.setState({costing:costing},function(){_this.calcTotalCost(name,value,index,keyName);// this.updateCostTotal()
});},_this.calcTotalCost=function(name,value,index,keyName){var costing=Object.assign({},_this.state.costing);if(keyName==="embroidery"){costing[keyName][index][name]=value;var stitchCount=costing[keyName][index].stitchCount?costing[keyName][index].stitchCount:0;var priceForStitches=costing[keyName][index].priceForStitches?costing[keyName][index].priceForStitches:0;costing[keyName][index].totalCost=Number(stitchCount)*Number(priceForStitches)/1000;costing[keyName+"TotalCost"]=costing[keyName].reduce(function(arr,cur){return cur.totalCost?arr+Number(cur.totalCost):arr+0;},0).toFixed(2);setTimeout(function(){_this.setState({costing:costing},function(){_this.updateCostTotal(),_this.landedCalc("shipmentTerm",costing.landedData.toValue);});},500);}else if(keyName==="trimPack"){costing[keyName][name]=value;costing.trimTotalCost=costing.trimTotalCost-costing.trimPackTotalCost;costing.trimPackTotalCost=((costing[keyName].price?Number(costing[keyName].price):0.0)*(costing[keyName].consumption?Number(costing[keyName].consumption):0.0)).toFixed(2);costing.trimTotalCost=Number(Number(costing.trimTotalCost)+Number(costing.trimPackTotalCost)).toFixed(2);_this.setState({costing:costing},function(){_this.updateCostTotal(),_this.landedCalc("shipmentTerm",costing.landedData.toValue);});}else{costing[keyName][index][name]=value;// const consumption = costing[keyName][index].consumption || 0
// const price = costing[keyName][index].price || 0
// const greige = costing[keyName][index].greige || 0
// const gst = costing[keyName][index].gst || 0
// costing[keyName][index].totalCost = consumption * greige * price % gst
var totalCost=void 0;var consumption=parseFloat(costing[keyName][index].consumption)||0;// const gst = parseFloat(costing[keyName][index].gst) || this.state.gst || 0;
if(costing[keyName][index].emb){var embCost=parseFloat(costing[keyName][index].embCost);var greige=parseFloat(costing[keyName][index].greige)||0;var valueLossData=_this.state.valueLoss.find(function(data){return data.value===costing[keyName][index].valueLoss;});var valueLoss=valueLossData?parseFloat(valueLossData.label)||1:1;//console.log(valueLoss,"valueloss")
var embValueLossData=_this.state.valueLoss.find(function(data){return data.value===costing[keyName][index].EmbValueLoss;});var embValueLoss=embValueLossData?parseFloat(embValueLossData.label)||1:1;//console.log(embValueLoss,"emb")
var dyingPrintData=_this.state.dyingPrint.find(function(data){return data.value===costing[keyName][index].dyingPrint;});var dyingPrint=dyingPrintData?parseFloat(dyingPrintData.label)||0:0;var upChargeData=_this.state.upCharge.find(function(data){return data.value===costing[keyName][index].upcharge;});var upCharge=upChargeData?parseFloat(upChargeData.label)||0:0;var gst=parseFloat(_this.state.gst)||0;// Emb Calculation
var greVal=greige/valueLoss;//console.log(greVal);
var greEmbVal=greVal+embCost;//console.log(greEmbVal);
var embVal=greEmbVal/embValueLoss;//console.log(embVal);
var dyingPrintVal=embVal+dyingPrint;//console.log(dyingPrintVal,"dyingPrintVal");
var upChargeVal=dyingPrintVal*upCharge/100;//console.log(upChargeVal,"upChargeVal");
var finalUpcharge=upChargeVal+dyingPrintVal;//console.log(finalUpcharge,"finalUpcharge");
var gstCal=finalUpcharge*gst/100;//console.log(gstCal,"gstCal");
// const baseCost = (((greige / valueLoss) + (embCost / valueLoss) + dyingPrint) % gst) +
// ((greige / valueLoss) + (embCost / valueLoss) + dyingPrint);
// const roundedBaseCost = Math.ceil(baseCost);
var baseCost=gstCal+finalUpcharge;//console.log("baseCost", baseCost);
//const roundedBaseCost = Math.ceil(baseCost);
var roundedBaseCost=parseFloat(baseCost.toFixed(2));if(isNaN(roundedBaseCost)){costing[keyName][index].price=0.00;totalCost=0.00;}else{costing[keyName][index].price=roundedBaseCost;totalCost=roundedBaseCost*consumption;}// costing[keyName][index].price = roundedBaseCost;
// //console.log(costing[keyName][index].price,"price")
// totalCost = roundedBaseCost * consumption;
}else if(costing[keyName][index].yarn){var yarnDyedValue=parseFloat(costing[keyName][index].yardDyedCost);var _gst=parseFloat(_this.state.gst)||0;var _upChargeData=_this.state.upCharge.find(function(data){return data.value===costing[keyName][index].upcharge;});var _upCharge=_upChargeData?parseFloat(_upChargeData.label)||0:0;var _upChargeVal=yarnDyedValue*_upCharge/100;var _finalUpcharge=_upChargeVal+yarnDyedValue;var ydValue=_finalUpcharge*_gst/100;var _baseCost=ydValue+_finalUpcharge;//const roundedBaseCost = Math.ceil(baseCost);
var _roundedBaseCost=parseFloat(_baseCost.toFixed(2));if(isNaN(_roundedBaseCost)){costing[keyName][index].price=0.00;totalCost=0.00;}else{costing[keyName][index].price=_roundedBaseCost;totalCost=_roundedBaseCost*consumption;}// costing[keyName][index].price = roundedBaseCost;
// totalCost = roundedBaseCost * consumption;
}// Greige case
else if(costing[keyName][index].greige){var _greige=parseFloat(costing[keyName][index].greige)||0;var _valueLossData=_this.state.valueLoss.find(function(data){return data.value===costing[keyName][index].valueLoss;});var _valueLoss=_valueLossData?parseFloat(_valueLossData.label)||1:1;var _dyingPrintData=_this.state.dyingPrint.find(function(data){return data.value===costing[keyName][index].dyingPrint;});var _dyingPrint=_dyingPrintData?parseFloat(_dyingPrintData.label)||0:0;var _gst2=parseFloat(_this.state.gst)||0;var _upChargeData2=_this.state.upCharge.find(function(data){return data.value===costing[keyName][index].upcharge;});var _upCharge2=_upChargeData2?parseFloat(_upChargeData2.label)||0:0;var _greVal=_greige/_valueLoss;//console.log(greVal,"greVal");
var _dyingPrintVal=_greVal+_dyingPrint;//console.log(dyingPrintVal,"dyingPrintVal");
var _upChargeVal2=_dyingPrintVal*_upCharge2/100;//console.log(upChargeVal,"upChargeVal");
var _finalUpcharge2=_upChargeVal2+_dyingPrintVal;//console.log(finalUpcharge,"finalUpcharge");
var gstVal=_finalUpcharge2*_gst2/100;//console.log(gstVal,"gstVal");
// Greige calculation
var _baseCost2=gstVal+_finalUpcharge2;//console.log("baseCost", baseCost);
//const roundedBaseCost = Math.ceil(baseCost);
var _roundedBaseCost2=parseFloat(_baseCost2.toFixed(2));// costing[keyName][index].price = roundedBaseCost;
// totalCost = roundedBaseCost * consumption;
if(isNaN(_roundedBaseCost2)){costing[keyName][index].price=0.00;totalCost=0.00;}else{costing[keyName][index].price=_roundedBaseCost2;totalCost=_roundedBaseCost2*consumption;}}// Default case
else{var price=parseFloat(costing[keyName][index].price)||0;// Default calculation (simple multiplication of consumption and price)
totalCost=consumption*price;}// console.log(greige, valueLoss, dyingPrint, gst, consumption, price,baseCost.toFixed(2), "costing")
// console.log(totalCost,"totalCost")
// Update the totalCost in the state
costing[keyName][index].totalCost=totalCost.toFixed(2);//costing[`${keyName}TotalCost`] = costing[keyName].reduce((arr, cur) => (cur.totalCost ? arr + cur.totalCost : arr + 0), 0 ) .toFixed(2)
if(keyName==="trim"){//costing[`${keyName}TotalCost`] = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing[keyName].reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
costing[keyName+"TotalCost"]=Number((Number(costing.trimPackTotalCost)||0)+Number(Array.isArray(costing[keyName])?costing[keyName].reduce(function(arr,cur){return arr+(cur&&cur.totalCost?Number(cur.totalCost):0);},0):0)).toFixed(2);}else{costing[keyName+"TotalCost"]=Number(costing[keyName].reduce(function(arr,cur){return(Number(cur.totalCost)||0)+arr;},0)).toFixed(2);}_this.setState({costing:costing},function(){_this.updateCostTotal(),_this.landedCalc("shipmentTerm",costing.landedData.toValue);});}},_this.updateValMod=function(name,value,keyName){var costing=Object.assign({},_this.state.costing);costing[keyName][name]=value;_this.setState({costing:costing});},_this.updateMain=function(name,value){var costing=Object.assign({},_this.state.costing);costing[name]=value;_this.setState({costing:costing});},_this.landedCalc=function(name,value){var costing=Object.assign({},_this.state.costing);if(name==="shipmentTerm"){var _this$state$costing2=Object.assign({},_this.state.costing),usdTotal=_this$state$costing2.usdTotal;var _this$state$costing$l=Object.assign({},_this.state.costing.landedData),conversionRate=_this$state$costing$l.conversionRate,freightCharges=_this$state$costing$l.freightCharges,duty=_this$state$costing$l.duty,processingCost=_this$state$costing$l.processingCost;var toValue=value,rateValue=usdTotal/Number(conversionRate),freightChargesTotal=rateValue+Number(freightCharges),dutyValue=freightChargesTotal*Number(duty),processValue=dutyValue+Number(processingCost);costing.landedData=Object.assign({},costing.landedData,{toValue:toValue,rateValue:rateValue.toFixed(2),freightChargesTotal:freightChargesTotal.toFixed(2),dutyValue:dutyValue.toFixed(2),processValue:processValue.toFixed(2),totalLandedValue:processValue.toFixed(2)});costing.shipmentTerm=value;}_this.setState({costing:costing},function(){return _this.toQuate();});},_this.landedWorkingCalculation=function(e){var landedData=Object.assign({},_this.state.costing.landedData);if(e&&e.target){var _e$target4=e.target,name=_e$target4.name,value=_e$target4.value;landedData[name]=Number(value).toFixed(3);}// let { usdTotal } = this.state.costing;
var Total=0;var sectdCurncy=_this.state.costing.selectedConversion;Total=_this.state.costing[sectdCurncy+"Total"];var _landedData=landedData,conversionRate=_landedData.conversionRate,freightCharges=_landedData.freightCharges,duty=_landedData.duty,processingCost=_landedData.processingCost;var toValue=_this.state.costing.shipmentTerm,rateValue=Total/Number(conversionRate),freightChargesTotal=rateValue+Number(freightCharges),dutyValue=freightChargesTotal*Number(duty),processValue=dutyValue+Number(processingCost);landedData=Object.assign({},landedData,{toValue:toValue,rateValue:rateValue.toFixed(2),freightChargesTotal:freightChargesTotal.toFixed(2),dutyValue:dutyValue.toFixed(2),processValue:processValue.toFixed(2),totalLandedValue:processValue.toFixed(2)// costing.shipmentTerm = value
});_this.setState({costing:Object.assign({},_this.state.costing,{landedData:landedData})},function(){return _this.toQuate();});},_this.checkValidation=function(){if(_this.validateArrayObject(_this.state.costing,"costingType",null)){_this.createCosting();return true;}else{_this.props.getalertMessage("error","Please select a Costing Type",6000);return false;}},_this.currencyConverter=function(e){var _e$target5=e.target,name=_e$target5.name,value=_e$target5.value;var costing=_this.state.costing;var toCurrencyConversion=value;costing.toCurrencyConversion=toCurrencyConversion;_this.setState({costing:costing});},_this.calConsumPrice=function(){setTimeout(function(){var costing=_this.state.costing;var trimPackTotalCost=costing.trimPack?Number(costing.trimPack.price?costing.trimPack.price:0.0)*Number(costing.trimPack.consumption?costing.trimPack.consumption:0.0):0.0;if(!!costing.fabric){costing.fabric.forEach(function(x,i){_this.calcTotalCost(null,null,i,"fabric");});}if(!!costing.embellishment){costing.embellishment.forEach(function(x,i){_this.updateEmbellishment(null,null,i);});}// if (!!costing.smockingSheering) {
//   costing.smockingSheering.forEach((x, i) => {
//     this.updateSmockingSheering(null, null, i)
//   })
// }
if(!!costing.trim){costing.trim.forEach(function(x,i){_this.calcTotalCost(null,null,i,"trim");});}if(!!costing.embroidery){costing.embroidery.forEach(function(x,i){_this.calcTotalCost(null,null,i,"embroidery");});}if(!!costing.wash){costing.wash.forEach(function(x,i){_this.updateWash(null,null,i);});}costing.trimPackTotalCost=trimPackTotalCost.toFixed(2);_this.setState({costing:costing,isLoading:false});},500);},_this.changeToDecimal=function(e,i,keyName){var costing=_this.state.costing;var _e$target6=e.target,name=_e$target6.name,value=_e$target6.value;if(!value||value==='0.00'){_this.props.getalertMessage("info","Provide Valid Entry",9000);if(i){costing[keyName][i][name]=parseFloat("0").toFixed(2);}else{costing[keyName][name]=parseFloat("0").toFixed(2);}}else{if(i!=null){costing[keyName][i][name]=Number(value).toFixed(2);}else{costing[keyName][name]=Number(value).toFixed(2);}}_this.setState({costing:costing});},_this.selectedConversion=function(e){var _e$target7=e.target,name=_e$target7.name,value=_e$target7.value;var costing=Object.assign({},_this.state.costing);costing.selectedConversion=name;costing.toCurrencyConversion=name==="euro"&&"eur"||name;costing.landedPrice=costing[name+"Total"];_this.setState({costing:costing},function(){return _this.landedWorkingCalculation();});},_this.changeCMT=function(e){if(e.target.value){var costing=Object.assign({},_this.state.costing);costing.manufacturingAndPieceCost.CMT=e.target.value;costing.manufacturingAndPieceCost.CMTSelected=costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revTailer?"2800":costing.manufacturingAndPieceCost.CMT===costing.manufacturingAndPieceCostDetails.revMachine?"1750":"";_this.setState({costing:costing},function(){return _this.updateCostTotal();});}},_this.leaveCostingPage=function(obj){var nextPage=obj.nextPage;Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref12){var onClose=_ref12.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"You want to Leave this page?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.setState({costingPageLeave:true});if(_this.checkValidation()){setTimeout(function(){nextPage();onClose();},1000);}else{onClose();}}},"Yes"));},closeOnClickOutside:true});},_this.confirmDuplicate=function(){Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref13){var onClose=_ref13.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:" p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:function onClick(){return onClose();},className:"close"},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Do you want to create a duplicate Costing sheet?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.dumpState();onClose();}},"Yes"));},closeOnClickOutside:true});},_this.dumpState=function(){__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].costingNumber().then(function(response){if(response.status==200){var costing=Object.assign({},_this.state.costing);costing.costingNumber=response.text.data.costingNumber;costing.createdAt=new Date();costing.orderDate=new Date();delete costing._id;_this.setState({costing:costing,action:"add",_id:""});_this.props.getalertMessage("success","Costing Sheet Successfully Duplicated!",4000);}else if(response.status==401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.goBackCosting=function(){var _this$state2=Object.assign({},_this.state),action=_this$state2.action;if(action!=="view"){Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref14){var onClose=_ref14.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:function onClick(){return onClose();},className:"close"},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"You are about to leave this page"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Would you like to save before exiting?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this.props.history.push({pathname:"/list",state:{moduleName:'COSTING',type:"list"}});onClose();// if (this.state.goBack >= -1) {
//   this.props.history.goBack()
// } else {
//   this.props.history.go(this.state.goBack)
//   onClose()
// }
}},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){if(_this.checkValidation()){setTimeout(function(){// this.props.history.goBack()
_this.props.history.push({pathname:"/list",state:{moduleName:'COSTING',type:"list"}});onClose();},1000);}else{onClose();}}},"Yes"));},closeOnClickOutside:true});}else{_this.props.history.goBack();}},_this.curSymbol=function(data){switch(data){case"usd":return"$";case"gbp":return"£";case"eur":return"€";default:return"$";}},_this.setTitle=function(value,arr){if(value){return arr.find(function(x){return x.value===value;}).label;}},_this.preventSpecialChars=function(e){var invalidChars=['-','+','e','E','.'];if(invalidChars.includes(e.key)){e.preventDefault();// Prevent these characters from being entered
}},_this.handleCurrencyChange=function(e,currency){var value=e.target.value;// this.setState(prevState => ({
//   costing: {
//     ...prevState.costing,
//     currencyConversion: {
//       ...prevState.costing.currencyConversion,
//       [currency]: value // Update the specific currency
//     }
//   }
// }), () => {
//   this.convertOthers();
// });
//   if (this.state.action === "add") {
//     // Update both currencies and costing.currencyConversion in "add" mode
//     this.setState(prevState => ({
//       currencies: {
//         ...prevState.currencies,
//         [currency]: value // Update the specific currency in currencies
//       },
//       costing: {
//         ...prevState.costing,
//         currencyConversion: {
//           ...prevState.costing.currencyConversion,
//           usd: prevState.currencies.usd,  // Ensure we keep the existing usd, gbp, and eur
//           gbp: prevState.currencies.gbp,
//           eur: prevState.currencies.eur,
//           [currency]: value // Update the specific currency in currencyConversion
//         }
//       }
//     }), () => {
//       this.convertOthers(); // Recalculate after updating both currencies and currencyConversion
//     });
//   } else if (this.state.action === "edit") {
//     // Update only costing.currencyConversion when in "edit" mode
//     this.setState(prevState => ({
//       costing: {
//         ...prevState.costing,
//         currencyConversion: {
//           ...prevState.costing.currencyConversion,
//           usd: prevState.costing.currencyConversion.usd || prevState.currencies.usd,  // Ensure usd is kept or fallback to currencies
//           gbp: prevState.costing.currencyConversion.gbp || prevState.currencies.gbp,
//           eur: prevState.costing.currencyConversion.eur || prevState.currencies.eur,
//           [currency]: value // Update the specific currency
//         }
//       }
//     }), () => {
//       this.convertOthers(); // Recalculate after updating currencyConversion
//     });
//   }
// };
_this.setState(function(prevState){var currencyConversion=prevState.costing.currencyConversion||{};// Fallback to an empty object if undefined
return{currencies:Object.assign({},prevState.currencies,_defineProperty({},currency,value)),costing:Object.assign({},prevState.costing,{currencyConversion:Object.assign({},currencyConversion,_defineProperty({usd:currencyConversion.usd||prevState.currencies.usd,// Maintain existing USD or fallback to currencies
gbp:currencyConversion.gbp||prevState.currencies.gbp,// Maintain existing GBP or fallback to currencies
eur:currencyConversion.eur||prevState.currencies.eur},currency,value))})};},_this.convertOthers);// Call convertOthers after setting the state
},_this.optionChange=function(index){var costing=Object.assign({},_this.state.costing);costing.fabricTotalCost=Number(costing.fabric.reduce(function(arr,cur){return arr+(Number(cur.totalCost)||0);},0)).toFixed(2);//console.log(costing.fabricTotalCost,"fabrictotal")
_this.setState({costing:costing},function(){return _this.updateCostTotal();});},_this.handleTypeChange=function(index,type){// const updatedFabrics = this.state.costing.fabric.map((fabric, idx) => {
//   if (idx === index) {
//     return {
//       ...fabric,
//       emb: type === 'emb',  // Set emb to true if 'emb' is selected
//       yarn: type === 'yarn', // Set yarn to true if 'yarn' is selected
//       greigeset : type === 'greigeset'
//     };
//   }
//   return fabric; // Ensure all other fabrics remain unchanged
// });
// this.setState(prevState => ({
//   costing: {
//     ...prevState.costing,
//     fabric: updatedFabrics
//   },
// }));
_this.setState(function(prevState){var updatedFabric=[].concat(_toConsumableArray(prevState.costing.fabric));// Reset all values and set only the selected type
updatedFabric[index]=Object.assign({},updatedFabric[index],{emb:type==='emb',yarn:type==='yarn',greigeset:type==='greigeset',// Clear all other fields
greige:null,valueLoss:null,embCost:null,EmbValueLoss:null,dyingPrint:null,upcharge:null,yardDyedCost:null,price:0,totalCost:0,gst:_this.state.gst});return{costing:Object.assign({},prevState.costing,{fabric:updatedFabric})};},function(){_this.optionChange();});},_this.renderDynamicHeaders=function(fabric){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"13%"},"Fabric no"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Count & construction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Quality / Classification"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"9%"},"Supplier"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"9%"},"Position"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"8%"},"Marker"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"11%"},"Print-Direction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"7%"},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"6%"},"Width"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Consumption"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Price(INR)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Total(INR)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this.addFabric();}})));},_this.renderConditionalHeaders=function(fabric){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Type"),fabric.emb&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Greige"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Value\xA0Loss"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Emb"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Value\xA0Loss"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Dying/Print"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"\xA0GST\xA0")),fabric.yarn&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Yarn"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"\xA0GST\xA0")),fabric.greigeset&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Greige"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Value\xA0Loss"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Dying/Print"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"\xA0GST\xA0")));},_this.renderFabricRow=function(fabric,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"fabricNumber",value:fabric.fabricNumber,onInputChange:function onInputChange(val){return _this.getFabricNumber(val,index);},onChange:function onChange(val){return _this.getFabricInfo(val,index);},placeholder:"fabric",options:fabric.fabricList?fabric.fabricList:[],disabled:_this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default.a,onClick:function onClick(){if(fabric.fabricNumber){var action=_this.state.action!=="add"&&_this.state.action||"edit";var search="?"+new URLSearchParams({action:action,_id:fabric.fabricNumber}).toString();window.open("/developmentFabric"+search,"_blank");}}// this.props.history.push(
//   "/developmentFabric",
//   {
//     action: this.state.action !== "add" && this.state.action || "edit",
//     _id: fabric.fabricNumber,
//     costingpage: { ...this.state },
//     route: "CostingPage"
//   }
// )
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},fabric.countAndConstruction),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},fabric.qualityClassification),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},fabric.supplierName,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_8__assets_images_select_png___default.a,onClick:function onClick(){_this.getSupplierSectionList(fabric.fabricNumber,"fabric"),_this.setState({fabricIndex:index});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"fabricPosition",value:fabric.fabricPosition,options:_this.state.positionList||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]//title={fabric.marker && this.setTitle(fabric.marker, this.state.markerList) || ""}
,{isFormGroup:false,inputType:"select",inputName:"marker",value:fabric.marker,options:_this.state.markerList||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]// title={(fabric.printDirection && this.state.printDirectionList) && this.setTitle(fabric.printDirection, this.state.printDirectionList) || ""}
,{isFormGroup:false,inputType:"select",inputName:"printDirection",value:fabric.printDirection,options:_this.state.printDirectionList||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"size",style:{width:"100%"},value:fabric.size,options:_this.state.fabricSizeList||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{width:"80%"},type:"text",name:"width",value:fabric.width,onChange:function onChange(e){return _this.updateValModules(e.target.name,e.target.value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"consumption",style:{width:"80%"},value:fabric.consumption,disabled:_this.state.disabled,onChange:function onChange(e){return _this.calcTotalCost(e.target.name,e.target.value,index,"fabric");},onBlur:function onBlur(e){return _this.changeToDecimal(e,index,"fabric");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%",fontSize:".55rem"}},"/mts")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",style:{width:"80%"},name:"price",value:fabric.price,disabled:_this.state.disabled,onChange:function onChange(e){return _this.calcTotalCost(e.target.name,e.target.value,index,"fabric");},onBlur:function onBlur(e){return _this.changeToDecimal(e,index,"fabric");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%",fontSize:".55rem"}},"/mts")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{value:fabric.totalCost?Number(fabric.totalCost).toFixed(2):0.0,name:"totalCost",onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this.removeFabric(index);}})));},_this.renderConditionalFabricRow=function(fabric,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{value:fabric.emb?'emb':fabric.yarn?'yarn':fabric.greigeset?'greigeset':'',onChange:function onChange(e){return _this.handleTypeChange(index,e.target.value);},style:{width:"80%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"--select--")," // Dummy default option",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"greigeset"},"Normal"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"emb"},"Embroidery"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"yarn"},"Yarn Dyed"))),fabric.emb&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"greige",style:{width:"80%"},value:fabric.greige||""// onChange={e => this.updateValModules('greige', e.target.value, index, "fabric")}
,onChange:function onChange(e){var value=e.target.value;// Check if the input is a valid number with up to two decimal places
var regex=/^\d*\.?\d{0,2}$/;if(regex.test(value)){// Update state only if the value is valid
_this.updateValModules('greige',value,index,"fabric");}},onBlur:function onBlur(e){return _this.changeToDecimal(e,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]// className="rowWidth"
,{isFormGroup:false,inputType:"select",inputName:"valueLoss",value:fabric.valueLoss||"",options:_this.state.valueLoss||[]// Update with actual options for value loss
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"emb",style:{width:"80%"},value:fabric.embCost||"",onChange:function onChange(e){return _this.updateValModules('embCost',e.target.value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"EmbValueLoss",value:fabric.EmbValueLoss||"",options:_this.state.valueLoss||[]// Update with actual options for value loss
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"dyingPrint",value:fabric.dyingPrint||"",options:_this.state.dyingPrint||[]// Update with actual options
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]// className="rowWidth"
,{isFormGroup:false,inputType:"select",inputName:"upcharge",value:fabric.upcharge||"",options:_this.state.upCharge||[]// Update with actual options for value loss
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{width:"80%"},type:"text",name:"gst"// value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
,value:_this.state.gst,onChange:function onChange(e){return _this.updateValModules(e.target.name,e.target.value,index,"fabric");},disabled:true}))),fabric.yarn&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"yardDyedCost",style:{width:"80%"},value:fabric.yardDyedCost||""// Assuming you have a field for Yarn value
,onChange:function onChange(e){return _this.updateValModules('yardDyedCost',e.target.value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]// className="rowWidth"
,{isFormGroup:false,inputType:"select",inputName:"upcharge",value:fabric.upcharge||"",options:_this.state.upCharge||[]// Update with actual options for value loss
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{width:"80%"},type:"text",name:"gst"// value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
,value:_this.state.gst,onChange:function onChange(e){return _this.updateValModules(e.target.name,e.target.value,index,"fabric");},disabled:true}))),fabric.greigeset&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"greige",style:{width:"80%"},value:fabric.greige||"",disabled:_this.state.disabled// onChange={e =>
//   this.calcTotalCost(
//     e.target.name,
//     e.target.value,
//     index,
//     "fabric"
//   )
// }
,onChange:function onChange(e){var value=e.target.value;// Check if the input is a valid number with up to two decimal places
var regex=/^\d*\.?\d{0,2}$/;if(regex.test(value)){// Update state only if the value is valid
_this.updateValModules('greige',value,index,"fabric");}},onBlur:function onBlur(e){return _this.changeToDecimal(e,index,"fabric");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"valueLoss",value:fabric.valueLoss||"",options:_this.state.valueLoss||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"dyingPrint",value:fabric.dyingPrint||"",options:_this.state.dyingPrint||[],onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */]// className="rowWidth"
,{isFormGroup:false,inputType:"select",inputName:"upcharge",value:fabric.upcharge||"",options:_this.state.upCharge||[]// Update with actual options for value loss
,onChange:function onChange(name,value){return _this.updateValModules(name,value,index,"fabric");},disabled:_this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{width:"80%"},type:"text",name:"gst"// value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
,value:_this.state.gst,onChange:function onChange(e){return _this.updateValModules(e.target.name,e.target.value,index,"fabric");},disabled:true}))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Costing,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add"){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentWillMount",value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){var _this3=this;var _props$location$state,action,_id,sampleRequestId,goBack,costing;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_props$location$state=this.props.location.state,action=_props$location$state.action,_id=_props$location$state._id,sampleRequestId=_props$location$state.sampleRequestId,goBack=_props$location$state.goBack;if(action==="edit"&&goBack){this.setState({action:action,_id:_id,goBack:this.state.goBack-1});}if(sampleRequestId!==""){costing=Object.assign({},this.state.costing);costing.sampleRequestId=this.props.location.state.sampleRequestId;this.setState({costing:costing});}this.setState({action:action,_id:_id});if(action==="add"&&sampleRequestId){this.changeSampleNo(sampleRequestId);}if(action=="view"){this.setState({disabled:true});}if(action=="edit"||action=="view"){this.setState({isLoading:true});if(_id){__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].getCostingInfo(_id).then(function(response){if(response.status===200){var _costing2=_this3.state.costing;_costing2=response.text.data;var sampleRequestNumbersList=_costing2.sampleRequestId&&[{label:_costing2.sampleRequestId.requestNumber,value:_costing2.sampleRequestId._id}]||[];_costing2.sampleRequestId=_costing2.sampleRequestId&&_costing2.sampleRequestId._id||null;if(!sampleRequestNumbersList.length){_this3.getSampleRqNo('');}if(!_costing2.girlsWearing){_costing2.girlsWearing={grouping:[]};}setTimeout(function(){_this3.setState({sampleRequestNumbersList:sampleRequestNumbersList,costing:_costing2},function(){_this3.getTrimPack(_costing2.customer,_costing2.customerDepartmentId);_this3.getSMVList(_costing2.styleReferenceId.value);if(_costing2.customer&&_costing2.customer._id){_this3._handleCustDeptChange(null,_costing2.customer._id,_costing2.customerDepartmentId);}//this.currencyConversion();
// this.calConsumPrice()
_this3.setState({isLoading:false});});},1000);_this3.convertoFixed2(_costing2);}}).catch(function(error){return _this3.props.getalertMessage("error",error.toString());});}else if(sampleRequestId){this.changeSampleNo(sampleRequestId);}}__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].prefillSRDetails().then(function(response){if(response.message==="Operation Successful"){_this3.setState({positionList:response.data.SAMPLEREQUEST.POSITION,laundryUnitList:response.data.WASH.LAUNDRYUNIT,priceperkgList:response.data.WASH.PRICEPERKG.map(function(x){return{label:x.label,value:x.label};}),patternList:response.data.SAMPLEREQUEST.SAMPLETYPE,sampleList:response.data.SAMPLEREQUEST.SAMPLETYPE,washTypeList:response.data.WASH.WASHTYPE,embTypeList:response.data.SAMPLEREQUEST.TYPE,backingTypeList:response.data.SYSTEMSAMPLEREQUEST.BACKINGTYPE,placementList:response.data.SAMPLEREQUEST.PLACEMENT,embPlacementList:response.data.SAMPLEREQUEST.PLACEMENT_EMB,noOfColorList:response.data.SAMPLEREQUEST.NOOFCOLORS,framesList:response.data.SAMPLEREQUEST.FRAMES,trimCategoryList:response.data.TRIM.TRIMCATEGORY,trimPlacementList:response.data.TRIMPLACEMENT,embFormList:response.data.SAMPLEREQUEST.EMBFORM,SHIRRINGORSMOCKING:response.data.SAMPLEREQUEST.SHIRRINGORSMOCKING});}}).catch(function(error){return _this3.props.getalertMessage("error",error.toString());});this.getCustomerList();this.getCostingSystem();this.getSampleRqNo("");this.getMagnumStyleNo("");case 12:case"end":return _context11.stop();}}},_callee11,this);}));function componentWillMount(){return _ref15.apply(this,arguments);}return componentWillMount;}()},{key:"componentDidMount",value:function componentDidMount(){var action=this.props.location.state.action;if(action==="add"){this.getCostingNumber();//console.log(this.state.action,"add")
// Initialize the fabric array with default gst values
//  this.setState(prevState => ({
//   gst: prevState.gst || "", // Ensure global GST is set
//   costing: {
//     ...prevState.costing,
//     fabric: (prevState.costing.fabric || []).map(item => ({
//       ...item,
//       gst: item.gst !== null ? item.gst : prevState.gst || "" // Use item.gst if not null, else fallback to global gst
//     }))
//   }
// }));
}if(this.state.action=="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}if(this.props.history.location.state){if(this.props.history.location.state.costingpage){this.setState(Object.assign({},this.props.history.location.state.costingpage));}}}// currencyConversion = () => {
//   let { usd, gbp, eur } = this.state.currencies; // Extract updated currency values from state
//   // Convert values to numbers
// usd = Number(usd);
// gbp = Number(gbp);
// eur = Number(eur);
//   console.log(usd, gbp, eur);
//   console.log(this.state._id,"idd")
//   SystemServices.currencyConversion(
//     "COSTING",
//     "CURRENCY_CONVERSION",
//     usd, // Use updated USD
//     gbp, // Use updated GBP
//     eur, // Use updated EUR
//   )
//     .then(response => {
//       if (response.status === 200) {
//         this.props.getalertMessage("success", response.text.message);
//       }
//     })
//     .catch(error => this.props.getalertMessage(error.toString()));
// };
},{key:"getSMVList",// handleCurrencyChange = (name, value) => {
//   // Update state with the new currency value
//   this.setState(
//     prevState => ({
//       currencies: {
//         ...prevState.currencies,
//         [name]: value
//       }
//     }),
//     // After state update, trigger the currency conversion
//     () => {
//       // Recalculate the totals after updating the currency value
//       this.currencyConversion();
//       this.convertOthers();
//     }
//   );
// };
value:function getSMVList(referenceId){var _this4=this;__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].getSMVByRefId(referenceId).then(function(response){_this4.setState({selectSmv:response.text.data.smvList.map(function(x){return{label:x.smvNumber,value:x.smvId};})});}).catch(function(error){return _this4.props.getalertMessage("error",error.toString());});}// getOneSmv = (name, value) => {
//   let costing = this.state.costing
//   StyleServices.getSMV(value)
//     .then(async response => {
//       let orderQty = Number(costing.manufacturingAndPieceCostDetails.orderQty)
//       let sam = response.text.data.totalSam
//       console.log(sam/.8, "samCalculation");
//       let minutesperDay = Number(response.text.data.minutesPerDay)
//       let smv80 = Number(response.text.data["80Target"])
//       let smv100 = Number(response.text.data["100Target"])
//       let tailers = costing.manufacturingAndPieceCostDetails.noOftailors
//       let costPerTailer = 1750
//       let perMachine = 2800
//       let targetPcsAt = minutesperDay / smv80
//       let avgOutputNeeded = orderQty / targetPcsAt
//       let daysFortailorLine = avgOutputNeeded / tailers
//       let totalDays = daysFortailorLine + 2 //idle days
//       let totalCost1750 = totalDays * tailers * costPerTailer
//       let revTailer = totalCost1750 / orderQty
//       let totalCost2800 = totalDays * tailers * perMachine
//       let revMachine = totalCost2800 / orderQty
//       costing.manufacturingAndPieceCostDetails.smv = value
//       costing.manufacturingAndPieceCostDetails.minutesperDay = minutesperDay
//       costing.manufacturingAndPieceCostDetails.targetPcsAt = targetPcsAt
//       costing.manufacturingAndPieceCostDetails.avgOutputNeeded = avgOutputNeeded
//       costing.manufacturingAndPieceCostDetails.daysFortailorLine = daysFortailorLine
//       costing.manufacturingAndPieceCostDetails.totalDays = totalDays
//       costing.manufacturingAndPieceCostDetails.revMachine = revMachine.toFixed(
//         2
//       )
//       costing.manufacturingAndPieceCostDetails.revTailer = revTailer.toFixed(
//         2
//       )
//       costing.manufacturingAndPieceCostDetails.smv80 = smv80
//       costing.manufacturingAndPieceCostDetails.smv100 = smv100
//       costing.manufacturingAndPieceCost.CMT = revTailer.toFixed(2)
//       this.setState(
//         {
//           costing
//         },
//         () => this.updateCostTotal()
//       )
//     })
//     .catch(error => this.props.getalertMessage("error", error.toString()))
// }
},{key:"getFabricNo",value:function getFabricNo(value){var _this5=this;if(this.state.sampleNo!==undefined){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getFabricNo(value,this.state.sampleNo.value).then(function(response){if(response.message==="Sample Request fabric Data"){var jsonData=[];response.data.fabric.map(function(info,index){var objData={};objData.label=info.fabricNumber;objData.value=info.fabricId;jsonData.push(objData);});_this5.setState({fabricNumbers:jsonData});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}else{__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getAllFabrics(value).then(function(response){if(response.message==="List Displayed"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.fabricNumber;objData.value=info._id;jsonData.push(objData);});_this5.setState({fabricNumbers:jsonData});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}}},{key:"getTrimNo",value:function getTrimNo(value){var _this6=this;if(this.state.sampleNo!==undefined){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getTrimNo(value,this.state.sampleNo.value).then(function(response){if(response.message==="Sample Request trim Data"){var jsonData=[];response.data.trim.map(function(info,index){var objData={};objData.label=info.trimNumber;objData.value=info.trimId;jsonData.push(objData);});_this6.setState({trimNumbers:jsonData},function(){});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}else{__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getAllTrims(value).then(function(response){if(response.message==="List Displayed"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.trimNumber;objData.value=info._id;jsonData.push(objData);});_this6.setState({trimNumbers:jsonData},function(){});}}).catch(function(error){// alert("Something Went wrong...Try Again Later")
});}}},{key:"createCosting",value:function createCosting(e){var _this7=this;var costing=Object.assign({},this.state.costing);if(_typeof(costing.styleReferenceId)==="object"){costing.styleReferenceId=costing.styleReferenceId.value;}__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].addCosting(costing).then(function(response){if(response.status===200){// this.setState({
//   costing: response.text.data
// })
_this7.props.getalertMessage("success",response.text.message);if(_this7.state.action==="add"){_this7.setState({action:"edit",_id:response.text.data._id,costing:Object.assign({},_this7.state.costing,{_id:response.text.data._id})});_this7.props.location.state={_id:response.text.data._id,action:"edit"// costing: { ...this.state.costing, _id: response.text.data._id }
// this.props.history.push("/CostingPage", {
//   action: "edit",
//   _id: response.text.data._id
// })
// this.setState({
//   goBack: this.state.goBack - 1
// })
// this.updateCostingPrintValues()
};}// this.props.history.goBack()
}}).catch(function(error){_this7.props.getalertMessage("error",error);});}},{key:"countPrice",value:function countPrice(e){this.setState({fabricCost:document.getElementsByName("consumption")[0].valueAsNumber*document.getElementsByName("price")[0].valueAsNumber,totalFabricCost:document.getElementsByName("consumption")[0].valueAsNumber*document.getElementsByName("price")[0].valueAsNumber});}// Fabric module start
//fabric module end
//trim module start
// removeTrim = index => {
//   let costing = { ...this.state.costing }
//   costing.trim[index].totalCost = 0
//   costing.trimTotalCost = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing.trim.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
//   costing.trim = costing.trim.filter((data, i) => i !== index)
//   this.setState(
//     {
//       costing
//     }, () => this.updateCostTotal()
//   )
// }
//smocking module start
// smocking module end
//embroidery module start
//embroidery module end
//backing module start
//embellishment module start
//embellishment module end
//wash module start
//addGirlsWearArray
//customer and department select
// getValueLoss = (value, i) => {
//   // if (!value) {
//   //   // Clear the search-specific options when input is empty
//   //   this.setState({ valueLossSearch: [] });
//   //   return;
//   // }
//   SystemServices.getValueLoss(value)
//     .then(response => {
//       if (response.status === 200) {
//         let costing = {...this.state.costing};
//         costing.fabric[i].valueLossList = response.text.data;
//         this.setState({ costing });
//       }
//     });
// };
// getEmbValueLoss = (value, i) => {
//   // if (!value) {
//   //   // Clear the search-specific options when input is empty
//   //   this.setState({ valueLossSearch: [] });
//   //   return;
//   // }
//   SystemServices.getValueLoss(value)
//     .then(response => {
//       if (response.status === 200) {
//         let costing = {...this.state.costing};
//         costing.fabric[i].EmbValueLossList = response.text.data;
//         this.setState({ costing });
//       }
//     });
// };
// getValueLoss = (inputValue, index) => {
//   SystemServices.getValueLoss(inputValue)
//     .then(response => {
//       if (response.status === 200) {
//         const fetchedOptions = response.text.data || [];
//         const { costing } = this.state;
//         // Retain the currently selected value for the row
//         const currentValue = costing.fabric[index].valueLoss;
//         const currentOption = currentValue
//           ? { value: currentValue, label: currentValue }
//           : null;
//         // Merge current selection with fetched options (if not already included)
//         const updatedOptions = currentOption && !fetchedOptions.some(option => option.value === currentValue)
//           ? [currentOption, ...fetchedOptions]
//           : fetchedOptions;
//         this.setState({ valueLoss: updatedOptions });
//       }
//     });
// };
//other cost module start
//
//Trim Pack
//update values of modules
//update main
},{key:"overheadValueLossCalculator",value:function overheadValueLossCalculator(e){var _this8=this;var costing=Object.assign({},this.state.costing);var _e$target8=e.target,name=_e$target8.name,value=_e$target8.value;costing.manufacturingAndPieceCost[name]=value;this.setState({costing:costing},function(){return _this8.updateCostTotal();});}},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data[key]!==val?true:false;return values;}// handleCurrencyChange = (e, currency) => {
//   let costing = { ...this.state.costing };
//   costing.currencyConversion[currency] = e.target.value; // Update the specific currency value
//   this.setState({ costing });
// };
},{key:"render",value:function render(){var _this9=this;var costing=this.state.costing;var toggle=this.state.costing.toggle;var girlsWearing=this.state.costing.girlsWearing;// console.log(costing,"costing")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section",id:"costingColr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row bg-white nopadding"},this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"costing-wraper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding d-flex align-items-center mt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 no-padding text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"mb-0 text-color-green font-weight-bold"},"COSTING")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_audit__["a" /* default */],{_id:this.state._id,moduleName:"Costingid",fontSize:"14px"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary pull-right px-2 py-1 mr-3",onClick:function onClick(e){// this.checkValidation()
_this9.setState({isLoading:true});setTimeout(function(){_this9.updateCostingPrintValues();setTimeout(function(){_this9.setState({isLoading:false});_this9.openPrint("printCosting");},3000);},2000);}// onClick={e => this.openPrint("printCosting")}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-print font-size"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 p-0 my-0 d-flex justify-content-start"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover text-left mr-3",onClick:function onClick(){_this9.goBackCosting();},title:"Go Back"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_2__assets_images_left_arrow_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group p-0 my-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"text",inputName:"costingNumber",label:"Costing ID",value:this.state.costing.costingNumber,onChange:this._handleInputChange,disabled:this.state.disabled||true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group p-0 my-1 mx-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:""},"Date Created"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_21_moment___default()(this.state.costing.orderDate).format("HH:mm DD MMM YYYY")))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-1 p-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group py-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"Mag Style No/Ref"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"styleReferenceId",value:costing.styleReferenceId,onInputChange:function onInputChange(e){return _this9.getMagnumStyleNo(e);},onChange:this.changeStyleNo,placeholder:"Find Style No",options:this.state.styleNoInfo,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-7 pl-0 py-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-sm-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"text",inputName:"magnumStyleName",label:"Mag Style Name",value:costing.magnumStyleName,onChange:this._handleInputChange,disabled:this.state.disabled||true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 p-0 pr-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"text",inputName:"customerName",label:"Customer / Department",value:costing.customerName,onChange:this._handleInputChange,disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-3 px-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"form-group  py-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"no"},"Sample Request No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"sampleRequestId",value:costing.sampleRequestId,onInputChange:function onInputChange(e){return _this9.getSampleRqNo(e);},onChange:this.changeSampleNo,placeholder:"Find Sample",options:this.state.sampleRequestNumbersList,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-2 py-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"text",inputName:"customerRefNumber",label:"Customer Ref No.",value:costing.customerRefNumber,onChange:this._handleInputChange,disabled:this.state.disabled||true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-2 py-0 my-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,className:"py-0 my-0",inputType:"select",inputName:"costingType",label:"Costing Type*",options:this.state.costingTypeList,value:costing.costingType,onChange:this._handleInputChange,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"nav-locator add-cost-li m-0 ",style:{width:"100%"}},Object.keys(toggle).map(function(keyName){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{style:{width:"14.2857142857%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"checkboxToggle",inputName:keyName,value:toggle[keyName],label:keyName==="girlsWearing"?"Girls wear":keyName==="smockingSheering"?"Smocking/Shirring":keyName,onChange:_this9.toggleChange,disabled:_this9.state.disabled}));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"fabric"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,toggle.fabric&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{header:"Fabric Cost Details"}),this.state.costing.fabric.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"13%"},"Fabric no"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Count & construction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Quality / Classification"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"9%"},"Supplier"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"9%"},"Position"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"8%"},"Marker"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"11%"},"Print-Direction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"7%"},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"6%"},"Width"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Consumption"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Type"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Price(INR)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},"Total(INR)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"5%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addFabric();}}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,this.state.costing.fabric.map(function(fabric,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{key:"table-"+index,className:"costingtable",style:{marginBottom:'25px'},id:"fabric-table-"+index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",{style:{borderBottom:'none'}},_this9.renderDynamicHeaders(fabric,index)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,_this9.renderFabricRow(fabric,index)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",{style:{borderBottom:'none'}},_this9.renderConditionalHeaders(fabric,index)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,_this9.renderConditionalFabricRow(fabric,index)));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{style:{display:'flex',justifyContent:'flex-end',marginRight:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"11",moduleName:"Fabric",totalCostValue:costing.fabricTotalCost||"0.00",name:"fabricTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}})))))),toggle.trim&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{id:"trim"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{header:"Trim Cost Details"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"15%"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"15%"},"Trim Ref no"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"15%"},"Description"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},"Quality"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"20%"},"Supplier"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Consp/ unit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Price / unit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addTrim();}}))),costing.trimPack&&costing.trimPack.trimPackNo!==""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"font-weight-bold"},"Trims Pack"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Trimpack no"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"py-2 d-block"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"trimPackList",value:costing.trimPack.trimPackNo,options:this.state.trimPackList,onChange:this.updateTrimPack,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Type of GMT"},costing.trimPack.typeOfGmt),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Packaging Method"},costing.trimPack.packagingMethod),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Packing Type"},costing.trimPack.packingType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Sub Type"},costing.trimPack.subType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Consumption"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",style:{width:"4rem"},name:"consumption",value:costing.trimPack.consumption,disabled:this.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,null,"trimPack");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,null,"trimPack");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%",fontSize:".55rem"}},"/pack")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{title:"Price"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"price",value:costing.trimPack.price,disabled:this.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,null,"trimPack");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,null,"trimPack");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%",fontSize:".55rem"}},"/pack")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"trimPackTotalCost",value:costing.trimPackTotalCost||0.00// onChange={this.updateTotalCost}
,disabled:true}))),costing.trim.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"trimCategory",value:trim.trimCategory,index:index,options:_this9.state.trimCategoryList,onChange:_this9.updateTrim,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"trimNumber",value:trim.trimNumber,onInputChange:function onInputChange(value){return _this9.getTrimRefNo(trim.trimCategory,value,index,"trim");},onChange:function onChange(value){return _this9.getTrimInfo(value,index,"trim");},placeholder:"Find trimRefNo",options:trim.trimList?trim.trimList:[],disabled:_this9.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default.a,onClick:function onClick(){if(trim.trimNumber){var action=_this9.state.action!=="add"&&_this9.state.action||"edit";var search="?"+new URLSearchParams({action:action,_id:trim.trimNumber}).toString();window.open("/Trim"+search,"_blank");}}// this.props.history.push(
//   "/Trim",
//   {
//     action: this.state.action !== "add" && this.state.action || "edit",
//     _id: trim.trimNumber,
//     costingpage: { ...this.state },
//     route: "CostingPage"
//   }
// )
// () =>
//   this.leaveCostingPage({
//     nextPage: () => {
//       this.props.history.push("/Trim", {
//         action: "edit",
//         _id: trim.trimNumber
//       })
//     }
//   })
// this.props.history.push("/Trim", {
//   action: "edit",
//   _id: trim.trimNumber
// })
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"pt-3"},trim.description)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"pt-3"},trim.quality)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},trim.supplierName,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"external-link cursor-hover d-inline",src:__WEBPACK_IMPORTED_MODULE_8__assets_images_select_png___default.a,onClick:function onClick(){_this9.getSupplierSectionList(trim.trimNumber,"trim"),_this9.setState({trimIndex:index});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"pt-3"},trim.size)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"consumption",value:trim.consumption,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,index,"trim");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"trim");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{title:trim.unit,style:{maxWidth:"20%",fontSize:trim.unit.length>=5&&".40rem"||trim.unit.length<=3&&".7rem"||"0.55rem",fontWeight:trim.unit.length>=5&&"900"||"normal"}},"/",trim.unit||"Pack")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"price",value:trim.price,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,index,"trim");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"trim");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{title:trim.unit,style:{maxWidth:"20%",fontSize:trim.unit.length>=5&&".40rem"||trim.unit.length<=3&&".7rem"||"0.55rem",fontWeight:trim.unit.length>=5&&"900"||"normal"}},"/",trim.unit||"Pack")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */]// style={{ width: "100%" }}
,{name:"totalCost",value:trim.totalCost?Number(trim.totalCost).toFixed(2):0.0,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"trim");},disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeTrim(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"8",moduleName:"Trim",totalCostValue:costing.trimTotalCost,name:"trimTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"smockingshirring"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,toggle.smockingSheering&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{header:"Smocking/Shirring"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"15%"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"20%"},"Trim Ref No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},"Placement"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"15%"},"Type"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},"No of Rows"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},"Length In Mtr"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"13%"},"Total Reqrd-Mtrs"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"5%"},"Price/mtrs"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",width:"10%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addSmocking();}}))),costing.smockingSheering.map(function(smockingSheering,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"trimCategory",value:smockingSheering.trimCategory,index:index,options:_this9.state.trimCategoryList,onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{name:"trimNumber",value:smockingSheering.trimNumber,onInputChange:function onInputChange(value){return _this9.getTrimRefNo(smockingSheering.trimCategory,value,index,"smockingSheering");},onChange:function onChange(value){return _this9.getTrimInfo(value,index,"smockingSheering");},placeholder:"Find trimRefNo",options:smockingSheering.trimList?smockingSheering.trimList:[],disabled:_this9.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default.a,onClick:function onClick(){return _this9.props.history.push("/Trim",{action:_this9.state.action!=="add"&&_this9.state.action||"edit",_id:smockingSheering.trimNumber,costingpage:Object.assign({},_this9.state),route:"CostingPage"});}// () =>
//   this.leaveCostingPage({
//     nextPage: () => {
//       this.props.history.push("/Trim", {
//         action: "edit",
//         _id: smockingSheering.trimNumber
//       })
//     }
//   })
// this.props.history.push("/Trim", {
//   action: "view",
//   _id: smockingSheering.trimNumber
// })
// onClick={() =>
//   this.props.history.push("/Trim", {
//     action: "view",
//     _id: smockingSheering.trimNumber
//   })
// }
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"placement",index:index,value:smockingSheering.placement,options:_this9.state.trimPlacementList,onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"type",value:smockingSheering.type,index:index,options:[{label:"Both Elastic",value:"Both Elastic"},{label:"Top TTH / Bottom Elastic",value:"Top TTH / Bottom Elastic"}],onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"noOfRow",value:smockingSheering.noOfRow,index:index,onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"length",index:index,value:smockingSheering.length,onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0 ml-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"4rem",marginTop:"0",marginBottom:"0",marginRight:"auto",marginLeft:"auto"},isFormGroup:false,inputType:"number",inputName:"totalReq",index:index,value:smockingSheering.totalReq,onChange:_this9.updateSmockingSheering,disabled:_this9.state.disabled||true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",style:{width:"4rem",marginTop:"0",marginBottom:"0",marginRight:"auto",marginLeft:"auto"},name:"price",value:smockingSheering.price,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateSmockingSheering(e.target.name,e.target.value,index);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"smockingSheering");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%"}},"/Mts")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"totalCost",value:smockingSheering.totalCost?Number(smockingSheering.totalCost).toFixed(2):0.0// onChange={this.updateTotalCost}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeSmocking(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"11",moduleName:"Smocking",totalCostValue:costing.smockingSheeringTotalCost,name:"smockingSheeringTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"embroidery"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,toggle.embroidery&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-bottom-0 text-left",colSpan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"mb-0 text-primary font-weight-bold"},"Embroidery Cost Details")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"backing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embroideryBacking",className:"my-0 py-0",value:this.state.costing.embroideryBacking// label="backing"
,onChange:function onChange(){var costing=_this9.state.costing;costing.embroideryBacking=!_this9.state.costing.embroideryBacking;_this9.setState({costing:costing});},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"bit attaching"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"bitAttaching",className:"my-0 py-0",value:this.state.costing.bitAttaching,onChange:function onChange(){var costing=_this9.state.costing;costing.bitAttaching=!_this9.state.costing.bitAttaching;_this9.setState({costing:costing});},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"5"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-left",colSpan:"1"},"Emb Placement"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0",colSpan:"1"},"Emb form"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"No of Colors"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-right",colSpan:"2"},"Frames"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-right",colSpan:"2"},"Stitches/Mtr"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Consumption/Unit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Stitches Count"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Prices/1000 Stitches"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addEmbroidery();}}))),costing.embroidery.map(function(embroideryData,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0",colSpan:"1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"d-block py-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"10rem",margin:"0 auto",marginLeft:"0"},isFormGroup:false,inputType:"select",inputName:"embPlacement",value:embroideryData.embPlacement,options:_this9.state.embPlacementList,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"embroidery");},disabled:_this9.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0",colSpan:"1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"10rem",margin:"0 auto",marginLeft:"0"},isFormGroup:false,inputType:"select",inputName:"embForm",value:embroideryData.embForm,options:_this9.state.embFormList,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"embroidery");},disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0",colSpan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"10rem",margin:"0 auto",marginLeft:"0"},isFormGroup:false,inputType:"select",inputName:"noOfCols",value:embroideryData.noOfCols,options:_this9.state.noOfColorList,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"embroidery");},disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0",colSpan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"10rem",margin:"0 auto",marginLeft:"0"},isFormGroup:false,inputType:"select",inputName:"frames",value:embroideryData.frames,options:_this9.state.framesList,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"embroidery");},disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"stitchesMtr",value:embroideryData.stitchesMtr,onChange:function onChange(name,value){return _this9.updateValModules(name,value,index,"embroidery");},disabled:_this9.state.disabled||embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"consumption-field",name:"consumption",value:embroideryData.consumption,disabled:_this9.state.disabled||embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel",onChange:function onChange(e){return _this9.updateValModules(e.target.name,e.target.value,index,"embroidery");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"embroidery");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%"}},"/mtrs")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"stitchCount",value:embroideryData.stitchCount,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateValModules(e.target.name,e.target.value,index,"embroidery");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"embroidery");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"priceForStitches",value:embroideryData.priceForStitches,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateValModules(e.target.name,e.target.value,index,"embroidery");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"embroidery");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"totalCost",value:embroideryData.totalCost?Number(embroideryData.totalCost).toFixed(2):embroideryData.totalCost// onChange={this.updateTotalCost}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeEmbroidery(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"11",moduleName:"Embroidery",totalCostValue:costing.embroideryTotalCost,name:"embroideryTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}}),this.state.costing.embroideryBacking&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Backing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Width"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Placement"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colSpan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Consumption"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"},"Prices/Mtrs"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"// width="11.1111111111%"
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addBacking();}}))),costing.backing.map(function(backing,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"backingType",value:backing.backingType,options:_this9.state.backingTypeList,onChange:function onChange(name,value){return _this9.calcTotalCost(name,value,index,"backing");},label:"Backing ",disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"width",value:backing.width,options:backing.widthList,onChange:function onChange(name,value){return _this9.calcTotalCost(name,value,index,"backing");},label:"Width",disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"placement",value:backing.placement,options:_this9.state.embPlacementList,onChange:function onChange(name,value){return _this9.calcTotalCost(name,value,index,"backing");},label:"Placement ",disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"6"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"consumption",value:backing.consumption,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,index,"backing");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"backing");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"price",value:backing.price,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.calcTotalCost(e.target.name,e.target.value,index,"backing");},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"backing");}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{maxWidth:"20%"}},"/",backing.units||"Mts")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"totalCost",value:backing.totalCost?Number(backing.totalCost).toFixed(2):0.0// onChange={this.updateTotalCost}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeBacking(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"11",moduleName:"Backing",totalCostValue:costing.backingTotalCost,name:"backingTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}}))))),toggle.embellishment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"embelishment"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{colSpan:"12",header:"Embellishment Cost Details"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable w-100 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,toggle.embellishment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end ml-auto mr-0",style:{width:"99.3%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"Type"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"10%"},"HH:MM"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"7%"},"Price/ 30mins"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 mr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addEmbellishment();}}))),costing.embellishment.map(function(embellishment,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end ml-auto mr-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,style:{width:"7rem"},inputType:"select",inputName:"embType",value:embellishment.embType,options:_this9.state.embTypeList,onChange:_this9.updateEmbellishment,index:index,label:"Type ",disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false// style={{ width: "5rem" }}
,inputType:"time",inputName:"hoursMinutes",value:embellishment.hoursMinutes||""+(new Date().getFullYear(),new Date().getMonth(),new Date().getDay()),onChange:_this9.updateEmbellishment,index:index,label:"HH:MM ",disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"pricePerHalfHour",value:embellishment.pricePerHalfHour,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateEmbellishment(e.target.name,e.target.value,index);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"embellishment");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{style:{margin:"auto 0 auto auto !important",padding:"auto 0 auto auto !important"},name:"totalCost",value:embellishment.totalCost&&Number(embellishment.totalCost).toFixed(2)// onChange={this.updateTotalCost}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeEmbellishment(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"d-inline-flex justify-content-end",style:{width:"98.1%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */]// trClassName={"d-flex justify-content-end"}
,{colSpan:"11",moduleName:"embellishment",totalCostValue:costing.embelishmentTotalCost&&Number(costing.embelishmentTotalCost).toFixed(2),name:"embelishmentTotalCost"// onChange={(name, value) => this.updateMain(name, value)}
}))))),toggle.wash&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-start align-items-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"15%",className:"border-bottom-0 text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{className:"mb-0 text-primary font-weight-bold"},"Wash Cost Details")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"5%",className:"font-weight-bold"},"Tacking"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"7%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"tacking",className:"my-0 py-0",value:costing.tacking,onChange:function onChange(){var costing=_this9.state.costing;costing.tacking=!costing.tacking;_this9.setState({costing:costing});},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"63%",className:"border-bottom-0 d-flex justify-content-end mr-0 ml-auto p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"15%"},"Type of wash"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-center",width:"11%"},"Laundry Unit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-right",width:"8%"},"Wt/Gmt"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-right px-0",width:"10%"},"Price / Kg / Gmt"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Costing_TotalHeader__["a" /* default */],{center:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"text-right px-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this9.addWash();}})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"wash"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,costing.wash.map(function(wash,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0 d-flex justify-content-end"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"8.1111111111%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"washType",index:index,value:wash.washType,options:_this9.state.washTypeList,label:"Wash Type",onChange:_this9.updateWash,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"7.1111111111%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"laundryUnit",index:index,value:wash.laundryUnit,options:_this9.state.laundryUnitList,label:"laundry Unit",onChange:_this9.updateWash,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"7.1111111111%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"weight",value:wash.weight,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateWash(e.target.name,e.target.value,index);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"wash");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{width:"5.1111111111%"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"4rem"},className:"consumption-field",name:"price",value:wash.price,disabled:_this9.state.disabled,onChange:function onChange(e){return _this9.updateWash(e.target.name,e.target.value,index);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"wash");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */]// style={{ margin: "auto", padding: "auto" }}
,{name:"totalCost",value:wash.totalCost&&Number(wash.totalCost).toFixed(2),onChange:_this9.updateWash,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){return _this9.removeWash(index);}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"d-inline-flex justify-content-end",style:{width:"98%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */]// trClassName={"d-flex justify-content-end"}
,{colSpan:"11",moduleName:"Wash",totalCostValue:costing.washTotalCost&&Number(costing.washTotalCost).toFixed(2),name:"washTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{header:"Other Charges"}),costing.otherCostDetails.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{width:"30%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{width:"100%",textAlign:"right"},type:"text",value:data.label,onChange:function onChange(e){return _this9.updateOtherCostdetails("label",e.target.value,index);},autoComplete:true,disabled:_this9.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"number-field",name:"value",value:data.value,disabled:_this9.state.disabled,id:"otId"+index,onChange:function onChange(e){return _this9.updateOtherCostdetails("value",e.target.value,index);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,index,"otherCostDetails");}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,costing.otherCostDetails.length===1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"remove",addRemoveFunc:function addRemoveFunc(){_this9.removeOtherCost(0);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:index==0?"add":"remove",addRemoveFunc:function addRemoveFunc(){index==0?_this9.addOtherCost():_this9.removeOtherCost(index);}}))));}),!costing.otherCostDetails.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"d-flex justify-content-end"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){_this9.addOtherCost();}}))),costing.otherCostDetails.length!=0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"d-flex justify-content-end",style:{marginRight:"1.68rem"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:"10",moduleName:"Other",totalCostValue:costing.otherTotalCost&&Number(costing.otherTotalCost).toFixed(2),name:"otherTotalCost",onChange:function onChange(name,value){return _this9.updateMain(name,value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable",id:"manufacturing"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Costing_ModuleHeader__["a" /* default */],{header:" Manufacturing Process / Piece Cost Details"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0 text-left"// width="11.1111111111%"
},"Select SMV"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"// width="11.1111111111%"
},"Order Qty"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colSpan:"1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"// width="11.1111111111%"
},"SAM @ 80%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colSpan:"1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"// width="11.1111111111%"
},"Rev/Tailor @"," ",costing.manufacturingAndPieceCostDetails.perMachine),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"border-bottom-0"// width="11.1111111111%"
},"Rev/Machine @"," ",costing.manufacturingAndPieceCostDetails.costPertailor),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colSpan:"2",className:"text-right"},"Fixed Charges"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"number-field",type:"number",name:"fixedCharge",value:costing.manufacturingAndPieceCost.fixedCharge,disabled:this.state.disabled// style={}
,onChange:function onChange(e){return _this9.manufactureUpdate(e.target.name,e.target.value);},onBlur:function onBlur(e){return _this9.changeToDecimal(e,null,"manufacturingAndPieceCost");}// style={{ marginRight: '-20px' }}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"sectedsmv",value:costing.manufacturingAndPieceCostDetails.smv,options:this.state.selectSmv,onChange:this.getOneSmv,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"orderQty",value:costing.manufacturingAndPieceCostDetails.orderQty,onChange:this.manufactureUpdate,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{style:{width:"4rem",margin:"0 auto"},isFormGroup:false,inputType:"number",inputName:"smv100",value:costing.manufacturingAndPieceCostDetails.smv100,onChange:this.getOneSmv,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"revTailer",value:costing.manufacturingAndPieceCostDetails.revTailer,onChange:this.manufactureUpdate,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"revMachine",value:costing.manufacturingAndPieceCostDetails.revMachine,onChange:this.manufactureUpdate,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"font-13 text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-primary"},"CMT @ "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{value:costing.manufacturingAndPieceCost.CMT,disabled:!costing.manufacturingAndPieceCostDetails||!costing.manufacturingAndPieceCostDetails.revTailer,onChange:this.changeCMT},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",null,"-select-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:costing.manufacturingAndPieceCostDetails.revTailer||0.0},costing.manufacturingAndPieceCostDetails.perMachine),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:costing.manufacturingAndPieceCostDetails.revMachine||0.0},costing.manufacturingAndPieceCostDetails.costPertailor)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"CMT",value:costing.manufacturingAndPieceCost.CMT||"0.00",onChange:this.manufactureUpdate// disabled
// style={{ marginRight: '-20px' }}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{colSpan:12,moduleName:"Manufacturing",totalCostValue:costing.manufacturingAndPieceCost.totalCost})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"group",type:"radio",className:"filled-in hide-all",id:"sample",value:"sample",checked:this.state.costing.selectedMenu.name==="sample",onChange:function onChange(e){var costing=_this9.state.costing;costing.selectedMenu.name=e.target.value;_this9.setState({costing:costing});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"sample"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Sample"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{name:"sample",value:this.state.costing.selectedMenu.name==="sample"&&this.state.costing.selectedMenu.value,onChange:function onChange(e){var costing=_this9.state.costing;costing.selectedMenu.value=e.target.value;costing.selectedMenu.date=new Date();_this9.setState({costing:costing});},disabled:this.state.disabled||this.state.costing.selectedMenu.name!="sample",className:"form-control"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:"",value:""},"--select--"),this.state.sampleList.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:i,value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Dated"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{display:"inline-block",marginTop:"30px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"sampleDate",value:this.state.costing.selectedMenu.name==="sample"?this.state.costing.selectedMenu.date:null,onChange:this.manufactureUpdate,disabled:this.state.disabled||this.state.costing.selectedMenu.name!="sample"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"group",type:"radio",className:"filled-in hide-all",id:"pattern",value:"pattern",checked:this.state.costing.selectedMenu.name==="pattern",onChange:function onChange(e){var costing=_this9.state.costing;costing.selectedMenu.name=e.target.value;_this9.setState({costing:costing});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"pattern"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Pattern"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{name:"pattern",value:this.state.costing.selectedMenu.name==="pattern"&&this.state.costing.selectedMenu.value,onChange:function onChange(e){var costing=_this9.state.costing;costing.selectedMenu.value=e.target.value;_this9.setState({costing:costing});},disabled:this.state.disabled||this.state.costing.selectedMenu.name!="pattern",className:"form-control"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:"",value:""},"--select--"),this.state.patternList.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:i,value:data.value},data.label);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Dated"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{display:"inline-block",marginTop:"30px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"patternDate",value:this.state.costing.selectedMenu.name==="pattern"?this.state.costing.selectedMenu.date:null,onChange:this.manufactureUpdate,disabled:this.state.disabled||this.state.costing.selectedMenu.name!="pattern"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"w-100 d-inline-flex align-items-end",style:{justifyContent:"flex-end",paddingLeft:"15.7rem"}},"Value Loss % :",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",name:"valueLoss",style:{width:"4rem"},className:"text-right",value:this.state.costing.manufacturingAndPieceCost.valueLoss,onChange:function onChange(e){return _this9.overheadValueLossCalculator(e);}}),"%")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{style:{marginRight:"15px",marginLeft:"-0.8rem"},name:"valueLossCost",value:Number(this.state.costing.manufacturingAndPieceCost.valueLossCost).toFixed(2)// onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
,disabled:true}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable ml-auto mr-0",style:{width:"40%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"12"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0 naming text-right"},"Contribution to overheads % :",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",name:"overHeads",style:{width:"4rem"},className:"text-right",value:this.state.costing.manufacturingAndPieceCost.overHeads,onChange:function onChange(e){return _this9.overheadValueLossCalculator(e);}}),"%"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"overHeadsCost",style:{width:"4rem",marginLeft:"-1.5rem"},value:Number(this.state.costing.manufacturingAndPieceCost.overHeadsCost).toFixed(2)// onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
,disabled:true}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable float-right"// style={{ marginRight: "-0.7rem", overflow: 'hidden' }}
,style:{width:'21%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Costing_TotalCostRow__["a" /* default */],{moduleName:"",totalCostValue:costing.costingTotal?Number(costing.costingTotal).toFixed(2):costing.costingTotal}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"11",className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"11",className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline  pr-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"usd",type:"radio",className:"filled-in hide-all",id:"rad1",value:"usd",checked:this.state.costing.selectedConversion==="usd",onChange:this.selectedConversion}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"rad1"},"USD-$-",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"custom-number-field1"// value={
//   this.state.action === "add" 
//     ? (this.state.currencies && this.state.currencies.usd) || '' 
//     : (this.state.costing && this.state.costing.currencyConversion && this.state.costing.currencyConversion.usd) ||this.state.currencies.usd
// }
,value:this.state.action==="add"?this.state.currencies&&this.state.currencies.usd||''// Add mode uses currencies
:this.state.costing&&this.state.costing.currencyConversion&&this.state.costing.currencyConversion.usd?this.state.costing.currencyConversion.usd// Edit mode with currencyConversion
:this.state.currencies.usd||''// If currencyConversion is missing, use currencies
,onChange:function onChange(e){return _this9.handleCurrencyChange(e,'usd');},onKeyDown:this.preventSpecialChars}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-center text-dark px-4",style:{fontSize:'16px',color:'#292b2c'}},"$ ",this.state.costing.usdTotal))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"11",className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline  pr-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"gbp",type:"radio",className:"filled-in hide-all",id:"rad2",value:"gbp",checked:this.state.costing.selectedConversion==="gbp",onChange:this.selectedConversion}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"rad2"},"GBP-\xA3-",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"custom-number-field1",value:this.state.action==="add"?this.state.currencies&&this.state.currencies.gbp||''// Add mode uses currencies
:this.state.costing&&this.state.costing.currencyConversion&&this.state.costing.currencyConversion.gbp?this.state.costing.currencyConversion.gbp// Edit mode with currencyConversion
:this.state.currencies.gbp||''// If currencyConversion is missing, use currencies
,onChange:function onChange(e){return _this9.handleCurrencyChange(e,'gbp');},onKeyDown:this.preventSpecialChars}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-center px-4",style:{fontSize:'16px',color:'#292b2c'}},"\xA3 ",this.state.costing.gbpTotal))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"11",className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"radio-inline pr-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"euro",type:"radio",className:"filled-in hide-all",id:"rad3",value:"euro",checked:this.state.costing.selectedConversion==="euro",onChange:this.selectedConversion}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{"for":"rad3"},"Euro-\u20AC-",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"custom-number-field1",value:this.state.action==="add"?this.state.currencies&&this.state.currencies.eur||''// Add mode uses currencies
:this.state.costing&&this.state.costing.currencyConversion&&this.state.costing.currencyConversion.eur?this.state.costing.currencyConversion.eur// Edit mode with currencyConversion
:this.state.currencies.eur||''// If currencyConversion is missing, use currencies
,onChange:function onChange(e){return _this9.handleCurrencyChange(e,'eur');},onKeyDown:this.preventSpecialChars}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-center px-4",style:{fontSize:'16px',color:'#292b2c'}},"\u20AC ",this.state.costing.euroTotal))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end ml-3 mr-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"mr-2"},"Shipment Term"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"select",inputName:"shipmentTerm"// label="Shipment Term"
,value:costing.shipmentTerm,options:this.state.shipmentTermList.map(function(x){return{label:x.label,value:x.label};}),onChange:this.landedCalc,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end ml-3 mr-3 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"mr-2"},"Shipment Mode"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Field_Field__["a" /* default */],{className:"py-0 my-0",isFormGroup:true,inputType:"select",inputName:"shipMode"// label="Shipment Mode"
,value:costing.shipMode,options:this.state.shipModeList,onChange:this._handleInputChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end ml-3 mr-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"mr-2 fw-bold font-size-14"},"Agreed Price @ \xA0",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{value:this.state.costing.agreedCurrency,onChange:function onChange(e){var costing=Object.assign({},_this9.state.costing);costing.agreedCurrency=e.target.value;_this9.setState({costing:costing});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",null,"\u20B9"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",null,"$"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",null,"\xA3"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",null,"\u20AC"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"mt-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",className:"number-field  custom-number-field",name:"agreedPrice",value:this.state.costing.agreedPrice,onChange:function onChange(e){var costing=Object.assign({},_this9.state.costing);costing.agreedPrice=e.target.value||'';_this9.setState({costing:costing});},onBlur:function onBlur(e){var costing=Object.assign({},_this9.state.costing);costing.agreedPrice=Number(e.target.value).toFixed(2);_this9.setState({costing:costing});}}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0",colSpan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{cursor:"pointer"},onClick:function onClick(e){return _this9.setState({showLandedCalc:!_this9.state.showLandedCalc});}},"Show landed Calculation",this.state.showLandedCalc?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pl-2 font-weight-bold"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-up"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pl-2 font-weight-bold"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-angle-down"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"border-top-0"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"costingtable"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.showLandedCalc&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end my-1",style:{width:"99%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Landed Price"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"font-weight-bold"},this.curSymbol(this.state.costing.toCurrencyConversion)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Costing_NumberField__["a" /* default */],{name:"landedPrice",style:{textAlign:"left"}// disabled={false}
,value:this.state.costing.landedData.totalLandedValue&&Number(this.state.costing.landedData.totalLandedValue).toFixed(2)||"0.00"// onChange={this.AgreedAndLandedPriceHandler}
,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-end mx-auto",style:{width:"27%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"if landed, then working is"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between",style:{width:"24.5%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right w-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"mr-2"},"Conversion from"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{name:"fromCurrencyConversion",value:this.state.costing.fromCurrencyConvertion,defaultValue:"usd"// onChange={e => this.currencyConverter(e)}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"usd"},"USD")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"mx-1"},"to"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"mr-1",name:"toCurrencyConversion",value:this.state.costing.toCurrencyConversion,onChange:function onChange(e){return _this9.currencyConverter(e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"---"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"gbp"},"GBP"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"usd"},"USD"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:"eur"},"EUR"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 text-right font-13 font-weight-bold"},"$",this.state.costing.landedPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between my-1",style:{width:"26.5%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right w-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pr-2"},"Conversion Rate"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"30%"},name:"conversionRate",value:this.state.costing.landedData.conversionRate?Number(this.state.costing.landedData.conversionRate):"",onChange:function onChange(e){return _this9.landedWorkingCalculation(e);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 text-right font-13 font-weight-bold"},this.curSymbol(this.state.costing.toCurrencyConversion),costing.landedData.rateValue)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between my-1",style:{width:"26.2%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right w-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pr-2"},"Freight Charges"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"30%"},name:"freightCharges",value:Number(this.state.costing.landedData.freightCharges),onChange:function onChange(e){return _this9.landedWorkingCalculation(e);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 text-right font-13 font-weight-bold"},this.curSymbol(this.state.costing.toCurrencyConversion),costing.landedData.freightChargesTotal)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between my-1",style:{width:"26.2%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right w-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pr-2",style:{marginRight:"3.2rem"}},"Duty"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"30%"},name:"duty",value:Number(this.state.costing.landedData.duty),onChange:function onChange(e){return _this9.landedWorkingCalculation(e);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 text-right font-13 font-weight-bold"},this.curSymbol(this.state.costing.toCurrencyConversion),costing.landedData.dutyValue)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between my-1",style:{width:"26.2%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right w-align"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"pr-2"},"Processing cost"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",style:{width:"30%"},name:"processingCost",value:Number(this.state.costing.landedData.processingCost),onChange:function onChange(e){return _this9.landedWorkingCalculation(e);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 text-right font-13 font-weight-bold"},this.curSymbol(this.state.costing.toCurrencyConversion),costing.landedData.processValue)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"d-flex justify-content-between my-1",style:{width:"26.3%",margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2",className:"border-top-0 naming text-right pt-1 border-bottom-style"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Total Landing Cost")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"1",className:"border-top-0 pt-0 border-bottom-style font-weight-bold font-for-medium text-right"},this.curSymbol(this.state.costing.toCurrencyConversion),costing.landedData.totalLandedValue))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 border-bottom-style row w-100"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 mx-auto row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-8 mx-auto"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Special Comments"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{col:"5",className:"w-100",value:this.state.costing.comments,onChange:function onChange(e){var costing=_this9.state.costing;costing.comments=e.target.value;_this9.setState({costing:costing});}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 border-bottom-style"},toggle.girlsWearing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding my-1 product-form pl-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-9 col-md-offset-1 no-padding product-form"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{className:"landingCalculation"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table table-bordered mb-0 landing-calc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{rowspan:"2"},"Grouping"),girlsWearing&&girlsWearing.grouping&&girlsWearing.grouping.length&&girlsWearing.grouping.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:x.values&&x.values.length,key:i},x.name);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,girlsWearing&&girlsWearing.grouping&&girlsWearing.grouping.length&&girlsWearing.grouping.map(function(x,i){return x.values&&x.values.length&&x.values.map(function(y,j){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:j},y.to);});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{rowspan:"2"},"Ratio"),girlsWearing&&girlsWearing.grouping&&girlsWearing.grouping.length&&girlsWearing.grouping.map(function(x,i){return x.values&&x.values.length&&x.values.map(function(y,j){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"smallInput",style:{padding:"0 !important"},type:"number",name:y.to,value:y.value?y.value:null// size="2"
,onChange:function onChange(e){return _this9.addGirlsWearArray(e,x.name,j);}}));});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"w-align"},girlsWearing&&girlsWearing.grouping&&girlsWearing.grouping.length&&girlsWearing.grouping.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:x.values.length},x.total);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colspan:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,girlsWearing.groupTotal)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-9 col-md-offset-1 no-padding product-form pt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{className:"landingCalculation"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table table-bordered mb-0 landing-calc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),girlsWearing&&girlsWearing.grouping&&girlsWearing.grouping.length&&girlsWearing.grouping.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:i},x.name);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,"Average")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"To Quote"),girlsWearing&&girlsWearing.toQuote&&girlsWearing.toQuote.length>0&&girlsWearing.toQuote.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:i},x);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,girlsWearing&&girlsWearing.toQuateAvg)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Can Quote"),girlsWearing&&girlsWearing.canQuote&&girlsWearing.canQuote.length>0&&girlsWearing.canQuote.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"smallInput",style:{padding:"0 !important"},type:"number",value:x?x:null,onChange:function onChange(e){return _this9.canQuote(e,i);}}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,girlsWearing.canQuateAvg)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Agreed Price"),girlsWearing&&girlsWearing.agreedQuote&&girlsWearing.agreedQuote.length>0&&girlsWearing.agreedQuote.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"smallInput",style:{padding:"0 !important"},type:"number",value:x?x:null,onChange:function onChange(e){return _this9.agreedQuote(e,i);}}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,costing.girlsWearing.agreedQuoteAvg))))))),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding text-center profile-btn bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(){return _this9.checkValidation();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Buttons_Button__["a" /* default */],{buttonName:"cancel",buttonType:"cancel",history:this.props.history}),this.state.action==="edit"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Buttons_Button__["a" /* default */],{buttonName:"Duplicate"// history={this.props.history}
,onClick:function onClick(){return _this9.confirmDuplicate();}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"scroll-up pull-right scroll-hide"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fab"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"fab-action-button"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"btn-floating btn-large green"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-bars font-for-icon-big"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"fab-buttons"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Costing_FloatMenuList__["a" /* default */],{moduleList:this.state.moduleList,goToDiv:this.goToDiv})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"printCosting",className:"d-none"},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__printCosting_js__["a" /* default */],{costingPrint:this.state.costingPrint})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__["a" /* default */],{open:this.state.modalToggle,onClose:function onClose(){return _this9.setState({modalToggle:false});},center:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table table-bordered"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Supplier Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Process"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Width"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Price"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Select"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.supplierSectionList.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,data.supplier),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,data.process),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,data.cuttableWidth),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,data.totalCost),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"supplierSection",type:"radio",className:"filled-in hide-all",id:"supplierSection"+index,value:"supplierSection"+index,checked:false,onChange:function onChange(){return _this9.selectSupplierSec(index);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{id:"supplier-section-radio","for":"supplierSection"+index})));}))))))));}}]);return Costing;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{// toggle: state.Header.toggle,
userDetails:state.main};};var mapDispatchToProps=function mapDispatchToProps(dispatch){// options.filter((data) => data.moduleName == this.props.location.moduleName)
return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Costing));

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA6lBMVEUAAAAAgIAAl4cAlogAlYkAlogAlYUAlogAlYkAlocAlocAlYcAlogAlokA//8AlYgAl4cAl4gAlokAlokAlogAl4gAnI4AlYgAl4gAlokAlocAl4kAmIgAlYgAlokAlYcAmYoAlogAmYgAlYgAlogAgIAAlIYAlYgAjo4AlokAlYcAlosAlokAl4kAkpIAlocAlYgAmIYAlokAlYkAlIYAmIkAlIkAm4UAqqoAmYgAlYkAlogAmYwAlokAlYkAlYcAnYkAlYgAlocAl4cAl4kAmIkAl4kAmYoAlogAl4gAl4cAlYQAlogAAACPCQs8AAAATXRSTlMABIRtjJRBfEFmoICSigFNYo5OiIWJEomwmWRdLzyXkyOND8uWAhOHCXCRLl99B3dvKjhqN0VDFwMeUqMUUHs1DXSGQGw0bjJLZ0Ida3Asny8AAAABYktHRACIBR1IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4wYODjs2yg0WtAAAAKJJREFUGNNjYAACRiZmFlY2dgY44OBk5+Lm4eWDC/ALCAoJi4giVIiJS/BLSkkjBBhkZPnl5BWQBBhk+RWVlFVUIRw1WZCAuga3ppY2WEBeh4VPll9XT9/AUBAsYGRswm5qBmSYWwhD9HBbWlnbgBi2UAElEajRwlABBjtLCG0PE3BghVCOTjBnODuCKRdXuMPc3D08hb14ES715hIGAh8gCwBmww5epsuQNAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wNi0xNFQxMjo1OTo1NCswMjowMHzuoJEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDYtMTRUMTI6NTk6NTQrMDI6MDANsxgtAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format__ = __webpack_require__(689);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintCosting=function(_Component){_inherits(PrintCosting,_Component);function PrintCosting(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintCosting);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintCosting.__proto__||Object.getPrototypeOf(PrintCosting)).call.apply(_ref,[this].concat(args))),_this),_this.state={costingPrint:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintCosting,[{key:"componentWillMount",value:function componentWillMount(){var costingPrint=this.props.costingPrint;this.setState({costingPrint:costingPrint});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.costingPrint!=this.props.costingPrint){this.setState({costingPrint:nextProps.costingPrint});//   this.calculateTotal()
}}},{key:"render",value:function render(){// let costingPrint = this.props;
var costingPrint=this.state.costingPrint;// console.log(costingPrint, "costingPrint")
var Embellishment=costingPrint.Embellishment,Embroidery=costingPrint.Embroidery,Fabric=costingPrint.Fabric,Manufacturing=costingPrint.Manufacturing,OtherCharges=costingPrint.OtherCharges,SmockingShirring=costingPrint.SmockingShirring,Toggles=costingPrint.Toggles,TrimObject=costingPrint.TrimObject,Wash=costingPrint.Wash,showLandedCalc=costingPrint.showLandedCalc,selectedConversion=costingPrint.selectedConversion,currencyUpdate=costingPrint.currencyUpdate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n                body{\n                    font-family: 'Montserrat', sans-serif;\n                    font-size:12px;\n                }\n                .fabricPrintDiv{\n                    border : 2px solid black;\n                    top : 0;\n                    bottom : 0;\n                }\n\n                .printrow {\n\n                    width: 100%;\n                }\n\n                .printcolumn {\n                    display: flex;\n                    flex-direction: column;\n                    flex-basis: 100%;\n                    flex: 1;\n                }\n                table>tbody>tr td{\n                    font-size:9px;\n                    text-align:center;\n                }\n                .label-text{\n                    color:#279588;\n                    font-size : 11px;\n                    font-weight:bold;\n                }\n                .label-text2{\n                    color:#279588;\n                    // font-size : 11px;\n                    font-weight:bold;\n                }\n                .blue{\n                    color : #146FF9;\n                }\n                .padding-for-heading{\n                    padding: 5px;\n                }\n\n\n                .specialComments{\n                    width: 75%;\n                    border : 1px solid black;\n                    height : 60px;\n                    margin: 10px;\n                }\n\n                .b{\n                    border: 1px solid black;\n                    margin: 10px;\n                    padding: 5px;\n                }\n                .fabric-text{\n                    font-size:16px;\n                    color: #279588;\n                    font-weight: 1000;\n                }\n\n                .bold{\n                    font-weight:bold;\n                }\n                .bb-p{\n                    border-bottom: 1px solid black;\n                    margin-bottom: 10px ;\n                }\n                .w-50 {\n                    width: 50%;\n                }\n                table.grid{\n                    border-collapse: collapse;\n                    margin-right: 5px;\n                    margin-left: 5px;\n                }\n                table.grid>tbody>tr td {\n                    border: 0.5px solid black;\n                    text-align: center;\n                    padding: 2px;\n                }\n                .width-for-table{\n                    width: 50%;\n                }\n                .text-center{\n                    text-align: center !important;\n                }\n                .p-1{\n                    padding : 5px;\n                }\n                .pl-1{\n                    padding-left: 23px;\n                }\n                .border-bot{\n                    border-bottom : 1px solid black;\n                }\n                .mt{\n                    margin-top:10px;\n                }\n                .mtl{\n                    margin-top:30px;\n                }\n                .margin{\n                    margin : 5px;\n                }\n                .pl-2{\n                    padding: 5px;\n                }\n                .table-heading{\n                    padding-left:5px;\n                    margin:0;\n                    color:#4285f4;\n                    text-transform:uppercase;\n\n                }\n\n                .text-capitalize{\n                    text-transform: capitalize;\n                }\n\n                .padding-option{\n                    padding:0px 20px 0px 60px;\n\n                }\n                .paddingLeft{\n                    left:100px !important;\n                }\n                table{\n                    width:100%;\n                }\n                .test-class{\n                    width:40%;\n\n                    display:inline-block\n                }\n                .test-class1{\n                    width:20%;\n                    display:inline-block\n                }\n                .test-class2{\n                    width:40%;\n                    display:inline-block\n                }\n                .float-left{\n                    float:left !important;\n                }\n\n                .padding-align-qc{\n                    padding-left: 42%!important;\n                }\n                .text-right{\n                    text-align:right !important;\n                }\n                .title-color{\n                    padding-left:5px;\n                    margin:0;\n                    color:#0033cc;\n                }\n                .total-title-color{\n                    color:#0066ff;\n                }\n                .float-right{\n                    float:right !important;\n                }\n                .col-md-6{\n                    width:50% !important;\n                }\n                .label-color{\n                    color:#279588;\n                    padding-left:5px;\n                    margin:0;\n                }\n               .total-value-calc{\n                   display:flex;\n                   flex-direction:row-reverse;\n                   padding:0 !important;\n               }\n               .col-md-9{\n                   width:75% !important;\n               }\n               .col-md-3{\n                   width: 25% !important;\n\n               }\n               .col-md-4{\n                   width:33.3% !important;\n               }\n               .height-value{\n                   height:160px !important;\n               }\n               .text-area-border{\n\n                   border: 2px solid black !important;\n               }\n                }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 table-heading "},"MAGNUM CLOTHING PVT LTD - COSTING SHEET"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Mag style no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Costing ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Cust ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"customer-dept"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Mag style name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Costing Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"smocking/sheering"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Toggles.smockingSheering?"Y":"N")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.styleReferenceId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.customerRefNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.customerName&&costingPrint.customerName||""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.magnumStyleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.costingType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"embroidery"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Toggles.embroidery?"Y":"N")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"costing done by"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.createdBy),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"costing done on"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.costingCreatedTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"modified by"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.modifiedBy?costingPrint.modifiedBy:costingPrint.createdBy),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"modified on"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},costingPrint.updatedAt)))))),Fabric.FabricArrayData.length>0&&Toggles.fabric&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold"},"fabric cost details"),Fabric.FabricArrayData.map(function(fabric,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"fabric no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"count & construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Quality/Classification"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"supplier"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"position"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"marker"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Print-Direction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"consp"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto"},"total/(INR)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.fabricNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.countAndConstruction),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.qualityClassification),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.supplierName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.fabricPosition),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.marker),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.printDirection),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.fabricSize),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.width),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.consumption&&Number(fabric.consumption).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.price&&Number(fabric.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(fabric.totalCost).toFixed(2),displayType:'text',thousandSeparator:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,fabric.emb&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Greige"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Value Loss"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Emb"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Value Loss"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Dying/Print"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST")),fabric.yarn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Yarn Cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST")),fabric.greigeset&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Greige"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Value Loss"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Dying/Print"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Up-Charge%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,fabric.emb&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.greige||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.valueLoss||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.embCost||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.EmbValueLoss||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.dyingPrint||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.upCharge||'','%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.gst||fabric.defaultGst)),fabric.yarn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.yardDyedCost||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.upCharge||'','%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.gst||fabric.defaultGst)),fabric.greigeset&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.greige||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.valueLoss||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.dyingPrint||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.upCharge||'','%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fabric.gst||fabric.defaultGst))),index===Fabric.FabricArrayData.length-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"11",className:"label-text text-right total-title-color"},"Total fabric cost(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Fabric.totalCost).toFixed(2),displayType:'text',thousandSeparator:true}))))));}))),(TrimObject.trimPack.trimPackNo!==null||TrimObject.trimArrayData.length>0)&&Toggles.trim&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold"},"trim cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"trim category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"trim ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"supplier"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"consp/unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto"},"total(INR)")),TrimObject.trimPack.trimPackNo!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},"Trim Pack"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.trimPackNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.typeOfGmt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.packagingMethod),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.packingType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.subType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.consumption&&Number(TrimObject.trimPack.consumption).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},TrimObject.trimPack.price&&Number(TrimObject.trimPack.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto"},TrimObject.trimPack.trimPackTotalCost)),TrimObject.trimArrayData.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.quality),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.supplierName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.consumption&&Number(trim.consumption).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.price&&Number(trim.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(trim.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"8",className:"label-text text-right total-title-color"},"Total trim cost(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(TrimObject.totalCost).toFixed(2),displayType:'text',thousandSeparator:true}))))))),SmockingShirring.smockingShirringArray.length>0&&Toggles.smockingSheering&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold"},"smocking shirring cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Trim Ref Number"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"No Of Rows"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Length in Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Total Requird Mtrs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto"},"Total/(INR)")),SmockingShirring.smockingShirringArray.map(function(smock,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.trimCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.trimNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.placement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.noOfRow),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.length),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.totalReq&&Number(smock.totalReq).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},smock.price&&Number(smock.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto`"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(smock.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"8",className:"label-text text-right total-title-color"},"Total Smocking Shirring cost(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(SmockingShirring.totalCost).toFixed(2),displayType:'text',thousandSeparator:true}))))))),Embroidery.EmbroideryArray.length>0&&Toggles.embroidery&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold float-left padding-option"},"embroidery cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold float-left padding-option"},"backing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold float-left padding-option"},Embroidery.BackingArray.length?"YES":"NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold float-left padding-option"},"bit attaching"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold"},Embroidery.bitAttaching?"YES":"NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"emb placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"emb form"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"no of cols"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"frames"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"stiches/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"consp"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"stitch count"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/1000 stitches"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto"},"total(INR)")),Embroidery.EmbroideryArray.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.embPlacement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.embForm),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.noOfCols),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.frames),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.stitchesMtr),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.consumption&&Number(data.consumption).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.stitchCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.priceForStitches&&Number(data.priceForStitches).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(data.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"8",className:"label-text text-right total-title-color"},"Total Embroidery cost(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Embroidery.embroideryTotalCost).toFixed(2),displayType:'text',thousandSeparator:true}))),Embroidery.BackingArray.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"backing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"width"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"consp"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto"},"total(INR)")),Embroidery.BackingArray.map(function(back,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},back.backingType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},back.width),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},back.placement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},back.consumption&&Number(back.consumption).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},back.price&&Number(back.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold ml-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(back.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:"8",className:"label-text text-right total-title-color"},"Total backing cost(INR)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Embroidery.backingTotalCost).toFixed(2),displayType:'text',thousandSeparator:true})))))))),Embellishment.embellishmentArray.length>0&&Toggles.embellishment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold"},"embellishment cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"no-padding-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6",style:{marginRight:"-200px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"HH:MM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"price/30 mins"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text ml-auto "},"total/(INR)")),Embellishment.embellishmentArray.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.embType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.hoursMinutes).format("HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.pricePerHalfHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold text-center ml-auto "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(data.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginTop:"0px",marginBottom:'5px'},className:"label-text text-right total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Embellishment.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginTop:"0px",marginBottom:'5px'},className:"label-text text-right total-title-color"},"Total embelish cost(INR)")))),Wash.washArray.length>0&&Toggles.wash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold float-left padding-option"},"wash cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold float-left padding-option"},"tacking"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"label-color bold"},"Y/N"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"no-padding-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"type of wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"laundary unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"wt/gmt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text "},"price/kg"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:" label-text ml-auto "},"total(INR)")),Wash.washArray.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.washType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.laundryUnit),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.weight),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},data.price&&Number(data.price).toFixed(2)||"0.00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold text-center ml-auto "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(data.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginTop:"0px",marginBottom:'5px'},className:"label-text text-right total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Wash.washCost).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginTop:"0px",marginBottom:'5px'},className:"label-text text-right total-title-color"},"Total wash cost(INR)")))),OtherCharges.otherChargesArray.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold float-left padding-option"},"other charges"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'10px',marginBottom:'0',marginTop:"0px"},className:"label-text"},"total(INR)")),OtherCharges.otherChargesArray.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0',marginTop:"0px",fontSize:'10px'},className:"bold"},data.value&&Number(data.value).toFixed(2)||data.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0',marginTop:"0px",fontSize:'10px'},className:" bold"},data.label));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0',marginTop:"5px"},className:"label-text text-right total-title-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(OtherCharges.otherTotalCost).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0',marginTop:"5px"},className:"bold total-title-color"},"Total other cost(INR)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title-color bold"},"manufacturing process / piece cost details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"w-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"order qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SAM@80%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"rev / tailor @",costingPrint.Manufacturing.perMachine),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"rev / machine @1750")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.orderQty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.smv100),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.revTailer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.revMachine))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Manufacturing.fixedCharge).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"label-text bold"},"Fixed charges")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},Manufacturing.CMT),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},"CMT @ ",Manufacturing.CMTSelected)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Manufacturing.totalCost).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"total manufacturing cost")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sample"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"dated"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"pattern"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"dated")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.selectedMenu.name==='sample'?Manufacturing.selectedMenu.value:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.selectedMenu.name==='sample'?__WEBPACK_IMPORTED_MODULE_1_moment___default()(Manufacturing.selectedMenu.data).format('Do MMM YYYY'):'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.selectedMenu.name==='pattern'?Manufacturing.selectedMenu.value:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.selectedMenu.name==='pattern'?__WEBPACK_IMPORTED_MODULE_1_moment___default()(Manufacturing.selectedMenu.data).format('Do MMM YYYY'):"N/A"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-9"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px'},className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Manufacturing.others.valueLoss.total).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'5px',marginBottom:'0px'},className:"label-text2 bold"},Number(Manufacturing.others.valueLoss.value).toFixed(2),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'5px',marginBottom:'0px'},className:"bold"},"value loss")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Number(Manufacturing.others.overHeads.total).toFixed(2),displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'5px',marginBottom:'0px',marginTop:"0px"},className:"label-text2 bold"},Number(Manufacturing.others.overHeads.value).toFixed(2),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'10px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"contribution to overheads")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.costingTotal,displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},"total cost(INR)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},selectedConversion==="usd"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},"$",Manufacturing.currencies.usd.total),selectedConversion==="gbp"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},"\xA3",Manufacturing.currencies.gbp.total),selectedConversion==="euro"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},"\u20AC",Manufacturing.currencies.eur.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},selectedConversion==="usd"&&"USD-$-"+(currencyUpdate&&currencyUpdate.usd!==undefined&&currencyUpdate.usd!==null?currencyUpdate.usd:Manufacturing.currencies.usd.value),selectedConversion==="gbp"&&"GBP-\xA3-"+(currencyUpdate&&currencyUpdate.gbp!==undefined&&currencyUpdate.gbp!==null?currencyUpdate.gbp:Manufacturing.currencies.gbp.value),selectedConversion==="euro"&&"Euro-\u20AC-"+(currencyUpdate&&currencyUpdate.eur!==undefined&&currencyUpdate.eur!==null?currencyUpdate.eur:Manufacturing.currencies.eur.value))))))))),!showLandedCalc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize height-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},Manufacturing.shipment.shipmentTerm),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"shipment term")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},Manufacturing.shipment.shipmentMode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"ship mode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},Manufacturing.agreedCurrency||'$',Manufacturing.agreedPrice),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},"agreed price")))))))),showLandedCalc==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize height-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold",style:{marginBottom:"0px",paddingLeft:"5px"}},"If landed,then the working is : "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"conversion to"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold "},Manufacturing.fromCurrencyConvertion," to ",Manufacturing.toCurrencyConvertion),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.conversionTotal,displayType:'text',thousandSeparator:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"conversion rate"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Manufacturing.coversionRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},Manufacturing.rateValue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Freight charges"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.freightCharges,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.freightTotal,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"duty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.dutyValue,displayType:'text',thousandSeparator:true,prefix:'%'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.dutyTotal,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"processing cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.processingCost,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.processValue,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"total-title-color bold"},"Total landed cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"total-title-color bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format__["a" /* default */],{value:Manufacturing.totalLanding,displayType:'text',thousandSeparator:true,prefix:Manufacturing.toCurrencyConvertion==='GBP'?'£':Manufacturing.toCurrencyConvertion==='EUR'?'€':'$'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},Manufacturing.shipment.shipmentTerm),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"shipment term")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"bold"},Manufacturing.shipment.shipmentMode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"bold"},"ship mode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},Manufacturing.landedPrice),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},"landed price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"total-value-calc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'30px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},Manufacturing.agreedCurrency||'$',Manufacturing.agreedPrice),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginRight:'40px',marginBottom:'0px',marginTop:"0px"},className:"total-title-color bold"},"agreed price")))))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"17%"},className:"comments-height"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold",style:{marginBottom:'0'}},"Special Comments :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"85%",border:'1px solid black',padding:'5px'}},Manufacturing.comments&&Manufacturing.comments.split('\n').map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{wordWrap:'break-word',margin:"0"}},comment);})))));}}]);return PrintCosting;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintCosting);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**
 * react-number-format - 4.9.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */



//     

                                                               

// basic noop function
function noop() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop,
  onChange: noop,
  onKeyDown: noop,
  onMouseUp: noop,
  onFocus: noop,
  onBlur: noop,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var removeFormatting = ref.removeFormatting;
    var mask = ref.mask;
    var defaultValue = ref.defaultValue;
    var isNumericString = ref.isNumericString;
    var allowNegative = ref.allowNegative;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var allowLeadingZeros = ref.allowLeadingZeros;
    var onValueChange = ref.onValueChange;
    var isAllowed = ref.isAllowed;
    var customNumerals = ref.customNumerals;
    var onChange = ref.onChange;
    var onKeyDown = ref.onKeyDown;
    var onMouseUp = ref.onMouseUp;
    var onFocus = ref.onFocus;
    var onBlur = ref.onBlur;
    var propValue = ref.value;
    var rest = objectWithoutProperties( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

NumberFormat.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NumberFormat);


/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModuleHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ModuleHeader(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:props.colSpan?props.colSpan:"11",className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"mb-0 text-primary font-weight-bold"},props.header)));}

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TotalCostRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NumberField__ = __webpack_require__(244);
function TotalCostRow(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colspan:!props.colSpan?"9":props.colSpan,className:"border-top-0 text-right naming"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"font-13 text-primary"},"Total "+props.moduleName+" Cost (INR)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:props.trClassName?props.trClassName:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NumberField__["a" /* default */],{value:props.totalCostValue||"0.00",name:props.name,onChange:props.onChange// onChange= {}
,disabled:true})));}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Totalheader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Totalheader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-center"},"Total(INR)");}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_Loading__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
var CostingComparison=function(_Component){_inherits(CostingComparison,_Component);function CostingComparison(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CostingComparison);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CostingComparison.__proto__||Object.getPrototypeOf(CostingComparison)).call.apply(_ref,[this].concat(args))),_this),_this.state={costings:[],isLoading:false,goBack:-1},_this.printCosting=function(){_this.setState({isLoading:true});var divToPrint=document.getElementById("costingTableCompare");var mydiv=document.getElementById("h6");mydiv.innerHTML+="Costing Comparison";var divToPrint=document.getElementById("costingTableCompare");var newWin=window.open("","mywindow");newWin.document.body.innerHTML="<html><head><title></title><style>h5{text-align:center}table,th,td{border: 1px solid black !important;text-align:center}</style></head><body>"+divToPrint.outerHTML+"</body>";newWin.focus();newWin.print();mydiv.innerHTML=null;_this.setState({isLoading:false});newWin.close();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CostingComparison,[{key:"componentWillMount",value:function componentWillMount(){var urlParams=new URLSearchParams(this.props.location.search);var ids=urlParams.get("_id").split(',');this.props.history.replace('/CostingComparison',this.props.location.search);this.setState({ids:ids});//     if(!ids){
//         let { ids } = this.props.location.state
//     CostingServices.costingCompare(ids).then((res) => {
//         if (res.status === 200) {
//             this.setState({ costings: res.text.data, isLoading: false })
//         }
//     }).catch((err) => {
//         this.props.getalertMessage("error", err.message)
//     })
//     }
}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var search=this.props.location.search;var urlParams=new URLSearchParams(this.props.location.search);var ids=urlParams.get("_id").split(',');// ids.map(x=>x)
ids.map(function(x){return x;});__WEBPACK_IMPORTED_MODULE_2__services__["b" /* CostingServices */].costingCompare(ids).then(function(res){if(res.status==200){_this2.setState({costings:res.text.data,isLoading:false});}}).catch(function(err){_this2.props.getalertMessage("error",err.message);});}},{key:"render",value:function render(){var _this3=this;var list=this.state.costings;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-section comparing-table mt-3",style:{height:"auto!important",paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-2 position-top-stick"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(){var _props$history=Object.assign({},_this3.props.history),route=_props$history.route;route!==undefined?_this3.props.history.push("/"+route,_defineProperty({},""+route.toLowerCase(),Object.assign({},_this3.props.history.location.state[""+route.toLowerCase()]))):_this3.props.history.goBack();// this.printFabric()
}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_1__assets_images_left_arrow_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Costing Comparison")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary pull-right px-2 py-1 mr-3",onClick:function onClick(){return _this3.printCosting();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-print font-size"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"costingTableCompare"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{id:"h6",className:"text-center"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,list.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"15%"},"\xA0"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.costingNumber," / ",x.customerName," / ",x.styleNumber,"-",x.magnumStyleName));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"12"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,list.length>0&&Object.keys(list[0].fabric).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Fabric"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.fabric[y]);}));}),list.length>0&&list[0].fabricTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.fabricTotalCost);})),list.length>0&&Object.keys(list[0].trimPack).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"TrimPack"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.trimPack[y]);}));}),list.length>0&&Object.keys(list[0].trim).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Trim"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.trim[y]);}));}),list.length>0&&list[0].trimTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.trimTotalCost);})),list.length>0&&Object.keys(list[0].embellishment).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Embelishment"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.embellishment[y]);}));}),list.length>0&&list[0].embelishmentTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.embelishmentTotalCost);})),list.length>0&&Object.keys(list[0].embroidery).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Embroidery"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.embroidery[y]);}));}),list.length>0&&list[0].embroideryTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.embroideryTotalCost);})),list.length>0&&Object.keys(list[0].smockingSheering).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Smocking Sheering"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.smockingSheering[y]);}));}),list.length>0&&list[0].smockingSheeringTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.smockingSheeringTotalCost);})),list.length>0&&Object.keys(list[0].wash).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{title:"Wash"},y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.wash[y]);}));}),list.length>0&&list[0].washTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.washTotalCost);})),list.length>0&&Object.keys(list[0].others).map(function(y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,y),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,x.others[y]);}));}),list.length>0&&list[0].otherTotalCost!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.otherTotalCost);})),list.length>0&&list[0].fixedCharge!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Fixed Charge"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.fixedCharge);})),list.length>0&&list[0].cmt!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"CMT"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.cmt);})),list.length>0&&list[0].cmt!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Value Loss @"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.valueLoss);})),list.length>0&&list[0].cmt!=="0"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Contribution % to overheads"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.overHeads);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total[INR]"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.costingTotal);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"System Total(Converted)"),list.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,x.convertedTotal);})))))));}}]);return CostingComparison;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CostingComparison);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GenerateTag=function(_Component){_inherits(GenerateTag,_Component);function GenerateTag(props){_classCallCheck(this,GenerateTag);var _this=_possibleConstructorReturn(this,(GenerateTag.__proto__||Object.getPrototypeOf(GenerateTag)).call(this,props));_this.alertOptions={offset:65,position:'top left',theme:'dark',time:1000,transition:'scale'};_this.state={meetingNotes:[],meetingNoteContent:'',searchMeetingNotesBy:''};return _this;}_createClass(GenerateTag,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].listMeetingNotes().then(function(response){if(response.message==="List Displayed"){_this2.setState({meetingNotes:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}},{key:'cloneMeeting',value:function cloneMeeting(id){var _this3=this;__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].cloneMeeting(id).then(function(response){if(response.message==="Meeting Note cloned"){__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].listMeetingNotes().then(function(response){if(response.message==="List Displayed"){_this3.setState({meetingNotes:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this3.msg);});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this3.msg);});}},{key:'removeMeeting',value:function removeMeeting(id){var _this4=this;__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].removeMeeting(id).then(function(response){if(response.message==="Meeting Note successfully deleted"){__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].listMeetingNotes().then(function(response){if(response.message==="List Displayed"){_this4.setState({meetingNotes:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this4.msg);});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this4.msg);});}},{key:'searchMeetingNotes',value:function searchMeetingNotes(){var _this5=this;__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].searchMeetingNotesBy(this.state.searchMeetingNotesBy,this.state.meetingNoteContent).then(function(response){if(response.message==="List Displayed"){_this5.setState({meetingNotes:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this5.msg);});}},{key:'addMeetingContent',value:function addMeetingContent(e){this.setState({meetingNoteContent:e.target.value},function(){var _this6=this;if(this.state.meetingNoteContent.length===0){__WEBPACK_IMPORTED_MODULE_1__services__["g" /* MeetingNotesServices */].listMeetingNotes().then(function(response){if(response.message==="List Displayed"){_this6.setState({meetingNotes:response.data});}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1__services__["m" /* UtilityService */].errorMsg(_this6.msg);});}});}},{key:'render',value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_alert___default.a,Object.assign({ref:function ref(a){return _this7.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'right-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageHeader_PageHeader__["a" /* default */],{header:'Tag'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'card-container  meeting-min-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'row',style:{paddingBottom:"2%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 product-form no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{'class':'dev-title',style:{paddingLeft:"15px",paddingBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Tag'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'upload-photo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_no_product_image_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Customer Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'',value:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Magnum Ref No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'',value:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Style Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'',value:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Fabric'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text','class':'form-control',name:'',value:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'ref-no'},'Wash Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Soft Wash '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Acid Wash ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-1 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0','class':'form-control',name:'',value:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Sample Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{'class':'form-control',name:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Soft Wash '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'style'},'Acid Wash ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-2 step-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':''},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date','class':'form-control',name:'',value:''}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-12 no-padding text-center profile-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button'},'Back'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button'},'Complete'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button'},'Edit'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button'},'print'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','class':'primary',name:'button'},'Cancel'))))))))));}}]);return GenerateTag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GenerateTag);

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7),__webpack_require__(0)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(13),f=r(c),s=n(11),p=r(s),d=n(12),m=r(d),y=n(6),v=[p.default.string,p.default.number,p.default.array,p.default.object],b=[p.default.string,p.default.array],h=[p.default.object,p.default.bool],g=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.setTimer=function(){n.clearTimer();var e=n.props.interval;t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))},n.clearTimer=function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(n)},t.globalMoment||(t.globalMoment=m.default),n.state={content:""},n.timer=null,n}return a(t,e),l(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){return e instanceof t?void(t.pooledElements.indexOf(e)===-1&&t.pooledElements.push(e)):void console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);n!==-1&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,u=e.tz;o=o||e.children,a=a||t.globalParse,u=u||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var l=null;return l=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),u&&(l=l.tz(u)),l}}]),l(t,[{key:"componentWillMount",value:function(){this.update(this.props)}},{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentWillReceiveProps",value:function(e){this.update(e)}},{key:"componentDidUpdate",value:function(e){e.interval!==this.props.interval&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=this;e=e||this.props;var r=e,o=r.fromNow,i=r.fromNowDuring,a=r.from,u=r.add,l=r.subtract,c=r.toNow,f=r.to,s=r.ago,p=r.calendar,d=r.diff,y=r.unit,v=r.decimal,b=e,h=b.format;h=h||t.globalFormat;var g=t.getDatetime(e);u&&g.add(u),l&&g.subtract(l);var O=Boolean(i)&&-g.diff((0,m.default)())<i,T="";T=h&&!O?g.format(h):a?g.from(a,s):o||O?g.fromNow(s):f?g.to(f,s):c?g.toNow(s):p?g.calendar(null,p):d?g.diff(d,y,v):g.toString();var w=t.globalFilter||this.props.filter;T=w(T),this.setState({content:T},function(){n.props.onChange(T)})}},{key:"render",value:function(){var e=(0,y.objectKeyFilter)(this.props,t.propTypes);return f.default.createElement(t.globalElement||this.props.element,u({dateTime:t.getDatetime(this.props)},e),this.state.content)}}]),t}(f.default.Component);g.propTypes={element:p.default.any,date:p.default.oneOfType(v),parse:p.default.oneOfType(b),format:p.default.string,add:p.default.object,subtract:p.default.object,ago:p.default.bool,fromNow:p.default.bool,fromNowDuring:p.default.number,from:p.default.oneOfType(v),toNow:p.default.bool,to:p.default.oneOfType(v),calendar:p.default.oneOfType(h),unix:p.default.bool,utc:p.default.bool,tz:p.default.string,locale:p.default.string,interval:p.default.number,diff:p.default.oneOfType(v),unit:p.default.string,decimal:p.default.bool,filter:p.default.func,onChange:p.default.func},g.defaultProps={element:"time",fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,unit:null,decimal:!1,interval:6e4,filter:function(e){return e},onChange:function(){}},g.globalMoment=null,g.globalLocale=null,g.globalFormat=null,g.globalParse=null,g.globalFilter=null,g.globalElement=null,g.globalTimezone=null,g.pooledElements=[],g.pooledTimer=null,t.default=g},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function i(e){if(s===clearTimeout)return clearTimeout(e);if((s===r||!s)&&clearTimeout)return s=clearTimeout,clearTimeout(e);try{return s(e)}catch(t){try{return s.call(null,e)}catch(t){return s.call(this,e)}}}function a(){y&&d&&(y=!1,d.length?m=d.concat(m):v=-1,m.length&&u())}function u(){if(!y){var e=o(a);y=!0;for(var t=m.length;t;){for(d=m,m=[];++v<t;)d&&d[v].run();v=-1,t=m.length}d=null,y=!1,i(e)}}function l(e,t){this.fun=e,this.array=t}function c(){}var f,s,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{s="function"==typeof clearTimeout?clearTimeout:r}catch(e){s=r}}();var d,m=[],y=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];m.push(new l(e,t)),1!==m.length||y||o(u)},l.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,l){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[n,o,i,a,u,l],s=0;c=new Error(t.replace(/%s/g,function(){return f[s++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(2),o=r;if("production"!==t.env.NODE_ENV){var i=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];i.apply(void 0,[t].concat(r))}}}e.exports=o}).call(t,n(1))},function(e,t){"use strict";function n(e,t){var n=Object.keys(t),r=Object.assign({},e);return Object.keys(r).filter(function(e){return n.indexOf(e)!==-1}).forEach(function(e){return delete r[e]}),r}Object.defineProperty(t,"__esModule",{value:!0}),t.objectKeyFilter=n},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,u,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var f in r)i.call(r,f)&&(l[f]=r[f]);if(o){u=o(r);for(var s=0;s<u.length;s++)a.call(r,u[s])&&(l[u[s]]=r[u[s]])}}return l}},function(e,t,n){(function(t){"use strict";function r(e,n,r,l,c){if("production"!==t.env.NODE_ENV)for(var f in e)if(e.hasOwnProperty(f)){var s;try{o("function"==typeof e[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",l||"React class",r,f,typeof e[f]),s=e[f](n,f,l,r,null,a)}catch(e){s=e}if(i(!s||s instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",l||"React class",r,f,typeof s),s instanceof Error&&!(s.message in u)){u[s.message]=!0;var p=c?c():"";i(!1,"Failed %s type: %s%s",r,s.message,null!=p?p:"")}}}if("production"!==t.env.NODE_ENV)var o=n(3),i=n(5),a=n(4),u={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(2),o=n(3),i=n(4);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){(function(t){"use strict";var r=n(2),o=n(3),i=n(5),a=n(7),u=n(4),l=n(8);e.exports=function(e,n){function c(e){var t=e&&(R&&e[R]||e[I]);if("function"==typeof t)return t}function f(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function s(e){this.message=e,this.stack=""}function p(e){function r(r,c,f,p,d,m,y){if(p=p||S,m=m||f,y!==u)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var v=p+":"+f;!a[v]&&l<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",m,p),a[v]=!0,l++)}return null==c[f]?r?new s(null===c[f]?"The "+d+" `"+m+"` is marked as required "+("in `"+p+"`, but its value is `null`."):"The "+d+" `"+m+"` is marked as required in "+("`"+p+"`, but its value is `undefined`.")):null:e(c,f,p,d,m)}if("production"!==t.env.NODE_ENV)var a={},l=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,o,i,a){var u=t[n],l=P(u);if(l!==e){var c=N(u);return new s("Invalid "+o+" `"+i+"` of type "+("`"+c+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return p(t)}function m(){return p(r.thatReturnsNull)}function y(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var a=t[n];if(!Array.isArray(a)){var l=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var c=0;c<a.length;c++){var f=e(a,c,r,o,i+"["+c+"]",u);if(f instanceof Error)return f}return null}return p(t)}function v(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return p(t)}function b(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||S,u=_(t[n]);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return p(t)}function h(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(f(a,e[u]))return null;var l=JSON.stringify(e);return new s("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?p(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function g(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var c in a)if(a.hasOwnProperty(c)){var f=e(a,c,r,o,i+"."+c,u);if(f instanceof Error)return f}return null}return p(t)}function O(e){function n(t,n,r,o,i){for(var a=0;a<e.length;a++){var l=e[a];if(null==l(t,n,r,o,i,u))return null}return new s("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var a=e[o];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",k(a),o),r.thatReturnsNull}return p(n)}function T(){function e(e,t,n,r,o){return j(e[t])?null:new s("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return p(e)}function w(e){function t(t,n,r,o,i){var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var c in e){var f=e[c];if(f){var p=f(a,c,r,o,i+"."+c,u);if(p)return p}}return null}return p(t)}function E(e){function t(t,n,r,o,i){var l=t[n],c=P(l);if("object"!==c)return new s("Invalid "+o+" `"+i+"` of type `"+c+"` "+("supplied to `"+r+"`, expected `object`."));var f=a({},t[n],e);for(var p in f){var d=e[p];if(!d)return new s("Invalid "+o+" `"+i+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(l,p,r,o,i+"."+p,u);if(m)return m}return null}return p(t)}function j(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(j);if(null===t||e(t))return!0;var n=c(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!j(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!j(i[1]))return!1}return!0;default:return!1}}function x(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function P(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":x(t,e)?"symbol":t}function N(e){if("undefined"==typeof e||null===e)return""+e;var t=P(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function k(e){var t=N(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:S}var R="function"==typeof Symbol&&Symbol.iterator,I="@@iterator",S="<<anonymous>>",D={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:m(),arrayOf:y,element:v(),instanceOf:b,node:T(),objectOf:g,oneOf:h,oneOfType:O,shape:w,exact:E};return s.prototype=Error.prototype,D.checkPropTypes=l,D.PropTypes=D,D}}).call(t,n(1))},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(10)(o,i)}else e.exports=n(9)()}).call(t,n(1))},function(t,n){t.exports=e},function(e,n){e.exports=t}])});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_action_rights__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printFabric_css__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printFabric_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__printFabric_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PrintFabricNo_TableRowSelect__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PrintFabricPage__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PrintStylePage__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_download_png__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_download_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_download_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_common_options__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Component
//Assets
//options
var PrintFabricNumber=function(_Component){_inherits(PrintFabricNumber,_Component);function PrintFabricNumber(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintFabricNumber);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintFabricNumber.__proto__||Object.getPrototypeOf(PrintFabricNumber)).call.apply(_ref,[this].concat(args))),_this),_this.state={moduleName:"",activePage:1,totalItemsCount:0,NumberFrom:"",NumberTo:"",SearchDateFrom:"",SearchDateTo:"",List:[],NumberFromList:[],NumberFromObj:"",NumberToObj:"",column:[],selectedData:[],isLoading:false,columnAll:true},_this.getFabricNumber=function(value){__WEBPACK_IMPORTED_MODULE_9__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){_this.setState({NumberFromList:response.text.data,isLoading:true});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status==401&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.searchBy=function(){var _this$state=_this.state,NumberTo=_this$state.NumberTo,NumberFrom=_this$state.NumberFrom,SearchDateFrom=_this$state.SearchDateFrom,SearchDateTo=_this$state.SearchDateTo;if(NumberTo!==""&&NumberFrom!==""){var data={filterType:_this.state.moduleName==="Fabric"?"fabricNumber":"",from:NumberFrom,to:NumberTo};if(_this.state.moduleName==="Fabric"){__WEBPACK_IMPORTED_MODULE_9__services__["e" /* DevelopmentServices */].searchFilterForFabricNumber(data).then(function(response){_this.setState({List:response.data});}).catch(function(error){});}}if(SearchDateFrom!==""&&SearchDateTo!==""){var _data={filterType:"dateRange",from:SearchDateFrom,to:SearchDateTo};if(_this.state.moduleName==="Fabric"){__WEBPACK_IMPORTED_MODULE_9__services__["e" /* DevelopmentServices */].searchFilterForFabricNumber(_data).then(function(response){_this.setState({List:response.data});}).catch(function(error){});}}},_this.getNumberList=function(e){if(_this.state.moduleName==="Fabric"){if(e!=""){__WEBPACK_IMPORTED_MODULE_9__services__["e" /* DevelopmentServices */].getFabricNumber(e).then(function(response){if(response.status==200){_this.setState({NumberFromList:response.text.data});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status==401&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}}},_this.getNumberFrom=function(fabricNum){if(fabricNum){_this.setState({NumberFrom:fabricNum.value,NumberFromObj:fabricNum});}else{_this.setState({NumberFrom:"",NumberFromObj:""});_this.getFabricNumber("");}},_this.getNumberTo=function(fabricNum){if(fabricNum){_this.setState({NumberTo:fabricNum.value,NumberToObj:fabricNum});}else{_this.setState({NumberTo:"",NumberToObj:""});_this.getFabricNumber("");}},_this.__handleFromDateChange=function(name,value){_this.setState(_defineProperty({},name,value));},_this._handlePageChange=function(pageNumber){_this.setState({activePage:pageNumber});},_this.printDiv=function(val){var divToPrint=document.getElementById(val);var newWin=window.open("","_blank");newWin.document.write("\n      <html>\n        <head>\n          <title>Print</title>\n          <style>\n            @media print {\n              body { font-family: 'Lato', sans-serif; font-size: 1rem; }\n              .print-h-w{height:98%;width:100%;border:1px solid black;page-break-after: always; word-wrap: break-word;}\n              .td-border{border-bottom:1px solid black;width:100%;}\n              table > tbody > tr td{font-size:11px;vertical-align:top;padding:0px 0px;max-width:100%;}\n              .text-center{text-align:center;}\n              .f-15{font-size:10px;}\n              .qr-wrap{padding:0px;height:100%}\n            }\n            img {\n              display: block;\n              max-width: 100%;\n              height: auto;\n            }\n          </style>\n        </head>\n        <body>\n          "+divToPrint.innerHTML+"\n        </body>\n      </html>\n    ");newWin.document.close();// Wait for images to load before printing
newWin.onload=function(){newWin.focus();newWin.print();newWin.close();};},_this.getRowData=function(data){var selectedData=[];if(data.all){selectedData=data.rowData.map(function(datarowData,index){var dat=Object.assign({},datarowData);return dat;});}else{selectedData=data.rowData.filter(function(datarowData,index){if(datarowData["checkbox"+index]){var dat=Object.assign({},datarowData);return dat;}});}_this.setState({all:data.all,selectedData:selectedData,column:data.column,columnAll:data.columnAll});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintFabricNumber,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var moduleName=this.props.location.state.moduleName;if(moduleName==="Fabric"){this.setState({isLoading:false});this.getFabricNumber("");}if(moduleName==="Style"){__WEBPACK_IMPORTED_MODULE_9__services__["k" /* StyleServices */].SearchStyle("").then(function(response){if(response.status==200){var jsonData=[];response.text.data.map(function(info){return jsonData.push({label:info.styleNumber,value:info._id});});_this2.setState({NumberFromList:jsonData,isLoading:true});}}).catch(function(error){// UtilityService.errorMsg(this.msg);
});}this.setState({moduleName:moduleName});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var moduleName=nextProps.location.state.moduleName;// if (moduleName === "Fabric") {
//   this.setState({ isLoading: false });
//   DevelopmentServices.getFabricNumber("")
//     .then(response => {
//       if(response.status == 200){
//         this.setState({ NumberFromList: response.text.data, isLoading: true });
//       }
//     })
//     .catch(error => {
//       UtilityService.errorMsg(this.msg, error);
//     });
// }
// if (moduleName === "Style") {
//   this.setState({ isLoading: false });
//   StyleServices.SearchStyle("")
//     .then(response => {
//       if (response.status == 200) {
//         let jsonData = [];
//         response.data.map(info => {
//           let objData = {};
//           objData.label = info.styleNumber;
//           objData.value = info._id;
//           jsonData.push(objData);
//         });
//         this.setState({ NumberFromList: jsonData, isLoading: true });
//       }
//     })
//     .catch(error => {
//       // UtilityService.errorMsg(this.msg);
//     });
// }
this.props.getRights(moduleName);this.setState({moduleName:moduleName});}//searchBy
},{key:"render",value:function render(){var _this3=this;var _state=this.state,List=_state.List,NumberFromObj=_state.NumberFromObj,NumberToObj=_state.NumberToObj,NumberFromList=_state.NumberFromList,SearchDateFrom=_state.SearchDateFrom,SearchDateTo=_state.SearchDateTo,isLoading=_state.isLoading,selectedData=_state.selectedData,moduleName=_state.moduleName;if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_alert___default.a,Object.assign({ref:function ref(a){return _this3.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"Print "+moduleName+" Number"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"fw-600"},"Search By "+moduleName+" Number"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{name:"From",value:NumberFromObj,onInputChange:this.getNumberList,onChange:this.getNumberFrom,placeholder:moduleName+" Number Start",options:NumberFromList})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{name:"To",value:NumberToObj,onInputChange:function onInputChange(e){return _this3.getNumberList(e);},onChange:this.getNumberTo,placeholder:moduleName+" Number End",options:NumberFromList}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"d-flex align-items-center justify-content-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"fw-600"},"Search By Created Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"btn-green-icon mr-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"",className:"cursor-pointer",src:__WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png___default.a,onClick:function onClick(){return _this3.printDiv("printTable");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"btn-green-icon "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_download_png___default.a,alt:""})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"SearchDateFrom",value:SearchDateFrom,onChange:this.__handleFromDateChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":""},"To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"SearchDateTo",value:SearchDateTo,onChange:this.__handleFromDateChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary",onClick:function onClick(){return _this3.searchBy();}},"Search"))),List.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_PrintFabricNo_TableRowSelect__["a" /* default */],{rowData:List,tableHeaderData:__WEBPACK_IMPORTED_MODULE_17__services_common_options__["c" /* tableHeader */].fabricPrintTable,getRowData:this.getRowData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"printTable",className:"d-none"},this.state.moduleName==="Fabric"&&selectedData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_PrintFabricPage__["a" /* default */],{tableHeaderData:__WEBPACK_IMPORTED_MODULE_17__services_common_options__["c" /* tableHeader */].fabricPrintTable,columnAll:this.state.columnAll,column:this.state.column,selectedData:selectedData}))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__["a" /* default */],null);}}}]);return PrintFabricNumber;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// export default PrintFabricNumber;
var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights,selectedRight:state.rights.rightsInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({getRights:__WEBPACK_IMPORTED_MODULE_3__redux_action_rights__["a" /* default */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PrintFabricNumber));

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/magnum_logo.15333455.png";

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//redux
var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Profile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Profile.__proto__||Object.getPrototypeOf(Profile)).call.apply(_ref,[this].concat(args))),_this),_this.state={userData:{firstName:'',lastName:'',profilePicture:'',rememberMe:false},changePassword:false,disabled:false},_this.componentWillMount=function(){var _this$props$userDetai=_this.props.userDetails,firstName=_this$props$userDetai.firstName,lastName=_this$props$userDetai.lastName,profilePicture=_this$props$userDetai.profilePicture;var userData=Object.assign({},_this.state.userData);userData.firstName=firstName;userData.lastName=lastName;userData.profilePicture=profilePicture;_this.setState({userData:userData});},_this.updateProfile=function(){__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].updateProfile(_this.state.userData).then(function(response){if(response.status===200){var userDetails={firstName:response.text.data.firstName,lastName:response.text.data.lastName,userId:"",authToken:localStorage.getItem("authToken"),profilePicture:response.text.data.profilePicture,rememberMe:response.text.data.rememberMe,isLoggedIn:true};_this.props.actions.updateBasicDetails(userDetails);_this.props.getalertMessage("success"," Profile Updated");_this.props.history.push("/");}response.status==401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.updateInfo=function(name,value){var userData=Object.assign({},_this.state.userData);userData[name]=value;_this.setState({userData:userData});},_this.updateProfilePicture=function(files){__WEBPACK_IMPORTED_MODULE_2__services__["f" /* FileUploadService */].uploadFile(files[0],'profile').then(function(response){if(response.status===200){var userData=Object.assign({},_this.state.userData);userData.profilePicture=response.text.data.url;_this.setState({userData:userData});_this.props.getalertMessage("success"," Image Updated");}else if(response.status===401){_this.props.unauthorisedFunc();}else{_this.props.getalertMessage("error"," Something went wrong ");}}).catch(function(error){_this.props.getalertMessage("error",error);});},_this.updateChangePassword=function(name,value){_this.setState(_defineProperty({},name,value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Profile,[{key:"render",value:function render(){var _this2=this;var userData=this.state.userData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding bg-white full-width"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"Profile"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-8 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 br-col"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"firstName",value:userData.firstName,label:"First Name",onChange:this.updateInfo,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"lastName",value:userData.lastName,label:"Last Name",onChange:this.updateInfo,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"Do You Want to Change Password ?"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{inputType:"checkboxToggle",inputName:"changePassword",value:this.state.changePassword,onChange:this.updateChangePassword})))),this.state.changePassword&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"password",inputName:"password",value:userData.password,label:"New Password",onChange:this.updateInfo,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"password",inputName:"changePassword",value:userData.changePassword,label:"Confirm Password",onChange:this.updateInfo,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"Address"},"Upload Profile Photo")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"upload-photo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:userData.profilePicture!=''?__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].fileUrl()+userData.profilePicture:__WEBPACK_IMPORTED_MODULE_1__assets_images_no_product_image_png___default.a,id:"uploadCAD",name:"profilePicture",alt:this.state.userData.profilePicture}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black btn-img-upload"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons input-file-i"},"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",accept:"image/*",className:"input-file",name:"profilePicture",style:{display:"none"},onChange:function onChange(e){return _this2.updateProfilePicture(e.target.files);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Update",onClick:this.updateProfile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history}))))))));}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userDetails:state.main};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_7__redux_action_main__,dispatch)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Profile));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pageNotFound_css__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pageNotFound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pageNotFound_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageNotFound=function(_Component){_inherits(PageNotFound,_Component);function PageNotFound(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PageNotFound);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PageNotFound.__proto__||Object.getPrototypeOf(PageNotFound)).call.apply(_ref,[this].concat(args))),_this),_this.state={errorStatus:"",errorText:""},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PageNotFound,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;if(this.props.error==404){this.setState({errorStatus:"404",errorText:"Sorry! Page not found"});setTimeout(function(){_this2.props.history.push("/");},2000);}else if(this.props.error==500){this.setState({errorStatus:"500",errorText:"Something went wrong"});}}},{key:"render",value:function render(){var _state=this.state,errorStatus=_state.errorStatus,errorText=_state.errorText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"container-fluid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-xs-12 ground-color text-center height-browser"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"container-error-404"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"clip"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"digit thirdDigit"},errorStatus[0]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"clip"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"digit secondDigit"},errorStatus[1]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"clip"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"digit firstDigit"},errorStatus[2]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"msg"},"OH!",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"triangle"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{"class":"h1"},errorText)))));}}]);return PageNotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PageNotFound);

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListPage__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_Loading__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//services
//alert
//options
var List=function(_Component){_inherits(List,_Component);function List(){var _ref;var _temp,_this,_ret;_classCallCheck(this,List);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=List.__proto__||Object.getPrototypeOf(List)).call.apply(_ref,[this].concat(args))),_this),_this.state={moduleName:"",type:"",isLoading:false,history:_this.props.history,//PageHeaderForList
header:"",link:"",toggleFilter:false,//SearchFilter
byOption:[],byValue:"",inputSearch:"",//ListTable
tableHeaderData:[],tableRowData:[],viewLink:"",editLink:"",costingCompare:[],//pagination
activePage:1,totalItemsCount:0,//loading table
isLoadingTable:false},_this.initializeValues=function(moduleName){switch(moduleName){case"MEETINGROOM":_this.setState({header:"Meeting Notes",addLink:"/MeetingNote",editLink:"/MeetingNote",viewLink:"/MeetingNote",byOption:[{label:"MN id ",value:"MNId"},{label:"Customer-Department",value:"custDept"// { label: "Customer Name", value: "customerName" },
// { label: "Department name", value: "customerDepartment" }
}],byValue:"MNId"});break;case"CUSTOMER":_this.setState({header:"Customer",addLink:"/CustomerPage",editLink:"/CustomerPage",viewLink:"/CustomerPage",byOption:[{value:"customerName",label:"Customer Name"},{value:"customerCode",label:"Customer Code	"}],byValue:"customerName"});break;case"CAD":_this.setState({header:"CAD",addLink:"/developmentCad",editLink:"/developmentCad",viewLink:"/developmentCad",byOption:[{label:"3D No ",value:"cadRefNumber"},{label:"Style No.",value:"styleNumber"},{label:"Customer-Department",value:"custDept"},{label:"3D Type",value:"cadType"},{label:"3D name",value:"cadName"},{label:"Category",value:"category"},{label:"Print Type",value:"printType"},{label:"Story Name",value:"storyName"}]});break;case"FABRIC":_this.setState({header:"Fabric",addLink:"/developmentFabric",editLink:"/developmentFabric",viewLink:"/developmentFabric",byOption:[{value:"fabricNumber",label:"Fabric No"},{value:"devRefNumber",label:"Dev ref no"},{value:"countAndConstruction",label:"Count & Construction"},{value:"quality",label:"Quality"},{value:"classificationOfFabric",label:"Classification"},{value:"supplierName",label:"Supplier Name"}],byValue:"fabricNumber"});break;case"STYLE":_this.setState({header:"style",addLink:"/StylePage",editLink:"/StylePage",viewLink:"/StylePage",byOption:[{value:"styleNo",label:"Style No / Ref"},{value:"styleName",label:"Style name"},{value:"custDept",label:"Customer-Department"},// { value: "customerName", label: "Customer Name" },
// { value: "customerDepartment", label: "Department Name" },
{value:"customerRefNumber",label:"Cust ref no"},{value:"itemNumber",label:"Item no"},{value:"fabricType",label:"Fabric type"},{value:"garmentType",label:"Garment type"}],byValue:"styleNo"});break;case"TRIM":_this.setState({header:"Trim",addLink:"/Trim",editLink:"/Trim",viewLink:"/Trim",byOption:[{label:"Trim No",value:"trimNumber"},{label:"Category",value:"trimCategory"},{label:"Description",value:"description"},{label:"Supplier ref no",value:"supplierRef"},{label:"Supplier",value:"supplierName"}],byValue:"trimNumber"});break;case"SOURCING":_this.setState({header:"SOURCING",addLink:"/developmentSourcing",editLink:"/developmentSourcing",viewLink:"/developmentSourcing",byOption:[]});break;case"SAMPLEREQUEST":_this.setState({header:"SAMPLE REQUEST",addLink:"/Sample",editLink:"/Sample",viewLink:"/Sample",byOption:[{label:"Style No.",value:"magnumStyleNumber"},{label:"SampleRequest No",value:"requestNumber"},{label:"Style Name",value:"magnumStyleName"},{value:"custDept",label:"Customer-Department"},// { label: "Customer Name", value: "customerName" },
// { label: "Customer Dept", value: "customerDept" },
{label:"Cust Ref No",value:"customerId"},{label:"Source Of Request",value:"typeOfRequest"},{label:"Sample Type",value:"sampleType"}],byValue:"magnumStyleNumber"});break;case"BNUMBER":_this.setState({header:"B NO",addLink:"/BNumber",editLink:"/BNumber",viewLink:"/BNumber",byOption:[{label:"B Number",value:"bNumber"},{label:"Fabric No.",value:"fabricNo"},{label:"Count&Construction",value:"countConstruction"},{label:"Quality",value:"quality"},{label:"Classification",value:"classification"},{label:"Greige Mill",value:"greigeMill"},{label:"Process Mill",value:"processMill"}],byValue:"bNumber"});break;case"SYSTEMSUPPLIER":_this.setState({header:"System Supplier",addLink:"/system/Supplier",editLink:"/system/Supplier",viewLink:"/system/Supplier",byOption:[]});break;case"COSTING":_this.setState({header:"Costing",addLink:"/CostingPage",editLink:"/CostingPage",viewLink:"/CostingPage",byOption:[{label:"Style No / Ref",value:"styleReferenceNo"},{label:"Costing Id",value:"costingNo"},{label:"Sample Request No",value:"sampleRequestNo"},{label:"Style Name",value:"styleName"},{value:"custDept",label:"Customer-Department"},{label:"Costing Type",value:"costingType"}],byValue:"styleReferenceNo"});break;case"EMPLOYEE":_this.setState({header:"Employee",addLink:"/employee",editLink:"/employee",viewLink:"/employee",byOption:[{label:"User ID",value:"userId"},{label:"Name",value:"employeeName"},{label:"Role ",value:"roleName"}],byValue:"userId"});break;case"ROLE":_this.setState({header:"Role",addLink:"/permissionRole",editLink:"/permissionRole",viewLink:"/permissionRole",byOption:[{label:"Role name",value:"roleName"}],byValue:"roleName"});break;case"SMVTHREAD":_this.setState({header:"Smv/Ob & Thread Consumption",addLink:"/SmvThread",editLink:"/SmvThread",viewLink:"/SmvThread",byOption:[{label:"Style No/Ref.",value:"styleNo"},{label:"SMV No.",value:"smvNo"},{label:"Style Name",value:"styleName"},{label:"Customer Name",value:"customerName"},{label:"Customer Dept.Name",value:"customerDepartment"}],byValue:"styleNo"});break;case"TECHNICALISSUES":_this.setState({header:"Technical issues",addLink:"/technicalIssues",editLink:"/technicalIssues",viewLink:"/technicalIssues",byOption:[{label:"Style No/Ref.",value:"styleNo"},{label:"Issue No.",value:"issueNumber"},{label:"Style Name",value:"styleName"},{label:"Customer Name",value:"customerName"},{label:"Customer Dept.Name",value:"customerDepartment"}],byValue:"styleNo"});break;case"CREATEIB":_this.setState({header:"Create IB",addLink:"/CreateIB",editLink:"/CreateIB",viewLink:"/CreateIB",byOption:[{label:"heading 1",value:"empty"},{label:"heading 2",value:"empty"},{label:"heading 3",value:"empty"},{label:"heading 4",value:"empty"}]});break;default:}},_this._updateListData=function(moduleName){_this.setState({isLoading:true});switch(moduleName){case"MEETINGROOM":__WEBPACK_IMPORTED_MODULE_4__services__["g" /* MeetingNotesServices */].listMeetingNotes(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].meetingNoteTable,tableRowData:response.text.data.MN,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"CUSTOMER":__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].listCustomer(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].customerTable,tableRowData:response.text.data.custs,totalItemsCount:response.text.data.custumerCount,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"CAD":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listCAD(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].cadTable,tableRowData:response.text.data.cad,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("delete",JSON.stringify(error));});break;case"FABRIC":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listFabric(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].fabricTable,tableRowData:response.text.data.fabArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"STYLE":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listStyles(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].styleTable,tableRowData:response.text.data.styleArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"TRIM":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listTrim(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].trimTable,tableRowData:response.text.data.trimArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"SOURCING":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listSourcing(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].sourcingTable,tableRowData:response.text.data.sourcingArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"SAMPLEREQUEST":__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].listSamples(_this.state.activePage,_this.props.location.state.referenceId).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].samplerequestTable,tableRowData:response.text.data.SR,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"BNUMBER":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listBNumber(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].bnoTable,tableRowData:response.text.data.bNumbers,totalItemsCount:response.text.data.bNumbersCount,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"SYSTEMSUPPLIER":__WEBPACK_IMPORTED_MODULE_4__services__["l" /* SystemServices */].listSystemSuppliers(_this.state.activePage).then(function(response){if(response.status===200){var tableRowData=[].concat(_toConsumableArray(response.text.data.data));tableRowData=tableRowData.map(function(data){data.supplierStatus=data.supplierStatus?"active":"inactive";return data;});_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].systemSupplierTable,tableRowData:tableRowData,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"FABRICREPORT":__WEBPACK_IMPORTED_MODULE_4__services__["l" /* SystemServices */].listSystemSuppliers(_this.state.activePage).then(function(response){if(response.status===200){var tableRowData=[].concat(_toConsumableArray(response.text.data.data));tableRowData=tableRowData.map(function(data){data.supplierStatus=data.supplierStatus?"active":"inactive";return data;});_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].systemSupplierTable,tableRowData:tableRowData,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"COSTING":__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].listCostings(_this.state.activePage,_this.props.location.state.sampleRequestId).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].costingTable,tableRowData:response.text.data.costingList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});break;case"EMPLOYEE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].listEmploye(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].employeeTable,tableRowData:response.text.data.users,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error);});break;case"ROLE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].listRoles(_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].roleTable,tableRowData:response.text.data.roleList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error);});break;case"SMVTHREAD":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listSMV(_this.props.location.state.referenceId,_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].smvTable,tableRowData:response.text.data.smvList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error);});break;case"TECHNICALISSUES":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listTI(_this.props.location.state.referenceId,_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].tiTable,tableRowData:response.text.data.techIssues,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error);});break;case"CREATEIB":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listIB(_this.props.location.state.referenceId,_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].IBTable,tableRowData:response.text.data.ibData,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}});break;default:}},_this._selectBy=function(value){_this.setState({byValue:value});},_this._inputChangeSearchQuery=function(e){_this.setState({inputSearch:e.target.value});},_this.resetFunc=function(){_this.setState({byValue:_this.state.byOption[0].value,inputSearch:"",activePage:1},function(){return _this.props.history.push({pathname:"/list",search:"?"+new URLSearchParams({byValue:"",inputSearch:"",activePage:1}).toString(),state:{moduleName:_this.state.moduleName,type:_this.state.type}});});},_this.searchFunc=function(){if(_this.state.inputSearch===""||_this.state.byValue===""){_this.props.getalertMessage("info","Enter valid input in BY and FOR!");}else{_this.props.history.push({pathname:"/list",search:"?"+new URLSearchParams({byValue:_this.state.byValue,inputSearch:_this.state.inputSearch,activePage:_this.state.activePage}).toString(),state:{moduleName:_this.state.moduleName,type:"list"}});}},_this.searchFuncParams=function(){_this.setState({isLoadingTable:false,isLoading:true});switch(_this.state.moduleName){case"MEETINGROOM":__WEBPACK_IMPORTED_MODULE_4__services__["g" /* MeetingNotesServices */].searchMeetingNotesBy(_this.state.byValue,_this.state.inputSearch.trim()).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].meetingNoteTable,tableRowData:response.text.data&&response.text.data.MN?response.text.data.MN:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.count:0,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"FABRIC":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].searchFabricBy(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].fabricTable,tableRowData:response.text.data&&response.text.data.fabArray?response.text.data.fabArray:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.count:0,isLoadingTable:true,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"BNUMBER":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].searchBNumberDev(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].bnoTable,tableRowData:response.text.data&&response.text.data.bNumbers?response.text.data.bNumbers:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.bNumbersCount:0,isLoadingTable:true,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"TRIM":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].searchTrimBy(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].trimTable,tableRowData:response.text.data&&response.text.data.trimArray?response.text.data.trimArray:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.count:0,isLoadingTable:true,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"ROLE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].searchRoles(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].roleTable,tableRowData:response.text.data&&response.text.data.roleList?response.text.data.roleList:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.count:0,isLoadingTable:true,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});break;case"EMPLOYEE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].searchEmployeeList(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].employeeTable,tableRowData:response.text.data&&response.text.data.users?response.text.data.users:[],totalItemsCount:response.text.data&&response.text.data.count?response.text.data.count:0,isLoadingTable:true,isLoading:false});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});break;case"CUSTOMER":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].searchCustomersBy(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].customerTable,tableRowData:response.text.data.custs,totalItemsCount:response.text.data.custumerCount,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"STYLE":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].searchStylesBy(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].styleTable,tableRowData:response.text.data.styleArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"SMVTHREAD":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].searchSMVList(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].smvTable,tableRowData:response.text.data.smvList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"TECHNICALISSUES":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].searchTIlist(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].tiTable,tableRowData:response.text.data.techIssues,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}else{_this.setState({isLoading:false,isLoadingTable:true});// this.props.getalertMessage("error", response.text.message)
}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"CAD":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].searchCadList(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].cadTable,tableRowData:response.text.data.cad,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"COSTING":__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].searchCosting(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].costingTable,tableRowData:response.text.data.costingList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;case"SAMPLEREQUEST":_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].searchSamplesBy(_this.state.byValue,_this.state.inputSearch.trim(),_this.state.activePage).then(function(response){if(response.status===200){_this.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].samplerequestTable,tableRowData:response.text.data.SR,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this.props.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage("error",error.toString());});break;default:}},_this.deleteFunc=function(id){Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref2){var onClose=_ref2.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-ui"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Are you sure?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You want to delete this file?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary",onClick:function onClick(){_this.setState({isLoading:true});_this._removeRow(id);onClose();}},"Yes, Delete it!"));},closeOnClickOutside:true// onClickOutside: () => {
//   console.log("onClickOutside")
// }
});},_this._handlePageChange=function(pageNumber){// this._updateListData(this.state.moduleName)
_this.props.history.push({pathname:"/list",search:"?"+new URLSearchParams({byValue:_this.state.byValue,inputSearch:_this.state.inputSearch,activePage:pageNumber}).toString(),state:{moduleName:_this.state.moduleName,type:"list"}});},_this.toggleShowFilter=function(){_this.setState({toggleFilter:!_this.state.toggleFilter},function(){if(!_this.state.toggleFilter){_this.setState({byValue:"",inputSearch:""},function(){return _this._updateListData(_this.state.moduleName);});}});},_this.costingCompare=function(data){if(data){var costingCompare=[].concat(_toConsumableArray(_this.state.costingCompare));var number={_id:data._id,costingNumber:data.costingNumber};if(costingCompare){var findNo=costingCompare.find(function(x){return x._id===data._id;});if(!findNo){if(costingCompare.length>=5){costingCompare.splice(0,1);costingCompare=[].concat(_toConsumableArray(costingCompare),[number]);_this.setState({costingCompare:costingCompare});}else{costingCompare=[].concat(_toConsumableArray(costingCompare),[number]);_this.setState({costingCompare:costingCompare});}}}}},_this.clearCompare=function(){_this.setState({costingCompare:[]});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(List,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var _props$location$state=this.props.location.state,moduleName=_props$location$state.moduleName,type=_props$location$state.type;this.setState({moduleName:moduleName,type:type});this.setState({isLoadingTable:false});this.initializeValues(moduleName);if(this.props.location.search!==""){var urlParams=new URLSearchParams(this.props.location.search);this.setState({byValue:urlParams.get("byValue"),inputSearch:urlParams.get("inputSearch"),activePage:urlParams.get("activePage")},function(){if(_this2.state.inputSearch!==""){_this2.searchFuncParams();}else{_this2._updateListData(moduleName);}});}else{this._updateListData(moduleName);}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var _nextProps$location$s=nextProps.location.state,moduleName=_nextProps$location$s.moduleName,type=_nextProps$location$s.type;if(moduleName!==this.state.moduleName){this.setState({moduleName:moduleName,type:type,activePage:1,history:nextProps.history,toggleFilter:false,inputSearch:""},function(){_this3.initializeValues(moduleName);_this3.setState({isLoadingTable:false}),_this3._updateListData(_this3.state.moduleName);});}if(nextProps.location.search!==""){console.log(nextProps.location.search);var urlParams=new URLSearchParams(nextProps.location.search);var byValue=urlParams.get("byValue");var inputSearch=urlParams.get("inputSearch");var activePage=urlParams.get("activePage");if(inputSearch!==""){this.setState({byValue:byValue,inputSearch:inputSearch,activePage:activePage},function(){return _this3.searchFuncParams();});}else{this.setState({activePage:activePage},function(){return _this3._updateListData(_this3.state.moduleName);});}}}},{key:"_removeRow",value:function _removeRow(id){var _this4=this;switch(this.state.moduleName){case"MEETINGROOM":__WEBPACK_IMPORTED_MODULE_4__services__["g" /* MeetingNotesServices */].removeMeeting(id).then(function(response){if(response.status===200){if(response.text.message=="Meeting Note successfully deleted")_this4.props.getalertMessage("delete",response.text.message);else _this4.props.getalertMessage("info",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["g" /* MeetingNotesServices */].listMeetingNotes(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].meetingNoteTable,tableRowData:response.text.data.MN,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status==404&&_this4.props.getalertMessage("error",response.text.message);response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status==401&&_this4.props.unauthorisedFunc();response.status==404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"CAD":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].deleteCAD(id).then(function(response){if(response.status===200){if(response.text.message==="Successfully deleted"){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listCAD(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].cadTable,tableRowData:response.text.data.cad,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status==404&&_this4.props.getalertMessage("error",response.text.message);response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}}}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"STYLE":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].removeStyle(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listStyles(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].styleTable,tableRowData:response.text.data.styleArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status==404&&_this4.props.getalertMessage("error",response.text.message);response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",error.toString());});break;case"BNUMBER":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].removeBNumber(id).then(function(response){if(response.status==200){if(response.text.message==="Successfully Deleted"){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listBNumber(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].bnoTable,tableRowData:response.text.data.bNumbers,totalItemsCount:response.text.data.bNumbersCount,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}}}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"SYSTEMSUPPLIER":__WEBPACK_IMPORTED_MODULE_4__services__["l" /* SystemServices */].removeSystemSupplier(id).then(function(response){if(response.status==200){if(response.text.message==="Successfully deleted"){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["l" /* SystemServices */].listSystemSuppliers(_this4.state.activePage).then(function(response){if(response.status===200){var tableRowData=[].concat(_toConsumableArray(response.text.data.data));tableRowData=tableRowData.map(function(data){data.supplierStatus=data.supplierStatus?"active":"inactive";return data;});_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].systemSupplierTable,tableRowData:tableRowData,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status==404&&_this4.props.getalertMessage("error",response.text.message);response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}}}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"FABRIC":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].removeFabric(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.message);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listFabric(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].fabricTable,tableRowData:response.text.data.fabArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();response.status==404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"TRIM":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].removeTrim(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.message);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listTrim(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].trimTable,tableRowData:response.text.data.trimArray,totalItemsCount:response.text.data.count,isLoading:true,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"CUSTOMER":__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].removeCustomer(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.message);__WEBPACK_IMPORTED_MODULE_4__services__["d" /* CustomerServices */].listCustomer(_this4.state.activePage).then(function(response){if(response.status==200){if(response.text.message==="List successfully displayed"){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].customerTable,tableRowData:response.text.data.custs,totalItemsCount:response.text.data.custumerCount,isLoading:false,isLoadingTable:true});}}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"SOURCING":__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].removeSourcing(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.message);__WEBPACK_IMPORTED_MODULE_4__services__["e" /* DevelopmentServices */].listSourcing(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].sourcingTable,tableRowData:response.text.data.sourcingArray,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"SAMPLEREQUEST":__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].removeSample(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.message);__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].listSamples(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].samplerequestTable,tableRowData:response.text.data.SR,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"COSTING":__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].removeCosting(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["b" /* CostingServices */].listCostings(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].costingTable,tableRowData:response.text.data.costingList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"EMPLOYEE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].removeEmploye(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].listEmploye(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].employeeTable,tableRowData:response.text.data.users,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}else if(response.status===401){_this4.props.unauthorisedFunc();}else if(response.status===404){_this4.props.getalertMessage("error",response.text.message);}else{_this4.props.getalertMessage("error",response.text.message);}_this4.setState({isLoading:false});}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"ROLE":__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].removeRole(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["h" /* PermissionServices */].listRoles(_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].roleTable,tableRowData:response.text.data.roleList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});}else if(response.status===401){_this4.props.unauthorisedFunc();}else if(response.status===404){_this4.props.getalertMessage("error",response.text.message);}else{_this4.props.getalertMessage("error",response.text.message);}_this4.setState({isLoading:false});}).catch(function(error){_this4.props.getalertMessage("error",JSON.stringify(error));});break;case"SMVTHREAD":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].removeThread(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listSMV(_this4.props.location.state.referenceId,_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].smvTable,tableRowData:response.text.data.smvList,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){return _this4.props.getalertMessage("error",error);});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",error.toString());});break;case"TECHNICALISSUES":__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].removeTechIssue(id).then(function(response){if(response.status==200){_this4.props.getalertMessage("delete",response.text.message);__WEBPACK_IMPORTED_MODULE_4__services__["k" /* StyleServices */].listTI(_this4.props.location.state.referenceId,_this4.state.activePage).then(function(response){if(response.status===200){_this4.setState({tableHeaderData:__WEBPACK_IMPORTED_MODULE_6__services_common_options__["c" /* tableHeader */].tiTable,tableRowData:response.text.data.techIssues,totalItemsCount:response.text.data.count,isLoading:false,isLoadingTable:true});}response.status===401&&_this4.props.unauthorisedFunc();}).catch(function(error){return _this4.props.getalertMessage("error",error);});}response.status===401&&_this4.props.unauthorisedFunc();response.status===404&&_this4.props.getalertMessage("error",response.text.message);}).catch(function(error){_this4.props.getalertMessage("error",error.toString());});break;default:}}},{key:"render",value:function render(){var isLoadingTable=this.state.isLoadingTable;if(this.state.isLoadingTable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section bg-white remove-scroll-for-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ListPage__["a" /* ListHeader */],{costingCompare:this.state.costingCompare,clearCompare:this.clearCompare,header:this.state.header,link:this.state.addLink,type:this.state.type,toggleFilter:this.state.toggleFilter,history:this.state.history,onToggleShow:this.toggleShowFilter,getalertMessage:this.props.getalertMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ListPage__["c" /* SearchFilter */],{byOption:this.state.byOption,_selectBy:this._selectBy,filterSelect:this.state.byValue,inputSearch:this.state.inputSearch,_inputChangeSearchQuery:this._inputChangeSearchQuery,searchFunc:this.searchFunc,resetFunc:this.resetFunc}),isLoadingTable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ListPage__["b" /* ListTable */],{tableHeaderData:this.state.tableHeaderData,tableRowData:this.state.tableRowData,editLink:this.state.editLink,viewLink:this.state.viewLink,costingCompare:this.costingCompare,moduleName:this.state.moduleName,deleteFunc:this.deleteFunc,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 pull-right"},this.state.totalItemsCount>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{activePage:Number(this.state.activePage),itemsCountPerPage:100,totalItemsCount:this.state.totalItemsCount,pageRangeDisplayed:5,onChange:this._handlePageChange})))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_Loading__["a" /* default */],null);}}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (List);List.propTypes={};List.defaultProps={};

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListHeader__ = __webpack_require__(711);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchFilter__ = __webpack_require__(713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SearchFilter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListTable__ = __webpack_require__(714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ListTable__["a"]; });


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Addlink__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_action_rights__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert_src_react_confirm_alert_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListHeader=function(_Component){_inherits(ListHeader,_Component);function ListHeader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListHeader.__proto__||Object.getPrototypeOf(ListHeader)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.comparePage=function(data){var action=_this.props.rights.costing.web.edit&&"edit"||_this.props.rights.costing.web.view&&"view";var search="?"+new URLSearchParams({_id:data.map(function(x){return x._id;}).join(',')}).toString();window.open('/CostingComparison'+search,"_blank");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListHeader,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,header=_props.header,toggleFilter=_props.toggleFilter,link=_props.link,type=_props.type;var _state=this.state,action=_state.action,_id=_state._id,fabric=_state.fabric;this.setState({header:header,toggleFilter:toggleFilter,link:link,type:type});this.props.getRights(this.props.moduleName);var accessCriteria=this.props.rights!==undefined&&this.props.selectedRight!==undefined&&this.props.selectedRight.rightsName!==undefined&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.rights,this.props.selectedRight.rightsName.toString());this.setState({accessCriteria:accessCriteria});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var header=nextProps.header,toggleFilter=nextProps.toggleFilter,link=nextProps.link,type=nextProps.type;var accessCriteria=nextProps.rights!==undefined&&nextProps.selectedRight!==undefined&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(nextProps.rights,nextProps.selectedRight.rightsName.toString());this.setState({header:header,toggleFilter:toggleFilter,link:link,type:type,accessCriteria:accessCriteria});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,onToggleShow=_props2.onToggleShow,history=_props2.history,costingCompare=_props2.costingCompare,clearCompare=_props2.clearCompare;var _state2=this.state,header=_state2.header,toggleFilter=_state2.toggleFilter,link=_state2.link,type=_state2.type,accessCriteria=_state2.accessCriteria;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding mt-1 position-top-stick '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Filters')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,header)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-md-4 '},accessCriteria!==undefined&&accessCriteria.web!==undefined&&accessCriteria.web.create&&type=='list'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Addlink__["a" /* default */],{link:link,history:history}),type=='report'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'class':'primary pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'publish'),' export report'),header==="Costing"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'holderFilter'},costingCompare&&costingCompare.length>0&&costingCompare.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'px-1'},''+x.costingNumber+(costingCompare.length!==i+1&&','||''));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:;'// href={'/CostingComparison'}
,className:'primary'// target="_blank"
,style:{fontSize:"8px"},onClick:function onClick(){if(costingCompare.length>1){//    history.push('/CostingComparison', {
//         ids: costingCompare 
//     })
// console.log(history)
_this2.comparePage(costingCompare);// window.open(`/CostingComparison`, val)
}else{_this2.props.getalertMessage('error','Please select an another value to Compare');// this.props.getalertMessage('error','Please select an another value to Compare')
}}},'Compare'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:;',style:{fontSize:"8px"},className:'primary',onClick:function onClick(){return clearCompare();}},'Clear')))));}}]);return ListHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights,selectedRight:state.rights.rightsInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({"getRights":__WEBPACK_IMPORTED_MODULE_4__redux_action_rights__["a" /* default */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ListHeader));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Addlink=function(_Component){_inherits(Addlink,_Component);function Addlink(){_classCallCheck(this,Addlink);return _possibleConstructorReturn(this,(Addlink.__proto__||Object.getPrototypeOf(Addlink)).apply(this,arguments));}_createClass(Addlink,[{key:"render",value:function render(){var _props=this.props,link=_props.link,history=_props.history;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary pull-right",onClick:function onClick(){return link==="/SmvThread"?history.push(""+link,{action:"add",_id:"",styleReferenceId:"",smvId:""}):link==="/CostingPage"?history.push(""+link,{action:"add",_id:"",sampleRequestId:""}):link==="/Trim"||link==="/developmentFabric"||link==="/Sample"||link==="/BNumber"||link==="/developmentSourcing"||link==="/system/Supplier"||link=="/developmentCad"||link=="/CustomerPage"||link=="/StylePage"||link=="/MeetingNote"||link=="/employee"||link=="/permissionRole"?history.push(""+link,{action:"add",_id:""}):history.push(""+link);}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons vertical-align-middle"},"add")," new"));}}]);return Addlink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Addlink);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchFilter=function(_Component){_inherits(SearchFilter,_Component);function SearchFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchFilter.__proto__||Object.getPrototypeOf(SearchFilter)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:""},_this.onEnter=function(event){if(event.keyCode===13){event.preventDefault();_this.props.searchFunc();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchFilter,[{key:"componentWillMount",value:function componentWillMount(){var byOption=this.props.byOption;this.setState({byOption:byOption},function(){// this.props.filterSelect !== "" && this.state.byOption.length > 0 && this.props._selectBy(byOption[0].value)
});document.addEventListener("keydown",this.onEnter);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener('keydown',this.onEnter);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var byOption=nextProps.byOption;this.setState({byOption:byOption});}},{key:"render",value:function render(){var byOption=this.state.byOption;var _props=this.props,_selectBy=_props._selectBy,_inputChangeSearchQuery=_props._inputChangeSearchQuery,searchFunc=_props.searchFunc,resetFunc=_props.resetFunc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-8 product-form pr-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"phone",className:"mb-0"},"BY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"filterSelect","class":"form-control",name:"",onChange:function onChange(e){return _selectBy(e.target.value);},value:this.props.filterSelect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",selected:true,disabled:true},"--select--"),byOption.map(function(data,i){return byOption!=="_id"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:i,value:data.value},data.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"FOR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"",value:this.props.inputSearch,onChange:function onChange(e){return _inputChangeSearchQuery(e);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-4 product-form pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary pull-left margin-1",name:"button",onClick:function onClick(){return searchFunc();}},"Search"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button","class":"primary pull-left margin-1 ml-2",name:"button",onClick:function onClick(){return resetFunc();}},"reset")));}}]);return SearchFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchFilter);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_action_rights__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListTable=function(_Component){_inherits(ListTable,_Component);function ListTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListTable.__proto__||Object.getPrototypeOf(ListTable)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListTable,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,tableHeaderData=_props.tableHeaderData,tableRowData=_props.tableRowData,editLink=_props.editLink,viewLink=_props.viewLink;this.setState({tableHeaderData:tableHeaderData,tableRowData:tableRowData,editLink:editLink,viewLink:viewLink});this.props.getRights(this.props.moduleName);}// componentDidMount(nextProps){
//   let accessCriteria = this.props.rights !== undefined && this.props.selectedRight !== undefined && this.props.rights[this.props.selectedRight.rightsName];
//   this.setState({accessCriteria})
// }
},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var tableHeaderData=nextProps.tableHeaderData,tableRowData=nextProps.tableRowData,editLink=nextProps.editLink,viewLink=nextProps.viewLink;var accessCriteria=nextProps.rights!==undefined&&nextProps.selectedRight!==undefined&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(nextProps.rights,nextProps.selectedRight.rightsName.toString());this.setState({tableHeaderData:tableHeaderData,tableRowData:tableRowData,editLink:editLink,viewLink:viewLink,accessCriteria:accessCriteria});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,tableHeaderData=_state.tableHeaderData,tableRowData=_state.tableRowData,editLink=_state.editLink,viewLink=_state.viewLink,accessCriteria=_state.accessCriteria;var _props2=this.props,deleteFunc=_props2.deleteFunc,history=_props2.history,costingCompare=_props2.costingCompare;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},tableRowData&&tableRowData.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container fixed-height-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"striped list-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,tableHeaderData.length>0&&tableHeaderData.map(function(data,i){return data.tableName!=="_id"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:i,className:"position-top-stick"},data.tableName);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"position-top-stick",colSpan:"3","data-field":"price"},"Action"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,tableRowData.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:index},tableHeaderData.length>0&&tableHeaderData.map(function(keyName){var leftAlignKeys=["styleName","magnumStyleName","cust_Dept","customer","customerName","custDept"];var isLeftAlign=leftAlignKeys.includes(keyName.tableKeyName);return keyName.tableKeyName!=="_id"?data[keyName.tableKeyName]!==null?data.fabricImage&&keyName.tableKeyName=="fabricNumber"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list-inline nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,data[keyName.tableKeyName])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons fabric-image-icon"},"image"))))):keyName.tableKeyName==='RIGHTS'&&accessCriteria!==undefined&&accessCriteria.web!==undefined&&accessCriteria.web.create&&(_this2.props.moduleName=='EMPLOYEE'||_this2.props.moduleName=='ROLE')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"linker cursor-hover",onClick:function onClick(){return _this2.props.history.push("/employeRights",{_id:data._id,moduleName:_this2.props.moduleName});}},"RIGHTS")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:(typeof data[keyName.tableKeyName]=="boolean"?"font-weight-bold":"")+" "+(isLeftAlign?"text-left":"")},typeof data[keyName.tableKeyName]=="boolean"?data[keyName.tableKeyName]===true?"active":"inactive":data[keyName.tableKeyName]):"":"";}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2.props.moduleName==="COSTING"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"compare mr-1",onClick:function onClick(){return costingCompare(data);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"view_list")),accessCriteria!==undefined&&accessCriteria.web!==undefined&&accessCriteria.web.view&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"view",style:{cursor:"pointer"},title:"View cursor-hover",onClick:function onClick(){return _this2.props.moduleName=="SMVTHREAD"?history.push(viewLink,{action:"view",_id:data._id,styleReferenceId:"",smvId:data.smvId}):viewLink==="/Sample"||viewLink==="/CostingPage"||viewLink==="/StylePage"||viewLink==="/employee"||viewLink==="/Trim"||viewLink==="/developmentFabric"||viewLink==="/developmentSourcing"||viewLink==="/system/Supplier"||viewLink==="/BNumber"||viewLink==="/developmentCad"||viewLink==="/CustomerPage"||viewLink==="/MeetingNote"||viewLink==="/permissionRole"||viewLink==="/technicalIssues"?history.push(viewLink,{hash:viewLink==="/StylePage"&&"seleted"+data.styleNo.split('-').join(''),action:"view",_id:data._id})//  history.push(`${viewLink === "/StylePage" ? `${data && data.styleNo ? `${viewLink}#seleted${data.styleNo.split('-').join('')}` : viewLink}` : viewLink}`, {
//   action: "view",
//   _id: data._id
// })
:history.push(viewLink+"?"+data._id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"visibility"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,accessCriteria!==undefined&&accessCriteria.web!==undefined&&accessCriteria.web.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:function onClick(){return _this2.props.moduleName=="SMVTHREAD"||_this2.props.moduleName=="TECHNICALISSUES"?history.push(editLink,{action:"edit",_id:data._id,styleReferenceId:"",smvId:data.smvId}):editLink==="/Sample"||editLink==="/CostingPage"||editLink==="/StylePage"||editLink==="/employee"||editLink==="/Trim"||editLink==="/developmentCad"||editLink==="/developmentFabric"||editLink==="/developmentSourcing"||editLink==="/system/Supplier"||editLink==="/BNumber"||editLink==="/CustomerPage"||editLink==="/MeetingNote"||editLink==="/permissionRole"?history.push(editLink,{action:"edit",hash:editLink==="/StylePage"&&"seleted"+data.styleNo.split('-').join(''),_id:data._id}):history.push(editLink+"?"+data._id);},"class":"edit cursor-hover",style:{cursor:"pointer"},title:"Edit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"create"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,accessCriteria!==undefined&&accessCriteria.web!==undefined&&accessCriteria.web.delete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:function onClick(){return deleteFunc(data._id);},className:"delete cursor-hover",title:"delete"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"delete"))));})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center p-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null," No Data Found "))));}}]);return ListTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights,selectedRight:state.rights.rightsInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({"getRights":__WEBPACK_IMPORTED_MODULE_3__redux_action_rights__["a" /* default */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ListTable));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TrimSidebar__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SupplierSection_SupplierMain_SupplierSection__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TrimMainSection_TrimMainSection__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__print__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_util__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectDestructuringEmpty(obj){if(obj==null)throw new TypeError("Cannot destructure undefined");}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AlertContainer from 'react-alert';
//loading
var Trim=function(_Component){_inherits(Trim,_Component);function Trim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Trim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Trim.__proto__||Object.getPrototypeOf(Trim)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",trim:{trimNumber:null,trimImage:null,HSN:null,qr:"",trimCategory:null,description:null,color:null,quality:null,trimRefNumber:null,supplierRef:"",sizeNumber:null,size:null,unit:null,comments:null,refImages:[],supplierSection:{fullPackageData:[],jobWorkData:[]}},disabled:false,hsnOptions:[],//HSN OPTIONS
hsnValue:{label:"",//HSN LABEL
value:""//HSN VALUE
},//OPTIONS
trimOptions:{},//TRIM SIDEBAR
trimNumber:"",qr:"",//TRIM MAIN SECTION
trimMainValues:{},//images
refImages:[],trimPrint:{},//loading
isLoading:false,printLoading:false,scroll:true},_this.handleCustomerInfo=function(value){__WEBPACK_IMPORTED_MODULE_5__services__["d" /* CustomerServices */].searchCustomersBy("customerId",value).then(function(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref2$data=_ref2.data,data=_ref2$data===undefined?[]:_ref2$data;var customerInfo=data.map(function(info,index){return{label:info.customerName,value:info._id};});_this.setState({customerInfo:customerInfo});}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.handleSelect=function(data,name){if(data){_this.setState(_defineProperty({},name,data.value),function(){});}else{_this.setState(_defineProperty({},name,""));}},_this.handleInput=function(_ref3){var _ref3$target=_ref3.target,value=_ref3$target.value,name=_ref3$target.name;_this.setState(_defineProperty({},name,value));},_this.getRefImages=function(refImages){var trim=Object.assign({},_this.state.trim);trim.refImages=refImages;_this.setState({trim:trim});},_this.changeImg=function(e){__WEBPACK_IMPORTED_MODULE_5__services__["f" /* FileUploadService */].uploadFile(e.target.files[0],"trim").then(function(response){if(response.status===200){var trim=Object.assign({},_this.state.trim);trim.trimImage=response.text.data.url;_this.setState({trim:trim});}else if(response.status===401){_this.props.unauthorisedFunc();}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.onChange=function(name,value){var trim=Object.assign({},_this.state.trim);trim.HSN=value;_this.setState({trim:trim});},_this.getHsnOptions=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var options;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://GET HSN OPTIONS ONCHANGE
options=[];_context2.next=3;return __WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getTrimDevelopmentHSN(e).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Promise.all(data.data.map(function(res){return options.push({label:res.name,value:res._id});}));case 2:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}());case 3:_this.setState({hsnOptions:options});case 4:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.onSelect=function(name,value){var trim=Object.assign({},_this.state.trim);trim[name]=value;if(name=="trimCategory"){_this.state.trimOptions.trimCatOptions.map(function(data){if(value===data.value){trim.trimRefNumber=data.trimRef;trim.unit=data.unit;}});__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getTrimDevelopmentQR(trim.trimRefNumber).then(function(response){if(response.status===200){var _trim=Object.assign({},_this.state.trim);_trim.trimNumber=response.text.data.trimNumber,_trim.qr=response.text.data.qr,_this.setState({trim:_trim});}if(response.status===401){_this.props.unauthorisedFunc();}}).catch(function(error){_this.props.getalertMessage("error",error.toString());});}_this.setState({trim:trim});},_this.getSupplier=function(data,name){var trim=Object.assign({},_this.state.trim);trim.supplierSection.supplierData=name==="fullPackageData"?"fullPackage":"jobWork";trim.supplierSection[name]=data;_this.setState({trim:trim});},_this.onSubmit=function(e){e.preventDefault();var trim=Object.assign({},_this.state.trim);if(_this.state.action==="edit"){trim._id=_this.state._id;}var dltEmtF=['trimCategory','description','color','quality','sizeNumber','size','unit'];dltEmtF.forEach(function(x,i){if(trim[x]===""){trim[x]=null;}});__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].createTrimForMarket(trim).then(function(response){if(response.status===200){_this.setState({_id:response.text.data._id});_this.props.getalertMessage("success"," Trim Created ");}if(response.status===401){_this.props.unauthorisedFunc();}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.removeFabricImage=function(){var trim=Object.assign({},_this.state.trim);trim.trimImage="";_this.setState({trim:trim});},_this.getFullPackage=function(fullPackageData){var trim=Object.assign({},_this.state.trim);fullPackageData.map(function(data,index){data.purposeLabel=data.purpose!==null&&_this.state.trimOptions&&_this.state.trimOptions.PURPOSE&&_this.state.trimOptions.PURPOSE.map(function(purpose,i){if(purpose.value===data.purpose){return purpose.label;}}).filter(Boolean)[0];data.SupplierNameLabel=data.supplierName!==null&&_this.state.trimOptions&&_this.state.trimOptions.SUPPLIERNAME&&_this.state.trimOptions.SUPPLIERNAME.map(function(SUPPLIERNAME,i){if(SUPPLIERNAME.value===data.supplierName){return SUPPLIERNAME.label;}}).filter(Boolean)[0];});if(trim){trim.supplierSection.fullPackageData=fullPackageData;_this.setState({trim:trim});}else{var fabric=Object.assign({},_this.state.fabric);fabric.supplierSection.fullPackageData=fullPackageData;_this.setState({fabric:fabric});}},_this.getJobwork=function(jobWorkData){var trim=Object.assign({},_this.state.trim);jobWorkData.map(function(data,index){data.purposeLabel=data.purpose!==null&&_this.state.trimOptions.PURPOSE&&_this.state.trimOptions.PURPOSE.map(function(purpose,i){if(purpose.value===data.purpose){return purpose.label;}}).filter(Boolean)[0];data.rowData.map(function(dat,i){dat.SupplierNameLabel=dat.supplierName!==null&&_this.state.trimOptions.SUPPLIERNAME&&_this.state.trimOptions.SUPPLIERNAME.map(function(SUPPLIERNAME,i){if(SUPPLIERNAME.value===dat.supplierName){return SUPPLIERNAME.label;}}).filter(Boolean)[0];});});trim.supplierSection.jobWorkData=jobWorkData;_this.setState({trim:trim});},_this.printTrim=function(){var _this$state=Object.assign({},_this.state),trim=_this$state.trim;var trimPrint={};trimPrint.trimNumber=trim.trimNumber;trimPrint.trimImage=trim.trimImage;trimPrint.comments=_this.state.trim.comments;var arr=['trimCategory','color','description','quality','unit','sizeNumber','size'];arr.forEach(function(x){var res=document.getElementById("fabricCreation").elements.namedItem(x).selectedOptions[0].innerHTML;trimPrint[x]=res!=='select'&&res||"";});trimPrint.trimRef=trim.trimRefNumber||"";trimPrint.supplierRef=trim.supplierRef||"";trimPrint.comments=trim.comments;trimPrint.refImages=trim.refImages;var supplierSection=_this.state.trim.supplierSection;trimPrint.fullPackageData=supplierSection&&supplierSection.fullPackageData&&[supplierSection.fullPackageData.find(function(x){return x.default;})];trimPrint.jobWorkData=supplierSection&&supplierSection.jobWorkData&&[supplierSection.jobWorkData.find(function(x){return x.default;})];// let { supplierSection } = { ...trim }
// supplierSection.fullPackageData && supplierSection.fullPackageData.find((x, i) => {
//     if (x.default) {
//         fullPackage = `fullPack${i}`
//         trimPrint.supplier = true
//         // trimPrint.fullPackage = true
//         // trimPrint.fullPackageData = x
//         // let res = document.querySelectorAll(`#fullPack${i} .select-currency`)[0].selectedOptions[0].innerHTML
//         // x.purpose = res !== 'select' && res || ""
//         // res = document.querySelectorAll(`#fullPack${i} .select-currency`)[1].selectedOptions[0].innerHTML
//         // x.supplierName = res !== 'select' && res || ""
//     }
// })
// supplierSection.jobWorkData && supplierSection.jobWorkData.find((x, i) => {
//     if (x.default) {
//         jobWork = `jobWrk${i}`
//         trimPrint.supplier = true
//         // trimPrint.jobWork = true
//         // trimPrint.jobWorkData = x
//     }
// })
// if (fullPackage || jobWork) {
//     this.setState({ trimPrint }, () => {
//         document.querySelector(`#${fullPackage || jobWork} .card`).style['box-shadow'] = 'none';
//         var divToPrint = document.querySelector(`#${fullPackage || jobWork} .card`)
//         var divToPrint1 = document.getElementById('printDevelopmentTrim')
//         html2canvas(divToPrint).then(canvas => {
//             const imgData = canvas.toDataURL("image/png")
//             var img = document.createElement("img")
//             img.style = {
//                 width: "98%",
//                 height: 'auto',
//                 margin: "0 auto"
//             }
//             img.src = imgData
//             document.getElementById('imgsupplier').innerHTML = img.outerHTML;
//             setTimeout(() => {
//                 var newWin = window.open("", "mywindow")
//                 newWin.document.write(divToPrint1.outerHTML)
//                 newWin.focus()
//                 newWin.print()
//                 // this.onPrintFinished(newWin.print())
//                 newWin.close()
//             }, 100);
//             document.querySelector(`#${fullPackage || jobWork} .card`).style['box-shadow'] = '0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12)';
//         })
//     })
// } else {
_this.setState({trimPrint:trimPrint},function(){var divToPrint=document.getElementById('printDevelopmentTrim');var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.focus();newWin.print();// this.onPrintFinished(newWin.print())
newWin.close();});// }
// var divToPrint = document.getElementById("trimPrint")
// // divToPrint.getElementsByClassName('profile-btn')[0].style.display = 'none'
// html2canvas(divToPrint, {
//     useCORS: true
// }).then(canvas => {
//     console.log(canvas);
//     const imgData = canvas.toDataURL("image/png")
//     console.log(imgData);
//     setTimeout(() => {
//         var newWin = window.open("", "mywindow")
//         var img = newWin.document.createElement("img")
//         img.src = imgData
//         newWin.document.body.appendChild(img)
//         newWin.focus()
//         newWin.print()
//         newWin.close()
//         // divToPrint.getElementsByClassName('profile-btn')[0].style.display = 'block'
//     }, 100);
// })      
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Trim,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;// capturing action
var action=void 0,_id=void 0;if(this.props.location.state){action=this.props.location.state.action;_id=this.props.location.state._id;}if(!action&&!_id){var urlParams=new URLSearchParams(this.props.location.search);action=urlParams.get("action");_id=urlParams.get("_id");this.props.history.replace('/Trim',{action:action,_id:_id});}this.setState({action:action,_id:_id});//For view purpose
if(action==="view"){this.setState({disabled:!this.state.disabled});}if(action!="add"){this.setState({scroll:false});}if(action==="view"||action==="edit"){__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getSpecificTrim(_id).then(function(response){if(response.status===200){var trimData=response.text.data;var trim=Object.assign({},_this3.state.trim);Object.keys(trimData).forEach(function(key){if(key in trim){// or obj1.hasOwnProperty(key)
trim[key]=trimData[key];}});_this3.setState({trim:trim});}if(response.status===401){_this3.props.unauthorisedFunc();}}).catch(function(error){_this3.props.getalertMessage("error",error.toString());});}var trimOptions={};__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getTrimDevelopmentOptions().then(function(res){if(res.status===200){// TRIM OPTIONS
//TRIM CATEGORY
trimOptions.trimCatOptions=res.text.data.trim.TRIMCATEGORY;//TRIM STATUS
trimOptions.trimStatusOptions=res.text.data.trim.TRIMSTATUS;//TRIM TYPES
trimOptions.trimTypesOptions=res.text.data.trim.TRIMTYPE;//TRIM SIZES
trimOptions.trimSizeOptions1=res.text.data.trim.TRIMSIZE1;trimOptions.trimSizeOptions2=res.text.data.trim.TRIMSIZE2;//trim quality
trimOptions.trimQualityOptions=res.text.data.trim.TRIMQUALITY;//TRIM DESC
trimOptions.trimDescOptions=res.text.data.trim.TRIMDESCRIPTION;//TRIM COLOR
trimOptions.trimColorOptions=res.text.data.trim.TRIMCOLOR;//supplier section
trimOptions.SUPPLIERNAME=res.text.data.trim.SUPPLIERNAME;trimOptions.SHIPMENTTERM=res.text.data.trim.SHIPMENTTERM;trimOptions.SHIPMENTMODE=res.text.data.trim.SHIPMENTMODE;trimOptions.PORTOFPICKUP=res.text.data.trim.PORTOFPICKUP;trimOptions.PURPOSE=res.text.data.trim.PURPOSE;trimOptions.PROCESS=res.text.data.trim.PROCESS;trimOptions.TRIMUNITS=res.text.data.trim.TRIMUNITS;trimOptions.IMAGETYPE=res.text.data.trim.IMAGETYPE;trimOptions.GST=res.text.data.trim.GST;trimOptions.TRANSPORT=res.text.data.trim.TRANSPORT;_this3.setState({trimOptions:trimOptions});}res.status===401&&_this3.props.unauthorisedFunc();}).catch(function(error){return _this3.props.getalertMessage("error",error.toString());});//hsn
var options=[];__WEBPACK_IMPORTED_MODULE_5__services__["e" /* DevelopmentServices */].getTrimDevelopmentHSN("").then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:data.data.map(function(res){return options.push({label:res.name,value:res._id});});case 1:case"end":return _context3.stop();}}},_callee3,_this3);}));return function(_x4){return _ref6.apply(this,arguments);};}());this.setState({hsnOptions:options});//supplierName
__WEBPACK_IMPORTED_MODULE_5__services__["l" /* SystemServices */].listSystemSuppliers().then(function(response){if(response.status===200){var suppliersOption=[];response.text.data.data.map(function(data){suppliersOption.push({label:data.supplierName,value:data._id});});_this3.setState({suppliersOption:suppliersOption,isLoading:true});}if(response.status===401){_this3.props.unauthorisedFunc();}}).catch(function(error){return _this3.props.getalertMessage("error",error.toString());});if(this.state.action==='add'){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==='add'){window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}}// handle Customer Search
// getting customer ID from drop down
//getRefImages
/*************** *///ONCHANGE
//ON SELECT
//Get supplier
//saving Trim
//fullpackage
},{key:"render",value:function render(){var _this4=this;if(this.state.isLoading&&Object.keys(this.state.trimOptions).length>0){var _React$createElement,_React$createElement2,_React$createElement3;_objectDestructuringEmpty(this.state);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section remove-scroll-for-right "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row nopadding bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{id:"fabricCreation",className:"w-100"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 product-form nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_TrimSidebar__["a" /* default */],{moduleName:"trim",number:this.state.trim.trimNumber!==null?""+this.state.trim.trimNumber:"",qr:this.state.trim.qr,image:this.state.trim.trimImage,HSN:this.state.trim.HSN,handleImageUpload:this.changeImg,onInputChange:this.getHsnOptions,getFabricData:this.onChange,hsnOptions:this.state.hsnOptions,disabled:this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled,removeFabricImage:this.removeFabricImage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-content-section product-form overflow-scroll",id:"trimPrint"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Page_PageHeader_PageHeader__["a" /* default */],{header:"TRIM DEVELOPMENT",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon mr-3 pull-right",style:{cursor:"pointer"},onClick:function onClick(e){return _this4.printTrim();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_printer_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,Object.keys(this.state.trimOptions).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_TrimMainSection_TrimMainSection__["a" /* default */],{trim:this.state.trim,trimOptions:this.state.trimOptions,onSelect:this.onSelect,disabled:this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled,suppliersOption:this.state.suppliersOption}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding mt-3 px-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"trim",getRefImages:this.getRefImages,disabled:this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled,uploadedDocs:this.state.trim.refImages.length>0?this.state.trim.refImages:null,imageTypeOption:this.state.trimOptions?this.state.trimOptions.IMAGETYPE:[]})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},this.state.action==='add'&&!this.state.disabled&&this.props.rights.trim.trim.web.create?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary mr-2",name:"button",onClick:function onClick(e){return _this4.onSubmit(e);}},"Save"):this.state.action==='edit'&&!this.state.disabled&&this.props.rights.trim.trim.web.edit?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary mr-2",name:"button",onClick:function onClick(e){return _this4.onSubmit(e);}},"Save"):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"cancel",history:this.props.history})),this.state.action==='add'&&!this.state.disabled&&this.props.rights.trim.supplier.web.create?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SupplierSection_SupplierMain_SupplierSection__["a" /* default */],(_React$createElement={action:this.state.action,moduleName:"trims",scrollSupplier:false,getFullPackage:this.getFullPackage,getJobWork:this.getJobwork,suppliersOption:this.state.supplierInfo,fullPackageData:this.state.trim.supplierSection.fullPackageData,jobWorkData:this.state.trim.supplierSection.jobWorkData,getSupplierForDefault:this.getSupplierForDefault,supplierSection:this.state.trim.supplierSection,getSupplier:this.getSupplier},_defineProperty(_React$createElement,"suppliersOption",this.state.suppliersOption),_defineProperty(_React$createElement,"toggle",this.state.toggle),_defineProperty(_React$createElement,"fabricInfo",this.state.trimOptions),_defineProperty(_React$createElement,"_id",this.state._id),_defineProperty(_React$createElement,"disabled",this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled),_defineProperty(_React$createElement,"history",this.props.history),_defineProperty(_React$createElement,"unauthorisedFunc",this.props.unauthorisedFunc),_defineProperty(_React$createElement,"getalertMessage",this.props.getalertMessage),_React$createElement)):this.state.action==='edit'&&!this.state.disabled&&this.props.rights.trim.supplier.web.edit?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SupplierSection_SupplierMain_SupplierSection__["a" /* default */],(_React$createElement2={action:this.state.action,moduleName:"trims",scrollSupplier:false,getFullPackage:this.getFullPackage,getJobWork:this.getJobwork,suppliersOption:this.state.supplierInfo,fullPackageData:this.state.trim.supplierSection.fullPackageData,jobWorkData:this.state.trim.supplierSection.jobWorkData,getSupplierForDefault:this.getSupplierForDefault,supplierSection:this.state.trim.supplierSection,getSupplier:this.getSupplier},_defineProperty(_React$createElement2,"suppliersOption",this.state.suppliersOption),_defineProperty(_React$createElement2,"toggle",this.state.toggle),_defineProperty(_React$createElement2,"fabricInfo",this.state.trimOptions),_defineProperty(_React$createElement2,"_id",this.state._id),_defineProperty(_React$createElement2,"disabled",this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled),_defineProperty(_React$createElement2,"history",this.props.history),_defineProperty(_React$createElement2,"unauthorisedFunc",this.props.unauthorisedFunc),_defineProperty(_React$createElement2,"getalertMessage",this.props.getalertMessage),_React$createElement2)):this.props.location.state.action==="view"&&this.props.rights.trim.supplier.web.view?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SupplierSection_SupplierMain_SupplierSection__["a" /* default */],(_React$createElement3={action:this.state.action,moduleName:"trims",scrollSupplier:false,getFullPackage:this.getFullPackage,getJobWork:this.getJobwork,suppliersOption:this.state.supplierInfo,fullPackageData:this.state.trim.supplierSection.fullPackageData,jobWorkData:this.state.trim.supplierSection.jobWorkData,getSupplierForDefault:this.getSupplierForDefault,supplierSection:this.state.trim.supplierSection,getSupplier:this.getSupplier},_defineProperty(_React$createElement3,"suppliersOption",this.state.suppliersOption),_defineProperty(_React$createElement3,"toggle",this.state.toggle),_defineProperty(_React$createElement3,"fabricInfo",this.state.trimOptions),_defineProperty(_React$createElement3,"_id",this.state._id),_defineProperty(_React$createElement3,"disabled",this.props.rights.view?this.props.rights.create||this.props.rights.edit?false:true:this.state.disabled),_defineProperty(_React$createElement3,"history",this.props.history),_defineProperty(_React$createElement3,"unauthorisedFunc",this.props.unauthorisedFunc),_defineProperty(_React$createElement3,"getalertMessage",this.props.getalertMessage),_React$createElement3)):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"printDevelopmentTrim",className:"d-none"},Object.keys(this.state.trimPrint).length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__print__["a" /* default */],{trim:this.state.trimPrint}))))))))));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Common_Loading__["a" /* default */],null);}}}]);return Trim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,null)(Trim));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select_Select__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TrimMainSection=function(_Component){_inherits(TrimMainSection,_Component);function TrimMainSection(){_classCallCheck(this,TrimMainSection);return _possibleConstructorReturn(this,(TrimMainSection.__proto__||Object.getPrototypeOf(TrimMainSection)).apply(this,arguments));}_createClass(TrimMainSection,[{key:"render",value:function render(){var _props=this.props,trimOptions=_props.trimOptions,trim=_props.trim,onSelect=_props.onSelect,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-5 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"ib-list-view  mb-0 p-0 listFieldWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimCatOptions,name:"trimCategory",onSelect:onSelect,disabled:disabled,value:trim.trimCategory})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimDescOptions,name:"description",onSelect:onSelect,disabled:disabled,value:trim.description})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Color"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimColorOptions,name:"color",onSelect:onSelect,disabled:disabled,value:trim.color})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimQualityOptions,name:"quality",onSelect:onSelect,disabled:disabled,value:trim.quality}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-5 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"ib-list-view  mb-0 p-0 listFieldWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"main-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Trim Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",disabled:true,value:trim.trimRefNumber})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Supplier Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-control",name:"supplierRef",onChange:function onChange(e){return onSelect(e.target.name,e.target.value);},disabled:disabled,value:trim.supplierRef})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimSizeOptions1,name:"sizeNumber",onSelect:onSelect,disabled:disabled,value:trim.sizeNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.trimSizeOptions2,name:"size",onSelect:onSelect,disabled:disabled,value:trim.size})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{"class":"text-right"},"Units"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_Select__["a" /* default */],{options:trimOptions.TRIMUNITS,name:"unit",onSelect:onSelect,disabled:disabled,value:trim.unit}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding px-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Common_Field_Field__["a" /* default */],{inputType:"textarea",inputName:"comments",label:"comments",onChange:onSelect,disabled:disabled,value:trim.comments})));}}]);return TrimMainSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TrimMainSection.defaultProps={trimOptions:{},trim:{},disabled:false};/* harmony default export */ __webpack_exports__["a"] = (TrimMainSection);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
var PrintDevelopmentTrim=function(_Component){_inherits(PrintDevelopmentTrim,_Component);function PrintDevelopmentTrim(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintDevelopmentTrim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintDevelopmentTrim.__proto__||Object.getPrototypeOf(PrintDevelopmentTrim)).call.apply(_ref,[this].concat(args))),_this),_this.state={trim:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintDevelopmentTrim,[{key:"componentWillMount",value:function componentWillMount(){this.setState({trim:this.props.trim});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.trim!=this.props.trim){this.setState({trim:nextProps.trim});}}},{key:"render",value:function render(){var trim=this.state.trim;var fullPackageData=trim.fullPackageData,jobWorkData=trim.jobWorkData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n              body{\n                  font-family: 'Montserrat', sans-serif;\n                  font-size:12px;\n              }\n              .fontSize12{\n                  font-size:12px;\n              }\n              .fabricPrintDiv{\n                border : 2px solid black;\n                top : 0;\n                bottom : 0;\n              }\n\n              .printrow {\n                display: flex;\n                flex-direction: row;\n                flex-wrap: wrap;\n                width: 100%;\n              }\n\n              .printcolumn {\n                display: flex;\n                flex-direction: column;\n                flex-basis: 100%;\n                flex: 1;\n              }\n              table>tbody>tr td{\n                  font-size:12px;\n              }\n              .label-text{\n                  color:#279588;\n                  font-size : 12px;\n                  font-weight:bold;\n              }\n              .blue{\n                  color : #146FF9;\n              }\n              .padding-for-heading{\n                padding: 5px;\n              }\n\n\n               .specialComments{\n                  width: 100%;\n                  border : 1px solid black;\n                  min-height : 60px;\n                  margin: 10px;\n                  padding: 10px!important;\n              }\n\n              .b{\n                  border: 1px solid black;\n                  margin: 10px;\n                  padding: 5px;\n              }\n              .fabric-text{\n                font-size:16px;\n                color: #279588;\n                font-weight: 1000;\n              }\n\n              .bold{\n                  font-weight:bold;\n              }\n              .bb-p{\n                border-bottom: 1px solid black;\n                margin-bottom: 10px ;\n              }\n              .w-50 {\n                  width: 50%;\n              }\n              table.grid{\n                border-collapse: collapse;\n                margin-right: 5px;\n                margin-left: 5px;\n              }\n              table.grid>tbody>tr td {\n                border: 0.5px solid black;\n                text-align: center;\n                padding: 2px;\n              }\n              .width-for-table{\n                  width: 50%;\n              }\n              .text-center{\n                text-align: center;\n              }\n              .p-1{\n                padding : 5px;\n              }\n              .pl-1{\n                padding-left: 23px;\n              }\n              .border-bot{\n                border-bottom : 1px solid black;\n              }\n              .mt{\n                margin-top:10px;\n              }\n              .mtl{\n                margin-top:30px;\n              }\n              .margin{\n                margin : 5px;\n              }\n              .pl-2{\n                padding: 5px;\n              }\n            }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 "},"MAGNUM CLOTHING PVT LTD - TRIM DEVELOPMENT SHEET - FDS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow mtl pl-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabric-text pl-1 "},trim&&trim.trimNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"100px",height:"100px",src:__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].fileUrl()+trim.trimImage,alt:trim.trimImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimCategory)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Trim Descrption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Color"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.color)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.quality))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Trim Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimRef)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Supplier Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.supplierRef)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.sizeNumber+" - "+trim.size)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Units"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.unit))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"})),(trim.fullPackageData||trim.jobWorkData)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"SUPPLIER PART"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"imgsupplier",className:"printrow"}),trim.fullPackageData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,console.log(trim.fullPackageData,"trim.fullPackageData"),trim.fullPackageData&&trim.fullPackageData.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,data&&data.default&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"FULL PACKAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PURPOSE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPP NAME"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPP REF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"LT (DAYS)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRICE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"UNITS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TRANS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"TOTAL COST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DEFAULT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.purposeLabel!==null?data.purposeLabel:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.date!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.date).format("MMM Do YYYY"):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.SupplierNameLabel!==null?data.SupplierNameLabel:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.supplierRef!==null?data.supplierRef:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.leadTime!==null?data.leadTime:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.width!==null?data.width:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currency!==null?data.currency==="rupee"?"$":"₹":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.price!==null?data.currency==="rupee"?"\u20B9"+data.price:"$"+data.price:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.MY!==null?data.MY:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.GST!==null&&data.currency==="rupee"?data.GST:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.transport!==null&&data.currency==="rupee"?data.transport:"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.totalCost!==null?data.totalCost:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.default!==null?data.default?"YES":"NO":"")),data.MY==="gross"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"1 Gross")," ","= 42 Pcs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"Price/Pc")," ","-",data.currencyData&&data.currencyData.priceMTS)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),data.currency==="dollar"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CONV. TO INR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SHIPMENT TERM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SHIPMENT MODE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PORT OF PICKUP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"FREIGHT COSTS \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CLEARANCE \u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DUTY %")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.conversionToINR!==null&&data.currencyData.conversionToINR!==undefined?data.currencyData.conversionToINR:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.shipmentTerm!==null&&data.currencyData.shipmentTerm!==undefined?data.currencyData.shipmentTerm:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.shipmentMode!==null&&data.currencyData.shipmentMode!==undefined?data.currencyData.shipmentMode:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.portOfPickup!==null&&data.currencyData.portOfPickup!==undefined?data.currencyData.portOfPickup:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.freightCosts!==null&&data.currencyData.freightCosts!==undefined?data.currencyData.freightCosts:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.clearance!==null&&data.currencyData.clearance!==undefined?data.currencyData.clearance:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.duty!==null&&data.currencyData.duty!==undefined?data.currencyData.duty:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.totalOrderQuantity!==null&&data.currencyData.totalOrderQuantity!==undefined?data.currencyData.totalOrderQuantity:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.width!==null&&data.currencyData.width!==undefined?data.currencyData.width:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.gsm!==null&&data.currencyData.gsm!==undefined?data.currencyData.gsm:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.weightOfFabricPerMtr!==null&&data.currencyData.weightOfFabricPerMtr!==undefined?data.currencyData.weightOfFabricPerMtr:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.weightForFullOrder!==null&&data.currencyData.weightForFullOrder!==undefined?data.currencyData.weightForFullOrder:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.currencyData&&data.currencyData.freightRatePerKg!==null&&data.currencyData.freightRatePerKg!==undefined?data.currencyData.freightRatePerKg:""))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"FULL PACKAGE - SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},data.specialComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);})))))));})),trim.jobWorkData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,trim&&trim.jobWorkData&&trim.jobWorkData.length>0&&trim.jobWorkData.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,data&&data.default&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"JOB WORK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"OPTION - ",data.purposeLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PROCESS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SUPPLIER NAME"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"LT (DAYS)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"$/\u20B9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PRICE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"VL%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"COST")),data.rowData.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,row.process.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.process),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.date!==null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(row.date).format("MMM Do YYYY"):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.SupplierNameLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.leadTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.width),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.currency==="dollar"?"$":"₹"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.vl),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},row.cost)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.GST,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.totalCost-data.transport)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Transport"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.transport),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.totalCost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"MOQ")," -"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},data.moq)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"}," ","Total Lead Time")," ","-"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},data.totalLeadTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"Finished Width")," ","-"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"},data.finishedWidth)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"Cuttable Width")," ","-",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold"}," ",data.cuttableWidth)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Total Cost"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},data.totalCost)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"JOB WORK - SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},data.specialComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);})))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"GENERAL SPECIAL COMMENTS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},trim.comments&&trim.comments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow padding-for-heading blue"},"IMAGES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},trim.refImages&&trim.refImages.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{width:"50px",height:"50px",src:__WEBPACK_IMPORTED_MODULE_2__services__["m" /* UtilityService */].fileUrl()+data.path}));}))));}}]);return PrintDevelopmentTrim;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintDevelopmentTrim);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_printSample__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_audit__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SampleRequest_GarmentTechModule_PrintGarmentTech__ = __webpack_require__(845);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { convertFromHTML } from 'draft-js';
//services
//components
//redux
var allProceses=["sample","cad","fabric","trim","pattern","cutting","sewing","embellishment","embroidery","marker","costing","signOff","dispatch","garmentTechnologist","qc","wash"];var Sample=function(_Component){_inherits(Sample,_Component);function Sample(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sample);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sample.__proto__||Object.getPrototypeOf(Sample)).call.apply(_ref,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sample,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.action==="add")window.removeEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}},{key:"componentWillMount",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this2=this;var action,_id,referenceId,styleId,setStyleId,urlParams,hash,sampleRequest,sampleRequestType,objData,styleData,copyOfSamplerequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.setState({isLoading:true});case 2:action=void 0,_id=void 0,referenceId=void 0,styleId=void 0,setStyleId=void 0;if(this.props.location.state){action=this.props.location.state.action;_id=this.props.location.state._id;referenceId=this.props.location.state.referenceId;styleId=this.props.location.state.styleId;setStyleId=this.props.location.state.setStyleId;}else{urlParams=new URLSearchParams(this.props.location.search);action=urlParams.get("action");_id=urlParams.get("_id");hash=this.props.location.hash.split('#')[1];this.props.history.replace('/Sample',{action:action,_id:_id,hash:hash});}if(!(styleId!=""&&referenceId!=""&&styleId!==undefined&&referenceId!==undefined)){_context2.next=13;break;}sampleRequest=Object.assign({},this.state.sampleRequest);//console.log(sampleRequest,"sampleRequest");
sampleRequest.magnumStyleId=styleId;sampleRequest.styleReferenceId=referenceId;if(!setStyleId){_context2.next=11;break;}_context2.next=11;return this.getMagnumStyleById(sampleRequest.styleReferenceId);case 11:_context2.next=13;return this.setState({sampleRequest:sampleRequest},function(){return _this2.getStyleReferenceInfo(_this2.state.sampleRequest.styleReferenceId);});case 13:_context2.next=15;return this.setState({action:action,_id:_id});case 15:if(!(action=="add")){_context2.next=25;break;}_context2.next=18;return __WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getSampleQr().then(function(response){if(response.status===200){//console.log(response,"res3")
var _sampleRequest=Object.assign({},_this2.state.sampleRequest);//console.log(this.state.sampleRequest, "sampleRequest6");
_sampleRequest.qr=response.text.data.qr;_sampleRequest.requestNumber=response.text.data.requestNumber;// Object.keys(sampleRequest.processUpdates).forEach(keyname => {
//   sampleRequest.processUpdates[keyname].status = "PENDING"
//   sampleRequest.processUpdates[keyname].ETA = new Date()
// })
_this2.setState({sampleRequest:_sampleRequest// isLoading: false
});}response.status===401&&_this2.props.unauthorisedFunc();}).catch(function(err){_this2.props.getalertMessage("error");});case 18:if(!setStyleId){_context2.next=23;break;}_context2.next=21;return this.getMagnumStyleById(styleId);case 21:_context2.next=25;break;case 23:_context2.next=25;return this.getMagnumStyleNo("");case 25:if(!(action=="view")){_context2.next=28;break;}_context2.next=28;return this.setState({disabled:true});case 28:if(!(action=="edit"||action=="view")){_context2.next=33;break;}if(!(_id!=="")){_context2.next=32;break;}_context2.next=32;return __WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].SampleInfo(_id).then(function(response){if(response.status==200){_this2.setState({sampleRequest:response.text.data});var _sampleRequest2=Object.assign({},_this2.state.sampleRequest);if(response.text.data.sample.data.length===0){_sampleRequest2.sample.data=[{size:null,quantity:null}];}if(response.text.data.garmentTechnologist.sampleForm.length===0){_sampleRequest2.garmentTechnologist.sampleForm=[{comments:"",fab:false,trims:false,workManShip:false,buyerChanges:false,pat:false,remarks:""}];}if(response.text.data.pattern.logs.length===0){_sampleRequest2.pattern.logs=[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}];}if(response.text.data.cutting.logs.length===0){_sampleRequest2.cutting.logs=[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}];}_sampleRequest2.processUpdates=Object.assign({},response.text.data.processUpdates);_this2.getMagnumStyleById(_sampleRequest2.styleReferenceId);_this2.setState({sampleRequest:_sampleRequest2,_id:response.text.data._id,createdAt:response.text.data.createdAt},function(){//this.getAssignedTo()
_this2.getStyleReferenceInfo(_this2.state.sampleRequest.styleReferenceId);});}});case 32:setTimeout(function(){if(_this2.props.history.location&&_this2.props.history.location.state&&_this2.props.history.location.state.hash){var _hash=_this2.props.history.location.state.hash==="GARMENT TECH"?"garmentTechnologist":"SIGN OFF"===_this2.props.history.location.state.hash?"signOff":_this2.props.history.location.state.hash.toLowerCase();_this2.scrollToModule(_hash);}},500);case 33://magnumStyleId
// this.getMagnumStyleNo("");
sampleRequestType=window.location.href.split("/")[3].split("?")[1];if(sampleRequestType==="reference"){objData={};objData.label=localStorage.getItem("referenceCode"),objData.value=localStorage.getItem("styleId");objData.customerId=localStorage.getItem("customerId");objData.customerDepartmentId=localStorage.getItem("departmentId");objData.referenceId=localStorage.getItem("referenceId");this.setState({styleNo:objData},function(){});}else if(window.location.href.split("/")[3].split("?")[1]==="MNId=true"||window.location.href.split("/")[3].split("?")[1]==="fromCAD=true"){styleData=JSON.parse(localStorage.getItem("styleInfoForSample"));__WEBPACK_IMPORTED_MODULE_11__services__["b" /* CostingServices */].getRequestInfoByStyleId(styleData.value).then(function(response){if(response.message==="Sample Request Data"){var _objData={};_objData.label=styleData.label,_objData.value=styleData.value;_objData.customerId=styleData.customerId,_objData.customerDepartmentId=styleData.customerDepartmentId;_objData.referenceId=styleData.styleReferenceId;_this2.setState({styleNo:_objData});}}).catch(function(error){alert("Something Went Wrong...Try Again Later");});}_context2.next=37;return __WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].prefillSRDetails().then(function(response){if(response.message==="Operation Successful"){var _sampleRequest3=Object.assign({},_this2.state.sampleRequest);_sampleRequest3.embroidery.leftData=[].concat(_toConsumableArray(response.data.SYSTEMSAMPLEREQUEST.LEFTVALUES));_this2.setState({sampleRequest:_sampleRequest3,sampleRequestType:sampleRequestType,prefillInfo:response.data,styleInfo:response.data.Style,fabricInfo:response.data.Fabric,trimInfo:response.data.Trims});if(action==="add"){var prefillInfo=_this2.state.prefillInfo;// Trim Category for Trim Module
// let trimCategory =
//   prefillInfo.TRIM.TRIMCATEGORY &&
//   prefillInfo.TRIM.TRIMCATEGORY.filter(
//     x => x.label.toLowerCase() === "thread"
//   )[0]
// Trim Category for Sewing Module
var trimCategorySewing=prefillInfo.TRIM.TRIMCATEGORY&&prefillInfo.TRIM.TRIMCATEGORY.filter(function(x){return x.label.toUpperCase()==="THREAD ELASTIC";})[0];// sampleRequest.trim.row1[0].trimCategory =
//   trimCategory && trimCategory.value
// sampleRequest.trim.row2[0].trimCategory =
//   trimCategory && trimCategory.value
_sampleRequest3.sewing.trimData[0].trimCategory=trimCategorySewing&&trimCategorySewing.value;// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row1 &&
//   sampleRequest.trim.row1.length > 0
// ) {
//   sampleRequest.trim.row1.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row1[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row2 &&
//   sampleRequest.trim.row2.length > 0
// ) {
//   sampleRequest.trim.row2.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row2[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
_this2.setState({sampleRequest:_sampleRequest3});_sampleRequest3.wash.washData.price=null;}else if(action==="edit"){var _prefillInfo=_this2.state.prefillInfo;// Trim Category for Trim Module
var trimCategory=_prefillInfo.TRIM.TRIMCATEGORY&&_prefillInfo.TRIM.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;// Trim Category for Sewing Module
var _trimCategorySewing=_prefillInfo.TRIM.TRIMCATEGORY&&_prefillInfo.TRIM.TRIMCATEGORY.filter(function(x){return x.label.toUpperCase()==="THREAD ELASTIC";})[0];// sampleRequest.trim.row1 = sampleRequest.trim.row1.map(x => {
//   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
//   return x
// })
// sampleRequest.trim.row2 = sampleRequest.trim.row2.map(x => {
//   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
//   return x
// })
_sampleRequest3.sewing.trimData=_sampleRequest3.sewing.trimData.map(function(x){x.trimCategory=x.trimCategory?x.trimCategory:_trimCategorySewing;return x;});// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row1 &&
//   sampleRequest.trim.row1.length > 0
// ) {
//   sampleRequest.trim.row1.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row1[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
if(_sampleRequest3.sewing&&_sampleRequest3.sewing.trimData&&_sampleRequest3.sewing.trimData.length){_sampleRequest3.sewing.trimData.forEach(function(x,i){if(x.trimCategory){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(x.trimCategory).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_sampleRequest3.sewing.trimData[i].trimList=response.text.data;case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});}});}// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row2 &&
//   sampleRequest.trim.row2.length > 0
// ) {
//   sampleRequest.trim.row2.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row2[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
// sampleRequest.wash.washData[0].price =
//   prefillInfo.WASH.PRICEPERKG[0].label
// sampleRequest.wash.washData = sampleRequest.wash.washData.map((x)=>{
//   x.price = x.price ? x.price : prefillInfo.WASH.PRICEPERKG[0].label
// })
// this.setState({ sampleRequest })
}}}).catch(function(error){_this2.props.getalertMessage("error",error.toString());});case 37:_context2.next=39;return __WEBPACK_IMPORTED_MODULE_11__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.message==="all customer details"){_this2.setState({customerList:response.data// customerId: response.data[0]._id,
// departmentId: response.data[0].departmentId
});}}).catch(function(error){_this2.props.getalertMessage("error",error.toString());});case 39:// await this.getAssignToList("")
// await  this.setState({
//     rights: this.props.rights
//   });
copyOfSamplerequest=JSON.stringify(this.state.sampleRequest);_context2.next=42;return this.setState({isLoading:false,emptyData:copyOfSamplerequest});case 42:_context2.next=44;return this.getAssignToList();case 44:if(!(this.state.action==="edit"||this.state.action==="add")){_context2.next=50;break;}if(!(this.state.action!=="add")){_context2.next=48;break;}_context2.next=48;return this.waitForStateToUpdate();case 48:_context2.next=50;return __WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getCustomerData({customer:this.state.sampleRequest.customer,customerDepartmentId:this.state.sampleRequest.customerDepartmentId,type:this.state.sampleRequest.typeOfRequest}).then(function(response){if(response.status==200){_this2.setState({sizeList:response.text.data.sizes});}}).catch(function(error){return _this2.props.getalertMessage("error hell",error.toString());});case 50:case"end":return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _ref2.apply(this,arguments);}return componentWillMount;}()},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;if(this.state.action==="add"){window.addEventListener("beforeunload",function(event){event.returnValue="Hellooww";});}if(this.props.history.location.state){if(this.props.history.location.state.sample){this.setState(Object.assign({},this.props.history.location.state.sample));}}__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getFabricNumber("").then(function(response){if(response.status==200){_this3.setState({fabricList:response.text.data});}}).catch(function(error){});__WEBPACK_IMPORTED_MODULE_11__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this3.setState({customerList:response.text.data// customerId: response.data[0]._id,
// departmentId: response.data[0].departmentId
});}}).catch(function(error){_this3.props.getalertMessage("error",error.toString());});__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].prefillDataCadSystem().then(function(res){if(res.status===200){_this3.setState({cadPreFill:{CADTYPE:res.text.data.CADTYPE,PRINTEMBTYPE:res.text.data.PRINTEMBTYPE,BORDERTYPE:res.text.data.BORDERTYPE}});}});}//Assinedto all modules
},{key:"searchMeetingNote",value:function searchMeetingNote(e){var _this4=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_11__services__["g" /* MeetingNotesServices */].searchMeetingNotesBy(this.state.searchMeetingNotesBy,this.state.meetingNoteValue).then(function(response){if(response.message==="List Displayed"){_this4.setState({meetingNotes:response.data});}}).catch(function(error){_this4.props.getalertMessage("error",error.toString());});}},{key:"getTrimNumber",value:function getTrimNumber(value){var _this5=this;__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getTrimNumber(value).then(function(response){if(response.message==="List Displayed"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.trimNumber;objData.value=info._id;jsonData.push(objData);});_this5.setState({trimNumberInfo:jsonData});}}).catch(function(error){_this5.props.getalertMessage("error",error.toString());});}},{key:"addEmbellishment",value:function addEmbellishment(e){e.preventDefault();var manualQty=this.state.manualQty;manualQty.push(manualQty.length+1);this.setState({manualQty:manualQty});}},{key:"removeEmbellishment",value:function removeEmbellishment(e,index){var manualQty=this.state.manualQty;manualQty.splice(index,1);this.setState({manualQty:manualQty});}},{key:"getPatternMaster",value:function getPatternMaster(value,name){var _this6=this;__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getEmployeId(value,name).then(function(response){if(response.message==="Operation Successful"){var jsonData=[];response.data.map(function(info,index){var objData={};objData.label=info.userId;objData.value=info._id;jsonData.push(objData);});_this6.setState({patternMasterInfo:jsonData});}}).catch(function(error){_this6.props.getalertMessage("error",error.toString());});}},{key:"createProduct",value:function createProduct(e){var _this7=this;e.preventDefault();var data={};data.embroideryTab=this.state.embroideryActive;data.MNId=this.state.meetingNoteId;data.magnumStyleId=this.state.styleNo.value;data.refImages=this.state.images;var form=document.forms["createProduct"];for(var i=0;i<form.elements.length;i++){data[form.elements[i].name]=form.elements[i].value;}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createProduct(data).then(function(response){if(response.message==="Successfully Updated"){__WEBPACK_IMPORTED_MODULE_11__services__["m" /* UtilityService */].successMsg(_this7.msg);_this7.setState({productId:response.data._id});}}).catch(function(error){_this7.props.getalertMessage("error",error.toString());});}},{key:"completeProduct",value:function completeProduct(e){var _this8=this;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeProduct(this.state.productId).then(function(response){if(response.message==="Successfully updated"){__WEBPACK_IMPORTED_MODULE_11__services__["m" /* UtilityService */].successMsg(_this8.msg);}}).catch(function(error){_this8.props.getalertMessage("error",error.toString());});}},{key:"addCategoryCount",value:function addCategoryCount(e,name){var data=this.state[""+name];var length=this.state[""+name].length;data.push(length);this.setState(_defineProperty({},""+name,data));}},{key:"removeCategoryCount",value:function removeCategoryCount(index,name){var data=this.state[""+name];data.splice(index,1);this.setState(_defineProperty({},""+name,data));}},{key:"addDispatch",value:function addDispatch(e,keyname){var dispatch=this.state.dispatch;dispatch[keyname].push(this.state.dispatch[keyname].length+1);this.setState({dispatch:dispatch});}},{key:"removeDispatch",value:function removeDispatch(e,index,keyname){var dispatch=this.state.dispatch;dispatch[keyname].splice(index,1);this.setState({dispatch:dispatch},function(){});}},{key:"changeRequest",value:function changeRequest(e){var _this9=this;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getAssignTo(e.target.value).then(function(response){if(response.message==="Operation Successful"){_this9.setState({markerId:response.data._id});}}).catch(function(error){_this9.props.getalertMessage("error",error.toString());});}},{key:"sampleImage",value:function sampleImage(e){var selDiv="";selDiv=document.querySelector("#selectedFiles");if(!e.target.files)return;selDiv.innerHTML="";var files=e.target.files;for(var i=0;i<files.length;i++){var f=files[i];selDiv.innerHTML+=f.name+"<br/>";}}},{key:"sampleImagewash",value:function sampleImagewash(e){var selDivwash="";selDivwash=document.querySelector("#selectedFileswash");if(!e.target.files)return;selDivwash.innerHTML="";var files=e.target.files;for(var i=0;i<files.length;i++){var f=files[i];selDivwash.innerHTML+=f.name+"<br/>";}}//Jayaprakash
//ToggleList function
//SwitchList function
//getUserStatus in process update
//EMbroidery section
// Sample module start
// Sample module end
//Cad module start
// Cad module end
//SampleRequest leftSection Start
//SampleRequest LeftSection End
// Employee list
//  Fabric module start
// Fabric module end
//trim module start
//trim module end
// common for pattern,sewing,cutting
///pattern module start
//pattern module end
// cutting module start
//cutting module end
// Sewing module start
//Sewing module end
//garment technologiest module start
//garment technologist module end
//embellishment module start
//embellishment module end
//embroidery module start
//backing
//embroidery module end
//wash moduel start
// wash module end
//qc module start
//qc module end
//dispatch module start
//dispatch module end
//marker module start
//marker module end
//costing module start
///costing module end
//signoff module start
//signoff module end
//processupdate
// SampleRequest
//scroll
//type
//refimages
//Assingned to , status , completed date update
//toggle update
},{key:"render",value:function render(){var _this10=this;var sampleRequest=this.state.sampleRequest;//console.log(this.state.sampleRequest, "sampleRequest");
//console.log(this.state.measurementChartData,"mea")
var rights=this.props.rights;var toggle=this.state.sampleRequest.toggle;if(this.state.prefillInfo.SYSTEMSAMPLEREQUEST.DURATION){var _state$prefillInfo$SY=this.state.prefillInfo.SYSTEMSAMPLEREQUEST.DURATION,DISPATCH=_state$prefillInfo$SY.DISPATCH,FABRIC=_state$prefillInfo$SY.FABRIC,PATTERNS=_state$prefillInfo$SY.PATTERNS,TRIM=_state$prefillInfo$SY.TRIM;};if(Object.keys(this.state.prefillInfo).length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section remove-scroll-for-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row nopadding"},this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["i" /* LeftSection */]// sampleRequest={sampleRequest}
,{getCustomerDepartmentName:this.getCustomerDepartmentName,action:this.state.action,history:this.props.history,sampleRequest:sampleRequest,magnumStyleId:this.state.sampleRequest.magnumStyleId,SAMPLETYPE:Object.keys(this.state.prefillInfo.SAMPLEREQUEST).length>0?this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE:[],styleNoInfo:this.state.styleNoInfo,getMagnumStyleNo:function getMagnumStyleNo(value){return _this10.getMagnumStyleNo(value);},getStyleReferenceInfo:this.getStyleReferenceInfo,updateSampleRequest:this.updateSampleRequest,updateCustomerDept:this.updateCustomerDept,saveSampleRequest:this.saveSampleRequest,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"right-section",className:"right-content-section overflow-scroll bg-white"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_audit__["a" /* default */],{_id:this.state._id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon mr-3 pull-right",style:{cursor:"pointer"},onClick:function onClick(e){_this10.setState({isLoading:true});setTimeout(function(){_this10.printData();_this10.setState({isLoading:false});setTimeout(function(){return _this10.openPrint("printSample");},5000);},2000);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Page_PageHeader_PageHeader__["a" /* default */],{header:"SAMPLE REQUEST",history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["n" /* SampleMain */],{sampleRequest:sampleRequest,updateSampleRequest:this.updateSampleRequest,SAMPLEREQUEST:this.state.prefillInfo.SAMPLEREQUEST,createSample:this.createSample,disabled:this.state.disabled,orderDate:this.state.sampleRequest.orderDate,confirmDuplicate:this.confirmDuplicate,rights:rights}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["p" /* SampleModuleSelect */],{selectedModule:function selectedModule(data){return _this10.handleselectedType(data);},selected:this.state.sampleRequest.selectedType,toggle:this.state.sampleRequest.toggle,rights:rights,action:this.state.action,toggleChange:this.toggleChange,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 text-center"},!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Buttons_Button__["a" /* default */],{buttonName:"SAVE",buttonType:"save",onClick:this.createSample})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"exTab2",className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"nav nav-tabs"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:"active"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#1","data-toggle":"tab"},"Manage Process")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#2","data-toggle":"tab"},"Process updates"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"tab-content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"tab-pane active",id:"1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding tab-pane active",id:"manage-process"},(rights.sample.web.view&&this.state.action==="view"||rights.sample.web.create&&this.state.action==="add"||rights.sample.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.sample&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["o" /* SampleModule */],{_id:this.state._id,sample:this.state.sampleRequest.sample,sampleProcess:this.state.sampleRequest.processUpdates.sample,SAMPLEREQUEST:this.state.prefillInfo.SAMPLEREQUEST,sizeList:this.state.sizeList,STATUS:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain,createSampleModule:this.createSampleModule,completeSampleModule:this.completeSampleModule,getSample:this.updateSampleModule,sampleRights:rights.sample,addSize:this.addSize,removeSize:this.removeSize,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.sample.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.garmentTech.web.view&&this.state.action==="view"||rights.garmentTech.web.create&&this.state.action==="add"||rights.garmentTech.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.garmentTechnologist&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["h" /* GarmentTechModule */],{_id:this.state._id,garmentTechnologist:this.state.sampleRequest.garmentTechnologist,garmentProcess:this.state.sampleRequest.processUpdates.garmentTechnologist,updateModulesMain:this.updateModulesMain,printGarment:this.printGarment,STATUS:this.state.prefillInfo.STATUS,updateGarment:this.updateGarment,updateGarmentForm:this.updateGarmentForm,addGarmentForm:this.addGarmentForm,removeGarmentForm:this.removeGarmentForm,createGarment:this.createGarment,completeGarment:this.completeGarment,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.garmentTech.web,editorDraft:this.onEditorStateChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.cad.web.view&&this.state.action==="view"||rights.cad.web.create&&this.state.action==="add"||rights.cad.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.cad&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["a" /* CadModule */],{cadPreFill:this.state.cadPreFill,_id:this.state._id,cad:this.state.sampleRequest.cad,cadProcess:this.state.sampleRequest.processUpdates.cad,updateModulesMain:this.updateModulesMain,cadUpdate:this.cadUpdate,getCad:this.updateCad,saveCAD:this.saveCAD,completeCAD:this.completeCAD,updateCadValues:this.updateCadValues,changeCADRefNum:this.changeCADRefNum,CAD:this.state.prefillInfo.CAD,STATUS:this.state.prefillInfo.STATUS,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.cad.web,history:this.props.history,action:this.state.action}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.fabric.web.view&&this.state.action==="view"||rights.fabric.web.create&&this.state.action==="add"||rights.fabric.web.edit&&this.state.action==="edit")&&toggle.fabric&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["g" /* FabricModule */],{getFabricNumber:this.getFabricNumber,fabricList:this.state.fabricList,_id:this.state._id,updateFabricName:this.updateFabricName// durationFabric={
//   this.setDuration(this.state.sampleRequest.processUpdates.fabric.ETA, FABRIC)
// }
,fabric:this.state.sampleRequest.fabric,fabricRadio:this.state.sampleRequest.fabricRadio,fabricProcess:this.state.sampleRequest.processUpdates.fabric,updateModulesMain:this.updateModulesMain,SAMPLEREQUEST:this.state.prefillInfo.SAMPLEREQUEST,FABRIC:this.state.prefillInfo.FABRIC,STATUS:this.state.prefillInfo.STATUS,createFabric:this.createFabric,updateFabric:this.updateFabric,clearDummyFabric:this.clearDummyFabric,fabricComments:this.state.sampleRequest.fabricComments,updateSampleRequest:this.updateSampleRequest,completeFabric:this.completeFabric,addFabric:this.addFabric,removeFabric:this.removeFabric,getFabricInfo:this.getFabricInfo,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.fabric.web,history:this.props.history,printFabric:this.printFabric,getalertMessage:this.props.getalertMessage,action:this.state.action,parentstate:this.state}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),(rights.trim.web.view&&this.state.action==="view"||rights.trim.web.create&&this.state.action==="add"||rights.trim.web.edit&&this.state.action==="edit")&&toggle.trim&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["t" /* TrimModule */],{getTrimRefNo:this.getTrimRefNo,getalertMessage:this.props.getalertMessage,_id:this.state._id// durationTrim={this.setDuration(this.state.sampleRequest.processUpdates.trim.ETA, TRIM)}
,trim:this.state.sampleRequest.trim,trimRadio:this.state.sampleRequest.trimRadio,trimProcess:this.state.sampleRequest.processUpdates.trim,updateSampleRequest:this.updateSampleRequest,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,TRIM:this.state.prefillInfo.TRIM,TRIMPLACEMENT:this.state.prefillInfo.TRIMPLACEMENT,updateTrim:this.updateTrim,updateTrimRow1:this.updateTrimRow1,updateTrimRow2:this.updateTrimRow2,getTrimInfo:this.getTrimInfo,getTrimInfoRow2:this.getTrimInfoRow2,removeTrim:this.removeTrim,addTrim:this.addTrim,createTrim:this.createTrim,completeTrim:this.completeTrim,assignedToList:this.state.assignedToList,trimNumberList:this.state.trimNumberList,disabled:this.state.disabled,permissions:rights.trim.web,history:this.props.history,action:this.state.action}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,(rights.pattern.web.view&&this.state.action==="view"||rights.pattern.web.create&&this.state.action==="add"||rights.pattern.web.edit&&this.state.action==="edit")&&toggle.pattern&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["k" /* PatternModule */],{_id:this.state._id// durationPatterns={this.setDuration(this.state.sampleRequest.processUpdates
//   .pattern.ETA, PATTERNS)}
,pattern:this.state.sampleRequest.pattern,patternProcess:this.state.sampleRequest.processUpdates.pattern,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,PATTERNTYPE:this.state.prefillInfo.PATTERNTYPE,assignedToList:this.state.prefillInfo.PATTERNMASTER,updatePatternCheck:this.updatePatternCheck,updatePattern:this.updatePattern,updatePatternLog:this.updatePatternLog,addPatternLog:this.addPatternLog,createPattern:this.createPattern,completePattern:this.completePattern,removePatternLog:this.removePatternLog,disabled:this.state.disabled,permissions:rights.pattern.web,getCustomerDepartmentName:this.getCustomerDepartmentName,magnumStyleId:this.state.sampleRequest.magnumStyleId,SAMPLETYPE:Object.keys(this.state.prefillInfo.SAMPLEREQUEST).length>0?this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE:[],styleNoInfo:this.state.styleNoInfo,getMagnumStyleNo:function getMagnumStyleNo(value){return _this10.getMagnumStyleNo(value);},getStyleReferenceInfo:this.getStyleReferenceInfo,customer:this.state.sampleRequest.customer,customerDepartmentId:this.state.sampleRequest.customerDepartmentId,type:this.state.sampleRequest.typeOfRequest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.cutting.web.view&&this.state.action==="view"||rights.cutting.web.create&&this.state.action==="add"||rights.cutting.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.cutting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["c" /* CuttingModule */],{_id:this.state._id,cutting:this.state.sampleRequest.cutting,sample:this.state.sampleRequest.sample,cuttingProcess:this.state.sampleRequest.processUpdates.cutting,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,CUTTINGTYPE:this.state.prefillInfo.CUTTINGTYPE,assignedToList:this.state.prefillInfo.CUTTINGMASTER,updateCutting:this.updateCutting,updateCuttingLog:this.updateCuttingLog,updateCuttingCheck:this.updateCuttingCheck,createCutting:this.createCutting,addCuttingLog:this.addCuttingLog,removeCuttingLog:this.removeCuttingLog,completeCutting:this.completeCutting,disabled:this.state.disabled,permissions:rights.cutting.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.sewing.web.view&&this.state.action==="view"||rights.sewing.web.create&&this.state.action==="add"||rights.sewing.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.sewing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["r" /* SewingModule */],{_id:this.state._id,sewing:this.state.sampleRequest.sewing,sample:this.state.sampleRequest.sample,sewingProcess:this.state.sampleRequest.processUpdates.sewing,tailorName:this.state.prefillInfo.SYSTEMSAMPLEREQUEST,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,SEWINGTYPE:this.state.prefillInfo.SAMPLEREQUEST.SEWINGTYPE,PLACEOFSEWING:this.state.prefillInfo.SAMPLEREQUEST.PLACEOFSEWING,TRIM:this.state.prefillInfo.TRIM,TRIMPLACEMENT:this.state.prefillInfo.TRIMPLACEMENT,trimNumberList:this.state.trimNumberList,updateSewingTrimData:this.updateSewingTrimData,getTrimInfoSewTrimData:this.getTrimInfoSewTrimData,updateSewing:this.updateSewing,updateSewing1:this.updateSewing1,addSewing:this.addSewing,removeSewing:this.removeSewing,updateSewingLog:this.updateSewingLog,updateSewingCheck:this.updateSewingCheck,createSewing:this.createSewing,addSewingLog:this.addSewingLog,removeSewingLog:this.removeSewingLog,completeSewing:this.completeSewing,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.sewing.web,smockingShirringaddTrim:this.smockingShirringaddTrim,smockingShirringremoveTrim:this.smockingShirringremoveTrim,getTrimRefNoSewing:this.getTrimRefNoSewing}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.embellishment.web.view&&this.state.action==="view"||rights.embellishment.web.create&&this.state.action==="add"||rights.embellishment.web.edit&&this.state.action==="edit")&&toggle.embellishment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["e" /* EmbellishmentModule */],{_id:this.state._id,embellishment:this.state.sampleRequest.embellishment,embellishmentComments:this.state.sampleRequest.embellishmentComments,embellishmentProcess:this.state.sampleRequest.processUpdates.embellishment,updateModulesMain:this.updateModulesMain,updateSampleRequest:this.updateSampleRequest,addEmb:this.addEmb,removeEmb:this.removeEmb,STATUS:this.state.prefillInfo.STATUS,updateEmbellishment:this.updateEmbellishment,createEmbellishment:this.createEmbellishment,completeEmbellishment:this.completeEmbellishment,TYPE:this.state.prefillInfo.SAMPLEREQUEST.TYPE,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.embellishment.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.embroidery.web.view&&this.state.action==="view"||rights.embroidery.web.create&&this.state.action==="add"||rights.embroidery.web.edit&&this.state.action==="edit")&&toggle.embroidery&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["f" /* EmbroideryModule */],{_id:this.state._id,embroidery:this.state.sampleRequest.embroidery,embroideryData:this.state.sampleRequest.embroidery.embroideryData,embroideryProcess:this.state.sampleRequest.processUpdates.embroidery,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,BACKINGTYPE:this.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE,PLACEMENT:this.state.prefillInfo.SAMPLEREQUEST.PLACEMENT_EMB,EMBFORM:this.state.prefillInfo.SAMPLEREQUEST.EMBFORM,EMBPLACEMENT:this.state.prefillInfo.SAMPLEREQUEST.EMBPLACEMENT,NOOFCOLORS:this.state.prefillInfo.SAMPLEREQUEST.NOOFCOLORS,FRAMES:this.state.prefillInfo.SAMPLEREQUEST.FRAMES,LEFTVALUES:this.state.prefillInfo.SYSTEMSAMPLEREQUEST.LEFTVALUES,PRICE1000STICHES:this.state.prefillInfo.SYSTEMSAMPLEREQUEST["PRICE&1000STICHES"],updateEmbroidery:this.updateEmbroidery,updateEmbroideryBackingData:this.updateEmbroideryBackingData,updateEmbroideryData:this.updateEmbroideryData,addEmbroideryData:this.addEmbroideryData,changeBackingArray:this.changeBackingArray,removeEmbroideryData:this.removeEmbroideryData,moveToRight:this.moveToRight,moveToLeft:this.moveToLeft,moveToBottom:this.moveToBottom,moveToUp:this.moveToUp,saveEmbroidery:this.saveEmbroidery,completeEmbroidery:this.completeEmbroidery,getRefImages:this.getRefImages,assignedToList:this.state.assignedToList,widthList:this.state.widthList,disabled:this.state.disabled,permissions:rights.embroidery.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.wash.web.view&&this.state.action==="view"||rights.wash.web.create&&this.state.action==="add"||rights.wash.web.edit&&this.state.action==="edit")&&toggle.wash&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["u" /* WashModule */],{_id:this.state._id,wash:this.state.sampleRequest.wash,washProcess:this.state.sampleRequest.processUpdates.wash,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,WASHTYPE:this.state.prefillInfo.WASH.WASHTYPE,WASHFORM:this.state.prefillInfo.WASH.WASHFORM,LU:this.state.prefillInfo.WASH.LAUNDRYUNIT,NOOFMOCKS:this.state.prefillInfo.WASH.NOOFMOCKS,PRICEPERKG:this.state.prefillInfo.WASH.PRICEPERKG,changeWashData:this.changeWashData,updateWash:this.updateWash,updateWash1:this.updateWash1,createWash:this.createWash,getRefImages:this.getRefImages,completeWash:this.completeWash,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.wash.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.dispatch.web.view&&this.state.action==="view"||rights.dispatch.web.create&&this.state.action==="add"||rights.dispatch.web.edit&&this.state.action==="edit")&&this.state.selected!=="costingRequest"&&toggle.dispatch&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["d" /* DispatchModule */],{_id:this.state._id// durationDispatch={
//   this.setDuration(this.state.sampleRequest.processUpdates.dispatch.ETA, DISPATCH)
// }
,dispatch:this.state.sampleRequest.dispatch,dispatchProcess:this.state.sampleRequest.processUpdates.dispatch,updateModulesMain:this.updateModulesMain,udpateDispatch:this.updateDispatch,udpateDispatchValues:this.udpateDispatchValues,addDispatchData:this.addDispatchData,removeDispatchData:this.removeDispatchData,createDispatch:this.createDispatch,completeDispatch:this.completeDispatch,STATUS:this.state.prefillInfo.STATUS,SIZELIST:this.state.sizeList,COURIER:this.state.prefillInfo.SYSTEMSAMPLEREQUEST.COURIER,LOCATION:this.state.prefillInfo.SYSTEMSAMPLEREQUEST.LOCATION,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.dispatch.web,customer:this.state.sampleRequest.customer,customerDepartmentId:this.state.sampleRequest.customerDepartmentId,type:this.state.sampleRequest.typeOfRequest,magnumStyleId:this.state.sampleRequest.magnumStyleId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.QC.web.view&&this.state.action==="view"||rights.QC.web.create&&this.state.action==="add"||rights.QC.web.edit&&this.state.action==="edit")&&toggle.qc&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["m" /* QcModule */],{_id:this.state._id,qc:this.state.sampleRequest.qc,qcProcess:this.state.sampleRequest.processUpdates.qc,updateModulesMain:this.updateModulesMain,updateQc:this.updateQc,createQC:this.createQC,completeQC:this.completeQC,STATUS:this.state.prefillInfo.STATUS,getRefImages:this.getRefImages,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.QC.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.marker.web.view&&this.state.action==="view"||rights.marker.web.create&&this.state.action==="add"||rights.marker.web.edit&&this.state.action==="edit")&&toggle.marker&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["j" /* MarkerModule */],{_id:this.state._id,marker:this.state.sampleRequest.marker,markerProcess:this.state.sampleRequest.processUpdates.marker,updateModulesMain:this.updateModulesMain,updateMarker:this.updateMarker,createMarker:this.createMarker,completeMarker:this.completeMarker,getRefImages:this.getRefImages,STATUS:this.state.prefillInfo.STATUS,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.marker.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.costing.web.view&&this.state.action==="view"||rights.costing.web.create&&this.state.action==="add"||rights.costing.web.edit&&this.state.action==="edit")&&toggle.costing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["b" /* CostingModule */],{_id:this.state._id,costingComments:this.state.sampleRequest.costingComments,costingProcess:this.state.sampleRequest.processUpdates.costing,updateModulesMain:this.updateModulesMain,updateCosting:this.updateSampleRequest,createCosting:this.createCosting,completeCosting:this.completeCosting,createCostingPage:this.createCostingPage,viewCostingPage:this.viewCostingPage,STATUS:this.state.prefillInfo.STATUS,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.costing.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null)),(rights.signoff.web.view&&this.state.action==="view"||rights.signoff.web.create&&this.state.action==="add"||rights.signoff.web.edit&&this.state.action==="edit")&&toggle.signOff&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["s" /* SignOffModule */],{_id:this.state._id,signOffComments:this.state.sampleRequest.signOffComments,signOffProcess:this.state.sampleRequest.processUpdates.signOff,updateModulesMain:this.updateModulesMain,STATUS:this.state.prefillInfo.STATUS,updateSignOff:this.updateSampleRequest,createSignOff:this.createSignOff,completeSignoff:this.completeSignoff,assignedToList:this.state.assignedToList,disabled:this.state.disabled,permissions:rights.signoff.web}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"clearfix"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr",null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["q" /* ScrollMenu */],{toggleData:sampleRequest.toggle,scrollToModule:this.scrollToModule,selectedQequest:this.state.selected!=="costingRequest",rights:rights})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"tab-pane",id:"2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SampleRequest__["l" /* ProcessUpdate */],{_id:this.state._id,toggle:this.state.sampleRequest.toggle,STATUS:this.state.prefillInfo.STATUS,processUpdates:this.state.sampleRequest.processUpdates,ProcessUpdates:this.ProcessUpdates,updateProcessUpdate:this.updateProcessUpdate,assignedTo:this.state.assignedTo,assignedToList:this.state.assignedToList,disabled:this.state.disabled,completeAllHandler:this.completeAllHandler,permissions:rights,action:this.state.action}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"printSample",className:"d-none"},this.state.printLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_printSample__["a" /* default */],{toggle:this.state.sampleRequest.toggle,sampleMain:this.state.sampleMain,bNo:this.state.sampleRequest.test1})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:"print-garment",className:"d-none"},this.state.printGarmentLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SampleRequest_GarmentTechModule_PrintGarmentTech__["a" /* default */],{printGarmentTech:this.state.printGarmentTech})));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Common_Loading__["a" /* default */],null);}}}]);return Sample;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this11=this;this.state={styleNoInfo:[],action:"",comments:"",_id:"",emptyData:null,selected:"sampleRequest",measurementChartData:{},sampleRequest:{requestNumber:null,qr:"",selectedType:"sampleRequest",originationOfRequest:null,magnumStyleId:null,typeOfRequest:"",sampleType:null,requiredDate:null,buyerName:"",assistantBuyer:"",fabricTechnologist:"",garmentTechnology:"",magnumTechnologist:null,customer:null,customerDepartmentId:null,orderDate:new Date(),styleReferenceId:null,magnumStyleName:"",customerRefNumber:"",test1:null,test2:"dsd",sample:{awaitingDevSample:false,awaitingDevSheet:false,data:[{size:null,quantity:null}],comments:""},cad:{cadId:null,cadName:"",cadRefNo:"",cadType:[],comments:""},fabric:[],fabricRadio:"notInHse",trimRadio:"notInHse",trim:{// row1: [
//   {
//     trimId: null,
//     trimCategory: null,
//     trimNumber: null,
//     description: "",
//     size: "",
//     quality: "",
//     sizeNumber: "",
//     trimRadio: "notInHse"
//   }
// ],
smokingOrShiring:false,// row2: [
//   {
//     trimCategory: null,
//     trimNumber: null,
//     placement: null,
//     number: null,
//     type: null,
//     noOfRow: null,
//     length: null,
//     totalReq: null
//   }
// ],
comment:""},pattern:{patternMaster:null,patternType:null,blockRefNumber:"",trailRequired:false,comment:"",date:null,existingBlockRefNumber:"",followedBlockRequired:false,approvalStatus:"",logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}]},cutting:{cuttingMasterName:null,cuttingType:null,logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}],comments:"",patternIssues:"",fabricIssues:false,approvalStatus:""},sewing:{placeOfSewing:"5cde88716510d24851321273",sewingData:[{tailorName:null,sewingType:"5cde887e6510d24851321276",size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]}],smokingOrShiring:false,trimData:[{trimCategory:null,trimNumber:null,placement:null,number:null,type:null,noOfRow:null,length:null,totalReq:null}],comments:""},embellishment:[{embType:null,hoursMinutes:null,pricePerHalfHour:null}],embellishmentComments:"",embroidery:{cutPanel:false,allOver:false,garmentForm:false,semiGarmentForm:false,tassel:false,selected:[String],rightData:[],leftData:[],additionalInfo:"",refImages:[],employeeName:null,smocking:false,sheering:false,backing:false,bitAttaching:false,backingData:[{backingType:null,width:null,placement:null}],embroideryData:[{embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""}],machine:[{frames:null,forms:null,placement:null,noOfCols:null,stitches:null,consumptions:null,StitchCount:null,price:null,backing:[{backing:"",width:null,placement:null}]}],comments:""},garmentTechnologist:{// sampleForm: [
//   {
//     comments: "",
//     fab: false,
//     trims: false,
//     workManShip: false,
//     buyerChanges: false,
//     pat: false,
//     remarks: ""
//   }
// ],
sampleForm:{fitMesurements:[],makeupConstruction:[],trimsComponents:[],packPresentation:[]},garmentTechComments:"",markerRequirements:false,smvAmmendment:false,trailRequired:false,mock:false,comment:""},wash:{washData:{washType:null,washFrom:"5d8c601cdd0f0307127f3770",laundryUnit:null,price:null},hasMock:false,numberOfMocks:null,tacking:false,recipe:true,refImages:[],comments:""},dispatch:{magnumCounter:false,data:[// {
//   location: null,
//   date: null,
//   courier: null,
//   awbNumber: "",
//   size: null,
//   quantity: null
// }
],comments:"",magnum:false},qc:{anyIssue:false,reason:"",refImages:[],comments:"",remarks:""},marker:{refImages:[],comments:""},costingComments:"",signOffComments:"",processUpdates:{sample:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},garmentTechnologist:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},cad:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},fabric:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},trim:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},pattern:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},cutting:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},sewing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},embellishment:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},embroidery:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},wash:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},dispatch:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},qc:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},marker:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},costing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},signOff:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""}},printLoading:false,fabricComments:"",toggle:{sample:true,cad:false,fabric:true,trim:true,pattern:true,cutting:true,sewing:true,garmentTechnologist:true,embellishment:false,embroidery:false,wash:false,dispatch:true,qc:true,marker:true,costing:true,signOff:true}},prefillInfo:{SAMPLEREQUEST:{},SAMPLE:{},CAD:{},FABRIC:{},TRIM:{},PATTERNTYPE:[],CUTTINGTYPE:[],STATUS:{},SEWING:{},SYSTEMSAMPLEREQUEST:{},EMBROIDERY:{},WASH:{},CUTTINGMASTER:[],PATTERNMASTER:[]},isLoading:false,default:false,printGarmentLoading:false,printGarmentTech:{},assignedToList:[],sizeList:[],assignedTo:{},row1List:[],row2List:[],rights:{},widthList:[],sampleMain:{},fabricList:[],customerDepartment:{},duplicateData:{processUpdates:{sample:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},garmentTechnologist:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},cad:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},fabric:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},trim:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},pattern:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},cutting:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},sewing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},embellishment:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},embroidery:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},wash:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},dispatch:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},qc:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},marker:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},costing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""},signOff:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:null,processCompleted:false,processDate:null,comments:""}},sample:{awaitingDevSample:false,awaitingDevSheet:false,data:[],sizes:[],comments:""},cad:{cadId:null,cadName:"",cadRefNo:"",cadType:[],comments:""},fabricRadio:"notInHse",trimRadio:"notInHse",pattern:{patternMaster:null,patternType:null,blockRefNumber:"",trailRequired:false,comment:"",date:null,existingBlockRefNumber:"",followedBlockRequired:false,approvalStatus:"",logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}]},cutting:{cuttingMasterName:null,cuttingType:null,logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}],comments:"",patternIssues:"",fabricIssues:false,approvalStatus:""},sewing:{placeOfSewing:"5cde88716510d24851321273",sewingData:[{tailorName:null,sewingType:"5cde887e6510d24851321276",size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]}],smokingOrShiring:false,trimData:[{trimCategory:null,trimNumber:null,placement:null,number:null,type:null,noOfRow:null,length:null,totalReq:null}],comments:""},embellishment:[{embType:null,hoursMinutes:null,pricePerHalfHour:null}],embellishmentComments:"",embroidery:{cutPanel:false,allOver:false,garmentForm:false,semiGarmentForm:false,tassel:false,selected:[String],rightData:[],leftData:[],additionalInfo:"",refImages:[],employeeName:null,smocking:false,sheering:false,backing:false,bitAttaching:false,backingData:[{backingType:null,width:null,placement:null}],embroideryData:[{embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""}],machine:[{frames:null,forms:null,placement:null,noOfCols:null,stitches:null,consumptions:null,StitchCount:null,price:null,backing:[{backing:"",width:null,placement:null}]}],comments:""},garmentTechnologist:{sampleForm:{fitMesurements:[],makeupConstruction:[],trimsComponents:[],packPresentation:[]},garmentTechComments:"",markerRequirements:false,smvAmmendment:false,trailRequired:false,mock:false,comment:""},dispatch:{magnumCounter:false,data:[// {
//   location: null,
//   date: null,
//   courier: null,
//   awbNumber: "",
//   size: null,
//   quantity: null
// }
],comments:"",magnum:false},qc:{anyIssue:false,reason:"",refImages:[],comments:"",remarks:""},marker:{refImages:[],comments:""}}};this.onEditorStateChange=function(value,arrKey,arrSubKey,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var locateDraft=sampleRequest.garmentTechnologist.sampleForm;var index=-1;var subindex=0;for(var key in locateDraft){index++;if(locateDraft.hasOwnProperty(key)){if(key===arrKey){locateDraft[key].forEach(function(element){if(key.toString()+subindex===arrSubKey){element.comments=value;}subindex++;});}_this11.setState({sampleRequest:sampleRequest});}}};this.waitForStateToUpdate=function(){return new Promise(function(resolve){var checkState=function checkState(){if(_this11.state.sampleRequest.customer&&_this11.state.sampleRequest.customerDepartmentId){resolve();// Resolve the promise if the state is correct
}else{setTimeout(checkState,50);// Check again after a short delay
}};checkState();});};this.getAssignedTo=function(){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getCustomerData({customer:_this11.state.sampleRequest.customer,customerDepartmentId:_this11.state.sampleRequest.customerDepartmentId,type:_this11.state.sampleRequest.typeOfRequest}).then(function(response){if(response.status==200){if(Object.keys(response.text.data.assignedTo).length>0){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var assignmentOfwork=["sample","cad","fabric","pattern","cutting","sewing","trim","garmentTechnologist","embellishment","embroidery","wash","dispatch","qc","marker","costing","signOff"];assignmentOfwork.map(function(keyName){sampleRequest.processUpdates[keyName].assignedTo=response.text.data.assignedTo[keyName]!==null?response.text.data.assignedTo[keyName].value:null;});_this11.setState({sampleRequest:sampleRequest});}_this11.setState({sizeList:response.text.data.sizes});}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeAllHandler=function(status){if(_this11.state._id!==""){var completedProcess=Object.assign({},_this11.state.sampleRequest.processUpdates);for(var i in completedProcess){completedProcess[i].status=status;if(status==="COMPLETED"){completedProcess[i].processDate=new Date();}}_this11.setState({sampleRequest:Object.assign({},_this11.state.sampleRequest,{processUpdaes:completedProcess})});var sampleRequestData=_this11.state.sampleRequest;sampleRequestData._id=_this11.state._id;Object.keys(sampleRequestData).forEach(function(x){if(allProceses.includes(x)){delete sampleRequestData[x];}});__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSampleRequest(sampleRequestData).then(function(res){if(res.status===200){_this11.props.getalertMessage("success",res.text.message);_this11.setState({_id:res.text.data._id},function(){return _this11.getAssignedTo();});}else{var required=["originationOfRequest","magnumStyleId","typeOfRequest","sampleType","buyerName","assistantBuyer"].filter(function(x){if(_this11.state.sampleRequest[x]===""||_this11.state.sampleRequest[x]===undefined||_this11.state.sampleRequest[x]===null){return x;}});_this11.props.getalertMessage("info",required[0]+" Required");}res.status===401&&_this11.props.unauthorisedFunc();}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}else{_this11.props.getalertMessage("error","Need to create sample request!.");}};this.getMainValues=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(customer,customerDepartmentId){var sample;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(customer==null||customerDepartmentId==null){sample=_this11.state.sampleRequest;sample.styleReferenceId=null;_this11.setState({sampleRequest:sample,isLoading:false});_this11.props.getalertMessage("error","Selected Magnum Styleref have invalid data");}_context4.next=3;return __WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getCustomerData2({customer:customer,customerDepartmentId:customerDepartmentId}).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(response.status==200){sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.assistantBuyer=response.text.data.asstbuyer;sampleRequest.buyerName=response.text.data.buyer;sampleRequest.fabricTechnologist=response.text.data.fabtech;sampleRequest.garmentTechnology=response.text.data.gmttech;sampleRequest.magnumTechnologist=response.text.data.garmentTechnologist;_this11.setState({sampleRequest:sampleRequest,isLoading:false});}case 1:case"end":return _context3.stop();}}},_callee3,_this11);}));return function(_x4){return _ref5.apply(this,arguments);};}()).catch(function(error){_this11.setState({isLoading:false});_this11.props.getalertMessage("error",error.toString());});case 3:case"end":return _context4.stop();}}},_callee4,_this11);}));return function(_x2,_x3){return _ref4.apply(this,arguments);};}();this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this11.setState({styleNoInfo:jsonData});}}).catch(function(error){});//console.log(this.state.styleNoInfo.map(va=>va.label),"styleInf")
};this.getMagnumStyleById=function(value){__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReferenceById(value).then(function(response){if(response.status===200){_this11.setState({styleNoInfo:response.text.data});}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.createSample=function(){var sampleRequestData=Object.assign({},_this11.state.sampleRequest);Object.keys(sampleRequestData).forEach(function(x){if(allProceses.includes(x)){delete sampleRequestData[x];}});sampleRequestData.requiredDate=new Date();if(_this11.state._id!==""){sampleRequestData._id=_this11.state._id;}else{delete sampleRequestData._id;}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSampleRequest(sampleRequestData).then(function(res){if(res.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.qr=res.text.data.qr;sampleRequest.requestNumber=res.text.data.requestNumber;sampleRequest.createdAt=res.text.data.createdAt;_this11.props.getalertMessage("success",res.text.message);_this11.props.history.replace('/Sample',{action:'edit',_id:res.text.data._id});_this11.setState({_id:res.text.data._id,createdAt:res.text.data.createdAt,sampleRequest:sampleRequest},function(){return _this11.getAssignedTo();});}else{var required=["originationOfRequest","magnumStyleId","typeOfRequest","sampleType","buyerName","assistantBuyer"].filter(function(x){if(_this11.state.sampleRequest[x]===""||_this11.state.sampleRequest[x]===undefined||_this11.state.sampleRequest[x]===null){return x;}});_this11.props.getalertMessage("info",required[0]+" Required");}res.status===401&&_this11.props.unauthorisedFunc();}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.createSampleRequest=function(e){var empObj={};var form=document.forms["sampleRequestForm"];for(var i=0;i<form.elements.length;i++){empObj[form.elements[i].name]=form.elements[i].value;}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSampleRequest(empObj,_this11.state.styleNo).then(function(response){if(response.message==="Sample request Created"){__WEBPACK_IMPORTED_MODULE_11__services__["m" /* UtilityService */].successMsg(_this11.msg);_this11.setState({productId:response.data._id,orderDate:response.data.orderDate,orderNumber:response.data.requestNumber});}}).catch(function(error){_this11.props.getalertMessage("error",error.toString());});};this.getDoneBy=function(value){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getDoneBy(value).then(function(response){if(response.message==="list displayed"){var jsonData=[];response.data.map(function(value,index){var empObj={};empObj.label=value.firstName;empObj.value=value._id;jsonData.push(empObj);});_this11.setState({doneBy:jsonData});}}).catch(function(error){_this11.props.getalertMessage("error",error.toString());});};this.onOpenModal=function(e){_this11.setState({modalOpen:true,selectedProcess:e.target.name});};this.onCloseModal=function(){_this11.setState({modalOpen:false});};this.gotoTop=function(e){e.preventDefault();var rightSectionDiv=document.getElementById("right-section");rightSectionDiv.scrollTop=0;};this.changeToggleList=function(e,keyname){var toggleLists=Object.assign({},_this11.state.toggleLists);toggleLists[keyname].toggle=!_this11.state.toggleLists[keyname].toggle;_this11.setState({toggleLists:toggleLists});};this.changeSwitchList=function(e,keyname){var switchList=Object.assign({},_this11.state.switchList);//
//
switchList[keyname].toggle=!_this11.state.switchList[keyname].toggle;_this11.setState({switchList:switchList});};this.getUserStatus=function(e,keyname){var switchList=Object.assign({},_this11.state.switchList);switchList[keyname].userStatus=e.target.value;_this11.setState({switchList:switchList});};this.goToDiv=function(e,divelement){e.preventDefault();var element=document.getElementById(divelement);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#right-section").animate({scrollTop:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).offset().top-50},1000);};this.createSampleModule=function(e){e.preventDefault();var sample={};sample.sample=Object.assign({},_this11.state.sampleRequest.sample);sample.sampleProcess=Object.assign({},_this11.state.sampleRequest.processUpdates.sample);sample._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSample(sample).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sample=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeSampleModule=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.sample.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeSample(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.sample=Object.assign({},response.text.data);_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateSampleModule=function(name,value,Dataindex){var sampleRequest=_this11.state.sampleRequest;if(Dataindex!==undefined){sampleRequest.sample.data[Dataindex][name]=value;}else{sampleRequest.sample[name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.addSize=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sample.data.push({size:null,quantity:null});_this11.setState({sampleRequest:sampleRequest});};this.removeSize=function(dataIndex){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sample.data.splice(dataIndex,1);_this11.setState({sampleRequest:sampleRequest});};this.saveCAD=function(e){e.preventDefault();var cad={};cad.cad=_this11.state.sampleRequest.cad;cad.cadProcess=_this11.state.sampleRequest.processUpdates.cad;cad._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createCAD(cad).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cad=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeCAD=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.cad.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeCAD(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.cad=Object.assign({},response.text.data);_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateCadValues=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cad[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.cadUpdate=function(){var cad=Object.assign({},_this11.state.sampleRequest.cad);var name=arguments.length<=0?undefined:arguments[0];var value=arguments.length<=1?undefined:arguments[1];cad[name]=value;_this11.setState({sampleRequest:Object.assign({},_this11.state.sampleRequest,{cad:cad})});};this.changeCADRefNum=function(cad){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(cad!==null){__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getCAD(cad.value).then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(response.status==200){sampleRequest.cad.cadType=response.text.data.cadType;sampleRequest.cad.cadId=cad.value;sampleRequest.cad.name=response.text.data.cadName;sampleRequest.cad.printEmbType=response.text.data.printType;sampleRequest.cad.borderType=response.text.data.borderType;}case 1:case"end":return _context5.stop();}}},_callee5,_this11);}));return function(_x5){return _ref6.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}else{sampleRequest.cad.cadType=[];sampleRequest.cad.cadId=null;sampleRequest.cad.name="";sampleRequest.cad.printEmbType="";sampleRequest.cad.borderType="";}setTimeout(function(){_this11.setState({sampleRequest:sampleRequest});},100);};this.getStyleReferenceInfo=function(value){if(value!==null){_this11.setState({isLoading:true});var _state=_this11.state,sampleRequest=_state.sampleRequest,measurementChartData=_state.measurementChartData;sampleRequest.styleReferenceId=value;__WEBPACK_IMPORTED_MODULE_11__services__["k" /* StyleServices */].getStyleInfoByReference(value).then(function(response){if(response.status===200){sampleRequest.magnumStyleName=response.text.data.magnumStyleName;measurementChartData.magnumStyleName=response.text.data.magnumStyleName;sampleRequest.customerRefNumber=response.text.data.customerRefNumber;measurementChartData.customerRefNumber=response.text.data.customerRefNumber;sampleRequest.magnumStyleId=response.text.data.magnumStyleId;measurementChartData.magnumStyleId=response.text.data.magnumStyleId;sampleRequest.customer=response.text.data.customer;measurementChartData.customer=response.text.data.customer;sampleRequest.customerDepartmentId=response.text.data.customerDepartmentId;measurementChartData.customerDepartmentId=response.text.data.customerDepartmentId;sampleRequest.itemNumber=response.text.data.itemNumber;measurementChartData.itemNumber=response.text.data.itemNumber;sampleRequest.blockRefNo=response.text.data.blockRefNumber;measurementChartData.blockRefNo=response.text.data.blockRefNumber;sampleRequest.oldMagStyleNo=response.text.data.refDetail;measurementChartData.oldMagStyleNo=response.text.data.refDetail;sampleRequest.refColNo=response.text.data.referenceColor;measurementChartData.refColNo=response.text.data.referenceColor;sampleRequest.magnumBuyerStyleName=response.text.data.magnumBuyerStyleName;measurementChartData.magnumBuyerStyleName=response.text.data.magnumBuyerStyleName;_this11.setState({sampleRequest:sampleRequest,measurementChartData:measurementChartData},function(){return _this11.getMainValues(sampleRequest.customer,sampleRequest.customerDepartmentId);});//console.log(this.state.sampleRequest, "sampleRequest");
}response.status==401&&_this11.props.unauthorisedFunc();}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}else{var _sampleRequest4=Object.assign({},_this11.state.sampleRequest);_sampleRequest4.styleReferenceId=null;_this11.setState({sampleRequest:_sampleRequest4});}};this.updateSampleRequest=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.updateFabricName=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);//console.log(sampleRequest, "sampleRequestname");
sampleRequest.fabric[index][name]=value;//console.log(sampleRequest.fabric[index][name], "sampleRequestname1212");
_this11.setState({sampleRequest:sampleRequest});};this.updateCustomerDept=function(index,customer,customerDepartmentId){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.customer=customer;sampleRequest.customerDepartmentId=customerDepartmentId;_this11.setState({sampleRequest:sampleRequest});};this.getAssignToList=function(value){__WEBPACK_IMPORTED_MODULE_11__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(res.status==200)){_context6.next=7;break;}_context6.t0=_this11;_context6.next=4;return res.text.data;case 4:_context6.t1=_context6.sent;_context6.t2={assignedToList:_context6.t1};_context6.t0.setState.call(_context6.t0,_context6.t2);case 7:case"end":return _context6.stop();}}},_callee6,_this11);}));return function(_x6){return _ref7.apply(this,arguments);};}());};this.updateFabric=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.fabric[index][name]=value;_this11.setState({sampleRequest:sampleRequest});};this.getFabricInfo=function(fabric,index){if(fabric!=null){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getFabricInfo(fabric.value).then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(response.status==200){sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.fabric[index].classificationOfFabric=response.text.data.classificationOfFabric!==null?response.text.data.classificationOfFabric.name:"";sampleRequest.fabric[index].countAndConstruction=response.text.data.count.warp+"*"+response.text.data.count.weft+"/"+response.text.data.construction.warp+"*"+response.text.data.construction.weft;sampleRequest.fabric[index].quality=response.text.data.quality!==null?response.text.data.quality.name:"";sampleRequest.fabric[index].fabricNumber=fabric.value;sampleRequest.fabric[index].bNumber=response.text.data.bNumber.baseRefNumber;sampleRequest.test1=response.text.data.bNumber.baseRefNumber;_this11.setState({sampleRequest:sampleRequest});}response.status==404&&_this11.props.getalertMessage("error",response.text.message);response.status==401&&_this11.props.unauthorisedFunc();case 3:case"end":return _context7.stop();}}},_callee7,_this11);}));return function(_x7){return _ref8.apply(this,arguments);};}()).catch(function(error){});}else{var sampleRequest=Object.assign({},_this11.state.sampleRequest);//console.log(this.sampleRequest.fabric,"test fab")
sampleRequest.fabric[index].fabricNumber=null;_this11.setState({sampleRequest:sampleRequest});}};this.addFabric=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(!sampleRequest.fabric.length){__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getFabricNumber("F-99999").then(function(response){if(response.status==200){sampleRequest.fabric.push({fabricId:null,fabricNumber:"",fabricList:response.text.data,fabricPosition:null,classificationOfFabric:"",quality:"",countAndConstruction:"",fabricRadio:"notInHse"});// this.setState({ fabricList: response.text.data })
_this11.getFabricInfo(response.text.data[0],0);}}).catch(function(error){});}else{sampleRequest.fabric.push({fabricId:null,fabricNumber:"",fabricList:_this11.props.fabricList,fabricPosition:null,classificationOfFabric:"",quality:"",countAndConstruction:"",fabricRadio:"notInHse"});}_this11.setState({sampleRequest:sampleRequest});};this.removeFabric=function(index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.fabric.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.createFabric=function(e){e.preventDefault();var fabric={};fabric.fabric=_this11.state.sampleRequest.fabric;fabric._id=_this11.state._id;fabric.fabricComments=_this11.state.sampleRequest.fabricComments;fabric.fabricProcess=_this11.state.sampleRequest.processUpdates.fabric;var count=fabric.fabric.reduce(function(n,data){return n+(data.fabricPosition!==null);},0);if(count==fabric.fabric.length){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createFabric(fabric).then(function(response){if(response.status===200){// let sampleRequest = { ...this.state.sampleRequest }
// sampleRequest.fabric = response.text.data
// this.setState({
//   sampleRequest
// })
_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}else{_this11.props.getalertMessage("error","fabric position mandatory");}};this.completeFabric=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.fabric.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeFabric(request).then(function(response){if(response.status==200){sampleRequest.processUpdates.fabric=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.clearDummyFabric=function(index){if(index==0){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.fabric[index].fabricId=null;_this11.setState({sampleRequest:sampleRequest});}};this.getTrimInfo=function(trim,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(trim!==null){sampleRequest.trim.row1[index].trimNumber=trim._id;sampleRequest.trim.row1[index].description=trim.description;sampleRequest.trim.row1[index].quality=trim.quality;sampleRequest.trim.row1[index].sizeNumber=trim.sizeNumber;sampleRequest.trim.row1[index].size=trim.size;}else{sampleRequest.trim.row1[index].trimNumber=null;}_this11.setState({sampleRequest:sampleRequest});_this11.samplePrintTrim();};this.getTrimInfoRow2=function(trim,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(trim!==null){sampleRequest.trim.row2[index].trimNumber=trim._id;sampleRequest.trim.row2[index].description=trim.description;sampleRequest.trim.row2[index].quality=trim.quality;sampleRequest.trim.row2[index].sizeNumber=trim.sizeNumber;sampleRequest.trim.row2[index].size=trim.size;}_this11.setState({sampleRequest:sampleRequest});_this11.samplePrintTrim();};this.updateTrim=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.updateTrimRow1=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name==="trimCategory"){sampleRequest.trim.row1[index][name]=value;sampleRequest.trim.row1[index]["trimNumber"]=null;_this11.setState({sampleRequest:sampleRequest});}else{sampleRequest.trim.row1[index][name]=value;_this11.setState({sampleRequest:sampleRequest});}};this.updateTrimRow2=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim.row2[index][name]=value;_this11.setState({sampleRequest:sampleRequest},function(){return _this11.updateCalcTrim();});if(name=="trimCategory"){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(value,"").then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim.row2[index].trimList=response.text.data;_this11.setState({sampleRequest:sampleRequest});case 3:case"end":return _context8.stop();}}},_callee8,_this11);}));return function(_x8){return _ref9.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}};this.updateCalcTrim=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim.row2=sampleRequest.trim.row2.map(function(data,index){if(data.type=="Both Elastic"){data.number=_this11.state.prefillInfo.SAMPLEREQUEST.BOTHELASTIC;}if(data.type=="Top TTH / Bottom Elastic"){data.number=_this11.state.prefillInfo.SAMPLEREQUEST.TOPTTHORBOTTOMELASTIC;}if(data.number!==null&&data.noOfRow!==null&&data.length!==null){var calc=Number(parseFloat(data.noOfRow))*Number(parseFloat(data.length))*Number(parseFloat(data.number))/100;data.totalReq=(calc+calc*0.1).toFixed(2);}return data;});_this11.setState({sampleRequest:sampleRequest});};this.addTrim=function(keyName){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var prefillInfo=_this11.state.prefillInfo;var trimCategory=prefillInfo.TRIM.TRIMCATEGORY&&prefillInfo.TRIM.TRIMCATEGORY.find(function(x){return x.label.toLowerCase()==="thread";}).value;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"th-00001").then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(response){var rowdata;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:rowdata={trimId:response.text.data[0]._id,trimCategory:trimCategory,trimNumber:response.text.data[0]._id,description:response.text.data[0].description,size:response.text.data[0].size,quality:response.text.data[0].quality,sizeNumber:response.text.data[0].sizeNumber,trimRadio:"notInHse",trimList:response.text.data};if(!sampleRequest.trim[keyName]){sampleRequest.trim=_defineProperty({},keyName,[rowdata]);}else{sampleRequest.trim[keyName]=[].concat(_toConsumableArray(sampleRequest.trim[keyName]),[rowdata]);}_this11.setState({sampleRequest:sampleRequest});case 3:case"end":return _context9.stop();}}},_callee9,_this11);}));return function(_x9){return _ref10.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.removeTrim=function(keyName,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim[keyName].splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.createTrim=function(e){e.preventDefault();var trim={};trim.trim=_this11.state.sampleRequest.trim;trim.trimProcess=_this11.state.sampleRequest.processUpdates.trim;trim._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createTrim(trim).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var row1=sampleRequest.trim.row1,row2=sampleRequest.trim.row2;sampleRequest.trim=response.text.data;sampleRequest.trim.row1=row1;sampleRequest.trim.row2=row2;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeTrim=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.trim.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeTrim(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.trim=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updatePatternCheck=function(name,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.pattern.logs[i][name]=new Date();_this11.setState({sampleRequest:sampleRequest});};this.updatePattern=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.pattern[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.updatePatternLog=function(name,value,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.pattern.logs[i][name]=new Date();}else{sampleRequest.pattern.logs[i][name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.addPatternLog=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.pattern.logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this11.setState({sampleRequest:sampleRequest});};this.removePatternLog=function(i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.pattern.logs.splice(i,1);_this11.setState({sampleRequest:sampleRequest});};this.createPattern=function(e){e.preventDefault();var pattern={};pattern.pattern=Object.assign({},_this11.state.sampleRequest.pattern);pattern.patternProcess=Object.assign({},_this11.state.sampleRequest.processUpdates.pattern);pattern._id=_this11.state._id;var sample=_this11.state.sampleRequest.toggle.sample;var status=_this11.state.sampleRequest.processUpdates.sample.status;if(sample&&status!=="COMPLETED"&&_this11.state.sampleRequest.processUpdates.pattern.status==="COMPLETED"){return _this11.props.getalertMessage("error","Sample process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createPattern(pattern).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.pattern=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completePattern=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.pattern.comments};var sample=sampleRequest.toggle.sample;var status=sampleRequest.processUpdates.sample.status;if(sample&&status!=="COMPLETED"){return _this11.props.getalertMessage("error","Sample process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completePattern(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.pattern=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateCutting=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name==="cuttingMasterName"){if(value!==null){sampleRequest.cutting[name]=value.value;}else{sampleRequest.cutting[name]=null;}}else{sampleRequest.cutting[name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.updateCuttingLog=function(name,value,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.cutting.logs[i][name]=new Date();}else{sampleRequest.cutting.logs[i][name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.updateCuttingCheck=function(name,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cutting.logs[i][name]=new Date();_this11.setState({sampleRequest:sampleRequest});};this.addCuttingLog=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cutting.logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this11.setState({sampleRequest:sampleRequest});};this.removeCuttingLog=function(i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cutting.logs.splice(i,1);_this11.setState({sampleRequest:sampleRequest});};this.createCutting=function(e){var data={};data.cutting=_this11.state.sampleRequest.cutting;data.cuttingProcess=Object.assign({},_this11.state.sampleRequest.processUpdates.cutting);data._id=_this11.state._id;var _state$sampleRequest$=_this11.state.sampleRequest.toggle,pattern=_state$sampleRequest$.pattern,fabric=_state$sampleRequest$.fabric;var patternStatus=_this11.state.sampleRequest.processUpdates.pattern.status;var fabricStatus=_this11.state.sampleRequest.processUpdates.fabric.status;if(_this11.state.sampleRequest.processUpdates.cutting.status==="COMPLETED"&&(pattern&&patternStatus!=="COMPLETED"||fabric&&fabricStatus!=="COMPLETED")){return _this11.props.getalertMessage("error","Pattern and Fabric should complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createCutting(data).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.cutting=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeCutting=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.cutting.comments};var _state$sampleRequest$2=_this11.state.sampleRequest.toggle,pattern=_state$sampleRequest$2.pattern,fabric=_state$sampleRequest$2.fabric;var patternStatus=_this11.state.sampleRequest.processUpdates.pattern.status;var fabricStatus=_this11.state.sampleRequest.processUpdates.fabric.status;if(pattern&&patternStatus!=="COMPLETED"||fabric&&fabricStatus!=="COMPLETED"){return _this11.props.getalertMessage("error","Pattern and Fabric should complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeCutting(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.cutting=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateSewing1=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name==="smokingOrShiring"){sampleRequest.sewing.smokingOrShiring=!sampleRequest.sewing.smokingOrShiring;}else{sampleRequest.sewing[name]=value;}_this11.setState({sampleRequest:sampleRequest},function(){return _this11.onSmockingShirring();});};this.onSmockingShirring=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(sampleRequest.sewing&&sampleRequest.sewing.trimData&&sampleRequest.sewing.trimData.length>0){sampleRequest.sewing.trimData.forEach(function(x,i){if(x.trimCategory){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(x.trimCategory).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:sampleRequest.sewing.trimData[i].trimList=response.text.data;case 1:case"end":return _context10.stop();}}},_callee10,_this11);}));return function(_x10){return _ref11.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});}});}else{sampleRequest.sewing.trimData=[];if(sampleRequest.sewing.trimData.length===0){var prefillInfo=Object.assign({},_this11.state.prefillInfo.TRIM);var trimCategory=prefillInfo.TRIMCATEGORY&&prefillInfo.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"").then(function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:// let sampleRequest = { ...this.state.sampleRequest };
sampleRequest.sewing.trimData[0]={trimId:null,trimCategory:trimCategory,trimNumber:"",description:"",size:"",quality:"",sizeNumber:"",trimRadio:"notInHse"};sampleRequest.sewing.trimData[0].trimList=response.text.data;_this11.setState({sampleRequest:sampleRequest});case 3:case"end":return _context11.stop();}}},_callee11,_this11);}));return function(_x11){return _ref12.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}}_this11.setState({sampleRequest:sampleRequest});};this.smockingShirringaddTrim=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var prefillInfo=Object.assign({},_this11.state.prefillInfo.TRIM);var trimCategory=prefillInfo.TRIMCATEGORY&&prefillInfo.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"").then(function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:// let sampleRequest = { ...this.state.sampleRequest };
sampleRequest.sewing.trimData.push({trimId:null,trimCategory:trimCategory,trimNumber:"",description:"",size:"",quality:"",sizeNumber:"",trimRadio:"notInHse"});sampleRequest.sewing.trimData[sampleRequest.sewing.trimData.length-1].trimList=response.text.data;_this11.setState({sampleRequest:sampleRequest});case 3:case"end":return _context12.stop();}}},_callee12,_this11);}));return function(_x12){return _ref13.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.smockingShirringremoveTrim=function(index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.trimData.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.updateSewing=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name==="tailorName"){if(value!==null){sampleRequest.sewing.sewingData[index][name]=value.value;}else{sampleRequest.sewing.sewingData[index][name]=null;}}else{sampleRequest.sewing.sewingData[index][name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.updateSewingTrimData=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.trimData[index][name]=value;_this11.setState({sampleRequest:sampleRequest},function(){return _this11.updateCalcSewing();});if(name=="trimCategory"){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(value,"").then(function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.trimData[index].trimList=response.text.data;_this11.setState({sampleRequest:sampleRequest});case 3:case"end":return _context13.stop();}}},_callee13,_this11);}));return function(_x13){return _ref14.apply(this,arguments);};}()).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});}};this.getTrimInfoSewTrimData=function(trim,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(trim!==null){sampleRequest.sewing.trimData[index].trimNumber=trim._id;sampleRequest.sewing.trimData[index].description=trim.description;sampleRequest.sewing.trimData[index].quality=trim.quality;sampleRequest.sewing.trimData[index].sizeNumber=trim.sizeNumber;sampleRequest.sewing.trimData[index].size=trim.size;}else{sampleRequest.sewing.trimData[index].trimNumber=null;}_this11.setState({sampleRequest:sampleRequest});};this.updateCalcSewing=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var _state$prefillInfo$SA=_this11.state.prefillInfo.SAMPLEREQUEST.SHIRRINGORSMOCKING,smockingorElastic=_state$prefillInfo$SA.smockingorElastic,toptthElastic=_state$prefillInfo$SA.toptthElastic;sampleRequest.sewing.trimData=sampleRequest.sewing.trimData.map(function(data,index){if(data.type=="Both Elastic"){data.multiple=Number(smockingorElastic.multiple);data.wastage=Number(smockingorElastic.wastage);}if(data.type=="Top TTH / Bottom Elastic"){data.multiple=Number(toptthElastic.multiple);data.wastage=Number(toptthElastic.wastage);}if(data.multiple!==null&&data.noOfRow!==null&&data.length!==null){var calc=Number(parseFloat(data.noOfRow))*Number(parseFloat(data.length))*Number(parseFloat(data.multiple));// /100
data.totalReq=Number((calc+calc*(data.wastage/100)).toFixed(2));}return data;});_this11.setState({sampleRequest:sampleRequest});};this.addSewing=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.sewingData.push({tailorName:null,sewingType:null,size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]});_this11.setState({sampleRequest:sampleRequest});};this.removeSewing=function(index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);// sampleRequest.sewing.sewingData = sampleRequest.sewing.sewingData.filter((d,i) => i != index)
sampleRequest.sewing.sewingData.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.updateSewingLog=function(name,value,i,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.sewing.sewingData[index].logs[i][name]=new Date();}else{sampleRequest.sewing.sewingData[index].logs[i][name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.updateSewingCheck=function(name,i,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs[i][name]=new Date();_this11.setState({sampleRequest:sampleRequest});};this.addSewingLog=function(index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this11.setState({sampleRequest:sampleRequest});};this.removeSewingLog=function(i,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs.splice(i,1);_this11.setState({sampleRequest:sampleRequest});};this.createSewing=function(e){e.preventDefault();var data={};var sewing=Object.assign({},_this11.state.sampleRequest.sewing);if(!sewing.smokingOrShiring){sewing.trimData=[];}data.sewing=sewing;data.sewingProcess=_this11.state.sampleRequest.processUpdates.sewing;data._id=_this11.state._id;var cutting=_this11.state.sampleRequest.toggle.cutting;var status=_this11.state.sampleRequest.processUpdates.cutting.status;if(_this11.state.sampleRequest.processUpdates.sewing.status==="COMPLETED"&&cutting&&status!=="COMPLETED"){return _this11.props.getalertMessage("error","Cutting process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSewing(data).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var sewingData=sampleRequest.sewing.sewingData;var trimData=sampleRequest.sewing.trimData;sampleRequest.sewing=response.text.data;sampleRequest.sewing.sewingData=sewingData;sampleRequest.sewing.trimData=trimData;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeSewing=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.sewing.comments};var cutting=sampleRequest.toggle.cutting;var status=sampleRequest.processUpdates.cutting.status;if(cutting&&status!=="COMPLETED"){return _this11.props.getalertMessage("error","Cutting process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeSewing(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.sewing=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateGarment=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.garmentTechnologist[name]=value;_this11.setState([sampleRequest]);};this.updateGarmentForm=function(name,arrKey,value,i){// console.log("gdshgdhsdg",name, arrKey, value, i);
var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.garmentTechnologist.sampleForm[arrKey][i][name]=value;_this11.setState({sampleRequest:sampleRequest});};this.addGarmentForm=function(arrKey){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.garmentTechnologist.sampleForm[arrKey].push({comments:"",fab:false,trims:false,workManShip:false,buyerChanges:false,pat:false,remarks:""});_this11.setState({sampleRequest:sampleRequest});};this.removeGarmentForm=function(arrKey,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.garmentTechnologist.sampleForm[arrKey]=sampleRequest.garmentTechnologist.sampleForm[arrKey].filter(function(d,ind){return ind!=i;});_this11.setState({sampleRequest:sampleRequest});};this.createGarment=function(e){e.preventDefault();var info={};info.garmentTechnologist=_this11.state.sampleRequest.garmentTechnologist;info.garmentProcess=_this11.state.sampleRequest.processUpdates.garmentTechnologist;info._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createGarment(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.garmentTechnologist=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.getCustomerDepartmentName=function(value){_this11.setState({customerDepartment:value});//console.log(this.state.customerDepartment,"cuDe")
};this.printGarment=function(val){var printGarmentTech={};printGarmentTech=Object.assign({},_this11.state.sampleRequest.garmentTechnologist);printGarmentTech.HEADERS=Object.assign({},_this11.state.sampleRequest.processUpdates.garmentTechnologist);printGarmentTech.customerDepartment=Object.assign({},_this11.state.customerDepartment);printGarmentTech.styleNo=_this11.state.styleNoInfo&&_this11.state.styleNoInfo.length>0&&_this11.state.styleNoInfo.find(function(style){return style.value===_this11.state.sampleRequest.styleReferenceId;});printGarmentTech.styleName=_this11.state.sampleRequest.magnumStyleName;printGarmentTech.sampleRequestDate=__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this11.state.sampleRequest.createdAt).format("Do MMM YYYY");printGarmentTech.sampleType=_this11.state.prefillInfo.SAMPLEREQUEST&&_this11.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE&&_this11.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE.length>0&&_this11.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE.find(function(sample){return sample.value===_this11.state.sampleRequest.sampleType;});printGarmentTech.sampleDated=_this11.state.sampleRequest.garmentTechnologist.sampleDate!==null?__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this11.state.sampleRequest.garmentTechnologist.sampleDate).format("Do MMM YYYY"):"";printGarmentTech.gmtTech=_this11.state.sampleRequest.garmentTechnology!==null?_this11.state.sampleRequest.garmentTechnology:"GARMENT TECH NOT ASSIGNED";// printGarmentTech.patternMaster = this.state.assignedToList.find(x=>)
_this11.setState({printGarmentLoading:true,printGarmentTech:printGarmentTech},function(){var divToPrint=document.getElementById(val);var newWin=window.open("","mywindow");newWin.document.write(divToPrint.outerHTML);newWin.focus();newWin.print();newWin.close();});};this.printFabric=function(){var divToPrint=document.getElementById("fabricForm");__WEBPACK_IMPORTED_MODULE_7_html2canvas___default()(divToPrint).then(function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(canvas){var imgData,newWin,img;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:imgData=canvas.toDataURL("image/jpg");newWin=window.open("","mywindow");img=newWin.document.createElement("img");img.src=imgData;_context14.next=6;return newWin.document.body.appendChild(img);case 6:_context14.next=8;return newWin.focus();case 8:_context14.next=10;return newWin.print();case 10:_context14.next=12;return newWin.close();case 12:case"end":return _context14.stop();}}},_callee14,_this11);}));return function(_x14){return _ref15.apply(this,arguments);};}());};this.onLoadFinish=function(){_this11.setState({isLoading:false});};this.completeGarment=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.garmentTechnologist.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeGarment(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.garmentTechnologist=Object.assign({},response.text.data);_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateEmbellishment=function(name,value,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embellishment[index][name]=value;_this11.setState({sampleRequest:sampleRequest});};this.addEmb=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embellishment.push({embType:null,hoursMinutes:null,pricePerHalfHour:null});_this11.setState({sampleRequest:sampleRequest});};this.removeEmb=function(index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embellishment.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.createEmbellishment=function(e){var info={};info.embellishment=_this11.state.sampleRequest.embellishment;info.embellishmentProcess=_this11.state.sampleRequest.processUpdates.embellishment;info.embellishmentComments=_this11.state.sampleRequest.embellishmentComments;info._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createEmbelishment(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embellishment=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeEmbellishment=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.embellishment.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeEmbelishment(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.embellishment=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateEmbroidery=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.moveToRight=function(){var x=document.getElementById("mySelect").selectedIndex;// var y = document.getElementById("mySelect").options;
// // alert("Index: " + y[x].index + " is " + y[x].text);
// var z = document.getElementById("mySelect2");
// var option = document.createElement("option");
// option.text = document.getElementById("mySelect").value;
// z.add(option);
var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.rightData.push(document.getElementById("mySelect").value);sampleRequest.embroidery.leftData.splice(document.getElementById("mySelect").selectedIndex,1);_this11.setState({sampleRequest:sampleRequest});// document.getElementById("mySelect").remove(y[x].index);
};this.moveToLeft=function(){var x=document.getElementById("mySelect2").selectedIndex;// var y = document.getElementById("mySelect2").options;
// // alert("Index: " + y[x].index + " is " + y[x].text);
// var z = document.getElementById("mySelect");
// var option = document.createElement("option");
// option.text = document.getElementById("mySelect2").value;
// z.add(option);
var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.leftData.push(document.getElementById("mySelect2").value);sampleRequest.embroidery.rightData.splice(document.getElementById("mySelect2").selectedIndex,1);_this11.setState({sampleRequest:sampleRequest});// document.getElementById("mySelect2").remove(y[x].index);
};this.moveToUp=function(){var x=document.getElementById("mySelect2").selectedIndex;var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.rightData=_this11.swapIndices(sampleRequest.embroidery.rightData,x,x-1);_this11.setState({sampleRequest:sampleRequest});};this.moveToBottom=function(){var x=document.getElementById("mySelect2").selectedIndex;var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.rightData=_this11.swapIndices(sampleRequest.embroidery.rightData,x,x+1);_this11.setState({sampleRequest:sampleRequest});};this.swapIndices=function(array,index1,index2){var newArray=array.slice();newArray[index1]=array[index2];newArray[index2]=array[index1];return newArray;};this.changeBackingArray=function(action,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);action==="add"?sampleRequest.embroidery.backingData.push({backingType:null,width:null,placement:null}):sampleRequest.embroidery.backingData.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.addEmbroideryData=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.embroideryData.push({embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""});_this11.setState({sampleRequest:sampleRequest});};this.removeEmbroideryData=function(i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.embroideryData=sampleRequest.embroidery.embroideryData.filter(function(d,ind){return ind!=i;});_this11.setState({sampleRequest:sampleRequest});};this.saveEmbroidery=function(e){e.preventDefault();var info={};info.embroidery=_this11.state.sampleRequest.embroidery;info.embroideryProcess=_this11.state.sampleRequest.processUpdates.embroidery;info._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createEmbroidery(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeEmbroidery=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.embroidery.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeEmbroidery(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.embroidery=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateEmbroideryBackingData=function(name,value,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.backingData[i][name]=value;_this11.setState({sampleRequest:sampleRequest});if(name=="backingType"){_this11.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE.map(function(data,index){if(data.value==value){var widthList=[];data.typeMultiple.map(function(dat1){widthList.push({label:dat1.width,value:dat1.width});});_this11.setState({widthList:widthList});}});}};this.updateEmbroideryData=function(name,value,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.embroidery.embroideryData[i][name]=value;if(name==="consumption"||name==="stitchesMtr"){var consumption=sampleRequest.embroidery.embroideryData[i].consumption?sampleRequest.embroidery.embroideryData[i].consumption:0;var stitches=sampleRequest.embroidery.embroideryData[i].stitchesMtr?sampleRequest.embroidery.embroideryData[i].stitchesMtr:0;var stitchCount=consumption*stitches;sampleRequest.embroidery.embroideryData[i].stitchCount=Number(stitchCount).toFixed(2);}if(name==="embForm"){sampleRequest.embroidery.embroideryData[i][name]=value;sampleRequest.embroidery.embroideryData[i].priceForStitches=_this11.state.prefillInfo.SAMPLEREQUEST.EMBFORM.find(function(x){return x.label===value;}).price;}else{sampleRequest.embroidery.embroideryData[i][name]=value;}_this11.setState({sampleRequest:sampleRequest});};this.changeWashData=function(action,index){var sampleRequest=Object.assign({},_this11.state.sampleRequest);action==="add"?sampleRequest.wash.washData.push({washType:null,washFrom:"5ce7c64ddbc5c3151d061e5f",laundryUnit:null,price:null// price: this.state.prefillInfo.WASH.PRICEPERKG[0].label
}):sampleRequest.wash.washData.splice(index,1);_this11.setState({sampleRequest:sampleRequest});};this.updateWash=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.wash[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.updateWash1=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(name==="washType"){var washData=_this11.state.prefillInfo.WASH.WASHTYPE.find(function(x){return x.value===value;});sampleRequest.wash.washData.price=washData&&washData.price||'';}sampleRequest.wash.washData[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.createWash=function(e){e.preventDefault();var info={};info.wash=_this11.state.sampleRequest.wash;info.washProcess=_this11.state.sampleRequest.processUpdates.wash;info._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createWash(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.wash=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeWash=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.wash.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeWash(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.wash=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateQc=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.qc[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.createQC=function(e){e.preventDefault();var info={};info.qc=_this11.state.sampleRequest.qc;info.qcProcess=_this11.state.sampleRequest.processUpdates.qc;info._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createQC(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.qc=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeQC=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.qc.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeQC(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.qc=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateDispatch=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.dispatch[name]=value;_this11.setState({sampleRequest:sampleRequest});};this.udpateDispatchValues=function(name,value,i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.dispatch.data[i][name]=value;_this11.setState({sampleRequest:sampleRequest});};this.addDispatchData=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.dispatch.data.push({location:null,date:__WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(1,"day").format(),courier:null,awbNumber:"",size:null,quantity:null});_this11.setState({sampleRequest:sampleRequest});};this.removeDispatchData=function(i){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.dispatch.data=sampleRequest.dispatch.data.filter(function(d,ind){return ind!=i;});_this11.setState({sampleRequest:sampleRequest});};this.createDispatch=function(e){e.preventDefault();var objData={};objData.dispatch=_this11.state.sampleRequest.dispatch;objData.dispatchProcess=_this11.state.sampleRequest.processUpdates.dispatch;objData._id=_this11.state._id;var _state$sampleRequest$3=_this11.state.sampleRequest.toggle,sewing=_state$sampleRequest$3.sewing,wash=_state$sampleRequest$3.wash;var status=_this11.state.sampleRequest.processUpdates.sewing.status;var washStatus=_this11.state.sampleRequest.processUpdates.wash.status;if(_this11.state.sampleRequest.processUpdates.dispatch.status==="COMPLETED")if(sewing&&status!=="COMPLETED"){return _this11.props.getalertMessage("error","Sewing process need to complete!",5000);}else if(wash&&(washStatus==="PENDING"||washStatus==="IN PROCESS")){return _this11.props.getalertMessage("error","Washing process need to complete or cancel!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createDispatch(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.wash=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeDispatch=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.dispatch.comments};var _sampleRequest$toggle=sampleRequest.toggle,sewing=_sampleRequest$toggle.sewing,wash=_sampleRequest$toggle.wash;var status=sampleRequest.processUpdates.sewing.status;var washStatus=sampleRequest.processUpdates.wash.status;if(sewing&&status!=="COMPLETED"){return _this11.props.getalertMessage("error","Sewing process need to complete!",5000);}else if(wash&&(washStatus==="PENDING"||washStatus==="IN PROCESS")){return _this11.props.getalertMessage("error","Washing process need to complete or cancel!",5000);}__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeDispatch(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.dispatch=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateMarker=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.marker[name]=value;_this11.setState([sampleRequest]);};this.createMarker=function(e){e.preventDefault();var objData={};objData.marker=_this11.state.sampleRequest.marker;objData.markerProcess=_this11.state.sampleRequest.processUpdates.marker;objData._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createMarker(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.marker=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeMarker=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.marker.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeMarker(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.marker=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.createCosting=function(e){e.preventDefault();var objData={};objData.costingComments=_this11.state.sampleRequest.costingComments;objData.costingProcess=_this11.state.sampleRequest.processUpdates.costing;objData._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createCosting(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.costing=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeCosting=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.costing.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeCosting(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.costing=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.viewCostingPage=function(){if(!_this11.state._id){_this11.props.getalertMessage("info","Please Create Request First");}else{_this11.props.history.push("/list",{moduleName:"COSTING",type:"list",sampleRequestId:_this11.state._id});}};this.createCostingPage=function(){if(!_this11.state._id){_this11.props.getalertMessage("info","Please Create Request First");}else{_this11.props.history.push("/CostingPage",{action:"add",_id:"",sampleRequestId:_this11.state._id});}};this.createSignOff=function(e){e.preventDefault();var objData={};objData.signOffComments=_this11.state.sampleRequest.signOffComments;objData.signOffProcess=_this11.state.sampleRequest.processUpdates.signOff;objData._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSignOff(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.signOffComments=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.completeSignoff=function(e){var sampleRequest=Object.assign({},_this11.state.sampleRequest);var request={_id:_this11.state._id,comments:sampleRequest.processUpdates.signOff.comments};__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].completeSignOff(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.signOff=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.updateKeyNameValues=function(name,value,index,keyName){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest[keyName][index][name]=value;_this11.setState({sampleRequest:sampleRequest});};this.updateProcessUpdate=function(name,value,keyname){var sampleRequest=Object.assign({},_this11.state.sampleRequest),userDetails=Object.assign({},_this11.props.userDetails);if(value==="COMPLETED"){switch(keyname){case"sample":_this11.completeSampleModule();break;case"cad":_this11.completeCAD();break;case"fabric":_this11.completeFabric();break;case"trim":_this11.completeTrim();break;case"pattern":_this11.completePattern();break;case"cutting":_this11.completeCutting();break;case"sewing":_this11.completeSewing();break;case"garmentTechnologist":_this11.completeGarment();break;case"embellishment":_this11.completeEmbellishment();break;case"embroidery":_this11.completeEmbroidery();break;case"wash":_this11.completeWash();break;case"dispatch":_this11.completeDispatch();break;case"qc":_this11.completeQC();break;case"marker":_this11.completeMarker();break;case"costing":_this11.completeCosting();break;case"signOff":_this11.completeSignoff();break;}}else{if(name=="assignedTo"){if(value!==null){sampleRequest.processUpdates[keyname][name]=value.value;}else{sampleRequest.processUpdates[keyname][name]=null;}}else{sampleRequest.processUpdates[keyname][name]=value;}sampleRequest.processUpdates[keyname].updatedBy=userDetails._id;_this11.setState({sampleRequest:sampleRequest});}};this.ProcessUpdates=function(e){e.preventDefault();var objData={};objData.processUpdates=_this11.state.sampleRequest.processUpdates;objData._id=_this11.state._id;__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].ProcessUpdates(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.processUpdates=response.text.data;_this11.setState({sampleRequest:sampleRequest});_this11.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this11.props.unauthorisedFunc();}else{_this11.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this11.props.getalertMessage("error",error.toString());});};this.saveSampleRequest=function(){var sampleRequest=Object.assign({},_this11.state.sampleRequest);__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].createSampleRequest(sampleRequest).then(function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:if(response.status==200){}case 1:case"end":return _context15.stop();}}},_callee15,_this11);}));return function(_x15){return _ref16.apply(this,arguments);};}()).catch(function(error){});};this.scrollToModule=function(moduleName){if(_this11.state.sampleRequest.toggle[moduleName]){var moduleEle=document.getElementById(moduleName);moduleEle.scrollIntoView({behavior:"smooth",block:"center"});}// moduleEle.scrollIntoView(false)
// moduleEle.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
};this.handleselectedType=function(type){// let sampleRequest = JSON.parse(this.state.emptyData)
var sampleRequest=Object.assign({},_this11.state.sampleRequest);// let sampleRequest = { ...this.state.emptyData };
sampleRequest.selectedType=type;if(type==="costingRequest"){sampleRequest.toggle={sample:false,garmentTechnologist:false,cad:false,fabric:true,trim:true,pattern:true,cutting:false,sewing:false,embellishment:false,embroidery:false,wash:false,dispatch:false,qc:true,marker:true,costing:true,signOff:true};}else{sampleRequest.toggle={sample:true,garmentTechnologist:true,cad:false,fabric:true,trim:true,pattern:true,cutting:true,sewing:true,embellishment:false,embroidery:false,wash:false,dispatch:true,qc:true,marker:true,costing:true,signOff:true};}_this11.setState({// sampleRequest:
sampleRequest:sampleRequest,selected:type});};this.getRefImages=function(refImages,moduleName){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest[moduleName].refImages=refImages;_this11.setState({sampleRequest:sampleRequest});};this.updateModulesMain=function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(name,value,moduleName){var sampleRequest,_ref18,isErr,message;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:sampleRequest=Object.assign({},_this11.state.sampleRequest);if(!(name==="status"&&value==="COMPLETED"&&['pattern','cutting','sewing','dispatch'].includes(moduleName))){_context16.next=9;break;}_context16.next=4;return _this11.shouldTodo(name,value,moduleName,sampleRequest);case 4:_ref18=_context16.sent;isErr=_ref18.isErr;message=_ref18.message;if(!isErr){_context16.next=9;break;}return _context16.abrupt("return",_this11.props.getalertMessage('error',message,5000));case 9:if(name=="assignedTo"){sampleRequest.processUpdates[moduleName][name]=value!==null?value.value:null;}else if(name=="status"){sampleRequest.processUpdates[moduleName][name]=value;if(value==="COMPLETED"){sampleRequest.processUpdates[moduleName].processDate=new Date();}}else{sampleRequest.processUpdates[moduleName][name]=value;}_this11.setState({sampleRequest:sampleRequest});case 11:case"end":return _context16.stop();}}},_callee16,_this11);}));return function(_x16,_x17,_x18){return _ref17.apply(this,arguments);};}();this.shouldTodo=function(name,value,moduleName,sampleRequest){return new Promise(function(resolve,reject){try{switch(moduleName){case'pattern':{var sample=sampleRequest.toggle.sample;var status=sampleRequest.processUpdates.sample.status;if(sample&&status!=="COMPLETED"){return resolve({isErr:true,message:"Sample process need to complete!"});}return resolve({isErr:false});}case'cutting':{var _state$sampleRequest$4=_this11.state.sampleRequest.toggle,pattern=_state$sampleRequest$4.pattern,fabric=_state$sampleRequest$4.fabric;var patternStatus=_this11.state.sampleRequest.processUpdates.pattern.status;var fabricStatus=_this11.state.sampleRequest.processUpdates.fabric.status;if(pattern&&patternStatus!=="COMPLETED"||fabric&&fabricStatus!=="COMPLETED"){return resolve({isErr:true,message:"Pattern and Fabric should complete!"});}return resolve({isErr:false});}case'sewing':{var cutting=sampleRequest.toggle.cutting;var _status=sampleRequest.processUpdates.cutting.status;if(cutting&&_status!=="COMPLETED"){return resolve({isErr:true,message:"Cutting process need to complete!"});}return resolve({isErr:false});}case'dispatch':{var _sampleRequest$toggle2=sampleRequest.toggle,sewing=_sampleRequest$toggle2.sewing,wash=_sampleRequest$toggle2.wash;var _status2=sampleRequest.processUpdates.sewing.status;var washStatus=sampleRequest.processUpdates.wash.status;if(sewing&&_status2!=="COMPLETED"){return resolve({isErr:true,message:"Sewing process need to complete!"});}else if(wash&&(washStatus==="PENDING"||washStatus==="IN PROCESS")){return resolve({isErr:true,message:"Washing process need to complete or cancel!"});}return resolve({isErr:false});}}}catch(error){reject({isErr:true,message:"something went wrong"});}});};this.toggleChange=function(name,value){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.toggle[name]=value;_this11.setState([sampleRequest]);};this.printData=function(){_this11.sampleRequestMain();_this11.sampleFabricPrint();_this11.samplePrintTrim();// this.samplePrintWash()
};this.samplePrintWash=function(){var sampleMain=Object.assign({},_this11.state.sampleMain);var washType=_this11.state.sampleRequest.wash&&_this11.state.sampleRequest.wash.washData&&_this11.state.sampleRequest.wash.washData.washType&&_this11.state.prefillInfo.WASH.WASHTYPE.find(function(x){return x.value===_this11.state.sampleRequest.wash.washData.washType;}).label;sampleMain.washType=washType||"";_this11.setState({sampleMain:sampleMain});};this.sampleRequestMain=function(){var sampleMain={};var sampleRequest=Object.assign({},_this11.state.sampleRequest);setTimeout(function(){if(!!sampleRequest.originationOfRequest){sampleMain.originationOfRequest=document.getElementsByName("originationOfRequest")[0]&&document.getElementsByName("originationOfRequest")[0].selectedOptions[0].innerHTML||undefined;sampleMain.originationOfRequest=sampleMain.originationOfRequest!=='--select--'&&sampleMain.originationOfRequest||"";}sampleMain.styleRefNo=_this11.state.styleNoInfo[0].label;sampleMain.createdAt=_this11.state.createdAt||new Date();sampleMain.qr=sampleRequest.qr;sampleMain.buyerName=sampleRequest.magnumBuyerStyleName;sampleMain.assistantBuyer=sampleRequest.assistantBuyer;sampleMain.fabricTechnologist=sampleRequest.fabricTechnologist;sampleMain.garmentTechnology=sampleRequest.garmentTechnology;sampleMain.magnumTechnologist=sampleRequest.magnumTechnologist;sampleMain.requestNumber=sampleRequest.requestNumber;sampleMain.magnumStyleName=sampleRequest.magnumStyleName;sampleMain.customerRefNumber=sampleRequest.customerRefNumber;sampleMain.itemNumber=sampleRequest.itemNumber;sampleMain.blockRefNo=sampleRequest.blockRefNo;sampleMain.oldMagStyleNo=sampleRequest.oldMagStyleNo;sampleMain.refColNo=sampleRequest.refColNo;sampleMain.bNumber=sampleRequest.fabric.map(function(item){return item.bNumber;});sampleMain.fabricName=sampleRequest.fabric.map(function(item){return item.fabricName;});var washType=document.getElementsByName("washType")[0]&&document.getElementsByName("washType")[0].selectedOptions[0].innerHTML||undefined;sampleMain.washType=washType!=='--select--'&&washType||"";if(!!sampleRequest.typeOfRequest){sampleMain.typeOfRequest=document.getElementsByName("typeOfRequest")[0].selectedOptions[0].innerHTML;sampleMain.typeOfRequest=sampleMain.typeOfRequest!=='--select--'&&sampleMain.typeOfRequest||"";}if(!!sampleRequest.sampleType){sampleMain.sampleType=document.getElementsByName("sampleType")[0].selectedOptions[0].innerHTML;}if(!!sampleRequest.customer&&!!sampleRequest.customerDepartmentId){sampleMain.customer=document.getElementsByName("customer")[0].selectedOptions[0].innerHTML;// sampleMain.departmentName = this.state.customerList.find(
//   (data, index) =>
//     data.departmentId === sampleRequest.customerDepartmentId
// ).departmentName;
}_this11.setState({sampleMain:sampleMain});_this11.sampleFabricPrint();},500);};this.sampleFabricPrint=function(){var sampleFabric={};var sampleArray=[];var fabricArray=[];setTimeout(function(){if(_this11.state.sampleRequest&&_this11.state.sampleRequest.sample&&_this11.state.sampleRequest.sample.data.length>0){_this11.state.sampleRequest.sample.data.map(function(data,index){var sample={};sample.size=data.size;sample.quantity=data.quantity;sampleArray.push(sample);});sampleFabric.sampleComments=_this11.state.sampleRequest.sample.comments;}if(_this11.state.sampleRequest&&_this11.state.sampleRequest.fabric&&_this11.state.sampleRequest.fabric.length>0){_this11.state.sampleRequest.fabric.map(function(fabricData,index){var fabric={};if(!!fabricData.fabricNumber){fabric.fabricNumber=fabricData.fabricList[0].label;}if(!!fabricData.fabricPosition){fabric.fabricPosition=_this11.state.prefillInfo.SAMPLEREQUEST.POSITION&&_this11.state.prefillInfo.SAMPLEREQUEST.POSITION.length&&_this11.state.prefillInfo.SAMPLEREQUEST.POSITION.find(function(data,index){return data.value===fabricData.fabricPosition;}).label;}if(!!fabricData.fabricOrigination){fabric.fabricOrigination=_this11.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION&&_this11.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION.length&&_this11.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION.find(function(data,index){return data.value===fabricData.fabricOrigination;}).label;}fabric.classificationOfFabric=fabricData.classificationOfFabric;fabric.quality=fabricData.quality;fabric.countAndConstruction=fabricData.countAndConstruction;fabric.check=fabricData.quality;fabricArray.push(fabric);});}sampleFabric.fabricArray=[].concat(fabricArray);sampleFabric.sampleArray=[].concat(sampleArray);setTimeout(function(){return _this11.setState({sampleMain:Object.assign({},_this11.state.sampleMain,{sampleFabric:sampleFabric})});},500);},500);};this.samplePrintTrim=function(){var sampleTrim={trimArray:[]};setTimeout(function(){if(_this11.state.sampleRequest.trim&&_this11.state.sampleRequest.trim.row1&&_this11.state.sampleRequest.trim.row1.length>0){_this11.state.sampleRequest.trim.row1.map(function(trims,index){var trimObject={};if(_this11.state.prefillInfo&&_this11.state.prefillInfo.TRIM&&_this11.state.prefillInfo.TRIM.TRIMCATEGORY){trimObject.trimCategory=_this11.state.prefillInfo.TRIM.TRIMCATEGORY.map(function(data,index){if(data.value===trims.trimCategory){return data.label;}}).filter(Boolean)[0];}if(trims.trimNumber&&trims.trimList){trimObject.trimNumber=trims.trimList.map(function(data,index){if(data.value===trims.trimNumber){return data.label;}}).filter(Boolean)[0];}trimObject.description=trims.description;trimObject.quality=trims.quality;trimObject.sizeNumber=trims.sizeNumber;trimObject.size=trims.size;sampleTrim.trimArray.push(trimObject);});}setTimeout(function(){return _this11.setState({sampleMain:Object.assign({},_this11.state.sampleMain,{sampleTrim:sampleTrim})});},500);},500);};this.openPrint=function(val){var sampleMain=JSON.parse(JSON.stringify(_this11.state.sampleMain));_this11.setState({sampleMain:sampleMain,printLoading:true},function(){// Get the div to print by its ID
var divToPrint=document.getElementById(val);var newWin=window.open('','mywindow');if(newWin){newWin.document.write("\n            <html>\n              <head>\n                <title>Print Preview</title>\n              </head>\n              <body>\n                "+divToPrint.outerHTML+"\n              </body>\n            </html>\n          ");newWin.document.close();// Finish writing to the new window
// Now wait until the new window finishes loading
newWin.onload=function(){newWin.focus();// Focus the window (sometimes needed)
newWin.print();// Now safely print
newWin.close();// Optionally close after print
};}else{console.error('Failed to open the print window');}});};this.confirmDuplicate=function(){Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref19){var onClose=_ref19.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:" p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Do you want to create a duplicate Sample Request sheet?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"If yes, Kindly don't forget to change/choose the new Source of Request and the Sample Type."," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"(marked with"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"text-danger madatory-asterisk"},"*"),")")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:onClose},"No")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",style:{width:"20%"},onClick:function onClick(){_this11.createDuplicate();onClose();}},"Yes"));},closeOnClickOutside:true});};this.createDuplicate=function(){if(_this11.state._id!==""){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getSampleQr().then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.qr=response.text.data.qr;sampleRequest.requestNumber=response.text.data.requestNumber;sampleRequest.typeOfRequest="";sampleRequest.sampleType=null;sampleRequest.orderDate=new Date();sampleRequest.createdAt=sampleRequest.updatedAt=undefined;_this11.setState({sampleRequest:Object.assign({},sampleRequest,_this11.state.duplicateData),action:"add",_id:""// isLoading: false
});_this11.props.getalertMessage("success","Duplicate Success! Please select Source of Request and Sample Type",5000);}response.status===401&&_this11.props.unauthorisedFunc();}).catch(function(err){_this11.props.getalertMessage("error");});}else{_this11.props.getalertMessage("error","Need to Create");}};this.getTrimRefNo=function(trimCategory,value,index){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(trimCategory,value).then(function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.trim.row1[index].trimList=response.text.data;_this11.setState({// trimNumberList: response.text.data
sampleRequest:sampleRequest});case 3:case"end":return _context17.stop();}}},_callee17,_this11);}));return function(_x19){return _ref20.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});};this.getTrimRefNoSewing=function(trimCategory,value,index){__WEBPACK_IMPORTED_MODULE_11__services__["j" /* SampleServices */].getTrimNumber(trimCategory,value).then(function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:sampleRequest=Object.assign({},_this11.state.sampleRequest);sampleRequest.sewing.trimData[index].trimList=response.text.data;_this11.setState({// trimNumberList: response.text.data
sampleRequest:sampleRequest});case 3:case"end":return _context18.stop();}}},_callee18,_this11);}));return function(_x20){return _ref21.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});};this.getFabricNumber=function(value,index){// alert(1)
__WEBPACK_IMPORTED_MODULE_11__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){// this.setState({ fabricList: response.text.data })
var sampleRequest=Object.assign({},_this11.state.sampleRequest);if(sampleRequest.fabric.length){sampleRequest.fabric[index].fabricList=response.text.data;_this11.setState({sampleRequest:sampleRequest});}}}).catch(function(error){});};this.setDuration=function(days,duration){var diffDays=days?__WEBPACK_IMPORTED_MODULE_10_moment___default()().diff(new Date(days),'days'):0;return diffDays?0:duration||0;};};var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights.sampleRequest,userDetails:state.main};};// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators({
//       "getRights": getRights
//   }, dispatch)
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,null)(Sample));// export default Sample;

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_QrCode__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintSample=function(_Component){_inherits(PrintSample,_Component);function PrintSample(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintSample);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintSample.__proto__||Object.getPrototypeOf(PrintSample)).call.apply(_ref,[this].concat(args))),_this),_this.state={sampleMain:null,toggle:null,bno:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintSample,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,toggle=_props.toggle,sampleMain=_props.sampleMain,bno=_props.bno;this.setState({toggle:toggle,sampleMain:sampleMain,bno:bno});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.sampleMain!=this.props.sampleMain){this.setState({sampleMain:nextProps.sampleMain});}if(nextProps.toggle!=this.props.toggle){this.setState({toggle:nextProps.toggle});}}},{key:"render",value:function render(){var _state=this.state,sampleMain=_state.sampleMain,toggle=_state.toggle,bno=_state.bno;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n                body{\n                    font-family: 'Montserrat', sans-serif;\n                    font-size:11px;\n                    box-sizing: border-box\n                }\n                .fabricPrintDiv{\n                    border : 2px solid black;\n                    top : 0;\n                    bottom : 0;\n                }\n\n                .printrow {\n\n                    width: 100%;\n                }\n\n                .printcolumn {\n                    display: flex;\n                    flex-direction: column;\n                    flex-basis: 100%;\n                    flex: 1;\n                }\n                table>tbody>tr td{\n                    font-size:8px;\n                    text-align:center;\n                }\n                .label-text{\n                    color:#279588;\n                    font-size : 11px;\n                    font-weight:bold;\n                    text-decoration: underline;\n                }\n                .blue{\n                    color : #146FF9;\n                }\n                .padding-for-heading{\n                    padding: 5px;\n                }\n\n                .specialComments{\n                    width: 75%;\n                    border : 1px solid black;\n                    height : 60px;\n                    margin: 10px;\n                }\n\n                .b{\n                    border: 1px solid black;\n                    margin: 10px;\n                    padding: 5px;\n                }\n                .fabric-text{\n                    font-size:16px;\n                    color: #279588;\n                    font-weight: 1000;\n                }\n\n                .bold{\n                    font-weight:bold;\n                    font-size: 9px;\n                }\n                .bb-p{\n                    border-bottom: 1px solid black;\n                    margin-bottom: 10px ;\n                }\n\n                .bb-pp{\n                    margin-bottom: 10px ;\n                }\n                .w-50 {\n                    width: 50%;\n                }\n                table.grid{\n                    border-collapse: collapse;\n                    margin-right: 5px;\n                    margin-left: 5px;\n                }\n                table.grid>tbody>tr td {\n                    border: 0.5px solid black;\n                    text-align: center;\n                    padding: 2px;\n                }\n\n                .textAlignLeftOnly {\n                    text-align: left;\n                    padding: auto 10px;\n                    margin: auto 10px\n                }\n\n                .textAlignRightOnly {\n                    text-align: right;\n                    padding: auto 10px;\n                    margin: auto 10px\n                }\n\n                .marginPadding {\n                    padding: 20px\n                    margin: 20px 10px 10px 10px\n                }\n                .width-for-table{\n                    width: 50%;\n                }\n                .text-center{\n                    text-align: center !important;\n                }\n                .p-1{\n                    padding : 5px;\n                }\n                .pl-1{\n                    padding-left: 23px;\n                }\n                .border-bot{\n                    border-bottom : 1px solid black;\n                }\n                .mt{\n                    margin-top:10px;\n                }\n                .mtl{\n                    margin-top:30px;\n                }\n                .margin{\n                    margin : 5px;\n                }\n                .pl-2{\n                    padding: 5px;\n                }\n                .table-heading{\n                    padding-left:5px;\n                    margin:0;\n                    color:#4285f4;\n                    text-transform:uppercase;\n\n                }\n\n                .text-capitalize{\n                    text-transform: capitalize;\n                }\n\n                .padding-option{\n                    padding:0px 20px 0px 60px;\n\n                }\n                .paddingLeft{\n                    left:100px !important;\n                }\n                table{\n                    width:100%;\n                }\n                .test-class{\n                    width:40%;\n\n                    display:inline-block\n                }\n                .test-class1{\n                    width:20%;\n                    display:inline-block\n                }\n                .test-class2{\n                    width:40%;\n                    display:inline-block\n                }\n                .float-left{\n                    float:left !important;\n                }\n\n                .padding-align-qc{\n                    padding-left: 42%!important;\n                }\n                .text-right{\n                    text-align:right !important;\n                }\n                .title-color{\n                    padding-left:5px;\n                    margin:0;\n                    color:#0033cc;\n                }\n                .total-title-color{\n                    color:#0066ff;\n                }\n                .float-right{\n                    float:right !important;\n                }\n                .col-md-6{\n                    width:50% !important;\n                }\n                .label-color{\n                    color:#279588;\n                    padding-left:5px;\n                    margin:0;\n                }\n               .total-value-calc{\n                   display:flex;\n                   flex-direction:row-reverse;\n                   padding:0 !important;\n               }\n               .col-md-9{\n                   width:75% !important;\n               }\n               .col-md-3{\n                   width: 25% !important;\n\n               }\n               .col-md-4{\n                   width:33.3% !important;\n               }\n               .height-value{\n                   height:160px !important;\n               }\n               .comments-height{\n                   height: 55px !important;\n               }\n               .text-area-border{\n\n                   border: 2px solid black !important;\n               }\n\n                table { page-break-inside:auto }\n                tr    { page-break-inside:avoid; page-break-after:auto }\n                thead { display:table-header-group }\n                tfoot { display:table-footer-group }\n\n                .last-row {\n                    page-break-after  : auto\n                }\n                }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bold text-center p-1 "},"MAGNUM CLOTHING PVT LTD - SAMPLE REQUEST SHEET"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",rowSpan:"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,sampleMain.requestNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_QrCode__["a" /* default */],{qr:sampleMain.qr}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bold",style:{fontSize:"0.7rem"}},"Dated ",sampleMain.createdAt?__WEBPACK_IMPORTED_MODULE_1_moment___default()(sampleMain.createdAt).format("HH:mm DD MMM YYYY"):""," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"style no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Cust ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"customer-dept"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Mag style name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"buyer style name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Item No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"source of request")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.styleRefNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.customerRefNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},""+sampleMain.customer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.magnumStyleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.buyerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.itemNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.typeOfRequest)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"old mag. ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"block ref no "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"origin of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"magnum tech"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"sample type")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"}," ",sampleMain.oldMagStyleNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.blockRefNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.originationOfRequest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.magnumTechnologist),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.sampleType)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"fabric no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Fabric Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"position"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Base No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"classification of fabric"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"count & construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Fabric Origination")),sampleMain.sampleFabric&&sampleMain.sampleFabric.fabricArray&&sampleMain.sampleFabric.fabricArray.length>0&&sampleMain.sampleFabric.fabricArray.map(function(fab,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.fabricNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.fabricName[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.fabricPosition),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.bNumber[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.classificationOfFabric),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.quality),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.countAndConstruction),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},fab.fabricOrigination));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"trim category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"trim no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"size")),sampleMain.sampleTrim&&sampleMain.sampleTrim.trimArray&&sampleMain.sampleTrim.trimArray.length>0&&sampleMain.sampleTrim.trimArray.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.trimNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.quality),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},trim.sizeNumber," - ",trim.size));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Wash"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"Ref Color")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.sampleFabric&&sampleMain.sampleFabric.sampleArray.length>0&&sampleMain.sampleFabric.sampleArray.map(function(sam,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold",style:{color:"#000 !important"}},sam.size));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.sampleFabric&&sampleMain.sampleFabric.sampleArray.length>0&&sampleMain.sampleFabric.sampleArray.map(function(sam,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold",style:{color:"#000 !important"}},sam.quantity));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold",style:{color:"#000 !important"}},sampleMain.washType||"No WASH"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"bold"},sampleMain.refColNo)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-pp"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:" marginPadding",colSpan:"12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"5px 10px 12px 10px",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{flexGrow:"4"},className:"label-text "},"Comments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{margin:"0 10px"},className:"label-text "},"date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{margin:"0 5px"},className:"label-text"},"sign")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{className:" marginPadding",colSpan:"12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:"flex",textAlign:"left",padding:"0px 10px 2px 10px",marginTop:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{flexGrow:"4",textAlign:"left",padding:"15px auto",marginTop:"0",marginBottom:"15px;"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"15px"},className:"bold "})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-pp last-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-capitalize"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GMT TECH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"PATTERN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"3D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"CUTTING"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"SEWING"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"EMBROIDERY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"EMBELLISHMENT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{padding:"20px",margin:"10px auto",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.garmentTechnologist?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.pattern?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},toggle.pattern?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.cutting?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.sewing?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.embroidery?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.embellishment?"":"N/A")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"DISPATCH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"GRADING"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text"},"MARKER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{padding:"20px",margin:"10px auto",borderBottom:"2px dotted #000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.dispatch?"":"N/A "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.qc?"":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{margin:"0 5px",paddingBottom:"30px"},className:"bold"},toggle.marker?"":"N/A ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null))))))));}}]);return PrintSample;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Old Layout, for Backup
// *SAMPLE'S INFO TABLE START
//                     {
//                         <div className="printrow bb-p">
//                             <p className="table-heading">sample details</p>
//                             <div className="test-class">
//                                 <div className="text-capitalize">
//                                     <table>
//                                         <tbody>
//                                             <tr>
//                                                 <td className="label-text">awaiting dev sample</td>
//                                                 <td className="label-text">awaiting design sheet</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="bold">test</td>
//                                                 <td className="bold">test</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                             <div className="test-class1">
//                                 <div className="text-capitalize">
//                                     <table>
//                                         <tbody>
//                                             <tr>
//                                                 <td className="label-text">size</td>
//                                                 <td className="label-text">Qty</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="bold">test</td>
//                                                 <td className="bold">test</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                             <div className="test-class2">
//                                 <div>
//                                     <p className="table-heading float-left">SMOCKING/SHIRRING :</p>
//                                     <p className="padding-option">YES/NO</p>
//                                     <p className="table-heading float-left">COMMENTS :</p>
//                                     <p className="padding-option">sample details</p>
//                                 </div>
//                             </div>
//                             <div className="text-capitalize">
//                                 <p className="table-heading">CAD</p>
//                                 <table>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">cad ref no</td>
//                                             <td className="label-text">cad type</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* SAMPLE'S INFO TABLE END */}
//                     {/* FABRIC'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">fabric</p>
//                                 <table>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">fabric ref no</td>
//                                             <td className="label-text">position</td>
//                                             <td className="label-text">classification of fabric</td>
//                                             <td className="label-text">quality</td>
//                                             <td className="label-text">count & construction</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* FABRIC'S INFO TABLE END */}
//                     {/* TRIM'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">trims</p>
//                                 <table style={{ width: '100%' }}>
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">trim category</td>
//                                             <td className="label-text">trim ref no</td>
//                                             <td className="label-text">description</td>
//                                             <td className="label-text">quality</td>
//                                             <td className="label-text">size</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* TRIM'S INFO TABLE END */}
//                     {/* PATTERN'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">pattern</p>
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">pattern master name</td>
//                                             <td className="label-text">pattern type</td>
//                                             <td className="label-text">Block ref used</td>
//                                             <td className="label-text">trial reqd</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* PATTERN'S INFO TABLE END */}
//                     {/* CUTTING'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">cutting</p>
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">cutting master name</td>
//                                             <td className="label-text">cutting type</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* CUTTING'S INFO TABLE END */}
//                     {/* SEWING'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">sewing</p>
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">place of sewing</td>
//                                             <td className="label-text">tailor name</td>
//                                             <td className="label-text">sewing type</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* SEWING'S INFO TABLE END */}
//                     {/* EMBROIDERY'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize ">
//                                 <p className="table-heading">embroidery&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;embelishment</p>
//                                 {/* <p className="table-heading paddingleft">embelishment</p> */}
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td colspan="1"></td>
//                                             <td className="label-text">type</td>
//                                             <td className="label-text">HH : MM</td>
//                                             <td className="label-text">price/30 Mins</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td></td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* EMBROIDERY'S INFO TABLE END */}
//                     {/* WASH'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize">
//                                 <p className="table-heading">wash</p>
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text ">wash type</td>
//                                             <td className="label-text ">wash form</td>
//                                             <td className="label-text ">laundary unit</td>
//                                             <td className="label-text ">no of mocks</td>
//                                             <td className="label-text ">tacking</td>
//                                             <td className="label-text ">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                             <td className="bold ">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     }
//                     {/* WASH'S INFO TABLE END */}
//                     {/* DISPATCH'S INFO TABLE START */}
//                     {
//                         <div className="printrow bb-p">
//                             <div className="text-capitalize ">
//                                 <p className="table-heading float-left">dispatch</p>
//                                 <p className="table-heading  padding-align-qc">QC</td>
//                                 <table className="w-100">
//                                     <tr>
//                                         <th></th>
//                                         <th></th>
//                                         <th></th>
//                                     </tr>
//                                     <tbody>
//                                         <tr>
//                                             <td className="label-text">magnum counter</td>
//                                             <td className="label-text">any issues?</td>
//                                             <td className="label-text">reason?</td>
//                                             <td className="label-text">completed date</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                             <td className="bold">test</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     } */
//                     {/* DISPATCH'S INFO TABLE END */}
/* harmony default export */ __webpack_exports__["a"] = (PrintSample);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CadModule__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CadModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CostingModule__ = __webpack_require__(725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CostingModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CuttingModule__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CuttingModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DispatchModule__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__DispatchModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmbellishmentModule__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__EmbellishmentModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmbroideryModule__ = __webpack_require__(729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__EmbroideryModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FabricModule__ = __webpack_require__(730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__FabricModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GarmentTechModule__ = __webpack_require__(731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__GarmentTechModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LeftSection__ = __webpack_require__(832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__LeftSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarkerModule__ = __webpack_require__(833);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__MarkerModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PatternModule__ = __webpack_require__(834);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__PatternModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProcessUpdate__ = __webpack_require__(835);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__ProcessUpdate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__QcModule__ = __webpack_require__(836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__QcModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SampleMain__ = __webpack_require__(837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__SampleMain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SampleModule__ = __webpack_require__(838);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__SampleModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SampleModuleSelect__ = __webpack_require__(839);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__SampleModuleSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ScrollMenu__ = __webpack_require__(840);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__ScrollMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SewingModule__ = __webpack_require__(841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__SewingModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SignOffModule__ = __webpack_require__(842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__SignOffModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TrimModule__ = __webpack_require__(843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__TrimModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__WashModule__ = __webpack_require__(844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__WashModule__["a"]; });


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_external_link_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CadModule=function(_Component){_inherits(CadModule,_Component);function CadModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CadModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CadModule.__proto__||Object.getPrototypeOf(CadModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",cad:null,CAD:{},STATUS:[],assignedToList:[],disabled:false},_this.getCADRefNumber=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["e" /* DevelopmentServices */].getCADRefNumber(value).then(function(response){if(response.status===200){_this.setState({CADRefNumInfo:response.text.data});}}).catch(function(error){});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CadModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,cad=_props.cad,_id=_props._id,CAD=_props.CAD,assignedToList=_props.assignedToList,STATUS=_props.STATUS,disabled=_props.disabled,cadProcess=_props.cadProcess,cadPreFill=_props.cadPreFill;this.setState({_id:_id,cad:cad,cadProcess:cadProcess,CAD:CAD,assignedToList:assignedToList,disabled:disabled,STATUS:STATUS,cadPreFill:cadPreFill});this.getCADRefNumber("");}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(Object.keys(this.state.CAD).length!=Object.keys(nextProps.CAD).length){this.setState({CAD:nextProps.CAD});}var cad=nextProps.cad,_id=nextProps._id,assignedToList=nextProps.assignedToList,STATUS=nextProps.STATUS,disabled=nextProps.disabled,cadProcess=nextProps.cadProcess,cadPreFill=nextProps.cadPreFill;this.setState({cad:cad,_id:_id,assignedToList:assignedToList,STATUS:STATUS,disabled:disabled,cadProcess:cadProcess,cadPreFill:cadPreFill});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,cad=_state.cad,CAD=_state.CAD,assignedToList=_state.assignedToList,STATUS=_state.STATUS;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"cad",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"3D",moduleName:"cad",process:this.state.cadProcess,updateModulesMain:this.props.updateModulesMain,onClick:this.onOpenModal,_id:this.state._id,statusList:STATUS,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"cadForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"3D Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"cadRefNo",value:cad.cadId,onInputChange:function onInputChange(e){return _this2.getCADRefNumber(e);},onChange:function onChange(value){return _this2.props.changeCADRefNum(value);},placeholder:"Find 3D RefNo",options:this.state.CADRefNumInfo,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"external-link cursor-hover pl-1",src:__WEBPACK_IMPORTED_MODULE_6__assets_images_external_link_png___default.a,onClick:function onClick(){return _this2.props.history.push("/developmentCad",{action:""+_this2.props.action,_id:cad.cadId});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"no"},"3D NAME"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"cadName",value:cad.cadName// index={index}
,onChange:this.props.cadUpdate,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"no"},"3D TYPE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,cad.cadType.map(function(data){return data.label;}).join(",\n ")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"no"},"PRINT/EMB TYPE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"printEmbType",value:cad.printEmbType,options:this.state.cadPreFill?this.state.cadPreFill.PRINTEMBTYPE:[]// index={index}
,onChange:this.props.cadUpdate,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"no"},"BORDER TYPE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"borderType",value:cad.borderType,options:this.state.cadPreFill?this.state.cadPreFill.BORDERTYPE:[]// index={index}
,onChange:this.props.cadUpdate,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one px-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:cad.comments,label:"comments",onChange:this.props.updateCadValues,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.saveCAD(e);},buttonName:"Save"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.completeCAD(e);},buttonName:"Complete"}))))))));}}]);return CadModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CadModule);

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CostingModule=function(_Component){_inherits(CostingModule,_Component);function CostingModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CostingModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CostingModule.__proto__||Object.getPrototypeOf(CostingModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",costing:[],STATUS:[],assignedToList:[],disabled:false,costingComments:""},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CostingModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,costingComments=_props.costingComments,costingProcess=_props.costingProcess,disabled=_props.disabled,STATUS=_props.STATUS;this.setState({_id:_id,costingComments:costingComments,costingProcess:costingProcess,disabled:disabled,STATUS:STATUS});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,costingComments=nextProps.costingComments,costingProcess=nextProps.costingProcess,disabled=nextProps.disabled,STATUS=nextProps.STATUS;this.setState({_id:_id,costingComments:costingComments,costingProcess:costingProcess,disabled:disabled,STATUS:STATUS});}},{key:"render",value:function render(){var _this2=this;var STATUS=this.state.STATUS;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"costing",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ModuleHeader__["a" /* default */],{header:"Costing",onClick:this.onOpenModal,_id:this.state._id,process:this.state.costingProcess,disabled:this.state.disabled,updateModulesMain:this.props.updateModulesMain,moduleName:"costing",statusList:STATUS})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"costingForm",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.viewCostingPage(e);},buttonName:"View Costing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.createCostingPage(e);},buttonName:"Create Costing"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"costingComments",value:this.props.costingComments,label:"comments",onChange:this.props.updateCosting,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.createCosting(e);},buttonName:"Save"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{onClick:function onClick(e){return _this2.props.completeCosting(e);},buttonName:"Complete"}))))));}}]);return CostingModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CostingModule);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimerModule__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CuttingModule=function(_Component){_inherits(CuttingModule,_Component);function CuttingModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CuttingModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CuttingModule.__proto__||Object.getPrototypeOf(CuttingModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",cutting:{},STATUS:[],CUTTINGTYPE:[],disabled:false,sample:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CuttingModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,cutting=_props.cutting,STATUS=_props.STATUS,CUTTINGTYPE=_props.CUTTINGTYPE,disabled=_props.disabled,assignedToList=_props.assignedToList,cuttingProcess=_props.cuttingProcess,sample=_props.sample;var data=sample.data;data=data.map(function(x){return x.size&&{label:x.size}||0;});this.setState({_id:_id,cutting:cutting,cuttingProcess:cuttingProcess,STATUS:STATUS,CUTTINGTYPE:CUTTINGTYPE,disabled:disabled,assignedToList:assignedToList,sample:data});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,cutting=nextProps.cutting,STATUS=nextProps.STATUS,CUTTINGTYPE=nextProps.CUTTINGTYPE,disabled=nextProps.disabled,assignedToList=nextProps.assignedToList,cuttingProcess=nextProps.cuttingProcess,sample=nextProps.sample;var data=sample.data;data=data.map(function(x){return x.size&&{label:x.size}||0;});this.setState({_id:_id,cutting:cutting,cuttingProcess:cuttingProcess,STATUS:STATUS,CUTTINGTYPE:CUTTINGTYPE,disabled:disabled,assignedToList:assignedToList,sample:data});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,cutting=_state.cutting,STATUS=_state.STATUS,CUTTING=_state.CUTTING;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"cutting",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModuleHeader__["a" /* default */],{header:"Cutting",onClick:this.onOpenModal,_id:this.state._id,moduleName:"cutting",process:this.state.cuttingProcess,updateModulesMain:this.props.updateModulesMain,disabled:this.state.disabled,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"cuttingForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"Cutting Master Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"cuttingMaster",value:cutting.cuttingMasterName//   onInputChange={e =>
//     this.getPatternMaster(e, "cuttingMaster")
//   }
,onChange:function onChange(e){return _this2.props.updateCutting("cuttingMasterName",e);},placeholder:"Cutting master Name",options:this.state.assignedToList,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"cuttingType",value:cutting.cuttingType,label:"Cutting type ",options:this.state.CUTTINGTYPE,onChange:this.props.updateCutting,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"size",value:cutting.size,label:"Size ",options:this.state.sample,onChange:this.props.updateCutting,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"approvalStatus",label:"Approval Status ",value:cutting.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}],onChange:this.props.updateCutting,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-center",style:{width:"7%",padding:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Logs"),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addCuttingLog();}}))),cutting.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TimerModule__["a" /* default */],{time:log.timeIn,buttonName:"time in",updatePatternCheck:function updatePatternCheck(){return _this2.props.updateCuttingCheck("timeIn",i);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TimerModule__["a" /* default */],{time:log.timeOut,buttonName:"time out",updatePatternCheck:function updatePatternCheck(){return _this2.props.updateCuttingCheck("timeOut",i);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"time",maxlength:23,inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this2.props.updateCuttingLog(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason,onChange:function onChange(name,value){return _this2.props.updateCuttingLog(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one pl-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeCuttingLog(i);}})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:cutting.comments,label:"comments",onChange:this.props.updateCutting,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 px-2 text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createCutting(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeCutting(e);}}))))));}}]);return CuttingModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CuttingModule);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dispatchTemplate={date:"",location:"",awb:"",courier:"",size:"",qty:""};var DispatchModule=function(_Component){_inherits(DispatchModule,_Component);function DispatchModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DispatchModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DispatchModule.__proto__||Object.getPrototypeOf(DispatchModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",dispatch:[],assignedToList:[],STATUS:[],disabled:false,durationDispatch:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DispatchModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,dispatch=_props.dispatch,dispatchProcess=_props.dispatchProcess,assignedToList=_props.assignedToList,STATUS=_props.STATUS,LOCATION=_props.LOCATION,COURIER=_props.COURIER,disabled=_props.disabled,SIZELIST=_props.SIZELIST,durationDispatch=_props.durationDispatch;this.setState({_id:_id,dispatch:dispatch,dispatchProcess:dispatchProcess,disabled:disabled,assignedToList:assignedToList,STATUS:STATUS,LOCATION:LOCATION,COURIER:COURIER,SIZELIST:SIZELIST,durationDispatch:durationDispatch});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,dispatch=nextProps.dispatch,dispatchProcess=nextProps.dispatchProcess,assignedToList=nextProps.assignedToList,STATUS=nextProps.STATUS,disabled=nextProps.disabled,LOCATION=nextProps.LOCATION,COURIER=nextProps.COURIER,SIZELIST=nextProps.SIZELIST,durationDispatch=nextProps.durationDispatch;this.setState({_id:_id,dispatch:dispatch,dispatchProcess:dispatchProcess,disabled:disabled,assignedToList:assignedToList,STATUS:STATUS,LOCATION:LOCATION,COURIER:COURIER,SIZELIST:SIZELIST,durationDispatch:durationDispatch});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,dispatch=_state.dispatch,assignedToList=_state.assignedToList,STATUS=_state.STATUS,disabled=_state.disabled;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"dispatch",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Dispatch ",durationETA:this.state.durationDispatch,updateModulesMain:this.props.updateModulesMain,moduleName:"dispatch",disabled:this.state.disabled,process:this.state.dispatchProcess,onClick:this.onOpenModal,_id:this.state._id,statusList:STATUS,measurementModal:true,customer:this.props.customer,customerDepartmentId:this.props.customerDepartmentId,type:this.props.type,magnumStyleId:this.props.magnumStyleId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"dispatchForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{marginBottom:" 15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"magnumCounter",value:dispatch.magnumCounter,label:"Magnum counter",onChange:this.props.udpateDispatch,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12  no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Location"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"AWB No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Courier"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},permissions.create&&permissions.edit&&!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addDispatchData();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,dispatch.data.length>0&&dispatch.data.map(function(val,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{durationETA:!val.date?-1:null,isFormGroup:false,inputType:"date",inputName:"date",label:"Date",value:val.date,onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"location",value:val.location,options:_this2.state.LOCATION,label:"Location",onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"awbNumber",value:val.awbNumber,label:"AWB No.",onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"courier",value:val.courier,options:_this2.state.COURIER,label:"Courier",onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"size",value:val.size,options:_this2.state.SIZELIST,label:"Size",onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"quantity",value:val.quantity,label:"Qty",onChange:function onChange(name,value){return _this2.props.udpateDispatchValues(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},permissions.create&&permissions.edit&&!_this2.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeDispatchData(i);}})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one px-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:dispatch.comments,label:"Comments",onChange:this.props.udpateDispatch,disabled:this.state.disabled}))))))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createDispatch(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeDispatch(e);}})))));}}]);return DispatchModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DispatchModule);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonIcon__ = __webpack_require__(250);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmbellishmentModule=function(_Component){_inherits(EmbellishmentModule,_Component);function EmbellishmentModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EmbellishmentModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EmbellishmentModule.__proto__||Object.getPrototypeOf(EmbellishmentModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",embellishment:[],assignedToList:[],STATUS:[],TYPE:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EmbellishmentModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,embellishment=_props.embellishment,STATUS=_props.STATUS,assignedToList=_props.assignedToList,disabled=_props.disabled,TYPE=_props.TYPE,embellishmentProcess=_props.embellishmentProcess;this.setState({_id:_id,embellishment:embellishment,embellishmentProcess:embellishmentProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled,TYPE:TYPE});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,embellishment=nextProps.embellishment,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled,TYPE=nextProps.TYPE,embellishmentProcess=nextProps.embellishmentProcess;this.setState({_id:_id,embellishment:embellishment,embellishmentProcess:embellishmentProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled,TYPE:TYPE});}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,permissions=_props2.permissions,embellishmentComments=_props2.embellishmentComments;var STATUS=this.state.STATUS;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"embellishment",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Embellishment",onClick:this.onOpenModal,_id:this.state._id,process:this.state.embellishmentProcess,disabled:this.state.disabled,moduleName:"embellishment",updateModulesMain:this.props.updateModulesMain,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"30%"},"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"HH:MM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Price/30mins"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addEmb();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.embellishment.map(function(embellishment,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"embType",value:embellishment.embType,options:_this2.state.TYPE,onChange:_this2.props.updateEmbellishment,index:index,label:"Type ",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"time",inputName:"hoursMinutes",value:embellishment.hoursMinutes,onChange:_this2.props.updateEmbellishment,index:index,label:"HH:MM",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"pricePerHalfHour",label:"Price/30mins",value:embellishment.pricePerHalfHour,onChange:_this2.props.updateEmbellishment,index:index,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeEmb(index);}})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"embellishmentComments",value:embellishmentComments,label:"comments",onChange:this.props.updateSampleRequest,disabled:this.state.disabled}))),permissions.create&&permissions.edit&&!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createEmbellishment(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeEmbellishment(e);}}))));}}]);return EmbellishmentModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EmbellishmentModule);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle_switch__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toggle_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmbroideryModule=function(_Component){_inherits(EmbroideryModule,_Component);function EmbroideryModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EmbroideryModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EmbroideryModule.__proto__||Object.getPrototypeOf(EmbroideryModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",embroidery:[],assignedToList:[],STATUS:[],disabled:false,widthList:[],backingArray:[]},_this.toggleChange=function(name,value){var toggle=Object.assign({},_this.state.toggle);toggle[name]=value;_this.setState({toggle:toggle});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EmbroideryModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,embroidery=_props.embroidery,embroideryProcess=_props.embroideryProcess,assignedToList=_props.assignedToList,STATUS=_props.STATUS,disabled=_props.disabled,BACKINGTYPE=_props.BACKINGTYPE,PLACEMENT=_props.PLACEMENT,EMBPLACEMENT=_props.EMBPLACEMENT,NOOFCOLORS=_props.NOOFCOLORS,FRAMES=_props.FRAMES,LEFTVALUES=_props.LEFTVALUES,PRICE1000STICHES=_props.PRICE1000STICHES,widthList=_props.widthList,EMBFORM=_props.EMBFORM;this.setState({_id:_id,embroidery:embroidery,embroideryProcess:embroideryProcess,assignedToList:assignedToList,STATUS:STATUS,BACKINGTYPE:BACKINGTYPE,EMBFORM:EMBFORM,PLACEMENT:PLACEMENT,LEFTVALUES:LEFTVALUES,PRICE1000STICHES:PRICE1000STICHES,EMBPLACEMENT:EMBPLACEMENT,NOOFCOLORS:NOOFCOLORS,FRAMES:FRAMES,widthList:widthList,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,embroidery=nextProps.embroidery,embroideryProcess=nextProps.embroideryProcess,assignedToList=nextProps.assignedToList,STATUS=nextProps.STATUS,disabled=nextProps.disabled,BACKINGTYPE=nextProps.BACKINGTYPE,PLACEMENT=nextProps.PLACEMENT,EMBFORM=nextProps.EMBFORM,EMBPLACEMENT=nextProps.EMBPLACEMENT,NOOFCOLORS=nextProps.NOOFCOLORS,FRAMES=nextProps.FRAMES,LEFTVALUES=nextProps.LEFTVALUES,PRICE1000STICHES=nextProps.PRICE1000STICHES,widthList=nextProps.widthList;this.setState({_id:_id,embroidery:embroidery,embroideryProcess:embroideryProcess,assignedToList:assignedToList,STATUS:STATUS,BACKINGTYPE:BACKINGTYPE,EMBFORM:EMBFORM,PLACEMENT:PLACEMENT,EMBPLACEMENT:EMBPLACEMENT,NOOFCOLORS:NOOFCOLORS,FRAMES:FRAMES,LEFTVALUES:LEFTVALUES,PRICE1000STICHES:PRICE1000STICHES,widthList:widthList,disabled:disabled});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,toggle=_state.toggle,embroidery=_state.embroidery,STATUS=_state.STATUS;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"embroidery",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModuleHeader__["a" /* default */],{header:"Embroidery",onClick:this.onOpenModal,_id:this.state._id,process:this.state.embroideryProcess,moduleName:"embroidery",disabled:this.state.disabled,updateModulesMain:this.props.updateModulesMain,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"embroideryForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 embroid-mul"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box1",checked:embroidery.cutPanel,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateEmbroidery("cutPanel",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box1"},"Cut Panel"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box2",checked:embroidery.allOver,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateEmbroidery("allOver",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box2"},"All Over"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box3",checked:embroidery.garmentForm,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateEmbroidery("garmentForm",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box3"},"Garment Form"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box4",checked:embroidery.semiGarmentForm,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateEmbroidery("semiGarmentForm",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box4"},"Semi garment Form"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"manage_permissions emb-chck"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"filled-in",id:"filled-in-box5",checked:embroidery.tassel,disabled:this.state.disabled,onChange:function onChange(e){return _this2.props.updateEmbroidery("tassel",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"filled-in-box5"},"Tassle")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8 col-md-offset-2 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-allocation flex-fixed"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-alloc-con process-left-con col-md-4 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"mySelect",onDoubleClick:function onDoubleClick(){return _this2.props.moveToRight();},className:"mySelectLeft",size:"10",style:{display:"block"},disabled:this.state.disabled},embroidery.leftData.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,data);}))),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-left-arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.moveToRight();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"up"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.moveToBottom();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-down"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-alloc-con col-md-4 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"mySelect2",onDoubleClick:function onDoubleClick(){return _this2.props.moveToLeft();},className:"mySelectRight",size:"10",style:{display:"block"},disabled:this.state.disabled},embroidery.rightData.map(function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,data);}))),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"process-nav-arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.moveToUp();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"up"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-up"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.moveToLeft();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 hide-customer-site"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",getRefImages:function getRefImages(refImages){return _this2.props.getRefImages(refImages,'embroidery');},disabled:this.state.disabled,uploadedDocs:embroidery.refImages.length>0?embroidery.refImages:null})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"backing",value:embroidery.backing,label:"backing",className:"",onChange:this.props.updateEmbroidery,disabled:this.state.disabled})),embroidery.backing&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null," ","Backing ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null," ","Width ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null," ","Placement ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.changeBackingArray('add');}}))),embroidery.backing&&embroidery.backingData.map(function(backingData,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"backingType",value:backingData.backingType,options:_this2.state.BACKINGTYPE,onChange:function onChange(name,value){return _this2.props.updateEmbroideryBackingData(name,value,i);},label:"Backing ",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"width",value:backingData.width// options={this.state.widthList}
,onChange:function onChange(name,value){return _this2.props.updateEmbroideryBackingData(name,value,i);},label:"Width",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"placement",value:backingData.placement,options:_this2.state.PLACEMENT,onChange:function onChange(name,value){return _this2.props.updateEmbroideryBackingData(name,value,i);},label:"Placement ",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.changeBackingArray('clear',i);}})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Emb Placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Emb form"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"No of Colors"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Frames"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Stitches/Mtr"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Consumption/Unit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Stitches Count"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Prices/1000 Stitches"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addEmbroideryData();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,embroidery.embroideryData.map(function(embroideryData,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"embPlacement",value:embroideryData.embPlacement,options:_this2.state.PLACEMENT,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"embForm",value:embroideryData.embForm,options:_this2.state.EMBFORM,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"noOfCols",value:embroideryData.noOfCols,options:_this2.state.NOOFCOLORS,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"frames",value:embroideryData.frames,options:_this2.state.FRAMES,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"stitchesMtr",value:embroideryData.stitchesMtr,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled||embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 d-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{size:"6",maxLength:"6",type:"text",name:"consumption",value:embroideryData.consumption,className:"form-control",disabled:_this2.state.disabled||embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel",onChange:function onChange(e){return _this2.props.updateEmbroideryData(e.target.name,e.target.value,i);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"/mtrs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"stitchCount",value:embroideryData.stitchCount,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled || embroideryData.embForm == "length"}
,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"priceForStitches",value:embroideryData.priceForStitches// options={this.state.PRICE1000STICHES&&this.state.PRICE1000STICHES.map(x => ({ label: x, value: x }))}
,onChange:function onChange(name,value){return _this2.props.updateEmbroideryData(name,value,i);},disabled:_this2.state.disabled// disabled={this.state.disabled || embroideryData.embForm == "length"}
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 pt-0 text-left"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeEmbroideryData(i);}})));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:embroidery.comments,label:"comments",onChange:this.props.updateEmbroidery,disabled:this.state.disabled}))))),permissions.create&&permissions.edit&&!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.saveEmbroidery(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeEmbroidery(e);}})))));}}]);return EmbroideryModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EmbroideryModule);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FabricModule=function(_Component){_inherits(FabricModule,_Component);function FabricModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FabricModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FabricModule.__proto__||Object.getPrototypeOf(FabricModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={fabric:null,SAMPLEREQUEST:{},FABRIC:{},STATUS:[],disabled:false,fabricList:[],durationFabric:null},_this.checkValidation=function(data,element){// console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
// console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
if(_this.validateArrayObject(_this.props.fabric,"fabricPosition",null)&&(_this.validateArrayObject(_this.props.fabric,"fabricNumber",null)||_this.validateArrayObject(_this.props.fabric,"fabricId",null))){if(data=="save"){_this.props.createFabric(element);}else{_this.props.completeFabric(element);}}else{_this.props.getalertMessage("error","Please fill all mandatory fields");}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FabricModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,SAMPLEREQUEST=_props.SAMPLEREQUEST,FABRIC=_props.FABRIC,STATUS=_props.STATUS,fabric=_props.fabric,fabricRadio=_props.fabricRadio,disabled=_props.disabled,assignedToList=_props.assignedToList,fabricProcess=_props.fabricProcess,durationFabric=_props.durationFabric,fabricList=_props.fabricList;this.setState({SAMPLEREQUEST:SAMPLEREQUEST,FABRIC:FABRIC,STATUS:STATUS,fabric:fabric,fabricRadio:fabricRadio,fabricProcess:fabricProcess,disabled:disabled,assignedToList:assignedToList,durationFabric:durationFabric,fabricList:fabricList});console.log(this.state.fabric,"fabricPosition");}// componentDidMount() {
//   this.getFabricNumber("")
// }
},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(Object.keys(this.state.SAMPLEREQUEST).length!=Object.keys(nextProps.SAMPLEREQUEST).length){this.setState({SAMPLEREQUEST:nextProps.SAMPLEREQUEST});}if(Object.keys(this.state.FABRIC).length!=Object.keys(nextProps.FABRIC).length){this.setState({FABRIC:nextProps.FABRIC});}if(this.state.STATUS.length!=nextProps.STATUS.length){this.setState({STATUS:nextProps.STATUS});}if(this.state.assignedToList.length!=nextProps.assignedToList.length){this.setState({assignedToList:nextProps.assignedToList});}if(this.state.fabric!=nextProps.fabric){this.setState({fabric:nextProps.fabric});}var fabricProcess=nextProps.fabricProcess,fabricRadio=nextProps.fabricRadio,durationFabric=nextProps.durationFabric;this.setState({fabricProcess:fabricProcess,fabricRadio:fabricRadio,durationFabric:durationFabric});var disabled=nextProps.disabled;this.setState({disabled:disabled});//console.log(this.state.fabric, "fabricPosition");
}// getFabricNumber = value => {
//   // alert(1)
//   DevelopmentServices.getFabricNumber(value)
//     .then(response => {
//       if (response.status == 200) {
//         this.setState({ fabricList: response.text.data })
//       }
//     })
//     .catch(error => { })
// }
},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data.filter(function(x){return x[key]==val;}).length===0?true:false;return values;}},{key:"render",value:function render(){var _this2=this;var _state=this.state,fabric=_state.fabric,FABRIC=_state.FABRIC,SAMPLEREQUEST=_state.SAMPLEREQUEST,STATUS=_state.STATUS;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"fabric",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModuleHeader__["a" /* default */],{header:"Fabric ",durationETA:this.state.durationFabric,moduleName:"fabric",process:this.state.fabricProcess,updateModulesMain:this.props.updateModulesMain,onClick:this.onOpenModal,statusList:STATUS,_id:this.props._id,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"},id:"fabricForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"fabricForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SAMPLE RELEASE FORM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"printer pull-right cursor-hover",onClick:function onClick(){return _this2.props.printFabric();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"fa fa-print"})," Print")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%",style:{paddingLeft:"15px"}},"Fabric ref no",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%",style:{paddingLeft:"1px"}},"Fabric Name"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Position"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"8.1111111111%"},"Base No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Classification of fabric"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"count&construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"fabric origination"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"In Hse"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Not In Hse"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addFabric();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.fabric.map(function(fabricData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",width:"15%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"fabricNumber",value:fabricData.fabricNumber,onInputChange:function onInputChange(val){return _this2.props.getFabricNumber(val,index);},onChange:function onChange(val){return _this2.props.getFabricInfo(val,index);},placeholder:"Find Fabric"// onFocus={() =>
//   this.props.clearDummyFabric(index)
// }
,options:fabricData.fabricList||_this2.props.fabricList,disabled:_this2.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false}))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default.a,onClick:function onClick(){if(fabricData.fabricNumber){var action=_this2.state.disabled&&'view'||'edit';var search="?"+new URLSearchParams({action:action,_id:fabricData.fabricNumber}).toString();window.open("/developmentFabric"+search,"_blank");}}// this.props.history.push(
//   "/developmentFabric",
//   {
//     action: `${this.props.action}`,
//     _id: fabricData.fabricNumber
//   }
// )
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"fabricName",value:fabricData.fabricName,index:index// label={"comments"}
,onChange:_this2.props.updateFabricName,disabled:_this2.state.disabled,max:25}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"fabricPosition",value:fabricData.fabricPosition,options:SAMPLEREQUEST.POSITION||[],index:index,onChange:_this2.props.updateFabric,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,fabricData.bNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,fabricData.classificationOfFabric)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,fabricData.quality)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,fabricData.countAndConstruction)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"fabricOrigination",value:fabricData.fabricOrigination,options:SAMPLEREQUEST.FABRICORIGINATION||[],index:index,onChange:_this2.props.updateFabric,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{padding:"8px 10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"fabricRadio"+index,value:"inHse"+index,checked:fabricData.fabricRadio==="inHse",index:index,onChange:function onChange(name,value){return _this2.props.updateFabric("fabricRadio","inHse",index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{padding:"8px 10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"fabricRadio"+index,value:"notInHse"+index,checked:fabricData.fabricRadio==="notInHse",index:index,onChange:function onChange(){return _this2.props.updateFabric("fabricRadio","notInHse",index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"// style={{ top: "12px" }}
},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeFabric(index);}})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-11 no-padding pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"fabricComments",value:this.props.fabricComments,label:"comments",onChange:this.props.updateSampleRequest,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.checkValidation("save",e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.checkValidation("complete",e);}})))))))));}}]);return FabricModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FabricModule);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autosize__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draft__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GarmentTechModule=function(_Component){_inherits(GarmentTechModule,_Component);function GarmentTechModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GarmentTechModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GarmentTechModule.__proto__||Object.getPrototypeOf(GarmentTechModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",garmentTechnologist:null,// frag: null,
STATUS:[],sampleDate:null,assignedToList:[],disabled:false},_this.onEditorStateChange=function(value,arrKey,arrSubKey){console.log(value,'--------------------value',arrKey,arrSubKey);// let frag=this.state.garmentTechnologist.sampleForm;
// if(!frag.fitMesurements.comments || frag.fitMesurements.comments ===""){
//   console.log('empty****',frag);
// }
// this.setState ({
//   frag
// })
// let sampleRequest = { ...this.state.sampleRequest };
// console.log(JSON.stringify(sampleRequest)+'----sampleRequest---')
// sampleRequest.garmentTechnologist.sampleForm[arrKey][i]['comments']=value
// this.setState ({
//   // sampleRequest
//   texteditordraft : value
// })
_this.props.editorDraft(value,arrKey,arrSubKey);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GarmentTechModule,[{key:"componentWillMount",value:function componentWillMount(){// .then(response => {
//   // let sample= this.state.sampleForm
// // if (!sample.garmentTechnologist.sampleForm.fitMesurements || sample.garmentTechnologist.sampleForm.fitMesurements === "")
// //         sample.garmentTechnologist.sampleForm.fitMesurements =
// //           response.text.data.OTHERS.sampleForm.fitMesurements
// })
var _props=this.props,_id=_props._id,garmentTechnologist=_props.garmentTechnologist,STATUS=_props.STATUS,disabled=_props.disabled,assignedToList=_props.assignedToList,garmentProcess=_props.garmentProcess;this.setState({_id:_id,garmentTechnologist:garmentTechnologist,garmentProcess:garmentProcess,// frag,
STATUS:STATUS,disabled:disabled,assignedToList:assignedToList});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,garmentTechnologist=nextProps.garmentTechnologist,STATUS=nextProps.STATUS,disabled=nextProps.disabled,assignedToList=nextProps.assignedToList,garmentProcess=nextProps.garmentProcess;this.setState({_id:_id,garmentTechnologist:garmentTechnologist,garmentProcess:garmentProcess,STATUS:STATUS,disabled:disabled,assignedToList:assignedToList});}},{key:"render",value:function render(){var _this2=this,_React$createElement;var permissions=this.props.permissions;var _state=this.state,garmentTechnologist=_state.garmentTechnologist,STATUS=_state.STATUS,sampleDate=_state.sampleDate;__WEBPACK_IMPORTED_MODULE_3_autosize___default()(document.querySelectorAll("textarea"));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-filter meeting-min-con",id:"garmentTechnologist",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModuleHeader__["a" /* default */],{header:"GARMENT TECHNOLOGIST",moduleName:"garmentTechnologist",updateModulesMain:this.props.updateModulesMain,process:this.state.garmentProcess,onClick:this.onOpenModal,statusList:STATUS,_id:this.state._id,disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"p-1 col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */]// durationETA={this.props.durationETA}
,(_React$createElement={isFormGroup:true,inputType:"date",inputName:"sampleDate",value:garmentTechnologist.sampleDate,label:"Sample Date",onChange:this.props.updateGarment},_defineProperty(_React$createElement,"onChange",function onChange(name,value){return _this2.props.updateGarment(name,value);}),_defineProperty(_React$createElement,"disabled",this.state.disabled),_React$createElement))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 product-form",style:{paddingBottom:"1%"},id:"garmentForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"garmentForm",id:"garmentForm2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding mt-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SAMPLE RELEASE FORM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"printer pull-right cursor-hover",onClick:function onClick(){return _this2.props.printGarment("print-garment");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-print"})," Print")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"srf-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"manage_permissions garment-tech-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"comment"},"Comments recieved from buyer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"fab"},"Fab."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"trim"},"Trims"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"work"},"Workmanship"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"change"},"Buyer's changes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"pat"},"Pat."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"data-field":"remark"},"Remarks"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"mod-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:"left"}},"Fit / MEASUREMENTS Comments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{colSpan:"7"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addGarmentForm('fitMesurements');}}))),garmentTechnologist.sampleForm.fitMesurements.length?garmentTechnologist.sampleForm.fitMesurements.map(function(sampleForm,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:'gar'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"50%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__draft__["a" /* default */],{value:sampleForm.comments,editorText:_this2.onEditorStateChange,editorType:"fitMesurements",editorSubType:"fitMesurements"+i})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"fab"+'fitMesurements'+i,value:sampleForm.fab// label="Marker Requirement"
,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("fab",'fitMesurements',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"trims"+'fitMesurements'+i,value:sampleForm.trims// label="Marker Requirement"
,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("trims",'fitMesurements',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"workManShip"+'fitMesurements'+i,value:sampleForm.workManShip// label="Marker Requirement"
,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("workManShip",'fitMesurements',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"buyerChanges"+'fitMesurements'+i,value:sampleForm.buyerChanges// label="Marker Requirement"
,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("buyerChanges",'fitMesurements',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"pat"+'fitMesurements'+i,value:sampleForm.pat// label="Marker Requirement"
,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("pat",'fitMesurements',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"25%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{inputType:"textarea",inputName:"remarks",value:sampleForm.remarks,onChange:function onChange(name,value){return _this2.props.updateGarmentForm(name,'fitMesurements',value,i);},className:"remarks",disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeGarmentForm('fitMesurements',i);}})));}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"mod-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:"left"}},"MAKE UP / CONSTRUCTION:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{colSpan:"7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addGarmentForm('makeupConstruction');}}))),garmentTechnologist.sampleForm.makeupConstruction.length?garmentTechnologist.sampleForm.makeupConstruction.map(function(sampleForm,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__draft__["a" /* default */],{value:sampleForm.comments,editorText:_this2.onEditorStateChange,editorType:"makeupConstruction",editorSubType:"makeupConstruction"+i})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"fab"+'makeupConstruction'+i,value:sampleForm.fab,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("fab",'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"trims"+'makeupConstruction'+i,value:sampleForm.trims,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("trims",'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"workManShip"+'makeupConstruction'+i,value:sampleForm.workManShip,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("workManShip",'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"buyerChanges"+'makeupConstruction'+i,value:sampleForm.buyerChanges,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("buyerChanges",'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"pat"+'makeupConstruction'+i,value:sampleForm.pat,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("pat",'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"25%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{inputType:"textarea",inputName:"remarks",value:sampleForm.remarks,onChange:function onChange(name,value){return _this2.props.updateGarmentForm(name,'makeupConstruction',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeGarmentForm('makeupConstruction',i);}})));}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"mod-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:"left"}},"TRIMS / COMPONENTS :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{colSpan:"7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addGarmentForm('trimsComponents');}}))),garmentTechnologist.sampleForm.trimsComponents.length?garmentTechnologist.sampleForm.trimsComponents.map(function(sampleForm,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__draft__["a" /* default */]// inputType="textarea" inputName="comments"
,{value:sampleForm.comments// onEditorStateChange = {this.onEditorStateChange('trimsComponents', i)}
,editorText:_this2.onEditorStateChange,editorType:"trimsComponents",editorSubType:"trimsComponents"+i})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"fab"+'trimsComponents'+i,value:sampleForm.fab,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("fab",'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"trims"+'trimsComponents'+i,value:sampleForm.trims,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("trims",'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"workManShip"+'trimsComponents'+i,value:sampleForm.workManShip,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("workManShip",'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"buyerChanges"+'trimsComponents'+i,value:sampleForm.buyerChanges,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("buyerChanges",'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"pat"+'trimsComponents'+i,value:sampleForm.pat,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("pat",'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"25%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{inputType:"textarea",inputName:"remarks",value:sampleForm.remarks,onChange:function onChange(name,value){return _this2.props.updateGarmentForm(name,'trimsComponents',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeGarmentForm('trimsComponents',i);}})));}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"mod-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:"left"}},"PACKAGING / PRESENTATION :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{colSpan:"7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addGarmentForm('packPresentation');}}))),garmentTechnologist.sampleForm.packPresentation.map(function(sampleForm,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__draft__["a" /* default */]// inputType="textarea" inputName="comments"
,{value:sampleForm.comments// onEditorStateChange = {this.onEditorStateChange('packPresentation', i)}
,editorText:_this2.onEditorStateChange,editorType:"packPresentation",editorSubType:"packPresentation"+i})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"fab"+'packPresentation'+i,value:sampleForm.fab,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("fab",'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"trims"+'packPresentation'+i,value:sampleForm.trims,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("trims",'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"workManShip"+'packPresentation'+i,value:sampleForm.workManShip,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("workManShip",'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"buyerChanges"+'packPresentation'+i,value:sampleForm.buyerChanges,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("buyerChanges",'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"pat"+'packPresentation'+i,value:sampleForm.pat,className:"",onChange:function onChange(name,value){return _this2.props.updateGarmentForm("pat",'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"25%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{inputType:"textarea",inputName:"remarks",value:sampleForm.remarks,onChange:function onChange(name,value){return _this2.props.updateGarmentForm(name,'packPresentation',value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeGarmentForm('packPresentation',i);}})));})// :''
))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding comments-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"garmentTechComments",value:garmentTechnologist.garmentTechComments,label:"Garment Tech Comments",onChange:this.props.updateGarment,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-11 mx-auto no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"markerRequirements",value:garmentTechnologist.markerRequirements,label:"Marker Requirement",className:"",onChange:this.props.updateGarment,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"smvAmmendment",value:garmentTechnologist.smvAmmendment,label:"SMV Ammendment",className:"",onChange:this.props.updateGarment,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"tiIssues",value:garmentTechnologist.tiIssues,label:"Technical Issues",className:"",onChange:this.props.updateGarment,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"trailRequired",value:garmentTechnologist.trailRequired,label:"Trail Required?",className:"",onChange:this.props.updateGarment,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"mock",value:garmentTechnologist.mock,label:"Mock",className:"",onChange:this.props.updateGarment,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:garmentTechnologist.comment,label:"comments",onChange:this.props.updateGarment,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createGarment(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeGarment(e);}})))));}}]);return GarmentTechModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GarmentTechModule);

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_draft_wysiwyg__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_draft_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_draft_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draftjs_to_html__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draftjs_to_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draftjs_to_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_draft_wysiwyg_dist_react_draft_wysiwyg_css__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_draft_wysiwyg_dist_react_draft_wysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_draft_wysiwyg_dist_react_draft_wysiwyg_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { EditorState, convertFromRaw, convertToRaw, convertFromHTML } from 'draft-js';
var Draft=function(_Component){_inherits(Draft,_Component);function Draft(props){_classCallCheck(this,Draft);var _this=_possibleConstructorReturn(this,(Draft.__proto__||Object.getPrototypeOf(Draft)).call(this,props));_this.onEditorStateChange=function(editorState){var garmentTechnologist=_this.props.garmentTechnologist;var test=__WEBPACK_IMPORTED_MODULE_3_draftjs_to_html___default()(Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["convertToRaw"])(editorState.getCurrentContent()));_this.props.editorText(test,_this.props.editorType,_this.props.editorSubType);_this.setState({editorState:editorState,test:test,garmentTechnologist:garmentTechnologist});};_this.state={garmentTechnologist:null,test:''};return _this;}_createClass(Draft,[{key:'componentWillMount',value:function componentWillMount(){var value=this.props.value;if(value){var blocksFromHTML=Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["convertFromHTML"])(value);var state=__WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromBlockArray(blocksFromHTML.contentBlocks,blocksFromHTML.entityMap);this.state={editorState:__WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].createWithContent(state,__WEBPACK_IMPORTED_MODULE_1_draft_js__["compositeDecorator"])};}}},{key:'render',value:function render(){var editorState=this.state.editorState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_draft_wysiwyg__["Editor"],{editorState:editorState,wrapperClassName:'demo-wrapper',editorClassName:'demo-editor',inputName:'comments',onEditorStateChange:this.onEditorStateChange,value:this.props.value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'draftContent'}));}}]);return Draft;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Draft);

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockMapBuilder = __webpack_require__(89);

var CharacterMetadata = __webpack_require__(37);

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var generateRandomKey = __webpack_require__(42);

var gkx = __webpack_require__(50);

var Immutable = __webpack_require__(8);

var moveBlockInContentState = __webpack_require__(749);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var List = Immutable.List,
    Repeat = Immutable.Repeat;
var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
    var charData = CharacterMetadata.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _objectSpread({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _objectSpread({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'insert-fragment');
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();

      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();

        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'move-block');
  }
};
module.exports = AtomicBlockUtils;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(37);

var _require = __webpack_require__(8),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;

    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var applyEntityToContentBlock = __webpack_require__(737);

var Immutable = __webpack_require__(8);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(37);

function applyEntityToContentBlock(contentBlock, startArg, end, entityKey) {
  var start = startArg;
  var characterList = contentBlock.getCharacterList();

  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }

  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEntitySegments = __webpack_require__(739);

var getRangesForDraftEntity = __webpack_require__(740);

var invariant = __webpack_require__(9);
/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */


function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);

  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }

  var newSelectionState = selectionState;

  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }

  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  var entity = entityMap.__get(entityKey);

  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.

  if (mutability === 'MUTABLE') {
    return selectionState;
  } // Find the entity range that overlaps with our removal range.


  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  } // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.


  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function (
    /*string*/
    segment,
    /*number*/
    ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }

      return segment;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
module.exports = DraftEntitySegments;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);
/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */


function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({
      start: start,
      end: end
    });
  });
  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(89);

var ContentBlockNode = __webpack_require__(38);

var Immutable = __webpack_require__(8);

var insertIntoList = __webpack_require__(254);

var invariant = __webpack_require__(9);

var randomizeBlockMapKeys = __webpack_require__(252);

var List = Immutable.List;

var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var mergeBlockData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'REPLACE_WITH_NEW_DATA';
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var data = null;

  switch (mergeBlockData) {
    case 'MERGE_OLD_DATA_TO_NEW_DATA':
      data = fragmentBlock.getData().merge(targetBlock.getData());
      break;

    case 'REPLACE_WITH_NEW_DATA':
      data = fragmentBlock.getData();
      break;
  }

  var type = targetBlock.getType();

  if (text && type === 'unstyled') {
    type = fragmentBlock.getType();
  }

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    type: type,
    data: data
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */


var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */


var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block

  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    } // update the last root block fragment


    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    } // update fragment parent links


    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    }); // update targetBlock parent child links

    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    } // Insert fragment blocks after the head and before the tail.


    fragment // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    }); // update tail

    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  } // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block


  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(8);

var insertIntoList = __webpack_require__(254);

var invariant = __webpack_require__(9);

var Repeat = Immutable.Repeat;

function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
  var len = null;

  if (text != null) {
    len = text.length;
  }

  if (len == null || len === 0) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(38);

var getNextDelimiterBlockKey = __webpack_require__(256);

var Immutable = __webpack_require__(8);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};
/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */


var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);

  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();

    if (parentKey) {
      parents.push(parentKey);
    }

    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};
/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */


var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);

  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);

    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update endblock if its retained

    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update start block parent ancestors

    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update start block next - can only happen if startBlock == endBlock

    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    }); // update start block prev

    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block next

    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block prev

    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    }); // update end block parent ancestors

    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update next delimiters all the way to a root delimiter

    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // if parent (startBlock) was deleted

    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
      var prevSiblingKey = startBlock.getPrevSiblingKey(); // endBlock becomes next sibling of parent's prevSibling

      transformBlock(endBlock.getKey(), blocks, function (block) {
        return block.merge({
          prevSibling: prevSiblingKey
        });
      });
      transformBlock(prevSiblingKey, blocks, function (block) {
        return block.merge({
          nextSibling: endBlock.getKey()
        });
      }); // Update parent for previous parent's children, and children for that parent

      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
      startBlock.getChildKeys().forEach(function (childKey) {
        transformBlock(childKey, blocks, function (block) {
          return block.merge({
            parent: newParentKey // set to null if there is no parent

          });
        });
      });

      if (newParentKey != null) {
        var newParent = blockMap.get(newParentKey);
        transformBlock(newParentKey, blocks, function (block) {
          return block.merge({
            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
          });
        });
      } // last child of deleted parent should point to next sibling


      transformBlock(startBlock.getChildKeys().find(function (key) {
        var block = blockMap.get(key);
        return block.getNextSiblingKey() === null;
      }), blocks, function (block) {
        return block.merge({
          nextSibling: startBlock.getNextSiblingKey()
        });
      });
    }
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode; // used to retain blocks that should not be deleted to avoid orphan children

  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected siblings so we can not remove its ancestors parents

    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    } // endBlock has children so can not remove this block or any of its ancestors


    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    } // we need to retain all ancestors of the next delimiter block


    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  }); // If cursor (collapsed) is at the start of the first child, delete parent
  // instead of child

  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
  var newBlocks = shouldDeleteParent ? Map([[startKey, null]]) : blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  }); // Only update tree block pointers if the range is across blocks

  if (isExperimentalTreeBlock && startBlock !== endBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */


var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }

  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(38);

var generateRandomKey = __webpack_require__(42);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var modifyBlockForContentState = __webpack_require__(255);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey(); // update block parent

    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update original next block

    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    }); // update original block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    }); // update below block

    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
  var key = selectionState.getAnchorKey();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();

  if (!text) {
    var blockType = blockToSplit.getType();

    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
      return modifyBlockForContentState(contentState, selectionState, function (block) {
        return block.merge({
          type: 'unstyled',
          depth: 0
        });
      });
    }
  }

  var offset = selectionState.getAnchorOffset();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var findRangesImmutable = __webpack_require__(90);

var getOwnObjectValues = __webpack_require__(257);

var Immutable = __webpack_require__(8);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;

var returnTrue = function returnTrue() {
  return true;
};

var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record(defaultDecoratorRange);
var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();

    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List(leafSets);
  },
  fromJS: function fromJS(_ref) {
    var leaves = _ref.leaves,
        other = _objectWithoutPropertiesLoose(_ref, ["leaves"]);

    return new DecoratorRange(_objectSpread({}, other, {
      leaves: leaves != null ? List(Array.isArray(leaves) ? leaves : getOwnObjectValues(leaves)).map(function (leaf) {
        return LeafRange(leaf);
      }) : null
    }));
  }
};
/**
 * Generate LeafRange records for a given character list.
 */

function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @typechecks
 * 
 * @format
 */

/*eslint-disable no-bitwise */

/**
 * Based on the rfc4122-compliant solution posted at
 * http://stackoverflow.com/questions/105034
 */
function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

module.exports = uuid;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeBidiService = __webpack_require__(748);

var Immutable = __webpack_require__(8);

var nullthrows = __webpack_require__(22);

var OrderedMap = Immutable.OrderedMap;
var bidiService;
var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};
module.exports = EditorBidiService;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnicodeBidi = __webpack_require__(158);

var UnicodeBidiDirection = __webpack_require__(116);

var invariant = __webpack_require__(9);

var UnicodeBidiService =
/*#__PURE__*/
function () {
  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _defineProperty(this, "_defaultDir", void 0);

    _defineProperty(this, "_lastDir", void 0);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }

    this._defaultDir = defaultDir;
    this.reset();
  }
  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  var _proto = UnicodeBidiService.prototype;

  _proto.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  _proto.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(38);

var getNextDelimiterBlockKey = __webpack_require__(256);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  } // possible values of 'insertionMode' are: 'after', 'before'


  var isInsertedAfterTarget = insertionMode === 'after';
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
      });
    }); // update old prev

    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    }); // update old next

    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    }); // update new next

    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    }); // update new prev

    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    }); // update new parent

    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks["delete"](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Immutable = __webpack_require__(8);

var List = Immutable.List;
var DELIMITER = '.';
/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = /*#__PURE__*/function () {
  function CompositeDraftDecorator(decorators) {
    _defineProperty(this, "_decorators", void 0);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  var _proto = CompositeDraftDecorator.prototype;

  _proto.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function (
    /*object*/
    decorator,
    /*number*/
    ii) {
      var counter = 0;
      var strategy = decorator.strategy;

      var callback = function callback(
      /*number*/
      start,
      /*number*/
      end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };

      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  _proto.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  _proto.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();
/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }

  return true;
}
/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */


function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @preventMunge
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(159);

var DefaultDraftInlineStyle = __webpack_require__(260);

var DraftEditorCompositionHandler = __webpack_require__(752);

var DraftEditorContents = __webpack_require__(760);

var DraftEditorDragHandler = __webpack_require__(777);

var DraftEditorEditHandler = __webpack_require__(780);

var flushControlled = __webpack_require__(815);

var DraftEditorPlaceholder = __webpack_require__(816);

var DraftEffects = __webpack_require__(272);

var EditorState = __webpack_require__(10);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(162);

var Style = __webpack_require__(120);

var UserAgent = __webpack_require__(23);

var cx = __webpack_require__(59);

var generateRandomKey = __webpack_require__(42);

var getDefaultKeyBinding = __webpack_require__(288);

var getScrollPosition = __webpack_require__(121);

var gkx = __webpack_require__(50);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(91);

var nullthrows = __webpack_require__(22);

var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.

var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.

var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};
var didInitODS = false;

var UpdateDraftEditorFlags = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UpdateDraftEditorFlags, _React$Component);

  function UpdateDraftEditorFlags() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UpdateDraftEditorFlags.prototype;

  _proto.render = function render() {
    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._update();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._update();
  };

  _proto._update = function _update() {
    var editor = this.props.editor;
    /**
     * Sometimes a render triggers a 'focus' or other event, and that will
     * schedule a second render pass.
     * In order to make sure the second render pass gets the latest editor
     * state, we update it here.
     * Example:
     * render #1
     * +
     * |
     * | cWU -> Nothing ... latestEditorState = STALE_STATE :(
     * |
     * | render -> this.props.editorState = FRESH_STATE
     * | +         *and* set latestEditorState = FRESH_STATE
     *   |
     * | |
     * | +--> triggers 'focus' event, calling 'handleFocus' with latestEditorState
     * |                                                +
     * |                                                |
     * +>cdU -> latestEditorState = FRESH_STATE         | the 'handleFocus' call schedules render #2
     *                                                  | with latestEditorState, which is FRESH_STATE
     *                                                  |
     * render #2 <--------------------------------------+
     * +
     * |
     * | cwU -> nothing updates
     * |
     * | render -> this.props.editorState = FRESH_STATE which was passed in above
     * |
     * +>cdU fires and resets latestEditorState = FRESH_STATE
     * ---
     * Note that if we don't set latestEditorState in 'render' in the above
     * diagram, then STALE_STATE gets passed to render #2.
     */

    editor._latestEditorState = this.props.editorState;
    /**
     * The reason we set this 'blockSelectEvents' flag is that  IE will fire a
     * 'selectionChange' event when we programmatically change the selection,
     * meaning it would trigger a new select event while we are in the middle
     * of updating.
     * We found that the 'selection.addRange' was what triggered the stray
     * selectionchange event in IE.
     * To be clear - we have not been able to reproduce specific bugs related
     * to this stray selection event, but have recorded logs that some
     * conditions do cause it to get bumped into during editOnSelect.
     */

    editor._blockSelectEvents = true;
  };

  return UpdateDraftEditorFlags;
}(React.Component);
/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */


var DraftEditor = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(DraftEditor, _React$Component2);

  /**
   * Define proxies that can route events to the current handler.
   */
  function DraftEditor(props) {
    var _this;

    _this = _React$Component2.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_blockSelectEvents", void 0);

    _defineProperty(_assertThisInitialized(_this), "_clipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handler", void 0);

    _defineProperty(_assertThisInitialized(_this), "_dragCount", void 0);

    _defineProperty(_assertThisInitialized(_this), "_internalDrag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_editorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_placeholderAccessibilityID", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestCommittedEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_pendingStateFromBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBlur", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCharacterData", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCopy", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCut", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragOver", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDrop", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyPress", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onPaste", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onSelect", void 0);

    _defineProperty(_assertThisInitialized(_this), "editor", void 0);

    _defineProperty(_assertThisInitialized(_this), "editorContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "focus", void 0);

    _defineProperty(_assertThisInitialized(_this), "blur", void 0);

    _defineProperty(_assertThisInitialized(_this), "setMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", void 0);

    _defineProperty(_assertThisInitialized(_this), "setClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getEditorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "update", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handleEditorContainerRef", function (node) {
      _this.editorContainer = node; // Instead of having a direct ref on the child, we'll grab it here.
      // This is safe as long as the rendered structure is static (which it is).
      // This lets the child support ref={props.editorRef} without merging refs.

      _this.editor = node !== null ? node.firstChild : null;
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function (scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _this.editor;

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus(); // Restore scroll position

      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      } // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.


      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      var editorNode = _this.editor;

      if (!editorNode) {
        return;
      }

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "setMode", function (mode) {
      var _this$props = _this.props,
          onPaste = _this$props.onPaste,
          onCut = _this$props.onCut,
          onCopy = _this$props.onCopy;

      var editHandler = _objectSpread({}, handlerMap.edit);

      if (onPaste) {
        /* $FlowFixMe[incompatible-type] (>=0.117.0 site=www,mobile) This comment
         * suppresses an error found when Flow v0.117 was deployed. To see the
         * error delete this comment and run Flow. */
        editHandler.onPaste = onPaste;
      }

      if (onCut) {
        editHandler.onCut = onCut;
      }

      if (onCopy) {
        editHandler.onCopy = onCopy;
      }

      var handler = _objectSpread({}, handlerMap, {
        edit: editHandler
      });

      _this._handler = handler[mode];
    });

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", function () {
      _this.setMode('edit');
    });

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", function (scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function () {
        _this.focus(scrollPosition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setClipboard", function (clipboard) {
      _this._clipboard = clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "getClipboard", function () {
      return _this._clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (editorState) {
      _this._latestEditorState = editorState;

      _this.props.onChange(editorState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function () {
      _this._dragCount++;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function () {
      _this._dragCount--;

      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    });

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    if (false) {
      ['onDownArrow', 'onEscape', 'onLeftArrow', 'onRightArrow', 'onTab', 'onUpArrow'].forEach(function (propName) {
        if (props.hasOwnProperty(propName)) {
          // eslint-disable-next-line no-console
          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + 'been deprecated. If your handler needs access to the keyboard ' + 'event, supply a custom `keyBindingFn` prop that falls back to ' + 'the default one (eg. https://is.gd/wHKQ3W).');
        }
      });
    } // See `restoreEditorDOM()`.


    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  var _proto2 = DraftEditor.prototype;

  _proto2._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    // Wrap event handlers in `flushControlled`. In sync mode, this is
    // effectively a no-op. In async mode, this ensures all updates scheduled
    // inside the handler are flushed before React yields to the browser.
    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];

        if (method) {
          if (flushControlled) {
            flushControlled(function () {
              return method(_this2, e);
            });
          } else {
            method(_this2, e);
          }
        }
      }
    };
  };

  _proto2._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  _proto2._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This comment
       * suppresses an error found when Flow v0.112 was deployed. To see the
       * error delete this comment and run Flow. */

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }

    return null;
  }
  /**
   * returns ariaDescribedBy prop with '{{editor_id_placeholder}}' replaced with
   * the DOM id of the placeholder (if it exists)
   * @returns aria-describedby attribute value
   */
  ;

  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
    var describedBy = this.props.ariaDescribedBy || '';
    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : '';
    return describedBy.replace('{{editor_id_placeholder}}', placeholderID) || undefined;
  };

  _proto2.render = function render() {
    var _this$props2 = this.props,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        editorState = _this$props2.editorState,
        preventScroll = _this$props2.preventScroll,
        readOnly = _this$props2.readOnly,
        textAlignment = _this$props2.textAlignment,
        textDirectionality = _this$props2.textDirectionality;
    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });
    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }; // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.

    /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */

    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _objectSpread({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      preventScroll: preventScroll,
      textDirectionality: textDirectionality
    };
    return React.createElement("div", {
      className: rootClass
    }, this._renderPlaceholder(), React.createElement("div", {
      className: cx('DraftEditor/editorContainer'),
      ref: this._handleEditorContainerRef
    }, React.createElement("div", {
      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
      "aria-controls": readOnly ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": readOnly ? null : ariaExpanded,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        'public/DraftEditor/content': true
      }),
      contentEditable: !readOnly,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React.createElement(UpdateDraftEditorFlags, {
      editor: this,
      editorState: editorState
    }), React.createElement(DraftEditorContents, _extends({}, editorContentsProps, {
      key: 'contents' + this.state.contentsKey
    })))));
  };

  _proto2.componentDidMount = function componentDidMount() {
    this._blockSelectEvents = false;

    if (!didInitODS && gkx('draft_ods_enabled')) {
      didInitODS = true;
      DraftEffects.initODS();
    }

    this.setMode('edit');
    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */

    if (isIE) {
      // editor can be null after mounting
      // https://stackoverflow.com/questions/44074747/componentdidmount-called-before-ref-callback
      if (!this.editor) {
        global.execCommand('AutoUrlDetect', false, false);
      } else {
        this.editor.ownerDocument.execCommand('AutoUrlDetect', false, false);
      }
    }
  };

  _proto2.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestEditorState = this.props.editorState;
    this._latestCommittedEditorState = this.props.editorState;
  }
  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */
  ;

  return DraftEditor;
}(React.Component);

_defineProperty(DraftEditor, "defaultProps", {
  ariaDescribedBy: '{{editor_id_placeholder}}',
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: function blockRendererFn() {
    return null;
  },
  blockStyleFn: function blockStyleFn() {
    return '';
  },
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
});

module.exports = DraftEditor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DOMObserver = __webpack_require__(753);

var DraftModifier = __webpack_require__(21);

var DraftOffsetKey = __webpack_require__(44);

var EditorState = __webpack_require__(10);

var Keys = __webpack_require__(119);

var UserAgent = __webpack_require__(23);

var editOnSelect = __webpack_require__(263);

var getContentEditableContainer = __webpack_require__(265);

var getDraftEditorSelection = __webpack_require__(266);

var getEntityKeyForSelection = __webpack_require__(160);

var nullthrows = __webpack_require__(22);

var isIE = UserAgent.isBrowser('IE');
/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */

var RESOLVE_DELAY = 20;
/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */

var resolved = false;
var stillComposing = false;
var domObserver = null;

function startDOMObserver(editor) {
  if (!domObserver) {
    domObserver = new DOMObserver(getContentEditableContainer(editor));
    domObserver.start();
  }
}

var DraftEditorCompositionHandler = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
    startDOMObserver(editor);
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },
  onSelect: editOnSelect,

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);

      editor._onKeyDown(e);

      return;
    }

    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(_editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    var mutations = nullthrows(domObserver).stopAndFlushMutations();
    domObserver = null;
    resolved = true;
    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    editor.exitCurrentMode();

    if (!mutations.size) {
      editor.update(editorState);
      return;
    } // TODO, check if Facebook still needs this flag or if it could be removed.
    // Since there can be multiple mutations providing a `composedChars` doesn't
    // apply well on this new model.
    // if (
    //   gkx('draft_handlebeforeinput_composed_text') &&
    //   editor.props.handleBeforeInput &&
    //   isEventHandled(
    //     editor.props.handleBeforeInput(
    //       composedChars,
    //       editorState,
    //       event.timeStamp,
    //     ),
    //   )
    // ) {
    //   return;
    // }


    var contentState = editorState.getCurrentContent();
    mutations.forEach(function (composedChars, offsetKey) {
      var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
          blockKey = _DraftOffsetKey$decod.blockKey,
          decoratorKey = _DraftOffsetKey$decod.decoratorKey,
          leafKey = _DraftOffsetKey$decod.leafKey;

      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
          start = _editorState$getBlock.start,
          end = _editorState$getBlock.end;

      var replacementRange = editorState.getSelection().merge({
        anchorKey: blockKey,
        focusKey: blockKey,
        anchorOffset: start,
        focusOffset: end,
        isBackward: false
      });
      var entityKey = getEntityKeyForSelection(contentState, replacementRange);
      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
      contentState = DraftModifier.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey); // We need to update the editorState so the leaf node ranges are properly
      // updated and multiple mutations are correctly applied.

      editorState = EditorState.set(editorState, {
        currentContent: contentState
      });
    }); // When we apply the text changes to the ContentState, the selection always
    // goes to the end of the field, but it should just stay where it is
    // after compositionEnd.

    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
    var compositionEndSelectionState = documentSelection.selectionState;
    editor.restoreEditorDOM(); // See:
    // - https://github.com/facebook/draft-js/issues/2093
    // - https://github.com/facebook/draft-js/pull/2094
    // Apply this fix only in IE for now. We can test it in
    // other browsers in the future to ensure no regressions

    var editorStateWithUpdatedSelection = isIE ? EditorState.forceSelection(editorState, compositionEndSelectionState) : EditorState.acceptSelection(editorState, compositionEndSelectionState);
    editor.update(EditorState.push(editorStateWithUpdatedSelection, contentState, 'insert-characters'));
  }
};
module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserAgent = __webpack_require__(23);

var findAncestorOffsetKey = __webpack_require__(117);

var getWindowForNode = __webpack_require__(262);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var nullthrows = __webpack_require__(22);

var Map = Immutable.Map;
// Heavily based on Prosemirror's DOMObserver https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
var DOM_OBSERVER_OPTIONS = {
  subtree: true,
  characterData: true,
  childList: true,
  characterDataOldValue: false,
  attributes: false
}; // IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified

var USE_CHAR_DATA = UserAgent.isBrowser('IE <= 11');

var DOMObserver = /*#__PURE__*/function () {
  function DOMObserver(container) {
    var _this = this;

    _defineProperty(this, "observer", void 0);

    _defineProperty(this, "container", void 0);

    _defineProperty(this, "mutations", void 0);

    _defineProperty(this, "onCharData", void 0);

    this.container = container;
    this.mutations = Map();
    var containerWindow = getWindowForNode(container);

    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
      this.observer = new containerWindow.MutationObserver(function (mutations) {
        return _this.registerMutations(mutations);
      });
    } else {
      this.onCharData = function (e) {
        !(e.target instanceof Node) ?  false ? invariant(false, 'Expected target to be an instance of Node') : invariant(false) : void 0;

        _this.registerMutation({
          type: 'characterData',
          target: e.target
        });
      };
    }
  }

  var _proto = DOMObserver.prototype;

  _proto.start = function start() {
    if (this.observer) {
      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.addEventListener('DOMCharacterDataModified', this.onCharData);
    }
  };

  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
    var observer = this.observer;

    if (observer) {
      this.registerMutations(observer.takeRecords());
      observer.disconnect();
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.removeEventListener('DOMCharacterDataModified', this.onCharData);
    }

    var mutations = this.mutations;
    this.mutations = Map();
    return mutations;
  };

  _proto.registerMutations = function registerMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      this.registerMutation(mutations[i]);
    }
  };

  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
    var type = mutation.type,
        target = mutation.target,
        removedNodes = mutation.removedNodes;

    if (type === 'characterData') {
      // When `textContent` is '', there is a race condition that makes
      // getting the offsetKey from the target not possible.
      // These events are also followed by a `childList`, which is the one
      // we are able to retrieve the offsetKey and apply the '' text.
      if (target.textContent !== '') {
        // IE 11 considers the enter keypress that concludes the composition
        // as an input char. This strips that newline character so the draft
        // state does not receive spurious newlines.
        if (USE_CHAR_DATA) {
          return target.textContent.replace('\n', '');
        }

        return target.textContent;
      }
    } else if (type === 'childList') {
      if (removedNodes && removedNodes.length) {
        // `characterData` events won't happen or are ignored when
        // removing the last character of a leaf node, what happens
        // instead is a `childList` event with a `removedNodes` array.
        // For this case the textContent should be '' and
        // `DraftModifier.replaceText` will make sure the content is
        // updated properly.
        return '';
      } else if (target.textContent !== '') {
        // Typing Chinese in an empty block in MS Edge results in a
        // `childList` event with non-empty textContent.
        // See https://github.com/facebook/draft-js/issues/2082
        return target.textContent;
      }
    }

    return null;
  };

  _proto.registerMutation = function registerMutation(mutation) {
    var textContent = this.getMutationTextContent(mutation);

    if (textContent != null) {
      var offsetKey = nullthrows(findAncestorOffsetKey(mutation.target));
      this.mutations = this.mutations.set(offsetKey, textContent);
    }
  };

  return DOMObserver;
}();

module.exports = DOMObserver;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */


var UAParser = __webpack_require__(755);

var UNKNOWN = 'Unknown';
var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};
/**
 * Convert from UAParser platform name to what we expect.
 */

function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}
/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */


function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }

  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}
/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */


var parser = new UAParser();
var results = parser.getResult(); // Do some conversion first.

var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
module.exports = uaData;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.37',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(756)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var invariant = __webpack_require__(9);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */

function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}
/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}
/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkSimpleExpression(range, version) {
  range = range.trim();

  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);

    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);

    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);

    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);

    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);

    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }

  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);

  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */


function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */


function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}
/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */


function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */


function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}
/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */


function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length); // mark "x" and "*" components as equal

  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);

    if (matches) {
      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);
  return [a, b];
}
/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}
/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);

    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};
module.exports = VersionRange;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */

function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }

  var result = {};

  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }

  return result;
}

module.exports = mapObject;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }

    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var gkx = __webpack_require__(50);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
module.exports = experimentalTreeDataSupport ? __webpack_require__(761) : __webpack_require__(775);

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorContents.react.js for tree nodes
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlockNode = __webpack_require__(762);

var DraftOffsetKey = __webpack_require__(44);

var React = __webpack_require__(0);

var nullthrows = __webpack_require__(22);

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */
var DraftEditorContentsExperimental = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContentsExperimental, _React$Component);

  function DraftEditorContentsExperimental() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContentsExperimental.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var rootBlock = blocksAsArray[0];
    var processedBlocks = [];
    var nodeBlock = rootBlock;

    while (nodeBlock) {
      var blockKey = nodeBlock.getKey();
      var blockProps = {
        blockRenderMap: blockRenderMap,
        blockRendererFn: blockRendererFn,
        blockStyleFn: blockStyleFn,
        contentState: content,
        customStyleFn: customStyleFn,
        customStyleMap: customStyleMap,
        decorator: decorator,
        editorKey: editorKey,
        editorState: editorState,
        forceSelection: forceSelection,
        selection: selection,
        block: nodeBlock,
        direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
        tree: editorState.getBlockTree(blockKey)
      };
      var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      processedBlocks.push({
        /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
         * comment suppresses an error found when Flow v0.112 was deployed. To
         * see the error delete this comment and run Flow. */
        block: React.createElement(DraftEditorBlockNode, _extends({
          key: blockKey
        }, blockProps)),
        wrapperTemplate: wrapperTemplate,
        key: blockKey,
        offsetKey: DraftOffsetKey.encode(blockKey, 0, 0)
      });
      var nextBlockKey = nodeBlock.getNextSiblingKey();
      nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var ii = 0; ii < processedBlocks.length;) {
      var info = processedBlocks[ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[ii].block);
          ii++;
        } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContentsExperimental;
}(React.Component);

module.exports = DraftEditorContentsExperimental;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorBlock.react.js and DraftEditorContents.react.js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorNode = __webpack_require__(763);

var DraftOffsetKey = __webpack_require__(44);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(162);

var Style = __webpack_require__(120);

var getElementPosition = __webpack_require__(274);

var getScrollPosition = __webpack_require__(121);

var getViewportDimensions = __webpack_require__(275);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(91);

var SCROLL_BUFFER = 10;
var List = Immutable.List; // we should harden up the bellow flow types to make them more strict

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * We will use this helper to identify blocks that need to be wrapped but have siblings that
 * also share the same wrapper element, this way we can do the wrapping once the last sibling
 * is added.
 */


var shouldNotAddWrapperElement = function shouldNotAddWrapperElement(block, contentState) {
  var nextSiblingKey = block.getNextSiblingKey();
  return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
};

var applyWrapperElementToSiblings = function applyWrapperElementToSiblings(wrapperTemplate, Element, nodes) {
  var wrappedSiblings = []; // we check back until we find a sibling that does not have same wrapper

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sibling = _step.value;

      if (sibling.type !== Element) {
        break;
      }

      wrappedSiblings.push(sibling);
    } // we now should remove from acc the wrappedSiblings and add them back under same wrap

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
  var childrenIs = wrappedSiblings.reverse();
  var key = childrenIs[0].key;
  nodes.push(React.cloneElement(wrapperTemplate, {
    key: "".concat(key, "-wrap"),
    'data-offset-key': DraftOffsetKey.encode(key, 0, 0)
  }, childrenIs));
  return nodes;
};

var getDraftRenderConfig = function getDraftRenderConfig(block, blockRenderMap) {
  var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get('unstyled');
  var wrapperTemplate = configForType.wrapper;
  var Element = configForType.element || blockRenderMap.get('unstyled').element;
  return {
    Element: Element,
    wrapperTemplate: wrapperTemplate
  };
};

var getCustomRenderConfig = function getCustomRenderConfig(block, blockRendererFn) {
  var customRenderer = blockRendererFn(block);

  if (!customRenderer) {
    return {};
  }

  var CustomComponent = customRenderer.component,
      customProps = customRenderer.props,
      customEditable = customRenderer.editable;
  return {
    CustomComponent: CustomComponent,
    customProps: customProps,
    customEditable: customEditable
  };
};

var getElementPropsConfig = function getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, ref) {
  var elementProps = {
    'data-block': true,
    'data-editor': editorKey,
    'data-offset-key': offsetKey,
    key: block.getKey(),
    ref: ref
  };
  var customClass = blockStyleFn(block);

  if (customClass) {
    elementProps.className = customClass;
  }

  if (customConfig.customEditable !== undefined) {
    elementProps = _objectSpread({}, elementProps, {
      contentEditable: customConfig.customEditable,
      suppressContentEditableWarning: true
    });
  }

  return elementProps;
};

var DraftEditorBlockNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlockNode, _React$Component);

  function DraftEditorBlockNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", React.createRef());

    return _this;
  }

  var _proto = DraftEditorBlockNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
        block = _this$props.block,
        direction = _this$props.direction,
        tree = _this$props.tree;
    var isContainerNode = !block.getChildKeys().isEmpty();
    var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection; // if we have children at this stage we always re-render container nodes
    // else if its a root node we avoid re-rendering by checking for block updates

    return isContainerNode || blockHasChanged;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this.wrapperRef.current;

    if (!blockNode) {
      // This Block Node was rendered without a wrapper element.
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var htmlBlockNode = blockNode;
      var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        block = _this$props2.block,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        contentState = _this$props2.contentState,
        decorator = _this$props2.decorator,
        editorKey = _this$props2.editorKey,
        editorState = _this$props2.editorState,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        direction = _this$props2.direction,
        forceSelection = _this$props2.forceSelection,
        selection = _this$props2.selection,
        tree = _this$props2.tree;
    var children = null;

    if (block.children.size) {
      children = block.children.reduce(function (acc, key) {
        var offsetKey = DraftOffsetKey.encode(key, 0, 0);
        var child = contentState.getBlockForKey(key);
        var customConfig = getCustomRenderConfig(child, blockRendererFn);
        var Component = customConfig.CustomComponent || DraftEditorBlockNode;

        var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap),
            Element = _getDraftRenderConfig.Element,
            wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;

        var elementProps = getElementPropsConfig(child, editorKey, offsetKey, blockStyleFn, customConfig, null);

        var childProps = _objectSpread({}, _this2.props, {
          tree: editorState.getBlockTree(key),
          blockProps: customConfig.customProps,
          offsetKey: offsetKey,
          block: child
        });

        acc.push(React.createElement(Element, elementProps, React.createElement(Component, childProps)));

        if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
          return acc;
        } // if we are here it means we are the last block
        // that has a wrapperTemplate so we should wrap itself
        // and all other previous siblings that share the same wrapper


        applyWrapperElementToSiblings(wrapperTemplate, Element, acc);
        return acc;
      }, []);
    }

    var blockKey = block.getKey();
    var offsetKey = DraftOffsetKey.encode(blockKey, 0, 0);
    var customConfig = getCustomRenderConfig(block, blockRendererFn);
    var Component = customConfig.CustomComponent;
    var blockNode = Component != null ? React.createElement(Component, _extends({}, this.props, {
      tree: editorState.getBlockTree(blockKey),
      blockProps: customConfig.customProps,
      offsetKey: offsetKey,
      block: block
    })) : React.createElement(DraftEditorNode, {
      block: block,
      children: children,
      contentState: contentState,
      customStyleFn: customStyleFn,
      customStyleMap: customStyleMap,
      decorator: decorator,
      direction: direction,
      forceSelection: forceSelection,
      hasSelection: isBlockOnSelectionEdge(selection, blockKey),
      selection: selection,
      tree: tree
    });

    if (block.getParentKey()) {
      return blockNode;
    }

    var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap),
        Element = _getDraftRenderConfig2.Element;

    var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, this.wrapperRef); // root block nodes needs to be wrapped

    return React.createElement(Element, elementProps, blockNode);
  };

  return DraftEditorBlockNode;
}(React.Component);

module.exports = DraftEditorBlockNode;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorDecoratedLeaves = __webpack_require__(764);

var DraftEditorLeaf = __webpack_require__(270);

var DraftOffsetKey = __webpack_require__(44);

var Immutable = __webpack_require__(8);

var React = __webpack_require__(0);

var cx = __webpack_require__(59);

var List = Immutable.List;

var DraftEditorNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorNode, _React$Component);

  function DraftEditorNode() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorNode.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState,
        customStyleFn = _this$props.customStyleFn,
        customStyleMap = _this$props.customStyleMap,
        decorator = _this$props.decorator,
        direction = _this$props.direction,
        forceSelection = _this$props.forceSelection,
        hasSelection = _this$props.hasSelection,
        selection = _this$props.selection,
        tree = _this$props.tree;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = tree.size - 1;
    var children = this.props.children || tree.map(function (leafSet, ii) {
      var decoratorKey = leafSet.get('decoratorKey');
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var Leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? selection : null,
          forceSelection: forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: customStyleMap,
          customStyleFn: customStyleFn,
          isLast: decoratorKey === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      if (!decoratorKey || !decorator) {
        return Leaves;
      }

      return React.createElement(DraftEditorDecoratedLeaves, {
        block: block,
        children: Leaves,
        contentState: contentState,
        decorator: decorator,
        decoratorKey: decoratorKey,
        direction: direction,
        leafSet: leafSet,
        text: text,
        key: ii
      });
    }).toArray();
    return React.createElement("div", {
      "data-offset-key": DraftOffsetKey.encode(blockKey, 0, 0),
      className: cx({
        'public/DraftStyleDefault/block': true,
        'public/DraftStyleDefault/ltr': direction === 'LTR',
        'public/DraftStyleDefault/rtl': direction === 'RTL'
      })
    }, children);
  };

  return DraftEditorNode;
}(React.Component);

module.exports = DraftEditorNode;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftOffsetKey = __webpack_require__(44);

var React = __webpack_require__(0);

var UnicodeBidi = __webpack_require__(158);

var UnicodeBidiDirection = __webpack_require__(116);

var DraftEditorDecoratedLeaves = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorDecoratedLeaves, _React$Component);

  function DraftEditorDecoratedLeaves() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorDecoratedLeaves.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        children = _this$props.children,
        contentState = _this$props.contentState,
        decorator = _this$props.decorator,
        decoratorKey = _this$props.decoratorKey,
        direction = _this$props.direction,
        leafSet = _this$props.leafSet,
        text = _this$props.text;
    var blockKey = block.getKey();
    var leavesForLeafSet = leafSet.get('leaves');
    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
    var decoratorProps = decorator.getPropsForKey(decoratorKey);
    var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, parseInt(decoratorKey, 10), 0);
    var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
    // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

    var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), direction);
    return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
      contentState: contentState,
      decoratedText: decoratedText,
      dir: dir,
      key: decoratorOffsetKey,
      entityKey: block.getEntityAt(leafSet.get('start')),
      offsetKey: decoratorOffsetKey
    }), children);
  };

  return DraftEditorDecoratedLeaves;
}(React.Component);

module.exports = DraftEditorDecoratedLeaves;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);

var UserAgent = __webpack_require__(23);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(60); // In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.


var useNewlineChar = UserAgent.isBrowser('IE <= 11');
/**
 * Check whether the node should be considered a newline.
 */

function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}
/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */


var NEWLINE_A = function NEWLINE_A(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "A",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "A",
    "data-text": "true",
    ref: ref
  });
};

var NEWLINE_B = function NEWLINE_B(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "B",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "B",
    "data-text": "true",
    ref: ref
  });
};

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.

    _defineProperty(_assertThisInitialized(_this), "_forceFlag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    _this._forceFlag = false;
    return _this;
  }

  var _proto = DraftEditorTextNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = this._node;
    var shouldBeNewline = nextProps.children === '';
    !isElement(node) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    var elementNode = node;

    if (shouldBeNewline) {
      return !isNewline(elementNode);
    }

    return elementNode.textContent !== nextProps.children;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A(function (ref) {
        return _this2._node = ref;
      }) : NEWLINE_B(function (ref) {
        return _this2._node = ref;
      });
    }

    return React.createElement("span", {
      key: this._forceFlag ? 'A' : 'B',
      "data-text": "true",
      ref: function ref(_ref) {
        return _this2._node = _ref;
      }
    }, this.props.children);
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEffects = __webpack_require__(272);

var DraftJsDebugLogging = __webpack_require__(264);

var UserAgent = __webpack_require__(23);

var containsNode = __webpack_require__(161);

var getActiveElement = __webpack_require__(273);

var getCorrectDocumentFromNode = __webpack_require__(118);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(60);

var isIE = UserAgent.isBrowser('IE');

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);

  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !isElement(anonymized) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  var castedElement = anonymized;
  return castedElement.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return getCorrectDocumentFromNode(node).createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();

  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }

  var childNodes = node.childNodes;

  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node; // this should only be used after checking with isElement

  var castedNode = currentNode;

  while (currentNode) {
    if (isElement(currentNode) && castedNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
      castedNode = currentNode;
    }
  }

  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */


function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  var documentObject = getCorrectDocumentFromNode(node);

  if (!containsNode(documentObject.documentElement, node)) {
    return;
  }

  var selection = documentObject.defaultView.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
  // and be done.

  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    } // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.


    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    } // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.


    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
/**
 * Extend selection towards focus point.
 */


function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  var extend = selection.extend; // containsNode returns false if node is null.
  // Let's refine the type of this value out here so flow knows.

  if (extend && node != null && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset: offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    } // logging to catch bug that is being reported in t18110632


    var nodeWasFocus = node === selection.focusNode;

    try {
      // Fixes some reports of "InvalidStateError: Failed to execute 'extend' on
      // 'Selection': This Selection object doesn't have any Ranges."
      // Note: selection.extend does not exist in IE.
      if (selection.rangeCount > 0 && selection.extend) {
        selection.extend(node, offset);
      }
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];

          if (n === activeElement) {
            labels.push('active element');
          }

          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }

          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }

          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      }); // allow the error to be thrown -
      // better than continuing in a broken state

      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    if (node && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      range.setEnd(node, offset);
      selection.addRange(range.cloneRange());
    }
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = getCorrectDocumentFromNode(node).createRange(); // logging to catch bug that is being reported in t16250795

  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset: offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
    DraftEffects.handleExtensionCausedError();
  }

  range.setStart(node, offset); // IE sometimes throws Unspecified Error when trying to addRange

  if (isIE) {
    try {
      selection.addRange(range);
    } catch (e) {
      if (false) {
        /* eslint-disable-next-line no-console */
        console.warn('Call to selection.addRange() threw exception: ', e);
      }
    }
  } else {
    selection.addRange(range);
  }
}

module.exports = {
  setDraftEditorSelection: setDraftEditorSelection,
  addFocusToSelection: addFocusToSelection
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var isNode = __webpack_require__(768);
/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */


function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var camelize = __webpack_require__(770);

var hyphenate = __webpack_require__(771);

function asString(value)
/*?string*/
{
  return value == null ? value : String(value);
}

function getStyleProperty(
/*DOMNode*/
node,
/*string*/
name)
/*?string*/
{
  var computedStyle; // W3C Standard

  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  } // Safari


  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }

    if (name === 'display') {
      return 'none';
    }
  } // Internet Explorer


  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }

    return asString(node.currentStyle[camelize(name)]);
  }

  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */

function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */

function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var containsNode = __webpack_require__(161);
/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */


function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.

  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  } // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode


  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getDocumentScrollElement(doc) {
  doc = doc || document;

  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }

  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }

  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(13);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(276);

var DraftOffsetKey = __webpack_require__(44);

var React = __webpack_require__(0);

var cx = __webpack_require__(59);

var joinClasses = __webpack_require__(776);

var nullthrows = __webpack_require__(22);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth >= 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};
/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */


var DraftEditorContents = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContents.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        preventScroll = _this$props.preventScroll,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];
    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];

      var key = _block.getKey();

      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;

      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        offsetKey: offsetKey,
        preventScroll: preventScroll,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };
      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();

      var _className = '';

      if (blockStyleFn) {
        _className = blockStyleFn(_block);
      } // List items are special snowflakes, since we handle nesting and
      // counters manually.


      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: _className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };

      if (customEditable !== undefined) {
        childProps = _objectSpread({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps,
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
       * comment suppresses an error found when Flow v0.112 was deployed. To
       * see the error delete this comment and run Flow. */
      React.createElement(Component, _extends({}, componentProps, {
        key: key
      })));
      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }

      lastWrapperTemplate = wrapperTemplate;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Combines multiple className strings into one.
 */

function joinClasses(className) {
  var newClassName = className || '';
  var argLength = arguments.length;

  if (argLength > 1) {
    for (var index = 1; index < argLength; index++) {
      var nextClass = arguments[index];

      if (nextClass) {
        newClassName = (newClassName ? newClassName + ' ' : '') + nextClass;
      }
    }
  }

  return newClassName;
}

module.exports = joinClasses;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DataTransfer = __webpack_require__(277);

var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var findAncestorOffsetKey = __webpack_require__(117);

var getCorrectDocumentFromNode = __webpack_require__(118);

var getTextContentFromFiles = __webpack_require__(279);

var getUpdatedSelectionState = __webpack_require__(268);

var getWindowForNode = __webpack_require__(262);

var isEventHandled = __webpack_require__(122);

var nullthrows = __webpack_require__(22);
/**
 * Get a SelectionState for the supplied mouse event.
 */


function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;
  var eventTargetDocument = getCorrectDocumentFromNode(event.currentTarget);
  /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
   * suppresses an error found when Flow v0.68 was deployed. To see the error
   * delete this comment and run Flow. */

  if (typeof eventTargetDocument.caretRangeFromPoint === 'function') {
    /* $FlowFixMe[incompatible-use] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */
    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));
  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
    endDrag(editor);
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor._dragCount = 0;
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();

    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';

    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {// handled
    } else if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
    } else {
      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
    }

    endDrag(editor);
  }
};

function endDrag(editor) {
  editor._internalDrag = false; // Fix issue #1383
  // Prior to React v16.5.0 onDrop breaks onSelect event:
  // https://github.com/facebook/react/issues/11379.
  // Dispatching a mouseup event on DOM node will make it go back to normal.

  var editorNode = editor.editorContainer;

  if (editorNode) {
    var mouseUpEvent = new MouseEvent('mouseup', {
      view: getWindowForNode(editorNode),
      bubbles: true,
      cancelable: true
    });
    editorNode.dispatchEvent(mouseUpEvent);
  }
}

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}
/**
 * Insert text at a specified selection.
 */


function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var invariant = __webpack_require__(9);
/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */


function toArray(obj) {
  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).

  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.

  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {// IE < 9 does not support Array#slice on collections objects
    }
  } // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.


  var ret = Array(length);

  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }

  return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */


function hasArrayNature(obj) {
  return (// not null/false
    !!obj && ( // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
    'length' in obj && // not window
    !('setInterval' in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && ( // a real array
    Array.isArray(obj) || // arguments
    'callee' in obj || // HTMLCollection/NodeList
    'item' in obj)
  );
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */


function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(23);

var onBeforeInput = __webpack_require__(781);

var onBlur = __webpack_require__(785);

var onCompositionStart = __webpack_require__(786);

var onCopy = __webpack_require__(787);

var onCut = __webpack_require__(788);

var onDragOver = __webpack_require__(790);

var onDragStart = __webpack_require__(791);

var onFocus = __webpack_require__(792);

var onInput = __webpack_require__(793);

var onKeyDown = __webpack_require__(794);

var onPaste = __webpack_require__(808);

var onSelect = __webpack_require__(263);

var isChrome = UserAgent.isBrowser('Chrome');
var isFirefox = UserAgent.isBrowser('Firefox');
var selectionHandler = isChrome || isFirefox ? onSelect : function (e) {};
var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: selectionHandler,
  onKeyUp: selectionHandler
};
module.exports = DraftEditorEditHandler;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var UserAgent = __webpack_require__(23);

var getEntityKeyForSelection = __webpack_require__(160);

var isEventHandled = __webpack_require__(122);

var isSelectionAtLeafStart = __webpack_require__(782);

var nullthrows = __webpack_require__(22);

var setImmediate = __webpack_require__(783); // When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.


var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */


function replaceText(editorState, text, inlineStyle, entityKey, forceSelection) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters', forceSelection);
}
/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */


function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;
  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.

  if (!chars) {
    return;
  } // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.


  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
    e.preventDefault();
    return;
  } // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.


  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();
    editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), true));
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), false); // Bunch of different cases follow where we need to prevent native insertion.

  var mustPreventNative = false;

  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }

  if (!mustPreventNative) {
    // Let's say we have a decorator that highlights hashtags. In many cases
    // we need to prevent native behavior and rerender ourselves --
    // particularly, any case *except* where the inserted characters end up
    // anywhere except exactly where you put them.
    //
    // Using [] to denote a decorated leaf, some examples:
    //
    // 1. 'hi #' and append 'f'
    // desired rendering: 'hi [#f]'
    // native rendering would be: 'hi #f' (incorrect)
    //
    // 2. 'x [#foo]' and insert '#' before 'f'
    // desired rendering: 'x #[#foo]'
    // native rendering would be: 'x [##foo]' (incorrect)
    //
    // 3. '[#foobar]' and insert ' ' between 'foo' and 'bar'
    // desired rendering: '[#foo] bar'
    // native rendering would be: '[#foo bar]' (incorrect)
    //
    // 4. '[#foo]' and delete '#' [won't use this beforeinput codepath though]
    // desired rendering: 'foo'
    // native rendering would be: '[foo]' (incorrect)
    //
    // 5. '[#foo]' and append 'b'
    // desired rendering: '[#foob]'
    // native rendering would be: '[#foob]'
    // (native insertion here would be ok for decorators like simple spans,
    // but not more complex decorators. To be safe, we need to prevent it.)
    //
    // It is safe to allow native insertion if and only if the full list of
    // decorator ranges matches what we expect native insertion to give, and
    // the range lengths have not changed. We don't need to compare the content
    // because the only possible mutation to consider here is inserting plain
    // text and decorators can't affect text content.
    var oldBlockTree = editorState.getBlockTree(anchorKey);
    var newBlockTree = newEditorState.getBlockTree(anchorKey);
    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function (_ref) {
      var oldLeafSet = _ref[0],
          newLeafSet = _ref[1];
      // selectionStart is guaranteed to be selectionEnd here
      var oldStart = oldLeafSet.get('start');
      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
      var oldEnd = oldLeafSet.get('end');
      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
      var newStart = newLeafSet.get('start');
      var newEnd = newLeafSet.get('end');
      var newDecoratorKey = newLeafSet.get('decoratorKey');
      return (// Different decorators
        oldLeafSet.get('decoratorKey') !== newDecoratorKey || // Different number of inline styles
        oldLeafSet.get('leaves').size !== newLeafSet.get('leaves').size || // Different effective decorator position
        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
      );
    });
  }

  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }

  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    newEditorState = EditorState.set(newEditorState, {
      forceSelection: true
    });
    editor.update(newEditorState);
    return;
  } // We made it all the way! Let the browser do its thing and insert the char.


  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  }); // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.

  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');

        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });
  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
 // setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(784);

module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(79)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

var containsNode = __webpack_require__(161);

var getActiveElement = __webpack_require__(273);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  var ownerDocument = e.currentTarget.ownerDocument;

  if ( // This ESLint rule conflicts with `sketchy-null-bool` flow check
  // eslint-disable-next-line no-extra-boolean-cast
  !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body) {
    var _selection = ownerDocument.defaultView.getSelection();

    var editorNode = editor.editor;

    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */


function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, {
    inCompositionMode: true
  })); // Allow composition handler to interpret the compositionstart event

  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getFragmentFromSelection = __webpack_require__(280);
/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */


function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var Style = __webpack_require__(120);

var getFragmentFromSelection = __webpack_require__(280);

var getScrollPosition = __webpack_require__(121);

var isNode = __webpack_require__(789);
/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */


function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition; // No selection, so there's nothing to cut.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  } // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.


  if (isNode(element)) {
    var node = element;
    scrollPosition = getScrollPosition(Style.getScrollParent(node));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isInstanceOfNode(target) {
  // we changed the name because of having duplicate module provider (fbjs)
  if (!target || !('ownerDocument' in target)) {
    return false;
  }

  if ('ownerDocument' in target) {
    var node = target;

    if (!node.ownerDocument.defaultView) {
      return node instanceof Node;
    }

    if (node instanceof node.ownerDocument.defaultView.Node) {
      return true;
    }
  }

  return false;
}

module.exports = isInstanceOfNode;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

var UserAgent = __webpack_require__(23);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.

  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var DraftOffsetKey = __webpack_require__(44);

var EditorState = __webpack_require__(10);

var UserAgent = __webpack_require__(23);

var _require = __webpack_require__(269),
    notEmptyKey = _require.notEmptyKey;

var findAncestorOffsetKey = __webpack_require__(117);

var keyCommandPlainBackspace = __webpack_require__(281);

var nullthrows = __webpack_require__(22);

var isGecko = UserAgent.isEngine('Gecko');
var DOUBLE_NEWLINE = '\n\n';

function onInputType(inputType, editorState) {
  switch (inputType) {
    case 'deleteContentBackward':
      return keyCommandPlainBackspace(editorState);
  }

  return editorState;
}
/**
 * This function serves two purposes
 *
 * 1. To update the editorState and call onChange method with the new
 * editorState. This editorState is calculated in editOnBeforeInput but the
 * onChange method is not called with the new state until this method does it.
 * It is done to handle a specific case where certain character inputs might
 * be replaced with something else. E.g. snippets ('rc' might be replaced
 * with boilerplate code for react component). More information on the
 * exact problem can be found here -
 * https://github.com/facebook/draft-js/commit/07892ba479bd4dfc6afd1e0ed179aaf51cd138b1
 *
 * 2. intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */


function editOnInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  } // at this point editor is not null for sure (after input)


  var castedEditorElement = editor.editor;
  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;
  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;

  if (anchorNode == null || isNotTextOrElementNode) {
    // TODO: (t16149272) figure out context for this change
    return;
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;

    if (span == null) {
      // Handle null-parent case.
      return;
    }

    anchorNode.nodeValue = span.textContent;

    for (var child = span.firstChild; child != null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.

  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  } // No change -- the DOM is up to date. Nothing to do here.


  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly.
    // Newest versions of Android support the dom-inputevent-inputtype
    // and we can use the `inputType` to properly apply the state changes.

    /* $FlowFixMe[prop-missing] inputType is only defined on a draft of a
     * standard. https://w3c.github.io/input-events/#dom-inputevent-inputtype
     */
    var inputType = e.nativeEvent.inputType;

    if (inputType) {
      var newEditorState = onInputType(inputType, editorState);

      if (newEditorState !== editorState) {
        editor.restoreEditorDOM();
        editor.update(newEditorState);
        return;
      }
    }

    return;
  }

  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
  var entityType = entity != null ? entity.getMutability() : null;
  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.

  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  } // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.


  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset: anchorOffset,
      focusOffset: focusOffset
    })
  });
  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var KeyBindingUtil = __webpack_require__(165);

var Keys = __webpack_require__(119);

var SecondaryClipboard = __webpack_require__(796);

var UserAgent = __webpack_require__(23);

var isEventHandled = __webpack_require__(122);

var keyCommandBackspaceToStartOfLine = __webpack_require__(797);

var keyCommandBackspaceWord = __webpack_require__(799);

var keyCommandDeleteWord = __webpack_require__(801);

var keyCommandInsertNewline = __webpack_require__(802);

var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(803);

var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(804);

var keyCommandPlainBackspace = __webpack_require__(281);

var keyCommandPlainDelete = __webpack_require__(805);

var keyCommandTransposeCharacters = __webpack_require__(806);

var keyCommandUndo = __webpack_require__(807);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
var isChrome = UserAgent.isBrowser('Chrome');
/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */

function onKeyCommand(command, editorState, e) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);

    case 'delete':
      return keyCommandPlainDelete(editorState);

    case 'delete-word':
      return keyCommandDeleteWord(editorState);

    case 'backspace':
      return keyCommandPlainBackspace(editorState);

    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);

    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState, e);

    case 'split-block':
      return keyCommandInsertNewline(editorState);

    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);

    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);

    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);

    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);

    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);

    default:
      return editorState;
  }
}
/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */


function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  function callDeprecatedHandler(handlerName) {
    var deprecatedHandler = editor.props[handlerName];

    if (deprecatedHandler) {
      deprecatedHandler(e);
      return true;
    } else {
      return false;
    }
  }

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault(); // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.

      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }

      break;

    case Keys.ESC:
      e.preventDefault();

      if (callDeprecatedHandler('onEscape')) {
        return;
      }

      break;

    case Keys.TAB:
      if (callDeprecatedHandler('onTab')) {
        return;
      }

      break;

    case Keys.UP:
      if (callDeprecatedHandler('onUpArrow')) {
        return;
      }

      break;

    case Keys.RIGHT:
      if (callDeprecatedHandler('onRightArrow')) {
        return;
      }

      break;

    case Keys.DOWN:
      if (callDeprecatedHandler('onDownArrow')) {
        return;
      }

      break;

    case Keys.LEFT:
      if (callDeprecatedHandler('onLeftArrow')) {
        return;
      }

      break;

    case Keys.SPACE:
      // Prevent Chrome on OSX behavior where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
      }

  }

  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

  if (command == null || command === '') {
    if (keyCode === Keys.SPACE && isChrome && isOptionKeyCommand(e)) {
      // The default keydown event has already been prevented in order to stop
      // Chrome from scrolling. Insert a nbsp into the editor as OSX would for
      // other browsers.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), "\xA0");
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
    }

    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  } // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.


  e.preventDefault(); // Allow components higher up the tree to handle the command first.

  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
    return;
  }

  var newState = onKeyCommand(command, editorState, e);

  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Keys = __webpack_require__(119);

function isSoftNewlineEvent(e) {
  return e.which === Keys.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
}

module.exports = isSoftNewlineEvent;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var getContentStateFragment = __webpack_require__(113);

var nullthrows = __webpack_require__(22);

var clipboard = null;
/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */

var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        var keyAfter = content.getKeyAfter(anchorKey);

        if (keyAfter == null) {
          return editorState;
        }

        targetRange = selection.set('focusKey', keyAfter).set('focusOffset', 0);
      } else {
        targetRange = selection.set('focusOffset', blockEnd);
      }
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange); // TODO: This should actually append to the current state when doing
    // successive ^K commands without any other cursor movement

    clipboard = getContentStateFragment(content, targetRange);
    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};
module.exports = SecondaryClipboard;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

var expandRangeToStartOfLine = __webpack_require__(798);

var getDraftEditorSelectionWithNodes = __webpack_require__(267);

var moveSelectionBackward = __webpack_require__(163);

var removeTextWithStrategy = __webpack_require__(92);

function keyCommandBackspaceToStartOfLine(editorState, e) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();

    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var ownerDocument = e.currentTarget.ownerDocument;
    var domSelection = ownerDocument.defaultView.getSelection(); // getRangeAt can technically throw if there's no selection, but we know
    // there is one here because text editor has focus (the cursor is a
    // selection of length 0). Therefore, we don't need to wrap this in a
    // try-catch block.

    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);
    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var UnicodeUtils = __webpack_require__(61);

var getCorrectDocumentFromNode = __webpack_require__(118);

var getRangeClientRects = __webpack_require__(282);

var invariant = __webpack_require__(9);
/**
 * Return the computed line height, in pixels, for the provided element.
 */


function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var correctDocument = getCorrectDocumentFromNode(element);
  var div = correctDocument.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';
  var documentBody = correctDocument.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0; // forced layout here

  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */


function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];

    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }

    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
/**
 * Return the length of a node, as used by Range offsets.
 */


function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;

    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;

    default:
      return node.childNodes.length;
  }
}
/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */


function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;

  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }

  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);

    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  } // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.
  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.


  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;
    var ii = maxIndexToConsider;

    for (; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);

      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(283);

var EditorState = __webpack_require__(10);

var moveSelectionBackward = __webpack_require__(163);

var removeTextWithStrategy = __webpack_require__(92);
/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */


function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */
 // \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + "\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]";
module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(283);

var EditorState = __webpack_require__(10);

var moveSelectionForward = __webpack_require__(284);

var removeTextWithStrategy = __webpack_require__(92);
/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */


function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.

    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);
/**
 * See comment for `moveSelectionToStartOfBlock`.
 */


function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);
/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */


function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

var UnicodeUtils = __webpack_require__(61);

var moveSelectionForward = __webpack_require__(284);

var removeTextWithStrategy = __webpack_require__(92);
/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(21);

var EditorState = __webpack_require__(10);

var getContentStateFragment = __webpack_require__(113);
/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */


function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();

  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength(); // Nothing to transpose if there aren't two characters.

  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  } // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.


  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(10);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.

  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, {
      nativelyRenderedContent: nativelyRenderedContent
    }));
    return;
  } // Otheriwse, manage the undo behavior manually.


  e.preventDefault();

  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  } // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.


  updateFn(EditorState.set(editorState, {
    nativelyRenderedContent: null
  })); // Wait to ensure that the re-render has occurred before performing
  // the undo action.

  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(89);

var CharacterMetadata = __webpack_require__(37);

var DataTransfer = __webpack_require__(277);

var DraftModifier = __webpack_require__(21);

var DraftPasteProcessor = __webpack_require__(809);

var EditorState = __webpack_require__(10);

var RichTextEditorUtil = __webpack_require__(287);

var getEntityKeyForSelection = __webpack_require__(160);

var getTextContentFromFiles = __webpack_require__(279);

var isEventHandled = __webpack_require__(122);

var splitTextIntoTextBlocks = __webpack_require__(814);
/**
 * Paste content.
 */


function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();

    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (
      /*string*/
      fileText) {
        fileText = fileText || defaultFileText;

        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);
        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });
      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.formatPastedText) {
    var _editor$props$formatP = editor.props.formatPastedText(text, html),
        formattedText = _editor$props$formatP.text,
        formattedHtml = _editor$props$formatP.html;

    text = formattedText;
    html = formattedHtml;
  }

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();

    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
      var _html;

      if ( // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    } // If there is html paste data, try to parse that.


    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);

      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    } // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.


    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var convertFromHTMLToContentBlocks = __webpack_require__(285);

var generateRandomKey = __webpack_require__(42);

var getSafeBodyFromHTML = __webpack_require__(286);

var gkx = __webpack_require__(50);

var Immutable = __webpack_require__(8);

var sanitizeDraftText = __webpack_require__(259);

var List = Immutable.List,
    Repeat = Immutable.Repeat;
var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      }; // next block updates previous block

      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1; // update previous block

        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _objectSpread({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  }
};
module.exports = DraftPasteProcessor;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var URI =
/*#__PURE__*/
function () {
  function URI(uri) {
    _defineProperty(this, "_uri", void 0);

    this._uri = uri;
  }

  var _proto = URI.prototype;

  _proto.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(60);

function isHTMLAnchorElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'A';
}

module.exports = isHTMLAnchorElement;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(60);

function isHTMLImageElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'IMG';
}

module.exports = isHTMLImageElement;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var ReactDOMComet = __webpack_require__(14);

var flushControlled = ReactDOMComet.unstable_flushControlled;
module.exports = flushControlled;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(59);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorPlaceholder.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  _proto.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });
    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };
    return React.createElement("div", {
      className: className
    }, React.createElement("div", {
      className: cx('public/DraftEditorPlaceholder/inner'),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var DraftStringKey = __webpack_require__(289);

var encodeEntityRanges = __webpack_require__(819);

var encodeInlineStyleRanges = __webpack_require__(820);

var invariant = __webpack_require__(9);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
  var parentKey = block.getParentKey();

  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

      var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
      // erroneously having the same key

      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }

      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode

      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
}; // Flip storage map so that our storage keys map to global
// DraftEntity keys.


var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  }; // add blocks

  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = __webpack_require__(289);

var UnicodeUtils = __webpack_require__(61);

var strlen = UnicodeUtils.strlen;
/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function (
  /*number*/
  start,
  /*number*/
  end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(61);

var findRangesImmutable = __webpack_require__(90);

var areEqual = function areEqual(a, b) {
  return a === b;
};

var isTruthy = function isTruthy(a) {
  return !!a;
};

var EMPTY_ARRAY = [];
/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */

function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = []; // Obtain an array with ranges for only the specified style.

  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });
  return ranges;
}
/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */


function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(58);

var ContentBlockNode = __webpack_require__(38);

var ContentState = __webpack_require__(157);

var DraftEntity = __webpack_require__(114);

var DraftTreeAdapter = __webpack_require__(822);

var DraftTreeInvariants = __webpack_require__(823);

var SelectionState = __webpack_require__(115);

var createCharacterList = __webpack_require__(824);

var decodeEntityRanges = __webpack_require__(825);

var decodeInlineStyleRanges = __webpack_require__(826);

var generateRandomKey = __webpack_require__(42);

var gkx = __webpack_require__(50);

var Immutable = __webpack_require__(8);

var invariant = __webpack_require__(9);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;

var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;
  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _objectSpread({}, range, {
      key: entityMap[range.key]
    });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _objectSpread({}, block, {
    key: block.key || generateRandomKey()
  });
};
/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */


var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _objectSpread({}, block, {
      parentRef: parentRef
    });
  }); // since we pop nodes from the stack we need to insert them in reverse

  return stack.concat(nodesWithParentRef.reverse());
};
/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */


var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0; // ensure children have valid keys to enable sibling links

    var children = block.children.map(addKeyIfMissing); // root level nodes

    var contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    })); // push root node to blockMap

    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();

      var _index = siblings.indexOf(node.key);

      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      } // ensure children have valid keys to enable sibling links


      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      })); // push node to blockMap


      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = rawState.blocks.find(function (block) {
    return Array.isArray(block.children) && block.children.length > 0;
  });
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap); // in dev mode, check that the tree invariants are met

  if (false) {
    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should be a valid tree') : invariant(false) : void 0;
  }

  return blockMap;
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });
  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0; // decode entities

  var entityMap = decodeRawEntityMap(rawState); // decode blockMap

  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var generateRandomKey = __webpack_require__(42);

var invariant = __webpack_require__(9);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();

  while (stack.length) {
    var _block = stack.pop();

    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }

  var type = block.type;
  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _objectSpread({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */


var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _objectSpread({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block); // if it's a non-leaf node, we don't do anything else

        if (block.children != null && block.children.length > 0) {
          return;
        }
      }

      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _objectSpread({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },

  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var transformedBlocks = [];
    var parentStack = [];
    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;

      var treeBlock = _objectSpread({}, block, {
        children: []
      });

      if (!isList) {
        transformedBlocks.push(treeBlock);
        return;
      }

      var lastParent = parentStack[0]; // block is non-nested & there are no nested blocks, directly push block

      if (lastParent == null && depth === 0) {
        transformedBlocks.push(treeBlock); // block is first nested block or previous nested block is at a lower level
      } else if (lastParent == null || lastParent.depth < depth - 1) {
        // create new parent block
        var newParent = {
          key: generateRandomKey(),
          text: '',
          depth: depth - 1,
          type: block.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        parentStack.unshift(newParent);

        if (depth === 1) {
          // add as a root-level block
          transformedBlocks.push(newParent);
        } else if (lastParent != null) {
          // depth > 1 => also add as previous parent's child
          lastParent.children.push(newParent);
        }

        newParent.children.push(treeBlock);
      } else if (lastParent.depth === depth - 1) {
        // add as child of last parent
        lastParent.children.push(treeBlock);
      } else {
        // pop out parents at levels above this one from the parent stack
        while (lastParent != null && lastParent.depth >= depth) {
          parentStack.shift();
          lastParent = parentStack[0];
        }

        if (depth > 0) {
          lastParent.children.push(treeBlock);
        } else {
          transformedBlocks.push(treeBlock);
        }
      }
    });
    return _objectSpread({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
module.exports = DraftTreeAdapter;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var warning = __webpack_require__(164);

var DraftTreeInvariants = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function isValidBlock(block, blockMap) {
    var key = block.getKey(); // is its parent's child

    var parentKey = block.getParentKey();

    if (parentKey != null) {
      var parent = blockMap.get(parentKey);

      if (!parent.getChildKeys().includes(key)) {
         false ? warning(true, 'Tree is missing parent -> child pointer on %s', key) : void 0;
        return false;
      }
    } // is its children's parent


    var children = block.getChildKeys().map(function (k) {
      return blockMap.get(k);
    });

    if (!children.every(function (c) {
      return c.getParentKey() === key;
    })) {
       false ? warning(true, 'Tree is missing child -> parent pointer on %s', key) : void 0;
      return false;
    } // is its previous sibling's next sibling


    var prevSiblingKey = block.getPrevSiblingKey();

    if (prevSiblingKey != null) {
      var prevSibling = blockMap.get(prevSiblingKey);

      if (prevSibling.getNextSiblingKey() !== key) {
         false ? warning(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
        return false;
      }
    } // is its next sibling's previous sibling


    var nextSiblingKey = block.getNextSiblingKey();

    if (nextSiblingKey != null) {
      var nextSibling = blockMap.get(nextSiblingKey);

      if (nextSibling.getPrevSiblingKey() !== key) {
         false ? warning(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
        return false;
      }
    } // no 2-node cycles


    if (nextSiblingKey !== null && prevSiblingKey !== null) {
      if (prevSiblingKey === nextSiblingKey) {
         false ? warning(true, 'Tree has a two-node cycle at %s', key) : void 0;
        return false;
      }
    } // if it's a leaf node, it has text but no children


    if (block.text != '') {
      if (block.getChildKeys().size > 0) {
         false ? warning(true, 'Leaf node %s has children', key) : void 0;
        return false;
      }
    }

    return true;
  },

  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function isConnectedTree(blockMap) {
    // exactly one node has no previous sibling + no parent
    var eligibleFirstNodes = blockMap.toArray().filter(function (block) {
      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
    });

    if (eligibleFirstNodes.length !== 1) {
       false ? warning(true, 'Tree is not connected. More or less than one first node') : void 0;
      return false;
    }

    var firstNode = eligibleFirstNodes.shift();
    var nodesSeen = 0;
    var currentKey = firstNode.getKey();
    var visitedStack = [];

    while (currentKey != null) {
      var currentNode = blockMap.get(currentKey);
      var childKeys = currentNode.getChildKeys();
      var nextSiblingKey = currentNode.getNextSiblingKey(); // if the node has children, add parent's next sibling to stack and go to children

      if (childKeys.size > 0) {
        if (nextSiblingKey != null) {
          visitedStack.unshift(nextSiblingKey);
        }

        var children = childKeys.map(function (k) {
          return blockMap.get(k);
        });

        var _firstNode = children.find(function (block) {
          return block.getPrevSiblingKey() == null;
        });

        if (_firstNode == null) {
           false ? warning(true, '%s has no first child', currentKey) : void 0;
          return false;
        }

        currentKey = _firstNode.getKey(); // TODO(T32490138): Deal with multi-node cycles here
      } else {
        if (currentNode.getNextSiblingKey() != null) {
          currentKey = currentNode.getNextSiblingKey();
        } else {
          currentKey = visitedStack.shift();
        }
      }

      nodesSeen++;
    }

    if (nodesSeen !== blockMap.size) {
       false ? warning(true, 'Tree is not connected. %s nodes were seen instead of %s', nodesSeen, blockMap.size) : void 0;
      return false;
    }

    return true;
  },

  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function isValidTree(blockMap) {
    var _this = this;

    var blocks = blockMap.toArray();

    if (!blocks.every(function (block) {
      return _this.isValidBlock(block, blockMap);
    })) {
      return false;
    }

    return this.isConnectedTree(blockMap);
  }
};
module.exports = DraftTreeInvariants;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(37);

var Immutable = __webpack_require__(8);

var List = Immutable.List;

function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({
      style: style,
      entity: entity
    });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(61);

var substr = UnicodeUtils.substr;
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);

  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;

      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }

  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(61);

var _require = __webpack_require__(8),
    OrderedSet = _require.OrderedSet;

var substr = UnicodeUtils.substr;
var EMPTY_SET = OrderedSet();
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);

  if (ranges) {
    ranges.forEach(function (range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;

      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }

  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeBoundingClientRect = __webpack_require__(828);
/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 *
 * When using from an iframe, you should pass the iframe window object
 */


function getVisibleSelectionRect(global) {
  var selection = global.getSelection();

  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeClientRects = __webpack_require__(282);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];

      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(251),__webpack_require__(8)):"function"==typeof define&&define.amd?define(["react","draft-js","immutable"],e):"object"==typeof exports?exports.reactDraftWysiwyg=e(require("react"),require("draft-js"),require("immutable")):t.reactDraftWysiwyg=e(t.react,t["draft-js"],t.immutable)}(window,function(n,o,r){return a={},i.m=c=[function(t,e,n){t.exports=n(10)()},function(t,e){t.exports=n},function(t,e,n){var o;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";var c={}.hasOwnProperty;function a(){for(var t=[],e=0;e<arguments.length;e++){var n=arguments[e];if(n){var o=typeof n;if("string"==o||"number"==o)t.push(n);else if(Array.isArray(n)&&n.length){var r=a.apply(null,n);r&&t.push(r)}else if("object"==o)for(var i in n)c.call(n,i)&&n[i]&&t.push(i)}}return t.join(" ")}t.exports?(a.default=a,t.exports=a):void 0===(o=function(){return a}.apply(e,[]))||(t.exports=o)}()},function(t,e){t.exports=o},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(3),i=n(5),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var M=n(0),i=n(1);function j(t){var e=t.getSelection(),n=t.getCurrentContent(),o=e.getStartKey(),r=e.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(t,e){return e===o}).takeUntil(function(t,e){return e===r}).concat([[r,i.get(r)]])}function u(t){return j(t).toList()}function l(t){if(t)return u(t).get(0)}function o(t){if(t){var n=l(t),e=t.getCurrentContent().getBlockMap().toSeq().toList(),o=0;if(e.forEach(function(t,e){t.get("key")===n.get("key")&&(o=e-1)}),-1<o)return e.get(o)}}function r(t){return t?t.getCurrentContent().getBlockMap().toList():new i.List}function c(t){var e=u(t);if(!e.some(function(t){return t.type!==e.get(0).type}))return e.get(0).type}function a(t){var e=M.RichUtils.tryToRemoveBlockStyle(t);return e?M.EditorState.push(t,e,"change-block-type"):t}function s(t){var e="",n=t.getSelection(),o=n.getAnchorOffset(),r=n.getFocusOffset(),i=u(t);if(0<i.size){if(n.getIsBackward()){var c=o;o=r,r=c}for(var a=0;a<i.size;a+=1){var l=0===a?o:0,s=a===i.size-1?r:i.get(a).getText().length;e+=i.get(a).getText().slice(l,s)}}return e}function p(t){var e=t.getCurrentContent(),n=t.getSelection(),o=M.Modifier.removeRange(e,n,"forward"),r=o.getSelectionAfter(),i=o.getBlockForKey(r.getStartKey());return o=M.Modifier.insertText(o,r,"\n",i.getInlineStyleAt(r.getStartOffset()),null),M.EditorState.push(t,o,"insert-fragment")}function d(t){var e=M.Modifier.splitBlock(t.getCurrentContent(),t.getSelection());return a(M.EditorState.push(t,e,"split-block"))}function f(t){var e=t.getCurrentContent().getBlockMap().toList(),n=t.getSelection().merge({anchorKey:e.first().get("key"),anchorOffset:0,focusKey:e.last().get("key"),focusOffset:e.last().getLength()}),o=M.Modifier.removeRange(t.getCurrentContent(),n,"forward");return M.EditorState.push(t,o,"remove-range")}function y(t,e){var n=M.Modifier.setBlockData(t.getCurrentContent(),t.getSelection(),e);return M.EditorState.push(t,n,"change-block-data")}function m(t){var o=new i.Map({}),e=u(t);if(e&&0<e.size)for(var n=function(t){var n=e.get(t).getData();if(!n||0===n.size)return o=o.clear(),"break";if(0===t)o=n;else if(o.forEach(function(t,e){n.get(e)&&n.get(e)===t||(o=o.delete(e))}),0===o.size)return o=o.clear(),"break"},r=0;r<e.size&&"break"!==n(r);r+=1);return o}var g=Object(i.Map)({code:{element:"pre"}}),b=M.DefaultDraftBlockRenderMap.merge(g);function h(t){if(t){var e=t.getType();return"unordered-list-item"===e||"ordered-list-item"===e}return!1}function v(t,e,n){var o,r=t.getSelection();o=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var i=t.getCurrentContent(),c=i.getBlockForKey(o),a=c.getType();if("unordered-list-item"!==a&&"ordered-list-item"!==a)return t;var l=i.getBlockBefore(o);if(!l)return t;if(l.getType()!==a)return t;var s=c.getDepth();if(1===e&&s===n)return t;var u,p,d,f,y,m,g,b=Math.min(l.getDepth()+1,n),h=(p=e,d=b,f=(u=t).getSelection(),y=u.getCurrentContent(),m=y.getBlockMap(),g=j(u).map(function(t){var e=t.getDepth()+p;return e=Math.max(0,Math.min(e,d)),t.set("depth",e)}),m=m.merge(g),y.merge({blockMap:m,selectionBefore:f,selectionAfter:f}));return M.EditorState.push(t,h,"adjust-depth")}function N(t,e){var n;return 13===(n=e).which&&(n.getModifierState("Shift")||n.getModifierState("Alt")||n.getModifierState("Control"))?t.getSelection().isCollapsed()?M.RichUtils.insertSoftNewline(t):p(t):function(t){var e=t.getSelection();if(e.isCollapsed()){var n=t.getCurrentContent(),o=e.getStartKey(),r=n.getBlockForKey(o);if(!h(r)&&"unstyled"!==r.getType()&&r.getLength()===e.getStartOffset())return d(t);if(h(r)&&0===r.getLength()){var i=r.getDepth();if(0===i)return a(t);if(0<i)return v(t,-1,i)}}}(t)}function E(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function S(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function w(t){return(w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function C(t){var e=t.getSelection();if(e.isCollapsed()){var n={},o=t.getCurrentInlineStyle().toList().toJS();if(o)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=0<=o.indexOf(t)}),n}var c=e.getStartOffset(),a=e.getEndOffset(),l=u(t);if(0<l.size){var r=function(){for(var n={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},o=0;o<l.size;o+=1){var t=0===o?c:0,e=o===l.size-1?a:l.get(o).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var r=function(t){var e=l.get(o).getInlineStyleAt(t);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=n[t]&&e.get(t)===t})},i=t;i<e;i+=1)r(i)}return{v:n}}();if("object"===w(r))return r.v}return{}}function L(t){var e,n=t.getSelection(),o=n.getStartOffset(),r=n.getEndOffset();o===r&&0===o?r=1:o===r&&--o;for(var i=l(t),c=o;c<r;c+=1){var a=i.getEntityAt(c);if(!a){e=void 0;break}if(c===o)e=a;else if(e!==a){e=void 0;break}}return e}function D(t,e){var n,o=l(t);return o.findEntityRanges(function(t){return t.get("entity")===e},function(t,e){n={start:t,end:e,text:o.get("text").slice(t,e)}}),n}function k(t,e,n){x[t]["".concat(t.toLowerCase(),"-").concat(n)]=S({},"".concat(e),n)}function O(){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E(Object(n),!0).forEach(function(t){S(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},x.color,{},x.bgcolor,{},x.fontSize,{},x.fontFamily,{CODE:x.CODE,SUPERSCRIPT:x.SUPERSCRIPT,SUBSCRIPT:x.SUBSCRIPT})}var x={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}};function I(t,e,n){var o=t.getSelection(),r=Object.keys(x[e]).reduce(function(t,e){return M.Modifier.removeInlineStyle(t,o,e)},t.getCurrentContent()),i=M.EditorState.push(t,r,"changeinline-style"),c=t.getCurrentInlineStyle();if(o.isCollapsed()&&(i=c.reduce(function(t,e){return M.RichUtils.toggleInlineStyle(t,e)},i)),"SUPERSCRIPT"===e||"SUBSCRIPT"==e)c.has(n)||(i=M.RichUtils.toggleInlineStyle(i,n));else{var a="bgcolor"===e?"backgroundColor":e;c.has("".concat(a,"-").concat(n))||(i=M.RichUtils.toggleInlineStyle(i,"".concat(e.toLowerCase(),"-").concat(n)),k(e,a,n))}return i}function T(t){t&&t.getCurrentContent().getBlockMap().map(function(t){return t.get("characterList")}).toList().flatten().forEach(function(t){t&&0===t.indexOf("color-")?k("color","color",t.substr(6)):t&&0===t.indexOf("bgcolor-")?k("bgcolor","backgroundColor",t.substr(8)):t&&0===t.indexOf("fontsize-")?k("fontSize","fontSize",+t.substr(9)):t&&0===t.indexOf("fontfamily-")&&k("fontFamily","fontFamily",t.substr(11))})}function A(t,e,n){var o=t.getInlineStyleAt(n).toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(o&&0<o.size)return o.get(0)}function z(o,s){if(o&&s&&0<s.length){var t=function(){var t=o.getSelection(),i={};if(t.isCollapsed())return s.forEach(function(t){i[t]=function(t,e){var n=t.getCurrentInlineStyle().toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(n&&0<n.size)return n.get(0)}(o,t)}),{v:i};var c=t.getStartOffset(),a=t.getEndOffset(),l=u(o);if(0<l.size){for(var e=function(n){var t=0===n?c:0,e=n===l.size-1?a:l.get(n).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var o=function(e){e===t?s.forEach(function(t){i[t]=A(l.get(n),t,e)}):s.forEach(function(t){i[t]&&i[t]!==A(l.get(n),t,e)&&(i[t]=void 0)})},r=t;r<e;r+=1)o(r)},n=0;n<l.size;n+=1)e(n);return{v:i}}}();if("object"===w(t))return t.v}return{}}function _(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=M.Modifier.removeInlineStyle(n,e.getSelection(),t)}),M.EditorState.push(e,n,"change-inline-style")}n.d(e,"isListBlock",function(){return h}),n.d(e,"changeDepth",function(){return v}),n.d(e,"handleNewLine",function(){return N}),n.d(e,"getEntityRange",function(){return D}),n.d(e,"getCustomStyleMap",function(){return O}),n.d(e,"toggleCustomInlineStyle",function(){return I}),n.d(e,"getSelectionEntity",function(){return L}),n.d(e,"extractInlineStyle",function(){return T}),n.d(e,"removeAllInlineStyles",function(){return _}),n.d(e,"getSelectionInlineStyle",function(){return C}),n.d(e,"getSelectionCustomInlineStyle",function(){return z}),n.d(e,"getSelectedBlocksMap",function(){return j}),n.d(e,"getSelectedBlocksList",function(){return u}),n.d(e,"getSelectedBlock",function(){return l}),n.d(e,"getBlockBeforeSelectedBlock",function(){return o}),n.d(e,"getAllBlocks",function(){return r}),n.d(e,"getSelectedBlocksType",function(){return c}),n.d(e,"removeSelectedBlocksStyle",function(){return a}),n.d(e,"getSelectionText",function(){return s}),n.d(e,"addLineBreakRemovingSelection",function(){return p}),n.d(e,"insertNewUnstyledBlock",function(){return d}),n.d(e,"clearEditorContent",function(){return f}),n.d(e,"setBlockData",function(){return y}),n.d(e,"getSelectedBlocksMetadata",function(){return m}),n.d(e,"blockRenderMap",function(){return b})}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e){t.exports=r},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(5),i=n(3),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var j=n(1),s=n(0),v=function(t,e,n){var o,r=t.textContent;return""===r.trim()?{chunk:(o=n,{text:" ",inlines:[new s.OrderedSet],entities:[o],blocks:[]})}:{chunk:{text:r,inlines:Array(r.length).fill(e),entities:Array(r.length).fill(n),blocks:[]}}},N=function(){return{text:"\n",inlines:[new s.OrderedSet],entities:new Array(1),blocks:[]}},E=function(){return{text:"",inlines:[],entities:[],blocks:[]}},S=function(t,e){return{text:"",inlines:[],entities:[],blocks:[{type:t,depth:0,data:e||new s.Map({})}]}},w=function(t,e,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:t,depth:Math.max(0,Math.min(4,e)),data:n||new s.Map({})}]}},C=function(t){return{text:"\r ",inlines:[new s.OrderedSet],entities:[t],blocks:[{type:"atomic",depth:0,data:new s.Map({})}]}},L=function(t,e){return{text:t.text+e.text,inlines:t.inlines.concat(e.inlines),entities:t.entities.concat(e.entities),blocks:t.blocks.concat(e.blocks)}},D=new s.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}}),k={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function O(t){return t.style.textAlign?new s.Map({"text-align":t.style.textAlign}):t.style.marginLeft?new s.Map({"margin-left":t.style.marginLeft}):void 0}var x=function(t){var e=void 0;if(t instanceof HTMLAnchorElement){var n={};e=t.dataset&&void 0!==t.dataset.mention?(n.url=t.href,n.text=t.innerHTML,n.value=t.dataset.value,j.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=t.getAttribute&&t.getAttribute("href")||t.href,n.title=t.innerHTML,n.targetOption=t.target,j.Entity.__create("LINK","MUTABLE",n))}return e};n.d(e,"default",function(){return o});var u=" ",p=new RegExp("&nbsp;","g"),I=!0;function o(t,e){var n,o,r,i=(n=e,o=t.trim().replace(p,u),(r=function(t){var e,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((e=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=t,n=e.getElementsByTagName("body")[0]),n}(o))?(I=!0,{chunk:function t(e,n,o,r,i,c){var a=e.nodeName.toLowerCase();if(c){var l=c(a,e);if(l){var s=j.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:C(s)}}}if("#text"===a&&"\n"!==e.textContent)return v(e,n,i);if("br"===a)return{chunk:N()};if("img"===a&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var p=j.Entity.__create("IMAGE","MUTABLE",u);return{chunk:C(p)}}if("video"===a&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=j.Entity.__create("VIDEO","MUTABLE",d);return{chunk:C(f)}}if("iframe"===a&&e instanceof HTMLIFrameElement){var y={};y.src=e.getAttribute&&e.getAttribute("src")||e.src,y.height=e.height,y.width=e.width;var m=j.Entity.__create("EMBEDDED_LINK","MUTABLE",y);return{chunk:C(m)}}var g,b=function(e,n){var t=D.filter(function(t){return t.element===e&&(!t.wrapper||t.wrapper===n)||t.wrapper===e||t.aliasedElements&&-1<t.aliasedElements.indexOf(e)}).keySeq().toSet().toArray();if(1===t.length)return t[0]}(a,r);b&&("ul"===a||"ol"===a?(r=a,o+=1):("unordered-list-item"!==b&&"ordered-list-item"!==b&&(r="",o=-1),I?(g=S(b,O(e)),I=!1):g=w(b,o,O(e)))),g=g||E(),n=function(t,e,n){var o,r=k[t];if(r)o=n.add(r).toOrderedSet();else if(e instanceof HTMLElement){var l=e;o=(o=n).withMutations(function(t){var e=l.style.color,n=l.style.backgroundColor,o=l.style.fontSize,r=l.style.fontFamily.replace(/^"|"$/g,""),i=l.style.fontWeight,c=l.style.textDecoration,a=l.style.fontStyle;e&&t.add("color-".concat(e.replace(/ /g,""))),n&&t.add("bgcolor-".concat(n.replace(/ /g,""))),o&&t.add("fontsize-".concat(o.replace(/px$/g,""))),r&&t.add("fontfamily-".concat(r)),"bold"===i&&t.add(k.strong),"underline"===c&&t.add(k.ins),"italic"===a&&t.add(k.em)}).toOrderedSet()}return o}(a,e,n);for(var h=e.firstChild;h;){var M=t(h,n,o,r,x(h)||i,c).chunk;g=L(g,M),h=h.nextSibling}return{chunk:g}}(r,new s.OrderedSet,-1,"",void 0,n).chunk}):null);if(i){var c=i.chunk,a=new s.OrderedMap({});c.entities&&c.entities.forEach(function(t){t&&(a=a.set(t,j.Entity.__get(t)))});var l=0;return{contentBlocks:c.text.split("\r").map(function(t,e){var n=l+t.length,o=c&&c.inlines.slice(l,n),r=c&&c.entities.slice(l,n),i=new s.List(o.map(function(t,e){var n={style:t,entity:null};return r[e]&&(n.entity=r[e]),j.CharacterMetadata.create(n)}));return l=n,new j.ContentBlock({key:Object(j.genKey)(),type:c&&c.blocks[e]&&c.blocks[e].type||"unstyled",depth:c&&c.blocks[e]&&c.blocks[e].depth,data:c&&c.blocks[e]&&c.blocks[e].data||new s.Map({}),text:t,characterList:i})}),entityMap:a}}return null}}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e,l){"use strict";function o(n){return Array.prototype.slice.call(arguments,1).forEach(function(e){e&&Object.keys(e).forEach(function(t){n[t]=e[t]})}),n}function s(t){return Object.prototype.toString.call(t)}function u(t){return"[object Function]"===s(t)}function p(t){return t.replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}var r={fuzzyLink:!0,fuzzyEmail:!0,fuzzyIP:!1};var i={"http:":{validate:function(t,e,n){var o=t.slice(e);return n.re.http||(n.re.http=new RegExp("^\\/\\/"+n.re.src_auth+n.re.src_host_port_strict+n.re.src_path,"i")),n.re.http.test(o)?o.match(n.re.http)[0].length:0}},"https:":"http:","ftp:":"http:","//":{validate:function(t,e,n){var o=t.slice(e);return n.re.no_http||(n.re.no_http=new RegExp("^"+n.re.src_auth+"(?:localhost|(?:(?:"+n.re.src_domain+")\\.)+"+n.re.src_domain_root+")"+n.re.src_port+n.re.src_host_terminator+n.re.src_path,"i")),n.re.no_http.test(o)?3<=e&&":"===t[e-3]?0:3<=e&&"/"===t[e-3]?0:o.match(n.re.no_http)[0].length:0}},"mailto:":{validate:function(t,e,n){var o=t.slice(e);return n.re.mailto||(n.re.mailto=new RegExp("^"+n.re.src_email_name+"@"+n.re.src_host_strict,"i")),n.re.mailto.test(o)?o.match(n.re.mailto)[0].length:0}}},d="a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",c="biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");function f(){return function(t,e){e.normalize(t)}}function a(r){var e=r.re=l(21)(r.__opts__),t=r.__tlds__.slice();function n(t){return t.replace("%TLDS%",e.src_tlds)}r.onCompile(),r.__tlds_replaced__||t.push(d),t.push(e.src_xn),e.src_tlds=t.join("|"),e.email_fuzzy=RegExp(n(e.tpl_email_fuzzy),"i"),e.link_fuzzy=RegExp(n(e.tpl_link_fuzzy),"i"),e.link_no_ip_fuzzy=RegExp(n(e.tpl_link_no_ip_fuzzy),"i"),e.host_fuzzy_test=RegExp(n(e.tpl_host_fuzzy_test),"i");var i=[];function c(t,e){throw new Error('(LinkifyIt) Invalid schema "'+t+'": '+e)}r.__compiled__={},Object.keys(r.__schemas__).forEach(function(t){var e=r.__schemas__[t];if(null!==e){var o,n={validate:null,link:null};if(r.__compiled__[t]=n,"[object Object]"===s(e))return"[object RegExp]"===s(e.validate)?n.validate=(o=e.validate,function(t,e){var n=t.slice(e);return o.test(n)?n.match(o)[0].length:0}):u(e.validate)?n.validate=e.validate:c(t,e),void(u(e.normalize)?n.normalize=e.normalize:e.normalize?c(t,e):n.normalize=f());if("[object String]"!==s(e))c(t,e);else i.push(t)}}),i.forEach(function(t){r.__compiled__[r.__schemas__[t]]&&(r.__compiled__[t].validate=r.__compiled__[r.__schemas__[t]].validate,r.__compiled__[t].normalize=r.__compiled__[r.__schemas__[t]].normalize)}),r.__compiled__[""]={validate:null,normalize:f()};var o,a=Object.keys(r.__compiled__).filter(function(t){return 0<t.length&&r.__compiled__[t]}).map(p).join("|");r.re.schema_test=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","i"),r.re.schema_search=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","ig"),r.re.pretest=RegExp("("+r.re.schema_test.source+")|("+r.re.host_fuzzy_test.source+")|@","i"),(o=r).__index__=-1,o.__text_cache__=""}function y(t,e){var n=t.__index__,o=t.__last_index__,r=t.__text_cache__.slice(n,o);this.schema=t.__schema__.toLowerCase(),this.index=n+e,this.lastIndex=o+e,this.raw=r,this.text=r,this.url=r}function m(t,e){var n=new y(t,e);return t.__compiled__[n.schema].normalize(n,t),n}function g(t,e){if(!(this instanceof g))return new g(t,e);var n;e||(n=t,Object.keys(n||{}).reduce(function(t,e){return t||r.hasOwnProperty(e)},!1)&&(e=t,t={})),this.__opts__=o({},r,e),this.__index__=-1,this.__last_index__=-1,this.__schema__="",this.__text_cache__="",this.__schemas__=o({},i,t),this.__compiled__={},this.__tlds__=c,this.__tlds_replaced__=!1,this.re={},a(this)}g.prototype.add=function(t,e){return this.__schemas__[t]=e,a(this),this},g.prototype.set=function(t){return this.__opts__=o(this.__opts__,t),this},g.prototype.test=function(t){if(this.__text_cache__=t,this.__index__=-1,!t.length)return!1;var e,n,o,r,i,c,a,l;if(this.re.schema_test.test(t))for((a=this.re.schema_search).lastIndex=0;null!==(e=a.exec(t));)if(r=this.testSchemaAt(t,e[2],a.lastIndex)){this.__schema__=e[2],this.__index__=e.index+e[1].length,this.__last_index__=e.index+e[0].length+r;break}return this.__opts__.fuzzyLink&&this.__compiled__["http:"]&&0<=(l=t.search(this.re.host_fuzzy_test))&&(this.__index__<0||l<this.__index__)&&null!==(n=t.match(this.__opts__.fuzzyIP?this.re.link_fuzzy:this.re.link_no_ip_fuzzy))&&(i=n.index+n[1].length,(this.__index__<0||i<this.__index__)&&(this.__schema__="",this.__index__=i,this.__last_index__=n.index+n[0].length)),this.__opts__.fuzzyEmail&&this.__compiled__["mailto:"]&&0<=t.indexOf("@")&&null!==(o=t.match(this.re.email_fuzzy))&&(i=o.index+o[1].length,c=o.index+o[0].length,(this.__index__<0||i<this.__index__||i===this.__index__&&c>this.__last_index__)&&(this.__schema__="mailto:",this.__index__=i,this.__last_index__=c)),0<=this.__index__},g.prototype.pretest=function(t){return this.re.pretest.test(t)},g.prototype.testSchemaAt=function(t,e,n){return this.__compiled__[e.toLowerCase()]?this.__compiled__[e.toLowerCase()].validate(t,n,this):0},g.prototype.match=function(t){var e=0,n=[];0<=this.__index__&&this.__text_cache__===t&&(n.push(m(this,e)),e=this.__last_index__);for(var o=e?t.slice(e):t;this.test(o);)n.push(m(this,e)),o=o.slice(this.__last_index__),e+=this.__last_index__;return n.length?n:null},g.prototype.tlds=function(t,e){return t=Array.isArray(t)?t:[t],e?this.__tlds__=this.__tlds__.concat(t).sort().filter(function(t,e,n){return t!==n[e-1]}).reverse():(this.__tlds__=t.slice(),this.__tlds_replaced__=!0),a(this),this},g.prototype.normalize=function(t){t.schema||(t.url="http://"+t.url),"mailto:"!==t.schema||/^mailto:/i.test(t.url)||(t.url="mailto:"+t.url)},g.prototype.onCompile=function(){},t.exports=g},function(t,e,n){t.exports=n(40)},function(t,e,n){},function(t,e,n){"use strict";var a=n(11);function o(){}function r(){}r.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,r,i){if(i!==a){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function e(){return t}var n={array:t.isRequired=t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,o){"use strict";t.exports=function(t){var e={};e.src_Any=o(22).source,e.src_Cc=o(23).source,e.src_Z=o(24).source,e.src_P=o(25).source,e.src_ZPCc=[e.src_Z,e.src_P,e.src_Cc].join("|"),e.src_ZCc=[e.src_Z,e.src_Cc].join("|");var n="[><｜]";return e.src_pseudo_letter="(?:(?![><｜]|"+e.src_ZPCc+")"+e.src_Any+")",e.src_ip4="(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",e.src_auth="(?:(?:(?!"+e.src_ZCc+"|[@/\\[\\]()]).)+@)?",e.src_port="(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?",e.src_host_terminator="(?=$|[><｜]|"+e.src_ZPCc+")(?!-|_|:\\d|\\.-|\\.(?!$|"+e.src_ZPCc+"))",e.src_path="(?:[/?#](?:(?!"+e.src_ZCc+"|"+n+"|[()[\\]{}.,\"'?!\\-]).|\\[(?:(?!"+e.src_ZCc+"|\\]).)*\\]|\\((?:(?!"+e.src_ZCc+"|[)]).)*\\)|\\{(?:(?!"+e.src_ZCc+'|[}]).)*\\}|\\"(?:(?!'+e.src_ZCc+'|["]).)+\\"|\\\'(?:(?!'+e.src_ZCc+"|[']).)+\\'|\\'(?="+e.src_pseudo_letter+"|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!"+e.src_ZCc+"|[.]).|"+(t&&t["---"]?"\\-(?!--(?:[^-]|$))(?:-*)|":"\\-+|")+"\\,(?!"+e.src_ZCc+").|\\!(?!"+e.src_ZCc+"|[!]).|\\?(?!"+e.src_ZCc+"|[?]).)+|\\/)?",e.src_email_name='[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*',e.src_xn="xn--[a-z0-9\\-]{1,59}",e.src_domain_root="(?:"+e.src_xn+"|"+e.src_pseudo_letter+"{1,63})",e.src_domain="(?:"+e.src_xn+"|(?:"+e.src_pseudo_letter+")|(?:"+e.src_pseudo_letter+"(?:-|"+e.src_pseudo_letter+"){0,61}"+e.src_pseudo_letter+"))",e.src_host="(?:(?:(?:(?:"+e.src_domain+")\\.)*"+e.src_domain+"))",e.tpl_host_fuzzy="(?:"+e.src_ip4+"|(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%)))",e.tpl_host_no_ip_fuzzy="(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%))",e.src_host_strict=e.src_host+e.src_host_terminator,e.tpl_host_fuzzy_strict=e.tpl_host_fuzzy+e.src_host_terminator,e.src_host_port_strict=e.src_host+e.src_port+e.src_host_terminator,e.tpl_host_port_fuzzy_strict=e.tpl_host_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_port_no_ip_fuzzy_strict=e.tpl_host_no_ip_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_fuzzy_test="localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:"+e.src_ZPCc+"|>|$))",e.tpl_email_fuzzy='(^|[><｜]|"|\\(|'+e.src_ZCc+")("+e.src_email_name+"@"+e.tpl_host_fuzzy_strict+")",e.tpl_link_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_fuzzy_strict+e.src_path+")",e.tpl_link_no_ip_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_no_ip_fuzzy_strict+e.src_path+")",e}},function(t,e){t.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/},function(t,e){t.exports=/[\0-\x1F\x7F-\x9F]/},function(t,e){t.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/},function(t,e){t.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){"use strict";n.r(e),n.d(e,"Editor",function(){return ar});var f=n(1),N=n.n(f),o=n(0),y=n.n(o),E=n(3),S=n(4),r=n(2),w=n.n(r);function i(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function c(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var a=c(function t(){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.callBacks=[],this.suggestionCallback=void 0,this.editorFlag=!1,this.suggestionFlag=!1,this.closeAllModals=function(e){n.callBacks.forEach(function(t){t(e)})},this.init=function(t){var e=document.getElementById(t);e&&e.addEventListener("click",function(){n.editorFlag=!0}),document&&(document.addEventListener("click",function(){n.editorFlag?n.editorFlag=!1:(n.closeAllModals(),n.suggestionCallback&&n.suggestionCallback())}),document.addEventListener("keydown",function(t){"Escape"===t.key&&n.closeAllModals()}))},this.onEditorClick=function(){n.closeModals(),!n.suggestionFlag&&n.suggestionCallback?n.suggestionCallback():n.suggestionFlag=!1},this.closeModals=function(t){n.closeAllModals(t)},this.registerCallBack=function(t){n.callBacks.push(t)},this.deregisterCallBack=function(e){n.callBacks=n.callBacks.filter(function(t){return t!==e})},this.setSuggestionCallback=function(t){n.suggestionCallback=t},this.removeSuggestionCallback=function(){n.suggestionCallback=void 0},this.onSuggestionClick=function(){n.suggestionFlag=!0}});function l(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function s(t,e,n){return e&&l(t.prototype,e),n&&l(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var u,p=s(function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.inputFocused=!1,this.editorMouseDown=!1,this.onEditorMouseDown=function(){e.editorFocused=!0},this.onInputMouseDown=function(){e.inputFocused=!0},this.isEditorBlur=function(t){return"INPUT"!==t.target.tagName&&"LABEL"!==t.target.tagName&&"TEXTAREA"!==t.target.tagName||e.editorFocused?!("INPUT"===t.target.tagName&&"LABEL"===t.target.tagName&&"TEXTAREA"===t.target.tagName||e.inputFocused)&&!(e.editorFocused=!1):!(e.inputFocused=!1)},this.isEditorFocused=function(){return!e.inputFocused||(e.inputFocused=!1)},this.isToolbarFocused=function(){return!e.editorFocused||(e.editorFocused=!1)},this.isInputFocused=function(){return e.inputFocused}}),d=[],C={onKeyDown:function(e){d.forEach(function(t){t(e)})},registerCallBack:function(t){d.push(t)},deregisterCallBack:function(e){d=d.filter(function(t){return t!==e})}},m=function(){u=!0},g=function(){u=!1},b=function(){return u};function L(t){var e=t.getData()&&t.getData().get("text-align");return e?"rdw-".concat(e,"-aligned-block"):""}function h(t,e){if(t)for(var n in t)!{}.hasOwnProperty.call(t,n)||e(n,t[n])}function M(t,e){var n=!1;if(t)for(var o in t)if({}.hasOwnProperty.call(t,o)&&e===o){n=!0;break}return n}function j(t){t.stopPropagation()}function v(t){return t[t.options[0]].icon}function D(t,o){if(t&&void 0===o)return t;var r={};return h(t,function(t,e){var n;n=e,"[object Object]"===Object.prototype.toString.call(n)?r[t]=D(e,o[t]):r[t]=void 0!==o[t]?o[t]:e}),r}var k=n(6),O=n.n(k),x=n(5);n(9);function I(t){return(I="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function A(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function z(t,e){return(z=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function _(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=P(o);if(r){var n=P(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===I(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function P(t){return(P=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var R=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&z(t,e)}(i,f["Component"]);var t,e,n,o=_(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).onClick=function(){var t=r.props,e=t.disabled,n=t.onClick,o=t.value;e||n(o)},r}return t=i,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.className,r=e.activeClassName,i=e.active,c=e.disabled,a=e.title;return N.a.createElement("div",{className:w()("rdw-option-wrapper",o,(T(t={},"rdw-option-active ".concat(r),i),T(t,"rdw-option-disabled",c),t)),onClick:this.onClick,"aria-selected":i,title:a},n)}}])&&A(t.prototype,e),n&&A(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();R.propTypes={onClick:y.a.func.isRequired,children:y.a.any,value:y.a.string,className:y.a.string,activeClassName:y.a.string,active:y.a.bool,disabled:y.a.bool,title:y.a.string},R.defaultProps={activeClassName:""};n(12);function U(t){return(U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function B(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function F(t,e){return(F=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Y(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Q(o);if(r){var n=Q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===U(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Q(t){return(Q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var H=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&F(t,e)}(i,f["Component"]);var t,e,n,r=Y(i);function i(){var o;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(o=r.call.apply(r,[this].concat(e))).state={highlighted:-1},o.onChange=function(t){var e=o.props.onChange;e&&e(t),o.toggleExpansion()},o.setHighlighted=function(t){o.setState({highlighted:t})},o.toggleExpansion=function(){var t=o.props,e=t.doExpand,n=t.doCollapse;t.expanded?n():e()},o}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.expanded;t.expanded&&!e&&this.setState({highlighted:-1})}},{key:"render",value:function(){var n=this,t=this.props,e=t.expanded,o=t.children,r=t.className,i=t.optionWrapperClassName,c=t.ariaLabel,a=t.onExpandEvent,l=t.title,s=this.state.highlighted,u=o.slice(1,o.length);return N.a.createElement("div",{className:w()("rdw-dropdown-wrapper",r),"aria-expanded":e,"aria-label":c||"rdw-dropdown"},N.a.createElement("a",{className:"rdw-dropdown-selectedtext",onClick:a,title:l},o[0],N.a.createElement("div",{className:w()({"rdw-dropdown-carettoclose":e,"rdw-dropdown-carettoopen":!e})})),e?N.a.createElement("ul",{className:w()("rdw-dropdown-optionwrapper",i),onClick:j},N.a.Children.map(u,function(t,e){return t&&N.a.cloneElement(t,{onSelect:n.onChange,highlighted:s===e,setHighlighted:n.setHighlighted,index:e})})):void 0)}}])&&B(t.prototype,e),n&&B(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();H.propTypes={children:y.a.any,onChange:y.a.func,className:y.a.string,expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,optionWrapperClassName:y.a.string,ariaLabel:y.a.string,title:y.a.string};n(13);function Z(t){return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function W(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function G(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function J(t,e){return(J=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function V(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=q(o);if(r){var n=q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Z(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function q(t){return(q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var K=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&J(t,e)}(r,f["Component"]);var t,e,n,o=V(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).onClick=function(t){var e=i.props,n=e.onSelect,o=e.onClick,r=e.value;e.disabled||(n&&n(r),o&&(t.stopPropagation(),o(r)))},i.setHighlighted=function(){var t=i.props;(0,t.setHighlighted)(t.index)},i.resetHighlighted=function(){(0,i.props.setHighlighted)(-1)},i}return t=r,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.active,r=e.disabled,i=e.highlighted,c=e.className,a=e.activeClassName,l=e.disabledClassName,s=e.highlightedClassName,u=e.title;return N.a.createElement("li",{className:w()("rdw-dropdownoption-default",c,(W(t={},"rdw-dropdownoption-active ".concat(a),o),W(t,"rdw-dropdownoption-highlighted ".concat(s),i),W(t,"rdw-dropdownoption-disabled ".concat(l),r),t)),onMouseEnter:this.setHighlighted,onMouseLeave:this.resetHighlighted,onClick:this.onClick,title:u},n)}}])&&G(t.prototype,e),n&&G(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();K.propTypes={children:y.a.any,value:y.a.any,onClick:y.a.func,onSelect:y.a.func,setHighlighted:y.a.func,index:y.a.number,disabled:y.a.bool,active:y.a.bool,highlighted:y.a.bool,className:y.a.string,activeClassName:y.a.string,disabledClassName:y.a.string,highlightedClassName:y.a.string,title:y.a.string},K.defaultProps={activeClassName:"",disabledClassName:"",highlightedClassName:""};n(14);function X(t){return(X="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function tt(t,e){return(tt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function et(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=nt(o);if(r){var n=nt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===X(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var ot=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&tt(t,e)}(r,f["Component"]);var t,e,n,o=et(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,n=t.config,o=t.currentState,r=t.onChange,i=t.translations;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n.className),"aria-label":"rdw-inline-control"},n.options.map(function(t,e){return N.a.createElement(R,{key:e,value:t,onClick:r,className:w()(n[t].className),active:!0===o[t]||"MONOSPACE"===t&&o.CODE,title:n[t].title||i["components.controls.inline.".concat(t)]},N.a.createElement("img",{alt:"",src:n[t].icon}))}))}},{key:"renderInDropDown",value:function(){var t=this.props,n=t.config,e=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=t.onChange,l=t.translations,s=n.className,u=n.dropdownClassName,p=n.title;return N.a.createElement(H,{className:w()("rdw-inline-dropdown",s),optionWrapperClassName:w()(u),onChange:a,expanded:e,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-inline-control",title:p},N.a.createElement("img",{src:v(n),alt:""}),n.options.map(function(t,e){return N.a.createElement(K,{key:e,value:t,className:w()("rdw-inline-dropdownoption",n[t].className),active:!0===c[t]||"MONOSPACE"===t&&c.CODE,title:n[t].title||l["components.controls.inline.".concat(t)]},N.a.createElement("img",{src:n[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&$(t.prototype,e),n&&$(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function rt(t){return(rt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function it(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ct(t,e){return(ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function at(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=lt(o);if(r){var n=lt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===rt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function lt(t){return(lt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}ot.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var st=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ct(t,e)}(i,f["Component"]);var t,e,n,r=at(i);function i(t){var l;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(l=r.call(this,t)).onExpandEvent=function(){l.signalExpanded=!l.state.expanded},l.expandCollapse=function(){l.setState({expanded:l.signalExpanded}),l.signalExpanded=!1},l.toggleInlineStyle=function(t){var e="monospace"===t?"CODE":t.toUpperCase(),n=l.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleInlineStyle(o,e);if("subscript"===t||"superscript"===t){var c="subscript"===t?"SUPERSCRIPT":"SUBSCRIPT",a=E.Modifier.removeInlineStyle(i.getCurrentContent(),i.getSelection(),c);i=E.EditorState.push(i,a,"change-inline-style")}i&&r(i)},l.changeKeys=function(t){if(t){var n={};return h(t,function(t,e){n["CODE"===t?"monospace":t.toLowerCase()]=e}),n}},l.doExpand=function(){l.setState({expanded:!0})},l.doCollapse=function(){l.setState({expanded:!1})};var e=l.props,n=e.editorState,o=e.modalHandler;return l.state={currentStyles:n?l.changeKeys(Object(S.getSelectionInlineStyle)(n)):{}},o.registerCallBack(l.expandCollapse),l}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentStyles:this.changeKeys(Object(S.getSelectionInlineStyle)(e))})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentStyles,c=e.component||ot;return N.a.createElement(c,{config:e,translations:n,currentState:i,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.toggleInlineStyle})}}])&&it(t.prototype,e),n&&it(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();st.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(15);function ut(t){return(ut="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function dt(t,e){return(dt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ft(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=yt(o);if(r){var n=yt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ut(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function yt(t){return(yt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var mt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&dt(t,e)}(r,f["Component"]);var t,e,n,o=ft(r);function r(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(e=o.call(this,t)).getBlockTypes=function(t){return[{label:"Normal",displayName:t["components.controls.blocktype.normal"]},{label:"H1",displayName:t["components.controls.blocktype.h1"]},{label:"H2",displayName:t["components.controls.blocktype.h2"]},{label:"H3",displayName:t["components.controls.blocktype.h3"]},{label:"H4",displayName:t["components.controls.blocktype.h4"]},{label:"H5",displayName:t["components.controls.blocktype.h5"]},{label:"H6",displayName:t["components.controls.blocktype.h6"]},{label:"Blockquote",displayName:t["components.controls.blocktype.blockquote"]},{label:"Code",displayName:t["components.controls.blocktype.code"]}]},e.state={blockTypes:e.getBlockTypes(t.translations)},e}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.translations;e!==t.translations&&this.setState({blockTypes:this.getBlockTypes(e)})}},{key:"renderFlat",value:function(t){var e=this.props,n=e.config.className,o=e.onChange,r=e.currentState.blockType;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n)},t.map(function(t,e){return N.a.createElement(R,{key:e,value:t.label,active:r===t.label,onClick:o},t.displayName)}))}},{key:"renderInDropdown",value:function(t){var e=this.props,n=e.config,o=n.className,r=n.dropdownClassName,i=n.title,c=e.currentState.blockType,a=e.expanded,l=e.doExpand,s=e.onExpandEvent,u=e.doCollapse,p=e.onChange,d=e.translations,f=this.state.blockTypes.filter(function(t){return t.label===c}),y=f&&f[0]&&f[0].displayName;return N.a.createElement("div",{className:"rdw-block-wrapper","aria-label":"rdw-block-control"},N.a.createElement(H,{className:w()("rdw-block-dropdown",o),optionWrapperClassName:w()(r),onChange:p,expanded:a,doExpand:l,doCollapse:u,onExpandEvent:s,title:i||d["components.controls.blocktype.blocktype"]},N.a.createElement("span",null,y||d["components.controls.blocktype.blocktype"]),t.map(function(t,e){return N.a.createElement(K,{active:c===t.label,value:t.label,key:e},t.displayName)})))}},{key:"render",value:function(){var n=this.props.config,t=n.inDropdown,e=this.state.blockTypes.filter(function(t){var e=t.label;return-1<n.options.indexOf(e)});return t?this.renderInDropdown(e):this.renderFlat(e)}}])&&pt(t.prototype,e),n&&pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();mt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var gt=mt;function bt(t){return(bt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Mt(t,e){return(Mt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function jt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=vt(o);if(r){var n=vt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===bt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function vt(t){return(vt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Nt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Mt(t,e)}(r,f["Component"]);var t,e,n,o=jt(r);function r(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(c=o.call(this,t)).onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.blocksTypes=[{label:"Normal",style:"unstyled"},{label:"H1",style:"header-one"},{label:"H2",style:"header-two"},{label:"H3",style:"header-three"},{label:"H4",style:"header-four"},{label:"H5",style:"header-five"},{label:"H6",style:"header-six"},{label:"Blockquote",style:"blockquote"},{label:"Code",style:"code"}],c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleBlockType=function(e){var t=c.blocksTypes.find(function(t){return t.label===e}).style,n=c.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleBlockType(o,t);i&&r(i)};var e=t.editorState,n=t.modalHandler;return c.state={expanded:!1,currentBlockType:e?Object(S.getSelectedBlocksType)(e):"unstyled"},n.registerCallBack(c.expandCollapse),c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlockType:Object(S.getSelectedBlocksType)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentBlockType,c=e.component||gt,a=this.blocksTypes.find(function(t){return t.style===i});return N.a.createElement(c,{config:e,translations:n,currentState:{blockType:a&&a.label},onChange:this.toggleBlockType,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&ht(t.prototype,e),n&&ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Nt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Et=Nt;n(16);function St(t){return(St="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Ct(t,e){return(Ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Dt(o);if(r){var n=Dt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===St(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Dt(t){return(Dt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var kt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Ct(t,e)}(i,f["Component"]);var t,e,n,r=Lt(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontSize:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-size");e=e.substring(0,e.length-2),this.setState({defaultFontSize:e})}}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.dropdownClassName,i=e.options,c=e.title,a=t.onChange,l=t.expanded,s=t.doCollapse,u=t.onExpandEvent,p=t.doExpand,d=t.translations,f=this.props.currentState.fontSize,y=this.state.defaultFontSize;return y=Number(y),f=f||i&&0<=i.indexOf(y)&&y,N.a.createElement("div",{className:"rdw-fontsize-wrapper","aria-label":"rdw-font-size-control"},N.a.createElement(H,{className:w()("rdw-fontsize-dropdown",o),optionWrapperClassName:w()(r),onChange:a,expanded:l,doExpand:p,doCollapse:s,onExpandEvent:u,title:c||d["components.controls.fontsize.fontsize"]},f?N.a.createElement("span",null,f):N.a.createElement("img",{src:n,alt:""}),i.map(function(t,e){return N.a.createElement(K,{className:"rdw-fontsize-option",active:f===t,value:t,key:e},t)})))}}])&&wt(t.prototype,e),n&&wt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function Ot(t){return(Ot="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function It(t,e){return(It=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Tt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=At(o);if(r){var n=At(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ot(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function At(t){return(At=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}kt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var zt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&It(t,e)}(r,f["Component"]);var t,e,n,o=Tt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontSize=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontSize",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontSize:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontSize:Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontSize,c=e.component||kt,a=i&&Number(i.substring(9));return N.a.createElement(c,{config:e,translations:n,currentState:{fontSize:a},onChange:this.toggleFontSize,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&xt(t.prototype,e),n&&xt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();zt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(17);function _t(t){return(_t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rt(t,e){return(Rt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ut(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bt(o);if(r){var n=Bt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_t(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bt(t){return(Bt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ft=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rt(t,e)}(i,f["Component"]);var t,e,n,r=Ut(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontFamily:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-family");this.setState({defaultFontFamily:e})}}},{key:"render",value:function(){var e=this.state.defaultFontFamily,t=this.props,n=t.config,o=n.className,r=n.dropdownClassName,i=n.options,c=n.title,a=t.translations,l=t.onChange,s=t.expanded,u=t.doCollapse,p=t.onExpandEvent,d=t.doExpand,f=this.props.currentState.fontFamily;return f=f||i&&e&&i.some(function(t){return t.toLowerCase()===e.toLowerCase()})&&e,N.a.createElement("div",{className:"rdw-fontfamily-wrapper","aria-label":"rdw-font-family-control"},N.a.createElement(H,{className:w()("rdw-fontfamily-dropdown",o),optionWrapperClassName:w()("rdw-fontfamily-optionwrapper",r),onChange:l,expanded:s,doExpand:d,doCollapse:u,onExpandEvent:p,title:c||a["components.controls.fontfamily.fontfamily"]},N.a.createElement("span",{className:"rdw-fontfamily-placeholder"},f||a["components.controls.fontfamily.fontfamily"]),i.map(function(t,e){return N.a.createElement(K,{active:f===t,value:t,key:e},t)})))}}])&&Pt(t.prototype,e),n&&Pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Ft.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var Yt=Ft;function Qt(t){return(Qt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Zt(t,e){return(Zt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Wt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Gt(o);if(r){var n=Gt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Qt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Gt(t){return(Gt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Jt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Zt(t,e)}(r,f["Component"]);var t,e,n,o=Wt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontFamily=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontFamily",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontFamily:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontFamily:Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontFamily,c=e.component||Yt,a=i&&i.substring(11);return N.a.createElement(c,{translations:n,config:e,currentState:{fontFamily:a},onChange:this.toggleFontFamily,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Ht(t.prototype,e),n&&Ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Jt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(18);function Vt(t){return(Vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Kt(t,e){return(Kt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Xt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=$t(o);if(r){var n=$t(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function $t(t){return($t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var te=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Kt(t,e)}(i,f["Component"]);var t,e,n,r=Xt(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).options=["unordered","ordered","indent","outdent"],e.toggleBlockType=function(t){(0,e.props.onChange)(t)},e.indent=function(){(0,e.props.onChange)("indent")},e.outdent=function(){(0,e.props.onChange)("outdent")},e}return t=i,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=t.currentState.listType,o=t.translations,r=t.indentDisabled,i=t.outdentDisabled,c=e.options,a=e.unordered,l=e.ordered,s=e.indent,u=e.outdent,p=e.className;return N.a.createElement("div",{className:w()("rdw-list-wrapper",p),"aria-label":"rdw-list-control"},0<=c.indexOf("unordered")&&N.a.createElement(R,{value:"unordered",onClick:this.toggleBlockType,className:w()(a.className),active:"unordered"===n,title:a.title||o["components.controls.list.unordered"]},N.a.createElement("img",{src:a.icon,alt:""})),0<=c.indexOf("ordered")&&N.a.createElement(R,{value:"ordered",onClick:this.toggleBlockType,className:w()(l.className),active:"ordered"===n,title:l.title||o["components.controls.list.ordered"]},N.a.createElement("img",{src:l.icon,alt:""})),0<=c.indexOf("indent")&&N.a.createElement(R,{onClick:this.indent,disabled:r,className:w()(s.className),title:s.title||o["components.controls.list.indent"]},N.a.createElement("img",{src:s.icon,alt:""})),0<=c.indexOf("outdent")&&N.a.createElement(R,{onClick:this.outdent,disabled:i,className:w()(u.className),title:u.title||o["components.controls.list.outdent"]},N.a.createElement("img",{src:u.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var n=this,t=this.props,o=t.config,e=t.expanded,r=t.doCollapse,i=t.doExpand,c=t.onExpandEvent,a=t.onChange,l=t.currentState.listType,s=t.translations,u=o.options,p=o.className,d=o.dropdownClassName,f=o.title;return N.a.createElement(H,{className:w()("rdw-list-dropdown",p),optionWrapperClassName:w()(d),onChange:a,expanded:e,doExpand:i,doCollapse:r,onExpandEvent:c,"aria-label":"rdw-list-control",title:f||s["components.controls.list.list"]},N.a.createElement("img",{src:v(o),alt:""}),this.options.filter(function(t){return 0<=u.indexOf(t)}).map(function(t,e){return N.a.createElement(K,{key:e,value:t,disabled:n.props["".concat(t,"Disabled")],className:w()("rdw-list-dropdownOption",o[t].className),active:l===t,title:o[t].title||s["components.controls.list.".concat(t)]},N.a.createElement("img",{src:o[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&qt(t.prototype,e),n&&qt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function ee(t){return(ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ne(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function oe(t,e){return(oe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ie(o);if(r){var n=ie(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ee(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ie(t){return(ie=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}te.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object,indentDisabled:y.a.bool,outdentDisabled:y.a.bool};var ce=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&oe(t,e)}(c,f["Component"]);var t,e,n,r=re(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){"unordered"===t?i.toggleBlockType("unordered-list-item"):"ordered"===t?i.toggleBlockType("ordered-list-item"):"indent"===t?i.adjustDepth(1):i.adjustDepth(-1)},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleBlockType=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=E.RichUtils.toggleBlockType(o,t);r&&n(r)},i.adjustDepth=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=Object(S.changeDepth)(o,t,4);r&&n(r)},i.isIndentDisabled=function(){var t=i.props.editorState,e=i.state.currentBlock,n=Object(S.getBlockBeforeSelectedBlock)(t);return!n||!Object(S.isListBlock)(e)||n.get("type")!==e.get("type")||n.get("depth")<e.get("depth")},i.isOutdentDisabled=function(){var t=i.state.currentBlock;return!t||!Object(S.isListBlock)(t)||t.get("depth")<=0};var e=i.props,n=e.editorState,o=e.modalHandler;return i.state={expanded:!1,currentBlock:n?Object(S.getSelectedBlock)(n):void 0},o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlock:Object(S.getSelectedBlock)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t,e=this.props,n=e.config,o=e.translations,r=this.state,i=r.expanded,c=r.currentBlock,a=n.component||te;"unordered-list-item"===c.get("type")?t="unordered":"ordered-list-item"===c.get("type")&&(t="ordered");var l=this.isIndentDisabled(),s=this.isOutdentDisabled();return N.a.createElement(a,{config:n,translations:o,currentState:{listType:t},expanded:i,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange,indentDisabled:l,outdentDisabled:s})}}])&&ne(t.prototype,e),n&&ne(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();ce.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(19);function ae(t){return(ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function se(t,e){return(se=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ue(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=pe(o);if(r){var n=pe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ae(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function pe(t){return(pe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var de=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&se(t,e)}(r,f["Component"]);var t,e,n,o=ue(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.left,r=e.center,i=e.right,c=e.justify,a=e.className,l=t.onChange,s=t.currentState.textAlignment,u=t.translations;return N.a.createElement("div",{className:w()("rdw-text-align-wrapper",a),"aria-label":"rdw-textalign-control"},0<=n.indexOf("left")&&N.a.createElement(R,{value:"left",className:w()(o.className),active:"left"===s,onClick:l,title:o.title||u["components.controls.textalign.left"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("center")&&N.a.createElement(R,{value:"center",className:w()(r.className),active:"center"===s,onClick:l,title:r.title||u["components.controls.textalign.center"]},N.a.createElement("img",{src:r.icon,alt:""})),0<=n.indexOf("right")&&N.a.createElement(R,{value:"right",className:w()(i.className),active:"right"===s,onClick:l,title:i.title||u["components.controls.textalign.right"]},N.a.createElement("img",{src:i.icon,alt:""})),0<=n.indexOf("justify")&&N.a.createElement(R,{value:"justify",className:w()(c.className),active:"justify"===s,onClick:l,title:c.title||u["components.controls.textalign.justify"]},N.a.createElement("img",{src:c.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState.textAlignment,a=t.onChange,l=t.translations,s=e.options,u=e.left,p=e.center,d=e.right,f=e.justify,y=e.className,m=e.dropdownClassName,g=e.title;return N.a.createElement(H,{className:w()("rdw-text-align-dropdown",y),optionWrapperClassName:w()(m),onChange:a,expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-textalign-control",title:g||l["components.controls.textalign.textalign"]},N.a.createElement("img",{src:c&&e[c]&&e[c].icon||v(e),alt:""}),0<=s.indexOf("left")&&N.a.createElement(K,{value:"left",active:"left"===c,className:w()("rdw-text-align-dropdownOption",u.className),title:u.title||l["components.controls.textalign.left"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("center")&&N.a.createElement(K,{value:"center",active:"center"===c,className:w()("rdw-text-align-dropdownOption",p.className),title:p.title||l["components.controls.textalign.center"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=s.indexOf("right")&&N.a.createElement(K,{value:"right",active:"right"===c,className:w()("rdw-text-align-dropdownOption",d.className),title:d.title||l["components.controls.textalign.right"]},N.a.createElement("img",{src:d.icon,alt:""})),0<=s.indexOf("justify")&&N.a.createElement(K,{value:"justify",active:"justify"===c,className:w()("rdw-text-align-dropdownOption",f.className),title:f.title||l["components.controls.textalign.justify"]},N.a.createElement("img",{src:f.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&le(t.prototype,e),n&&le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function fe(t){return(fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ye(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function me(t,e){return(me=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ge(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=be(o);if(r){var n=be(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===fe(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function be(t){return(be=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}de.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var he=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&me(t,e)}(i,f["Component"]);var t,e,n,o=ge(i);function i(t){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(r=o.call(this,t)).onExpandEvent=function(){r.signalExpanded=!r.state.expanded},r.expandCollapse=function(){r.setState({expanded:r.signalExpanded}),r.signalExpanded=!1},r.doExpand=function(){r.setState({expanded:!0})},r.doCollapse=function(){r.setState({expanded:!1})},r.addBlockAlignmentData=function(t){var e=r.props,n=e.editorState,o=e.onChange;o(r.state.currentTextAlignment!==t?Object(S.setBlockData)(n,{"text-align":t}):Object(S.setBlockData)(n,{"text-align":void 0}))};var e=r.props.modalHandler;return r.state={currentTextAlignment:void 0},e.registerCallBack(r.expandCollapse),r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e!==t.editorState&&this.setState({currentTextAlignment:Object(S.getSelectedBlocksMetadata)(e).get("text-align")})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentTextAlignment,c=e.component||de;return N.a.createElement(c,{config:e,translations:n,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{textAlignment:i},onChange:this.addBlockAlignmentData})}}])&&ye(t.prototype,e),n&&ye(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();he.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(20);function Me(t){return(Me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function je(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ve(t,e){return(ve=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ne(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ee(o);if(r){var n=Ee(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Me(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ee(t){return(Ee=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Se=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ve(t,e)}(r,f["Component"]);var t,e,n,o=Ne(r);function r(){var u;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(u=o.call.apply(o,[this].concat(e))).state={currentStyle:"color"},u.onChange=function(t){(0,u.props.onChange)(u.state.currentStyle,t)},u.setCurrentStyleColor=function(){u.setState({currentStyle:"color"})},u.setCurrentStyleBgcolor=function(){u.setState({currentStyle:"bgcolor"})},u.renderModal=function(){var t=u.props,e=t.config,n=e.popupClassName,o=e.colors,r=t.currentState,i=r.color,c=r.bgColor,a=t.translations,l=u.state.currentStyle,s="color"===l?i:c;return N.a.createElement("div",{className:w()("rdw-colorpicker-modal",n),onClick:j},N.a.createElement("span",{className:"rdw-colorpicker-modal-header"},N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"color"===l}),onClick:u.setCurrentStyleColor},a["components.controls.colorpicker.text"]),N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"bgcolor"===l}),onClick:u.setCurrentStyleBgcolor},a["components.controls.colorpicker.background"])),N.a.createElement("span",{className:"rdw-colorpicker-modal-options"},o.map(function(t,e){return N.a.createElement(R,{value:t,key:e,className:"rdw-colorpicker-option",activeClassName:"rdw-colorpicker-option-active",active:s===t,onClick:u.onChange},N.a.createElement("span",{style:{backgroundColor:t},className:"rdw-colorpicker-cube"}))})))},u}return t=r,(e=[{key:"componentDidUpdate",value:function(t){this.props.expanded&&!t.expanded&&this.setState({currentStyle:"color"})}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-colorpicker-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-color-picker",title:r||a["components.controls.colorpicker.colorpicker"]},N.a.createElement(R,{onClick:c,className:w()(o)},N.a.createElement("img",{src:n,alt:""})),i?this.renderModal():void 0)}}])&&je(t.prototype,e),n&&je(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Se.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var we=Se;function Ce(t){return(Ce="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function De(t,e){return(De=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ke(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Oe(o);if(r){var n=Oe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ce(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Oe(t){return(Oe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&De(t,e)}(i,f["Component"]);var t,e,n,r=ke(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).state={expanded:!1,currentColor:void 0,currentBgColor:void 0},c.onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleColor=function(t,e){var n=c.props,o=n.editorState,r=n.onChange,i=Object(S.toggleCustomInlineStyle)(o,t,e);i&&r(i),c.doCollapse()};var e=t.editorState,n=t.modalHandler,o={expanded:!1,currentColor:void 0,currentBgColor:void 0};return e&&(o.currentColor=Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,o.currentBgColor=Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR),c.state=o,n.registerCallBack(c.expandCollapse),c}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentColor:Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,currentBgColor:Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.currentColor,i=o.currentBgColor,c=o.expanded,a=e.component||we,l=r&&r.substring(6),s=i&&i.substring(8);return N.a.createElement(a,{config:e,translations:n,onChange:this.toggleColor,expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{color:l,bgColor:s}})}}])&&Le(t.prototype,e),n&&Le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();xe.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Ie=xe,Te=n(7),Ae=n.n(Te);n(26);function ze(t){return(ze="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function _e(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Pe(t,e){return(Pe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ue(o);if(r){var n=Ue(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ze(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ue(t){return(Ue=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Be=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Pe(t,e)}(r,f["Component"]);var t,e,n,o=Re(r);function r(){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:c.props.config.defaultTargetOption},c.removeLink=function(){(0,c.props.onChange)("unlink")},c.addLink=function(){var t=c.props.onChange,e=c.state;t("link",e.linkTitle,e.linkTarget,e.linkTargetOption)},c.updateValue=function(t){var e,n,o;c.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},c.updateTargetOption=function(t){c.setState({linkTargetOption:t.target.checked?"_blank":"_self"})},c.hideModal=function(){c.setState({showModal:!1})},c.signalExpandShowModal=function(){var t=c.props,e=t.onExpandEvent,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target||"",linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c.forceExpandAndShowModal=function(){var t=c.props,e=t.doExpand,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target,linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){t.expanded&&!this.props.expanded&&this.setState({showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:this.props.config.defaultTargetOption})}},{key:"renderAddLinkModal",value:function(){var t=this.props,e=t.config.popupClassName,n=t.doCollapse,o=t.translations,r=this.state,i=r.linkTitle,c=r.linkTarget,a=r.linkTargetOption;return N.a.createElement("div",{className:w()("rdw-link-modal",e),onClick:j},N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTitle"},o["components.controls.link.linkTitle"]),N.a.createElement("input",{id:"linkTitle",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTitle",value:i}),N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTarget"},o["components.controls.link.linkTarget"]),N.a.createElement("input",{id:"linkTarget",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTarget",value:c}),N.a.createElement("label",{className:"rdw-link-modal-target-option",htmlFor:"openLinkInNewWindow"},N.a.createElement("input",{id:"openLinkInNewWindow",type:"checkbox",defaultChecked:"_blank"===a,value:"_blank",onChange:this.updateTargetOption}),N.a.createElement("span",null,o["components.controls.link.linkTargetOption"])),N.a.createElement("span",{className:"rdw-link-modal-buttonsection"},N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:this.addLink,disabled:!c||!i},o["generic.add"]),N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:n},o["generic.cancel"])))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.link,r=e.unlink,i=e.className,c=t.currentState,a=t.expanded,l=t.translations,s=this.state.showModal;return N.a.createElement("div",{className:w()("rdw-link-wrapper",i),"aria-label":"rdw-link-control"},0<=n.indexOf("link")&&N.a.createElement(R,{value:"unordered-list-item",className:w()(o.className),onClick:this.signalExpandShowModal,"aria-haspopup":"true","aria-expanded":s,title:o.title||l["components.controls.link.link"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("unlink")&&N.a.createElement(R,{disabled:!c.link,value:"ordered-list-item",className:w()(r.className),onClick:this.removeLink,title:r.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:r.icon,alt:""})),a&&s?this.renderAddLinkModal():void 0)}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.expanded,n=t.onExpandEvent,o=t.doCollapse,r=t.doExpand,i=t.onChange,c=t.config,a=t.currentState,l=t.translations,s=c.options,u=c.link,p=c.unlink,d=c.className,f=c.dropdownClassName,y=c.title,m=this.state.showModal;return N.a.createElement("div",{className:"rdw-link-wrapper","aria-haspopup":"true","aria-label":"rdw-link-control","aria-expanded":e,title:y},N.a.createElement(H,{className:w()("rdw-link-dropdown",d),optionWrapperClassName:w()(f),onChange:i,expanded:e&&!m,doExpand:r,doCollapse:o,onExpandEvent:n},N.a.createElement("img",{src:v(c),alt:""}),0<=s.indexOf("link")&&N.a.createElement(K,{onClick:this.forceExpandAndShowModal,className:w()("rdw-link-dropdownoption",u.className),title:u.title||l["components.controls.link.link"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("unlink")&&N.a.createElement(K,{onClick:this.removeLink,disabled:!a.link,className:w()("rdw-link-dropdownoption",p.className),title:p.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:p.icon,alt:""}))),e&&m?this.renderAddLinkModal():void 0)}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&_e(t.prototype,e),n&&_e(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Be.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var Fe=Be;function Ye(t){return(Ye="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Qe(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function He(t,e){return(He=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ze(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=We(o);if(r){var n=We(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ye(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function We(t){return(We=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ge(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ge(Object(n),!0).forEach(function(t){Ve(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ge(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function Ve(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function qe(t){var e=Ke.match(t.target);return Je(Je({},t),{},{target:e&&e[0]&&e[0].url||t.target})}var Ke=Ae()(),Xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&He(t,e)}(i,f["Component"]);var t,e,n,r=Ze(i);function i(t){var d;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(d=r.call(this,t)).onExpandEvent=function(){d.signalExpanded=!d.state.expanded},d.onChange=function(t,e,n,o){var r=d.props.config.linkCallback;if("link"===t){var i=(r||qe)({title:e,target:n,targetOption:o});d.addLink(i.title,i.target,i.targetOption)}else d.removeLink()},d.getCurrentValues=function(){var t=d.props.editorState,e=d.state.currentEntity,n=t.getCurrentContent(),o={};if(e&&"LINK"===n.getEntity(e).get("type")){o.link={};var r=e&&Object(S.getEntityRange)(t,e);o.link.target=e&&n.getEntity(e).get("data").url,o.link.targetOption=e&&n.getEntity(e).get("data").targetOption,o.link.title=r&&r.text}return o.selectionText=Object(S.getSelectionText)(t),o},d.doExpand=function(){d.setState({expanded:!0})},d.expandCollapse=function(){d.setState({expanded:d.signalExpanded}),d.signalExpanded=!1},d.doCollapse=function(){d.setState({expanded:!1})},d.removeLink=function(){var t=d.props,e=t.editorState,n=t.onChange,o=d.state.currentEntity,r=e.getSelection();if(o){var i=Object(S.getEntityRange)(e,o);r=r.getIsBackward()?r.merge({anchorOffset:i.end,focusOffset:i.start}):r.merge({anchorOffset:i.start,focusOffset:i.end}),n(E.RichUtils.toggleLink(e,r,null))}},d.addLink=function(t,e,n){var o=d.props,r=o.editorState,i=o.onChange,c=d.state.currentEntity,a=r.getSelection();if(c){var l=Object(S.getEntityRange)(r,c);a=a.getIsBackward()?a.merge({anchorOffset:l.end,focusOffset:l.start}):a.merge({anchorOffset:l.start,focusOffset:l.end})}var s=r.getCurrentContent().createEntity("LINK","MUTABLE",{url:e,targetOption:n}).getLastCreatedEntityKey(),u=E.Modifier.replaceText(r.getCurrentContent(),a,"".concat(t),r.getCurrentInlineStyle(),s),p=E.EditorState.push(r,u,"insert-characters");a=p.getSelection().merge({anchorOffset:a.get("anchorOffset")+t.length,focusOffset:a.get("anchorOffset")+t.length}),p=E.EditorState.acceptSelection(p,a),u=E.Modifier.insertText(p.getCurrentContent(),a," ",p.getCurrentInlineStyle(),void 0),i(E.EditorState.push(p,u,"insert-characters")),d.doCollapse()};var e=d.props,n=e.editorState,o=e.modalHandler;return d.state={expanded:!1,link:void 0,selectionText:void 0,currentEntity:n?Object(S.getSelectionEntity)(n):void 0},o.registerCallBack(d.expandCollapse),d}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentEntity:Object(S.getSelectionEntity)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=this.getCurrentValues(),i=r.link,c=r.selectionText,a=e.component||Fe;return N.a.createElement(a,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{link:i,selectionText:c},onChange:this.onChange})}}])&&Qe(t.prototype,e),n&&Qe(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Xe.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var $e=Xe;n(27);function tn(t){return(tn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function en(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function nn(t,e){return(nn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function on(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=rn(o);if(r){var n=rn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===tn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function rn(t){return(rn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&nn(t,e)}(i,f["Component"]);var t,e,n,o=on(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={embeddedLink:"",height:r.props.config.defaultSize.height,width:r.props.config.defaultSize.width},r.onChange=function(){var t=r.props.onChange,e=r.state;t(e.embeddedLink,e.height,e.width)},r.updateValue=function(t){var e,n,o;r.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props,n=e.expanded,o=e.config;if(!n&&t.expanded){var r=o.defaultSize,i=r.height,c=r.width;this.setState({embeddedLink:"",height:i,width:c})}}},{key:"rendeEmbeddedLinkModal",value:function(){var t=this.state,e=t.embeddedLink,n=t.height,o=t.width,r=this.props,i=r.config.popupClassName,c=r.doCollapse,a=r.translations;return N.a.createElement("div",{className:w()("rdw-embedded-modal",i),onClick:j},N.a.createElement("div",{className:"rdw-embedded-modal-header"},N.a.createElement("span",{className:"rdw-embedded-modal-header-option"},a["components.controls.embedded.embeddedlink"],N.a.createElement("span",{className:"rdw-embedded-modal-header-label"}))),N.a.createElement("div",{className:"rdw-embedded-modal-link-section"},N.a.createElement("span",{className:"rdw-embedded-modal-link-input-wrapper"},N.a.createElement("input",{className:"rdw-embedded-modal-link-input",placeholder:a["components.controls.embedded.enterlink"],onChange:this.updateValue,onBlur:this.updateValue,value:e,name:"embeddedLink"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("div",{className:"rdw-embedded-modal-size"},N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:n,name:"height",className:"rdw-embedded-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:o,name:"width",className:"rdw-embedded-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")))),N.a.createElement("span",{className:"rdw-embedded-modal-btn-section"},N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:this.onChange,disabled:!e||!n||!o},a["generic.add"]),N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:c},a["generic.cancel"])))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-embedded-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-embedded-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.embedded.embedded"]},N.a.createElement("img",{src:n,alt:""})),i?this.rendeEmbeddedLinkModal():void 0)}}])&&en(t.prototype,e),n&&en(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object,doCollapse:y.a.func};var an=cn;function ln(t){return(ln="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function sn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function un(t,e){return(un=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function pn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=dn(o);if(r){var n=dn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ln(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function dn(t){return(dn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&un(t,e)}(r,f["Component"]);var t,e,n,o=pn(r);function r(){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(s=o.call.apply(o,[this].concat(e))).state={expanded:!1},s.onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.addEmbeddedLink=function(t,e,n){var o=s.props,r=o.editorState,i=o.onChange,c=o.config.embedCallback,a=c?c(t):t,l=r.getCurrentContent().createEntity("EMBEDDED_LINK","MUTABLE",{src:a,height:e,width:n}).getLastCreatedEntityKey();i(E.AtomicBlockUtils.insertAtomicBlock(r,l," ")),s.doCollapse()},s}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||an;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmbeddedLink,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&sn(t.prototype,e),n&&sn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var yn=fn;n(28);function mn(t){return(mn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function gn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function bn(t,e){return(bn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function hn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Mn(o);if(r){var n=Mn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===mn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Mn(t){return(Mn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var jn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&bn(t,e)}(i,f["Component"]);var t,e,n,r=hn(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t.target.innerHTML)},e}return t=i,(e=[{key:"renderEmojiModal",value:function(){var n=this,t=this.props.config,e=t.popupClassName,o=t.emojis;return N.a.createElement("div",{className:w()("rdw-emoji-modal",e),onClick:j},o.map(function(t,e){return N.a.createElement("span",{key:e,className:"rdw-emoji-icon",alt:"",onClick:n.onChange},t)}))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-emoji-wrapper","aria-haspopup":"true","aria-label":"rdw-emoji-control","aria-expanded":i,title:r||a["components.controls.emoji.emoji"]},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c},N.a.createElement("img",{src:n,alt:""})),i?this.renderEmojiModal():void 0)}}])&&gn(t.prototype,e),n&&gn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();jn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var vn=jn;function Nn(t){return(Nn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function En(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Sn(t,e){return(Sn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function wn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Cn(o);if(r){var n=Cn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Nn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Cn(t){return(Cn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ln=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Sn(t,e)}(r,f["Component"]);var t,e,n,o=wn(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={expanded:!1},i.onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.addEmoji=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());o(E.EditorState.push(n,r,"insert-characters")),i.doCollapse()},i}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||vn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmoji,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onCollpase:this.closeModal})}}])&&En(t.prototype,e),n&&En(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Ln.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Dn(){return N.a.createElement("div",{className:"rdw-spinner"},N.a.createElement("div",{className:"rdw-bounce1"}),N.a.createElement("div",{className:"rdw-bounce2"}),N.a.createElement("div",{className:"rdw-bounce3"}))}n(29),n(30);function kn(t){return(kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function On(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function xn(t,e){return(xn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function In(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Tn(o);if(r){var n=Tn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Tn(t){return(Tn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var An=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&xn(t,e)}(r,f["Component"]);var t,e,n,o=In(r);function r(){var a;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))).state={imgSrc:"",dragEnter:!1,uploadHighlighted:a.props.config.uploadEnabled&&!!a.props.config.uploadCallback,showImageLoading:!1,height:a.props.config.defaultSize.height,width:a.props.config.defaultSize.width,alt:""},a.onDragEnter=function(t){a.stopPropagation(t),a.setState({dragEnter:!0})},a.onImageDrop=function(t){var e,n;t.preventDefault(),t.stopPropagation(),a.setState({dragEnter:!1}),n=t.dataTransfer.items?(e=t.dataTransfer.items,!0):(e=t.dataTransfer.files,!1);for(var o=0;o<e.length;o+=1)if((!n||"file"===e[o].kind)&&e[o].type.match("^image/")){var r=n?e[o].getAsFile():e[o];a.uploadImage(r)}},a.showImageUploadOption=function(){a.setState({uploadHighlighted:!0})},a.addImageFromState=function(){var t=a.state,e=t.imgSrc,n=t.alt,o=a.state,r=o.height,i=o.width,c=a.props.onChange;isNaN(r)||(r+="px"),isNaN(i)||(i+="px"),c(e,r,i,n)},a.showImageURLOption=function(){a.setState({uploadHighlighted:!1})},a.toggleShowImageLoading=function(){var t=!a.state.showImageLoading;a.setState({showImageLoading:t})},a.updateValue=function(t){var e,n,o;a.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},a.selectImage=function(t){t.target.files&&0<t.target.files.length&&a.uploadImage(t.target.files[0])},a.uploadImage=function(t){a.toggleShowImageLoading(),(0,a.props.config.uploadCallback)(t).then(function(t){var e=t.data;a.setState({showImageLoading:!1,dragEnter:!1,imgSrc:e.link||e.url}),a.fileUpload=!1}).catch(function(){a.setState({showImageLoading:!1,dragEnter:!1})})},a.fileUploadClick=function(t){a.fileUpload=!0,t.stopPropagation()},a.stopPropagation=function(t){a.fileUpload?a.fileUpload=!1:(t.preventDefault(),t.stopPropagation())},a}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.config;t.expanded&&!this.props.expanded?this.setState({imgSrc:"",dragEnter:!1,uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback,showImageLoading:!1,height:e.defaultSize.height,width:e.defaultSize.width,alt:""}):e.uploadCallback===t.config.uploadCallback&&e.uploadEnabled===t.config.uploadEnabled||this.setState({uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback})}},{key:"renderAddImageModal",value:function(){var t=this.state,e=t.imgSrc,n=t.uploadHighlighted,o=t.showImageLoading,r=t.dragEnter,i=t.height,c=t.width,a=t.alt,l=this.props,s=l.config,u=s.popupClassName,p=s.uploadCallback,d=s.uploadEnabled,f=s.urlEnabled,y=s.previewImage,m=s.inputAccept,g=s.alt,b=l.doCollapse,h=l.translations;return N.a.createElement("div",{className:w()("rdw-image-modal",u),onClick:this.stopPropagation},N.a.createElement("div",{className:"rdw-image-modal-header"},d&&p&&N.a.createElement("span",{onClick:this.showImageUploadOption,className:"rdw-image-modal-header-option"},h["components.controls.image.fileUpload"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":n})})),f&&N.a.createElement("span",{onClick:this.showImageURLOption,className:"rdw-image-modal-header-option"},h["components.controls.image.byURL"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":!n})}))),n?N.a.createElement("div",{onClick:this.fileUploadClick},N.a.createElement("div",{onDragEnter:this.onDragEnter,onDragOver:this.stopPropagation,onDrop:this.onImageDrop,className:w()("rdw-image-modal-upload-option",{"rdw-image-modal-upload-option-highlighted":r})},N.a.createElement("label",{htmlFor:"file",className:"rdw-image-modal-upload-option-label"},y&&e?N.a.createElement("img",{src:e,alt:e,className:"rdw-image-modal-upload-option-image-preview"}):e||h["components.controls.image.dropFileText"])),N.a.createElement("input",{type:"file",id:"file",accept:m,onChange:this.selectImage,className:"rdw-image-modal-upload-option-input"})):N.a.createElement("div",{className:"rdw-image-modal-url-section"},N.a.createElement("input",{className:"rdw-image-modal-url-input",placeholder:h["components.controls.image.enterlink"],name:"imgSrc",onChange:this.updateValue,onBlur:this.updateValue,value:e}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),g.present&&N.a.createElement("div",{className:"rdw-image-modal-size"},N.a.createElement("span",{className:"rdw-image-modal-alt-lbl"},"Alt Text"),N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:a,name:"alt",className:"rdw-image-modal-alt-input",placeholder:"alt"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},g.mandatory&&"*")),N.a.createElement("div",{className:"rdw-image-modal-size"},"↕ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:i,name:"height",className:"rdw-image-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")," ↔ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:c,name:"width",className:"rdw-image-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",{className:"rdw-image-modal-btn-section"},N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:this.addImageFromState,disabled:!e||!i||!c||g.mandatory&&!a},h["generic.add"]),N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:b},h["generic.cancel"])),o?N.a.createElement("div",{className:"rdw-image-modal-spinner"},N.a.createElement(Dn,null)):void 0)}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-image-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-image-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.image.image"]},N.a.createElement("img",{src:n,alt:""})),i?this.renderAddImageModal():void 0)}}])&&On(t.prototype,e),n&&On(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();An.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var zn=An;function _n(t){return(_n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rn(t,e){return(Rn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Un(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bn(o);if(r){var n=Bn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_n(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bn(t){return(Bn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rn(t,e)}(r,f["Component"]);var t,e,n,o=Un(r);function r(t){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(s=o.call(this,t)).onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.addImage=function(t,e,n,o){var r=s.props,i=r.editorState,c=r.onChange,a={src:t,height:e,width:n};r.config.alt.present&&(a.alt=o);var l=i.getCurrentContent().createEntity("IMAGE","MUTABLE",a).getLastCreatedEntityKey();c(E.AtomicBlockUtils.insertAtomicBlock(i,l," ")),s.doCollapse()};var e=s.props.modalHandler;return s.state={expanded:!1},e.registerCallBack(s.expandCollapse),s}return t=r,(e=[{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||zn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addImage,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Pn(t.prototype,e),n&&Pn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Yn(t){var e=t.config,n=t.onChange,o=t.translations,r=e.icon,i=e.className,c=e.title;return N.a.createElement("div",{className:"rdw-remove-wrapper","aria-label":"rdw-remove-control"},N.a.createElement(R,{className:w()(i),onClick:n,title:c||o["components.controls.remove.remove"]},N.a.createElement("img",{src:r,alt:""})))}var Qn=Fn;n(31);Yn.propTypes={onChange:y.a.func,config:y.a.object,translations:y.a.object};var Hn=Yn;function Zn(t){return(Zn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Gn(t,e){return(Gn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Jn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Vn(o);if(r){var n=Vn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Zn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Vn(t){return(Vn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var qn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Gn(t,e)}(i,f["Component"]);var t,e,n,r=Jn(i);function i(){var n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))).state={expanded:!1},n.onExpandEvent=function(){n.signalExpanded=!n.state.expanded},n.expandCollapse=function(){n.setState({expanded:n.signalExpanded}),n.signalExpanded=!1},n.removeInlineStyles=function(){var t=n.props,e=t.editorState;(0,t.onChange)(n.removeAllInlineStyles(e))},n.removeAllInlineStyles=function(n){var o=n.getCurrentContent();return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","MONOSPACE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){o=E.Modifier.removeInlineStyle(o,n.getSelection(),t)}),h(Object(S.getSelectionCustomInlineStyle)(n,["FONTSIZE","FONTFAMILY","COLOR","BGCOLOR"]),function(t,e){e&&(o=E.Modifier.removeInlineStyle(o,n.getSelection(),e))}),E.EditorState.push(n,o,"change-inline-style")},n.doExpand=function(){n.setState({expanded:!0})},n.doCollapse=function(){n.setState({expanded:!1})},n}return t=i,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||Hn;return N.a.createElement(r,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.removeInlineStyles})}}])&&Wn(t.prototype,e),n&&Wn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();qn.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,config:y.a.object,translations:y.a.object,modalHandler:y.a.object};n(32);function Kn(t){return(Kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function $n(t,e){return($n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function to(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=eo(o);if(r){var n=eo(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function eo(t){return(eo=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var no=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&$n(t,e)}(i,f["Component"]);var t,e,n,r=to(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t)},e}return t=i,(e=[{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations,u=e.options,p=e.undo,d=e.redo,f=e.className,y=e.dropdownClassName,m=e.title;return N.a.createElement(H,{className:w()("rdw-history-dropdown",f),optionWrapperClassName:w()(y),expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-history-control",title:m||s["components.controls.history.history"]},N.a.createElement("img",{src:v(e),alt:""}),0<=u.indexOf("undo")&&N.a.createElement(K,{value:"undo",onClick:this.onChange,disabled:a,className:w()("rdw-history-dropdownoption",p.className),title:p.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=u.indexOf("redo")&&N.a.createElement(K,{value:"redo",onClick:this.onChange,disabled:l,className:w()("rdw-history-dropdownoption",d.className),title:d.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:d.icon,alt:""})))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.undo,r=e.redo,i=e.className,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations;return N.a.createElement("div",{className:w()("rdw-history-wrapper",i),"aria-label":"rdw-history-control"},0<=n.indexOf("undo")&&N.a.createElement(R,{value:"undo",onClick:this.onChange,className:w()(o.className),disabled:a,title:o.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("redo")&&N.a.createElement(R,{value:"redo",onClick:this.onChange,className:w()(r.className),disabled:l,title:r.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:r.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&Xn(t.prototype,e),n&&Xn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function oo(t){return(oo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ro(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function io(t,e){return(io=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function co(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ao(o);if(r){var n=ao(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===oo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ao(t){return(ao=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}no.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var lo=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&io(t,e)}(c,f["Component"]);var t,e,n,r=co(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.EditorState[t](n);r&&o(r)},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})};var e={expanded:!(i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1}),undoDisabled:!1,redoDisabled:!1},n=t.editorState,o=t.modalHandler;return n&&(e.undoDisabled=0===n.getUndoStack().size,e.redoDisabled=0===n.getRedoStack().size),i.state=e,o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&t.editorState!==e&&this.setState({undoDisabled:0===e.getUndoStack().size,redoDisabled:0===e.getRedoStack().size})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.undoDisabled,i=o.redoDisabled,c=o.expanded,a=e.component||no;return N.a.createElement(a,{config:e,translations:n,currentState:{undoDisabled:r,redoDisabled:i},expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange})}}])&&ro(t.prototype,e),n&&ro(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();lo.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var so={inline:st,blockType:Et,fontSize:zt,fontFamily:Jt,list:ce,textAlign:he,colorPicker:Ie,link:$e,embedded:yn,emoji:Ln,image:Qn,remove:qn,history:lo},uo=/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,po=/^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;function fo(t){return String(t).replace(uo,"").match(po)?t:"#"}n(33);function yo(t){return(yo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function mo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function go(t,e){return(go=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function bo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ho(o);if(r){var n=ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===yo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ho(t){return(ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Mo(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"LINK"===n.getEntity(e).getType()},e)}function jo(t){var e,a=t.showOpenOptionOnHover;return(e=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&go(t,e)}(i,f["Component"]);var t,e,n,o=bo(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={showPopOver:!1},r.openLink=function(){var t=r.props,e=t.entityKey,n=t.contentState.getEntity(e).getData().url,o=window.open(fo(n),"blank");o&&o.focus()},r.toggleShowPopOver=function(){var t=!r.state.showPopOver;r.setState({showPopOver:t})},r}return t=i,(e=[{key:"render",value:function(){var t=this.props,e=t.children,n=t.entityKey,o=t.contentState.getEntity(n).getData(),r=o.url,i=o.targetOption,c=this.state.showPopOver;return N.a.createElement("span",{className:"rdw-link-decorator-wrapper",onMouseEnter:this.toggleShowPopOver,onMouseLeave:this.toggleShowPopOver},N.a.createElement("a",{href:fo(r),target:i},e),c&&a?N.a.createElement("img",{src:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuMDcyIDBIOC45MTVhLjkyNS45MjUgMCAwIDAgMCAxLjg0OWgyLjkyNUw2Ljk2MSA2LjcyN2EuOTE4LjkxOCAwIDAgMC0uMjcuNjU0YzAgLjI0Ny4wOTUuNDguMjcuNjU0YS45MTguOTE4IDAgMCAwIC42NTQuMjcuOTE4LjkxOCAwIDAgMCAuNjUzLS4yN2w0Ljg4LTQuODh2Mi45MjZhLjkyNS45MjUgMCAwIDAgMS44NDggMFYuOTI0QS45MjUuOTI1IDAgMCAwIDE0LjA3MiAweiIvPjxwYXRoIGQ9Ik0xMC42MjMgMTMuNDExSDEuNTg1VjQuMzcyaDYuNzk4bDEuNTg0LTEuNTg0SC43OTJBLjc5Mi43OTIgMCAwIDAgMCAzLjU4djEwLjYyNGMwIC40MzcuMzU1Ljc5Mi43OTIuNzkyaDEwLjYyNGEuNzkyLjc5MiAwIDAgMCAuNzkyLS43OTJWNS4wMjlsLTEuNTg1IDEuNTg0djYuNzk4eiIvPjwvZz48L3N2Zz4=",alt:"",onClick:this.openLink,className:"rdw-link-decorator-icon"}):void 0)}}])&&mo(t.prototype,e),n&&mo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}()).propTypes={entityKey:y.a.string.isRequired,children:y.a.array,contentState:y.a.object},e}n(34);function vo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function No(t,e,n){return e&&vo(t.prototype,e),n&&vo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var Eo=No(function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getMentionComponent=function(){function t(t){var e=t.entityKey,n=t.children,o=t.contentState.getEntity(e).getData(),r=o.url,i=o.value;return N.a.createElement("a",{href:r||i,className:w()("rdw-mention-link",c)},n)}var c=n.className;return t.propTypes={entityKey:y.a.number,children:y.a.array,contentState:y.a.object},t},this.getMentionDecorator=function(){return{strategy:n.findMentionEntities,component:n.getMentionComponent()}},this.className=e});Eo.prototype.findMentionEntities=function(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"MENTION"===n.getEntity(e).getType()},e)};var So=Eo;n(35);function wo(t){return(wo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Co(t,e){return(Co=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Do(o);if(r){var n=Do(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===wo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Do(t){return(Do=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ko(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Oo(t,e,n){return e&&ko(t.prototype,e),n&&ko(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function xo(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var Io=Oo(function t(e){var p=this;xo(this,t),this.findSuggestionEntities=function(t,e){if(p.config.getEditorState()){var n=p.config,o=n.separator,r=n.trigger,i=n.getSuggestions,c=(0,n.getEditorState)().getSelection();if(c.get("anchorKey")===t.get("key")&&c.get("anchorKey")===c.get("focusKey")){var a=t.getText(),l=(a=a.substr(0,c.get("focusOffset")===a.length-1?a.length:c.get("focusOffset")+1)).lastIndexOf(o+r),s=o+r;if((void 0===l||l<0)&&a[0]===r&&(l=0,s=r),0<=l){var u=a.substr(l+s.length,a.length);i().some(function(t){return!!t.value&&(p.config.caseSensitive?0<=t.value.indexOf(u):0<=t.value.toLowerCase().indexOf(u&&u.toLowerCase()))})&&e(0===l?0:l+1,a.length)}}}},this.getSuggestionComponent=function(){var t,a=this.config;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Co(t,e)}(r,f["Component"]);var o=Lo(r);function r(){var c;xo(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={style:{left:15},activeOption:-1,showSuggestions:!0},c.onEditorKeyDown=function(t){var e=c.state.activeOption,n={};"ArrowDown"===t.key?(t.preventDefault(),e===c.filteredSuggestions.length-1?n.activeOption=0:n.activeOption=e+1):"ArrowUp"===t.key?n.activeOption=e<=0?c.filteredSuggestions.length-1:e-1:"Escape"===t.key?(n.showSuggestions=!1,g()):"Enter"===t.key&&c.addMention(),c.setState(n)},c.onOptionMouseEnter=function(t){var e=t.target.getAttribute("data-index");c.setState({activeOption:e})},c.onOptionMouseLeave=function(){c.setState({activeOption:-1})},c.setSuggestionReference=function(t){c.suggestion=t},c.setDropdownReference=function(t){c.dropdown=t},c.closeSuggestionDropdown=function(){c.setState({showSuggestions:!1})},c.filteredSuggestions=[],c.filterSuggestions=function(t){var e=t.children[0].props.text.substr(1),n=a.getSuggestions();c.filteredSuggestions=n&&n.filter(function(t){return!e||0===e.length||(a.caseSensitive?0<=t.value.indexOf(e):0<=t.value.toLowerCase().indexOf(e&&e.toLowerCase()))})},c.addMention=function(){var t=c.state.activeOption,e=a.getEditorState(),n=a.onChange,o=a.separator,r=a.trigger,i=c.filteredSuggestions[t];i&&function(t,e,n,o,r){var i=r.value,c=r.url,a=t.getCurrentContent().createEntity("MENTION","IMMUTABLE",{text:"".concat(o).concat(i),value:i,url:c}).getLastCreatedEntityKey(),l=Object(S.getSelectedBlock)(t).getText(),s=t.getSelection().focusOffset,u=(l.lastIndexOf(n+o,s)||0)+1,p=!1;l.length===u+1&&(s=l.length)," "===l[s]&&(p=!0);var d=t.getSelection().merge({anchorOffset:u,focusOffset:s}),f=E.EditorState.acceptSelection(t,d),y=E.Modifier.replaceText(f.getCurrentContent(),d,"".concat(o).concat(i),f.getCurrentInlineStyle(),a);f=E.EditorState.push(f,y,"insert-characters"),p||(d=f.getSelection().merge({anchorOffset:u+i.length+o.length,focusOffset:u+i.length+o.length}),f=E.EditorState.acceptSelection(f,d),y=E.Modifier.insertText(f.getCurrentContent(),d," ",f.getCurrentInlineStyle(),void 0)),e(E.EditorState.push(f,y,"insert-characters"))}(e,n,o,r,i)},c}return Oo(r,[{key:"componentDidMount",value:function(){var t,e,n,o=a.getWrapperRef().getBoundingClientRect(),r=this.suggestion.getBoundingClientRect(),i=this.dropdown.getBoundingClientRect();o.width<r.left-o.left+i.width?e=15:t=15,o.bottom<i.bottom&&(n=0),this.setState({style:{left:t,right:e,bottom:n}}),C.registerCallBack(this.onEditorKeyDown),m(),a.modalHandler.setSuggestionCallback(this.closeSuggestionDropdown),this.filterSuggestions(this.props)}},{key:"componentDidUpdate",value:function(t){this.props.children!==t.children&&(this.filterSuggestions(t),this.setState({showSuggestions:!0}))}},{key:"componentWillUnmount",value:function(){C.deregisterCallBack(this.onEditorKeyDown),g(),a.modalHandler.removeSuggestionCallback()}},{key:"render",value:function(){var n=this,t=this.props.children,e=this.state,o=e.activeOption,r=e.showSuggestions,i=a.dropdownClassName,c=a.optionClassName;return N.a.createElement("span",{className:"rdw-suggestion-wrapper",ref:this.setSuggestionReference,onClick:a.modalHandler.onSuggestionClick,"aria-haspopup":"true","aria-label":"rdw-suggestion-popup"},N.a.createElement("span",null,t),r&&N.a.createElement("span",{className:w()("rdw-suggestion-dropdown",i),contentEditable:"false",suppressContentEditableWarning:!0,style:this.state.style,ref:this.setDropdownReference},this.filteredSuggestions.map(function(t,e){return N.a.createElement("span",{key:e,spellCheck:!1,onClick:n.addMention,"data-index":e,onMouseEnter:n.onOptionMouseEnter,onMouseLeave:n.onOptionMouseLeave,className:w()("rdw-suggestion-option",c,{"rdw-suggestion-option-active":e===o})},t.text)})))}}]),r}()).propTypes={children:y.a.array},t}.bind(this),this.getSuggestionDecorator=function(){return{strategy:p.findSuggestionEntities,component:p.getSuggestionComponent()}};var n=e.separator,o=e.trigger,r=e.getSuggestions,i=e.onChange,c=e.getEditorState,a=e.getWrapperRef,l=e.caseSensitive,s=e.dropdownClassName,u=e.optionClassName,d=e.modalHandler;this.config={separator:n,trigger:o,getSuggestions:r,onChange:i,getEditorState:c,getWrapperRef:a,caseSensitive:l,dropdownClassName:s,optionClassName:u,modalHandler:d}}),To=function(t){return[new So(t.mentionClassName).getMentionDecorator(),new Io(t).getSuggestionDecorator()]};n(36);function Ao(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function zo(t,e,n){return e&&Ao(t.prototype,e),n&&Ao(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function _o(t){var e=t.block,n=t.contentState.getEntity(e.getEntityAt(0)).getData(),o=n.src,r=n.height,i=n.width;return N.a.createElement("iframe",{height:r,width:i,src:o,frameBorder:"0",allowFullScreen:!0,title:"Wysiwyg Embedded Content"})}var Po=zo(function t(e){var a=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getHashtagComponent=function(){function t(t){var e=t.children,n=e[0].props.text;return N.a.createElement("a",{href:n,className:w()("rdw-hashtag-link",o)},e)}var o=a.className;return t.propTypes={children:y.a.object},t},this.findHashtagEntities=function(t,e){for(var n=t.getText(),o=0,r=0;0<n.length&&0<=o;)if(n[0]===a.hashCharacter?(r=o=0,n=n.substr(a.hashCharacter.length)):0<=(o=n.indexOf(a.separator+a.hashCharacter))&&(n=n.substr(o+(a.separator+a.hashCharacter).length),r+=o+a.separator.length),0<=o){var i=0<=n.indexOf(a.separator)?n.indexOf(a.separator):n.length,c=n.substr(0,i);c&&0<c.length&&(e(r,r+c.length+a.hashCharacter.length),r+=a.hashCharacter.length)}},this.getHashtagDecorator=function(){return{strategy:a.findHashtagEntities,component:a.getHashtagComponent()}},this.className=e.className,this.hashCharacter=e.hashCharacter||"#",this.separator=e.separator||" "}),Ro=function(t){return new Po(t).getHashtagDecorator()};_o.propTypes={block:y.a.object,contentState:y.a.object};var Uo=_o;n(37);function Bo(t){return(Bo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Fo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Yo(t,e){return(Yo=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Qo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ho(o);if(r){var n=Ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Bo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ho(t){return(Ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Zo=function(d){var t;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Yo(t,e)}(r,f["Component"]);var t,e,n,o=Qo(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={hovered:!1},i.setEntityAlignmentLeft=function(){i.setEntityAlignment("left")},i.setEntityAlignmentRight=function(){i.setEntityAlignment("right")},i.setEntityAlignmentCenter=function(){i.setEntityAlignment("none")},i.setEntityAlignment=function(t){var e=i.props,n=e.block,o=e.contentState,r=n.getEntityAt(0);o.mergeEntityData(r,{alignment:t}),d.onChange(E.EditorState.push(d.getEditorState(),o,"change-block-data")),i.setState({dummy:!0})},i.toggleHovered=function(){var t=!i.state.hovered;i.setState({hovered:t})},i}return t=r,(e=[{key:"renderAlignmentOptions",value:function(t){return N.a.createElement("div",{className:w()("rdw-image-alignment-options-popup",{"rdw-image-alignment-options-popup-right":"right"===t})},N.a.createElement(R,{onClick:this.setEntityAlignmentLeft,className:"rdw-image-alignment-option"},"L"),N.a.createElement(R,{onClick:this.setEntityAlignmentCenter,className:"rdw-image-alignment-option"},"C"),N.a.createElement(R,{onClick:this.setEntityAlignmentRight,className:"rdw-image-alignment-option"},"R"))}},{key:"render",value:function(){var t=this.props,e=t.block,n=t.contentState,o=this.state.hovered,r=d.isReadOnly,i=d.isImageAlignmentEnabled,c=n.getEntity(e.getEntityAt(0)).getData(),a=c.src,l=c.alignment,s=c.height,u=c.width,p=c.alt;return N.a.createElement("span",{onMouseEnter:this.toggleHovered,onMouseLeave:this.toggleHovered,className:w()("rdw-image-alignment",{"rdw-image-left":"left"===l,"rdw-image-right":"right"===l,"rdw-image-center":!l||"none"===l})},N.a.createElement("span",{className:"rdw-image-imagewrapper"},N.a.createElement("img",{src:a,alt:p,style:{height:s,width:u}}),!r()&&o&&i()?this.renderAlignmentOptions(l):void 0))}}])&&Fo(t.prototype,e),n&&Fo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}()).propTypes={block:y.a.object,contentState:y.a.object},t},Wo=function(o,r){return function(t){if("function"==typeof r){var e=r(t,o,o.getEditorState);if(e)return e}if("atomic"===t.getType()){var n=o.getEditorState().getCurrentContent().getEntity(t.getEntityAt(0));if(n&&"IMAGE"===n.type)return{component:Zo(o),editable:!1};if(n&&"EMBEDDED_LINK"===n.type)return{component:Uo,editable:!1}}}},Go={options:["inline","blockType","fontSize","fontFamily","list","textAlign","colorPicker","link","embedded","emoji","image","remove","history"],inline:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["bold","italic","underline","strikethrough","monospace","superscript","subscript"],bold:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMjM2IDBjMS42NTIgMCAyLjk0LjI5OCAzLjg2Ni44OTMuOTI1LjU5NSAxLjM4OCAxLjQ4NSAxLjM4OCAyLjY2OSAwIC42MDEtLjE3MyAxLjEzOS0uNTE2IDEuNjEtLjM0My40NzQtLjg0NC44My0xLjQ5OSAxLjA2OC44NDMuMTY3IDEuNDc0LjUyMyAxLjg5NSAxLjA3MS40MTkuNTUuNjMgMS4xODMuNjMgMS45MDMgMCAxLjI0NS0uNDQ0IDIuMTg3LTEuMzMgMi44MjUtLjg4Ni42NDEtMi4xNDQuOTYxLTMuNzY5Ljk2MUgwdi0yLjE2N2gxLjQ5NFYyLjE2N0gwVjBoNi4yMzZ6TTQuMzA4IDUuNDQ2aDIuMDI0Yy43NTIgMCAxLjMzLS4xNDMgMS43MzQtLjQzLjQwNS0uMjg1LjYwOC0uNzAxLjYwOC0xLjI1IDAtLjYtLjIwNC0xLjA0NC0uNjEyLTEuMzMtLjQwOC0uMjg2LTEuMDE2LS40MjctMS44MjYtLjQyN0g0LjMwOHYzLjQzN3ptMCAxLjgwNFYxMWgyLjU5M2MuNzQ3IDAgMS4zMTQtLjE1MiAxLjcwNy0uNDUyLjM5LS4zLjU4OC0uNzQ1LjU4OC0xLjMzNCAwLS42MzYtLjE2OC0xLjEyNC0uNS0xLjQ2LS4zMzYtLjMzNS0uODY0LS41MDQtMS41ODItLjUwNEg0LjMwOHoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},italic:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTcgM1YyaDR2MUg5Ljc1M2wtMyAxMEg4djFINHYtMWgxLjI0N2wzLTEwSDd6Ii8+PC9zdmc+",className:void 0,title:void 0},underline:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTYuMDQ1IDJ2Ljk5Mkw0Ljc4NSAzdjUuMTcyYzAgLjg1OS4yNDMgMS41MTIuNzI3IDEuOTU3czEuMTI0LjY2OCAxLjkxOC42NjhjLjgzNiAwIDEuNTA5LS4yMjEgMi4wMTktLjY2NC41MTEtLjQ0Mi43NjYtMS4wOTYuNzY2LTEuOTYxVjNsLTEuMjYtLjAwOFYySDEzdi45OTJMMTEuNzM5IDN2NS4xNzJjMCAxLjIzNC0uMzk4IDIuMTgxLTEuMTk1IDIuODQtLjc5Ny42NTktMS44MzUuOTg4LTMuMTE0Ljk4OC0xLjI0MiAwLTIuMjQ4LS4zMjktMy4wMTctLjk4OC0uNzY5LS42NTktMS4xNTItMS42MDUtMS4xNTItMi44NFYzTDIgMi45OTJWMmg0LjA0NXpNMiAxM2gxMXYxSDJ6Ii8+PC9zdmc+",className:void 0,title:void 0},strikethrough:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4wNCA1Ljk1NGg2LjIxNWE3LjQxMiA3LjQxMiAwIDAgMC0uNzk1LS40MzggMTEuOTA3IDExLjkwNyAwIDAgMC0xLjQ0Ny0uNTU3Yy0xLjE4OC0uMzQ4LTEuOTY2LS43MTEtMi4zMzQtMS4wODgtLjM2OC0uMzc3LS41NTItLjc3LS41NTItMS4xODEgMC0uNDk1LjE4Ny0uOTA2LjU2LTEuMjMyLjM4LS4zMzEuODg3LS40OTcgMS41MjMtLjQ5Ny42OCAwIDEuMjY2LjI1NSAxLjc1Ny43NjcuMjk1LjMxNS41ODIuODkxLjg2MSAxLjczbC4xMTcuMDE2LjcwMy4wNS4xLS4wMjRjLjAyOC0uMTUyLjA0Mi0uMjc5LjA0Mi0uMzggMC0uMzM3LS4wMzktLjg1Mi0uMTE3LTEuNTQ0YTkuMzc0IDkuMzc0IDAgMCAwLS4xNzYtLjk5NUM5Ljg4LjM3OSA5LjM4NS4yNDQgOS4wMTcuMTc2IDguMzY1LjA3IDcuODk5LjAxNiA3LjYyLjAxNmMtMS40NSAwLTIuNTQ1LjM1Ny0zLjI4NyAxLjA3MS0uNzQ3LjcyLTEuMTIgMS41ODktMS4xMiAyLjYwNyAwIC41MTEuMTMzIDEuMDQuNCAxLjU4Ni4xMjkuMjUzLjI3LjQ3OC40MjcuNjc0ek04LjI4IDguMTE0Yy41NzUuMjM2Ljk1Ny40MzYgMS4xNDcuNTk5LjQ1MS40MS42NzcuODUyLjY3NyAxLjMyNCAwIC4zODMtLjEzLjc0NS0uMzkzIDEuMDg4LS4yNS4zMzgtLjU5LjU4LTEuMDIuNzI2YTMuNDE2IDMuNDE2IDAgMCAxLTEuMTYzLjIyOGMtLjQwNyAwLS43NzUtLjA2Mi0xLjEwNC0uMTg2YTIuNjk2IDIuNjk2IDAgMCAxLS44NzgtLjQ4IDMuMTMzIDMuMTMzIDAgMCAxLS42Ny0uNzk0IDEuNTI3IDEuNTI3IDAgMCAxLS4xMDQtLjIyNyA1Ny41MjMgNTcuNTIzIDAgMCAwLS4xODgtLjQ3MyAyMS4zNzEgMjEuMzcxIDAgMCAwLS4yNTEtLjU5OWwtLjg1My4wMTd2LjM3MWwtLjAxNy4zMTNhOS45MiA5LjkyIDAgMCAwIDAgLjU3M2MuMDExLjI3LjAxNy43MDkuMDE3IDEuMzE2di4xMWMwIC4wNzkuMDIyLjE0LjA2Ny4xODUuMDgzLjA2OC4yODQuMTQ3LjYwMi4yMzdsMS4xNy4zMzdjLjQ1Mi4xMy45OTYuMTk0IDEuNjMyLjE5NC42ODYgMCAxLjI1Mi0uMDU5IDEuNjk4LS4xNzdhNC42OTQgNC42OTQgMCAwIDAgMS4yOC0uNTU3Yy40MDEtLjI1OS43MDUtLjQ4Ni45MTEtLjY4My4yNjgtLjI3Ni40NjYtLjU2OC41OTQtLjg3OGE0Ljc0IDQuNzQgMCAwIDAgLjM0My0xLjc4OGMwLS4yOTgtLjAyLS41NTctLjA1OC0uNzc2SDguMjgxek0xNC45MTQgNi41N2EuMjYuMjYgMCAwIDAtLjE5My0uMDc2SC4yNjhhLjI2LjI2IDAgMCAwLS4xOTMuMDc2LjI2NC4yNjQgMCAwIDAtLjA3NS4xOTR2LjU0YzAgLjA3OS4wMjUuMTQzLjA3NS4xOTRhLjI2LjI2IDAgMCAwIC4xOTMuMDc2SDE0LjcyYS4yNi4yNiAwIDAgMCAuMTkzLS4wNzYuMjY0LjI2NCAwIDAgMCAuMDc1LS4xOTR2LS41NGEuMjY0LjI2NCAwIDAgMC0uMDc1LS4xOTR6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},monospace:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ0NCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS4wMjEgMi45MDZjLjE4NiAxLjIxOS4zNzIgMS41LjM3MiAyLjcxOUMxLjM5MyA2LjM3NSAwIDcuMDMxIDAgNy4wMzF2LjkzOHMxLjM5My42NTYgMS4zOTMgMS40MDZjMCAxLjIxOS0uMTg2IDEuNS0uMzcyIDIuNzE5Qy43NDMgMTQuMDYzIDEuNzY0IDE1IDIuNjkzIDE1aDEuOTV2LTEuODc1cy0xLjY3Mi4xODgtMS42NzItLjkzOGMwLS44NDMuMTg2LS44NDMuMzcyLTIuNzE4LjA5My0uODQ0LS40NjQtMS41LTEuMDIyLTEuOTY5LjU1OC0uNDY5IDEuMTE1LTEuMDMxIDEuMDIyLTEuODc1QzMuMDY0IDMuNzUgMi45NyAzLjc1IDIuOTcgMi45MDZjMC0xLjEyNSAxLjY3Mi0xLjAzMSAxLjY3Mi0xLjAzMVYwaC0xLjk1QzEuNjcgMCAuNzQzLjkzOCAxLjAyIDIuOTA2ek0xMS45NzkgMi45MDZjLS4xODYgMS4yMTktLjM3MiAxLjUtLjM3MiAyLjcxOSAwIC43NSAxLjM5MyAxLjQwNiAxLjM5MyAxLjQwNnYuOTM4cy0xLjM5My42NTYtMS4zOTMgMS40MDZjMCAxLjIxOS4xODYgMS41LjM3MiAyLjcxOS4yNzggMS45NjktLjc0MyAyLjkwNi0xLjY3MiAyLjkwNmgtMS45NXYtMS44NzVzMS42NzIuMTg4IDEuNjcyLS45MzhjMC0uODQzLS4xODYtLjg0My0uMzcyLTIuNzE4LS4wOTMtLjg0NC40NjQtMS41IDEuMDIyLTEuOTY5LS41NTgtLjQ2OS0xLjExNS0xLjAzMS0xLjAyMi0xLjg3NS4xODYtMS44NzUuMzcyLTEuODc1LjM3Mi0yLjcxOSAwLTEuMTI1LTEuNjcyLTEuMDMxLTEuNjcyLTEuMDMxVjBoMS45NWMxLjAyMiAwIDEuOTUuOTM4IDEuNjcyIDIuOTA2eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},superscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzA1IDEwLjE2NUwxMS44NjUgMTVIOS4wNTdsLTMuMTkyLTMuNTM2TDIuNzQ2IDE1SDBsNC41MjMtNC44MzVMLjIxOCA1LjYwM2gyLjc3TDUuOTg2IDguOTEgOS4wMSA1LjYwM2gyLjY0OWwtNC4zNTQgNC41NjJ6bTYuMjM0LTMuMjY5bDEuODc5LTEuMzA2Yy42NC0uNDE2IDEuMDYyLS44MDEgMS4yNjQtMS4xNTcuMjAxLS4zNTYuMzAyLS43MzguMzAyLTEuMTQ4IDAtLjY2OS0uMjM3LTEuMjEtLjcxLTEuNjItLjQ3NC0uNDExLTEuMDk3LS42MTctMS44NjgtLjYxNy0uNzQ0IDAtMS4zNC4yMDgtMS43ODUuNjI0LS40NDcuNDE2LS42NyAxLjA0My0uNjcgMS44ODFoMS40MzZjMC0uNS4wOTQtLjg0Ni4yODEtMS4wMzguMTg4LS4xOTEuNDQ1LS4yODcuNzcyLS4yODdzLjU4NS4wOTcuNzc3LjI5MmMuMTkuMTk1LjI4Ni40MzcuMjg2LjcyNiAwIC4yOS0uMDg5LjU1LS4yNjYuNzg1cy0uNjcuNjI4LTEuNDc5IDEuMTg0Yy0uNjkxLjQ3Ny0xLjYyNy45MjctMS45MDggMS4zNWwuMDE0IDEuNTY5SDE3VjYuODk2aC0zLjQ2MXoiLz48L3N2Zz4=",className:void 0,title:void 0},subscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjg2NiAxMS42NDZIOS4wNkw1Ljg2NyA3Ljk0MmwtMy4xMjEgMy43MDRIMGw0LjUyNC01LjA2NEwuMjE4IDEuODA0aDIuNzdsMyAzLjQ2NCAzLjAyMy0zLjQ2NGgyLjY1TDcuMzA2IDYuNTgybDQuNTYgNS4wNjR6bTEuNzI1IDIuMDU4bDEuODI3LTEuMzY4Yy42NC0uNDM1IDEuMDYyLS44NCAxLjI2NC0xLjIxMi4yMDItLjM3Mi4zMDItLjc3My4zMDItMS4yMDIgMC0uNy0uMjM3LTEuMjY2LS43MS0xLjY5Ni0uNDc0LS40MzEtMS4wOTctLjY0Ni0xLjg2OS0uNjQ2LS43NDQgMC0xLjM0LjIxOC0xLjc4NS42NTMtLjQ0Ni40MzYtLjY3IDEuMDkyLS42NyAxLjk3aDEuNDM2YzAtLjUyNC4wOTQtLjg4Ni4yODEtMS4wODcuMTg4LS4yLjQ0NS0uMzAxLjc3Mi0uMzAxcy41ODYuMTAyLjc3Ny4zMDZjLjE5LjIwNC4yODYuNDU4LjI4Ni43NiAwIC4zMDMtLjA4OC41NzctLjI2Ni44MjItLjE3Ny4yNDUtLjY3LjY1OC0xLjQ3OCAxLjI0LS42OTIuNS0xLjYyOC45NzEtMS45MSAxLjQxM0wxMS44NjQgMTVIMTd2LTEuMjk2aC0zLjQxeiIvPjwvc3ZnPg==",className:void 0,title:void 0}},blockType:{inDropdown:!0,options:["Normal","H1","H2","H3","H4","H5","H6","Blockquote","Code"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontSize:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4=",options:[8,9,10,11,12,14,16,18,24,30,36,48,60,72,96],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontFamily:{options:["Arial","Georgia","Impact","Tahoma","Times New Roman","Verdana"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},list:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["unordered","ordered","indent","outdent"],unordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS43MiAzLjQyN2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3LjAxIDEuNzIuMDFDLjc3LjAwOCAwIC43NzUgMCAxLjcxNWMwIC45NC43NzQgMS43MTEgMS43MiAxLjcxMXptMC0yLjYyNWMuNTEgMCAuOTIyLjQxMi45MjIuOTE0YS45Mi45MiAwIDAgMS0xLjg0MiAwIC45Mi45MiAwIDAgMSAuOTItLjkxNHpNMS43MiA4LjcwM2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3IDUuMjg3IDEuNzIgNS4yODdDLjc3IDUuMjg3IDAgNi4wNTIgMCA2Ljk5NXMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjJjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAwIDEtMS44NDIgMGMwLS41MDUuNDE1LS45MTQuOTItLjkxNHpNMS43MiAxMy45ODJjLjk1MSAwIDEuNzIyLS43NjggMS43MjItMS43MDggMC0uOTQzLS43NzQtMS43MDgtMS43MjEtMS43MDgtLjk0NyAwLTEuNzIxLjc2OC0xLjcyMSAxLjcwOHMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjVjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAxIDEtMS44NDIgMCAuOTIuOTIgMCAwIDEgLjkyLS45MTR6TTUuNzQ0IDIuMTE1aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OS40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDcuMzk0aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOThINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OC40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDEyLjY3aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjQuNC40IDAgMCAwIC40MDIuMzk4eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},ordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4yMDIgMS40NjZoOC4xNWMuMzM4IDAgLjYxMi0uMzIyLjYxMi0uNzIgMC0uMzk3LS4yNzQtLjcyLS42MTItLjcyaC04LjE1Yy0uMzM4IDAtLjYxMS4zMjMtLjYxMS43MiAwIC4zOTguMjczLjcyLjYxLjcyek0xMi4zNTIgNS43ODNoLTguMTVjLS4zMzggMC0uNjExLjMyMi0uNjExLjcyIDAgLjM5Ny4yNzMuNzIuNjEuNzJoOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5OC0uMjc0LS43Mi0uNjEyLS43MnpNMTIuMzUyIDExLjU0aC04LjE1Yy0uMzM4IDAtLjYxMS4zMjItLjYxMS43MiAwIC4zOTYuMjczLjcxOS42MS43MTloOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5Ny0uMjc0LS43Mi0uNjEyLS43MnpNLjc2NyAxLjI0OXYxLjgwMmMwIC4xOTUuMTM2LjM0My4zMTUuMzQzLjE3NiAwIC4zMTUtLjE1LjMxNS0uMzQzVi4zNTZjMC0uMTktLjEzMy0uMzM5LS4zMDItLjMzOS0uMTQ4IDAtLjIyMy4xMTgtLjI0Ny4xNTZhLjIyOC4yMjggMCAwIDAtLjAwMy4wMDVMLjU3OS42MjFhLjQ3NC40NzQgMCAwIDAtLjA5OC4yNzNjMCAuMTk0LjEyOC4zNTEuMjg2LjM1NXpNLjM1MiA4LjE5SDEuNTVjLjE1NyAwIC4yODUtLjE2Mi4yODUtLjM2MiAwLS4xOTgtLjEyOC0uMzU5LS4yODUtLjM1OUguNjh2LS4wMDZjMC0uMTA3LjIxLS4yODEuMzc4LS40MjIuMzM2LS4yNzguNzUzLS42MjUuNzUzLTEuMjI2IDAtLjU3LS4zNzYtMS0uODc0LTEtLjQ3NyAwLS44MzYuMzg1LS44MzYuODk3IDAgLjI5Ny4xNjQuNDAyLjMwNS40MDIuMiAwIC4zMjEtLjE3Ni4zMjEtLjM0NiAwLS4xMDYuMDIzLS4yMjguMjA0LS4yMjguMjQzIDAgLjI1LjI1NC4yNS4yODMgMCAuMjI4LS4yNTIuNDQyLS40OTUuNjQ5LS4zMDEuMjU1LS42NDIuNTQ0LS42NDIuOTkydi4zODRjMCAuMjA1LjE1OS4zNDMuMzA4LjM0M3pNMS43NyAxMC41NDNjMC0uNTkyLS4yOTYtLjkzMS0uODE0LS45MzEtLjY4IDAtLjg1OS41Ny0uODU5Ljg3MiAwIC4zNTEuMjIyLjM5LjMxOC4zOS4xODUgMCAuMzEtLjE0OC4zMS0uMzY2IDAtLjA4NC4wMjYtLjE4MS4yMjQtLjE4MS4xNDIgMCAuMi4wMjQuMi4yNjcgMCAuMjM3LS4wNDMuMjYzLS4yMTMuMjYzLS4xNjQgMC0uMjg4LjE1Mi0uMjg4LjM1NCAwIC4yLjEyNS4zNS4yOTEuMzUuMjI1IDAgLjI3LjEwOC4yNy4yODN2LjA3NWMwIC4yOTQtLjA5Ny4zNS0uMjc3LjM1LS4yNDggMC0uMjY3LS4xNS0uMjY3LS4xOTcgMC0uMTc0LS4wOTgtLjM1LS4zMTctLjM1LS4xOTIgMC0uMzA3LjE0MS0uMzA3LjM3OCAwIC40My4zMTMuODg4Ljg5NS44ODguNTY0IDAgLjkwMS0uNC45MDEtMS4wN3YtLjA3NGMwLS4yNzQtLjA3NC0uNTAyLS4yMTQtLjY2Ni4wOTYtLjE2My4xNDgtLjM4LjE0OC0uNjM1eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},indent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS43MTYgMy4yMTFIMTd2MS4xOTdINS43MTZ6TTAgLjAyaDE3djEuMTk3SDB6TTAgMTIuNzgzaDE3djEuMTk3SDB6TTUuNzE2IDkuNTkzSDE3djEuMTk3SDUuNzE2ek01LjcxNiA2LjQwMkgxN3YxLjE5N0g1LjcxNnpNLjE4NyA5LjQ5MUwyLjUyIDcgLjE4NyA0LjUwOXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},outdent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS4zOTYgMy4xOTNoMTAuNTczVjQuMzlINS4zOTZ6TS4wMzkuMDAzaDE1LjkzVjEuMkguMDM5ek0uMDM5IDEyLjc2NmgxNS45M3YxLjE5N0guMDM5ek01LjM5NiA5LjU3NWgxMC41NzN2MS4xOTdINS4zOTZ6TTUuMzk2IDYuMzg0aDEwLjU3M3YxLjE5N0g1LjM5NnpNMi4xODcgNC40OTFMMCA2Ljk4M2wyLjE4NyAyLjQ5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},title:void 0},textAlign:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["left","center","right","justify"],left:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOC40OTMgMTQuODg3SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4IDEwLjE2MkguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1M2gxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUzek04LjQ5MyA1LjQzNUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOC43MDlILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTJoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},center:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuNTU2IDE0Ljg4N0gzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTggMTAuMTYySC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUzaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6TTExLjU1NiA1LjQzNUgzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTguNzA5SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTJ6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},right:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjE4IDE0Ljg4N0g2LjQ1YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOCAxMC4xNjJILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTNoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1M3pNMTQuNjE4IDUuNDM1SDYuNDVhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4LjcwOUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1MmgxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyeiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},justify:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjIgMTQuODg4SC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgMTAuMTYySC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgNS40MzZILjMyNWEuMzI2LjMyNiAwIDAgMSAwLS42NTJIMTQuNjJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42Mi43MUguMzI1YS4zMjYuMzI2IDAgMCAxIDAtLjY1M0gxNC42MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},title:void 0},colorPicker:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+",className:void 0,component:void 0,popupClassName:void 0,colors:["rgb(97,189,109)","rgb(26,188,156)","rgb(84,172,210)","rgb(44,130,201)","rgb(147,101,184)","rgb(71,85,119)","rgb(204,204,204)","rgb(65,168,95)","rgb(0,168,133)","rgb(61,142,185)","rgb(41,105,176)","rgb(85,57,130)","rgb(40,50,78)","rgb(0,0,0)","rgb(247,218,100)","rgb(251,160,38)","rgb(235,107,86)","rgb(226,80,65)","rgb(163,143,132)","rgb(239,239,239)","rgb(255,255,255)","rgb(250,197,28)","rgb(243,121,52)","rgb(209,72,65)","rgb(184,49,47)","rgb(124,112,107)","rgb(209,213,216)"],title:void 0},link:{inDropdown:!1,className:void 0,component:void 0,popupClassName:void 0,dropdownClassName:void 0,showOpenOptionOnHover:!0,defaultTargetOption:"_self",options:["link","unlink"],link:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjk2Ny45NUEzLjIyNiAzLjIyNiAwIDAgMCAxMS42Ny4wMDJjLS44NyAwLTEuNjg2LjMzNy0yLjI5Ny45NDhMNy4xMDUgMy4yMThBMy4yNDcgMy4yNDcgMCAwIDAgNi4yNCA2LjI0YTMuMjI1IDMuMjI1IDAgMCAwLTMuMDIyLjg2NUwuOTUgOS4zNzNhMy4yNTMgMy4yNTMgMCAwIDAgMCA0LjU5NCAzLjIyNiAzLjIyNiAwIDAgMCAyLjI5Ny45NDhjLjg3IDAgMS42ODYtLjMzNiAyLjI5OC0uOTQ4TDcuODEyIDExLjdhMy4yNDcgMy4yNDcgMCAwIDAgLjg2NS0zLjAyMyAzLjIyNSAzLjIyNSAwIDAgMCAzLjAyMi0uODY1bDIuMjY4LTIuMjY3YTMuMjUyIDMuMjUyIDAgMCAwIDAtNC41OTV6TTcuMTA1IDEwLjk5M0w0LjgzNyAxMy4yNmEyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NSAyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LS42NTUgMi4yNTIgMi4yNTIgMCAwIDEgMC0zLjE4bDIuMjY4LTIuMjY4YTIuMjMyIDIuMjMyIDAgMCAxIDEuNTktLjY1NWMuNDMgMCAuODQxLjEyIDEuMTk1LjM0M0w0Ljc3MiA5LjQzOGEuNS41IDAgMSAwIC43MDcuNzA3bDEuOTM5LTEuOTM4Yy41NDUuODY4LjQ0MiAyLjAzLS4zMTMgMi43ODV6bTYuMTU1LTYuMTU1bC0yLjI2OCAyLjI2N2EyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NWMtLjQzMSAwLS44NDEtLjEyLTEuMTk1LS4zNDNsMS45MzgtMS45MzhhLjUuNSAwIDEgMC0uNzA3LS43MDdMNy40OTkgNi43MWEyLjI1MiAyLjI1MiAwIDAgMSAuMzEzLTIuNzg1bDIuMjY3LTIuMjY4YTIuMjMzIDIuMjMzIDAgMCAxIDEuNTktLjY1NSAyLjIzMyAyLjIzMyAwIDAgMSAyLjI0NiAyLjI0NWMwIC42MDMtLjIzMiAxLjE2OC0uNjU1IDEuNTl6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=",className:void 0,title:void 0},unlink:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTMuOTU2IDEuMDM3YTMuNTUgMy41NSAwIDAgMC01LjAxNCAwTDYuNDM2IDMuNTQ0YS41NDUuNTQ1IDAgMSAwIC43Ny43N2wyLjUwOC0yLjUwNmEyLjQzOCAyLjQzOCAwIDAgMSAxLjczNS0uNzE1Yy42NTggMCAxLjI3NS4yNTQgMS43MzYuNzE1LjQ2LjQ2MS43MTUgMS4wNzguNzE1IDEuNzM2IDAgLjY1OC0uMjU0IDEuMjc0LS43MTUgMS43MzVMOS45MDcgOC41NThhMi40NTggMi40NTggMCAwIDEtMy40NzIgMCAuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3MSAzLjUzNCAzLjUzNCAwIDAgMCAyLjUwNyAxLjAzN2MuOTA4IDAgMS44MTYtLjM0NiAyLjUwNy0xLjAzN2wzLjI3OC0zLjI3OGEzLjUyIDMuNTIgMCAwIDAgMS4wMzUtMi41MDdjMC0uOTUtLjM2Ny0xLjg0LTEuMDM1LTIuNTA3eiIvPjxwYXRoIGQ9Ik03LjQgMTEuMDY1bC0yLjEyMiAyLjEyYTIuNDM3IDIuNDM3IDAgMCAxLTEuNzM1LjcxNiAyLjQzNyAyLjQzNyAwIDAgMS0xLjczNi0uNzE1IDIuNDU3IDIuNDU3IDAgMCAxIDAtMy40NzFsMy4wODYtMy4wODZhMi40MzggMi40MzggMCAwIDEgMS43MzUtLjcxNWMuNjU4IDAgMS4yNzUuMjU0IDEuNzM2LjcxNWEuNTQ1LjU0NSAwIDEgMCAuNzcxLS43NzEgMy41NSAzLjU1IDAgMCAwLTUuMDE0IDBMMS4wMzYgOC45NDRBMy41MiAzLjUyIDAgMCAwIDAgMTEuNDVjMCAuOTUuMzY3IDEuODQgMS4wMzUgMi41MDdhMy41MiAzLjUyIDAgMCAwIDIuNTA2IDEuMDM1Yy45NSAwIDEuODQtLjM2OCAyLjUwNy0xLjAzNWwyLjEyMi0yLjEyMWEuNTQ1LjU0NSAwIDAgMC0uNzcxLS43NzF6TTkuMjc0IDEyLjAwMmEuNTQ2LjU0NiAwIDAgMC0uNTQ2LjU0NXYxLjYzN2EuNTQ2LjU0NiAwIDAgMCAxLjA5MSAwdi0xLjYzN2EuNTQ1LjU0NSAwIDAgMC0uNTQ1LS41NDV6TTExLjIzIDExLjYxNmEuNTQ1LjU0NSAwIDEgMC0uNzcyLjc3MmwxLjE1NyAxLjE1NmEuNTQzLjU0MyAwIDAgMCAuNzcxIDAgLjU0NS41NDUgMCAwIDAgMC0uNzdsLTEuMTU2LTEuMTU4ek0xMi41MzcgOS44MkgxMC45YS41NDYuNTQ2IDAgMCAwIDAgMS4wOTFoMS42MzdhLjU0Ni41NDYgMCAwIDAgMC0xLjA5ek00LjkxIDMuNTQ3YS41NDYuNTQ2IDAgMCAwIC41NDUtLjU0NVYxLjM2NmEuNTQ2LjU0NiAwIDAgMC0xLjA5IDB2MS42MzZjMCAuMzAxLjI0NC41NDUuNTQ1LjU0NXpNMi44ODggMy45MzNhLjU0My41NDMgMCAwIDAgLjc3MSAwIC41NDUuNTQ1IDAgMCAwIDAtLjc3MUwyLjUwMiAyLjAwNWEuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3bDEuMTU3IDEuMTU4ek0xLjYyOCA1LjczaDEuNjM2YS41NDYuNTQ2IDAgMCAwIDAtMS4wOTJIMS42MjhhLjU0Ni41NDYgMCAwIDAgMCAxLjA5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},linkCallback:void 0},emoji:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,emojis:["😀","😁","😂","😃","😉","😋","😎","😍","😗","🤗","🤔","😣","😫","😴","😌","🤓","😛","😜","😠","😇","😷","😈","👻","😺","😸","😹","😻","😼","😽","🙀","🙈","🙉","🙊","👼","👮","🕵","💂","👳","🎅","👸","👰","👲","🙍","🙇","🚶","🏃","💃","⛷","🏂","🏌","🏄","🚣","🏊","⛹","🏋","🚴","👫","💪","👈","👉","👆","🖕","👇","🖖","🤘","🖐","👌","👍","👎","✊","👊","👏","🙌","🙏","🐵","🐶","🐇","🐥","🐸","🐌","🐛","🐜","🐝","🍉","🍄","🍔","🍤","🍨","🍪","🎂","🍰","🍾","🍷","🍸","🍺","🌍","🚑","⏰","🌙","🌝","🌞","⭐","🌟","🌠","🌨","🌩","⛄","🔥","🎄","🎈","🎉","🎊","🎁","🎗","🏀","🏈","🎲","🔇","🔈","📣","🔔","🎵","🎷","💰","🖊","📅","✅","❎","💯"],title:void 0},embedded:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNzA4IDYuNjE1YS40MzYuNDM2IDAgMCAwLS41NDMuMjkxbC0xLjgzIDYuMDQ1YS40MzYuNDM2IDAgMCAwIC44MzMuMjUyTDcgNy4xNmEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHpNOC45MzEgNi42MTVhLjQzNi40MzYgMCAwIDAtLjU0My4yOTFsLTEuODMgNi4wNDVhLjQzNi40MzYgMCAwIDAgLjgzNC4yNTJsMS44My02LjA0NGEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHoiLz48cGF0aCBkPSJNMTYuNTY0IDBILjQzNkEuNDM2LjQzNiAwIDAgMCAwIC40MzZ2MTYuMTI4YzAgLjI0LjE5NS40MzYuNDM2LjQzNmgxNi4xMjhjLjI0IDAgLjQzNi0uMTk1LjQzNi0uNDM2Vi40MzZBLjQzNi40MzYgMCAwIDAgMTYuNTY0IDB6TTMuNDg3Ljg3MmgxMC4wMjZ2MS43NDNIMy40ODdWLjg3MnptLTIuNjE1IDBoMS43NDN2MS43NDNILjg3MlYuODcyem0xNS4yNTYgMTUuMjU2SC44NzJWMy40ODhoMTUuMjU2djEyLjY0em0wLTEzLjUxM2gtMS43NDNWLjg3MmgxLjc0M3YxLjc0M3oiLz48Y2lyY2xlIGN4PSI5My44NjciIGN5PSIyNDUuMDY0IiByPSIxMy4xMjgiIHRyYW5zZm9ybT0ibWF0cml4KC4wMzMyIDAgMCAuMDMzMiAwIDApIi8+PGNpcmNsZSBjeD0iOTMuODY3IiBjeT0iMzYwLjU5MiIgcj0iMTMuMTI4IiB0cmFuc2Zvcm09Im1hdHJpeCguMDMzMiAwIDAgLjAzMzIgMCAwKSIvPjxwYXRoIGQ9Ik0xNC4yNTQgMTIuNjQxSDEwLjJhLjQzNi40MzYgMCAwIDAgMCAuODcyaDQuMDU0YS40MzYuNDM2IDAgMCAwIDAtLjg3MnoiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,embedCallback:void 0,defaultSize:{height:"auto",width:"auto"},title:void 0},image:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,urlEnabled:!0,uploadEnabled:!0,previewImage:!1,alignmentEnabled:!0,uploadCallback:void 0,inputAccept:"image/gif,image/jpeg,image/jpg,image/png,image/svg",alt:{present:!1,mandatory:!1},defaultSize:{height:"auto",width:"auto"},title:void 0},remove:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOC4xIDE0bDYuNC03LjJjLjYtLjcuNi0xLjgtLjEtMi41bC0yLjctMi43Yy0uMy0uNC0uOC0uNi0xLjMtLjZIOC42Yy0uNSAwLTEgLjItMS40LjZMLjUgOS4yYy0uNi43LS42IDEuOS4xIDIuNWwyLjcgMi43Yy4zLjQuOC42IDEuMy42SDE2di0xSDguMXptLTEuMy0uMXMwLS4xIDAgMGwtMi43LTIuN2MtLjQtLjQtLjQtLjkgMC0xLjNMNy41IDZoLTFsLTMgMy4zYy0uNi43LS42IDEuNy4xIDIuNEw1LjkgMTRINC42Yy0uMiAwLS40LS4xLS42LS4yTDEuMiAxMWMtLjMtLjMtLjMtLjggMC0xLjFMNC43IDZoMS44TDEwIDJoMUw3LjUgNmwzLjEgMy43LTMuNSA0Yy0uMS4xLS4yLjEtLjMuMnoiLz48L3N2Zz4=",className:void 0,component:void 0,title:void 0},history:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["undo","redo"],undo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMTQuODc1YzIuNjcyIDAgNC44NDYtMi4xNDUgNC44NDYtNC43ODEgMC0yLjYzNy0yLjE3NC00Ljc4MS00Ljg0Ni00Ljc4MVY4LjVMMS42MTUgNC4yNSA3IDB2My4xODhjMy44NiAwIDcgMy4wOTggNyA2LjkwNlMxMC44NiAxNyA3IDE3cy03LTMuMDk4LTctNi45MDZoMi4xNTRjMCAyLjYzNiAyLjE3NCA0Ljc4MSA0Ljg0NiA0Ljc4MXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},redo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNTA0IDEzLjk3N2E0LjQ5NyA0LjQ5NyAwIDAgMS00LjQ5Mi00LjQ5MiA0LjQ5NyA0LjQ5NyAwIDAgMSA0LjQ5Mi00LjQ5M3YyLjk5NWw0Ljk5LTMuOTkzTDYuNTA0IDB2Mi45OTVhNi40OTYgNi40OTYgMCAwIDAtNi40ODggNi40OWMwIDMuNTc4IDIuOTEgNi40OSA2LjQ4OCA2LjQ5YTYuNDk2IDYuNDk2IDAgMCAwIDYuNDg3LTYuNDloLTEuOTk2YTQuNDk3IDQuNDk3IDAgMCAxLTQuNDkxIDQuNDkyeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+",className:void 0,title:void 0},title:void 0}},Jo={en:{"generic.add":"Add","generic.cancel":"Cancel","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Block Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Color Picker","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Highlight","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Embedded Link","components.controls.embedded.enterlink":"Enter link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Font","components.controls.fontsize.fontsize":"Font Size","components.controls.history.history":"History","components.controls.history.undo":"Undo","components.controls.history.redo":"Redo","components.controls.image.image":"Image","components.controls.image.fileUpload":"File Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop the file or click to upload","components.controls.inline.bold":"Bold","components.controls.inline.italic":"Italic","components.controls.inline.underline":"Underline","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Link Title","components.controls.link.linkTarget":"Link Target","components.controls.link.linkTargetOption":"Open link in new window","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"List","components.controls.list.unordered":"Unordered","components.controls.list.ordered":"Ordered","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Remove","components.controls.textalign.textalign":"Text Align","components.controls.textalign.left":"Left","components.controls.textalign.center":"Center","components.controls.textalign.right":"Right","components.controls.textalign.justify":"Justify"},fr:{"generic.add":"Ok","generic.cancel":"Annuler","components.controls.blocktype.h1":"Titre 1","components.controls.blocktype.h2":"Titre 2","components.controls.blocktype.h3":"Titre 3","components.controls.blocktype.h4":"Titre 4","components.controls.blocktype.h5":"Titre 5","components.controls.blocktype.h6":"Titre 6","components.controls.blocktype.blockquote":"Citation","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Type bloc","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Palette de couleur","components.controls.colorpicker.text":"Texte","components.controls.colorpicker.background":"Fond","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Lien iFrame","components.controls.embedded.enterlink":"Entrer le lien","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Police","components.controls.fontsize.fontsize":"Taille de police","components.controls.history.history":"Historique","components.controls.history.undo":"Précédent","components.controls.history.redo":"Suivant","components.controls.image.image":"Image","components.controls.image.fileUpload":"Téléchargement","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Glisser une image ou cliquer pour télécharger","components.controls.inline.bold":"Gras","components.controls.inline.italic":"Italique","components.controls.inline.underline":"Souligner","components.controls.inline.strikethrough":"Barrer","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Exposant","components.controls.inline.subscript":"Indice","components.controls.link.linkTitle":"Titre du lien","components.controls.link.linkTarget":"Cible du lien","components.controls.link.linkTargetOption":"Ouvrir le lien dans une nouvelle fenêtre","components.controls.link.link":"Lier","components.controls.link.unlink":"Délier","components.controls.list.list":"Liste","components.controls.list.unordered":"Désordonnée","components.controls.list.ordered":"Ordonnée","components.controls.list.indent":"Augmenter le retrait","components.controls.list.outdent":"Diminuer le retrait","components.controls.remove.remove":"Supprimer","components.controls.textalign.textalign":"Alignement du texte","components.controls.textalign.left":"Gauche","components.controls.textalign.center":"Centre","components.controls.textalign.right":"Droite","components.controls.textalign.justify":"Justifier"},zh:{"generic.add":"添加","generic.cancel":"取消","components.controls.blocktype.h1":"标题1","components.controls.blocktype.h2":"标题2","components.controls.blocktype.h3":"标题3","components.controls.blocktype.h4":"标题4","components.controls.blocktype.h5":"标题5","components.controls.blocktype.h6":"标题6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"源码","components.controls.blocktype.blocktype":"样式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"选色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"内嵌","components.controls.embedded.embeddedlink":"内嵌网页","components.controls.embedded.enterlink":"输入网页地址","components.controls.emoji.emoji":"表情符号","components.controls.fontfamily.fontfamily":"字体","components.controls.fontsize.fontsize":"字号","components.controls.history.history":"历史","components.controls.history.undo":"撤销","components.controls.history.redo":"恢复","components.controls.image.image":"图片","components.controls.image.fileUpload":"来自文件","components.controls.image.byURL":"在线图片","components.controls.image.dropFileText":"点击或者拖拽文件上传","components.controls.inline.bold":"粗体","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下划线","components.controls.inline.strikethrough":"删除线","components.controls.inline.monospace":"等宽字体","components.controls.inline.superscript":"上标","components.controls.inline.subscript":"下标","components.controls.link.linkTitle":"超链接","components.controls.link.linkTarget":"输入链接地址","components.controls.link.linkTargetOption":"在新窗口中打开链接","components.controls.link.link":"链接","components.controls.link.unlink":"删除链接","components.controls.list.list":"列表","components.controls.list.unordered":"项目符号","components.controls.list.ordered":"编号","components.controls.list.indent":"增加缩进量","components.controls.list.outdent":"减少缩进量","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文本对齐","components.controls.textalign.left":"文本左对齐","components.controls.textalign.center":"居中","components.controls.textalign.right":"文本右对齐","components.controls.textalign.justify":"两端对齐"},ru:{"generic.add":"Добавить","generic.cancel":"Отменить","components.controls.blocktype.h1":"Заголовок 1","components.controls.blocktype.h2":"Заголовок 2","components.controls.blocktype.h3":"Заголовок 3","components.controls.blocktype.h4":"Заголовок 4","components.controls.blocktype.h5":"Заголовок 5","components.controls.blocktype.h6":"Заголовок 6","components.controls.blocktype.blockquote":"Цитата","components.controls.blocktype.code":"Код","components.controls.blocktype.blocktype":"Форматирование","components.controls.blocktype.normal":"Обычный","components.controls.colorpicker.colorpicker":"Выбор цвета","components.controls.colorpicker.text":"Текст","components.controls.colorpicker.background":"Фон","components.controls.embedded.embedded":"Встраивание","components.controls.embedded.embeddedlink":"Ссылка в iFrame","components.controls.embedded.enterlink":"Вставьте ссылку","components.controls.emoji.emoji":"Эмодзи","components.controls.fontfamily.fontfamily":"Шрифт","components.controls.fontsize.fontsize":"Размер шрифта","components.controls.history.history":"История","components.controls.history.undo":"Отменить","components.controls.history.redo":"Вернуть","components.controls.image.image":"Изображение","components.controls.image.fileUpload":"Файлы","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Переместите в эту область файлы или кликните для загрузки","components.controls.inline.bold":"Жирный","components.controls.inline.italic":"Курсив","components.controls.inline.underline":"Подчеркивание","components.controls.inline.strikethrough":"Зачеркивание","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Верхний индекс","components.controls.inline.subscript":"Нижний индекс","components.controls.link.linkTitle":"Текст","components.controls.link.linkTarget":"Адрес ссылки","components.controls.link.linkTargetOption":"Открывать в новом окне","components.controls.link.link":"Ссылка","components.controls.link.unlink":"Убрать ссылку","components.controls.list.list":"Список","components.controls.list.unordered":"Неупорядоченный","components.controls.list.ordered":"Упорядоченный","components.controls.list.indent":"Отступ","components.controls.list.outdent":"Выступ","components.controls.remove.remove":"Удалить","components.controls.textalign.textalign":"Выравнивание текста","components.controls.textalign.left":"Слева","components.controls.textalign.center":"По центру","components.controls.textalign.right":"Справа","components.controls.textalign.justify":"Выравнить"},pt:{"generic.add":"Ok","generic.cancel":"Cancelar","components.controls.blocktype.h1":"Título 1","components.controls.blocktype.h2":"Título 2","components.controls.blocktype.h3":"Título 3","components.controls.blocktype.h4":"Título 4","components.controls.blocktype.h5":"Título 5","components.controls.blocktype.h6":"Título 6","components.controls.blocktype.blockquote":"Citação","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Estilo","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Paleta de cores","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Fundo","components.controls.embedded.embedded":"Embarcado","components.controls.embedded.embeddedlink":"Link embarcado","components.controls.embedded.enterlink":"Coloque o link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonte","components.controls.fontsize.fontsize":"Tamanho da Fonte","components.controls.history.history":"Histórico","components.controls.history.undo":"Desfazer","components.controls.history.redo":"Refazer","components.controls.image.image":"Imagem","components.controls.image.fileUpload":"Carregar arquivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arraste uma imagem aqui ou clique para carregar","components.controls.inline.bold":"Negrito","components.controls.inline.italic":"Itálico","components.controls.inline.underline":"Sublinhado","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobrescrito","components.controls.inline.subscript":"Subscrito","components.controls.link.linkTitle":"Título do link","components.controls.link.linkTarget":"Alvo do link","components.controls.link.linkTargetOption":"Abrir link em outra janela","components.controls.link.link":"Adicionar Link","components.controls.link.unlink":"Remover link","components.controls.list.list":"Lista","components.controls.list.unordered":"Sem ordenção","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Aumentar recuo","components.controls.list.outdent":"Diminuir recuo","components.controls.remove.remove":"Remover","components.controls.textalign.textalign":"Alinhamento do texto","components.controls.textalign.left":"À Esquerda","components.controls.textalign.center":"Centralizado","components.controls.textalign.right":"À Direita","components.controls.textalign.justify":"Justificado"},ko:{"generic.add":"입력","generic.cancel":"취소","components.controls.blocktype.h1":"제목1","components.controls.blocktype.h2":"제목2","components.controls.blocktype.h3":"제목3","components.controls.blocktype.h4":"제목4","components.controls.blocktype.h5":"제목5","components.controls.blocktype.h6":"제목6","components.controls.blocktype.blockquote":"인용","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"블록","components.controls.blocktype.normal":"표준","components.controls.colorpicker.colorpicker":"색상 선택","components.controls.colorpicker.text":"글꼴색","components.controls.colorpicker.background":"배경색","components.controls.embedded.embedded":"임베드","components.controls.embedded.embeddedlink":"임베드 링크","components.controls.embedded.enterlink":"주소를 입력하세요","components.controls.emoji.emoji":"이모지","components.controls.fontfamily.fontfamily":"글꼴","components.controls.fontsize.fontsize":"글꼴 크기","components.controls.history.history":"히스토리","components.controls.history.undo":"실행 취소","components.controls.history.redo":"다시 실행","components.controls.image.image":"이미지","components.controls.image.fileUpload":"파일 업로드","components.controls.image.byURL":"주소","components.controls.image.dropFileText":"클릭하거나 파일을 드롭하여 업로드하세요","components.controls.inline.bold":"굵게","components.controls.inline.italic":"기울임꼴","components.controls.inline.underline":"밑줄","components.controls.inline.strikethrough":"취소선","components.controls.inline.monospace":"고정 너비","components.controls.inline.superscript":"위 첨자","components.controls.inline.subscript":"아래 첨자","components.controls.link.linkTitle":"링크 제목","components.controls.link.linkTarget":"링크 타겟","components.controls.link.linkTargetOption":"새창으로 열기","components.controls.link.link":"링크","components.controls.link.unlink":"링크 제거","components.controls.list.list":"리스트","components.controls.list.unordered":"일반 리스트","components.controls.list.ordered":"순서 리스트","components.controls.list.indent":"들여쓰기","components.controls.list.outdent":"내어쓰기","components.controls.remove.remove":"삭제","components.controls.textalign.textalign":"텍스트 정렬","components.controls.textalign.left":"왼쪽","components.controls.textalign.center":"중앙","components.controls.textalign.right":"오른쪽","components.controls.textalign.justify":"양쪽"},it:{"generic.add":"Aggiungi","generic.cancel":"Annulla","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Citazione","components.controls.blocktype.code":"Codice","components.controls.blocktype.blocktype":"Stili","components.controls.blocktype.normal":"Normale","components.controls.colorpicker.colorpicker":"Colore testo","components.controls.colorpicker.text":"Testo","components.controls.colorpicker.background":"Evidenziazione","components.controls.embedded.embedded":"Incorpora","components.controls.embedded.embeddedlink":"Incorpora link","components.controls.embedded.enterlink":"Inserisci link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Carattere","components.controls.fontsize.fontsize":"Dimensione carattere","components.controls.history.history":"Modifiche","components.controls.history.undo":"Annulla","components.controls.history.redo":"Ripristina","components.controls.image.image":"Immagine","components.controls.image.fileUpload":"Carica immagine","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Trascina il file o clicca per caricare","components.controls.inline.bold":"Grassetto","components.controls.inline.italic":"Corsivo","components.controls.inline.underline":"Sottolineato","components.controls.inline.strikethrough":"Barrato","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Apice","components.controls.inline.subscript":"Pedice","components.controls.link.linkTitle":"Testo","components.controls.link.linkTarget":"Link","components.controls.link.linkTargetOption":"Apri link in una nuova finestra","components.controls.link.link":"Inserisci link","components.controls.link.unlink":"Rimuovi link","components.controls.list.list":"Lista","components.controls.list.unordered":"Elenco puntato","components.controls.list.ordered":"Elenco numerato","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Rimuovi formattazione","components.controls.textalign.textalign":"Allineamento del testo","components.controls.textalign.left":"Allinea a sinistra","components.controls.textalign.center":"Allinea al centro","components.controls.textalign.right":"Allinea a destra","components.controls.textalign.justify":"Giustifica"},nl:{"generic.add":"Toevoegen","generic.cancel":"Annuleren","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Blocktype","components.controls.blocktype.normal":"Normaal","components.controls.colorpicker.colorpicker":"Kleurkiezer","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Achtergrond","components.controls.embedded.embedded":"Ingevoegd","components.controls.embedded.embeddedlink":"Ingevoegde link","components.controls.embedded.enterlink":"Voeg link toe","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Lettertype","components.controls.fontsize.fontsize":"Lettergrootte","components.controls.history.history":"Geschiedenis","components.controls.history.undo":"Ongedaan maken","components.controls.history.redo":"Opnieuw","components.controls.image.image":"Afbeelding","components.controls.image.fileUpload":"Bestand uploaden","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop het bestand hier of klik om te uploaden","components.controls.inline.bold":"Dikgedrukt","components.controls.inline.italic":"Schuingedrukt","components.controls.inline.underline":"Onderstrepen","components.controls.inline.strikethrough":"Doorstrepen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Linktitel","components.controls.link.linkTarget":"Link bestemming","components.controls.link.linkTargetOption":"Open link in een nieuw venster","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"Lijst","components.controls.list.unordered":"Ongeordend","components.controls.list.ordered":"Geordend","components.controls.list.indent":"Inspringen","components.controls.list.outdent":"Inspringen verkleinen","components.controls.remove.remove":"Verwijderen","components.controls.textalign.textalign":"Tekst uitlijnen","components.controls.textalign.left":"Links","components.controls.textalign.center":"Gecentreerd","components.controls.textalign.right":"Rechts","components.controls.textalign.justify":"Uitgelijnd"},de:{"generic.add":"Hinzufügen","generic.cancel":"Abbrechen","components.controls.blocktype.h1":"Überschrift 1","components.controls.blocktype.h2":"Überschrift 2","components.controls.blocktype.h3":"Überschrift 3","components.controls.blocktype.h4":"Überschrift 4","components.controls.blocktype.h5":"Überschrift 5","components.controls.blocktype.h6":"Überschrift 6","components.controls.blocktype.blockquote":"Zitat","components.controls.blocktype.code":"Quellcode","components.controls.blocktype.blocktype":"Blocktyp","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farbauswahl","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Hintergrund","components.controls.embedded.embedded":"Eingebettet","components.controls.embedded.embeddedlink":"Eingebetteter Link","components.controls.embedded.enterlink":"Link eingeben","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Schriftart","components.controls.fontsize.fontsize":"Schriftgröße","components.controls.history.history":"Historie","components.controls.history.undo":"Zurücknehmen","components.controls.history.redo":"Wiederholen","components.controls.image.image":"Bild","components.controls.image.fileUpload":"Datei-Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Dateien ziehen und ablegen, oder klicken zum Hochladen","components.controls.inline.bold":"Fett","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Unterstreichen","components.controls.inline.strikethrough":"Durchstreichen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hochgestellt","components.controls.inline.subscript":"Tiefgestellt","components.controls.link.linkTitle":"Link-Titel","components.controls.link.linkTarget":"Link-Ziel","components.controls.link.linkTargetOption":"Link in neuem Fenster öffnen","components.controls.link.link":"Link","components.controls.link.unlink":"Aufheben","components.controls.list.list":"Liste","components.controls.list.unordered":"Aufzählung","components.controls.list.ordered":"Nummerierte Liste","components.controls.list.indent":"Einzug vergrößern","components.controls.list.outdent":"Einzug reduzieren","components.controls.remove.remove":"Entfernen","components.controls.textalign.textalign":"Textausrichtung","components.controls.textalign.left":"Linksbündig","components.controls.textalign.center":"Zentrieren","components.controls.textalign.right":"Rechtsbündig","components.controls.textalign.justify":"Blocksatz"},da:{"generic.add":"Tilføj","generic.cancel":"Annuller","components.controls.blocktype.h1":"Overskrift 1","components.controls.blocktype.h2":"Overskrift 2","components.controls.blocktype.h3":"Overskrift 3","components.controls.blocktype.h4":"Overskrift 4","components.controls.blocktype.h5":"Overskrift 5","components.controls.blocktype.h6":"Overskrift 6","components.controls.blocktype.blockquote":"Blokcitat","components.controls.blocktype.code":"Kode","components.controls.blocktype.blocktype":"Blok Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farver","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Baggrund","components.controls.embedded.embedded":"Indlejre","components.controls.embedded.embeddedlink":"Indlejre Link","components.controls.embedded.enterlink":"Indtast link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonttype","components.controls.fontsize.fontsize":"Fontstørrelser","components.controls.history.history":"Historie","components.controls.history.undo":"Fortryd","components.controls.history.redo":"Gendan","components.controls.image.image":"Billede","components.controls.image.fileUpload":"Filoverførsel","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop filen eller klik for at uploade","components.controls.inline.bold":"Fed","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Understrege","components.controls.inline.strikethrough":"Gennemstreget","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hævet","components.controls.inline.subscript":"Sænket","components.controls.link.linkTitle":"Link Titel","components.controls.link.linkTarget":"Link Mål","components.controls.link.linkTargetOption":"Åbn link i nyt vindue","components.controls.link.link":"Link","components.controls.link.unlink":"Fjern link","components.controls.list.list":"Liste","components.controls.list.unordered":"Uordnet","components.controls.list.ordered":"Ordnet","components.controls.list.indent":"Indrykning","components.controls.list.outdent":"Udrykning","components.controls.remove.remove":"Fjern","components.controls.textalign.textalign":"Tekstjustering","components.controls.textalign.left":"Venstre","components.controls.textalign.center":"Center","components.controls.textalign.right":"Højre","components.controls.textalign.justify":"Margener"},zh_tw:{"generic.add":"新增","generic.cancel":"取消","components.controls.blocktype.h1":"標題1","components.controls.blocktype.h2":"標題2","components.controls.blocktype.h3":"標題3","components.controls.blocktype.h4":"標題4","components.controls.blocktype.h5":"標題5","components.controls.blocktype.h6":"標題6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"程式碼","components.controls.blocktype.blocktype":"樣式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"選色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"內嵌","components.controls.embedded.embeddedlink":"內嵌網頁","components.controls.embedded.enterlink":"輸入網頁地址","components.controls.emoji.emoji":"表情符號","components.controls.fontfamily.fontfamily":"字體","components.controls.fontsize.fontsize":"字體大小","components.controls.history.history":"歷史紀錄","components.controls.history.undo":"復原","components.controls.history.redo":"重做","components.controls.image.image":"圖片","components.controls.image.fileUpload":"檔案上傳","components.controls.image.byURL":"網址","components.controls.image.dropFileText":"點擊或拖曳檔案上傳","components.controls.inline.bold":"粗體","components.controls.inline.italic":"斜體","components.controls.inline.underline":"底線","components.controls.inline.strikethrough":"刪除線","components.controls.inline.monospace":"等寬字體","components.controls.inline.superscript":"上標","components.controls.inline.subscript":"下標","components.controls.link.linkTitle":"超連結","components.controls.link.linkTarget":"輸入連結位址","components.controls.link.linkTargetOption":"在新視窗打開連結","components.controls.link.link":"連結","components.controls.link.unlink":"刪除連結","components.controls.list.list":"列表","components.controls.list.unordered":"項目符號","components.controls.list.ordered":"編號","components.controls.list.indent":"增加縮排","components.controls.list.outdent":"減少縮排","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文字對齊","components.controls.textalign.left":"文字向左對齊","components.controls.textalign.center":"文字置中","components.controls.textalign.right":"文字向右對齊","components.controls.textalign.justify":"兩端對齊"},pl:{"generic.add":"Dodaj","generic.cancel":"Anuluj","components.controls.blocktype.h1":"Nagłówek 1","components.controls.blocktype.h2":"Nagłówek 2","components.controls.blocktype.h3":"Nagłówek 3","components.controls.blocktype.h4":"Nagłówek 4","components.controls.blocktype.h5":"Nagłówek 5","components.controls.blocktype.h6":"Nagłówek 6","components.controls.blocktype.blockquote":"Cytat","components.controls.blocktype.code":"Kod","components.controls.blocktype.blocktype":"Format","components.controls.blocktype.normal":"Normalny","components.controls.colorpicker.colorpicker":"Kolor","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Tło","components.controls.embedded.embedded":"Osadź","components.controls.embedded.embeddedlink":"Osadź odnośnik","components.controls.embedded.enterlink":"Wprowadź odnośnik","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Krój czcionki","components.controls.fontsize.fontsize":"Rozmiar czcionki","components.controls.history.history":"Historia","components.controls.history.undo":"Cofnij","components.controls.history.redo":"Ponów","components.controls.image.image":"Obrazek","components.controls.image.fileUpload":"Prześlij plik","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Upuść plik lub kliknij, aby przesłać","components.controls.inline.bold":"Pogrubienie","components.controls.inline.italic":"Kursywa","components.controls.inline.underline":"Podkreślenie","components.controls.inline.strikethrough":"Przekreślenie","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Indeks górny","components.controls.inline.subscript":"Indeks dolny","components.controls.link.linkTitle":"Tytuł odnośnika","components.controls.link.linkTarget":"Adres odnośnika","components.controls.link.linkTargetOption":"Otwórz odnośnik w nowej karcie","components.controls.link.link":"Wstaw odnośnik","components.controls.link.unlink":"Usuń odnośnik","components.controls.list.list":"Lista","components.controls.list.unordered":"Lista nieuporządkowana","components.controls.list.ordered":"Lista uporządkowana","components.controls.list.indent":"Zwiększ wcięcie","components.controls.list.outdent":"Zmniejsz wcięcie","components.controls.remove.remove":"Usuń","components.controls.textalign.textalign":"Wyrównaj tekst","components.controls.textalign.left":"Do lewej","components.controls.textalign.center":"Do środka","components.controls.textalign.right":"Do prawej","components.controls.textalign.justify":"Wyjustuj"},es:{"generic.add":"Añadir","generic.cancel":"Cancelar","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Código","components.controls.blocktype.blocktype":"Tipo de bloque","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Seleccionar color","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Subrayado","components.controls.embedded.embedded":"Adjuntar","components.controls.embedded.embeddedlink":"Adjuntar Link","components.controls.embedded.enterlink":"Introducir link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fuente","components.controls.fontsize.fontsize":"Tamaño de fuente","components.controls.history.history":"Histórico","components.controls.history.undo":"Deshacer","components.controls.history.redo":"Rehacer","components.controls.image.image":"Imagen","components.controls.image.fileUpload":"Subir archivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arrastra el archivo o haz click para subirlo","components.controls.inline.bold":"Negrita","components.controls.inline.italic":"Cursiva","components.controls.inline.underline":"Subrayado","components.controls.inline.strikethrough":"Tachado","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobreíndice","components.controls.inline.subscript":"Subíndice","components.controls.link.linkTitle":"Título del enlace","components.controls.link.linkTarget":"Objetivo del enlace","components.controls.link.linkTargetOption":"Abrir en nueva ventana","components.controls.link.link":"Enlazar","components.controls.link.unlink":"Desenlazar","components.controls.list.list":"Lista","components.controls.list.unordered":"Desordenada","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Indentada","components.controls.list.outdent":"Dentada","components.controls.remove.remove":"Eliminar","components.controls.textalign.textalign":"Alineación del texto","components.controls.textalign.left":"Izquierda","components.controls.textalign.center":"Centrado","components.controls.textalign.right":"Derecha","components.controls.textalign.justify":"Justificado"},ja:{"generic.add":"追加","generic.cancel":"キャンセル","components.controls.blocktype.h1":"見出し1","components.controls.blocktype.h2":"見出し2","components.controls.blocktype.h3":"見出し3","components.controls.blocktype.h4":"見出し4","components.controls.blocktype.h5":"見出し5","components.controls.blocktype.h6":"見出し6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"コード","components.controls.blocktype.blocktype":"スタイル","components.controls.blocktype.normal":"標準テキスト","components.controls.colorpicker.colorpicker":"テキストの色","components.controls.colorpicker.text":"テキスト","components.controls.colorpicker.background":"ハイライト","components.controls.embedded.embedded":"埋め込み","components.controls.embedded.embeddedlink":"埋め込みリンク","components.controls.embedded.enterlink":"リンクを入力してください","components.controls.emoji.emoji":"絵文字","components.controls.fontfamily.fontfamily":"フォント","components.controls.fontsize.fontsize":"フォントサイズ","components.controls.history.history":"履歴","components.controls.history.undo":"元に戻す","components.controls.history.redo":"やり直し","components.controls.image.image":"画像","components.controls.image.fileUpload":"ファイルをアップロード","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"ここに画像をドラッグするか、クリックしてください","components.controls.inline.bold":"太字","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下線","components.controls.inline.strikethrough":"取り消し線","components.controls.inline.monospace":"等幅フォント","components.controls.inline.superscript":"上付き文字","components.controls.inline.subscript":"下付き文字","components.controls.link.linkTitle":"リンクタイトル","components.controls.link.linkTarget":"リンク対象","components.controls.link.linkTargetOption":"新しいウィンドウで開く","components.controls.link.link":"リンク","components.controls.link.unlink":"リンクを解除","components.controls.list.list":"リスト","components.controls.list.unordered":"箇条書き","components.controls.list.ordered":"番号付き","components.controls.list.indent":"インデント増","components.controls.list.outdent":"インデント減","components.controls.remove.remove":"書式をクリア","components.controls.textalign.textalign":"整列","components.controls.textalign.left":"左揃え","components.controls.textalign.center":"中央揃え","components.controls.textalign.right":"右揃え","components.controls.textalign.justify":"両端揃え"}};n(38),n(39);function Vo(t){return(Vo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qo(){return(qo=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function Ko(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Xo(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ko(Object(n),!0).forEach(function(t){$o(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ko(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function $o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function tr(t){return function(t){if(Array.isArray(t))return er(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return er(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return er(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function er(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function nr(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function or(t,e){return(or=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function rr(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ir(o);if(r){var n=ir(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ir(t){return(ir=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cr=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&or(t,e)}(i,f["Component"]);var t,e,n,r=rr(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).onEditorBlur=function(){c.setState({editorFocused:!1})},c.onEditorFocus=function(t){var e=c.props.onFocus;c.setState({editorFocused:!0});var n=c.focusHandler.isEditorFocused();e&&n&&e(t)},c.onEditorMouseDown=function(){c.focusHandler.onEditorMouseDown()},c.keyBindingFn=function(t){if("Tab"!==t.key)return"ArrowUp"!==t.key&&"ArrowDown"!==t.key||b()&&t.preventDefault(),Object(E.getDefaultKeyBinding)(t);var e=c.props.onTab;if(!e||!e(t)){var n=Object(S.changeDepth)(c.state.editorState,t.shiftKey?-1:1,4);n&&n!==c.state.editorState&&(c.onChange(n),t.preventDefault())}return null},c.onToolbarFocus=function(t){var e=c.props.onFocus;e&&c.focusHandler.isToolbarFocused()&&e(t)},c.onWrapperBlur=function(t){var e=c.props.onBlur;e&&c.focusHandler.isEditorBlur(t)&&e(t,c.getEditorState())},c.onChange=function(t){var e=c.props,n=e.readOnly,o=e.onEditorStateChange;n||"atomic"===Object(S.getSelectedBlocksType)(t)&&t.getSelection().isCollapsed||(o&&o(t,c.props.wrapperId),M(c.props,"editorState")?c.afterChange(t):c.setState({editorState:t},c.afterChange(t)))},c.setWrapperReference=function(t){c.wrapper=t},c.setEditorReference=function(t){c.props.editorRef&&c.props.editorRef(t),c.editor=t},c.getCompositeDecorator=function(t){var e=[].concat(tr(c.props.customDecorators),[{strategy:Mo,component:jo({showOpenOptionOnHover:t.link.showOpenOptionOnHover})}]);return c.props.mention&&e.push.apply(e,tr(To(Xo(Xo({},c.props.mention),{},{onChange:c.onChange,getEditorState:c.getEditorState,getSuggestions:c.getSuggestions,getWrapperRef:c.getWrapperRef,modalHandler:c.modalHandler})))),c.props.hashtag&&e.push(Ro(c.props.hashtag)),new E.CompositeDecorator(e)},c.getWrapperRef=function(){return c.wrapper},c.getEditorState=function(){return c.state?c.state.editorState:null},c.getSuggestions=function(){return c.props.mention&&c.props.mention.suggestions},c.afterChange=function(o){setTimeout(function(){var t=c.props,e=t.onChange,n=t.onContentStateChange;e&&e(Object(E.convertToRaw)(o.getCurrentContent())),n&&n(Object(E.convertToRaw)(o.getCurrentContent()))})},c.isReadOnly=function(){return c.props.readOnly},c.isImageAlignmentEnabled=function(){return c.state.toolbar.image.alignmentEnabled},c.createEditorState=function(t){var e;if(M(c.props,"editorState"))c.props.editorState&&(e=E.EditorState.set(c.props.editorState,{decorator:t}));else if(M(c.props,"defaultEditorState"))c.props.defaultEditorState&&(e=E.EditorState.set(c.props.defaultEditorState,{decorator:t}));else if(M(c.props,"contentState")){if(c.props.contentState){var n=Object(E.convertFromRaw)(c.props.contentState);e=E.EditorState.createWithContent(n,t),e=E.EditorState.moveSelectionToEnd(e)}}else if(M(c.props,"defaultContentState")||M(c.props,"initialContentState")){var o=c.props.defaultContentState||c.props.initialContentState;o&&(o=Object(E.convertFromRaw)(o),e=E.EditorState.createWithContent(o,t),e=E.EditorState.moveSelectionToEnd(e))}return e=e||E.EditorState.createEmpty(t)},c.filterEditorProps=function(t){return e=t,n=["onChange","onEditorStateChange","onContentStateChange","initialContentState","defaultContentState","contentState","editorState","defaultEditorState","locale","localization","toolbarOnFocus","toolbar","toolbarCustomButtons","toolbarClassName","editorClassName","toolbarHidden","wrapperClassName","toolbarStyle","editorStyle","wrapperStyle","uploadCallback","onFocus","onBlur","onTab","mention","hashtag","ariaLabel","customBlockRenderFunc","customDecorators","handlePastedText","customStyleMap"],o=Object.keys(e).filter(function(t){return n.indexOf(t)<0}),r={},o&&0<o.length&&o.forEach(function(t){r[t]=e[t]}),r;var e,n,o,r},c.getStyleMap=function(t){return Xo(Xo({},Object(S.getCustomStyleMap)()),t.customStyleMap)},c.changeEditorState=function(t){var e=Object(E.convertFromRaw)(t),n=c.state.editorState;return n=E.EditorState.push(n,e,"insert-characters"),n=E.EditorState.moveSelectionToEnd(n)},c.focusEditor=function(){setTimeout(function(){c.editor.focus()})},c.handleKeyCommand=function(t){var e=c.state,n=e.editorState,o=e.toolbar.inline;if(o&&0<=o.options.indexOf(t)){var r=E.RichUtils.handleKeyCommand(n,t);if(r)return c.onChange(r),!0}return!1},c.handleReturn=function(t){if(b())return!0;var e=c.state.editorState,n=Object(S.handleNewLine)(e,t);return!!n&&(c.onChange(n),!0)},c.handlePastedTextFn=function(t,e){var n=c.state.editorState,o=c.props,r=o.handlePastedText,i=o.stripPastedStyles;return r?r(t,e,n,c.onChange):!i&&function(t,e,n,o){var r=Object(S.getSelectedBlock)(n);if(r&&"code"===r.type){var i=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());return o(E.EditorState.push(n,i,"insert-characters")),!0}if(e){var c=O()(e),a=n.getCurrentContent();return c.entityMap.forEach(function(t,e){a=a.mergeEntityData(e,t)}),a=E.Modifier.replaceWithFragment(a,n.getSelection(),new x.List(c.contentBlocks)),o(E.EditorState.push(n,a,"insert-characters")),!0}return!1}(t,e,n,c.onChange)},c.preventDefault=function(t){"INPUT"===t.target.tagName||"LABEL"===t.target.tagName||"TEXTAREA"===t.target.tagName?c.focusHandler.onInputMouseDown():t.preventDefault()};var e=D(Go,t.toolbar),n=t.wrapperId?t.wrapperId:Math.floor(1e4*Math.random());c.wrapperId="rdw-wrapper-".concat(n),c.modalHandler=new a,c.focusHandler=new p,c.blockRendererFn=Wo({isReadOnly:c.isReadOnly,isImageAlignmentEnabled:c.isImageAlignmentEnabled,getEditorState:c.getEditorState,onChange:c.onChange},t.customBlockRenderFunc),c.editorProps=c.filterEditorProps(t),c.customStyleMap=c.getStyleMap(t),c.compositeDecorator=c.getCompositeDecorator(e);var o=c.createEditorState(c.compositeDecorator);return Object(S.extractInlineStyle)(o),c.state={editorState:o,editorFocused:!1,toolbar:e},c}return t=i,(e=[{key:"componentDidMount",value:function(){this.modalHandler.init(this.wrapperId)}},{key:"componentDidUpdate",value:function(t){if(t!==this.props){var e={},n=this.props,o=n.editorState,r=n.contentState;if(!this.state.toolbar){var i=D(Go,i);e.toolbar=i}if(M(this.props,"editorState")&&o!==t.editorState)e.editorState=o?E.EditorState.set(o,{decorator:this.compositeDecorator}):E.EditorState.createEmpty(this.compositeDecorator);else if(M(this.props,"contentState")&&r!==t.contentState)if(r){var c=this.changeEditorState(r);c&&(e.editorState=c)}else e.editorState=E.EditorState.createEmpty(this.compositeDecorator);t.editorState===o&&t.contentState===r||Object(S.extractInlineStyle)(e.editorState),Object.keys(e).length&&this.setState(e),this.editorProps=this.filterEditorProps(this.props),this.customStyleMap=this.getStyleMap(this.props)}}},{key:"render",value:function(){var t=this.state,e=t.editorState,n=t.editorFocused,r=t.toolbar,o=this.props,i=o.locale,c=o.localization,a=c.locale,l=c.translations,s=o.toolbarCustomButtons,u=o.toolbarOnFocus,p=o.toolbarClassName,d=o.toolbarHidden,f=o.editorClassName,y=o.wrapperClassName,m=o.toolbarStyle,g=o.editorStyle,b=o.wrapperStyle,h=o.uploadCallback,M=o.ariaLabel,j={modalHandler:this.modalHandler,editorState:e,onChange:this.onChange,translations:Xo(Xo({},Jo[i||a]),l)},v=n||this.focusHandler.isInputFocused()||!u;return N.a.createElement("div",{id:this.wrapperId,className:w()(y,"rdw-editor-wrapper"),style:b,onClick:this.modalHandler.onEditorClick,onBlur:this.onWrapperBlur,"aria-label":"rdw-wrapper"},!d&&N.a.createElement("div",{className:w()("rdw-editor-toolbar",p),style:Xo({visibility:v?"visible":"hidden"},m),onMouseDown:this.preventDefault,"aria-label":"rdw-toolbar","aria-hidden":(!n&&u).toString(),onFocus:this.onToolbarFocus},r.options.map(function(t,e){var n=so[t],o=r[t];return"image"===t&&h&&(o.uploadCallback=h),N.a.createElement(n,qo({key:e},j,{config:o}))}),s&&s.map(function(t,e){return N.a.cloneElement(t,Xo({key:e},j))})),N.a.createElement("div",{ref:this.setWrapperReference,className:w()(f,"rdw-editor-main"),style:g,onClick:this.focusEditor,onFocus:this.onEditorFocus,onBlur:this.onEditorBlur,onKeyDown:C.onKeyDown,onMouseDown:this.onEditorMouseDown},N.a.createElement(E.Editor,qo({ref:this.setEditorReference,keyBindingFn:this.keyBindingFn,editorState:e,onChange:this.onChange,blockStyleFn:L,customStyleMap:this.getStyleMap(this.props),handleReturn:this.handleReturn,handlePastedText:this.handlePastedTextFn,blockRendererFn:this.blockRendererFn,handleKeyCommand:this.handleKeyCommand,ariaLabel:M||"rdw-editor",blockRenderMap:S.blockRenderMap},this.editorProps))))}}])&&nr(t.prototype,e),n&&nr(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cr.propTypes={onChange:y.a.func,onEditorStateChange:y.a.func,onContentStateChange:y.a.func,initialContentState:y.a.object,defaultContentState:y.a.object,contentState:y.a.object,editorState:y.a.object,defaultEditorState:y.a.object,toolbarOnFocus:y.a.bool,spellCheck:y.a.bool,stripPastedStyles:y.a.bool,toolbar:y.a.object,toolbarCustomButtons:y.a.array,toolbarClassName:y.a.string,toolbarHidden:y.a.bool,locale:y.a.string,localization:y.a.object,editorClassName:y.a.string,wrapperClassName:y.a.string,toolbarStyle:y.a.object,editorStyle:y.a.object,wrapperStyle:y.a.object,uploadCallback:y.a.func,onFocus:y.a.func,onBlur:y.a.func,onTab:y.a.func,mention:y.a.object,hashtag:y.a.object,textAlignment:y.a.string,readOnly:y.a.bool,tabIndex:y.a.number,placeholder:y.a.string,ariaLabel:y.a.string,ariaOwneeID:y.a.string,ariaActiveDescendantID:y.a.string,ariaAutoComplete:y.a.string,ariaDescribedBy:y.a.string,ariaExpanded:y.a.string,ariaHasPopup:y.a.string,customBlockRenderFunc:y.a.func,wrapperId:y.a.number,customDecorators:y.a.array,editorRef:y.a.func,handlePastedText:y.a.func},cr.defaultProps={toolbarOnFocus:!1,toolbarHidden:!1,stripPastedStyles:!1,localization:{locale:"en",translations:{}},customDecorators:[]};var ar=cr}],i.c=a,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(n,o,function(t){return e[t]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=8);function i(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}var c,a});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.draftjsToHtml = factory());
}(this, (function () { 'use strict';

  /**
  * Utility function to execute callback for eack key->value pair.
  */
  function forEach(obj, callback) {
    if (obj) {
      for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if ({}.hasOwnProperty.call(obj, key)) {
          callback(key, obj[key]);
        }
      }
    }
  }
  /**
  * The function returns true if the string passed to it has no content.
  */

  function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
      return true;
    }

    return false;
  }

  /**
  * Mapping block-type to corresponding html tag.
  */

  var blockTypesMapping = {
    unstyled: 'p',
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'header-six': 'h6',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    blockquote: 'blockquote',
    code: 'pre'
  };
  /**
  * Function will return HTML tag for a block.
  */

  function getBlockTag(type) {
    return type && blockTypesMapping[type];
  }
  /**
  * Function will return style string for a block.
  */

  function getBlockStyle(data) {
    var styles = '';
    forEach(data, function (key, value) {
      if (value) {
        styles += "".concat(key, ":").concat(value, ";");
      }
    });
    return styles;
  }
  /**
  * The function returns an array of hashtag-sections in blocks.
  * These will be areas in block which have hashtags applicable to them.
  */

  function getHashtagRanges(blockText, hashtagConfig) {
    var sections = [];

    if (hashtagConfig) {
      var counter = 0;
      var startIndex = 0;
      var text = blockText;
      var trigger = hashtagConfig.trigger || '#';
      var separator = hashtagConfig.separator || ' ';

      for (; text.length > 0 && startIndex >= 0;) {
        if (text[0] === trigger) {
          startIndex = 0;
          counter = 0;
          text = text.substr(trigger.length);
        } else {
          startIndex = text.indexOf(separator + trigger);

          if (startIndex >= 0) {
            text = text.substr(startIndex + (separator + trigger).length);
            counter += startIndex + separator.length;
          }
        }

        if (startIndex >= 0) {
          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
          var hashtag = text.substr(0, endIndex);

          if (hashtag && hashtag.length > 0) {
            sections.push({
              offset: counter,
              length: hashtag.length + trigger.length,
              type: 'HASHTAG'
            });
          }

          counter += trigger.length;
        }
      }
    }

    return sections;
  }
  /**
  * The function returns an array of entity-sections in blocks.
  * These will be areas in block which have same entity or no entity applicable to them.
  */


  function getSections(block, hashtagConfig) {
    var sections = [];
    var lastOffset = 0;
    var sectionRanges = block.entityRanges.map(function (range) {
      var offset = range.offset,
          length = range.length,
          key = range.key;
      return {
        offset: offset,
        length: length,
        key: key,
        type: 'ENTITY'
      };
    });
    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
    sectionRanges = sectionRanges.sort(function (s1, s2) {
      return s1.offset - s2.offset;
    });
    sectionRanges.forEach(function (r) {
      if (r.offset > lastOffset) {
        sections.push({
          start: lastOffset,
          end: r.offset
        });
      }

      sections.push({
        start: r.offset,
        end: r.offset + r.length,
        entityKey: r.key,
        type: r.type
      });
      lastOffset = r.offset + r.length;
    });

    if (lastOffset < block.text.length) {
      sections.push({
        start: lastOffset,
        end: block.text.length
      });
    }

    return sections;
  }
  /**
  * Function to check if the block is an atomic entity block.
  */


  function isAtomicEntityBlock(block) {
    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
      return true;
    }

    return false;
  }
  /**
  * The function will return array of inline styles applicable to the block.
  */


  function getStyleArrayForBlock(block) {
    var text = block.text,
        inlineStyleRanges = block.inlineStyleRanges;
    var inlineStyles = {
      BOLD: new Array(text.length),
      ITALIC: new Array(text.length),
      UNDERLINE: new Array(text.length),
      STRIKETHROUGH: new Array(text.length),
      CODE: new Array(text.length),
      SUPERSCRIPT: new Array(text.length),
      SUBSCRIPT: new Array(text.length),
      COLOR: new Array(text.length),
      BGCOLOR: new Array(text.length),
      FONTSIZE: new Array(text.length),
      FONTFAMILY: new Array(text.length),
      length: text.length
    };

    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
      inlineStyleRanges.forEach(function (range) {
        var offset = range.offset;
        var length = offset + range.length;

        for (var i = offset; i < length; i += 1) {
          if (range.style.indexOf('color-') === 0) {
            inlineStyles.COLOR[i] = range.style.substring(6);
          } else if (range.style.indexOf('bgcolor-') === 0) {
            inlineStyles.BGCOLOR[i] = range.style.substring(8);
          } else if (range.style.indexOf('fontsize-') === 0) {
            inlineStyles.FONTSIZE[i] = range.style.substring(9);
          } else if (range.style.indexOf('fontfamily-') === 0) {
            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
          } else if (inlineStyles[range.style]) {
            inlineStyles[range.style][i] = true;
          }
        }
      });
    }

    return inlineStyles;
  }
  /**
  * The function will return inline style applicable at some offset within a block.
  */


  function getStylesAtOffset(inlineStyles, offset) {
    var styles = {};

    if (inlineStyles.COLOR[offset]) {
      styles.COLOR = inlineStyles.COLOR[offset];
    }

    if (inlineStyles.BGCOLOR[offset]) {
      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
    }

    if (inlineStyles.FONTSIZE[offset]) {
      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
    }

    if (inlineStyles.FONTFAMILY[offset]) {
      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
    }

    if (inlineStyles.UNDERLINE[offset]) {
      styles.UNDERLINE = true;
    }

    if (inlineStyles.ITALIC[offset]) {
      styles.ITALIC = true;
    }

    if (inlineStyles.BOLD[offset]) {
      styles.BOLD = true;
    }

    if (inlineStyles.STRIKETHROUGH[offset]) {
      styles.STRIKETHROUGH = true;
    }

    if (inlineStyles.CODE[offset]) {
      styles.CODE = true;
    }

    if (inlineStyles.SUBSCRIPT[offset]) {
      styles.SUBSCRIPT = true;
    }

    if (inlineStyles.SUPERSCRIPT[offset]) {
      styles.SUPERSCRIPT = true;
    }

    return styles;
  }
  /**
  * Function returns true for a set of styles if the value of these styles at an offset
  * are same as that on the previous offset.
  */

  function sameStyleAsPrevious(inlineStyles, styles, index) {
    var sameStyled = true;

    if (index > 0 && index < inlineStyles.length) {
      styles.forEach(function (style) {
        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
      });
    } else {
      sameStyled = false;
    }

    return sameStyled;
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */

  function addInlineStyleMarkup(style, content) {
    if (style === 'BOLD') {
      return "<strong>".concat(content, "</strong>");
    }

    if (style === 'ITALIC') {
      return "<em>".concat(content, "</em>");
    }

    if (style === 'UNDERLINE') {
      return "<ins>".concat(content, "</ins>");
    }

    if (style === 'STRIKETHROUGH') {
      return "<del>".concat(content, "</del>");
    }

    if (style === 'CODE') {
      return "<code>".concat(content, "</code>");
    }

    if (style === 'SUPERSCRIPT') {
      return "<sup>".concat(content, "</sup>");
    }

    if (style === 'SUBSCRIPT') {
      return "<sub>".concat(content, "</sub>");
    }

    return content;
  }
  /**
  * The function returns text for given section of block after doing required character replacements.
  */

  function getSectionText(text) {
    if (text && text.length > 0) {
      var chars = text.map(function (ch) {
        switch (ch) {
          case '\n':
            return '<br>';

          case '&':
            return '&amp;';

          case '<':
            return '&lt;';

          case '>':
            return '&gt;';

          default:
            return ch;
        }
      });
      return chars.join('');
    }

    return '';
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */


  function addStylePropertyMarkup(styles, text) {
    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
      var styleString = 'style="';

      if (styles.COLOR) {
        styleString += "color: ".concat(styles.COLOR, ";");
      }

      if (styles.BGCOLOR) {
        styleString += "background-color: ".concat(styles.BGCOLOR, ";");
      }

      if (styles.FONTSIZE) {
        styleString += "font-size: ".concat(styles.FONTSIZE).concat(/^\d+$/.test(styles.FONTSIZE) ? 'px' : '', ";");
      }

      if (styles.FONTFAMILY) {
        styleString += "font-family: ".concat(styles.FONTFAMILY, ";");
      }

      styleString += '"';
      return "<span ".concat(styleString, ">").concat(text, "</span>");
    }

    return text;
  }
  /**
  * Function will return markup for Entity.
  */

  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
    var entity = entityMap[entityKey];

    if (typeof customEntityTransform === 'function') {
      var html = customEntityTransform(entity, text);

      if (html) {
        return html;
      }
    }

    if (entity.type === 'MENTION') {
      return "<a href=\"".concat(entity.data.url, "\" class=\"wysiwyg-mention\" data-mention data-value=\"").concat(entity.data.value, "\">").concat(text, "</a>");
    }

    if (entity.type === 'LINK') {
      var targetOption = entity.data.targetOption || '_self';
      return "<a href=\"".concat(entity.data.url, "\" target=\"").concat(targetOption, "\">").concat(text, "</a>");
    }

    if (entity.type === 'IMAGE') {
      var alignment = entity.data.alignment;

      if (alignment && alignment.length) {
        return "<div style=\"text-align:".concat(alignment, ";\"><img src=\"").concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/></div>");
      }

      return "<img src=\"".concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/>");
    }

    if (entity.type === 'EMBEDDED_LINK') {
      return "<iframe width=\"".concat(entity.data.width, "\" height=\"").concat(entity.data.height, "\" src=\"").concat(entity.data.src, "\" frameBorder=\"0\"></iframe>");
    }

    return text;
  }
  /**
  * For a given section in a block the function will return a further list of sections,
  * with similar inline styles applicable to them.
  */


  function getInlineStyleSections(block, styles, start, end) {
    var styleSections = [];
    var text = Array.from(block.text);

    if (text.length > 0) {
      var inlineStyles = getStyleArrayForBlock(block);
      var section;

      for (var i = start; i < end; i += 1) {
        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
          section.text.push(text[i]);
          section.end = i + 1;
        } else {
          section = {
            styles: getStylesAtOffset(inlineStyles, i),
            text: [text[i]],
            start: i,
            end: i + 1
          };
          styleSections.push(section);
        }
      }
    }

    return styleSections;
  }
  /**
  * Replace leading blank spaces by &nbsp;
  */


  function trimLeadingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = 0; i < replacedText.length; i += 1) {
        if (sectionText[i] === ' ') {
          replacedText = replacedText.replace(' ', '&nbsp;');
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * Replace trailing blank spaces by &nbsp;
  */

  function trimTrailingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
        if (replacedText[i] === ' ') {
          replacedText = "".concat(replacedText.substring(0, i), "&nbsp;").concat(replacedText.substring(i + 1));
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * The method returns markup for section to which inline styles
  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
  */

  function getStyleTagSectionMarkup(styleSection) {
    var styles = styleSection.styles,
        text = styleSection.text;
    var content = getSectionText(text);
    forEach(styles, function (style, value) {
      content = addInlineStyleMarkup(style, content);
    });
    return content;
  }
  /**
  * The method returns markup for section to which inline styles
  like color, background-color, font-size are applicable.
  */


  function getInlineStyleSectionMarkup(block, styleSection) {
    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
    var styleSectionText = '';
    styleTagSections.forEach(function (stylePropertySection) {
      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
    });
    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
    return styleSectionText;
  }
  /*
  * The method returns markup for an entity section.
  * An entity section is a continuous section in a block
  * to which same entity or no entity is applicable.
  */


  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
    var entityInlineMarkup = [];
    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
    inlineStyleSections.forEach(function (styleSection) {
      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
    });
    var sectionText = entityInlineMarkup.join('');

    if (section.type === 'ENTITY') {
      if (section.entityKey !== undefined && section.entityKey !== null) {
        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
      }
    } else if (section.type === 'HASHTAG') {
      sectionText = "<a href=\"".concat(sectionText, "\" class=\"wysiwyg-hashtag\">").concat(sectionText, "</a>");
    }

    return sectionText;
  }
  /**
  * Function will return the markup for block preserving the inline styles and
  * special characters like newlines or blank spaces.
  */


  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
    var blockMarkup = [];
    var sections = getSections(block, hashtagConfig);
    sections.forEach(function (section, index) {
      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);

      if (index === 0) {
        sectionText = trimLeadingZeros(sectionText);
      }

      if (index === sections.length - 1) {
        sectionText = trimTrailingZeros(sectionText);
      }

      blockMarkup.push(sectionText);
    });
    return blockMarkup.join('');
  }
  /**
  * Function will return html for the block.
  */

  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
    var blockHtml = [];

    if (isAtomicEntityBlock(block)) {
      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
    } else {
      var blockTag = getBlockTag(block.type);

      if (blockTag) {
        blockHtml.push("<".concat(blockTag));
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          blockHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          blockHtml.push(' dir = "auto"');
        }

        blockHtml.push('>');
        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        blockHtml.push("</".concat(blockTag, ">"));
      }
    }

    blockHtml.push('\n');
    return blockHtml.join('');
  }

  /**
  * Function to check if a block is of type list.
  */

  function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
  }
  /**
  * Function will return html markup for a list block.
  */

  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock;
    listBlocks.forEach(function (block) {
      var nestedBlock = false;

      if (!previousBlock) {
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.type !== block.type) {
        listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.depth === block.depth) {
        if (nestedListBlock && nestedListBlock.length > 0) {
          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
          nestedListBlock = [];
        }
      } else {
        nestedBlock = true;
        nestedListBlock.push(block);
      }

      if (!nestedBlock) {
        listHtml.push('<li');
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          listHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          listHtml.push(' dir = "auto"');
        }

        listHtml.push('>');
        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        listHtml.push('</li>\n');
        previousBlock = block;
      }
    });

    if (nestedListBlock && nestedListBlock.length > 0) {
      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }

    listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
    return listHtml.join('');
  }

  /**
  * The function will generate html markup for given draftjs editorContent.
  */

  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];

    if (editorContent) {
      var blocks = editorContent.blocks,
          entityMap = editorContent.entityMap;

      if (blocks && blocks.length > 0) {
        var listBlocks = [];
        blocks.forEach(function (block) {
          if (isList(block.type)) {
            listBlocks.push(block);
          } else {
            if (listBlocks.length > 0) {
              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len

              html.push(listHtml);
              listBlocks = [];
            }

            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
            html.push(blockHtml);
          }
        });

        if (listBlocks.length > 0) {
          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len

          html.push(listHtml);
          listBlocks = [];
        }
      }
    }

    return html.join('');
  }

  return draftToHtml;

})));


/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_QrCode__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Field_CustomerDeptSelect__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
//options
//services
var LeftSection=function(_Component){_inherits(LeftSection,_Component);function LeftSection(){var _ref,_this$state;var _temp,_this,_ret;_classCallCheck(this,LeftSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LeftSection.__proto__||Object.getPrototypeOf(LeftSection)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={//options
styleOptions:"",disabled:false,SAMPLETYPE:[],customerList:[],styleNoInfo:[],magnumStyleId:""},_defineProperty(_this$state,"disabled",false),_defineProperty(_this$state,"toolTip",{}),_defineProperty(_this$state,"action",""),_this$state),_this.getCustomerList=function(){__WEBPACK_IMPORTED_MODULE_8__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){_this.setState({customerList:response.text.data},function(){_this.state.customerList&&_this.state.customerList.length>0&&_this.state.customerList.map(function(cust){if(cust.departmentId===_this.state.sampleRequest.customerDepartmentId||cust.customerName===_this.state.sampleRequest.customer){var toolTip={custName:cust.customerName,deptName:cust.departmentName,merchandiser:cust.merchandiser};_this.setState({toolTip:toolTip},function(){_this.props.getCustomerDepartmentName(toolTip);});}});});}}).catch(function(error){});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LeftSection,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,sampleRequest=_props.sampleRequest,SAMPLETYPE=_props.SAMPLETYPE,disabled=_props.disabled,styleNoInfo=_props.styleNoInfo,magnumStyleId=_props.magnumStyleId,action=_props.action;this.setState({sampleRequest:sampleRequest,disabled:disabled,SAMPLETYPE:SAMPLETYPE,styleNoInfo:styleNoInfo,magnumStyleId:magnumStyleId,action:action});}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.getCustomerList();},4500);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(Object.keys(this.state.SAMPLETYPE).length!=Object.keys(nextProps.SAMPLETYPE).length){this.setState({SAMPLETYPE:nextProps.SAMPLETYPE});}if(nextProps.sampleRequest.customer!==this.state.sampleRequest.customer&&nextProps.sampleRequest.customerDepartmentId!==this.state.sampleRequest.customerDepartmentId){this.getCustomerList();}var sampleRequest=nextProps.sampleRequest,disabled=nextProps.disabled,styleNoInfo=nextProps.styleNoInfo,magnumStyleId=nextProps.magnumStyleId;this.setState({sampleRequest:sampleRequest,disabled:disabled,styleNoInfo:styleNoInfo,magnumStyleId:magnumStyleId});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,sampleRequest=_state.sampleRequest,SAMPLETYPE=_state.SAMPLETYPE,magnumStyleId=_state.magnumStyleId,styleNoInfo=_state.styleNoInfo;var redirectTem=void 0;if(sampleRequest&&sampleRequest.styleReferenceId&&styleNoInfo&&styleNoInfo.length){var hash=styleNoInfo[0];var action=this.props.action==="add"&&"view"||this.props.action;var search="?"+new URLSearchParams({action:action,_id:sampleRequest.magnumStyleId}).toString();redirectTem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:"/StylePage",search:search,hash:"seleted"+hash.label.split("-").join("")},target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"btn-default"},"Magnum Style No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*")));}else{redirectTem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"btn-default"},"Magnum Style No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*"));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"left-content-section no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col text-center bg-color padding-bottom-bg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"text-green font-lg font-weight-bold mt-1"},sampleRequest.requestNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_QrCode__["a" /* default */],{qr:sampleRequest.qr}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},redirectTem,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"styleReferenceId",value:sampleRequest.styleReferenceId,onInputChange:function onInputChange(value){return _this3.props.getMagnumStyleNo(value);},onChange:function onChange(val){return _this3.props.getStyleReferenceInfo(val!==null?val.value:null);},placeholder:"Find Style",options:this.state.styleNoInfo,disabled:this.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"magnumStyleName",value:sampleRequest.magnumStyleName,label:"Magnum Style Name*",onChange:this.props.updateSampleRequest,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"customerRefNumber",value:sampleRequest.customerRefNumber,label:"Cust Ref No.",onChange:this.props.updateSampleRequest,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Field_CustomerDeptSelect__["a" /* default */],{value:sampleRequest.customer+"-"+sampleRequest.customerDepartmentId,toolTip:this.state.toolTip,options:this.state.customerList,onChange:this.props.updateCustomerDept,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"typeOfRequest",value:sampleRequest.typeOfRequest,options:__WEBPACK_IMPORTED_MODULE_7__services_common_options__["a" /* default */].typeOfRequest,label:"Source of Request*",onChange:this.props.updateSampleRequest,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mt-1  p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"sampleType",value:sampleRequest.sampleType||"",options:SAMPLETYPE,label:"Sample Type*",onChange:this.props.updateSampleRequest,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"p-0"})));}}]);return LeftSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LeftSection);LeftSection.propTypes={};LeftSection.defaultProps={};

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MarkerModule=function(_Component){_inherits(MarkerModule,_Component);function MarkerModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MarkerModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MarkerModule.__proto__||Object.getPrototypeOf(MarkerModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",marker:[],STATUS:[],assignedToList:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MarkerModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,marker=_props.marker,markerProcess=_props.markerProcess,STATUS=_props.STATUS,assignedToList=_props.assignedToList,disabled=_props.disabled;this.setState({_id:_id,marker:marker,markerProcess:markerProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,marker=nextProps.marker,markerProcess=nextProps.markerProcess,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled;this.setState({_id:_id,marker:marker,markerProcess:markerProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,marker=_state.marker,STATUS=_state.STATUS;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter",id:"marker",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ModuleHeader__["a" /* default */],{header:"Marker ",onClick:this.onOpenModal,_id:this.state._id,updateModulesMain:this.props.updateModulesMain,moduleName:"marker",disabled:this.state.disabled,process:this.state.markerProcess,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 ",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"markerForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 hide-customer-site"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"marker",getRefImages:function getRefImages(refImages){return _this2.props.getRefImages(refImages,"marker");},disabled:this.state.disabled,uploadedDocs:marker.refImages?marker.refImages:null,imageTypeOption:[]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:marker.comments,label:"comments",onChange:this.props.updateMarker,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createMarker(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeMarker(e);}}))))));}}]);return MarkerModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MarkerModule);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimerModule__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var patternTemplate={assignedTo:"",masterName:"",type:"",blockRef:"",trial:true,status:"",ETA:"",completedDate:""};var timeTemplate={in:"",out:"",break:"",reason:""};var PatternModule=function(_Component){_inherits(PatternModule,_Component);function PatternModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PatternModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PatternModule.__proto__||Object.getPrototypeOf(PatternModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={pattern:_this.props.pattern,disabled:false,toggle:true,patternCount:[patternTemplate],timeCount:[timeTemplate],assignedToList:[],STATUS:[],PATTERN:{},durationPatterns:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PatternModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,pattern=_props.pattern,assignedToList=_props.assignedToList,disabled=_props.disabled,STATUS=_props.STATUS,PATTERNTYPE=_props.PATTERNTYPE,patternProcess=_props.patternProcess,durationPatterns=_props.durationPatterns;this.setState({_id:_id,pattern:pattern,patternProcess:patternProcess,assignedToList:assignedToList,disabled:disabled,STATUS:STATUS,PATTERNTYPE:PATTERNTYPE,durationPatterns:durationPatterns});//console.log(this.props,"propspatt")
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,pattern=nextProps.pattern,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled,STATUS=nextProps.STATUS,PATTERNTYPE=nextProps.PATTERNTYPE,patternProcess=nextProps.patternProcess,durationPatterns=nextProps.durationPatterns;this.setState({_id:_id,pattern:pattern,patternProcess:patternProcess,assignedToList:assignedToList,disabled:disabled,STATUS:STATUS,PATTERNTYPE:PATTERNTYPE,durationPatterns:durationPatterns});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,pattern=_state.pattern,STATUS=_state.STATUS,assignedToList=_state.assignedToList;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter",id:"pattern",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ModuleHeader__["a" /* default */],{header:"Pattern ",durationETA:this.state.durationPatterns,onClick:this.onOpenModal,_id:this.state._id,moduleName:"pattern",disabled:this.state.disabled,process:this.state.patternProcess,updateModulesMain:this.props.updateModulesMain,statusList:STATUS,measurementModal:true,customer:this.props.customer,customerDepartmentId:this.props.customerDepartmentId,type:this.props.type,magnumStyleId:this.props.magnumStyleId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"patternForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Pattern Master Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Pattern type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Block Ref used"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Trial Required"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Approval Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"patternMaster",value:pattern.patternMaster// onInputChange={e =>
//   this.getPatternMaster(e, "patternMaster")
// }
,onChange:function onChange(value){return _this2.props.updatePattern("patternMaster",value.value);},placeholder:"Find Pattern Master ",options:assignedToList,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"patternType",value:pattern.patternType,options:this.state.PATTERNTYPE||[],onChange:this.props.updatePattern,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"blockRefNumber",value:pattern.blockRefNumber,onChange:this.props.updatePattern,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkboxToggle",inputName:"trailRequired",value:pattern.trailRequired,onChange:this.props.updatePattern,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"approvalStatus",value:pattern.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}]// index={index}
,onChange:this.props.updatePattern,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-center",style:{width:"7%",padding:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Logs"),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addPatternLog();}}))),pattern.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TimerModule__["a" /* default */],{time:log.timeIn,buttonName:"time in",updatePatternCheck:function updatePatternCheck(){return _this2.props.updatePatternCheck("timeIn",i);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TimerModule__["a" /* default */],{time:log.timeOut,buttonName:"time out",updatePatternCheck:function updatePatternCheck(){return _this2.props.updatePatternCheck("timeOut",i);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"time",maxlength:23,inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this2.props.updatePatternLog(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason,onChange:function onChange(name,value){return _this2.props.updatePatternLog(name,value,i);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one pl-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removePatternLog(i);}})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:pattern.comment,label:"comments",onChange:this.props.updatePattern,disabled:this.state.disabled})))))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createPattern(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completePattern(e);}})))));}}]);return PatternModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PatternModule);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProcessUpdate=function(_Component){_inherits(ProcessUpdate,_Component);function ProcessUpdate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProcessUpdate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProcessUpdate.__proto__||Object.getPrototypeOf(ProcessUpdate)).call.apply(_ref,[this].concat(args))),_this),_this.state={tempState:{date:JSON.stringify(new Date())}// statusOption: [
//   { label: "CANCEL", value: "CANCEL" },
//   { label: "COMPLETED", value: "COMPLETED" },
//   { label: "IN PROCESS", value: "INPROCESS" },
//   { label: "PENDING", value: "PENDING" }
// ]
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProcessUpdate,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,assignedTo=_props.assignedTo,toggle=_props.toggle,STATUS=_props.STATUS,processUpdates=_props.processUpdates,assignedToList=_props.assignedToList,disabled=_props.disabled;this.setState({_id:_id,assignedTo:assignedTo,toggle:toggle,processUpdates:processUpdates,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,assignedTo=nextProps.assignedTo,toggle=nextProps.toggle,STATUS=nextProps.STATUS,processUpdates=nextProps.processUpdates,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled;this.setState({_id:_id,assignedTo:assignedTo,toggle:toggle,processUpdates:processUpdates,assignedToList:assignedToList,STATUS:STATUS,disabled:disabled});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,toggle=_state.toggle,STATUS=_state.STATUS,processUpdates=_state.processUpdates,disabled=_state.disabled;var _props2=this.props,permissions=_props2.permissions,action=_props2.action;var gvnAllPermit=void 0,length=Object.keys(permissions).length;var j=0;Object.keys(permissions).forEach(function(x){var keyname1=x==="garmentTechnologist"?"garmentTech":x==='qc'?"QC":x==='signOff'?'signoff':x;if(permissions[keyname1].web.create||permissions[keyname1].web.edit){j++;if(j==length){gvnAllPermit=true;}}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,gvnAllPermit&&!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{type:"save",buttonName:"Click to complete all",onClick:function onClick(){return _this2.props.completeAllHandler("COMPLETED");},disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{type:"save",buttonName:"Click to Cancel all",onClick:function onClick(){return _this2.props.completeAllHandler("CANCEL");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 mt-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table table-fixed"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"bg-color"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"10",className:"text-left"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"25"},"Assigned To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"18"},"ETA Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"18"},"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"18"},"Comments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"19"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{width:"10"},"Completed Date"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,Object.keys(toggle).map(function(keyname,i){var keyname1=keyname==="garmentTechnologist"?"garmentTech":keyname==='qc'?"QC":keyname==='signOff'?'signoff':keyname;var permit=permissions[keyname1].web.edit||permissions[keyname1].web.view||permissions[keyname1].web.create;if(toggle[keyname]&&(permissions[keyname1].web.view&&action==="view"||permissions[keyname1].web.create&&action==="add"||permissions[keyname1].web.edit&&action==="edit")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-bottom-style",key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"uppercase-text"},keyname=="garmentTechnologist"?"Garment Tech":keyname==='qc'?'GRADING':keyname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"assignedTo",value:_this2.state.processUpdates[keyname].assignedTo,onChange:function onChange(value){return _this2.props.updateProcessUpdate("assignedTo",value,keyname);},placeholder:"AssignedTo",options:_this2.state.assignedToList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"ETA",value:_this2.state.processUpdates[keyname].ETA,onChange:function onChange(name,value){return _this2.props.updateProcessUpdate(name,value,keyname);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"status",value:_this2.state.processUpdates[keyname].status,options:STATUS,onChange:function onChange(name,value){return _this2.props.updateProcessUpdate(name,value,keyname);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"comments",value:_this2.state.processUpdates[keyname].comments,options:_this2.state.statusOption,disabled:_this2.state.disabled,onChange:function onChange(name,value){return _this2.props.updateProcessUpdate(name,value,keyname);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{disabled:_this2.state.disabled,type:"button","class":"primary",name:"button",onClick:function onClick(){_this2.props.updateProcessUpdate("processDate",new Date(),keyname);_this2.props.updateProcessUpdate("status","COMPLETED",keyname);}},"Completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2.state.processUpdates[keyname].processDate!==null&&_this2.state.processUpdates[keyname].status==="COMPLETED"?__WEBPACK_IMPORTED_MODULE_4_moment___default()(_this2.state.processUpdates[keyname].processDate).format("DD MMM YYYY"):""));}})))),gvnAllPermit&&!disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:this.props.ProcessUpdates})));}}]);return ProcessUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProcessUpdate);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QcModule=function(_Component){_inherits(QcModule,_Component);function QcModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QcModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QcModule.__proto__||Object.getPrototypeOf(QcModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",qc:[],STATUS:[],assignedToList:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QcModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,qc=_props.qc,qcProcess=_props.qcProcess,STATUS=_props.STATUS,assignedToList=_props.assignedToList,disabled=_props.disabled;this.setState({_id:_id,qc:qc,qcProcess:qcProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,qc=nextProps.qc,qcProcess=nextProps.qcProcess,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled;this.setState({_id:_id,qc:qc,qcProcess:qcProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,qc=_state.qc,STATUS=_state.STATUS,assignedToList=_state.assignedToList;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"qc",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Grading ",onClick:this.onOpenModal,_id:this.state._id,process:this.state.qcProcess,updateModulesMain:this.props.updateModulesMain,moduleName:"qc",disabled:this.state.disabled,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"anyIssue",value:qc.anyIssue,label:"Any Issue",onChange:this.props.updateQc,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},qc.anyIssue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"ref-no"},"if yes, reason"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text","class":"form-control",name:"reason",value:qc.reason,onChange:function onChange(e){return _this2.props.updateQc(e.target.name,e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 hide-customer-site"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"marker",getRefImages:function getRefImages(refImages){return _this2.props.getRefImages(refImages,"qc");},disabled:this.state.disabled,uploadedDocs:qc.refImages.length>0?qc.refImages:null,imageTypeOption:[]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:qc.comments,label:"comments",onChange:this.props.updateQc,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createQC(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeQC(e);}})))));}}]);return QcModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (QcModule);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//components
// import ModuleHeader from '../ModuleHeader'
var SampleMain=function(_Component){_inherits(SampleMain,_Component);function SampleMain(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SampleMain);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SampleMain.__proto__||Object.getPrototypeOf(SampleMain)).call.apply(_ref,[this].concat(args))),_this),_this.state={sampleRequest:{},//options
SAMPLEREQUEST:{},disabled:false},_this.getMagnumStyleNo=function(){},_this.changeStyleNo=function(){},_this.createSampleRequest=function(e){e.preventDefault();var sampleRequest=Object.assign({},_this.state.sampleRequest);},_this.openModal=function(moduelname){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SampleMain,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,sampleRequest=_props.sampleRequest,disabled=_props.disabled,orderDate=_props.orderDate;this.setState({SAMPLEREQUEST:this.props.SAMPLEREQUEST,sampleRequest:sampleRequest,disabled:disabled,orderDate:orderDate});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(Object.keys(this.state.SAMPLEREQUEST).length!=Object.keys(nextProps.SAMPLEREQUEST).length){this.setState({SAMPLEREQUEST:nextProps.SAMPLEREQUEST});}var sampleRequest=nextProps.sampleRequest,disabled=nextProps.disabled,orderDate=nextProps.orderDate;this.setState({sampleRequest:sampleRequest,disabled:disabled,orderDate:orderDate});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,SAMPLEREQUEST=_state.SAMPLEREQUEST,sampleRequest=_state.sampleRequest,orderDate=_state.orderDate;var rights=this.props.rights;// let gvnAllPermit, length = Object.keys(rights).length
// let j = 0
// Object.keys(rights).forEach((x) => {
//   let keyname1 = x === "garmentTechnologist" ? "garmentTech" : x === 'qc' ? "QC" : x === 'signOff' ? 'signoff' : x
//   if (rights[keyname1].web.create || rights[keyname1].web.edit) {
//     j++
//     if (j == length) {
//       gvnAllPermit = true
//     }
//   }
// })
var gvnAllPermit=void 0;Object.keys(rights.sampleRequest).forEach(function(x){gvnAllPermit=rights.sampleRequest[x];});if(Object.keys(SAMPLEREQUEST).length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"originationOfRequest",value:sampleRequest.originationOfRequest,options:SAMPLEREQUEST.ORIGINATIONOFREQUEST,label:"Origination of Request *",onChange:this.props.updateSampleRequest,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Buyer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,sampleRequest.buyerName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Assistant Buyer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,sampleRequest.assistantBuyer))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Fabric Technologist"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,sampleRequest.fabricTechnologist))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Garment Technologist"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,sampleRequest.garmentTechnology))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Magnum Technologist"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,sampleRequest.magnumTechnologist)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date Created"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(orderDate).format("HH:mm DD MMM YYYY")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center"},!this.state.disabled&&gvnAllPermit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"Create Request",buttonType:"save",onClick:this.props.createSample}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonName:"Duplicate",buttonType:"save",onClick:function onClick(){_this2.props.confirmDuplicate();}}))));}else{return null;}}}]);return SampleMain;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SampleMain);SampleMain.propTypes={};SampleMain.defaultProps={};

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SampleModule=function(_Component){_inherits(SampleModule,_Component);function SampleModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SampleModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SampleModule.__proto__||Object.getPrototypeOf(SampleModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",sample:[],SAMPLEREQUEST:{},STATUS:[],assignedToList:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SampleModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,sample=_props.sample,_id=_props._id,SAMPLEREQUEST=_props.SAMPLEREQUEST,disabled=_props.disabled,assignedToList=_props.assignedToList,sampleProcess=_props.sampleProcess,sizeList=_props.sizeList;this.setState({sample:sample,_id:_id,SAMPLEREQUEST:SAMPLEREQUEST,disabled:disabled,sampleProcess:sampleProcess,assignedToList:assignedToList,sizeList:sizeList});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(Object.keys(this.state.SAMPLEREQUEST).length!=Object.keys(nextProps.SAMPLEREQUEST).length){this.setState({SAMPLEREQUEST:nextProps.SAMPLEREQUEST});}if(this.state.STATUS.length!=nextProps.STATUS.length){this.setState({STATUS:nextProps.STATUS});}if(this.state.assignedToList.length!=nextProps.assignedToList.length){this.setState({assignedToList:nextProps.assignedToList});}var sample=nextProps.sample,_id=nextProps._id,disabled=nextProps.disabled,sampleProcess=nextProps.sampleProcess,sizeList=nextProps.sizeList;this.setState({sample:sample,sampleProcess:sampleProcess,sizeList:sizeList,_id:_id,disabled:disabled});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,sample=_state.sample,SAMPLEREQUEST=_state.SAMPLEREQUEST,STATUS=_state.STATUS,assignedToList=_state.assignedToList;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding",id:"sample",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Sample",moduleName:"sample",onClick:this.openModal,_id:this.state._id,process:this.props.sampleProcess,statusList:STATUS,updateModulesMain:this.props.updateModulesMain,disabled:this.props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"sampleForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"awaitingDevSample",value:sample.awaitingDevSample,label:"Awaiting Dev Sample",onChange:this.props.getSample,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"awaitingDevSheet",value:sample.awaitingDevSheet,label:"Awaiting Design Sheet",onChange:this.props.getSample,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-1 inline-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sizes"),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addSize();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"main-sample-size-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},sample.data.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,"class":"col-md-4 size-mngr size-mngr-mod pl-0 mb-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-4-shadow px-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group mb-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"size",value:data.size,index:i,onChange:_this2.props.getSample,options:_this2.state.sizeList,disabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-5 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group mb-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"address"},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",min:"0",value:data.quantity,disabled:_this2.state.disabled,onChange:function onChange(e){return _this2.props.getSample(e.target.name,e.target.value,i);},"class":"form-control",name:"quantity"}))),!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 add-address",style:{top:"18px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeSize(i);}}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:sample.comments,label:"comments",onChange:this.props.getSample,disabled:this.state.disabled})),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createSampleModule(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeSampleModule(e);}}))));}}]);return SampleModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SampleModule);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Component
var SampleModuleSelect=function(_Component){_inherits(SampleModuleSelect,_Component);function SampleModuleSelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SampleModuleSelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SampleModuleSelect.__proto__||Object.getPrototypeOf(SampleModuleSelect)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:"",disabled:false,toggle:{}},_this.moduleChoosen=function(e){_this.setState({selected:e.target.value});_this.props.selectedModule(e.target.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SampleModuleSelect,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,disabled=_props.disabled,selected=_props.selected,toggle=_props.toggle;this.setState({disabled:disabled,selected:selected,toggle:toggle});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var disabled=nextProps.disabled,selected=nextProps.selected,toggle=nextProps.toggle;this.setState({disabled:disabled,selected:selected,toggle:toggle});}//toggle
// toggleChange = async (name, value) => {
//     let toggle = { ...this.state.toggle }
//     toggle[name] = value
//     // await this.setState({ toggle })
//     await this.props.toggleDataChange(toggle)
// }
},{key:"render",value:function render(){var _this2=this;var _props2=this.props,toggle=_props2.toggle,rights=_props2.rights;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"sampleRequestForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col",style:{paddingTop:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},this.state.productId!==undefined&&this.state.productId!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"date"},"Order Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.state.orderDate).format("YYYY-MM-DD")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"date"},"Request No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.state.orderNumber)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 product-form nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8 mul-check check-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"group1",type:"radio",className:"filled-in hide-all",id:"rad1",value:"sampleRequest",checked:this.state.selected==="sampleRequest",onChange:function onChange(e){return _this2.moduleChoosen(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"rad1"},"SAMPLE REQUEST")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"radio-inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"group1",type:"radio",className:"filled-in hide-all",id:"rad2",value:"costingRequest",checked:this.state.selected==="costingRequest",onChange:function onChange(e){return _this2.moduleChoosen(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{"for":"rad2"},"COSTING REQUEST"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"samp-req-con w-100"},this.state.dispatchId!==undefined&&this.state.dispatchId!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{paddingTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.history.push("/generateTag");},"class":"primary"},"generate tag")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"nav-locator"},(rights.sample.web.view&&this.props.action==="view"||rights.sample.web.create&&this.props.action==="add"||rights.sample.web.edit&&this.props.action==="edit")&&this.state.selected!=="costingRequest"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"sample",className:toggle.sample?"":"print-hidden",value:toggle.sample,label:"Sample",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.garmentTech.web.view&&this.props.action==="view"||rights.garmentTech.web.create&&this.props.action==="add"||rights.garmentTech.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"garmentTechnologist",className:toggle.garmentTechnologist?"":"print-hidden",value:toggle.garmentTechnologist,label:"garmentTech",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.cad.web.view&&this.props.action==="view"||rights.cad.web.create&&this.props.action==="add"||rights.cad.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"cad",className:toggle.cad?"":"print-hidden",value:toggle.cad,label:"3D",onChange:this.props.toggleChange,disabled:this.state.disabled}))),(rights.fabric.web.view&&this.props.action==="view"||rights.fabric.web.create&&this.props.action==="add"||rights.fabric.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"fabric",className:toggle.fabric?"":"print-hidden",value:toggle.fabric,label:"fabric",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.trim.web.view&&this.props.action==="view"||rights.trim.web.create&&this.props.action==="add"||rights.trim.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"trim",className:toggle.trim?"":"print-hidden",value:toggle.trim,label:"trim",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.pattern.web.view&&this.props.action==="view"||rights.pattern.web.create&&this.props.action==="add"||rights.pattern.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"pattern",className:toggle.pattern?"":"print-hidden",value:toggle.pattern,label:"pattern",onChange:this.props.toggleChange,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,(rights.cutting.web.view&&this.props.action==="view"||rights.cutting.web.create&&this.props.action==="add"||rights.cutting.web.edit&&this.props.action==="edit")&&this.state.selected!=="costingRequest"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"cutting",className:toggle.cutting?"":"print-hidden",value:toggle.cutting,label:"cutting",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.sewing.web.view&&this.props.action==="view"||rights.sewing.web.create&&this.props.action==="add"||rights.sewing.web.edit&&this.props.action==="edit")&&this.state.selected!=="costingRequest"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"sewing",className:toggle.sewing?"":"print-hidden",value:toggle.sewing,label:"sewing",onChange:this.props.toggleChange,disabled:this.state.disabled}))),(rights.embellishment.web.view&&this.props.action==="view"||rights.embellishment.web.create&&this.props.action==="add"||rights.embellishment.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embellishment",className:toggle.embellishment?"":"print-hidden",value:toggle.embellishment,label:"embellishment",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.embroidery.web.view&&this.props.action==="view"||rights.embroidery.web.create&&this.props.action==="add"||rights.embroidery.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"embroidery",className:toggle.embroidery?"":"print-hidden",value:toggle.embroidery,label:"embroidery",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.wash.web.view&&this.props.action==="view"||rights.wash.web.create&&this.props.action==="add"||rights.wash.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"wash",className:toggle.wash?"":"print-hidden",value:toggle.wash,label:"wash",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.dispatch.web.view&&this.props.action==="view"||rights.dispatch.web.create&&this.props.action==="add"||rights.dispatch.web.edit&&this.props.action==="edit")&&this.state.selected!=="costingRequest"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"dispatch",className:toggle.dispatch?"":"print-hidden",value:toggle.dispatch,label:"dispatch",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.QC.web.view&&this.props.action==="view"||rights.QC.web.create&&this.props.action==="add"||rights.QC.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"qc",className:toggle.qc?"":"print-hidden",value:toggle.qc,label:"Grading",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.marker.web.view&&this.props.action==="view"||rights.marker.web.create&&this.props.action==="add"||rights.marker.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"marker",className:toggle.marker?"":"print-hidden",value:toggle.marker,label:"marker",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.costing.web.view&&this.props.action==="view"||rights.costing.web.create&&this.props.action==="add"||rights.costing.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"costing",className:toggle.costing?"":"print-hidden",value:toggle.costing,label:"costing",onChange:this.props.toggleChange,disabled:this.state.disabled})),(rights.signoff.web.view&&this.props.action==="view"||rights.signoff.web.create&&this.props.action==="add"||rights.signoff.web.edit&&this.props.action==="edit")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"signOff",className:toggle.signOff?"":"print-hidden",value:toggle.signOff,label:"signoff",onChange:this.props.toggleChange,disabled:this.state.disabled})))))))));}}]);return SampleModuleSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SampleModuleSelect);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Costing_FloatMenuList__ = __webpack_require__(243);
function ScrollMenu(props){var toggleData=props.toggleData;var moduleList=Object.keys(toggleData).filter(function(x){return toggleData[x];});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"scroll-up pull-right scroll-hide"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"fab"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"class":"fab-action-button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"class":"btn-floating btn-large green"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"fa fa-bars font-for-icon-big"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{"class":"fab-buttons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Costing_FloatMenuList__["a" /* default */],{moduleList:moduleList,goToDiv:props.scrollToModule}))));}

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimerModule__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonIcon__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_util__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var shirringTemplate={trimCategory:"",trimRefNo:"",placement:"",type:"",noOfRows:"",length:"",total:""};var SewingModule=function(_Component){_inherits(SewingModule,_Component);function SewingModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SewingModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SewingModule.__proto__||Object.getPrototypeOf(SewingModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={sewing:[],STATUS:[],PLACEOFSEWING:[],SEWINGTYPE:[],trimCategoryList:[],trimNumberList:[],assignedToList:[],sample:{},disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SewingModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,sewing=_props.sewing,disabled=_props.disabled,STATUS=_props.STATUS,assignedToList=_props.assignedToList,PLACEOFSEWING=_props.PLACEOFSEWING,SEWINGTYPE=_props.SEWINGTYPE,sewingProcess=_props.sewingProcess,trimNumberList=_props.trimNumberList,TRIM=_props.TRIM,sample=_props.sample,TRIMPLACEMENT=_props.TRIMPLACEMENT;var data=sample.data;data=data.map(function(x){return x.size&&{label:x.size}||0;});this.setState({_id:_id,sewing:sewing,disabled:disabled,STATUS:STATUS,assignedToList:assignedToList,PLACEOFSEWING:PLACEOFSEWING,SEWINGTYPE:SEWINGTYPE,sewingProcess:sewingProcess,trimNumberList:trimNumberList,sample:data,TRIM:TRIM,TRIMPLACEMENT:TRIMPLACEMENT});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,sewing=nextProps.sewing,disabled=nextProps.disabled,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,PLACEOFSEWING=nextProps.PLACEOFSEWING,SEWINGTYPE=nextProps.SEWINGTYPE,sewingProcess=nextProps.sewingProcess,trimNumberList=nextProps.trimNumberList,sample=nextProps.sample,TRIM=nextProps.TRIM,TRIMPLACEMENT=nextProps.TRIMPLACEMENT;var data=sample.data;data=data.map(function(x){return x.size&&{label:x.size}||0;});this.setState({_id:_id,sewing:sewing,disabled:disabled,STATUS:STATUS,assignedToList:assignedToList,PLACEOFSEWING:PLACEOFSEWING,SEWINGTYPE:SEWINGTYPE,sewingProcess:sewingProcess,sample:data,trimNumberList:trimNumberList,TRIM:TRIM,TRIMPLACEMENT:TRIMPLACEMENT});var TAILORSNAME=this.props.tailorName.TAILORSNAME;this.setState({assignedToList:TAILORSNAME});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,sewing=_state.sewing,STATUS=_state.STATUS,assignedToList=_state.assignedToList,PLACEOFSEWING=_state.PLACEOFSEWING,SEWINGTYPE=_state.SEWINGTYPE,sample=_state.sample;var permissions=this.props.permissions;// let { data } = this.state.sample;
// data = data.map(sample => {
//   return {
//     label: sample.size || 0
//   }
// }
// )
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"mt-5",id:"sewing"// style={{ marginBottom: ".5%" }}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Sewing ",onClick:this.onOpenModal,_id:this.state._id,process:this.state.sewingProcess,updateModulesMain:this.props.updateModulesMain,placeOfSewing:sewing.placeOfSewing,PLACEOFSEWING:this.state.PLACEOFSEWING,updateSewing:this.props.updateSewing1,moduleName:"sewing",disabled:this.state.disabled,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"sewingForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12  no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-center",style:{width:"7%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sewing"),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addSewing();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,sewing.sewingData.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"costingtable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Tailor name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Sewing type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Qty"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"},"Approval Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"10%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0 padding-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{name:"tailorName",value:value.tailorName// onInputChange={this.getFabricNumber}
,onChange:function onChange(value){return _this2.props.updateSewing("tailorName",value,index);},placeholder:"Tailor Name",options:_this2.state.assignedToList,disabled:_this2.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"sewingType",value:value.sewingType,options:_this2.state.SEWINGTYPE||[],index:index,onChange:_this2.props.updateSewing,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"size",value:value.size,index:index,options:sample,onChange:_this2.props.updateSewing,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"quantity",value:value.quantity,index:index,onChange:_this2.props.updateSewing,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"approvalStatus",value:value.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}],index:index,onChange:_this2.props.updateSewing,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},value.approvalStatus=="rejected"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"text",inputName:"rejected",value:value.rejected,index:index,onChange:_this2.props.updateSewing,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeSewing(index);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" col-md-12 padding-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-center",style:{width:"7%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Logs"),!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addSewingLog(index);}}))),value.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding",key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TimerModule__["a" /* default */],{time:log.timeIn,buttonName:"time in",updatePatternCheck:function updatePatternCheck(){return _this2.props.updateSewingCheck("timeIn",i,index);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TimerModule__["a" /* default */],{time:log.timeOut,buttonName:"time out",updatePatternCheck:function updatePatternCheck(){return _this2.props.updateSewingCheck("timeOut",i,index);},disabled:_this2.state.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"time",inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this2.props.updateSewingLog(name,value,i,index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason,onChange:function onChange(name,value){return _this2.props.updateSewingLog(name,value,i,index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-1 step-one pl-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeSewingLog(i,index);}})));})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"smokingOrShiring",value:this.state.sewing.smokingOrShiring,label:"smocking/Shirring",onChange:function onChange(e){_this2.props.updateSewing1(e);},disabled:this.state.disabled,className:"p-0 col-1"}),this.state.sewing.smokingOrShiring&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"14%"},"Trim Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Trim Ref no"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Placement"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"No Of Rows"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Length in cm"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Total Reqrd-mtrs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.sewing.trimData&&this.state.sewing.trimData.length&&this.state.sewing.trimData.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"trimCategory",value:index===0?value.trimCategory:null,index:index,options:_this2.state.TRIM.TRIMCATEGORY||[],onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */]// clearable={false}
,{name:"trimNumber",value:value.trimNumber,onInputChange:function onInputChange(data){return _this2.props.getTrimRefNoSewing(value.trimCategory,data,index);},onChange:function onChange(value){return _this2.props.getTrimInfoSewTrimData(value,index);},placeholder:"Find trimRefNo",options:value.trimList?value.trimList:[],disabled:_this2.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"placement",value:value.placement,index:index,options:_this2.state.TRIMPLACEMENT||[],onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"type",value:value.type,index:index,options:[{label:"Both Elastic",value:"Both Elastic"},{label:"Top TTH / Bottom Elastic",value:"Top TTH / Bottom Elastic"}],onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"noOfRow",index:index,value:value.noOfRow,onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"length",value:value.length,index:index,onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"totalReq",value:value.totalReq,index:index,onChange:_this2.props.updateSewingTrimData,disabled:_this2.state.disabled||true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{top:"12px"}},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:index===0?"btn-floating btn-small waves-effect waves-light green pull-right":"btn-floating btn-small waves-effect waves-light red pull-right del-tr-btn",onClick:function onClick(e){return index===0?_this2.props.smockingShirringaddTrim():_this2.props.smockingShirringremoveTrim("row2",index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},index===0?"add":"clear"))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:sewing.comments,label:"comments",onChange:this.props.updateSewing1,disabled:this.state.disabled})))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:this.props.createSewing}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Complete",onClick:this.props.completeSewing}))))));}}]);return SewingModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SewingModule);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Buttons_Button__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignOffModule=function(_Component){_inherits(SignOffModule,_Component);function SignOffModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SignOffModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SignOffModule.__proto__||Object.getPrototypeOf(SignOffModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",signOff:[],STATUS:[],assignedToList:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SignOffModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,signOffComments=_props.signOffComments,signOffProcess=_props.signOffProcess,STATUS=_props.STATUS,assignedToList=_props.assignedToList,disabled=_props.disabled;this.setState({_id:_id,signOffComments:signOffComments,signOffProcess:signOffProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,signOffComments=nextProps.signOffComments,signOffProcess=nextProps.signOffProcess,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,disabled=nextProps.disabled;this.setState({_id:_id,signOffComments:signOffComments,signOffProcess:signOffProcess,STATUS:STATUS,assignedToList:assignedToList,disabled:disabled});}},{key:"render",value:function render(){var _state=this.state,signOffComments=_state.signOffComments,STATUS=_state.STATUS,assignedToList=_state.assignedToList,disabled=_state.disabled;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter ",id:"signOff",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],{header:"Sign Off ",onClick:this.onOpenModal,_id:this.state._id,process:this.state.signOffProcess,disabled:this.state.disabled,updateModulesMain:this.props.updateModulesMain,moduleName:"signOff",statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"signOffComments",value:signOffComments,label:"comments",onChange:this.props.updateSignOff,disabled:this.state.disabled}))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 padding-top text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"save",onClick:this.props.createSignOff}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Buttons_Button__["a" /* default */],{buttonType:"save",buttonName:"Complete",onClick:this.props.completeSignoff}))))));}}]);return SignOffModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SignOffModule);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select_Select__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var trimTemplate={assignedTo:"",trimCategory:"",trimRefNo:"",description:"",quality:"",size:"",status:"",ETA:"",completedDate:""};var shirringTemplate={trimCategory:"",trimRefNo:"",placement:"",type:"",noOfRows:"",length:"",total:""};var TrimModule=function(_Component){_inherits(TrimModule,_Component);function TrimModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TrimModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TrimModule.__proto__||Object.getPrototypeOf(TrimModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",trim:{},STATUS:[],TRIM:{},trimOptions:{},trimCategoryList:[],trimNumberList:[],assignedToList:[],disabled:false,durationTrim:null,finish:false},_this.toggleChange=function(){_this.setState({smocking:!_this.state.smocking});},_this.changeCount=function(index,name){index===0?_this.state[name].push(name==="trimCount"?trimTemplate:shirringTemplate):_this.state[name].splice(index,1);_this.setState(_defineProperty({},name,_this.state[name]));},_this.checkValidation=function(data,element){// console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
// console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
if(_this.validateArrayObject(_this.props.trim.row1,"trimNumber",null)&&(_this.validateArrayObject(_this.props.trim.row1,"trimCategory","")||_this.validateArrayObject(_this.props.trim.row1,"trimCategory",null))){if(data==="save"){_this.props.createTrim(element);}else{_this.props.completeTrim(element);}}else{_this.props.getalertMessage("error","Please fill all mandatory fields");}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TrimModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,trim=_props.trim,trimRadio=_props.trimRadio,trimProcess=_props.trimProcess,disabled=_props.disabled,STATUS=_props.STATUS,assignedToList=_props.assignedToList,trimNumberList=_props.trimNumberList,TRIM=_props.TRIM,TRIMPLACEMENT=_props.TRIMPLACEMENT,durationTrim=_props.durationTrim;this.setState({_id:_id,trim:trim,trimRadio:trimRadio,trimProcess:trimProcess,disabled:disabled,STATUS:STATUS,assignedToList:assignedToList,trimNumberList:trimNumberList,TRIM:TRIM,TRIMPLACEMENT:TRIMPLACEMENT,durationTrim:durationTrim});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,trim=nextProps.trim,trimRadio=nextProps.trimRadio,trimProcess=nextProps.trimProcess,disabled=nextProps.disabled,STATUS=nextProps.STATUS,assignedToList=nextProps.assignedToList,trimNumberList=nextProps.trimNumberList,TRIM=nextProps.TRIM,TRIMPLACEMENT=nextProps.TRIMPLACEMENT,durationTrim=nextProps.durationTrim;this.setState({_id:_id,trim:trim,trimRadio:trimRadio,trimProcess:trimProcess,disabled:disabled,STATUS:STATUS,assignedToList:assignedToList,trimNumberList:trimNumberList,TRIM:TRIM,TRIMPLACEMENT:TRIMPLACEMENT,durationTrim:durationTrim});}// componentDidMount() {
//   let trim = {...this.state.trim}
//   if (!this.state.finish) {
//     if (trim && trim.row1 && trim.row1.length > 0) {
//       trim.row1.forEach((x, i) => {
//         if (x.trimCategory) {
//           SampleServices.getTrimNumber(x.trimCategory)
//             .then(async response => {
//               trim.row1[i].trimList = response.text.data
//             })
//             .catch(error => alert(error.toString()))
//         }
//       })
//     }
//     if (trim && trim.row2 && trim.row2.length > 0) {
//       trim.row2.forEach((x, i) => {
//         if (x.trimCategory) {
//           SampleServices.getTrimNumber(x.trimCategory)
//             .then(async response => {
//               trim.row2[i].trimList = response.text.data
//             })
//             .catch(error => alert(error.toString()))
//         }
//       })
//     }
//     this.setState({ finish: true, trim })
//   }
// }
// getTrimRefNo = (trimCategory, value) => {
//   SampleServices.getTrimNumber(trimCategory, value)
//     .then(async response => {
//       console.log(response, "REZ TRIM")
//       this.setState({
//         trimNumberList: response.text.data
//       })
//     })
//     .catch(error => alert(error.toString()))
// }
},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data.filter(function(x){return x[key]==val;}).length===0?true:false;return values;}},{key:"render",value:function render(){var _this2=this;var _state=this.state,trim=_state.trim,STATUS=_state.STATUS;var permissions=this.props.permissions;// console.log
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"trim",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModuleHeader__["a" /* default */],{header:"Trim ",durationETA:this.state.durationTrim,moduleName:"trim",process:this.state.trimProcess,updateModulesMain:this.props.updateModulesMain,onClick:this.onOpenModal,_id:this.state._id,disabled:this.state.disabled,statusList:STATUS}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"trimForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{"class":"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{"class":"border-bottom-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Trim Category"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Trim Ref no"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{fontSize:"1.2rem"},className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},"size"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{"class":"border-bottom-0 text-left",width:"11.1111111111%"},!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"add",addRemoveFunc:function addRemoveFunc(){return _this2.props.addTrim("row1");}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.state.trim&&this.state.trim.row1&&this.state.trim.row1.length&&this.state.trim.row1.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"trimCategory",value:trim.trimCategory,index:index,options:_this2.state.TRIM.TRIMCATEGORY||[],onChange:_this2.props.updateTrimRow1,onInputChange:_this2.props.updateTrimRow1,disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",width:"15%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select inline-external"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"trimNumber"// clearable={false}
,value:trim.trimNumber,onInputChange:function onInputChange(value){return _this2.props.getTrimRefNo(trim.trimCategory,value,index);},onChange:function onChange(value){return _this2.props.getTrimInfo(value,index);},placeholder:"Find trimRefNo",options:trim.trimList?trim.trimList:[],disabled:_this2.state.disabled,onSelectResetsInput:false,onBlurResetsInput:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"external-link cursor-hover",src:__WEBPACK_IMPORTED_MODULE_7__assets_images_external_link_png___default.a,onClick:function onClick(){if(trim.trimNumber){var action=_this2.state.disabled&&'view'||'edit';var search="?"+new URLSearchParams({action:action,_id:trim.trimNumber}).toString();window.open("/Trim"+search,"_blank");}}// this.props.history.push("/Trim", {
//   action:
//     this.props.action === "add"
//       ? "edit"
//       : this.props.action,
//   _id: trim.trimNumber
// })
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{padding:"13px 9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,trim.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{padding:"13px 9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,trim.quality)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0",style:{padding:"13px 9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dis-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,trim.sizeNumber+"-"+trim.size))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,label:"in Hse",inputType:"radio",inputName:"trimRadio"+index,value:"inHsetrimRadio"+index,checked:trim.trimRadio==="inHse",index:index,onChange:function onChange(name,value){return _this2.props.updateTrimRow1("trimRadio","inHse",index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"trimRadio"+index,label:"not In Hse",value:"notInHsetrimRadio"+index,checked:trim.trimRadio==="notInHse",index:index,onChange:function onChange(name,value){return _this2.props.updateTrimRow1("trimRadio","notInHse",index);},disabled:_this2.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",className:"border-top-0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"class":"border-top-0"},!_this2.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Costing_Button_ButtonIcon__["a" /* default */],{buttonType:"clear",addRemoveFunc:function addRemoveFunc(){return _this2.props.removeTrim("row1",index);}})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-11 no-padding pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-10 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:this.state.trim.comment,label:"comments",onChange:this.props.updateTrim,disabled:this.state.disabled}))))))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.checkValidation("save",e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.checkValidation("complete",e);}})))));}}]);return TrimModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TrimModule);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_testIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleHeader__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FileUpload_FileUpload__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Costing_Button_ButtonIcon__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WashModule=function(_Component){_inherits(WashModule,_Component);function WashModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WashModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WashModule.__proto__||Object.getPrototypeOf(WashModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={_id:"",wash:[],assignedToList:[],STATUS:[],disabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WashModule,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,_id=_props._id,wash=_props.wash,washProcess=_props.washProcess,assignedToList=_props.assignedToList,STATUS=_props.STATUS,WASHTYPE=_props.WASHTYPE,WASHFORM=_props.WASHFORM,NOOFMOCKS=_props.NOOFMOCKS,LU=_props.LU,PRICEPERKG=_props.PRICEPERKG,disabled=_props.disabled;this.setState({_id:_id,wash:wash,washProcess:washProcess,assignedToList:assignedToList,STATUS:STATUS,disabled:disabled,WASHTYPE:WASHTYPE,WASHFORM:WASHFORM,LU:LU,PRICEPERKG:PRICEPERKG,NOOFMOCKS:NOOFMOCKS});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _id=nextProps._id,wash=nextProps.wash,washProcess=nextProps.washProcess,assignedToList=nextProps.assignedToList,STATUS=nextProps.STATUS,WASHTYPE=nextProps.WASHTYPE,WASHFORM=nextProps.WASHFORM,NOOFMOCKS=nextProps.NOOFMOCKS,LU=nextProps.LU,PRICEPERKG=nextProps.PRICEPERKG,disabled=nextProps.disabled;this.setState({_id:_id,wash:wash,washProcess:washProcess,assignedToList:assignedToList,STATUS:STATUS,disabled:disabled,WASHTYPE:WASHTYPE,WASHFORM:WASHFORM,LU:LU,PRICEPERKG:PRICEPERKG,NOOFMOCKS:NOOFMOCKS});}},{key:"render",value:function render(){var _React$createElement,_this2=this;var _state=this.state,wash=_state.wash,disabled=_state.disabled,STATUS=_state.STATUS,assignedToList=_state.assignedToList;var permissions=this.props.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"card-filter meeting-min-con",id:"wash",style:{marginBottom:".5%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleHeader__["a" /* default */],(_React$createElement={header:"Wash",onClick:this.onOpenModal,_id:this.state._id,process:this.state.washProcess,updateModulesMain:this.props.updateModulesMain,disabled:this.state.disabled,moduleName:"wash"},_defineProperty(_React$createElement,"updateModulesMain",this.props.updateModulesMain),_defineProperty(_React$createElement,"statusList",STATUS),_React$createElement)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 product-form",style:{paddingBottom:"1%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"wash-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-11 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Wash Type")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Wash Form")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"laundry Unit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Price"))),wash&&wash.washData&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-11 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"washType",value:wash.washData.washType,options:this.state.WASHTYPE// index={index}
,label:"Wash Type",onChange:this.props.updateWash1,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"washFrom",value:wash.washData.washFrom,options:this.state.WASHFORM// index={index}
,label:"Wash Form",onChange:this.props.updateWash1,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"laundryUnit",value:wash.washData.laundryUnit,options:this.state.LU// index={index}
,label:"laundry Unit",onChange:this.props.updateWash1,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"number",inputName:"price",value:wash.washData.price// index={index}
,label:"Price/Kg"// options={this.state.PRICEPERKG&&this.state.PRICEPERKG.map(x=>({label:x.label,value:x.label}))}
,onChange:this.props.updateWash1,disabled:this.state.disabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"hasMock",value:wash.hasMock,label:"MOCKS ?",onChange:this.props.updateWash,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"numberOfMocks",value:wash.numberOfMocks,options:this.state.NOOFMOCKS,label:"No. Of Mocks",onChange:this.props.updateWash,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"tacking",value:wash.tacking,label:"Tacking",onChange:this.props.updateWash,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-2 step-one pl-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkboxToggle",inputName:"recipe",value:wash.recipe,label:"Recipe",onChange:this.props.updateWash,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 hide-customer-site"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUpload_FileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"marker",getRefImages:function getRefImages(refImages){return _this2.props.getRefImages(refImages,"wash");},disabled:this.state.disabled,uploadedDocs:wash.refImages?wash.refImages:null,imageTypeOption:[]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:wash.comments,label:"comments",onChange:this.props.updateWash,disabled:this.state.disabled})))))),!this.state.disabled&&(permissions.create||permissions.edit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding text-center profile-btn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"save",onClick:function onClick(e){return _this2.props.createWash(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Buttons_Button__["a" /* default */],{buttonName:"Complete",onClick:function onClick(e){return _this2.props.completeWash(e);}})))));}}]);return WashModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WashModule);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//services
var PrintGarmentTech=function(_Component){_inherits(PrintGarmentTech,_Component);function PrintGarmentTech(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintGarmentTech);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintGarmentTech.__proto__||Object.getPrototypeOf(PrintGarmentTech)).call.apply(_ref,[this].concat(args))),_this),_this.state={printGarmentTech:{}},_this.commentsHead=function(data){switch(data){case'fitMesurements':return"FIT / MEASUREMENTS";break;case'makeupConstruction':return"MAKE UP / CONSTRUCTION";break;case'trimsComponents':return"TRIMS / COMPONENTS";break;case'packPresentation':return"PACKAGING / PRESENTATION";break;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintGarmentTech,[{key:"componentWillMount",value:function componentWillMount(){this.setState({printGarmentTech:this.props.printGarmentTech});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.printGarmentTech!=this.props.printGarmentTech){this.setState({printGarmentTech:nextProps.printGarmentTech});}}},{key:"render",value:function render(){var _this2=this;var printGarmentTech=this.state.printGarmentTech;console.log(printGarmentTech.sampleForm);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fabricPrintDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"@media print {\n              body{\n                  font-family: 'Montserrat', sans-serif;\n                  font-size:12px;\n                  padding:10px auto;\n              }\n              .fabricPrintDiv{\n                padding: 10px\n                border : 2px solid black;\n                top : 0;\n                bottom : 0;\n              }\n\n              .printrow {\n                display: flex;\n                flex-direction: row;\n                flex-wrap: wrap;\n                width: 100%;                \n              }\n\n              .printcolumn {\n                display: flex;\n                flex-direction: column;\n                flex-basis: 100%;\n                flex: 1;\n              }\n              table>tbody>tr td{\n                  font-size:12px;\n              }\n              .label-text{\n                  color:#279588;\n                  font-size : 12px;\n                  font-weight:bold;\n              }\n              .blue{\n                  color : #146FF9!important;\n              }\n              .padding-for-heading{\n                padding: 5px;\n              }\n              .boldItlUnd{\n                font-weight:900;\n                text-decoration: underline;\n                font-style:italic;\n              }              \n\n              .specialComments{\n                  width: 100% !important;\n                  border : 1px solid black;\n                  min-height : 60px!important;\n                  margin: 5px!important;\n                  padding: 10px!important;\n              }\n              \n              // tr, td { \n              //   page-break-before: always;\n              //   page-break-after: avoid;\n              //   page-break-inside: avoid;\n              // }\n\n              // .specialComments, p { \n              //   page-break-before: always!important;\n              //   page-break-after: avoid!important;\n              //   page-break-inside: avoid!important;\n              // }\n              \n              .b{\n                  border: 1px solid black;\n                  margin: 10px;\n                  padding: 5px;\n              }\n              .fabric-text{\n                font-size:16px;\n                color: #279588;\n                font-weight: 1000;\n              }\n\n              .bold{\n                  font-weight:bold;\n              }\n              .bb-p{\n                border-bottom: 1px solid black;\n                margin-bottom: 10px ;\n              }\n              .w-50 {\n                  width: 50%;\n              }\n              table.grid{\n                border-collapse: collapse;\n                margin-right: 5px;\n                margin-left: 5px;\n              }\n              table.grid>tbody>tr td {\n                border: 0.5px solid black;\n                padding: 5px;\n              }\n              .width-for-table{\n                  width: 50%;\n              }\n              .text-center{\n                text-align: center;\n              }\n              .p-1{\n                padding : 5px;\n              }\n              .pl-1{\n                padding-left: 23px;\n              }\n              .border-bot{\n                border-bottom : 1px solid black;\n              }\n              .mt{\n                margin-top:10px;\n              }\n              .mtl{\n                margin-top:30px;\n              }\n              .margin{\n                margin : 5px;\n              }\n              .pl-2{\n                padding: 5px;\n              }\n            }"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow bb-p"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printcolumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"100%",fontWeight:"900"},className:"text-center padding-for-heading label-text"},"SAMPLE RELEASE FORM")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"CUST-DEPT: "),printGarmentTech.customerDepartment.custName,"-",printGarmentTech.customerDepartment.deptName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"STYLE NO: "),printGarmentTech.styleNo.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"STYLE NAME: "),printGarmentTech.styleName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"SAMPLE REQUEST DATE: "),printGarmentTech.sampleRequestDate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"SAMPLE TYPE: "),printGarmentTech.sampleType.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label-text"},"SAMPLE DATED: "),printGarmentTech.sampleDated)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"45%"}},"COMMENTS FROM BUYER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"5%"}},"FAB."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"5%"}},"TRM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"5%"}},"WKMN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"5%"}},"BYC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"5%"}},"PAT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"30%"}},"REMARKS")),printGarmentTech.sampleForm&&Object.keys(printGarmentTech.sampleForm).map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{textAlign:"left!important",fontSize:"18px",fontWeight:"900"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"7",className:"boldItlUnd label-text"},_this2.commentsHead(data))),printGarmentTech.sampleForm[data].map(function(data2,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"left!important",width:"45%"}},data2.comments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(comment));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"5%"}},data2.fab?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"5%"}},data2.trims?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"5%"}},data2.workManShip?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"5%"}},data2.buyerChanges?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"5%"}},data2.pat?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"6",style:{textAlign:"left!important",width:"30%"}},data2.remarks.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);}))));}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"100%"},className:"text-center padding-for-heading boldItlUnd label-text"},"GARMENT TECH COMMENTS")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments"},printGarmentTech.garmentTechComments&&printGarmentTech.garmentTechComments.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"20%"}},"MARKER REQ"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"20%"}},"SMV AMMEND"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"20%"}},"Technical Issues"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"20%"}},"TRAIL REQ"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"20%"}},"MOCK")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"20%"}},printGarmentTech.markerRequirements&&printGarmentTech.markerRequirements?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"20%"}},printGarmentTech.smvAmmendment&&printGarmentTech.smvAmmendment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"20%"}},printGarmentTech.tiIssues&&printGarmentTech.tiIssues?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"20%"}},printGarmentTech.trailRequired&&printGarmentTech.trailRequired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center",style:{width:"20%"}},printGarmentTech.mock&&printGarmentTech.mock?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2714"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2716"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"33.3%"}},"MERCHANDISER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"33.3%"}},"GMT TECH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"label-text text-center boldItlUnd",style:{width:"33.3%"}},"PATTERN MASTER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%",height:"25px"}},printGarmentTech.customerDepartment.merchandiser&&Object.keys(printGarmentTech.customerDepartment.merchandiser).length>0&&(printGarmentTech.customerDepartment.merchandiser.firstName||"")+" "+printGarmentTech.customerDepartment.merchandiser.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%",height:"25px"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"33.3%",height:"25px"}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:"100%"},className:"text-center padding-for-heading label-text boldItlUnd"},"COMMENTS")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"printrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"specialComments "},printGarmentTech.comment&&printGarmentTech.comment.split("\n").map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,comment);})))))));}}]);return PrintGarmentTech;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrintGarmentTech);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;

var _processNodes = __webpack_require__(166);

Object.defineProperty(exports, 'processNodes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_processNodes).default;
  }
});

var _convertNodeToElement = __webpack_require__(290);

Object.defineProperty(exports, 'convertNodeToElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_convertNodeToElement).default;
  }
});

var _htmlparser = __webpack_require__(73);

Object.defineProperty(exports, 'htmlparser2', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_htmlparser).default;
  }
});

var _HtmlParser = __webpack_require__(888);

var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HtmlParser2.default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmptyTextNode;
/**
 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
 *
 * @param {Object} node The element object as created by htmlparser2
 * @returns {boolean} Whether the node is an empty text node
 */
function isEmptyTextNode(node) {
  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ElementType$Text$Ele;

var _htmlparser = __webpack_require__(73);

var _TextElementType = __webpack_require__(879);

var _TextElementType2 = _interopRequireDefault(_TextElementType);

var _TagElementType = __webpack_require__(880);

var _TagElementType2 = _interopRequireDefault(_TagElementType);

var _StyleElementType = __webpack_require__(886);

var _StyleElementType2 = _interopRequireDefault(_StyleElementType);

var _UnsupportedElementType = __webpack_require__(887);

var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
                                                                                                                                                                                                                   * value
                                                                                                                                                                                                                   */

exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(850);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}


/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(294);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var DomHandler = __webpack_require__(293);
var DomUtils = __webpack_require__(295);

//TODO: make this a streamable handler
function FeedHandler(callback, options) {
    this.init(callback, options);
}

__webpack_require__(82)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where) {
    return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where) {
    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse) {
    return DomUtils.getText(
        DomUtils.getElementsByTagName(what, where, recurse, 1)
    ).trim();
}

function addConditionally(obj, prop, what, where, recurse) {
    var tmp = fetch(what, where, recurse);
    if (tmp) obj[prop] = tmp;
}

var isValidFeed = function(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function() {
    var feed = {},
        feedRoot = getOneElement(isValidFeed, this.dom),
        tmp,
        childs;

    if (feedRoot) {
        if (feedRoot.name === "feed") {
            childs = feedRoot.children;

            feed.type = "atom";
            addConditionally(feed, "id", "id", childs);
            addConditionally(feed, "title", "title", childs);
            if (
                (tmp = getOneElement("link", childs)) &&
                (tmp = tmp.attribs) &&
                (tmp = tmp.href)
            )
                feed.link = tmp;
            addConditionally(feed, "description", "subtitle", childs);
            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
            addConditionally(feed, "author", "email", childs, true);

            feed.items = getElements("entry", childs).map(function(item) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "id", item);
                addConditionally(entry, "title", "title", item);
                if (
                    (tmp = getOneElement("link", item)) &&
                    (tmp = tmp.attribs) &&
                    (tmp = tmp.href)
                )
                    entry.link = tmp;
                if ((tmp = fetch("summary", item) || fetch("content", item)))
                    entry.description = tmp;
                if ((tmp = fetch("updated", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        } else {
            childs = getOneElement("channel", feedRoot.children).children;

            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            addConditionally(feed, "title", "title", childs);
            addConditionally(feed, "link", "link", childs);
            addConditionally(feed, "description", "description", childs);
            if ((tmp = fetch("lastBuildDate", childs)))
                feed.updated = new Date(tmp);
            addConditionally(feed, "author", "managingEditor", childs, true);

            feed.items = getElements("item", feedRoot.children).map(function(
                item
            ) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "guid", item);
                addConditionally(entry, "title", "title", item);
                addConditionally(entry, "link", "link", item);
                addConditionally(entry, "description", "description", item);
                if ((tmp = fetch("pubDate", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        }
    }
    this.dom = feed;
    DomHandler.prototype._handleCallback.call(
        this,
        feedRoot ? null : Error("couldn't find root of feed")
    );
};

module.exports = FeedHandler;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(93),
    getOuterHTML = __webpack_require__(858),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(859);
var entities = __webpack_require__(860);

/* mixed-case SVG and MathML tags & attributes
   recognized by the HTML parser, see
   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
*/
var foreignNames = __webpack_require__(864);
foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
foreignNames.attributeNames.__proto__ = null;

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '';
  var value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    if (opts.xmlMode === 'foreign') {
      /* fix up mixed-case attribute names */
      key = foreignNames.attributeNames[key] || key;
    }
    output += key;
    if ((value !== null && value !== '') || opts.xmlMode) {
      output +=
        '="' +
        (opts.decodeEntities
          ? entities.encodeXML(value)
          : value.replace(/\"/g, '&quot;')) +
        '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
};

var render = (module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for (var i = 0; i < dom.length; i++) {
    var elem = dom[i];

    if (elem.type === 'root') output += render(elem.children, opts);
    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment) output += renderComment(elem);
    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
    else output += renderText(elem, opts);
  }

  return output;
});

var foreignModeIntegrationPoints = [
  'mi',
  'mo',
  'mn',
  'ms',
  'mtext',
  'annotation-xml',
  'foreignObject',
  'desc',
  'title'
];

function renderTag(elem, opts) {
  // Handle SVG / MathML in HTML
  if (opts.xmlMode === 'foreign') {
    /* fix up mixed-case element names */
    elem.name = foreignNames.elementNames[elem.name] || elem.name;
    /* exit foreign mode at integration points */
    if (
      elem.parent &&
      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
    )
      opts = Object.assign({}, opts, { xmlMode: false });
  }
  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
  }

  var tag = '<' + elem.name;
  var attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (
    opts.decodeEntities &&
    !(elem.parent && elem.parent.name in unencodedElements)
  ) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementType", function() { return ElementType; });
/* harmony export (immutable) */ __webpack_exports__["isTag"] = isTag;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType || (ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
// Exports for backwards compatibility
/** Type for the root element of a document */
const Root = ElementType.Root;
/* harmony export (immutable) */ __webpack_exports__["Root"] = Root;

/** Type for Text */
const Text = ElementType.Text;
/* harmony export (immutable) */ __webpack_exports__["Text"] = Text;

/** Type for <? ... ?> */
const Directive = ElementType.Directive;
/* harmony export (immutable) */ __webpack_exports__["Directive"] = Directive;

/** Type for <!-- ... --> */
const Comment = ElementType.Comment;
/* harmony export (immutable) */ __webpack_exports__["Comment"] = Comment;

/** Type for <script> tags */
const Script = ElementType.Script;
/* harmony export (immutable) */ __webpack_exports__["Script"] = Script;

/** Type for <style> tags */
const Style = ElementType.Style;
/* harmony export (immutable) */ __webpack_exports__["Style"] = Style;

/** Type for Any tag */
const Tag = ElementType.Tag;
/* harmony export (immutable) */ __webpack_exports__["Tag"] = Tag;

/** Type for <![CDATA[ ... ]]> */
const CDATA = ElementType.CDATA;
/* harmony export (immutable) */ __webpack_exports__["CDATA"] = CDATA;

/** Type for <!doctype ...> */
const Doctype = ElementType.Doctype;
/* harmony export (immutable) */ __webpack_exports__["Doctype"] = Doctype;



/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = __webpack_require__(296);
var encode_1 = __webpack_require__(299);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */
function decode(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = __webpack_require__(299);
Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } });
Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return encode_2.escapeUTF8; } });
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
var decode_2 = __webpack_require__(296);
Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decode_json_1 = __importDefault(__webpack_require__(863));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
}
exports.default = decodeCodePoint;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = {"elementNames":{"altglyph":"altGlyph","altglyphdef":"altGlyphDef","altglyphitem":"altGlyphItem","animatecolor":"animateColor","animatemotion":"animateMotion","animatetransform":"animateTransform","clippath":"clipPath","feblend":"feBlend","fecolormatrix":"feColorMatrix","fecomponenttransfer":"feComponentTransfer","fecomposite":"feComposite","feconvolvematrix":"feConvolveMatrix","fediffuselighting":"feDiffuseLighting","fedisplacementmap":"feDisplacementMap","fedistantlight":"feDistantLight","fedropshadow":"feDropShadow","feflood":"feFlood","fefunca":"feFuncA","fefuncb":"feFuncB","fefuncg":"feFuncG","fefuncr":"feFuncR","fegaussianblur":"feGaussianBlur","feimage":"feImage","femerge":"feMerge","femergenode":"feMergeNode","femorphology":"feMorphology","feoffset":"feOffset","fepointlight":"fePointLight","fespecularlighting":"feSpecularLighting","fespotlight":"feSpotLight","fetile":"feTile","feturbulence":"feTurbulence","foreignobject":"foreignObject","glyphref":"glyphRef","lineargradient":"linearGradient","radialgradient":"radialGradient","textpath":"textPath"},"attributeNames":{"definitionurl":"definitionURL","attributename":"attributeName","attributetype":"attributeType","basefrequency":"baseFrequency","baseprofile":"baseProfile","calcmode":"calcMode","clippathunits":"clipPathUnits","diffuseconstant":"diffuseConstant","edgemode":"edgeMode","filterunits":"filterUnits","glyphref":"glyphRef","gradienttransform":"gradientTransform","gradientunits":"gradientUnits","kernelmatrix":"kernelMatrix","kernelunitlength":"kernelUnitLength","keypoints":"keyPoints","keysplines":"keySplines","keytimes":"keyTimes","lengthadjust":"lengthAdjust","limitingconeangle":"limitingConeAngle","markerheight":"markerHeight","markerunits":"markerUnits","markerwidth":"markerWidth","maskcontentunits":"maskContentUnits","maskunits":"maskUnits","numoctaves":"numOctaves","pathlength":"pathLength","patterncontentunits":"patternContentUnits","patterntransform":"patternTransform","patternunits":"patternUnits","pointsatx":"pointsAtX","pointsaty":"pointsAtY","pointsatz":"pointsAtZ","preservealpha":"preserveAlpha","preserveaspectratio":"preserveAspectRatio","primitiveunits":"primitiveUnits","refx":"refX","refy":"refY","repeatcount":"repeatCount","repeatdur":"repeatDur","requiredextensions":"requiredExtensions","requiredfeatures":"requiredFeatures","specularconstant":"specularConstant","specularexponent":"specularExponent","spreadmethod":"spreadMethod","startoffset":"startOffset","stddeviation":"stdDeviation","stitchtiles":"stitchTiles","surfacescale":"surfaceScale","systemlanguage":"systemLanguage","tablevalues":"tableValues","targetx":"targetX","targety":"targetY","textlength":"textLength","viewbox":"viewBox","viewtarget":"viewTarget","xchannelselector":"xChannelSelector","ychannelselector":"yChannelSelector","zoomandpan":"zoomAndPan"}}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),
/* 866 */
/***/ (function(module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var isTag = __webpack_require__(93).isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = rootElems.slice();
	while(stack.length){
		var elem = stack.shift();
		if(!isTag(elem)) continue;
		if (elem.children && elem.children.length > 0) {
			stack.unshift.apply(stack, elem.children);
		}
		if(test(elem)) result.push(elem);
	}
	return result;
}


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(93);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(300);

function Stream(options) {
    Parser.call(this, new Cbs(this), options);
}

__webpack_require__(82)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope) {
    this.scope = scope;
}

var EVENTS = __webpack_require__(73).EVENTS;

Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        Cbs.prototype["on" + name] = function() {
            this.scope.emit(name);
        };
    } else if (EVENTS[name] === 1) {
        Cbs.prototype["on" + name] = function(a) {
            this.scope.emit(name, a);
        };
    } else if (EVENTS[name] === 2) {
        Cbs.prototype["on" + name] = function(a, b) {
            this.scope.emit(name, a, b);
        };
    } else {
        throw Error("wrong number of arguments!");
    }
});


/***/ }),
/* 871 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(873).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(301)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 875 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 876 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs) {
    this._cbs = cbs || {};
}

var EVENTS = __webpack_require__(73).EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function() {
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a) {
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a, b) {
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs) {
    this._cbs = cbs || {};
    this.events = [];
}

var EVENTS = __webpack_require__(73).EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function() {
            this.events.push([name]);
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a) {
            this.events.push([name, a]);
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a, b) {
            this.events.push([name, a, b]);
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});

CollectingHandler.prototype.onreset = function() {
    this.events = [];
    if (this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function() {
    if (this._cbs.onreset) this._cbs.onreset();

    for (var i = 0, len = this.events.length; i < len; i++) {
        if (this._cbs[this.events[i][0]]) {
            var num = this.events[i].length;

            if (num === 1) {
                this._cbs[this.events[i][0]]();
            } else if (num === 2) {
                this._cbs[this.events[i][0]](this.events[i][1]);
            } else {
                this._cbs[this.events[i][0]](
                    this.events[i][1],
                    this.events[i][2]
                );
            }
        }
    }
};


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextElementType;
/**
 * Converts a text node to a React text element
 *
 * @param {Object} node The text node
 * @returns {String} The text
 */
function TextElementType(node) {

  // React will accept plain text for rendering so just return the node data
  return node.data;
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TagElementType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _processNodes = __webpack_require__(166);

var _processNodes2 = _interopRequireDefault(_processNodes);

var _generatePropsFromAttributes = __webpack_require__(302);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

var _VoidElements = __webpack_require__(885);

var _VoidElements2 = _interopRequireDefault(_VoidElements);

var _isValidTagOrAttributeName = __webpack_require__(303);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
 *
 * @param {Object} node The tag node
 * @param {String} index The index of the React element relative to it's parent
 * @param {Function} transform The transform function to apply to all children
 * @returns {React.Element} The React tag element
 */
function TagElementType(node, index, transform) {

  var tagName = node.name;

  // validate tag name
  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
    return null;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // If the node is not a void element and has children then process them
  var children = null;
  if (_VoidElements2.default.indexOf(tagName) === -1) {
    children = (0, _processNodes2.default)(node.children, transform);
  }

  // create and return the element
  return _react2.default.createElement(tagName, props, children);
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = htmlAttributesToReact;

var _BooleanAttributes = __webpack_require__(882);

var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);

var _ReactAttributes = __webpack_require__(883);

var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);

var _isValidTagOrAttributeName = __webpack_require__(303);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the parsed attribute value taking into account things like boolean attributes
 *
 * @param {String} attribute The name of the attribute
 * @param {*} value The value of the attribute from the HTML
 * @returns {*} The parsed attribute value
 */
var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {

  // if the attribute if a boolean then it's value should be the same as it's name
  // e.g. disabled="disabled"
  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
    return attr.toLowerCase();
  });
  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
    value = attribute;
  }

  return value;
};

/**
 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
 * version does not exist for an attribute then just use it as it is
 *
 * @param {Object} attributes The HTML attributes to convert
 * @returns {Object} The React attributes
 */
function htmlAttributesToReact(attributes) {

  return Object.keys(attributes).filter(function (attr) {
    return (0, _isValidTagOrAttributeName2.default)(attr);
  }).reduce(function (mappedAttributes, attribute) {

    // lowercase the attribute name and find it in the react attribute map
    var lowerCaseAttribute = attribute.toLowerCase();

    // format the attribute name
    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;

    // add the parsed attribute value to the mapped attributes
    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);

    return mappedAttributes;
  }, {});
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * List of boolean attributes
 * These attributes should have their React attribute value set to be the same as their name
 * E.g. <input disabled> = <input disabled>
 *      <input disabled=""> = <input disabled>
 *      <input disabled="disabled"> = <input disabled>
 * @type {Array}
 */
exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Mapping of standard HTML attributes to their React counterparts
 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * @type {Object}
 */
exports.default = {
  /**
   * Standard Properties
   */
  accept: 'accept',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  allowtransparency: 'allowTransparency',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocomplete: 'autoComplete',
  autoplay: 'autoPlay',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  charset: 'charSet',
  challenge: 'challenge',
  checked: 'checked',
  cite: 'cite',
  classid: 'classID',
  class: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlsList: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  form: 'form',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formmethod: 'formMethod',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  for: 'htmlFor',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginheight: 'marginHeight',
  marginwidth: 'marginWidth',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  slot: 'slot',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  /**
   * RDFa Properties
   */
  about: 'about',
  datatype: 'datatype',
  inlist: 'inlist',
  prefix: 'prefix',
  property: 'property',
  resource: 'resource',
  typeof: 'typeof',
  vocab: 'vocab',
  /**
   * Non-standard Properties
   */
  autocapitalize: 'autoCapitalize',
  autocorrect: 'autoCorrect',
  autosave: 'autoSave',
  color: 'color',
  itemprop: 'itemProp',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  itemid: 'itemID',
  itemref: 'itemRef',
  results: 'results',
  security: 'security',
  unselectable: 'unselectable'
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = InlineStyleToObject;
/**
 * Converts an inline style string into an object of React style properties
 *
 * @param {String} inlineStyle='' The inline style to convert
 * @returns {Object} The converted style
 */
function InlineStyleToObject() {
  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


  // just return empty object if the inlineStyle is empty
  if (inlineStyle === '') {
    return {};
  }

  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {

    // extract the style property name and value
    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
      return i > 0;
    }).map(function (item) {
      return item.trim().toLowerCase();
    }),
        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
        property = _stylePropertyValue$s2[0],
        value = _stylePropertyValue$s2[1];

    // if there is no value (i.e. no : in the style) then ignore it


    if (value === undefined) {
      return styleObject;
    }

    // convert the property name into the correct React format
    // remove all hyphens and convert the letter immediately after each hyphen to upper case
    // additionally don't uppercase any -ms- prefix
    // e.g. -ms-style-property = msStyleProperty
    //      -webkit-style-property = WebkitStyleProperty
    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
      return character.toUpperCase();
    });

    // add the new style property and value to the style object
    styleObject[property] = value;

    return styleObject;
  }, {});
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * List of void elements
 * These elements are not allowed to have children
 * @type {Array}
 */
exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StyleElementType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _generatePropsFromAttributes = __webpack_require__(302);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a <style> element to a React element
 *
 * @param {Object} node The style node
 * @param {String} index The index of the React element relative to it's parent
 * @returns {React.Element} The React style element
 */
function StyleElementType(node, index) {

  // The style element only ever has a single child which is the styles so try and find this to add as
  // a child to the style element that will be created
  var styles = void 0;
  if (node.children.length > 0) {
    styles = node.children[0].data;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // create and return the element
  return _react2.default.createElement('style', props, styles);
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnsupportedElementType;
/**
 * Handles an unsupported element type by returning null so nothing is rendered
 * @returns {null}
 */
function UnsupportedElementType() {

  // do nothing because the element type is unsupported
  // comment, directive, script, cdata, doctype are all currently unsupported
  return null;
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HtmlParser;

var _htmlparser = __webpack_require__(73);

var _htmlparser2 = _interopRequireDefault(_htmlparser);

var _processNodes = __webpack_require__(166);

var _processNodes2 = _interopRequireDefault(_processNodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parses a HTML string and returns a list of React components generated from it
 *
 * @param {String} html The HTML to convert into React component
 * @param {Object} options Options to pass
 * @returns {Array} List of top level React elements
 */
function HtmlParser(html) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$decodeEntities = _ref.decodeEntities,
      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
      transform = _ref.transform,
      _ref$preprocessNodes = _ref.preprocessNodes,
      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
    return nodes;
  } : _ref$preprocessNodes;

  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
  return (0, _processNodes2.default)(nodes, transform);
}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Buttons_Button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SystemSupplier=function(_Component){_inherits(SystemSupplier,_Component);function SystemSupplier(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SystemSupplier);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SystemSupplier.__proto__||Object.getPrototypeOf(SystemSupplier)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:"",_id:"",disabled:false,systemSupplier:{supplierCode:"",supplierName:"",supplierPhone:"",supplierEmail:"",supplierFax:"",supplierAddress:""}},_this.createSupplier=function(){var systemSupplier=Object.assign({},_this.state.systemSupplier);if(_this.state._id){systemSupplier._id=_this.state._id;}__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].SystemSupplier(systemSupplier,_this.state.action).then(function(response){if(response.status===200){if(response.text.message==="Successfully Added"){_this.props.getalertMessage('success',response.text.message);var _systemSupplier=Object.assign({},_this.state.systemSupplier);Object.keys(_systemSupplier).forEach(function(element){_systemSupplier[element]='';});_this.setState({systemSupplier:_systemSupplier});}else if(response.text.message==="Supplier Code exists"){_this.props.getalertMessage('warning',response.text.message);}else if(response.text.message==="Successfully updated"){_this.props.getalertMessage('edit',response.text.message);}}response.status===400&&_this.props.getalertMessage('warning',response.text.message);response.status===401&&_this.unauthorisedFunc();}).catch(function(error){_this.props.getalertMessage('error',error.toString());});},_this.updateValue=function(name,value){var systemSupplier=Object.assign({},_this.state.systemSupplier);systemSupplier[name]=value;_this.setState({systemSupplier:systemSupplier});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SystemSupplier,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var action=this.props.location.state.action;var _id=this.props.location.state._id;this.setState({action:action,_id:_id});if(_id!==""){__WEBPACK_IMPORTED_MODULE_1__services__["l" /* SystemServices */].viewystemSupplier(_id).then(function(response){if(response.status===200){var systemSupplier=Object.assign({},_this2.state.systemSupplier);Object.keys(systemSupplier).forEach(function(key){systemSupplier[key]=response.text.data[key];});var _id2=response.text.data._id;_this2.setState({systemSupplier:systemSupplier,_id:_id2});}}).catch(function(error){_this2.props.getalertMessage('error',error.toString());});}if(action==="view"){this.setState({disabled:true});}}},{key:"render",value:function render(){var systemSupplier=this.state.systemSupplier;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:this.state.action+" System Supplier"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-8 col-md-offset-2 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 no-padding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"supplierCode",value:systemSupplier.supplierCode,label:"Supplier Code",onChange:this.updateValue,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"supplierName",value:systemSupplier.supplierName,label:"Supplier Name",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"supplierPhone",value:systemSupplier.supplierPhone,label:"Supplier Phone",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"supplierEmail",value:systemSupplier.supplierEmail,label:"Supplier Email",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"supplierFax",value:systemSupplier.supplierFax,label:"Supplier Fax",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"supplierAddress",value:systemSupplier.supplierAddress,label:"Supplier Address",onChange:this.updateValue,disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 profile-btn text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Buttons_Button__["a" /* default */],{buttonName:"save",onClick:this.createSupplier}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Buttons_Button__["a" /* default */],{buttonType:"cancel",buttonName:"back",history:this.props.history})))))));}}]);return SystemSupplier;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SystemSupplier);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__page__["a"]; });


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_download_png__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_download_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_download_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_to_print__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_to_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_to_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Report_reports__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Report_forms__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__print__ = __webpack_require__(965);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//service
var processTypeoptions=__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].processTypeoptions;var isOther=function isOther(type){switch(type){case'sampleProcesses':return false;case'custDept':return false;default:return true;}};var statusOptions=[{value:"CANCEL",label:"Cancelled"},{value:"COMPLETED",label:"Completed"},{value:"PENDING",label:"Pending"},{value:"IN PROCESS",label:"In Process"}];var progressOptions=[{value:"ALL",label:"All"},{value:"COMPLETED",label:"Completed"},{value:"NOTCOMPLETED",label:"Not Completed"}];var Report=function(_Component){_inherits(Report,_Component);function Report(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Report);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Report.__proto__||Object.getPrototypeOf(Report)).call.apply(_ref,[this].concat(args))),_this),_this.customerChoosen="",_this.state={processUpdatesETA:"",filePreviewIframe:"",bNumber:"",countCons:"",processType:"",processTypeOptions:processTypeoptions,header:{},body:[],type:"",reportType:"",fabricReportList:[],reportTypeOption:[],customerOption:[],customerList:[],ids:[],NumberFromList:[],NumberFromObj:"",NumberToObj:"",supplierOption:[],sampleTypeOptions:[],supplierName:null,requirementOption:[],printDate:'',List:[],emailId:"",currentDiv:"",status:null,progress:null,requirement:null,customerWithDept:[],hasMore:true,isLoading:false,imagecount:0,count:0,generateCount:0,page:1,rights:{},sampleType:null,typeOfRequest:null,image:false,fromDate:null,toDate:null,createdAt:null,completed:null,styleNo:null,styleName:null,styleType:"styleNo",styleTypeValue:"",garmentType:null,itemNo:"",imageType:null,location:null,courier:null,customerRefNo:"",actionedBy:"",openModal:false,arrayValue:[],arrayValue1:[],arrayValue2:[],userPageInput:1,scroll:true,patterMasterList:[],patternMaster:null,requestKey:"status",requestValue:"",STATUS:[],showForm:true,all:false,sortIn:0,sortField:null,sortDirection:null,prevReportType:null,prevProcessType:null},_this.alertOptions={offset:65,position:"top left",theme:"dark",time:1000,transition:"scale"},_this.getNumberList=function(e){__WEBPACK_IMPORTED_MODULE_10__services__["j" /* SampleServices */].getSampleReqNo(e).then(function(response){if(response.status==200){_this.setState({NumberFromList:response.text.data// isLoading: true
});}}).catch(function(error){// UtilityService.errorMsg(this.msg);
});},_this.updateReportType=function(name,value){if(value!=""){var oldState=Object.assign({},_this.state.oldState);_this.setState(Object.assign({},oldState,_defineProperty({},name,value)));var arr=["custDept","dispatch","fabPricePending","fabricLibrary","sampleLibrary","sampleProcesses","bulkUpdateDispatch","processUpdates","processCompleted","patternMasterReport","bulkUpdateProcess","styleDownloads","sampleRequestDownloads"];if(arr.includes(value)){// value === "custDept" || value === "dispatch"
setTimeout(function(){__WEBPACK_IMPORTED_MODULE_10__services__["i" /* ReportServices */].getSampleType().then(function(res){if(res.status==200){_this.setState({fromDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(6,"months").format("DD MMM YYYY"),// toDate: new Date(),
sampleTypeOptions:res.text.data.SAMPLETYPE,STATUS:res.text.data.STATUS,patterMasterList:res.text.data.patternMaster});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},500);if(value==="sampleLibrary"||value==="styleDownloads"){__WEBPACK_IMPORTED_MODULE_10__services__["k" /* StyleServices */].getStylePrefilledData().then(function(res){_this.setState({garmentTypeOptions:res.text.data.GARMENTTYPE,actionedByOptions:res.text.data.ACTIONEDBY});});if(value==="sampleLibrary")__WEBPACK_IMPORTED_MODULE_10__services__["m" /* UtilityService */].getImageType().then(function(res){_this.setState({imageTypeOptions:res.text.data});});}}else if(value==="fabric"){_this.setState({isLoading:true});//get fabric section from system
__WEBPACK_IMPORTED_MODULE_10__services__["e" /* DevelopmentServices */].prefillFabricDetails().then(function(response){_this.setState({supplierOption:response.data.Fabric.SUPPLIERNAME,requirementOption:response.data.Fabric.REQUIREMENT,isLoading:false});}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}}else{_this.setState(_defineProperty({},name,null));}_this.customerChoosen="";_this.setState({body:[],fabricReportList:[]});},_this.exportReport=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reportType,page,sortBy,sortOrder){var objData,filter,styleRes,styleResVal;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:objData={submitReport:true,isLoading:true// fabricReportList: []
};if(page===1){objData=Object.assign({},objData,{generateCount:page,userPageInput:page});}_this.setState(objData);// const adjustedSortBy = sortBy === "ETA/ETD" ? "ETA" : sortBy;
filter={customerDepartList:_this.customerChoosen,supplier:_this.state.supplierName?_this.state.supplierName.value:null,requirement:_this.state.requirement,status:_this.state.status,progress:_this.state.progress,reportType:_this.state.type==="bulkUpdateProcess"?"processUpdates":_this.state.type,isExport:reportType==="sendEmail"?false:reportType===true?true:false,sendMail:reportType==="sendEmail"?true:false,emailId:_this.state.emailId.trim(),page:page// sortField: adjustedSortBy,
// sortDirection: sortOrder
};// Include sorting fields only for 'bulkUpdateProcess' and 'processUpdates'
if(["bulkUpdateProcess","processUpdates"].includes(reportType)){filter.sortField=sortBy;filter.sortDirection=sortOrder;}_context2.t0=_this.state.type;_context2.next=_context2.t0==='custDept'?8:_context2.t0==='dispatch'?15:_context2.t0==='fabPricePending'?22:_context2.t0==='fabricLibrary'?25:_context2.t0==='sampleProcesses'?32:_context2.t0==="sampleLibrary"?44:_context2.t0==='bNumber'?56:_context2.t0==='processCompleted'?61:_context2.t0==='bulkUpdateDispatch'?66:_context2.t0==='processUpdates'?71:_context2.t0==='bulkUpdateProcess'?78:_context2.t0==='patternMasterReport'?85:_context2.t0==='styleDownloads'?91:_context2.t0==='sampleRequestDownloads'?95:98;break;case 8:filter.withImage=Boolean(_this.state.image);filter.typeOfRequest=_this.state.typeOfRequest;//filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue.length>0?_this.state.arrayValue.map(function(x){return x.value;}):null;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;filter.createdAt=_this.state.createdAt;return _context2.abrupt("break",98);case 15://filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.location=_this.state.location;filter.courier=_this.state.courigenerateer;filter.awbNumber=_this.state.awbNumber;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;return _context2.abrupt("break",98);case 22://filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue.length>0?_this.state.arrayValue.map(function(x){return x.value;}):null;filter.typeOfRequest=_this.state.typeOfRequest;return _context2.abrupt("break",98);case 25:filter.sampleType=_this.state.sampleType;filter.fabNumber=_this.state.fabNumber;filter.toDate=_this.state.toDate;filter.quality=_this.state.quality;filter.fromDate=_this.state.fromDate;filter.countCons=_this.state.countCons;return _context2.abrupt("break",98);case 32://filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.fabNumber=_this.state.fabNumber;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;filter.typeOfRequest=_this.state.typeOfRequest;filter.headers=[].concat(_toConsumableArray(_this.state.arrayValue1)).map(function(x){return x.label==="3D"&&"CAD"||x.label.toUpperCase();});filter.processes=[].concat(_toConsumableArray([].concat(_toConsumableArray(_this.state.arrayValue)).map(function(x){return x.value;})),[{headers:[].concat(_toConsumableArray(_this.state.arrayValue1)).map(function(x){return x.value;})}]);// filter.processes = [...this.state.arrayValue].map(x => x.value)
if(!(!filter.headers.length||!filter.processes.length)){_context2.next=43;break;}_this.props.getalertMessage('info',"Please select mandatory fields");_this.setState({isLoading:false});return _context2.abrupt("return");case 43:return _context2.abrupt("break",98);case 44:filter.styleType=_this.state.styleType;styleRes=_this.state.styleType;styleResVal=_this.state.styleTypeValue;filter.styleNo='styleNo'===styleRes?styleResVal:_this.state.styleNo;filter.styleName='styleName'===styleRes?styleResVal:_this.state.styleName;filter.styleTypeValue=_this.state.styleTypeValue;filter.garmentType=_this.state.garmentType;filter.imageType=_this.state.imageType;filter.itemNo=_this.state.itemNo;filter.customerRefNo=_this.state.customerRefNo;filter.actionedBy=_this.state.actionedBy;return _context2.abrupt("break",98);case 56:filter.bNumber=_this.state.bNumber;filter.countCons=_this.state.countCons;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;return _context2.abrupt("break",98);case 61:filter.processType=_this.state.processType;//filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.typeOfRequest=_this.state.typeOfRequest;filter.completed=_this.state.completed;return _context2.abrupt("break",98);case 66:filter={};filter.reportType="bulkUpdateDispatch";filter.isExport=false;filter.ids=_this.state.ids.map(function(x){return x.value;});return _context2.abrupt("break",98);case 71:filter.processType=_this.state.processType;//filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.typeOfRequest=_this.state.typeOfRequest;filter.eta=_this.state.processUpdatesETA;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;return _context2.abrupt("break",98);case 78:filter.processType=_this.state.processType;//filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.typeOfRequest=_this.state.typeOfRequest;filter.eta=_this.state.processUpdatesETA;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;return _context2.abrupt("break",98);case 85://filter.sampleType = this.state.sampleType;
filter.sampleType=_this.state.arrayValue2.length>0?_this.state.arrayValue2.map(function(x){return x.value;}):null;filter.typeOfRequest=_this.state.typeOfRequest;filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;filter.patternMasterId=_this.state.patternMaster?_this.state.patternMaster.value:null;return _context2.abrupt("break",98);case 91:filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;filter.actionedBy=_this.state.actionedBy;return _context2.abrupt("break",98);case 95:filter.toDate=_this.state.toDate;filter.fromDate=_this.state.fromDate;return _context2.abrupt("break",98);case 98:_context2.next=100;return __WEBPACK_IMPORTED_MODULE_10__services__["i" /* ReportServices */].getReport(filter).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var header;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status===200)){_context.next=25;break;}if(!filter.sendMail){_context.next=6;break;}_context.next=4;return _this.props.getalertMessage("success",response.text.data);case 4:_context.next=23;break;case 6:if(!filter.isExport){_context.next=11;break;}_context.next=9;return _this.downloadReport(response.text.data);case 9:_context.next=23;break;case 11:if(!(!filter.isExport&&isOther(_this.state.type))){_context.next=22;break;}if(!(_this.state.type==='sampleLibrary')){_context.next=18;break;}console.log("SampleLibrary Data");_context.next=16;return _this.setState({fabricReportList:[],count:response.text.data.count,// hasMore:
//   response.text.data.count < 100 ||
//     page * 100 >= response.text.data.count
//     ? false
//     : true,
page:page,generateCount:_this.state.generateCount,header:{},body:[]// image: this.state.type === 'fabric' ? true : false
},function(){return _this.setState({fabricReportList:response.text.data.tableList});});case 16:_context.next=20;break;case 18:_context.next=20;return _this.setState({showForm:false,fabricReportList:page!=1&&[].concat(_toConsumableArray(_this.state.fabricReportList),_toConsumableArray(response.text.data.tableList))||[].concat(_toConsumableArray(response.text.data.tableList)),count:response.text.data.count,hasMore:response.text.data.count<100||page*100>=response.text.data.count?false:true,page:page,generateCount:_this.state.generateCount+1,header:{},body:[]// image: this.state.type === 'fabric' ? true : false
},function(){return _this.scrollToTable();});case 20:_context.next=23;break;case 22:if(_this.state.type==="custDept"||_this.state.type==="sampleProcesses"){header=Object.assign({},_this.state.header);if(page===1&&response.text.data.tableList.length){header.h1="CUSTOMER";header.h2=Object.keys(response.text.data.tableList[0].data[0]);}_this.setState({header:header,body:page!=1&&[].concat(_toConsumableArray(_this.state.body),_toConsumableArray(response.text.data.tableList))||[].concat(_toConsumableArray(response.text.data.tableList)),count:response.text.data.count,hasMore:response.text.data.count<100||page*100>=response.text.data.count?false:true,page:page,generateCount:_this.state.generateCount+1},function(){return _this.scrollToTable();});}case 23:_context.next=26;break;case 25:__WEBPACK_IMPORTED_MODULE_10__services__["m" /* UtilityService */].errorMsg(_this.msg,response.text.message,1500);// console.log(response.text, "responseresponse");
case 26:_context.next=28;return _this.setState({isLoading:false});case 28:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x5){return _ref3.apply(this,arguments);};}()).catch(function(error){return _this.props.getalertMessage("error",error.toString());});case 100:return _context2.abrupt("return",true);case 101:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x,_x2,_x3,_x4){return _ref2.apply(this,arguments);};}(),_this.downloadReport=function(data){var anchor=document.createElement("a");anchor.href=__WEBPACK_IMPORTED_MODULE_10__services__["m" /* UtilityService */].baseUrl()+data.link;anchor.target="_blank";anchor.download=__WEBPACK_IMPORTED_MODULE_10__services__["m" /* UtilityService */].baseUrl()+data.link;anchor.click();},_this.changeSupplierInfo=function(supplierName){supplierName!==null?_this.setState({supplierName:supplierName}):_this.setState({supplierName:null});},_this.storeCustomerData=function(currentNode,selectedNodes){_this.customerChoosen=selectedNodes;},_this.handleScroll=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var length,bottom,nextPage,_length,_bottom,page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(_this.state.type!=='sampleLibrary'&&_this.state.type!=='custDept'&&_this.state.type!=='fabPricePending'&&_this.state.type!=='sampleProcesses'&&_this.state.type!=='dispatch')){_context3.next=12;break;}length=_this.state.fabricReportList.length||_this.state.body.length;//console.log(length, "length");
if(!(_this.state.count!==length)){_context3.next=10;break;}bottom=e.target.scrollHeight<=e.target.scrollTop+e.target.clientHeight+40;if(!(bottom&&_this.state.scroll)){_context3.next=10;break;}nextPage=_this.state.page+1;_this.setState({scroll:false,page:nextPage});// Pass the current sortField and sortDirection to exportReport
_context3.next=9;return _this.exportReport(_this.state.type,nextPage,_this.state.sortField,_this.state.sortDirection);case 9:// Re-enable scrolling for further data loading
_this.setState({scroll:true});case 10:_context3.next=27;break;case 12:if(!(_this.state.type==='custDept'||_this.state.type==='fabPricePending'||_this.state.type==='sampleProcesses'||_this.state.type==='dispatch')){_context3.next=27;break;}_length=_this.state.fabricReportList.length||_this.state.body.length;if(!(_this.state.count!==_length)){_context3.next=27;break;}// const bottom = e.target.scrollHeight - e.target.scrollTop === (e.target.clientHeight+40);
_bottom=e.target.scrollHeight<=e.target.scrollTop+40+e.target.clientHeight;console.log(_bottom,"bottom");if(!(_bottom&&_this.state.scroll)){_context3.next=27;break;}page=_this.state.page%_length+1;_this.setState({scroll:false,generateCount:0});if(!isOther(_this.state.type)){_context3.next=27;break;}_context3.t0=_this;_context3.next=24;return _this.exportReport(false,page);case 24:_context3.t1=_context3.sent;_context3.t2={scroll:_context3.t1};_context3.t0.setState.call(_context3.t0,_context3.t2);case 27:case"end":return _context3.stop();}}},_callee3,_this2);}));return function(_x6){return _ref4.apply(this,arguments);};}(),_this.generatePage=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(page){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.setState({generateCount:page,userPageInput:page===0?1:page});page=page===1?page+1:page||1;_context4.next=4;return _this.exportReport(false,page);case 4:case"end":return _context4.stop();}}},_callee4,_this2);}));return function(_x7){return _ref5.apply(this,arguments);};}(),_this.scrollToTable=function(){var ele=document.getElementById("report-list-height");ele.scrollIntoView();},_this.updateSampleType=function(e){var _e$target=e.target,name=_e$target.name,value=_e$target.value;_this.setState({typeOfRequest:value});},_this.updateRequest=function(e){var _e$target2=e.target,name=_e$target2.name,value=_e$target2.value;_this.setState({typeOfRequest:value});},_this.updateState=function(name,value){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var key=arguments[3];if(_this.state[name]===value){if(value!==""){_this.setState(_defineProperty({},name,value));}else{_this.setState(_defineProperty({},name,null));}}else{if(value!==""){var _this$setState4,_this$setState5;if(reset)_this.setState((_this$setState4={},_defineProperty(_this$setState4,name,value),_defineProperty(_this$setState4,"header",{}),_defineProperty(_this$setState4,"body",[]),_defineProperty(_this$setState4,"fabricReportList",[]),_this$setState4));else _this.setState((_this$setState5={},_defineProperty(_this$setState5,name,value),_defineProperty(_this$setState5,key,""),_this$setState5));}else{_this.setState(_defineProperty({},name,null));}}},_this.addNumbers=function(){var _this$state=Object.assign({},_this.state),ids=_this$state.ids,NumberFromObj=_this$state.NumberFromObj;if(NumberFromObj!==""){var obj=ids.find(function(x){return x.value===NumberFromObj.value;});if(!obj){ids=[].concat(_toConsumableArray(ids),[NumberFromObj]);_this.setState({ids:ids,selectedNumberObj:NumberFromObj.value,NumberFromObj:''});}else{_this.setState({NumberFromObj:''});_this.props.getalertMessage('info','SR Number already added in list');}}},_this.selectMultipleOption=function(value){_this.setState({arrayValue1:value});},_this.selectMultipleOption1=function(value){_this.setState({arrayValue:value});},_this.selectMultipleOption2=function(value){_this.setState({arrayValue2:value});},_this.displayData=function(index){var fabricReportList=[].concat(_toConsumableArray(_this.state.fabricReportList));fabricReportList.map(function(x,i){if(i==index){x.disable=!x.disable;}});_this.setState({fabricReportList:fabricReportList});},_this.modalData=function(data){var filePreviewIframe=_this.state.filePreviewIframe;filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:data});_this.setState({filePreviewIframe:filePreviewIframe,openModal:true});},_this.removeNumbers=function(value){// var selected = document.getElementById("mySelectNum").value
var _this$state2=Object.assign({},_this.state),ids=_this$state2.ids,NumberFromObj=_this$state2.NumberFromObj;if(value&&ids&&ids.length){ids=ids.filter(function(x){return x.value!=value;});_this.setState({ids:ids});}else{_this.props.getalertMessage('info',"Select SR Number");}},_this.resetBy=function(){_this.setState({ids:[],List:[],fabricReportList:[]});},_this.getNumberFrom=function(fabricNum){if(fabricNum){_this.setState({NumberFrom:fabricNum.value,NumberFromObj:fabricNum});}else{_this.setState({NumberFrom:"",NumberFromObj:""});//   this.getFabricNumber("")
}},_this.bulkDispatchUpdate=function(date,awbNumber,location,courier){if(!awbNumber||!location||!courier||!_this.state.ids.length){_this.props.getalertMessage("info","Please fill all valid data");}else{var obj={date:!date&&new Date()||date,awbNumber:awbNumber,location:location,courier:courier};var list=[].concat(_toConsumableArray(_this.state.fabricReportList));list=list.reduce(function(pv,cv,i){var objD={};objD._id=cv.id;objD.dispatch=[Object.assign({size:cv.selectedSize,quantity:cv.selectedQty},obj)];if(pv.some(function(e){return e._id===cv.id;})){pv.map(function(x){if(x._id===cv.id){x.dispatch=[].concat(_toConsumableArray(x.dispatch),_toConsumableArray(objD.dispatch));}});}else{pv.push(objD);}return pv;},[]);__WEBPACK_IMPORTED_MODULE_10__services__["j" /* SampleServices */].bulkUpdateDispatch({data:list}).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.message);}response.status==401&&_this.props.unauthorisedFunc();response.status==400&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});}},_this.addDispatchData=function(data,index){var _Object$assign2;var fabricReportList=_this.state.fabricReportList;var indexData=Object.assign({},fabricReportList[index],(_Object$assign2={},_defineProperty(_Object$assign2,'SIZE',data),_defineProperty(_Object$assign2,"selectedSize",""),_defineProperty(_Object$assign2,"selectedQty",""),_Object$assign2));fabricReportList=fabricReportList.splice(index,0,indexData);_this.setState(fabricReportList);},_this.dispatchUpdate=function(value,index,key){var fabricReportList=_this.state.fabricReportList;fabricReportList[index][key]=value;// fabricReportList = fabricReportList.splice(index, 0, indexData)
_this.setState(fabricReportList);},_this.sorting=function(key){var _this$state3=_this.state,fabricReportList=_this$state3.fabricReportList,sortIn=_this$state3.sortIn;if(key==="SR NO"){fabricReportList=fabricReportList.sort(function(a,b){return sortIn&&(a[key].number.toLowerCase()>b[key].number.toLowerCase()&&1||-1)||a[key].number.toLowerCase()>b[key].number.toLowerCase()?-1:1;});}else if(key==="STYLE NO"){fabricReportList=fabricReportList.sort(function(a,b){return sortIn&&(a[key].code.toLowerCase()>b[key].code.toLowerCase()&&1||-1)||a[key].code.toLowerCase()>b[key].code.toLowerCase()?-1:1;});}else if(key==="ETA/ETD"){//fabricReportList = fabricReportList.sort((a, b) => sortIn ? moment(a[key], "DD MMM YYYY").valueOf() - moment(b[key], "DD MMM YYYY").valueOf() ? 1 : -1 : moment(a[key], "DD MMM YYYY").valueOf() - moment(b[key], "DD MMM YYYY").valueOf() ? -1 : 1)
fabricReportList=fabricReportList.sort(function(a,b){var dateA=a[key]?__WEBPACK_IMPORTED_MODULE_6_moment___default()(a[key],"DD MMM YYYY").valueOf():sortIn?Number.MAX_SAFE_INTEGER:0;var dateB=b[key]?__WEBPACK_IMPORTED_MODULE_6_moment___default()(b[key],"DD MMM YYYY").valueOf():sortIn?Number.MAX_SAFE_INTEGER:0;if(dateA===dateB)return 0;// Handles cases where both dates are empty or identical
return sortIn?dateA-dateB:dateB-dateA;});}else if(key==="FABRIC ETA"){fabricReportList=fabricReportList.sort(function(a,b){var dateA=a[key]?__WEBPACK_IMPORTED_MODULE_6_moment___default()(a[key],"DD MMM YYYY").valueOf():sortIn?Number.MAX_SAFE_INTEGER:0;var dateB=b[key]?__WEBPACK_IMPORTED_MODULE_6_moment___default()(b[key],"DD MMM YYYY").valueOf():sortIn?Number.MAX_SAFE_INTEGER:0;if(dateA===dateB)return 0;// Handles cases where both dates are empty or identical
return sortIn?dateA-dateB:dateB-dateA;});}else if(key==="DATE OF REQUEST"){fabricReportList=fabricReportList.map(function(x){return Object.assign({},x,_defineProperty({},key,__WEBPACK_IMPORTED_MODULE_6_moment___default()(x[key].trim(),"DD MMM YYYY").valueOf()));}).sort(function(a,b){return sortIn?b[key]-a[key]:a[key]-b[key];}).map(function(x){return Object.assign({},x,_defineProperty({},key,__WEBPACK_IMPORTED_MODULE_6_moment___default()(x[key]).format("DD MMM YYYY")));});}else{fabricReportList=fabricReportList.sort(function(a,b){return sortIn?a[key].toLowerCase()>b[key].toLowerCase()?1:-1:a[key].toLowerCase()>b[key].toLowerCase()?-1:1;});}_this.setState({fabricReportList:fabricReportList,sortIn:sortIn?0:1});},_this.handleSorting=function(field){var _this$state4=_this.state,sortField=_this$state4.sortField,sortDirection=_this$state4.sortDirection,reportType=_this$state4.reportType,processType=_this$state4.processType,prevReportType=_this$state4.prevReportType,prevProcessType=_this$state4.prevProcessType;// Check if the reportType or processType has changed
var isTypeChanged=reportType!==prevReportType||processType!==prevProcessType;// If reportType or processType has changed, reset sortDirection to null
var newSortDirection=isTypeChanged?"asc":sortField===field&&sortDirection==="asc"?"desc":"asc";// Update the state with the new sorting field and direction
_this.setState({sortField:field,sortDirection:newSortDirection,prevReportType:reportType,// Update the previous reportType for next comparison
prevProcessType:processType,// Update the previous processType for next comparison
page:1// Reset to the first page for new sorting
},function(){// Trigger exportReport only for specific report types
_this.exportReport(_this.state.type,1,field,newSortDirection);});},_this.handleCheckBox=function(name,value,index){var fabricReportList=_this.state.fabricReportList;if(name==="all"){fabricReportList=fabricReportList.map(function(data,i){data["checkbox"+i]=value;return data;});_this.setState({fabricReportList:fabricReportList,all:value});}else{fabricReportList[index][name]=value;_this.setState({fabricReportList:fabricReportList,all:false});}},_this.saveProcessUpdates=function(){var ids=_this.state.fabricReportList.reduce(function(a,c,i){if(c["checkbox"+i]){a.push(c["SR NO"]._id);}return a;},[]);var obj={requestKey:_this.state.requestKey,requestValue:_this.state.requestValue,ids:ids,processType:_this.state.processType};return __WEBPACK_IMPORTED_MODULE_10__services__["i" /* ReportServices */].bulkUpdateProcess(Object.assign({},obj)).then(function(response){if(response.status===200){_this.props.getalertMessage("success",response.message);return _this.exportReport(false,1);}response.status==401&&_this.props.unauthorisedFunc();response.status==400&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Report,[{key:"componentWillMount",value:function componentWillMount(){var _this3=this;setTimeout(function(){var reportTypeOption=[{label:"BNumber Report",value:"bNumber",disabled:_this3.props.rights.bNumber.web.view},{label:"Bulk Updates For Dispatch",value:"bulkUpdateDispatch",disabled:_this3.props.rights.bulkUpdateDispatch.web.view},{label:"Dispatch Report",value:"dispatch",disabled:_this3.props.rights.dispatch.web.view},{label:"Fabric Library",value:"fabricLibrary",disabled:_this3.props.rights.fabricLibrary.web.view},{label:"Fabric Price Pending",value:"fabPricePending",disabled:_this3.props.rights.fabPricePending.web.view},{label:"Fabric Report",value:"fabric",disabled:_this3.props.rights.fabric.web.view},{label:"Outstanding Customer",value:"custDept",disabled:_this3.props.rights.outstandingCustomer.web.view},{label:"Pattern Master Report",value:"patternMasterReport",disabled:_this3.props.rights.patternMasterReport.web.view},{label:"Process Completed",value:"processCompleted",disabled:_this3.props.rights.processCompleted.web.view},{label:"Process Updates",value:"bulkUpdateProcess",disabled:_this3.props.rights.bulkUpdateProcess.web.view},{label:"Samples Awaiting Materials",value:"processUpdates",disabled:_this3.props.rights.processUpdates.web.view},{label:"Sample Library",value:"sampleLibrary",disabled:_this3.props.rights.sampleLibrary.web.view},{label:"Sample Report By Processes",value:"sampleProcesses",disabled:_this3.props.rights.sampleProcesses.web.view},{label:"Sample Request Downloads",value:"sampleRequestDownloads"// disabled: this.props.rights.sampleProcesses.web.view
},{label:"Style Downloads",value:"styleDownloads",disabled:_this3.props.rights.processUpdates.web.view}];// console.log(this.props.rights, "this.props.rights");
// reportTypeOption.forEach((x)=>{
//   console.log(this.props.rights[x.value], x);
// })
reportTypeOption=reportTypeOption.filter(function(y){var name=y.value==='custDept'&&'outstandingCustomer'||y.value;return _this3.props.rights[name]&&_this3.props.rights[name].web.view;});_this3.setState({reportTypeOption:reportTypeOption});},400);}},{key:"componentDidMount",value:function componentDidMount(){var _this4=this;//sampleNo
__WEBPACK_IMPORTED_MODULE_10__services__["j" /* SampleServices */].getSampleReqNo("").then(function(response){if(response.status===200){_this4.setState({NumberFromList:response.text.data// isLoading: true
});}response.status==401&&_this4.props.unauthorisedFunc();}).catch(function(error){return _this4.props.getalertMessage("error",error.toString());});//customer
__WEBPACK_IMPORTED_MODULE_10__services__["d" /* CustomerServices */].customerInfo().then(function(response){if(response.status===200){var customerOption=[].concat(_toConsumableArray(new Set(response.text.data.map(function(x){return x.customerName;}))));_this4.setState({customerList:[].concat(_toConsumableArray(response.text.data)),customerOption:customerOption});}}).catch(function(error){return _this4.props.getalertMessage("error",error.toString());});__WEBPACK_IMPORTED_MODULE_10__services__["d" /* CustomerServices */].customerWithDepartmentInfo().then(function(response){if(response.status===200){_this4.setState({customerWithDepartment:response.text.data});}}).catch(function(error){return _this4.props.getalertMessage("error",error.toString());});//get fabric section from system
// DevelopmentServices.prefillFabricDetails()
//   .then(response => {
//     this.setState({
//       supplierOption: response.data.Fabric.SUPPLIERNAME,
//       requirementOption: response.data.Fabric.REQUIREMENT
//     });
//   })
//   .catch(error => this.props.getalertMessage("error", error.toString()));
__WEBPACK_IMPORTED_MODULE_10__services__["j" /* SampleServices */].prefillSRDetails().then(function(res){if(res.message==="Operation Successful"){_this4.setState({COURIER:res.data.SYSTEMSAMPLEREQUEST.COURIER,LOCATION:res.data.SYSTEMSAMPLEREQUEST.LOCATION,fabQualityList:res.data.FABRIC.BASICQUALITY});}});setTimeout(function(){_this4.setState({oldState:_this4.state});},1000);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _state=this.state,reportType=_state.reportType,processType=_state.processType;// Check if reportType or processType has changed
if(prevState.reportType!==reportType||prevState.processType!==processType){// Reset sortField and sortDirection on type change
this.setState({sortField:null,sortDirection:null});}}// handleScroll = async e => {
//   if (this.state.type !== 'sampleLibrary') {
//     let length = this.state.fabricReportList.length || this.state.body.length;
//     if (this.state.count !== length) {
//       // const bottom = e.target.scrollHeight - e.target.scrollTop === (e.target.clientHeight+40);
//       const bottom = e.target.scrollHeight <= ((e.target.scrollTop + 40) + e.target.clientHeight);
//       console.log(bottom, "bottom");
//       if (bottom && this.state.scroll) {
//         let page = (this.state.page % length) + 1;
//         this.setState({
//           scroll: false,
//           generateCount: 0
//         });
//         if (isOther(this.state.type)) {
//           this.setState({
//             scroll: await this.exportReport(false, page)
//           });
//         }
//       }
//     }
//   }
// };
// handleScroll = async (e) => {
//   if (this.state.type !== 'sampleLibrary') {
//     const length = this.state.fabricReportList.length || this.state.body.length;
//     if (this.state.count !== length) {
//       const bottom = e.target.scrollHeight <= (e.target.scrollTop + e.target.clientHeight + 40);
//       if (bottom && this.state.scroll) {
//         const nextPage = this.state.page + 1;
//         this.setState({ scroll: false, page: nextPage });
//         // Trigger exportReport with current sort values for the next page
//         await this.exportReport(this.state.type, nextPage, this.state.sortBy, this.state.sortOrder);
//         // Re-enable scrolling for further data loading
//         this.setState({ scroll: true });
//       }
//     }
//   }
// };
// handleSorting = (field) => {
//   const sortOrder = this.state.sortBy === field && this.state.sortOrder === "asc" ? "desc" : "asc";
//   this.setState({ sortBy: field, sortOrder }, () => {
//     // Only fetch sorted data from backend for specific report types
//     if (["bulkUpdateProcess", "processUpdates"].includes(this.state.type)) {
//       this.exportReport(this.state.type, 1, field, sortOrder);
//     }
//   });
// };
//   handleSorting = (field) => {
//     const { sortField, sortDirection, reportType, processType } = this.state;
//     // Reset sortDirection to 'asc' if reportType or processType changed; otherwise, toggle
//     const newSortDirection = (reportType !== this.state.prevReportType || processType !== this.state.prevProcessType) 
//         ? 'asc' 
//         : (sortField === field && sortDirection === 'asc' ? 'desc' : 'asc');
//     this.state.prevReportType = reportType;
//     this.state.prevProcessType = processType;
//     this.setState(
//         { sortField: field, sortDirection: newSortDirection, page: 1 },
//         () => {
//             // Trigger export with updated sort criteria
//             this.exportReport(this.state.type, 1, field, newSortDirection);
//         }
//     );
// };
},{key:"render",value:function render(){var _this5=this;var _state2=this.state,type=_state2.type,reportTypeOption=_state2.reportTypeOption,supplierOption=_state2.supplierOption,requirement=_state2.requirement,requirementOption=_state2.requirementOption,fabricReportList=_state2.fabricReportList,status=_state2.status,progress=_state2.progress,sampleType=_state2.sampleType,sampleTypeOptions=_state2.sampleTypeOptions,styleType=_state2.styleType,styleTypeValue=_state2.styleTypeValue,header=_state2.header,body=_state2.body,arrayValue=_state2.arrayValue;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Common_Loading__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_alert___default.a,Object.assign({ref:function ref(a){return _this5.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section bg-white",id:"reportId"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row nopadding bg-white",id:"formId"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 px-0 py-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover",onClick:function onClick(e){return _this5.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-arrow-left"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-center Report-Label"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,"Report")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 "},this.state.type!='bulkUpdateDispatch'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon pull-right",onClick:function onClick(e){_this5.state.type!==""&&_this5.exportReport(true)||_this5.props.getalertMessage("info","Please Select Report Type");}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_download_png___default.a})):'',this.state.type!='bulkUpdateDispatch'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"btn-green-icon pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_to_print___default.a,{trigger:function trigger(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_printer_png___default.a});},content:function content(){return _this5.componentRef;}})):''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"list-inline text-center justify-content-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Report Type")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"type"// className={"p-1 px-3"}
,value:type,options:reportTypeOption,onChange:this.updateReportType,disabled:false})))),function(){switch(_this5.state.type){case"fabric":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["f" /* FabricForm */],{customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,supplierName:_this5.state.supplierName,changeSupplierInfo:_this5.changeSupplierInfo,supplierOption:supplierOption,requirement:requirement,requirementOption:requirementOption,updateState:_this5.updateState,status:status,statusOptions:statusOptions});case"custDept":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["d" /* CustOutstandingForm */],{fromDate:_this5.state.fromDate,toDate:_this5.state.toDate,updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment,selectMultipleOption1:_this5.selectMultipleOption1,arrayValue:_this5.state.arrayValue,createdAt:_this5.state.createdAt,storeCustomerData:_this5.storeCustomerData,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,image:_this5.state.image});case"fabPricePending":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["h" /* FabricPricePending */],{customerWithDepartment:_this5.state.customerWithDepartment,updateState:_this5.updateState,selectMultipleOption1:_this5.selectMultipleOption1,arrayValue:_this5.state.arrayValue,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,storeCustomerData:_this5.storeCustomerData,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest});case"sampleProcesses":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["n" /* SampleReportByProcessesForm */],{customerWithDepartment:_this5.state.customerWithDepartment,fromDate:_this5.state.fromDate,toDate:_this5.state.toDate,updateState:_this5.updateState,arrayValue:_this5.state.arrayValue,arrayValue1:_this5.state.arrayValue1,selectMultipleOption:_this5.selectMultipleOption,selectMultipleOption1:_this5.selectMultipleOption1,processType:_this5.state.processType,processTypeOptions:_this5.state.processTypeOptions,status:status,statusOptions:statusOptions,progress:progress,progressOptions:progressOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,storeCustomerData:_this5.storeCustomerData});case"fabricLibrary":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["g" /* FabricLibrary */]// customerWithDepartment={
//   this.state.customerWithDepartment
// }
,{fromDate:_this5.state.fromDate,updateState:_this5.updateState,sampleType:sampleType,toDate:_this5.state.toDate,sampleTypeOptions:sampleTypeOptions,storeCustomerData:_this5.storeCustomerData,fabNumber:_this5.state.fabNumber,fabQualityList:_this5.state.fabQualityList});case"sampleLibrary":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["m" /* SampleLibrary */],{customerWithDepartment:_this5.state.customerWithDepartment,updateState:_this5.updateState,styleType:styleType,styleTypeValue:styleTypeValue,garmentType:_this5.state.garmentType,itemNo:_this5.state.itemNo,imageType:_this5.state.imageType,customerRefNo:_this5.state.customerRefNo,actionedBy:_this5.state.actionedBy,actionedByOptions:_this5.state.actionedByOptions,garmentTypeOptions:_this5.state.garmentTypeOptions,imageTypeOptions:_this5.state.imageTypeOptions,storeCustomerData:_this5.storeCustomerData,exportReport:function exportReport(){return _this5.exportReport(false,1);}});case"dispatch":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["e" /* DispatchForm */],{fromDate:_this5.state.fromDate,updateState:_this5.updateState,toDate:_this5.state.toDate,customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2,location:_this5.state.location,LOCATION:_this5.state.LOCATION,courier:_this5.state.courier,courierOptions:_this5.state.COURIER,awbNumber:_this5.state.awbNumber});case"bNumber":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["a" /* BNumberForm */],{customerWithDepartment:_this5.state.customerWithDepartment,updateState:_this5.updateState,storeCustomerData:_this5.storeCustomerData,countCons:_this5.state.countCons,bNumber:_this5.state.bNumber});case"bulkUpdateDispatch":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["c" /* BulkUpdateForDispatch */],{getalertMessage:_this5.props.getalertMessage,updateState:_this5.updateState,getNumberFrom:_this5.getNumberFrom,NumberFromList:_this5.state.NumberFromList,NumberFromObj:_this5.state.NumberFromObj,getNumberList:_this5.getNumberList,addNumbers:_this5.addNumbers,searchBy:_this5.searchBy,resetBy:_this5.resetBy,removeNumbers:_this5.removeNumbers,ids:_this5.state.ids,toDate:_this5.state.toDate,awbNumber:_this5.state.awbNumber,location:_this5.state.location,LOCATION:_this5.state.LOCATION,courier:_this5.state.courier,courierOptions:_this5.state.COURIER,List:_this5.state.fabricReportList,printDate:_this5.state.printDate,exportReport:_this5.exportReport,bulkDispatchUpdate:_this5.bulkDispatchUpdate,addDispatchData:_this5.addDispatchData,dispatchUpdate:_this5.dispatchUpdate});case"processCompleted":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["k" /* ProcessCompletedForm */],{updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,processType:_this5.state.processType,processTypeOptions:_this5.state.processTypeOptions,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,completed:_this5.state.completed,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2});case"printYarn":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["j" /* PrintYarnForm */],{customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,supplierName:_this5.state.supplierName,changeSupplierInfo:_this5.changeSupplierInfo,supplierOption:supplierOption,requirement:requirement,requirementOption:requirementOption,updateReportType:_this5.updateReportType,status:status,statusOptions:statusOptions});case"processUpdates"://Sample Awaiting Materials
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["l" /* ProcessUpdatesForm */],{fromDate:_this5.state.fromDate,toDate:_this5.state.toDate,updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment// processUpdatesETA={this.state.processUpdatesETA}
,storeCustomerData:_this5.storeCustomerData,processType:_this5.state.processType,processTypeOptions:_this5.state.processTypeOptions,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2});case"patternMasterReport":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["i" /* PatterMasterReport */],{updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment,patternMasterList:_this5.state.patterMasterList,storeCustomerData:_this5.storeCustomerData,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,completed:_this5.state.completed,patternMaster:_this5.state.patternMaster,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2,fromDate:_this5.state.fromDate,toDate:_this5.state.toDate// updatePatternMaster={this.updateState}
});case"bulkUpdateProcess":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["b" /* BulkProcessUpdates */],{fromDate:_this5.state.fromDate,toDate:_this5.state.toDate,updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment// processUpdatesETA={this.state.processUpdatesETA}
,storeCustomerData:_this5.storeCustomerData,processType:_this5.state.processType,processTypeOptions:_this5.state.processTypeOptions,typeOfRequest:_this5.state.typeOfRequest,typeOfRequestOptions:__WEBPACK_IMPORTED_MODULE_13__services_common_options__["a" /* default */].typeOfRequest,sampleType:sampleType,sampleTypeOptions:sampleTypeOptions,selectMultipleOption2:_this5.selectMultipleOption2,arrayValue2:_this5.state.arrayValue2,requestValue:_this5.state.requestValue,requestKey:_this5.state.requestKey,STATUS:_this5.state.STATUS,list:_this5.state.fabricReportList,showForm:_this5.state.showForm,saveProcessUpdates:_this5.saveProcessUpdates,all:_this5.state.all});case"styleDownloads":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["o" /* StyleDownloads */],{updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,completed:_this5.state.completed,fromDate:_this5.state.fromDate,toDate:_this5.state.toDate,actionedByOptions:_this5.state.actionedByOptions,actionedBy:_this5.state.actionedBy});case"sampleRequestDownloads":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Report_forms__["o" /* StyleDownloads */],{updateState:_this5.updateState,customerWithDepartment:_this5.state.customerWithDepartment,storeCustomerData:_this5.storeCustomerData,completed:_this5.state.completed,fromDate:_this5.state.fromDate,toDate:_this5.state.toDate});default:return null;}}(),this.state.type!='bulkUpdateDispatch'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 text-center mt-2 "+(!this.state.type?"d-none":"")},(this.state.type!=="bulkUpdateProcess"||this.state.showForm)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{"class":"primary",onClick:function onClick(e){// Reset sortField and sortDirection to null before generating the report
_this5.setState({sortField:null,sortDirection:null,page:1},function(){// Call exportReport with the reset values
_this5.exportReport(false,1);});}},"generate report")),this.state.type!=='bulkUpdateProcess'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-md-offset-2 text-center  mt-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-9 mt-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"email",placeholder:"Enter an Email...",className:"form-control ml-2 border-1",onChange:function onChange(e){_this5.setState({emailId:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-3 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary",disabled:this.state.emailId.length>0?false:true,onClick:function onClick(e){return _this5.exportReport("sendEmail");}},"send email")))):''),this.state.type==="sampleLibrary"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 pull-right d-flex new-paginamtion-align"},this.state.generateCount&&this.state.generateCount!==1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary"// disabled={this.state.emailId.length > 0 ? false : true}
,onClick:function onClick(e){return _this5.generatePage(0);}},"<<"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary"// disabled={this.state.emailId.length > 0 ? false : true}
,onClick:function onClick(e){return _this5.generatePage(_this5.state.userPageInput-1);}},"<"))||"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"text-right d-flex page-text"},"Page",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number"// placeholder="Enter page no..."
,className:"form-control ml-2 border-1",onChange:function onChange(e){_this5.setState({userPageInput:Number(e.target.value)});},value:this.state.userPageInput}),"of ",this.state.count),this.state.count>this.state.generateCount&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary"// disabled={this.state.emailId.length > 0 ? false : true}
,onClick:function onClick(e){return _this5.generatePage(_this5.state.generateCount+1);}},">"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary"// disabled={this.state.emailId.length > 0 ? false : true}
,onClick:function onClick(e){return _this5.generatePage(_this5.state.count);}},">>")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary"// disabled={this.state.emailId.length > 0 ? false : true}
,onClick:function onClick(e){return _this5.generatePage(_this5.state.userPageInput||1);}},"Go")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:(fabricReportList.length||body.length)&&"row nopadding bg-white d-flex justify-content-center"||"d-none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"w-100"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{id:"report-list-height",className:"report-list-height mt-5",onScroll:this.state.type!=='sampleLibrary'&&this.handleScroll},this.state.type==="fabric"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,fabricReportList!==undefined&&fabricReportList.length>0&&Object.keys(fabricReportList[0]).map(function(data){if(data!=="ID")return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"report-header"},data);})),this.state.type==="dispatch"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["c" /* Dispatch */],{list:fabricReportList,displayData:this.displayData}),this.state.type==="bNumber"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["a" /* BNumberList */],{list:fabricReportList,right:this.props.rights.bNumber}),this.state.type==="fabPricePending"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["e" /* FabricPricePendingList */],{rights:this.props.rights.fabPricePending,styleRights:this.props.styleRights,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="fabricLibrary"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["d" /* FabricLibraryList */],{rights:this.props.rights.fabricLibrary,styleRights:this.props.styleRights,modalData:this.modalData,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="sampleProcesses"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["k" /* SampleReportByProcessesList */],{rights:this.props.rights.sampleProcesses,styleRights:this.props.styleRights,sampleRights:this.props.sampleRequest,modalData:this.modalData,list:body,processType:this.state.processType,history:this.props.history,disabled:this.state.disabled,header:header,showHeaders:arrayValue}),this.state.type==="sampleLibrary"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["j" /* SampleLibraryList */],{rights:this.props.rights.sampleLibrary,styleRights:this.props.styleRights,modalData:this.modalData,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="processCompleted"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["h" /* ProcessCompletedList */],{rights:this.props.rights.processCompleted,styleRights:this.props.styleRights,sampleRights:this.props.sampleRequest,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="printYarn"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["g" /* PrintYarnList */],{list:fabricReportList,state:this.state,modalData:this.modalData,rights:this.props.rights.printYarn,styleRights:this.props.styleRights}),(this.state.type==="processUpdates"||this.state.type==="bulkUpdateProcess")&&// sample awaiting material
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["i" /* ProcessUpdatesList */],{type:this.state.type,rights:this.props.rights.processUpdates,styleRights:this.props.styleRights,sampleRights:this.props.sampleRequest,list:fabricReportList,processType:this.state.processType,history:this.props.history,sorting:this.handleSorting,handleCheckBox:this.handleCheckBox,all:this.state.all}),this.state.type==="fabric"&&fabricReportList!==undefined&&Array.isArray(fabricReportList)&&fabricReportList.length>0&&fabricReportList.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,Object.keys(data).map(function(dat){if(dat=="IMAGE"&&data[dat]!=""){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:""+data[dat],style:{width:" 50px",height:"50px"}}));}else if(dat=="DEV REF NUMBER"||dat=="FABRIC REF NO"){if(_this5.props.rights.fabric.web.edit||_this5.props.rights.fabric.web.view){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"under-line cursor-hover"// let stylePage = listValue => {
//   let action =
//     (props.styleRights.web.edit && "edit") ||
//     (props.rights.web.view && "view");
//   let newSearch = "?" + new URLSearchParams({
//     action: action,
//     _id: listValue._id,
//     hash: `seleted${listValue.referenceCode.split("-").join("")}`
//   }).toString()
//   window.open(`/StylePage${newSearch}#seleted${listValue.referenceCode.split("-").join("")}`, "_blank")
// };
,onClick:function onClick(){var action=_this5.props.styleRights.web.edit&&"edit"||_this5.props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:data.ID// hash: `seleted${listValue.code.split("-").join("")}`
}).toString();window.open("/developmentFabric"+newSearch,"_blank");// window.open(`/StylePage${newSearch}`, "_blank")
}// this.props.history.push(
//   "/developmentFabric",
//   {
//     action:
//       this.props.rights.fabric.web.edit ==
//         true
//         ? "edit"
//         : this.props.rights.fabric.web.view
//           ? "view"
//           : "",
//     _id: data.ID,
//     report: { ...this.state },
//     route: "Report"
//   }
// )
},data[dat]));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,data[dat]));}}else if(dat!="ID"){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,data[dat]);}}));}),this.state.type==="custDept"&&body&&body.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["b" /* CustOutstand */],{state:this.state,list:body,header:header,history:this.props.history,rights:this.props.rights,getalertMessage:this.props.getalertMessage,changeBg:this.changeBg,setTitle:this.setTitle,modalData:this.modalData}),this.state.type==="patternMasterReport"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["f" /* PatterMasterReportList */],{rights:this.props.rights.processCompleted,styleRights:this.props.styleRights,sampleRights:this.props.sampleRequest,list:fabricReportList,processType:this.state.processType,history:this.props.history}),(this.state.type==="styleDownloads"||this.state.type==="sampleRequestDownloads")&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Report_reports__["l" /* StyleDownloadsList */],{rights:this.props.rights.processCompleted,sampleRights:this.props.sampleRequest,styleRights:this.props.styleRights,list:fabricReportList,processType:this.state.processType,history:this.props.history})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__print__["a" /* default */],{fabricReportList:fabricReportList,body:body,header:header,arrayValue:arrayValue,ref:function ref(el){return _this5.componentRef=el;},type:this.state.type}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this5.setState({openModal:false});},s:true,center:true},this.state.filePreviewIframe));}}]);return Report;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights.reports,styleRights:state.main.rights.style,sampleRequest:state.main.rights.sampleRequest,fabric:state.main.rights.fabric};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,null)(Report));

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var addWidth=function addWidth(title){var arr=["CUST-DEPT","STYLE NAME"];switch(title){case"STYLE NAME":return"5%";case"CUST REF NO":return"1%";case"ITEM NO":return"1%";case"SIZE":return"1%";case"SAMPLE TYPE":return"1%";case"QTY":return"1%";default:return'2%';}};function Dispatch(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left",width:"1%"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",nowrap:true,width:"20%"},"CUSTOMER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",width:"7%"},"DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",width:"15%"},"AWB NO."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",width:"15%"},"LOCATION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",width:"15%"},"COURIER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-left border",width:"27%"},"\xA0")),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"text-left",style:{display:'table-row',borderTop:"1px solid #ddeeff",borderBottom:""+(index===props.list.length-1?"1px solid #ddeeff":"none")}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"1%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid #ddeeff",borderTop:"1px solid #ddeeff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:;",className:"font-weight-bold primary",onClick:function onClick(){return props.displayData(index);}},data.disable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"unfold_less")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"class":"material-icons"},"unfold_more")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"20%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid #ddeeff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.customer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"7%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid #ddeeff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"15%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid #ddeeff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.awbNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"15%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid #ddeeff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"15%",style:{borderLeft:"1px solid #ddeeff",borderRight:"1px solid white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,data.courier)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left",width:"27%",style:{borderLeft:"1px solid #ddeeff"}},"\xA0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:data.disable?"":'d-none',border:"0",style:{width:'80%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{display:'table-row'}},["DEPT","STYLE NO","CUST REF NO","ITEM NO","STYLE NAME","SAMPLE TYPE","SIZE","QTY","FABRIC","COMMENTS"].map(function(ref){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{wordWrap:'break-word',borderTop:"1px solid white",borderRight:"1px solid white"},width:addWidth(ref),className:"report-sub-header text-left border"},ref);})),data.data.map(function(ref){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:{wordWrap:'break-word'}},["DEPT","STYLE NO","CUST REF NO","ITEM NO","STYLE NAME","SAMPLE TYPE","SIZE","QTY","FABRIC","COMMENTS"].map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:addWidth(ref),className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"wordwrap"},ref[dat]));}));}))));}));}/* harmony default export */ __webpack_exports__["a"] = (Dispatch);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var alignV=function alignV(data){var h=["SAMPLE","3D","FABRIC","TRIM","PATTERN","CUTTING","SEWING","GARMENT TECH","EMBELLISHMENT","EMBROIDERY","WASH",// "QC",
'GRADING',"MARKER","COSTING","SIGN OFF","DISPATCH"];if(h.includes(data)){return true;}else{return false;}};var setTitle=function setTitle(data,type){if((typeof data==="undefined"?"undefined":_typeof(data))==="object"){if(type==="content"){if(_typeof(data.status)==='object'){return data.status.status;}else{return data.status;}}else{return data.assignedTo;}}else{return data;}};var changeBg=function changeBg(data){var isBlue=false,status=void 0;if(_typeof(data.status)==="object"){status=data.status.status;isBlue=true;}else{status=data.status;}switch(status){case"P":return(!isBlue&&'bg-danger'||'bg-primary')+" p-2 text-white font-weight-bold borderDark align-middle";case"CA":return(!isBlue&&'bg-dark'||'bg-primary')+" py-2 px-1 text-white font-weight-bold borderDark align-middle";case"C":return(!isBlue&&'bg-success'||'bg-primary')+" p-2 text-white font-weight-bold borderDark align-middle";case"IN":return(!isBlue&&'bg-warning'||'bg-primary')+" py-2 px-1 text-white font-weight-bold borderDark align-middle";case"X":return(!isBlue&&'bg-yellow'||'bg-primary')+" p-2 text-dark font-weight-bold borderDark align-middle";case"":return"bg-primary p-2 text-white font-weight-bold borderDark align-middle";default:return"wordwrap py-1";}};function CustOutstand(props){var header=props.header;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Samples Outstanding by Customer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"P - PENDING \xA0\xA0 CA - Cancelled \xA0\xA0 C - Completed \xA0\xA0 IN - InProcess \xA0\xA0 X - NotAllocated")),Object.keys(header).length>0&&header.h1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,header&&header.h2&&header.h2.length>0&&header.h2.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:!alignV(x)&&x==="STYLE NAME"&&"19%",className:"report-header "+(alignV(x)&&"m-0 p-0")},i===0&&header.h1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+(alignV(x)?"rotate90 p-0 m-0":x==="DATE"?"Date":"wordwrap")},x));}))),props.list&&props.list.length>0&&props.list.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"23",className:"text-left h6 w-100 p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{borderBottom:"1px solid var(--primary-color)"},className:"w-100 d-block"},x.name))),x.data.map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(dat).map(function(k,i){if(k==="IMAGE"&&dat[k]!==""){if(props.state.image==="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{onClick:function onClick(){return dat[k]&&props.modalData(dat[k]);},src:""+dat[k],style:{width:" 50px",height:"50px"}}));}}else if(k==="SR No"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.rights.outstandingCustomer.web.edit&&!props.rights.outstandingCustomer.web.view){props.getalertMessage("info","no access");}else{var action=props.rights['outstandingCustomer'].web.edit&&"edit"||props.rights['outstandingCustomer'].web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat[k]._id}).toString();window.open("/Sample"+search,"_blank");// props.history.push("/Sample", {
//     action:
//         (props.rights.outstandingCustomer.web.edit &&
//             "edit") ||
//         (props.rights.outstandingCustomer.web.view &&
//             "view"),
//     _id: dat[k]._id,
//     report: { ...props.state },
//     route: "Report"
// })
}}},dat[k].number));}else if(k==="STYLE NO"||k==="STYLE NAME"){if(k==="STYLE NO"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.rights['outstandingCustomer'].web.edit&&!props.rights['outstandingCustomer'].web.view){props.getalertMessage("info","no access");}else{var action=props.rights['outstandingCustomer'].web.edit&&"edit"||props.rights['outstandingCustomer'].web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat[k]._id}).toString();window.open("/StylePage"+search+"#seleted"+dat[k].code.split("-").join(""),"_blank");// props.history.push(
//     "/StylePage",
//     {
//         action: (props.rights['outstandingCustomer'].web.edit && "edit") || (props.rights['outstandingCustomer'].web.view && "view"),
//         _id: dat[k]._id,
//         hash: `seleted${dat[k].code.split("-").join("")}`,
//         report: { ...props.state },
//         route: "Report"
//     }
// )
}}},dat[k].code));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.rights.outstandingCustomer.web.edit&&!props.rights.outstandingCustomer.web.view){props.getalertMessage("info","no access");}else{var action=props.rights['outstandingCustomer'].web.edit&&"edit"||props.rights['outstandingCustomer'].web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat["STYLE NO"]._id}).toString();window.open("/StylePage"+search+"#seleted"+dat["STYLE NO"].code.split("-").join(""),"_blank");// props.history.push("/StylePage", {
//     action: (props.rights['outstandingCustomer'].web.edit && "edit") || (props.rights['outstandingCustomer'].web.view && "view"),
//     _id: dat["STYLE NO"]._id,
//     hash: `seleted${dat["STYLE NO"].code.split("-").join("")}`,
//     report: props.state,
//     route: "Report"
// }
// )
}}},dat[k]));}}else if(k==="SAMPLE TYPE"){// Apply left alignment when SAMPLE TYPE
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"// Add left alignment class here
,style:{padding:".1rem"},title:setTitle(dat[k],"title")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+changeBg(dat[k])},setTitle(dat[k],"content")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"m-0",style:{padding:".1rem",cursor:alignV(k)&&'pointer'||''},title:setTitle(dat[k],"title")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+changeBg(dat[k]),onClick:function onClick(){if(!props.rights.outstandingCustomer.web.edit&&!props.rights.outstandingCustomer.web.view){props.getalertMessage("info","no access");}else if(alignV(k)){var action=props.rights['outstandingCustomer'].web.edit&&"edit"||props.rights['outstandingCustomer'].web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat['SR No']._id}).toString();window.open("/Sample"+search+"#"+(k==="GRADING"&&'QC'||k),"_blank");// props.history.push("/Sample", {
//     action:
//         (props.rights.outstandingCustomer.web.edit &&
//             "edit") ||
//         (props.rights.outstandingCustomer.web.view &&
//             "view"),
//     _id: dat['SR No']._id,
//     report: { ...props.state },
//     route: "Report",
//     hash: k
// })
}}},setTitle(dat[k],"content")));}}));}));}));}/* harmony default export */ __webpack_exports__["a"] = (CustOutstand);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
function BNumberList(props){var BNumber=function BNumber(data){{var action=props.right.web.edit&&"edit"||props.right.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:data["ID"]// hash: `seleted${data.split("-").join("")}`
}).toString();// window.open(`/StylePage${newSearch}`, "_blank")
window.open("/BNumber"+newSearch,"_blank");};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center",width:"5%"},"S.NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",nowrap:true,width:"10%"},"SUBMISSION DATE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"BNUMBER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"STYLE NO."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"10%"},"COUNT & CONSTRUCTION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"COMPOSITION"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"CUSTOMER-DEPT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"TYPE OF WASH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"FABRIC QUALITY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"TESTING LAB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"TYPE OF TEST"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"CLASSIFICATION OF FABRIC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"FINISHED WIDTH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"GSM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"REPORT STATUS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border",width:"5%"},"COMMENTS")),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["S.No."]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["SUBMISSION DATE"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["BNO"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+data,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return BNumber(data);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["STYLE NO"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["COUNT&CONSTRUCTION"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["COMPOSITION"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"},data["CUSTOMER-DEPT"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["TYPE OF WASH"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["FABRIC QUALITY"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["TESTING LAB"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["TYPE OF TEST"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["CLASSIFICATION OF FABRIC"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["FINISHED WIDTH"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["GSM"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["REPORT STATUS"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data["COMMENTS"])));}));}/* harmony default export */ __webpack_exports__["a"] = (BNumberList);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(305);
var FabricPricePendingList=function FabricPricePendingList(props){var stylePage=function stylePage(listValue){{var action=props.rights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.code.split("-").join("")}).toString();// window.open(`/StylePage${newSearch}`, "_blank")
window.open("/StylePage"+newSearch+"#seleted"+listValue.code.split("-").join(""),"_blank");};};var samplePage=function samplePage(data){var action=props.rights.web.edit&&"edit"||props.rights.web.view&&"view",k=props.processType;var search="?"+new URLSearchParams({action:action,_id:data._id}).toString();window.open("/Sample"+search+"#"+"FABRIC","_blank");};var fabricpage=function fabricpage(data2){var action=props.rights.web.edit&&"edit"||props.rights.web.view&&"view",k=props.processType;var fabricsearch="?"+new URLSearchParams({action:action,_id:data2._id// hash: `seleted${data2.number.split("-").join("")}`
}).toString();window.open("/developmentFabric"+fabricsearch,"_blank");};// console.log(props,"sahsja");
// console.log(props.list[0],"dfuys");
console.log(props,"props");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(props.list[0]).map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue);})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(listValue).map(function(listData){return listData==="SAMPLE REQUEST NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+listValue[listData].number,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return samplePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="STYLE NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="FABRIC NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Fabric Page Of "+listValue[listData].number,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return fabricpage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:listData.trim()==="STYLE NAME"||listData.trim()==="CUST-DEPT"||listData.trim()==="SAMPLE TYPE"?"text-left":""},listValue[listData]);})));}));};/* harmony default export */ __webpack_exports__["a"] = (FabricPricePendingList);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
var DispatchForm=function DispatchForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 mx-auto br-col p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex flex-row justify-content-around"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Dispatched Between"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control w-100"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4",style:{zIndex:1000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"p-3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex flex-row justify-content-around"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Location"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"location",value:props.location,options:props.LOCATION,onChange:props.updateState,disabled:false,className:"w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"Courier"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"courier",value:props.courier,options:props.courierOptions,onChange:props.updateState,disabled:false,className:"w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"text-center"},"AWB Number"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"awbNumber",value:props.awbNumber,onChange:props.updateState,disabled:false,className:"w-100"}))));};/* harmony default export */ __webpack_exports__["a"] = (DispatchForm);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define("ReactDropdownTreeSelect",["react"],t):"object"==typeof exports?exports.ReactDropdownTreeSelect=t(require("react")):e.ReactDropdownTreeSelect=t(e.React)}(this,function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r})},n.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=9)}([function(e,t,n){e.exports=n(15)()},function(t,n){t.exports=e},function(e,t,n){var r;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";var n={}.hasOwnProperty;function o(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var a=typeof r;if("string"===a||"number"===a)e.push(this&&this[r]||r);else if(Array.isArray(r))e.push(o.apply(this,r));else if("object"===a)for(var i in r)n.call(r,i)&&r[i]&&e.push(this&&this[i]||i)}}return e.join(" ")}void 0!==e&&e.exports?(o.default=o,e.exports=o):void 0===(r=function(){return o}.apply(t,[]))||(e.exports=r)}()},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";e.exports=function(e,t){const n=e.filter(t);return 0!==n.length&&n.length!==e.length}},function(e,t,n){var r;r=function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}return n.m=e,n.c=t,n.p="",n(0)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=function(e,t,n){for(var r=!0;r;){var o=e,a=t,i=n;r=!1,null===o&&(o=Function.prototype);var l=Object.getOwnPropertyDescriptor(o,a);if(void 0!==l){if("value"in l)return l.value;var s=l.get;if(void 0===s)return;return s.call(i)}var c=Object.getPrototypeOf(o);if(null===c)return;e=c,t=a,n=i,r=!0,l=c=void 0}};function i(e){return e&&e.__esModule?e:{default:e}}var l=n(8),s=i(l),c=i(n(6)),u=i(n(2)),h=n(1),d=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),a(Object.getPrototypeOf(t.prototype),"constructor",this).call(this),this.state={showLoader:!1,lastScrollTop:0,actionTriggered:!1,pullToRefreshThresholdBreached:!1},this.startY=0,this.currentY=0,this.dragging=!1,this.maxPullDownDistance=0,this.onScrollListener=this.onScrollListener.bind(this),this.throttledOnScrollListener=(0,u.default)(this.onScrollListener,150).bind(this),this.onStart=this.onStart.bind(this),this.onMove=this.onMove.bind(this),this.onEnd=this.onEnd.bind(this),this.getScrollableTarget=this.getScrollableTarget.bind(this)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,l.Component),o(t,[{key:"componentDidMount",value:function(){if(this._scrollableNode=this.getScrollableTarget(),this.el=this.props.height?this._infScroll:this._scrollableNode||window,this.el.addEventListener("scroll",this.throttledOnScrollListener),"number"==typeof this.props.initialScrollY&&this.el.scrollHeight>this.props.initialScrollY&&this.el.scrollTo(0,this.props.initialScrollY),this.props.pullDownToRefresh&&(this.el.addEventListener("touchstart",this.onStart),this.el.addEventListener("touchmove",this.onMove),this.el.addEventListener("touchend",this.onEnd),this.el.addEventListener("mousedown",this.onStart),this.el.addEventListener("mousemove",this.onMove),this.el.addEventListener("mouseup",this.onEnd),this.maxPullDownDistance=this._pullDown.firstChild.getBoundingClientRect().height,this.forceUpdate(),"function"!=typeof this.props.refreshFunction))throw new Error('Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\'')}},{key:"componentWillUnmount",value:function(){this.el.removeEventListener("scroll",this.throttledOnScrollListener),this.props.pullDownToRefresh&&(this.el.removeEventListener("touchstart",this.onStart),this.el.removeEventListener("touchmove",this.onMove),this.el.removeEventListener("touchend",this.onEnd),this.el.removeEventListener("mousedown",this.onStart),this.el.removeEventListener("mousemove",this.onMove),this.el.removeEventListener("mouseup",this.onEnd))}},{key:"componentWillReceiveProps",value:function(e){this.props.dataLength!==e.dataLength&&this.setState({showLoader:!1,actionTriggered:!1,pullToRefreshThresholdBreached:!1})}},{key:"getScrollableTarget",value:function(){return this.props.scrollableTarget instanceof HTMLElement?this.props.scrollableTarget:"string"==typeof this.props.scrollableTarget?document.getElementById(this.props.scrollableTarget):(null===this.props.scrollableTarget&&console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      "),null)}},{key:"onStart",value:function(e){this.state.lastScrollTop||(this.dragging=!0,this.startY=e.pageY||e.touches[0].pageY,this.currentY=this.startY,this._infScroll.style.willChange="transform",this._infScroll.style.transition="transform 0.2s cubic-bezier(0,0,0.31,1)")}},{key:"onMove",value:function(e){this.dragging&&(this.currentY=e.pageY||e.touches[0].pageY,this.currentY<this.startY||(this.currentY-this.startY>=this.props.pullDownToRefreshThreshold&&this.setState({pullToRefreshThresholdBreached:!0}),this.currentY-this.startY>1.5*this.maxPullDownDistance||(this._infScroll.style.overflow="visible",this._infScroll.style.transform="translate3d(0px, "+(this.currentY-this.startY)+"px, 0px)")))}},{key:"onEnd",value:function(e){var t=this;this.startY=0,this.currentY=0,this.dragging=!1,this.state.pullToRefreshThresholdBreached&&this.props.refreshFunction&&this.props.refreshFunction(),requestAnimationFrame(function(){t._infScroll.style.overflow="auto",t._infScroll.style.transform="none",t._infScroll.style.willChange="none"})}},{key:"isElementAtBottom",value:function(e){var t=arguments.length<=1||void 0===arguments[1]?.8:arguments[1],n=e===document.body||e===document.documentElement?window.screen.availHeight:e.clientHeight,r=(0,h.parseThreshold)(t);return r.unit===h.ThresholdUnits.Pixel?e.scrollTop+n>=e.scrollHeight-r.value:e.scrollTop+n>=r.value/100*e.scrollHeight}},{key:"onScrollListener",value:function(e){var t=this;"function"==typeof this.props.onScroll&&setTimeout(function(){return t.props.onScroll(e)},0);var n=this.props.height||this._scrollableNode?e.target:document.documentElement.scrollTop?document.documentElement:document.body;this.state.actionTriggered||(this.isElementAtBottom(n,this.props.scrollThreshold)&&this.props.hasMore&&(this.setState({actionTriggered:!0,showLoader:!0}),this.props.next()),this.setState({lastScrollTop:n.scrollTop}))}},{key:"render",value:function(){var e=this,t=r({height:this.props.height||"auto",overflow:"auto",WebkitOverflowScrolling:"touch"},this.props.style),n=this.props.hasChildren||!(!this.props.children||!this.props.children.length),o=this.props.pullDownToRefresh&&this.props.height?{overflow:"auto"}:{};return s.default.createElement("div",{style:o},s.default.createElement("div",{className:"infinite-scroll-component",ref:function(t){return e._infScroll=t},style:t},this.props.pullDownToRefresh&&s.default.createElement("div",{style:{position:"relative"},ref:function(t){return e._pullDown=t}},s.default.createElement("div",{style:{position:"absolute",left:0,right:0,top:-1*this.maxPullDownDistance}},!this.state.pullToRefreshThresholdBreached&&this.props.pullDownToRefreshContent,this.state.pullToRefreshThresholdBreached&&this.props.releaseToRefreshContent)),this.props.children,!this.state.showLoader&&!n&&this.props.hasMore&&this.props.loader,this.state.showLoader&&this.props.hasMore&&this.props.loader,!this.props.hasMore&&this.props.endMessage))}}]),t}();t.default=d,d.defaultProps={pullDownToRefreshContent:s.default.createElement("h3",null,"Pull down to refresh"),releaseToRefreshContent:s.default.createElement("h3",null,"Release to refresh"),pullDownToRefreshThreshold:100,disableBrowserPullToRefresh:!0},d.propTypes={next:c.default.func,hasMore:c.default.bool,children:c.default.node,loader:c.default.node.isRequired,scrollThreshold:c.default.oneOfType([c.default.number,c.default.string]),endMessage:c.default.node,style:c.default.object,height:c.default.number,scrollableTarget:c.default.node,hasChildren:c.default.bool,pullDownToRefresh:c.default.bool,pullDownToRefreshContent:c.default.node,releaseToRefreshContent:c.default.node,pullDownToRefreshThreshold:c.default.number,refreshFunction:c.default.func,onScroll:c.default.func,dataLength:c.default.number.isRequired},e.exports=t.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.parseThreshold=function(e){if("number"==typeof e)return{unit:n.Percent,value:100*e};if("string"==typeof e)return e.match(/^(\d*(.\d+)?)px$/)?{unit:n.Pixel,value:parseFloat(e)}:e.match(/^(\d*(.\d+)?)%$/)?{unit:n.Percent,value:parseFloat(e)}:(console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'),r);return console.warn("scrollThreshold should be string or number"),r};var n={Pixel:"Pixel",Percent:"Percent"};t.ThresholdUnits=n;var r={unit:n.Percent,value:.8}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n){var r,o;return t||(t=250),function(){var a=n||this,i=+new Date,l=arguments;r&&i<r+t?(clearTimeout(o),o=setTimeout(function(){r=i,e.apply(a,l)},t)):(r=i,e.apply(a,l))}},e.exports=t.default},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";var r=function(e){};e.exports=function(e,t,n,o,a,i,l,s){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,o,a,i,l,s],h=0;(c=new Error(t.replace(/%s/g,function(){return u[h++]}))).name="Invariant Violation"}throw c.framesToPop=1,c}}},function(e,t,n){"use strict";var r=n(3),o=n(4),a=n(7);e.exports=function(){function e(e,t,n,r,i,l){l!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){e.exports=n(5)()},function(e,t){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,n){t.exports=e}])},e.exports=r(n(1))},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";n.r(t);var r,o,a,i=n(2),l=n.n(i),s=n(0),c=n.n(s),u=n(1),h=n.n(u),d=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Object.keys(e).reduce(function(t,n){var r;return t["data-"+(r=n,r.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())]=e[n],t},{})},p=(function(){}(),function(e){return!e||Array.isArray(e)&&!e.length}),f=function(e,t){return e instanceof Event&&!function(e){if(e.path)return e.path;for(var t=e.target,n=[t];t.parentElement;)t=t.parentElement,n.unshift(t);return n}(e).some(function(e){return e===t})},g=function(e,t){var n=void 0;return function(){for(var r=arguments.length,o=Array(r),a=0;a<r;a++)o[a]=arguments[a];var i=!n;clearTimeout(n),n=setTimeout(function(){n=null,e.apply(void 0,o)},t),i&&e.apply(void 0,o)}},y=(r="rdts",o=1,a=new WeakMap,{get:function(e){return a.has(e)||a.set(e,o++),""+r+a.get(e)},reset:function(){a=new WeakMap,o=1}}),b=n(8),v=n.n(b),m=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function w(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var O=l.a.bind(v.a),k=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=w(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.handleClick=function(e){var t=r.props,n=t.id,o=t.onDelete;e.stopPropagation(),e.nativeEvent.stopImmediatePropagation(),o(n,void 0!==(e.key||e.keyCode))},r.onKeyDown=function(e){"Backspace"===e.key&&(r.handleClick(e),e.preventDefault())},r.onKeyUp=function(e){(32===e.keyCode||["Delete","Enter"].indexOf(e.key)>-1)&&(r.handleClick(e),e.preventDefault())},w(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),m(t,[{key:"render",value:function(){var e=this.props,t=e.id,n=e.label,r=e.labelRemove,o=void 0===r?"Remove":r,a=e.readOnly,i=e.disabled,l=t+"_tag",s=O("tag-remove",{readOnly:a},{disabled:i}),c=a||i,u=c?void 0:this.handleClick,d=c?void 0:this.onKeyDown,p=c?void 0:this.onKeyUp;return h.a.createElement("span",{className:O("tag"),id:l},n,h.a.createElement("button",{onClick:u,onKeyDown:d,onKeyUp:p,className:s,type:"button","aria-label":o,"aria-labelledby":l,"aria-disabled":c},"x"))}}]),t}();k.propTypes={id:c.a.string.isRequired,label:c.a.string.isRequired,onDelete:c.a.func,readOnly:c.a.bool,disabled:c.a.bool,labelRemove:c.a.string};var T=k,_=n(7),P=n.n(_);function S(e){if(e)return e&&"#"===e[0]?{"aria-labelledby":e.replace(/#/g,"")}:{"aria-label":e}}var C=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),E=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};var x=l.a.bind(P.a),N=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleInputChange=function(e){e.persist(),n.delayedCallback(e)},n.delayedCallback=g(function(e){return n.props.onInputChange(e.target.value)},300),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),C(t,[{key:"render",value:function(){var e=this.props,t=e.tags,n=e.onTagRemove,r=e.inputRef,o=e.placeholderText,a=void 0===o?"Choose...":o,i=e.onFocus,l=e.onBlur,s=e.disabled,c=e.readOnly,u=e.onKeyDown,p=e.activeDescendant,f=e.label,g=e.labelRemove;return h.a.createElement("ul",{className:x("tag-list")},function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments[1],n=arguments[2],r=arguments[3],o=arguments[4];return e.map(function(e){var a=e._id,i=e.label,l=e.tagClassName,s=e.dataset;return h.a.createElement("li",E({className:x("tag-item",l),key:"tag-item-"+a},d(s)),h.a.createElement(T,{label:i,id:a,onDelete:t,readOnly:n,disabled:r,labelRemove:o}))})}(t,n,c,s,g),h.a.createElement("li",{className:x("tag-item")},h.a.createElement("input",E({type:"text",disabled:s,ref:r,className:x("search"),placeholder:a,onKeyDown:u,onChange:this.handleInputChange,onFocus:i,onBlur:l,readOnly:c,"aria-activedescendant":p,"aria-autocomplete":u?"list":void 0},S(f)))))}}]),t}();N.propTypes={tags:c.a.array,placeholderText:c.a.string,onInputChange:c.a.func,onFocus:c.a.func,onBlur:c.a.func,onTagRemove:c.a.func,onKeyDown:c.a.func,inputRef:c.a.func,disabled:c.a.bool,readOnly:c.a.bool,activeDescendant:c.a.string,label:c.a.string,labelRemove:c.a.string};var j=N,D=n(4),R=n.n(D),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},M=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function A(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var F=l.a.bind(R.a),L=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=A(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.getAriaAttributes=function(){var e=r.props,t=e.simpleSelect,n=e.label,o=e.showDropdown;return I({role:"button",tabIndex:0,"aria-haspopup":t?"listbox":"tree","aria-expanded":o?"true":"false"},S(n))},r.handleTrigger=function(e){e.key&&13!==e.keyCode&&32!==e.keyCode&&40!==e.keyCode||e.key&&r.triggerNode&&r.triggerNode!==document.activeElement||(r.props.showDropdown||32!==e.keyCode||e.preventDefault(),r.props.onTrigger(e))},A(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),M(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.disabled,r=t.readOnly,o=t.showDropdown,a=F({"dropdown-trigger":!0,arrow:!0,disabled:n,readOnly:r,top:o,bottom:!o});return h.a.createElement("a",I({ref:function(t){e.triggerNode=t},className:a,onClick:n?void 0:this.handleTrigger,onKeyDown:n?void 0:this.handleTrigger},this.getAriaAttributes()),this.props.children)}}]),t}();L.propTypes={onTrigger:c.a.func,disabled:c.a.bool,readOnly:c.a.bool,showDropdown:c.a.bool,label:c.a.string};var B=L,V=n(6),Y=n.n(V),K=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function q(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var H=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=q(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.handleClick=function(){r.props.onAction(r.props.actionData)},q(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),K(t,[{key:"render",value:function(){var e=this.props,t=e.title,n=e.className,r=e.text,o=e.readOnly;return h.a.createElement("i",{title:t,className:n,onClick:o?void 0:this.handleClick},r)}}]),t}();H.propTypes={title:c.a.string,text:c.a.string,className:c.a.string,actionData:c.a.object,onAction:c.a.func,readOnly:c.a.bool},H.defaultProps={onAction:function(){}};var U=H,W=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},z=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var $=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),z(t,[{key:"render",value:function(){var e=this.props,t=e.actions,n=e.id,r=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["actions","id"]);return p(t)?null:t.map(function(e,t){var o=e.id||"action-"+t;return h.a.createElement(U,W({key:o},r,e,{actionData:{action:o,id:n}}))})}}]),t}();$.propTypes={id:c.a.string.isRequired,actions:c.a.array};var J=$,Z=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},G=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var Q=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),G(t,[{key:"render",value:function(){var e=this.props,t=e.checked,n=e.indeterminate,r=void 0!==n&&n,o=e.onChange,a=e.disabled,i=e.readOnly,l=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["checked","indeterminate","onChange","disabled","readOnly"]),s=a||i;return h.a.createElement("input",Z({type:"checkbox",ref:function(e){var t=e.checked,n=e.indeterminate;return function(e){e&&(e.checked=t,e.indeterminate=n)}}({checked:t,indeterminate:r}),onChange:o,disabled:s},l))}}]),t}();Q.propTypes={checked:c.a.bool,indeterminate:c.a.bool,onChange:c.a.func,disabled:c.a.bool,readOnly:c.a.bool};var X=Q,ee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},te=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var ne=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),te(t,[{key:"render",value:function(){var e=this.props,t=e.name,n=e.checked,r=e.onChange,o=e.disabled,a=e.readOnly,i=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["name","checked","onChange","disabled","readOnly"]),l=o||a;return h.a.createElement("input",ee({type:"radio",name:t,ref:function(e){var t=e.checked;return function(e){e&&(e.checked=t)}}({checked:n}),onChange:r,disabled:l},i))}}]),t}();ne.propTypes={name:c.a.string.isRequired,checked:c.a.bool,onChange:c.a.func,disabled:c.a.bool,readOnly:c.a.bool};var re=ne,oe=n(3),ae=n.n(oe),ie=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},le=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function se(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var ce=l.a.bind(ae.a),ue=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=se(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.handleCheckboxChange=function(e){var t=r.props,n=t.simpleSelect,o=t.radioSelect,a=t.id,i=t.onCheckboxChange;n||o?i(a,!0):i(a,e.target.checked);e.stopPropagation(),e.nativeEvent.stopImmediatePropagation()},se(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),le(t,[{key:"render",value:function(){var e=this.props,t=e.simpleSelect,n=e.radioSelect,r=e.title,o=e.label,a=e.id,i=e.partial,l=e.checked,s=this.props,c=s.value,u=s.disabled,d=s.showPartiallySelected,p=s.readOnly,f=s.clientId,g={className:"node-label"};t&&!p&&!u&&(g.onClick=this.handleCheckboxChange);var y={id:a,value:c,checked:l,disabled:u,readOnly:p,tabIndex:-1};return h.a.createElement("label",{title:r||o,htmlFor:a},n?h.a.createElement(re,ie({name:f,className:"radio-item",onChange:this.handleCheckboxChange},y)):h.a.createElement(X,ie({name:a,className:ce("checkbox-item",{"simple-select":t}),indeterminate:d&&i,onChange:this.handleCheckboxChange},y)),h.a.createElement("span",g,o))}}]),t}();ue.propTypes={id:c.a.string.isRequired,actions:c.a.array,title:c.a.string,label:c.a.string.isRequired,value:c.a.string.isRequired,checked:c.a.bool,partial:c.a.bool,disabled:c.a.bool,dataset:c.a.object,simpleSelect:c.a.bool,radioSelect:c.a.bool,showPartiallySelected:c.a.bool,onCheckboxChange:c.a.func,readOnly:c.a.bool,clientId:c.a.string};var he=ue,de=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function pe(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var fe=l.a.bind(ae.a),ge=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=pe(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.onToggle=function(e){e.stopPropagation(),e.nativeEvent.stopImmediatePropagation(),r.props.onNodeToggle(r.props.id)},r.onKeyDown=function(e){"Enter"!==e.key&&32!==e.keyCode||(r.props.onNodeToggle(r.props.id),e.preventDefault())},pe(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),de(t,[{key:"render",value:function(){var e=this.props,t=e.expanded;if(e.isLeaf)return null;var n=fe("toggle",{expanded:t,collapsed:!t});return h.a.createElement("i",{role:"button",tabIndex:-1,className:n,onClick:this.onToggle,onKeyDown:this.onKeyDown,"aria-hidden":!0})}}]),t}();ge.propTypes={expanded:c.a.bool,isLeaf:c.a.bool,onNodeToggle:c.a.func,id:c.a.string};var ye=ge,be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ve=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function me(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var we=l.a.bind(ae.a),Oe=function(e){return p(e)},ke=function(e){function t(){var e,n,r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];return n=r=me(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(a))),r.getAriaAttributes=function(){var e=r.props,t=e._children,n=e._depth,o=e.checked,a=e.disabled,i=e.expanded,l=e.readOnly,s=e.simpleSelect,c=e.partial,u={};return u.role=s?"option":"treeitem",u["aria-disabled"]=a||l,u["aria-selected"]=o,s||(u["aria-checked"]=c?"mixed":o,u["aria-level"]=(n||0)+1,u["aria-expanded"]=t&&(i?"true":"false")),u},me(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["PureComponent"]),ve(t,[{key:"render",value:function(){var e=this.props,t=e.simpleSelect,n=e.radioSelect,r=e.keepTreeOnSearch,o=e._id,a=e._children,i=e.dataset,l=e._depth,s=e.expanded,c=e.title,u=e.label,p=e.partial,f=e.checked,g=e.value,y=e.disabled,b=e.actions,v=e.onAction,m=e.searchModeOn,w=e.onNodeToggle,O=e.onCheckboxChange,k=e.showPartiallySelected,T=e.readOnly,_=e.clientId,P=function(e){var t=e.keepTreeOnSearch,n=e.keepChildrenOnSearch,r=e._children,o=e.matchInChildren,a=e.matchInParent,i=e.disabled,l=e.partial,s=e.hide,c=e.className,u=e.showPartiallySelected,h=e.readOnly,d=e.checked,p=e._focused;return we("node",{leaf:Oe(r),tree:!Oe(r),disabled:i,hide:s,"match-in-children":t&&o,"match-in-parent":t&&n&&a,partial:u&&l,readOnly:h,checked:d,focused:p},c)}(this.props),S=r||!m?{paddingLeft:20*(l||0)+"px"}:{},C=o+"_li";return h.a.createElement("li",be({className:P,style:S,id:C},d(i),this.getAriaAttributes()),h.a.createElement(ye,{isLeaf:Oe(a),expanded:s,id:o,onNodeToggle:w}),h.a.createElement(he,{title:c,label:u,id:o,partial:p,checked:f,value:g,disabled:y,simpleSelect:t,radioSelect:n,onCheckboxChange:O,showPartiallySelected:k,readOnly:T,clientId:_}),h.a.createElement(J,{actions:b,onAction:v,id:o,readOnly:T}))}}]),t}();ke.propTypes={_id:c.a.string.isRequired,_depth:c.a.number,_children:c.a.array,actions:c.a.array,className:c.a.string,title:c.a.string,label:c.a.string.isRequired,value:c.a.string.isRequired,checked:c.a.bool,expanded:c.a.bool,disabled:c.a.bool,partial:c.a.bool,dataset:c.a.object,keepTreeOnSearch:c.a.bool,keepChildrenOnSearch:c.a.bool,searchModeOn:c.a.bool,onNodeToggle:c.a.func,onAction:c.a.func,onCheckboxChange:c.a.func,simpleSelect:c.a.bool,radioSelect:c.a.bool,showPartiallySelected:c.a.bool,readOnly:c.a.bool,clientId:c.a.string};var Te=ke,_e=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Pe=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var Se=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return Ce.call(n),n.computeInstanceProps(e),n.state={items:n.allVisibleNodes.slice(0,n.props.pageSize)},n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["Component"]),Pe(t,[{key:"render",value:function(){var e=this.props.searchModeOn;return h.a.createElement("ul",_e({className:"root "+(e?"searchModeOn":""),ref:this.setNodeRef},this.getAriaAttributes()),this.state.scrollableTarget&&h.a.createElement(Y.a,{dataLength:this.state.items.length,next:this.loadMore,hasMore:this.hasMore(),loader:h.a.createElement("span",{className:"searchLoader"},"Loading..."),scrollableTarget:this.state.scrollableTarget},this.state.items))}}]),t}();Se.propTypes={data:c.a.object,keepTreeOnSearch:c.a.bool,keepChildrenOnSearch:c.a.bool,searchModeOn:c.a.bool,onChange:c.a.func,onNodeToggle:c.a.func,onAction:c.a.func,onCheckboxChange:c.a.func,simpleSelect:c.a.bool,radioSelect:c.a.bool,showPartiallySelected:c.a.bool,pageSize:c.a.number,readOnly:c.a.bool,clientId:c.a.string,activeDescendant:c.a.string},Se.defaultProps={pageSize:100};var Ce=function(){var e=this;this.componentWillReceiveProps=function(t){e.computeInstanceProps(t),e.setState({items:e.allVisibleNodes.slice(0,e.currentPage*e.props.pageSize)},function(){var n=t.activeDescendant,r=e.state.scrollableTarget,o=n&&document&&document.getElementById(n);o&&r&&(r.scrollTop=o.offsetTop-(r.clientHeight-o.clientHeight)/2)})},this.componentDidMount=function(){e.setState({scrollableTarget:e.node.parentNode})},this.computeInstanceProps=function(t){if(e.allVisibleNodes=e.getNodes(t),e.totalPages=Math.ceil(e.allVisibleNodes.length/e.props.pageSize),t.activeDescendant){var n=t.activeDescendant.replace(/_li$/,""),r=e.allVisibleNodes.findIndex(function(e){return e.key===n})+1;e.currentPage=r>0?Math.ceil(r/e.props.pageSize):1}else e.currentPage=1},this.getNodes=function(e){var t=e.data,n=e.keepTreeOnSearch,r=e.keepChildrenOnSearch,o=e.searchModeOn,a=e.simpleSelect,i=e.radioSelect,l=e.showPartiallySelected,s=e.readOnly,c=e.onAction,u=e.onChange,d=e.onCheckboxChange,p=e.onNodeToggle,f=e.activeDescendant,g=e.clientId,y=[];return t.forEach(function(e){(function(e,t,n){if(t||e.expanded)return!0;var r=e._parent&&n.get(e._parent);return!r||r.expanded})(e,o,t)&&y.push(h.a.createElement(Te,_e({keepTreeOnSearch:n,keepChildrenOnSearch:r,key:e._id},e,{searchModeOn:o,onChange:u,onCheckboxChange:d,onNodeToggle:p,onAction:c,simpleSelect:a,radioSelect:i,showPartiallySelected:l,readOnly:s,clientId:g,activeDescendant:f})))}),y},this.hasMore=function(){return e.currentPage<e.totalPages},this.loadMore=function(){e.currentPage=e.currentPage+1;var t=e.allVisibleNodes.slice(0,e.currentPage*e.props.pageSize);e.setState({items:t})},this.setNodeRef=function(t){e.node=t},this.getAriaAttributes=function(){var t=e.props,n=t.readOnly,r=t.simpleSelect,o={};return o.role=r?"listbox":"tree",o["aria-multiselectable"]=r?"false":"true",o["aria-readonly"]=n?"true":"false",o}},Ee=Se,xe=n(5),Ne=n.n(xe),je=function(e){return e},De=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"children",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:je;return Ne()(e[t],function(e){return n(e).checked})||e[t].some(function(e){return n(e).partial})};var Re=function(e){var t=e.tree,n=e.simple,r=e.radio,o=e.showPartialState,a=e.hierarchical,i=e.rootPrefixId;return function e(t){var n=t.nodes,r=t.parent,o=t.depth,a=void 0===o?0:o,i=t.simple,l=t.radio,s=t.showPartialState,c=t.hierarchical,u=t.rootPrefixId,h=t._rv,d=void 0===h?{list:new Map,defaultValues:[],singleSelectedNode:null}:h,f=i||l;return n.forEach(function(t,n){t._depth=a,r?(t._id=t.id||r._id+"-"+n,t._parent=r._id,r._children.push(t._id)):t._id=t.id||""+(u?u+"-"+n:n),f&&t.checked&&(d.singleSelectedNode?t.checked=!1:d.singleSelectedNode=t),f&&t.isDefaultValue&&d.singleSelectedNode&&!d.singleSelectedNode.isDefaultValue&&(d.singleSelectedNode.checked=!1,d.singleSelectedNode=null),!t.isDefaultValue||f&&0!==d.defaultValues.length||(d.defaultValues.push(t._id),t.checked=!0,f&&(d.singleSelectedNode=t)),c&&!l||function(e){for(var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]&&!arguments[2]?["disabled"]:["checked","disabled"],r=0;r<n.length;r++){var o=n[r];void 0===e[o]&&void 0!==t[o]&&(e[o]=t[o])}}(t,r,!l),d.list.set(t._id,t),!i&&t.children&&(t._children=[],e({nodes:t.children,parent:t,depth:a+1,radio:l,showPartialState:s,hierarchical:c,_rv:d}),s&&!t.checked&&(t.partial=De(t),f||p(t.children)||!t.children.every(function(e){return e.checked})||(t.checked=!0)),t.children=void 0)}),d}({nodes:Array.isArray(t)?t:[t],simple:n,radio:r,showPartialState:o,hierarchical:a,rootPrefixId:i})},Ie=function e(t,n,r){n[t._id]=!0,p(t._children)||t._children.forEach(function(t){return e(r(t),n,r)})},Me=function(e,t){var n=[],r={};return e.forEach(function(e,o){r[o]||(t(e,o,r)&&n.push(e),r[o]=!0)}),n},Ae={getNodesMatching:Me,getVisibleNodes:function(e,t,n){return Me(e,function(e,r,o){return n&&e._children&&e._children.length&&!0!==e.expanded&&Ie(e,o,t),!e.hide})},markSubTreeVisited:Ie},Fe=function(){return function(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return function(e,t){var n=[],r=!0,o=!1,a=void 0;try{for(var i,l=e[Symbol.iterator]();!(r=(i=l.next()).done)&&(n.push(i.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{!r&&l.return&&l.return()}finally{if(o)throw a}}return n}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),Le="ArrowUp",Be="ArrowDown",Ve="ArrowLeft",Ye="ArrowRight",Ke="Enter",qe="Home",He="PageUp",Ue="End",We="PageDown",ze={None:"None",FocusPrevious:"FocusPrevious",FocusNext:"FocusNext",FocusParent:"FocusParent",FocusFirst:"FocusFirst",FocusLast:"FocusLast",ToggleExpanded:"ToggleExpanded",ToggleChecked:"ToggleChecked"},$e=new Set([ze.FocusPrevious,ze.FocusNext,ze.FocusParent,ze.FocusFirst,ze.FocusLast]),Je=[Le,Be,qe,He,Ue,We],Ze=Je.concat([Ve,Ye,Ke]),Ge=function(e,t,n,r){return t.indexOf(e)>-1||!n&&e===r},Qe=function(e,t,n){if(!e||0===e.length)return t;var r=t;(function(e){return Ge(e,[ze.FocusFirst,ze.FocusLast],!0)})(n)?r=Fe(e,1)[0]:[ze.FocusPrevious,ze.FocusNext].indexOf(n)>-1&&(r=function(e,t){var n=e.indexOf(t)+1;return n%e.length==0?e[0]:e[n]}(e,t));return r},Xe={isValidKey:function(e,t){return(t?Ze:Je).indexOf(e)>-1},getAction:function(e,t){return t===Ve?function(e,t){return e&&t===Ve?!0===e.expanded?ze.ToggleExpanded:e._parent?ze.FocusParent:ze.None:ze.None}(e,t):t===Ye?function(e,t){return e&&e._children&&t===Ye?!0!==e.expanded?ze.ToggleExpanded:ze.FocusNext:ze.None}(e,t):function(e,t){return Ge(e,[qe,He],t,Be)}(t,e)?ze.FocusFirst:function(e,t){return Ge(e,[Ue,We],t,Le)}(t,e)?ze.FocusLast:function(e,t){if(!e)return ze.None;switch(t){case Le:return ze.FocusPrevious;case Be:return ze.FocusNext;case Ke:return ze.ToggleChecked;default:return ze.None}}(e,t)},getNextFocus:function(e,t,n,r,o){if(n===ze.FocusParent)return function(e,t){return e&&e._parent?t(e._parent):e}(t,r);if(!$e.has(n))return t;var a=Ae.getVisibleNodes(e,r,o);return function(e){return Ge(e,[ze.FocusPrevious,ze.FocusLast],!0)}(n)&&(a=a.reverse()),Qe(a,t,n)},getNextFocusAfterTagDelete:function(e,t,n,r){var o=t&&t.findIndex(function(t){return t._id===e});if(o<0||!n.length)return r;var a=n[o=n.length>o?o:n.length-1]._id,i=document.getElementById(a+"_tag");return i&&i.firstElementChild||r},handleFocusNavigationkey:function(e,t,n,r,o){var a=Xe.getNextFocus(e,n,t,r,o);return n&&a&&n._id!==a._id&&(n._focused=!1),a?(a._focused=!0,a._id):n&&n._id},handleToggleNavigationkey:function(e,t,n,r,o){return e!==ze.ToggleChecked||n||t.readOnly||t.disabled?e===ze.ToggleExpanded&&o(t._id):r(t._id,!0!==t.checked),t&&t._id}},et=Xe,tt=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var nt=function(){function e(t){var n=t.data,r=t.simpleSelect,o=t.radioSelect,a=t.showPartiallySelected,i=t.hierarchical,l=t.rootPrefixId;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._src=n;var s=Re({tree:JSON.parse(JSON.stringify(n)),simple:r,radio:o,showPartialState:a,hierarchical:i,rootPrefixId:l}),c=s.list,u=s.defaultValues,h=s.singleSelectedNode;this.tree=c,this.defaultValues=u,this.simpleSelect=r,this.radioSelect=o,this.showPartialState=!i&&a,this.searchMaps=new Map,this.hierarchical=i,(r||o)&&h&&(this.currentChecked=h._id)}return tt(e,[{key:"getNodeById",value:function(e){return this.tree.get(e)}},{key:"getMatches",value:function(e){var t=this;if(this.searchMaps.has(e))return this.searchMaps.get(e);var n=-1,r=e;this.searchMaps.forEach(function(t,o){e.startsWith(o)&&o.length>n&&(n=o.length,r=o)});var o=[],a=function(t){t.label.toLowerCase().indexOf(e)>=0&&o.push(t._id)};r!==e?this.searchMaps.get(r).forEach(function(e){return a(t.getNodeById(e))}):this.tree.forEach(a);return this.searchMaps.set(e,o),o}},{key:"addParentsToTree",value:function(e,t){if(void 0!==e){var n=this.getNodeById(e);this.addParentsToTree(n._parent,t),n.hide=!0,n.matchInChildren=!0,t.set(e,n)}}},{key:"addChildrenToTree",value:function(e,t,n){var r=this;void 0!==e&&e.forEach(function(e){if(!n||!n.includes(e)){var o=r.getNodeById(e);o.matchInParent=!0,t.set(e,o),r.addChildrenToTree(o._children,t)}})}},{key:"filterTree",value:function(e,t,n){var r=this,o=this.getMatches(e.toLowerCase()),a=new Map;o.forEach(function(e){var i=r.getNodeById(e);i.hide=!1,t&&r.addParentsToTree(i._parent,a),a.set(e,i),t&&n&&r.addChildrenToTree(i._children,a,o)});var i=0===o.length;return this.matchTree=a,{allNodesHidden:i,tree:a}}},{key:"restoreNodes",value:function(){return this.tree.forEach(function(e){e.hide=!1}),this.tree}},{key:"restoreDefaultValues",value:function(){var e=this;return this.defaultValues.forEach(function(t){e.setNodeCheckedState(t,!0)}),this.tree}},{key:"togglePreviousChecked",value:function(e,t){var n=this.currentChecked;n&&n!==e&&(this.getNodeById(n).checked=!1),this.currentChecked=t?e:null}},{key:"setNodeCheckedState",value:function(e,t){var n=this.getNodeById(e);n.checked=t,this.showPartialState&&(n.partial=!1),this.simpleSelect?this.togglePreviousChecked(e,t):this.radioSelect?(this.togglePreviousChecked(e,t),this.showPartialState&&this.partialCheckParents(n),t||this.unCheckParents(n)):(this.hierarchical||this.toggleChildren(e,t),this.showPartialState&&this.partialCheckParents(n),this.hierarchical||t||this.unCheckParents(n))}},{key:"unCheckParents",value:function(e){for(var t=e._parent;t;){var n=this.getNodeById(t);n.checked=!1,n.partial=De(n,"_children",this.getNodeById.bind(this)),t=n._parent}}},{key:"partialCheckParents",value:function(e){for(var t=this,n=e._parent;n;){var r=this.getNodeById(n);r.checked=r._children.every(function(e){return t.getNodeById(e).checked}),r.partial=De(r,"_children",this.getNodeById.bind(this)),n=r._parent}}},{key:"toggleChildren",value:function(e,t){var n=this,r=this.getNodeById(e);r.checked=t,this.showPartialState&&(r.partial=!1),p(r._children)||r._children.forEach(function(e){return n.toggleChildren(e,t)})}},{key:"toggleNodeExpandState",value:function(e){var t=this.getNodeById(e);return t.expanded=!t.expanded,t.expanded||this.collapseChildren(t),this.tree}},{key:"collapseChildren",value:function(e){var t=this;e.expanded=!1,p(e._children)||e._children.forEach(function(e){return t.collapseChildren(t.getNodeById(e))})}},{key:"getTreeAndTags",value:function(){return{tree:this.tree,tags:this.tags}}},{key:"handleNavigationKey",value:function(e,t,n,r,o,a,i){var l=this,s=e&&this.getNodeById(e),c=et.getAction(s,n);return $e.has(c)?et.handleFocusNavigationkey(t,c,s,function(e){return l.getNodeById(e)},o):s&&t.has(s._id)?et.handleToggleNavigationkey(c,s,r,a,i):e}},{key:"tags",get:function(){var e=this;return this.radioSelect||this.simpleSelect?this.currentChecked?[this.getNodeById(this.currentChecked)]:[]:Ae.getNodesMatching(this.tree,function(t,n,r){return t.checked&&!e.hierarchical&&Ae.markSubTreeVisited(t,r,function(t){return e.getNodeById(t)}),t.checked})}}]),e}(),rt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ot=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();
/*!
 * React Dropdown Tree Select
 * A lightweight, fast and highly customizable tree select component.
 * Hrusikesh Panda <hrusikesh.panda@dowjones.com>
 * Copyright (c) 2017 Dow Jones, Inc. <support@dowjones.com> (http://dowjones.com)
 * license MIT
 * see https://github.com/dowjones/react-dropdown-tree-select
 */
var at=l.a.bind(R.a),it=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.initNewProps=function(e){var t=e.data,r=e.simpleSelect,o=e.radioSelect,a=e.showPartiallySelected,i=e.hierarchical;n.treeManager=new nt({data:t,simpleSelect:r,radioSelect:o,showPartiallySelected:a,hierarchical:i,rootPrefixId:n.clientId});var l=n.state.currentFocus&&n.treeManager.getNodeById(n.state.currentFocus);l&&(l._focused=!0),n.setState(n.treeManager.getTreeAndTags())},n.resetSearchState=function(){return n.searchInput.value="",{tree:n.treeManager.restoreNodes(),searchModeOn:!1,allNodesHidden:!1}},n.handleClick=function(e,t){n.setState(function(e){var t=n.props.showDropdownAlways||n.keepDropdownActive||!e.showDropdown;return t!==e.showDropdown&&(t?document.addEventListener("click",n.handleOutsideClick,!1):document.removeEventListener("click",n.handleOutsideClick,!1)),t?n.props.onFocus():n.props.onBlur(),t?{showDropdown:t}:rt({showDropdown:t},n.resetSearchState())},t)},n.handleOutsideClick=function(e){!n.props.showDropdownAlways&&f(e,n.node)&&n.handleClick()},n.onInputChange=function(e){var t=n.treeManager.filterTree(e,n.props.keepTreeOnSearch,n.props.keepChildrenOnSearch),r=t.allNodesHidden,o=t.tree,a=e.length>0;n.setState({tree:o,searchModeOn:a,allNodesHidden:r})},n.onTagRemove=function(e,t){var r=n.state.tags;n.onCheckboxChange(e,!1,function(o){t&&et.getNextFocusAfterTagDelete(e,r,o,n.searchInput).focus()})},n.onNodeToggle=function(e){n.treeManager.toggleNodeExpandState(e);var t=n.state.searchModeOn?n.treeManager.matchTree:n.treeManager.tree;n.setState({tree:t}),"function"==typeof n.props.onNodeToggle&&n.props.onNodeToggle(n.treeManager.getNodeById(e))},n.onCheckboxChange=function(e,t,r){var o=n.props,a=o.simpleSelect,i=o.radioSelect,l=o.keepOpenOnSelect;n.treeManager.setNodeCheckedState(e,t);var s=n.treeManager.tags,c=a||i,u=!(c&&!l)&&n.state.showDropdown;s.length||(n.treeManager.restoreDefaultValues(),s=n.treeManager.tags);var h={tree:n.state.searchModeOn?n.treeManager.matchTree:n.treeManager.tree,tags:s,showDropdown:u};(c&&!u||n.props.clearSearchOnChange)&&Object.assign(h,n.resetSearchState()),c&&!u&&document.removeEventListener("click",n.handleOutsideClick,!1),n.setState(h,function(){r&&r(s)}),n.props.onChange(n.treeManager.getNodeById(e),s)},n.onAction=function(e,t){"function"==typeof n.props.onAction&&n.props.onAction(e,n.treeManager.getNodeById(t))},n.onInputFocus=function(){n.keepDropdownActive=!0},n.onInputBlur=function(){n.keepDropdownActive=!1},n.onTrigger=function(e){n.handleClick(e,function(){n.state.showDropdown&&n.searchInput.focus()})},n.onKeyboardKeyDown=function(e){var t=n.props,r=t.readOnly,o=t.simpleSelect,a=n.state,i=a.showDropdown,l=a.tags,s=a.searchModeOn,c=a.currentFocus,u=n.treeManager,h=s?u.matchTree:u.tree;if(i||!et.isValidKey(e.key,!1)&&!/^\w$/i.test(e.key))if(i&&et.isValidKey(e.key,!0)){var d=u.handleNavigationKey(c,h,e.key,r,!s,n.onCheckboxChange,n.onNodeToggle);d!==c&&n.setState({currentFocus:d})}else{if(i&&["Escape","Tab"].indexOf(e.key)>-1)return void(o&&h.has(c)?n.onCheckboxChange(c,!0):(n.keepDropdownActive=!1,n.handleClick()));if("Backspace"!==e.key||!l.length||0!==n.searchInput.value.length)return;var p=l.pop();n.onCheckboxChange(p._id,!1)}else if(e.persist(),n.handleClick(null,function(){return n.onKeyboardKeyDown(e)}),/\w/i.test(e.key))return;e.preventDefault()},n.state={showDropdown:n.props.showDropdown||n.props.showDropdownAlways||!1,searchModeOn:!1,currentFocus:void 0},n.clientId=e.id||y.get(n),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,u["Component"]),ot(t,[{key:"componentWillMount",value:function(){var e=this.props,t=e.data,n=e.hierarchical;this.initNewProps(rt({data:t,hierarchical:n},this.props))}},{key:"componentWillUnmount",value:function(){document.removeEventListener("click",this.handleOutsideClick,!1)}},{key:"componentWillReceiveProps",value:function(e){this.initNewProps(e)}},{key:"render",value:function(){var e=this,t=this.props,n=t.disabled,r=t.readOnly,o=t.simpleSelect,a=t.radioSelect,i=t.label,l=this.state.showDropdown,s={disabled:n,readOnly:r,activeDescendant:this.state.currentFocus?this.state.currentFocus+"_li":void 0,label:i,simpleSelect:o,radioSelect:a};return h.a.createElement("div",{id:this.clientId,className:at(this.props.className,"react-dropdown-tree-select"),ref:function(t){e.node=t}},h.a.createElement("div",{className:at("dropdown",{"simple-select":o},{"radio-select":a})},h.a.createElement(B,rt({onTrigger:this.onTrigger,showDropdown:l},s),h.a.createElement(j,rt({inputRef:function(t){e.searchInput=t},tags:this.state.tags,placeholderText:this.props.placeholderText,onInputChange:this.onInputChange,onFocus:this.onInputFocus,onBlur:this.onInputBlur,onTagRemove:this.onTagRemove,onKeyDown:this.onKeyboardKeyDown,labelRemove:this.props.labelRemove},s))),l&&h.a.createElement("div",{className:"dropdown-content"},this.state.allNodesHidden?h.a.createElement("span",{className:"no-matches"},this.props.noMatchesText||"No matches found"):h.a.createElement(Ee,rt({data:this.state.tree,keepTreeOnSearch:this.props.keepTreeOnSearch,keepChildrenOnSearch:this.props.keepChildrenOnSearch,searchModeOn:this.state.searchModeOn,onAction:this.onAction,onCheckboxChange:this.onCheckboxChange,onNodeToggle:this.onNodeToggle,showPartiallySelected:this.props.showPartiallySelected,clientId:this.clientId},s)))))}}]),t}();it.propTypes={data:c.a.oneOfType([c.a.object,c.a.array]).isRequired,clearSearchOnChange:c.a.bool,keepTreeOnSearch:c.a.bool,keepChildrenOnSearch:c.a.bool,keepOpenOnSelect:c.a.bool,placeholderText:c.a.string,showDropdown:c.a.bool,showDropdownAlways:c.a.bool,className:c.a.string,onChange:c.a.func,onAction:c.a.func,onNodeToggle:c.a.func,onFocus:c.a.func,onBlur:c.a.func,simpleSelect:c.a.bool,radioSelect:c.a.bool,noMatchesText:c.a.string,showPartiallySelected:c.a.bool,disabled:c.a.bool,readOnly:c.a.bool,hierarchical:c.a.bool,id:c.a.string,label:c.a.string,labelRemove:c.a.string},it.defaultProps={onFocus:function(){},onBlur:function(){},onChange:function(){}};t.default=it},,,,,function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";var r=n(14);function o(){}e.exports=function(){function e(e,t,n,o,a,i){if(i!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=o,n.PropTypes=n,n}}])});
//# sourceMappingURL=react-dropdown-tree-select.js.map

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(900);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(901),
    isObjectLike = __webpack_require__(88);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(902),
    equalArrays = __webpack_require__(306),
    equalByTag = __webpack_require__(913),
    equalObjects = __webpack_require__(917),
    getTag = __webpack_require__(938),
    isArray = __webpack_require__(72),
    isBuffer = __webpack_require__(307),
    isTypedArray = __webpack_require__(308);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(110),
    stackClear = __webpack_require__(903),
    stackDelete = __webpack_require__(904),
    stackGet = __webpack_require__(905),
    stackHas = __webpack_require__(906),
    stackSet = __webpack_require__(907);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(110);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 904 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 905 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(110),
    Map = __webpack_require__(155),
    MapCache = __webpack_require__(152);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(152),
    setCacheAdd = __webpack_require__(909),
    setCacheHas = __webpack_require__(910);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    Uint8Array = __webpack_require__(914),
    eq = __webpack_require__(154),
    equalArrays = __webpack_require__(306),
    mapToArray = __webpack_require__(915),
    setToArray = __webpack_require__(916);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(918);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(919),
    getSymbols = __webpack_require__(921),
    keys = __webpack_require__(924);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(920),
    isArray = __webpack_require__(72);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(922),
    stubArray = __webpack_require__(923);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 922 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(925),
    baseKeys = __webpack_require__(933),
    isArrayLike = __webpack_require__(937);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(926),
    isArguments = __webpack_require__(927),
    isArray = __webpack_require__(72),
    isBuffer = __webpack_require__(307),
    isIndex = __webpack_require__(242),
    isTypedArray = __webpack_require__(308);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(928),
    isObjectLike = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isLength = __webpack_require__(309),
    isObjectLike = __webpack_require__(88);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(238);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(934),
    nativeKeys = __webpack_require__(935);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(936);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(239),
    isLength = __webpack_require__(309);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(939),
    Map = __webpack_require__(155),
    Promise = __webpack_require__(940),
    Set = __webpack_require__(941),
    WeakMap = __webpack_require__(942),
    baseGetTag = __webpack_require__(87),
    toSource = __webpack_require__(240);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(57),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
var CustOutstandingForm=function CustOutstandingForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 p-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 p-0 pr-1 ",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 p-0",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 p-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-5 p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue,options:props.sampleTypeOptions,onChange:props.selectMultipleOption1,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Need Image"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"image",value:props.image,options:[{label:"YES",value:true},{label:"NO",value:false}],onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Created On"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"createdAt",label:"createdAt",value:props.createdAt,onChange:props.updateState,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (CustOutstandingForm);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(4);
var FabricForm=function FabricForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 mx-auto br-col p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 p-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6",style:{zIndex:1000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"supplier")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"supplierName",value:props.supplierName// onInputChange={this.getSupplierInfo}
,onChange:props.changeSupplierInfo,placeholder:"Find Suppliername",options:props.supplierOption,disabled:false})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Requirement")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"requirement",value:props.requirement,options:props.requirementOption,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Status")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6 height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"status",value:props.status,options:props.statusOptions.filter(function(x){return x.value!=="IN PROCESS";}),onChange:props.updateState,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (FabricForm);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
var FabricPricePending=function FabricPricePending(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 p-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue,options:props.sampleTypeOptions,onChange:props.selectMultipleOption1,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of Request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})));};/* harmony default export */ __webpack_exports__["a"] = (FabricPricePending);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
var FabricLibrary=function FabricLibrary(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Fabric No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"fabNumber",value:props.fabNumber,onChange:props.updateState,disabled:false,className:"w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Count & Construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"countCons",value:props.countCons,onChange:props.updateState,disabled:false,className:"w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Quality"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"quality",value:props.quality,options:props.fabQualityList,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"})));};/* harmony default export */ __webpack_exports__["a"] = (FabricLibrary);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(4);
var BNumber=function BNumber(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"row text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 p-2 ml-auto",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 p-1 mr-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6",style:{padding:"8px 5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"BNumber"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"bNumber",value:props.bNumber,style:{height:"40px !important"},onChange:props.updateState,disabled:false// className="Select-control"
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-6",style:{padding:"8px 5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Count & Construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"countCons",value:props.countCons,style:{height:"40px !important"},onChange:props.updateState,disabled:false// className="Select-control"
}))));};/* harmony default export */ __webpack_exports__["a"] = (BNumber);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
var SampleLibrary=function SampleLibrary(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 p-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"For"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"d-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"styleType",value:props.styleType// options={props.sampleTypeOptions}
,options:[{"label":"Style Name","value":"styleName"},{"label":"Style No","value":"styleNo"}],onChange:props.updateState,disabled:false,className:"Select-control"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",name:"styleTypeValue",title:props.styleTypeValue,className:"form-control w-100 ml-3",value:props.styleTypeValue,onChange:function onChange(e){return props.updateState("styleTypeValue",e.target.value);},onKeyPress:function onKeyPress(e){return e.key==="Enter"&&props.exportReport();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Garment Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"garmentType",value:props.garmentType,options:props.garmentTypeOptions,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Image Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"imageType",value:props.imageType,options:props.imageTypeOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Item No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",name:"itemNo",title:props.itemNo,className:"form-control w-100",value:props.itemNo,onChange:function onChange(e){return props.updateState("itemNo",e.target.value);},onKeyPress:function onKeyPress(e){return e.key==="Enter"&&props.exportReport();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer Ref No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",name:"customerRefNo",title:props.customerRefNo,className:"form-control w-100",value:props.customerRefNo,onChange:function onChange(e){return props.updateState("customerRefNo",e.target.value);},onKeyPress:function onKeyPress(e){return e.key==="Enter"&&props.exportReport();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Actioned By"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"actionedBy",value:props.actionedBy,options:props.actionedByOptions,onChange:props.updateState,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (SampleLibrary);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
var BulkUpdateForDispatch=function BulkUpdateForDispatch(props){var leftAlignFields=["CUST-DEPT","STYLENAME","SAMPLETYPE"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate"// label="to Date"
,value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"AWB No.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"text",inputName:"awbNumber",value:props.awbNumber,onChange:props.updateState,disabled:false,className:"w-100"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Location",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"location",value:props.location,options:props.LOCATION,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Courier",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"courier",value:props.courier,options:props.courierOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 mt-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary",onClick:function onClick(){return props.bulkDispatchUpdate(props.toDate,props.awbNumber,props.location,props.courier);}},"Update"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center d-flex justify-content-center my-3",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"UpdateNo",options:props.NumberFromList,onInputChange:props.getNumberList,value:props.NumberFromObj,onChange:props.getNumberFrom,placeholder:"Select Request No."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 d-flex justify-content-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary buttonBulkUpdate",onClick:props.addNumbers},"Add"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary mx-1 buttonBulkUpdate",onClick:function onClick(){if(!props.awbNumber||!props.location||!props.courier){props.getalertMessage('info','Please fill mandatory Fields');}else{props.exportReport(false,1);}}},"Search"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary buttonBulkUpdate",onClick:props.resetBy},"Reset"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-5 py-3 px-0 rounded",style:{border:'1px solid #dee2e6'}},props.ids.length>0&&props.ids.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary m-1",onClick:function onClick(){return props.removeNumbers(x.value);}},x.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"X"));}))),props.List.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{id:"report-list-height",className:"mt-5"// onScroll={this.handleScroll}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(props.List[0]).map(function(x){return x!=="id"&&x!=='selectedSize'&&x!=='selectedQty'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header"},x);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header"},"Add")),props.List.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(data).map(function(x){return x!=="id"&&x!=='selectedSize'&&x!=='selectedQty'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:x==="QTY"&&'8%',className:leftAlignFields.includes(x)?'text-left':''},x==="SIZE"&&Array.isArray(data[x])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{onChange:function onChange(e){return props.dispatchUpdate(e.target.value,i,'selectedSize');},value:data['selectedSize']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"select"),data["SIZE"].map(function(d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:d},d);}))||x==="QTY"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"mt-2 d-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"number",inputName:"selectedQty"+i,value:data['selectedQty'],onChange:function onChange(name,value){return props.dispatchUpdate(value,i,'selectedQty');},className:"mx-auto d-flex w-100 justify-content-center"}))||data[x]));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary",onClick:function onClick(){return props.addDispatchData(data["SIZE"],i);}},"Add")));})))));};/* harmony default export */ __webpack_exports__["a"] = (BulkUpdateForDispatch);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
var ProcessCompletedForm=function ProcessCompletedForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12  text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 p-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Completed On"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"completed",label:"completed",value:props.completed,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Process Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"processType",value:props.processType,options:props.processTypeOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false})))// </div>
;};/* harmony default export */ __webpack_exports__["a"] = (ProcessCompletedForm);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(4);
var PrintYarnForm=function PrintYarnForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12  text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4",style:{zIndex:1000}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"supplier")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"supplierName",value:props.supplierName// onInputChange={this.getSupplierInfo}
,onChange:props.changeSupplierInfo,placeholder:"Find Suppliername",options:props.supplierOption,disabled:false})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Requirement")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"requirement",value:props.requirement,options:props.requirementOption,onChange:props.updateReportType,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Status")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4 height-adjust"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"status",value:props.status,options:props.statusOptions,onChange:props.updateReportType,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (PrintYarnForm);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
//sample awaiting material
var ProcessUpdatesForm=function ProcessUpdatesForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 px-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA/ETD From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA/ETD To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Process Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"processType",value:props.processType,options:props.processTypeOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false})))));};/* harmony default export */ __webpack_exports__["a"] = (ProcessUpdatesForm);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Include CSS
var SampleReportByProcessesForm=function SampleReportByProcessesForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 text-center ",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center",style:{zIndex:"1003"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Process Type ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue,options:props.processTypeOptions,onChange:props.selectMultipleOption1,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"No Items selected",disabled:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"status",value:props.status||"ALL",options:[{value:"ALL",label:"All"}].concat(_toConsumableArray(props.statusOptions)),onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Show only Headers ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue1,options:props.processTypeOptions,onChange:props.selectMultipleOption,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"No Items selected",disabled:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"progress",value:props.progress||'ALL',options:props.progressOptions,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1",style:{zIndex:"1002"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 p-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData}))));};/* harmony default export */ __webpack_exports__["a"] = (SampleReportByProcessesForm);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_picky_dist_picky_css__);
var PatterMasterReport=function PatterMasterReport(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 d-flex justify-content-center text-center mx-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 px-2",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 height-adjust",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Pattern Master Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{name:"assignedTo",value:props.patternMaster,onChange:function onChange(value){return props.updateState("patternMaster",value);},placeholder:"Find pattern master",options:props.patternMasterList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 height-adjust",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 height-adjust",style:{zIndex:"1001"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center text-center mx-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (PatterMasterReport);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_picky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_picky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_picky_dist_picky_css__);
//process update form 
var BulkProcessUpdates=function BulkProcessUpdates(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 text-center"},props.showForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 px-2",style:{zIndex:"1002"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA/ETD From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"ETA/ETD To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Process Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"processType",value:props.processType,options:props.processTypeOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3",style:{zIndex:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Source of request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"typeOfRequest",value:props.typeOfRequest,options:props.typeOfRequestOptions,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3",style:{zIndex:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Sample Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_picky___default.a,{value:props.arrayValue2,options:props.sampleTypeOptions,onChange:props.selectMultipleOption2,open:false,valueKey:"value",labelKey:"label",multiple:true,includeSelectAll:true,manySelectedPlaceholder:"%s selected",allSelectedPlaceholder:"%s selected",includeFilter:true,dropdownHeight:300,placeholder:"Select a sample type",disabled:false})))),props.requestKey&&!props.showForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 d-flex justify-content-center p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Update To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"requestKey",value:props.requestKey,options:[{label:"ETA",value:"ETA"},{label:"STATUS",value:"status"}],onChange:function onChange(name,value){return props.updateState(name,value,false,"requestValue");},disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Update Value"),props.requestKey==="status"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"requestValue",value:props.requestValue,options:props.STATUS&&props.STATUS.filter(function(x){return x.value!=="PENDING";})||[],onChange:function onChange(name,value){return props.updateState(name,value,false);},disabled:false,className:"Select-control"})||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"requestValue",value:props.requestValue,onChange:function onChange(name,value){return props.updateState(name,value,false);},disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2 pt-4 d-flex align-items-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary",onClick:props.saveProcessUpdates},"Save"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"px-2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{"class":"primary",onClick:function onClick(){return props.updateState("showForm",true);}},"Reset"))));};/* harmony default export */ __webpack_exports__["a"] = (BulkProcessUpdates);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__ = __webpack_require__(24);
var StyleDownloads=function StyleDownloads(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 d-flex justify-content-center text-center mx-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3 px-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Customer department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_report_multiSelect__["a" /* default */],{customerInfo:props.customerWithDepartment,selectedCustomers:props.storeCustomerData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"999"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date From"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"fromDate",label:"from Date",value:props.fromDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"999"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Date To"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"date",inputName:"toDate",label:"to Date",value:props.toDate,onChange:props.updateState,disabled:false,className:"Select-control"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-2",style:{zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Actioned By"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Common_Field_Field__["a" /* default */],{inputType:"select",inputName:"actionedBy",value:props.actionedBy,options:props.actionedByOptions,onChange:props.updateState,disabled:false,className:"Select-control"}))));};/* harmony default export */ __webpack_exports__["a"] = (StyleDownloads);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
var FabricLibraryList=function FabricLibraryList(props){var fabricpage=function fabricpage(data2){var action=props.rights.web.edit&&"edit"||props.rights.web.view&&"view",k=props.processType;var fabricsearch="?"+new URLSearchParams({action:action,_id:data2._id// hash: `seleted${data2.number.split("-").join("")}`
}).toString();window.open("/developmentFabric"+fabricsearch,"_blank");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{id:"fabTable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" col-md-3 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:function onClick(){return fabricpage(listValue);}},listValue.fabricNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-auto "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"fabric-library-report-img",onClick:function onClick(){return props.modalData(listValue.fabricImage);},src:listValue.fabricImage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name-Type")," : ",listValue.imageType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Quality")," : ",listValue.quality)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Composition")," : ",listValue.composition||"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Requirement")," : ",listValue.requirement||"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0"},listValue.countConstruction))))));})))));};/* harmony default export */ __webpack_exports__["a"] = (FabricLibraryList);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(25);
var SampleLibraryList=function SampleLibraryList(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{id:"sampleLibTable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" col-md-3 "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{onClick:function onClick(){if(!props.styleRights.web.edit&&!props.styleRights.web.view){props.getalertMessage("info","no access");}else{var action=props.styleRights.web.edit&&"edit"||props.styleRights.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:listValue._id}).toString();window.open("/StylePage"+search+"#seleted"+listValue.styleNumber.split("-").join(""),"_blank");}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:"black"}},listValue.styleNumber," - ",listValue.styleName||"STYLE IMAGE"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-auto "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"sample-library-report-img",onClick:function onClick(){return props.modalData(listValue.imageUrl);},src:listValue.imageUrl}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"p-0"},"Name-Type: ",listValue.imageName))))));})))));};/* harmony default export */ __webpack_exports__["a"] = (SampleLibraryList);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
var ProcessCompletedList=function ProcessCompletedList(props){var stylePage=function stylePage(listValue){{var action=props.styleRights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.code.split("-").join("")}).toString();// window.open(`/StylePage${newSearch}`, "_blank")     
window.open("/StylePage"+newSearch+"#seleted"+listValue.code.split("-").join(""),"_blank");};};var samplePage=function samplePage(data){var action=props.sampleRights.sampleRequest.web.edit&&"edit"||props.sampleRights.sampleRequest.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:data._id}).toString();window.open("/Sample"+search,"_blank");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Process Name:",props.processType&&props.processType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(props.list[0]).map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue);})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(listValue).map(function(listData){return listData==="SAMPLE REQUEST NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+listValue[listData].number,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return samplePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="STYLE NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:listData.trim()==="STYLE NAME"||listData.trim()==="CUST-DEPT"||listData.trim()==="SAMPLE TYPE"?"text-left":""},listValue[listData]);})));}));};/* harmony default export */ __webpack_exports__["a"] = (ProcessCompletedList);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
var PrintYarnList=function PrintYarnList(props){var stylePage=function stylePage(listValue){var action=props.styleRights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.referenceCode.split("-").join("")}).toString();window.open("/StylePage"+newSearch+"#seleted"+listValue.referenceCode.split("-").join(""),"_blank");// window.open(`/StylePage${newSearch}`, "_blank")
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(props.list[0]).map(function(listValue){return listValue!=="ID"&&listValue!=="COMMENTS"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue);})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(listValue).map(function(listName){return listName==="IMAGE"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{onClick:function onClick(){return listValue[listName]&&props.modalData(listValue[listName]);},style:{width:" 50px",height:"50px"},src:""+listValue[listName]})):listName==="STYLE NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},listValue[listName].referenceCode,listValue[listName].referenceCode&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listName].referenceCode,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listName]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listName!=="ID"&&listName!=="COMMENTS"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listName]);})));}),"null");};/* harmony default export */ __webpack_exports__["a"] = (PrintYarnList);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__ = __webpack_require__(2);
var ProcessUpdatesList=function ProcessUpdatesList(props){var stylePage=function stylePage(listValue){// props.history.push("/StylePage", 
{var action=props.styleRights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.code.split("-").join("")}).toString();window.open("/StylePage"+newSearch+"#seleted"+listValue.code.split("-").join(""),"_blank");// window.open(`/StylePage${newSearch}`, "_blank")
};};var samplePage=function samplePage(data){var action=props.sampleRights.sampleRequest.web.edit&&"edit"||props.sampleRights.sampleRequest.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:data._id}).toString();window.open("/Sample"+search,"_blank");};var select={};if(props.type==="bulkUpdateProcess"){select={Select:""};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Process Name: ",props.processType&&props.processType.toUpperCase()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.type!=="bulkUpdateProcess"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},"S.No"),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(Object.assign({},select,props.list[0])).map(function(listValue){var hide=["S.No.","Select","checkbox0"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue!=="checkbox0"&&listValue," ",!hide.includes(listValue)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{onClick:function onClick(){return props.sorting(listValue);},style:{"font-size":"14px"}},"\u21C5"),listValue==="Select"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"checkbox",inputName:"all",value:props.all,onChange:props.handleCheckBox,className:"mx-auto d-flex w-100 justify-content-center"}));})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.type==="bulkUpdateProcess"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"checkbox",inputName:"checkbox"+index,value:listValue["checkbox"+index],index:index,onChange:props.handleCheckBox})),props.type!=="bulkUpdateProcess"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,index+1),Object.keys(listValue).map(function(listData){return listData==="SR NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+listValue[listData]._id,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return samplePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="STYLE NO"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a}))||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:listData==="STYLE NAME"||listData==="SAMPLE TYPE"||listData==="CUST-DEPT"?'left':'center'}},listValue[listData]);})));})));};/* harmony default export */ __webpack_exports__["a"] = (ProcessUpdatesList);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var alignV=function alignV(data){var h=["SAMPLE","CAD","FABRIC","TRIM","PATTERN","CUTTING","SEWING","GARMENT TECH","EMBELLISHMENT","EMBROIDERY","WASH",// "QC",
'GRADING',"MARKER","COSTING","SIGNOFF","DISPATCH"];if(h.includes(data)){return true;}else{return false;}};var setTitle=function setTitle(data,type){if((typeof data==="undefined"?"undefined":_typeof(data))==="object"){if(type==="content"){if(_typeof(data.status)==='object'){return data.status.status;}else{return data.status;}}else{return data.assignedTo;}}else{return data;}};var changeBg=function changeBg(data){var isBlue=false,status=void 0;if(_typeof(data.status)==="object"){status=data.status.status;isBlue=true;}else{status=data.status;}switch(status){case"P":return(!isBlue&&'bg-danger'||'bg-primary')+" p-2 text-white font-weight-bold borderDark align-middle";case"CA":return(!isBlue&&'bg-dark'||'bg-primary')+" py-2 px-1 text-white font-weight-bold borderDark align-middle";case"C":return(!isBlue&&'bg-success'||'bg-primary')+" p-2 text-white font-weight-bold borderDark align-middle";case"IN":return(!isBlue&&'bg-warning'||'bg-primary')+" py-2 px-1 text-white font-weight-bold borderDark align-middle";case"X":return(!isBlue&&'bg-yellow'||'bg-primary')+" p-2 text-dark font-weight-bold borderDark align-middle";case"":return"bg-primary p-2 text-white font-weight-bold borderDark align-middle";default:return"wordwrap py-1";}};var showHead=function showHead(data,headers){if(headers.length){headers.map(function(x){return x.label;});if(headers.includes(data)){return"d-none";}}};function SampleReportByProcessesList(props){console.log(props,"props");var header=props.header,showHeaders=props.showHeaders;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Samples Report by Processes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"P - PENDING \xA0\xA0 CA - Cancelled \xA0\xA0 C - Completed \xA0\xA0 IN - InProcess \xA0\xA0 X - NotAllocated")),Object.keys(header).length>0&&header.h1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,header&&header.h2&&header.h2.length>0&&header.h2.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:!alignV(x)&&x==="STYLE NAME"&&"19%",className:"report-header "+(alignV(x)&&"m-0 p-0")+" "+showHead(x,showHeaders)},i===0&&header.h1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+(alignV(x)?"rotate90 p-0 m-0":x==="DATE"?"Date":"wordwrap")},x==="CAD"&&"3D"||x));}))),props.list&&props.list.length>0&&props.list.map(function(x,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"23",className:"text-left h6 w-100 p-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{borderBottom:"1px solid var(--primary-color)"},className:"w-100 d-block"},x.name))),x.data.map(function(dat){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(dat).map(function(k,i){if(k==="IMAGE"&&dat[k]!==""){if(props.state.image==="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{onClick:function onClick(){return dat[k]&&props.modalData(dat[k]);},src:""+dat[k],style:{width:" 50px",height:"50px"}}));}}else if(k==="SR No"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.sampleRights.sampleRequest.web.edit&&!props.sampleRights.sampleRequest.web.view){props.getalertMessage("info","no access");}else{var action=props['sampleRights'].sampleRequest.web.edit&&"edit"||props['sampleRights'].sampleRequest.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat[k]._id}).toString();window.open("/Sample"+search,"_blank");// props.history.push("/Sample", {
//     action:
//         (props.rights.sampleRights.web.edit &&
//             "edit") ||
//         (props.rights.sampleRights.web.view &&
//             "view"),
//     _id: dat[k]._id,
//     report: { ...props.state },
//     route: "Report"
// })
}}},dat[k].number));}else if(k==="STYLE NO"||k==="STYLE NAME"){if(k==="STYLE NO"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.styleRights.web.edit&&!props.styleRights.web.view){props.getalertMessage("info","no access");}else{var action=props.styleRights.web.edit&&"edit"||props.styleRights.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat[k]._id}).toString();window.open("/StylePage"+search+"#seleted"+dat[k].code.split("-").join(""),"_blank");}}},dat[k].code));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"under-line cursor-hover",onClick:function onClick(){if(!props.styleRights.web.edit&&!props.styleRights.web.view){props.getalertMessage("info","no access");}else{var action=props.styleRights.web.edit&&"edit"||props.styleRights.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat["STYLE NO"]._id}).toString();window.open("/StylePage"+search+"#seleted"+dat["STYLE NO"].code.split("-").join(""),"_blank");}}},dat[k]));}}else if(k==="SAMPLE TYPE"){// Apply left alignment when SAMPLE TYPE
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"// Add left alignment class here
,style:{padding:".1rem"}// Optionally, add some padding for visual consistency
,title:setTitle(dat[k],"title")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+changeBg(dat[k])},setTitle(dat[k],"content")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"m-0",style:{padding:".1rem",cursor:alignV(k)&&'pointer'||''},title:setTitle(dat[k],"title")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+changeBg(dat[k]),onClick:function onClick(){if(alignV(k)&&!props.sampleRights[k.toLowerCase()==="garment tech"&&"garmentTech"||k.toLowerCase()].web.edit&&!props.sampleRights[k.toLowerCase()==="garment tech"&&"garmentTech"||k.toLowerCase()].web.view){props.getalertMessage("info","no access");}else if(alignV(k)){var action=props.sampleRights[k.toLowerCase()==="garment tech"&&"garmentTech"||k.toLowerCase()].web.edit&&"edit"||props.sampleRights[k.toLowerCase()==="garment tech"&&"garmentTech"||k.toLowerCase()].web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:dat['SR No']._id}).toString();window.open("/Sample"+search+"#"+(k==="GRADING"&&'QC'||k==="GARMENT TECH"&&'garmentTechnologist'||k),"_blank");}}},setTitle(dat[k],"content")));}}));}));}));}/* harmony default export */ __webpack_exports__["a"] = (SampleReportByProcessesList);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
var PatterMasterReportList=function PatterMasterReportList(props){var stylePage=function stylePage(listValue){{var action=props.styleRights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.code.split("-").join("")}).toString();// window.open(`/StylePage${newSearch}`, "_blank")     
window.open("/StylePage"+newSearch+"#seleted"+listValue.code.split("-").join(""),"_blank");};};var samplePage=function samplePage(data){var action=props.sampleRights.sampleRequest.web.edit&&"edit"||props.sampleRights.sampleRequest.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:data._id}).toString();window.open("/Sample"+search,"_blank");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(props.list[0]).map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue);})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(listValue).map(function(listData){return listData==="SAMPLE REQUEST NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between"},listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+listValue[listData].number,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return samplePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="STYLE NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:listData.trim()==="STYLE NAME"||listData.trim()==="CUST-DEPT"||listData.trim()==="SAMPLE TYPE"?"text-left":""},listValue[listData]);})));}));};/* harmony default export */ __webpack_exports__["a"] = (PatterMasterReportList);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png__);
var StyleDownloadsList=function StyleDownloadsList(props){var stylePage=function stylePage(listValue){{var action=props.styleRights.web.edit&&"edit"||props.rights.web.view&&"view";var newSearch="?"+new URLSearchParams({action:action,_id:listValue._id,hash:"seleted"+listValue.code.split("-").join("")}).toString();// window.open(`/StylePage${newSearch}`, "_blank")     
window.open("/StylePage"+newSearch+"#seleted"+listValue.code.split("-").join(""),"_blank");};};var samplePage=function samplePage(data){var action=props.sampleRights.sampleRequest.web.edit&&"edit"||props.sampleRights.sampleRequest.web.view&&"view";var search="?"+new URLSearchParams({action:action,_id:data._id}).toString();window.open("/Sample"+search,"_blank");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&Object.keys(props.list[0]).map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header text-center border"},listValue);})),props.list!==undefined&&Array.isArray(props.list)&&props.list.length>0&&props.list.map(function(listValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(listValue).map(function(listData){return listData==="SR NO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"d-flex align-items-center justify-content-between text-left"},listValue[listData].number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Sample Page Of "+listValue[listData]._id,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return samplePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="Style Ref/No"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):listData==="Style Name"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:" text-left"},listValue[listData].code,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{title:"Go To Style Page Of "+listValue[listData].code,className:"cursor-hover",style:{cursor:"pointer",marginTop:"-1px",verticalAlign:"top",marginLeft:"5px"},onClick:function onClick(){return stylePage(listValue[listData]);},src:__WEBPACK_IMPORTED_MODULE_1__assets_images_external_link_png___default.a})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:listData.trim()==="Cust-Dept"?"text-left":""},listValue[listData]);})));}));};/* harmony default export */ __webpack_exports__["a"] = (StyleDownloadsList);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_to_print__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_to_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_to_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Report_reports__ = __webpack_require__(304);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentToPrint=function(_React$Component){_inherits(ComponentToPrint,_React$Component);function ComponentToPrint(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ComponentToPrint);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ComponentToPrint.__proto__||Object.getPrototypeOf(ComponentToPrint)).call.apply(_ref,[this].concat(args))),_this),_this.state={fabricReportList:[],type:""},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ComponentToPrint,[{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,fabricReportList=_props.fabricReportList,body=_props.body,header=_props.header,arrayValue=_props.arrayValue,type=_props.type;this.setState({fabricReportList:fabricReportList,body:body,header:header,arrayValue:arrayValue,type:type});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var fabricReportList=nextProps.fabricReportList,body=nextProps.body,header=nextProps.header,arrayValue=nextProps.arrayValue,type=nextProps.type;this.setState({fabricReportList:fabricReportList,body:body,header:header,arrayValue:arrayValue,type:type});}},{key:"render",value:function render(){var _state=this.state,fabricReportList=_state.fabricReportList,body=_state.body,header=_state.header,arrayValue=_state.arrayValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{id:"report-list-height1",className:"report-list-height1 mt-5",onScroll:this.state.type!=='sampleLibrary'&&this.handleScroll},this.state.type==="fabric"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,fabricReportList!==undefined&&fabricReportList.length>0&&Object.keys(fabricReportList[0]).map(function(data){if(data!=="ID")return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"report-header"},data);})),this.state.type==="dispatch"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["c" /* Dispatch */],{list:fabricReportList,displayData:this.displayData}),this.state.type==="bNumber"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["a" /* BNumberList */],{list:fabricReportList}),this.state.type==="fabPricePending"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["e" /* FabricPricePendingList */],{list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="fabricLibrary"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["d" /* FabricLibraryList */],{modalData:this.modalData,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="sampleProcesses"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["k" /* SampleReportByProcessesList */],{sampleRights:this.props.sampleRequest,modalData:this.modalData,list:body,processType:this.state.processType,history:this.props.history,disabled:this.state.disabled,header:header,showHeaders:arrayValue}),this.state.type==="sampleLibrary"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["j" /* SampleLibraryList */],{modalData:this.modalData,list:fabricReportList,processType:this.state.processType,history:this.props.history}),this.state.type==="processCompleted"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["h" /* ProcessCompletedList */],{list:fabricReportList,processType:this.state.processType,history:this.props.history}),(this.state.type==="processUpdates"||this.state.type==="bulkUpdateProcess")&&// sample awaiting material
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["i" /* ProcessUpdatesList */],{type:this.state.type,list:fabricReportList,processType:this.state.processType,history:this.props.history,sorting:this.sorting,handleCheckBox:this.handleCheckBox,all:this.state.all}),this.state.type==="fabric"&&fabricReportList!==undefined&&Array.isArray(fabricReportList)&&fabricReportList.length>0&&fabricReportList.map(function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,Object.keys(data).map(function(dat){if(dat=="IMAGE"&&data[dat]!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:""+data[dat],style:{width:" 50px",height:"50px"}}));}else if(dat=="DEV REF NUMBER"||dat=="FABRIC REF NO"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,data[dat]));}else if(dat!="ID"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data[dat]);}}));}),this.state.type==="custDept"&&body&&body.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["b" /* CustOutstand */],{state:this.state,list:body,header:header,history:this.props.history,getalertMessage:this.props.getalertMessage,changeBg:this.changeBg,setTitle:this.setTitle,modalData:this.modalData}),this.state.type==="patternMasterReport"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["f" /* PatterMasterReportList */],{list:fabricReportList,processType:this.state.processType,history:this.props.history}),(this.state.type==="styleDownloads"||this.state.type==="sampleRequestDownloads")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Report_reports__["l" /* StyleDownloadsList */],{list:fabricReportList,processType:this.state.processType,history:this.props.history}));}}]);return ComponentToPrint;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ComponentToPrint);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_action_rights__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printStyle_css__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__printStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Page_PageHeader_PageHeader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PrintFabricNo_TableRowSelect__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PrintFabricPage__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PrintStylePage__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_download_png__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_download_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_download_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_common_options__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Component
//Assets
//options
var PrintStyleNumber=function(_Component){_inherits(PrintStyleNumber,_Component);function PrintStyleNumber(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrintStyleNumber);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrintStyleNumber.__proto__||Object.getPrototypeOf(PrintStyleNumber)).call.apply(_ref,[this].concat(args))),_this),_this.state={moduleName:"",activePage:1,totalItemsCount:0,NumberFrom:"",NumberTo:"",SearchDateFrom:"",printDate:'',SearchDateTo:"",List:[],NumberFromList:[],NumberFromObj:"",NumberToObj:"",column:[],selectedData:[],isLoading:false,columnAll:true,ids:[],selectedNumberObj:''},_this.getFabricNumber=function(value){__WEBPACK_IMPORTED_MODULE_9__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){_this.setState({NumberFromList:response.text.data,isLoading:true});}response.status==404&&_this.props.getalertMessage("error",response.text.message);response.status==401&&_this.props.getalertMessage("error",response.text.message);}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.searchBy=function(){var _this$state=_this.state,NumberTo=_this$state.NumberTo,NumberFrom=_this$state.NumberFrom,SearchDateFrom=_this$state.SearchDateFrom,SearchDateTo=_this$state.SearchDateTo,ids=_this$state.ids;if(ids&&ids.length){ids=ids.map(function(x){return x.value;});__WEBPACK_IMPORTED_MODULE_9__services__["j" /* SampleServices */].sampleTagByStyle(ids).then(function(response){if(response.text.data.length>0){_this.setState({List:response.text.data,all:false,printDate:''});_this.props.getalertMessage("success","List Generated!",3000);}else{_this.props.getalertMessage("error","Selected Style No doesn't have any associated data to list!",3000);}}).catch(function(error){return console.error(error);});}else{_this.props.getalertMessage("error","Please add SR number(s)!",3000);}// if (NumberTo !== "" && NumberFrom !== "") {
//   let data = {
//     filterType: this.state.moduleName === "Style" ? "styleNumber" : "",
//     from: NumberFrom,
//     to: NumberTo
//   }
//   if (this.state.moduleName === "Style") {
//     StyleServices.searchFilterForStyleNumber(data)
//       .then(response => {
//         this.setState({
//           List: response.data
//         })
//       })
//       .catch(error => {})
//   }
// }
// if (SearchDateFrom !== "" && SearchDateTo !== "") {
//   let data = {
//     filterType: "dateRange",
//     from: SearchDateFrom,
//     to: SearchDateTo
//   }
//   if (this.state.moduleName === "Style") {
//     StyleServices.searchFilterForStyleNumber(data)
//       .then(response => {
//         this.setState({
//           List: response.data
//         })
//       })
//       .catch(error => {})
//   }
// }
},_this.getNumberList=function(e){if(_this.state.moduleName==="Style"){__WEBPACK_IMPORTED_MODULE_9__services__["j" /* SampleServices */].getSampleReqNo(e).then(function(response){if(response.status==200){_this.setState({NumberFromList:response.text.data,isLoading:true});}}).catch(function(error){// UtilityService.errorMsg(this.msg);
});}},_this.getNumberFrom=function(fabricNum){if(fabricNum){_this.setState({NumberFrom:fabricNum.value,NumberFromObj:fabricNum});}else{_this.setState({NumberFrom:"",NumberFromObj:""});//   this.getFabricNumber("")
}},_this.getNumberTo=function(fabricNum){if(fabricNum){_this.setState({NumberTo:fabricNum.value,NumberToObj:fabricNum});}else{_this.setState({NumberTo:"",NumberToObj:""});//   this.getFabricNumber("")
}},_this.__handleFromDateChange=function(name,value){var _this$setState;var _this$state2=_this.state,List=_this$state2.List,selectedData=_this$state2.selectedData;if(List.length!==0&&name==='printDate'){List.map(function(data,index){List[index].date=value;});}if(selectedData.length!==0&&name==='printDate'){selectedData.map(function(data,index){selectedData[index].date=value;});}_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,"List",List),_this$setState));},_this._handlePageChange=function(pageNumber){_this.setState({activePage:pageNumber});},_this.printDiv=function(val){if(_this.state.selectedData.length){var divToPrint=document.getElementById(val);var newWin=window.open("");newWin.document.write(divToPrint.outerHTML);newWin.print();newWin.close();}else{_this.props.getalertMessage("info","Please select to print!");}},_this.getRowData=function(data){var selectedData=[];if(data.all){selectedData=data.rowData.map(function(datarowData,index){var dat=Object.assign({},datarowData);return dat;});}else{selectedData=data.rowData.filter(function(datarowData,index){if(datarowData["checkbox"+index]){var dat=Object.assign({},datarowData);return dat;}});}_this.setState({all:data.all,selectedData:selectedData,column:data.column,columnAll:data.columnAll});},_this.addNumbers=function(){var _this$state3=Object.assign({},_this.state),ids=_this$state3.ids,NumberFromObj=_this$state3.NumberFromObj;if(NumberFromObj!==""){var obj=ids.find(function(x){return x.value===NumberFromObj.value;});if(!obj){ids=[].concat(_toConsumableArray(ids),[NumberFromObj]);_this.setState({ids:ids,selectedNumberObj:NumberFromObj.value,NumberFromObj:''});}else{_this.setState({NumberFromObj:''});_this.props.getalertMessage('info','SR Number already added in list');}}},_this.removeNumbers=function(value){// var selected = document.getElementById("mySelectNum").value
var _this$state4=Object.assign({},_this.state),ids=_this$state4.ids,NumberFromObj=_this$state4.NumberFromObj;if(value&&ids&&ids.length){ids=ids.filter(function(x){return x.value!=value;});_this.setState({ids:ids});}else{_this.props.getalertMessage('info',"Select SR Number");}},_this.resetBy=function(){_this.setState({ids:[],List:[]});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrintStyleNumber,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var moduleName=this.props.location.state.moduleName;if(moduleName==="Style"){// StyleServices.SearchStyle("")
//   .then(response => {
//     if (response.status == 200) {
//       let jsonData = []
//       response.text.data.map(info =>
//         jsonData.push({ label: info.styleNumber, value: info._id })
//       )
//       this.setState({ NumberFromList: jsonData, isLoading: true })
//     }
//   })
//   .catch(error => {
//     // UtilityService.errorMsg(this.msg);
//   })
__WEBPACK_IMPORTED_MODULE_9__services__["j" /* SampleServices */].getSampleReqNo("").then(function(response){if(response.status===200){_this2.setState({NumberFromList:response.text.data,isLoading:true});}response.status==401&&_this2.props.unauthorisedFunc();}).catch(function(error){return _this2.props.getalertMessage("error",error.toString());});}this.setState({moduleName:moduleName});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var moduleName=nextProps.location.state.moduleName;// if (moduleName === "Fabric") {
//   this.setState({ isLoading: false });
//   DevelopmentServices.getFabricNumber("")
//     .then(response => {
//       if(response.status == 200){
//         this.setState({ NumberFromList: response.text.data, isLoading: true });
//       }
//     })
//     .catch(error => {
//       UtilityService.errorMsg(this.msg, error);
//     });
// }
if(moduleName==="Style"){this.setState({isLoading:false});__WEBPACK_IMPORTED_MODULE_9__services__["j" /* SampleServices */].getSampleReqNo("").then(function(response){if(response.status==200){// let jsonData = []
// response.data.map(info => {
//   let objData = {}
//   objData.label = info.styleNumber
//   objData.value = info._id
//   jsonData.push(objData)
// })
_this3.setState({NumberFromList:response.text.data,isLoading:true});}}).catch(function(error){// UtilityService.errorMsg(this.msg);
});}this.props.getRights(moduleName);this.setState({moduleName:moduleName});}//searchBy
},{key:"render",value:function render(){var _this4=this;var _state=this.state,List=_state.List,NumberFromObj=_state.NumberFromObj,NumberToObj=_state.NumberToObj,NumberFromList=_state.NumberFromList,SearchDateFrom=_state.SearchDateFrom,printDate=_state.printDate,SearchDateTo=_state.SearchDateTo,isLoading=_state.isLoading,selectedData=_state.selectedData,moduleName=_state.moduleName;if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_alert___default.a,Object.assign({ref:function ref(a){return _this4.msg=a;}},this.alertOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"right-section bg-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Page_PageHeader_PageHeader__["a" /* default */],{history:this.props.history,header:"Print Sample Tag"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"col-md-12 d-flex flex-column justify-content-center align-items-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"fw-600"},"Search by Sample Request No."),selectedData.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mx-3 my-3 d-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Select date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:false,inputType:"date",inputName:"printDate",value:printDate,onChange:this.__handleFromDateChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"btn-green-icon mx-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"",className:"cursor-pointer",src:__WEBPACK_IMPORTED_MODULE_16__assets_images_printer_png___default.a,onClick:function onClick(){return _this4.printDiv("printTable");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"custom-async-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{name:"From",value:NumberFromObj,onInputChange:this.getNumberList,onChange:this.getNumberFrom,placeholder:"Sample Request No. Start",options:NumberFromList})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary",onClick:function onClick(){return _this4.addNumbers();}},"Add"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary mx-1",onClick:function onClick(){return _this4.searchBy();}},"Search"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary",onClick:function onClick(){return _this4.resetBy();}},"Reset")),this.state.ids&&this.state.ids.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-5 py-3 px-0 rounded",style:{border:'1px solid #dee2e6'}},this.state.ids.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"primary m-1"},x.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",{onClick:function onClick(){return _this4.removeNumbers(x.value);}},"X"));}))))),List.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_PrintFabricNo_TableRowSelect__["a" /* default */],{all:this.state.all,rowData:List,tableHeaderData:__WEBPACK_IMPORTED_MODULE_17__services_common_options__["c" /* tableHeader */].stylePrintTable,getRowData:this.getRowData,selectedDate:printDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"printTable",className:"d-none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_PrintStylePage__["a" /* default */],{tableHeaderData:__WEBPACK_IMPORTED_MODULE_17__services_common_options__["c" /* tableHeader */].stylePrintTable,columnAll:this.state.columnAll,column:this.state.column,selectedData:selectedData}))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Common_Loading__["a" /* default */],null);}}}]);return PrintStyleNumber;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// export default PrintFabricNumber;
var mapStateToProps=function mapStateToProps(state){return{rights:state.main.rights,selectedRight:state.rights.rightsInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({getRights:__WEBPACK_IMPORTED_MODULE_3__redux_action_rights__["a" /* default */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PrintStyleNumber));

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__measurementModal_css__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__measurementModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__measurementModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_left_arrow_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_left_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_left_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customModal_CustomModal__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_to_print__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_to_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_to_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_confirm_alert__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import  Async from "react-select";
var MeasurementModal=function(_Component){_inherits(MeasurementModal,_Component);function MeasurementModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,MeasurementModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MeasurementModal.__proto__||Object.getPrototypeOf(MeasurementModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,action:"",showModal:false,modalSearchInput:"",measurements:[{code:"C1",description:"Bust/Chest @2.5cm Below Underarm",tolMinus:"1.00",tolPlus:"1.00",sizes:{4:"1.00",8:"1.00",10:"1.00",12:"1.00",16:"1.00",18:"1.00"},comments:"Gathering Relaxed",bw:"1.00",// New field for BW
aw:"1.00"}],showDropdown:false,dropdownPosition:{top:0,left:0},dropdownPositionAddMore:{top:0,left:0},availableSizes:[],selectedSizes:[],measurements1:[],srList:[],srValueObj:null,shrinkagePercentage:{length:"",width:""},additionalData:[],// To store data from the API
selectedMeasurements:[],// To track selected measurements
showDropdown1:false,// To control dropdown visibility
dropdownRef:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),buttonRef1:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),dropdownRef1:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),buttonRef2:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),// srValue:{
//   srvalueDup: ""
// },
isModalOpen:false,// Controls whether the modal is open or closed
srValue:"",ItemNo:"",SampleType:"",SourceOfRequest:"",CustomerDept:"",typeOfRequest:"",Cusrefno:"",Magnumstylename:"",Magnumstyleno:"",GarmentType:"",isOpen1:false,isOpen2:false,SHRINKAGETYPEOPTIONS:[],rowHeights:{},// Store heights for each row index
_id:_this.props.location.state._id},_this.openModal=function(){return _this.setState({open:true});},_this.closeModal=function(){return _this.setState({open:false});},_this.updateRowHeights=function(){var heights={};_this.state.measurements1.forEach(function(_,index){var td=document.getElementById("measurement-td-"+index);if(td){heights[index]=td.offsetHeight;}});_this.setState({rowHeights:heights});},_this.handleClickOutside=function(event){var _this$state=_this.state,dropdownRef=_this$state.dropdownRef,buttonRef1=_this$state.buttonRef1,dropdownRef1=_this$state.dropdownRef1,buttonRef2=_this$state.buttonRef2;if(dropdownRef.current&&!dropdownRef.current.contains(event.target)&&buttonRef1.current&&!buttonRef1.current.contains(event.target)){// Hide the dropdown if the click is outside the dropdown and the button
_this.setState({showDropdown1:false,isOpen2:false});}if(dropdownRef1.current&&!dropdownRef1.current.contains(event.target)&&buttonRef2.current&&!buttonRef2.current.contains(event.target)){_this.setState({showDropdown:false,isOpen1:false});}},_this.openModal=function(){_this.setState({isModalOpen:true});},_this.closeModal=function(){_this.setState({isModalOpen:false,srValue:"",srValueObj:null});},_this.handleInputChange=function(e){_this.setState({srValue:e.target.value});},_this.duplicateMC=function(){var _this$state2=_this.state,_id=_this$state2._id,srValue=_this$state2.srValue;var data=srValue;__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].duplicateMeasurementChat(data,_id).then(function(response){if(response.status==200){_this.props.getalertMessage("success","Measurement Chart duplicated successfully");_this.setState({isModalOpen:false,srValue:""},function(){window.location.reload();});}else{_this.props.getalertMessage("error","enter the correct SR Number");}}).catch(function(error){return _this.props.getalertMessage("error","enter the correct SR Number");});},_this.handleDupInputChange=function(e){var value=e.target.value;// Prevent leading space
if(/^\s/.test(value)){return;// Do nothing if first character is a space
}_this.setState({srValue:e.target.value});},_this.handleAddRow=function(){var newRow={code:"C"+(_this.state.measurements.length+1),description:"",tolMinus:"1.00",tolPlus:"1.00",sizes:[],comments:"",bw:"",// New field for BW
aw:""};_this.setState(function(prevState){return{measurements:[].concat(_toConsumableArray(prevState.measurements),[newRow])};});},_this.handleAddMore=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var showDropdown1,value,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:showDropdown1=_this.state.showDropdown1;_this.setState(function(prevState){return{isOpen2:!prevState.isOpen2};});if(showDropdown1){_context.next=17;break;}_context.prev=3;value={magnumStyleId:_this.props.location.state.magnumStyleId,sourceSampleRequestId:_this.state._id};_context.next=7;return __WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].addMoreTypeOfSize(value);case 7:response=_context.sent;if(response.status===404){_this.props.getalertMessage("error",response.text.message);}if(response.status===200&&_this.state.buttonRef1){// const buttonRect = this.state.buttonRef1.current.getBoundingClientRect();
_this.setState({additionalData:response.text.data,// Store fetched data
showDropdown1:false,// Hide dropdown
showModal:true// Open the modal
// dropdownPositionAddMore: {
//   top: buttonRect.bottom + window.scrollY,
//   left: buttonRect.left + window.scrollX,
// },
},function(){//console.log("Updated additionalData:", this.state.additionalData);
});}_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](3);console.error("Error fetching additional data:",_context.t0);case 15:_context.next=18;break;case 17:_this.setState({showDropdown1:false});case 18:case"end":return _context.stop();}}},_callee,_this2,[[3,12]]);})),_this.renderDropdown=function(){var _this$state3=_this.state,additionalData=_this$state3.additionalData,selectedMeasurements=_this$state3.selectedMeasurements,dropdownRef=_this$state3.dropdownRef,dropdownPositionAddMore=_this$state3.dropdownPositionAddMore;return(// <ul
//   style={{
//     position: "absolute",
//     // top: dropdownPositionAddMore.top, // Use the calculated top position
//     // left: dropdownPositionAddMore.left, // Use the calculated left position
//     listStyleType: "none",
//     padding: "8px",
//     backgroundColor: "white",
//     border: "1px solid #ddd",
//     borderRadius: "4px",
//     boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//     maxHeight: "200px",
//     overflowY: "auto",
//      width: "100%"
//   }}
// >
// additionalData.map((item) => (
//   <li
//     key={item.code}
//     style={{
//       padding: "6px 12px",
//       borderBottom: "1px solid #f0f0f0",
//       display: "flex",
//       alignItems: "center",
//     }}
//   >
//     <input
//       type="checkbox"
//       checked={selectedMeasurements.some((m) => m.code === item.code)}
//       onChange={() => this.handleCheckboxChange(item)}
//       style={{ marginRight: "8px",
//         position: "static", // Reset position
//         left: "auto",       // Reset left positioning
//         opacity: 1,
//         cursor: "pointer",
//        }}
//     />
//     {item.placeofMeasurement}
//   </li>
// ))
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,additionalData.length>0?additionalData.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:item.code,style:{padding:"6px 12px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",checked:selectedMeasurements.some(function(m){return m.placeofMeasurement===item.placeofMeasurement;}),onChange:function onChange(){return _this.handleCheckboxChange(item);},style:{marginRight:"8px",position:"static",// Reset position
left:"auto",// Reset left positioning
opacity:1,cursor:"pointer"}}),item.placeofMeasurement);}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{style:{padding:"12px",textAlign:"center",color:"#999"}},"No data available")));},_this.handleCheckboxChange=function(item){var _this$state4=_this.state,selectedMeasurements=_this$state4.selectedMeasurements,measurements1=_this$state4.measurements1,selectedSizes=_this$state4.selectedSizes;// Check if the item is already selected based on placeofMeasurement
var isSelected=selectedMeasurements.some(function(m){return m.placeofMeasurement===item.placeofMeasurement;});if(isSelected){// Remove the item if already selected
var updatedSelectedMeasurements=selectedMeasurements.filter(function(m){return m.placeofMeasurement!==item.placeofMeasurement;});var updatedMeasurements1=measurements1.filter(function(m){return m.placeofMeasurement!==item.placeofMeasurement;});_this.setState({selectedMeasurements:updatedSelectedMeasurements,measurements1:updatedMeasurements1});}else{// Create the sizes array dynamically based on selectedSizes
var sizes=selectedSizes.map(function(size){return{sizeOftype:size.sizeOftype,awSpec:null,awQA:null,bwSpec:null,bwQA:null};});// Create the new measurement object
var newMeasurement=Object.assign({},item,{tolMinus:"",tolPlus:"",comments:"",sizes:sizes});// Update the state
_this.setState(function(prevState){return{selectedMeasurements:[].concat(_toConsumableArray(prevState.selectedMeasurements),[newMeasurement]),measurements1:[].concat(_toConsumableArray(prevState.measurements1),[newMeasurement])};});}},_this.handleSelectAllPOMs=function(){var _this$state5=_this.state,additionalData=_this$state5.additionalData,selectedMeasurements=_this$state5.selectedMeasurements,selectedSizes=_this$state5.selectedSizes,measurements1=_this$state5.measurements1;// Check if all items are already selected
var allSelected=additionalData.length>0&&selectedMeasurements.length===additionalData.length;if(allSelected){// If all are selected, remove only the selected ones from `selectedMeasurements` and `measurements1`
// Filtering `measurements1` to keep only items that are NOT in `additionalData`
// `.some(...)` checks if `m.placeofMeasurement` exists in `additionalData`
// `!` negates the result to remove matching items (selected ones) while keeping default data
var updatedMeasurements1=measurements1.filter(function(m){return!additionalData.some(function(item){return item.placeofMeasurement===m.placeofMeasurement;});});_this.setState({selectedMeasurements:[],measurements1:updatedMeasurements1// Keep existing default data
});}else{// Select all
var newMeasurements=additionalData.map(function(item){var sizes=selectedSizes.map(function(size){return{sizeOftype:size.sizeOftype,awSpec:null,awQA:null,bwSpec:null,bwQA:null};});return Object.assign({},item,{tolMinus:"",tolPlus:"",comments:"",sizes:sizes});});_this.setState({selectedMeasurements:newMeasurements,measurements1:[].concat(_toConsumableArray(measurements1),_toConsumableArray(newMeasurements))// Append to existing data
});}},_this.handleInputChange=function(index,field,value){var updatedValue=value;if(field==="comments"||field==="dispatchComments"){// Prevent leading spaces and allow only single space between words
updatedValue=value.trimStart().replace(/\s+/g," ");}else{// Apply numeric validation only if it's not "comments"
var regex=/^\d{0,5}(?:\.\d{0,5})?$/;if(!regex.test(value))return;}// Create a copy of measurements1 to avoid direct mutation
var updatedMeasurements=[].concat(_toConsumableArray(_this.state.measurements1));if(field==="sizes"){updatedMeasurements[index].sizes=Object.assign({},updatedMeasurements[index].sizes,updatedValue);}else{updatedMeasurements[index][field]=updatedValue;}// Update the state
_this.setState({measurements1:updatedMeasurements});},_this.handleInputChange1=function(rowIndex,sizeType,field,value){//const regex = /^\d*\.?\d{0,2}$/;
// const regex = /^\d{0,3}(?:\.\d{0,2})?$/;
var regex=/^[-+]?\d{0,3}(?:\.\d{0,2})?$/;if(!regex.test(value))return;var updatedMeasurements=[].concat(_toConsumableArray(_this.state.measurements1));var sizesArray=updatedMeasurements[rowIndex].sizes;var updateSize=Object.assign({},sizesArray[sizeType]);updateSize[field]=value;sizesArray[sizeType]=updateSize;_this.setState({measurements1:updatedMeasurements});},_this.handleShrinkageChange=function(e){var _e$target=e.target,name=_e$target.name,value=_e$target.value;// Destructure name and value from the event target
//const regex = /^\d{0,5}(?:\.\d{0,5})?$/;
var regex=/^\d{0,5}(\.\d{0,5})?$/;if(!regex.test(value))return;_this.setState(function(prevState){return{shrinkagePercentage:Object.assign({},prevState.shrinkagePercentage,_defineProperty({},name,value))};},function(){_this.updateMeasurementChat();// Update the measurement chart after shrinkage change
});},_this.toggleDropdown=function(){_this.setState(function(prevState){return{isOpen1:!prevState.isOpen1};});_this.setState({showDropdown:!_this.state.showDropdown});},_this.handleAddSize=function(size){var isAlreadySelected=_this.state.selectedSizes.some(function(s){return s.sizeOftype===size;});if(isAlreadySelected){// Remove the size if it's already selected
var updatedSelectedSizes=_this.state.selectedSizes.filter(function(s){return s.sizeOftype!==size;});var updatedMeasurements=_this.state.measurements1.map(function(measurement){return Object.assign({},measurement,{sizes:(measurement.sizes||[]).filter(function(s){return s.sizeOftype!==size;})// Ensure sizes is an array
});});_this.setState({selectedSizes:updatedSelectedSizes,measurements1:updatedMeasurements});}else{// Add the size if it's not selected
var newSize={sizeOftype:size,awSpec:"",awQA:"",bwSpec:"",bwQA:""};var _updatedSelectedSizes=[].concat(_toConsumableArray(_this.state.selectedSizes),[newSize]);var _updatedMeasurements=_this.state.measurements1.map(function(measurement){return Object.assign({},measurement,{sizes:[].concat(_toConsumableArray(measurement.sizes||[]),[newSize])// Ensure sizes is an array
});});_this.setState({selectedSizes:_updatedSelectedSizes,measurements1:_updatedMeasurements//showDropdown: false,
});}},_this.saveChart=function(){var _this$state6=_this.state,measurements1=_this$state6.measurements1,shrinkagePercentage=_this$state6.shrinkagePercentage,_id=_this$state6._id;__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].saveMeasurementChar(measurements1,shrinkagePercentage,_id).then(function(res){if(res.status==200){_this.props.getalertMessage("success","Measurement Chart saved successfully");_this.setState({selectedMeasurements:[]});}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});},_this.updateMeasurementChat=function(){// Map through each measurement
var updatedMeasurementChat=_this.state.measurements1.map(function(measurement){// Find the matching label for the shrinkageType (ID)
var shrinkageTypeObj=_this.state.SHRINKAGETYPEOPTIONS.find(function(option){return option.value===measurement.shrinkageType;});var shrinkageLabel=shrinkageTypeObj?shrinkageTypeObj.label:null;var _this$state$shrinkage=_this.state.shrinkagePercentage,lengthPercentage=_this$state$shrinkage.length,widthPercentage=_this$state$shrinkage.width;// If shrinkageType is missing, set bwSpec to "0.00"
if(!shrinkageLabel){return Object.assign({},measurement,{sizes:measurement.sizes.map(function(size){return Object.assign({},size,{bwSpec:"0.00"// Default value
});})});}//console.log(shrinkageLabel, "type"); // Now this will log the label instead of ID
// Perform calculations based on shrinkage type
if(shrinkageLabel==="Length"){var updatedSizes=measurement.sizes.map(function(size){if(size.awSpec!==null){var awSpec=parseFloat(size.awSpec);var shrinkagePercentage=parseFloat(lengthPercentage);if(!isNaN(awSpec)&&!isNaN(shrinkagePercentage)){var bwSpec=awSpec+awSpec*shrinkagePercentage/100;return Object.assign({},size,{bwSpec:bwSpec.toFixed(2)});}}return Object.assign({},size,{bwSpec:"0.00"});// Default if awSpec is invalid
});//console.log(updatedSizes,"size")
return Object.assign({},measurement,{sizes:updatedSizes});}if(shrinkageLabel==="Width"){var _updatedSizes=measurement.sizes.map(function(size){if(size.awSpec!==null){var awSpec=parseFloat(size.awSpec);var shrinkagePercentage=parseFloat(widthPercentage);if(!isNaN(awSpec)&&!isNaN(shrinkagePercentage)){var bwSpec=awSpec+awSpec*shrinkagePercentage/100;return Object.assign({},size,{bwSpec:bwSpec.toFixed(2)});}}return Object.assign({},size,{bwSpec:"0.00"});// Default if awSpec is invalid
});return Object.assign({},measurement,{sizes:_updatedSizes});}return measurement;});//console.log(updatedMeasurementChat,"up")
// Update the state with the modified measurements
_this.setState({measurements1:updatedMeasurementChat});},_this.handleDeleteRow=function(indexToDelete){_this.setState(function(prevState){// Ensure the index exists before trying to access it
if(indexToDelete<0||indexToDelete>=prevState.measurements1.length){return null;// Return null to prevent state update if the index is invalid
}// Extract the deleted item safely
var deletedItem=prevState.measurements1[indexToDelete];// Filter out the deleted row and update the state
var updatedMeasurements=prevState.measurements1.filter(function(_,index){return index!==indexToDelete;});var updatedSelectedMeasurements=prevState.selectedMeasurements.filter(function(m){return m.code!==deletedItem.code;});return{measurements1:updatedMeasurements,selectedMeasurements:updatedSelectedMeasurements};},function(){// Ensure the API call runs after the state update
var _this$state7=_this.state,measurements1=_this$state7.measurements1,shrinkagePercentage=_this$state7.shrinkagePercentage,_id=_this$state7._id;__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].saveMeasurementChar(measurements1,shrinkagePercentage,_id).then(function(res){if(res.status===200){_this.props.getalertMessage("error","Measurement Chart's row deleted");}}).catch(function(error){return _this.props.getalertMessage("error",error.toString());});});},_this.SizeTable=function(_ref3){var row=_ref3.row,index=_ref3.index;var selectedSizes=_this.state.selectedSizes;var state=_this.props.location.state;var header=state?state.header:"Default Header";var isDispatch=header==="Dispatch ";var inputDispatchField=isDispatch?"200px":"";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{style:{// tableLayout: "fixed",
width:"100%",borderSpacing:"0px",borderCollapse:"separate",backgroundColor:"white",marginBottom:index===0?"16px":"0px"}},index===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"53px",padding:"0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:_this.toggleDropdown,style:{padding:"6px 12px",backgroundColor:"#009688",color:"white",border:"none",borderRadius:"4px",cursor:"pointer"},ref:function ref(el){return _this.buttonRef=el;}// Reference to the button
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-plus",style:{fontSize:"12px"}})," "),_this.state.showDropdown&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{style:{position:"fixed",// Use fixed position
top:_this.state.dropdownPosition.top,left:_this.state.dropdownPosition.left,listStyleType:"none",padding:"8px",backgroundColor:"white",border:"1px solid #ddd",borderRadius:"4px",boxShadow:"0 4px 6px rgba(0, 0, 0, 0.1)",maxHeight:"200px",// Set a fixed height for scrolling
overflowY:"auto",// Enable vertical scrolling
zIndex:1000}},_this.state.availableSizes.map(function(size){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:size,style:{padding:"6px 12px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",checked:_this.state.selectedSizes.some(function(s){return s.sizeOftype===size;}),onChange:function onChange(){return _this.handleAddSize(size);},style:{marginRight:"8px",position:"static",// Reset position
left:"auto",// Reset left positioning
opacity:1,cursor:"pointer"}}),size);}))),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{key:sizeIndex,style:{textAlign:"center",width:inputDispatchField}},size.sizeOftype);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{width:"53px"}}),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:sizeIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"row",gap:"6px",alignItems:"center",justifyContent:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awSpec||"",onChange:function onChange(e){_this.handleInputChange1(index,sizeIndex,"awSpec",e.target.value),_this.updateMeasurementChat();},style:{width:"55px",padding:"6px",boxSizing:"border-box"},placeholder:"AW Spec"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwSpec||"",onChange:function onChange(e){return _this.handleInputChange1(index,sizeIndex,"bwSpec",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box"},placeholder:"BW Spec"}),isDispatch&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awQA||"",onChange:function onChange(e){return _this.handleInputChange1(index,sizeIndex,"awQA",e.target.value);},style:{width:"50px",padding:"6px",boxSizing:"border-box"},placeholder:"AW QA"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwQA||"",onChange:function onChange(e){return _this.handleInputChange1(index,sizeIndex,"bwQA",e.target.value);},style:{width:"50px",padding:"6px",boxSizing:"border-box"},placeholder:"BW QA"}))));}))))//</div>
;},_this.SizeTable1=function(_ref4){var row=_ref4.row,index=_ref4.index;// Assuming `row.sizes` is an array of size objects
var sizes=row.sizes||[];// console.log(sizes,"si");
var header=_this.props.location.state.header;// console.log('header:', header, );
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{style:{width:"100%",borderSpacing:"0",borderCollapse:"collapse",// Use collapse for clean borders
backgroundColor:"white",border:"1px solid #000"// Add border to the table
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{border:"1px solid #000",padding:"0px"}},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{border:"1px solid #000",padding:"0px"}},"BW Spec"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{border:"1px solid #000",padding:"0px"}},"AW Spec"),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{border:"1px solid #000",padding:"0px"}},"BWQA"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{border:"1px solid #000",padding:"0px"}},"AWQA")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,sizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:sizeIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"0px"}},size.sizeOftype||"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"0px"}},size.bwSpec||"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"0px"}},size.awSpec),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"0px"}},size.bwQA||"-"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"0px"}},size.awQA||"-")));})));},_this.renderTables=function(){var measurements1=_this.state.measurements1;var state=_this.props.location.state;var header=state?state.header:"Default Header";var isDispatch=header==="Dispatch ";var dispatch=isDispatch?2:4;var sizesPerTable=dispatch;// Adjust the number of sizes per table
var splitData=_this.splitTableData(measurements1,sizesPerTable);return measurements1.map(function(tableData,tableIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:tableIndex,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{style:{width:"100%",borderSpacing:"0",borderCollapse:"collapse",// Use collapse for clean borders
borderRadius:"6px",overflow:"auto",backgroundColor:"white",border:"1px solid #000"// Add border to the table
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"61px",border:"1px solid #000",padding:"8px"}},"Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"81px",border:"1px solid #000",padding:"8px"}},"Description"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"46px",border:"1px solid #000",padding:"8px"}},"TOL (-)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"46px",border:"1px solid #000",padding:"8px"}},"TOL (+)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colSpan:6,style:{width:"auto",height:"30px",border:"1px solid #000",padding:"8px"}},isDispatch?"Size & BW, AW":isDispatch===false?"Size & AW Spec, BW Spec":"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"94px",border:"1px solid #000",padding:"8px"}},"Comments"),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"94px",border:"1px solid #000",padding:"8px"}},"QA/Tech Comments"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:tableIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.code),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.placeofMeasurement),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.tolMinus),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.tolPlus),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:6,style:{border:"1px solid #000",padding:"0"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.SizeTable1,{row:tableData,index:tableIndex})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.comments),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{border:"1px solid #000",padding:"8px"}},tableData.dispatchComments)))));});},_this.downloadExcel=function(id,value){__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].downloadExcel(id,_this.props.location.state.header.toLowerCase().trim());},_this.handleRowChange=function(field,value,index){// Create a copy of the current measurements1 array
var updatedMeasurements=[].concat(_toConsumableArray(_this.state.measurements1));// Update the specific row's field
updatedMeasurements[index][field]=value;// Update the state with the modified measurements1 array
_this.setState({measurements1:updatedMeasurements});},_this.handleBackNavigation=function(){Object(__WEBPACK_IMPORTED_MODULE_8_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref5){var onClose=_ref5.onClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"p-5 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:onClose,className:"close",style:{position:"absolute",right:"40px",top:"15px"}},"X"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Are you sure you want to leave"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Make sure your changes are saved"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%",marginRight:"10px"},onClick:function onClick(){onClose();_this.navigateBack();}},"Yes"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button",className:"primary",style:{width:"20%"},onClick:onClose},"No"));},closeOnClickOutside:false});},_this.navigateBack=function(){var state=_this.props.history.location.state;var route=state&&state.route;// Avoids optional chaining
if(route!==undefined){_this.props.history.push("/"+route,_defineProperty({},route.toLowerCase(),state[route.toLowerCase()]||{}));}else{_this.props.history.goBack();}},_this.handleSRValueSelect=function(selectedOption){if(selectedOption){_this.setState({srValue:selectedOption.label,// just the label to send in the api
srValueObj:selectedOption// entire option object 
});}else{_this.setState({srValue:"",srValueObj:null});}},_this.getSampleRequestList=function(inputValue){if(inputValue==null)return;if(inputValue===""){_this.setState({srList:[]});}__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSampleReqNo(inputValue).then(function(response){if(response.status===200){_this.setState({srList:response.text.data});}}).catch(function(error){console.error("Failed to fetch sample request numbers:",error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MeasurementModal,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;document.addEventListener("mousedown",this.handleClickOutside);this.updateRowHeights();var action=this.props.location.state&&this.props.location.state.action?this.props.location.state.action:null;this.setState({action:action});var _id=this.props.location.state._id;__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].SampleInfo(_id).then(function(response){if(response.status===200){var fetchedMeasurements=response.text.data.measurementChat;//console.log(fetchedMeasurements,"fffff")
// Extract selected sizes from the fetched measurements
var selectedSizes=fetchedMeasurements.flatMap(function(measurement){return measurement.sizes||[];})// Flatten all sizes into a single array
.filter(function(size,index,self// Remove duplicates
){return index===self.findIndex(function(s){return s.sizeOftype===size.sizeOftype;});});// Update the state with fetched measurements and selected sizes
_this3.setState({measurements1:fetchedMeasurements,selectedSizes:selectedSizes,shrinkagePercentage:{length:response.text.data.shrinkagePercentage.length,width:response.text.data.shrinkagePercentage.width}});}}).catch(function(error){console.error("Error fetching data:",error);});// console.log(this.props.location.state.customer, "customer");
//   SampleServices.SampleInfo(_id)
// .then((response) => {
//   if (response.status === 200) {
//     const fetchedMeasurements = response.text.data.measurementChat;
//     // ✅ Skip state update if measurementChat is missing or empty
//     if (!Array.isArray(fetchedMeasurements) || fetchedMeasurements.length === 0) {
//       return;
//     }
//     // Extract selected sizes from the fetched measurements
//     const selectedSizes = fetchedMeasurements
//       .flatMap((measurement) => measurement.sizes || []) // Flatten all sizes into a single array
//       .filter(
//         (size, index, self) =>
//           index === self.findIndex((s) => s.sizeOftype === size.sizeOftype)
//       );
//     // Update the state with fetched measurements and selected sizes
//     this.setState({
//       measurements1: fetchedMeasurements,
//       selectedSizes: selectedSizes,
//       shrinkagePercentage: {
//         length: response.text.data.shrinkagePercentage.length,
//         width: response.text.data.shrinkagePercentage.width,
//       },
//     });
//   }
// })
// .catch((error) => {
//   console.error("Error fetching data:", error);
// });
__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].measurementChatDetails(_id).then(function(response){if(response.status==200){var fetchedMeasurements=response.text.data.measurementChat;// Extract selected sizes from the fetched measurements
var selectedSizes=fetchedMeasurements.flatMap(function(measurement){return measurement.sizes||[];})// Flatten all sizes into a single array
.filter(function(size,index,self// Remove duplicates
){return index===self.findIndex(function(s){return s.sizeOftype===size.sizeOftype;});});// Update the state with fetched measurements and selected sizes
_this3.setState({measurements1:fetchedMeasurements// selectedSizes: selectedSizes,
// shrinkagePercentage: {
//   length: response.text.data.shrinkagePercentage.length,
//   width: response.text.data.shrinkagePercentage.width,
// },
});_this3.setState({Magnumstylename:response.text.data.magnumStyleName,Magnumstyleno:response.text.data.referenceCode,Cusrefno:response.text.data.customerRefNumber,CustomerDept:response.text.data.customerName+"-"+response.text.data.departmentName,SourceOfRequest:response.text.data.sampleRequest,SampleType:response.text.data.sampletype,ItemNo:response.text.data.itemNumber,typeOfRequest:response.text.data.typeOfRequest,GarmentType:response.text.data.garmentType});}});__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].measurementChatDetails(_id).then(function(response){if(response.status==200){_this3.setState({Magnumstylename:response.text.data.magnumStyleName,Magnumstyleno:response.text.data.referenceCode,Cusrefno:response.text.data.customerRefNumber,CustomerDept:response.text.data.customerName+"-"+response.text.data.departmentName,SourceOfRequest:response.text.data.sampleRequest,SampleType:response.text.data.sampletype,ItemNo:response.text.data.itemNumber,typeOfRequest:response.text.data.typeOfRequest,GarmentType:response.text.data.garmentType});}});__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getCustomerData({customer:this.props.location.state.customer,customerDepartmentId:this.props.location.state.customerDepartmentId,type:this.props.location.state.type}).then(function(response){if(response.status==200){var availableSizes=response.text.data.sizes.map(function(size){return size.label.split(" - ")[0].trim();}// Extract and trim the label before " - "
);_this3.setState({availableSizes:availableSizes});}}).catch(function(error){return _this3.props.getalertMessage("error hell",error.toString());});var value={magnumStyleId:this.props.location.state.magnumStyleId,sourceSampleRequestId:this.state._id};__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].addMoreTypeOfSize(value).then(function(response){if(response.status==200){//console.log(response,"addmor")
}});__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].prefillSRDetails().then(function(response){if(response.message==="Operation Successful"){//console.log(response,"res")
_this3.setState({SHRINKAGETYPEOPTIONS:response.data.SAMPLEREQUEST.SHRINKAGETYPE});}}).catch(function(error){console.error("Error fetching details:",error);});//console.log(this.state.SHRINKAGETYPEOPTIONS,"op")
__WEBPACK_IMPORTED_MODULE_4__services__["j" /* SampleServices */].getSampleReqNo("").then(function(response){if(response.status===200){_this3.setState({srList:response.text.data});}response.status==401&&_this3.props.unauthorisedFunc();}).catch(function(error){return _this3.props.getalertMessage("error",error.toString());});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(prevState.measurements1!==this.state.measurements1){this.updateRowHeights();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("mousedown",this.handleClickOutside);}// Close the modal
// Handle input change
// Handle save action (calling API and resetting state)
// openDuplicateModal = () => {
//   confirmAlert({
//     customUI: ({ onClose }) => {
//       return (
//         <div className="custom-ui">
//           <h1>Duplicate File</h1>
//           <label>Sample Request Id</label>
//           <input
//             type="text"
//             value={this.state.srValue.srvalueDup || ""}
//             name="srvalueDup"
//             onChange={ this.handleDupInputChange}
//             placeholder="Enter Sample Request ID"
//           />
//           <div style={{ marginTop: "20px" }}>
//             <button
//               style={{
//                 padding: "4px 14px",
//       backgroundColor: "#009688",
//       color: "white",
//       border: "none",
//       borderRadius: "4px",
//       cursor: "pointer",
//               }}
//               onClick={() => {
//                 this.duplicateMC(); // Call the API
//                 // this.setState({ srValue: "" }); // Reset state
//                 onClose(); // Close the modal
//               }}
//             >
//               Save
//             </button>
//             <button
//               style={{
//                 backgroundColor: "white",
//                 color: "#009688",
//                 border: "1px solid #009688",
//                 borderRadius: "5px",
//                 padding: "4px 14px",
//                 cursor: "pointer",
//               }}
//               onClick={() => {
//                 // this.setState({ srValue: "" }); // Reset state
//                 onClose(); // Close the modal
//               }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       );
//     },
//     closeOnClickOutside: true,
//   });
// };
//   handleAddMore = () => {
//     const value = ({magnumStyleId:this.props.location.state.magnumStyleId,sourceSampleRequestId:this.state._id})
//     SampleServices.addMoreTypeOfSize(value).then(response => {
//       if (response.status === 200) {
//         const newData = response.data; // New data from the API
//         this.mergeMeasurements(newData); // Merge new data with existing measurements
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching add more data:", error);
//     });
// };
// Function to merge new data with existing measurements
// mergeMeasurements = (newData) => {
//   this.setState((prevState) => {
//     const existingMeasurements = prevState.measurements1;
//     // Merge new data with existing measurements
//     const mergedMeasurements = newData.map((newItem) => {
//       // Check if the item already exists in measurements1
//       const existingItem = existingMeasurements.find(
//         (item) => item.code === newItem.code
//       );
//       // If the item exists, preserve its sizes (if any)
//       if (existingItem) {
//         return {
//           ...newItem,
//           sizes: existingItem.sizes || [], // Preserve existing sizes
//         };
//       }
//       // If the item does not exist, add it with an empty sizes array
//       return {
//         ...newItem,
//         sizes: [], // Initialize sizes as an empty array
//       };
//     });
//     // Update the state with merged measurements
//     return {
//       measurements1: mergedMeasurements,
//     };
//   });
// };
// handleAddMore = async () => {
//   try {
//     const value = {
//       magnumStyleId: this.props.location.state.magnumStyleId,
//       sourceSampleRequestId: this.state._id,
//     };
//     const response = await SampleServices.addMoreTypeOfSize(value);
//     if (response.status == 200) {
//       this.setState({
//         additionalData: response.text.data, // Store fetched data
//         showDropdown1: true, // Show the dropdown
//       });
//       console.log(this.state.showDropdown1,"d1")
//     }
//   } catch (error) {
//     console.error("Error fetching additional data:", error);
//   }
// };
// handleAddMore = async () => {
//   const { showDropdown1 } = this.state;
//   this.setState((prevState) => ({
//     isOpen2: !prevState.isOpen2,
//   }));
//   if (!showDropdown1) {
//     try {
//       const value = {
//         magnumStyleId: this.props.location.state.magnumStyleId,
//         sourceSampleRequestId: this.state._id,
//       };
//       const response = await SampleServices.addMoreTypeOfSize(value);
//       if (response.status === 404) {
//         this.props.getalertMessage("error", response.text.message);
//       }
//       if (response.status === 200 && this.state.buttonRef1) {
//         const buttonRect =
//           this.state.buttonRef1.current.getBoundingClientRect();
//         this.setState({
//           additionalData: response.text.data, // Store fetched data
//           showDropdown1: true, // Show the dropdown
//           dropdownPositionAddMore: {
//             top: buttonRect.bottom + window.scrollY, // Set top position
//             left: buttonRect.left + window.scrollX, // Set left position
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching additional data:", error);
//     }
//   } else {
//     // Hide the dropdown if it's already visible
//     this.setState({ showDropdown1: false });
//   }
// };
// handleCheckboxChange = (item) => {
//   const { selectedMeasurements, measurements1, selectedSizes } = this.state;
//   // Check if the item is already selected
//   const isSelected = selectedMeasurements.some((m) => m.code === item.code);
//   if (isSelected) {
//     // Remove the item if already selected
//     const updatedSelectedMeasurements = selectedMeasurements.filter(
//       (m) => m.code !== item.code
//     );
//     const updatedMeasurements1 = measurements1.filter(
//       (m) => m.code !== item.code
//     );
//     //console.log(updatedSelectedMeasurements,"updat")
//     this.setState({
//       selectedMeasurements: updatedSelectedMeasurements,
//       measurements1: updatedMeasurements1,
//     });
//   } else {
//     // Create the sizes array dynamically based on selectedSizes
//     const sizes = selectedSizes.map((size, index) => ({
//       sizeOftype: size.sizeOftype, // Use the sizeOftype from selectedSizes
//       awSpec: null,
//       awQA: null,
//       bwSpec: null,
//       bwQA: null,
//     }));
//     // Create the new measurement object
//     const newMeasurement = {
//       ...item,
//       tolMinus: "",
//       tolPlus: "",
//       comments: "",
//       sizes: sizes, // Add the dynamically created sizes array
//     };
//     // Update the state
//     this.setState((prevState) => ({
//       selectedMeasurements: [
//         ...prevState.selectedMeasurements,
//         newMeasurement,
//       ],
//       measurements1: [...prevState.measurements1, newMeasurement],
//     }));
//   }
// }
// handleSelectAllPOMs = () => {
//   const { additionalData, selectedMeasurements, selectedSizes } = this.state;
//   // Check if all items are already selected
//   const allSelected = additionalData.length > 0 &&
//     selectedMeasurements.length === additionalData.length;
//   if (allSelected) {
//     // If all are selected, clear selections
//     this.setState({
//       selectedMeasurements: [],
//       // measurements1: [],
//     });
//   } else {
//     // Select all
//     const newMeasurements = additionalData.map((item) => {
//       const sizes = selectedSizes.map((size) => ({
//         sizeOftype: size.sizeOftype,
//         awSpec: null,
//         awQA: null,
//         bwSpec: null,
//         bwQA: null,
//       }));
//       return {
//         ...item,
//         tolMinus: "",
//         tolPlus: "",
//         comments: "",
//         sizes: sizes,
//       };
//     });
//     this.setState({
//       selectedMeasurements: newMeasurements,
//       measurements1: newMeasurements,
//     });
//   }
// }
// handleInputChange = (index, field, value) => {
//   const regex = /^\d{0,5}(?:\.\d{0,5})?$/;
//   if (!regex.test(value)) return;
//   const updatedMeasurements = [...this.state.measurements1];
//    if (field === "sizes") {
//      updatedMeasurements[index].sizes = { ...updatedMeasurements[index].sizes, ...value };
//    }else {
//     updatedMeasurements[index][field] = value;
//   }
//   this.setState({ measurements1: updatedMeasurements });
// }
// Handle adding a new size to all rows
// updateMeasurementChat = () => {
//   const updatedMeasurementChat = this.state.measurements1.map(
//     (measurement) => {
//       const { length: lengthPercentage, width: widthPercentage } =
//         this.state.shrinkagePercentage;
//       // If shrinkageType is missing, set bwSpec to "0.00"
//       if (!measurement.shrinkageType) {
//         const updatedSizes = measurement.sizes.map((size) => ({
//           ...size,
//           bwSpec: "0.00", // Default value
//         }));
//         return {
//           ...measurement,
//           sizes: updatedSizes,
//         };
//       }
//       console.log(measurement.shrinkageType,"type")
//       if (measurement.shrinkageType === "LENGTH") {
//         const updatedSizes = measurement.sizes.map((size) => {
//           if (size.awSpec !== null) {
//             const awSpec = parseFloat(size.awSpec);
//             const shrinkagePercentage = parseFloat(lengthPercentage);
//             if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
//               const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
//               return {
//                 ...size,
//                 bwSpec: bwSpec.toFixed(2),
//               };
//             }
//           }
//           return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
//         });
//         return {
//           ...measurement,
//           sizes: updatedSizes,
//         };
//       }
//       if (measurement.shrinkageType === "WIDTH") {
//         const updatedSizes = measurement.sizes.map((size) => {
//           if (size.awSpec !== null) {
//             const awSpec = parseFloat(size.awSpec);
//             const shrinkagePercentage = parseFloat(widthPercentage);
//             if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
//               const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
//               return {
//                 ...size,
//                 bwSpec: bwSpec.toFixed(2),
//               };
//             }
//           }
//           return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
//         });
//         return {
//           ...measurement,
//           sizes: updatedSizes,
//         };
//       }
//       return measurement;
//     }
//   );
//   // Update the state with the modified measurements
//   this.setState({ measurements1: updatedMeasurementChat });
// }
// Size Table Component for inside the main table
// SizeTable1 = ({ row, index, handleSizeChange }) => {
//   const { state } = this.props.location;
//   const header = state ? state.header : "Default Header";
//   const isDispatch = header === "Dispatch ";
//   const inputDispatchField = isDispatch ? "200px" : "";
//   return (
//     <table
//       style={{
//         // tableLayout: "fixed",
//         width: "100%",
//         borderSpacing: "0px",
//         borderCollapse: "separate",
//         backgroundColor: "white",
//         marginBottom: index === 0 ? "16px" : "0px",
//       }}
//     >
//       {index === 0 && (
//         <thead>
//           <tr>
//           {row.sizes.map((size, sizeIndex) => (
//             <th
//               key={sizeIndex}
//               style={{ textAlign: "center", width: inputDispatchField }}
//             >
//               {size.sizeOftype}
//             </th>
//           ))}
//           </tr>
//           <tr>
//           {header !=="Dispatch " &&(
//             <Fragment>
//             {this.state.selectedSizes.map((size, sizeIndex) => (
//             <th>
//               <div
//                   className="aw-bw-header"
//                 >
//                   <div className="">AW Spec</div>
//                   <div className="">BW Spec</div>
//                 </div>
//             </th>
//             ))}
//             </Fragment>
//           )}
//           {header === "Dispatch " && (
//             <Fragment>
//               {this.state.selectedSizes.map((size, sizeIndex) => (
//             <th>
//                <div
//                   className="aw-bw-dis-header"
//                 >
//                   <div className="">AW Spec</div>
//                   <div className="">AW QA</div>
//                   <div className="">BW Spec</div>
//                   <div className="">BW QA</div>
//                 </div>
//             </th>
//               ))}
//             </Fragment>
//           )}
//           </tr>
//         </thead>
//       )}
//       <tbody>
//         <tr>
//           {/* <td style={{ width: "53px" }}></td> */}
//           {row.sizes.map((size, sizeIndex) => (
//             <td key={sizeIndex}>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   gap: "6px",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <p
//                   style={{
//                     width: "50px",
//                     padding: "6px",
//                     // border: "1px solid black",
//                   }}
//                 >
//                   {(row.sizes &&
//                     row.sizes[sizeIndex] &&
//                     row.sizes[sizeIndex].awSpec) ||
//                     "-"}
//                 </p>
//                 <p
//                   style={{
//                     width: "50px",
//                     padding: "6px",
//                     // border: "1px solid black",
//                   }}
//                 >
//                   {(row.sizes &&
//                     row.sizes[sizeIndex] &&
//                     row.sizes[sizeIndex].bwSpec) ||
//                     "-"}
//                 </p>
//                 {isDispatch && (
//                   <React.Fragment>
//                     <p
//                       style={{
//                         width: "50px",
//                         padding: "6px",
//                         // border: "1px solid black",
//                       }}
//                     >
//                       {(row.sizes &&
//                         row.sizes[sizeIndex] &&
//                         row.sizes[sizeIndex].awQA) ||
//                         "-"}
//                     </p>
//                     <p
//                       style={{
//                         width: "50px",
//                         padding: "6px",
//                         // border: "1px solid black",
//                       }}
//                     >
//                       {(row.sizes &&
//                         row.sizes[sizeIndex] &&
//                         row.sizes[sizeIndex].bwQA) ||
//                         "-"}
//                     </p>
//                   </React.Fragment>
//                 )}
//               </div>
//             </td>
//           ))}
//         </tr>
//       </tbody>
//     </table>
//   );
// }
},{key:"splitTableData",// SizeTable1 = ({ row, index }) => {
//   // Assuming `row.sizes` is an array of size objects
//   const sizes = row.sizes || [];
//   // // console.log(sizes,"si");
//   // const header = this.props.location.state.header
//   // console.log('header:', header, );
//   const { state } = this.props.location;
//   const header = state ? state.header : "Default Header";
//   const isDispatch = header === "Dispatch ";
//   const inputDispatchField = isDispatch ? "200px" : "";
//    return (
//      <table
//        style={{
//         // tableLayout: "fixed",
//          width: "100%",
//         borderSpacing: "0px",
//         borderCollapse: "separate",
//         backgroundColor: "white",
//         marginBottom: index === 0 ? "16px" : "0px",
//         border: "1px solid #000", // Add border to the table
//        }}
//      >
//        {index === 0 && (
//         <thead>
//           <tr>
//           {row.sizes.map((size, sizeIndex) => (
//             <th
//               key={sizeIndex}
//               style={{ textAlign: "center", width: inputDispatchField }}
//             >
//               {size.sizeOftype}
//             </th>
//           ))}
//           </tr>
//           <tr>
//           {header !=="Dispatch " &&(
//             <Fragment>
//             {this.state.selectedSizes.map((size, sizeIndex) => (
//             <th>
//               <div
//                   className="aw-bw-header"
//                 >
//                   <div className="">AW Spec</div>
//                   <div className="">BW Spec</div>
//                 </div>
//             </th>
//             ))}
//             </Fragment>
//              )}
//           {header === "Dispatch " && (
//              <Fragment>
//              {this.state.selectedSizes.map((size, sizeIndex) => (
//            <th>
//               <div
//                  className="aw-bw-dis-header"
//                >
//                  <div className="">AW Spec</div>
//                  <div className="">AW QA</div>
//                  <div className="">BW Spec</div>
//                  <div className="">BW QA</div>
//                </div>
//            </th>
//              ))}
//            </Fragment>
//            )}
//            </tr>
//         </thead>
//       )}
//       <tbody>
//         <tr>
//           {/* <td style={{ width: "53px" }}></td> */}
//           {row.sizes.map((size, sizeIndex) => (
//             <td key={sizeIndex}>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   gap: "6px",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <p
//                   style={{
//                     width: "50px",
//                     padding: "6px",
//                     // border: "1px solid black",
//                   }}
//                 >
//                   {(row.sizes &&
//                     row.sizes[sizeIndex] &&
//                     row.sizes[sizeIndex].awSpec) ||
//                     "-"}
//                 </p>
//                 <p
//                   style={{
//                     width: "50px",
//                     padding: "6px",
//                     // border: "1px solid black",
//                   }}
//                 >
//                   {(row.sizes &&
//                     row.sizes[sizeIndex] &&
//                     row.sizes[sizeIndex].bwSpec) ||
//                     "-"}
//                 </p>
//                 {isDispatch && (
//                   <React.Fragment>
//                     <p
//                       style={{
//                         width: "50px",
//                         padding: "6px",
//                         // border: "1px solid black",
//                       }}
//                     >
//                       {(row.sizes &&
//                         row.sizes[sizeIndex] &&
//                         row.sizes[sizeIndex].awQA) ||
//                         "-"}
//                     </p>
//                     <p
//                       style={{
//                         width: "50px",
//                         padding: "6px",
//                         // border: "1px solid black",
//                       }}
//                     >
//                       {(row.sizes &&
//                         row.sizes[sizeIndex] &&
//                         row.sizes[sizeIndex].bwQA) ||
//                         "-"}
//                     </p>
//                   </React.Fragment>
//                 )}
//               </div>
//             </td>
//           ))}
//         </tr>
//        </tbody>
//      </table>
//    );
// }
value:function splitTableData(data,sizesPerTable){var tables=[];var maxSizes=Math.max.apply(Math,_toConsumableArray(data.map(function(row){return row.sizes.length;})));var _loop=function _loop(i){var table=data.map(function(row){return{code:row.code,description:row.placeofMeasurement,tolMinus:row.tolMinus,tolPlus:row.tolPlus,sizes:row.sizes.slice(i,i+sizesPerTable),// Slicing sizes per table
comments:row.comments,actions:row.actions};}).filter(function(row){return row.sizes.length>0;});// Exclude empty size rows
tables.push(table);};for(var i=0;i<maxSizes;i+=sizesPerTable){_loop(i);}return tables;}// getSampleRequestList = (inputValue) => {
//   // Optional: You can debounce this call if needed
//   if (!inputValue) return;
//   SampleServices.getSampleReqNo(inputValue)
//     .then((response) => {
//       if (response.status === 200) {
//         this.setState({
//           srList: response.text.data, 
//         });
//       }
//     })
//     .catch((error) => {
//       console.error("Failed to fetch sample request numbers:", error);
//     });
// }
},{key:"render",value:function render(){var _this4=this;var selectedSizes=this.state.selectedSizes;var _state=this.state,isModalOpen=_state.isModalOpen,srValue=_state.srValue,isOpen1=_state.isOpen1;var state=this.props.location.state;var header=state?state.header:"Default Header";//console.log(header,"header",this.props.location.state.header)
var isDispatch=header==="Dispatch ";var inputDispatchField=isDispatch?"200px":"";//console.log(this.state.selectedMeasurements.length,"selected",this.state.additionalData.length,"add")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"right-section "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 px-0 py-2 ",style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4 nopadding text-left",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"p-2 cursor-hover"// onClick={() => {
//   const route = this.props.history.location.state.route;
//   route
//     ? this.props.history.push(`/${route}`, {
//         [`${route.toLowerCase()}`]: {
//           ...this.props.history.location.state[
//             `${route.toLowerCase()}`
//           ],
//         },
//       })
//     : this.props.history.goBack();
// }}
,onClick:this.handleBackNavigation},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{width:"20px",src:__WEBPACK_IMPORTED_MODULE_3__assets_images_left_arrow_png___default.a,alt:"Back"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{fontWeight:"bold"}},"MEASUREMENT CHART (",header.toUpperCase().trim(),")")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-4",style:{display:"flex",justifyContent:"flex-end",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:function ref(el){return _this4.componentRef=el;},style:{display:"none"},className:"hidden-print"},this.renderTables()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("style",null,"\n    @media print {\n    /* Your previous style */\n      .hidden-print {\n        display: block !important;\n      }\n      table {\n        border: 1px solid #000 !important;\n      }\n      th, td {\n        border: 1px solid #000 !important;\n        padding: 8px !important;\n      }\n      .print-table-container {\n        page-break-inside: avoid; /* Prevent table from splitting across pages */\n      }\n    }\n  ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{backgroundColor:"white",color:"#009688",border:"1px solid #009688",borderRadius:"5px",padding:"4px 14px",cursor:"pointer",display:"flex",alignItems:"center",gap:"5px"},onClick:function onClick(){return _this4.downloadExcel(_this4.state._id);},disabled:this.state.action==="view"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-file-excel-o"})," Excel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{padding:"4px 14px",backgroundColor:"#009688",color:"white",border:"none",borderRadius:"4px",cursor:"pointer"},onClick:this.saveChart,disabled:this.state.action==="view"},"Save"),header!=="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{padding:"4px 14px",backgroundColor:"#009688",color:"white",border:"none",borderRadius:"4px",cursor:"pointer"},onClick:this.openModal,disabled:header==="Dispatch "||this.state.action==="view"},"Duplicate")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__customModal_CustomModal__["a" /* default */],{isOpen:isModalOpen,onClose:this.closeModal,onSave:this.duplicateMC,srValue:srValue,srValueObj:this.state.srValueObj,sampleRequestList:this.state.srList,getSampleRequestList:this.getSampleRequestList,handleSRValueSelect:this.handleSRValueSelect// handleInputChange={this.handleDupInputChange}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"row",justifyContent:"space-between",// even space between items
alignItems:"flex-start",width:"100%",padding:"10px 34px",boxSizing:"border-box",textAlign:"center"}},[{label:"Magnum Style No",value:this.state.Magnumstyleno},{label:"Magnum Style Name",value:this.state.Magnumstylename},{label:"Customer / Dept",value:this.state.CustomerDept},{label:"Cus Ref.No",value:this.state.Cusrefno},{label:"Garment Type",value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.capitalize(this.state.GarmentType||"")},{label:"Source of Request",value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.capitalize(this.state.typeOfRequest||"")},{label:"Sample type",value:this.state.SampleType},{label:"SR No",value:this.state.SourceOfRequest}].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index,style:{flex:1,// Evenly distribute space
padding:"0 10px",// Optional spacing between items
minWidth:0,// Prevent overflow
wordBreak:"break-word"// Wrap long words
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,item.label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{whiteSpace:"normal"}},item.value||""));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"",style:{width:"96%",// height: "99px",
display:"flex",alignItems:"flex-start",boxSizing:"border-box",boxShadow:"0px 0px 20px 0px rgba(0, 0, 0, 0.1)",marginLeft:"32px",marginBottom:"5px",paddingBottom:"8px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"shrinkLabel"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"col-form-label font-weight-bold"},"Shrinkage Percentage:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:"80%",display:"flex",gap:"15px",alignItems:"center"// height: "78px",
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"5px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"form-label"},"Length(%)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",placeholder:"Length (%)",name:"length",value:this.state.shrinkagePercentage.length||"",onChange:this.handleShrinkageChange,disabled:header==="Dispatch "||this.state.action==="view",style:{width:"120px",padding:"6px 10px",border:"1px solid",borderRadius:"4px",boxSizing:"border-box",fontSize:"12px"// height: "32px",
}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"5px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"form-label"},"Width(%)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",placeholder:"Width (%)",name:"width",value:this.state.shrinkagePercentage.width||"",onChange:this.handleShrinkageChange,disabled:header==="Dispatch "||this.state.action==="view",style:{width:"120px",padding:"6px 10px",border:"1px solid",borderRadius:"4px",boxSizing:"border-box",fontSize:"12px"// height: "32px",
}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"table-container1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"tableWrapper leftBody"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{scope:"col",style:{fontSize:"14px",padding:"0px"}},"Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{scope:"col",style:{fontSize:"14px",padding:"0px"}},"Description"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{fontSize:"14px"}},"Shrinkage"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{fontSize:"14px",paddingRight:"5px"}},"TOL (-)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{fontSize:"14px"}},"TOL (+)")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{height:"49px"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.measurements1&&this.state.measurements1.length>0?this.state.measurements1.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:index,style:{backgroundColor:index%2==0?"#F2F2EF":"white"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"p-0",style:{fontSize:"12px",fontWeight:"400px"}},row.code),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:" h-54px",style:{fontSize:"12px",fontWeight:"400px",maxWidth:"330px",wordWrap:"break-word",padding:"0px 9px",textAlign:"left"}},row.placeofMeasurement),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"",style:{textAlign:"left",padding:"5px 5px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"w-50-p-4",value:row.shrinkageType,onChange:function onChange(e){_this4.handleRowChange("shrinkageType",e.target.value,index);_this4.updateMeasurementChat();},disabled:header==="Dispatch "||_this4.state.action==="view",style:{border:row.shrinkageType?"1px solid #ddd":"1px solid red"// Red border if empty
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{value:""},"-select-"),_this4.state.SHRINKAGETYPEOPTIONS&&_this4.state.SHRINKAGETYPEOPTIONS.map(function(option,idx){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:idx,value:option.value},option.label);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{padding:"5px 5px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.tolMinus,onChange:function onChange(e){return _this4.handleInputChange(index,"tolMinus",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},disabled:header==="Dispatch "||_this4.state.action==="view"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{padding:"0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.tolPlus,onChange:function onChange(e){return _this4.handleInputChange(index,"tolPlus",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},disabled:header==="Dispatch "||_this4.state.action==="view"})));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"2"},"No Data Available")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"tableWrapper sizesBody"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{colspan:"50%",style:{fontSize:"14px",padding:"0px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{position:"sticky",left:header==="Dispatch "?"33%":"20%",width:"200px"}},isDispatch?"Size & BW, AW":isDispatch===false?"Size & AW Spec, BW Spec":"Size"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{width:"53px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"dropdownButton",onClick:this.toggleDropdown,style:{padding:"1px 5px",borderColor:isOpen1?"lightcoral":"#009688",marginBottom:"5px"},ref:this.state.buttonRef2,disabled:header==="Dispatch "||this.state.action==="view"||this.state.measurements1.length<1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(isOpen1?"fa-close":"fa-plus"),style:{fontSize:"12px",color:isOpen1?"rgba(244, 67, 54, 1)":"#009688"}})),this.state.showDropdown&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{style:{position:"absolute",top:"100%",left:0,listStyleType:"none",padding:"8px",backgroundColor:"white",border:"1px solid #ddd",borderRadius:"4px",boxShadow:"0 4px 6px rgba(0, 0, 0, 0.1)",maxHeight:this.state.measurements1.length>=3?"230px":"127px",// Set a fixed height for scrolling
overflowY:"auto",// Enable vertical scrolling
overflowX:"hidden",// Disable horizontal scrolling
zIndex:1000},ref:this.state.dropdownRef1},this.state.availableSizes.map(function(size){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:size,style:{padding:"6px 12px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",checked:_this4.state.selectedSizes.some(function(s){return s.sizeOftype===size;}),onChange:function onChange(){return _this4.handleAddSize(size);},style:{marginRight:"8px",position:"static",// Reset position
left:"auto",// Reset left positioning
opacity:1,cursor:"pointer"}}),size);}))),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{key:sizeIndex,style:{textAlign:"center",width:inputDispatchField,fontSize:"14px"}},size.sizeOftype);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{fontSize:"14px",padding:"0px"}},header!=="Dispatch "?"Comments":"Pattern Comments"),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{style:{fontSize:"14px",padding:"0px",textAlign:"center",fontWeight:"600"}},"QA/Tech Comments")),header!=="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{// style={{
//   display: "flex",
//   flexDirection: "row",
//   gap: "6px",
//   alignItems: "center",
//   justifyContent: "center",
//   padding: "10px",
// }}
className:"aw-bw-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"AW Spec"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"BW Spec")));})),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{// style={{
//   display: "flex",
//   flexDirection: "row",
//   gap: "10px",
//   alignItems: "center",
//   justifyContent: "center",
//   padding: "",
// }}
className:"aw-bw-dis-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"AW Spec"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"AW QA"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"BW Spec"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""},"BW QA")));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.measurements1&&this.state.measurements1.length>0?this.state.measurements1.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{style:{backgroundColor:_this4.state.selectedSizes&&_this4.state.selectedSizes.length>0?index%2==0?"#F2F2EF":"white":"white"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"hei",style:{width:"53px",padding:"0px"}}),selectedSizes.map(function(size,sizeIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,header!=="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:sizeIndex,className:"p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{// style={{
//   display: "flex",
//   flexDirection: "row",
//   gap: "6px",
//   alignItems: "center",
//   justifyContent: "center",
//   padding: "10px",
// }}
className:"aw-bw"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awSpec||"",onChange:function onChange(e){_this4.handleInputChange1(index,sizeIndex,"awSpec",e.target.value),_this4.updateMeasurementChat();},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},placeholder:"AW Spec",disabled:header==="Dispatch "||_this4.state.action==="view",className:"sizes-aw"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwSpec||"",onChange:function onChange(e){return _this4.handleInputChange1(index,sizeIndex,"bwSpec",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},placeholder:"BW Spec",disabled:header==="Dispatch "||_this4.state.action==="view",className:"sizes-aw"}))),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{key:sizeIndex,className:"p-0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{// style={{
//   display: "flex",
//   flexDirection: "row",
//   gap: "6px",
//   alignItems: "center",
//   justifyContent: "center",
//   padding: "10px",
// }}
className:"aw-bw-dis"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awSpec||"",onChange:function onChange(e){_this4.handleInputChange1(index,sizeIndex,"awSpec",e.target.value),_this4.updateMeasurementChat();},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},placeholder:"AW Spec",disabled:header==="Dispatch "||_this4.state.action==="view",className:"sizes-aw"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awQA||"",onChange:function onChange(e){return _this4.handleInputChange1(index,sizeIndex,"awQA",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",// border: "1px solid",
border:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awSpec&&row.sizes[sizeIndex].awQA&&parseFloat(row.sizes[sizeIndex].awSpec||0)==parseFloat(row.sizes[sizeIndex].awQA||0)?"2px solid":"1px solid",fontSize:"12px",//   borderColor:
//   row.sizes &&
//   row.sizes[sizeIndex] &&
//   row.sizes[sizeIndex].awSpec &&
//   row.sizes[sizeIndex].awQA
//     ? parseFloat(row.sizes[sizeIndex].awSpec || 0) >=
//       parseFloat(row.sizes[sizeIndex].awQA || 0)
//       ? "lightgreen"
//       : "red"
//     : "black", 
// }}
borderColor:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].awSpec&&row.sizes[sizeIndex].awQA?parseFloat(row.sizes[sizeIndex].awSpec||0)===parseFloat(row.sizes[sizeIndex].awQA||0)?"lightgreen"// ✅ Equal → Light Green
:parseFloat(row.sizes[sizeIndex].awSpec||0)>parseFloat(row.sizes[sizeIndex].awQA||0)?"blue"// ✅ Greater → Red
:"red"// ✅ Less → Blue
:"black"// Default color if values are missing
},placeholder:"AW QA",disabled:_this4.state.action==="view",className:"sizes-aw"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwSpec||"",onChange:function onChange(e){return _this4.handleInputChange1(index,sizeIndex,"bwSpec",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px"},placeholder:"BW Spec",disabled:header==="Dispatch "||_this4.state.action==="view",className:"sizes-aw"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",value:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwQA||"",onChange:function onChange(e){return _this4.handleInputChange1(index,sizeIndex,"bwQA",e.target.value);},style:{width:"55px",padding:"6px",boxSizing:"border-box",borderRadius:"4px",// border: "1px solid",
border:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwSpec&&row.sizes[sizeIndex].bwQA&&parseFloat(row.sizes[sizeIndex].bwSpec||0)==parseFloat(row.sizes[sizeIndex].bwQA||0)?"2px solid"// ✅ 
:"1px solid",// Default border-radius
fontSize:"12px",borderColor:row.sizes&&row.sizes[sizeIndex]&&row.sizes[sizeIndex].bwSpec&&row.sizes[sizeIndex].bwQA?parseFloat(row.sizes[sizeIndex].bwSpec||0)===parseFloat(row.sizes[sizeIndex].bwQA||0)?"lightgreen"// ✅ Equal → Light Green
:parseFloat(row.sizes[sizeIndex].bwSpec||0)>parseFloat(row.sizes[sizeIndex].bwQA||0)?"blue"// ✅ Greater → Red
:"red"// ✅ Less → Blue
:"black"// Default color if values are missing
},placeholder:"BW QA",disabled:_this4.state.action==="view",className:"sizes-aw"})))));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{padding:"5px 5px",fontSize:"12px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{value:row.comments,onChange:function onChange(e){var trimmedValue=e.target.value.replace(/^\s+/,"");_this4.handleInputChange(index,"comments",trimmedValue);},maxLength:75,style:{padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px",width:"250px"},disabled:_this4.state.action==="view"||header==="Dispatch ",placeholder:"Comments"})),header==="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{style:{padding:"0px",fontSize:"12px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{value:row.dispatchComments,onChange:function onChange(e){var trimmedValue=e.target.value.replace(/^\s+/,"");_this4.handleInputChange(index,"dispatchComments",trimmedValue);},maxLength:75,style:{padding:"6px",boxSizing:"border-box",borderRadius:"4px",border:"1px solid",fontSize:"12px",width:"420px"},disabled:_this4.state.action==="view",placeholder:"Dispatch Comments"})),header!=="Dispatch "&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:function onClick(){return _this4.handleDeleteRow(index);},style:{backgroundColor:"rgba(244, 67, 54, 0.1)",color:"rgba(244, 67, 54, 1)",border:"none",borderRadius:"50%",width:"24px",height:"24px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:"700"},disabled:_this4.state.action==="view"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-close",style:{fontSize:"12px"}}))));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{margin:"10px",marginLeft:"34px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"addmoreButton",onClick:this.handleAddMore,disabled:this.state.action==="view"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Add More"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-plus",style:{fontSize:"12px"}})),this.state.showModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-overlay"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-content1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-times",onClick:function onClick(){return _this4.setState({showModal:false});},style:{position:"absolute",top:"10px",right:"10px",fontSize:"18px",cursor:"pointer",color:"#555"},"aria-label":"Close modal"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"Select POMs"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{position:"relative",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",className:"form-control",placeholder:"Search Code or Measurement",value:this.state.modalSearchInput||"",onChange:function onChange(e){return _this4.setState({modalSearchInput:e.target.value});},style:{width:"100%",padding:"5px 30px 5px 10px",// space for clear icon
borderRadius:"4px",border:"1px solid #ccc"}}),this.state.modalSearchInput&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-times",onClick:function onClick(e){e.stopPropagation();_this4.setState({modalSearchInput:""});},style:{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",cursor:"pointer",color:"#777"},"aria-label":"Clear search"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-table-container scrolle"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"modal-table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"checkbox-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",onChange:this.handleSelectAllPOMs,checked:this.state.additionalData.length>0&&this.state.selectedMeasurements.length===this.state.additionalData.length,style:{// marginRight: "8px",
position:"static",// Reset position
left:"auto",// Reset left positioning
opacity:1,cursor:"pointer",marginBottom:"0px",width:"auto"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",{className:"wd-80"},"Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Description"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.state.additionalData.length>0?// this.state.additionalData.map((item) => (
this.state.additionalData.filter(function(item){var search=(_this4.state.modalSearchInput||"").toLowerCase();return item.code.toLowerCase().includes(search)||item.placeofMeasurement.toLowerCase().includes(search);}).map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:item.placeofMeasurement},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"checkbox-col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",checked:_this4.state.selectedMeasurements.some(function(m){return m.placeofMeasurement===item.placeofMeasurement;}),onChange:function onChange(){return _this4.handleCheckboxChange(item);},style:{// marginRight: "8px",
position:"static",// Reset position
left:"auto",// Reset left positioning
opacity:1,cursor:"pointer",marginBottom:"0px",width:"auto"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"wd-80"},item.code),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,item.placeofMeasurement));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{colSpan:"3",className:"modal-no-data"},"No data available"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:function onClick(){return _this4.setState({showModal:false});},className:"modal-close"},"OK"))))));}}]);return MeasurementModal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MeasurementModal);

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CutomModal_css__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CutomModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CutomModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
// Custom CSS for the modal
var CustomModal=function CustomModal(_ref){var isOpen=_ref.isOpen,onClose=_ref.onClose,onSave=_ref.onSave,srValue=_ref.srValue,srValueObj=_ref.srValueObj,getSampleRequestList=_ref.getSampleRequestList,handleSRValueSelect=_ref.handleSRValueSelect,sampleRequestList=_ref.sampleRequestList,handleInputChange=_ref.handleInputChange;// getSampleRequestList = (inputValue) => {
//   SampleServices.getSampleReqNo(inputValue)
//     .then((response) => {
//       if (response.status === 200) {
//         this.setState({
//           sampleRequestList: response.text.data, // assuming format: [{ label, value }]
//         });
//       }
//     })
//     .catch((err) => {
//       console.error("Failed to fetch sample request numbers", err);
//     });
// };
if(!isOpen)return null;// If modal is not open, don't render
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'close-button',style:{position:"absolute",top:"4px",right:"10px",background:"none",border:"none",fontSize:"26px",cursor:"pointer"},onClick:onClose// Close the modal when clicked
},' x'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Duplicate File'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginBottom:"10px",fontWeight:"600"}},'Sample Request Id'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'customCompAsync'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:'srvalueDup',value:srValueObj||null,onInputChange:getSampleRequestList,onMenuOpen:function onMenuOpen(){return getSampleRequestList("");},onChange:handleSRValueSelect,placeholder:'Find Sample Request No.',options:sampleRequestList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{padding:"4px 14px",backgroundColor:"#009688",color:"white",border:"none",borderRadius:"4px",cursor:"pointer"},onClick:onSave// Call the save function
},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{backgroundColor:"white",color:"#009688",border:"1.5px solid #009688",borderRadius:"5px",padding:"4px 14px",cursor:"pointer"},onClick:onClose// Close modal on cancel
},'Cancel'))));};/* harmony default export */ __webpack_exports__["a"] = (CustomModal);

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sampleMobileApp_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sampleMobileApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sampleMobileApp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_MobileApp_back_png__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_MobileApp_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_MobileApp_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_MobileApp_logout_png__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_MobileApp_logout_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_MobileApp_logout_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_qr_png__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_qr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_qr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_warning_svg__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_common_options__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MobileAppFields__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MobileFileUpload__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MobileHeader__ = __webpack_require__(982);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var allProceses=["sample","cad","fabric","trim","pattern","cutting","sewing","embellishment","embroidery","marker","costing","signOff","dispatch","garmentTechnologist","qc","wash"];var SampleMobileApp=function(_Component){_inherits(SampleMobileApp,_Component);function SampleMobileApp(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SampleMobileApp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SampleMobileApp.__proto__||Object.getPrototypeOf(SampleMobileApp)).call.apply(_ref,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SampleMobileApp,[{key:"componentWillMount",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this2=this;var _id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// let sampleRequest = { ...this.state.sampleRequest };
//console.log(this.props.location.state._id,"props")
_id=this.props.location.state._id||"";_context2.next=3;return __WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].SampleInfo(_id).then(function(response){if(response.status==200){_this2.setState({sampleRequest:response.text.data});var sampleRequest=Object.assign({},_this2.state.sampleRequest);if(response.text.data.sample.data.length===0){sampleRequest.sample.data=[{size:null,quantity:null}];}if(response.text.data.garmentTechnologist.sampleForm.length===0){sampleRequest.garmentTechnologist.sampleForm=[{comments:"",fab:false,trims:false,workManShip:false,buyerChanges:false,pat:false,remarks:""}];}if(response.text.data.pattern.logs.length===0){sampleRequest.pattern.logs=[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}];}if(response.text.data.cutting.logs.length===0){sampleRequest.cutting.logs=[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}];}sampleRequest.processUpdates=Object.assign({},response.text.data.processUpdates);_this2.getMagnumStyleById(sampleRequest.styleReferenceId);_this2.setState({sampleRequest:sampleRequest,_id:response.text.data._id,createdAt:response.text.data.createdAt},function(){//this.getAssignedTo()
_this2.getStyleReferenceInfo(_this2.state.sampleRequest.styleReferenceId);});}});case 3:_context2.next=5;return __WEBPACK_IMPORTED_MODULE_13__services__["d" /* CustomerServices */].customerInfo().then(function(response){//console.log(response.message,"mess")
if(response.text.message=="all customer details"){//console.log(response,"res")
_this2.setState({customerList:response.text.data// customerId: response.data[0]._id,
// departmentId: response.data[0].departmentId
});}}).catch(function(error){_this2.props.getalertMessage("error",error.toString());});case 5:_context2.next=7;return this.waitForStateToUpdate();case 7:_context2.next=9;return __WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].prefillSRDetails().then(function(response){if(response.message==="Operation Successful"){var sampleRequest=Object.assign({},_this2.state.sampleRequest);sampleRequest.embroidery.leftData=[].concat(_toConsumableArray(response.data.SYSTEMSAMPLEREQUEST.LEFTVALUES));_this2.setState({sampleRequest:sampleRequest,// sampleRequestType,
prefillInfo:response.data,styleInfo:response.data.Style,fabricInfo:response.data.Fabric,trimInfo:response.data.Trims});var prefillInfo=_this2.state.prefillInfo;// Trim Category for Trim Module
var trimCategory=prefillInfo.TRIM.TRIMCATEGORY&&prefillInfo.TRIM.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;// Trim Category for Sewing Module
var trimCategorySewing=prefillInfo.TRIM.TRIMCATEGORY&&prefillInfo.TRIM.TRIMCATEGORY.filter(function(x){return x.label.toUpperCase()==="THREAD ELASTIC";})[0];// sampleRequest.trim.row1 = sampleRequest.trim.row1.map(x => {
//   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
//   return x
// })
// sampleRequest.trim.row2 = sampleRequest.trim.row2.map(x => {
//   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
//   return x
// })
sampleRequest.sewing.trimData=sampleRequest.sewing.trimData.map(function(x){x.trimCategory=x.trimCategory?x.trimCategory:trimCategorySewing;return x;});// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row1 &&
//   sampleRequest.trim.row1.length > 0
// ) {
//   sampleRequest.trim.row1.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row1[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
if(sampleRequest.sewing&&sampleRequest.sewing.trimData&&sampleRequest.sewing.trimData.length){sampleRequest.sewing.trimData.forEach(function(x,i){if(x.trimCategory){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(x.trimCategory).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:sampleRequest.sewing.trimData[i].trimList=response.text.data;case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});}});}// if (
//   sampleRequest.trim &&
//   sampleRequest.trim.row2 &&
//   sampleRequest.trim.row2.length > 0
// ) {
//   sampleRequest.trim.row2.forEach((x, i) => {
//     if (x.trimCategory) {
//       SampleServices.getTrimNumber(x.trimCategory)
//         .then(async response => {
//           sampleRequest.trim.row2[i].trimList = response.text.data
//         })
//         .catch(error => alert(error.toString()))
//     }
//   })
// }
// sampleRequest.wash.washData[0].price =
//   prefillInfo.WASH.PRICEPERKG[0].label
// sampleRequest.wash.washData = sampleRequest.wash.washData.map((x)=>{
//   x.price = x.price ? x.price : prefillInfo.WASH.PRICEPERKG[0].label
// })
// this.setState({ sampleRequest })
}}).catch(function(error){_this2.props.getalertMessage("error",error.toString());});case 9:_context2.next=11;return __WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getCustomerData({customer:this.state.sampleRequest&&this.state.sampleRequest.customer,customerDepartmentId:this.state.sampleRequest&&this.state.sampleRequest.customerDepartmentId,type:this.state.sampleRequest&&this.state.sampleRequest.typeOfRequest}).then(function(response){if(response.status==200){_this2.setState({sizeList:response.text.data.sizes});}}).catch(function(error){return _this2.props.getalertMessage("error hell",error.toString());});case 11:this.getCADRefNumber("");case 12:case"end":return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _ref2.apply(this,arguments);}return componentWillMount;}()},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;window.addEventListener("scroll",this.handleScroll);//   this.handleTouchMove = (event) => {
//     if (event.scale !== 1) {
//         event.preventDefault();
//     }
// };
// document.addEventListener("touchmove", this.handleTouchMove, { passive: false });
// CustomerServices.customerInfo()
//       .then(response => {
//         if (response.status === 200) {
//           this.setState({
//             customerList: response.text.data
//             // customerId: response.data[0]._id,
//             // departmentId: response.data[0].departmentId
//           });
//         }
//       })
//       .catch(error => {
//         this.props.getalertMessage("error", error.toString());
//       });
__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getCustomerData({customer:this.state.sampleRequest&&this.state.sampleRequest.customer,customerDepartmentId:this.state.sampleRequest&&this.state.sampleRequest.customerDepartmentId,type:this.state.sampleRequest&&this.state.sampleRequest.typeOfRequest}).then(function(response){if(response.status==200){_this3.setState({sizeList:response.text.data.sizes});}}).catch(function(error){return _this3.props.getalertMessage("error hell",error.toString());});var data1=[];if(this.state.sampleRequest&&this.state.sampleRequest.sample&&this.state.sampleRequest.sample.data){data1=this.state.sampleRequest.sample.data.filter(function(x){return x.size;})// Ensures only valid sizes are processed
.map(function(x){return{label:x.size};});// Transforms the array
}this.setState({cuttingSizes:data1});__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].prefillDataCadSystem().then(function(res){if(res.status===200){_this3.setState({cadPreFill:{CADTYPE:res.text.data.CADTYPE,PRINTEMBTYPE:res.text.data.PRINTEMBTYPE,BORDERTYPE:res.text.data.BORDERTYPE}});}});__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getFabricNumber("").then(function(response){if(response.status==200){_this3.setState({fabricList:response.text.data});}}).catch(function(error){});// Hide loader after 5 seconds
setTimeout(function(){_this3.setState({isLoading:false});},5000);// this.getMagnumStyleNo("");
}// componentDidUpdate(prevProps, prevState) {
//   if (this.state.is3D && !prevState.is3D) {
//     if (this.state.is3DTextRef.current) {
//       this.state.is3DTextRef.current.focus();
//     }
//   }
// }
// componentDidMount() {
// }
},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("scroll",this.handleScroll);// document.removeEventListener("touchmove", this.handleTouchMove);
}// handleToggleDropdown = (key) =>{
//     this.setState((prevState)=>({
//         [key]: !prevState[key],
//     }))
// };
//   handleToggleDropdown = (key) => {
//     this.setState((prevState) => {
//         // If the clicked key is already open, close it
//         const isCurrentlyOpen = prevState[key];
//         return {
//             isSample: false,
//             is3D: false,
//             isFabric: false,
//             isTrim: false,
//             isPattern: false,
//             isCutting: false,
//             isSewing: false,
//             isMarker: false,
//             isEmbellishment: false,
//             isEmbroidery: false,
//             isWash: false,
//             isDispatch: false,
//             isGrading: false,
//             isSignOff: false,
//             [key]: !isCurrentlyOpen, // Toggle only the clicked key
//         };
//     });
// }
// updateSampleRequest = (name, value) => {
//   this.setState((prevState) => ({
//     sampleRequest: {
//       ...prevState.sampleRequest,
//       [name]: value, // Dynamically updates the correct key
//     },
//   }));
// };
//toggle update
// toggleChange = (name, value) => {
//   let sampleRequest = { ...this.state.sampleRequest };
//   sampleRequest.toggle[name] = value;
//   this.setState([sampleRequest]);
// };
},{key:"validateArrayObject",value:function validateArrayObject(data,key,val){var values=data.filter(function(x){return x[key]==val;}).length===0?true:false;return values;}},{key:"validateArrayObjectTrim",value:function validateArrayObjectTrim(data,key,val){var values=data.filter(function(x){return x[key]==val;}).length===0?true:false;return values;}// common for pattern,sewing,cutting
// logOut() {
//         localStorage.removeItem("authToken");
//         localStorage.clear();
//          //this.props.signOut();
//         this.props.history !== undefined && this.props.history.push("/login")
//     }
},{key:"render",value:function render(){var _this4=this;// console.log(this.state.prefillInfo.SAMPLEREQUEST,"test")
// console.log(this.state.sampleRequest,"sa")
//console.log(this.state.sampleRequest.cad,"cad")
//console.log(this.state.cuttingSizes,"csize")
//console.log(this.props,"props");
if(this.state.isLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Common_Loading__["a" /* default */],null);// Show loading screen while isLoading is true
}else if(this.props.rights.sampleRequest.sampleRequest.web.edit===false){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"un-auth"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_warning_svg___default.a,alt:"warning"}),"You are not authorized to edit the Sample Request",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{style:{marginTop:"20px"},className:"sv-btn",onClick:function onClick(){var route=_this4.props.history.location.state&&_this4.props.history.location.state.route;route!==undefined?_this4.props.history.push("/"+route,_defineProperty({},""+route.toLowerCase(),Object.assign({},_this4.props.history.location.state[""+route.toLowerCase()]))):_this4.props.history.goBack();}},"Ok"));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"zoom-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__MobileHeader__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"samplemain-div",ref:this.orgReqRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"topdiv"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrdiv"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"qrhead"},this.state.sampleRequest.requestNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"center",marginTop:"5px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrimg"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:this.state.sampleRequest.qr,alt:"qr"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrrightdiv"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Magnum Style No.*"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"styleReferenceId",value:this.state.sampleRequest.styleReferenceId,onInputChange:function onInputChange(value){return _this4.getMagnumStyleNo(value);}//  onMenuOpen={() => this.getMagnumStyleNo("")}
,onChange:function onChange(val){return _this4.getStyleReferenceInfo(val!==null?val.value:null);},placeholder:"Find Style",options:this.state.styleNoInfo// disabled={this.state.disabled}
,onSelectResetsInput:false,onBlurResetsInput:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Magnum Style Name*",inputType:"text",value:this.state.sampleRequest.magnumStyleName,disabled:true})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrbottomdiv"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrb-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Cust Ref No.",inputType:"text",value:this.state.sampleRequest.customerRefNumber,disabled:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Cust-Dept*"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"dropdown1",value:this.state.sampleRequest.customer+"-"+this.state.sampleRequest.customerDepartmentId,disabled:true,style:{backgroundColor:"#eee",cursor:"not-allowed"}},this.state.customerList.map(function(customer,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:index,id:"select",title:customer.customerName+"-"+customer.departmentName,name:index,value:customer._id+"-"+customer.departmentId},customer.customerName,"-",customer.departmentName);})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qrb-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Source of Request*",inputName:"typeOfRequest",value:this.state.sampleRequest.typeOfRequest,onChange:this.updateSampleRequest,options:__WEBPACK_IMPORTED_MODULE_15__services_common_options__["a" /* default */].typeOfRequest,inputType:"select"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Sample Type*",inputName:"sampleType",value:this.state.sampleRequest.sampleType||"",onChange:this.updateSampleRequest,options:this.state.prefillInfo.SAMPLEREQUEST&&this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE||[],inputType:"select"})))),this.state.showStickyHeader&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{position:"fixed",top:0,left:0,right:0,backgroundColor:"#fff",zIndex:1000,padding:"10px 20px",boxShadow:"0 2px 6px rgba(0, 0, 0, 0.1)"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field mobileAppAsync"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"styleReferenceId",value:this.state.sampleRequest.styleReferenceId,onInputChange:function onInputChange(value){return _this4.getMagnumStyleNo(value);}// onMenuOpen={() => this.getMagnumStyleNo("")}
,onChange:function onChange(val){return _this4.getStyleReferenceInfo(val!==null?val.value:null);},placeholder:"Find Style",options:this.state.styleNoInfo})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"text",value:this.state.sampleRequest.magnumStyleName,disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"text",value:this.state.sampleRequest.customerRefNumber,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{className:"dropdown1",value:this.state.sampleRequest.customer+"-"+this.state.sampleRequest.customerDepartmentId,disabled:true,style:{backgroundColor:"#eee",cursor:"not-allowed",width:"100%"}},this.state.customerList.map(function(customer,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:index,title:customer.customerName+"-"+customer.departmentName,value:customer._id+"-"+customer.departmentId},customer.customerName,"-",customer.departmentName);})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputName:"typeOfRequest",value:this.state.sampleRequest.typeOfRequest,onChange:this.updateSampleRequest,options:__WEBPACK_IMPORTED_MODULE_15__services_common_options__["a" /* default */].typeOfRequest,inputType:"select"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sticky-form-field"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputName:"sampleType",value:this.state.sampleRequest.sampleType||"",onChange:this.updateSampleRequest,options:this.state.prefillInfo.SAMPLEREQUEST&&this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE||[],inputType:"select"}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"req"},"Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"org-req"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",style:{marginBottom:"6px"}},"Origination of Request\xA0*"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{"class":"dropdown1",value:this.state.sampleRequest.originationOfRequest,onChange:function onChange(e){return _this4.updateSampleRequest("originationOfRequest",e.target.value);}},this.state.prefillInfo.SAMPLEREQUEST&&this.state.prefillInfo.SAMPLEREQUEST.ORIGINATIONOFREQUEST?this.state.prefillInfo.SAMPLEREQUEST.ORIGINATIONOFREQUEST.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:i,value:data.value},data.label);}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mgtec"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mgtec-label"},"Magnum Technologist"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mgtec-val"},this.state.sampleRequest.magnumTechnologist)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"dacr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"dacr-label"},"Date Created"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"dacr-val"},__WEBPACK_IMPORTED_MODULE_17_moment___default()(this.state.sampleRequest.orderDate).format("HH:mm DD MMM YYYY"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"samp-but"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"but-sam",onClick:this.createSample},"Create Request")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"but-sam1"},"Duplicate"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sample-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",{className:"sample-title"},"Sample Request"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sample-grid"},[{label:"Sample",key:"sample"},{label:"GarmentTech",key:"garmentTechnologist",permissionKey:"garmentTech"},{label:"3D",key:"cad"},{label:"Fabric",key:"fabric"},{label:"Trim",key:"trim"},{label:"Pattern",key:"pattern"},{label:"Cutting",key:"cutting"},{label:"Sewing",key:"sewing"},{label:"Marker",key:"marker"},{label:"Embellishment",key:"embellishment"},{label:"Embroidery",key:"embroidery"},{label:"Wash",key:"wash"},{label:"Dispatch",key:"dispatch"},{label:"Grading",key:"qc",permissionKey:"QC"},{label:"Costing",key:"costing"},{label:"Sign Off",key:"signOff",permissionKey:"signoff"}].map(function(_ref4,index){var label=_ref4.label,key=_ref4.key,_ref4$permissionKey=_ref4.permissionKey,permissionKey=_ref4$permissionKey===undefined?key:_ref4$permissionKey;var hasPermission=_this4.props.rights&&_this4.props.rights.sampleRequest&&_this4.props.rights.sampleRequest[permissionKey]&&_this4.props.rights.sampleRequest[permissionKey].web&&_this4.props.rights.sampleRequest[permissionKey].web.edit;return hasPermission&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index,className:"sample-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",checked:_this4.state.sampleRequest.toggle[key],onChange:function onChange(){return _this4.toggleChange(key);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"save-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"sv-btn",onClick:this.createSample},"Save")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"ma-pro"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"ma-pro-txt"},"Manage Process")),this.props.rights.sampleRequest.sample.web.edit&&this.state.sampleRequest.toggle.sample&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isSample");},style:{color:this.state.isSample?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isSample,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isSample?"600":"400"}},"Sample"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isSample?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isSample&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"sample",_id:this.state._id,process:this.state.sampleRequest.processUpdates.sample,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"3px",marginTop:"12px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Awaiting Dev Sample",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.sample.awaitingDevSample,checked:this.state.sampleRequest.sample.awaitingDevSample// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateSampleModule("awaitingDevSample",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Awaiting Design Sheet",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.sample.awaitingDevSheet,checked:this.state.sampleRequest.sample.awaitingDevSheet// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateSampleModule("awaitingDevSheet",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",gap:"10px",marginTop:"10px"}},"Sizes ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"",onClick:this.addSize})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sizes",style:{marginBottom:"20px"}},this.state.sampleRequest.sample.data.map(function(data,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"size",style:{display:"flex",gap:"50px",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{marginTop:"0px",flex:"1"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",style:{visibility:"hidden"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"select",inputName:"size",value:data.size,index:i,onChange:_this4.updateSampleModule,options:_this4.state.sizeList// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{marginTop:"0px",flex:"1"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Qty"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeSize(i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"number",min:"0",value:data.quantity,disabled:_this4.state.disabled,onChange:function onChange(e){return _this4.updateSampleModule(e.target.name,e.target.value,i);},"class":"input1",name:"quantity",maxLength:"10"})));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.sample.comments,label:"Comments",onChange:this.updateSampleModule}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createSampleModule(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeSampleModule(e);}},"Complete")))),this.props.rights.sampleRequest.garmentTech.web.edit&&this.state.sampleRequest.toggle.garmentTechnologist&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isGarmentTech");},style:{color:this.state.isGarmentTech?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isGarmentTech,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isGarmentTech?"600":"400"}},"GarmentTech"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isGarmentTech?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isGarmentTech&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"garmentTechnologist",_id:this.state._id,process:this.state.sampleRequest.processUpdates.garmentTechnologist,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"3px",marginTop:"12px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Marker Requirement",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.garmentTechnologist.markerRequirements,checked:this.state.sampleRequest.garmentTechnologist.markerRequirements// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateGarment("markerRequirements",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"SMV Ammendment",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.garmentTechnologist.smvAmmendment,checked:this.state.sampleRequest.garmentTechnologist.smvAmmendment// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateGarment("smvAmmendment",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"3px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Technical Issues",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.garmentTechnologist.tiIssues,checked:this.state.sampleRequest.garmentTechnologist.tiIssues// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateGarment("tiIssues",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Trail Required?",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.garmentTechnologist.trailRequired,checked:this.state.sampleRequest.garmentTechnologist.trailRequired// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateGarment("trailRequired",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",gap:"3px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},"Mock",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.garmentTechnologist.mock,checked:this.state.sampleRequest.garmentTechnologist.mock// onChange={e => onChange(inputName, e.target.checked, index, i)}
,onChange:function onChange(e){return _this4.updateGarment("mock",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"garmentTechComments",value:this.state.sampleRequest.garmentTechnologist.garmentTechComments,label:"Garment Tech Comments",onChange:this.updateGarment}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:this.state.sampleRequest.garmentTechnologist.comment,label:"Comments",onChange:this.updateGarment}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createGarment(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeGarment(e);}},"Complete")))),this.props.rights.sampleRequest.cad.web.edit&&this.state.sampleRequest.toggle.cad&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("is3D");},style:{color:this.state.is3D?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.is3D,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.is3D?"600":"400"}},"3D"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.is3D?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.is3D&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"cad",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.cad,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"3D Ref No."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"cadRefNo",value:this.state.sampleRequest.cad.cadId,onInputChange:function onInputChange(e){return _this4.getCADRefNumber(e);},onChange:function onChange(value){return _this4.changeCADRefNum(value);},placeholder:"Find 3D RefNo",options:this.state.CADRefNumInfo// disabled={this.state.disabled}
// onSelectResetsInput={false}
// onBlurResetsInput={false}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"3D Name",inputType:"text",inputName:"cadName",value:this.state.sampleRequest.cad.cadName// index={index}
,onChange:this.cadUpdate// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"3D Type"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},this.state.sampleRequest.cad&&this.state.sampleRequest.cad.cadType&&this.state.sampleRequest.cad.cadType.length>0?this.state.sampleRequest.cad.cadType.map(function(data){return data.label;}).join(",\n "):"-")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Print/EMB Type",inputType:"select",inputName:"printEmbType",value:this.state.sampleRequest.cad&&this.state.sampleRequest.cad.printEmbType,options:this.state.cadPreFill?this.state.cadPreFill.PRINTEMBTYPE:[]// index={index}
,onChange:this.cadUpdate// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Border Type",inputType:"select",inputName:"borderType",value:this.state.sampleRequest.cad&&this.state.sampleRequest.cad.borderType,options:this.state.cadPreFill?this.state.cadPreFill.BORDERTYPE:[]// index={index}
,onChange:this.cadUpdate// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.cad.comments,label:"Comments",onChange:this.updateCadValues}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.saveCAD(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeCAD(e);}},"Complete")))),this.props.rights.sampleRequest.fabric.web.edit&&this.state.sampleRequest.toggle.fabric&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isFabric");},style:{color:this.state.isFabric?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isFabric,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isFabric?"600":"400"}},"Fabric"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isFabric?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isFabric&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"fabric",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.fabric,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addFabric})),this.state.sampleRequest.fabric.map(function(fabricData,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index,style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeFabric(index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Fabric Ref No*"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"fabricNumber",value:fabricData.fabricNumber,onInputChange:function onInputChange(val){return _this4.getFabricNumber(val,index);},onChange:function onChange(val){return _this4.getFabricInfo(val,index);},placeholder:"Find Fabric"// onFocus={() =>
//   this.props.clearDummyFabric(index)
// }
,options:fabricData.fabricList||_this4.state.fabricList// disabled={this.state.disabled}
// onSelectResetsInput={false}
// onBlurResetsInput={false}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"fabricName",label:"Fabric Name",value:fabricData.fabricName,index:index// label={"comments"}
,onChange:_this4.updateFabricName// disabled={this.state.disabled}
,max:25})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Position*",inputType:"select",inputName:"fabricPosition",value:fabricData.fabricPosition,options:_this4.state.prefillInfo.SAMPLEREQUEST.POSITION||[],index:index,onChange:_this4.updateFabric// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Base No"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},fabricData.bNumber?fabricData.bNumber:"-"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Classification of Fabric"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},fabricData.classificationOfFabric?fabricData.classificationOfFabric:"-")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Quality"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},fabricData.quality?fabricData.quality:"-"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Count & Construction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},fabricData.countAndConstruction?fabricData.countAndConstruction:"-")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Fabric Origination",inputType:"select",inputName:"fabricOrigination",value:fabricData.fabricOrigination,options:_this4.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION||[],index:index,onChange:_this4.updateFabric// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:"20px",display:"flex",flexDirection:"column",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"fabricRadio"+index,value:"inHse"+index,checked:fabricData.fabricRadio==="inHse",index:index,onChange:function onChange(name,value){return _this4.updateFabric("fabricRadio","inHse",index);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"in-use"},"In Use")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"fabricRadio"+index,value:"notInHse"+index,checked:fabricData.fabricRadio==="notInHse",index:index,onChange:function onChange(){return _this4.updateFabric("fabricRadio","notInHse",index);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"not-in-use"},"Not in Use"))));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"fabricComments",value:this.state.sampleRequest.fabricComments,label:"Comments",onChange:this.updateSampleRequest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.checkValidation("save",e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.checkValidation("complete",e);}},"Complete")))),this.props.rights.sampleRequest.trim.web.edit&&this.state.sampleRequest.toggle.trim&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isTrim");},style:{color:this.state.isTrim?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isTrim,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isTrim?"600":"400"}},"Trim"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isTrim?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isTrim&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"trim",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.trim,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:function onClick(){return _this4.addTrim("row1");}})),this.state.sampleRequest.trim&&this.state.sampleRequest.trim.row1&&this.state.sampleRequest.trim.row1.length&&this.state.sampleRequest.trim.row1.map(function(trim,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:"",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeTrim("row1",index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Trim Category*",inputType:"select",inputName:"trimCategory",value:trim.trimCategory,index:index,options:_this4.state.prefillInfo.TRIM.TRIMCATEGORY||[],onChange:_this4.updateTrimRow1,onInputChange:_this4.updateTrimRow1// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Trim Ref No*"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"trimNumber"// clearable={false}
,value:trim.trimNumber,onInputChange:function onInputChange(value){return _this4.getTrimRefNo(trim.trimCategory,value,index);},onChange:function onChange(value){return _this4.getTrimInfo(value,index);},placeholder:"Find trimRefNo",options:trim.trimList?trim.trimList:[]// disabled={this.state.disabled}
// onSelectResetsInput={false}
// onBlurResetsInput={false}
})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Description"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},trim.description?trim.description:"-")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Quality"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},trim.quality?trim.quality:"-"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Size"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},trim.sizeNumber&&trim.size?trim.sizeNumber+"-"+trim.size:"-"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:"20px",display:"flex",flexDirection:"column",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"trimRadio"+index,value:"inHsetrimRadio"+index,checked:trim.trimRadio==="inHse",index:index,onChange:function onChange(name,value){return _this4.updateTrimRow1("trimRadio","inHse",index);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"in-use"},"In Use")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:false,inputType:"radio",inputName:"trimRadio"+index,value:"notInHsetrimRadio"+index,checked:trim.trimRadio==="notInHse",index:index,onChange:function onChange(name,value){return _this4.updateTrimRow1("trimRadio","notInHse",index);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"not-in-use"},"Not in Use"))));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:this.state.sampleRequest.trim.comment,label:"Comments",onChange:this.updateTrim}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.checkValidationTrim("save",e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.checkValidationTrim("complete",e);}},"Complete")))),this.props.rights.sampleRequest.pattern.web.edit&&this.state.sampleRequest.toggle.pattern&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isPattern");},style:{color:this.state.isPattern?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isPattern,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isPattern?"600":"400"}},"Pattern"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isPattern?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isPattern&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"pattern",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.pattern,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Pattern Master Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"patternMaster"// value={this.state.sampleRequest.pattern.patternMaster}
,value:this.state.sampleRequest.pattern.patternMaster?this.state.prefillInfo.PATTERNMASTER.find(function(option){return option.value===_this4.state.sampleRequest.pattern.patternMaster;}):null// onInputChange={e =>
//   this.getPatternMaster(e, "patternMaster")
// }
// onChange={value =>
//   this.updatePattern(
//     "patternMaster",
//     value.value
//   )
// }
,onChange:function onChange(value){return _this4.updatePattern("patternMaster",value?value.value:null);},placeholder:"Find Pattern Master ",options:this.state.prefillInfo.PATTERNMASTER// disabled={this.state.disabled}
// onSelectResetsInput={false}
// onBlurResetsInput={false}
,isClearable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Pattern Type",inputType:"select",inputName:"patternType",value:this.state.sampleRequest.pattern.patternType,options:this.state.prefillInfo.PATTERNTYPE||[],onChange:this.updatePattern// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Block Ref Used",inputType:"text",inputName:"blockRefNumber",value:this.state.sampleRequest.pattern.blockRefNumber,onChange:this.updatePattern// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Approval Status",inputType:"select",inputName:"approvalStatus",value:this.state.sampleRequest.pattern.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}]// index={index}
,onChange:this.updatePattern// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"center"}},"Trail Required",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"trailRequired",value:this.state.sampleRequest.pattern.trailRequired,onChange:function onChange(e){return _this4.updatePattern("trailRequired",e.target.checked);},checked:this.state.sampleRequest.pattern.trailRequired// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Logs ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addPatternLog,style:{cursor:"pointer"}})),this.state.sampleRequest.pattern.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",gap:"10px",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeIn!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeIn).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updatePatternCheck("timeIn",i);}},"Time In")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"time",maxlength:23,inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this4.updatePatternLog(name,value,i);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeOut!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeOut).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updatePatternCheck("timeOut",i);}},"Time Out")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removePatternLog(i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason// onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
// }
,onChange:function onChange(name,value){return _this4.updatePatternLog(name,value,i);}// disabled={this.state.disabled}
})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comment",value:this.state.sampleRequest.pattern.comment,label:"Comments",onChange:this.updatePattern}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createPattern(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completePattern(e);}},"Complete")))),this.props.rights.sampleRequest.cutting.web.edit&&this.state.sampleRequest.toggle.cutting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isCutting");},style:{color:this.state.isCutting?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isCutting,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isCutting?"600":"400"}},"Cutting"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isCutting?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isCutting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"cutting",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.cutting,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Cutting Master Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"cuttingMaster",value:this.state.sampleRequest.cutting.cuttingMasterName//   onInputChange={e =>
//     this.getPatternMaster(e, "cuttingMaster")
//   }
,onChange:function onChange(e){return _this4.updateCutting("cuttingMasterName",e);},placeholder:"Cutting master Name",options:this.state.prefillInfo.CUTTINGMASTER//  disabled={this.state.disabled}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"cuttingType",value:this.state.sampleRequest.cutting.cuttingType,label:"Cutting type ",options:this.state.prefillInfo.CUTTINGTYPE,onChange:this.updateCutting// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"size",value:this.state.sampleRequest.cutting.size,label:"Size ",options:this.state.sampleRequest&&this.state.sampleRequest.sample&&this.state.sampleRequest.sample.data?this.state.sampleRequest.sample.data.filter(function(x){return x.size;})// Ensures size exists
.map(function(x){return{label:x.size,value:x.size};})// Creates label-value pairs
:[]// Fallback if data is missing
,onChange:this.updateCutting// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"approvalStatus",label:"Approval Status ",value:this.state.sampleRequest.cutting.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}],onChange:this.updateCutting// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Logs ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addCuttingLog,style:{cursor:"pointer"}})),this.state.sampleRequest.cutting.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",gap:"10px",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeIn!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeIn).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updateCuttingCheck("timeIn",i);}},"Time In")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"time",maxlength:23,inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this4.updateCuttingLog(name,value,i);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeOut!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeOut).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updateCuttingCheck("timeOut",i);}},"Time Out")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeCuttingLog(i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason// onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
// }
,onChange:function onChange(name,value){return _this4.updateCuttingLog(name,value,i);}// disabled={this.state.disabled}
})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.cutting.comments,label:"Comments",onChange:this.updateCutting}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createCutting(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeCutting(e);}},"Complete")))),this.props.rights.sampleRequest.sewing.web.edit&&this.state.sampleRequest.toggle.sewing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isSewing");},style:{color:this.state.isSewing?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isSewing,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isSewing?"600":"400"}},"Sewing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isSewing?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isSewing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"sewing",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.sewing,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain,PLACEOFSEWING:this.state.prefillInfo.SAMPLEREQUEST.PLACEOFSEWING,placeOfSewing:this.state.sampleRequest.sewing.placeOfSewing,updateSewing:this.updateSewing1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton",style:{justifyContent:"space-between",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Sewing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addSewing})),this.state.sampleRequest.sewing.sewingData.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index,style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeSewing(index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Tailor Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"tailorName",value:value.tailorName// onInputChange={this.getFabricNumber}
,onChange:function onChange(value){return _this4.updateSewing("tailorName",value,index);},placeholder:"Tailor Name",options:_this4.state.prefillInfo.SYSTEMSAMPLEREQUEST.TAILORSNAME// disabled={this.state.disabled}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Sewing Type",inputType:"select",inputName:"sewingType",value:value.sewingType,options:_this4.state.prefillInfo.SAMPLEREQUEST.SEWINGTYPE||[],index:index,onChange:_this4.updateSewing// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"size",value:value.size,label:"Size ",index:index,options:_this4.state.sampleRequest&&_this4.state.sampleRequest.sample&&_this4.state.sampleRequest.sample.data?_this4.state.sampleRequest.sample.data.filter(function(x){return x.size;})// Ensures size exists
.map(function(x){return{label:x.size,value:x.size};})// Creates label-value pairs
:[]// Fallback if data is missing
,onChange:_this4.updateSewing// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Qty",inputType:"text",inputName:"quantity",value:value.quantity,index:index,onChange:_this4.updateSewing// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Approval Status",inputType:"select",inputName:"approvalStatus",value:value.approvalStatus,options:[{label:"approved",value:"approved"},{label:"pending",value:"pending"},{label:"rejected",value:"rejected"}],index:index,onChange:_this4.updateSewing// disabled={this.state.disabled}
}),value.approvalStatus=="rejected"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Reason",inputType:"text",inputName:"rejected",value:value.rejected,index:index,onChange:_this4.updateSewing,disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Logs ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:function onClick(){return _this4.addSewingLog(index);},style:{cursor:"pointer"}})),value.logs.map(function(log,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",gap:"10px",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeIn!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeIn).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updateSewingCheck("timeIn",i,index);}},"Time In")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"time",maxlength:23,inputName:"breakTime",label:"Break Time (Duration)",value:log.breakTime,onChange:function onChange(name,value){return _this4.updateSewingLog(name,value,i,index);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,log.timeOut!==""?__WEBPACK_IMPORTED_MODULE_17_moment___default()(log.timeOut).format('MMMM Do YYYY, hh:mm'):""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"log-btn",onClick:function onClick(){return _this4.updateSewingCheck("timeOut",i,index);}},"Time Out")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeSewingLog(i,index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",label:"Reason",value:log.reason// onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
// }
,onChange:function onChange(name,value){return _this4.updateSewingLog(name,value,i,index);}// disabled={this.state.disabled}
})));}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Smocking/Shirring",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"smokingOrShiring",value:this.state.sampleRequest.sewing.smokingOrShiring//  onChange={e => {
//   this.updateSewing1(e)
// }}
,onChange:function onChange(e){return _this4.updateSewing1("smokingOrShiring",e.target.checked);},checked:this.state.sampleRequest.sewing.smokingOrShiring// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),this.state.sampleRequest.sewing.smokingOrShiring&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:function onClick(){return _this4.smockingShirringaddTrim();}})),this.state.sampleRequest.sewing.trimData&&this.state.sampleRequest.sewing.trimData.length&&this.state.sampleRequest.sewing.trimData.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.smockingShirringremoveTrim("row2",index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",label:"Trim Category",inputName:"trimCategory",value:index===0?value.trimCategory:null,index:index,options:_this4.state.prefillInfo.TRIM.TRIMCATEGORY||[],onChange:_this4.updateSewingTrimData// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Fabric ref no."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{name:"trimNumber",value:value.trimNumber,onInputChange:function onInputChange(data){return _this4.getTrimRefNoSewing(value.trimCategory,data,index);},onChange:function onChange(value){return _this4.getTrimInfoSewTrimData(value,index);},placeholder:"Find trimRefNo",options:value.trimList?value.trimList:[]// disabled={this.state.disabled}
// onSelectResetsInput={false}
// onBlurResetsInput={false}
})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Placement",inputType:"select",inputName:"placement",value:value.placement,index:index,options:_this4.state.prefillInfo.TRIMPLACEMENT||[],onChange:_this4.updateSewingTrimData// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Type",inputType:"select",inputName:"type",value:value.type,index:index,options:[{label:"Both Elastic",value:"Both Elastic"},{label:"Top TTH / Bottom Elastic",value:"Top TTH / Bottom Elastic"}],onChange:_this4.updateSewingTrimData// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"No Of Rows",inputType:"number",inputName:"noOfRow",index:index,value:value.noOfRow,onChange:_this4.updateSewingTrimData// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Length in cm",inputType:"number",inputName:"length",value:value.length,index:index,onChange:_this4.updateSewingTrimData// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Total Reqrd-mtrs",inputType:"number",inputName:"totalReq",value:value.totalReq,index:index,onChange:_this4.updateSewingTrimData,disabled:true})));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.sewing.comments,label:"Comments",onChange:this.updateSewing1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:this.createSewing},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:this.completeSewing},"Complete")))),this.props.rights.sampleRequest.marker.web.edit&&this.state.sampleRequest.toggle.marker&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isMarker");},style:{color:this.state.isMarker?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isMarker,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isMarker?"600":"400"}},"Marker"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isMarker?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isMarker&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"marker",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.marker,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileFileUpload__["a" /* default */],{getRefImages:function getRefImages(refImages){return _this4.getRefImages(refImages,"marker");},moduleName:"marker",Heading:"Upload Images",uploadedDocs:this.state.sampleRequest.marker.refImages?this.state.sampleRequest.marker.refImages:null,imageTypeOption:[]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.marker.comments,label:"Comments",onChange:this.updateMarker}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createMarker(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeMarker(e);}},"Complete")))),this.props.rights.sampleRequest.embellishment.web.edit&&this.state.sampleRequest.toggle.embellishment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isEmbellishment");},style:{color:this.state.isEmbellishment?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isEmbellishment,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isEmbellishment?"600":"400"}},"Embellishment"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isEmbellishment?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isEmbellishment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"embellishment",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.embellishment,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:function onClick(){return _this4.addEmb();}})),this.state.sampleRequest.embellishment.map(function(embellishment,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:"",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeEmb(index);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"embType",value:embellishment.embType,options:_this4.state.prefillInfo.SAMPLEREQUEST.TYPE,onChange:_this4.updateEmbellishment,index:index,label:"Type "// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"time",inputName:"hoursMinutes",value:embellishment.hoursMinutes,onChange:_this4.updateEmbellishment,index:index,label:"HH:MM"// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"pricePerHalfHour",label:"Price/30mins",value:embellishment.pricePerHalfHour,onChange:_this4.updateEmbellishment,index:index// disabled={this.state.disabled}
})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"embellishmentComments",value:this.state.sampleRequest.embellishmentComments,label:"Comments",onChange:this.updateSampleRequest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createEmbellishment(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeEmbellishment(e);}},"Complete")))),this.props.rights.sampleRequest.embroidery.web.edit&&this.state.sampleRequest.toggle.embroidery&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isEmbroidery");},style:{color:this.state.isEmbroidery?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isEmbroidery,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isEmbroidery?"600":"400"}},"Embroidery"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isEmbroidery?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isEmbroidery&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"embroidery",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.embroidery,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"emp-top-ch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-gap-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",checked:this.state.sampleRequest.embroidery.cutPanel,style:{position:"static",opacity:"1",marginTop:"0px"},onChange:function onChange(e){return _this4.updateEmbroidery("cutPanel",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",style:{marginBottom:"0px"}},"Cut Panel")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-gap-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",checked:this.state.sampleRequest.embroidery.garmentForm,name:"",id:"filled-in-box1",style:{position:"static",opacity:"1",marginTop:"0px"},onChange:function onChange(e){return _this4.updateEmbroidery("garmentForm",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",id:"filled-in-box1",style:{marginBottom:"0px"}}," Garment Form"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"emp-top-ch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-gap-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",checked:this.state.sampleRequest.embroidery.allOver,style:{position:"static",opacity:"1",marginTop:"0px"},onChange:function onChange(e){return _this4.updateEmbroidery("allOver",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",style:{marginBottom:"0px"}},"All Over")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-gap-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",checked:this.state.sampleRequest.embroidery.semiGarmentForm,style:{position:"static",opacity:"1",marginTop:"0px"},onChange:function onChange(e){return _this4.updateEmbroidery("semiGarmentForm",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",style:{marginBottom:"0px"}},"Semi Garment Form")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-gap-10",style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",name:"",id:"",checked:this.state.sampleRequest.embroidery.tassel,style:{position:"static",opacity:"1",marginTop:"0px"},onChange:function onChange(e){return _this4.updateEmbroidery("tassel",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1",style:{marginBottom:"2px"}},"Tassle")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginBottom:"20px",marginTop:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"",style:{flex:"1"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{id:"mySelect",onDoubleClick:function onDoubleClick(){return _this4.moveToRight();}//  className="mySelectLeft"
,style:{display:"block",width:"80%",border:"1px solid",borderRadius:"4px",padding:"10px"},size:"10",disabled:this.state.disabled},this.state.sampleRequest.embroidery.leftData.map(function(data){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{style:{marginBottom:"4px"}},data);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"up-down-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this4.moveToRight();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"up1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-chevron-right"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this4.moveToLeft();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"down1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-chevron-left"}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"",style:{display:"flex",justifyContent:"space-between",marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"",style:{flex:"1"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select",{id:"mySelect2",onDoubleClick:function onDoubleClick(){return _this4.moveToLeft();}// onDoubleClick={}
// className="mySelectRight"
,size:"10",style:{display:"block",width:"80%",border:"1px solid",borderRadius:"4px",padding:"10px"}// disabled={this.state.disabled}
},this.state.sampleRequest.embroidery.rightData.map(function(data){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{style:{marginBottom:"4px"}},data);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"up-down-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this4.moveToUp();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"up1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-chevron-up"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this4.moveToBottom();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"down1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-chevron-down"}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileFileUpload__["a" /* default */],{Heading:"Upload Images",getRefImages:function getRefImages(refImages){return _this4.getRefImages(refImages,'embroidery');}// disabled={this.state.disabled}
,uploadedDocs:this.state.sampleRequest.embroidery.refImages.length>0?this.state.sampleRequest.embroidery.refImages:null})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Backing",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",value:this.state.sampleRequest.embroidery.backing,checked:this.state.sampleRequest.embroidery.backing,onChange:function onChange(e){return _this4.updateEmbroidery("backing",e.target.checked);}// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"})))),this.state.sampleRequest.embroidery.backing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton",style:{gap:"10px"}},"Backing",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:function onClick(){return _this4.changeBackingArray('add');}})),this.state.sampleRequest.embroidery.backing&&this.state.sampleRequest.embroidery.backingData.map(function(backingData,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:"",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.changeBackingArray('clear',i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"backingType",value:backingData.backingType,options:_this4.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE,onChange:function onChange(name,value){return _this4.updateEmbroideryBackingData(name,value,i);},label:"Backing "// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"width",value:backingData.width// options={this.state.widthList}
,onChange:function onChange(name,value){return _this4.updateEmbroideryBackingData(name,value,i);},label:"Width",disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"placement",value:backingData.placement,options:_this4.state.prefillInfo.SAMPLEREQUEST.PLACEMENT_EMB,onChange:function onChange(name,value){return _this4.updateEmbroideryBackingData(name,value,i);},label:"Placement ",disabled:_this4.state.disabled})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addEmbroideryData})),this.state.sampleRequest.embroidery.embroideryData.map(function(embroideryData,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:i,style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.props.removeEmbroideryData(i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Emb Placement",inputType:"select",inputName:"embPlacement",value:embroideryData.embPlacement,options:_this4.state.prefillInfo.SAMPLEREQUEST.PLACEMENT_EMB,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Emb Form",inputType:"select",inputName:"embForm",value:embroideryData.embForm,options:_this4.state.prefillInfo.SAMPLEREQUEST.EMBFORM,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"No of Colors",inputType:"select",inputName:"noOfCols",value:embroideryData.noOfCols,options:_this4.state.prefillInfo.SAMPLEREQUEST.NOOFCOLORS,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Frames",inputType:"select",inputName:"frames",value:embroideryData.frames,options:_this4.state.prefillInfo.SAMPLEREQUEST.FRAMES,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Stitches/Mtr",inputType:"text",inputName:"stitchesMtr",value:embroideryData.stitchesMtr,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);},disabled:embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Consumption/Unit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"input-qr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{size:"6",maxLength:"6",type:"text",name:"consumption",value:embroideryData.consumption,className:"input1",disabled:embroideryData.embForm&&embroideryData.embForm.toLowerCase()==="panel",onChange:function onChange(e){return _this4.updateEmbroideryData(e.target.name,e.target.value,i);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Stitches Count",inputType:"text",inputName:"stitchCount",value:embroideryData.stitchCount,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled || embroideryData.embForm == "length"}
// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,label:"Price/1000 Stitches",inputType:"text",inputName:"priceForStitches",value:embroideryData.priceForStitches// options={this.state.PRICE1000STICHES&&this.state.PRICE1000STICHES.map(x => ({ label: x, value: x }))}
,onChange:function onChange(name,value){return _this4.updateEmbroideryData(name,value,i);}// disabled={this.state.disabled}
// disabled={this.state.disabled || embroideryData.embForm == "length"}
})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.embroidery.comments,label:"Comments",onChange:this.updateEmbroidery}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.saveEmbroidery(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeEmbroidery(e);}},"Complete")))),this.props.rights.sampleRequest.wash.web.edit&&this.state.sampleRequest.toggle.wash&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isWash");},style:{color:this.state.isWash?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isWash,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isWash?"600":"400"}},"Wash"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isWash?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isWash&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"wash",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.wash,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"washType",value:this.state.sampleRequest.wash.washData.washType,options:this.state.prefillInfo.WASH.WASHTYPE// index={index}
,label:"Wash Type",onChange:this.updateWash1// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"washFrom",value:this.state.sampleRequest.wash.washData.washFrom,options:this.state.prefillInfo.WASH.WASHFORM// index={index}
,label:"Wash Form",onChange:this.updateWash1// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"laundryUnit",value:this.state.sampleRequest.wash.washData.laundryUnit,options:this.state.prefillInfo.WASH.LAUNDRYUNIT// index={index}
,label:"Laundry Unit",onChange:this.updateWash1// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"number",inputName:"price",value:this.state.sampleRequest.wash.washData.price// index={index}
,label:"Price/Kg"// options={this.state.PRICEPERKG&&this.state.PRICEPERKG.map(x=>({label:x.label,value:x.label}))}
,onChange:this.updateWash1// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}},"MOCKS ?",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"hasMock",value:this.state.sampleRequest.wash.hasMock,onChange:function onChange(e){return _this4.updateWash("hasMock",e.target.checked);},checked:this.state.sampleRequest.wash.hasMock// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"numberOfMocks",value:this.state.sampleRequest.wash.numberOfMocks,options:this.state.prefillInfo.WASH.NOOFMOCKS,label:"No. Of Mocks",onChange:this.updateWash// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}},"Tacking",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"tacking",value:this.state.sampleRequest.wash.tacking,onChange:function onChange(e){return _this4.updateWash("tacking",e.target.checked);},checked:this.state.sampleRequest.wash.tacking// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}},"Recipe",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"recipe",value:this.state.sampleRequest.wash.recipe,onChange:function onChange(e){return _this4.updateWash("recipe",e.target.checked);},checked:this.state.sampleRequest.wash.recipe// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileFileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"marker",getRefImages:function getRefImages(refImages){return _this4.getRefImages(refImages,"wash");}// disabled={this.state.disabled}
,uploadedDocs:this.state.sampleRequest.wash.refImages?this.state.sampleRequest.wash.refImages:null,imageTypeOption:[]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.wash.comments,label:"Comments",onChange:this.updateWash}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createWash(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeWash(e);}},"Complete")))),this.props.rights.sampleRequest.dispatch.web.edit&&this.state.sampleRequest.toggle.dispatch&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isDispatch");},style:{color:this.state.isDispatch?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isDispatch,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isDispatch?"600":"400"}},"Dispatch"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isDispatch?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isDispatch&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"dispatch",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.dispatch,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}},"Magnum Counter",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"magnumCounter",value:this.state.sampleRequest.dispatch.magnumCounter,onChange:function onChange(e){return _this4.updateDispatch("magnumCounter",e.target.checked);},checked:this.state.sampleRequest.dispatch.magnumCounter// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricaddbutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_MobileApp_add_circle_svg___default.a,alt:"add",onClick:this.addDispatchData})),this.state.sampleRequest.dispatch.data.length>0&&this.state.sampleRequest.dispatch.data.map(function(val,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:i,style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"fabricremovebutton"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_MobileApp_remove_circle_svg___default.a,alt:"remove",onClick:function onClick(){return _this4.removeDispatchData(i);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{durationETA:!val.date?-1:null,isFormGroup:true,inputType:"date",inputName:"date",label:"Date",value:val.date,onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"location",value:val.location,options:_this4.state.prefillInfo.SYSTEMSAMPLEREQUEST.LOCATION,label:"Location",onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);}// disabled={this.state.disabled}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"awbNumber",value:val.awbNumber,label:"AWB No.",onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"courier",value:val.courier,options:_this4.state.prefillInfo.SYSTEMSAMPLEREQUEST.COURIER,label:"Courier",onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);},disabled:_this4.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"size",value:val.size,options:_this4.state.sizeList,label:"Size",onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);}// disabled={this.state.disabled}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"number",inputName:"quantity",value:val.quantity,label:"Qty",onChange:function onChange(name,value){return _this4.udpateDispatchValues(name,value,i);}// disabled={this.state.disabled}
})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.dispatch.comments,label:"Comments",onChange:this.udpateDispatch}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createDispatch(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeDispatch(e);}},"Complete")))),this.props.rights.sampleRequest.QC.web.edit&&this.state.sampleRequest.toggle.qc&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isGrading");},style:{color:this.state.isGrading?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isGrading,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isGrading?"600":"400"}},"Grading"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isGrading?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isGrading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"qc",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.qc,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"15px"}},"Any Issue",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"switch"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{style:{position:"static",opacity:"1"},type:"checkbox",name:"anyIssue",value:this.state.sampleRequest.qc.anyIssue,onChange:function onChange(e){return _this4.updateQc("anyIssue",e.target.checked);},checked:this.state.sampleRequest.qc.anyIssue// checked={true}
// onChange={true}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"slider round"}))),this.state.sampleRequest.qc.anyIssue&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"reason",value:this.state.sampleRequest.qc.reason,label:"if yes, reason",onChange:this.updateQc})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileFileUpload__["a" /* default */],{Heading:"Upload Images",moduleName:"marker",getRefImages:function getRefImages(refImages){return _this4.getRefImages(refImages,"qc");}// disabled={this.state.disabled}
,uploadedDocs:this.state.sampleRequest.qc.refImages.length>0?this.state.sampleRequest.qc.refImages:null,imageTypeOption:[]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"comments",value:this.state.sampleRequest.qc.comments,label:"Comments",onChange:this.updateQc}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createQC(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeQC(e);}},"Complete")))),this.props.rights.sampleRequest.costing.web.edit&&this.state.sampleRequest.toggle.costing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isCosting");},style:{color:this.state.isCosting?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isCosting,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isCosting?"600":"400"}},"Costing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isCosting?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isCosting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"costing",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.costing,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"costingComments",value:this.state.sampleRequest.costingComments,label:"Comments",onChange:this.updateSampleRequest,style:{marginTop:"10px"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:function onClick(e){return _this4.createCosting(e);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:function onClick(e){return _this4.completeCosting(e);}},"Complete")))),this.props.rights.sampleRequest.signoff.web.edit&&this.state.sampleRequest.toggle.signOff&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-dropdown"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"md-brbox",onClick:function onClick(){return _this4.handleToggleDropdown("isSignOff");},style:{color:this.state.isSignOff?"rgba(0, 150, 136, 1)":"black"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{ref:this.textRefs.isSignOff,tabIndex:-1// Makes the span focusable programmatically
,style:{outline:"none",fontWeight:this.state.isSignOff?"600":"400"}},"Sign Off"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa "+(this.state.isSignOff?"fa-angle-up":"fa-angle-down")+" font-icon"})),this.state.isSignOff&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MbModuleHeader__["a" /* default */],{moduleName:"signOff",_id:this.state._id,process:this.state.sampleRequest&&this.state.sampleRequest.processUpdates&&this.state.sampleRequest.processUpdates.signOff,statusList:this.state.prefillInfo.STATUS,updateModulesMain:this.updateModulesMain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"signOffComments",value:this.state.sampleRequest.signOffComments,label:"Comments",onChange:this.updateSampleRequest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"sa-co-btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-sav",onClick:this.createSignOff},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"du-co",onClick:this.completeSignoff},"Complete"))))));}}]);return SampleMobileApp;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _state,_this5=this;this.orgReqRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();this.state=(_state={CADRefNumInfo:{},cuttingSizes:{},fabricList:[],toggles:{sample:false,trim:false,cutting:false,embellishment:false,wash:false,grading:false,marker:false,threeD:false,fabric:false,pattern:false,sewing:false,embroidery:false,dispatch:false,signOff:false},isSample:false,is3D:false,isGarmentTech:false,isFabric:false,isTrim:false,isPattern:false,isCutting:false,isSewing:false,isMarker:false,isEmbellishment:false,isEmbroidery:false,isWash:false,isDispatch:false,isGrading:false,isCosting:false,isSignOff:false,showStickyHeader:false,is3DTextRef:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef()},_defineProperty(_state,"showStickyHeader",false),_defineProperty(_state,"isLoading",true),_defineProperty(_state,"sizes",[{id:1}]),_defineProperty(_state,"fabric",[{id:1}]),_defineProperty(_state,"logs",[{id:1}]),_defineProperty(_state,"embellishment",[{id:1}]),_defineProperty(_state,"embroidery",[{id:1}]),_defineProperty(_state,"dispatch",[{id:1}]),_defineProperty(_state,"selectedOption","not-in-use"),_defineProperty(_state,"showUploadDiv",false),_defineProperty(_state,"styleNoInfo",[]),_defineProperty(_state,"action",""),_defineProperty(_state,"comments",""),_defineProperty(_state,"_id",""),_defineProperty(_state,"emptyData",null),_defineProperty(_state,"selected","sampleRequest"),_defineProperty(_state,"measurementChartData",{}),_defineProperty(_state,"sampleRequest",{requestNumber:null,qr:"",selectedType:"sampleRequest",originationOfRequest:null,magnumStyleId:null,typeOfRequest:"",sampleType:null,requiredDate:null,buyerName:"",assistantBuyer:"",fabricTechnologist:"",garmentTechnology:"",magnumTechnologist:null,customer:null,customerDepartmentId:null,orderDate:new Date(),styleReferenceId:null,magnumStyleName:"",customerRefNumber:"",test1:null,test2:"dsd",sample:{awaitingDevSample:false,awaitingDevSheet:false,data:[{size:null,quantity:null}],comments:""},cad:{cadId:null,cadName:"",cadRefNo:"",cadType:[],comments:""},fabric:[],fabricRadio:"notInHse",trimRadio:"notInHse",trim:{// row1: [
//   {
//     trimId: null,
//     trimCategory: null,
//     trimNumber: null,
//     description: "",
//     size: "",
//     quality: "",
//     sizeNumber: "",
//     trimRadio: "notInHse"
//   }
// ],
smokingOrShiring:false,// row2: [
//   {
//     trimCategory: null,
//     trimNumber: null,
//     placement: null,
//     number: null,
//     type: null,
//     noOfRow: null,
//     length: null,
//     totalReq: null
//   }
// ],
comment:""},pattern:{patternMaster:null,patternType:null,blockRefNumber:"",trailRequired:false,comment:"",date:null,existingBlockRefNumber:"",followedBlockRequired:false,approvalStatus:"",logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}]},cutting:{cuttingMasterName:null,cuttingType:null,logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}],comments:"",patternIssues:"",fabricIssues:false,approvalStatus:""},sewing:{placeOfSewing:"5cde88716510d24851321273",sewingData:[{tailorName:null,sewingType:"5cde887e6510d24851321276",size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]}],smokingOrShiring:false,trimData:[{trimCategory:null,trimNumber:null,placement:null,number:null,type:null,noOfRow:null,length:null,totalReq:null}],comments:""},embellishment:[{embType:null,hoursMinutes:null,pricePerHalfHour:null}],embellishmentComments:"",embroidery:{cutPanel:false,allOver:false,garmentForm:false,semiGarmentForm:false,tassel:false,selected:[String],rightData:[],leftData:[],additionalInfo:"",refImages:[],employeeName:null,smocking:false,sheering:false,backing:false,bitAttaching:false,backingData:[{backingType:null,width:null,placement:null}],embroideryData:[{embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""}],machine:[{frames:null,forms:null,placement:null,noOfCols:null,stitches:null,consumptions:null,StitchCount:null,price:null,backing:[{backing:"",width:null,placement:null}]}],comments:""},garmentTechnologist:{// sampleForm: [
//   {
//     comments: "",
//     fab: false,
//     trims: false,
//     workManShip: false,
//     buyerChanges: false,
//     pat: false,
//     remarks: ""
//   }
// ],
sampleForm:{fitMesurements:[],makeupConstruction:[],trimsComponents:[],packPresentation:[]},garmentTechComments:"",markerRequirements:false,smvAmmendment:false,trailRequired:false,mock:false,comment:""},wash:{washData:{washType:null,washFrom:"5d8c601cdd0f0307127f3770",laundryUnit:null,price:null},hasMock:false,numberOfMocks:null,tacking:false,recipe:true,refImages:[],comments:""},dispatch:{magnumCounter:false,data:[// {
//   location: null,
//   date: null,
//   courier: null,
//   awbNumber: "",
//   size: null,
//   quantity: null
// }
],comments:"",magnum:false},qc:{anyIssue:false,reason:"",refImages:[],comments:"",remarks:""},marker:{refImages:[],comments:""},costingComments:"",signOffComments:"",processUpdates:{sample:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},garmentTechnologist:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},cad:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},fabric:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},trim:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},pattern:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},cutting:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},sewing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},embellishment:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},embroidery:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},wash:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},dispatch:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},qc:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},marker:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},costing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},signOff:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""}},printLoading:false,fabricComments:"",toggle:{sample:true,cad:false,fabric:true,trim:true,pattern:true,cutting:true,sewing:true,garmentTechnologist:true,embellishment:false,embroidery:false,wash:false,dispatch:true,qc:true,marker:true,costing:true,signOff:true}}),_defineProperty(_state,"customerList",[]),_defineProperty(_state,"prefillInfo",{SAMPLEREQUEST:{},SAMPLE:{},CAD:{},FABRIC:{},TRIM:{},PATTERNTYPE:[],CUTTINGTYPE:[],STATUS:{},SEWING:{},SYSTEMSAMPLEREQUEST:{},EMBROIDERY:{},WASH:{},CUTTINGMASTER:[],PATTERNMASTER:[]}),_defineProperty(_state,"default",false),_defineProperty(_state,"printGarmentLoading",false),_defineProperty(_state,"printGarmentTech",{}),_defineProperty(_state,"assignedToList",[]),_defineProperty(_state,"assignedToListSewing",[]),_defineProperty(_state,"sizeList",[]),_defineProperty(_state,"assignedTo",{}),_defineProperty(_state,"row1List",[]),_defineProperty(_state,"row2List",[]),_defineProperty(_state,"rights",{}),_defineProperty(_state,"widthList",[]),_defineProperty(_state,"sampleMain",{}),_defineProperty(_state,"fabricList",[]),_defineProperty(_state,"customerDepartment",{}),_defineProperty(_state,"duplicateData",{processUpdates:{sample:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},garmentTechnologist:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},cad:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},fabric:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},trim:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},pattern:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},cutting:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},sewing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},embellishment:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},embroidery:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},wash:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},dispatch:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},qc:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},marker:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},costing:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""},signOff:{assignedTo:null,updatedBy:null,status:"PENDING",ETA:new Date(),processCompleted:false,processDate:null,comments:""}},sample:{awaitingDevSample:false,awaitingDevSheet:false,data:[],sizes:[],comments:""},cad:{cadId:null,cadName:"",cadRefNo:"",cadType:[],comments:""},fabricRadio:"notInHse",trimRadio:"notInHse",pattern:{patternMaster:null,patternType:null,blockRefNumber:"",trailRequired:false,comment:"",date:null,existingBlockRefNumber:"",followedBlockRequired:false,approvalStatus:"",logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}]},cutting:{cuttingMasterName:null,cuttingType:null,logs:[{remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""}],comments:"",patternIssues:"",fabricIssues:false,approvalStatus:""},sewing:{placeOfSewing:"5cde88716510d24851321273",sewingData:[{tailorName:null,sewingType:"5cde887e6510d24851321276",size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]}],smokingOrShiring:false,trimData:[{trimCategory:null,trimNumber:null,placement:null,number:null,type:null,noOfRow:null,length:null,totalReq:null}],comments:""},embellishment:[{embType:null,hoursMinutes:null,pricePerHalfHour:null}],embellishmentComments:"",embroidery:{cutPanel:false,allOver:false,garmentForm:false,semiGarmentForm:false,tassel:false,selected:[String],rightData:[],leftData:[],additionalInfo:"",refImages:[],employeeName:null,smocking:false,sheering:false,backing:false,bitAttaching:false,backingData:[{backingType:null,width:null,placement:null}],embroideryData:[{embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""}],machine:[{frames:null,forms:null,placement:null,noOfCols:null,stitches:null,consumptions:null,StitchCount:null,price:null,backing:[{backing:"",width:null,placement:null}]}],comments:""},garmentTechnologist:{sampleForm:{fitMesurements:[],makeupConstruction:[],trimsComponents:[],packPresentation:[]},garmentTechComments:"",markerRequirements:false,smvAmmendment:false,trailRequired:false,mock:false,comment:""},dispatch:{magnumCounter:false,data:[// {
//   location: null,
//   date: null,
//   courier: null,
//   awbNumber: "",
//   size: null,
//   quantity: null
// }
],comments:"",magnum:false},qc:{anyIssue:false,reason:"",refImages:[],comments:"",remarks:""},marker:{refImages:[],comments:""}}),_state);this.textRefs={isSample:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isGarmentTech:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),is3D:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isFabric:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isTrim:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isPattern:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isCutting:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isSewing:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isMarker:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isEmbellishment:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isEmbroidery:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isWash:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isDispatch:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isGrading:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isCosting:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),isSignOff:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef()};this.waitForStateToUpdate=function(){return new Promise(function(resolve){var checkState=function checkState(){if(_this5.state.sampleRequest.customer&&_this5.state.sampleRequest.customerDepartmentId){resolve();// Resolve the promise if the state is correct
}else{setTimeout(checkState,50);// Check again after a short delay
}};checkState();});};this.handleScroll=function(){if(_this5.orgReqRef.current){var rect=_this5.orgReqRef.current.getBoundingClientRect();_this5.setState({showStickyHeader:rect.bottom<=0});}};this.getMagnumStyleById=function(value){__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReferenceById(value).then(function(response){if(response.status===200){_this5.setState({styleNoInfo:response.text.data});//console.log('this.setState', 'response.text.data:', response.text.data);
}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.createSample=function(){var sampleRequestData=Object.assign({},_this5.state.sampleRequest);Object.keys(sampleRequestData).forEach(function(x){if(allProceses.includes(x)){delete sampleRequestData[x];}});sampleRequestData.requiredDate=new Date();if(_this5.state._id!==""){sampleRequestData._id=_this5.state._id;}else{delete sampleRequestData._id;}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createSampleRequest(sampleRequestData).then(function(res){if(res.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.qr=res.text.data.qr;sampleRequest.requestNumber=res.text.data.requestNumber;sampleRequest.createdAt=res.text.data.createdAt;_this5.props.getalertMessage("success",res.text.message);// this.props.history.replace('/Sample', {
//   action: 'edit',
//   _id: res.text.data._id
// })
_this5.setState({_id:res.text.data._id,createdAt:res.text.data.createdAt,sampleRequest:sampleRequest}// () => this.getAssignedTo()
);}else{var required=["originationOfRequest","magnumStyleId","typeOfRequest","sampleType","buyerName","assistantBuyer"].filter(function(x){if(_this5.state.sampleRequest[x]===""||_this5.state.sampleRequest[x]===undefined||_this5.state.sampleRequest[x]===null){return x;}});_this5.props.getalertMessage("info",required[0]+" Required");}res.status===401&&_this5.props.unauthorisedFunc();}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateModulesMain=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(name,value,moduleName){var sampleRequest,_ref6,isErr,message;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:sampleRequest=Object.assign({},_this5.state.sampleRequest);if(!(name==="status"&&value==="COMPLETED"&&['pattern','cutting','sewing','dispatch'].includes(moduleName))){_context3.next=9;break;}_context3.next=4;return _this5.shouldTodo(name,value,moduleName,sampleRequest);case 4:_ref6=_context3.sent;isErr=_ref6.isErr;message=_ref6.message;if(!isErr){_context3.next=9;break;}return _context3.abrupt("return",_this5.props.getalertMessage('error',message,5000));case 9:if(name=="assignedTo"){sampleRequest.processUpdates[moduleName][name]=value!==null?value.value:null;}else if(name=="status"){sampleRequest.processUpdates[moduleName][name]=value;if(value==="COMPLETED"){sampleRequest.processUpdates[moduleName].processDate=new Date();}}else{sampleRequest.processUpdates[moduleName][name]=value;}_this5.setState({sampleRequest:sampleRequest});case 11:case"end":return _context3.stop();}}},_callee3,_this5);}));return function(_x2,_x3,_x4){return _ref5.apply(this,arguments);};}();this.getMagnumStyleNo=function(value){__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getMagnumStyleNoWithReference(value).then(function(response){if(response.status===200){var jsonData=[];response.text.data.map(function(info,index){var objData={};objData.label=info.referenceCode;objData.value=info.referenceId;jsonData.push(objData);});_this5.setState({styleNoInfo:jsonData});}}).catch(function(error){// Handle error if needed
console.error("Error fetching style info:",error);});//console.log(this.state.styleNoInfo.map(va=>va.label),"styleInf")
};this.getStyleReferenceInfo=function(value){if(value!==null){_this5.setState({isLoading:true});var _state2=_this5.state,sampleRequest=_state2.sampleRequest,measurementChartData=_state2.measurementChartData;sampleRequest.styleReferenceId=value;__WEBPACK_IMPORTED_MODULE_13__services__["k" /* StyleServices */].getStyleInfoByReference(value).then(function(response){if(response.status===200){sampleRequest.magnumStyleName=response.text.data.magnumStyleName;measurementChartData.magnumStyleName=response.text.data.magnumStyleName;sampleRequest.customerRefNumber=response.text.data.customerRefNumber;measurementChartData.customerRefNumber=response.text.data.customerRefNumber;sampleRequest.magnumStyleId=response.text.data.magnumStyleId;measurementChartData.magnumStyleId=response.text.data.magnumStyleId;sampleRequest.customer=response.text.data.customer;measurementChartData.customer=response.text.data.customer;sampleRequest.customerDepartmentId=response.text.data.customerDepartmentId;measurementChartData.customerDepartmentId=response.text.data.customerDepartmentId;sampleRequest.itemNumber=response.text.data.itemNumber;measurementChartData.itemNumber=response.text.data.itemNumber;sampleRequest.blockRefNo=response.text.data.blockRefNumber;measurementChartData.blockRefNo=response.text.data.blockRefNumber;sampleRequest.oldMagStyleNo=response.text.data.refDetail;measurementChartData.oldMagStyleNo=response.text.data.refDetail;sampleRequest.refColNo=response.text.data.referenceColor;measurementChartData.refColNo=response.text.data.referenceColor;sampleRequest.magnumBuyerStyleName=response.text.data.magnumBuyerStyleName;measurementChartData.magnumBuyerStyleName=response.text.data.magnumBuyerStyleName;_this5.setState({sampleRequest:sampleRequest,measurementChartData:measurementChartData},function(){return _this5.getMainValues(sampleRequest.customer,sampleRequest.customerDepartmentId);});//console.log(this.state.sampleRequest, "sampleRequest");
}response.status==401&&_this5.props.unauthorisedFunc();}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});}else{var _sampleRequest=Object.assign({},_this5.state.sampleRequest);_sampleRequest.styleReferenceId=null;_this5.setState({sampleRequest:_sampleRequest});}};this.getMainValues=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(customer,customerDepartmentId){var sample;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(customer==null||customerDepartmentId==null){sample=_this5.state.sampleRequest;sample.styleReferenceId=null;_this5.setState({sampleRequest:sample//isLoading: false
});_this5.props.getalertMessage("error","Selected Magnum Styleref have invalid data");}_context5.next=3;return __WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getCustomerData2({customer:customer,customerDepartmentId:customerDepartmentId}).then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(response.status==200){sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.assistantBuyer=response.text.data.asstbuyer;sampleRequest.buyerName=response.text.data.buyer;sampleRequest.fabricTechnologist=response.text.data.fabtech;sampleRequest.garmentTechnology=response.text.data.gmttech;sampleRequest.magnumTechnologist=response.text.data.garmentTechnologist;_this5.setState({sampleRequest:sampleRequest//isLoading: false
});}case 1:case"end":return _context4.stop();}}},_callee4,_this5);}));return function(_x7){return _ref8.apply(this,arguments);};}()).catch(function(error){_this5.setState({//isLoading: false
});_this5.props.getalertMessage("error",error.toString());});case 3:case"end":return _context5.stop();}}},_callee5,_this5);}));return function(_x5,_x6){return _ref7.apply(this,arguments);};}();this.handleAddSize=function(){_this5.setState(function(prevState){return{sizes:[].concat(_toConsumableArray(prevState.sizes),[{id:prevState.sizes.length+1}])};});};this.handleRemoveSize=function(id){_this5.setState(function(prevState){return{sizes:prevState.sizes.filter(function(size){return size.id!==id;})};});};this.handleRadioChange=function(event){_this5.setState({selectedOption:event.target.value});};this.handleAddLog=function(){_this5.setState(function(prevState){return{logs:[].concat(_toConsumableArray(prevState.logs),[{id:prevState.logs.length+1}])};});};this.handleLogRemove=function(id){_this5.setState(function(prevState){return{logs:prevState.logs.filter(function(size){return size.id!==id;})};});};this.handleAddSection=function(){_this5.setState(function(prevState){return{fabric:[].concat(_toConsumableArray(prevState.fabric),[{id:prevState.fabric.length+1}])};});};this.handleRemovefabric=function(id){_this5.setState(function(prevState){return{fabric:prevState.fabric.filter(function(fabric){return fabric.id!==id;})};});};this.handleAddDispatch=function(){_this5.setState(function(prevState){return{dispatch:[].concat(_toConsumableArray(prevState.dispatch),[{id:prevState.dispatch.length+1}])};});};this.handleRemovedispatch=function(id){_this5.setState(function(prevState){return{dispatch:prevState.dispatch.filter(function(dispatch1){return dispatch1.id!==id;})};});};this.handleAddEmbroidery=function(){_this5.setState(function(prevState){return{embroidery:[].concat(_toConsumableArray(prevState.embroidery),[{id:prevState.embroidery.length+1}])};});};this.handleRemoveEmbroidery=function(id){_this5.setState(function(prevState){return{embroidery:prevState.embroidery.filter(function(embroidery){return embroidery.id!==id;})};});};this.handleAddEmbSection=function(){_this5.setState(function(prevState){return{embellishment:[].concat(_toConsumableArray(prevState.embellishment),[{id:prevState.embellishment.length+1}])};});};this.handleRemoveEmb=function(id){_this5.setState(function(prevState){return{embellishment:prevState.embellishment.filter(function(emb){return emb.id!==id;})};});};this.handleToggleUpload=function(){_this5.setState({showUploadDiv:true});};this.handleCancelUpload=function(){_this5.setState({showUploadDiv:false});};this.handleToggle=function(field){_this5.setState(function(prevState){return{toggles:Object.assign({},prevState.toggles,_defineProperty({},field,!prevState.toggles[field]))};});};this.handleToggleDropdown=function(key){_this5.setState(function(prevState){var isCurrentlyOpen=prevState[key];return _defineProperty({isSample:false,isGarmentTech:false,is3D:false,isFabric:false,isTrim:false,isPattern:false,isCutting:false,isSewing:false,isMarker:false,isEmbellishment:false,isEmbroidery:false,isWash:false,isDispatch:false,isGrading:false,isCosting:false,isSignOff:false},key,!isCurrentlyOpen);},function(){// Focus on the text span after the state update
if(_this5.state[key]&&_this5.textRefs[key].current){_this5.textRefs[key].current.focus();}});};this.updateSampleRequest=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.toggleChange=function(key){_this5.setState(function(prevState){var sampleRequest=Object.assign({},prevState.sampleRequest);// Ensure 'toggle' exists
if(!sampleRequest.toggle){sampleRequest.toggle={};}// Toggle the value
sampleRequest.toggle[key]=!sampleRequest.toggle[key];return{sampleRequest:sampleRequest};});};this.updateSampleModule=function(name,value,Dataindex){var sampleRequest=_this5.state.sampleRequest;if(Dataindex!==undefined){sampleRequest.sample.data[Dataindex][name]=value;}else{sampleRequest.sample[name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.addSize=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sample.data.push({size:null,quantity:null});_this5.setState({sampleRequest:sampleRequest});};this.removeSize=function(dataIndex){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sample.data.splice(dataIndex,1);_this5.setState({sampleRequest:sampleRequest});};this.createSampleModule=function(e){e.preventDefault();var sample={};sample.sample=Object.assign({},_this5.state.sampleRequest.sample);sample.sampleProcess=Object.assign({},_this5.state.sampleRequest.processUpdates.sample);sample._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createSample(sample).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sample=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeSampleModule=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.sample.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeSample(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.sample=Object.assign({},response.text.data);_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.getCADRefNumber=function(value){__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getCADRefNumber(value).then(function(response){if(response.status===200){_this5.setState({CADRefNumInfo:response.text.data});}}).catch(function(error){});};this.changeCADRefNum=function(cad){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(cad!==null){__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getCAD(cad.value).then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(response.status==200){sampleRequest.cad.cadType=response.text.data.cadType;sampleRequest.cad.cadId=cad.value;sampleRequest.cad.name=response.text.data.cadName;sampleRequest.cad.printEmbType=response.text.data.printType;sampleRequest.cad.borderType=response.text.data.borderType;}case 1:case"end":return _context6.stop();}}},_callee6,_this5);}));return function(_x8){return _ref10.apply(this,arguments);};}()).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});}else{sampleRequest.cad.cadType=[];sampleRequest.cad.cadId=null;sampleRequest.cad.name="";sampleRequest.cad.printEmbType="";sampleRequest.cad.borderType="";}setTimeout(function(){_this5.setState({sampleRequest:sampleRequest});},100);};this.cadUpdate=function(){var cad=Object.assign({},_this5.state.sampleRequest.cad);var name=arguments.length<=0?undefined:arguments[0];var value=arguments.length<=1?undefined:arguments[1];cad[name]=value;_this5.setState({sampleRequest:Object.assign({},_this5.state.sampleRequest,{cad:cad})});};this.updateCadValues=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cad[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.saveCAD=function(e){e.preventDefault();var cad={};cad.cad=_this5.state.sampleRequest.cad;cad.cadProcess=_this5.state.sampleRequest.processUpdates.cad;cad._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createCAD(cad).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cad=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeCAD=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.cad.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeCAD(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.cad=Object.assign({},response.text.data);_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.addFabric=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(!sampleRequest.fabric.length){__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getFabricNumber("F-99999").then(function(response){if(response.status==200){sampleRequest.fabric.push({fabricId:null,fabricNumber:"",fabricList:response.text.data,fabricPosition:null,classificationOfFabric:"",quality:"",countAndConstruction:"",fabricRadio:"notInHse"});// this.setState({ fabricList: response.text.data })
_this5.getFabricInfo(response.text.data[0],0);}}).catch(function(error){});}else{sampleRequest.fabric.push({fabricId:null,fabricNumber:"",fabricList:_this5.props.fabricList,fabricPosition:null,classificationOfFabric:"",quality:"",countAndConstruction:"",fabricRadio:"notInHse"});}_this5.setState({sampleRequest:sampleRequest});};this.removeFabric=function(index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.fabric.splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.getFabricNumber=function(value,index){// alert(1)
__WEBPACK_IMPORTED_MODULE_13__services__["e" /* DevelopmentServices */].getFabricNumber(value).then(function(response){if(response.status==200){// this.setState({ fabricList: response.text.data })
var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(sampleRequest.fabric.length){sampleRequest.fabric[index].fabricList=response.text.data;_this5.setState({sampleRequest:sampleRequest});}}}).catch(function(error){});};this.getFabricInfo=function(fabric,index){if(fabric!=null){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getFabricInfo(fabric.value).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(response.status==200){sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.fabric[index].classificationOfFabric=response.text.data.classificationOfFabric!==null?response.text.data.classificationOfFabric.name:"";sampleRequest.fabric[index].countAndConstruction=response.text.data.count.warp+"*"+response.text.data.count.weft+"/"+response.text.data.construction.warp+"*"+response.text.data.construction.weft;sampleRequest.fabric[index].quality=response.text.data.quality!==null?response.text.data.quality.name:"";sampleRequest.fabric[index].fabricNumber=fabric.value;sampleRequest.fabric[index].bNumber=response.text.data.bNumber.baseRefNumber;sampleRequest.test1=response.text.data.bNumber.baseRefNumber;_this5.setState({sampleRequest:sampleRequest});}response.status==404&&_this5.props.getalertMessage("error",response.text.message);response.status==401&&_this5.props.unauthorisedFunc();case 3:case"end":return _context7.stop();}}},_callee7,_this5);}));return function(_x9){return _ref11.apply(this,arguments);};}()).catch(function(error){});}else{var sampleRequest=Object.assign({},_this5.state.sampleRequest);//console.log(this.sampleRequest.fabric,"test fab")
sampleRequest.fabric[index].fabricNumber=null;_this5.setState({sampleRequest:sampleRequest});}};this.updateFabricName=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);//console.log(sampleRequest, "sampleRequestname");
sampleRequest.fabric[index][name]=value;//console.log(sampleRequest.fabric[index][name], "sampleRequestname1212");
_this5.setState({sampleRequest:sampleRequest});};this.updateFabric=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.fabric[index][name]=value;_this5.setState({sampleRequest:sampleRequest});};this.checkValidation=function(data,element){// console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
// console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
if(_this5.validateArrayObject(_this5.state.sampleRequest.fabric,"fabricPosition",null)&&(_this5.validateArrayObject(_this5.state.sampleRequest.fabric,"fabricNumber",null)||_this5.validateArrayObject(_this5.state.sampleRequest.fabric,"fabricId",null))){if(data=="save"){_this5.createFabric(element);}else{_this5.completeFabric(element);}}else{_this5.props.getalertMessage("error","Please fill all mandatory fields");}};this.createFabric=function(e){e.preventDefault();var fabric={};fabric.fabric=_this5.state.sampleRequest.fabric;fabric._id=_this5.state._id;fabric.fabricComments=_this5.state.sampleRequest.fabricComments;fabric.fabricProcess=_this5.state.sampleRequest.processUpdates.fabric;var count=fabric.fabric.reduce(function(n,data){return n+(data.fabricPosition!==null);},0);if(count==fabric.fabric.length){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createFabric(fabric).then(function(response){if(response.status===200){// let sampleRequest = { ...this.state.sampleRequest }
// sampleRequest.fabric = response.text.data
// this.setState({
//   sampleRequest
// })
_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});}else{_this5.props.getalertMessage("error","fabric position mandatory");}};this.completeFabric=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.fabric.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeFabric(request).then(function(response){if(response.status==200){sampleRequest.processUpdates.fabric=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateTrimRow1=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name==="trimCategory"){sampleRequest.trim.row1[index][name]=value;sampleRequest.trim.row1[index]["trimNumber"]=null;_this5.setState({sampleRequest:sampleRequest});}else{sampleRequest.trim.row1[index][name]=value;_this5.setState({sampleRequest:sampleRequest});}};this.getTrimRefNo=function(trimCategory,value,index){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(trimCategory,value).then(function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.trim.row1[index].trimList=response.text.data;_this5.setState({// trimNumberList: response.text.data
sampleRequest:sampleRequest});case 3:case"end":return _context8.stop();}}},_callee8,_this5);}));return function(_x10){return _ref12.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});};this.getTrimInfo=function(trim,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(trim!==null){sampleRequest.trim.row1[index].trimNumber=trim._id;sampleRequest.trim.row1[index].description=trim.description;sampleRequest.trim.row1[index].quality=trim.quality;sampleRequest.trim.row1[index].sizeNumber=trim.sizeNumber;sampleRequest.trim.row1[index].size=trim.size;}else{sampleRequest.trim.row1[index].trimNumber=null;}_this5.setState({sampleRequest:sampleRequest});// this.samplePrintTrim();
};this.updateTrim=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.trim[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.removeTrim=function(keyName,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.trim[keyName].splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.addTrim=function(keyName){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var prefillInfo=_this5.state.prefillInfo;var trimCategory=prefillInfo.TRIM.TRIMCATEGORY&&prefillInfo.TRIM.TRIMCATEGORY.find(function(x){return x.label.toLowerCase()==="thread";}).value;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"th-00001").then(function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(response){var rowdata;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:rowdata={trimId:response.text.data[0]._id,trimCategory:trimCategory,trimNumber:response.text.data[0]._id,description:response.text.data[0].description,size:response.text.data[0].size,quality:response.text.data[0].quality,sizeNumber:response.text.data[0].sizeNumber,trimRadio:"notInHse",trimList:response.text.data};if(!sampleRequest.trim[keyName]){sampleRequest.trim=_defineProperty({},keyName,[rowdata]);}else{sampleRequest.trim[keyName]=[].concat(_toConsumableArray(sampleRequest.trim[keyName]),[rowdata]);}_this5.setState({sampleRequest:sampleRequest});case 3:case"end":return _context9.stop();}}},_callee9,_this5);}));return function(_x11){return _ref13.apply(this,arguments);};}()).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.checkValidationTrim=function(data,element){// console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
// console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
if(_this5.validateArrayObjectTrim(_this5.state.sampleRequest.trim.row1,"trimNumber",null)&&(_this5.validateArrayObjectTrim(_this5.state.sampleRequest.trim.row1,"trimCategory","")||_this5.validateArrayObjectTrim(_this5.state.sampleRequest.trim.row1,"trimCategory",null))){if(data==="save"){_this5.createTrim(element);}else{_this5.completeTrim(element);}}else{_this5.props.getalertMessage("error","Please fill all mandatory fields");}};this.createTrim=function(e){e.preventDefault();var trim={};trim.trim=_this5.state.sampleRequest.trim;trim.trimProcess=_this5.state.sampleRequest.processUpdates.trim;trim._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createTrim(trim).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var row1=sampleRequest.trim.row1,row2=sampleRequest.trim.row2;sampleRequest.trim=response.text.data;sampleRequest.trim.row1=row1;sampleRequest.trim.row2=row2;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeTrim=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.trim.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeTrim(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.trim=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updatePattern=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.pattern[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.addPatternLog=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.pattern.logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this5.setState({sampleRequest:sampleRequest});};this.removePatternLog=function(i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.pattern.logs.splice(i,1);_this5.setState({sampleRequest:sampleRequest});};this.getAssignToList=function(value){__WEBPACK_IMPORTED_MODULE_13__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(res.status==200)){_context10.next=7;break;}_context10.t0=_this5;_context10.next=4;return res.text.data;case 4:_context10.t1=_context10.sent;_context10.t2={assignedToList:_context10.t1};_context10.t0.setState.call(_context10.t0,_context10.t2);case 7:case"end":return _context10.stop();}}},_callee10,_this5);}));return function(_x12){return _ref14.apply(this,arguments);};}());};this.updatePatternCheck=function(name,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.pattern.logs[i][name]=new Date();_this5.setState({sampleRequest:sampleRequest});};this.updatePatternLog=function(name,value,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.pattern.logs[i][name]=new Date();}else{sampleRequest.pattern.logs[i][name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.createPattern=function(e){e.preventDefault();var pattern={};pattern.pattern=Object.assign({},_this5.state.sampleRequest.pattern);pattern.patternProcess=Object.assign({},_this5.state.sampleRequest.processUpdates.pattern);pattern._id=_this5.state._id;var sample=_this5.state.sampleRequest.toggle.sample;var status=_this5.state.sampleRequest.processUpdates.sample.status;if(sample&&status!=="COMPLETED"&&_this5.state.sampleRequest.processUpdates.pattern.status==="COMPLETED"){return _this5.props.getalertMessage("error","Sample process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createPattern(pattern).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.pattern=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completePattern=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.pattern.comments};var sample=sampleRequest.toggle.sample;var status=sampleRequest.processUpdates.sample.status;if(sample&&status!=="COMPLETED"){return _this5.props.getalertMessage("error","Sample process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completePattern(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.pattern=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateCutting=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name==="cuttingMasterName"){if(value!==null){sampleRequest.cutting[name]=value.value;}else{sampleRequest.cutting[name]=null;}}else{sampleRequest.cutting[name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.addCuttingLog=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cutting.logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this5.setState({sampleRequest:sampleRequest});};this.removeCuttingLog=function(i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cutting.logs.splice(i,1);_this5.setState({sampleRequest:sampleRequest});};this.updateCuttingLog=function(name,value,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.cutting.logs[i][name]=new Date();}else{sampleRequest.cutting.logs[i][name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.updateCuttingCheck=function(name,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cutting.logs[i][name]=new Date();_this5.setState({sampleRequest:sampleRequest});};this.createCutting=function(e){var data={};data.cutting=_this5.state.sampleRequest.cutting;data.cuttingProcess=Object.assign({},_this5.state.sampleRequest.processUpdates.cutting);data._id=_this5.state._id;var _state$sampleRequest$=_this5.state.sampleRequest.toggle,pattern=_state$sampleRequest$.pattern,fabric=_state$sampleRequest$.fabric;var patternStatus=_this5.state.sampleRequest.processUpdates.pattern.status;var fabricStatus=_this5.state.sampleRequest.processUpdates.fabric.status;if(_this5.state.sampleRequest.processUpdates.cutting.status==="COMPLETED"&&(pattern&&patternStatus!=="COMPLETED"||fabric&&fabricStatus!=="COMPLETED")){return _this5.props.getalertMessage("error","Pattern and Fabric should complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createCutting(data).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.cutting=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeCutting=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.cutting.comments};var _state$sampleRequest$2=_this5.state.sampleRequest.toggle,pattern=_state$sampleRequest$2.pattern,fabric=_state$sampleRequest$2.fabric;var patternStatus=_this5.state.sampleRequest.processUpdates.pattern.status;var fabricStatus=_this5.state.sampleRequest.processUpdates.fabric.status;if(pattern&&patternStatus!=="COMPLETED"||fabric&&fabricStatus!=="COMPLETED"){return _this5.props.getalertMessage("error","Pattern and Fabric should complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeCutting(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.cutting=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateSewing1=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name==="smokingOrShiring"){sampleRequest.sewing.smokingOrShiring=!sampleRequest.sewing.smokingOrShiring;}else{sampleRequest.sewing[name]=value;}_this5.setState({sampleRequest:sampleRequest},function(){return _this5.onSmockingShirring();});};this.onSmockingShirring=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(sampleRequest.sewing&&sampleRequest.sewing.trimData&&sampleRequest.sewing.trimData.length>0){sampleRequest.sewing.trimData.forEach(function(x,i){if(x.trimCategory){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(x.trimCategory).then(function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:sampleRequest.sewing.trimData[i].trimList=response.text.data;case 1:case"end":return _context11.stop();}}},_callee11,_this5);}));return function(_x13){return _ref15.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});}});}else{sampleRequest.sewing.trimData=[];if(sampleRequest.sewing.trimData.length===0){var prefillInfo=Object.assign({},_this5.state.prefillInfo.TRIM);var trimCategory=prefillInfo.TRIMCATEGORY&&prefillInfo.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"").then(function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:// let sampleRequest = { ...this.state.sampleRequest };
sampleRequest.sewing.trimData[0]={trimId:null,trimCategory:trimCategory,trimNumber:"",description:"",size:"",quality:"",sizeNumber:"",trimRadio:"notInHse"};sampleRequest.sewing.trimData[0].trimList=response.text.data;_this5.setState({sampleRequest:sampleRequest});case 3:case"end":return _context12.stop();}}},_callee12,_this5);}));return function(_x14){return _ref16.apply(this,arguments);};}()).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});}}_this5.setState({sampleRequest:sampleRequest});};this.addSewing=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.sewingData.push({tailorName:null,sewingType:null,size:"",quantity:"",approvalStatus:"",rejected:"",logs:[// {
//   remarks: "",
//   timeIn: "",
//   timeOut: "",
//   breakTime: "",
//   reason: ""
// }
]});_this5.setState({sampleRequest:sampleRequest});};this.removeSewing=function(index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);// sampleRequest.sewing.sewingData = sampleRequest.sewing.sewingData.filter((d,i) => i != index)
sampleRequest.sewing.sewingData.splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.updateSewing=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name==="tailorName"){if(value!==null){sampleRequest.sewing.sewingData[index][name]=value.value;}else{sampleRequest.sewing.sewingData[index][name]=null;}}else{sampleRequest.sewing.sewingData[index][name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.updateSewingLog=function(name,value,i,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name=="timeIn"||name=="timeOut"){sampleRequest.sewing.sewingData[index].logs[i][name]=new Date();}else{sampleRequest.sewing.sewingData[index].logs[i][name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.updateSewingCheck=function(name,i,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs[i][name]=new Date();_this5.setState({sampleRequest:sampleRequest});};this.addSewingLog=function(index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs.push({remarks:"",timeIn:"",timeOut:"",breakTime:"",reason:""});_this5.setState({sampleRequest:sampleRequest});};this.removeSewingLog=function(i,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.sewingData[index].logs.splice(i,1);_this5.setState({sampleRequest:sampleRequest});};this.updateSewingTrimData=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.trimData[index][name]=value;_this5.setState({sampleRequest:sampleRequest},function(){return _this5.updateCalcSewing();});if(name=="trimCategory"){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(value,"").then(function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.trimData[index].trimList=response.text.data;_this5.setState({sampleRequest:sampleRequest});case 3:case"end":return _context13.stop();}}},_callee13,_this5);}));return function(_x15){return _ref17.apply(this,arguments);};}()).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});}};this.updateCalcSewing=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var _state$prefillInfo$SA=_this5.state.prefillInfo.SAMPLEREQUEST.SHIRRINGORSMOCKING,smockingorElastic=_state$prefillInfo$SA.smockingorElastic,toptthElastic=_state$prefillInfo$SA.toptthElastic;sampleRequest.sewing.trimData=sampleRequest.sewing.trimData.map(function(data,index){if(data.type=="Both Elastic"){data.multiple=Number(smockingorElastic.multiple);data.wastage=Number(smockingorElastic.wastage);}if(data.type=="Top TTH / Bottom Elastic"){data.multiple=Number(toptthElastic.multiple);data.wastage=Number(toptthElastic.wastage);}if(data.multiple!==null&&data.noOfRow!==null&&data.length!==null){var calc=Number(parseFloat(data.noOfRow))*Number(parseFloat(data.length))*Number(parseFloat(data.multiple));// /100
data.totalReq=Number((calc+calc*(data.wastage/100)).toFixed(2));}return data;});_this5.setState({sampleRequest:sampleRequest});};this.getTrimRefNoSewing=function(trimCategory,value,index){__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(trimCategory,value).then(function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(response){var sampleRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.trimData[index].trimList=response.text.data;_this5.setState({// trimNumberList: response.text.data
sampleRequest:sampleRequest});case 3:case"end":return _context14.stop();}}},_callee14,_this5);}));return function(_x16){return _ref18.apply(this,arguments);};}()).catch(function(error){return alert(error.toString());});};this.getTrimInfoSewTrimData=function(trim,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(trim!==null){sampleRequest.sewing.trimData[index].trimNumber=trim._id;sampleRequest.sewing.trimData[index].description=trim.description;sampleRequest.sewing.trimData[index].quality=trim.quality;sampleRequest.sewing.trimData[index].sizeNumber=trim.sizeNumber;sampleRequest.sewing.trimData[index].size=trim.size;}else{sampleRequest.sewing.trimData[index].trimNumber=null;}_this5.setState({sampleRequest:sampleRequest});};this.smockingShirringaddTrim=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var prefillInfo=Object.assign({},_this5.state.prefillInfo.TRIM);var trimCategory=prefillInfo.TRIMCATEGORY&&prefillInfo.TRIMCATEGORY.filter(function(x){return x.label.toLowerCase()==="thread";})[0].value;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].getTrimNumber(trimCategory,"").then(function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:// let sampleRequest = { ...this.state.sampleRequest };
sampleRequest.sewing.trimData.push({trimId:null,trimCategory:trimCategory,trimNumber:"",description:"",size:"",quality:"",sizeNumber:"",trimRadio:"notInHse"});sampleRequest.sewing.trimData[sampleRequest.sewing.trimData.length-1].trimList=response.text.data;_this5.setState({sampleRequest:sampleRequest});case 3:case"end":return _context15.stop();}}},_callee15,_this5);}));return function(_x17){return _ref19.apply(this,arguments);};}()).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.smockingShirringremoveTrim=function(index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.sewing.trimData.splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.createSewing=function(e){e.preventDefault();var data={};var sewing=Object.assign({},_this5.state.sampleRequest.sewing);if(!sewing.smokingOrShiring){sewing.trimData=[];}data.sewing=sewing;data.sewingProcess=_this5.state.sampleRequest.processUpdates.sewing;data._id=_this5.state._id;var cutting=_this5.state.sampleRequest.toggle.cutting;var status=_this5.state.sampleRequest.processUpdates.cutting.status;if(_this5.state.sampleRequest.processUpdates.sewing.status==="COMPLETED"&&cutting&&status!=="COMPLETED"){return _this5.props.getalertMessage("error","Cutting process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createSewing(data).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var sewingData=sampleRequest.sewing.sewingData;var trimData=sampleRequest.sewing.trimData;sampleRequest.sewing=response.text.data;sampleRequest.sewing.sewingData=sewingData;sampleRequest.sewing.trimData=trimData;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeSewing=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.sewing.comments};var cutting=sampleRequest.toggle.cutting;var status=sampleRequest.processUpdates.cutting.status;if(cutting&&status!=="COMPLETED"){return _this5.props.getalertMessage("error","Cutting process need to complete!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeSewing(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.sewing=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateMarker=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.marker[name]=value;_this5.setState([sampleRequest]);};this.createMarker=function(e){e.preventDefault();var objData={};objData.marker=_this5.state.sampleRequest.marker;objData.markerProcess=_this5.state.sampleRequest.processUpdates.marker;objData._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createMarker(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.marker=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeMarker=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.marker.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeMarker(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.marker=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.addEmb=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embellishment.push({embType:null,hoursMinutes:null,pricePerHalfHour:null});_this5.setState({sampleRequest:sampleRequest});};this.removeEmb=function(index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embellishment.splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.updateEmbellishment=function(name,value,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embellishment[index][name]=value;_this5.setState({sampleRequest:sampleRequest});};this.createEmbellishment=function(e){var info={};info.embellishment=_this5.state.sampleRequest.embellishment;info.embellishmentProcess=_this5.state.sampleRequest.processUpdates.embellishment;info.embellishmentComments=_this5.state.sampleRequest.embellishmentComments;info._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createEmbelishment(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embellishment=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeEmbellishment=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.embellishment.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeEmbelishment(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.embellishment=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateEmbroidery=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.moveToRight=function(){var x=document.getElementById("mySelect").selectedIndex;// var y = document.getElementById("mySelect").options;
// // alert("Index: " + y[x].index + " is " + y[x].text);
// var z = document.getElementById("mySelect2");
// var option = document.createElement("option");
// option.text = document.getElementById("mySelect").value;
// z.add(option);
var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.rightData.push(document.getElementById("mySelect").value);sampleRequest.embroidery.leftData.splice(document.getElementById("mySelect").selectedIndex,1);_this5.setState({sampleRequest:sampleRequest});// document.getElementById("mySelect").remove(y[x].index);
};this.moveToLeft=function(){var x=document.getElementById("mySelect2").selectedIndex;// var y = document.getElementById("mySelect2").options;
// // alert("Index: " + y[x].index + " is " + y[x].text);
// var z = document.getElementById("mySelect");
// var option = document.createElement("option");
// option.text = document.getElementById("mySelect2").value;
// z.add(option);
var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.leftData.push(document.getElementById("mySelect2").value);sampleRequest.embroidery.rightData.splice(document.getElementById("mySelect2").selectedIndex,1);_this5.setState({sampleRequest:sampleRequest});// document.getElementById("mySelect2").remove(y[x].index);
};this.moveToUp=function(){var x=document.getElementById("mySelect2").selectedIndex;var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.rightData=_this5.swapIndices(sampleRequest.embroidery.rightData,x,x-1);_this5.setState({sampleRequest:sampleRequest});};this.moveToBottom=function(){var x=document.getElementById("mySelect2").selectedIndex;var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.rightData=_this5.swapIndices(sampleRequest.embroidery.rightData,x,x+1);_this5.setState({sampleRequest:sampleRequest});};this.swapIndices=function(array,index1,index2){var newArray=array.slice();newArray[index1]=array[index2];newArray[index2]=array[index1];return newArray;};this.changeBackingArray=function(action,index){var sampleRequest=Object.assign({},_this5.state.sampleRequest);action==="add"?sampleRequest.embroidery.backingData.push({backingType:null,width:null,placement:null}):sampleRequest.embroidery.backingData.splice(index,1);_this5.setState({sampleRequest:sampleRequest});};this.updateEmbroideryBackingData=function(name,value,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.backingData[i][name]=value;_this5.setState({sampleRequest:sampleRequest});if(name=="backingType"){_this5.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE.map(function(data,index){if(data.value==value){var widthList=[];data.typeMultiple.map(function(dat1){widthList.push({label:dat1.width,value:dat1.width});});_this5.setState({widthList:widthList});}});}};this.addEmbroideryData=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.embroideryData.push({embPlacement:null,embForm:null,noOfCols:null,frames:null,stitchesMtr:"",consumption:"",stitchCount:"",priceForStitches:""});_this5.setState({sampleRequest:sampleRequest});};this.removeEmbroideryData=function(i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.embroideryData=sampleRequest.embroidery.embroideryData.filter(function(d,ind){return ind!=i;});_this5.setState({sampleRequest:sampleRequest});};this.updateEmbroideryData=function(name,value,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery.embroideryData[i][name]=value;if(name==="consumption"||name==="stitchesMtr"){var consumption=sampleRequest.embroidery.embroideryData[i].consumption?sampleRequest.embroidery.embroideryData[i].consumption:0;var stitches=sampleRequest.embroidery.embroideryData[i].stitchesMtr?sampleRequest.embroidery.embroideryData[i].stitchesMtr:0;var stitchCount=consumption*stitches;sampleRequest.embroidery.embroideryData[i].stitchCount=Number(stitchCount).toFixed(2);}if(name==="embForm"){sampleRequest.embroidery.embroideryData[i][name]=value;sampleRequest.embroidery.embroideryData[i].priceForStitches=_this5.state.prefillInfo.SAMPLEREQUEST.EMBFORM.find(function(x){return x.label===value;}).price;}else{sampleRequest.embroidery.embroideryData[i][name]=value;}_this5.setState({sampleRequest:sampleRequest});};this.saveEmbroidery=function(e){e.preventDefault();var info={};info.embroidery=_this5.state.sampleRequest.embroidery;info.embroideryProcess=_this5.state.sampleRequest.processUpdates.embroidery;info._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createEmbroidery(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.embroidery=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeEmbroidery=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.embroidery.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeEmbroidery(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.embroidery=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateDispatch=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.dispatch[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.addDispatchData=function(){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.dispatch.data.push({location:null,date:__WEBPACK_IMPORTED_MODULE_17_moment___default()().subtract(1,"day").format(),courier:null,awbNumber:"",size:null,quantity:null});_this5.setState({sampleRequest:sampleRequest});};this.removeDispatchData=function(i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.dispatch.data=sampleRequest.dispatch.data.filter(function(d,ind){return ind!=i;});_this5.setState({sampleRequest:sampleRequest});};this.udpateDispatchValues=function(name,value,i){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.dispatch.data[i][name]=value;_this5.setState({sampleRequest:sampleRequest});};this.createDispatch=function(e){e.preventDefault();var objData={};objData.dispatch=_this5.state.sampleRequest.dispatch;objData.dispatchProcess=_this5.state.sampleRequest.processUpdates.dispatch;objData._id=_this5.state._id;var _state$sampleRequest$3=_this5.state.sampleRequest.toggle,sewing=_state$sampleRequest$3.sewing,wash=_state$sampleRequest$3.wash;var status=_this5.state.sampleRequest.processUpdates.sewing.status;var washStatus=_this5.state.sampleRequest.processUpdates.wash.status;if(_this5.state.sampleRequest.processUpdates.dispatch.status==="COMPLETED")if(sewing&&status!=="COMPLETED"){return _this5.props.getalertMessage("error","Sewing process need to complete!",5000);}else if(wash&&(washStatus==="PENDING"||washStatus==="IN PROCESS")){return _this5.props.getalertMessage("error","Washing process need to complete or cancel!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createDispatch(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.wash=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeDispatch=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.dispatch.comments};var _sampleRequest$toggle=sampleRequest.toggle,sewing=_sampleRequest$toggle.sewing,wash=_sampleRequest$toggle.wash;var status=sampleRequest.processUpdates.sewing.status;var washStatus=sampleRequest.processUpdates.wash.status;if(sewing&&status!=="COMPLETED"){return _this5.props.getalertMessage("error","Sewing process need to complete!",5000);}else if(wash&&(washStatus==="PENDING"||washStatus==="IN PROCESS")){return _this5.props.getalertMessage("error","Washing process need to complete or cancel!",5000);}__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeDispatch(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.dispatch=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateQc=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.qc[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.createQC=function(e){e.preventDefault();var info={};info.qc=_this5.state.sampleRequest.qc;info.qcProcess=_this5.state.sampleRequest.processUpdates.qc;info._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createQC(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.qc=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeQC=function(e){// e.preventDefault();
var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.qc.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeQC(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.qc=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.createSignOff=function(e){e.preventDefault();var objData={};objData.signOffComments=_this5.state.sampleRequest.signOffComments;objData.signOffProcess=_this5.state.sampleRequest.processUpdates.signOff;objData._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createSignOff(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.signOffComments=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeSignoff=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.signOff.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeSignOff(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.signOff=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.getRefImages=function(refImages,moduleName){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest[moduleName].refImages=refImages;_this5.setState({sampleRequest:sampleRequest});};this.updateWash1=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);if(name==="washType"){var washData=_this5.state.prefillInfo.WASH.WASHTYPE.find(function(x){return x.value===value;});sampleRequest.wash.washData.price=washData&&washData.price||'';}sampleRequest.wash.washData[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.updateWash=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.wash[name]=value;_this5.setState({sampleRequest:sampleRequest});};this.createWash=function(e){e.preventDefault();var info={};info.wash=_this5.state.sampleRequest.wash;info.washProcess=_this5.state.sampleRequest.processUpdates.wash;info._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createWash(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.wash=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeWash=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.wash.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeWash(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.wash=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.updateGarment=function(name,value){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.garmentTechnologist[name]=value;_this5.setState([sampleRequest]);};this.createGarment=function(e){e.preventDefault();var info={};info.garmentTechnologist=_this5.state.sampleRequest.garmentTechnologist;info.garmentProcess=_this5.state.sampleRequest.processUpdates.garmentTechnologist;info._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createGarment(info).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.garmentTechnologist=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeGarment=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.garmentTechnologist.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeGarment(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.garmentTechnologist=Object.assign({},response.text.data);_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.createCosting=function(e){e.preventDefault();var objData={};objData.costingComments=_this5.state.sampleRequest.costingComments;objData.costingProcess=_this5.state.sampleRequest.processUpdates.costing;objData._id=_this5.state._id;__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].createCosting(objData).then(function(response){if(response.status===200){var sampleRequest=Object.assign({},_this5.state.sampleRequest);sampleRequest.costing=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};this.completeCosting=function(e){var sampleRequest=Object.assign({},_this5.state.sampleRequest);var request={_id:_this5.state._id,comments:sampleRequest.processUpdates.costing.comments};__WEBPACK_IMPORTED_MODULE_13__services__["j" /* SampleServices */].completeCosting(request).then(function(response){if(response.status===200){sampleRequest.processUpdates.costing=response.text.data;_this5.setState({sampleRequest:sampleRequest});_this5.props.getalertMessage("success",response.text.message);}else if(response.status==401){_this5.props.unauthorisedFunc();}else{_this5.props.getalertMessage("error",response.text.message);}}).catch(function(error){return _this5.props.getalertMessage("error",error.toString());});};};var mapStateToProps=function mapStateToProps(state){return{toggle:state.Header.toggle,// Getting 'toggle' from 'Header' slice of state
rights:state.main.rights// Getting 'rights' from 'main' slice of state
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps)(SampleMobileApp)));// export default SampleMobileApp;

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAPCAYAAADd/14OAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkSURBVHgBndI9igIxFADg9/KYLRfLhWWHsKMgOoLTWepJxBN4BPUkWlp6A4/gVCLYvNLOUazUJL5go86oYCDJS/LlhyQIL9JvpdYki/2jMSN6hsKo3lWOphK2CNUOnyEAnPhYwAzNoZdH//EgjGLn81/UmBRvd4PCcjz8HMkW43cItW6WLJ2316bjvQmSjNPsESqWTqVsInHm532TWfzoqs5BX/B6mQrugHMsq+ovCuaP+O4etQxaRXNAFIR8NKfOhlecg69w4cvcY8iMHEsVQZYVlA0ScJBKs0QG2/AuaflBvr4AZVBfwNGW2LkAAAAASUVORK5CYII="

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGwSURBVHgBzVXBTsJAEJ1pIeFmvWkg2ovAEb4AuSkSxT/gD5Qv0D/QT/APgETUm/gFcES89GCjx+Xmoe04WyBpTJttN5D4Dtvd7mtnZ+bNDsCWgdFFsdrqGoHZICSLl1bsB4ROQP6b+/H0AFkMlMrtCa9qPBVA4PBcJHwjORYRTd35qA5pIE9eqrSpWDm7TsVnXsg/anVVXCMcAzzmUbjvo3tIgRVPGGg2UhlAxEN+TCELOIyEwa6KZoAuwhzhjoqWA00Q0DANT9tANF971RM7R7k7D73e9+zFifL0QxRB4acg2KMaG5nsl087GzfgOAPho99kI8JEs881dbPeU4booHJ+FUDQUfE4KcDFJ8LSRbjlWlnIMCo98MFHSAmM3Dws/fCqUXqwSqayAFeJ7ss5h6rnzpYi0FbR35/nKf8aXpIITf75eL23SRVNWab1z9njOLqn7YFMvsyPDKFUEb+6jONpeyCVxUm9UPHWBqSLFmwBoQHW74JPY0M21GR3U5GWHhg05tFK23Bk/CVftk4VN75lJvQG9tTiArIhQ8tMavp2Al9wWIQH3vBr/jyA/4BfPC6yCCzO1AAAAAAASUVORK5CYII="

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add-circle.ebc88f6b.svg";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/remove-circle.a6ccfdf4.svg";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/warning.50715480.svg";

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sampleMobileApp_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sampleMobileApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sampleMobileApp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MobileAppFields__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_calendar_svg__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_calendar_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import modalIcon from "../../../assets/images/testIcon.svg"
// import Audit from "../../Common/audit"
// import Field from "../../../Common/Field/Field"
// import "./index.css"
// import MeasurementModal from "../PatternModule/MeasurementModal/MeasurementModal"
// import Button from "../../../Buttons/Button"
var ModuleHeader=function(_Component){_inherits(ModuleHeader,_Component);function ModuleHeader(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ModuleHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModuleHeader.__proto__||Object.getPrototypeOf(ModuleHeader)).call.apply(_ref,[this].concat(args))),_this),_this.state={assignedToList:[]// statusOption: [
//   { label: "CANCEL", value: "CANCEL" },
//   { label: "COMPLETED", value: "COMPLETED" },
//   { label: "IN PROCESS", value: "INPROCESS" },
//   { label: "PENDING", value: "PENDING" }
// ]
},_this.searchEmpList=function(value){__WEBPACK_IMPORTED_MODULE_3__services__["h" /* PermissionServices */].searchEmploye(value).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(res.status==200)){_context.next=7;break;}_context.t0=_this;_context.next=4;return res.text.data;case 4:_context.t1=_context.sent;_context.t2={assignedToList:_context.t1};_context.t0.setState.call(_context.t0,_context.t2);case 7:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModuleHeader,[{key:"componentWillMount",value:function componentWillMount(){this.searchEmpList("");var _props=this.props,process=_props.process,disabled=_props.disabled;this.setState({process:process,disabled:disabled});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// this.searchEmpList("")
var process=nextProps.process,disabled=nextProps.disabled;this.setState({process:process,disabled:disabled});}// componentDidMount() {
//   this.searchEmpList("")
// }
},{key:"render",value:function render(){var _this3=this;var state=this.props.location.state;var _state$process=this.state.process,assignedTo=_state$process.assignedTo,status=_state$process.status,ETA=_state$process.ETA,processDate=_state$process.processDate;var _props2=this.props,placeOfSewing=_props2.placeOfSewing,statusList=_props2.statusList,measurementModal=_props2.measurementModal;//console.log(this.props,"moduleheaderrporps")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Assigned To"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"mobileAppAsync",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{name:"assignedTo",value:assignedTo,onChange:function onChange(value){return _this3.props.updateModulesMain("assignedTo",value,_this3.props.moduleName);},placeholder:"Find AssignedTo",options:this.state.assignedToList,disabled:this.state.disabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"status",value:status,label:"Status",options:statusList,onChange:function onChange(name,value){return _this3.props.updateModulesMain(name,value,_this3.props.moduleName);},disabled:this.state.disabled})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MobileAppFields__["a" /* default */],{durationETA:this.props.durationETA,isFormGroup:true,inputType:"date",inputName:"ETA",value:ETA,label:"ETA Date",onChange:function onChange(name,value){return _this3.props.updateModulesMain(name,value,_this3.props.moduleName);},disabled:this.state.disabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"label1"},"Completed Date"),status=="COMPLETED"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},processDate!==null?__WEBPACK_IMPORTED_MODULE_4_moment___default()(processDate).format("DD MMM YYYY"):"",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_calendar_svg___default.a,alt:"calender"})):// <span style={{display:"flex",justifyContent:"flex-start",alignItems:"center",width:"100%",
//   height:"100%"
// }}>-</span>
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"completed-date-mdheader"},"-",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_MobileApp_calendar_svg___default.a,alt:"calender"})))),placeOfSewing!==undefined&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"select-qr",style:{flex:"1"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MobileAppFields__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"placeOfSewing",value:placeOfSewing!==null||this.props.PLACEOFSEWING&&this.props.PLACEOFSEWING[0].value,label:"Place of sewing",options:this.props.PLACEOFSEWING||[],onChange:this.props.updateSewing,disabled:this.state.disabled})));}}]);return ModuleHeader;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* withRouter */])(ModuleHeader));

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/calendar.7e4f16fe.svg";

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_common_fileType__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_Video__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_alert__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Common_Alert__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sampleMobileApp_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sampleMobileApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__sampleMobileApp_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//options 
//components
//images
var FileUpload=function(_Component){_inherits(FileUpload,_Component);function FileUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileUpload.__proto__||Object.getPrototypeOf(FileUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={action:'',moduleName:'',refImages:[],openModal:false,imageEdit:false,imageForModal:"",imageIndex:"",imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",index:_this.props.index,imageTypeOption:[],loading:false,disabled:false},_this.imageInfo=function(index){_this.setState({action:'edit',imageIndex:index,imageInfo:_this.state.refImages[index]});},_this.uploadNewImage=function(e){var imageInfo=Object.assign({},_this.state.imageInfo);imageInfo.fileName=e.target.files[0].name;__WEBPACK_IMPORTED_MODULE_4__services_common_fileType__["a" /* default */].map(function(data,index){if(data.fileType==e.target.files[0].type){imageInfo.fileType=data.name;}});_this.setState({uploadNewImage:e.target.files[0],imageInfo:imageInfo});},_this.updateImage=function(){var imageInfo=Object.assign({},_this.state.imageInfo);var uploadNewImage=_this.state.uploadNewImage;_this.setState({loading:true});var refImages=[].concat(_toConsumableArray(_this.state.refImages));if(uploadNewImage!==""){__WEBPACK_IMPORTED_MODULE_3__services__["f" /* FileUploadService */].uploadFile(uploadNewImage,_this.state.moduleName).then(function(response){if(response.status===200){imageInfo.path=response.text.data.url;imageInfo.url=response.text.data.fullUrl;imageInfo.fileName=uploadNewImage.name;if(_this.state.action=='add'){refImages.push(Object.assign({},imageInfo));}if(_this.state.action=='edit'){refImages[_this.state.imageIndex]=Object.assign({},imageInfo);}_this.setState({refImages:refImages,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",imageEdit:false},function(){return _this.props.getRefImages(refImages,_this.state.index);},_this.setState({loading:false}));}else if(response.status==401){__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].unauthorisedFunc();}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this.msg,response.text.message);}}).catch(function(error){_this.setState({loading:false});});}else{refImages[_this.state.imageIndex]=Object.assign({},imageInfo);_this.setState({refImages:refImages,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''},uploadNewImage:"",imageEdit:false},function(){return _this.props.getRefImages(refImages,_this.state.index);},_this.setState({loading:false}));}},_this._onChange=function(name,value){var imageInfo=Object.assign({},_this.state.imageInfo);imageInfo[name]=value;_this.setState({imageInfo:imageInfo});},_this.removeImage=function(indexVal){var refImages=[].concat(_toConsumableArray(_this.state.refImages));refImages=refImages.filter(function(image,index){return index!==indexVal;});_this.setState({refImages:refImages},function(){return _this.props.getRefImages(refImages,_this.state.index);});},_this.openForm=function(e,action){e.preventDefault();_this.setState({imageEdit:true,action:action,imageInfo:{imageName:'',imageType:null,path:'',url:'',imageDescription:'',fileName:'',fileType:''}});},_this.downloadFile=function(image){var anchor=document.createElement('a');anchor.href=image.url;anchor.target='_blank';anchor.download=image.imageDescription;anchor.click();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileUpload,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.uploadedDocs!==null){this.setState({refImages:this.props.uploadedDocs});}this.setState({// imageTypeOption : this.props.imageTypeOption,
moduleName:this.props.moduleName,disabled:this.props.disabled});}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].getImageType().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status==200){_this2.setState({imageTypeOption:response.text.data});}else{__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg,response.text.message);}case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}()).catch(function(error){return __WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].errorMsg(_this2.msg);});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.uploadedDocs!==null){this.setState({refImages:nextProps.uploadedDocs});}// if(nextProps.imageTypeOption != this.props.imageTypeOption){
//   this.setState({
//     imageTypeOption : nextProps.imageTypeOption
//   })
// }
this.setState({moduleName:nextProps.moduleName,disabled:nextProps.disabled});}},{key:"render",value:function render(){var _this3=this;var Heading=this.props.Heading;var filePreviewIframe=null;filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("iframe",{src:this.state.imageInfo.path,width:"100%",frameborder:"0"})," ");if(this.state.imageInfo.fileType=='video')filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Common_Video__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+this.state.imageInfo.path,width:"100%",height:"500"});if(this.state.imageInfo.fileType=='image')filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+this.state.imageInfo.path});if(this.state.imageInfo.fileType=='doc'||this.state.imageInfo.fileType=='sheet'||this.state.imageInfo.fileType=='pdf'||this.state.imageInfo.fileType=='zip'){filePreviewIframe=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("iframe",{className:'height-for-modal',width:"100%",src:"https://docs.google.com/viewer?url="+this.state.imageInfo.url+"&embedded=true",frameborder:"0"}));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_alert___default.a,Object.assign({ref:function ref(a){return _this3.msg=a;}},__WEBPACK_IMPORTED_MODULE_15__components_Common_Alert__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding custom-style"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,Heading),!this.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"primary pull-right",onClick:function onClick(e){return _this3.openForm(e,'add');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons vertical-align-middle"},"add"),"add file")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-12 nopadding"},this.state.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Common_Loading__["a" /* default */],null),this.state.imageEdit===true?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"table-site"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{"class":"text-center site-title"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,this.state.action==="add"?"ADD":this.state.action==="edit"?"EDIT":""," FILE"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-6 col-md-offset-3 product-form"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"text",inputName:"imageName",value:this.state.imageInfo.imageName,label:"File Name",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"select",inputName:"imageType",value:this.state.imageInfo.imageType,options:this.state.imageTypeOption,label:"File Type",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one",style:{margin:"10px 0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"file-field input-field form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"btn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",{style:{fontSize:"10px",color:"black"}},"File"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"file",id:"fileItem",onChange:function onChange(e){return _this3.uploadNewImage(e);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"file-path-wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{"class":"file-path validate form-control",type:"text",style:{marginTop:"6px"},value:this.state.imageInfo.fileName,disabled:true})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12 step-one",style:{marginTop:"15px",marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Common_Field_Field__["a" /* default */],{isFormGroup:true,inputType:"textarea",inputName:"imageDescription",value:this.state.imageInfo.imageDescription,label:"Comments",onChange:this._onChange,disabled:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-md-12",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{type:"button","class":"primary",name:"button",onClick:function onClick(){return _this3.updateImage();}},this.state.action=='add'?'Add':'Update'," File")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:function onClick(){return _this3.setState({imageEdit:false});},style:{color:"#fff",cursor:"pointer"},"class":"primary site-add-go-back"},"Back")))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"ref-images",style:{paddingLeft:0,paddingRight:"0",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"list-inline pt-3"},this.state.refImages.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:index,className:"img-responsive-fill-list p-3"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"data-lightbox":"image-1",onClick:function onClick(){_this3.setState({loading:true});setTimeout(function(){return _this3.setState({openModal:true,imageInfo:Object.assign({},image),loading:false});},2000);}},image.fileType=='image'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__services__["m" /* UtilityService */].fileUrl()+image.path}):image.fileType=='pdf'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_pdf_png___default.a}):image.fileType=='doc'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_microsoft_word_logo_png___default.a}):image.fileType=='sheet'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_excel_png___default.a}):image.fileType=='zip'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_zip_png___default.a}):image.fileType=='video'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_play_button_png___default.a}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_nopreview_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{"class":"img-label"},image.imageName===""?"Sketch"+(index+1):image.imageName!==""&&image.imageName!==undefined&&image.imageName.length>7?image.imageName.substring(0,7):image.imageName)),!_this3.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black main-edit",title:"Edit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons",onClick:function onClick(){return _this3.setState({imageEdit:true},_this3.imageInfo(index));}},"edit"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light black edit edit-img",title:"img-edit",onClick:function onClick(){return _this3.downloadFile(image);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"file_download"))),!_this3.state.disabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{"class":"btn-floating btn-small waves-effect waves-light red delete",title:"Delete",onClick:function onClick(){return _this3.removeImage(index);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{"class":"material-icons"},"close"))));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.openModal,onClose:function onClose(){return _this3.setState({openModal:false});},s:true,center:true},filePreviewIframe));}}]);return FileUpload;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FileUpload);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_MobileApp_back_svg__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_MobileApp_back_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_MobileApp_back_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_MobileApp_logout_svg__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_MobileApp_logout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_MobileApp_logout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sampleMobileApp_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sampleMobileApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sampleMobileApp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_action_main__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { ToggleChange } from '../../../redux/action/Header';
var MobileHeader=function(_Component){_inherits(MobileHeader,_Component);function MobileHeader(props){_classCallCheck(this,MobileHeader);var _this=_possibleConstructorReturn(this,(MobileHeader.__proto__||Object.getPrototypeOf(MobileHeader)).call(this,props));_this.state={};_this.logOut=_this.logOut.bind(_this);return _this;}_createClass(MobileHeader,[{key:"logOut",value:function logOut(){localStorage.removeItem("authToken");localStorage.clear();this.props.signOut();// this.props.history !== undefined && this.props.history.push("/")
this.props.history!==undefined&&this.props.history.replace("/");//This ensures that the user cannot go back after logging out. clear route history stack
}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"container1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"backbutton",onClick:function onClick(){var route=_this2.props.history.location.state&&_this2.props.history.location.state.route;route!==undefined?_this2.props.history.push("/"+route,_defineProperty({},""+route.toLowerCase(),Object.assign({},_this2.props.history.location.state[""+route.toLowerCase()]))):_this2.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__assets_images_MobileApp_back_svg___default.a,alt:"back",className:"backicon"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"title1"},"Sample Request"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button1"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"logoutdiv",onClick:function onClick(){return _this2.logOut();}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_MobileApp_logout_svg___default.a,alt:"logout",className:"logouticon"}))));}}]);return MobileHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// const mapStateToProps = (state) => {
//     return ({
//         toggle: state.Header.toggle,
//         userDetails : state.main
//     });
// }
var mapDispatchToProps=function mapDispatchToProps(dispatch){// options.filter((data) => data.moduleName == this.props.location.moduleName)
return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({"signOut":__WEBPACK_IMPORTED_MODULE_7__redux_action_main__["signOut"]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(MobileHeader)));

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/back.8c23c426.svg";

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_logo4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utility_service_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_cookies__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_action_main_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_MobileApp_logo4_1_2_svg__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_MobileApp_logo4_1_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_MobileApp_logo4_1_2_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import './style.css';
//redux
// import * as mainAction from "../../redux/action/main";
//component
var LogInPage=function(_Component){_inherits(LogInPage,_Component);function LogInPage(props){_classCallCheck(this,LogInPage);var _this=_possibleConstructorReturn(this,(LogInPage.__proto__||Object.getPrototypeOf(LogInPage)).call(this,props));_this.state={userId:"",password:"",remember:false,loader:false};_this.submitLogin=_this.submitLogin.bind(_this);_this.handleFormChange=_this.handleFormChange.bind(_this);_this.props.actions.updateBasicDetails=_this.props.actions.updateBasicDetails.bind(_this);_this.captureEnter=_this.captureEnter.bind(_this);return _this;}_createClass(LogInPage,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keypress',this.captureEnter);}},{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.load('userId')!==undefined&&__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.load('password')!==undefined){this.setState({userId:__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.load('userId'),password:__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.load("password"),remember:true});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keypress',this.captureEnter);}},{key:'captureEnter',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(e.key=="Enter"){this.submitLogin(e);}case 1:case'end':return _context.stop();}}},_callee,this);}));function captureEnter(_x){return _ref.apply(this,arguments);}return captureEnter;}()},{key:'submitLogin',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _this2=this;var userDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:e.preventDefault();userDetails={userId:this.state.userId,password:this.state.password,rememberMe:this.state.remember};if(!(this.state.userId==""||this.state.password=="")){_context2.next=5;break;}alert("Please fill all fields");return _context2.abrupt('return');case 5:this.setState({loader:true});_context2.next=8;return fetch(__WEBPACK_IMPORTED_MODULE_3__services_utility_service_js__["a" /* default */].baseUrl()+'api/employee/login',{method:"POST",body:JSON.stringify(userDetails),headers:{'Accept':'application/json','Content-Type':'application/json','AuthToken':__WEBPACK_IMPORTED_MODULE_3__services_utility_service_js__["a" /* default */].authToken()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.message==="Successfully logged in"){localStorage.setItem("authToken",responseJson.data.authToken);var _userDetails={userName:responseJson.data.name,userId:responseJson.data._id,authToken:responseJson.data.authToken,profilePicture:responseJson.data.profilePicture,isLoggedIn:true,rights:responseJson.data.rights};_this2.props.actions.updateBasicDetails(_userDetails);_this2.props.history.push('/qr');_this2.setState({loader:false});}else if(responseJson.message=='Wrong Password'){_this2.props.getalertMessage('error',responseJson.message);_this2.setState({password:""});_this2.setState({loader:false});}else{_this2.props.getalertMessage('error',responseJson.message);_this2.setState({loader:false});}}).catch(function(error){var userDetails={isLoggedIn:false};_this2.setState({loader:false});_this2.props.actions.updateBasicDetails(userDetails);_this2.props.getalertMessage('error',error);});case 8:case'end':return _context2.stop();}}},_callee2,this);}));function submitLogin(_x2){return _ref2.apply(this,arguments);}return submitLogin;}()},{key:'changeRemember',value:function changeRemember(e){this.setState({remember:!this.state.remember},function(){if(this.state.remember===true&&this.state.userId!==""&&this.state.password!==""){__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.save('userId',this.state.userId,{path:'/qr'});__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.save('password',this.state.password,{path:'/qr'});}else if(this.state.userId!==""&&this.state.password!==""){__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.remove("userId");__WEBPACK_IMPORTED_MODULE_4_react_cookies___default.a.remove("password");}});}},{key:'handleFormChange',value:function handleFormChange(event){event.preventDefault();if(event.key==="Enter"){this.submitLogin();return;}var key=event.target.id,val=event.target.value;if(key=="userId"){this.setState({userId:val});}else if(key=="password"){this.setState({password:val});}else{this.setState({remember:val});}}},{key:'render',value:function render(){if(!this.state.loader){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container login-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_MobileApp_logo4_1_2_svg___default.a,alt:'Magnum Logo'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{margin:"20px 0px",color:"rgba(0, 150, 136, 1)",fontSize:"20px",fontWeight:"600"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'LOG IN')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'log-form1',style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'log-form-col1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label1'},'User ID*'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:'log-inp',value:this.state.userId,onChange:this.handleFormChange,id:'userId',placeholder:'User ID'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'log-form-col1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label1'},'Password*'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'password',className:'log-inp',value:this.state.password,onChange:this.handleFormChange,id:'password',placeholder:'Password'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'log-con-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'log-btn1',onClick:this.submitLogin},'LOG IN'))));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Common_Loading__["a" /* default */],null);}}}]);return LogInPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_7__redux_action_main_js__,dispatch)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(LogInPage));

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo4 1 (2).ce7a999d.svg";

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_qr_reader__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sample_service__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_logout_svg__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_logout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_logout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_action_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Scanner=function(_Component){_inherits(Scanner,_Component);function Scanner(props){var _this2=this;_classCallCheck(this,Scanner);var _this=_possibleConstructorReturn(this,(Scanner.__proto__||Object.getPrototypeOf(Scanner)).call(this,props));_this.callApi=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(requestNumber){var response,_id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;console.log("Calling API with requestNumber:",requestNumber);_context.next=4;return __WEBPACK_IMPORTED_MODULE_3__services_sample_service__["a" /* default */].SampleInfo("",requestNumber||" ");case 4:response=_context.sent;// Call API
if(response&&response.status===200){_id=response.text.data._id;// Extract ID from API response
_this.setState({_id:_id});console.log("Fetched _id:",_id);// Redirect to /mobileApp with _id in state
_this.props.history.push({pathname:"/mobileApp",state:{_id:_id}});}else{console.error("API Error: Unexpected response",response);}_context.next=11;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);console.error("API Error:",_context.t0);case 11:case"end":return _context.stop();}}},_callee,_this2,[[0,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleResult=function(result,error){if(!_this._isMounted)return;if(result){try{console.log("Scanned QR Code:",result.text);var scannedData=JSON.parse(result.text);// Parse the scanned QR data
var requestNumber=scannedData.requestNumber;// Extract requestNumber
if(requestNumber){console.log("Extracted requestNumber:",requestNumber);_this.setState({data:requestNumber});// Store requestNumber
_this.callApi(requestNumber);// Call API immediately
}else{console.error("QR Code does not contain a valid requestNumber.");}}catch(err){console.error("Error parsing QR Code:",err);}}if(error){console.error("QR Reader Error:",error);}};_this.state={data:null,_id:null};_this._isMounted=false;_this.logOut=_this.logOut.bind(_this);_this.handleResult=_this.handleResult.bind(_this);return _this;}_createClass(Scanner,[{key:"componentDidMount",value:function componentDidMount(){this._isMounted=true;}},{key:"componentWillUnmount",value:function componentWillUnmount(){this._isMounted=false;}},{key:"logOut",value:function logOut(){localStorage.removeItem("authToken");localStorage.clear();this.props.signOut();this.props.history!==undefined&&this.props.history.replace("/");//This ensures that the user cannot go back after logging out. clear route history stack
// window.location.replace("/"); 
}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"qr-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center",marginBottom:"5vh",justifyContent:"center",gap:"3%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{textAlign:"center",color:"rgba(0, 150, 136, 1)",fontWeight:900,fontSize:25}},"Scan Your QR Code"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"button1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"logoutdiv",onClick:function onClick(){return _this3.logOut();}}," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_MobileApp_logout_svg___default.a,alt:"logout",className:"logouticon"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_qr_reader__["a" /* QrReader */],{className:"qr-class",constraints:{facingMode:"environment"}// Use back camera if available
,onResult:this.handleResult// Handle scan result
}));}}]);return Scanner;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({"signOut":__WEBPACK_IMPORTED_MODULE_6__redux_action_main__["signOut"]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Scanner)));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jo; });
/* unused harmony export useQrReader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var n,o,i=(n=function(t,e){return n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},n(t,e)},function(t,e){function r(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),a=function(t){function e(e){var r,n,o,i=this.constructor,a=t.call(this,e)||this;return Object.defineProperty(a,"name",{value:i.name,enumerable:!1,configurable:!0}),r=a,n=i.prototype,(o=Object.setPrototypeOf)?o(r,n):r.__proto__=n,function(t,e){void 0===e&&(e=t.constructor);var r=Error.captureStackTrace;r&&r(t,e)}(a),a}return i(e,t),e}(Error),u=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),s=function(t){function e(e){void 0===e&&(e=void 0);var r=t.call(this,e)||this;return r.message=e,r}return u(e,t),e.prototype.getKind=function(){return this.constructor.kind},e.kind="Exception",e}(a),c=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),f=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return c(e,t),e.kind="ArgumentException",e}(s),h=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return h(e,t),e.kind="IllegalArgumentException",e}(s),d=function(){function t(t){if(this.binarizer=t,null===t)throw new l("Binarizer must be non-null.")}return t.prototype.getWidth=function(){return this.binarizer.getWidth()},t.prototype.getHeight=function(){return this.binarizer.getHeight()},t.prototype.getBlackRow=function(t,e){return this.binarizer.getBlackRow(t,e)},t.prototype.getBlackMatrix=function(){return null!==this.matrix&&void 0!==this.matrix||(this.matrix=this.binarizer.getBlackMatrix()),this.matrix},t.prototype.isCropSupported=function(){return this.binarizer.getLuminanceSource().isCropSupported()},t.prototype.crop=function(e,r,n,o){var i=this.binarizer.getLuminanceSource().crop(e,r,n,o);return new t(this.binarizer.createBinarizer(i))},t.prototype.isRotateSupported=function(){return this.binarizer.getLuminanceSource().isRotateSupported()},t.prototype.rotateCounterClockwise=function(){var e=this.binarizer.getLuminanceSource().rotateCounterClockwise();return new t(this.binarizer.createBinarizer(e))},t.prototype.rotateCounterClockwise45=function(){var e=this.binarizer.getLuminanceSource().rotateCounterClockwise45();return new t(this.binarizer.createBinarizer(e))},t.prototype.toString=function(){try{return this.getBlackMatrix().toString()}catch(t){return""}},t}(),p=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),g=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return p(e,t),e.getChecksumInstance=function(){return new e},e.kind="ChecksumException",e}(s),y=function(){function t(t){this.source=t}return t.prototype.getLuminanceSource=function(){return this.source},t.prototype.getWidth=function(){return this.source.getWidth()},t.prototype.getHeight=function(){return this.source.getHeight()},t}(),w=function(){function t(){}return t.arraycopy=function(t,e,r,n,o){for(;o--;)r[n++]=t[e++]},t.currentTimeMillis=function(){return Date.now()},t}(),_=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),v=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return _(e,t),e.kind="IndexOutOfBoundsException",e}(s),m=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),A=function(t){function e(e,r){void 0===e&&(e=void 0),void 0===r&&(r=void 0);var n=t.call(this,r)||this;return n.index=e,n.message=r,n}return m(e,t),e.kind="ArrayIndexOutOfBoundsException",e}(v),E=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},C=function(){function t(){}return t.fill=function(t,e){for(var r=0,n=t.length;r<n;r++)t[r]=e},t.fillWithin=function(e,r,n,o){t.rangeCheck(e.length,r,n);for(var i=r;i<n;i++)e[i]=o},t.rangeCheck=function(t,e,r){if(e>r)throw new l("fromIndex("+e+") > toIndex("+r+")");if(e<0)throw new A(e);if(r>t)throw new A(r)},t.asList=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return t},t.create=function(t,e,r){return Array.from({length:t}).map((function(t){return Array.from({length:e}).fill(r)}))},t.createInt32Array=function(t,e,r){return Array.from({length:t}).map((function(t){return Int32Array.from({length:e}).fill(r)}))},t.equals=function(t,e){if(!t)return!1;if(!e)return!1;if(!t.length)return!1;if(!e.length)return!1;if(t.length!==e.length)return!1;for(var r=0,n=t.length;r<n;r++)if(t[r]!==e[r])return!1;return!0},t.hashCode=function(t){var e,r;if(null===t)return 0;var n=1;try{for(var o=E(t),i=o.next();!i.done;i=o.next()){n=31*n+i.value}}catch(t){e={error:t}}finally{try{i&&!i.done&&(r=o.return)&&r.call(o)}finally{if(e)throw e.error}}return n},t.fillUint8Array=function(t,e){for(var r=0;r!==t.length;r++)t[r]=e},t.copyOf=function(t,e){return t.slice(0,e)},t.copyOfUint8Array=function(t,e){if(t.length<=e){var r=new Uint8Array(e);return r.set(t),r}return t.slice(0,e)},t.copyOfRange=function(t,e,r){var n=r-e,o=new Int32Array(n);return w.arraycopy(t,e,o,0,n),o},t.binarySearch=function(e,r,n){void 0===n&&(n=t.numberComparator);for(var o=0,i=e.length-1;o<=i;){var a=i+o>>1,u=n(r,e[a]);if(u>0)o=a+1;else{if(!(u<0))return a;i=a-1}}return-o-1},t.numberComparator=function(t,e){return t-e},t}(),I=function(){function t(){}return t.numberOfTrailingZeros=function(t){var e;if(0===t)return 32;var r=31;return 0!==(e=t<<16)&&(r-=16,t=e),0!==(e=t<<8)&&(r-=8,t=e),0!==(e=t<<4)&&(r-=4,t=e),0!==(e=t<<2)&&(r-=2,t=e),r-(t<<1>>>31)},t.numberOfLeadingZeros=function(t){if(0===t)return 32;var e=1;return t>>>16==0&&(e+=16,t<<=16),t>>>24==0&&(e+=8,t<<=8),t>>>28==0&&(e+=4,t<<=4),t>>>30==0&&(e+=2,t<<=2),e-=t>>>31},t.toHexString=function(t){return t.toString(16)},t.toBinaryString=function(t){return String(parseInt(String(t),2))},t.bitCount=function(t){return t=(t=(858993459&(t-=t>>>1&1431655765))+(t>>>2&858993459))+(t>>>4)&252645135,t+=t>>>8,63&(t+=t>>>16)},t.truncDivision=function(t,e){return Math.trunc(t/e)},t.parseInt=function(t,e){return void 0===e&&(e=void 0),parseInt(t,e)},t.MIN_VALUE_32_BITS=-2147483648,t.MAX_VALUE=Number.MAX_SAFE_INTEGER,t}(),S=function(){function t(e,r){void 0===e?(this.size=0,this.bits=new Int32Array(1)):(this.size=e,this.bits=null==r?t.makeArray(e):r)}return t.prototype.getSize=function(){return this.size},t.prototype.getSizeInBytes=function(){return Math.floor((this.size+7)/8)},t.prototype.ensureCapacity=function(e){if(e>32*this.bits.length){var r=t.makeArray(e);w.arraycopy(this.bits,0,r,0,this.bits.length),this.bits=r}},t.prototype.get=function(t){return 0!=(this.bits[Math.floor(t/32)]&1<<(31&t))},t.prototype.set=function(t){this.bits[Math.floor(t/32)]|=1<<(31&t)},t.prototype.flip=function(t){this.bits[Math.floor(t/32)]^=1<<(31&t)},t.prototype.getNextSet=function(t){var e=this.size;if(t>=e)return e;var r=this.bits,n=Math.floor(t/32),o=r[n];o&=~((1<<(31&t))-1);for(var i=r.length;0===o;){if(++n===i)return e;o=r[n]}var a=32*n+I.numberOfTrailingZeros(o);return a>e?e:a},t.prototype.getNextUnset=function(t){var e=this.size;if(t>=e)return e;var r=this.bits,n=Math.floor(t/32),o=~r[n];o&=~((1<<(31&t))-1);for(var i=r.length;0===o;){if(++n===i)return e;o=~r[n]}var a=32*n+I.numberOfTrailingZeros(o);return a>e?e:a},t.prototype.setBulk=function(t,e){this.bits[Math.floor(t/32)]=e},t.prototype.setRange=function(t,e){if(e<t||t<0||e>this.size)throw new l;if(e!==t){e--;for(var r=Math.floor(t/32),n=Math.floor(e/32),o=this.bits,i=r;i<=n;i++){var a=(2<<(i<n?31:31&e))-(1<<(i>r?0:31&t));o[i]|=a}}},t.prototype.clear=function(){for(var t=this.bits.length,e=this.bits,r=0;r<t;r++)e[r]=0},t.prototype.isRange=function(t,e,r){if(e<t||t<0||e>this.size)throw new l;if(e===t)return!0;e--;for(var n=Math.floor(t/32),o=Math.floor(e/32),i=this.bits,a=n;a<=o;a++){var u=(2<<(a<o?31:31&e))-(1<<(a>n?0:31&t))&4294967295;if((i[a]&u)!==(r?u:0))return!1}return!0},t.prototype.appendBit=function(t){this.ensureCapacity(this.size+1),t&&(this.bits[Math.floor(this.size/32)]|=1<<(31&this.size)),this.size++},t.prototype.appendBits=function(t,e){if(e<0||e>32)throw new l("Num bits must be between 0 and 32");this.ensureCapacity(this.size+e);for(var r=e;r>0;r--)this.appendBit(1==(t>>r-1&1))},t.prototype.appendBitArray=function(t){var e=t.size;this.ensureCapacity(this.size+e);for(var r=0;r<e;r++)this.appendBit(t.get(r))},t.prototype.xor=function(t){if(this.size!==t.size)throw new l("Sizes don't match");for(var e=this.bits,r=0,n=e.length;r<n;r++)e[r]^=t.bits[r]},t.prototype.toBytes=function(t,e,r,n){for(var o=0;o<n;o++){for(var i=0,a=0;a<8;a++)this.get(t)&&(i|=1<<7-a),t++;e[r+o]=i}},t.prototype.getBitArray=function(){return this.bits},t.prototype.reverse=function(){for(var t=new Int32Array(this.bits.length),e=Math.floor((this.size-1)/32),r=e+1,n=this.bits,o=0;o<r;o++){var i=n[o];i=(i=(i=(i=(i=i>>1&1431655765|(1431655765&i)<<1)>>2&858993459|(858993459&i)<<2)>>4&252645135|(252645135&i)<<4)>>8&16711935|(16711935&i)<<8)>>16&65535|(65535&i)<<16,t[e-o]=i}if(this.size!==32*r){var a=32*r-this.size,u=t[0]>>>a;for(o=1;o<r;o++){var s=t[o];u|=s<<32-a,t[o-1]=u,u=s>>>a}t[r-1]=u}this.bits=t},t.makeArray=function(t){return new Int32Array(Math.floor((t+31)/32))},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.size===r.size&&C.equals(this.bits,r.bits)},t.prototype.hashCode=function(){return 31*this.size+C.hashCode(this.bits)},t.prototype.toString=function(){for(var t="",e=0,r=this.size;e<r;e++)0==(7&e)&&(t+=" "),t+=this.get(e)?"X":".";return t},t.prototype.clone=function(){return new t(this.size,this.bits.slice())},t}();!function(t){t[t.OTHER=0]="OTHER",t[t.PURE_BARCODE=1]="PURE_BARCODE",t[t.POSSIBLE_FORMATS=2]="POSSIBLE_FORMATS",t[t.TRY_HARDER=3]="TRY_HARDER",t[t.CHARACTER_SET=4]="CHARACTER_SET",t[t.ALLOWED_LENGTHS=5]="ALLOWED_LENGTHS",t[t.ASSUME_CODE_39_CHECK_DIGIT=6]="ASSUME_CODE_39_CHECK_DIGIT",t[t.ASSUME_GS1=7]="ASSUME_GS1",t[t.RETURN_CODABAR_START_END=8]="RETURN_CODABAR_START_END",t[t.NEED_RESULT_POINT_CALLBACK=9]="NEED_RESULT_POINT_CALLBACK",t[t.ALLOWED_EAN_EXTENSIONS=10]="ALLOWED_EAN_EXTENSIONS"}(o||(o={}));var O,T=o,b=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),R=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return b(e,t),e.getFormatInstance=function(){return new e},e.kind="FormatException",e}(s),N=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")};!function(t){t[t.Cp437=0]="Cp437",t[t.ISO8859_1=1]="ISO8859_1",t[t.ISO8859_2=2]="ISO8859_2",t[t.ISO8859_3=3]="ISO8859_3",t[t.ISO8859_4=4]="ISO8859_4",t[t.ISO8859_5=5]="ISO8859_5",t[t.ISO8859_6=6]="ISO8859_6",t[t.ISO8859_7=7]="ISO8859_7",t[t.ISO8859_8=8]="ISO8859_8",t[t.ISO8859_9=9]="ISO8859_9",t[t.ISO8859_10=10]="ISO8859_10",t[t.ISO8859_11=11]="ISO8859_11",t[t.ISO8859_13=12]="ISO8859_13",t[t.ISO8859_14=13]="ISO8859_14",t[t.ISO8859_15=14]="ISO8859_15",t[t.ISO8859_16=15]="ISO8859_16",t[t.SJIS=16]="SJIS",t[t.Cp1250=17]="Cp1250",t[t.Cp1251=18]="Cp1251",t[t.Cp1252=19]="Cp1252",t[t.Cp1256=20]="Cp1256",t[t.UnicodeBigUnmarked=21]="UnicodeBigUnmarked",t[t.UTF8=22]="UTF8",t[t.ASCII=23]="ASCII",t[t.Big5=24]="Big5",t[t.GB18030=25]="GB18030",t[t.EUC_KR=26]="EUC_KR"}(O||(O={}));var D,P=function(){function t(e,r,n){for(var o,i,a=[],u=3;u<arguments.length;u++)a[u-3]=arguments[u];this.valueIdentifier=e,this.name=n,this.values="number"==typeof r?Int32Array.from([r]):r,this.otherEncodingNames=a,t.VALUE_IDENTIFIER_TO_ECI.set(e,this),t.NAME_TO_ECI.set(n,this);for(var s=this.values,c=0,f=s.length;c!==f;c++){var h=s[c];t.VALUES_TO_ECI.set(h,this)}try{for(var l=N(a),d=l.next();!d.done;d=l.next()){var p=d.value;t.NAME_TO_ECI.set(p,this)}}catch(t){o={error:t}}finally{try{d&&!d.done&&(i=l.return)&&i.call(l)}finally{if(o)throw o.error}}}return t.prototype.getValueIdentifier=function(){return this.valueIdentifier},t.prototype.getName=function(){return this.name},t.prototype.getValue=function(){return this.values[0]},t.getCharacterSetECIByValue=function(e){if(e<0||e>=900)throw new R("incorect value");var r=t.VALUES_TO_ECI.get(e);if(void 0===r)throw new R("incorect value");return r},t.getCharacterSetECIByName=function(e){var r=t.NAME_TO_ECI.get(e);if(void 0===r)throw new R("incorect value");return r},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.getName()===r.getName()},t.VALUE_IDENTIFIER_TO_ECI=new Map,t.VALUES_TO_ECI=new Map,t.NAME_TO_ECI=new Map,t.Cp437=new t(O.Cp437,Int32Array.from([0,2]),"Cp437"),t.ISO8859_1=new t(O.ISO8859_1,Int32Array.from([1,3]),"ISO-8859-1","ISO88591","ISO8859_1"),t.ISO8859_2=new t(O.ISO8859_2,4,"ISO-8859-2","ISO88592","ISO8859_2"),t.ISO8859_3=new t(O.ISO8859_3,5,"ISO-8859-3","ISO88593","ISO8859_3"),t.ISO8859_4=new t(O.ISO8859_4,6,"ISO-8859-4","ISO88594","ISO8859_4"),t.ISO8859_5=new t(O.ISO8859_5,7,"ISO-8859-5","ISO88595","ISO8859_5"),t.ISO8859_6=new t(O.ISO8859_6,8,"ISO-8859-6","ISO88596","ISO8859_6"),t.ISO8859_7=new t(O.ISO8859_7,9,"ISO-8859-7","ISO88597","ISO8859_7"),t.ISO8859_8=new t(O.ISO8859_8,10,"ISO-8859-8","ISO88598","ISO8859_8"),t.ISO8859_9=new t(O.ISO8859_9,11,"ISO-8859-9","ISO88599","ISO8859_9"),t.ISO8859_10=new t(O.ISO8859_10,12,"ISO-8859-10","ISO885910","ISO8859_10"),t.ISO8859_11=new t(O.ISO8859_11,13,"ISO-8859-11","ISO885911","ISO8859_11"),t.ISO8859_13=new t(O.ISO8859_13,15,"ISO-8859-13","ISO885913","ISO8859_13"),t.ISO8859_14=new t(O.ISO8859_14,16,"ISO-8859-14","ISO885914","ISO8859_14"),t.ISO8859_15=new t(O.ISO8859_15,17,"ISO-8859-15","ISO885915","ISO8859_15"),t.ISO8859_16=new t(O.ISO8859_16,18,"ISO-8859-16","ISO885916","ISO8859_16"),t.SJIS=new t(O.SJIS,20,"SJIS","Shift_JIS"),t.Cp1250=new t(O.Cp1250,21,"Cp1250","windows-1250"),t.Cp1251=new t(O.Cp1251,22,"Cp1251","windows-1251"),t.Cp1252=new t(O.Cp1252,23,"Cp1252","windows-1252"),t.Cp1256=new t(O.Cp1256,24,"Cp1256","windows-1256"),t.UnicodeBigUnmarked=new t(O.UnicodeBigUnmarked,25,"UnicodeBigUnmarked","UTF-16BE","UnicodeBig"),t.UTF8=new t(O.UTF8,26,"UTF8","UTF-8"),t.ASCII=new t(O.ASCII,Int32Array.from([27,170]),"ASCII","US-ASCII"),t.Big5=new t(O.Big5,28,"Big5"),t.GB18030=new t(O.GB18030,29,"GB18030","GB2312","EUC_CN","GBK"),t.EUC_KR=new t(O.EUC_KR,30,"EUC_KR","EUC-KR"),t}(),M=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),B=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return M(e,t),e.kind="UnsupportedOperationException",e}(s),L=function(){function t(){}return t.decode=function(t,e){var r=this.encodingName(e);return this.customDecoder?this.customDecoder(t,r):"undefined"==typeof TextDecoder||this.shouldDecodeOnFallback(r)?this.decodeFallback(t,r):new TextDecoder(r).decode(t)},t.shouldDecodeOnFallback=function(e){return!t.isBrowser()&&"ISO-8859-1"===e},t.encode=function(t,e){var r=this.encodingName(e);return this.customEncoder?this.customEncoder(t,r):"undefined"==typeof TextEncoder?this.encodeFallback(t):(new TextEncoder).encode(t)},t.isBrowser=function(){return"undefined"!=typeof window&&"[object Window]"==={}.toString.call(window)},t.encodingName=function(t){return"string"==typeof t?t:t.getName()},t.encodingCharacterSet=function(t){return t instanceof P?t:P.getCharacterSetECIByName(t)},t.decodeFallback=function(e,r){var n=this.encodingCharacterSet(r);if(t.isDecodeFallbackSupported(n)){for(var o="",i=0,a=e.length;i<a;i++){var u=e[i].toString(16);u.length<2&&(u="0"+u),o+="%"+u}return decodeURIComponent(o)}if(n.equals(P.UnicodeBigUnmarked))return String.fromCharCode.apply(null,new Uint16Array(e.buffer));throw new B("Encoding "+this.encodingName(r)+" not supported by fallback.")},t.isDecodeFallbackSupported=function(t){return t.equals(P.UTF8)||t.equals(P.ISO8859_1)||t.equals(P.ASCII)},t.encodeFallback=function(t){for(var e=btoa(unescape(encodeURIComponent(t))).split(""),r=[],n=0;n<e.length;n++)r.push(e[n].charCodeAt(0));return new Uint8Array(r)},t}(),F=function(){function t(){}return t.castAsNonUtf8Char=function(t,e){void 0===e&&(e=null);var r=e?e.getName():this.ISO88591;return L.decode(new Uint8Array([t]),r)},t.guessEncoding=function(e,r){if(null!=r&&void 0!==r.get(T.CHARACTER_SET))return r.get(T.CHARACTER_SET).toString();for(var n=e.length,o=!0,i=!0,a=!0,u=0,s=0,c=0,f=0,h=0,l=0,d=0,p=0,g=0,y=0,w=0,_=e.length>3&&239===e[0]&&187===e[1]&&191===e[2],v=0;v<n&&(o||i||a);v++){var m=255&e[v];a&&(u>0?0==(128&m)?a=!1:u--:0!=(128&m)&&(0==(64&m)?a=!1:(u++,0==(32&m)?s++:(u++,0==(16&m)?c++:(u++,0==(8&m)?f++:a=!1))))),o&&(m>127&&m<160?o=!1:m>159&&(m<192||215===m||247===m)&&w++),i&&(h>0?m<64||127===m||m>252?i=!1:h--:128===m||160===m||m>239?i=!1:m>160&&m<224?(l++,p=0,++d>g&&(g=d)):m>127?(h++,d=0,++p>y&&(y=p)):(d=0,p=0))}return a&&u>0&&(a=!1),i&&h>0&&(i=!1),a&&(_||s+c+f>0)?t.UTF8:i&&(t.ASSUME_SHIFT_JIS||g>=3||y>=3)?t.SHIFT_JIS:o&&i?2===g&&2===l||10*w>=n?t.SHIFT_JIS:t.ISO88591:o?t.ISO88591:i?t.SHIFT_JIS:a?t.UTF8:t.PLATFORM_DEFAULT_ENCODING},t.format=function(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];var n=-1;function o(t,r,o,i,a,u){if("%%"===t)return"%";if(void 0!==e[++n]){t=i?parseInt(i.substr(1)):void 0;var s,c=a?parseInt(a.substr(1)):void 0;switch(u){case"s":s=e[n];break;case"c":s=e[n][0];break;case"f":s=parseFloat(e[n]).toFixed(t);break;case"p":s=parseFloat(e[n]).toPrecision(t);break;case"e":s=parseFloat(e[n]).toExponential(t);break;case"x":s=parseInt(e[n]).toString(c||16);break;case"d":s=parseFloat(parseInt(e[n],c||10).toPrecision(t)).toFixed(0)}s="object"==typeof s?JSON.stringify(s):(+s).toString(c);for(var f=parseInt(o),h=o&&o[0]+""=="0"?"0":" ";s.length<f;)s=void 0!==r?s+h:h+s;return s}}var i=/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;return t.replace(i,o)},t.getBytes=function(t,e){return L.encode(t,e)},t.getCharCode=function(t,e){return void 0===e&&(e=0),t.charCodeAt(e)},t.getCharAt=function(t){return String.fromCharCode(t)},t.SHIFT_JIS=P.SJIS.getName(),t.GB2312="GB2312",t.ISO88591=P.ISO8859_1.getName(),t.EUC_JP="EUC_JP",t.UTF8=P.UTF8.getName(),t.PLATFORM_DEFAULT_ENCODING=t.UTF8,t.ASSUME_SHIFT_JIS=!1,t}(),k=function(){function t(t){void 0===t&&(t=""),this.value=t}return t.prototype.enableDecoding=function(t){return this.encoding=t,this},t.prototype.append=function(t){return"string"==typeof t?this.value+=t.toString():this.encoding?this.value+=F.castAsNonUtf8Char(t,this.encoding):this.value+=String.fromCharCode(t),this},t.prototype.appendChars=function(t,e,r){for(var n=e;e<e+r;n++)this.append(t[n]);return this},t.prototype.length=function(){return this.value.length},t.prototype.charAt=function(t){return this.value.charAt(t)},t.prototype.deleteCharAt=function(t){this.value=this.value.substr(0,t)+this.value.substring(t+1)},t.prototype.setCharAt=function(t,e){this.value=this.value.substr(0,t)+e+this.value.substr(t+1)},t.prototype.substring=function(t,e){return this.value.substring(t,e)},t.prototype.setLengthToZero=function(){this.value=""},t.prototype.toString=function(){return this.value},t.prototype.insert=function(t,e){this.value=this.value.substr(0,t)+e+this.value.substr(t+e.length)},t}(),x=function(){function t(t,e,r,n){if(this.width=t,this.height=e,this.rowSize=r,this.bits=n,null==e&&(e=t),this.height=e,t<1||e<1)throw new l("Both dimensions must be greater than 0");null==r&&(r=Math.floor((t+31)/32)),this.rowSize=r,null==n&&(this.bits=new Int32Array(this.rowSize*this.height))}return t.parseFromBooleanArray=function(e){for(var r=e.length,n=e[0].length,o=new t(n,r),i=0;i<r;i++)for(var a=e[i],u=0;u<n;u++)a[u]&&o.set(u,i);return o},t.parseFromString=function(e,r,n){if(null===e)throw new l("stringRepresentation cannot be null");for(var o=new Array(e.length),i=0,a=0,u=-1,s=0,c=0;c<e.length;)if("\n"===e.charAt(c)||"\r"===e.charAt(c)){if(i>a){if(-1===u)u=i-a;else if(i-a!==u)throw new l("row lengths do not match");a=i,s++}c++}else if(e.substring(c,c+r.length)===r)c+=r.length,o[i]=!0,i++;else{if(e.substring(c,c+n.length)!==n)throw new l("illegal character encountered: "+e.substring(c));c+=n.length,o[i]=!1,i++}if(i>a){if(-1===u)u=i-a;else if(i-a!==u)throw new l("row lengths do not match");s++}for(var f=new t(u,s),h=0;h<i;h++)o[h]&&f.set(Math.floor(h%u),Math.floor(h/u));return f},t.prototype.get=function(t,e){var r=e*this.rowSize+Math.floor(t/32);return 0!=(this.bits[r]>>>(31&t)&1)},t.prototype.set=function(t,e){var r=e*this.rowSize+Math.floor(t/32);this.bits[r]|=1<<(31&t)&4294967295},t.prototype.unset=function(t,e){var r=e*this.rowSize+Math.floor(t/32);this.bits[r]&=~(1<<(31&t)&4294967295)},t.prototype.flip=function(t,e){var r=e*this.rowSize+Math.floor(t/32);this.bits[r]^=1<<(31&t)&4294967295},t.prototype.xor=function(t){if(this.width!==t.getWidth()||this.height!==t.getHeight()||this.rowSize!==t.getRowSize())throw new l("input matrix dimensions do not match");for(var e=new S(Math.floor(this.width/32)+1),r=this.rowSize,n=this.bits,o=0,i=this.height;o<i;o++)for(var a=o*r,u=t.getRow(o,e).getBitArray(),s=0;s<r;s++)n[a+s]^=u[s]},t.prototype.clear=function(){for(var t=this.bits,e=t.length,r=0;r<e;r++)t[r]=0},t.prototype.setRegion=function(t,e,r,n){if(e<0||t<0)throw new l("Left and top must be nonnegative");if(n<1||r<1)throw new l("Height and width must be at least 1");var o=t+r,i=e+n;if(i>this.height||o>this.width)throw new l("The region must fit inside the matrix");for(var a=this.rowSize,u=this.bits,s=e;s<i;s++)for(var c=s*a,f=t;f<o;f++)u[c+Math.floor(f/32)]|=1<<(31&f)&4294967295},t.prototype.getRow=function(t,e){null==e||e.getSize()<this.width?e=new S(this.width):e.clear();for(var r=this.rowSize,n=this.bits,o=t*r,i=0;i<r;i++)e.setBulk(32*i,n[o+i]);return e},t.prototype.setRow=function(t,e){w.arraycopy(e.getBitArray(),0,this.bits,t*this.rowSize,this.rowSize)},t.prototype.rotate180=function(){for(var t=this.getWidth(),e=this.getHeight(),r=new S(t),n=new S(t),o=0,i=Math.floor((e+1)/2);o<i;o++)r=this.getRow(o,r),n=this.getRow(e-1-o,n),r.reverse(),n.reverse(),this.setRow(o,n),this.setRow(e-1-o,r)},t.prototype.getEnclosingRectangle=function(){for(var t=this.width,e=this.height,r=this.rowSize,n=this.bits,o=t,i=e,a=-1,u=-1,s=0;s<e;s++)for(var c=0;c<r;c++){var f=n[s*r+c];if(0!==f){if(s<i&&(i=s),s>u&&(u=s),32*c<o){for(var h=0;0==(f<<31-h&4294967295);)h++;32*c+h<o&&(o=32*c+h)}if(32*c+31>a){for(h=31;f>>>h==0;)h--;32*c+h>a&&(a=32*c+h)}}}return a<o||u<i?null:Int32Array.from([o,i,a-o+1,u-i+1])},t.prototype.getTopLeftOnBit=function(){for(var t=this.rowSize,e=this.bits,r=0;r<e.length&&0===e[r];)r++;if(r===e.length)return null;for(var n=r/t,o=r%t*32,i=e[r],a=0;0==(i<<31-a&4294967295);)a++;return o+=a,Int32Array.from([o,n])},t.prototype.getBottomRightOnBit=function(){for(var t=this.rowSize,e=this.bits,r=e.length-1;r>=0&&0===e[r];)r--;if(r<0)return null;for(var n=Math.floor(r/t),o=32*Math.floor(r%t),i=e[r],a=31;i>>>a==0;)a--;return o+=a,Int32Array.from([o,n])},t.prototype.getWidth=function(){return this.width},t.prototype.getHeight=function(){return this.height},t.prototype.getRowSize=function(){return this.rowSize},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.width===r.width&&this.height===r.height&&this.rowSize===r.rowSize&&C.equals(this.bits,r.bits)},t.prototype.hashCode=function(){var t=this.width;return t=31*(t=31*(t=31*(t=31*t+this.width)+this.height)+this.rowSize)+C.hashCode(this.bits)},t.prototype.toString=function(t,e,r){return void 0===t&&(t="X "),void 0===e&&(e="  "),void 0===r&&(r="\n"),this.buildToString(t,e,r)},t.prototype.buildToString=function(t,e,r){for(var n=new k,o=0,i=this.height;o<i;o++){for(var a=0,u=this.width;a<u;a++)n.append(this.get(a,o)?t:e);n.append(r)}return n.toString()},t.prototype.clone=function(){return new t(this.width,this.height,this.rowSize,this.bits.slice())},t}(),V=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),U=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return V(e,t),e.getNotFoundInstance=function(){return new e},e.kind="NotFoundException",e}(s),H=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),G=function(t){function e(r){var n=t.call(this,r)||this;return n.luminances=e.EMPTY,n.buckets=new Int32Array(e.LUMINANCE_BUCKETS),n}return H(e,t),e.prototype.getBlackRow=function(t,r){var n=this.getLuminanceSource(),o=n.getWidth();null==r||r.getSize()<o?r=new S(o):r.clear(),this.initArrays(o);for(var i=n.getRow(t,this.luminances),a=this.buckets,u=0;u<o;u++)a[(255&i[u])>>e.LUMINANCE_SHIFT]++;var s=e.estimateBlackPoint(a);if(o<3)for(u=0;u<o;u++)(255&i[u])<s&&r.set(u);else{var c=255&i[0],f=255&i[1];for(u=1;u<o-1;u++){var h=255&i[u+1];(4*f-c-h)/2<s&&r.set(u),c=f,f=h}}return r},e.prototype.getBlackMatrix=function(){var t=this.getLuminanceSource(),r=t.getWidth(),n=t.getHeight(),o=new x(r,n);this.initArrays(r);for(var i=this.buckets,a=1;a<5;a++)for(var u=Math.floor(n*a/5),s=t.getRow(u,this.luminances),c=Math.floor(4*r/5),f=Math.floor(r/5);f<c;f++){i[(255&s[f])>>e.LUMINANCE_SHIFT]++}var h=e.estimateBlackPoint(i),l=t.getMatrix();for(a=0;a<n;a++){var d=a*r;for(f=0;f<r;f++){(255&l[d+f])<h&&o.set(f,a)}}return o},e.prototype.createBinarizer=function(t){return new e(t)},e.prototype.initArrays=function(t){this.luminances.length<t&&(this.luminances=new Uint8ClampedArray(t));for(var r=this.buckets,n=0;n<e.LUMINANCE_BUCKETS;n++)r[n]=0},e.estimateBlackPoint=function(t){for(var r=t.length,n=0,o=0,i=0,a=0;a<r;a++)t[a]>i&&(o=a,i=t[a]),t[a]>n&&(n=t[a]);var u=0,s=0;for(a=0;a<r;a++){var c=a-o;(d=t[a]*c*c)>s&&(u=a,s=d)}if(o>u){var f=o;o=u,u=f}if(u-o<=r/16)throw new U;var h=u-1,l=-1;for(a=u-1;a>o;a--){var d,p=a-o;(d=p*p*(u-a)*(n-t[a]))>l&&(h=a,l=d)}return h<<e.LUMINANCE_SHIFT},e.LUMINANCE_BITS=5,e.LUMINANCE_SHIFT=8-e.LUMINANCE_BITS,e.LUMINANCE_BUCKETS=1<<e.LUMINANCE_BITS,e.EMPTY=Uint8ClampedArray.from([0]),e}(y),X=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),W=function(t){function e(e){var r=t.call(this,e)||this;return r.matrix=null,r}return X(e,t),e.prototype.getBlackMatrix=function(){if(null!==this.matrix)return this.matrix;var r=this.getLuminanceSource(),n=r.getWidth(),o=r.getHeight();if(n>=e.MINIMUM_DIMENSION&&o>=e.MINIMUM_DIMENSION){var i=r.getMatrix(),a=n>>e.BLOCK_SIZE_POWER;0!=(n&e.BLOCK_SIZE_MASK)&&a++;var u=o>>e.BLOCK_SIZE_POWER;0!=(o&e.BLOCK_SIZE_MASK)&&u++;var s=e.calculateBlackPoints(i,a,u,n,o),c=new x(n,o);e.calculateThresholdForBlock(i,a,u,n,o,s,c),this.matrix=c}else this.matrix=t.prototype.getBlackMatrix.call(this);return this.matrix},e.prototype.createBinarizer=function(t){return new e(t)},e.calculateThresholdForBlock=function(t,r,n,o,i,a,u){for(var s=i-e.BLOCK_SIZE,c=o-e.BLOCK_SIZE,f=0;f<n;f++){var h=f<<e.BLOCK_SIZE_POWER;h>s&&(h=s);for(var l=e.cap(f,2,n-3),d=0;d<r;d++){var p=d<<e.BLOCK_SIZE_POWER;p>c&&(p=c);for(var g=e.cap(d,2,r-3),y=0,w=-2;w<=2;w++){var _=a[l+w];y+=_[g-2]+_[g-1]+_[g]+_[g+1]+_[g+2]}var v=y/25;e.thresholdBlock(t,p,h,v,o,u)}}},e.cap=function(t,e,r){return t<e?e:t>r?r:t},e.thresholdBlock=function(t,r,n,o,i,a){for(var u=0,s=n*i+r;u<e.BLOCK_SIZE;u++,s+=i)for(var c=0;c<e.BLOCK_SIZE;c++)(255&t[s+c])<=o&&a.set(r+c,n+u)},e.calculateBlackPoints=function(t,r,n,o,i){for(var a=i-e.BLOCK_SIZE,u=o-e.BLOCK_SIZE,s=new Array(n),c=0;c<n;c++){s[c]=new Int32Array(r);var f=c<<e.BLOCK_SIZE_POWER;f>a&&(f=a);for(var h=0;h<r;h++){var l=h<<e.BLOCK_SIZE_POWER;l>u&&(l=u);for(var d=0,p=255,g=0,y=0,w=f*o+l;y<e.BLOCK_SIZE;y++,w+=o){for(var _=0;_<e.BLOCK_SIZE;_++){var v=255&t[w+_];d+=v,v<p&&(p=v),v>g&&(g=v)}if(g-p>e.MIN_DYNAMIC_RANGE)for(y++,w+=o;y<e.BLOCK_SIZE;y++,w+=o)for(_=0;_<e.BLOCK_SIZE;_++)d+=255&t[w+_]}var m=d>>2*e.BLOCK_SIZE_POWER;if(g-p<=e.MIN_DYNAMIC_RANGE&&(m=p/2,c>0&&h>0)){var A=(s[c-1][h]+2*s[c][h-1]+s[c-1][h-1])/4;p<A&&(m=A)}s[c][h]=m}}return s},e.BLOCK_SIZE_POWER=3,e.BLOCK_SIZE=1<<e.BLOCK_SIZE_POWER,e.BLOCK_SIZE_MASK=e.BLOCK_SIZE-1,e.MINIMUM_DIMENSION=5*e.BLOCK_SIZE,e.MIN_DYNAMIC_RANGE=24,e}(G),j=function(){function t(t,e){this.width=t,this.height=e}return t.prototype.getWidth=function(){return this.width},t.prototype.getHeight=function(){return this.height},t.prototype.isCropSupported=function(){return!1},t.prototype.crop=function(t,e,r,n){throw new B("This luminance source does not support cropping.")},t.prototype.isRotateSupported=function(){return!1},t.prototype.rotateCounterClockwise=function(){throw new B("This luminance source does not support rotation by 90 degrees.")},t.prototype.rotateCounterClockwise45=function(){throw new B("This luminance source does not support rotation by 45 degrees.")},t.prototype.toString=function(){for(var t=new Uint8ClampedArray(this.width),e=new k,r=0;r<this.height;r++){for(var n=this.getRow(r,t),o=0;o<this.width;o++){var i=255&n[o],a=void 0;a=i<64?"#":i<128?"+":i<192?".":" ",e.append(a)}e.append("\n")}return e.toString()},t}(),z=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Y=function(t){function e(e){var r=t.call(this,e.getWidth(),e.getHeight())||this;return r.delegate=e,r}return z(e,t),e.prototype.getRow=function(t,e){for(var r=this.delegate.getRow(t,e),n=this.getWidth(),o=0;o<n;o++)r[o]=255-(255&r[o]);return r},e.prototype.getMatrix=function(){for(var t=this.delegate.getMatrix(),e=this.getWidth()*this.getHeight(),r=new Uint8ClampedArray(e),n=0;n<e;n++)r[n]=255-(255&t[n]);return r},e.prototype.isCropSupported=function(){return this.delegate.isCropSupported()},e.prototype.crop=function(t,r,n,o){return new e(this.delegate.crop(t,r,n,o))},e.prototype.isRotateSupported=function(){return this.delegate.isRotateSupported()},e.prototype.invert=function(){return this.delegate},e.prototype.rotateCounterClockwise=function(){return new e(this.delegate.rotateCounterClockwise())},e.prototype.rotateCounterClockwise45=function(){return new e(this.delegate.rotateCounterClockwise45())},e}(j),Z=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),K=function(t){function e(r){var n=t.call(this,r.width,r.height)||this;return n.canvas=r,n.tempCanvasElement=null,n.buffer=e.makeBufferFromCanvasImageData(r),n}return Z(e,t),e.makeBufferFromCanvasImageData=function(t){var r=t.getContext("2d").getImageData(0,0,t.width,t.height);return e.toGrayscaleBuffer(r.data,t.width,t.height)},e.toGrayscaleBuffer=function(t,e,r){for(var n=new Uint8ClampedArray(e*r),o=0,i=0,a=t.length;o<a;o+=4,i++){var u=void 0;if(0===t[o+3])u=255;else u=306*t[o]+601*t[o+1]+117*t[o+2]+512>>10;n[i]=u}return n},e.prototype.getRow=function(t,e){if(t<0||t>=this.getHeight())throw new l("Requested row is outside the image: "+t);var r=this.getWidth(),n=t*r;return null===e?e=this.buffer.slice(n,n+r):(e.length<r&&(e=new Uint8ClampedArray(r)),e.set(this.buffer.slice(n,n+r))),e},e.prototype.getMatrix=function(){return this.buffer},e.prototype.isCropSupported=function(){return!0},e.prototype.crop=function(e,r,n,o){return t.prototype.crop.call(this,e,r,n,o),this},e.prototype.isRotateSupported=function(){return!0},e.prototype.rotateCounterClockwise=function(){return this.rotate(-90),this},e.prototype.rotateCounterClockwise45=function(){return this.rotate(-45),this},e.prototype.getTempCanvasElement=function(){if(null===this.tempCanvasElement){var t=this.canvas.ownerDocument.createElement("canvas");t.width=this.canvas.width,t.height=this.canvas.height,this.tempCanvasElement=t}return this.tempCanvasElement},e.prototype.rotate=function(t){var r=this.getTempCanvasElement(),n=r.getContext("2d"),o=t*e.DEGREE_TO_RADIANS,i=this.canvas.width,a=this.canvas.height,u=Math.ceil(Math.abs(Math.cos(o))*i+Math.abs(Math.sin(o))*a),s=Math.ceil(Math.abs(Math.sin(o))*i+Math.abs(Math.cos(o))*a);return r.width=u,r.height=s,n.translate(u/2,s/2),n.rotate(o),n.drawImage(this.canvas,i/-2,a/-2),this.buffer=e.makeBufferFromCanvasImageData(r),this},e.prototype.invert=function(){return new Y(this)},e.DEGREE_TO_RADIANS=Math.PI/180,e}(j),q=function(){function t(t,e,r){this.deviceId=t,this.label=e,this.kind="videoinput",this.groupId=r||void 0}return t.prototype.toJSON=function(){return{kind:this.kind,groupId:this.groupId,deviceId:this.deviceId,label:this.label}},t}(),Q=function(t,e,r,n){return new(r||(r=Promise))((function(o,i){function a(t){try{s(n.next(t))}catch(t){i(t)}}function u(t){try{s(n.throw(t))}catch(t){i(t)}}function s(t){var e;t.done?o(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(a,u)}s((n=n.apply(t,e||[])).next())}))},J=function(t,e){var r,n,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:u(0),throw:u(1),return:u(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function u(i){return function(u){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;a;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,n=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(o=a.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){a.label=i[1];break}if(6===i[0]&&a.label<o[1]){a.label=o[1],o=i;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(i);break}o[2]&&a.ops.pop(),a.trys.pop();continue}i=e.call(t,a)}catch(t){i=[6,t],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,u])}}},$=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},tt=function(){function t(t,e,r){void 0===e&&(e=500),this.reader=t,this.timeBetweenScansMillis=e,this._hints=r,this._stopContinuousDecode=!1,this._stopAsyncDecode=!1,this._timeBetweenDecodingAttempts=0}return Object.defineProperty(t.prototype,"hasNavigator",{get:function(){return"undefined"!=typeof navigator},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isMediaDevicesSuported",{get:function(){return this.hasNavigator&&!!navigator.mediaDevices},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"canEnumerateDevices",{get:function(){return!(!this.isMediaDevicesSuported||!navigator.mediaDevices.enumerateDevices)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"timeBetweenDecodingAttempts",{get:function(){return this._timeBetweenDecodingAttempts},set:function(t){this._timeBetweenDecodingAttempts=t<0?0:t},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"hints",{get:function(){return this._hints},set:function(t){this._hints=t||null},enumerable:!1,configurable:!0}),t.prototype.listVideoInputDevices=function(){return Q(this,void 0,void 0,(function(){var t,e,r,n,o,i,a,u,s,c,f,h;return J(this,(function(l){switch(l.label){case 0:if(!this.hasNavigator)throw new Error("Can't enumerate devices, navigator is not present.");if(!this.canEnumerateDevices)throw new Error("Can't enumerate devices, method not supported.");return[4,navigator.mediaDevices.enumerateDevices()];case 1:t=l.sent(),e=[];try{for(r=$(t),n=r.next();!n.done;n=r.next())o=n.value,"videoinput"===(i="video"===o.kind?"videoinput":o.kind)&&(a=o.deviceId||o.id,u=o.label||"Video device "+(e.length+1),s=o.groupId,c={deviceId:a,label:u,kind:i,groupId:s},e.push(c))}catch(t){f={error:t}}finally{try{n&&!n.done&&(h=r.return)&&h.call(r)}finally{if(f)throw f.error}}return[2,e]}}))}))},t.prototype.getVideoInputDevices=function(){return Q(this,void 0,void 0,(function(){return J(this,(function(t){switch(t.label){case 0:return[4,this.listVideoInputDevices()];case 1:return[2,t.sent().map((function(t){return new q(t.deviceId,t.label)}))]}}))}))},t.prototype.findDeviceById=function(t){return Q(this,void 0,void 0,(function(){var e;return J(this,(function(r){switch(r.label){case 0:return[4,this.listVideoInputDevices()];case 1:return(e=r.sent())?[2,e.find((function(e){return e.deviceId===t}))]:[2,null]}}))}))},t.prototype.decodeFromInputVideoDevice=function(t,e){return Q(this,void 0,void 0,(function(){return J(this,(function(r){switch(r.label){case 0:return[4,this.decodeOnceFromVideoDevice(t,e)];case 1:return[2,r.sent()]}}))}))},t.prototype.decodeOnceFromVideoDevice=function(t,e){return Q(this,void 0,void 0,(function(){var r;return J(this,(function(n){switch(n.label){case 0:return this.reset(),r={video:t?{deviceId:{exact:t}}:{facingMode:"environment"}},[4,this.decodeOnceFromConstraints(r,e)];case 1:return[2,n.sent()]}}))}))},t.prototype.decodeOnceFromConstraints=function(t,e){return Q(this,void 0,void 0,(function(){var r;return J(this,(function(n){switch(n.label){case 0:return[4,navigator.mediaDevices.getUserMedia(t)];case 1:return r=n.sent(),[4,this.decodeOnceFromStream(r,e)];case 2:return[2,n.sent()]}}))}))},t.prototype.decodeOnceFromStream=function(t,e){return Q(this,void 0,void 0,(function(){var r;return J(this,(function(n){switch(n.label){case 0:return this.reset(),[4,this.attachStreamToVideo(t,e)];case 1:return r=n.sent(),[4,this.decodeOnce(r)];case 2:return[2,n.sent()]}}))}))},t.prototype.decodeFromInputVideoDeviceContinuously=function(t,e,r){return Q(this,void 0,void 0,(function(){return J(this,(function(n){switch(n.label){case 0:return[4,this.decodeFromVideoDevice(t,e,r)];case 1:return[2,n.sent()]}}))}))},t.prototype.decodeFromVideoDevice=function(t,e,r){return Q(this,void 0,void 0,(function(){var n;return J(this,(function(o){switch(o.label){case 0:return n={video:t?{deviceId:{exact:t}}:{facingMode:"environment"}},[4,this.decodeFromConstraints(n,e,r)];case 1:return[2,o.sent()]}}))}))},t.prototype.decodeFromConstraints=function(t,e,r){return Q(this,void 0,void 0,(function(){var n;return J(this,(function(o){switch(o.label){case 0:return[4,navigator.mediaDevices.getUserMedia(t)];case 1:return n=o.sent(),[4,this.decodeFromStream(n,e,r)];case 2:return[2,o.sent()]}}))}))},t.prototype.decodeFromStream=function(t,e,r){return Q(this,void 0,void 0,(function(){var n;return J(this,(function(o){switch(o.label){case 0:return this.reset(),[4,this.attachStreamToVideo(t,e)];case 1:return n=o.sent(),[4,this.decodeContinuously(n,r)];case 2:return[2,o.sent()]}}))}))},t.prototype.stopAsyncDecode=function(){this._stopAsyncDecode=!0},t.prototype.stopContinuousDecode=function(){this._stopContinuousDecode=!0},t.prototype.attachStreamToVideo=function(t,e){return Q(this,void 0,void 0,(function(){var r;return J(this,(function(n){switch(n.label){case 0:return r=this.prepareVideoElement(e),this.addVideoSource(r,t),this.videoElement=r,this.stream=t,[4,this.playVideoOnLoadAsync(r)];case 1:return n.sent(),[2,r]}}))}))},t.prototype.playVideoOnLoadAsync=function(t){var e=this;return new Promise((function(r,n){return e.playVideoOnLoad(t,(function(){return r()}))}))},t.prototype.playVideoOnLoad=function(t,e){var r=this;this.videoEndedListener=function(){return r.stopStreams()},this.videoCanPlayListener=function(){return r.tryPlayVideo(t)},t.addEventListener("ended",this.videoEndedListener),t.addEventListener("canplay",this.videoCanPlayListener),t.addEventListener("playing",e),this.tryPlayVideo(t)},t.prototype.isVideoPlaying=function(t){return t.currentTime>0&&!t.paused&&!t.ended&&t.readyState>2},t.prototype.tryPlayVideo=function(t){return Q(this,void 0,void 0,(function(){return J(this,(function(e){switch(e.label){case 0:if(this.isVideoPlaying(t))return console.warn("Trying to play video that is already playing."),[2];e.label=1;case 1:return e.trys.push([1,3,,4]),[4,t.play()];case 2:return e.sent(),[3,4];case 3:return e.sent(),console.warn("It was not possible to play the video."),[3,4];case 4:return[2]}}))}))},t.prototype.getMediaElement=function(t,e){var r=document.getElementById(t);if(!r)throw new f("element with id '"+t+"' not found");if(r.nodeName.toLowerCase()!==e.toLowerCase())throw new f("element with id '"+t+"' must be an "+e+" element");return r},t.prototype.decodeFromImage=function(t,e){if(!t&&!e)throw new f("either imageElement with a src set or an url must be provided");return e&&!t?this.decodeFromImageUrl(e):this.decodeFromImageElement(t)},t.prototype.decodeFromVideo=function(t,e){if(!t&&!e)throw new f("Either an element with a src set or an URL must be provided");return e&&!t?this.decodeFromVideoUrl(e):this.decodeFromVideoElement(t)},t.prototype.decodeFromVideoContinuously=function(t,e,r){if(void 0===t&&void 0===e)throw new f("Either an element with a src set or an URL must be provided");return e&&!t?this.decodeFromVideoUrlContinuously(e,r):this.decodeFromVideoElementContinuously(t,r)},t.prototype.decodeFromImageElement=function(t){if(!t)throw new f("An image element must be provided.");this.reset();var e=this.prepareImageElement(t);return this.imageElement=e,this.isImageLoaded(e)?this.decodeOnce(e,!1,!0):this._decodeOnLoadImage(e)},t.prototype.decodeFromVideoElement=function(t){var e=this._decodeFromVideoElementSetup(t);return this._decodeOnLoadVideo(e)},t.prototype.decodeFromVideoElementContinuously=function(t,e){var r=this._decodeFromVideoElementSetup(t);return this._decodeOnLoadVideoContinuously(r,e)},t.prototype._decodeFromVideoElementSetup=function(t){if(!t)throw new f("A video element must be provided.");this.reset();var e=this.prepareVideoElement(t);return this.videoElement=e,e},t.prototype.decodeFromImageUrl=function(t){if(!t)throw new f("An URL must be provided.");this.reset();var e=this.prepareImageElement();this.imageElement=e;var r=this._decodeOnLoadImage(e);return e.src=t,r},t.prototype.decodeFromVideoUrl=function(t){if(!t)throw new f("An URL must be provided.");this.reset();var e=this.prepareVideoElement(),r=this.decodeFromVideoElement(e);return e.src=t,r},t.prototype.decodeFromVideoUrlContinuously=function(t,e){if(!t)throw new f("An URL must be provided.");this.reset();var r=this.prepareVideoElement(),n=this.decodeFromVideoElementContinuously(r,e);return r.src=t,n},t.prototype._decodeOnLoadImage=function(t){var e=this;return new Promise((function(r,n){e.imageLoadedListener=function(){return e.decodeOnce(t,!1,!0).then(r,n)},t.addEventListener("load",e.imageLoadedListener)}))},t.prototype._decodeOnLoadVideo=function(t){return Q(this,void 0,void 0,(function(){return J(this,(function(e){switch(e.label){case 0:return[4,this.playVideoOnLoadAsync(t)];case 1:return e.sent(),[4,this.decodeOnce(t)];case 2:return[2,e.sent()]}}))}))},t.prototype._decodeOnLoadVideoContinuously=function(t,e){return Q(this,void 0,void 0,(function(){return J(this,(function(r){switch(r.label){case 0:return[4,this.playVideoOnLoadAsync(t)];case 1:return r.sent(),this.decodeContinuously(t,e),[2]}}))}))},t.prototype.isImageLoaded=function(t){return!!t.complete&&0!==t.naturalWidth},t.prototype.prepareImageElement=function(t){var e;return void 0===t&&((e=document.createElement("img")).width=200,e.height=200),"string"==typeof t&&(e=this.getMediaElement(t,"img")),t instanceof HTMLImageElement&&(e=t),e},t.prototype.prepareVideoElement=function(t){var e;return t||"undefined"==typeof document||((e=document.createElement("video")).width=200,e.height=200),"string"==typeof t&&(e=this.getMediaElement(t,"video")),t instanceof HTMLVideoElement&&(e=t),e.setAttribute("autoplay","true"),e.setAttribute("muted","true"),e.setAttribute("playsinline","true"),e},t.prototype.decodeOnce=function(t,e,r){var n=this;void 0===e&&(e=!0),void 0===r&&(r=!0),this._stopAsyncDecode=!1;var o=function(i,a){if(n._stopAsyncDecode)return a(new U("Video stream has ended before any code could be detected.")),void(n._stopAsyncDecode=void 0);try{i(n.decode(t))}catch(t){if(e&&t instanceof U||(t instanceof g||t instanceof R)&&r)return setTimeout(o,n._timeBetweenDecodingAttempts,i,a);a(t)}};return new Promise((function(t,e){return o(t,e)}))},t.prototype.decodeContinuously=function(t,e){var r=this;this._stopContinuousDecode=!1;var n=function(){if(r._stopContinuousDecode)r._stopContinuousDecode=void 0;else try{var o=r.decode(t);e(o,null),setTimeout(n,r.timeBetweenScansMillis)}catch(t){e(null,t),(t instanceof g||t instanceof R||t instanceof U)&&setTimeout(n,r._timeBetweenDecodingAttempts)}};n()},t.prototype.decode=function(t){var e=this.createBinaryBitmap(t);return this.decodeBitmap(e)},t.prototype.createBinaryBitmap=function(t){var e=this.getCaptureCanvasContext(t);this.drawImageOnCanvas(e,t);var r=this.getCaptureCanvas(t),n=new K(r),o=new W(n);return new d(o)},t.prototype.getCaptureCanvasContext=function(t){if(!this.captureCanvasContext){var e=this.getCaptureCanvas(t).getContext("2d");this.captureCanvasContext=e}return this.captureCanvasContext},t.prototype.getCaptureCanvas=function(t){if(!this.captureCanvas){var e=this.createCaptureCanvas(t);this.captureCanvas=e}return this.captureCanvas},t.prototype.drawImageOnCanvas=function(t,e){t.drawImage(e,0,0)},t.prototype.decodeBitmap=function(t){return this.reader.decode(t,this._hints)},t.prototype.createCaptureCanvas=function(t){if("undefined"==typeof document)return this._destroyCaptureCanvas(),null;var e,r,n=document.createElement("canvas");return void 0!==t&&(t instanceof HTMLVideoElement?(e=t.videoWidth,r=t.videoHeight):t instanceof HTMLImageElement&&(e=t.naturalWidth||t.width,r=t.naturalHeight||t.height)),n.style.width=e+"px",n.style.height=r+"px",n.width=e,n.height=r,n},t.prototype.stopStreams=function(){this.stream&&(this.stream.getVideoTracks().forEach((function(t){return t.stop()})),this.stream=void 0),!1===this._stopAsyncDecode&&this.stopAsyncDecode(),!1===this._stopContinuousDecode&&this.stopContinuousDecode()},t.prototype.reset=function(){this.stopStreams(),this._destroyVideoElement(),this._destroyImageElement(),this._destroyCaptureCanvas()},t.prototype._destroyVideoElement=function(){this.videoElement&&(void 0!==this.videoEndedListener&&this.videoElement.removeEventListener("ended",this.videoEndedListener),void 0!==this.videoPlayingEventListener&&this.videoElement.removeEventListener("playing",this.videoPlayingEventListener),void 0!==this.videoCanPlayListener&&this.videoElement.removeEventListener("loadedmetadata",this.videoCanPlayListener),this.cleanVideoSource(this.videoElement),this.videoElement=void 0)},t.prototype._destroyImageElement=function(){this.imageElement&&(void 0!==this.imageLoadedListener&&this.imageElement.removeEventListener("load",this.imageLoadedListener),this.imageElement.src=void 0,this.imageElement.removeAttribute("src"),this.imageElement=void 0)},t.prototype._destroyCaptureCanvas=function(){this.captureCanvasContext=void 0,this.captureCanvas=void 0},t.prototype.addVideoSource=function(t,e){try{t.srcObject=e}catch(r){t.src=URL.createObjectURL(e)}},t.prototype.cleanVideoSource=function(t){try{t.srcObject=null}catch(e){t.src=""}this.videoElement.removeAttribute("src")},t}(),et=function(){function t(t,e,r,n,o,i){void 0===r&&(r=null==e?0:8*e.length),void 0===i&&(i=w.currentTimeMillis()),this.text=t,this.rawBytes=e,this.numBits=r,this.resultPoints=n,this.format=o,this.timestamp=i,this.text=t,this.rawBytes=e,this.numBits=null==r?null==e?0:8*e.length:r,this.resultPoints=n,this.format=o,this.resultMetadata=null,this.timestamp=null==i?w.currentTimeMillis():i}return t.prototype.getText=function(){return this.text},t.prototype.getRawBytes=function(){return this.rawBytes},t.prototype.getNumBits=function(){return this.numBits},t.prototype.getResultPoints=function(){return this.resultPoints},t.prototype.getBarcodeFormat=function(){return this.format},t.prototype.getResultMetadata=function(){return this.resultMetadata},t.prototype.putMetadata=function(t,e){null===this.resultMetadata&&(this.resultMetadata=new Map),this.resultMetadata.set(t,e)},t.prototype.putAllMetadata=function(t){null!==t&&(null===this.resultMetadata?this.resultMetadata=t:this.resultMetadata=new Map(t))},t.prototype.addResultPoints=function(t){var e=this.resultPoints;if(null===e)this.resultPoints=t;else if(null!==t&&t.length>0){var r=new Array(e.length+t.length);w.arraycopy(e,0,r,0,e.length),w.arraycopy(t,0,r,e.length,t.length),this.resultPoints=r}},t.prototype.getTimestamp=function(){return this.timestamp},t.prototype.toString=function(){return this.text},t}();!function(t){t[t.AZTEC=0]="AZTEC",t[t.CODABAR=1]="CODABAR",t[t.CODE_39=2]="CODE_39",t[t.CODE_93=3]="CODE_93",t[t.CODE_128=4]="CODE_128",t[t.DATA_MATRIX=5]="DATA_MATRIX",t[t.EAN_8=6]="EAN_8",t[t.EAN_13=7]="EAN_13",t[t.ITF=8]="ITF",t[t.MAXICODE=9]="MAXICODE",t[t.PDF_417=10]="PDF_417",t[t.QR_CODE=11]="QR_CODE",t[t.RSS_14=12]="RSS_14",t[t.RSS_EXPANDED=13]="RSS_EXPANDED",t[t.UPC_A=14]="UPC_A",t[t.UPC_E=15]="UPC_E",t[t.UPC_EAN_EXTENSION=16]="UPC_EAN_EXTENSION"}(D||(D={}));var rt,nt=D;!function(t){t[t.OTHER=0]="OTHER",t[t.ORIENTATION=1]="ORIENTATION",t[t.BYTE_SEGMENTS=2]="BYTE_SEGMENTS",t[t.ERROR_CORRECTION_LEVEL=3]="ERROR_CORRECTION_LEVEL",t[t.ISSUE_NUMBER=4]="ISSUE_NUMBER",t[t.SUGGESTED_PRICE=5]="SUGGESTED_PRICE",t[t.POSSIBLE_COUNTRY=6]="POSSIBLE_COUNTRY",t[t.UPC_EAN_EXTENSION=7]="UPC_EAN_EXTENSION",t[t.PDF417_EXTRA_METADATA=8]="PDF417_EXTRA_METADATA",t[t.STRUCTURED_APPEND_SEQUENCE=9]="STRUCTURED_APPEND_SEQUENCE",t[t.STRUCTURED_APPEND_PARITY=10]="STRUCTURED_APPEND_PARITY"}(rt||(rt={}));var ot,it=rt,at=function(){function t(t,e,r,n,o,i){void 0===o&&(o=-1),void 0===i&&(i=-1),this.rawBytes=t,this.text=e,this.byteSegments=r,this.ecLevel=n,this.structuredAppendSequenceNumber=o,this.structuredAppendParity=i,this.numBits=null==t?0:8*t.length}return t.prototype.getRawBytes=function(){return this.rawBytes},t.prototype.getNumBits=function(){return this.numBits},t.prototype.setNumBits=function(t){this.numBits=t},t.prototype.getText=function(){return this.text},t.prototype.getByteSegments=function(){return this.byteSegments},t.prototype.getECLevel=function(){return this.ecLevel},t.prototype.getErrorsCorrected=function(){return this.errorsCorrected},t.prototype.setErrorsCorrected=function(t){this.errorsCorrected=t},t.prototype.getErasures=function(){return this.erasures},t.prototype.setErasures=function(t){this.erasures=t},t.prototype.getOther=function(){return this.other},t.prototype.setOther=function(t){this.other=t},t.prototype.hasStructuredAppend=function(){return this.structuredAppendParity>=0&&this.structuredAppendSequenceNumber>=0},t.prototype.getStructuredAppendParity=function(){return this.structuredAppendParity},t.prototype.getStructuredAppendSequenceNumber=function(){return this.structuredAppendSequenceNumber},t}(),ut=function(){function t(){}return t.prototype.exp=function(t){return this.expTable[t]},t.prototype.log=function(t){if(0===t)throw new l;return this.logTable[t]},t.addOrSubtract=function(t,e){return t^e},t}(),st=function(){function t(t,e){if(0===e.length)throw new l;this.field=t;var r=e.length;if(r>1&&0===e[0]){for(var n=1;n<r&&0===e[n];)n++;n===r?this.coefficients=Int32Array.from([0]):(this.coefficients=new Int32Array(r-n),w.arraycopy(e,n,this.coefficients,0,this.coefficients.length))}else this.coefficients=e}return t.prototype.getCoefficients=function(){return this.coefficients},t.prototype.getDegree=function(){return this.coefficients.length-1},t.prototype.isZero=function(){return 0===this.coefficients[0]},t.prototype.getCoefficient=function(t){return this.coefficients[this.coefficients.length-1-t]},t.prototype.evaluateAt=function(t){if(0===t)return this.getCoefficient(0);var e,r=this.coefficients;if(1===t){e=0;for(var n=0,o=r.length;n!==o;n++){var i=r[n];e=ut.addOrSubtract(e,i)}return e}e=r[0];var a=r.length,u=this.field;for(n=1;n<a;n++)e=ut.addOrSubtract(u.multiply(t,e),r[n]);return e},t.prototype.addOrSubtract=function(e){if(!this.field.equals(e.field))throw new l("GenericGFPolys do not have same GenericGF field");if(this.isZero())return e;if(e.isZero())return this;var r=this.coefficients,n=e.coefficients;if(r.length>n.length){var o=r;r=n,n=o}var i=new Int32Array(n.length),a=n.length-r.length;w.arraycopy(n,0,i,0,a);for(var u=a;u<n.length;u++)i[u]=ut.addOrSubtract(r[u-a],n[u]);return new t(this.field,i)},t.prototype.multiply=function(e){if(!this.field.equals(e.field))throw new l("GenericGFPolys do not have same GenericGF field");if(this.isZero()||e.isZero())return this.field.getZero();for(var r=this.coefficients,n=r.length,o=e.coefficients,i=o.length,a=new Int32Array(n+i-1),u=this.field,s=0;s<n;s++)for(var c=r[s],f=0;f<i;f++)a[s+f]=ut.addOrSubtract(a[s+f],u.multiply(c,o[f]));return new t(u,a)},t.prototype.multiplyScalar=function(e){if(0===e)return this.field.getZero();if(1===e)return this;for(var r=this.coefficients.length,n=this.field,o=new Int32Array(r),i=this.coefficients,a=0;a<r;a++)o[a]=n.multiply(i[a],e);return new t(n,o)},t.prototype.multiplyByMonomial=function(e,r){if(e<0)throw new l;if(0===r)return this.field.getZero();for(var n=this.coefficients,o=n.length,i=new Int32Array(o+e),a=this.field,u=0;u<o;u++)i[u]=a.multiply(n[u],r);return new t(a,i)},t.prototype.divide=function(t){if(!this.field.equals(t.field))throw new l("GenericGFPolys do not have same GenericGF field");if(t.isZero())throw new l("Divide by 0");for(var e=this.field,r=e.getZero(),n=this,o=t.getCoefficient(t.getDegree()),i=e.inverse(o);n.getDegree()>=t.getDegree()&&!n.isZero();){var a=n.getDegree()-t.getDegree(),u=e.multiply(n.getCoefficient(n.getDegree()),i),s=t.multiplyByMonomial(a,u),c=e.buildMonomial(a,u);r=r.addOrSubtract(c),n=n.addOrSubtract(s)}return[r,n]},t.prototype.toString=function(){for(var t="",e=this.getDegree();e>=0;e--){var r=this.getCoefficient(e);if(0!==r){if(r<0?(t+=" - ",r=-r):t.length>0&&(t+=" + "),0===e||1!==r){var n=this.field.log(r);0===n?t+="1":1===n?t+="a":(t+="a^",t+=n)}0!==e&&(1===e?t+="x":(t+="x^",t+=e))}}return t},t}(),ct=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ft=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return ct(e,t),e.kind="ArithmeticException",e}(s),ht=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),lt=function(t){function e(e,r,n){var o=t.call(this)||this;o.primitive=e,o.size=r,o.generatorBase=n;for(var i=new Int32Array(r),a=1,u=0;u<r;u++)i[u]=a,(a*=2)>=r&&(a^=e,a&=r-1);o.expTable=i;var s=new Int32Array(r);for(u=0;u<r-1;u++)s[i[u]]=u;return o.logTable=s,o.zero=new st(o,Int32Array.from([0])),o.one=new st(o,Int32Array.from([1])),o}return ht(e,t),e.prototype.getZero=function(){return this.zero},e.prototype.getOne=function(){return this.one},e.prototype.buildMonomial=function(t,e){if(t<0)throw new l;if(0===e)return this.zero;var r=new Int32Array(t+1);return r[0]=e,new st(this,r)},e.prototype.inverse=function(t){if(0===t)throw new ft;return this.expTable[this.size-this.logTable[t]-1]},e.prototype.multiply=function(t,e){return 0===t||0===e?0:this.expTable[(this.logTable[t]+this.logTable[e])%(this.size-1)]},e.prototype.getSize=function(){return this.size},e.prototype.getGeneratorBase=function(){return this.generatorBase},e.prototype.toString=function(){return"GF(0x"+I.toHexString(this.primitive)+","+this.size+")"},e.prototype.equals=function(t){return t===this},e.AZTEC_DATA_12=new e(4201,4096,1),e.AZTEC_DATA_10=new e(1033,1024,1),e.AZTEC_DATA_6=new e(67,64,1),e.AZTEC_PARAM=new e(19,16,1),e.QR_CODE_FIELD_256=new e(285,256,0),e.DATA_MATRIX_FIELD_256=new e(301,256,1),e.AZTEC_DATA_8=e.DATA_MATRIX_FIELD_256,e.MAXICODE_FIELD_64=e.AZTEC_DATA_6,e}(ut),dt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),pt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return dt(e,t),e.kind="ReedSolomonException",e}(s),gt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),yt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return gt(e,t),e.kind="IllegalStateException",e}(s),wt=function(){function t(t){this.field=t}return t.prototype.decode=function(t,e){for(var r=this.field,n=new st(r,t),o=new Int32Array(e),i=!0,a=0;a<e;a++){var u=n.evaluateAt(r.exp(a+r.getGeneratorBase()));o[o.length-1-a]=u,0!==u&&(i=!1)}if(!i){var s=new st(r,o),c=this.runEuclideanAlgorithm(r.buildMonomial(e,1),s,e),f=c[0],h=c[1],l=this.findErrorLocations(f),d=this.findErrorMagnitudes(h,l);for(a=0;a<l.length;a++){var p=t.length-1-r.log(l[a]);if(p<0)throw new pt("Bad error location");t[p]=lt.addOrSubtract(t[p],d[a])}}},t.prototype.runEuclideanAlgorithm=function(t,e,r){if(t.getDegree()<e.getDegree()){var n=t;t=e,e=n}for(var o=this.field,i=t,a=e,u=o.getZero(),s=o.getOne();a.getDegree()>=(r/2|0);){var c=i,f=u;if(u=s,(i=a).isZero())throw new pt("r_{i-1} was zero");a=c;for(var h=o.getZero(),l=i.getCoefficient(i.getDegree()),d=o.inverse(l);a.getDegree()>=i.getDegree()&&!a.isZero();){var p=a.getDegree()-i.getDegree(),g=o.multiply(a.getCoefficient(a.getDegree()),d);h=h.addOrSubtract(o.buildMonomial(p,g)),a=a.addOrSubtract(i.multiplyByMonomial(p,g))}if(s=h.multiply(u).addOrSubtract(f),a.getDegree()>=i.getDegree())throw new yt("Division algorithm failed to reduce polynomial?")}var y=s.getCoefficient(0);if(0===y)throw new pt("sigmaTilde(0) was zero");var w=o.inverse(y);return[s.multiplyScalar(w),a.multiplyScalar(w)]},t.prototype.findErrorLocations=function(t){var e=t.getDegree();if(1===e)return Int32Array.from([t.getCoefficient(1)]);for(var r=new Int32Array(e),n=0,o=this.field,i=1;i<o.getSize()&&n<e;i++)0===t.evaluateAt(i)&&(r[n]=o.inverse(i),n++);if(n!==e)throw new pt("Error locator degree does not match number of roots");return r},t.prototype.findErrorMagnitudes=function(t,e){for(var r=e.length,n=new Int32Array(r),o=this.field,i=0;i<r;i++){for(var a=o.inverse(e[i]),u=1,s=0;s<r;s++)if(i!==s){var c=o.multiply(e[s],a),f=0==(1&c)?1|c:-2&c;u=o.multiply(u,f)}n[i]=o.multiply(t.evaluateAt(a),o.inverse(u)),0!==o.getGeneratorBase()&&(n[i]=o.multiply(n[i],a))}return n},t}();!function(t){t[t.UPPER=0]="UPPER",t[t.LOWER=1]="LOWER",t[t.MIXED=2]="MIXED",t[t.DIGIT=3]="DIGIT",t[t.PUNCT=4]="PUNCT",t[t.BINARY=5]="BINARY"}(ot||(ot={}));var _t=function(){function t(){}return t.prototype.decode=function(e){this.ddata=e;var r=e.getBits(),n=this.extractBits(r),o=this.correctBits(n),i=t.convertBoolArrayToByteArray(o),a=t.getEncodedData(o),u=new at(i,a,null,null);return u.setNumBits(o.length),u},t.highLevelDecode=function(t){return this.getEncodedData(t)},t.getEncodedData=function(e){for(var r=e.length,n=ot.UPPER,o=ot.UPPER,i="",a=0;a<r;)if(o===ot.BINARY){if(r-a<5)break;var u=t.readCode(e,a,5);if(a+=5,0===u){if(r-a<11)break;u=t.readCode(e,a,11)+31,a+=11}for(var s=0;s<u;s++){if(r-a<8){a=r;break}var c=t.readCode(e,a,8);i+=F.castAsNonUtf8Char(c),a+=8}o=n}else{var f=o===ot.DIGIT?4:5;if(r-a<f)break;c=t.readCode(e,a,f);a+=f;var h=t.getCharacter(o,c);h.startsWith("CTRL_")?(n=o,o=t.getTable(h.charAt(5)),"L"===h.charAt(6)&&(n=o)):(i+=h,o=n)}return i},t.getTable=function(t){switch(t){case"L":return ot.LOWER;case"P":return ot.PUNCT;case"M":return ot.MIXED;case"D":return ot.DIGIT;case"B":return ot.BINARY;default:return ot.UPPER}},t.getCharacter=function(e,r){switch(e){case ot.UPPER:return t.UPPER_TABLE[r];case ot.LOWER:return t.LOWER_TABLE[r];case ot.MIXED:return t.MIXED_TABLE[r];case ot.PUNCT:return t.PUNCT_TABLE[r];case ot.DIGIT:return t.DIGIT_TABLE[r];default:throw new yt("Bad table")}},t.prototype.correctBits=function(e){var r,n;this.ddata.getNbLayers()<=2?(n=6,r=lt.AZTEC_DATA_6):this.ddata.getNbLayers()<=8?(n=8,r=lt.AZTEC_DATA_8):this.ddata.getNbLayers()<=22?(n=10,r=lt.AZTEC_DATA_10):(n=12,r=lt.AZTEC_DATA_12);var o=this.ddata.getNbDatablocks(),i=e.length/n;if(i<o)throw new R;for(var a=e.length%n,u=new Int32Array(i),s=0;s<i;s++,a+=n)u[s]=t.readCode(e,a,n);try{new wt(r).decode(u,i-o)}catch(t){throw new R(t)}var c=(1<<n)-1,f=0;for(s=0;s<o;s++){if(0===(d=u[s])||d===c)throw new R;1!==d&&d!==c-1||f++}var h=new Array(o*n-f),l=0;for(s=0;s<o;s++){var d;if(1===(d=u[s])||d===c-1)h.fill(d>1,l,l+n-1),l+=n-1;else for(var p=n-1;p>=0;--p)h[l++]=0!=(d&1<<p)}return h},t.prototype.extractBits=function(t){var e=this.ddata.isCompact(),r=this.ddata.getNbLayers(),n=(e?11:14)+4*r,o=new Int32Array(n),i=new Array(this.totalBitsInLayer(r,e));if(e)for(var a=0;a<o.length;a++)o[a]=a;else{var u=n+1+2*I.truncDivision(I.truncDivision(n,2)-1,15),s=n/2,c=I.truncDivision(u,2);for(a=0;a<s;a++){var f=a+I.truncDivision(a,15);o[s-a-1]=c-f-1,o[s+a]=c+f+1}}a=0;for(var h=0;a<r;a++){for(var l=4*(r-a)+(e?9:12),d=2*a,p=n-1-d,g=0;g<l;g++)for(var y=2*g,w=0;w<2;w++)i[h+y+w]=t.get(o[d+w],o[d+g]),i[h+2*l+y+w]=t.get(o[d+g],o[p-w]),i[h+4*l+y+w]=t.get(o[p-w],o[p-g]),i[h+6*l+y+w]=t.get(o[p-g],o[d+w]);h+=8*l}return i},t.readCode=function(t,e,r){for(var n=0,o=e;o<e+r;o++)n<<=1,t[o]&&(n|=1);return n},t.readByte=function(e,r){var n=e.length-r;return n>=8?t.readCode(e,r,8):t.readCode(e,r,n)<<8-n},t.convertBoolArrayToByteArray=function(e){for(var r=new Uint8Array((e.length+7)/8),n=0;n<r.length;n++)r[n]=t.readByte(e,8*n);return r},t.prototype.totalBitsInLayer=function(t,e){return((e?88:112)+16*t)*t},t.UPPER_TABLE=["CTRL_PS"," ","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","CTRL_LL","CTRL_ML","CTRL_DL","CTRL_BS"],t.LOWER_TABLE=["CTRL_PS"," ","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","CTRL_US","CTRL_ML","CTRL_DL","CTRL_BS"],t.MIXED_TABLE=["CTRL_PS"," ","\\1","\\2","\\3","\\4","\\5","\\6","\\7","\b","\t","\n","\\13","\f","\r","\\33","\\34","\\35","\\36","\\37","@","\\","^","_","`","|","~","\\177","CTRL_LL","CTRL_UL","CTRL_PL","CTRL_BS"],t.PUNCT_TABLE=["","\r","\r\n",". ",", ",": ","!",'"',"#","$","%","&","'","(",")","*","+",",","-",".","/",":",";","<","=",">","?","[","]","{","}","CTRL_UL"],t.DIGIT_TABLE=["CTRL_PS"," ","0","1","2","3","4","5","6","7","8","9",",",".","CTRL_UL","CTRL_US"],t}(),vt=function(){function t(){}return t.round=function(t){return NaN===t?0:t<=Number.MIN_SAFE_INTEGER?Number.MIN_SAFE_INTEGER:t>=Number.MAX_SAFE_INTEGER?Number.MAX_SAFE_INTEGER:t+(t<0?-.5:.5)|0},t.distance=function(t,e,r,n){var o=t-r,i=e-n;return Math.sqrt(o*o+i*i)},t.sum=function(t){for(var e=0,r=0,n=t.length;r!==n;r++){e+=t[r]}return e},t}(),mt=function(){function t(){}return t.floatToIntBits=function(t){return t},t.MAX_VALUE=Number.MAX_SAFE_INTEGER,t}(),At=function(){function t(t,e){this.x=t,this.y=e}return t.prototype.getX=function(){return this.x},t.prototype.getY=function(){return this.y},t.prototype.equals=function(e){if(e instanceof t){var r=e;return this.x===r.x&&this.y===r.y}return!1},t.prototype.hashCode=function(){return 31*mt.floatToIntBits(this.x)+mt.floatToIntBits(this.y)},t.prototype.toString=function(){return"("+this.x+","+this.y+")"},t.orderBestPatterns=function(t){var e,r,n,o=this.distance(t[0],t[1]),i=this.distance(t[1],t[2]),a=this.distance(t[0],t[2]);if(i>=o&&i>=a?(r=t[0],e=t[1],n=t[2]):a>=i&&a>=o?(r=t[1],e=t[0],n=t[2]):(r=t[2],e=t[0],n=t[1]),this.crossProductZ(e,r,n)<0){var u=e;e=n,n=u}t[0]=e,t[1]=r,t[2]=n},t.distance=function(t,e){return vt.distance(t.x,t.y,e.x,e.y)},t.crossProductZ=function(t,e,r){var n=e.x,o=e.y;return(r.x-n)*(t.y-o)-(r.y-o)*(t.x-n)},t}(),Et=function(){function t(t,e){this.bits=t,this.points=e}return t.prototype.getBits=function(){return this.bits},t.prototype.getPoints=function(){return this.points},t}(),Ct=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),It=function(t){function e(e,r,n,o,i){var a=t.call(this,e,r)||this;return a.compact=n,a.nbDatablocks=o,a.nbLayers=i,a}return Ct(e,t),e.prototype.getNbLayers=function(){return this.nbLayers},e.prototype.getNbDatablocks=function(){return this.nbDatablocks},e.prototype.isCompact=function(){return this.compact},e}(Et),St=function(){function t(e,r,n,o){this.image=e,this.height=e.getHeight(),this.width=e.getWidth(),null==r&&(r=t.INIT_SIZE),null==n&&(n=e.getWidth()/2|0),null==o&&(o=e.getHeight()/2|0);var i=r/2|0;if(this.leftInit=n-i,this.rightInit=n+i,this.upInit=o-i,this.downInit=o+i,this.upInit<0||this.leftInit<0||this.downInit>=this.height||this.rightInit>=this.width)throw new U}return t.prototype.detect=function(){for(var t=this.leftInit,e=this.rightInit,r=this.upInit,n=this.downInit,o=!1,i=!0,a=!1,u=!1,s=!1,c=!1,f=!1,h=this.width,l=this.height;i;){i=!1;for(var d=!0;(d||!u)&&e<h;)(d=this.containsBlackPoint(r,n,e,!1))?(e++,i=!0,u=!0):u||e++;if(e>=h){o=!0;break}for(var p=!0;(p||!s)&&n<l;)(p=this.containsBlackPoint(t,e,n,!0))?(n++,i=!0,s=!0):s||n++;if(n>=l){o=!0;break}for(var g=!0;(g||!c)&&t>=0;)(g=this.containsBlackPoint(r,n,t,!1))?(t--,i=!0,c=!0):c||t--;if(t<0){o=!0;break}for(var y=!0;(y||!f)&&r>=0;)(y=this.containsBlackPoint(t,e,r,!0))?(r--,i=!0,f=!0):f||r--;if(r<0){o=!0;break}i&&(a=!0)}if(!o&&a){for(var w=e-t,_=null,v=1;null===_&&v<w;v++)_=this.getBlackPointOnSegment(t,n-v,t+v,n);if(null==_)throw new U;var m=null;for(v=1;null===m&&v<w;v++)m=this.getBlackPointOnSegment(t,r+v,t+v,r);if(null==m)throw new U;var A=null;for(v=1;null===A&&v<w;v++)A=this.getBlackPointOnSegment(e,r+v,e-v,r);if(null==A)throw new U;var E=null;for(v=1;null===E&&v<w;v++)E=this.getBlackPointOnSegment(e,n-v,e-v,n);if(null==E)throw new U;return this.centerEdges(E,_,A,m)}throw new U},t.prototype.getBlackPointOnSegment=function(t,e,r,n){for(var o=vt.round(vt.distance(t,e,r,n)),i=(r-t)/o,a=(n-e)/o,u=this.image,s=0;s<o;s++){var c=vt.round(t+s*i),f=vt.round(e+s*a);if(u.get(c,f))return new At(c,f)}return null},t.prototype.centerEdges=function(e,r,n,o){var i=e.getX(),a=e.getY(),u=r.getX(),s=r.getY(),c=n.getX(),f=n.getY(),h=o.getX(),l=o.getY(),d=t.CORR;return i<this.width/2?[new At(h-d,l+d),new At(u+d,s+d),new At(c-d,f-d),new At(i+d,a-d)]:[new At(h+d,l+d),new At(u+d,s-d),new At(c-d,f+d),new At(i-d,a-d)]},t.prototype.containsBlackPoint=function(t,e,r,n){var o=this.image;if(n){for(var i=t;i<=e;i++)if(o.get(i,r))return!0}else for(var a=t;a<=e;a++)if(o.get(r,a))return!0;return!1},t.INIT_SIZE=10,t.CORR=1,t}(),Ot=function(){function t(){}return t.checkAndNudgePoints=function(t,e){for(var r=t.getWidth(),n=t.getHeight(),o=!0,i=0;i<e.length&&o;i+=2){var a=Math.floor(e[i]),u=Math.floor(e[i+1]);if(a<-1||a>r||u<-1||u>n)throw new U;o=!1,-1===a?(e[i]=0,o=!0):a===r&&(e[i]=r-1,o=!0),-1===u?(e[i+1]=0,o=!0):u===n&&(e[i+1]=n-1,o=!0)}o=!0;for(i=e.length-2;i>=0&&o;i-=2){a=Math.floor(e[i]),u=Math.floor(e[i+1]);if(a<-1||a>r||u<-1||u>n)throw new U;o=!1,-1===a?(e[i]=0,o=!0):a===r&&(e[i]=r-1,o=!0),-1===u?(e[i+1]=0,o=!0):u===n&&(e[i+1]=n-1,o=!0)}},t}(),Tt=function(){function t(t,e,r,n,o,i,a,u,s){this.a11=t,this.a21=e,this.a31=r,this.a12=n,this.a22=o,this.a32=i,this.a13=a,this.a23=u,this.a33=s}return t.quadrilateralToQuadrilateral=function(e,r,n,o,i,a,u,s,c,f,h,l,d,p,g,y){var w=t.quadrilateralToSquare(e,r,n,o,i,a,u,s);return t.squareToQuadrilateral(c,f,h,l,d,p,g,y).times(w)},t.prototype.transformPoints=function(t){for(var e=t.length,r=this.a11,n=this.a12,o=this.a13,i=this.a21,a=this.a22,u=this.a23,s=this.a31,c=this.a32,f=this.a33,h=0;h<e;h+=2){var l=t[h],d=t[h+1],p=o*l+u*d+f;t[h]=(r*l+i*d+s)/p,t[h+1]=(n*l+a*d+c)/p}},t.prototype.transformPointsWithValues=function(t,e){for(var r=this.a11,n=this.a12,o=this.a13,i=this.a21,a=this.a22,u=this.a23,s=this.a31,c=this.a32,f=this.a33,h=t.length,l=0;l<h;l++){var d=t[l],p=e[l],g=o*d+u*p+f;t[l]=(r*d+i*p+s)/g,e[l]=(n*d+a*p+c)/g}},t.squareToQuadrilateral=function(e,r,n,o,i,a,u,s){var c=e-n+i-u,f=r-o+a-s;if(0===c&&0===f)return new t(n-e,i-n,e,o-r,a-o,r,0,0,1);var h=n-i,l=u-i,d=o-a,p=s-a,g=h*p-l*d,y=(c*p-l*f)/g,w=(h*f-c*d)/g;return new t(n-e+y*n,u-e+w*u,e,o-r+y*o,s-r+w*s,r,y,w,1)},t.quadrilateralToSquare=function(e,r,n,o,i,a,u,s){return t.squareToQuadrilateral(e,r,n,o,i,a,u,s).buildAdjoint()},t.prototype.buildAdjoint=function(){return new t(this.a22*this.a33-this.a23*this.a32,this.a23*this.a31-this.a21*this.a33,this.a21*this.a32-this.a22*this.a31,this.a13*this.a32-this.a12*this.a33,this.a11*this.a33-this.a13*this.a31,this.a12*this.a31-this.a11*this.a32,this.a12*this.a23-this.a13*this.a22,this.a13*this.a21-this.a11*this.a23,this.a11*this.a22-this.a12*this.a21)},t.prototype.times=function(e){return new t(this.a11*e.a11+this.a21*e.a12+this.a31*e.a13,this.a11*e.a21+this.a21*e.a22+this.a31*e.a23,this.a11*e.a31+this.a21*e.a32+this.a31*e.a33,this.a12*e.a11+this.a22*e.a12+this.a32*e.a13,this.a12*e.a21+this.a22*e.a22+this.a32*e.a23,this.a12*e.a31+this.a22*e.a32+this.a32*e.a33,this.a13*e.a11+this.a23*e.a12+this.a33*e.a13,this.a13*e.a21+this.a23*e.a22+this.a33*e.a23,this.a13*e.a31+this.a23*e.a32+this.a33*e.a33)},t}(),bt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Rt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return bt(e,t),e.prototype.sampleGrid=function(t,e,r,n,o,i,a,u,s,c,f,h,l,d,p,g,y,w,_){var v=Tt.quadrilateralToQuadrilateral(n,o,i,a,u,s,c,f,h,l,d,p,g,y,w,_);return this.sampleGridWithTransform(t,e,r,v)},e.prototype.sampleGridWithTransform=function(t,e,r,n){if(e<=0||r<=0)throw new U;for(var o=new x(e,r),i=new Float32Array(2*e),a=0;a<r;a++){for(var u=i.length,s=a+.5,c=0;c<u;c+=2)i[c]=c/2+.5,i[c+1]=s;n.transformPoints(i),Ot.checkAndNudgePoints(t,i);try{for(c=0;c<u;c+=2)t.get(Math.floor(i[c]),Math.floor(i[c+1]))&&o.set(c/2,a)}catch(t){throw new U}}return o},e}(Ot),Nt=function(){function t(){}return t.setGridSampler=function(e){t.gridSampler=e},t.getInstance=function(){return t.gridSampler},t.gridSampler=new Rt,t}(),Dt=function(){function t(t,e){this.x=t,this.y=e}return t.prototype.toResultPoint=function(){return new At(this.getX(),this.getY())},t.prototype.getX=function(){return this.x},t.prototype.getY=function(){return this.y},t}(),Pt=function(){function t(t){this.EXPECTED_CORNER_BITS=new Int32Array([3808,476,2107,1799]),this.image=t}return t.prototype.detect=function(){return this.detectMirror(!1)},t.prototype.detectMirror=function(t){var e=this.getMatrixCenter(),r=this.getBullsEyeCorners(e);if(t){var n=r[0];r[0]=r[2],r[2]=n}this.extractParameters(r);var o=this.sampleGrid(this.image,r[this.shift%4],r[(this.shift+1)%4],r[(this.shift+2)%4],r[(this.shift+3)%4]),i=this.getMatrixCornerPoints(r);return new It(o,i,this.compact,this.nbDataBlocks,this.nbLayers)},t.prototype.extractParameters=function(t){if(!(this.isValidPoint(t[0])&&this.isValidPoint(t[1])&&this.isValidPoint(t[2])&&this.isValidPoint(t[3])))throw new U;var e=2*this.nbCenterLayers,r=new Int32Array([this.sampleLine(t[0],t[1],e),this.sampleLine(t[1],t[2],e),this.sampleLine(t[2],t[3],e),this.sampleLine(t[3],t[0],e)]);this.shift=this.getRotation(r,e);for(var n=0,o=0;o<4;o++){var i=r[(this.shift+o)%4];this.compact?(n<<=7,n+=i>>1&127):(n<<=10,n+=(i>>2&992)+(i>>1&31))}var a=this.getCorrectedParameterData(n,this.compact);this.compact?(this.nbLayers=1+(a>>6),this.nbDataBlocks=1+(63&a)):(this.nbLayers=1+(a>>11),this.nbDataBlocks=1+(2047&a))},t.prototype.getRotation=function(t,e){var r=0;t.forEach((function(t,n,o){r=(r<<3)+((t>>e-2<<1)+(1&t))})),r=((1&r)<<11)+(r>>1);for(var n=0;n<4;n++)if(I.bitCount(r^this.EXPECTED_CORNER_BITS[n])<=2)return n;throw new U},t.prototype.getCorrectedParameterData=function(t,e){var r,n;e?(r=7,n=2):(r=10,n=4);for(var o=r-n,i=new Int32Array(r),a=r-1;a>=0;--a)i[a]=15&t,t>>=4;try{new wt(lt.AZTEC_PARAM).decode(i,o)}catch(t){throw new U}var u=0;for(a=0;a<n;a++)u=(u<<4)+i[a];return u},t.prototype.getBullsEyeCorners=function(t){var e=t,r=t,n=t,o=t,i=!0;for(this.nbCenterLayers=1;this.nbCenterLayers<9;this.nbCenterLayers++){var a=this.getFirstDifferent(e,i,1,-1),u=this.getFirstDifferent(r,i,1,1),s=this.getFirstDifferent(n,i,-1,1),c=this.getFirstDifferent(o,i,-1,-1);if(this.nbCenterLayers>2){var f=this.distancePoint(c,a)*this.nbCenterLayers/(this.distancePoint(o,e)*(this.nbCenterLayers+2));if(f<.75||f>1.25||!this.isWhiteOrBlackRectangle(a,u,s,c))break}e=a,r=u,n=s,o=c,i=!i}if(5!==this.nbCenterLayers&&7!==this.nbCenterLayers)throw new U;this.compact=5===this.nbCenterLayers;var h=new At(e.getX()+.5,e.getY()-.5),l=new At(r.getX()+.5,r.getY()+.5),d=new At(n.getX()-.5,n.getY()+.5),p=new At(o.getX()-.5,o.getY()-.5);return this.expandSquare([h,l,d,p],2*this.nbCenterLayers-3,2*this.nbCenterLayers)},t.prototype.getMatrixCenter=function(){var t,e,r,n;try{t=(s=new St(this.image).detect())[0],e=s[1],r=s[2],n=s[3]}catch(a){var o=this.image.getWidth()/2,i=this.image.getHeight()/2;t=this.getFirstDifferent(new Dt(o+7,i-7),!1,1,-1).toResultPoint(),e=this.getFirstDifferent(new Dt(o+7,i+7),!1,1,1).toResultPoint(),r=this.getFirstDifferent(new Dt(o-7,i+7),!1,-1,1).toResultPoint(),n=this.getFirstDifferent(new Dt(o-7,i-7),!1,-1,-1).toResultPoint()}var a=vt.round((t.getX()+n.getX()+e.getX()+r.getX())/4),u=vt.round((t.getY()+n.getY()+e.getY()+r.getY())/4);try{var s;t=(s=new St(this.image,15,a,u).detect())[0],e=s[1],r=s[2],n=s[3]}catch(o){t=this.getFirstDifferent(new Dt(a+7,u-7),!1,1,-1).toResultPoint(),e=this.getFirstDifferent(new Dt(a+7,u+7),!1,1,1).toResultPoint(),r=this.getFirstDifferent(new Dt(a-7,u+7),!1,-1,1).toResultPoint(),n=this.getFirstDifferent(new Dt(a-7,u-7),!1,-1,-1).toResultPoint()}return a=vt.round((t.getX()+n.getX()+e.getX()+r.getX())/4),u=vt.round((t.getY()+n.getY()+e.getY()+r.getY())/4),new Dt(a,u)},t.prototype.getMatrixCornerPoints=function(t){return this.expandSquare(t,2*this.nbCenterLayers,this.getDimension())},t.prototype.sampleGrid=function(t,e,r,n,o){var i=Nt.getInstance(),a=this.getDimension(),u=a/2-this.nbCenterLayers,s=a/2+this.nbCenterLayers;return i.sampleGrid(t,a,a,u,u,s,u,s,s,u,s,e.getX(),e.getY(),r.getX(),r.getY(),n.getX(),n.getY(),o.getX(),o.getY())},t.prototype.sampleLine=function(t,e,r){for(var n=0,o=this.distanceResultPoint(t,e),i=o/r,a=t.getX(),u=t.getY(),s=i*(e.getX()-t.getX())/o,c=i*(e.getY()-t.getY())/o,f=0;f<r;f++)this.image.get(vt.round(a+f*s),vt.round(u+f*c))&&(n|=1<<r-f-1);return n},t.prototype.isWhiteOrBlackRectangle=function(t,e,r,n){t=new Dt(t.getX()-3,t.getY()+3),e=new Dt(e.getX()-3,e.getY()-3),r=new Dt(r.getX()+3,r.getY()-3),n=new Dt(n.getX()+3,n.getY()+3);var o=this.getColor(n,t);if(0===o)return!1;var i=this.getColor(t,e);return i===o&&((i=this.getColor(e,r))===o&&(i=this.getColor(r,n))===o)},t.prototype.getColor=function(t,e){for(var r=this.distancePoint(t,e),n=(e.getX()-t.getX())/r,o=(e.getY()-t.getY())/r,i=0,a=t.getX(),u=t.getY(),s=this.image.get(t.getX(),t.getY()),c=Math.ceil(r),f=0;f<c;f++)a+=n,u+=o,this.image.get(vt.round(a),vt.round(u))!==s&&i++;var h=i/r;return h>.1&&h<.9?0:h<=.1===s?1:-1},t.prototype.getFirstDifferent=function(t,e,r,n){for(var o=t.getX()+r,i=t.getY()+n;this.isValid(o,i)&&this.image.get(o,i)===e;)o+=r,i+=n;for(o-=r,i-=n;this.isValid(o,i)&&this.image.get(o,i)===e;)o+=r;for(o-=r;this.isValid(o,i)&&this.image.get(o,i)===e;)i+=n;return new Dt(o,i-=n)},t.prototype.expandSquare=function(t,e,r){var n=r/(2*e),o=t[0].getX()-t[2].getX(),i=t[0].getY()-t[2].getY(),a=(t[0].getX()+t[2].getX())/2,u=(t[0].getY()+t[2].getY())/2,s=new At(a+n*o,u+n*i),c=new At(a-n*o,u-n*i);return o=t[1].getX()-t[3].getX(),i=t[1].getY()-t[3].getY(),a=(t[1].getX()+t[3].getX())/2,u=(t[1].getY()+t[3].getY())/2,[s,new At(a+n*o,u+n*i),c,new At(a-n*o,u-n*i)]},t.prototype.isValid=function(t,e){return t>=0&&t<this.image.getWidth()&&e>0&&e<this.image.getHeight()},t.prototype.isValidPoint=function(t){var e=vt.round(t.getX()),r=vt.round(t.getY());return this.isValid(e,r)},t.prototype.distancePoint=function(t,e){return vt.distance(t.getX(),t.getY(),e.getX(),e.getY())},t.prototype.distanceResultPoint=function(t,e){return vt.distance(t.getX(),t.getY(),e.getX(),e.getY())},t.prototype.getDimension=function(){return this.compact?4*this.nbLayers+11:this.nbLayers<=4?4*this.nbLayers+15:4*this.nbLayers+2*(I.truncDivision(this.nbLayers-4,8)+1)+15},t}(),Mt=function(){function t(){}return t.prototype.decode=function(t,e){void 0===e&&(e=null);var r=null,n=new Pt(t.getBlackMatrix()),o=null,i=null;try{o=(a=n.detectMirror(!1)).getPoints(),this.reportFoundResultPoints(e,o),i=(new _t).decode(a)}catch(t){r=t}if(null==i)try{var a;o=(a=n.detectMirror(!0)).getPoints(),this.reportFoundResultPoints(e,o),i=(new _t).decode(a)}catch(t){if(null!=r)throw r;throw t}var u=new et(i.getText(),i.getRawBytes(),i.getNumBits(),o,nt.AZTEC,w.currentTimeMillis()),s=i.getByteSegments();null!=s&&u.putMetadata(it.BYTE_SEGMENTS,s);var c=i.getECLevel();return null!=c&&u.putMetadata(it.ERROR_CORRECTION_LEVEL,c),u},t.prototype.reportFoundResultPoints=function(t,e){if(null!=t){var r=t.get(T.NEED_RESULT_POINT_CALLBACK);null!=r&&e.forEach((function(t,e,n){r.foundPossibleResultPoint(t)}))}},t.prototype.reset=function(){},t}(),Bt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e){return void 0===e&&(e=500),t.call(this,new Mt,e)||this}Bt(e,t)}(tt);var Lt=function(){function t(){}return t.prototype.decode=function(t,e){try{return this.doDecode(t,e)}catch(c){if(e&&!0===e.get(T.TRY_HARDER)&&t.isRotateSupported()){var r=t.rotateCounterClockwise(),n=this.doDecode(r,e),o=n.getResultMetadata(),i=270;null!==o&&!0===o.get(it.ORIENTATION)&&(i+=o.get(it.ORIENTATION)%360),n.putMetadata(it.ORIENTATION,i);var a=n.getResultPoints();if(null!==a)for(var u=r.getHeight(),s=0;s<a.length;s++)a[s]=new At(u-a[s].getY()-1,a[s].getX());return n}throw new U}},t.prototype.reset=function(){},t.prototype.doDecode=function(t,e){var r,n=t.getWidth(),o=t.getHeight(),i=new S(n),a=e&&!0===e.get(T.TRY_HARDER),u=Math.max(1,o>>(a?8:5));r=a?o:15;for(var s=Math.trunc(o/2),c=0;c<r;c++){var f=Math.trunc((c+1)/2),h=s+u*(0==(1&c)?f:-f);if(h<0||h>=o)break;try{i=t.getBlackRow(h,i)}catch(t){continue}for(var l=function(t){if(1===t&&(i.reverse(),e&&!0===e.get(T.NEED_RESULT_POINT_CALLBACK))){var r=new Map;e.forEach((function(t,e){return r.set(e,t)})),r.delete(T.NEED_RESULT_POINT_CALLBACK),e=r}try{var o=d.decodeRow(h,i,e);if(1===t){o.putMetadata(it.ORIENTATION,180);var a=o.getResultPoints();null!==a&&(a[0]=new At(n-a[0].getX()-1,a[0].getY()),a[1]=new At(n-a[1].getX()-1,a[1].getY()))}return{value:o}}catch(t){}},d=this,p=0;p<2;p++){var g=l(p);if("object"==typeof g)return g.value}}throw new U},t.recordPattern=function(t,e,r){for(var n=r.length,o=0;o<n;o++)r[o]=0;var i=t.getSize();if(e>=i)throw new U;for(var a=!t.get(e),u=0,s=e;s<i;){if(t.get(s)!==a)r[u]++;else{if(++u===n)break;r[u]=1,a=!a}s++}if(u!==n&&(u!==n-1||s!==i))throw new U},t.recordPatternInReverse=function(e,r,n){for(var o=n.length,i=e.get(r);r>0&&o>=0;)e.get(--r)!==i&&(o--,i=!i);if(o>=0)throw new U;t.recordPattern(e,r+1,n)},t.patternMatchVariance=function(t,e,r){for(var n=t.length,o=0,i=0,a=0;a<n;a++)o+=t[a],i+=e[a];if(o<i)return Number.POSITIVE_INFINITY;var u=o/i;r*=u;for(var s=0,c=0;c<n;c++){var f=t[c],h=e[c]*u,l=f>h?f-h:h-f;if(l>r)return Number.POSITIVE_INFINITY;s+=l}return s/o},t}(),Ft=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),kt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return Ft(e,t),e.findStartPattern=function(t){for(var r=t.getSize(),n=t.getNextSet(0),o=0,i=Int32Array.from([0,0,0,0,0,0]),a=n,u=!1,s=n;s<r;s++)if(t.get(s)!==u)i[o]++;else{if(5===o){for(var c=e.MAX_AVG_VARIANCE,f=-1,h=e.CODE_START_A;h<=e.CODE_START_C;h++){var l=Lt.patternMatchVariance(i,e.CODE_PATTERNS[h],e.MAX_INDIVIDUAL_VARIANCE);l<c&&(c=l,f=h)}if(f>=0&&t.isRange(Math.max(0,a-(s-a)/2),a,!1))return Int32Array.from([a,s,f]);a+=i[0]+i[1],(i=i.slice(2,i.length-1))[o-1]=0,i[o]=0,o--}else o++;i[o]=1,u=!u}throw new U},e.decodeCode=function(t,r,n){Lt.recordPattern(t,n,r);for(var o=e.MAX_AVG_VARIANCE,i=-1,a=0;a<e.CODE_PATTERNS.length;a++){var u=e.CODE_PATTERNS[a],s=this.patternMatchVariance(r,u,e.MAX_INDIVIDUAL_VARIANCE);s<o&&(o=s,i=a)}if(i>=0)return i;throw new U},e.prototype.decodeRow=function(t,r,n){var o,i=n&&!0===n.get(T.ASSUME_GS1),a=e.findStartPattern(r),u=a[2],s=0,c=new Uint8Array(20);switch(c[s++]=u,u){case e.CODE_START_A:o=e.CODE_CODE_A;break;case e.CODE_START_B:o=e.CODE_CODE_B;break;case e.CODE_START_C:o=e.CODE_CODE_C;break;default:throw new R}for(var f=!1,h=!1,l="",d=a[0],p=a[1],y=Int32Array.from([0,0,0,0,0,0]),w=0,_=0,v=u,m=0,A=!0,E=!1,C=!1;!f;){var I=h;switch(h=!1,w=_,_=e.decodeCode(r,y,p),c[s++]=_,_!==e.CODE_STOP&&(A=!0),_!==e.CODE_STOP&&(v+=++m*_),d=p,p+=y.reduce((function(t,e){return t+e}),0),_){case e.CODE_START_A:case e.CODE_START_B:case e.CODE_START_C:throw new R}switch(o){case e.CODE_CODE_A:if(_<64)l+=C===E?String.fromCharCode(" ".charCodeAt(0)+_):String.fromCharCode(" ".charCodeAt(0)+_+128),C=!1;else if(_<96)l+=C===E?String.fromCharCode(_-64):String.fromCharCode(_+64),C=!1;else switch(_!==e.CODE_STOP&&(A=!1),_){case e.CODE_FNC_1:i&&(0===l.length?l+="]C1":l+=String.fromCharCode(29));break;case e.CODE_FNC_2:case e.CODE_FNC_3:break;case e.CODE_FNC_4_A:!E&&C?(E=!0,C=!1):E&&C?(E=!1,C=!1):C=!0;break;case e.CODE_SHIFT:h=!0,o=e.CODE_CODE_B;break;case e.CODE_CODE_B:o=e.CODE_CODE_B;break;case e.CODE_CODE_C:o=e.CODE_CODE_C;break;case e.CODE_STOP:f=!0}break;case e.CODE_CODE_B:if(_<96)l+=C===E?String.fromCharCode(" ".charCodeAt(0)+_):String.fromCharCode(" ".charCodeAt(0)+_+128),C=!1;else switch(_!==e.CODE_STOP&&(A=!1),_){case e.CODE_FNC_1:i&&(0===l.length?l+="]C1":l+=String.fromCharCode(29));break;case e.CODE_FNC_2:case e.CODE_FNC_3:break;case e.CODE_FNC_4_B:!E&&C?(E=!0,C=!1):E&&C?(E=!1,C=!1):C=!0;break;case e.CODE_SHIFT:h=!0,o=e.CODE_CODE_A;break;case e.CODE_CODE_A:o=e.CODE_CODE_A;break;case e.CODE_CODE_C:o=e.CODE_CODE_C;break;case e.CODE_STOP:f=!0}break;case e.CODE_CODE_C:if(_<100)_<10&&(l+="0"),l+=_;else switch(_!==e.CODE_STOP&&(A=!1),_){case e.CODE_FNC_1:i&&(0===l.length?l+="]C1":l+=String.fromCharCode(29));break;case e.CODE_CODE_A:o=e.CODE_CODE_A;break;case e.CODE_CODE_B:o=e.CODE_CODE_B;break;case e.CODE_STOP:f=!0}}I&&(o=o===e.CODE_CODE_A?e.CODE_CODE_B:e.CODE_CODE_A)}var S=p-d;if(p=r.getNextUnset(p),!r.isRange(p,Math.min(r.getSize(),p+(p-d)/2),!1))throw new U;if((v-=m*w)%103!==w)throw new g;var O=l.length;if(0===O)throw new U;O>0&&A&&(l=o===e.CODE_CODE_C?l.substring(0,O-2):l.substring(0,O-1));for(var b=(a[1]+a[0])/2,N=d+S/2,D=c.length,P=new Uint8Array(D),M=0;M<D;M++)P[M]=c[M];var B=[new At(b,t),new At(N,t)];return new et(l,P,0,B,nt.CODE_128,(new Date).getTime())},e.CODE_PATTERNS=[Int32Array.from([2,1,2,2,2,2]),Int32Array.from([2,2,2,1,2,2]),Int32Array.from([2,2,2,2,2,1]),Int32Array.from([1,2,1,2,2,3]),Int32Array.from([1,2,1,3,2,2]),Int32Array.from([1,3,1,2,2,2]),Int32Array.from([1,2,2,2,1,3]),Int32Array.from([1,2,2,3,1,2]),Int32Array.from([1,3,2,2,1,2]),Int32Array.from([2,2,1,2,1,3]),Int32Array.from([2,2,1,3,1,2]),Int32Array.from([2,3,1,2,1,2]),Int32Array.from([1,1,2,2,3,2]),Int32Array.from([1,2,2,1,3,2]),Int32Array.from([1,2,2,2,3,1]),Int32Array.from([1,1,3,2,2,2]),Int32Array.from([1,2,3,1,2,2]),Int32Array.from([1,2,3,2,2,1]),Int32Array.from([2,2,3,2,1,1]),Int32Array.from([2,2,1,1,3,2]),Int32Array.from([2,2,1,2,3,1]),Int32Array.from([2,1,3,2,1,2]),Int32Array.from([2,2,3,1,1,2]),Int32Array.from([3,1,2,1,3,1]),Int32Array.from([3,1,1,2,2,2]),Int32Array.from([3,2,1,1,2,2]),Int32Array.from([3,2,1,2,2,1]),Int32Array.from([3,1,2,2,1,2]),Int32Array.from([3,2,2,1,1,2]),Int32Array.from([3,2,2,2,1,1]),Int32Array.from([2,1,2,1,2,3]),Int32Array.from([2,1,2,3,2,1]),Int32Array.from([2,3,2,1,2,1]),Int32Array.from([1,1,1,3,2,3]),Int32Array.from([1,3,1,1,2,3]),Int32Array.from([1,3,1,3,2,1]),Int32Array.from([1,1,2,3,1,3]),Int32Array.from([1,3,2,1,1,3]),Int32Array.from([1,3,2,3,1,1]),Int32Array.from([2,1,1,3,1,3]),Int32Array.from([2,3,1,1,1,3]),Int32Array.from([2,3,1,3,1,1]),Int32Array.from([1,1,2,1,3,3]),Int32Array.from([1,1,2,3,3,1]),Int32Array.from([1,3,2,1,3,1]),Int32Array.from([1,1,3,1,2,3]),Int32Array.from([1,1,3,3,2,1]),Int32Array.from([1,3,3,1,2,1]),Int32Array.from([3,1,3,1,2,1]),Int32Array.from([2,1,1,3,3,1]),Int32Array.from([2,3,1,1,3,1]),Int32Array.from([2,1,3,1,1,3]),Int32Array.from([2,1,3,3,1,1]),Int32Array.from([2,1,3,1,3,1]),Int32Array.from([3,1,1,1,2,3]),Int32Array.from([3,1,1,3,2,1]),Int32Array.from([3,3,1,1,2,1]),Int32Array.from([3,1,2,1,1,3]),Int32Array.from([3,1,2,3,1,1]),Int32Array.from([3,3,2,1,1,1]),Int32Array.from([3,1,4,1,1,1]),Int32Array.from([2,2,1,4,1,1]),Int32Array.from([4,3,1,1,1,1]),Int32Array.from([1,1,1,2,2,4]),Int32Array.from([1,1,1,4,2,2]),Int32Array.from([1,2,1,1,2,4]),Int32Array.from([1,2,1,4,2,1]),Int32Array.from([1,4,1,1,2,2]),Int32Array.from([1,4,1,2,2,1]),Int32Array.from([1,1,2,2,1,4]),Int32Array.from([1,1,2,4,1,2]),Int32Array.from([1,2,2,1,1,4]),Int32Array.from([1,2,2,4,1,1]),Int32Array.from([1,4,2,1,1,2]),Int32Array.from([1,4,2,2,1,1]),Int32Array.from([2,4,1,2,1,1]),Int32Array.from([2,2,1,1,1,4]),Int32Array.from([4,1,3,1,1,1]),Int32Array.from([2,4,1,1,1,2]),Int32Array.from([1,3,4,1,1,1]),Int32Array.from([1,1,1,2,4,2]),Int32Array.from([1,2,1,1,4,2]),Int32Array.from([1,2,1,2,4,1]),Int32Array.from([1,1,4,2,1,2]),Int32Array.from([1,2,4,1,1,2]),Int32Array.from([1,2,4,2,1,1]),Int32Array.from([4,1,1,2,1,2]),Int32Array.from([4,2,1,1,1,2]),Int32Array.from([4,2,1,2,1,1]),Int32Array.from([2,1,2,1,4,1]),Int32Array.from([2,1,4,1,2,1]),Int32Array.from([4,1,2,1,2,1]),Int32Array.from([1,1,1,1,4,3]),Int32Array.from([1,1,1,3,4,1]),Int32Array.from([1,3,1,1,4,1]),Int32Array.from([1,1,4,1,1,3]),Int32Array.from([1,1,4,3,1,1]),Int32Array.from([4,1,1,1,1,3]),Int32Array.from([4,1,1,3,1,1]),Int32Array.from([1,1,3,1,4,1]),Int32Array.from([1,1,4,1,3,1]),Int32Array.from([3,1,1,1,4,1]),Int32Array.from([4,1,1,1,3,1]),Int32Array.from([2,1,1,4,1,2]),Int32Array.from([2,1,1,2,1,4]),Int32Array.from([2,1,1,2,3,2]),Int32Array.from([2,3,3,1,1,1,2])],e.MAX_AVG_VARIANCE=.25,e.MAX_INDIVIDUAL_VARIANCE=.7,e.CODE_SHIFT=98,e.CODE_CODE_C=99,e.CODE_CODE_B=100,e.CODE_CODE_A=101,e.CODE_FNC_1=102,e.CODE_FNC_2=97,e.CODE_FNC_3=96,e.CODE_FNC_4_A=101,e.CODE_FNC_4_B=100,e.CODE_START_A=103,e.CODE_START_B=104,e.CODE_START_C=105,e.CODE_STOP=106,e}(Lt),xt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Vt=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Ut=function(t){function e(e,r){void 0===e&&(e=!1),void 0===r&&(r=!1);var n=t.call(this)||this;return n.usingCheckDigit=e,n.extendedMode=r,n.decodeRowResult="",n.counters=new Int32Array(9),n}return xt(e,t),e.prototype.decodeRow=function(t,r,n){var o,i,a,u,s=this.counters;s.fill(0),this.decodeRowResult="";var c,f,h=e.findAsteriskPattern(r,s),l=r.getNextSet(h[1]),d=r.getSize();do{e.recordPattern(r,l,s);var p=e.toNarrowWidePattern(s);if(p<0)throw new U;c=e.patternToChar(p),this.decodeRowResult+=c,f=l;try{for(var y=(o=void 0,Vt(s)),w=y.next();!w.done;w=y.next()){l+=w.value}}catch(t){o={error:t}}finally{try{w&&!w.done&&(i=y.return)&&i.call(y)}finally{if(o)throw o.error}}l=r.getNextSet(l)}while("*"!==c);this.decodeRowResult=this.decodeRowResult.substring(0,this.decodeRowResult.length-1);var _,v=0;try{for(var m=Vt(s),A=m.next();!A.done;A=m.next()){v+=A.value}}catch(t){a={error:t}}finally{try{A&&!A.done&&(u=m.return)&&u.call(m)}finally{if(a)throw a.error}}if(l!==d&&2*(l-f-v)<v)throw new U;if(this.usingCheckDigit){for(var E=this.decodeRowResult.length-1,C=0,I=0;I<E;I++)C+=e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(I));if(this.decodeRowResult.charAt(E)!==e.ALPHABET_STRING.charAt(C%43))throw new g;this.decodeRowResult=this.decodeRowResult.substring(0,E)}if(0===this.decodeRowResult.length)throw new U;_=this.extendedMode?e.decodeExtended(this.decodeRowResult):this.decodeRowResult;var S=(h[1]+h[0])/2,O=f+v/2;return new et(_,null,0,[new At(S,t),new At(O,t)],nt.CODE_39,(new Date).getTime())},e.findAsteriskPattern=function(t,r){for(var n=t.getSize(),o=t.getNextSet(0),i=0,a=o,u=!1,s=r.length,c=o;c<n;c++)if(t.get(c)!==u)r[i]++;else{if(i===s-1){if(this.toNarrowWidePattern(r)===e.ASTERISK_ENCODING&&t.isRange(Math.max(0,a-Math.floor((c-a)/2)),a,!1))return[a,c];a+=r[0]+r[1],r.copyWithin(0,2,2+i-1),r[i-1]=0,r[i]=0,i--}else i++;r[i]=1,u=!u}throw new U},e.toNarrowWidePattern=function(t){var e,r,n,o=t.length,i=0;do{var a=2147483647;try{for(var u=(e=void 0,Vt(t)),s=u.next();!s.done;s=u.next()){(l=s.value)<a&&l>i&&(a=l)}}catch(t){e={error:t}}finally{try{s&&!s.done&&(r=u.return)&&r.call(u)}finally{if(e)throw e.error}}i=a,n=0;for(var c=0,f=0,h=0;h<o;h++){(l=t[h])>i&&(f|=1<<o-1-h,n++,c+=l)}if(3===n){for(h=0;h<o&&n>0;h++){var l;if((l=t[h])>i&&(n--,2*l>=c))return-1}return f}}while(n>3);return-1},e.patternToChar=function(t){for(var r=0;r<e.CHARACTER_ENCODINGS.length;r++)if(e.CHARACTER_ENCODINGS[r]===t)return e.ALPHABET_STRING.charAt(r);if(t===e.ASTERISK_ENCODING)return"*";throw new U},e.decodeExtended=function(t){for(var e=t.length,r="",n=0;n<e;n++){var o=t.charAt(n);if("+"===o||"$"===o||"%"===o||"/"===o){var i=t.charAt(n+1),a="\0";switch(o){case"+":if(!(i>="A"&&i<="Z"))throw new R;a=String.fromCharCode(i.charCodeAt(0)+32);break;case"$":if(!(i>="A"&&i<="Z"))throw new R;a=String.fromCharCode(i.charCodeAt(0)-64);break;case"%":if(i>="A"&&i<="E")a=String.fromCharCode(i.charCodeAt(0)-38);else if(i>="F"&&i<="J")a=String.fromCharCode(i.charCodeAt(0)-11);else if(i>="K"&&i<="O")a=String.fromCharCode(i.charCodeAt(0)+16);else if(i>="P"&&i<="T")a=String.fromCharCode(i.charCodeAt(0)+43);else if("U"===i)a="\0";else if("V"===i)a="@";else if("W"===i)a="`";else{if("X"!==i&&"Y"!==i&&"Z"!==i)throw new R;a=""}break;case"/":if(i>="A"&&i<="O")a=String.fromCharCode(i.charCodeAt(0)-32);else{if("Z"!==i)throw new R;a=":"}}r+=a,n++}else r+=o}return r},e.ALPHABET_STRING="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%",e.CHARACTER_ENCODINGS=[52,289,97,352,49,304,112,37,292,100,265,73,328,25,280,88,13,268,76,28,259,67,322,19,274,82,7,262,70,22,385,193,448,145,400,208,133,388,196,168,162,138,42],e.ASTERISK_ENCODING=148,e}(Lt),Ht=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Gt=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Xt=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.narrowLineWidth=-1,e}return Ht(e,t),e.prototype.decodeRow=function(t,r,n){var o,i,a=this.decodeStart(r),u=this.decodeEnd(r),s=new k;e.decodeMiddle(r,a[1],u[0],s);var c=s.toString(),f=null;null!=n&&(f=n.get(T.ALLOWED_LENGTHS)),null==f&&(f=e.DEFAULT_ALLOWED_LENGTHS);var h=c.length,l=!1,d=0;try{for(var p=Gt(f),g=p.next();!g.done;g=p.next()){var y=g.value;if(h===y){l=!0;break}y>d&&(d=y)}}catch(t){o={error:t}}finally{try{g&&!g.done&&(i=p.return)&&i.call(p)}finally{if(o)throw o.error}}if(!l&&h>d&&(l=!0),!l)throw new R;var w=[new At(a[1],t),new At(u[0],t)];return new et(c,null,0,w,nt.ITF,(new Date).getTime())},e.decodeMiddle=function(t,r,n,o){var i=new Int32Array(10),a=new Int32Array(5),u=new Int32Array(5);for(i.fill(0),a.fill(0),u.fill(0);r<n;){Lt.recordPattern(t,r,i);for(var s=0;s<5;s++){var c=2*s;a[s]=i[c],u[s]=i[c+1]}var f=e.decodeDigit(a);o.append(f.toString()),f=this.decodeDigit(u),o.append(f.toString()),i.forEach((function(t){r+=t}))}},e.prototype.decodeStart=function(t){var r=e.skipWhiteSpace(t),n=e.findGuardPattern(t,r,e.START_PATTERN);return this.narrowLineWidth=(n[1]-n[0])/4,this.validateQuietZone(t,n[0]),n},e.prototype.validateQuietZone=function(t,e){var r=10*this.narrowLineWidth;r=r<e?r:e;for(var n=e-1;r>0&&n>=0&&!t.get(n);n--)r--;if(0!==r)throw new U},e.skipWhiteSpace=function(t){var e=t.getSize(),r=t.getNextSet(0);if(r===e)throw new U;return r},e.prototype.decodeEnd=function(t){t.reverse();try{var r=e.skipWhiteSpace(t),n=void 0;try{n=e.findGuardPattern(t,r,e.END_PATTERN_REVERSED[0])}catch(o){o instanceof U&&(n=e.findGuardPattern(t,r,e.END_PATTERN_REVERSED[1]))}this.validateQuietZone(t,n[0]);var o=n[0];return n[0]=t.getSize()-n[1],n[1]=t.getSize()-o,n}finally{t.reverse()}},e.findGuardPattern=function(t,r,n){var o=n.length,i=new Int32Array(o),a=t.getSize(),u=!1,s=0,c=r;i.fill(0);for(var f=r;f<a;f++)if(t.get(f)!==u)i[s]++;else{if(s===o-1){if(Lt.patternMatchVariance(i,n,e.MAX_INDIVIDUAL_VARIANCE)<e.MAX_AVG_VARIANCE)return[c,f];c+=i[0]+i[1],w.arraycopy(i,2,i,0,s-1),i[s-1]=0,i[s]=0,s--}else s++;i[s]=1,u=!u}throw new U},e.decodeDigit=function(t){for(var r=e.MAX_AVG_VARIANCE,n=-1,o=e.PATTERNS.length,i=0;i<o;i++){var a=e.PATTERNS[i],u=Lt.patternMatchVariance(t,a,e.MAX_INDIVIDUAL_VARIANCE);u<r?(r=u,n=i):u===r&&(n=-1)}if(n>=0)return n%10;throw new U},e.PATTERNS=[Int32Array.from([1,1,2,2,1]),Int32Array.from([2,1,1,1,2]),Int32Array.from([1,2,1,1,2]),Int32Array.from([2,2,1,1,1]),Int32Array.from([1,1,2,1,2]),Int32Array.from([2,1,2,1,1]),Int32Array.from([1,2,2,1,1]),Int32Array.from([1,1,1,2,2]),Int32Array.from([2,1,1,2,1]),Int32Array.from([1,2,1,2,1]),Int32Array.from([1,1,3,3,1]),Int32Array.from([3,1,1,1,3]),Int32Array.from([1,3,1,1,3]),Int32Array.from([3,3,1,1,1]),Int32Array.from([1,1,3,1,3]),Int32Array.from([3,1,3,1,1]),Int32Array.from([1,3,3,1,1]),Int32Array.from([1,1,1,3,3]),Int32Array.from([3,1,1,3,1]),Int32Array.from([1,3,1,3,1])],e.MAX_AVG_VARIANCE=.38,e.MAX_INDIVIDUAL_VARIANCE=.5,e.DEFAULT_ALLOWED_LENGTHS=[6,8,10,12,14],e.START_PATTERN=Int32Array.from([1,1,1,1]),e.END_PATTERN_REVERSED=[Int32Array.from([1,1,2]),Int32Array.from([1,1,3])],e}(Lt),Wt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),jt=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.decodeRowStringBuffer="",e}return Wt(e,t),e.findStartGuardPattern=function(t){for(var r,n=!1,o=0,i=Int32Array.from([0,0,0]);!n;){i=Int32Array.from([0,0,0]);var a=(r=e.findGuardPattern(t,o,!1,this.START_END_PATTERN,i))[0],u=a-((o=r[1])-a);u>=0&&(n=t.isRange(u,a,!1))}return r},e.checkChecksum=function(t){return e.checkStandardUPCEANChecksum(t)},e.checkStandardUPCEANChecksum=function(t){var r=t.length;if(0===r)return!1;var n=parseInt(t.charAt(r-1),10);return e.getStandardUPCEANChecksum(t.substring(0,r-1))===n},e.getStandardUPCEANChecksum=function(t){for(var e=t.length,r=0,n=e-1;n>=0;n-=2){if((o=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0))<0||o>9)throw new R;r+=o}r*=3;for(n=e-2;n>=0;n-=2){var o;if((o=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0))<0||o>9)throw new R;r+=o}return(1e3-r)%10},e.decodeEnd=function(t,r){return e.findGuardPattern(t,r,!1,e.START_END_PATTERN,new Int32Array(e.START_END_PATTERN.length).fill(0))},e.findGuardPatternWithoutCounters=function(t,e,r,n){return this.findGuardPattern(t,e,r,n,new Int32Array(n.length))},e.findGuardPattern=function(t,r,n,o,i){for(var a=t.getSize(),u=0,s=r=n?t.getNextUnset(r):t.getNextSet(r),c=o.length,f=n,h=r;h<a;h++)if(t.get(h)!==f)i[u]++;else{if(u===c-1){if(Lt.patternMatchVariance(i,o,e.MAX_INDIVIDUAL_VARIANCE)<e.MAX_AVG_VARIANCE)return Int32Array.from([s,h]);s+=i[0]+i[1];for(var l=i.slice(2,i.length-1),d=0;d<u-1;d++)i[d]=l[d];i[u-1]=0,i[u]=0,u--}else u++;i[u]=1,f=!f}throw new U},e.decodeDigit=function(t,r,n,o){this.recordPattern(t,n,r);for(var i=this.MAX_AVG_VARIANCE,a=-1,u=o.length,s=0;s<u;s++){var c=o[s],f=Lt.patternMatchVariance(r,c,e.MAX_INDIVIDUAL_VARIANCE);f<i&&(i=f,a=s)}if(a>=0)return a;throw new U},e.MAX_AVG_VARIANCE=.48,e.MAX_INDIVIDUAL_VARIANCE=.7,e.START_END_PATTERN=Int32Array.from([1,1,1]),e.MIDDLE_PATTERN=Int32Array.from([1,1,1,1,1]),e.END_PATTERN=Int32Array.from([1,1,1,1,1,1]),e.L_PATTERNS=[Int32Array.from([3,2,1,1]),Int32Array.from([2,2,2,1]),Int32Array.from([2,1,2,2]),Int32Array.from([1,4,1,1]),Int32Array.from([1,1,3,2]),Int32Array.from([1,2,3,1]),Int32Array.from([1,1,1,4]),Int32Array.from([1,3,1,2]),Int32Array.from([1,2,1,3]),Int32Array.from([3,1,1,2])],e}(Lt),zt=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Yt=function(){function t(){this.CHECK_DIGIT_ENCODINGS=[24,20,18,17,12,6,3,10,9,5],this.decodeMiddleCounters=Int32Array.from([0,0,0,0]),this.decodeRowStringBuffer=""}return t.prototype.decodeRow=function(e,r,n){var o=this.decodeRowStringBuffer,i=this.decodeMiddle(r,n,o),a=o.toString(),u=t.parseExtensionString(a),s=[new At((n[0]+n[1])/2,e),new At(i,e)],c=new et(a,null,0,s,nt.UPC_EAN_EXTENSION,(new Date).getTime());return null!=u&&c.putAllMetadata(u),c},t.prototype.decodeMiddle=function(e,r,n){var o,i,a=this.decodeMiddleCounters;a[0]=0,a[1]=0,a[2]=0,a[3]=0;for(var u=e.getSize(),s=r[1],c=0,f=0;f<5&&s<u;f++){var h=jt.decodeDigit(e,a,s,jt.L_AND_G_PATTERNS);n+=String.fromCharCode("0".charCodeAt(0)+h%10);try{for(var l=(o=void 0,zt(a)),d=l.next();!d.done;d=l.next()){s+=d.value}}catch(t){o={error:t}}finally{try{d&&!d.done&&(i=l.return)&&i.call(l)}finally{if(o)throw o.error}}h>=10&&(c|=1<<4-f),4!==f&&(s=e.getNextSet(s),s=e.getNextUnset(s))}if(5!==n.length)throw new U;var p=this.determineCheckDigit(c);if(t.extensionChecksum(n.toString())!==p)throw new U;return s},t.extensionChecksum=function(t){for(var e=t.length,r=0,n=e-2;n>=0;n-=2)r+=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0);r*=3;for(n=e-1;n>=0;n-=2)r+=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0);return(r*=3)%10},t.prototype.determineCheckDigit=function(t){for(var e=0;e<10;e++)if(t===this.CHECK_DIGIT_ENCODINGS[e])return e;throw new U},t.parseExtensionString=function(e){if(5!==e.length)return null;var r=t.parseExtension5String(e);return null==r?null:new Map([[it.SUGGESTED_PRICE,r]])},t.parseExtension5String=function(t){var e;switch(t.charAt(0)){case"0":e="£";break;case"5":e="$";break;case"9":switch(t){case"90000":return null;case"99991":return"0.00";case"99990":return"Used"}e="";break;default:e=""}var r=parseInt(t.substring(1)),n=r%100;return e+(r/100).toString()+"."+(n<10?"0"+n:n.toString())},t}(),Zt=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Kt=function(){function t(){this.decodeMiddleCounters=Int32Array.from([0,0,0,0]),this.decodeRowStringBuffer=""}return t.prototype.decodeRow=function(e,r,n){var o=this.decodeRowStringBuffer,i=this.decodeMiddle(r,n,o),a=o.toString(),u=t.parseExtensionString(a),s=[new At((n[0]+n[1])/2,e),new At(i,e)],c=new et(a,null,0,s,nt.UPC_EAN_EXTENSION,(new Date).getTime());return null!=u&&c.putAllMetadata(u),c},t.prototype.decodeMiddle=function(t,e,r){var n,o,i=this.decodeMiddleCounters;i[0]=0,i[1]=0,i[2]=0,i[3]=0;for(var a=t.getSize(),u=e[1],s=0,c=0;c<2&&u<a;c++){var f=jt.decodeDigit(t,i,u,jt.L_AND_G_PATTERNS);r+=String.fromCharCode("0".charCodeAt(0)+f%10);try{for(var h=(n=void 0,Zt(i)),l=h.next();!l.done;l=h.next()){u+=l.value}}catch(t){n={error:t}}finally{try{l&&!l.done&&(o=h.return)&&o.call(h)}finally{if(n)throw n.error}}f>=10&&(s|=1<<1-c),1!==c&&(u=t.getNextSet(u),u=t.getNextUnset(u))}if(2!==r.length)throw new U;if(parseInt(r.toString())%4!==s)throw new U;return u},t.parseExtensionString=function(t){return 2!==t.length?null:new Map([[it.ISSUE_NUMBER,parseInt(t)]])},t}(),qt=function(){function t(){}return t.decodeRow=function(t,e,r){var n=jt.findGuardPattern(e,r,!1,this.EXTENSION_START_PATTERN,new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));try{return(new Yt).decodeRow(t,e,n)}catch(r){return(new Kt).decodeRow(t,e,n)}},t.EXTENSION_START_PATTERN=Int32Array.from([1,1,2]),t}(),Qt=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Jt=function(t){function e(){var r=t.call(this)||this;r.decodeRowStringBuffer="",e.L_AND_G_PATTERNS=e.L_PATTERNS.map((function(t){return Int32Array.from(t)}));for(var n=10;n<20;n++){for(var o=e.L_PATTERNS[n-10],i=new Int32Array(o.length),a=0;a<o.length;a++)i[a]=o[o.length-a-1];e.L_AND_G_PATTERNS[n]=i}return r}return Qt(e,t),e.prototype.decodeRow=function(t,r,n){var o=e.findStartGuardPattern(r),i=null==n?null:n.get(T.NEED_RESULT_POINT_CALLBACK);if(null!=i){var a=new At((o[0]+o[1])/2,t);i.foundPossibleResultPoint(a)}var u=this.decodeMiddle(r,o,this.decodeRowStringBuffer),s=u.rowOffset,c=u.resultString;if(null!=i){var f=new At(s,t);i.foundPossibleResultPoint(f)}var h=e.decodeEnd(r,s);if(null!=i){var l=new At((h[0]+h[1])/2,t);i.foundPossibleResultPoint(l)}var d=h[1],p=d+(d-h[0]);if(p>=r.getSize()||!r.isRange(d,p,!1))throw new U;var y=c.toString();if(y.length<8)throw new R;if(!e.checkChecksum(y))throw new g;var w=(o[1]+o[0])/2,_=(h[1]+h[0])/2,v=this.getBarcodeFormat(),m=[new At(w,t),new At(_,t)],A=new et(y,null,0,m,v,(new Date).getTime()),E=0;try{var C=qt.decodeRow(t,r,h[1]);A.putMetadata(it.UPC_EAN_EXTENSION,C.getText()),A.putAllMetadata(C.getResultMetadata()),A.addResultPoints(C.getResultPoints()),E=C.getText().length}catch(t){}var I=null==n?null:n.get(T.ALLOWED_EAN_EXTENSIONS);if(null!=I){var S=!1;for(var O in I)if(E.toString()===O){S=!0;break}if(!S)throw new U}return v===nt.EAN_13||nt.UPC_A,A},e.checkChecksum=function(t){return e.checkStandardUPCEANChecksum(t)},e.checkStandardUPCEANChecksum=function(t){var r=t.length;if(0===r)return!1;var n=parseInt(t.charAt(r-1),10);return e.getStandardUPCEANChecksum(t.substring(0,r-1))===n},e.getStandardUPCEANChecksum=function(t){for(var e=t.length,r=0,n=e-1;n>=0;n-=2){if((o=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0))<0||o>9)throw new R;r+=o}r*=3;for(n=e-2;n>=0;n-=2){var o;if((o=t.charAt(n).charCodeAt(0)-"0".charCodeAt(0))<0||o>9)throw new R;r+=o}return(1e3-r)%10},e.decodeEnd=function(t,r){return e.findGuardPattern(t,r,!1,e.START_END_PATTERN,new Int32Array(e.START_END_PATTERN.length).fill(0))},e}(jt),$t=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),te=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},ee=function(t){function e(){var e=t.call(this)||this;return e.decodeMiddleCounters=Int32Array.from([0,0,0,0]),e}return $t(e,t),e.prototype.decodeMiddle=function(t,r,n){var o,i,a,u,s=this.decodeMiddleCounters;s[0]=0,s[1]=0,s[2]=0,s[3]=0;for(var c=t.getSize(),f=r[1],h=0,l=0;l<6&&f<c;l++){var d=Jt.decodeDigit(t,s,f,Jt.L_AND_G_PATTERNS);n+=String.fromCharCode("0".charCodeAt(0)+d%10);try{for(var p=(o=void 0,te(s)),g=p.next();!g.done;g=p.next()){f+=g.value}}catch(t){o={error:t}}finally{try{g&&!g.done&&(i=p.return)&&i.call(p)}finally{if(o)throw o.error}}d>=10&&(h|=1<<5-l)}n=e.determineFirstDigit(n,h),f=Jt.findGuardPattern(t,f,!0,Jt.MIDDLE_PATTERN,new Int32Array(Jt.MIDDLE_PATTERN.length).fill(0))[1];for(l=0;l<6&&f<c;l++){d=Jt.decodeDigit(t,s,f,Jt.L_PATTERNS);n+=String.fromCharCode("0".charCodeAt(0)+d);try{for(var y=(a=void 0,te(s)),w=y.next();!w.done;w=y.next()){f+=w.value}}catch(t){a={error:t}}finally{try{w&&!w.done&&(u=y.return)&&u.call(y)}finally{if(a)throw a.error}}}return{rowOffset:f,resultString:n}},e.prototype.getBarcodeFormat=function(){return nt.EAN_13},e.determineFirstDigit=function(t,e){for(var r=0;r<10;r++)if(e===this.FIRST_DIGIT_ENCODINGS[r])return t=String.fromCharCode("0".charCodeAt(0)+r)+t;throw new U},e.FIRST_DIGIT_ENCODINGS=[0,11,13,14,19,25,28,21,22,26],e}(Jt),re=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ne=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},oe=function(t){function e(){var e=t.call(this)||this;return e.decodeMiddleCounters=Int32Array.from([0,0,0,0]),e}return re(e,t),e.prototype.decodeMiddle=function(t,e,r){var n,o,i,a,u=this.decodeMiddleCounters;u[0]=0,u[1]=0,u[2]=0,u[3]=0;for(var s=t.getSize(),c=e[1],f=0;f<4&&c<s;f++){var h=Jt.decodeDigit(t,u,c,Jt.L_PATTERNS);r+=String.fromCharCode("0".charCodeAt(0)+h);try{for(var l=(n=void 0,ne(u)),d=l.next();!d.done;d=l.next()){c+=d.value}}catch(t){n={error:t}}finally{try{d&&!d.done&&(o=l.return)&&o.call(l)}finally{if(n)throw n.error}}}c=Jt.findGuardPattern(t,c,!0,Jt.MIDDLE_PATTERN,new Int32Array(Jt.MIDDLE_PATTERN.length).fill(0))[1];for(f=0;f<4&&c<s;f++){h=Jt.decodeDigit(t,u,c,Jt.L_PATTERNS);r+=String.fromCharCode("0".charCodeAt(0)+h);try{for(var p=(i=void 0,ne(u)),g=p.next();!g.done;g=p.next()){c+=g.value}}catch(t){i={error:t}}finally{try{g&&!g.done&&(a=p.return)&&a.call(p)}finally{if(i)throw i.error}}}return{rowOffset:c,resultString:r}},e.prototype.getBarcodeFormat=function(){return nt.EAN_8},e}(Jt),ie=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ae=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ean13Reader=new ee,e}return ie(e,t),e.prototype.getBarcodeFormat=function(){return nt.UPC_A},e.prototype.decode=function(t,e){return this.maybeReturnResult(this.ean13Reader.decode(t))},e.prototype.decodeRow=function(t,e,r){return this.maybeReturnResult(this.ean13Reader.decodeRow(t,e,r))},e.prototype.decodeMiddle=function(t,e,r){return this.ean13Reader.decodeMiddle(t,e,r)},e.prototype.maybeReturnResult=function(t){var e=t.getText();if("0"===e.charAt(0)){var r=new et(e.substring(1),null,null,t.getResultPoints(),nt.UPC_A);return null!=t.getResultMetadata()&&r.putAllMetadata(t.getResultMetadata()),r}throw new U},e.prototype.reset=function(){this.ean13Reader.reset()},e}(Jt),ue=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),se=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},ce=function(t){function e(){var e=t.call(this)||this;return e.decodeMiddleCounters=new Int32Array(4),e}return ue(e,t),e.prototype.decodeMiddle=function(t,r,n){var o,i,a=this.decodeMiddleCounters.map((function(t){return t}));a[0]=0,a[1]=0,a[2]=0,a[3]=0;for(var u=t.getSize(),s=r[1],c=0,f=0;f<6&&s<u;f++){var h=e.decodeDigit(t,a,s,e.L_AND_G_PATTERNS);n+=String.fromCharCode("0".charCodeAt(0)+h%10);try{for(var l=(o=void 0,se(a)),d=l.next();!d.done;d=l.next()){s+=d.value}}catch(t){o={error:t}}finally{try{d&&!d.done&&(i=l.return)&&i.call(l)}finally{if(o)throw o.error}}h>=10&&(c|=1<<5-f)}return e.determineNumSysAndCheckDigit(new k(n),c),s},e.prototype.decodeEnd=function(t,r){return e.findGuardPatternWithoutCounters(t,r,!0,e.MIDDLE_END_PATTERN)},e.prototype.checkChecksum=function(t){return Jt.checkChecksum(e.convertUPCEtoUPCA(t))},e.determineNumSysAndCheckDigit=function(t,e){for(var r=0;r<=1;r++)for(var n=0;n<10;n++)if(e===this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n])return t.insert(0,"0"+r),void t.append("0"+n);throw U.getNotFoundInstance()},e.prototype.getBarcodeFormat=function(){return nt.UPC_E},e.convertUPCEtoUPCA=function(t){var e=t.slice(1,7).split("").map((function(t){return t.charCodeAt(0)})),r=new k;r.append(t.charAt(0));var n=e[5];switch(n){case 0:case 1:case 2:r.appendChars(e,0,2),r.append(n),r.append("0000"),r.appendChars(e,2,3);break;case 3:r.appendChars(e,0,3),r.append("00000"),r.appendChars(e,3,2);break;case 4:r.appendChars(e,0,4),r.append("00000"),r.append(e[4]);break;default:r.appendChars(e,0,5),r.append("0000"),r.append(n)}return t.length>=8&&r.append(t.charAt(7)),r.toString()},e.MIDDLE_END_PATTERN=Int32Array.from([1,1,1,1,1,1]),e.NUMSYS_AND_CHECK_DIGIT_PATTERNS=[Int32Array.from([56,52,50,49,44,38,35,42,41,37]),Int32Array.from([7,11,13,14,19,25,28,21,22,1])],e}(Jt),fe=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),he=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},le=function(t){function e(e){var r=t.call(this)||this,n=null==e?null:e.get(T.POSSIBLE_FORMATS),o=[];return null!=n&&(n.indexOf(nt.EAN_13)>-1?o.push(new ee):n.indexOf(nt.UPC_A)>-1&&o.push(new ae),n.indexOf(nt.EAN_8)>-1&&o.push(new oe),n.indexOf(nt.UPC_E)>-1&&o.push(new ce)),0===o.length&&(o.push(new ee),o.push(new oe),o.push(new ce)),r.readers=o,r}return fe(e,t),e.prototype.decodeRow=function(t,e,r){var n,o;try{for(var i=he(this.readers),a=i.next();!a.done;a=i.next()){var u=a.value;try{var s=u.decodeRow(t,e,r),c=s.getBarcodeFormat()===nt.EAN_13&&"0"===s.getText().charAt(0),f=null==r?null:r.get(T.POSSIBLE_FORMATS),h=null==f||f.includes(nt.UPC_A);if(c&&h){var l=s.getRawBytes(),d=new et(s.getText().substring(1),l,l.length,s.getResultPoints(),nt.UPC_A);return d.putAllMetadata(s.getResultMetadata()),d}return s}catch(t){}}}catch(t){n={error:t}}finally{try{a&&!a.done&&(o=i.return)&&o.call(i)}finally{if(n)throw n.error}}throw new U},e.prototype.reset=function(){var t,e;try{for(var r=he(this.readers),n=r.next();!n.done;n=r.next()){n.value.reset()}}catch(e){t={error:e}}finally{try{n&&!n.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}},e}(Lt),de=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),pe=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},ge=function(t){function e(){var e=t.call(this)||this;return e.decodeFinderCounters=new Int32Array(4),e.dataCharacterCounters=new Int32Array(8),e.oddRoundingErrors=new Array(4),e.evenRoundingErrors=new Array(4),e.oddCounts=new Array(e.dataCharacterCounters.length/2),e.evenCounts=new Array(e.dataCharacterCounters.length/2),e}return de(e,t),e.prototype.getDecodeFinderCounters=function(){return this.decodeFinderCounters},e.prototype.getDataCharacterCounters=function(){return this.dataCharacterCounters},e.prototype.getOddRoundingErrors=function(){return this.oddRoundingErrors},e.prototype.getEvenRoundingErrors=function(){return this.evenRoundingErrors},e.prototype.getOddCounts=function(){return this.oddCounts},e.prototype.getEvenCounts=function(){return this.evenCounts},e.prototype.parseFinderValue=function(t,r){for(var n=0;n<r.length;n++)if(Lt.patternMatchVariance(t,r[n],e.MAX_INDIVIDUAL_VARIANCE)<e.MAX_AVG_VARIANCE)return n;throw new U},e.count=function(t){return vt.sum(new Int32Array(t))},e.increment=function(t,e){for(var r=0,n=e[0],o=1;o<t.length;o++)e[o]>n&&(n=e[o],r=o);t[r]++},e.decrement=function(t,e){for(var r=0,n=e[0],o=1;o<t.length;o++)e[o]<n&&(n=e[o],r=o);t[r]--},e.isFinderPattern=function(t){var r,n,o=t[0]+t[1],i=o/(o+t[2]+t[3]);if(i>=e.MIN_FINDER_PATTERN_RATIO&&i<=e.MAX_FINDER_PATTERN_RATIO){var a=Number.MAX_SAFE_INTEGER,u=Number.MIN_SAFE_INTEGER;try{for(var s=pe(t),c=s.next();!c.done;c=s.next()){var f=c.value;f>u&&(u=f),f<a&&(a=f)}}catch(t){r={error:t}}finally{try{c&&!c.done&&(n=s.return)&&n.call(s)}finally{if(r)throw r.error}}return u<10*a}return!1},e.MAX_AVG_VARIANCE=.2,e.MAX_INDIVIDUAL_VARIANCE=.45,e.MIN_FINDER_PATTERN_RATIO=9.5/12,e.MAX_FINDER_PATTERN_RATIO=12.5/14,e}(Lt),ye=function(){function t(t,e){this.value=t,this.checksumPortion=e}return t.prototype.getValue=function(){return this.value},t.prototype.getChecksumPortion=function(){return this.checksumPortion},t.prototype.toString=function(){return this.value+"("+this.checksumPortion+")"},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.value===r.value&&this.checksumPortion===r.checksumPortion},t.prototype.hashCode=function(){return this.value^this.checksumPortion},t}(),we=function(){function t(t,e,r,n,o){this.value=t,this.startEnd=e,this.value=t,this.startEnd=e,this.resultPoints=new Array,this.resultPoints.push(new At(r,o)),this.resultPoints.push(new At(n,o))}return t.prototype.getValue=function(){return this.value},t.prototype.getStartEnd=function(){return this.startEnd},t.prototype.getResultPoints=function(){return this.resultPoints},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.value===r.value},t.prototype.hashCode=function(){return this.value},t}(),_e=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},ve=function(){function t(){}return t.getRSSvalue=function(e,r,n){var o,i,a=0;try{for(var u=_e(e),s=u.next();!s.done;s=u.next()){a+=s.value}}catch(t){o={error:t}}finally{try{s&&!s.done&&(i=u.return)&&i.call(u)}finally{if(o)throw o.error}}for(var c=0,f=0,h=e.length,l=0;l<h-1;l++){var d=void 0;for(d=1,f|=1<<l;d<e[l];d++,f&=~(1<<l)){var p=t.combins(a-d-1,h-l-2);if(n&&0===f&&a-d-(h-l-1)>=h-l-1&&(p-=t.combins(a-d-(h-l),h-l-2)),h-l-1>1){for(var g=0,y=a-d-(h-l-2);y>r;y--)g+=t.combins(a-d-y-1,h-l-3);p-=g*(h-1-l)}else a-d>r&&p--;c+=p}a-=d}return c},t.combins=function(t,e){var r,n;t-e>e?(n=e,r=t-e):(n=t-e,r=e);for(var o=1,i=1,a=t;a>r;a--)o*=a,i<=n&&(o/=i,i++);for(;i<=n;)o/=i,i++;return o},t}(),me=function(){function t(){}return t.buildBitArray=function(t){var e=2*t.length-1;null==t[t.length-1].getRightChar()&&(e-=1);for(var r=new S(12*e),n=0,o=t[0].getRightChar().getValue(),i=11;i>=0;--i)0!=(o&1<<i)&&r.set(n),n++;for(i=1;i<t.length;++i){for(var a=t[i],u=a.getLeftChar().getValue(),s=11;s>=0;--s)0!=(u&1<<s)&&r.set(n),n++;if(null!=a.getRightChar()){var c=a.getRightChar().getValue();for(s=11;s>=0;--s)0!=(c&1<<s)&&r.set(n),n++}}return r},t}(),Ae=function(){function t(t,e){e?this.decodedInformation=null:(this.finished=t,this.decodedInformation=e)}return t.prototype.getDecodedInformation=function(){return this.decodedInformation},t.prototype.isFinished=function(){return this.finished},t}(),Ee=function(){function t(t){this.newPosition=t}return t.prototype.getNewPosition=function(){return this.newPosition},t}(),Ce=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ie=function(t){function e(e,r){var n=t.call(this,e)||this;return n.value=r,n}return Ce(e,t),e.prototype.getValue=function(){return this.value},e.prototype.isFNC1=function(){return this.value===e.FNC1},e.FNC1="$",e}(Ee),Se=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Oe=function(t){function e(e,r,n){var o=t.call(this,e)||this;return n?(o.remaining=!0,o.remainingValue=o.remainingValue):(o.remaining=!1,o.remainingValue=0),o.newString=r,o}return Se(e,t),e.prototype.getNewString=function(){return this.newString},e.prototype.isRemaining=function(){return this.remaining},e.prototype.getRemainingValue=function(){return this.remainingValue},e}(Ee),Te=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),be=function(t){function e(e,r,n){var o=t.call(this,e)||this;if(r<0||r>10||n<0||n>10)throw new R;return o.firstDigit=r,o.secondDigit=n,o}return Te(e,t),e.prototype.getFirstDigit=function(){return this.firstDigit},e.prototype.getSecondDigit=function(){return this.secondDigit},e.prototype.getValue=function(){return 10*this.firstDigit+this.secondDigit},e.prototype.isFirstDigitFNC1=function(){return this.firstDigit===e.FNC1},e.prototype.isSecondDigitFNC1=function(){return this.secondDigit===e.FNC1},e.prototype.isAnyFNC1=function(){return this.firstDigit===e.FNC1||this.secondDigit===e.FNC1},e.FNC1=10,e}(Ee),Re=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Ne=function(){function t(){}return t.parseFieldsInGeneralPurpose=function(e){var r,n,o,i,a,u,s,c;if(!e)return null;if(e.length<2)throw new U;var f=e.substring(0,2);try{for(var h=Re(t.TWO_DIGIT_DATA_LENGTH),l=h.next();!l.done;l=h.next()){if((A=l.value)[0]===f)return A[1]===t.VARIABLE_LENGTH?t.processVariableAI(2,A[2],e):t.processFixedAI(2,A[1],e)}}catch(t){r={error:t}}finally{try{l&&!l.done&&(n=h.return)&&n.call(h)}finally{if(r)throw r.error}}if(e.length<3)throw new U;var d=e.substring(0,3);try{for(var p=Re(t.THREE_DIGIT_DATA_LENGTH),g=p.next();!g.done;g=p.next()){if((A=g.value)[0]===d)return A[1]===t.VARIABLE_LENGTH?t.processVariableAI(3,A[2],e):t.processFixedAI(3,A[1],e)}}catch(t){o={error:t}}finally{try{g&&!g.done&&(i=p.return)&&i.call(p)}finally{if(o)throw o.error}}try{for(var y=Re(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH),w=y.next();!w.done;w=y.next()){if((A=w.value)[0]===d)return A[1]===t.VARIABLE_LENGTH?t.processVariableAI(4,A[2],e):t.processFixedAI(4,A[1],e)}}catch(t){a={error:t}}finally{try{w&&!w.done&&(u=y.return)&&u.call(y)}finally{if(a)throw a.error}}if(e.length<4)throw new U;var _=e.substring(0,4);try{for(var v=Re(t.FOUR_DIGIT_DATA_LENGTH),m=v.next();!m.done;m=v.next()){var A;if((A=m.value)[0]===_)return A[1]===t.VARIABLE_LENGTH?t.processVariableAI(4,A[2],e):t.processFixedAI(4,A[1],e)}}catch(t){s={error:t}}finally{try{m&&!m.done&&(c=v.return)&&c.call(v)}finally{if(s)throw s.error}}throw new U},t.processFixedAI=function(e,r,n){if(n.length<e)throw new U;var o=n.substring(0,e);if(n.length<e+r)throw new U;var i=n.substring(e,e+r),a=n.substring(e+r),u="("+o+")"+i,s=t.parseFieldsInGeneralPurpose(a);return null==s?u:u+s},t.processVariableAI=function(e,r,n){var o,i=n.substring(0,e);o=n.length<e+r?n.length:e+r;var a=n.substring(e,o),u=n.substring(o),s="("+i+")"+a,c=t.parseFieldsInGeneralPurpose(u);return null==c?s:s+c},t.VARIABLE_LENGTH=[],t.TWO_DIGIT_DATA_LENGTH=[["00",18],["01",14],["02",14],["10",t.VARIABLE_LENGTH,20],["11",6],["12",6],["13",6],["15",6],["17",6],["20",2],["21",t.VARIABLE_LENGTH,20],["22",t.VARIABLE_LENGTH,29],["30",t.VARIABLE_LENGTH,8],["37",t.VARIABLE_LENGTH,8],["90",t.VARIABLE_LENGTH,30],["91",t.VARIABLE_LENGTH,30],["92",t.VARIABLE_LENGTH,30],["93",t.VARIABLE_LENGTH,30],["94",t.VARIABLE_LENGTH,30],["95",t.VARIABLE_LENGTH,30],["96",t.VARIABLE_LENGTH,30],["97",t.VARIABLE_LENGTH,3],["98",t.VARIABLE_LENGTH,30],["99",t.VARIABLE_LENGTH,30]],t.THREE_DIGIT_DATA_LENGTH=[["240",t.VARIABLE_LENGTH,30],["241",t.VARIABLE_LENGTH,30],["242",t.VARIABLE_LENGTH,6],["250",t.VARIABLE_LENGTH,30],["251",t.VARIABLE_LENGTH,30],["253",t.VARIABLE_LENGTH,17],["254",t.VARIABLE_LENGTH,20],["400",t.VARIABLE_LENGTH,30],["401",t.VARIABLE_LENGTH,30],["402",17],["403",t.VARIABLE_LENGTH,30],["410",13],["411",13],["412",13],["413",13],["414",13],["420",t.VARIABLE_LENGTH,20],["421",t.VARIABLE_LENGTH,15],["422",3],["423",t.VARIABLE_LENGTH,15],["424",3],["425",3],["426",3]],t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH=[["310",6],["311",6],["312",6],["313",6],["314",6],["315",6],["316",6],["320",6],["321",6],["322",6],["323",6],["324",6],["325",6],["326",6],["327",6],["328",6],["329",6],["330",6],["331",6],["332",6],["333",6],["334",6],["335",6],["336",6],["340",6],["341",6],["342",6],["343",6],["344",6],["345",6],["346",6],["347",6],["348",6],["349",6],["350",6],["351",6],["352",6],["353",6],["354",6],["355",6],["356",6],["357",6],["360",6],["361",6],["362",6],["363",6],["364",6],["365",6],["366",6],["367",6],["368",6],["369",6],["390",t.VARIABLE_LENGTH,15],["391",t.VARIABLE_LENGTH,18],["392",t.VARIABLE_LENGTH,15],["393",t.VARIABLE_LENGTH,18],["703",t.VARIABLE_LENGTH,30]],t.FOUR_DIGIT_DATA_LENGTH=[["7001",13],["7002",t.VARIABLE_LENGTH,30],["7003",10],["8001",14],["8002",t.VARIABLE_LENGTH,20],["8003",t.VARIABLE_LENGTH,30],["8004",t.VARIABLE_LENGTH,30],["8005",6],["8006",18],["8007",t.VARIABLE_LENGTH,30],["8008",t.VARIABLE_LENGTH,12],["8018",18],["8020",t.VARIABLE_LENGTH,25],["8100",6],["8101",10],["8102",2],["8110",t.VARIABLE_LENGTH,70],["8200",t.VARIABLE_LENGTH,70]],t}(),De=function(){function t(t){this.buffer=new k,this.information=t}return t.prototype.decodeAllCodes=function(t,e){for(var r=e,n=null;;){var o=this.decodeGeneralPurposeField(r,n),i=Ne.parseFieldsInGeneralPurpose(o.getNewString());if(null!=i&&t.append(i),n=o.isRemaining()?""+o.getRemainingValue():null,r===o.getNewPosition())break;r=o.getNewPosition()}return t.toString()},t.prototype.isStillNumeric=function(t){if(t+7>this.information.getSize())return t+4<=this.information.getSize();for(var e=t;e<t+3;++e)if(this.information.get(e))return!0;return this.information.get(t+3)},t.prototype.decodeNumeric=function(t){if(t+7>this.information.getSize()){var e=this.extractNumericValueFromBitArray(t,4);return new be(this.information.getSize(),0===e?be.FNC1:e-1,be.FNC1)}var r=this.extractNumericValueFromBitArray(t,7);return new be(t+7,(r-8)/11,(r-8)%11)},t.prototype.extractNumericValueFromBitArray=function(e,r){return t.extractNumericValueFromBitArray(this.information,e,r)},t.extractNumericValueFromBitArray=function(t,e,r){for(var n=0,o=0;o<r;++o)t.get(e+o)&&(n|=1<<r-o-1);return n},t.prototype.decodeGeneralPurposeField=function(t,e){this.buffer.setLengthToZero(),null!=e&&this.buffer.append(e),this.current.setPosition(t);var r=this.parseBlocks();return null!=r&&r.isRemaining()?new Oe(this.current.getPosition(),this.buffer.toString(),r.getRemainingValue()):new Oe(this.current.getPosition(),this.buffer.toString())},t.prototype.parseBlocks=function(){var t,e;do{var r=this.current.getPosition();if(t=this.current.isAlpha()?(e=this.parseAlphaBlock()).isFinished():this.current.isIsoIec646()?(e=this.parseIsoIec646Block()).isFinished():(e=this.parseNumericBlock()).isFinished(),!(r!==this.current.getPosition())&&!t)break}while(!t);return e.getDecodedInformation()},t.prototype.parseNumericBlock=function(){for(;this.isStillNumeric(this.current.getPosition());){var t=this.decodeNumeric(this.current.getPosition());if(this.current.setPosition(t.getNewPosition()),t.isFirstDigitFNC1()){var e=void 0;return e=t.isSecondDigitFNC1()?new Oe(this.current.getPosition(),this.buffer.toString()):new Oe(this.current.getPosition(),this.buffer.toString(),t.getSecondDigit()),new Ae(!0,e)}if(this.buffer.append(t.getFirstDigit()),t.isSecondDigitFNC1()){e=new Oe(this.current.getPosition(),this.buffer.toString());return new Ae(!0,e)}this.buffer.append(t.getSecondDigit())}return this.isNumericToAlphaNumericLatch(this.current.getPosition())&&(this.current.setAlpha(),this.current.incrementPosition(4)),new Ae(!1)},t.prototype.parseIsoIec646Block=function(){for(;this.isStillIsoIec646(this.current.getPosition());){var t=this.decodeIsoIec646(this.current.getPosition());if(this.current.setPosition(t.getNewPosition()),t.isFNC1()){var e=new Oe(this.current.getPosition(),this.buffer.toString());return new Ae(!0,e)}this.buffer.append(t.getValue())}return this.isAlphaOr646ToNumericLatch(this.current.getPosition())?(this.current.incrementPosition(3),this.current.setNumeric()):this.isAlphaTo646ToAlphaLatch(this.current.getPosition())&&(this.current.getPosition()+5<this.information.getSize()?this.current.incrementPosition(5):this.current.setPosition(this.information.getSize()),this.current.setAlpha()),new Ae(!1)},t.prototype.parseAlphaBlock=function(){for(;this.isStillAlpha(this.current.getPosition());){var t=this.decodeAlphanumeric(this.current.getPosition());if(this.current.setPosition(t.getNewPosition()),t.isFNC1()){var e=new Oe(this.current.getPosition(),this.buffer.toString());return new Ae(!0,e)}this.buffer.append(t.getValue())}return this.isAlphaOr646ToNumericLatch(this.current.getPosition())?(this.current.incrementPosition(3),this.current.setNumeric()):this.isAlphaTo646ToAlphaLatch(this.current.getPosition())&&(this.current.getPosition()+5<this.information.getSize()?this.current.incrementPosition(5):this.current.setPosition(this.information.getSize()),this.current.setIsoIec646()),new Ae(!1)},t.prototype.isStillIsoIec646=function(t){if(t+5>this.information.getSize())return!1;var e=this.extractNumericValueFromBitArray(t,5);if(e>=5&&e<16)return!0;if(t+7>this.information.getSize())return!1;var r=this.extractNumericValueFromBitArray(t,7);if(r>=64&&r<116)return!0;if(t+8>this.information.getSize())return!1;var n=this.extractNumericValueFromBitArray(t,8);return n>=232&&n<253},t.prototype.decodeIsoIec646=function(t){var e=this.extractNumericValueFromBitArray(t,5);if(15===e)return new Ie(t+5,Ie.FNC1);if(e>=5&&e<15)return new Ie(t+5,"0"+(e-5));var r,n=this.extractNumericValueFromBitArray(t,7);if(n>=64&&n<90)return new Ie(t+7,""+(n+1));if(n>=90&&n<116)return new Ie(t+7,""+(n+7));switch(this.extractNumericValueFromBitArray(t,8)){case 232:r="!";break;case 233:r='"';break;case 234:r="%";break;case 235:r="&";break;case 236:r="'";break;case 237:r="(";break;case 238:r=")";break;case 239:r="*";break;case 240:r="+";break;case 241:r=",";break;case 242:r="-";break;case 243:r=".";break;case 244:r="/";break;case 245:r=":";break;case 246:r=";";break;case 247:r="<";break;case 248:r="=";break;case 249:r=">";break;case 250:r="?";break;case 251:r="_";break;case 252:r=" ";break;default:throw new R}return new Ie(t+8,r)},t.prototype.isStillAlpha=function(t){if(t+5>this.information.getSize())return!1;var e=this.extractNumericValueFromBitArray(t,5);if(e>=5&&e<16)return!0;if(t+6>this.information.getSize())return!1;var r=this.extractNumericValueFromBitArray(t,6);return r>=16&&r<63},t.prototype.decodeAlphanumeric=function(t){var e=this.extractNumericValueFromBitArray(t,5);if(15===e)return new Ie(t+5,Ie.FNC1);if(e>=5&&e<15)return new Ie(t+5,"0"+(e-5));var r,n=this.extractNumericValueFromBitArray(t,6);if(n>=32&&n<58)return new Ie(t+6,""+(n+33));switch(n){case 58:r="*";break;case 59:r=",";break;case 60:r="-";break;case 61:r=".";break;case 62:r="/";break;default:throw new yt("Decoding invalid alphanumeric value: "+n)}return new Ie(t+6,r)},t.prototype.isAlphaTo646ToAlphaLatch=function(t){if(t+1>this.information.getSize())return!1;for(var e=0;e<5&&e+t<this.information.getSize();++e)if(2===e){if(!this.information.get(t+2))return!1}else if(this.information.get(t+e))return!1;return!0},t.prototype.isAlphaOr646ToNumericLatch=function(t){if(t+3>this.information.getSize())return!1;for(var e=t;e<t+3;++e)if(this.information.get(e))return!1;return!0},t.prototype.isNumericToAlphaNumericLatch=function(t){if(t+1>this.information.getSize())return!1;for(var e=0;e<4&&e+t<this.information.getSize();++e)if(this.information.get(t+e))return!1;return!0},t}(),Pe=function(){function t(t){this.information=t,this.generalDecoder=new De(t)}return t.prototype.getInformation=function(){return this.information},t.prototype.getGeneralDecoder=function(){return this.generalDecoder},t}(),Me=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Be=function(t){function e(e){return t.call(this,e)||this}return Me(e,t),e.prototype.encodeCompressedGtin=function(t,e){t.append("(01)");var r=t.length();t.append("9"),this.encodeCompressedGtinWithoutAI(t,e,r)},e.prototype.encodeCompressedGtinWithoutAI=function(t,r,n){for(var o=0;o<4;++o){var i=this.getGeneralDecoder().extractNumericValueFromBitArray(r+10*o,10);i/100==0&&t.append("0"),i/10==0&&t.append("0"),t.append(i)}e.appendCheckDigit(t,n)},e.appendCheckDigit=function(t,e){for(var r=0,n=0;n<13;n++){var o=t.charAt(n+e).charCodeAt(0)-"0".charCodeAt(0);r+=0==(1&n)?3*o:o}10===(r=10-r%10)&&(r=0),t.append(r)},e.GTIN_SIZE=40,e}(Pe),Le=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Fe=function(t){function e(e){return t.call(this,e)||this}return Le(e,t),e.prototype.parseInformation=function(){var t=new k;t.append("(01)");var r=t.length(),n=this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE,4);return t.append(n),this.encodeCompressedGtinWithoutAI(t,e.HEADER_SIZE+4,r),this.getGeneralDecoder().decodeAllCodes(t,e.HEADER_SIZE+44)},e.HEADER_SIZE=4,e}(Be),ke=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),xe=function(t){function e(e){return t.call(this,e)||this}return ke(e,t),e.prototype.parseInformation=function(){var t=new k;return this.getGeneralDecoder().decodeAllCodes(t,e.HEADER_SIZE)},e.HEADER_SIZE=5,e}(Pe),Ve=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ue=function(t){function e(e){return t.call(this,e)||this}return Ve(e,t),e.prototype.encodeCompressedWeight=function(t,e,r){var n=this.getGeneralDecoder().extractNumericValueFromBitArray(e,r);this.addWeightCode(t,n);for(var o=this.checkWeight(n),i=1e5,a=0;a<5;++a)o/i==0&&t.append("0"),i/=10;t.append(o)},e}(Be),He=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ge=function(t){function e(e){return t.call(this,e)||this}return He(e,t),e.prototype.parseInformation=function(){if(this.getInformation().getSize()!=e.HEADER_SIZE+Ue.GTIN_SIZE+e.WEIGHT_SIZE)throw new U;var t=new k;return this.encodeCompressedGtin(t,e.HEADER_SIZE),this.encodeCompressedWeight(t,e.HEADER_SIZE+Ue.GTIN_SIZE,e.WEIGHT_SIZE),t.toString()},e.HEADER_SIZE=5,e.WEIGHT_SIZE=15,e}(Ue),Xe=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),We=function(t){function e(e){return t.call(this,e)||this}return Xe(e,t),e.prototype.addWeightCode=function(t,e){t.append("(3103)")},e.prototype.checkWeight=function(t){return t},e}(Ge),je=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ze=function(t){function e(e){return t.call(this,e)||this}return je(e,t),e.prototype.addWeightCode=function(t,e){e<1e4?t.append("(3202)"):t.append("(3203)")},e.prototype.checkWeight=function(t){return t<1e4?t:t-1e4},e}(Ge),Ye=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ze=function(t){function e(e){return t.call(this,e)||this}return Ye(e,t),e.prototype.parseInformation=function(){if(this.getInformation().getSize()<e.HEADER_SIZE+Be.GTIN_SIZE)throw new U;var t=new k;this.encodeCompressedGtin(t,e.HEADER_SIZE);var r=this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE+Be.GTIN_SIZE,e.LAST_DIGIT_SIZE);t.append("(392"),t.append(r),t.append(")");var n=this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE+Be.GTIN_SIZE+e.LAST_DIGIT_SIZE,null);return t.append(n.getNewString()),t.toString()},e.HEADER_SIZE=8,e.LAST_DIGIT_SIZE=2,e}(Be),Ke=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),qe=function(t){function e(e){return t.call(this,e)||this}return Ke(e,t),e.prototype.parseInformation=function(){if(this.getInformation().getSize()<e.HEADER_SIZE+Be.GTIN_SIZE)throw new U;var t=new k;this.encodeCompressedGtin(t,e.HEADER_SIZE);var r=this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE+Be.GTIN_SIZE,e.LAST_DIGIT_SIZE);t.append("(393"),t.append(r),t.append(")");var n=this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE+Be.GTIN_SIZE+e.LAST_DIGIT_SIZE,e.FIRST_THREE_DIGITS_SIZE);n/100==0&&t.append("0"),n/10==0&&t.append("0"),t.append(n);var o=this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE+Be.GTIN_SIZE+e.LAST_DIGIT_SIZE+e.FIRST_THREE_DIGITS_SIZE,null);return t.append(o.getNewString()),t.toString()},e.HEADER_SIZE=8,e.LAST_DIGIT_SIZE=2,e.FIRST_THREE_DIGITS_SIZE=10,e}(Be),Qe=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Je=function(t){function e(e,r,n){var o=t.call(this,e)||this;return o.dateCode=n,o.firstAIdigits=r,o}return Qe(e,t),e.prototype.parseInformation=function(){if(this.getInformation().getSize()!=e.HEADER_SIZE+e.GTIN_SIZE+e.WEIGHT_SIZE+e.DATE_SIZE)throw new U;var t=new k;return this.encodeCompressedGtin(t,e.HEADER_SIZE),this.encodeCompressedWeight(t,e.HEADER_SIZE+e.GTIN_SIZE,e.WEIGHT_SIZE),this.encodeCompressedDate(t,e.HEADER_SIZE+e.GTIN_SIZE+e.WEIGHT_SIZE),t.toString()},e.prototype.encodeCompressedDate=function(t,r){var n=this.getGeneralDecoder().extractNumericValueFromBitArray(r,e.DATE_SIZE);if(38400!=n){t.append("("),t.append(this.dateCode),t.append(")");var o=n%32,i=(n/=32)%12+1,a=n/=12;a/10==0&&t.append("0"),t.append(a),i/10==0&&t.append("0"),t.append(i),o/10==0&&t.append("0"),t.append(o)}},e.prototype.addWeightCode=function(t,e){t.append("("),t.append(this.firstAIdigits),t.append(e/1e5),t.append(")")},e.prototype.checkWeight=function(t){return t%1e5},e.HEADER_SIZE=8,e.WEIGHT_SIZE=20,e.DATE_SIZE=16,e}(Ue);var $e=function(){function t(t,e,r,n){this.leftchar=t,this.rightchar=e,this.finderpattern=r,this.maybeLast=n}return t.prototype.mayBeLast=function(){return this.maybeLast},t.prototype.getLeftChar=function(){return this.leftchar},t.prototype.getRightChar=function(){return this.rightchar},t.prototype.getFinderPattern=function(){return this.finderpattern},t.prototype.mustBeLast=function(){return null==this.rightchar},t.prototype.toString=function(){return"[ "+this.leftchar+", "+this.rightchar+" : "+(null==this.finderpattern?"null":this.finderpattern.getValue())+" ]"},t.equals=function(e,r){return e instanceof t&&(t.equalsOrNull(e.leftchar,r.leftchar)&&t.equalsOrNull(e.rightchar,r.rightchar)&&t.equalsOrNull(e.finderpattern,r.finderpattern))},t.equalsOrNull=function(e,r){return null===e?null===r:t.equals(e,r)},t.prototype.hashCode=function(){return this.leftchar.getValue()^this.rightchar.getValue()^this.finderpattern.getValue()},t}(),tr=function(){function t(t,e,r){this.pairs=t,this.rowNumber=e,this.wasReversed=r}return t.prototype.getPairs=function(){return this.pairs},t.prototype.getRowNumber=function(){return this.rowNumber},t.prototype.isReversed=function(){return this.wasReversed},t.prototype.isEquivalent=function(t){return this.checkEqualitity(this,t)},t.prototype.toString=function(){return"{ "+this.pairs+" }"},t.prototype.equals=function(e,r){return e instanceof t&&(this.checkEqualitity(e,r)&&e.wasReversed===r.wasReversed)},t.prototype.checkEqualitity=function(t,e){var r;if(t&&e)return t.forEach((function(t,n){e.forEach((function(e){t.getLeftChar().getValue()===e.getLeftChar().getValue()&&t.getRightChar().getValue()===e.getRightChar().getValue()&&t.getFinderPatter().getValue()===e.getFinderPatter().getValue()&&(r=!0)}))})),r},t}(),er=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),rr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},nr=function(t){function e(){var r=null!==t&&t.apply(this,arguments)||this;return r.pairs=new Array(e.MAX_PAIRS),r.rows=new Array,r.startEnd=[2],r}return er(e,t),e.prototype.decodeRow=function(t,r,n){this.pairs.length=0,this.startFromEven=!1;try{return e.constructResult(this.decodeRow2pairs(t,r))}catch(t){}return this.pairs.length=0,this.startFromEven=!0,e.constructResult(this.decodeRow2pairs(t,r))},e.prototype.reset=function(){this.pairs.length=0,this.rows.length=0},e.prototype.decodeRow2pairs=function(t,e){for(var r,n=!1;!n;)try{this.pairs.push(this.retrieveNextPair(e,this.pairs,t))}catch(t){if(t instanceof U){if(!this.pairs.length)throw new U;n=!0}}if(this.checkChecksum())return this.pairs;if(r=!!this.rows.length,this.storeRow(t,!1),r){var o=this.checkRowsBoolean(!1);if(null!=o)return o;if(null!=(o=this.checkRowsBoolean(!0)))return o}throw new U},e.prototype.checkRowsBoolean=function(t){if(this.rows.length>25)return this.rows.length=0,null;this.pairs.length=0,t&&(this.rows=this.rows.reverse());var e=null;try{e=this.checkRows(new Array,0)}catch(t){console.log(t)}return t&&(this.rows=this.rows.reverse()),e},e.prototype.checkRows=function(t,r){for(var n,o,i=r;i<this.rows.length;i++){var a=this.rows[i];this.pairs.length=0;try{for(var u=(n=void 0,rr(t)),s=u.next();!s.done;s=u.next()){var c=s.value;this.pairs.push(c.getPairs())}}catch(t){n={error:t}}finally{try{s&&!s.done&&(o=u.return)&&o.call(u)}finally{if(n)throw n.error}}if(this.pairs.push(a.getPairs()),e.isValidSequence(this.pairs)){if(this.checkChecksum())return this.pairs;var f=new Array(t);f.push(a);try{return this.checkRows(f,i+1)}catch(t){console.log(t)}}}throw new U},e.isValidSequence=function(t){var r,n;try{for(var o=rr(e.FINDER_PATTERN_SEQUENCES),i=o.next();!i.done;i=o.next()){var a=i.value;if(!(t.length>a.length)){for(var u=!0,s=0;s<t.length;s++)if(t[s].getFinderPattern().getValue()!=a[s]){u=!1;break}if(u)return!0}}}catch(t){r={error:t}}finally{try{i&&!i.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}return!1},e.prototype.storeRow=function(t,r){for(var n=0,o=!1,i=!1;n<this.rows.length;){var a=this.rows[n];if(a.getRowNumber()>t){i=a.isEquivalent(this.pairs);break}o=a.isEquivalent(this.pairs),n++}i||o||e.isPartialRow(this.pairs,this.rows)||(this.rows.push(n,new tr(this.pairs,t,r)),this.removePartialRows(this.pairs,this.rows))},e.prototype.removePartialRows=function(t,e){var r,n,o,i,a,u;try{for(var s=rr(e),c=s.next();!c.done;c=s.next()){var f=c.value;if(f.getPairs().length!==t.length){try{for(var h=(o=void 0,rr(f.getPairs())),l=h.next();!l.done;l=h.next()){var d=l.value,p=!1;try{for(var g=(a=void 0,rr(t)),y=g.next();!y.done;y=g.next()){var w=y.value;if($e.equals(d,w)){p=!0;break}}}catch(t){a={error:t}}finally{try{y&&!y.done&&(u=g.return)&&u.call(g)}finally{if(a)throw a.error}}p||!1}}catch(t){o={error:t}}finally{try{l&&!l.done&&(i=h.return)&&i.call(h)}finally{if(o)throw o.error}}}}}catch(t){r={error:t}}finally{try{c&&!c.done&&(n=s.return)&&n.call(s)}finally{if(r)throw r.error}}},e.isPartialRow=function(t,e){var r,n,o,i,a,u;try{for(var s=rr(e),c=s.next();!c.done;c=s.next()){var f=c.value,h=!0;try{for(var l=(o=void 0,rr(t)),d=l.next();!d.done;d=l.next()){var p=d.value,g=!1;try{for(var y=(a=void 0,rr(f.getPairs())),w=y.next();!w.done;w=y.next()){var _=w.value;if(p.equals(_)){g=!0;break}}}catch(t){a={error:t}}finally{try{w&&!w.done&&(u=y.return)&&u.call(y)}finally{if(a)throw a.error}}if(!g){h=!1;break}}}catch(t){o={error:t}}finally{try{d&&!d.done&&(i=l.return)&&i.call(l)}finally{if(o)throw o.error}}if(h)return!0}}catch(t){r={error:t}}finally{try{c&&!c.done&&(n=s.return)&&n.call(s)}finally{if(r)throw r.error}}return!1},e.prototype.getRows=function(){return this.rows},e.constructResult=function(t){var e=function(t){try{if(t.get(1))return new Fe(t);if(!t.get(2))return new xe(t);switch(De.extractNumericValueFromBitArray(t,1,4)){case 4:return new We(t);case 5:return new ze(t)}switch(De.extractNumericValueFromBitArray(t,1,5)){case 12:return new Ze(t);case 13:return new qe(t)}switch(De.extractNumericValueFromBitArray(t,1,7)){case 56:return new Je(t,"310","11");case 57:return new Je(t,"320","11");case 58:return new Je(t,"310","13");case 59:return new Je(t,"320","13");case 60:return new Je(t,"310","15");case 61:return new Je(t,"320","15");case 62:return new Je(t,"310","17");case 63:return new Je(t,"320","17")}}catch(e){throw console.log(e),new yt("unknown decoder: "+t)}}(me.buildBitArray(t)).parseInformation(),r=t[0].getFinderPattern().getResultPoints(),n=t[t.length-1].getFinderPattern().getResultPoints(),o=[r[0],r[1],n[0],n[1]];return new et(e,null,null,o,nt.RSS_EXPANDED,null)},e.prototype.checkChecksum=function(){var t=this.pairs.get(0),e=t.getLeftChar(),r=t.getRightChar();if(null==r)return!1;for(var n=r.getChecksumPortion(),o=2,i=1;i<this.pairs.size();++i){var a=this.pairs.get(i);n+=a.getLeftChar().getChecksumPortion(),o++;var u=a.getRightChar();null!=u&&(n+=u.getChecksumPortion(),o++)}return 211*(o-4)+(n%=211)==e.getValue()},e.getNextSecondBar=function(t,e){var r;return t.get(e)?(r=t.getNextUnset(e),r=t.getNextSet(r)):(r=t.getNextSet(e),r=t.getNextUnset(r)),r},e.prototype.retrieveNextPair=function(t,r,n){var o,i=r.length%2==0;this.startFromEven&&(i=!i);var a=!0,u=-1;do{this.findNextPair(t,r,u),null==(o=this.parseFoundFinderPattern(t,n,i))?u=e.getNextSecondBar(t,this.startEnd[0]):a=!1}while(a);var s,c=this.decodeDataCharacter(t,o,i,!0);if(!this.isEmptyPair(r)&&r[r.length-1].mustBeLast())throw new U;try{s=this.decodeDataCharacter(t,o,i,!1)}catch(t){s=null,console.log(t)}return new $e(c,s,o,!0)},e.prototype.isEmptyPair=function(t){return 0===t.length},e.prototype.findNextPair=function(t,r,n){var o=this.getDecodeFinderCounters();o[0]=0,o[1]=0,o[2]=0,o[3]=0;var i,a=t.getSize();if(n>=0)i=n;else if(this.isEmptyPair(r))i=0;else{i=r[r.length-1].getFinderPattern().getStartEnd()[1]}var u=r.length%2!=0;this.startFromEven&&(u=!u);for(var s=!1;i<a&&(s=!t.get(i));)i++;for(var c=0,f=i,h=i;h<a;h++)if(t.get(h)!=s)o[c]++;else{if(3==c){if(u&&e.reverseCounters(o),e.isFinderPattern(o))return this.startEnd[0]=f,void(this.startEnd[1]=h);u&&e.reverseCounters(o),f+=o[0]+o[1],o[0]=o[2],o[1]=o[3],o[2]=0,o[3]=0,c--}else c++;o[c]=1,s=!s}throw new U},e.reverseCounters=function(t){for(var e=t.length,r=0;r<e/2;++r){var n=t[r];t[r]=t[e-r-1],t[e-r-1]=n}},e.prototype.parseFoundFinderPattern=function(t,r,n){var o,i,a;if(n){for(var u=this.startEnd[0]-1;u>=0&&!t.get(u);)u--;u++,o=this.startEnd[0]-u,i=u,a=this.startEnd[1]}else i=this.startEnd[0],o=(a=t.getNextUnset(this.startEnd[1]+1))-this.startEnd[1];var s,c=this.getDecodeFinderCounters();w.arraycopy(c,0,c,1,c.length-1),c[0]=o;try{s=this.parseFinderValue(c,e.FINDER_PATTERNS)}catch(t){return null}return new we(s,[i,a],i,a,r)},e.prototype.decodeDataCharacter=function(t,r,n,o){for(var i=this.getDataCharacterCounters(),a=0;a<i.length;a++)i[a]=0;if(o)e.recordPatternInReverse(t,r.getStartEnd()[0],i);else{e.recordPattern(t,r.getStartEnd()[1],i);for(var u=0,s=i.length-1;u<s;u++,s--){var c=i[u];i[u]=i[s],i[s]=c}}var f=vt.sum(new Int32Array(i))/17,h=(r.getStartEnd()[1]-r.getStartEnd()[0])/15;if(Math.abs(f-h)/h>.3)throw new U;var l=this.getOddCounts(),d=this.getEvenCounts(),p=this.getOddRoundingErrors(),g=this.getEvenRoundingErrors();for(u=0;u<i.length;u++){var y=1*i[u]/f,w=y+.5;if(w<1){if(y<.3)throw new U;w=1}else if(w>8){if(y>8.7)throw new U;w=8}var _=u/2;0==(1&u)?(l[_]=w,p[_]=y-w):(d[_]=w,g[_]=y-w)}this.adjustOddEvenCounts(17);var v=4*r.getValue()+(n?0:2)+(o?0:1)-1,m=0,A=0;for(u=l.length-1;u>=0;u--){if(e.isNotA1left(r,n,o)){var E=e.WEIGHTS[v][2*u];A+=l[u]*E}m+=l[u]}var C=0;for(u=d.length-1;u>=0;u--)if(e.isNotA1left(r,n,o)){E=e.WEIGHTS[v][2*u+1];C+=d[u]*E}var I=A+C;if(0!=(1&m)||m>13||m<4)throw new U;var S=(13-m)/2,O=e.SYMBOL_WIDEST[S],T=9-O,b=ve.getRSSvalue(l,O,!0),R=ve.getRSSvalue(d,T,!1),N=e.EVEN_TOTAL_SUBSET[S],D=e.GSUM[S];return new ye(b*N+R+D,I)},e.isNotA1left=function(t,e,r){return!(0==t.getValue()&&e&&r)},e.prototype.adjustOddEvenCounts=function(t){var r=vt.sum(new Int32Array(this.getOddCounts())),n=vt.sum(new Int32Array(this.getEvenCounts())),o=!1,i=!1;r>13?i=!0:r<4&&(o=!0);var a=!1,u=!1;n>13?u=!0:n<4&&(a=!0);var s=r+n-t,c=1==(1&r),f=0==(1&n);if(1==s)if(c){if(f)throw new U;i=!0}else{if(!f)throw new U;u=!0}else if(-1==s)if(c){if(f)throw new U;o=!0}else{if(!f)throw new U;a=!0}else{if(0!=s)throw new U;if(c){if(!f)throw new U;r<n?(o=!0,u=!0):(i=!0,a=!0)}else if(f)throw new U}if(o){if(i)throw new U;e.increment(this.getOddCounts(),this.getOddRoundingErrors())}if(i&&e.decrement(this.getOddCounts(),this.getOddRoundingErrors()),a){if(u)throw new U;e.increment(this.getEvenCounts(),this.getOddRoundingErrors())}u&&e.decrement(this.getEvenCounts(),this.getEvenRoundingErrors())},e.SYMBOL_WIDEST=[7,5,4,3,1],e.EVEN_TOTAL_SUBSET=[4,20,52,104,204],e.GSUM=[0,348,1388,2948,3988],e.FINDER_PATTERNS=[Int32Array.from([1,8,4,1]),Int32Array.from([3,6,4,1]),Int32Array.from([3,4,6,1]),Int32Array.from([3,2,8,1]),Int32Array.from([2,6,5,1]),Int32Array.from([2,2,9,1])],e.WEIGHTS=[[1,3,9,27,81,32,96,77],[20,60,180,118,143,7,21,63],[189,145,13,39,117,140,209,205],[193,157,49,147,19,57,171,91],[62,186,136,197,169,85,44,132],[185,133,188,142,4,12,36,108],[113,128,173,97,80,29,87,50],[150,28,84,41,123,158,52,156],[46,138,203,187,139,206,196,166],[76,17,51,153,37,111,122,155],[43,129,176,106,107,110,119,146],[16,48,144,10,30,90,59,177],[109,116,137,200,178,112,125,164],[70,210,208,202,184,130,179,115],[134,191,151,31,93,68,204,190],[148,22,66,198,172,94,71,2],[6,18,54,162,64,192,154,40],[120,149,25,75,14,42,126,167],[79,26,78,23,69,207,199,175],[103,98,83,38,114,131,182,124],[161,61,183,127,170,88,53,159],[55,165,73,8,24,72,5,15],[45,135,194,160,58,174,100,89]],e.FINDER_PAT_A=0,e.FINDER_PAT_B=1,e.FINDER_PAT_C=2,e.FINDER_PAT_D=3,e.FINDER_PAT_E=4,e.FINDER_PAT_F=5,e.FINDER_PATTERN_SEQUENCES=[[e.FINDER_PAT_A,e.FINDER_PAT_A],[e.FINDER_PAT_A,e.FINDER_PAT_B,e.FINDER_PAT_B],[e.FINDER_PAT_A,e.FINDER_PAT_C,e.FINDER_PAT_B,e.FINDER_PAT_D],[e.FINDER_PAT_A,e.FINDER_PAT_E,e.FINDER_PAT_B,e.FINDER_PAT_D,e.FINDER_PAT_C],[e.FINDER_PAT_A,e.FINDER_PAT_E,e.FINDER_PAT_B,e.FINDER_PAT_D,e.FINDER_PAT_D,e.FINDER_PAT_F],[e.FINDER_PAT_A,e.FINDER_PAT_E,e.FINDER_PAT_B,e.FINDER_PAT_D,e.FINDER_PAT_E,e.FINDER_PAT_F,e.FINDER_PAT_F],[e.FINDER_PAT_A,e.FINDER_PAT_A,e.FINDER_PAT_B,e.FINDER_PAT_B,e.FINDER_PAT_C,e.FINDER_PAT_C,e.FINDER_PAT_D,e.FINDER_PAT_D],[e.FINDER_PAT_A,e.FINDER_PAT_A,e.FINDER_PAT_B,e.FINDER_PAT_B,e.FINDER_PAT_C,e.FINDER_PAT_C,e.FINDER_PAT_D,e.FINDER_PAT_E,e.FINDER_PAT_E],[e.FINDER_PAT_A,e.FINDER_PAT_A,e.FINDER_PAT_B,e.FINDER_PAT_B,e.FINDER_PAT_C,e.FINDER_PAT_C,e.FINDER_PAT_D,e.FINDER_PAT_E,e.FINDER_PAT_F,e.FINDER_PAT_F],[e.FINDER_PAT_A,e.FINDER_PAT_A,e.FINDER_PAT_B,e.FINDER_PAT_B,e.FINDER_PAT_C,e.FINDER_PAT_D,e.FINDER_PAT_D,e.FINDER_PAT_E,e.FINDER_PAT_E,e.FINDER_PAT_F,e.FINDER_PAT_F]],e.MAX_PAIRS=11,e}(ge),or=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ir=function(t){function e(e,r,n){var o=t.call(this,e,r)||this;return o.count=0,o.finderPattern=n,o}return or(e,t),e.prototype.getFinderPattern=function(){return this.finderPattern},e.prototype.getCount=function(){return this.count},e.prototype.incrementCount=function(){this.count++},e}(ye),ar=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ur=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},sr=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.possibleLeftPairs=[],e.possibleRightPairs=[],e}return ar(e,t),e.prototype.decodeRow=function(t,r,n){var o,i,a,u,s=this.decodePair(r,!1,t,n);e.addOrTally(this.possibleLeftPairs,s),r.reverse();var c=this.decodePair(r,!0,t,n);e.addOrTally(this.possibleRightPairs,c),r.reverse();try{for(var f=ur(this.possibleLeftPairs),h=f.next();!h.done;h=f.next()){var l=h.value;if(l.getCount()>1)try{for(var d=(a=void 0,ur(this.possibleRightPairs)),p=d.next();!p.done;p=d.next()){var g=p.value;if(g.getCount()>1&&e.checkChecksum(l,g))return e.constructResult(l,g)}}catch(t){a={error:t}}finally{try{p&&!p.done&&(u=d.return)&&u.call(d)}finally{if(a)throw a.error}}}}catch(t){o={error:t}}finally{try{h&&!h.done&&(i=f.return)&&i.call(f)}finally{if(o)throw o.error}}throw new U},e.addOrTally=function(t,e){var r,n;if(null!=e){var o=!1;try{for(var i=ur(t),a=i.next();!a.done;a=i.next()){var u=a.value;if(u.getValue()===e.getValue()){u.incrementCount(),o=!0;break}}}catch(t){r={error:t}}finally{try{a&&!a.done&&(n=i.return)&&n.call(i)}finally{if(r)throw r.error}}o||t.push(e)}},e.prototype.reset=function(){this.possibleLeftPairs.length=0,this.possibleRightPairs.length=0},e.constructResult=function(t,e){for(var r=4537077*t.getValue()+e.getValue(),n=new String(r).toString(),o=new k,i=13-n.length;i>0;i--)o.append("0");o.append(n);var a=0;for(i=0;i<13;i++){var u=o.charAt(i).charCodeAt(0)-"0".charCodeAt(0);a+=0==(1&i)?3*u:u}10===(a=10-a%10)&&(a=0),o.append(a.toString());var s=t.getFinderPattern().getResultPoints(),c=e.getFinderPattern().getResultPoints();return new et(o.toString(),null,0,[s[0],s[1],c[0],c[1]],nt.RSS_14,(new Date).getTime())},e.checkChecksum=function(t,e){var r=(t.getChecksumPortion()+16*e.getChecksumPortion())%79,n=9*t.getFinderPattern().getValue()+e.getFinderPattern().getValue();return n>72&&n--,n>8&&n--,r===n},e.prototype.decodePair=function(t,e,r,n){try{var o=this.findFinderPattern(t,e),i=this.parseFoundFinderPattern(t,r,e,o),a=null==n?null:n.get(T.NEED_RESULT_POINT_CALLBACK);if(null!=a){var u=(o[0]+o[1])/2;e&&(u=t.getSize()-1-u),a.foundPossibleResultPoint(new At(u,r))}var s=this.decodeDataCharacter(t,i,!0),c=this.decodeDataCharacter(t,i,!1);return new ir(1597*s.getValue()+c.getValue(),s.getChecksumPortion()+4*c.getChecksumPortion(),i)}catch(t){return null}},e.prototype.decodeDataCharacter=function(t,r,n){for(var o=this.getDataCharacterCounters(),i=0;i<o.length;i++)o[i]=0;if(n)Lt.recordPatternInReverse(t,r.getStartEnd()[0],o);else{Lt.recordPattern(t,r.getStartEnd()[1]+1,o);for(var a=0,u=o.length-1;a<u;a++,u--){var s=o[a];o[a]=o[u],o[u]=s}}var c=n?16:15,f=vt.sum(new Int32Array(o))/c,h=this.getOddCounts(),l=this.getEvenCounts(),d=this.getOddRoundingErrors(),p=this.getEvenRoundingErrors();for(a=0;a<o.length;a++){var g=o[a]/f,y=Math.floor(g+.5);y<1?y=1:y>8&&(y=8);var w=Math.floor(a/2);0==(1&a)?(h[w]=y,d[w]=g-y):(l[w]=y,p[w]=g-y)}this.adjustOddEvenCounts(n,c);var _=0,v=0;for(a=h.length-1;a>=0;a--)v*=9,v+=h[a],_+=h[a];var m=0,A=0;for(a=l.length-1;a>=0;a--)m*=9,m+=l[a],A+=l[a];var E=v+3*m;if(n){if(0!=(1&_)||_>12||_<4)throw new U;var C=(12-_)/2,I=9-(R=e.OUTSIDE_ODD_WIDEST[C]),S=ve.getRSSvalue(h,R,!1),O=ve.getRSSvalue(l,I,!0),T=e.OUTSIDE_EVEN_TOTAL_SUBSET[C],b=e.OUTSIDE_GSUM[C];return new ye(S*T+O+b,E)}if(0!=(1&A)||A>10||A<4)throw new U;C=(10-A)/2,I=9-(R=e.INSIDE_ODD_WIDEST[C]),S=ve.getRSSvalue(h,R,!0),O=ve.getRSSvalue(l,I,!1);var R,N=e.INSIDE_ODD_TOTAL_SUBSET[C];b=e.INSIDE_GSUM[C];return new ye(O*N+S+b,E)},e.prototype.findFinderPattern=function(t,e){var r=this.getDecodeFinderCounters();r[0]=0,r[1]=0,r[2]=0,r[3]=0;for(var n=t.getSize(),o=!1,i=0;i<n&&e!==(o=!t.get(i));)i++;for(var a=0,u=i,s=i;s<n;s++)if(t.get(s)!==o)r[a]++;else{if(3===a){if(ge.isFinderPattern(r))return[u,s];u+=r[0]+r[1],r[0]=r[2],r[1]=r[3],r[2]=0,r[3]=0,a--}else a++;r[a]=1,o=!o}throw new U},e.prototype.parseFoundFinderPattern=function(t,r,n,o){for(var i=t.get(o[0]),a=o[0]-1;a>=0&&i!==t.get(a);)a--;a++;var u=o[0]-a,s=this.getDecodeFinderCounters(),c=new Int32Array(s.length);w.arraycopy(s,0,c,1,s.length-1),c[0]=u;var f=this.parseFinderValue(c,e.FINDER_PATTERNS),h=a,l=o[1];return n&&(h=t.getSize()-1-h,l=t.getSize()-1-l),new we(f,[a,o[1]],h,l,r)},e.prototype.adjustOddEvenCounts=function(t,e){var r=vt.sum(new Int32Array(this.getOddCounts())),n=vt.sum(new Int32Array(this.getEvenCounts())),o=!1,i=!1,a=!1,u=!1;t?(r>12?i=!0:r<4&&(o=!0),n>12?u=!0:n<4&&(a=!0)):(r>11?i=!0:r<5&&(o=!0),n>10?u=!0:n<4&&(a=!0));var s=r+n-e,c=(1&r)==(t?1:0),f=1==(1&n);if(1===s)if(c){if(f)throw new U;i=!0}else{if(!f)throw new U;u=!0}else if(-1===s)if(c){if(f)throw new U;o=!0}else{if(!f)throw new U;a=!0}else{if(0!==s)throw new U;if(c){if(!f)throw new U;r<n?(o=!0,u=!0):(i=!0,a=!0)}else if(f)throw new U}if(o){if(i)throw new U;ge.increment(this.getOddCounts(),this.getOddRoundingErrors())}if(i&&ge.decrement(this.getOddCounts(),this.getOddRoundingErrors()),a){if(u)throw new U;ge.increment(this.getEvenCounts(),this.getOddRoundingErrors())}u&&ge.decrement(this.getEvenCounts(),this.getEvenRoundingErrors())},e.OUTSIDE_EVEN_TOTAL_SUBSET=[1,10,34,70,126],e.INSIDE_ODD_TOTAL_SUBSET=[4,20,48,81],e.OUTSIDE_GSUM=[0,161,961,2015,2715],e.INSIDE_GSUM=[0,336,1036,1516],e.OUTSIDE_ODD_WIDEST=[8,6,4,3,1],e.INSIDE_ODD_WIDEST=[2,4,6,8],e.FINDER_PATTERNS=[Int32Array.from([3,8,2,1]),Int32Array.from([3,5,5,1]),Int32Array.from([3,3,7,1]),Int32Array.from([3,1,9,1]),Int32Array.from([2,7,4,1]),Int32Array.from([2,5,6,1]),Int32Array.from([2,3,8,1]),Int32Array.from([1,5,7,1]),Int32Array.from([1,3,9,1])],e}(ge),cr=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),fr=function(t){function e(e){var r=t.call(this)||this;r.readers=[];var n=e?e.get(T.POSSIBLE_FORMATS):null,o=e&&void 0!==e.get(T.ASSUME_CODE_39_CHECK_DIGIT);return n&&((n.includes(nt.EAN_13)||n.includes(nt.UPC_A)||n.includes(nt.EAN_8)||n.includes(nt.UPC_E))&&r.readers.push(new le(e)),n.includes(nt.CODE_39)&&r.readers.push(new Ut(o)),n.includes(nt.CODE_128)&&r.readers.push(new kt),n.includes(nt.ITF)&&r.readers.push(new Xt),n.includes(nt.RSS_14)&&r.readers.push(new sr),n.includes(nt.RSS_EXPANDED)&&(console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."),r.readers.push(new nr))),0===r.readers.length&&(r.readers.push(new le(e)),r.readers.push(new Ut),r.readers.push(new le(e)),r.readers.push(new kt),r.readers.push(new Xt),r.readers.push(new sr)),r}return cr(e,t),e.prototype.decodeRow=function(t,e,r){for(var n=0;n<this.readers.length;n++)try{return this.readers[n].decodeRow(t,e,r)}catch(t){}throw new U},e.prototype.reset=function(){this.readers.forEach((function(t){return t.reset()}))},e}(Lt),hr=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){return void 0===e&&(e=500),t.call(this,new fr(r),e,r)||this}hr(e,t)}(tt);var lr,dr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},pr=function(){function t(t,e,r){this.ecCodewords=t,this.ecBlocks=[e],r&&this.ecBlocks.push(r)}return t.prototype.getECCodewords=function(){return this.ecCodewords},t.prototype.getECBlocks=function(){return this.ecBlocks},t}(),gr=function(){function t(t,e){this.count=t,this.dataCodewords=e}return t.prototype.getCount=function(){return this.count},t.prototype.getDataCodewords=function(){return this.dataCodewords},t}(),yr=function(){function t(t,e,r,n,o,i){var a,u;this.versionNumber=t,this.symbolSizeRows=e,this.symbolSizeColumns=r,this.dataRegionSizeRows=n,this.dataRegionSizeColumns=o,this.ecBlocks=i;var s=0,c=i.getECCodewords(),f=i.getECBlocks();try{for(var h=dr(f),l=h.next();!l.done;l=h.next()){var d=l.value;s+=d.getCount()*(d.getDataCodewords()+c)}}catch(t){a={error:t}}finally{try{l&&!l.done&&(u=h.return)&&u.call(h)}finally{if(a)throw a.error}}this.totalCodewords=s}return t.prototype.getVersionNumber=function(){return this.versionNumber},t.prototype.getSymbolSizeRows=function(){return this.symbolSizeRows},t.prototype.getSymbolSizeColumns=function(){return this.symbolSizeColumns},t.prototype.getDataRegionSizeRows=function(){return this.dataRegionSizeRows},t.prototype.getDataRegionSizeColumns=function(){return this.dataRegionSizeColumns},t.prototype.getTotalCodewords=function(){return this.totalCodewords},t.prototype.getECBlocks=function(){return this.ecBlocks},t.getVersionForDimensions=function(e,r){var n,o;if(0!=(1&e)||0!=(1&r))throw new R;try{for(var i=dr(t.VERSIONS),a=i.next();!a.done;a=i.next()){var u=a.value;if(u.symbolSizeRows===e&&u.symbolSizeColumns===r)return u}}catch(t){n={error:t}}finally{try{a&&!a.done&&(o=i.return)&&o.call(i)}finally{if(n)throw n.error}}throw new R},t.prototype.toString=function(){return""+this.versionNumber},t.buildVersions=function(){return[new t(1,10,10,8,8,new pr(5,new gr(1,3))),new t(2,12,12,10,10,new pr(7,new gr(1,5))),new t(3,14,14,12,12,new pr(10,new gr(1,8))),new t(4,16,16,14,14,new pr(12,new gr(1,12))),new t(5,18,18,16,16,new pr(14,new gr(1,18))),new t(6,20,20,18,18,new pr(18,new gr(1,22))),new t(7,22,22,20,20,new pr(20,new gr(1,30))),new t(8,24,24,22,22,new pr(24,new gr(1,36))),new t(9,26,26,24,24,new pr(28,new gr(1,44))),new t(10,32,32,14,14,new pr(36,new gr(1,62))),new t(11,36,36,16,16,new pr(42,new gr(1,86))),new t(12,40,40,18,18,new pr(48,new gr(1,114))),new t(13,44,44,20,20,new pr(56,new gr(1,144))),new t(14,48,48,22,22,new pr(68,new gr(1,174))),new t(15,52,52,24,24,new pr(42,new gr(2,102))),new t(16,64,64,14,14,new pr(56,new gr(2,140))),new t(17,72,72,16,16,new pr(36,new gr(4,92))),new t(18,80,80,18,18,new pr(48,new gr(4,114))),new t(19,88,88,20,20,new pr(56,new gr(4,144))),new t(20,96,96,22,22,new pr(68,new gr(4,174))),new t(21,104,104,24,24,new pr(56,new gr(6,136))),new t(22,120,120,18,18,new pr(68,new gr(6,175))),new t(23,132,132,20,20,new pr(62,new gr(8,163))),new t(24,144,144,22,22,new pr(62,new gr(8,156),new gr(2,155))),new t(25,8,18,6,16,new pr(7,new gr(1,5))),new t(26,8,32,6,14,new pr(11,new gr(1,10))),new t(27,12,26,10,24,new pr(14,new gr(1,16))),new t(28,12,36,10,16,new pr(18,new gr(1,22))),new t(29,16,36,14,16,new pr(24,new gr(1,32))),new t(30,16,48,14,22,new pr(28,new gr(1,49)))]},t.VERSIONS=t.buildVersions(),t}(),wr=function(){function t(e){var r=e.getHeight();if(r<8||r>144||0!=(1&r))throw new R;this.version=t.readVersion(e),this.mappingBitMatrix=this.extractDataRegion(e),this.readMappingMatrix=new x(this.mappingBitMatrix.getWidth(),this.mappingBitMatrix.getHeight())}return t.prototype.getVersion=function(){return this.version},t.readVersion=function(t){var e=t.getHeight(),r=t.getWidth();return yr.getVersionForDimensions(e,r)},t.prototype.readCodewords=function(){var t=new Int8Array(this.version.getTotalCodewords()),e=0,r=4,n=0,o=this.mappingBitMatrix.getHeight(),i=this.mappingBitMatrix.getWidth(),a=!1,u=!1,s=!1,c=!1;do{if(r!==o||0!==n||a)if(r!==o-2||0!==n||0==(3&i)||u)if(r!==o+4||2!==n||0!=(7&i)||s)if(r!==o-2||0!==n||4!=(7&i)||c){do{r<o&&n>=0&&!this.readMappingMatrix.get(n,r)&&(t[e++]=255&this.readUtah(r,n,o,i)),r-=2,n+=2}while(r>=0&&n<i);r+=1,n+=3;do{r>=0&&n<i&&!this.readMappingMatrix.get(n,r)&&(t[e++]=255&this.readUtah(r,n,o,i)),r+=2,n-=2}while(r<o&&n>=0);r+=3,n+=1}else t[e++]=255&this.readCorner4(o,i),r-=2,n+=2,c=!0;else t[e++]=255&this.readCorner3(o,i),r-=2,n+=2,s=!0;else t[e++]=255&this.readCorner2(o,i),r-=2,n+=2,u=!0;else t[e++]=255&this.readCorner1(o,i),r-=2,n+=2,a=!0}while(r<o||n<i);if(e!==this.version.getTotalCodewords())throw new R;return t},t.prototype.readModule=function(t,e,r,n){return t<0&&(t+=r,e+=4-(r+4&7)),e<0&&(e+=n,t+=4-(n+4&7)),this.readMappingMatrix.set(e,t),this.mappingBitMatrix.get(e,t)},t.prototype.readUtah=function(t,e,r,n){var o=0;return this.readModule(t-2,e-2,r,n)&&(o|=1),o<<=1,this.readModule(t-2,e-1,r,n)&&(o|=1),o<<=1,this.readModule(t-1,e-2,r,n)&&(o|=1),o<<=1,this.readModule(t-1,e-1,r,n)&&(o|=1),o<<=1,this.readModule(t-1,e,r,n)&&(o|=1),o<<=1,this.readModule(t,e-2,r,n)&&(o|=1),o<<=1,this.readModule(t,e-1,r,n)&&(o|=1),o<<=1,this.readModule(t,e,r,n)&&(o|=1),o},t.prototype.readCorner1=function(t,e){var r=0;return this.readModule(t-1,0,t,e)&&(r|=1),r<<=1,this.readModule(t-1,1,t,e)&&(r|=1),r<<=1,this.readModule(t-1,2,t,e)&&(r|=1),r<<=1,this.readModule(0,e-2,t,e)&&(r|=1),r<<=1,this.readModule(0,e-1,t,e)&&(r|=1),r<<=1,this.readModule(1,e-1,t,e)&&(r|=1),r<<=1,this.readModule(2,e-1,t,e)&&(r|=1),r<<=1,this.readModule(3,e-1,t,e)&&(r|=1),r},t.prototype.readCorner2=function(t,e){var r=0;return this.readModule(t-3,0,t,e)&&(r|=1),r<<=1,this.readModule(t-2,0,t,e)&&(r|=1),r<<=1,this.readModule(t-1,0,t,e)&&(r|=1),r<<=1,this.readModule(0,e-4,t,e)&&(r|=1),r<<=1,this.readModule(0,e-3,t,e)&&(r|=1),r<<=1,this.readModule(0,e-2,t,e)&&(r|=1),r<<=1,this.readModule(0,e-1,t,e)&&(r|=1),r<<=1,this.readModule(1,e-1,t,e)&&(r|=1),r},t.prototype.readCorner3=function(t,e){var r=0;return this.readModule(t-1,0,t,e)&&(r|=1),r<<=1,this.readModule(t-1,e-1,t,e)&&(r|=1),r<<=1,this.readModule(0,e-3,t,e)&&(r|=1),r<<=1,this.readModule(0,e-2,t,e)&&(r|=1),r<<=1,this.readModule(0,e-1,t,e)&&(r|=1),r<<=1,this.readModule(1,e-3,t,e)&&(r|=1),r<<=1,this.readModule(1,e-2,t,e)&&(r|=1),r<<=1,this.readModule(1,e-1,t,e)&&(r|=1),r},t.prototype.readCorner4=function(t,e){var r=0;return this.readModule(t-3,0,t,e)&&(r|=1),r<<=1,this.readModule(t-2,0,t,e)&&(r|=1),r<<=1,this.readModule(t-1,0,t,e)&&(r|=1),r<<=1,this.readModule(0,e-2,t,e)&&(r|=1),r<<=1,this.readModule(0,e-1,t,e)&&(r|=1),r<<=1,this.readModule(1,e-1,t,e)&&(r|=1),r<<=1,this.readModule(2,e-1,t,e)&&(r|=1),r<<=1,this.readModule(3,e-1,t,e)&&(r|=1),r},t.prototype.extractDataRegion=function(t){var e=this.version.getSymbolSizeRows(),r=this.version.getSymbolSizeColumns();if(t.getHeight()!==e)throw new l("Dimension of bitMatrix must match the version size");for(var n=this.version.getDataRegionSizeRows(),o=this.version.getDataRegionSizeColumns(),i=e/n|0,a=r/o|0,u=new x(a*o,i*n),s=0;s<i;++s)for(var c=s*n,f=0;f<a;++f)for(var h=f*o,d=0;d<n;++d)for(var p=s*(n+2)+1+d,g=c+d,y=0;y<o;++y){var w=f*(o+2)+1+y;if(t.get(w,p)){var _=h+y;u.set(_,g)}}return u},t}(),_r=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},vr=function(){function t(t,e){this.numDataCodewords=t,this.codewords=e}return t.getDataBlocks=function(e,r){var n,o,i,a,u=r.getECBlocks(),s=0,c=u.getECBlocks();try{for(var f=_r(c),h=f.next();!h.done;h=f.next()){s+=(w=h.value).getCount()}}catch(t){n={error:t}}finally{try{h&&!h.done&&(o=f.return)&&o.call(f)}finally{if(n)throw n.error}}var d=new Array(s),p=0;try{for(var g=_r(c),y=g.next();!y.done;y=g.next())for(var w=y.value,_=0;_<w.getCount();_++){var v=w.getDataCodewords(),m=u.getECCodewords()+v;d[p++]=new t(v,new Uint8Array(m))}}catch(t){i={error:t}}finally{try{y&&!y.done&&(a=g.return)&&a.call(g)}finally{if(i)throw i.error}}var A=d[0].codewords.length-u.getECCodewords(),E=A-1,C=0;for(_=0;_<E;_++)for(var I=0;I<p;I++)d[I].codewords[_]=e[C++];var S=24===r.getVersionNumber(),O=S?8:p;for(I=0;I<O;I++)d[I].codewords[A-1]=e[C++];var T=d[0].codewords.length;for(_=A;_<T;_++)for(I=0;I<p;I++){var b=S?(I+8)%p:I,R=S&&b>7?_-1:_;d[b].codewords[R]=e[C++]}if(C!==e.length)throw new l;return d},t.prototype.getNumDataCodewords=function(){return this.numDataCodewords},t.prototype.getCodewords=function(){return this.codewords},t}(),mr=function(){function t(t){this.bytes=t,this.byteOffset=0,this.bitOffset=0}return t.prototype.getBitOffset=function(){return this.bitOffset},t.prototype.getByteOffset=function(){return this.byteOffset},t.prototype.readBits=function(t){if(t<1||t>32||t>this.available())throw new l(""+t);var e=0,r=this.bitOffset,n=this.byteOffset,o=this.bytes;if(r>0){var i=8-r,a=t<i?t:i,u=255>>8-a<<(s=i-a);e=(o[n]&u)>>s,t-=a,8===(r+=a)&&(r=0,n++)}if(t>0){for(;t>=8;)e=e<<8|255&o[n],n++,t-=8;if(t>0){var s;u=255>>(s=8-t)<<s;e=e<<t|(o[n]&u)>>s,r+=t}}return this.bitOffset=r,this.byteOffset=n,e},t.prototype.available=function(){return 8*(this.bytes.length-this.byteOffset)-this.bitOffset},t}();!function(t){t[t.PAD_ENCODE=0]="PAD_ENCODE",t[t.ASCII_ENCODE=1]="ASCII_ENCODE",t[t.C40_ENCODE=2]="C40_ENCODE",t[t.TEXT_ENCODE=3]="TEXT_ENCODE",t[t.ANSIX12_ENCODE=4]="ANSIX12_ENCODE",t[t.EDIFACT_ENCODE=5]="EDIFACT_ENCODE",t[t.BASE256_ENCODE=6]="BASE256_ENCODE"}(lr||(lr={}));var Ar,Er=function(){function t(){}return t.decode=function(t){var e=new mr(t),r=new k,n=new k,o=new Array,i=lr.ASCII_ENCODE;do{if(i===lr.ASCII_ENCODE)i=this.decodeAsciiSegment(e,r,n);else{switch(i){case lr.C40_ENCODE:this.decodeC40Segment(e,r);break;case lr.TEXT_ENCODE:this.decodeTextSegment(e,r);break;case lr.ANSIX12_ENCODE:this.decodeAnsiX12Segment(e,r);break;case lr.EDIFACT_ENCODE:this.decodeEdifactSegment(e,r);break;case lr.BASE256_ENCODE:this.decodeBase256Segment(e,r,o);break;default:throw new R}i=lr.ASCII_ENCODE}}while(i!==lr.PAD_ENCODE&&e.available()>0);return n.length()>0&&r.append(n.toString()),new at(t,r.toString(),0===o.length?null:o,null)},t.decodeAsciiSegment=function(t,e,r){var n=!1;do{var o=t.readBits(8);if(0===o)throw new R;if(o<=128)return n&&(o+=128),e.append(String.fromCharCode(o-1)),lr.ASCII_ENCODE;if(129===o)return lr.PAD_ENCODE;if(o<=229){var i=o-130;i<10&&e.append("0"),e.append(""+i)}else switch(o){case 230:return lr.C40_ENCODE;case 231:return lr.BASE256_ENCODE;case 232:e.append(String.fromCharCode(29));break;case 233:case 234:case 241:break;case 235:n=!0;break;case 236:e.append("[)>05"),r.insert(0,"");break;case 237:e.append("[)>06"),r.insert(0,"");break;case 238:return lr.ANSIX12_ENCODE;case 239:return lr.TEXT_ENCODE;case 240:return lr.EDIFACT_ENCODE;default:if(254!==o||0!==t.available())throw new R}}while(t.available()>0);return lr.ASCII_ENCODE},t.decodeC40Segment=function(t,e){var r=!1,n=[],o=0;do{if(8===t.available())return;var i=t.readBits(8);if(254===i)return;this.parseTwoBytes(i,t.readBits(8),n);for(var a=0;a<3;a++){var u=n[a];switch(o){case 0:if(u<3)o=u+1;else{if(!(u<this.C40_BASIC_SET_CHARS.length))throw new R;var s=this.C40_BASIC_SET_CHARS[u];r?(e.append(String.fromCharCode(s.charCodeAt(0)+128)),r=!1):e.append(s)}break;case 1:r?(e.append(String.fromCharCode(u+128)),r=!1):e.append(String.fromCharCode(u)),o=0;break;case 2:if(u<this.C40_SHIFT2_SET_CHARS.length){s=this.C40_SHIFT2_SET_CHARS[u];r?(e.append(String.fromCharCode(s.charCodeAt(0)+128)),r=!1):e.append(s)}else switch(u){case 27:e.append(String.fromCharCode(29));break;case 30:r=!0;break;default:throw new R}o=0;break;case 3:r?(e.append(String.fromCharCode(u+224)),r=!1):e.append(String.fromCharCode(u+96)),o=0;break;default:throw new R}}}while(t.available()>0)},t.decodeTextSegment=function(t,e){var r=!1,n=[],o=0;do{if(8===t.available())return;var i=t.readBits(8);if(254===i)return;this.parseTwoBytes(i,t.readBits(8),n);for(var a=0;a<3;a++){var u=n[a];switch(o){case 0:if(u<3)o=u+1;else{if(!(u<this.TEXT_BASIC_SET_CHARS.length))throw new R;var s=this.TEXT_BASIC_SET_CHARS[u];r?(e.append(String.fromCharCode(s.charCodeAt(0)+128)),r=!1):e.append(s)}break;case 1:r?(e.append(String.fromCharCode(u+128)),r=!1):e.append(String.fromCharCode(u)),o=0;break;case 2:if(u<this.TEXT_SHIFT2_SET_CHARS.length){s=this.TEXT_SHIFT2_SET_CHARS[u];r?(e.append(String.fromCharCode(s.charCodeAt(0)+128)),r=!1):e.append(s)}else switch(u){case 27:e.append(String.fromCharCode(29));break;case 30:r=!0;break;default:throw new R}o=0;break;case 3:if(!(u<this.TEXT_SHIFT3_SET_CHARS.length))throw new R;s=this.TEXT_SHIFT3_SET_CHARS[u];r?(e.append(String.fromCharCode(s.charCodeAt(0)+128)),r=!1):e.append(s),o=0;break;default:throw new R}}}while(t.available()>0)},t.decodeAnsiX12Segment=function(t,e){var r=[];do{if(8===t.available())return;var n=t.readBits(8);if(254===n)return;this.parseTwoBytes(n,t.readBits(8),r);for(var o=0;o<3;o++){var i=r[o];switch(i){case 0:e.append("\r");break;case 1:e.append("*");break;case 2:e.append(">");break;case 3:e.append(" ");break;default:if(i<14)e.append(String.fromCharCode(i+44));else{if(!(i<40))throw new R;e.append(String.fromCharCode(i+51))}}}}while(t.available()>0)},t.parseTwoBytes=function(t,e,r){var n=(t<<8)+e-1,o=Math.floor(n/1600);r[0]=o,n-=1600*o,o=Math.floor(n/40),r[1]=o,r[2]=n-40*o},t.decodeEdifactSegment=function(t,e){do{if(t.available()<=16)return;for(var r=0;r<4;r++){var n=t.readBits(6);if(31===n){var o=8-t.getBitOffset();return void(8!==o&&t.readBits(o))}0==(32&n)&&(n|=64),e.append(String.fromCharCode(n))}}while(t.available()>0)},t.decodeBase256Segment=function(t,e,r){var n,o=1+t.getByteOffset(),i=this.unrandomize255State(t.readBits(8),o++);if((n=0===i?t.available()/8|0:i<250?i:250*(i-249)+this.unrandomize255State(t.readBits(8),o++))<0)throw new R;for(var a=new Uint8Array(n),u=0;u<n;u++){if(t.available()<8)throw new R;a[u]=this.unrandomize255State(t.readBits(8),o++)}r.push(a);try{e.append(L.decode(a,F.ISO88591))}catch(t){throw new yt("Platform does not support required encoding: "+t.message)}},t.unrandomize255State=function(t,e){var r=t-(149*e%255+1);return r>=0?r:r+256},t.C40_BASIC_SET_CHARS=["*","*","*"," ","0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],t.C40_SHIFT2_SET_CHARS=["!",'"',"#","$","%","&","'","(",")","*","+",",","-",".","/",":",";","<","=",">","?","@","[","\\","]","^","_"],t.TEXT_BASIC_SET_CHARS=["*","*","*"," ","0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"],t.TEXT_SHIFT2_SET_CHARS=t.C40_SHIFT2_SET_CHARS,t.TEXT_SHIFT3_SET_CHARS=["`","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","{","|","}","~",String.fromCharCode(127)],t}(),Cr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Ir=function(){function t(){this.rsDecoder=new wt(lt.DATA_MATRIX_FIELD_256)}return t.prototype.decode=function(t){var e,r,n=new wr(t),o=n.getVersion(),i=n.readCodewords(),a=vr.getDataBlocks(i,o),u=0;try{for(var s=Cr(a),c=s.next();!c.done;c=s.next()){u+=c.value.getNumDataCodewords()}}catch(t){e={error:t}}finally{try{c&&!c.done&&(r=s.return)&&r.call(s)}finally{if(e)throw e.error}}for(var f=new Uint8Array(u),h=a.length,l=0;l<h;l++){var d=a[l],p=d.getCodewords(),g=d.getNumDataCodewords();this.correctErrors(p,g);for(var y=0;y<g;y++)f[y*h+l]=p[y]}return Er.decode(f)},t.prototype.correctErrors=function(t,e){var r=new Int32Array(t);try{this.rsDecoder.decode(r,t.length-e)}catch(t){throw new g}for(var n=0;n<e;n++)t[n]=r[n]},t}(),Sr=function(){function t(t){this.image=t,this.rectangleDetector=new St(this.image)}return t.prototype.detect=function(){var e=this.rectangleDetector.detect(),r=this.detectSolid1(e);if((r=this.detectSolid2(r))[3]=this.correctTopRight(r),!r[3])throw new U;var n=(r=this.shiftToModuleCenter(r))[0],o=r[1],i=r[2],a=r[3],u=this.transitionsBetween(n,a)+1,s=this.transitionsBetween(i,a)+1;1==(1&u)&&(u+=1),1==(1&s)&&(s+=1),4*u<7*s&&4*s<7*u&&(u=s=Math.max(u,s));var c=t.sampleGrid(this.image,n,o,i,a,u,s);return new Et(c,[n,o,i,a])},t.shiftPoint=function(t,e,r){var n=(e.getX()-t.getX())/(r+1),o=(e.getY()-t.getY())/(r+1);return new At(t.getX()+n,t.getY()+o)},t.moveAway=function(t,e,r){var n=t.getX(),o=t.getY();return n<e?n-=1:n+=1,o<r?o-=1:o+=1,new At(n,o)},t.prototype.detectSolid1=function(t){var e=t[0],r=t[1],n=t[3],o=t[2],i=this.transitionsBetween(e,r),a=this.transitionsBetween(r,n),u=this.transitionsBetween(n,o),s=this.transitionsBetween(o,e),c=i,f=[o,e,r,n];return c>a&&(c=a,f[0]=e,f[1]=r,f[2]=n,f[3]=o),c>u&&(c=u,f[0]=r,f[1]=n,f[2]=o,f[3]=e),c>s&&(f[0]=n,f[1]=o,f[2]=e,f[3]=r),f},t.prototype.detectSolid2=function(e){var r=e[0],n=e[1],o=e[2],i=e[3],a=this.transitionsBetween(r,i),u=t.shiftPoint(n,o,4*(a+1)),s=t.shiftPoint(o,n,4*(a+1));return this.transitionsBetween(u,r)<this.transitionsBetween(s,i)?(e[0]=r,e[1]=n,e[2]=o,e[3]=i):(e[0]=n,e[1]=o,e[2]=i,e[3]=r),e},t.prototype.correctTopRight=function(e){var r=e[0],n=e[1],o=e[2],i=e[3],a=this.transitionsBetween(r,i),u=this.transitionsBetween(n,i),s=t.shiftPoint(r,n,4*(u+1)),c=t.shiftPoint(o,n,4*(a+1));a=this.transitionsBetween(s,i),u=this.transitionsBetween(c,i);var f=new At(i.getX()+(o.getX()-n.getX())/(a+1),i.getY()+(o.getY()-n.getY())/(a+1)),h=new At(i.getX()+(r.getX()-n.getX())/(u+1),i.getY()+(r.getY()-n.getY())/(u+1));return this.isValid(f)?this.isValid(h)?this.transitionsBetween(s,f)+this.transitionsBetween(c,f)>this.transitionsBetween(s,h)+this.transitionsBetween(c,h)?f:h:f:this.isValid(h)?h:null},t.prototype.shiftToModuleCenter=function(e){var r=e[0],n=e[1],o=e[2],i=e[3],a=this.transitionsBetween(r,i)+1,u=this.transitionsBetween(o,i)+1,s=t.shiftPoint(r,n,4*u),c=t.shiftPoint(o,n,4*a);1==(1&(a=this.transitionsBetween(s,i)+1))&&(a+=1),1==(1&(u=this.transitionsBetween(c,i)+1))&&(u+=1);var f,h,l=(r.getX()+n.getX()+o.getX()+i.getX())/4,d=(r.getY()+n.getY()+o.getY()+i.getY())/4;return r=t.moveAway(r,l,d),n=t.moveAway(n,l,d),o=t.moveAway(o,l,d),i=t.moveAway(i,l,d),s=t.shiftPoint(r,n,4*u),s=t.shiftPoint(s,i,4*a),f=t.shiftPoint(n,r,4*u),f=t.shiftPoint(f,o,4*a),c=t.shiftPoint(o,i,4*u),c=t.shiftPoint(c,n,4*a),h=t.shiftPoint(i,o,4*u),[s,f,c,h=t.shiftPoint(h,r,4*a)]},t.prototype.isValid=function(t){return t.getX()>=0&&t.getX()<this.image.getWidth()&&t.getY()>0&&t.getY()<this.image.getHeight()},t.sampleGrid=function(t,e,r,n,o,i,a){return Nt.getInstance().sampleGrid(t,i,a,.5,.5,i-.5,.5,i-.5,a-.5,.5,a-.5,e.getX(),e.getY(),o.getX(),o.getY(),n.getX(),n.getY(),r.getX(),r.getY())},t.prototype.transitionsBetween=function(t,e){var r=Math.trunc(t.getX()),n=Math.trunc(t.getY()),o=Math.trunc(e.getX()),i=Math.trunc(e.getY()),a=Math.abs(i-n)>Math.abs(o-r);if(a){var u=r;r=n,n=u,u=o,o=i,i=u}for(var s=Math.abs(o-r),c=Math.abs(i-n),f=-s/2,h=n<i?1:-1,l=r<o?1:-1,d=0,p=this.image.get(a?n:r,a?r:n),g=r,y=n;g!==o;g+=l){var w=this.image.get(a?y:g,a?g:y);if(w!==p&&(d++,p=w),(f+=c)>0){if(y===i)break;y+=h,f-=s}}return d},t}(),Or=function(){function t(){this.decoder=new Ir}return t.prototype.decode=function(e,r){var n,o;if(void 0===r&&(r=null),null!=r&&r.has(T.PURE_BARCODE)){var i=t.extractPureBits(e.getBlackMatrix());n=this.decoder.decode(i),o=t.NO_POINTS}else{var a=new Sr(e.getBlackMatrix()).detect();n=this.decoder.decode(a.getBits()),o=a.getPoints()}var u=n.getRawBytes(),s=new et(n.getText(),u,8*u.length,o,nt.DATA_MATRIX,w.currentTimeMillis()),c=n.getByteSegments();null!=c&&s.putMetadata(it.BYTE_SEGMENTS,c);var f=n.getECLevel();return null!=f&&s.putMetadata(it.ERROR_CORRECTION_LEVEL,f),s},t.prototype.reset=function(){},t.extractPureBits=function(t){var e=t.getTopLeftOnBit(),r=t.getBottomRightOnBit();if(null==e||null==r)throw new U;var n=this.moduleSize(e,t),o=e[1],i=r[1],a=e[0],u=(r[0]-a+1)/n,s=(i-o+1)/n;if(u<=0||s<=0)throw new U;var c=n/2;o+=c,a+=c;for(var f=new x(u,s),h=0;h<s;h++)for(var l=o+h*n,d=0;d<u;d++)t.get(a+d*n,l)&&f.set(d,h);return f},t.moduleSize=function(t,e){for(var r=e.getWidth(),n=t[0],o=t[1];n<r&&e.get(n,o);)n++;if(n===r)throw new U;var i=n-t[0];if(0===i)throw new U;return i},t.NO_POINTS=[],t}(),Tr=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e){return void 0===e&&(e=500),t.call(this,new Or,e)||this}Tr(e,t)}(tt),function(t){t[t.L=0]="L",t[t.M=1]="M",t[t.Q=2]="Q",t[t.H=3]="H"}(Ar||(Ar={}));var br,Rr=function(){function t(e,r,n){this.value=e,this.stringValue=r,this.bits=n,t.FOR_BITS.set(n,this),t.FOR_VALUE.set(e,this)}return t.prototype.getValue=function(){return this.value},t.prototype.getBits=function(){return this.bits},t.fromString=function(e){switch(e){case"L":return t.L;case"M":return t.M;case"Q":return t.Q;case"H":return t.H;default:throw new f(e+"not available")}},t.prototype.toString=function(){return this.stringValue},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.value===r.value},t.forBits=function(e){if(e<0||e>=t.FOR_BITS.size)throw new l;return t.FOR_BITS.get(e)},t.FOR_BITS=new Map,t.FOR_VALUE=new Map,t.L=new t(Ar.L,"L",1),t.M=new t(Ar.M,"M",0),t.Q=new t(Ar.Q,"Q",3),t.H=new t(Ar.H,"H",2),t}(),Nr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Dr=function(){function t(t){this.errorCorrectionLevel=Rr.forBits(t>>3&3),this.dataMask=7&t}return t.numBitsDiffering=function(t,e){return I.bitCount(t^e)},t.decodeFormatInformation=function(e,r){var n=t.doDecodeFormatInformation(e,r);return null!==n?n:t.doDecodeFormatInformation(e^t.FORMAT_INFO_MASK_QR,r^t.FORMAT_INFO_MASK_QR)},t.doDecodeFormatInformation=function(e,r){var n,o,i=Number.MAX_SAFE_INTEGER,a=0;try{for(var u=Nr(t.FORMAT_INFO_DECODE_LOOKUP),s=u.next();!s.done;s=u.next()){var c=s.value,f=c[0];if(f===e||f===r)return new t(c[1]);var h=t.numBitsDiffering(e,f);h<i&&(a=c[1],i=h),e!==r&&(h=t.numBitsDiffering(r,f))<i&&(a=c[1],i=h)}}catch(t){n={error:t}}finally{try{s&&!s.done&&(o=u.return)&&o.call(u)}finally{if(n)throw n.error}}return i<=3?new t(a):null},t.prototype.getErrorCorrectionLevel=function(){return this.errorCorrectionLevel},t.prototype.getDataMask=function(){return this.dataMask},t.prototype.hashCode=function(){return this.errorCorrectionLevel.getBits()<<3|this.dataMask},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.errorCorrectionLevel===r.errorCorrectionLevel&&this.dataMask===r.dataMask},t.FORMAT_INFO_MASK_QR=21522,t.FORMAT_INFO_DECODE_LOOKUP=[Int32Array.from([21522,0]),Int32Array.from([20773,1]),Int32Array.from([24188,2]),Int32Array.from([23371,3]),Int32Array.from([17913,4]),Int32Array.from([16590,5]),Int32Array.from([20375,6]),Int32Array.from([19104,7]),Int32Array.from([30660,8]),Int32Array.from([29427,9]),Int32Array.from([32170,10]),Int32Array.from([30877,11]),Int32Array.from([26159,12]),Int32Array.from([25368,13]),Int32Array.from([27713,14]),Int32Array.from([26998,15]),Int32Array.from([5769,16]),Int32Array.from([5054,17]),Int32Array.from([7399,18]),Int32Array.from([6608,19]),Int32Array.from([1890,20]),Int32Array.from([597,21]),Int32Array.from([3340,22]),Int32Array.from([2107,23]),Int32Array.from([13663,24]),Int32Array.from([12392,25]),Int32Array.from([16177,26]),Int32Array.from([14854,27]),Int32Array.from([9396,28]),Int32Array.from([8579,29]),Int32Array.from([11994,30]),Int32Array.from([11245,31])],t}(),Pr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Mr=function(){function t(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];this.ecCodewordsPerBlock=t,this.ecBlocks=e}return t.prototype.getECCodewordsPerBlock=function(){return this.ecCodewordsPerBlock},t.prototype.getNumBlocks=function(){var t,e,r=0,n=this.ecBlocks;try{for(var o=Pr(n),i=o.next();!i.done;i=o.next()){r+=i.value.getCount()}}catch(e){t={error:e}}finally{try{i&&!i.done&&(e=o.return)&&e.call(o)}finally{if(t)throw t.error}}return r},t.prototype.getTotalECCodewords=function(){return this.ecCodewordsPerBlock*this.getNumBlocks()},t.prototype.getECBlocks=function(){return this.ecBlocks},t}(),Br=function(){function t(t,e){this.count=t,this.dataCodewords=e}return t.prototype.getCount=function(){return this.count},t.prototype.getDataCodewords=function(){return this.dataCodewords},t}(),Lr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Fr=function(){function t(t,e){for(var r,n,o=[],i=2;i<arguments.length;i++)o[i-2]=arguments[i];this.versionNumber=t,this.alignmentPatternCenters=e,this.ecBlocks=o;var a=0,u=o[0].getECCodewordsPerBlock(),s=o[0].getECBlocks();try{for(var c=Lr(s),f=c.next();!f.done;f=c.next()){var h=f.value;a+=h.getCount()*(h.getDataCodewords()+u)}}catch(t){r={error:t}}finally{try{f&&!f.done&&(n=c.return)&&n.call(c)}finally{if(r)throw r.error}}this.totalCodewords=a}return t.prototype.getVersionNumber=function(){return this.versionNumber},t.prototype.getAlignmentPatternCenters=function(){return this.alignmentPatternCenters},t.prototype.getTotalCodewords=function(){return this.totalCodewords},t.prototype.getDimensionForVersion=function(){return 17+4*this.versionNumber},t.prototype.getECBlocksForLevel=function(t){return this.ecBlocks[t.getValue()]},t.getProvisionalVersionForDimension=function(t){if(t%4!=1)throw new R;try{return this.getVersionForNumber((t-17)/4)}catch(t){throw new R}},t.getVersionForNumber=function(e){if(e<1||e>40)throw new l;return t.VERSIONS[e-1]},t.decodeVersionInformation=function(e){for(var r=Number.MAX_SAFE_INTEGER,n=0,o=0;o<t.VERSION_DECODE_INFO.length;o++){var i=t.VERSION_DECODE_INFO[o];if(i===e)return t.getVersionForNumber(o+7);var a=Dr.numBitsDiffering(e,i);a<r&&(n=o+7,r=a)}return r<=3?t.getVersionForNumber(n):null},t.prototype.buildFunctionPattern=function(){var t=this.getDimensionForVersion(),e=new x(t);e.setRegion(0,0,9,9),e.setRegion(t-8,0,8,9),e.setRegion(0,t-8,9,8);for(var r=this.alignmentPatternCenters.length,n=0;n<r;n++)for(var o=this.alignmentPatternCenters[n]-2,i=0;i<r;i++)0===n&&(0===i||i===r-1)||n===r-1&&0===i||e.setRegion(this.alignmentPatternCenters[i]-2,o,5,5);return e.setRegion(6,9,1,t-17),e.setRegion(9,6,t-17,1),this.versionNumber>6&&(e.setRegion(t-11,0,3,6),e.setRegion(0,t-11,6,3)),e},t.prototype.toString=function(){return""+this.versionNumber},t.VERSION_DECODE_INFO=Int32Array.from([31892,34236,39577,42195,48118,51042,55367,58893,63784,68472,70749,76311,79154,84390,87683,92361,96236,102084,102881,110507,110734,117786,119615,126325,127568,133589,136944,141498,145311,150283,152622,158308,161089,167017]),t.VERSIONS=[new t(1,new Int32Array(0),new Mr(7,new Br(1,19)),new Mr(10,new Br(1,16)),new Mr(13,new Br(1,13)),new Mr(17,new Br(1,9))),new t(2,Int32Array.from([6,18]),new Mr(10,new Br(1,34)),new Mr(16,new Br(1,28)),new Mr(22,new Br(1,22)),new Mr(28,new Br(1,16))),new t(3,Int32Array.from([6,22]),new Mr(15,new Br(1,55)),new Mr(26,new Br(1,44)),new Mr(18,new Br(2,17)),new Mr(22,new Br(2,13))),new t(4,Int32Array.from([6,26]),new Mr(20,new Br(1,80)),new Mr(18,new Br(2,32)),new Mr(26,new Br(2,24)),new Mr(16,new Br(4,9))),new t(5,Int32Array.from([6,30]),new Mr(26,new Br(1,108)),new Mr(24,new Br(2,43)),new Mr(18,new Br(2,15),new Br(2,16)),new Mr(22,new Br(2,11),new Br(2,12))),new t(6,Int32Array.from([6,34]),new Mr(18,new Br(2,68)),new Mr(16,new Br(4,27)),new Mr(24,new Br(4,19)),new Mr(28,new Br(4,15))),new t(7,Int32Array.from([6,22,38]),new Mr(20,new Br(2,78)),new Mr(18,new Br(4,31)),new Mr(18,new Br(2,14),new Br(4,15)),new Mr(26,new Br(4,13),new Br(1,14))),new t(8,Int32Array.from([6,24,42]),new Mr(24,new Br(2,97)),new Mr(22,new Br(2,38),new Br(2,39)),new Mr(22,new Br(4,18),new Br(2,19)),new Mr(26,new Br(4,14),new Br(2,15))),new t(9,Int32Array.from([6,26,46]),new Mr(30,new Br(2,116)),new Mr(22,new Br(3,36),new Br(2,37)),new Mr(20,new Br(4,16),new Br(4,17)),new Mr(24,new Br(4,12),new Br(4,13))),new t(10,Int32Array.from([6,28,50]),new Mr(18,new Br(2,68),new Br(2,69)),new Mr(26,new Br(4,43),new Br(1,44)),new Mr(24,new Br(6,19),new Br(2,20)),new Mr(28,new Br(6,15),new Br(2,16))),new t(11,Int32Array.from([6,30,54]),new Mr(20,new Br(4,81)),new Mr(30,new Br(1,50),new Br(4,51)),new Mr(28,new Br(4,22),new Br(4,23)),new Mr(24,new Br(3,12),new Br(8,13))),new t(12,Int32Array.from([6,32,58]),new Mr(24,new Br(2,92),new Br(2,93)),new Mr(22,new Br(6,36),new Br(2,37)),new Mr(26,new Br(4,20),new Br(6,21)),new Mr(28,new Br(7,14),new Br(4,15))),new t(13,Int32Array.from([6,34,62]),new Mr(26,new Br(4,107)),new Mr(22,new Br(8,37),new Br(1,38)),new Mr(24,new Br(8,20),new Br(4,21)),new Mr(22,new Br(12,11),new Br(4,12))),new t(14,Int32Array.from([6,26,46,66]),new Mr(30,new Br(3,115),new Br(1,116)),new Mr(24,new Br(4,40),new Br(5,41)),new Mr(20,new Br(11,16),new Br(5,17)),new Mr(24,new Br(11,12),new Br(5,13))),new t(15,Int32Array.from([6,26,48,70]),new Mr(22,new Br(5,87),new Br(1,88)),new Mr(24,new Br(5,41),new Br(5,42)),new Mr(30,new Br(5,24),new Br(7,25)),new Mr(24,new Br(11,12),new Br(7,13))),new t(16,Int32Array.from([6,26,50,74]),new Mr(24,new Br(5,98),new Br(1,99)),new Mr(28,new Br(7,45),new Br(3,46)),new Mr(24,new Br(15,19),new Br(2,20)),new Mr(30,new Br(3,15),new Br(13,16))),new t(17,Int32Array.from([6,30,54,78]),new Mr(28,new Br(1,107),new Br(5,108)),new Mr(28,new Br(10,46),new Br(1,47)),new Mr(28,new Br(1,22),new Br(15,23)),new Mr(28,new Br(2,14),new Br(17,15))),new t(18,Int32Array.from([6,30,56,82]),new Mr(30,new Br(5,120),new Br(1,121)),new Mr(26,new Br(9,43),new Br(4,44)),new Mr(28,new Br(17,22),new Br(1,23)),new Mr(28,new Br(2,14),new Br(19,15))),new t(19,Int32Array.from([6,30,58,86]),new Mr(28,new Br(3,113),new Br(4,114)),new Mr(26,new Br(3,44),new Br(11,45)),new Mr(26,new Br(17,21),new Br(4,22)),new Mr(26,new Br(9,13),new Br(16,14))),new t(20,Int32Array.from([6,34,62,90]),new Mr(28,new Br(3,107),new Br(5,108)),new Mr(26,new Br(3,41),new Br(13,42)),new Mr(30,new Br(15,24),new Br(5,25)),new Mr(28,new Br(15,15),new Br(10,16))),new t(21,Int32Array.from([6,28,50,72,94]),new Mr(28,new Br(4,116),new Br(4,117)),new Mr(26,new Br(17,42)),new Mr(28,new Br(17,22),new Br(6,23)),new Mr(30,new Br(19,16),new Br(6,17))),new t(22,Int32Array.from([6,26,50,74,98]),new Mr(28,new Br(2,111),new Br(7,112)),new Mr(28,new Br(17,46)),new Mr(30,new Br(7,24),new Br(16,25)),new Mr(24,new Br(34,13))),new t(23,Int32Array.from([6,30,54,78,102]),new Mr(30,new Br(4,121),new Br(5,122)),new Mr(28,new Br(4,47),new Br(14,48)),new Mr(30,new Br(11,24),new Br(14,25)),new Mr(30,new Br(16,15),new Br(14,16))),new t(24,Int32Array.from([6,28,54,80,106]),new Mr(30,new Br(6,117),new Br(4,118)),new Mr(28,new Br(6,45),new Br(14,46)),new Mr(30,new Br(11,24),new Br(16,25)),new Mr(30,new Br(30,16),new Br(2,17))),new t(25,Int32Array.from([6,32,58,84,110]),new Mr(26,new Br(8,106),new Br(4,107)),new Mr(28,new Br(8,47),new Br(13,48)),new Mr(30,new Br(7,24),new Br(22,25)),new Mr(30,new Br(22,15),new Br(13,16))),new t(26,Int32Array.from([6,30,58,86,114]),new Mr(28,new Br(10,114),new Br(2,115)),new Mr(28,new Br(19,46),new Br(4,47)),new Mr(28,new Br(28,22),new Br(6,23)),new Mr(30,new Br(33,16),new Br(4,17))),new t(27,Int32Array.from([6,34,62,90,118]),new Mr(30,new Br(8,122),new Br(4,123)),new Mr(28,new Br(22,45),new Br(3,46)),new Mr(30,new Br(8,23),new Br(26,24)),new Mr(30,new Br(12,15),new Br(28,16))),new t(28,Int32Array.from([6,26,50,74,98,122]),new Mr(30,new Br(3,117),new Br(10,118)),new Mr(28,new Br(3,45),new Br(23,46)),new Mr(30,new Br(4,24),new Br(31,25)),new Mr(30,new Br(11,15),new Br(31,16))),new t(29,Int32Array.from([6,30,54,78,102,126]),new Mr(30,new Br(7,116),new Br(7,117)),new Mr(28,new Br(21,45),new Br(7,46)),new Mr(30,new Br(1,23),new Br(37,24)),new Mr(30,new Br(19,15),new Br(26,16))),new t(30,Int32Array.from([6,26,52,78,104,130]),new Mr(30,new Br(5,115),new Br(10,116)),new Mr(28,new Br(19,47),new Br(10,48)),new Mr(30,new Br(15,24),new Br(25,25)),new Mr(30,new Br(23,15),new Br(25,16))),new t(31,Int32Array.from([6,30,56,82,108,134]),new Mr(30,new Br(13,115),new Br(3,116)),new Mr(28,new Br(2,46),new Br(29,47)),new Mr(30,new Br(42,24),new Br(1,25)),new Mr(30,new Br(23,15),new Br(28,16))),new t(32,Int32Array.from([6,34,60,86,112,138]),new Mr(30,new Br(17,115)),new Mr(28,new Br(10,46),new Br(23,47)),new Mr(30,new Br(10,24),new Br(35,25)),new Mr(30,new Br(19,15),new Br(35,16))),new t(33,Int32Array.from([6,30,58,86,114,142]),new Mr(30,new Br(17,115),new Br(1,116)),new Mr(28,new Br(14,46),new Br(21,47)),new Mr(30,new Br(29,24),new Br(19,25)),new Mr(30,new Br(11,15),new Br(46,16))),new t(34,Int32Array.from([6,34,62,90,118,146]),new Mr(30,new Br(13,115),new Br(6,116)),new Mr(28,new Br(14,46),new Br(23,47)),new Mr(30,new Br(44,24),new Br(7,25)),new Mr(30,new Br(59,16),new Br(1,17))),new t(35,Int32Array.from([6,30,54,78,102,126,150]),new Mr(30,new Br(12,121),new Br(7,122)),new Mr(28,new Br(12,47),new Br(26,48)),new Mr(30,new Br(39,24),new Br(14,25)),new Mr(30,new Br(22,15),new Br(41,16))),new t(36,Int32Array.from([6,24,50,76,102,128,154]),new Mr(30,new Br(6,121),new Br(14,122)),new Mr(28,new Br(6,47),new Br(34,48)),new Mr(30,new Br(46,24),new Br(10,25)),new Mr(30,new Br(2,15),new Br(64,16))),new t(37,Int32Array.from([6,28,54,80,106,132,158]),new Mr(30,new Br(17,122),new Br(4,123)),new Mr(28,new Br(29,46),new Br(14,47)),new Mr(30,new Br(49,24),new Br(10,25)),new Mr(30,new Br(24,15),new Br(46,16))),new t(38,Int32Array.from([6,32,58,84,110,136,162]),new Mr(30,new Br(4,122),new Br(18,123)),new Mr(28,new Br(13,46),new Br(32,47)),new Mr(30,new Br(48,24),new Br(14,25)),new Mr(30,new Br(42,15),new Br(32,16))),new t(39,Int32Array.from([6,26,54,82,110,138,166]),new Mr(30,new Br(20,117),new Br(4,118)),new Mr(28,new Br(40,47),new Br(7,48)),new Mr(30,new Br(43,24),new Br(22,25)),new Mr(30,new Br(10,15),new Br(67,16))),new t(40,Int32Array.from([6,30,58,86,114,142,170]),new Mr(30,new Br(19,118),new Br(6,119)),new Mr(28,new Br(18,47),new Br(31,48)),new Mr(30,new Br(34,24),new Br(34,25)),new Mr(30,new Br(20,15),new Br(61,16)))],t}();!function(t){t[t.DATA_MASK_000=0]="DATA_MASK_000",t[t.DATA_MASK_001=1]="DATA_MASK_001",t[t.DATA_MASK_010=2]="DATA_MASK_010",t[t.DATA_MASK_011=3]="DATA_MASK_011",t[t.DATA_MASK_100=4]="DATA_MASK_100",t[t.DATA_MASK_101=5]="DATA_MASK_101",t[t.DATA_MASK_110=6]="DATA_MASK_110",t[t.DATA_MASK_111=7]="DATA_MASK_111"}(br||(br={}));var kr,xr=function(){function t(t,e){this.value=t,this.isMasked=e}return t.prototype.unmaskBitMatrix=function(t,e){for(var r=0;r<e;r++)for(var n=0;n<e;n++)this.isMasked(r,n)&&t.flip(n,r)},t.values=new Map([[br.DATA_MASK_000,new t(br.DATA_MASK_000,(function(t,e){return 0==(t+e&1)}))],[br.DATA_MASK_001,new t(br.DATA_MASK_001,(function(t,e){return 0==(1&t)}))],[br.DATA_MASK_010,new t(br.DATA_MASK_010,(function(t,e){return e%3==0}))],[br.DATA_MASK_011,new t(br.DATA_MASK_011,(function(t,e){return(t+e)%3==0}))],[br.DATA_MASK_100,new t(br.DATA_MASK_100,(function(t,e){return 0==(Math.floor(t/2)+Math.floor(e/3)&1)}))],[br.DATA_MASK_101,new t(br.DATA_MASK_101,(function(t,e){return t*e%6==0}))],[br.DATA_MASK_110,new t(br.DATA_MASK_110,(function(t,e){return t*e%6<3}))],[br.DATA_MASK_111,new t(br.DATA_MASK_111,(function(t,e){return 0==(t+e+t*e%3&1)}))]]),t}(),Vr=function(){function t(t){var e=t.getHeight();if(e<21||1!=(3&e))throw new R;this.bitMatrix=t}return t.prototype.readFormatInformation=function(){if(null!==this.parsedFormatInfo&&void 0!==this.parsedFormatInfo)return this.parsedFormatInfo;for(var t=0,e=0;e<6;e++)t=this.copyBit(e,8,t);t=this.copyBit(7,8,t),t=this.copyBit(8,8,t),t=this.copyBit(8,7,t);for(var r=5;r>=0;r--)t=this.copyBit(8,r,t);var n=this.bitMatrix.getHeight(),o=0,i=n-7;for(r=n-1;r>=i;r--)o=this.copyBit(8,r,o);for(e=n-8;e<n;e++)o=this.copyBit(e,8,o);if(this.parsedFormatInfo=Dr.decodeFormatInformation(t,o),null!==this.parsedFormatInfo)return this.parsedFormatInfo;throw new R},t.prototype.readVersion=function(){if(null!==this.parsedVersion&&void 0!==this.parsedVersion)return this.parsedVersion;var t=this.bitMatrix.getHeight(),e=Math.floor((t-17)/4);if(e<=6)return Fr.getVersionForNumber(e);for(var r=0,n=t-11,o=5;o>=0;o--)for(var i=t-9;i>=n;i--)r=this.copyBit(i,o,r);var a=Fr.decodeVersionInformation(r);if(null!==a&&a.getDimensionForVersion()===t)return this.parsedVersion=a,a;r=0;for(i=5;i>=0;i--)for(o=t-9;o>=n;o--)r=this.copyBit(i,o,r);if(null!==(a=Fr.decodeVersionInformation(r))&&a.getDimensionForVersion()===t)return this.parsedVersion=a,a;throw new R},t.prototype.copyBit=function(t,e,r){return(this.isMirror?this.bitMatrix.get(e,t):this.bitMatrix.get(t,e))?r<<1|1:r<<1},t.prototype.readCodewords=function(){var t=this.readFormatInformation(),e=this.readVersion(),r=xr.values.get(t.getDataMask()),n=this.bitMatrix.getHeight();r.unmaskBitMatrix(this.bitMatrix,n);for(var o=e.buildFunctionPattern(),i=!0,a=new Uint8Array(e.getTotalCodewords()),u=0,s=0,c=0,f=n-1;f>0;f-=2){6===f&&f--;for(var h=0;h<n;h++)for(var l=i?n-1-h:h,d=0;d<2;d++)o.get(f-d,l)||(c++,s<<=1,this.bitMatrix.get(f-d,l)&&(s|=1),8===c&&(a[u++]=s,c=0,s=0));i=!i}if(u!==e.getTotalCodewords())throw new R;return a},t.prototype.remask=function(){if(null!==this.parsedFormatInfo){var t=xr.values[this.parsedFormatInfo.getDataMask()],e=this.bitMatrix.getHeight();t.unmaskBitMatrix(this.bitMatrix,e)}},t.prototype.setMirror=function(t){this.parsedVersion=null,this.parsedFormatInfo=null,this.isMirror=t},t.prototype.mirror=function(){for(var t=this.bitMatrix,e=0,r=t.getWidth();e<r;e++)for(var n=e+1,o=t.getHeight();n<o;n++)t.get(e,n)!==t.get(n,e)&&(t.flip(n,e),t.flip(e,n))},t}(),Ur=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Hr=function(){function t(t,e){this.numDataCodewords=t,this.codewords=e}return t.getDataBlocks=function(e,r,n){var o,i,a,u;if(e.length!==r.getTotalCodewords())throw new l;var s=r.getECBlocksForLevel(n),c=0,f=s.getECBlocks();try{for(var h=Ur(f),d=h.next();!d.done;d=h.next()){c+=(_=d.value).getCount()}}catch(t){o={error:t}}finally{try{d&&!d.done&&(i=h.return)&&i.call(h)}finally{if(o)throw o.error}}var p=new Array(c),g=0;try{for(var y=Ur(f),w=y.next();!w.done;w=y.next())for(var _=w.value,v=0;v<_.getCount();v++){var m=_.getDataCodewords(),A=s.getECCodewordsPerBlock()+m;p[g++]=new t(m,new Uint8Array(A))}}catch(t){a={error:t}}finally{try{w&&!w.done&&(u=y.return)&&u.call(y)}finally{if(a)throw a.error}}for(var E=p[0].codewords.length,C=p.length-1;C>=0;){if(p[C].codewords.length===E)break;C--}C++;var I=E-s.getECCodewordsPerBlock(),S=0;for(v=0;v<I;v++)for(var O=0;O<g;O++)p[O].codewords[v]=e[S++];for(O=C;O<g;O++)p[O].codewords[I]=e[S++];var T=p[0].codewords.length;for(v=I;v<T;v++)for(O=0;O<g;O++){var b=O<C?v:v+1;p[O].codewords[b]=e[S++]}return p},t.prototype.getNumDataCodewords=function(){return this.numDataCodewords},t.prototype.getCodewords=function(){return this.codewords},t}();!function(t){t[t.TERMINATOR=0]="TERMINATOR",t[t.NUMERIC=1]="NUMERIC",t[t.ALPHANUMERIC=2]="ALPHANUMERIC",t[t.STRUCTURED_APPEND=3]="STRUCTURED_APPEND",t[t.BYTE=4]="BYTE",t[t.ECI=5]="ECI",t[t.KANJI=6]="KANJI",t[t.FNC1_FIRST_POSITION=7]="FNC1_FIRST_POSITION",t[t.FNC1_SECOND_POSITION=8]="FNC1_SECOND_POSITION",t[t.HANZI=9]="HANZI"}(kr||(kr={}));var Gr,Xr,Wr=function(){function t(e,r,n,o){this.value=e,this.stringValue=r,this.characterCountBitsForVersions=n,this.bits=o,t.FOR_BITS.set(o,this),t.FOR_VALUE.set(e,this)}return t.forBits=function(e){var r=t.FOR_BITS.get(e);if(void 0===r)throw new l;return r},t.prototype.getCharacterCountBits=function(t){var e,r=t.getVersionNumber();return e=r<=9?0:r<=26?1:2,this.characterCountBitsForVersions[e]},t.prototype.getValue=function(){return this.value},t.prototype.getBits=function(){return this.bits},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;return this.value===r.value},t.prototype.toString=function(){return this.stringValue},t.FOR_BITS=new Map,t.FOR_VALUE=new Map,t.TERMINATOR=new t(kr.TERMINATOR,"TERMINATOR",Int32Array.from([0,0,0]),0),t.NUMERIC=new t(kr.NUMERIC,"NUMERIC",Int32Array.from([10,12,14]),1),t.ALPHANUMERIC=new t(kr.ALPHANUMERIC,"ALPHANUMERIC",Int32Array.from([9,11,13]),2),t.STRUCTURED_APPEND=new t(kr.STRUCTURED_APPEND,"STRUCTURED_APPEND",Int32Array.from([0,0,0]),3),t.BYTE=new t(kr.BYTE,"BYTE",Int32Array.from([8,16,16]),4),t.ECI=new t(kr.ECI,"ECI",Int32Array.from([0,0,0]),7),t.KANJI=new t(kr.KANJI,"KANJI",Int32Array.from([8,10,12]),8),t.FNC1_FIRST_POSITION=new t(kr.FNC1_FIRST_POSITION,"FNC1_FIRST_POSITION",Int32Array.from([0,0,0]),5),t.FNC1_SECOND_POSITION=new t(kr.FNC1_SECOND_POSITION,"FNC1_SECOND_POSITION",Int32Array.from([0,0,0]),9),t.HANZI=new t(kr.HANZI,"HANZI",Int32Array.from([8,10,12]),13),t}(),jr=function(){function t(){}return t.decode=function(e,r,n,o){var i=new mr(e),a=new k,u=new Array,s=-1,c=-1;try{var f=null,h=!1,l=void 0;do{if(i.available()<4)l=Wr.TERMINATOR;else{var d=i.readBits(4);l=Wr.forBits(d)}switch(l){case Wr.TERMINATOR:break;case Wr.FNC1_FIRST_POSITION:case Wr.FNC1_SECOND_POSITION:h=!0;break;case Wr.STRUCTURED_APPEND:if(i.available()<16)throw new R;s=i.readBits(8),c=i.readBits(8);break;case Wr.ECI:var p=t.parseECIValue(i);if(null===(f=P.getCharacterSetECIByValue(p)))throw new R;break;case Wr.HANZI:var g=i.readBits(4),y=i.readBits(l.getCharacterCountBits(r));g===t.GB2312_SUBSET&&t.decodeHanziSegment(i,a,y);break;default:var w=i.readBits(l.getCharacterCountBits(r));switch(l){case Wr.NUMERIC:t.decodeNumericSegment(i,a,w);break;case Wr.ALPHANUMERIC:t.decodeAlphanumericSegment(i,a,w,h);break;case Wr.BYTE:t.decodeByteSegment(i,a,w,f,u,o);break;case Wr.KANJI:t.decodeKanjiSegment(i,a,w);break;default:throw new R}}}while(l!==Wr.TERMINATOR)}catch(t){throw new R}return new at(e,a.toString(),0===u.length?null:u,null===n?null:n.toString(),s,c)},t.decodeHanziSegment=function(t,e,r){if(13*r>t.available())throw new R;for(var n=new Uint8Array(2*r),o=0;r>0;){var i=t.readBits(13),a=i/96<<8&4294967295|i%96;a+=a<959?41377:42657,n[o]=a>>8&255,n[o+1]=255&a,o+=2,r--}try{e.append(L.decode(n,F.GB2312))}catch(t){throw new R(t)}},t.decodeKanjiSegment=function(t,e,r){if(13*r>t.available())throw new R;for(var n=new Uint8Array(2*r),o=0;r>0;){var i=t.readBits(13),a=i/192<<8&4294967295|i%192;a+=a<7936?33088:49472,n[o]=a>>8,n[o+1]=a,o+=2,r--}try{e.append(L.decode(n,F.SHIFT_JIS))}catch(t){throw new R(t)}},t.decodeByteSegment=function(t,e,r,n,o,i){if(8*r>t.available())throw new R;for(var a,u=new Uint8Array(r),s=0;s<r;s++)u[s]=t.readBits(8);a=null===n?F.guessEncoding(u,i):n.getName();try{e.append(L.decode(u,a))}catch(t){throw new R(t)}o.push(u)},t.toAlphaNumericChar=function(e){if(e>=t.ALPHANUMERIC_CHARS.length)throw new R;return t.ALPHANUMERIC_CHARS[e]},t.decodeAlphanumericSegment=function(e,r,n,o){for(var i=r.length();n>1;){if(e.available()<11)throw new R;var a=e.readBits(11);r.append(t.toAlphaNumericChar(Math.floor(a/45))),r.append(t.toAlphaNumericChar(a%45)),n-=2}if(1===n){if(e.available()<6)throw new R;r.append(t.toAlphaNumericChar(e.readBits(6)))}if(o)for(var u=i;u<r.length();u++)"%"===r.charAt(u)&&(u<r.length()-1&&"%"===r.charAt(u+1)?r.deleteCharAt(u+1):r.setCharAt(u,String.fromCharCode(29)))},t.decodeNumericSegment=function(e,r,n){for(;n>=3;){if(e.available()<10)throw new R;var o=e.readBits(10);if(o>=1e3)throw new R;r.append(t.toAlphaNumericChar(Math.floor(o/100))),r.append(t.toAlphaNumericChar(Math.floor(o/10)%10)),r.append(t.toAlphaNumericChar(o%10)),n-=3}if(2===n){if(e.available()<7)throw new R;var i=e.readBits(7);if(i>=100)throw new R;r.append(t.toAlphaNumericChar(Math.floor(i/10))),r.append(t.toAlphaNumericChar(i%10))}else if(1===n){if(e.available()<4)throw new R;var a=e.readBits(4);if(a>=10)throw new R;r.append(t.toAlphaNumericChar(a))}},t.parseECIValue=function(t){var e=t.readBits(8);if(0==(128&e))return 127&e;if(128==(192&e))return(63&e)<<8&4294967295|t.readBits(8);if(192==(224&e))return(31&e)<<16&4294967295|t.readBits(16);throw new R},t.ALPHANUMERIC_CHARS="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:",t.GB2312_SUBSET=1,t}(),zr=function(){function t(t){this.mirrored=t}return t.prototype.isMirrored=function(){return this.mirrored},t.prototype.applyMirroredCorrection=function(t){if(this.mirrored&&null!==t&&!(t.length<3)){var e=t[0];t[0]=t[2],t[2]=e}},t}(),Yr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Zr=function(){function t(){this.rsDecoder=new wt(lt.QR_CODE_FIELD_256)}return t.prototype.decodeBooleanArray=function(t,e){return this.decodeBitMatrix(x.parseFromBooleanArray(t),e)},t.prototype.decodeBitMatrix=function(t,e){var r=new Vr(t),n=null;try{return this.decodeBitMatrixParser(r,e)}catch(t){n=t}try{r.remask(),r.setMirror(!0),r.readVersion(),r.readFormatInformation(),r.mirror();var o=this.decodeBitMatrixParser(r,e);return o.setOther(new zr(!0)),o}catch(t){if(null!==n)throw n;throw t}},t.prototype.decodeBitMatrixParser=function(t,e){var r,n,o,i,a=t.readVersion(),u=t.readFormatInformation().getErrorCorrectionLevel(),s=t.readCodewords(),c=Hr.getDataBlocks(s,a,u),f=0;try{for(var h=Yr(c),l=h.next();!l.done;l=h.next()){f+=(w=l.value).getNumDataCodewords()}}catch(t){r={error:t}}finally{try{l&&!l.done&&(n=h.return)&&n.call(h)}finally{if(r)throw r.error}}var d=new Uint8Array(f),p=0;try{for(var g=Yr(c),y=g.next();!y.done;y=g.next()){var w,_=(w=y.value).getCodewords(),v=w.getNumDataCodewords();this.correctErrors(_,v);for(var m=0;m<v;m++)d[p++]=_[m]}}catch(t){o={error:t}}finally{try{y&&!y.done&&(i=g.return)&&i.call(g)}finally{if(o)throw o.error}}return jr.decode(d,a,u,e)},t.prototype.correctErrors=function(t,e){var r=new Int32Array(t);try{this.rsDecoder.decode(r,t.length-e)}catch(t){throw new g}for(var n=0;n<e;n++)t[n]=r[n]},t}(),Kr=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),qr=function(t){function e(e,r,n){var o=t.call(this,e,r)||this;return o.estimatedModuleSize=n,o}return Kr(e,t),e.prototype.aboutEquals=function(t,e,r){if(Math.abs(e-this.getY())<=t&&Math.abs(r-this.getX())<=t){var n=Math.abs(t-this.estimatedModuleSize);return n<=1||n<=this.estimatedModuleSize}return!1},e.prototype.combineEstimate=function(t,r,n){return new e((this.getX()+r)/2,(this.getY()+t)/2,(this.estimatedModuleSize+n)/2)},e}(At),Qr=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Jr=function(){function t(t,e,r,n,o,i,a){this.image=t,this.startX=e,this.startY=r,this.width=n,this.height=o,this.moduleSize=i,this.resultPointCallback=a,this.possibleCenters=[],this.crossCheckStateCount=new Int32Array(3)}return t.prototype.find=function(){for(var t=this.startX,e=this.height,r=t+this.width,n=this.startY+e/2,o=new Int32Array(3),i=this.image,a=0;a<e;a++){var u=n+(0==(1&a)?Math.floor((a+1)/2):-Math.floor((a+1)/2));o[0]=0,o[1]=0,o[2]=0;for(var s=t;s<r&&!i.get(s,u);)s++;for(var c=0;s<r;){if(i.get(s,u))if(1===c)o[1]++;else if(2===c){var f;if(this.foundPatternCross(o))if(null!==(f=this.handlePossibleCenter(o,u,s)))return f;o[0]=o[2],o[1]=1,o[2]=0,c=1}else o[++c]++;else 1===c&&c++,o[c]++;s++}if(this.foundPatternCross(o))if(null!==(f=this.handlePossibleCenter(o,u,r)))return f}if(0!==this.possibleCenters.length)return this.possibleCenters[0];throw new U},t.centerFromEnd=function(t,e){return e-t[2]-t[1]/2},t.prototype.foundPatternCross=function(t){for(var e=this.moduleSize,r=e/2,n=0;n<3;n++)if(Math.abs(e-t[n])>=r)return!1;return!0},t.prototype.crossCheckVertical=function(e,r,n,o){var i=this.image,a=i.getHeight(),u=this.crossCheckStateCount;u[0]=0,u[1]=0,u[2]=0;for(var s=e;s>=0&&i.get(r,s)&&u[1]<=n;)u[1]++,s--;if(s<0||u[1]>n)return NaN;for(;s>=0&&!i.get(r,s)&&u[0]<=n;)u[0]++,s--;if(u[0]>n)return NaN;for(s=e+1;s<a&&i.get(r,s)&&u[1]<=n;)u[1]++,s++;if(s===a||u[1]>n)return NaN;for(;s<a&&!i.get(r,s)&&u[2]<=n;)u[2]++,s++;if(u[2]>n)return NaN;var c=u[0]+u[1]+u[2];return 5*Math.abs(c-o)>=2*o?NaN:this.foundPatternCross(u)?t.centerFromEnd(u,s):NaN},t.prototype.handlePossibleCenter=function(e,r,n){var o,i,a=e[0]+e[1]+e[2],u=t.centerFromEnd(e,n),s=this.crossCheckVertical(r,u,2*e[1],a);if(!isNaN(s)){var c=(e[0]+e[1]+e[2])/3;try{for(var f=Qr(this.possibleCenters),h=f.next();!h.done;h=f.next()){var l=h.value;if(l.aboutEquals(c,s,u))return l.combineEstimate(s,u,c)}}catch(t){o={error:t}}finally{try{h&&!h.done&&(i=f.return)&&i.call(f)}finally{if(o)throw o.error}}var d=new qr(u,s,c);this.possibleCenters.push(d),null!==this.resultPointCallback&&void 0!==this.resultPointCallback&&this.resultPointCallback.foundPossibleResultPoint(d)}return null},t}(),$r=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),tn=function(t){function e(e,r,n,o){var i=t.call(this,e,r)||this;return i.estimatedModuleSize=n,i.count=o,void 0===o&&(i.count=1),i}return $r(e,t),e.prototype.getEstimatedModuleSize=function(){return this.estimatedModuleSize},e.prototype.getCount=function(){return this.count},e.prototype.aboutEquals=function(t,e,r){if(Math.abs(e-this.getY())<=t&&Math.abs(r-this.getX())<=t){var n=Math.abs(t-this.estimatedModuleSize);return n<=1||n<=this.estimatedModuleSize}return!1},e.prototype.combineEstimate=function(t,r,n){var o=this.count+1;return new e((this.count*this.getX()+r)/o,(this.count*this.getY()+t)/o,(this.count*this.estimatedModuleSize+n)/o,o)},e}(At),en=function(){function t(t){this.bottomLeft=t[0],this.topLeft=t[1],this.topRight=t[2]}return t.prototype.getBottomLeft=function(){return this.bottomLeft},t.prototype.getTopLeft=function(){return this.topLeft},t.prototype.getTopRight=function(){return this.topRight},t}(),rn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},nn=function(){function t(t,e){this.image=t,this.resultPointCallback=e,this.possibleCenters=[],this.crossCheckStateCount=new Int32Array(5),this.resultPointCallback=e}return t.prototype.getImage=function(){return this.image},t.prototype.getPossibleCenters=function(){return this.possibleCenters},t.prototype.find=function(e){var r=null!=e&&void 0!==e.get(T.TRY_HARDER),n=null!=e&&void 0!==e.get(T.PURE_BARCODE),o=this.image,i=o.getHeight(),a=o.getWidth(),u=Math.floor(3*i/(4*t.MAX_MODULES));(u<t.MIN_SKIP||r)&&(u=t.MIN_SKIP);for(var s=!1,c=new Int32Array(5),f=u-1;f<i&&!s;f+=u){c[0]=0,c[1]=0,c[2]=0,c[3]=0,c[4]=0;for(var h=0,l=0;l<a;l++)if(o.get(l,f))1==(1&h)&&h++,c[h]++;else if(0==(1&h))if(4===h)if(t.foundPatternCross(c)){if(!0!==this.handlePossibleCenter(c,f,l,n)){c[0]=c[2],c[1]=c[3],c[2]=c[4],c[3]=1,c[4]=0,h=3;continue}if(u=2,!0===this.hasSkipped)s=this.haveMultiplyConfirmedCenters();else{var d=this.findRowSkip();d>c[2]&&(f+=d-c[2]-u,l=a-1)}h=0,c[0]=0,c[1]=0,c[2]=0,c[3]=0,c[4]=0}else c[0]=c[2],c[1]=c[3],c[2]=c[4],c[3]=1,c[4]=0,h=3;else c[++h]++;else c[h]++;if(t.foundPatternCross(c))!0===this.handlePossibleCenter(c,f,a,n)&&(u=c[0],this.hasSkipped&&(s=this.haveMultiplyConfirmedCenters()))}var p=this.selectBestPatterns();return At.orderBestPatterns(p),new en(p)},t.centerFromEnd=function(t,e){return e-t[4]-t[3]-t[2]/2},t.foundPatternCross=function(t){for(var e=0,r=0;r<5;r++){var n=t[r];if(0===n)return!1;e+=n}if(e<7)return!1;var o=e/7,i=o/2;return Math.abs(o-t[0])<i&&Math.abs(o-t[1])<i&&Math.abs(3*o-t[2])<3*i&&Math.abs(o-t[3])<i&&Math.abs(o-t[4])<i},t.prototype.getCrossCheckStateCount=function(){var t=this.crossCheckStateCount;return t[0]=0,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t},t.prototype.crossCheckDiagonal=function(e,r,n,o){for(var i=this.getCrossCheckStateCount(),a=0,u=this.image;e>=a&&r>=a&&u.get(r-a,e-a);)i[2]++,a++;if(e<a||r<a)return!1;for(;e>=a&&r>=a&&!u.get(r-a,e-a)&&i[1]<=n;)i[1]++,a++;if(e<a||r<a||i[1]>n)return!1;for(;e>=a&&r>=a&&u.get(r-a,e-a)&&i[0]<=n;)i[0]++,a++;if(i[0]>n)return!1;var s=u.getHeight(),c=u.getWidth();for(a=1;e+a<s&&r+a<c&&u.get(r+a,e+a);)i[2]++,a++;if(e+a>=s||r+a>=c)return!1;for(;e+a<s&&r+a<c&&!u.get(r+a,e+a)&&i[3]<n;)i[3]++,a++;if(e+a>=s||r+a>=c||i[3]>=n)return!1;for(;e+a<s&&r+a<c&&u.get(r+a,e+a)&&i[4]<n;)i[4]++,a++;if(i[4]>=n)return!1;var f=i[0]+i[1]+i[2]+i[3]+i[4];return Math.abs(f-o)<2*o&&t.foundPatternCross(i)},t.prototype.crossCheckVertical=function(e,r,n,o){for(var i=this.image,a=i.getHeight(),u=this.getCrossCheckStateCount(),s=e;s>=0&&i.get(r,s);)u[2]++,s--;if(s<0)return NaN;for(;s>=0&&!i.get(r,s)&&u[1]<=n;)u[1]++,s--;if(s<0||u[1]>n)return NaN;for(;s>=0&&i.get(r,s)&&u[0]<=n;)u[0]++,s--;if(u[0]>n)return NaN;for(s=e+1;s<a&&i.get(r,s);)u[2]++,s++;if(s===a)return NaN;for(;s<a&&!i.get(r,s)&&u[3]<n;)u[3]++,s++;if(s===a||u[3]>=n)return NaN;for(;s<a&&i.get(r,s)&&u[4]<n;)u[4]++,s++;if(u[4]>=n)return NaN;var c=u[0]+u[1]+u[2]+u[3]+u[4];return 5*Math.abs(c-o)>=2*o?NaN:t.foundPatternCross(u)?t.centerFromEnd(u,s):NaN},t.prototype.crossCheckHorizontal=function(e,r,n,o){for(var i=this.image,a=i.getWidth(),u=this.getCrossCheckStateCount(),s=e;s>=0&&i.get(s,r);)u[2]++,s--;if(s<0)return NaN;for(;s>=0&&!i.get(s,r)&&u[1]<=n;)u[1]++,s--;if(s<0||u[1]>n)return NaN;for(;s>=0&&i.get(s,r)&&u[0]<=n;)u[0]++,s--;if(u[0]>n)return NaN;for(s=e+1;s<a&&i.get(s,r);)u[2]++,s++;if(s===a)return NaN;for(;s<a&&!i.get(s,r)&&u[3]<n;)u[3]++,s++;if(s===a||u[3]>=n)return NaN;for(;s<a&&i.get(s,r)&&u[4]<n;)u[4]++,s++;if(u[4]>=n)return NaN;var c=u[0]+u[1]+u[2]+u[3]+u[4];return 5*Math.abs(c-o)>=o?NaN:t.foundPatternCross(u)?t.centerFromEnd(u,s):NaN},t.prototype.handlePossibleCenter=function(e,r,n,o){var i=e[0]+e[1]+e[2]+e[3]+e[4],a=t.centerFromEnd(e,n),u=this.crossCheckVertical(r,Math.floor(a),e[2],i);if(!isNaN(u)&&(a=this.crossCheckHorizontal(Math.floor(a),Math.floor(u),e[2],i),!isNaN(a)&&(!o||this.crossCheckDiagonal(Math.floor(u),Math.floor(a),e[2],i)))){for(var s=i/7,c=!1,f=this.possibleCenters,h=0,l=f.length;h<l;h++){var d=f[h];if(d.aboutEquals(s,u,a)){f[h]=d.combineEstimate(u,a,s),c=!0;break}}if(!c){var p=new tn(a,u,s);f.push(p),null!==this.resultPointCallback&&void 0!==this.resultPointCallback&&this.resultPointCallback.foundPossibleResultPoint(p)}return!0}return!1},t.prototype.findRowSkip=function(){var e,r;if(this.possibleCenters.length<=1)return 0;var n=null;try{for(var o=rn(this.possibleCenters),i=o.next();!i.done;i=o.next()){var a=i.value;if(a.getCount()>=t.CENTER_QUORUM){if(null!=n)return this.hasSkipped=!0,Math.floor((Math.abs(n.getX()-a.getX())-Math.abs(n.getY()-a.getY()))/2);n=a}}}catch(t){e={error:t}}finally{try{i&&!i.done&&(r=o.return)&&r.call(o)}finally{if(e)throw e.error}}return 0},t.prototype.haveMultiplyConfirmedCenters=function(){var e,r,n,o,i=0,a=0,u=this.possibleCenters.length;try{for(var s=rn(this.possibleCenters),c=s.next();!c.done;c=s.next()){(p=c.value).getCount()>=t.CENTER_QUORUM&&(i++,a+=p.getEstimatedModuleSize())}}catch(t){e={error:t}}finally{try{c&&!c.done&&(r=s.return)&&r.call(s)}finally{if(e)throw e.error}}if(i<3)return!1;var f=a/u,h=0;try{for(var l=rn(this.possibleCenters),d=l.next();!d.done;d=l.next()){var p=d.value;h+=Math.abs(p.getEstimatedModuleSize()-f)}}catch(t){n={error:t}}finally{try{d&&!d.done&&(o=l.return)&&o.call(l)}finally{if(n)throw n.error}}return h<=.05*a},t.prototype.selectBestPatterns=function(){var t,e,r,n,o=this.possibleCenters.length;if(o<3)throw new U;var i,a=this.possibleCenters;if(o>3){var u=0,s=0;try{for(var c=rn(this.possibleCenters),f=c.next();!f.done;f=c.next()){var h=f.value.getEstimatedModuleSize();u+=h,s+=h*h}}catch(e){t={error:e}}finally{try{f&&!f.done&&(e=c.return)&&e.call(c)}finally{if(t)throw t.error}}i=u/o;var l=Math.sqrt(s/o-i*i);a.sort((function(t,e){var r=Math.abs(e.getEstimatedModuleSize()-i),n=Math.abs(t.getEstimatedModuleSize()-i);return r<n?-1:r>n?1:0}));for(var d=Math.max(.2*i,l),p=0;p<a.length&&a.length>3;p++){var g=a[p];Math.abs(g.getEstimatedModuleSize()-i)>d&&(a.splice(p,1),p--)}}if(a.length>3){u=0;try{for(var y=rn(a),w=y.next();!w.done;w=y.next()){u+=w.value.getEstimatedModuleSize()}}catch(t){r={error:t}}finally{try{w&&!w.done&&(n=y.return)&&n.call(y)}finally{if(r)throw r.error}}i=u/a.length,a.sort((function(t,e){if(e.getCount()===t.getCount()){var r=Math.abs(e.getEstimatedModuleSize()-i),n=Math.abs(t.getEstimatedModuleSize()-i);return r<n?1:r>n?-1:0}return e.getCount()-t.getCount()})),a.splice(3)}return[a[0],a[1],a[2]]},t.CENTER_QUORUM=2,t.MIN_SKIP=3,t.MAX_MODULES=57,t}(),on=function(){function t(t){this.image=t}return t.prototype.getImage=function(){return this.image},t.prototype.getResultPointCallback=function(){return this.resultPointCallback},t.prototype.detect=function(t){this.resultPointCallback=null==t?null:t.get(T.NEED_RESULT_POINT_CALLBACK);var e=new nn(this.image,this.resultPointCallback).find(t);return this.processFinderPatternInfo(e)},t.prototype.processFinderPatternInfo=function(e){var r=e.getTopLeft(),n=e.getTopRight(),o=e.getBottomLeft(),i=this.calculateModuleSize(r,n,o);if(i<1)throw new U("No pattern found in proccess finder.");var a=t.computeDimension(r,n,o,i),u=Fr.getProvisionalVersionForDimension(a),s=u.getDimensionForVersion()-7,c=null;if(u.getAlignmentPatternCenters().length>0)for(var f=n.getX()-r.getX()+o.getX(),h=n.getY()-r.getY()+o.getY(),l=1-3/s,d=Math.floor(r.getX()+l*(f-r.getX())),p=Math.floor(r.getY()+l*(h-r.getY())),g=4;g<=16;g<<=1)try{c=this.findAlignmentInRegion(i,d,p,g);break}catch(t){if(!(t instanceof U))throw t}var y=t.createTransform(r,n,o,c,a),w=t.sampleGrid(this.image,y,a);return new Et(w,null===c?[o,r,n]:[o,r,n,c])},t.createTransform=function(t,e,r,n,o){var i,a,u,s,c=o-3.5;return null!==n?(i=n.getX(),a=n.getY(),s=u=c-3):(i=e.getX()-t.getX()+r.getX(),a=e.getY()-t.getY()+r.getY(),u=c,s=c),Tt.quadrilateralToQuadrilateral(3.5,3.5,c,3.5,u,s,3.5,c,t.getX(),t.getY(),e.getX(),e.getY(),i,a,r.getX(),r.getY())},t.sampleGrid=function(t,e,r){return Nt.getInstance().sampleGridWithTransform(t,r,r,e)},t.computeDimension=function(t,e,r,n){var o=vt.round(At.distance(t,e)/n),i=vt.round(At.distance(t,r)/n),a=Math.floor((o+i)/2)+7;switch(3&a){case 0:a++;break;case 2:a--;break;case 3:throw new U("Dimensions could be not found.")}return a},t.prototype.calculateModuleSize=function(t,e,r){return(this.calculateModuleSizeOneWay(t,e)+this.calculateModuleSizeOneWay(t,r))/2},t.prototype.calculateModuleSizeOneWay=function(t,e){var r=this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()),Math.floor(t.getY()),Math.floor(e.getX()),Math.floor(e.getY())),n=this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()),Math.floor(e.getY()),Math.floor(t.getX()),Math.floor(t.getY()));return isNaN(r)?n/7:isNaN(n)?r/7:(r+n)/14},t.prototype.sizeOfBlackWhiteBlackRunBothWays=function(t,e,r,n){var o=this.sizeOfBlackWhiteBlackRun(t,e,r,n),i=1,a=t-(r-t);a<0?(i=t/(t-a),a=0):a>=this.image.getWidth()&&(i=(this.image.getWidth()-1-t)/(a-t),a=this.image.getWidth()-1);var u=Math.floor(e-(n-e)*i);return i=1,u<0?(i=e/(e-u),u=0):u>=this.image.getHeight()&&(i=(this.image.getHeight()-1-e)/(u-e),u=this.image.getHeight()-1),a=Math.floor(t+(a-t)*i),(o+=this.sizeOfBlackWhiteBlackRun(t,e,a,u))-1},t.prototype.sizeOfBlackWhiteBlackRun=function(t,e,r,n){var o=Math.abs(n-e)>Math.abs(r-t);if(o){var i=t;t=e,e=i,i=r,r=n,n=i}for(var a=Math.abs(r-t),u=Math.abs(n-e),s=-a/2,c=t<r?1:-1,f=e<n?1:-1,h=0,l=r+c,d=t,p=e;d!==l;d+=c){var g=o?p:d,y=o?d:p;if(1===h===this.image.get(g,y)){if(2===h)return vt.distance(d,p,t,e);h++}if((s+=u)>0){if(p===n)break;p+=f,s-=a}}return 2===h?vt.distance(r+c,n,t,e):NaN},t.prototype.findAlignmentInRegion=function(t,e,r,n){var o=Math.floor(n*t),i=Math.max(0,e-o),a=Math.min(this.image.getWidth()-1,e+o);if(a-i<3*t)throw new U("Alignment top exceeds estimated module size.");var u=Math.max(0,r-o),s=Math.min(this.image.getHeight()-1,r+o);if(s-u<3*t)throw new U("Alignment bottom exceeds estimated module size.");return new Jr(this.image,i,u,a-i,s-u,t,this.resultPointCallback).find()},t}(),an=function(){function t(){this.decoder=new Zr}return t.prototype.getDecoder=function(){return this.decoder},t.prototype.decode=function(e,r){var n,o;if(null!=r&&void 0!==r.get(T.PURE_BARCODE)){var i=t.extractPureBits(e.getBlackMatrix());n=this.decoder.decodeBitMatrix(i,r),o=t.NO_POINTS}else{var a=new on(e.getBlackMatrix()).detect(r);n=this.decoder.decodeBitMatrix(a.getBits(),r),o=a.getPoints()}n.getOther()instanceof zr&&n.getOther().applyMirroredCorrection(o);var u=new et(n.getText(),n.getRawBytes(),void 0,o,nt.QR_CODE,void 0),s=n.getByteSegments();null!==s&&u.putMetadata(it.BYTE_SEGMENTS,s);var c=n.getECLevel();return null!==c&&u.putMetadata(it.ERROR_CORRECTION_LEVEL,c),n.hasStructuredAppend()&&(u.putMetadata(it.STRUCTURED_APPEND_SEQUENCE,n.getStructuredAppendSequenceNumber()),u.putMetadata(it.STRUCTURED_APPEND_PARITY,n.getStructuredAppendParity())),u},t.prototype.reset=function(){},t.extractPureBits=function(t){var e=t.getTopLeftOnBit(),r=t.getBottomRightOnBit();if(null===e||null===r)throw new U;var n=this.moduleSize(e,t),o=e[1],i=r[1],a=e[0],u=r[0];if(a>=u||o>=i)throw new U;if(i-o!=u-a&&(u=a+(i-o))>=t.getWidth())throw new U;var s=Math.round((u-a+1)/n),c=Math.round((i-o+1)/n);if(s<=0||c<=0)throw new U;if(c!==s)throw new U;var f=Math.floor(n/2);o+=f;var h=(a+=f)+Math.floor((s-1)*n)-u;if(h>0){if(h>f)throw new U;a-=h}var l=o+Math.floor((c-1)*n)-i;if(l>0){if(l>f)throw new U;o-=l}for(var d=new x(s,c),p=0;p<c;p++)for(var g=o+Math.floor(p*n),y=0;y<s;y++)t.get(a+Math.floor(y*n),g)&&d.set(y,p);return d},t.moduleSize=function(t,e){for(var r=e.getHeight(),n=e.getWidth(),o=t[0],i=t[1],a=!0,u=0;o<n&&i<r;){if(a!==e.get(o,i)){if(5==++u)break;a=!a}o++,i++}if(o===n||i===r)throw new U;return(o-t[0])/7},t.NO_POINTS=new Array,t}(),un=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},sn=function(){function t(){}return t.prototype.PDF417Common=function(){},t.getBitCountSum=function(t){return vt.sum(t)},t.toIntArray=function(e){var r,n;if(null==e||!e.length)return t.EMPTY_INT_ARRAY;var o=new Int32Array(e.length),i=0;try{for(var a=un(e),u=a.next();!u.done;u=a.next()){var s=u.value;o[i++]=s}}catch(t){r={error:t}}finally{try{u&&!u.done&&(n=a.return)&&n.call(a)}finally{if(r)throw r.error}}return o},t.getCodeword=function(e){var r=C.binarySearch(t.SYMBOL_TABLE,262143&e);return r<0?-1:(t.CODEWORD_TABLE[r]-1)%t.NUMBER_OF_CODEWORDS},t.NUMBER_OF_CODEWORDS=929,t.MAX_CODEWORDS_IN_BARCODE=t.NUMBER_OF_CODEWORDS-1,t.MIN_ROWS_IN_BARCODE=3,t.MAX_ROWS_IN_BARCODE=90,t.MODULES_IN_CODEWORD=17,t.MODULES_IN_STOP_PATTERN=18,t.BARS_IN_MODULE=8,t.EMPTY_INT_ARRAY=new Int32Array([]),t.SYMBOL_TABLE=Int32Array.from([66142,66170,66206,66236,66290,66292,66350,66382,66396,66454,66470,66476,66594,66600,66614,66626,66628,66632,66640,66654,66662,66668,66682,66690,66718,66720,66748,66758,66776,66798,66802,66804,66820,66824,66832,66846,66848,66876,66880,66936,66950,66956,66968,66992,67006,67022,67036,67042,67044,67048,67062,67118,67150,67164,67214,67228,67256,67294,67322,67350,67366,67372,67398,67404,67416,67438,67474,67476,67490,67492,67496,67510,67618,67624,67650,67656,67664,67678,67686,67692,67706,67714,67716,67728,67742,67744,67772,67782,67788,67800,67822,67826,67828,67842,67848,67870,67872,67900,67904,67960,67974,67992,68016,68030,68046,68060,68066,68068,68072,68086,68104,68112,68126,68128,68156,68160,68216,68336,68358,68364,68376,68400,68414,68448,68476,68494,68508,68536,68546,68548,68552,68560,68574,68582,68588,68654,68686,68700,68706,68708,68712,68726,68750,68764,68792,68802,68804,68808,68816,68830,68838,68844,68858,68878,68892,68920,68976,68990,68994,68996,69e3,69008,69022,69024,69052,69062,69068,69080,69102,69106,69108,69142,69158,69164,69190,69208,69230,69254,69260,69272,69296,69310,69326,69340,69386,69394,69396,69410,69416,69430,69442,69444,69448,69456,69470,69478,69484,69554,69556,69666,69672,69698,69704,69712,69726,69754,69762,69764,69776,69790,69792,69820,69830,69836,69848,69870,69874,69876,69890,69918,69920,69948,69952,70008,70022,70040,70064,70078,70094,70108,70114,70116,70120,70134,70152,70174,70176,70264,70384,70412,70448,70462,70496,70524,70542,70556,70584,70594,70600,70608,70622,70630,70636,70664,70672,70686,70688,70716,70720,70776,70896,71136,71180,71192,71216,71230,71264,71292,71360,71416,71452,71480,71536,71550,71554,71556,71560,71568,71582,71584,71612,71622,71628,71640,71662,71726,71732,71758,71772,71778,71780,71784,71798,71822,71836,71864,71874,71880,71888,71902,71910,71916,71930,71950,71964,71992,72048,72062,72066,72068,72080,72094,72096,72124,72134,72140,72152,72174,72178,72180,72206,72220,72248,72304,72318,72416,72444,72456,72464,72478,72480,72508,72512,72568,72588,72600,72624,72638,72654,72668,72674,72676,72680,72694,72726,72742,72748,72774,72780,72792,72814,72838,72856,72880,72894,72910,72924,72930,72932,72936,72950,72966,72972,72984,73008,73022,73056,73084,73102,73116,73144,73156,73160,73168,73182,73190,73196,73210,73226,73234,73236,73250,73252,73256,73270,73282,73284,73296,73310,73318,73324,73346,73348,73352,73360,73374,73376,73404,73414,73420,73432,73454,73498,73518,73522,73524,73550,73564,73570,73572,73576,73590,73800,73822,73858,73860,73872,73886,73888,73916,73944,73970,73972,73992,74014,74016,74044,74048,74104,74118,74136,74160,74174,74210,74212,74216,74230,74244,74256,74270,74272,74360,74480,74502,74508,74544,74558,74592,74620,74638,74652,74680,74690,74696,74704,74726,74732,74782,74784,74812,74992,75232,75288,75326,75360,75388,75456,75512,75576,75632,75646,75650,75652,75664,75678,75680,75708,75718,75724,75736,75758,75808,75836,75840,75896,76016,76256,76736,76824,76848,76862,76896,76924,76992,77048,77296,77340,77368,77424,77438,77536,77564,77572,77576,77584,77600,77628,77632,77688,77702,77708,77720,77744,77758,77774,77788,77870,77902,77916,77922,77928,77966,77980,78008,78018,78024,78032,78046,78060,78074,78094,78136,78192,78206,78210,78212,78224,78238,78240,78268,78278,78284,78296,78322,78324,78350,78364,78448,78462,78560,78588,78600,78622,78624,78652,78656,78712,78726,78744,78768,78782,78798,78812,78818,78820,78824,78838,78862,78876,78904,78960,78974,79072,79100,79296,79352,79368,79376,79390,79392,79420,79424,79480,79600,79628,79640,79664,79678,79712,79740,79772,79800,79810,79812,79816,79824,79838,79846,79852,79894,79910,79916,79942,79948,79960,79982,79988,80006,80024,80048,80062,80078,80092,80098,80100,80104,80134,80140,80176,80190,80224,80252,80270,80284,80312,80328,80336,80350,80358,80364,80378,80390,80396,80408,80432,80446,80480,80508,80576,80632,80654,80668,80696,80752,80766,80776,80784,80798,80800,80828,80844,80856,80878,80882,80884,80914,80916,80930,80932,80936,80950,80962,80968,80976,80990,80998,81004,81026,81028,81040,81054,81056,81084,81094,81100,81112,81134,81154,81156,81160,81168,81182,81184,81212,81216,81272,81286,81292,81304,81328,81342,81358,81372,81380,81384,81398,81434,81454,81458,81460,81486,81500,81506,81508,81512,81526,81550,81564,81592,81602,81604,81608,81616,81630,81638,81644,81702,81708,81722,81734,81740,81752,81774,81778,81780,82050,82078,82080,82108,82180,82184,82192,82206,82208,82236,82240,82296,82316,82328,82352,82366,82402,82404,82408,82440,82448,82462,82464,82492,82496,82552,82672,82694,82700,82712,82736,82750,82784,82812,82830,82882,82884,82888,82896,82918,82924,82952,82960,82974,82976,83004,83008,83064,83184,83424,83468,83480,83504,83518,83552,83580,83648,83704,83740,83768,83824,83838,83842,83844,83848,83856,83872,83900,83910,83916,83928,83950,83984,84e3,84028,84032,84088,84208,84448,84928,85040,85054,85088,85116,85184,85240,85488,85560,85616,85630,85728,85756,85764,85768,85776,85790,85792,85820,85824,85880,85894,85900,85912,85936,85966,85980,86048,86080,86136,86256,86496,86976,88160,88188,88256,88312,88560,89056,89200,89214,89312,89340,89536,89592,89608,89616,89632,89664,89720,89840,89868,89880,89904,89952,89980,89998,90012,90040,90190,90204,90254,90268,90296,90306,90308,90312,90334,90382,90396,90424,90480,90494,90500,90504,90512,90526,90528,90556,90566,90572,90584,90610,90612,90638,90652,90680,90736,90750,90848,90876,90884,90888,90896,90910,90912,90940,90944,91e3,91014,91020,91032,91056,91070,91086,91100,91106,91108,91112,91126,91150,91164,91192,91248,91262,91360,91388,91584,91640,91664,91678,91680,91708,91712,91768,91888,91928,91952,91966,92e3,92028,92046,92060,92088,92098,92100,92104,92112,92126,92134,92140,92188,92216,92272,92384,92412,92608,92664,93168,93200,93214,93216,93244,93248,93304,93424,93664,93720,93744,93758,93792,93820,93888,93944,93980,94008,94064,94078,94084,94088,94096,94110,94112,94140,94150,94156,94168,94246,94252,94278,94284,94296,94318,94342,94348,94360,94384,94398,94414,94428,94440,94470,94476,94488,94512,94526,94560,94588,94606,94620,94648,94658,94660,94664,94672,94686,94694,94700,94714,94726,94732,94744,94768,94782,94816,94844,94912,94968,94990,95004,95032,95088,95102,95112,95120,95134,95136,95164,95180,95192,95214,95218,95220,95244,95256,95280,95294,95328,95356,95424,95480,95728,95758,95772,95800,95856,95870,95968,95996,96008,96016,96030,96032,96060,96064,96120,96152,96176,96190,96220,96226,96228,96232,96290,96292,96296,96310,96322,96324,96328,96336,96350,96358,96364,96386,96388,96392,96400,96414,96416,96444,96454,96460,96472,96494,96498,96500,96514,96516,96520,96528,96542,96544,96572,96576,96632,96646,96652,96664,96688,96702,96718,96732,96738,96740,96744,96758,96772,96776,96784,96798,96800,96828,96832,96888,97008,97030,97036,97048,97072,97086,97120,97148,97166,97180,97208,97220,97224,97232,97246,97254,97260,97326,97330,97332,97358,97372,97378,97380,97384,97398,97422,97436,97464,97474,97476,97480,97488,97502,97510,97516,97550,97564,97592,97648,97666,97668,97672,97680,97694,97696,97724,97734,97740,97752,97774,97830,97836,97850,97862,97868,97880,97902,97906,97908,97926,97932,97944,97968,97998,98012,98018,98020,98024,98038,98618,98674,98676,98838,98854,98874,98892,98904,98926,98930,98932,98968,99006,99042,99044,99048,99062,99166,99194,99246,99286,99350,99366,99372,99386,99398,99416,99438,99442,99444,99462,99504,99518,99534,99548,99554,99556,99560,99574,99590,99596,99608,99632,99646,99680,99708,99726,99740,99768,99778,99780,99784,99792,99806,99814,99820,99834,99858,99860,99874,99880,99894,99906,99920,99934,99962,99970,99972,99976,99984,99998,1e5,100028,100038,100044,100056,100078,100082,100084,100142,100174,100188,100246,100262,100268,100306,100308,100390,100396,100410,100422,100428,100440,100462,100466,100468,100486,100504,100528,100542,100558,100572,100578,100580,100584,100598,100620,100656,100670,100704,100732,100750,100792,100802,100808,100816,100830,100838,100844,100858,100888,100912,100926,100960,100988,101056,101112,101148,101176,101232,101246,101250,101252,101256,101264,101278,101280,101308,101318,101324,101336,101358,101362,101364,101410,101412,101416,101430,101442,101448,101456,101470,101478,101498,101506,101508,101520,101534,101536,101564,101580,101618,101620,101636,101640,101648,101662,101664,101692,101696,101752,101766,101784,101838,101858,101860,101864,101934,101938,101940,101966,101980,101986,101988,101992,102030,102044,102072,102082,102084,102088,102096,102138,102166,102182,102188,102214,102220,102232,102254,102282,102290,102292,102306,102308,102312,102326,102444,102458,102470,102476,102488,102514,102516,102534,102552,102576,102590,102606,102620,102626,102632,102646,102662,102668,102704,102718,102752,102780,102798,102812,102840,102850,102856,102864,102878,102886,102892,102906,102936,102974,103008,103036,103104,103160,103224,103280,103294,103298,103300,103312,103326,103328,103356,103366,103372,103384,103406,103410,103412,103472,103486,103520,103548,103616,103672,103920,103992,104048,104062,104160,104188,104194,104196,104200,104208,104224,104252,104256,104312,104326,104332,104344,104368,104382,104398,104412,104418,104420,104424,104482,104484,104514,104520,104528,104542,104550,104570,104578,104580,104592,104606,104608,104636,104652,104690,104692,104706,104712,104734,104736,104764,104768,104824,104838,104856,104910,104930,104932,104936,104968,104976,104990,104992,105020,105024,105080,105200,105240,105278,105312,105372,105410,105412,105416,105424,105446,105518,105524,105550,105564,105570,105572,105576,105614,105628,105656,105666,105672,105680,105702,105722,105742,105756,105784,105840,105854,105858,105860,105864,105872,105888,105932,105970,105972,106006,106022,106028,106054,106060,106072,106100,106118,106124,106136,106160,106174,106190,106210,106212,106216,106250,106258,106260,106274,106276,106280,106306,106308,106312,106320,106334,106348,106394,106414,106418,106420,106566,106572,106610,106612,106630,106636,106648,106672,106686,106722,106724,106728,106742,106758,106764,106776,106800,106814,106848,106876,106894,106908,106936,106946,106948,106952,106960,106974,106982,106988,107032,107056,107070,107104,107132,107200,107256,107292,107320,107376,107390,107394,107396,107400,107408,107422,107424,107452,107462,107468,107480,107502,107506,107508,107544,107568,107582,107616,107644,107712,107768,108016,108060,108088,108144,108158,108256,108284,108290,108292,108296,108304,108318,108320,108348,108352,108408,108422,108428,108440,108464,108478,108494,108508,108514,108516,108520,108592,108640,108668,108736,108792,109040,109536,109680,109694,109792,109820,110016,110072,110084,110088,110096,110112,110140,110144,110200,110320,110342,110348,110360,110384,110398,110432,110460,110478,110492,110520,110532,110536,110544,110558,110658,110686,110714,110722,110724,110728,110736,110750,110752,110780,110796,110834,110836,110850,110852,110856,110864,110878,110880,110908,110912,110968,110982,111e3,111054,111074,111076,111080,111108,111112,111120,111134,111136,111164,111168,111224,111344,111372,111422,111456,111516,111554,111556,111560,111568,111590,111632,111646,111648,111676,111680,111736,111856,112096,112152,112224,112252,112320,112440,112514,112516,112520,112528,112542,112544,112588,112686,112718,112732,112782,112796,112824,112834,112836,112840,112848,112870,112890,112910,112924,112952,113008,113022,113026,113028,113032,113040,113054,113056,113100,113138,113140,113166,113180,113208,113264,113278,113376,113404,113416,113424,113440,113468,113472,113560,113614,113634,113636,113640,113686,113702,113708,113734,113740,113752,113778,113780,113798,113804,113816,113840,113854,113870,113890,113892,113896,113926,113932,113944,113968,113982,114016,114044,114076,114114,114116,114120,114128,114150,114170,114194,114196,114210,114212,114216,114242,114244,114248,114256,114270,114278,114306,114308,114312,114320,114334,114336,114364,114380,114420,114458,114478,114482,114484,114510,114524,114530,114532,114536,114842,114866,114868,114970,114994,114996,115042,115044,115048,115062,115130,115226,115250,115252,115278,115292,115298,115300,115304,115318,115342,115394,115396,115400,115408,115422,115430,115436,115450,115478,115494,115514,115526,115532,115570,115572,115738,115758,115762,115764,115790,115804,115810,115812,115816,115830,115854,115868,115896,115906,115912,115920,115934,115942,115948,115962,115996,116024,116080,116094,116098,116100,116104,116112,116126,116128,116156,116166,116172,116184,116206,116210,116212,116246,116262,116268,116282,116294,116300,116312,116334,116338,116340,116358,116364,116376,116400,116414,116430,116444,116450,116452,116456,116498,116500,116514,116520,116534,116546,116548,116552,116560,116574,116582,116588,116602,116654,116694,116714,116762,116782,116786,116788,116814,116828,116834,116836,116840,116854,116878,116892,116920,116930,116936,116944,116958,116966,116972,116986,117006,117048,117104,117118,117122,117124,117136,117150,117152,117180,117190,117196,117208,117230,117234,117236,117304,117360,117374,117472,117500,117506,117508,117512,117520,117536,117564,117568,117624,117638,117644,117656,117680,117694,117710,117724,117730,117732,117736,117750,117782,117798,117804,117818,117830,117848,117874,117876,117894,117936,117950,117966,117986,117988,117992,118022,118028,118040,118064,118078,118112,118140,118172,118210,118212,118216,118224,118238,118246,118266,118306,118312,118338,118352,118366,118374,118394,118402,118404,118408,118416,118430,118432,118460,118476,118514,118516,118574,118578,118580,118606,118620,118626,118628,118632,118678,118694,118700,118730,118738,118740,118830,118834,118836,118862,118876,118882,118884,118888,118902,118926,118940,118968,118978,118980,118984,118992,119006,119014,119020,119034,119068,119096,119152,119166,119170,119172,119176,119184,119198,119200,119228,119238,119244,119256,119278,119282,119284,119324,119352,119408,119422,119520,119548,119554,119556,119560,119568,119582,119584,119612,119616,119672,119686,119692,119704,119728,119742,119758,119772,119778,119780,119784,119798,119920,119934,120032,120060,120256,120312,120324,120328,120336,120352,120384,120440,120560,120582,120588,120600,120624,120638,120672,120700,120718,120732,120760,120770,120772,120776,120784,120798,120806,120812,120870,120876,120890,120902,120908,120920,120946,120948,120966,120972,120984,121008,121022,121038,121058,121060,121064,121078,121100,121112,121136,121150,121184,121212,121244,121282,121284,121288,121296,121318,121338,121356,121368,121392,121406,121440,121468,121536,121592,121656,121730,121732,121736,121744,121758,121760,121804,121842,121844,121890,121922,121924,121928,121936,121950,121958,121978,121986,121988,121992,122e3,122014,122016,122044,122060,122098,122100,122116,122120,122128,122142,122144,122172,122176,122232,122246,122264,122318,122338,122340,122344,122414,122418,122420,122446,122460,122466,122468,122472,122510,122524,122552,122562,122564,122568,122576,122598,122618,122646,122662,122668,122694,122700,122712,122738,122740,122762,122770,122772,122786,122788,122792,123018,123026,123028,123042,123044,123048,123062,123098,123146,123154,123156,123170,123172,123176,123190,123202,123204,123208,123216,123238,123244,123258,123290,123314,123316,123402,123410,123412,123426,123428,123432,123446,123458,123464,123472,123486,123494,123500,123514,123522,123524,123528,123536,123552,123580,123590,123596,123608,123630,123634,123636,123674,123698,123700,123740,123746,123748,123752,123834,123914,123922,123924,123938,123944,123958,123970,123976,123984,123998,124006,124012,124026,124034,124036,124048,124062,124064,124092,124102,124108,124120,124142,124146,124148,124162,124164,124168,124176,124190,124192,124220,124224,124280,124294,124300,124312,124336,124350,124366,124380,124386,124388,124392,124406,124442,124462,124466,124468,124494,124508,124514,124520,124558,124572,124600,124610,124612,124616,124624,124646,124666,124694,124710,124716,124730,124742,124748,124760,124786,124788,124818,124820,124834,124836,124840,124854,124946,124948,124962,124964,124968,124982,124994,124996,125e3,125008,125022,125030,125036,125050,125058,125060,125064,125072,125086,125088,125116,125126,125132,125144,125166,125170,125172,125186,125188,125192,125200,125216,125244,125248,125304,125318,125324,125336,125360,125374,125390,125404,125410,125412,125416,125430,125444,125448,125456,125472,125504,125560,125680,125702,125708,125720,125744,125758,125792,125820,125838,125852,125880,125890,125892,125896,125904,125918,125926,125932,125978,125998,126002,126004,126030,126044,126050,126052,126056,126094,126108,126136,126146,126148,126152,126160,126182,126202,126222,126236,126264,126320,126334,126338,126340,126344,126352,126366,126368,126412,126450,126452,126486,126502,126508,126522,126534,126540,126552,126574,126578,126580,126598,126604,126616,126640,126654,126670,126684,126690,126692,126696,126738,126754,126756,126760,126774,126786,126788,126792,126800,126814,126822,126828,126842,126894,126898,126900,126934,127126,127142,127148,127162,127178,127186,127188,127254,127270,127276,127290,127302,127308,127320,127342,127346,127348,127370,127378,127380,127394,127396,127400,127450,127510,127526,127532,127546,127558,127576,127598,127602,127604,127622,127628,127640,127664,127678,127694,127708,127714,127716,127720,127734,127754,127762,127764,127778,127784,127810,127812,127816,127824,127838,127846,127866,127898,127918,127922,127924,128022,128038,128044,128058,128070,128076,128088,128110,128114,128116,128134,128140,128152,128176,128190,128206,128220,128226,128228,128232,128246,128262,128268,128280,128304,128318,128352,128380,128398,128412,128440,128450,128452,128456,128464,128478,128486,128492,128506,128522,128530,128532,128546,128548,128552,128566,128578,128580,128584,128592,128606,128614,128634,128642,128644,128648,128656,128670,128672,128700,128716,128754,128756,128794,128814,128818,128820,128846,128860,128866,128868,128872,128886,128918,128934,128940,128954,128978,128980,129178,129198,129202,129204,129238,129258,129306,129326,129330,129332,129358,129372,129378,129380,129384,129398,129430,129446,129452,129466,129482,129490,129492,129562,129582,129586,129588,129614,129628,129634,129636,129640,129654,129678,129692,129720,129730,129732,129736,129744,129758,129766,129772,129814,129830,129836,129850,129862,129868,129880,129902,129906,129908,129930,129938,129940,129954,129956,129960,129974,130010]),t.CODEWORD_TABLE=Int32Array.from([2627,1819,2622,2621,1813,1812,2729,2724,2723,2779,2774,2773,902,896,908,868,865,861,859,2511,873,871,1780,835,2493,825,2491,842,837,844,1764,1762,811,810,809,2483,807,2482,806,2480,815,814,813,812,2484,817,816,1745,1744,1742,1746,2655,2637,2635,2626,2625,2623,2628,1820,2752,2739,2737,2728,2727,2725,2730,2785,2783,2778,2777,2775,2780,787,781,747,739,736,2413,754,752,1719,692,689,681,2371,678,2369,700,697,694,703,1688,1686,642,638,2343,631,2341,627,2338,651,646,643,2345,654,652,1652,1650,1647,1654,601,599,2322,596,2321,594,2319,2317,611,610,608,606,2324,603,2323,615,614,612,1617,1616,1614,1612,616,1619,1618,2575,2538,2536,905,901,898,909,2509,2507,2504,870,867,864,860,2512,875,872,1781,2490,2489,2487,2485,1748,836,834,832,830,2494,827,2492,843,841,839,845,1765,1763,2701,2676,2674,2653,2648,2656,2634,2633,2631,2629,1821,2638,2636,2770,2763,2761,2750,2745,2753,2736,2735,2733,2731,1848,2740,2738,2786,2784,591,588,576,569,566,2296,1590,537,534,526,2276,522,2274,545,542,539,548,1572,1570,481,2245,466,2242,462,2239,492,485,482,2249,496,494,1534,1531,1528,1538,413,2196,406,2191,2188,425,419,2202,415,2199,432,430,427,1472,1467,1464,433,1476,1474,368,367,2160,365,2159,362,2157,2155,2152,378,377,375,2166,372,2165,369,2162,383,381,379,2168,1419,1418,1416,1414,385,1411,384,1423,1422,1420,1424,2461,802,2441,2439,790,786,783,794,2409,2406,2403,750,742,738,2414,756,753,1720,2367,2365,2362,2359,1663,693,691,684,2373,680,2370,702,699,696,704,1690,1687,2337,2336,2334,2332,1624,2329,1622,640,637,2344,634,2342,630,2340,650,648,645,2346,655,653,1653,1651,1649,1655,2612,2597,2595,2571,2568,2565,2576,2534,2529,2526,1787,2540,2537,907,904,900,910,2503,2502,2500,2498,1768,2495,1767,2510,2508,2506,869,866,863,2513,876,874,1782,2720,2713,2711,2697,2694,2691,2702,2672,2670,2664,1828,2678,2675,2647,2646,2644,2642,1823,2639,1822,2654,2652,2650,2657,2771,1855,2765,2762,1850,1849,2751,2749,2747,2754,353,2148,344,342,336,2142,332,2140,345,1375,1373,306,2130,299,2128,295,2125,319,314,311,2132,1354,1352,1349,1356,262,257,2101,253,2096,2093,274,273,267,2107,263,2104,280,278,275,1316,1311,1308,1320,1318,2052,202,2050,2044,2040,219,2063,212,2060,208,2055,224,221,2066,1260,1258,1252,231,1248,229,1266,1264,1261,1268,155,1998,153,1996,1994,1991,1988,165,164,2007,162,2006,159,2003,2e3,172,171,169,2012,166,2010,1186,1184,1182,1179,175,1176,173,1192,1191,1189,1187,176,1194,1193,2313,2307,2305,592,589,2294,2292,2289,578,572,568,2297,580,1591,2272,2267,2264,1547,538,536,529,2278,525,2275,547,544,541,1574,1571,2237,2235,2229,1493,2225,1489,478,2247,470,2244,465,2241,493,488,484,2250,498,495,1536,1533,1530,1539,2187,2186,2184,2182,1432,2179,1430,2176,1427,414,412,2197,409,2195,405,2193,2190,426,424,421,2203,418,2201,431,429,1473,1471,1469,1466,434,1477,1475,2478,2472,2470,2459,2457,2454,2462,803,2437,2432,2429,1726,2443,2440,792,789,785,2401,2399,2393,1702,2389,1699,2411,2408,2405,745,741,2415,758,755,1721,2358,2357,2355,2353,1661,2350,1660,2347,1657,2368,2366,2364,2361,1666,690,687,2374,683,2372,701,698,705,1691,1689,2619,2617,2610,2608,2605,2613,2593,2588,2585,1803,2599,2596,2563,2561,2555,1797,2551,1795,2573,2570,2567,2577,2525,2524,2522,2520,1786,2517,1785,2514,1783,2535,2533,2531,2528,1788,2541,2539,906,903,911,2721,1844,2715,2712,1838,1836,2699,2696,2693,2703,1827,1826,1824,2673,2671,2669,2666,1829,2679,2677,1858,1857,2772,1854,1853,1851,1856,2766,2764,143,1987,139,1986,135,133,131,1984,128,1983,125,1981,138,137,136,1985,1133,1132,1130,112,110,1974,107,1973,104,1971,1969,122,121,119,117,1977,114,1976,124,1115,1114,1112,1110,1117,1116,84,83,1953,81,1952,78,1950,1948,1945,94,93,91,1959,88,1958,85,1955,99,97,95,1961,1086,1085,1083,1081,1078,100,1090,1089,1087,1091,49,47,1917,44,1915,1913,1910,1907,59,1926,56,1925,53,1922,1919,66,64,1931,61,1929,1042,1040,1038,71,1035,70,1032,68,1048,1047,1045,1043,1050,1049,12,10,1869,1867,1864,1861,21,1880,19,1877,1874,1871,28,1888,25,1886,22,1883,982,980,977,974,32,30,991,989,987,984,34,995,994,992,2151,2150,2147,2146,2144,356,355,354,2149,2139,2138,2136,2134,1359,343,341,338,2143,335,2141,348,347,346,1376,1374,2124,2123,2121,2119,1326,2116,1324,310,308,305,2131,302,2129,298,2127,320,318,316,313,2133,322,321,1355,1353,1351,1357,2092,2091,2089,2087,1276,2084,1274,2081,1271,259,2102,256,2100,252,2098,2095,272,269,2108,266,2106,281,279,277,1317,1315,1313,1310,282,1321,1319,2039,2037,2035,2032,1203,2029,1200,1197,207,2053,205,2051,201,2049,2046,2043,220,218,2064,215,2062,211,2059,228,226,223,2069,1259,1257,1254,232,1251,230,1267,1265,1263,2316,2315,2312,2311,2309,2314,2304,2303,2301,2299,1593,2308,2306,590,2288,2287,2285,2283,1578,2280,1577,2295,2293,2291,579,577,574,571,2298,582,581,1592,2263,2262,2260,2258,1545,2255,1544,2252,1541,2273,2271,2269,2266,1550,535,532,2279,528,2277,546,543,549,1575,1573,2224,2222,2220,1486,2217,1485,2214,1482,1479,2238,2236,2234,2231,1496,2228,1492,480,477,2248,473,2246,469,2243,490,487,2251,497,1537,1535,1532,2477,2476,2474,2479,2469,2468,2466,2464,1730,2473,2471,2453,2452,2450,2448,1729,2445,1728,2460,2458,2456,2463,805,804,2428,2427,2425,2423,1725,2420,1724,2417,1722,2438,2436,2434,2431,1727,2444,2442,793,791,788,795,2388,2386,2384,1697,2381,1696,2378,1694,1692,2402,2400,2398,2395,1703,2392,1701,2412,2410,2407,751,748,744,2416,759,757,1807,2620,2618,1806,1805,2611,2609,2607,2614,1802,1801,1799,2594,2592,2590,2587,1804,2600,2598,1794,1793,1791,1789,2564,2562,2560,2557,1798,2554,1796,2574,2572,2569,2578,1847,1846,2722,1843,1842,1840,1845,2716,2714,1835,1834,1832,1830,1839,1837,2700,2698,2695,2704,1817,1811,1810,897,862,1777,829,826,838,1760,1758,808,2481,1741,1740,1738,1743,2624,1818,2726,2776,782,740,737,1715,686,679,695,1682,1680,639,628,2339,647,644,1645,1643,1640,1648,602,600,597,595,2320,593,2318,609,607,604,1611,1610,1608,1606,613,1615,1613,2328,926,924,892,886,899,857,850,2505,1778,824,823,821,819,2488,818,2486,833,831,828,840,1761,1759,2649,2632,2630,2746,2734,2732,2782,2781,570,567,1587,531,527,523,540,1566,1564,476,467,463,2240,486,483,1524,1521,1518,1529,411,403,2192,399,2189,423,416,1462,1457,1454,428,1468,1465,2210,366,363,2158,360,2156,357,2153,376,373,370,2163,1410,1409,1407,1405,382,1402,380,1417,1415,1412,1421,2175,2174,777,774,771,784,732,725,722,2404,743,1716,676,674,668,2363,665,2360,685,1684,1681,626,624,622,2335,620,2333,617,2330,641,635,649,1646,1644,1642,2566,928,925,2530,2527,894,891,888,2501,2499,2496,858,856,854,851,1779,2692,2668,2665,2645,2643,2640,2651,2768,2759,2757,2744,2743,2741,2748,352,1382,340,337,333,1371,1369,307,300,296,2126,315,312,1347,1342,1350,261,258,250,2097,246,2094,271,268,264,1306,1301,1298,276,1312,1309,2115,203,2048,195,2045,191,2041,213,209,2056,1246,1244,1238,225,1234,222,1256,1253,1249,1262,2080,2079,154,1997,150,1995,147,1992,1989,163,160,2004,156,2001,1175,1174,1172,1170,1167,170,1164,167,1185,1183,1180,1177,174,1190,1188,2025,2024,2022,587,586,564,559,556,2290,573,1588,520,518,512,2268,508,2265,530,1568,1565,461,457,2233,450,2230,446,2226,479,471,489,1526,1523,1520,397,395,2185,392,2183,389,2180,2177,410,2194,402,422,1463,1461,1459,1456,1470,2455,799,2433,2430,779,776,773,2397,2394,2390,734,728,724,746,1717,2356,2354,2351,2348,1658,677,675,673,670,667,688,1685,1683,2606,2589,2586,2559,2556,2552,927,2523,2521,2518,2515,1784,2532,895,893,890,2718,2709,2707,2689,2687,2684,2663,2662,2660,2658,1825,2667,2769,1852,2760,2758,142,141,1139,1138,134,132,129,126,1982,1129,1128,1126,1131,113,111,108,105,1972,101,1970,120,118,115,1109,1108,1106,1104,123,1113,1111,82,79,1951,75,1949,72,1946,92,89,86,1956,1077,1076,1074,1072,98,1069,96,1084,1082,1079,1088,1968,1967,48,45,1916,42,1914,39,1911,1908,60,57,54,1923,50,1920,1031,1030,1028,1026,67,1023,65,1020,62,1041,1039,1036,1033,69,1046,1044,1944,1943,1941,11,9,1868,7,1865,1862,1859,20,1878,16,1875,13,1872,970,968,966,963,29,960,26,23,983,981,978,975,33,971,31,990,988,985,1906,1904,1902,993,351,2145,1383,331,330,328,326,2137,323,2135,339,1372,1370,294,293,291,289,2122,286,2120,283,2117,309,303,317,1348,1346,1344,245,244,242,2090,239,2088,236,2085,2082,260,2099,249,270,1307,1305,1303,1300,1314,189,2038,186,2036,183,2033,2030,2026,206,198,2047,194,216,1247,1245,1243,1240,227,1237,1255,2310,2302,2300,2286,2284,2281,565,563,561,558,575,1589,2261,2259,2256,2253,1542,521,519,517,514,2270,511,533,1569,1567,2223,2221,2218,2215,1483,2211,1480,459,456,453,2232,449,474,491,1527,1525,1522,2475,2467,2465,2451,2449,2446,801,800,2426,2424,2421,2418,1723,2435,780,778,775,2387,2385,2382,2379,1695,2375,1693,2396,735,733,730,727,749,1718,2616,2615,2604,2603,2601,2584,2583,2581,2579,1800,2591,2550,2549,2547,2545,1792,2542,1790,2558,929,2719,1841,2710,2708,1833,1831,2690,2688,2686,1815,1809,1808,1774,1756,1754,1737,1736,1734,1739,1816,1711,1676,1674,633,629,1638,1636,1633,1641,598,1605,1604,1602,1600,605,1609,1607,2327,887,853,1775,822,820,1757,1755,1584,524,1560,1558,468,464,1514,1511,1508,1519,408,404,400,1452,1447,1444,417,1458,1455,2208,364,361,358,2154,1401,1400,1398,1396,374,1393,371,1408,1406,1403,1413,2173,2172,772,726,723,1712,672,669,666,682,1678,1675,625,623,621,618,2331,636,632,1639,1637,1635,920,918,884,880,889,849,848,847,846,2497,855,852,1776,2641,2742,2787,1380,334,1367,1365,301,297,1340,1338,1335,1343,255,251,247,1296,1291,1288,265,1302,1299,2113,204,196,192,2042,1232,1230,1224,214,1220,210,1242,1239,1235,1250,2077,2075,151,148,1993,144,1990,1163,1162,1160,1158,1155,161,1152,157,1173,1171,1168,1165,168,1181,1178,2021,2020,2018,2023,585,560,557,1585,516,509,1562,1559,458,447,2227,472,1516,1513,1510,398,396,393,390,2181,386,2178,407,1453,1451,1449,1446,420,1460,2209,769,764,720,712,2391,729,1713,664,663,661,659,2352,656,2349,671,1679,1677,2553,922,919,2519,2516,885,883,881,2685,2661,2659,2767,2756,2755,140,1137,1136,130,127,1125,1124,1122,1127,109,106,102,1103,1102,1100,1098,116,1107,1105,1980,80,76,73,1947,1068,1067,1065,1063,90,1060,87,1075,1073,1070,1080,1966,1965,46,43,40,1912,36,1909,1019,1018,1016,1014,58,1011,55,1008,51,1029,1027,1024,1021,63,1037,1034,1940,1939,1937,1942,8,1866,4,1863,1,1860,956,954,952,949,946,17,14,969,967,964,961,27,957,24,979,976,972,1901,1900,1898,1896,986,1905,1903,350,349,1381,329,327,324,1368,1366,292,290,287,284,2118,304,1341,1339,1337,1345,243,240,237,2086,233,2083,254,1297,1295,1293,1290,1304,2114,190,187,184,2034,180,2031,177,2027,199,1233,1231,1229,1226,217,1223,1241,2078,2076,584,555,554,552,550,2282,562,1586,507,506,504,502,2257,499,2254,515,1563,1561,445,443,441,2219,438,2216,435,2212,460,454,475,1517,1515,1512,2447,798,797,2422,2419,770,768,766,2383,2380,2376,721,719,717,714,731,1714,2602,2582,2580,2548,2546,2543,923,921,2717,2706,2705,2683,2682,2680,1771,1752,1750,1733,1732,1731,1735,1814,1707,1670,1668,1631,1629,1626,1634,1599,1598,1596,1594,1603,1601,2326,1772,1753,1751,1581,1554,1552,1504,1501,1498,1509,1442,1437,1434,401,1448,1445,2206,1392,1391,1389,1387,1384,359,1399,1397,1394,1404,2171,2170,1708,1672,1669,619,1632,1630,1628,1773,1378,1363,1361,1333,1328,1336,1286,1281,1278,248,1292,1289,2111,1218,1216,1210,197,1206,193,1228,1225,1221,1236,2073,2071,1151,1150,1148,1146,152,1143,149,1140,145,1161,1159,1156,1153,158,1169,1166,2017,2016,2014,2019,1582,510,1556,1553,452,448,1506,1500,394,391,387,1443,1441,1439,1436,1450,2207,765,716,713,1709,662,660,657,1673,1671,916,914,879,878,877,882,1135,1134,1121,1120,1118,1123,1097,1096,1094,1092,103,1101,1099,1979,1059,1058,1056,1054,77,1051,74,1066,1064,1061,1071,1964,1963,1007,1006,1004,1002,999,41,996,37,1017,1015,1012,1009,52,1025,1022,1936,1935,1933,1938,942,940,938,935,932,5,2,955,953,950,947,18,943,15,965,962,958,1895,1894,1892,1890,973,1899,1897,1379,325,1364,1362,288,285,1334,1332,1330,241,238,234,1287,1285,1283,1280,1294,2112,188,185,181,178,2028,1219,1217,1215,1212,200,1209,1227,2074,2072,583,553,551,1583,505,503,500,513,1557,1555,444,442,439,436,2213,455,451,1507,1505,1502,796,763,762,760,767,711,710,708,706,2377,718,715,1710,2544,917,915,2681,1627,1597,1595,2325,1769,1749,1747,1499,1438,1435,2204,1390,1388,1385,1395,2169,2167,1704,1665,1662,1625,1623,1620,1770,1329,1282,1279,2109,1214,1207,1222,2068,2065,1149,1147,1144,1141,146,1157,1154,2013,2011,2008,2015,1579,1549,1546,1495,1487,1433,1431,1428,1425,388,1440,2205,1705,658,1667,1664,1119,1095,1093,1978,1057,1055,1052,1062,1962,1960,1005,1003,1e3,997,38,1013,1010,1932,1930,1927,1934,941,939,936,933,6,930,3,951,948,944,1889,1887,1884,1881,959,1893,1891,35,1377,1360,1358,1327,1325,1322,1331,1277,1275,1272,1269,235,1284,2110,1205,1204,1201,1198,182,1195,179,1213,2070,2067,1580,501,1551,1548,440,437,1497,1494,1490,1503,761,709,707,1706,913,912,2198,1386,2164,2161,1621,1766,2103,1208,2058,2054,1145,1142,2005,2002,1999,2009,1488,1429,1426,2200,1698,1659,1656,1975,1053,1957,1954,1001,998,1924,1921,1918,1928,937,934,931,1879,1876,1873,1870,945,1885,1882,1323,1273,1270,2105,1202,1199,1196,1211,2061,2057,1576,1543,1540,1484,1481,1478,1491,1700]),t}(),cn=function(){function t(t,e){this.bits=t,this.points=e}return t.prototype.getBits=function(){return this.bits},t.prototype.getPoints=function(){return this.points},t}(),fn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},hn=function(){function t(){}return t.detectMultiple=function(e,r,n){var o=e.getBlackMatrix(),i=t.detect(n,o);return i.length||((o=o.clone()).rotate180(),i=t.detect(n,o)),new cn(o,i)},t.detect=function(e,r){for(var n,o,i=new Array,a=0,u=0,s=!1;a<r.getHeight();){var c=t.findVertices(r,a,u);if(null!=c[0]||null!=c[3]){if(s=!0,i.push(c),!e)break;null!=c[2]?(u=Math.trunc(c[2].getX()),a=Math.trunc(c[2].getY())):(u=Math.trunc(c[4].getX()),a=Math.trunc(c[4].getY()))}else{if(!s)break;s=!1,u=0;try{for(var f=(n=void 0,fn(i)),h=f.next();!h.done;h=f.next()){var l=h.value;null!=l[1]&&(a=Math.trunc(Math.max(a,l[1].getY()))),null!=l[3]&&(a=Math.max(a,Math.trunc(l[3].getY())))}}catch(t){n={error:t}}finally{try{h&&!h.done&&(o=f.return)&&o.call(f)}finally{if(n)throw n.error}}a+=t.ROW_STEP}}return i},t.findVertices=function(e,r,n){var o=e.getHeight(),i=e.getWidth(),a=new Array(8);return t.copyToResult(a,t.findRowsWithPattern(e,o,i,r,n,t.START_PATTERN),t.INDEXES_START_PATTERN),null!=a[4]&&(n=Math.trunc(a[4].getX()),r=Math.trunc(a[4].getY())),t.copyToResult(a,t.findRowsWithPattern(e,o,i,r,n,t.STOP_PATTERN),t.INDEXES_STOP_PATTERN),a},t.copyToResult=function(t,e,r){for(var n=0;n<r.length;n++)t[r[n]]=e[n]},t.findRowsWithPattern=function(e,r,n,o,i,a){for(var u=new Array(4),s=!1,c=new Int32Array(a.length);o<r;o+=t.ROW_STEP){if(null!=(d=t.findGuardPattern(e,i,o,n,!1,a,c))){for(;o>0;){if(null==(l=t.findGuardPattern(e,i,--o,n,!1,a,c))){o++;break}d=l}u[0]=new At(d[0],o),u[1]=new At(d[1],o),s=!0;break}}var f=o+1;if(s){for(var h=0,l=Int32Array.from([Math.trunc(u[0].getX()),Math.trunc(u[1].getX())]);f<r;f++){var d;if(null!=(d=t.findGuardPattern(e,l[0],f,n,!1,a,c))&&Math.abs(l[0]-d[0])<t.MAX_PATTERN_DRIFT&&Math.abs(l[1]-d[1])<t.MAX_PATTERN_DRIFT)l=d,h=0;else{if(h>t.SKIPPED_ROW_COUNT_MAX)break;h++}}f-=h+1,u[2]=new At(l[0],f),u[3]=new At(l[1],f)}return f-o<t.BARCODE_MIN_HEIGHT&&C.fill(u,null),u},t.findGuardPattern=function(e,r,n,o,i,a,u){C.fillWithin(u,0,u.length,0);for(var s=r,c=0;e.get(s,n)&&s>0&&c++<t.MAX_PIXEL_DRIFT;)s--;for(var f=s,h=0,l=a.length,d=i;f<o;f++){if(e.get(f,n)!==d)u[h]++;else{if(h===l-1){if(t.patternMatchVariance(u,a,t.MAX_INDIVIDUAL_VARIANCE)<t.MAX_AVG_VARIANCE)return new Int32Array([s,f]);s+=u[0]+u[1],w.arraycopy(u,2,u,0,h-1),u[h-1]=0,u[h]=0,h--}else h++;u[h]=1,d=!d}}return h===l-1&&t.patternMatchVariance(u,a,t.MAX_INDIVIDUAL_VARIANCE)<t.MAX_AVG_VARIANCE?new Int32Array([s,f-1]):null},t.patternMatchVariance=function(t,e,r){for(var n=t.length,o=0,i=0,a=0;a<n;a++)o+=t[a],i+=e[a];if(o<i)return 1/0;var u=o/i;r*=u;for(var s=0,c=0;c<n;c++){var f=t[c],h=e[c]*u,l=f>h?f-h:h-f;if(l>r)return 1/0;s+=l}return s/o},t.INDEXES_START_PATTERN=Int32Array.from([0,4,1,5]),t.INDEXES_STOP_PATTERN=Int32Array.from([6,2,7,3]),t.MAX_AVG_VARIANCE=.42,t.MAX_INDIVIDUAL_VARIANCE=.8,t.START_PATTERN=Int32Array.from([8,1,1,1,1,1,1,3]),t.STOP_PATTERN=Int32Array.from([7,1,1,3,1,1,1,2,1]),t.MAX_PIXEL_DRIFT=3,t.MAX_PATTERN_DRIFT=5,t.SKIPPED_ROW_COUNT_MAX=25,t.ROW_STEP=5,t.BARCODE_MIN_HEIGHT=10,t}(),ln=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},dn=function(){function t(t,e){if(0===e.length)throw new l;this.field=t;var r=e.length;if(r>1&&0===e[0]){for(var n=1;n<r&&0===e[n];)n++;n===r?this.coefficients=new Int32Array([0]):(this.coefficients=new Int32Array(r-n),w.arraycopy(e,n,this.coefficients,0,this.coefficients.length))}else this.coefficients=e}return t.prototype.getCoefficients=function(){return this.coefficients},t.prototype.getDegree=function(){return this.coefficients.length-1},t.prototype.isZero=function(){return 0===this.coefficients[0]},t.prototype.getCoefficient=function(t){return this.coefficients[this.coefficients.length-1-t]},t.prototype.evaluateAt=function(t){var e,r;if(0===t)return this.getCoefficient(0);if(1===t){var n=0;try{for(var o=ln(this.coefficients),i=o.next();!i.done;i=o.next()){var a=i.value;n=this.field.add(n,a)}}catch(t){e={error:t}}finally{try{i&&!i.done&&(r=o.return)&&r.call(o)}finally{if(e)throw e.error}}return n}for(var u=this.coefficients[0],s=this.coefficients.length,c=1;c<s;c++)u=this.field.add(this.field.multiply(t,u),this.coefficients[c]);return u},t.prototype.add=function(e){if(!this.field.equals(e.field))throw new l("ModulusPolys do not have same ModulusGF field");if(this.isZero())return e;if(e.isZero())return this;var r=this.coefficients,n=e.coefficients;if(r.length>n.length){var o=r;r=n,n=o}var i=new Int32Array(n.length),a=n.length-r.length;w.arraycopy(n,0,i,0,a);for(var u=a;u<n.length;u++)i[u]=this.field.add(r[u-a],n[u]);return new t(this.field,i)},t.prototype.subtract=function(t){if(!this.field.equals(t.field))throw new l("ModulusPolys do not have same ModulusGF field");return t.isZero()?this:this.add(t.negative())},t.prototype.multiply=function(e){return e instanceof t?this.multiplyOther(e):this.multiplyScalar(e)},t.prototype.multiplyOther=function(e){if(!this.field.equals(e.field))throw new l("ModulusPolys do not have same ModulusGF field");if(this.isZero()||e.isZero())return new t(this.field,new Int32Array([0]));for(var r=this.coefficients,n=r.length,o=e.coefficients,i=o.length,a=new Int32Array(n+i-1),u=0;u<n;u++)for(var s=r[u],c=0;c<i;c++)a[u+c]=this.field.add(a[u+c],this.field.multiply(s,o[c]));return new t(this.field,a)},t.prototype.negative=function(){for(var e=this.coefficients.length,r=new Int32Array(e),n=0;n<e;n++)r[n]=this.field.subtract(0,this.coefficients[n]);return new t(this.field,r)},t.prototype.multiplyScalar=function(e){if(0===e)return new t(this.field,new Int32Array([0]));if(1===e)return this;for(var r=this.coefficients.length,n=new Int32Array(r),o=0;o<r;o++)n[o]=this.field.multiply(this.coefficients[o],e);return new t(this.field,n)},t.prototype.multiplyByMonomial=function(e,r){if(e<0)throw new l;if(0===r)return new t(this.field,new Int32Array([0]));for(var n=this.coefficients.length,o=new Int32Array(n+e),i=0;i<n;i++)o[i]=this.field.multiply(this.coefficients[i],r);return new t(this.field,o)},t.prototype.toString=function(){for(var t=new k,e=this.getDegree();e>=0;e--){var r=this.getCoefficient(e);0!==r&&(r<0?(t.append(" - "),r=-r):t.length()>0&&t.append(" + "),0!==e&&1===r||t.append(r),0!==e&&(1===e?t.append("x"):(t.append("x^"),t.append(e))))}return t.toString()},t}(),pn=function(){function t(){}return t.prototype.add=function(t,e){return(t+e)%this.modulus},t.prototype.subtract=function(t,e){return(this.modulus+t-e)%this.modulus},t.prototype.exp=function(t){return this.expTable[t]},t.prototype.log=function(t){if(0===t)throw new l;return this.logTable[t]},t.prototype.inverse=function(t){if(0===t)throw new ft;return this.expTable[this.modulus-this.logTable[t]-1]},t.prototype.multiply=function(t,e){return 0===t||0===e?0:this.expTable[(this.logTable[t]+this.logTable[e])%(this.modulus-1)]},t.prototype.getSize=function(){return this.modulus},t.prototype.equals=function(t){return t===this},t}(),gn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),yn=function(t){function e(e,r){var n=t.call(this)||this;n.modulus=e,n.expTable=new Int32Array(e),n.logTable=new Int32Array(e);for(var o=1,i=0;i<e;i++)n.expTable[i]=o,o=o*r%e;for(i=0;i<e-1;i++)n.logTable[n.expTable[i]]=i;return n.zero=new dn(n,new Int32Array([0])),n.one=new dn(n,new Int32Array([1])),n}return gn(e,t),e.prototype.getZero=function(){return this.zero},e.prototype.getOne=function(){return this.one},e.prototype.buildMonomial=function(t,e){if(t<0)throw new l;if(0===e)return this.zero;var r=new Int32Array(t+1);return r[0]=e,new dn(this,r)},e.PDF417_GF=new e(sn.NUMBER_OF_CODEWORDS,3),e}(pn),wn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},_n=function(){function t(){this.field=yn.PDF417_GF}return t.prototype.decode=function(t,e,r){for(var n,o,i=new dn(this.field,t),a=new Int32Array(e),u=!1,s=e;s>0;s--){var c=i.evaluateAt(this.field.exp(s));a[e-s]=c,0!==c&&(u=!0)}if(!u)return 0;var f=this.field.getOne();if(null!=r)try{for(var h=wn(r),l=h.next();!l.done;l=h.next()){var d=l.value,p=this.field.exp(t.length-1-d),y=new dn(this.field,new Int32Array([this.field.subtract(0,p),1]));f=f.multiply(y)}}catch(t){n={error:t}}finally{try{l&&!l.done&&(o=h.return)&&o.call(h)}finally{if(n)throw n.error}}var w=new dn(this.field,a),_=this.runEuclideanAlgorithm(this.field.buildMonomial(e,1),w,e),v=_[0],m=_[1],A=this.findErrorLocations(v),E=this.findErrorMagnitudes(m,v,A);for(s=0;s<A.length;s++){var C=t.length-1-this.field.log(A[s]);if(C<0)throw g.getChecksumInstance();t[C]=this.field.subtract(t[C],E[s])}return A.length},t.prototype.runEuclideanAlgorithm=function(t,e,r){if(t.getDegree()<e.getDegree()){var n=t;t=e,e=n}for(var o=t,i=e,a=this.field.getZero(),u=this.field.getOne();i.getDegree()>=Math.round(r/2);){var s=o,c=a;if(a=u,(o=i).isZero())throw g.getChecksumInstance();i=s;for(var f=this.field.getZero(),h=o.getCoefficient(o.getDegree()),l=this.field.inverse(h);i.getDegree()>=o.getDegree()&&!i.isZero();){var d=i.getDegree()-o.getDegree(),p=this.field.multiply(i.getCoefficient(i.getDegree()),l);f=f.add(this.field.buildMonomial(d,p)),i=i.subtract(o.multiplyByMonomial(d,p))}u=f.multiply(a).subtract(c).negative()}var y=u.getCoefficient(0);if(0===y)throw g.getChecksumInstance();var w=this.field.inverse(y);return[u.multiply(w),i.multiply(w)]},t.prototype.findErrorLocations=function(t){for(var e=t.getDegree(),r=new Int32Array(e),n=0,o=1;o<this.field.getSize()&&n<e;o++)0===t.evaluateAt(o)&&(r[n]=this.field.inverse(o),n++);if(n!==e)throw g.getChecksumInstance();return r},t.prototype.findErrorMagnitudes=function(t,e,r){for(var n=e.getDegree(),o=new Int32Array(n),i=1;i<=n;i++)o[n-i]=this.field.multiply(i,e.getCoefficient(i));var a=new dn(this.field,o),u=r.length,s=new Int32Array(u);for(i=0;i<u;i++){var c=this.field.inverse(r[i]),f=this.field.subtract(0,t.evaluateAt(c)),h=this.field.inverse(a.evaluateAt(c));s[i]=this.field.multiply(f,h)}return s},t}(),vn=function(){function t(e,r,n,o,i){e instanceof t?this.constructor_2(e):this.constructor_1(e,r,n,o,i)}return t.prototype.constructor_1=function(t,e,r,n,o){var i=null==e||null==r,a=null==n||null==o;if(i&&a)throw new U;i?(e=new At(0,n.getY()),r=new At(0,o.getY())):a&&(n=new At(t.getWidth()-1,e.getY()),o=new At(t.getWidth()-1,r.getY())),this.image=t,this.topLeft=e,this.bottomLeft=r,this.topRight=n,this.bottomRight=o,this.minX=Math.trunc(Math.min(e.getX(),r.getX())),this.maxX=Math.trunc(Math.max(n.getX(),o.getX())),this.minY=Math.trunc(Math.min(e.getY(),n.getY())),this.maxY=Math.trunc(Math.max(r.getY(),o.getY()))},t.prototype.constructor_2=function(t){this.image=t.image,this.topLeft=t.getTopLeft(),this.bottomLeft=t.getBottomLeft(),this.topRight=t.getTopRight(),this.bottomRight=t.getBottomRight(),this.minX=t.getMinX(),this.maxX=t.getMaxX(),this.minY=t.getMinY(),this.maxY=t.getMaxY()},t.merge=function(e,r){return null==e?r:null==r?e:new t(e.image,e.topLeft,e.bottomLeft,r.topRight,r.bottomRight)},t.prototype.addMissingRows=function(e,r,n){var o=this.topLeft,i=this.bottomLeft,a=this.topRight,u=this.bottomRight;if(e>0){var s=n?this.topLeft:this.topRight,c=Math.trunc(s.getY()-e);c<0&&(c=0);var f=new At(s.getX(),c);n?o=f:a=f}if(r>0){var h=n?this.bottomLeft:this.bottomRight,l=Math.trunc(h.getY()+r);l>=this.image.getHeight()&&(l=this.image.getHeight()-1);var d=new At(h.getX(),l);n?i=d:u=d}return new t(this.image,o,i,a,u)},t.prototype.getMinX=function(){return this.minX},t.prototype.getMaxX=function(){return this.maxX},t.prototype.getMinY=function(){return this.minY},t.prototype.getMaxY=function(){return this.maxY},t.prototype.getTopLeft=function(){return this.topLeft},t.prototype.getTopRight=function(){return this.topRight},t.prototype.getBottomLeft=function(){return this.bottomLeft},t.prototype.getBottomRight=function(){return this.bottomRight},t}(),mn=function(){function t(t,e,r,n){this.columnCount=t,this.errorCorrectionLevel=n,this.rowCountUpperPart=e,this.rowCountLowerPart=r,this.rowCount=e+r}return t.prototype.getColumnCount=function(){return this.columnCount},t.prototype.getErrorCorrectionLevel=function(){return this.errorCorrectionLevel},t.prototype.getRowCount=function(){return this.rowCount},t.prototype.getRowCountUpperPart=function(){return this.rowCountUpperPart},t.prototype.getRowCountLowerPart=function(){return this.rowCountLowerPart},t}(),An=function(){function t(){this.buffer=""}return t.form=function(t,e){var r=-1;return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g,(function(t,n,o,i,a,u){if("%%"===t)return"%";if(void 0!==e[++r]){t=i?parseInt(i.substr(1)):void 0;var s,c=a?parseInt(a.substr(1)):void 0;switch(u){case"s":s=e[r];break;case"c":s=e[r][0];break;case"f":s=parseFloat(e[r]).toFixed(t);break;case"p":s=parseFloat(e[r]).toPrecision(t);break;case"e":s=parseFloat(e[r]).toExponential(t);break;case"x":s=parseInt(e[r]).toString(c||16);break;case"d":s=parseFloat(parseInt(e[r],c||10).toPrecision(t)).toFixed(0)}s="object"==typeof s?JSON.stringify(s):(+s).toString(c);for(var f=parseInt(o),h=o&&o[0]+""=="0"?"0":" ";s.length<f;)s=void 0!==n?s+h:h+s;return s}}))},t.prototype.format=function(e){for(var r=[],n=1;n<arguments.length;n++)r[n-1]=arguments[n];this.buffer+=t.form(e,r)},t.prototype.toString=function(){return this.buffer},t}(),En=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Cn=function(){function t(t){this.boundingBox=new vn(t),this.codewords=new Array(t.getMaxY()-t.getMinY()+1)}return t.prototype.getCodewordNearby=function(e){var r=this.getCodeword(e);if(null!=r)return r;for(var n=1;n<t.MAX_NEARBY_DISTANCE;n++){var o=this.imageRowToCodewordIndex(e)-n;if(o>=0&&null!=(r=this.codewords[o]))return r;if((o=this.imageRowToCodewordIndex(e)+n)<this.codewords.length&&null!=(r=this.codewords[o]))return r}return null},t.prototype.imageRowToCodewordIndex=function(t){return t-this.boundingBox.getMinY()},t.prototype.setCodeword=function(t,e){this.codewords[this.imageRowToCodewordIndex(t)]=e},t.prototype.getCodeword=function(t){return this.codewords[this.imageRowToCodewordIndex(t)]},t.prototype.getBoundingBox=function(){return this.boundingBox},t.prototype.getCodewords=function(){return this.codewords},t.prototype.toString=function(){var t,e,r=new An,n=0;try{for(var o=En(this.codewords),i=o.next();!i.done;i=o.next()){var a=i.value;null!=a?r.format("%3d: %3d|%3d%n",n++,a.getRowNumber(),a.getValue()):r.format("%3d:    |   %n",n++)}}catch(e){t={error:e}}finally{try{i&&!i.done&&(e=o.return)&&e.call(o)}finally{if(t)throw t.error}}return r.toString()},t.MAX_NEARBY_DISTANCE=5,t}(),In=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Sn=function(t,e){var r="function"==typeof Symbol&&t[Symbol.iterator];if(!r)return t;var n,o,i=r.call(t),a=[];try{for(;(void 0===e||e-- >0)&&!(n=i.next()).done;)a.push(n.value)}catch(t){o={error:t}}finally{try{n&&!n.done&&(r=i.return)&&r.call(i)}finally{if(o)throw o.error}}return a},On=function(){function t(){this.values=new Map}return t.prototype.setValue=function(t){t=Math.trunc(t);var e=this.values.get(t);null==e&&(e=0),e++,this.values.set(t,e)},t.prototype.getValue=function(){var t,e,r=-1,n=new Array,o=function(t,e){var o=function(){return t},i=function(){return e};i()>r?(r=i(),(n=[]).push(o())):i()===r&&n.push(o())};try{for(var i=In(this.values.entries()),a=i.next();!a.done;a=i.next()){var u=Sn(a.value,2);o(u[0],u[1])}}catch(e){t={error:e}}finally{try{a&&!a.done&&(e=i.return)&&e.call(i)}finally{if(t)throw t.error}}return sn.toIntArray(n)},t.prototype.getConfidence=function(t){return this.values.get(t)},t}(),Tn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),bn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Rn=function(t){function e(e,r){var n=t.call(this,e)||this;return n._isLeft=r,n}return Tn(e,t),e.prototype.setRowNumbers=function(){var t,e;try{for(var r=bn(this.getCodewords()),n=r.next();!n.done;n=r.next()){var o=n.value;null!=o&&o.setRowNumberAsRowIndicatorColumn()}}catch(e){t={error:e}}finally{try{n&&!n.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}},e.prototype.adjustCompleteIndicatorColumnRowNumbers=function(t){var e=this.getCodewords();this.setRowNumbers(),this.removeIncorrectCodewords(e,t);for(var r=this.getBoundingBox(),n=this._isLeft?r.getTopLeft():r.getTopRight(),o=this._isLeft?r.getBottomLeft():r.getBottomRight(),i=this.imageRowToCodewordIndex(Math.trunc(n.getY())),a=this.imageRowToCodewordIndex(Math.trunc(o.getY())),u=-1,s=1,c=0,f=i;f<a;f++)if(null!=e[f]){var h=e[f],l=h.getRowNumber()-u;if(0===l)c++;else if(1===l)s=Math.max(s,c),c=1,u=h.getRowNumber();else if(l<0||h.getRowNumber()>=t.getRowCount()||l>f)e[f]=null;else{for(var d=void 0,p=(d=s>2?(s-2)*l:l)>=f,g=1;g<=d&&!p;g++)p=null!=e[f-g];p?e[f]=null:(u=h.getRowNumber(),c=1)}}},e.prototype.getRowHeights=function(){var t,e,r=this.getBarcodeMetadata();if(null==r)return null;this.adjustIncompleteIndicatorColumnRowNumbers(r);var n=new Int32Array(r.getRowCount());try{for(var o=bn(this.getCodewords()),i=o.next();!i.done;i=o.next()){var a=i.value;if(null!=a){var u=a.getRowNumber();if(u>=n.length)continue;n[u]++}}}catch(e){t={error:e}}finally{try{i&&!i.done&&(e=o.return)&&e.call(o)}finally{if(t)throw t.error}}return n},e.prototype.adjustIncompleteIndicatorColumnRowNumbers=function(t){for(var e=this.getBoundingBox(),r=this._isLeft?e.getTopLeft():e.getTopRight(),n=this._isLeft?e.getBottomLeft():e.getBottomRight(),o=this.imageRowToCodewordIndex(Math.trunc(r.getY())),i=this.imageRowToCodewordIndex(Math.trunc(n.getY())),a=this.getCodewords(),u=-1,s=o;s<i;s++)if(null!=a[s]){var c=a[s];c.setRowNumberAsRowIndicatorColumn();var f=c.getRowNumber()-u;0===f||(1===f?u=c.getRowNumber():c.getRowNumber()>=t.getRowCount()?a[s]=null:u=c.getRowNumber())}},e.prototype.getBarcodeMetadata=function(){var t,e,r=this.getCodewords(),n=new On,o=new On,i=new On,a=new On;try{for(var u=bn(r),s=u.next();!s.done;s=u.next()){var c=s.value;if(null!=c){c.setRowNumberAsRowIndicatorColumn();var f=c.getValue()%30,h=c.getRowNumber();switch(this._isLeft||(h+=2),h%3){case 0:o.setValue(3*f+1);break;case 1:a.setValue(f/3),i.setValue(f%3);break;case 2:n.setValue(f+1)}}}}catch(e){t={error:e}}finally{try{s&&!s.done&&(e=u.return)&&e.call(u)}finally{if(t)throw t.error}}if(0===n.getValue().length||0===o.getValue().length||0===i.getValue().length||0===a.getValue().length||n.getValue()[0]<1||o.getValue()[0]+i.getValue()[0]<sn.MIN_ROWS_IN_BARCODE||o.getValue()[0]+i.getValue()[0]>sn.MAX_ROWS_IN_BARCODE)return null;var l=new mn(n.getValue()[0],o.getValue()[0],i.getValue()[0],a.getValue()[0]);return this.removeIncorrectCodewords(r,l),l},e.prototype.removeIncorrectCodewords=function(t,e){for(var r=0;r<t.length;r++){var n=t[r];if(null!=t[r]){var o=n.getValue()%30,i=n.getRowNumber();if(i>e.getRowCount())t[r]=null;else switch(this._isLeft||(i+=2),i%3){case 0:3*o+1!==e.getRowCountUpperPart()&&(t[r]=null);break;case 1:Math.trunc(o/3)===e.getErrorCorrectionLevel()&&o%3===e.getRowCountLowerPart()||(t[r]=null);break;case 2:o+1!==e.getColumnCount()&&(t[r]=null)}}}},e.prototype.isLeft=function(){return this._isLeft},e.prototype.toString=function(){return"IsLeft: "+this._isLeft+"\n"+t.prototype.toString.call(this)},e}(Cn),Nn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Dn=function(){function t(t,e){this.ADJUST_ROW_NUMBER_SKIP=2,this.barcodeMetadata=t,this.barcodeColumnCount=t.getColumnCount(),this.boundingBox=e,this.detectionResultColumns=new Array(this.barcodeColumnCount+2)}return t.prototype.getDetectionResultColumns=function(){this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]),this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount+1]);var t,e=sn.MAX_CODEWORDS_IN_BARCODE;do{t=e,e=this.adjustRowNumbersAndGetCount()}while(e>0&&e<t);return this.detectionResultColumns},t.prototype.adjustIndicatorColumnRowNumbers=function(t){null!=t&&t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata)},t.prototype.adjustRowNumbersAndGetCount=function(){var t=this.adjustRowNumbersByRow();if(0===t)return 0;for(var e=1;e<this.barcodeColumnCount+1;e++)for(var r=this.detectionResultColumns[e].getCodewords(),n=0;n<r.length;n++)null!=r[n]&&(r[n].hasValidRowNumber()||this.adjustRowNumbers(e,n,r));return t},t.prototype.adjustRowNumbersByRow=function(){return this.adjustRowNumbersFromBothRI(),this.adjustRowNumbersFromLRI()+this.adjustRowNumbersFromRRI()},t.prototype.adjustRowNumbersFromBothRI=function(){if(null!=this.detectionResultColumns[0]&&null!=this.detectionResultColumns[this.barcodeColumnCount+1])for(var t=this.detectionResultColumns[0].getCodewords(),e=this.detectionResultColumns[this.barcodeColumnCount+1].getCodewords(),r=0;r<t.length;r++)if(null!=t[r]&&null!=e[r]&&t[r].getRowNumber()===e[r].getRowNumber())for(var n=1;n<=this.barcodeColumnCount;n++){var o=this.detectionResultColumns[n].getCodewords()[r];null!=o&&(o.setRowNumber(t[r].getRowNumber()),o.hasValidRowNumber()||(this.detectionResultColumns[n].getCodewords()[r]=null))}},t.prototype.adjustRowNumbersFromRRI=function(){if(null==this.detectionResultColumns[this.barcodeColumnCount+1])return 0;for(var e=0,r=this.detectionResultColumns[this.barcodeColumnCount+1].getCodewords(),n=0;n<r.length;n++)if(null!=r[n])for(var o=r[n].getRowNumber(),i=0,a=this.barcodeColumnCount+1;a>0&&i<this.ADJUST_ROW_NUMBER_SKIP;a--){var u=this.detectionResultColumns[a].getCodewords()[n];null!=u&&(i=t.adjustRowNumberIfValid(o,i,u),u.hasValidRowNumber()||e++)}return e},t.prototype.adjustRowNumbersFromLRI=function(){if(null==this.detectionResultColumns[0])return 0;for(var e=0,r=this.detectionResultColumns[0].getCodewords(),n=0;n<r.length;n++)if(null!=r[n])for(var o=r[n].getRowNumber(),i=0,a=1;a<this.barcodeColumnCount+1&&i<this.ADJUST_ROW_NUMBER_SKIP;a++){var u=this.detectionResultColumns[a].getCodewords()[n];null!=u&&(i=t.adjustRowNumberIfValid(o,i,u),u.hasValidRowNumber()||e++)}return e},t.adjustRowNumberIfValid=function(t,e,r){return null==r||r.hasValidRowNumber()||(r.isValidRowNumber(t)?(r.setRowNumber(t),e=0):++e),e},t.prototype.adjustRowNumbers=function(e,r,n){var o,i,a=n[r],u=this.detectionResultColumns[e-1].getCodewords(),s=u;null!=this.detectionResultColumns[e+1]&&(s=this.detectionResultColumns[e+1].getCodewords());var c=new Array(14);c[2]=u[r],c[3]=s[r],r>0&&(c[0]=n[r-1],c[4]=u[r-1],c[5]=s[r-1]),r>1&&(c[8]=n[r-2],c[10]=u[r-2],c[11]=s[r-2]),r<n.length-1&&(c[1]=n[r+1],c[6]=u[r+1],c[7]=s[r+1]),r<n.length-2&&(c[9]=n[r+2],c[12]=u[r+2],c[13]=s[r+2]);try{for(var f=Nn(c),h=f.next();!h.done;h=f.next()){var l=h.value;if(t.adjustRowNumber(a,l))return}}catch(t){o={error:t}}finally{try{h&&!h.done&&(i=f.return)&&i.call(f)}finally{if(o)throw o.error}}},t.adjustRowNumber=function(t,e){return null!=e&&(!(!e.hasValidRowNumber()||e.getBucket()!==t.getBucket())&&(t.setRowNumber(e.getRowNumber()),!0))},t.prototype.getBarcodeColumnCount=function(){return this.barcodeColumnCount},t.prototype.getBarcodeRowCount=function(){return this.barcodeMetadata.getRowCount()},t.prototype.getBarcodeECLevel=function(){return this.barcodeMetadata.getErrorCorrectionLevel()},t.prototype.setBoundingBox=function(t){this.boundingBox=t},t.prototype.getBoundingBox=function(){return this.boundingBox},t.prototype.setDetectionResultColumn=function(t,e){this.detectionResultColumns[t]=e},t.prototype.getDetectionResultColumn=function(t){return this.detectionResultColumns[t]},t.prototype.toString=function(){var t=this.detectionResultColumns[0];null==t&&(t=this.detectionResultColumns[this.barcodeColumnCount+1]);for(var e=new An,r=0;r<t.getCodewords().length;r++){e.format("CW %3d:",r);for(var n=0;n<this.barcodeColumnCount+2;n++)if(null!=this.detectionResultColumns[n]){var o=this.detectionResultColumns[n].getCodewords()[r];null!=o?e.format(" %3d|%3d",o.getRowNumber(),o.getValue()):e.format("    |   ")}else e.format("    |   ");e.format("%n")}return e.toString()},t}(),Pn=function(){function t(e,r,n,o){this.rowNumber=t.BARCODE_ROW_UNKNOWN,this.startX=Math.trunc(e),this.endX=Math.trunc(r),this.bucket=Math.trunc(n),this.value=Math.trunc(o)}return t.prototype.hasValidRowNumber=function(){return this.isValidRowNumber(this.rowNumber)},t.prototype.isValidRowNumber=function(e){return e!==t.BARCODE_ROW_UNKNOWN&&this.bucket===e%3*3},t.prototype.setRowNumberAsRowIndicatorColumn=function(){this.rowNumber=Math.trunc(3*Math.trunc(this.value/30)+Math.trunc(this.bucket/3))},t.prototype.getWidth=function(){return this.endX-this.startX},t.prototype.getStartX=function(){return this.startX},t.prototype.getEndX=function(){return this.endX},t.prototype.getBucket=function(){return this.bucket},t.prototype.getValue=function(){return this.value},t.prototype.getRowNumber=function(){return this.rowNumber},t.prototype.setRowNumber=function(t){this.rowNumber=t},t.prototype.toString=function(){return this.rowNumber+"|"+this.value},t.BARCODE_ROW_UNKNOWN=-1,t}(),Mn=function(){function t(){}return t.initialize=function(){for(var e=0;e<sn.SYMBOL_TABLE.length;e++)for(var r=sn.SYMBOL_TABLE[e],n=1&r,o=0;o<sn.BARS_IN_MODULE;o++){for(var i=0;(1&r)===n;)i+=1,r>>=1;n=1&r,t.RATIOS_TABLE[e]||(t.RATIOS_TABLE[e]=new Array(sn.BARS_IN_MODULE)),t.RATIOS_TABLE[e][sn.BARS_IN_MODULE-o-1]=Math.fround(i/sn.MODULES_IN_CODEWORD)}this.bSymbolTableReady=!0},t.getDecodedValue=function(e){var r=t.getDecodedCodewordValue(t.sampleBitCounts(e));return-1!==r?r:t.getClosestDecodedValue(e)},t.sampleBitCounts=function(t){for(var e=vt.sum(t),r=new Int32Array(sn.BARS_IN_MODULE),n=0,o=0,i=0;i<sn.MODULES_IN_CODEWORD;i++){var a=e/(2*sn.MODULES_IN_CODEWORD)+i*e/sn.MODULES_IN_CODEWORD;o+t[n]<=a&&(o+=t[n],n++),r[n]++}return r},t.getDecodedCodewordValue=function(e){var r=t.getBitValue(e);return-1===sn.getCodeword(r)?-1:r},t.getBitValue=function(t){for(var e=0,r=0;r<t.length;r++)for(var n=0;n<t[r];n++)e=e<<1|(r%2==0?1:0);return Math.trunc(e)},t.getClosestDecodedValue=function(e){var r=vt.sum(e),n=new Array(sn.BARS_IN_MODULE);if(r>1)for(var o=0;o<n.length;o++)n[o]=Math.fround(e[o]/r);var i=mt.MAX_VALUE,a=-1;this.bSymbolTableReady||t.initialize();for(var u=0;u<t.RATIOS_TABLE.length;u++){for(var s=0,c=t.RATIOS_TABLE[u],f=0;f<sn.BARS_IN_MODULE;f++){var h=Math.fround(c[f]-n[f]);if((s+=Math.fround(h*h))>=i)break}s<i&&(i=s,a=sn.SYMBOL_TABLE[u])}return a},t.bSymbolTableReady=!1,t.RATIOS_TABLE=new Array(sn.SYMBOL_TABLE.length).map((function(t){return new Array(sn.BARS_IN_MODULE)})),t}(),Bn=function(){function t(){this.segmentCount=-1,this.fileSize=-1,this.timestamp=-1,this.checksum=-1}return t.prototype.getSegmentIndex=function(){return this.segmentIndex},t.prototype.setSegmentIndex=function(t){this.segmentIndex=t},t.prototype.getFileId=function(){return this.fileId},t.prototype.setFileId=function(t){this.fileId=t},t.prototype.getOptionalData=function(){return this.optionalData},t.prototype.setOptionalData=function(t){this.optionalData=t},t.prototype.isLastSegment=function(){return this.lastSegment},t.prototype.setLastSegment=function(t){this.lastSegment=t},t.prototype.getSegmentCount=function(){return this.segmentCount},t.prototype.setSegmentCount=function(t){this.segmentCount=t},t.prototype.getSender=function(){return this.sender||null},t.prototype.setSender=function(t){this.sender=t},t.prototype.getAddressee=function(){return this.addressee||null},t.prototype.setAddressee=function(t){this.addressee=t},t.prototype.getFileName=function(){return this.fileName},t.prototype.setFileName=function(t){this.fileName=t},t.prototype.getFileSize=function(){return this.fileSize},t.prototype.setFileSize=function(t){this.fileSize=t},t.prototype.getChecksum=function(){return this.checksum},t.prototype.setChecksum=function(t){this.checksum=t},t.prototype.getTimestamp=function(){return this.timestamp},t.prototype.setTimestamp=function(t){this.timestamp=t},t}(),Ln=function(){function t(){}return t.parseLong=function(t,e){return void 0===e&&(e=void 0),parseInt(t,e)},t}(),Fn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),kn=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return Fn(e,t),e.kind="NullPointerException",e}(s),xn=function(){function t(){}return t.prototype.writeBytes=function(t){this.writeBytesOffset(t,0,t.length)},t.prototype.writeBytesOffset=function(t,e,r){if(null==t)throw new kn;if(e<0||e>t.length||r<0||e+r>t.length||e+r<0)throw new v;if(0!==r)for(var n=0;n<r;n++)this.write(t[e+n])},t.prototype.flush=function(){},t.prototype.close=function(){},t}(),Vn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Un=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return Vn(e,t),e}(s),Hn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Gn=function(t){function e(e){void 0===e&&(e=32);var r=t.call(this)||this;if(r.count=0,e<0)throw new l("Negative initial size: "+e);return r.buf=new Uint8Array(e),r}return Hn(e,t),e.prototype.ensureCapacity=function(t){t-this.buf.length>0&&this.grow(t)},e.prototype.grow=function(t){var e=this.buf.length<<1;if(e-t<0&&(e=t),e<0){if(t<0)throw new Un;e=I.MAX_VALUE}this.buf=C.copyOfUint8Array(this.buf,e)},e.prototype.write=function(t){this.ensureCapacity(this.count+1),this.buf[this.count]=t,this.count+=1},e.prototype.writeBytesOffset=function(t,e,r){if(e<0||e>t.length||r<0||e+r-t.length>0)throw new v;this.ensureCapacity(this.count+r),w.arraycopy(t,e,this.buf,this.count,r),this.count+=r},e.prototype.writeTo=function(t){t.writeBytesOffset(this.buf,0,this.count)},e.prototype.reset=function(){this.count=0},e.prototype.toByteArray=function(){return C.copyOfUint8Array(this.buf,this.count)},e.prototype.size=function(){return this.count},e.prototype.toString=function(t){return t?"string"==typeof t?this.toString_string(t):this.toString_number(t):this.toString_void()},e.prototype.toString_void=function(){return new String(this.buf).toString()},e.prototype.toString_string=function(t){return new String(this.buf).toString()},e.prototype.toString_number=function(t){return new String(this.buf).toString()},e.prototype.close=function(){},e}(xn);function Xn(){if("undefined"!=typeof window)return window.BigInt||null;if("undefined"!=typeof global)return global.BigInt||null;if("undefined"!=typeof self)return self.BigInt||null;throw new Error("Can't search globals for BigInt!")}function Wn(t){if(void 0===Xr&&(Xr=Xn()),null===Xr)throw new Error("BigInt is not supported!");return Xr(t)}!function(t){t[t.ALPHA=0]="ALPHA",t[t.LOWER=1]="LOWER",t[t.MIXED=2]="MIXED",t[t.PUNCT=3]="PUNCT",t[t.ALPHA_SHIFT=4]="ALPHA_SHIFT",t[t.PUNCT_SHIFT=5]="PUNCT_SHIFT"}(Gr||(Gr={}));var jn=function(){function t(){}return t.decode=function(e,r){var n=new k(""),o=P.ISO8859_1;n.enableDecoding(o);for(var i=1,a=e[i++],u=new Bn;i<e[0];){switch(a){case t.TEXT_COMPACTION_MODE_LATCH:i=t.textCompaction(e,i,n);break;case t.BYTE_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH_6:i=t.byteCompaction(a,e,o,i,n);break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:n.append(e[i++]);break;case t.NUMERIC_COMPACTION_MODE_LATCH:i=t.numericCompaction(e,i,n);break;case t.ECI_CHARSET:P.getCharacterSetECIByValue(e[i++]);break;case t.ECI_GENERAL_PURPOSE:i+=2;break;case t.ECI_USER_DEFINED:i++;break;case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:i=t.decodeMacroBlock(e,i,u);break;case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:case t.MACRO_PDF417_TERMINATOR:throw new R;default:i--,i=t.textCompaction(e,i,n)}if(!(i<e.length))throw R.getFormatInstance();a=e[i++]}if(0===n.length())throw R.getFormatInstance();var s=new at(null,n.toString(),null,r);return s.setOther(u),s},t.decodeMacroBlock=function(e,r,n){if(r+t.NUMBER_OF_SEQUENCE_CODEWORDS>e[0])throw R.getFormatInstance();for(var o=new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS),i=0;i<t.NUMBER_OF_SEQUENCE_CODEWORDS;i++,r++)o[i]=e[r];n.setSegmentIndex(I.parseInt(t.decodeBase900toBase10(o,t.NUMBER_OF_SEQUENCE_CODEWORDS)));var a=new k;r=t.textCompaction(e,r,a),n.setFileId(a.toString());var u=-1;for(e[r]===t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD&&(u=r+1);r<e[0];)switch(e[r]){case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:switch(e[++r]){case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:var s=new k;r=t.textCompaction(e,r+1,s),n.setFileName(s.toString());break;case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:var c=new k;r=t.textCompaction(e,r+1,c),n.setSender(c.toString());break;case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:var f=new k;r=t.textCompaction(e,r+1,f),n.setAddressee(f.toString());break;case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:var h=new k;r=t.numericCompaction(e,r+1,h),n.setSegmentCount(I.parseInt(h.toString()));break;case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:var l=new k;r=t.numericCompaction(e,r+1,l),n.setTimestamp(Ln.parseLong(l.toString()));break;case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:var d=new k;r=t.numericCompaction(e,r+1,d),n.setChecksum(I.parseInt(d.toString()));break;case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:var p=new k;r=t.numericCompaction(e,r+1,p),n.setFileSize(Ln.parseLong(p.toString()));break;default:throw R.getFormatInstance()}break;case t.MACRO_PDF417_TERMINATOR:r++,n.setLastSegment(!0);break;default:throw R.getFormatInstance()}if(-1!==u){var g=r-u;n.isLastSegment()&&g--,n.setOptionalData(C.copyOfRange(e,u,u+g))}return r},t.textCompaction=function(e,r,n){for(var o=new Int32Array(2*(e[0]-r)),i=new Int32Array(2*(e[0]-r)),a=0,u=!1;r<e[0]&&!u;){var s=e[r++];if(s<t.TEXT_COMPACTION_MODE_LATCH)o[a]=s/30,o[a+1]=s%30,a+=2;else switch(s){case t.TEXT_COMPACTION_MODE_LATCH:o[a++]=t.TEXT_COMPACTION_MODE_LATCH;break;case t.BYTE_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH_6:case t.NUMERIC_COMPACTION_MODE_LATCH:case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:case t.MACRO_PDF417_TERMINATOR:r--,u=!0;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o[a]=t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE,s=e[r++],i[a]=s,a++}}return t.decodeTextCompaction(o,i,a,n),r},t.decodeTextCompaction=function(e,r,n,o){for(var i=Gr.ALPHA,a=Gr.ALPHA,u=0;u<n;){var s=e[u],c="";switch(i){case Gr.ALPHA:if(s<26)c=String.fromCharCode(65+s);else switch(s){case 26:c=" ";break;case t.LL:i=Gr.LOWER;break;case t.ML:i=Gr.MIXED;break;case t.PS:a=i,i=Gr.PUNCT_SHIFT;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o.append(r[u]);break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}break;case Gr.LOWER:if(s<26)c=String.fromCharCode(97+s);else switch(s){case 26:c=" ";break;case t.AS:a=i,i=Gr.ALPHA_SHIFT;break;case t.ML:i=Gr.MIXED;break;case t.PS:a=i,i=Gr.PUNCT_SHIFT;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o.append(r[u]);break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}break;case Gr.MIXED:if(s<t.PL)c=t.MIXED_CHARS[s];else switch(s){case t.PL:i=Gr.PUNCT;break;case 26:c=" ";break;case t.LL:i=Gr.LOWER;break;case t.AL:i=Gr.ALPHA;break;case t.PS:a=i,i=Gr.PUNCT_SHIFT;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o.append(r[u]);break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}break;case Gr.PUNCT:if(s<t.PAL)c=t.PUNCT_CHARS[s];else switch(s){case t.PAL:i=Gr.ALPHA;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o.append(r[u]);break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}break;case Gr.ALPHA_SHIFT:if(i=a,s<26)c=String.fromCharCode(65+s);else switch(s){case 26:c=" ";break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}break;case Gr.PUNCT_SHIFT:if(i=a,s<t.PAL)c=t.PUNCT_CHARS[s];else switch(s){case t.PAL:i=Gr.ALPHA;break;case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:o.append(r[u]);break;case t.TEXT_COMPACTION_MODE_LATCH:i=Gr.ALPHA}}""!==c&&o.append(c),u++}},t.byteCompaction=function(e,r,n,o,i){var a=new Gn,u=0,s=0,c=!1;switch(e){case t.BYTE_COMPACTION_MODE_LATCH:for(var f=new Int32Array(6),h=r[o++];o<r[0]&&!c;)switch(f[u++]=h,s=900*s+h,h=r[o++]){case t.TEXT_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH:case t.NUMERIC_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH_6:case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:case t.MACRO_PDF417_TERMINATOR:o--,c=!0;break;default:if(u%5==0&&u>0){for(var l=0;l<6;++l)a.write(Number(Wn(s)>>Wn(8*(5-l))));s=0,u=0}}o===r[0]&&h<t.TEXT_COMPACTION_MODE_LATCH&&(f[u++]=h);for(var d=0;d<u;d++)a.write(f[d]);break;case t.BYTE_COMPACTION_MODE_LATCH_6:for(;o<r[0]&&!c;){var p=r[o++];if(p<t.TEXT_COMPACTION_MODE_LATCH)u++,s=900*s+p;else switch(p){case t.TEXT_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH:case t.NUMERIC_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH_6:case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:case t.MACRO_PDF417_TERMINATOR:o--,c=!0}if(u%5==0&&u>0){for(l=0;l<6;++l)a.write(Number(Wn(s)>>Wn(8*(5-l))));s=0,u=0}}}return i.append(L.decode(a.toByteArray(),n)),o},t.numericCompaction=function(e,r,n){for(var o=0,i=!1,a=new Int32Array(t.MAX_NUMERIC_CODEWORDS);r<e[0]&&!i;){var u=e[r++];if(r===e[0]&&(i=!0),u<t.TEXT_COMPACTION_MODE_LATCH)a[o]=u,o++;else switch(u){case t.TEXT_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH:case t.BYTE_COMPACTION_MODE_LATCH_6:case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:case t.MACRO_PDF417_TERMINATOR:r--,i=!0}(o%t.MAX_NUMERIC_CODEWORDS==0||u===t.NUMERIC_COMPACTION_MODE_LATCH||i)&&o>0&&(n.append(t.decodeBase900toBase10(a,o)),o=0)}return r},t.decodeBase900toBase10=function(e,r){for(var n=Wn(0),o=0;o<r;o++)n+=t.EXP900[r-o-1]*Wn(e[o]);var i=n.toString();if("1"!==i.charAt(0))throw new R;return i.substring(1)},t.TEXT_COMPACTION_MODE_LATCH=900,t.BYTE_COMPACTION_MODE_LATCH=901,t.NUMERIC_COMPACTION_MODE_LATCH=902,t.BYTE_COMPACTION_MODE_LATCH_6=924,t.ECI_USER_DEFINED=925,t.ECI_GENERAL_PURPOSE=926,t.ECI_CHARSET=927,t.BEGIN_MACRO_PDF417_CONTROL_BLOCK=928,t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD=923,t.MACRO_PDF417_TERMINATOR=922,t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE=913,t.MAX_NUMERIC_CODEWORDS=15,t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME=0,t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT=1,t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP=2,t.MACRO_PDF417_OPTIONAL_FIELD_SENDER=3,t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE=4,t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE=5,t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM=6,t.PL=25,t.LL=27,t.AS=27,t.ML=28,t.AL=28,t.PS=29,t.PAL=29,t.PUNCT_CHARS=";<>@[\\]_`~!\r\t,:\n-.$/\"|*()?{}'",t.MIXED_CHARS="0123456789&\r\t,:#-.$/+%*=^",t.EXP900=Xn()?function(){var t=[];t[0]=Wn(1);var e=Wn(900);t[1]=e;for(var r=2;r<16;r++)t[r]=t[r-1]*e;return t}():[],t.NUMBER_OF_SEQUENCE_CODEWORDS=2,t}(),zn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Yn=function(){function t(){}return t.decode=function(e,r,n,o,i,a,u){for(var s,c=new vn(e,r,n,o,i),f=null,h=null,l=!0;;l=!1){if(null!=r&&(f=t.getRowIndicatorColumn(e,c,r,!0,a,u)),null!=o&&(h=t.getRowIndicatorColumn(e,c,o,!1,a,u)),null==(s=t.merge(f,h)))throw U.getNotFoundInstance();var d=s.getBoundingBox();if(!l||null==d||!(d.getMinY()<c.getMinY()||d.getMaxY()>c.getMaxY()))break;c=d}s.setBoundingBox(c);var p=s.getBarcodeColumnCount()+1;s.setDetectionResultColumn(0,f),s.setDetectionResultColumn(p,h);for(var g=null!=f,y=1;y<=p;y++){var w=g?y:p-y;if(void 0===s.getDetectionResultColumn(w)){var _=void 0;_=0===w||w===p?new Rn(c,0===w):new Cn(c),s.setDetectionResultColumn(w,_);for(var v=-1,m=v,A=c.getMinY();A<=c.getMaxY();A++){if((v=t.getStartColumn(s,w,A,g))<0||v>c.getMaxX()){if(-1===m)continue;v=m}var E=t.detectCodeword(e,c.getMinX(),c.getMaxX(),g,v,A,a,u);null!=E&&(_.setCodeword(A,E),m=v,a=Math.min(a,E.getWidth()),u=Math.max(u,E.getWidth()))}}}return t.createDecoderResult(s)},t.merge=function(e,r){if(null==e&&null==r)return null;var n=t.getBarcodeMetadata(e,r);if(null==n)return null;var o=vn.merge(t.adjustBoundingBox(e),t.adjustBoundingBox(r));return new Dn(n,o)},t.adjustBoundingBox=function(e){var r,n;if(null==e)return null;var o=e.getRowHeights();if(null==o)return null;var i=t.getMax(o),a=0;try{for(var u=zn(o),s=u.next();!s.done;s=u.next()){var c=s.value;if(a+=i-c,c>0)break}}catch(t){r={error:t}}finally{try{s&&!s.done&&(n=u.return)&&n.call(u)}finally{if(r)throw r.error}}for(var f=e.getCodewords(),h=0;a>0&&null==f[h];h++)a--;var l=0;for(h=o.length-1;h>=0&&(l+=i-o[h],!(o[h]>0));h--);for(h=f.length-1;l>0&&null==f[h];h--)l--;return e.getBoundingBox().addMissingRows(a,l,e.isLeft())},t.getMax=function(t){var e,r,n=-1;try{for(var o=zn(t),i=o.next();!i.done;i=o.next()){var a=i.value;n=Math.max(n,a)}}catch(t){e={error:t}}finally{try{i&&!i.done&&(r=o.return)&&r.call(o)}finally{if(e)throw e.error}}return n},t.getBarcodeMetadata=function(t,e){var r,n;return null==t||null==(r=t.getBarcodeMetadata())?null==e?null:e.getBarcodeMetadata():null==e||null==(n=e.getBarcodeMetadata())?r:r.getColumnCount()!==n.getColumnCount()&&r.getErrorCorrectionLevel()!==n.getErrorCorrectionLevel()&&r.getRowCount()!==n.getRowCount()?null:r},t.getRowIndicatorColumn=function(e,r,n,o,i,a){for(var u=new Rn(r,o),s=0;s<2;s++)for(var c=0===s?1:-1,f=Math.trunc(Math.trunc(n.getX())),h=Math.trunc(Math.trunc(n.getY()));h<=r.getMaxY()&&h>=r.getMinY();h+=c){var l=t.detectCodeword(e,0,e.getWidth(),o,f,h,i,a);null!=l&&(u.setCodeword(h,l),f=o?l.getStartX():l.getEndX())}return u},t.adjustCodewordCount=function(e,r){var n=r[0][1],o=n.getValue(),i=e.getBarcodeColumnCount()*e.getBarcodeRowCount()-t.getNumberOfECCodeWords(e.getBarcodeECLevel());if(0===o.length){if(i<1||i>sn.MAX_CODEWORDS_IN_BARCODE)throw U.getNotFoundInstance();n.setValue(i)}else o[0]!==i&&n.setValue(i)},t.createDecoderResult=function(e){var r=t.createBarcodeMatrix(e);t.adjustCodewordCount(e,r);for(var n=new Array,o=new Int32Array(e.getBarcodeRowCount()*e.getBarcodeColumnCount()),i=[],a=new Array,u=0;u<e.getBarcodeRowCount();u++)for(var s=0;s<e.getBarcodeColumnCount();s++){var c=r[u][s+1].getValue(),f=u*e.getBarcodeColumnCount()+s;0===c.length?n.push(f):1===c.length?o[f]=c[0]:(a.push(f),i.push(c))}for(var h=new Array(i.length),l=0;l<h.length;l++)h[l]=i[l];return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(),o,sn.toIntArray(n),sn.toIntArray(a),h)},t.createDecoderResultFromAmbiguousValues=function(e,r,n,o,i){for(var a=new Int32Array(o.length),u=100;u-- >0;){for(var s=0;s<a.length;s++)r[o[s]]=i[s][a[s]];try{return t.decodeCodewords(r,e,n)}catch(t){if(!(t instanceof g))throw t}if(0===a.length)throw g.getChecksumInstance();for(s=0;s<a.length;s++){if(a[s]<i[s].length-1){a[s]++;break}if(a[s]=0,s===a.length-1)throw g.getChecksumInstance()}}throw g.getChecksumInstance()},t.createBarcodeMatrix=function(t){for(var e,r,n,o,i=Array.from({length:t.getBarcodeRowCount()},(function(){return new Array(t.getBarcodeColumnCount()+2)})),a=0;a<i.length;a++)for(var u=0;u<i[a].length;u++)i[a][u]=new On;var s=0;try{for(var c=zn(t.getDetectionResultColumns()),f=c.next();!f.done;f=c.next()){var h=f.value;if(null!=h)try{for(var l=(n=void 0,zn(h.getCodewords())),d=l.next();!d.done;d=l.next()){var p=d.value;if(null!=p){var g=p.getRowNumber();if(g>=0){if(g>=i.length)continue;i[g][s].setValue(p.getValue())}}}}catch(t){n={error:t}}finally{try{d&&!d.done&&(o=l.return)&&o.call(l)}finally{if(n)throw n.error}}s++}}catch(t){e={error:t}}finally{try{f&&!f.done&&(r=c.return)&&r.call(c)}finally{if(e)throw e.error}}return i},t.isValidBarcodeColumn=function(t,e){return e>=0&&e<=t.getBarcodeColumnCount()+1},t.getStartColumn=function(e,r,n,o){var i,a,u=o?1:-1,s=null;if(t.isValidBarcodeColumn(e,r-u)&&(s=e.getDetectionResultColumn(r-u).getCodeword(n)),null!=s)return o?s.getEndX():s.getStartX();if(null!=(s=e.getDetectionResultColumn(r).getCodewordNearby(n)))return o?s.getStartX():s.getEndX();if(t.isValidBarcodeColumn(e,r-u)&&(s=e.getDetectionResultColumn(r-u).getCodewordNearby(n)),null!=s)return o?s.getEndX():s.getStartX();for(var c=0;t.isValidBarcodeColumn(e,r-u);){r-=u;try{for(var f=(i=void 0,zn(e.getDetectionResultColumn(r).getCodewords())),h=f.next();!h.done;h=f.next()){var l=h.value;if(null!=l)return(o?l.getEndX():l.getStartX())+u*c*(l.getEndX()-l.getStartX())}}catch(t){i={error:t}}finally{try{h&&!h.done&&(a=f.return)&&a.call(f)}finally{if(i)throw i.error}}c++}return o?e.getBoundingBox().getMinX():e.getBoundingBox().getMaxX()},t.detectCodeword=function(e,r,n,o,i,a,u,s){i=t.adjustCodewordStartColumn(e,r,n,o,i,a);var c,f=t.getModuleBitCount(e,r,n,o,i,a);if(null==f)return null;var h=vt.sum(f);if(o)c=i+h;else{for(var l=0;l<f.length/2;l++){var d=f[l];f[l]=f[f.length-1-l],f[f.length-1-l]=d}i=(c=i)-h}if(!t.checkCodewordSkew(h,u,s))return null;var p=Mn.getDecodedValue(f),g=sn.getCodeword(p);return-1===g?null:new Pn(i,c,t.getCodewordBucketNumber(p),g)},t.getModuleBitCount=function(t,e,r,n,o,i){for(var a=o,u=new Int32Array(8),s=0,c=n?1:-1,f=n;(n?a<r:a>=e)&&s<u.length;)t.get(a,i)===f?(u[s]++,a+=c):(s++,f=!f);return s===u.length||a===(n?r:e)&&s===u.length-1?u:null},t.getNumberOfECCodeWords=function(t){return 2<<t},t.adjustCodewordStartColumn=function(e,r,n,o,i,a){for(var u=i,s=o?-1:1,c=0;c<2;c++){for(;(o?u>=r:u<n)&&o===e.get(u,a);){if(Math.abs(i-u)>t.CODEWORD_SKEW_SIZE)return i;u+=s}s=-s,o=!o}return u},t.checkCodewordSkew=function(e,r,n){return r-t.CODEWORD_SKEW_SIZE<=e&&e<=n+t.CODEWORD_SKEW_SIZE},t.decodeCodewords=function(e,r,n){if(0===e.length)throw R.getFormatInstance();var o=1<<r+1,i=t.correctErrors(e,n,o);t.verifyCodewordCount(e,o);var a=jn.decode(e,""+r);return a.setErrorsCorrected(i),a.setErasures(n.length),a},t.correctErrors=function(e,r,n){if(null!=r&&r.length>n/2+t.MAX_ERRORS||n<0||n>t.MAX_EC_CODEWORDS)throw g.getChecksumInstance();return t.errorCorrection.decode(e,n,r)},t.verifyCodewordCount=function(t,e){if(t.length<4)throw R.getFormatInstance();var r=t[0];if(r>t.length)throw R.getFormatInstance();if(0===r){if(!(e<t.length))throw R.getFormatInstance();t[0]=t.length-e}},t.getBitCountForCodeword=function(t){for(var e=new Int32Array(8),r=0,n=e.length-1;!((1&t)!==r&&(r=1&t,--n<0));)e[n]++,t>>=1;return e},t.getCodewordBucketNumber=function(t){return t instanceof Int32Array?this.getCodewordBucketNumber_Int32Array(t):this.getCodewordBucketNumber_number(t)},t.getCodewordBucketNumber_number=function(e){return t.getCodewordBucketNumber(t.getBitCountForCodeword(e))},t.getCodewordBucketNumber_Int32Array=function(t){return(t[0]-t[2]+t[4]-t[6]+9)%9},t.toString=function(t){for(var e=new An,r=0;r<t.length;r++){e.format("Row %2d: ",r);for(var n=0;n<t[r].length;n++){var o=t[r][n];0===o.getValue().length?e.format("        ",null):e.format("%4d(%2d)",o.getValue()[0],o.getConfidence(o.getValue()[0]))}e.format("%n")}return e.toString()},t.CODEWORD_SKEW_SIZE=2,t.MAX_ERRORS=3,t.MAX_EC_CODEWORDS=512,t.errorCorrection=new _n,t}(),Zn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Kn=function(){function t(){}return t.prototype.decode=function(e,r){void 0===r&&(r=null);var n=t.decode(e,r,!1);if(null==n||0===n.length||null==n[0])throw U.getNotFoundInstance();return n[0]},t.prototype.decodeMultiple=function(e,r){void 0===r&&(r=null);try{return t.decode(e,r,!0)}catch(t){if(t instanceof R||t instanceof g)throw U.getNotFoundInstance();throw t}},t.decode=function(e,r,n){var o,i,a=new Array,u=hn.detectMultiple(e,r,n);try{for(var s=Zn(u.getPoints()),c=s.next();!c.done;c=s.next()){var f=c.value,h=Yn.decode(u.getBits(),f[4],f[5],f[6],f[7],t.getMinCodewordWidth(f),t.getMaxCodewordWidth(f)),l=new et(h.getText(),h.getRawBytes(),void 0,f,nt.PDF_417);l.putMetadata(it.ERROR_CORRECTION_LEVEL,h.getECLevel());var d=h.getOther();null!=d&&l.putMetadata(it.PDF417_EXTRA_METADATA,d),a.push(l)}}catch(t){o={error:t}}finally{try{c&&!c.done&&(i=s.return)&&i.call(s)}finally{if(o)throw o.error}}return a.map((function(t){return t}))},t.getMaxWidth=function(t,e){return null==t||null==e?0:Math.trunc(Math.abs(t.getX()-e.getX()))},t.getMinWidth=function(t,e){return null==t||null==e?I.MAX_VALUE:Math.trunc(Math.abs(t.getX()-e.getX()))},t.getMaxCodewordWidth=function(e){return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0],e[4]),t.getMaxWidth(e[6],e[2])*sn.MODULES_IN_CODEWORD/sn.MODULES_IN_STOP_PATTERN),Math.max(t.getMaxWidth(e[1],e[5]),t.getMaxWidth(e[7],e[3])*sn.MODULES_IN_CODEWORD/sn.MODULES_IN_STOP_PATTERN)))},t.getMinCodewordWidth=function(e){return Math.floor(Math.min(Math.min(t.getMinWidth(e[0],e[4]),t.getMinWidth(e[6],e[2])*sn.MODULES_IN_CODEWORD/sn.MODULES_IN_STOP_PATTERN),Math.min(t.getMinWidth(e[1],e[5]),t.getMinWidth(e[7],e[3])*sn.MODULES_IN_CODEWORD/sn.MODULES_IN_STOP_PATTERN)))},t.prototype.reset=function(){},t}(),qn=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Qn=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return qn(e,t),e.kind="ReaderException",e}(s),Jn=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},$n=function(){function t(){}return t.prototype.decode=function(t,e){return this.setHints(e),this.decodeInternal(t)},t.prototype.decodeWithState=function(t){return null!==this.readers&&void 0!==this.readers||this.setHints(null),this.decodeInternal(t)},t.prototype.setHints=function(t){this.hints=t;var e=null!=t&&void 0!==t.get(T.TRY_HARDER),r=null==t?null:t.get(T.POSSIBLE_FORMATS),n=new Array;if(null!=r){var o=r.some((function(t){return t===nt.UPC_A||t===nt.UPC_E||t===nt.EAN_13||t===nt.EAN_8||t===nt.CODABAR||t===nt.CODE_39||t===nt.CODE_93||t===nt.CODE_128||t===nt.ITF||t===nt.RSS_14||t===nt.RSS_EXPANDED}));o&&!e&&n.push(new fr(t)),r.includes(nt.QR_CODE)&&n.push(new an),r.includes(nt.DATA_MATRIX)&&n.push(new Or),r.includes(nt.AZTEC)&&n.push(new Mt),r.includes(nt.PDF_417)&&n.push(new Kn),o&&e&&n.push(new fr(t))}0===n.length&&(e||n.push(new fr(t)),n.push(new an),n.push(new Or),n.push(new Mt),n.push(new Kn),e&&n.push(new fr(t))),this.readers=n},t.prototype.reset=function(){var t,e;if(null!==this.readers)try{for(var r=Jn(this.readers),n=r.next();!n.done;n=r.next()){n.value.reset()}}catch(e){t={error:e}}finally{try{n&&!n.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}},t.prototype.decodeInternal=function(t){var e,r;if(null===this.readers)throw new Qn("No readers where selected, nothing can be read.");try{for(var n=Jn(this.readers),o=n.next();!o.done;o=n.next()){var i=o.value;try{return i.decode(t,this.hints)}catch(t){if(t instanceof Qn)continue}}}catch(t){e={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(e)throw e.error}}throw new U("No MultiFormat Readers were able to detect the code.")},t}(),to=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){void 0===e&&(e=null),void 0===r&&(r=500);var n=new $n;return n.setHints(e),t.call(this,n,r)||this}to(e,t),e.prototype.decodeBitmap=function(t){return this.reader.decodeWithState(t)}}(tt);var eo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e){return void 0===e&&(e=500),t.call(this,new Kn,e)||this}eo(e,t)}(tt);var ro,no=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e){return void 0===e&&(e=500),t.call(this,new an,e)||this}no(e,t)}(tt),function(t){t[t.ERROR_CORRECTION=0]="ERROR_CORRECTION",t[t.CHARACTER_SET=1]="CHARACTER_SET",t[t.DATA_MATRIX_SHAPE=2]="DATA_MATRIX_SHAPE",t[t.MIN_SIZE=3]="MIN_SIZE",t[t.MAX_SIZE=4]="MAX_SIZE",t[t.MARGIN=5]="MARGIN",t[t.PDF417_COMPACT=6]="PDF417_COMPACT",t[t.PDF417_COMPACTION=7]="PDF417_COMPACTION",t[t.PDF417_DIMENSIONS=8]="PDF417_DIMENSIONS",t[t.AZTEC_LAYERS=9]="AZTEC_LAYERS",t[t.QR_VERSION=10]="QR_VERSION"}(ro||(ro={}));var oo=ro,io=function(){function t(t){this.field=t,this.cachedGenerators=[],this.cachedGenerators.push(new st(t,Int32Array.from([1])))}return t.prototype.buildGenerator=function(t){var e=this.cachedGenerators;if(t>=e.length)for(var r=e[e.length-1],n=this.field,o=e.length;o<=t;o++){var i=r.multiply(new st(n,Int32Array.from([1,n.exp(o-1+n.getGeneratorBase())])));e.push(i),r=i}return e[t]},t.prototype.encode=function(t,e){if(0===e)throw new l("No error correction bytes");var r=t.length-e;if(r<=0)throw new l("No data bytes provided");var n=this.buildGenerator(e),o=new Int32Array(r);w.arraycopy(t,0,o,0,r);for(var i=new st(this.field,o),a=(i=i.multiplyByMonomial(e,1)).divide(n)[1].getCoefficients(),u=e-a.length,s=0;s<u;s++)t[r+s]=0;w.arraycopy(a,0,t,r+u,a.length)},t}(),ao=function(){function t(){}return t.applyMaskPenaltyRule1=function(e){return t.applyMaskPenaltyRule1Internal(e,!0)+t.applyMaskPenaltyRule1Internal(e,!1)},t.applyMaskPenaltyRule2=function(e){for(var r=0,n=e.getArray(),o=e.getWidth(),i=e.getHeight(),a=0;a<i-1;a++)for(var u=n[a],s=0;s<o-1;s++){var c=u[s];c===u[s+1]&&c===n[a+1][s]&&c===n[a+1][s+1]&&r++}return t.N2*r},t.applyMaskPenaltyRule3=function(e){for(var r=0,n=e.getArray(),o=e.getWidth(),i=e.getHeight(),a=0;a<i;a++)for(var u=0;u<o;u++){var s=n[a];u+6<o&&1===s[u]&&0===s[u+1]&&1===s[u+2]&&1===s[u+3]&&1===s[u+4]&&0===s[u+5]&&1===s[u+6]&&(t.isWhiteHorizontal(s,u-4,u)||t.isWhiteHorizontal(s,u+7,u+11))&&r++,a+6<i&&1===n[a][u]&&0===n[a+1][u]&&1===n[a+2][u]&&1===n[a+3][u]&&1===n[a+4][u]&&0===n[a+5][u]&&1===n[a+6][u]&&(t.isWhiteVertical(n,u,a-4,a)||t.isWhiteVertical(n,u,a+7,a+11))&&r++}return r*t.N3},t.isWhiteHorizontal=function(t,e,r){e=Math.max(e,0),r=Math.min(r,t.length);for(var n=e;n<r;n++)if(1===t[n])return!1;return!0},t.isWhiteVertical=function(t,e,r,n){r=Math.max(r,0),n=Math.min(n,t.length);for(var o=r;o<n;o++)if(1===t[o][e])return!1;return!0},t.applyMaskPenaltyRule4=function(e){for(var r=0,n=e.getArray(),o=e.getWidth(),i=e.getHeight(),a=0;a<i;a++)for(var u=n[a],s=0;s<o;s++)1===u[s]&&r++;var c=e.getHeight()*e.getWidth();return Math.floor(10*Math.abs(2*r-c)/c)*t.N4},t.getDataMaskBit=function(t,e,r){var n,o;switch(t){case 0:n=r+e&1;break;case 1:n=1&r;break;case 2:n=e%3;break;case 3:n=(r+e)%3;break;case 4:n=Math.floor(r/2)+Math.floor(e/3)&1;break;case 5:n=(1&(o=r*e))+o%3;break;case 6:n=(1&(o=r*e))+o%3&1;break;case 7:n=(o=r*e)%3+(r+e&1)&1;break;default:throw new l("Invalid mask pattern: "+t)}return 0===n},t.applyMaskPenaltyRule1Internal=function(e,r){for(var n=0,o=r?e.getHeight():e.getWidth(),i=r?e.getWidth():e.getHeight(),a=e.getArray(),u=0;u<o;u++){for(var s=0,c=-1,f=0;f<i;f++){var h=r?a[u][f]:a[f][u];h===c?s++:(s>=5&&(n+=t.N1+(s-5)),s=1,c=h)}s>=5&&(n+=t.N1+(s-5))}return n},t.N1=3,t.N2=3,t.N3=40,t.N4=10,t}(),uo=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},so=function(){function t(t,e){this.width=t,this.height=e;for(var r=new Array(e),n=0;n!==e;n++)r[n]=new Uint8Array(t);this.bytes=r}return t.prototype.getHeight=function(){return this.height},t.prototype.getWidth=function(){return this.width},t.prototype.get=function(t,e){return this.bytes[e][t]},t.prototype.getArray=function(){return this.bytes},t.prototype.setNumber=function(t,e,r){this.bytes[e][t]=r},t.prototype.setBoolean=function(t,e,r){this.bytes[e][t]=r?1:0},t.prototype.clear=function(t){var e,r;try{for(var n=uo(this.bytes),o=n.next();!o.done;o=n.next()){var i=o.value;C.fill(i,t)}}catch(t){e={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(e)throw e.error}}},t.prototype.equals=function(e){if(!(e instanceof t))return!1;var r=e;if(this.width!==r.width)return!1;if(this.height!==r.height)return!1;for(var n=0,o=this.height;n<o;++n)for(var i=this.bytes[n],a=r.bytes[n],u=0,s=this.width;u<s;++u)if(i[u]!==a[u])return!1;return!0},t.prototype.toString=function(){for(var t=new k,e=0,r=this.height;e<r;++e){for(var n=this.bytes[e],o=0,i=this.width;o<i;++o)switch(n[o]){case 0:t.append(" 0");break;case 1:t.append(" 1");break;default:t.append("  ")}t.append("\n")}return t.toString()},t}(),co=function(){function t(){this.maskPattern=-1}return t.prototype.getMode=function(){return this.mode},t.prototype.getECLevel=function(){return this.ecLevel},t.prototype.getVersion=function(){return this.version},t.prototype.getMaskPattern=function(){return this.maskPattern},t.prototype.getMatrix=function(){return this.matrix},t.prototype.toString=function(){var t=new k;return t.append("<<\n"),t.append(" mode: "),t.append(this.mode?this.mode.toString():"null"),t.append("\n ecLevel: "),t.append(this.ecLevel?this.ecLevel.toString():"null"),t.append("\n version: "),t.append(this.version?this.version.toString():"null"),t.append("\n maskPattern: "),t.append(this.maskPattern.toString()),this.matrix?(t.append("\n matrix:\n"),t.append(this.matrix.toString())):t.append("\n matrix: null\n"),t.append(">>\n"),t.toString()},t.prototype.setMode=function(t){this.mode=t},t.prototype.setECLevel=function(t){this.ecLevel=t},t.prototype.setVersion=function(t){this.version=t},t.prototype.setMaskPattern=function(t){this.maskPattern=t},t.prototype.setMatrix=function(t){this.matrix=t},t.isValidMaskPattern=function(e){return e>=0&&e<t.NUM_MASK_PATTERNS},t.NUM_MASK_PATTERNS=8,t}(),fo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ho=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return fo(e,t),e.kind="WriterException",e}(s),lo=function(){function t(){}return t.clearMatrix=function(t){t.clear(255)},t.buildMatrix=function(e,r,n,o,i){t.clearMatrix(i),t.embedBasicPatterns(n,i),t.embedTypeInfo(r,o,i),t.maybeEmbedVersionInfo(n,i),t.embedDataBits(e,o,i)},t.embedBasicPatterns=function(e,r){t.embedPositionDetectionPatternsAndSeparators(r),t.embedDarkDotAtLeftBottomCorner(r),t.maybeEmbedPositionAdjustmentPatterns(e,r),t.embedTimingPatterns(r)},t.embedTypeInfo=function(e,r,n){var o=new S;t.makeTypeInfoBits(e,r,o);for(var i=0,a=o.getSize();i<a;++i){var u=o.get(o.getSize()-1-i),s=t.TYPE_INFO_COORDINATES[i],c=s[0],f=s[1];if(n.setBoolean(c,f,u),i<8){var h=n.getWidth()-i-1,l=8;n.setBoolean(h,l,u)}else{h=8,l=n.getHeight()-7+(i-8);n.setBoolean(h,l,u)}}},t.maybeEmbedVersionInfo=function(e,r){if(!(e.getVersionNumber()<7)){var n=new S;t.makeVersionInfoBits(e,n);for(var o=17,i=0;i<6;++i)for(var a=0;a<3;++a){var u=n.get(o);o--,r.setBoolean(i,r.getHeight()-11+a,u),r.setBoolean(r.getHeight()-11+a,i,u)}}},t.embedDataBits=function(e,r,n){for(var o=0,i=-1,a=n.getWidth()-1,u=n.getHeight()-1;a>0;){for(6===a&&(a-=1);u>=0&&u<n.getHeight();){for(var s=0;s<2;++s){var c=a-s;if(t.isEmpty(n.get(c,u))){var f=void 0;o<e.getSize()?(f=e.get(o),++o):f=!1,255!==r&&ao.getDataMaskBit(r,c,u)&&(f=!f),n.setBoolean(c,u,f)}}u+=i}u+=i=-i,a-=2}if(o!==e.getSize())throw new ho("Not all bits consumed: "+o+"/"+e.getSize())},t.findMSBSet=function(t){return 32-I.numberOfLeadingZeros(t)},t.calculateBCHCode=function(e,r){if(0===r)throw new l("0 polynomial");var n=t.findMSBSet(r);for(e<<=n-1;t.findMSBSet(e)>=n;)e^=r<<t.findMSBSet(e)-n;return e},t.makeTypeInfoBits=function(e,r,n){if(!co.isValidMaskPattern(r))throw new ho("Invalid mask pattern");var o=e.getBits()<<3|r;n.appendBits(o,5);var i=t.calculateBCHCode(o,t.TYPE_INFO_POLY);n.appendBits(i,10);var a=new S;if(a.appendBits(t.TYPE_INFO_MASK_PATTERN,15),n.xor(a),15!==n.getSize())throw new ho("should not happen but we got: "+n.getSize())},t.makeVersionInfoBits=function(e,r){r.appendBits(e.getVersionNumber(),6);var n=t.calculateBCHCode(e.getVersionNumber(),t.VERSION_INFO_POLY);if(r.appendBits(n,12),18!==r.getSize())throw new ho("should not happen but we got: "+r.getSize())},t.isEmpty=function(t){return 255===t},t.embedTimingPatterns=function(e){for(var r=8;r<e.getWidth()-8;++r){var n=(r+1)%2;t.isEmpty(e.get(r,6))&&e.setNumber(r,6,n),t.isEmpty(e.get(6,r))&&e.setNumber(6,r,n)}},t.embedDarkDotAtLeftBottomCorner=function(t){if(0===t.get(8,t.getHeight()-8))throw new ho;t.setNumber(8,t.getHeight()-8,1)},t.embedHorizontalSeparationPattern=function(e,r,n){for(var o=0;o<8;++o){if(!t.isEmpty(n.get(e+o,r)))throw new ho;n.setNumber(e+o,r,0)}},t.embedVerticalSeparationPattern=function(e,r,n){for(var o=0;o<7;++o){if(!t.isEmpty(n.get(e,r+o)))throw new ho;n.setNumber(e,r+o,0)}},t.embedPositionAdjustmentPattern=function(e,r,n){for(var o=0;o<5;++o)for(var i=t.POSITION_ADJUSTMENT_PATTERN[o],a=0;a<5;++a)n.setNumber(e+a,r+o,i[a])},t.embedPositionDetectionPattern=function(e,r,n){for(var o=0;o<7;++o)for(var i=t.POSITION_DETECTION_PATTERN[o],a=0;a<7;++a)n.setNumber(e+a,r+o,i[a])},t.embedPositionDetectionPatternsAndSeparators=function(e){var r=t.POSITION_DETECTION_PATTERN[0].length;t.embedPositionDetectionPattern(0,0,e),t.embedPositionDetectionPattern(e.getWidth()-r,0,e),t.embedPositionDetectionPattern(0,e.getWidth()-r,e);t.embedHorizontalSeparationPattern(0,7,e),t.embedHorizontalSeparationPattern(e.getWidth()-8,7,e),t.embedHorizontalSeparationPattern(0,e.getWidth()-8,e);t.embedVerticalSeparationPattern(7,0,e),t.embedVerticalSeparationPattern(e.getHeight()-7-1,0,e),t.embedVerticalSeparationPattern(7,e.getHeight()-7,e)},t.maybeEmbedPositionAdjustmentPatterns=function(e,r){if(!(e.getVersionNumber()<2))for(var n=e.getVersionNumber()-1,o=t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n],i=0,a=o.length;i!==a;i++){var u=o[i];if(u>=0)for(var s=0;s!==a;s++){var c=o[s];c>=0&&t.isEmpty(r.get(c,u))&&t.embedPositionAdjustmentPattern(c-2,u-2,r)}}},t.POSITION_DETECTION_PATTERN=Array.from([Int32Array.from([1,1,1,1,1,1,1]),Int32Array.from([1,0,0,0,0,0,1]),Int32Array.from([1,0,1,1,1,0,1]),Int32Array.from([1,0,1,1,1,0,1]),Int32Array.from([1,0,1,1,1,0,1]),Int32Array.from([1,0,0,0,0,0,1]),Int32Array.from([1,1,1,1,1,1,1])]),t.POSITION_ADJUSTMENT_PATTERN=Array.from([Int32Array.from([1,1,1,1,1]),Int32Array.from([1,0,0,0,1]),Int32Array.from([1,0,1,0,1]),Int32Array.from([1,0,0,0,1]),Int32Array.from([1,1,1,1,1])]),t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE=Array.from([Int32Array.from([-1,-1,-1,-1,-1,-1,-1]),Int32Array.from([6,18,-1,-1,-1,-1,-1]),Int32Array.from([6,22,-1,-1,-1,-1,-1]),Int32Array.from([6,26,-1,-1,-1,-1,-1]),Int32Array.from([6,30,-1,-1,-1,-1,-1]),Int32Array.from([6,34,-1,-1,-1,-1,-1]),Int32Array.from([6,22,38,-1,-1,-1,-1]),Int32Array.from([6,24,42,-1,-1,-1,-1]),Int32Array.from([6,26,46,-1,-1,-1,-1]),Int32Array.from([6,28,50,-1,-1,-1,-1]),Int32Array.from([6,30,54,-1,-1,-1,-1]),Int32Array.from([6,32,58,-1,-1,-1,-1]),Int32Array.from([6,34,62,-1,-1,-1,-1]),Int32Array.from([6,26,46,66,-1,-1,-1]),Int32Array.from([6,26,48,70,-1,-1,-1]),Int32Array.from([6,26,50,74,-1,-1,-1]),Int32Array.from([6,30,54,78,-1,-1,-1]),Int32Array.from([6,30,56,82,-1,-1,-1]),Int32Array.from([6,30,58,86,-1,-1,-1]),Int32Array.from([6,34,62,90,-1,-1,-1]),Int32Array.from([6,28,50,72,94,-1,-1]),Int32Array.from([6,26,50,74,98,-1,-1]),Int32Array.from([6,30,54,78,102,-1,-1]),Int32Array.from([6,28,54,80,106,-1,-1]),Int32Array.from([6,32,58,84,110,-1,-1]),Int32Array.from([6,30,58,86,114,-1,-1]),Int32Array.from([6,34,62,90,118,-1,-1]),Int32Array.from([6,26,50,74,98,122,-1]),Int32Array.from([6,30,54,78,102,126,-1]),Int32Array.from([6,26,52,78,104,130,-1]),Int32Array.from([6,30,56,82,108,134,-1]),Int32Array.from([6,34,60,86,112,138,-1]),Int32Array.from([6,30,58,86,114,142,-1]),Int32Array.from([6,34,62,90,118,146,-1]),Int32Array.from([6,30,54,78,102,126,150]),Int32Array.from([6,24,50,76,102,128,154]),Int32Array.from([6,28,54,80,106,132,158]),Int32Array.from([6,32,58,84,110,136,162]),Int32Array.from([6,26,54,82,110,138,166]),Int32Array.from([6,30,58,86,114,142,170])]),t.TYPE_INFO_COORDINATES=Array.from([Int32Array.from([8,0]),Int32Array.from([8,1]),Int32Array.from([8,2]),Int32Array.from([8,3]),Int32Array.from([8,4]),Int32Array.from([8,5]),Int32Array.from([8,7]),Int32Array.from([8,8]),Int32Array.from([7,8]),Int32Array.from([5,8]),Int32Array.from([4,8]),Int32Array.from([3,8]),Int32Array.from([2,8]),Int32Array.from([1,8]),Int32Array.from([0,8])]),t.VERSION_INFO_POLY=7973,t.TYPE_INFO_POLY=1335,t.TYPE_INFO_MASK_PATTERN=21522,t}(),po=function(){function t(t,e){this.dataBytes=t,this.errorCorrectionBytes=e}return t.prototype.getDataBytes=function(){return this.dataBytes},t.prototype.getErrorCorrectionBytes=function(){return this.errorCorrectionBytes},t}(),go=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")};!function(){function t(){}t.calculateMaskPenalty=function(t){return ao.applyMaskPenaltyRule1(t)+ao.applyMaskPenaltyRule2(t)+ao.applyMaskPenaltyRule3(t)+ao.applyMaskPenaltyRule4(t)},t.encode=function(e,r,n){void 0===n&&(n=null);var o=t.DEFAULT_BYTE_MODE_ENCODING,i=null!==n&&void 0!==n.get(oo.CHARACTER_SET);i&&(o=n.get(oo.CHARACTER_SET).toString());var a=this.chooseMode(e,o),u=new S;if(a===Wr.BYTE&&(i||t.DEFAULT_BYTE_MODE_ENCODING!==o)){var s=P.getCharacterSetECIByName(o);void 0!==s&&this.appendECI(s,u)}this.appendModeInfo(a,u);var c,f=new S;if(this.appendBytes(e,a,f,o),null!==n&&void 0!==n.get(oo.QR_VERSION)){var h=Number.parseInt(n.get(oo.QR_VERSION).toString(),10);c=Fr.getVersionForNumber(h);var l=this.calculateBitsNeeded(a,u,f,c);if(!this.willFit(l,c,r))throw new ho("Data too big for requested version")}else c=this.recommendVersion(r,a,u,f);var d=new S;d.appendBitArray(u);var p=a===Wr.BYTE?f.getSizeInBytes():e.length;this.appendLengthInfo(p,c,a,d),d.appendBitArray(f);var g=c.getECBlocksForLevel(r),y=c.getTotalCodewords()-g.getTotalECCodewords();this.terminateBits(y,d);var w=this.interleaveWithECBytes(d,c.getTotalCodewords(),y,g.getNumBlocks()),_=new co;_.setECLevel(r),_.setMode(a),_.setVersion(c);var v=c.getDimensionForVersion(),m=new so(v,v),A=this.chooseMaskPattern(w,r,c,m);return _.setMaskPattern(A),lo.buildMatrix(w,r,c,A,m),_.setMatrix(m),_},t.recommendVersion=function(t,e,r,n){var o=this.calculateBitsNeeded(e,r,n,Fr.getVersionForNumber(1)),i=this.chooseVersion(o,t),a=this.calculateBitsNeeded(e,r,n,i);return this.chooseVersion(a,t)},t.calculateBitsNeeded=function(t,e,r,n){return e.getSize()+t.getCharacterCountBits(n)+r.getSize()},t.getAlphanumericCode=function(e){return e<t.ALPHANUMERIC_TABLE.length?t.ALPHANUMERIC_TABLE[e]:-1},t.chooseMode=function(e,r){if(void 0===r&&(r=null),P.SJIS.getName()===r&&this.isOnlyDoubleByteKanji(e))return Wr.KANJI;for(var n=!1,o=!1,i=0,a=e.length;i<a;++i){var u=e.charAt(i);if(t.isDigit(u))n=!0;else{if(-1===this.getAlphanumericCode(u.charCodeAt(0)))return Wr.BYTE;o=!0}}return o?Wr.ALPHANUMERIC:n?Wr.NUMERIC:Wr.BYTE},t.isOnlyDoubleByteKanji=function(t){var e;try{e=L.encode(t,P.SJIS)}catch(t){return!1}var r=e.length;if(r%2!=0)return!1;for(var n=0;n<r;n+=2){var o=255&e[n];if((o<129||o>159)&&(o<224||o>235))return!1}return!0},t.chooseMaskPattern=function(t,e,r,n){for(var o=Number.MAX_SAFE_INTEGER,i=-1,a=0;a<co.NUM_MASK_PATTERNS;a++){lo.buildMatrix(t,e,r,a,n);var u=this.calculateMaskPenalty(n);u<o&&(o=u,i=a)}return i},t.chooseVersion=function(e,r){for(var n=1;n<=40;n++){var o=Fr.getVersionForNumber(n);if(t.willFit(e,o,r))return o}throw new ho("Data too big")},t.willFit=function(t,e,r){return e.getTotalCodewords()-e.getECBlocksForLevel(r).getTotalECCodewords()>=(t+7)/8},t.terminateBits=function(t,e){var r=8*t;if(e.getSize()>r)throw new ho("data bits cannot fit in the QR Code"+e.getSize()+" > "+r);for(var n=0;n<4&&e.getSize()<r;++n)e.appendBit(!1);var o=7&e.getSize();if(o>0)for(n=o;n<8;n++)e.appendBit(!1);var i=t-e.getSizeInBytes();for(n=0;n<i;++n)e.appendBits(0==(1&n)?236:17,8);if(e.getSize()!==r)throw new ho("Bits size does not equal capacity")},t.getNumDataBytesAndNumECBytesForBlockID=function(t,e,r,n,o,i){if(n>=r)throw new ho("Block ID too large");var a=t%r,u=r-a,s=Math.floor(t/r),c=s+1,f=Math.floor(e/r),h=f+1,l=s-f,d=c-h;if(l!==d)throw new ho("EC bytes mismatch");if(r!==u+a)throw new ho("RS blocks mismatch");if(t!==(f+l)*u+(h+d)*a)throw new ho("Total bytes mismatch");n<u?(o[0]=f,i[0]=l):(o[0]=h,i[0]=d)},t.interleaveWithECBytes=function(e,r,n,o){var i,a,u,s;if(e.getSizeInBytes()!==n)throw new ho("Number of bits and data bytes does not match");for(var c=0,f=0,h=0,l=new Array,d=0;d<o;++d){var p=new Int32Array(1),g=new Int32Array(1);t.getNumDataBytesAndNumECBytesForBlockID(r,n,o,d,p,g);var y=p[0],w=new Uint8Array(y);e.toBytes(8*c,w,0,y);var _=t.generateECBytes(w,g[0]);l.push(new po(w,_)),f=Math.max(f,y),h=Math.max(h,_.length),c+=p[0]}if(n!==c)throw new ho("Data bytes does not match offset");var v=new S;for(d=0;d<f;++d)try{for(var m=(i=void 0,go(l)),A=m.next();!A.done;A=m.next()){d<(w=A.value.getDataBytes()).length&&v.appendBits(w[d],8)}}catch(t){i={error:t}}finally{try{A&&!A.done&&(a=m.return)&&a.call(m)}finally{if(i)throw i.error}}for(d=0;d<h;++d)try{for(var E=(u=void 0,go(l)),C=E.next();!C.done;C=E.next()){d<(_=C.value.getErrorCorrectionBytes()).length&&v.appendBits(_[d],8)}}catch(t){u={error:t}}finally{try{C&&!C.done&&(s=E.return)&&s.call(E)}finally{if(u)throw u.error}}if(r!==v.getSizeInBytes())throw new ho("Interleaving error: "+r+" and "+v.getSizeInBytes()+" differ.");return v},t.generateECBytes=function(t,e){for(var r=t.length,n=new Int32Array(r+e),o=0;o<r;o++)n[o]=255&t[o];new io(lt.QR_CODE_FIELD_256).encode(n,e);var i=new Uint8Array(e);for(o=0;o<e;o++)i[o]=n[r+o];return i},t.appendModeInfo=function(t,e){e.appendBits(t.getBits(),4)},t.appendLengthInfo=function(t,e,r,n){var o=r.getCharacterCountBits(e);if(t>=1<<o)throw new ho(t+" is bigger than "+((1<<o)-1));n.appendBits(t,o)},t.appendBytes=function(e,r,n,o){switch(r){case Wr.NUMERIC:t.appendNumericBytes(e,n);break;case Wr.ALPHANUMERIC:t.appendAlphanumericBytes(e,n);break;case Wr.BYTE:t.append8BitBytes(e,n,o);break;case Wr.KANJI:t.appendKanjiBytes(e,n);break;default:throw new ho("Invalid mode: "+r)}},t.getDigit=function(t){return t.charCodeAt(0)-48},t.isDigit=function(e){var r=t.getDigit(e);return r>=0&&r<=9},t.appendNumericBytes=function(e,r){for(var n=e.length,o=0;o<n;){var i=t.getDigit(e.charAt(o));if(o+2<n){var a=t.getDigit(e.charAt(o+1)),u=t.getDigit(e.charAt(o+2));r.appendBits(100*i+10*a+u,10),o+=3}else if(o+1<n){a=t.getDigit(e.charAt(o+1));r.appendBits(10*i+a,7),o+=2}else r.appendBits(i,4),o++}},t.appendAlphanumericBytes=function(e,r){for(var n=e.length,o=0;o<n;){var i=t.getAlphanumericCode(e.charCodeAt(o));if(-1===i)throw new ho;if(o+1<n){var a=t.getAlphanumericCode(e.charCodeAt(o+1));if(-1===a)throw new ho;r.appendBits(45*i+a,11),o+=2}else r.appendBits(i,6),o++}},t.append8BitBytes=function(t,e,r){var n;try{n=L.encode(t,r)}catch(t){throw new ho(t)}for(var o=0,i=n.length;o!==i;o++){var a=n[o];e.appendBits(a,8)}},t.appendKanjiBytes=function(t,e){var r;try{r=L.encode(t,P.SJIS)}catch(t){throw new ho(t)}for(var n=r.length,o=0;o<n;o+=2){var i=(255&r[o])<<8&4294967295|255&r[o+1],a=-1;if(i>=33088&&i<=40956?a=i-33088:i>=57408&&i<=60351&&(a=i-49472),-1===a)throw new ho("Invalid byte sequence");var u=192*(a>>8)+(255&a);e.appendBits(u,13)}},t.appendECI=function(t,e){e.appendBits(Wr.ECI.getBits(),4),e.appendBits(t.getValue(),8)},t.ALPHANUMERIC_TABLE=Int32Array.from([-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,36,-1,-1,-1,37,38,-1,-1,-1,-1,39,40,-1,41,42,43,0,1,2,3,4,5,6,7,8,9,44,-1,-1,-1,-1,-1,-1,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,-1,-1,-1,-1,-1]),t.DEFAULT_BYTE_MODE_ENCODING=P.UTF8.getName()}();var yo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r,n,o,i,a,u,s){var c=t.call(this,a,u)||this;if(c.yuvData=e,c.dataWidth=r,c.dataHeight=n,c.left=o,c.top=i,o+a>r||i+u>n)throw new l("Crop rectangle does not fit within image data.");return s&&c.reverseHorizontal(a,u),c}yo(e,t),e.prototype.getRow=function(t,e){if(t<0||t>=this.getHeight())throw new l("Requested row is outside the image: "+t);var r=this.getWidth();(null==e||e.length<r)&&(e=new Uint8ClampedArray(r));var n=(t+this.top)*this.dataWidth+this.left;return w.arraycopy(this.yuvData,n,e,0,r),e},e.prototype.getMatrix=function(){var t=this.getWidth(),e=this.getHeight();if(t===this.dataWidth&&e===this.dataHeight)return this.yuvData;var r=t*e,n=new Uint8ClampedArray(r),o=this.top*this.dataWidth+this.left;if(t===this.dataWidth)return w.arraycopy(this.yuvData,o,n,0,r),n;for(var i=0;i<e;i++){var a=i*t;w.arraycopy(this.yuvData,o,n,a,t),o+=this.dataWidth}return n},e.prototype.isCropSupported=function(){return!0},e.prototype.crop=function(t,r,n,o){return new e(this.yuvData,this.dataWidth,this.dataHeight,this.left+t,this.top+r,n,o,!1)},e.prototype.renderThumbnail=function(){for(var t=this.getWidth()/e.THUMBNAIL_SCALE_FACTOR,r=this.getHeight()/e.THUMBNAIL_SCALE_FACTOR,n=new Int32Array(t*r),o=this.yuvData,i=this.top*this.dataWidth+this.left,a=0;a<r;a++){for(var u=a*t,s=0;s<t;s++){var c=255&o[i+s*e.THUMBNAIL_SCALE_FACTOR];n[u+s]=4278190080|65793*c}i+=this.dataWidth*e.THUMBNAIL_SCALE_FACTOR}return n},e.prototype.getThumbnailWidth=function(){return this.getWidth()/e.THUMBNAIL_SCALE_FACTOR},e.prototype.getThumbnailHeight=function(){return this.getHeight()/e.THUMBNAIL_SCALE_FACTOR},e.prototype.reverseHorizontal=function(t,e){for(var r=this.yuvData,n=0,o=this.top*this.dataWidth+this.left;n<e;n++,o+=this.dataWidth)for(var i=o+t/2,a=o,u=o+t-1;a<i;a++,u--){var s=r[a];r[a]=r[u],r[u]=s}},e.prototype.invert=function(){return new Y(this)},e.THUMBNAIL_SCALE_FACTOR=2}(j);var wo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r,n,o,i,a,u){var s=t.call(this,r,n)||this;if(s.dataWidth=o,s.dataHeight=i,s.left=a,s.top=u,4===e.BYTES_PER_ELEMENT){for(var c=r*n,f=new Uint8ClampedArray(c),h=0;h<c;h++){var d=e[h],p=d>>16&255,g=d>>7&510,y=255&d;f[h]=(p+g+y)/4&255}s.luminances=f}else s.luminances=e;if(void 0===o&&(s.dataWidth=r),void 0===i&&(s.dataHeight=n),void 0===a&&(s.left=0),void 0===u&&(s.top=0),s.left+r>s.dataWidth||s.top+n>s.dataHeight)throw new l("Crop rectangle does not fit within image data.");return s}wo(e,t),e.prototype.getRow=function(t,e){if(t<0||t>=this.getHeight())throw new l("Requested row is outside the image: "+t);var r=this.getWidth();(null==e||e.length<r)&&(e=new Uint8ClampedArray(r));var n=(t+this.top)*this.dataWidth+this.left;return w.arraycopy(this.luminances,n,e,0,r),e},e.prototype.getMatrix=function(){var t=this.getWidth(),e=this.getHeight();if(t===this.dataWidth&&e===this.dataHeight)return this.luminances;var r=t*e,n=new Uint8ClampedArray(r),o=this.top*this.dataWidth+this.left;if(t===this.dataWidth)return w.arraycopy(this.luminances,o,n,0,r),n;for(var i=0;i<e;i++){var a=i*t;w.arraycopy(this.luminances,o,n,a,t),o+=this.dataWidth}return n},e.prototype.isCropSupported=function(){return!0},e.prototype.crop=function(t,r,n,o){return new e(this.luminances,n,o,this.dataWidth,this.dataHeight,this.left+t,this.top+r)},e.prototype.invert=function(){return new Y(this)}}(j);var _o=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(){return null!==t&&t.apply(this,arguments)||this}_o(e,t),e.forName=function(t){return this.getCharacterSetECIByName(t)}}(P);var vo=function(){function t(t){this.previous=t}return t.prototype.getPrevious=function(){return this.previous},t}(),mo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Ao=function(t){function e(e,r,n){var o=t.call(this,e)||this;return o.value=r,o.bitCount=n,o}return mo(e,t),e.prototype.appendTo=function(t,e){t.appendBits(this.value,this.bitCount)},e.prototype.add=function(t,r){return new e(this,t,r)},e.prototype.addBinaryShift=function(t,r){return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"),new e(this,t,r)},e.prototype.toString=function(){var t=this.value&(1<<this.bitCount)-1;return t|=1<<this.bitCount,"<"+I.toBinaryString(t|1<<this.bitCount).substring(1)+">"},e}(vo),Eo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r,n){var o=t.call(this,e,0,0)||this;return o.binaryShiftStart=r,o.binaryShiftByteCount=n,o}Eo(e,t),e.prototype.appendTo=function(t,e){for(var r=0;r<this.binaryShiftByteCount;r++)(0===r||31===r&&this.binaryShiftByteCount<=62)&&(t.appendBits(31,5),this.binaryShiftByteCount>62?t.appendBits(this.binaryShiftByteCount-31,16):0===r?t.appendBits(Math.min(this.binaryShiftByteCount,31),5):t.appendBits(this.binaryShiftByteCount-31,5)),t.appendBits(e[this.binaryShiftStart+r],8)},e.prototype.addBinaryShift=function(t,r){return new e(this,t,r)},e.prototype.toString=function(){return"<"+this.binaryShiftStart+"::"+(this.binaryShiftStart+this.binaryShiftByteCount-1)+">"}}(Ao);new Ao(null,0,0);var Co=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")};!function(t){var e,r;try{for(var n=Co(t),o=n.next();!o.done;o=n.next()){var i=o.value;C.fill(i,-1)}}catch(t){e={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(e)throw e.error}}t[0][4]=0,t[1][4]=0,t[1][0]=28,t[3][4]=0,t[2][4]=0,t[2][0]=15}(C.createInt32Array(6,6)),function(t){var e=F.getCharCode(" "),r=F.getCharCode("."),n=F.getCharCode(",");t[0][e]=1;for(var o=F.getCharCode("Z"),i=F.getCharCode("A"),a=i;a<=o;a++)t[0][a]=a-i+2;t[1][e]=1;var u=F.getCharCode("z"),s=F.getCharCode("a");for(a=s;a<=u;a++)t[1][a]=a-s+2;t[2][e]=1;var c=F.getCharCode("9"),f=F.getCharCode("0");for(a=f;a<=c;a++)t[2][a]=a-f+2;t[2][n]=12,t[2][r]=13;for(var h=["\0"," ","","","","","","","","\b","\t","\n","\v","\f","\r","","","","","","@","\\","^","_","`","|","~",""],l=0;l<h.length;l++)t[3][F.getCharCode(h[l])]=l;var d=["\0","\r","\0","\0","\0","\0","!","'","#","$","%","&","'","(",")","*","+",",","-",".","/",":",";","<","=",">","?","[","]","{","}"];for(l=0;l<d.length;l++)F.getCharCode(d[l])>0&&(t[4][F.getCharCode(d[l])]=l)}(C.createInt32Array(5,256));var Io=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),So=function(t){function e(r){var n=t.call(this,r.width,r.height)||this;return n.canvas=r,n.buffer=e.makeBufferFromCanvasImageData(r),n}return Io(e,t),e.makeBufferFromCanvasImageData=function(t){var r=t.getContext("2d");if(!r)throw new Error("Couldn't get canvas context.");var n=r.getImageData(0,0,t.width,t.height);return e.toGrayscaleBuffer(n.data,t.width,t.height)},e.toGrayscaleBuffer=function(t,e,r){for(var n=new Uint8ClampedArray(e*r),o=0,i=0,a=t.length;o<a;o+=4,i++){var u=void 0;if(0===t[o+3])u=255;else u=306*t[o]+601*t[o+1]+117*t[o+2]+512>>10;n[i]=u}return n},e.prototype.getRow=function(t,e){if(t<0||t>=this.getHeight())throw new l("Requested row is outside the image: "+t);var r=this.getWidth(),n=t*r;return null===e?e=this.buffer.slice(n,n+r):(e.length<r&&(e=new Uint8ClampedArray(r)),e.set(this.buffer.slice(n,n+r))),e},e.prototype.getMatrix=function(){return this.buffer},e.prototype.isCropSupported=function(){return!0},e.prototype.crop=function(e,r,n,o){return t.prototype.crop.call(this,e,r,n,o),this},e.prototype.isRotateSupported=function(){return!0},e.prototype.rotateCounterClockwise=function(){return this.rotate(-90),this},e.prototype.rotateCounterClockwise45=function(){return this.rotate(-45),this},e.prototype.invert=function(){return new Y(this)},e.prototype.getTempCanvasElement=function(){if(null===this.tempCanvasElement){var t=this.canvas.ownerDocument.createElement("canvas");t.width=this.canvas.width,t.height=this.canvas.height,this.tempCanvasElement=t}return this.tempCanvasElement},e.prototype.rotate=function(t){var r=this.getTempCanvasElement();if(!r)throw new Error("Could not create a Canvas element.");var n=t*e.DEGREE_TO_RADIANS,o=this.canvas.width,i=this.canvas.height,a=Math.ceil(Math.abs(Math.cos(n))*o+Math.abs(Math.sin(n))*i),u=Math.ceil(Math.abs(Math.sin(n))*o+Math.abs(Math.cos(n))*i);r.width=a,r.height=u;var s=r.getContext("2d");if(!s)throw new Error("Could not create a Convas Context element.");return s.translate(a/2,u/2),s.rotate(n),s.drawImage(this.canvas,o/-2,i/-2),this.buffer=e.makeBufferFromCanvasImageData(r),this},e.DEGREE_TO_RADIANS=Math.PI/180,e}(j);function Oo(){return"undefined"!=typeof navigator}function To(){return!!(Oo()&&navigator.mediaDevices&&navigator.mediaDevices.enumerateDevices)}var bo=function(){return bo=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var o in e=arguments[r])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},bo.apply(this,arguments)},Ro=function(t,e,r,n){return new(r||(r=Promise))((function(o,i){function a(t){try{s(n.next(t))}catch(t){i(t)}}function u(t){try{s(n.throw(t))}catch(t){i(t)}}function s(t){var e;t.done?o(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(a,u)}s((n=n.apply(t,e||[])).next())}))},No=function(t,e){var r,n,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:u(0),throw:u(1),return:u(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function u(i){return function(u){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;a;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,n=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(o=a.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){a.label=i[1];break}if(6===i[0]&&a.label<o[1]){a.label=o[1],o=i;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(i);break}o[2]&&a.ops.pop(),a.trys.pop();continue}i=e.call(t,a)}catch(t){i=[6,t],n=0}finally{r=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,u])}}},Do=function(t){var e="function"==typeof Symbol&&Symbol.iterator,r=e&&t[e],n=0;if(r)return r.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&n>=t.length&&(t=void 0),{value:t&&t[n++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},Po={delayBetweenScanAttempts:500,delayBetweenScanSuccess:500,tryPlayVideoTimeout:5e3},Mo=function(){function t(t,e,r){void 0===e&&(e=new Map),void 0===r&&(r={}),this.reader=t,this.hints=e,this.options=bo(bo({},Po),r)}return Object.defineProperty(t.prototype,"possibleFormats",{set:function(t){this.hints.set(T.POSSIBLE_FORMATS,t)},enumerable:!1,configurable:!0}),t.addVideoSource=function(t,e){try{t.srcObject=e}catch(r){t.src=URL.createObjectURL(e)}},t.mediaStreamSetTorch=function(t,e){return Ro(this,void 0,void 0,(function(){return No(this,(function(r){switch(r.label){case 0:return[4,t.applyConstraints({advanced:[{fillLightMode:e?"flash":"off",torch:!!e}]})];case 1:return r.sent(),[2]}}))}))},t.mediaStreamIsTorchCompatible=function(e){var r,n,o=e.getVideoTracks();try{for(var i=Do(o),a=i.next();!a.done;a=i.next()){var u=a.value;if(t.mediaStreamIsTorchCompatibleTrack(u))return!0}}catch(t){r={error:t}}finally{try{a&&!a.done&&(n=i.return)&&n.call(i)}finally{if(r)throw r.error}}return!1},t.mediaStreamIsTorchCompatibleTrack=function(t){try{return"torch"in t.getCapabilities()}catch(t){return console.error(t),console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."),!1}},t.isVideoPlaying=function(t){return t.currentTime>0&&!t.paused&&t.readyState>2},t.getMediaElement=function(t,e){var r=document.getElementById(t);if(!r)throw new f("element with id '"+t+"' not found");if(r.nodeName.toLowerCase()!==e.toLowerCase())throw new f("element with id '"+t+"' must be an "+e+" element");return r},t.createVideoElement=function(e){if(e instanceof HTMLVideoElement)return e;if("string"==typeof e)return t.getMediaElement(e,"video");if(!e&&"undefined"!=typeof document){var r=document.createElement("video");return r.width=200,r.height=200,r}throw new Error("Couldn't get videoElement from videoSource!")},t.prepareImageElement=function(e){if(e instanceof HTMLImageElement)return e;if("string"==typeof e)return t.getMediaElement(e,"img");if(void 0===e){var r=document.createElement("img");return r.width=200,r.height=200,r}throw new Error("Couldn't get imageElement from imageSource!")},t.prepareVideoElement=function(e){var r=t.createVideoElement(e);return r.setAttribute("autoplay","true"),r.setAttribute("muted","true"),r.setAttribute("playsinline","true"),r},t.isImageLoaded=function(t){return!!t.complete&&0!==t.naturalWidth},t.createBinaryBitmapFromCanvas=function(t){var e=new So(t),r=new W(e);return new d(r)},t.drawImageOnCanvas=function(t,e){t.drawImage(e,0,0)},t.getMediaElementDimensions=function(t){if(t instanceof HTMLVideoElement)return{height:t.videoHeight,width:t.videoWidth};if(t instanceof HTMLImageElement)return{height:t.naturalHeight||t.height,width:t.naturalWidth||t.width};throw new Error("Couldn't find the Source's dimentions!")},t.createCaptureCanvas=function(e){if(!e)throw new f("Cannot create a capture canvas without a media element.");if("undefined"==typeof document)throw new Error('The page "Document" is undefined, make sure you\'re running in a browser.');var r=document.createElement("canvas"),n=t.getMediaElementDimensions(e),o=n.width,i=n.height;return r.style.width=o+"px",r.style.height=i+"px",r.width=o,r.height=i,r},t.tryPlayVideo=function(e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:if(null==e?void 0:e.ended)return console.error("Trying to play video that has ended."),[2,!1];if(t.isVideoPlaying(e))return console.warn("Trying to play video that is already playing."),[2,!0];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,e.play()];case 2:return n.sent(),[2,!0];case 3:return r=n.sent(),console.warn("It was not possible to play the video.",r),[2,!1];case 4:return[2]}}))}))},t.createCanvasFromMediaElement=function(e){var r=t.createCaptureCanvas(e),n=r.getContext("2d");if(!n)throw new Error("Couldn't find Canvas 2D Context.");return t.drawImageOnCanvas(n,e),r},t.createBinaryBitmapFromMediaElem=function(e){var r=t.createCanvasFromMediaElement(e);return t.createBinaryBitmapFromCanvas(r)},t.destroyImageElement=function(t){t.src="",t.removeAttribute("src"),t=void 0},t.listVideoInputDevices=function(){return Ro(this,void 0,void 0,(function(){var t,e,r,n,o,i,a,u,s,c,f,h;return No(this,(function(l){switch(l.label){case 0:if(!Oo())throw new Error("Can't enumerate devices, navigator is not present.");if(!To())throw new Error("Can't enumerate devices, method not supported.");return[4,navigator.mediaDevices.enumerateDevices()];case 1:t=l.sent(),e=[];try{for(r=Do(t),n=r.next();!n.done;n=r.next())o=n.value,"videoinput"===(i="video"===o.kind?"videoinput":o.kind)&&(a=o.deviceId||o.id,u=o.label||"Video device "+(e.length+1),s=o.groupId,c={deviceId:a,label:u,kind:i,groupId:s},e.push(c))}catch(t){f={error:t}}finally{try{n&&!n.done&&(h=r.return)&&h.call(r)}finally{if(f)throw f.error}}return[2,e]}}))}))},t.findDeviceById=function(e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:return[4,t.listVideoInputDevices()];case 1:return(r=n.sent())?[2,r.find((function(t){return t.deviceId===e}))]:[2]}}))}))},t.cleanVideoSource=function(t){if(t){try{t.srcObject=null}catch(e){t.src=""}t&&t.removeAttribute("src")}},t.playVideoOnLoadAsync=function(e,r){return Ro(this,void 0,void 0,(function(){return No(this,(function(n){switch(n.label){case 0:return[4,t.tryPlayVideo(e)];case 1:return n.sent()?[2,!0]:[2,new Promise((function(n,o){var i=setTimeout((function(){t.isVideoPlaying(e)||(o(!1),e.removeEventListener("canplay",a))}),r),a=function(){t.tryPlayVideo(e).then((function(t){clearTimeout(i),e.removeEventListener("canplay",a),n(t)}))};e.addEventListener("canplay",a)}))]}}))}))},t.attachStreamToVideo=function(e,r,n){return void 0===n&&(n=5e3),Ro(this,void 0,void 0,(function(){var o;return No(this,(function(i){switch(i.label){case 0:return o=t.prepareVideoElement(r),t.addVideoSource(o,e),[4,t.playVideoOnLoadAsync(o,n)];case 1:return i.sent(),[2,o]}}))}))},t._waitImageLoad=function(e){return new Promise((function(r,n){var o=setTimeout((function(){t.isImageLoaded(e)||(e.removeEventListener("load",i),n())}),1e4),i=function(){clearTimeout(o),e.removeEventListener("load",i),r()};e.addEventListener("load",i)}))},t.checkCallbackFnOrThrow=function(t){if(!t)throw new f("`callbackFn` is a required parameter, you cannot capture results without it.")},t.disposeMediaStream=function(t){t.getVideoTracks().forEach((function(t){return t.stop()})),t=void 0},t.prototype.decode=function(e){var r=t.createCanvasFromMediaElement(e);return this.decodeFromCanvas(r)},t.prototype.decodeBitmap=function(t){return this.reader.decode(t,this.hints)},t.prototype.decodeFromCanvas=function(e){var r=t.createBinaryBitmapFromCanvas(e);return this.decodeBitmap(r)},t.prototype.decodeFromImageElement=function(e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:if(!e)throw new f("An image element must be provided.");return r=t.prepareImageElement(e),[4,this._decodeOnLoadImage(r)];case 1:return[2,n.sent()]}}))}))},t.prototype.decodeFromImageUrl=function(e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:if(!e)throw new f("An URL must be provided.");(r=t.prepareImageElement()).src=e,n.label=1;case 1:return n.trys.push([1,,3,4]),[4,this.decodeFromImageElement(r)];case 2:return[2,n.sent()];case 3:return t.destroyImageElement(r),[7];case 4:return[2]}}))}))},t.prototype.decodeFromConstraints=function(e,r,n){return Ro(this,void 0,void 0,(function(){var o,i;return No(this,(function(a){switch(a.label){case 0:return t.checkCallbackFnOrThrow(n),[4,navigator.mediaDevices.getUserMedia(e)];case 1:o=a.sent(),a.label=2;case 2:return a.trys.push([2,4,,5]),[4,this.decodeFromStream(o,r,n)];case 3:return[2,a.sent()];case 4:throw i=a.sent(),t.disposeMediaStream(o),i;case 5:return[2]}}))}))},t.prototype.decodeFromStream=function(e,r,n){return Ro(this,void 0,void 0,(function(){var o,i,a,u,s,c,f,h,l,d,p=this;return No(this,(function(g){switch(g.label){case 0:return t.checkCallbackFnOrThrow(n),o=this.options.tryPlayVideoTimeout,[4,t.attachStreamToVideo(e,r,o)];case 1:return i=g.sent(),a=function(){var t,r;try{for(var n=Do(e.getVideoTracks()),o=n.next();!o.done;o=n.next()){o.value.stop()}}catch(e){t={error:e}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(t)throw t.error}}e=void 0},u=function(){a(),t.cleanVideoSource(i)},s=this.scan(i,n,u),c=e.getVideoTracks(),f=bo(bo({},s),{stop:function(){s.stop()},streamVideoConstraintsApply:function(t,e){return Ro(this,void 0,void 0,(function(){var r,n,o,i,a,u;return No(this,(function(s){switch(s.label){case 0:r=e?c.filter(e):c,s.label=1;case 1:s.trys.push([1,6,7,8]),n=Do(r),o=n.next(),s.label=2;case 2:return o.done?[3,5]:[4,o.value.applyConstraints(t)];case 3:s.sent(),s.label=4;case 4:return o=n.next(),[3,2];case 5:return[3,8];case 6:return i=s.sent(),a={error:i},[3,8];case 7:try{o&&!o.done&&(u=n.return)&&u.call(n)}finally{if(a)throw a.error}return[7];case 8:return[2]}}))}))},streamVideoConstraintsGet:function(t){return c.find(t).getConstraints()},streamVideoSettingsGet:function(t){return c.find(t).getSettings()},streamVideoCapabilitiesGet:function(t){return c.find(t).getCapabilities()}}),t.mediaStreamIsTorchCompatible(e)&&(h=null==c?void 0:c.find((function(e){return t.mediaStreamIsTorchCompatibleTrack(e)})),l=function(e){return Ro(p,void 0,void 0,(function(){return No(this,(function(r){switch(r.label){case 0:return[4,t.mediaStreamSetTorch(h,e)];case 1:return r.sent(),[2]}}))}))},f.switchTorch=l,d=function(){s.stop(),l(!1)},f.stop=d),[2,f]}}))}))},t.prototype.decodeFromVideoDevice=function(e,r,n){return Ro(this,void 0,void 0,(function(){var o;return No(this,(function(i){switch(i.label){case 0:return t.checkCallbackFnOrThrow(n),o={video:e?{deviceId:{exact:e}}:{facingMode:"environment"}},[4,this.decodeFromConstraints(o,r,n)];case 1:return[2,i.sent()]}}))}))},t.prototype.decodeFromVideoElement=function(e,r){return Ro(this,void 0,void 0,(function(){var n,o;return No(this,(function(i){switch(i.label){case 0:if(t.checkCallbackFnOrThrow(r),!e)throw new f("A video element must be provided.");return n=t.prepareVideoElement(e),o=this.options.tryPlayVideoTimeout,[4,t.playVideoOnLoadAsync(n,o)];case 1:return i.sent(),[2,this.scan(n,r)]}}))}))},t.prototype.decodeFromVideoUrl=function(e,r){return Ro(this,void 0,void 0,(function(){var n,o,i;return No(this,(function(a){switch(a.label){case 0:if(t.checkCallbackFnOrThrow(r),!e)throw new f("An URL must be provided.");return(n=t.prepareVideoElement()).src=e,o=function(){t.cleanVideoSource(n)},i=this.options.tryPlayVideoTimeout,[4,t.playVideoOnLoadAsync(n,i)];case 1:return a.sent(),[2,this.scan(n,r,o)]}}))}))},t.prototype.decodeOnceFromConstraints=function(t,e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:return[4,navigator.mediaDevices.getUserMedia(t)];case 1:return r=n.sent(),[4,this.decodeOnceFromStream(r,e)];case 2:return[2,n.sent()]}}))}))},t.prototype.decodeOnceFromStream=function(e,r){return Ro(this,void 0,void 0,(function(){var n,o;return No(this,(function(i){switch(i.label){case 0:return n=Boolean(r),[4,t.attachStreamToVideo(e,r)];case 1:o=i.sent(),i.label=2;case 2:return i.trys.push([2,,4,5]),[4,this.scanOneResult(o)];case 3:return[2,i.sent()];case 4:return n||t.cleanVideoSource(o),[7];case 5:return[2]}}))}))},t.prototype.decodeOnceFromVideoDevice=function(t,e){return Ro(this,void 0,void 0,(function(){var r;return No(this,(function(n){switch(n.label){case 0:return r={video:t?{deviceId:{exact:t}}:{facingMode:"environment"}},[4,this.decodeOnceFromConstraints(r,e)];case 1:return[2,n.sent()]}}))}))},t.prototype.decodeOnceFromVideoElement=function(e){return Ro(this,void 0,void 0,(function(){var r,n;return No(this,(function(o){switch(o.label){case 0:if(!e)throw new f("A video element must be provided.");return r=t.prepareVideoElement(e),n=this.options.tryPlayVideoTimeout,[4,t.playVideoOnLoadAsync(r,n)];case 1:return o.sent(),[4,this.scanOneResult(r)];case 2:return[2,o.sent()]}}))}))},t.prototype.decodeOnceFromVideoUrl=function(e){return Ro(this,void 0,void 0,(function(){var r,n;return No(this,(function(o){switch(o.label){case 0:if(!e)throw new f("An URL must be provided.");(r=t.prepareVideoElement()).src=e,n=this.decodeOnceFromVideoElement(r),o.label=1;case 1:return o.trys.push([1,,3,4]),[4,n];case 2:return[2,o.sent()];case 3:return t.cleanVideoSource(r),[7];case 4:return[2]}}))}))},t.prototype.scanOneResult=function(t,e,r,n){var o=this;return void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===n&&(n=!0),new Promise((function(i,a){o.scan(t,(function(t,o,u){if(t)return i(t),void u.stop();if(o){if(o instanceof U&&e)return;if(o instanceof g&&r)return;if(o instanceof R&&n)return;u.stop(),a(o)}}))}))},t.prototype.scan=function(e,r,n){var o=this;t.checkCallbackFnOrThrow(r);var i=t.createCaptureCanvas(e),a=i.getContext("2d");if(!a)throw new Error("Couldn't create canvas for visual element scan.");var u,s=function(){a=void 0,i=void 0},c=!1,f={stop:function(){c=!0,clearTimeout(u),s(),n&&n()}},h=function(){if(!c)try{t.drawImageOnCanvas(a,e);var l=o.decodeFromCanvas(i);r(l,void 0,f),u=setTimeout(h,o.options.delayBetweenScanSuccess)}catch(t){if(r(void 0,t,f),t instanceof g||t instanceof R||t instanceof U)return void(u=setTimeout(h,o.options.delayBetweenScanAttempts));s(),n&&n(t)}};return h(),f},t.prototype._decodeOnLoadImage=function(e){return Ro(this,void 0,void 0,(function(){return No(this,(function(r){switch(r.label){case 0:return t.isImageLoaded(e)?[3,2]:[4,t._waitImageLoad(e)];case 1:r.sent(),r.label=2;case 2:return[2,this.decode(e)]}}))}))},t}(),Bo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){return t.call(this,new Mt,e,r)||this}Bo(e,t)}(Mo);var Lo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){return t.call(this,new fr(e),e,r)||this}Lo(e,t)}(Mo);var Fo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){return t.call(this,new Or,e,r)||this}Fo(e,t)}(Mo);var ko=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){var n=this,o=new $n;return o.setHints(e),(n=t.call(this,o,e,r)||this).reader=o,n}ko(e,t),Object.defineProperty(e.prototype,"possibleFormats",{set:function(t){this.hints.set(T.POSSIBLE_FORMATS,t),this.reader.setHints(this.hints)},enumerable:!1,configurable:!0}),e.prototype.decodeBitmap=function(t){return this.reader.decodeWithState(t)},e.prototype.setHints=function(t){this.hints=t,this.reader.setHints(this.hints)}}(Mo);var xo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}();!function(t){function e(e,r){return t.call(this,new Kn,e,r)||this}xo(e,t)}(Mo);var Vo=function(){var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])},t(e,r)};return function(e,r){function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Uo=function(t){function e(e,r){return t.call(this,new an,e,r)||this}return Vo(e,t),e}(Mo),Ho=function(t,e,r){var n=typeof t===r;return n||console.warn('[ReactQrReader]: Expected "'.concat(e,'" to be a of type "').concat(r,'".')),n},Go=function(t){var n=t.scanDelay,o=t.constraints,i=t.onResult,a=t.videoId,u=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){var t=new Uo(null,{delayBetweenScanAttempts:n});if(!function(){var t="undefined"!=typeof navigator&&!!navigator.mediaDevices;return t||console.warn('[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'),t}()&&Ho(i,"onResult","function")){i(null,new Error('MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'),t)}return Ho(o,"constraints","object")&&t.decodeFromConstraints({video:o},a,(function(e,r){Ho(i,"onResult","function")&&i(e,r,t)})).then((function(t){return u.current=t})).catch((function(e){Ho(i,"onResult","function")&&i(null,e,t)})),function(){var t;null===(t=u.current)||void 0===t||t.stop()}}),[])},Xo=function(){return Xo=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var o in e=arguments[r])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},Xo.apply(this,arguments)},Wo={container:{width:"100%",paddingTop:"100%",overflow:"hidden",position:"relative"},video:{top:0,left:0,width:"100%",height:"100%",display:"block",overflow:"hidden",position:"absolute",transform:void 0}},jo=function(e){var r=e.videoContainerStyle,n=e.containerStyle,o=e.videoStyle,i=e.constraints,a=e.ViewFinder,u=e.scanDelay,s=e.className,c=e.onResult,f=e.videoId;return Go({constraints:i,scanDelay:u,onResult:c,videoId:f}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section",{className:s,style:n},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:Xo(Xo({},Wo.container),r)},!!a&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](a,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("video",{muted:!0,id:f,style:Xo(Xo(Xo({},Wo.video),o),{transform:"user"===(null==i?void 0:i.facingMode)&&"scaleX(-1)"})})))};jo.displayName="QrReader",jo.defaultProps={constraints:{facingMode:"user"},videoId:"video",scanDelay:500};
//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_reducers__ = __webpack_require__(990);
var middleware=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__redux_reducers__["a" /* default */],middleware));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rights__ = __webpack_require__(993);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({Header:__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */],main:__WEBPACK_IMPORTED_MODULE_2__main__["a" /* default */],rights:__WEBPACK_IMPORTED_MODULE_3__rights__["a" /* default */]}));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INITIAL_STATE={toggle:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case'togglechange':return Object.assign({},state,{toggle:action.payload});default:return Object.assign({},state);}});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INITIAL_STATE={"_id":"","userId":"","authToken":"","firstName":"","lastName":"","profilePicture":"","rememberMe":false,"isLoggedIn":null,"rights":null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case"UPDATE_BASIC_DETAILS":return Object.assign({},state,action.payload);case"FETCH_USER_DETAILS":return Object.assign({},state);case'UPDATE_RIGHTS':return Object.assign({},state,{rights:action.payload});case"SIGN_OUT":return Object.assign({},INITIAL_STATE,{isLoggedIn:false});default:return state;}});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var initial_state={rightsInfo:"",updatedRights:""};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initial_state;var action=arguments[1];switch(action.type){case'rights':return Object.assign({},state,{rightsInfo:action.payload});default:return Object.assign({},state);}});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==="localhost"||// [::1] is the IPv6 localhost address.
window.location.hostname==="[::1]"||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("serviceWorker"in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener("load",function(){var swUrl=""+"/service-worker.js";if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==="installed"){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
// console.log("New content is available; please refresh.");
}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
// console.log("Content is cached for offline use.");
}}};};}).catch(function(error){console.error("Error during service worker registration:",error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get("content-type").indexOf("javascript")===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log("No internet connection found. App is running in offline mode.");});}function unregister(){if("serviceWorker"in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.89b57eaa.js